/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 466);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(658);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(666)();
}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(709);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(117);

var assertThisInitialized = __webpack_require__(19);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(254);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(30);
var core = __webpack_require__(41);
var hide = __webpack_require__(59);
var redefine = __webpack_require__(55);
var ctx = __webpack_require__(75);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.sheetsManager = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _extends3 = _interopRequireDefault(__webpack_require__(3));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _warning = _interopRequireDefault(__webpack_require__(27));

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(188));

var _utils = __webpack_require__(14);

var _jss = __webpack_require__(370);

var _reactJssContext = _interopRequireDefault(__webpack_require__(750));

var _jssPreset = _interopRequireDefault(__webpack_require__(369));

var _mergeClasses = _interopRequireDefault(__webpack_require__(376));

var _multiKeyStore = _interopRequireDefault(__webpack_require__(751));

var _createMuiTheme = _interopRequireDefault(__webpack_require__(256));

var _themeListener = _interopRequireDefault(__webpack_require__(255));

var _createGenerateClassName = _interopRequireDefault(__webpack_require__(363));

var _getStylesCreator = _interopRequireDefault(__webpack_require__(752));

var _getThemeProps = _interopRequireDefault(__webpack_require__(377));

/* eslint-disable no-underscore-dangle */
// Default JSS instance.
var jss = (0, _jss.create)((0, _jssPreset.default)()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.

var generateClassName = (0, _createGenerateClassName.default)(); // Global index counter to preserve source order.
// We create the style sheet during at the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.

var indexCounter = -10e10; // Exported for test purposes

var sheetsManager = new Map(); // We use the same empty object to ref count the styles that don't need a theme object.

exports.sheetsManager = sheetsManager;
var noopTheme = {}; // In order to have self-supporting components, we rely on default theme when not provided.

var defaultTheme = (0, _createMuiTheme.default)({
  typography: {
    suppressWarning: true
  }
}); // Link a style sheet with a component.
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.

var withStylesOld = function withStylesOld(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var _extends2;

    var _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
        _options$flip = options.flip,
        flip = _options$flip === void 0 ? null : _options$flip,
        name = options.name,
        styleSheetOptions = (0, _objectWithoutProperties2.default)(options, ["withTheme", "flip", "name"]);
    var stylesCreator = (0, _getStylesCreator.default)(stylesOrCreator);
    var listenToTheme = stylesCreator.themingEnabled || typeof name === 'string' || withTheme;
    indexCounter += 1;
    stylesCreator.options.index = indexCounter;
     false ? (0, _warning.default)(indexCounter < 0, ['Material-UI: you might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join('\n')) : void 0;

    var WithStyles =
    /*#__PURE__*/
    function (_React$Component) {
      (0, _inherits2.default)(WithStyles, _React$Component);

      function WithStyles(props, context) {
        var _this;

        (0, _classCallCheck2.default)(this, WithStyles);
        _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(WithStyles).call(this, props, context));
        _this.jss = context[_reactJssContext.default.jss] || jss;
        _this.sheetsManager = sheetsManager;
        _this.unsubscribeId = null;
        var muiThemeProviderOptions = context.muiThemeProviderOptions;

        if (muiThemeProviderOptions) {
          if (muiThemeProviderOptions.sheetsManager) {
            _this.sheetsManager = muiThemeProviderOptions.sheetsManager;
          }

          _this.sheetsCache = muiThemeProviderOptions.sheetsCache;
          _this.disableStylesGeneration = muiThemeProviderOptions.disableStylesGeneration;
        } // Attach the stylesCreator to the instance of the component as in the context
        // of react-hot-loader the hooks can be executed in a different closure context:
        // https://github.com/gaearon/react-hot-loader/blob/master/src/patch.dev.js#L107


        _this.stylesCreatorSaved = stylesCreator;
        _this.sheetOptions = (0, _extends3.default)({
          generateClassName: generateClassName
        }, context[_reactJssContext.default.sheetOptions]); // We use || as the function call is lazy evaluated.

        _this.theme = listenToTheme ? _themeListener.default.initial(context) || defaultTheme : noopTheme;

        _this.attach(_this.theme);

        _this.cacheClasses = {
          // Cache for the finalized classes value.
          value: null,
          // Cache for the last used classes prop pointer.
          lastProp: null,
          // Cache for the last used rendered classes pointer.
          lastJSS: {}
        };
        return _this;
      }

      (0, _createClass2.default)(WithStyles, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;

          if (!listenToTheme) {
            return;
          }

          this.unsubscribeId = _themeListener.default.subscribe(this.context, function (theme) {
            var oldTheme = _this2.theme;
            _this2.theme = theme;

            _this2.attach(_this2.theme); // Rerender the component so the underlying component gets the theme update.
            // By theme update we mean receiving and applying the new class names.


            _this2.setState({}, function () {
              _this2.detach(oldTheme);
            });
          });
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
          // react-hot-loader specific logic
          if (this.stylesCreatorSaved === stylesCreator || "production" === 'production') {
            return;
          }

          this.detach(this.theme);
          this.stylesCreatorSaved = stylesCreator;
          this.attach(this.theme);
          this.forceUpdate();
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.detach(this.theme);

          if (this.unsubscribeId !== null) {
            _themeListener.default.unsubscribe(this.context, this.unsubscribeId);
          }
        }
      }, {
        key: "getClasses",
        value: function getClasses() {
          if (this.disableStylesGeneration) {
            return this.props.classes || {};
          } // Tracks if either the rendered classes or classes prop has changed,
          // requiring the generation of a new finalized classes object.


          var generate = false;

          var sheetManager = _multiKeyStore.default.get(this.sheetsManager, this.stylesCreatorSaved, this.theme);

          if (sheetManager.sheet.classes !== this.cacheClasses.lastJSS) {
            this.cacheClasses.lastJSS = sheetManager.sheet.classes;
            generate = true;
          }

          if (this.props.classes !== this.cacheClasses.lastProp) {
            this.cacheClasses.lastProp = this.props.classes;
            generate = true;
          }

          if (generate) {
            this.cacheClasses.value = (0, _mergeClasses.default)({
              baseClasses: this.cacheClasses.lastJSS,
              newClasses: this.props.classes,
              Component: Component
            });
          }

          return this.cacheClasses.value;
        }
      }, {
        key: "attach",
        value: function attach(theme) {
          if (this.disableStylesGeneration) {
            return;
          }

          var stylesCreatorSaved = this.stylesCreatorSaved;

          var sheetManager = _multiKeyStore.default.get(this.sheetsManager, stylesCreatorSaved, theme);

          if (!sheetManager) {
            sheetManager = {
              refs: 0,
              sheet: null
            };

            _multiKeyStore.default.set(this.sheetsManager, stylesCreatorSaved, theme, sheetManager);
          }

          if (sheetManager.refs === 0) {
            var sheet;

            if (this.sheetsCache) {
              sheet = _multiKeyStore.default.get(this.sheetsCache, stylesCreatorSaved, theme);
            }

            if (!sheet) {
              sheet = this.createSheet(theme);
              sheet.attach();

              if (this.sheetsCache) {
                _multiKeyStore.default.set(this.sheetsCache, stylesCreatorSaved, theme, sheet);
              }
            }

            sheetManager.sheet = sheet;
            var sheetsRegistry = this.context[_reactJssContext.default.sheetsRegistry];

            if (sheetsRegistry) {
              sheetsRegistry.add(sheet);
            }
          }

          sheetManager.refs += 1;
        }
      }, {
        key: "createSheet",
        value: function createSheet(theme) {
          var styles = this.stylesCreatorSaved.create(theme, name);
          var meta = name;

          if (false) {
            // Provide a better DX outside production.
            meta = (0, _utils.getDisplayName)(Component);
            process.env.NODE_ENV !== "production" ? (0, _warning.default)(typeof meta === 'string', ['Material-UI: the component displayName is invalid. It needs to be a string.', "Please fix the following component: ".concat(Component, ".")].join('\n')) : void 0;
          }

          var sheet = this.jss.createStyleSheet(styles, (0, _extends3.default)({
            meta: meta,
            classNamePrefix: meta,
            flip: typeof flip === 'boolean' ? flip : theme.direction === 'rtl',
            link: false
          }, this.sheetOptions, this.stylesCreatorSaved.options, {
            name: name || Component.displayName
          }, styleSheetOptions));
          return sheet;
        }
      }, {
        key: "detach",
        value: function detach(theme) {
          if (this.disableStylesGeneration) {
            return;
          }

          var sheetManager = _multiKeyStore.default.get(this.sheetsManager, this.stylesCreatorSaved, theme);

          sheetManager.refs -= 1;

          if (sheetManager.refs === 0) {
            _multiKeyStore.default.delete(this.sheetsManager, this.stylesCreatorSaved, theme);

            this.jss.removeStyleSheet(sheetManager.sheet);
            var sheetsRegistry = this.context[_reactJssContext.default.sheetsRegistry];

            if (sheetsRegistry) {
              sheetsRegistry.remove(sheetManager.sheet);
            }
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props = this.props,
              classes = _this$props.classes,
              innerRef = _this$props.innerRef,
              other = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "innerRef"]);
          var more = (0, _getThemeProps.default)({
            theme: this.theme,
            name: name,
            props: other
          }); // Provide the theme to the wrapped component.
          // So we don't have to use the `withTheme()` Higher-order Component.

          if (withTheme && !more.theme) {
            more.theme = this.theme;
          }

          return _react.default.createElement(Component, (0, _extends3.default)({}, more, {
            classes: this.getClasses(),
            ref: innerRef
          }));
        }
      }]);
      return WithStyles;
    }(_react.default.Component);

     false ? WithStyles.propTypes = {
      /**
       * Override or extend the styles applied to the component.
       */
      classes: _propTypes.default.object,

      /**
       * Use that property to pass a ref callback to the decorated component.
       */
      innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object])
    } : void 0;
    WithStyles.contextTypes = (0, _extends3.default)((_extends2 = {
      muiThemeProviderOptions: _propTypes.default.object
    }, (0, _defineProperty2.default)(_extends2, _reactJssContext.default.jss, _propTypes.default.object), (0, _defineProperty2.default)(_extends2, _reactJssContext.default.sheetOptions, _propTypes.default.object), (0, _defineProperty2.default)(_extends2, _reactJssContext.default.sheetsRegistry, _propTypes.default.object), _extends2), listenToTheme ? _themeListener.default.contextTypes : {});

    if (false) {
      WithStyles.displayName = "WithStyles(".concat((0, _utils.getDisplayName)(Component), ")");
    }

    (0, _hoistNonReactStatics.default)(WithStyles, Component);

    if (false) {
      // Exposed for test purposes.
      WithStyles.Naked = Component;
      WithStyles.options = options;
    }

    return WithStyles;
  };
};
/* istanbul ignore if */


if (!_utils.ponyfillGlobal.__MUI_STYLES__) {
  _utils.ponyfillGlobal.__MUI_STYLES__ = {};
}

if (!_utils.ponyfillGlobal.__MUI_STYLES__.withStyles) {
  _utils.ponyfillGlobal.__MUI_STYLES__.withStyles = withStylesOld;
}

var _default = function _default(styles, options) {
  return _utils.ponyfillGlobal.__MUI_STYLES__.withStyles(styles, (0, _extends3.default)({
    defaultTheme: defaultTheme
  }, options));
};

exports.default = _default;

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__componentPropType__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__componentPropType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__componentPropType__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "componentPropType", function() { return __WEBPACK_IMPORTED_MODULE_0__componentPropType___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chainPropTypes__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chainPropTypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__chainPropTypes__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "chainPropTypes", function() { return __WEBPACK_IMPORTED_MODULE_1__chainPropTypes___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__exactProp__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__exactProp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__exactProp__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "exactProp", function() { return __WEBPACK_IMPORTED_MODULE_2__exactProp___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getDisplayName__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getDisplayName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__getDisplayName__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "getDisplayName", function() { return __WEBPACK_IMPORTED_MODULE_3__getDisplayName___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ponyfillGlobal__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ponyfillGlobal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ponyfillGlobal__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ponyfillGlobal", function() { return __WEBPACK_IMPORTED_MODULE_4__ponyfillGlobal___default.a; });
/** @license Material-UI v3.0.0-alpha.3
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */







/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n___ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__i18n___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__localisedStrings_en_js__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__localisedStrings_en_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__localisedStrings_en_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__localisedStrings_de_js__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__localisedStrings_de_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__localisedStrings_de_js__);
var localiser=__WEBPACK_IMPORTED_MODULE_0__i18n____default.a.localiser,loc=__WEBPACK_IMPORTED_MODULE_0__i18n____default.a.localiser.loc;var strings={en:__WEBPACK_IMPORTED_MODULE_1__localisedStrings_en_js___default.a,de:__WEBPACK_IMPORTED_MODULE_2__localisedStrings_de_js___default.a};var lang=localiser.getCurrentLanguage();loc.strings=strings[lang];lang!=='en'&&(loc.strings_en=__WEBPACK_IMPORTED_MODULE_1__localisedStrings_en_js___default.a);// for fallback
/* harmony default export */ __webpack_exports__["a"] = (localiser);

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.11';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });

        return result;
      }

      if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });

        return result;
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(67), __webpack_require__(761)(module)))

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return WORKSPACES_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return SKIP_ONBOARDING_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return PERIOD_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CURRENCY_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return MAGIX_EMAIL_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return MAGIX_SERIAL_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return MAGIX_CATEGORY_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return COUPON_ID_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return XC_USER_FOUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return PRODUCT_NAME_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return PRODUCT_LANGUAGE_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return EXTERNAL_REDIRECT_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return INTERNAL_REDIRECT_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return REACTIVATE_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return BACK_TO_PARAM; });
/* unused harmony export SHOW_PATH_PARAM */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return PRODUCT_QUANTITY_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return PRODUCT_SOURCE_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ASK_FOR_COMPANY_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return APP_COMPANY_ID_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return DESKTOP_APPLICATION_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return UPGRADE_POPUP_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return REAL_ESTATE_PLAN_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return IS_REAL_ESTATE_POPUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return XC_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return HTTP_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return HTTP_MLS_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return HTTP_STATIC_RESOURCES_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return SEGMENT_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return SEGMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return SOCKET_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return HOTJAR_SITE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return TEMP_COMP_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return PLUS_OVERVIEW_PLAN_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return PERPETUAL_OVERVIEW_PLAN_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return STANDARD_OVERVIEW_PLAN_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return REAL_ESTATE_OVERVIEW_PLAN_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return COUNTRY_DETECTION_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACCOUNT_UPDATE_EXTERNAL_IDS_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return HOSTING_BUTTON_URL_EN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return HOSTING_BUTTON_URL_DE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CB_LIBRARY_SUPPORT_ARTICLE_EN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CB_LIBRARY_SUPPORT_ARTICLE_DE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return SEND_CURRENT_OFFERS_URL; });
/* unused harmony export INTERCOM_WORKSPACE_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return AUTHENTICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CRS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CONTACT_SALES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return MLS_DATA_PROJECT_ENDPOINTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCOUNT_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return MLS_UI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return USER_ROLE_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return USER_ROLE_BASIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return USER_ROLE_GUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return USER_ROLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CURRENCIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CB_API_FETCH_CURRENCY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return PLAN_CATEGORIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return ORIGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return SUBSCRIPTION_PLAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return PRODUCT_CATEGORY; });
/* unused harmony export PERPETUAL_PRODUCT_CATEGORY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return COUPONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return PRODUCT_PREFIX_TO_PACKAGE_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return PRODUCT_CATEGORY_TO_PACKAGE_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return PERPETAUL_PRODUCT_CATEGORY_TO_PACKAGE_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return FALLBACK_COUPON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return DISCOUNT_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return DISCOUNT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return MAXIC_DISCOUNT_PROD_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return PACKAGE_DESCRIPTION_ITEM_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return DISCOUNTS_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return SUBSCRIPTION_PLAN_UPGRADE_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return PHOTO_PERPETUAL_LATEST_VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return WEB_PERPETUAL_LATEST_VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return DESIGNER_PERPETUAL_LATEST_VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return MAP_ADDON_TO_LATEST_VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return SUBSCRIPTION_PERIOD; });
/* unused harmony export MEMBER_ADDONS_DISCOUNT_DESKTOP_PLUS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return SUBSCRIPTION_PRICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return PACKAGES_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return getCloudPlans; });
/* unused harmony export getRealEstatePlans */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return getMemberAddonsIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return DEFAULT_SUBSCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CHARGEBEE_SITE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CHARGEBEE_ENABLE_GA_TRACKING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CHARGEBEE_ENABLE_REFERSION_TRACKING; });
/* unused harmony export SUBSCRIPTION_KEY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CAP_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return ONBOARDING_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return USER_DOWNLOAD_NOTIFICATION_SETTING_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return USER_DISCOUNT_BANNER_SETTING_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return FOREVER_HIDDEN_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return USER_PAGE_SETTINGS_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return FONTS_ACCEPTED_FILE_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return STATIC_RESOURCE_INDUSTRIES_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return STATIC_RESOURCE_COUNTRIES_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return STATIC_RESOURCE_SIZES_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return apiStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return DESKTOP_APPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return TEMPORARY_COMPANY_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return loggerConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return REACT_APP_BUILD_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return REACT_APP_BRANCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return REACT_APP_BUILD_VCS_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return SERIAL_NUMBER_REGEXP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return USER_TABLE_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return USER_TABLE_ADMINS_AND_MEMBERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return USER_TABLE_GUESTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return USER_TABLE_REDUCE_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return USER_TABLE_MANAGE_AGENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return USER_TABLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return TABLE_COLUMNS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return SORT_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return SUBSCRIPTION_VIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return SERIAL_NUMBER_PREFIXES_OLD_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return SERIAL_NUMBER_PREFIXES_NEW_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return BUY_MORE_POPUP_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return QUANTITY_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return COUPON_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return REDUCE_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ADDON_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADDONS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADDONS_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return ENABLE_MLS_ID_FIELD_FOR_INDUSTRIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return REAL_ESTATE_INDUSTY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return PACKAGES_HIDE_SIDEBAR_BREAKPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return FORCE_RE_CHECKOUT_WITH_ALL_USERS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineEnumerableProperties__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineEnumerableProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineEnumerableProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_i18n_i18n__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_theme_icons__ = __webpack_require__(24);
var _USER_ROLES,_PRODUCT_CATEGORY_TO_,_PERPETAUL_PRODUCT_CA,_DISCOUNTS_CONFIG,_SUBSCRIPTION_PLAN$TE,_SUBSCRIPTION_PLAN_UP,_mutatorMap,_MAP_ADDON_TO_LATEST_,_SUBSCRIPTION_PLAN$ES,_SUBSCRIPTION_PLAN$SC,_SUBSCRIPTION_PLAN$PH,_SUBSCRIPTION_PLAN$WE,_SUBSCRIPTION_PLAN$DE,_SUBSCRIPTION_PLAN$TE2,_SUBSCRIPTION_PRICES,_mutatorMap2,_SUBSCRIPTION_PLAN$TE3,_PACKAGES_CONFIG,_mutatorMap3,_USER_TABLES,_ADDONS_CONFIG;// NOTE: For Team City environment variables to be reachable here they need to be started
// with REACT_APP_ prefix! I.e. REACT_APP_XC_URL or REACT_APP_HOTJAR_SITE_ID.
var localize=__WEBPACK_IMPORTED_MODULE_5_i18n_i18n__["a" /* default */].loc.localize;var WORKSPACES_PARAM='from-workspaces';var SKIP_ONBOARDING_PARAM='skip-onboarding';var PERIOD_PARAM='period';var CURRENCY_PARAM='currency';var MAGIX_EMAIL_PARAM='pemail';var MAGIX_SERIAL_PARAM='pserial';var MAGIX_CATEGORY_PARAM='pcat';var COUPON_ID_PARAM='cid';var XC_USER_FOUND='user-found';var PRODUCT_NAME_PARAM='prod';var PRODUCT_LANGUAGE_PARAM='lang';var EXTERNAL_REDIRECT_PARAM='external-redirect';var INTERNAL_REDIRECT_PARAM='internal-redirect';var REACTIVATE_PARAM='reactivate';var BACK_TO_PARAM='back-to-path';var SHOW_PATH_PARAM='show-path';var PRODUCT_QUANTITY_PARAM='quantity';var PRODUCT_SOURCE_PARAM='source';var ASK_FOR_COMPANY_PARAM='select-company';var APP_COMPANY_ID_PARAM='app-company-id';var DESKTOP_APPLICATION_PARAM='desktop-app';var UPGRADE_POPUP_PARAM='upgrade-popup';var REAL_ESTATE_PLAN_PARAM='real-estate-plan';var IS_REAL_ESTATE_POPUP='is-re-popup';var XC_URL="https://cloud.xara.com/";var HTTP_API_URL="https://prod-mw.xara.com/2";var HTTP_MLS_API_URL="https://prod-mw.xara.com/3";var HTTP_STATIC_RESOURCES_URL="https://prod-mw.xara.com/static";var SEGMENT_TOKEN="rPbjGNElCaBDQdLTczi3f8YdshyWxtsF";var SEGMENT="true";var SOCKET_URL="https://prod-mw.xara.com:443";var HOTJAR_SITE_ID="1270301";var TEMP_COMP_PREFIX='tempcomp_';var PLUS_OVERVIEW_PLAN_ID='plus-overview';var PERPETUAL_OVERVIEW_PLAN_ID='perpetual-overview';var STANDARD_OVERVIEW_PLAN_ID='standard-overview';var REAL_ESTATE_OVERVIEW_PLAN_ID='real-estate-overview';var COUNTRY_DETECTION_ENDPOINT='/account/country';var ACCOUNT_UPDATE_EXTERNAL_IDS_ENDPOINT='/account/externalid';var HOSTING_BUTTON_URL_EN='https://www.xara.com/hosting/';var HOSTING_BUTTON_URL_DE='https://www.xara.com/de/hosting/';var CB_LIBRARY_SUPPORT_ARTICLE_EN='https://helpandsupport.xara.com/index.htm?rhcsh=1&rhmapno=1027';var CB_LIBRARY_SUPPORT_ARTICLE_DE='https://helpandsupport.xara.com/deu/index.htm?rhcsh=1&rhmapno=1027';var SEND_CURRENT_OFFERS_URL="https://marketing-web.xara.com/coupons/sendactivecoupons";var INTERCOM_WORKSPACE_ID="w83u8qa8";/* AUTH */var AUTHENTICATION={SIGN_IN_URL:'/auth/xara-basic',SIGN_UP_URL:'/xara-basic',RESET_PASSWORD_URL:'/xara-basic/password'};/* CRS */var CRS={INFO_URL:"https://crs-web.xara.com/crsinfo",USAGE_URL:"https://crs-web.xara.com/usage"};/* CONTACT SALES */var CONTACT_SALES={CALENDLY_LINK:"https://meet.brevo.com/xara-group-ltd/xara-for-enterprise",API_ENDPOINT:"https://www.xara.com/contact-sales-request/"};/* CONTACT SALES */var MLS_DATA_PROJECT_ENDPOINTS={CONNECT_MLS:"https://www.xara.com/activate-playbooks-request/",REVIEW_MLS:"https://www.xara.com/review-mls-request/"};/* ACCOUNT */var ACCOUNT_SETTINGS={minPasswordLength:8,maxPasswordLength:72};/* MLS */var MLS_UI={DIRECT_MLS_API:'direct_mls_api',// TYPE1
SELF_CONNECT_API:'self_connect_api'// TYPE2
};// USER ROLES / PERMISSION LEVEL
var USER_ROLE_ADMIN='admin';var USER_ROLE_BASIC='basic';var USER_ROLE_GUEST='guest';var USER_ROLES=(_USER_ROLES={},__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_USER_ROLES,USER_ROLE_ADMIN,{label:localize('config-user-roles-admin'),trackingName:USER_ROLE_ADMIN}),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_USER_ROLES,USER_ROLE_BASIC,{label:localize('config-user-roles-member'),trackingName:USER_ROLE_BASIC}),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_USER_ROLES,USER_ROLE_GUEST,{label:localize('config-user-roles-guest'),trackingName:USER_ROLE_GUEST}),_USER_ROLES);var CURRENCIES={USD:{key:'usd',value:localize('subscription-currency-usd'),symbol:'$'},GBP:{key:'gbp',value:localize('subscription-currency-gbp'),symbol:'£'},EUR:{key:'eur',value:localize('subscription-currency-eur'),symbol:'€'}};var CB_API_FETCH_CURRENCY=CURRENCIES.USD.key;var PLAN_CATEGORIES={CLOUD_SUITE:'Cloud Suite',CREATIVE_TOOLS:'Creative Tools'};var ORIGIN={PHOTO:3,WEB:2,DESIGNER:1,PHOTO_PERPETUAL:8,WEB_PERPETUAL:7,DESIGNER_PERPETUAL:6,XC:4,XC_API:5,XC_PLAYBOOK:9};var SUBSCRIPTION_PLAN={PHOTO:'photo',WEB:'web',DESIGNER:'designer',PHOTO_PERPETUAL:'photol',WEB_PERPETUAL:'webl',DESIGNER_PERPETUAL:'designerl',ESSENTIAL:'essential',SCALE:'scale',ENTERPRISE:'enterprise',TEAM_PLUS:'teamplus',INDIVIDUAL_AGENT:'individual_agent',BROKERAGES:'brokerages'};var PRODUCT_CATEGORY={PHOTO:'pgd',WEB:'wd',DESIGNER:'dp'};var PERPETUAL_PRODUCT_CATEGORY={PHOTO_PERPETUAL:'pgd',WEB_PERPETUAL:'wd',DESIGNER_PERPETUAL:'dp'};/* COUPONS / DISCOUNTS */var COUPONS={GET_COUPON_INFO:'/payment/chargebee/coupon'};var PRODUCT_PREFIX_TO_PACKAGE_MAP={XPS:SUBSCRIPTION_PLAN.DESIGNER,XWDS:SUBSCRIPTION_PLAN.WEB,PGDS:SUBSCRIPTION_PLAN.PHOTO,XPL:SUBSCRIPTION_PLAN.DESIGNER_PERPETUAL,XWDL:SUBSCRIPTION_PLAN.WEB_PERPETUAL,XPGDL:SUBSCRIPTION_PLAN.PHOTO_PERPETUAL};var PRODUCT_CATEGORY_TO_PACKAGE_MAP=(_PRODUCT_CATEGORY_TO_={},__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_PRODUCT_CATEGORY_TO_,PRODUCT_CATEGORY.DESIGNER,SUBSCRIPTION_PLAN.DESIGNER),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_PRODUCT_CATEGORY_TO_,PRODUCT_CATEGORY.WEB,SUBSCRIPTION_PLAN.WEB),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_PRODUCT_CATEGORY_TO_,PRODUCT_CATEGORY.PHOTO,SUBSCRIPTION_PLAN.PHOTO),_PRODUCT_CATEGORY_TO_);var PERPETAUL_PRODUCT_CATEGORY_TO_PACKAGE_MAP=(_PERPETAUL_PRODUCT_CA={},__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_PERPETAUL_PRODUCT_CA,PERPETUAL_PRODUCT_CATEGORY.DESIGNER_PERPETUAL,SUBSCRIPTION_PLAN.DESIGNER_PERPETUAL),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_PERPETAUL_PRODUCT_CA,PERPETUAL_PRODUCT_CATEGORY.WEB_PERPETUAL,SUBSCRIPTION_PLAN.WEB_PERPETUAL),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_PERPETAUL_PRODUCT_CA,PERPETUAL_PRODUCT_CATEGORY.PHOTO_PERPETUAL,SUBSCRIPTION_PLAN.PHOTO_PERPETUAL),_PERPETAUL_PRODUCT_CA);var FALLBACK_COUPON={SUBSCRIPTION:"30RENEW",PERPETUAL:"30OFF_PER"};var DISCOUNT_KEY={TIER1:'tier_1',// expired or will expire in 0-6 months
TIER2:'tier_2',// expires in 6 month - 1 year
TIER3:'tier_3',// expires in more than 1 year (extended).
UPGRADE_POPUP:'upgrade_popup',PHOTOL:'tier_pgd',WEBL:'tier_wd',DESIGNERL:'tier_dp'};var DISCOUNT_TYPE={MAGIX:'magix',COUPON_SET_ID:'coupon_set_id',COUPON_ID:'coupon_id'};var MAXIC_DISCOUNT_PROD_TYPE={PERPETUAL:'perpetual',SUBSCRIPTION:'subscription'};var PACKAGE_DESCRIPTION_ITEM_TYPE={SECTION:'section',ACCORDION:'accordion'};var DISCOUNTS_CONFIG=(_DISCOUNTS_CONFIG={},__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_DISCOUNTS_CONFIG,DISCOUNT_KEY.TIER1,{discount:"0.4",coupon_set_id:"40_OFFER"}),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_DISCOUNTS_CONFIG,DISCOUNT_KEY.TIER2,{discount:"0.5",coupon_set_id:"50_OFFER"}),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_DISCOUNTS_CONFIG,DISCOUNT_KEY.TIER3,{discount:"0.50",coupon_set_id:"50_OFFER"}),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_DISCOUNTS_CONFIG,DISCOUNT_KEY.UPGRADE_POPUP,{discount:"0.2",coupon_set_id:"BOOST_MY_ROI"}),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_DISCOUNTS_CONFIG,DISCOUNT_KEY.PHOTOL,{discount:"0.2",coupon_set_id:"20_V20"}),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_DISCOUNTS_CONFIG,DISCOUNT_KEY.WEBL,{discount:"0.3",coupon_set_id:"30_V20"}),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_DISCOUNTS_CONFIG,DISCOUNT_KEY.DESIGNERL,{discount:"0.4",coupon_set_id:"30_DPV20"}),_DISCOUNTS_CONFIG);// Xara Cloud+ combines Xara Designer Pro+ (desktop product), with Xara Cloud (online editing)
var SUBSCRIPTION_PLAN_UPGRADE_OPTIONS=(_SUBSCRIPTION_PLAN_UP={},_SUBSCRIPTION_PLAN$TE=SUBSCRIPTION_PLAN.TEAM_PLUS,_mutatorMap={},_mutatorMap[_SUBSCRIPTION_PLAN$TE]=_mutatorMap[_SUBSCRIPTION_PLAN$TE]||{},_mutatorMap[_SUBSCRIPTION_PLAN$TE].get=function(){return[SUBSCRIPTION_PLAN.ENTERPRISE];},__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_SUBSCRIPTION_PLAN_UP,SUBSCRIPTION_PLAN.ESSENTIAL,[// Cloud only
SUBSCRIPTION_PLAN.TEAM_PLUS,SUBSCRIPTION_PLAN.ENTERPRISE]),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_SUBSCRIPTION_PLAN_UP,SUBSCRIPTION_PLAN.SCALE,[SUBSCRIPTION_PLAN.ENTERPRISE]),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_SUBSCRIPTION_PLAN_UP,SUBSCRIPTION_PLAN.ENTERPRISE,[]),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_SUBSCRIPTION_PLAN_UP,SUBSCRIPTION_PLAN.BROKERAGES,[]),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_SUBSCRIPTION_PLAN_UP,SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT,[]),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_SUBSCRIPTION_PLAN_UP,SUBSCRIPTION_PLAN.WEB,[// standalone desktop app
SUBSCRIPTION_PLAN.DESIGNER,SUBSCRIPTION_PLAN.TEAM_PLUS,SUBSCRIPTION_PLAN.ENTERPRISE]),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_SUBSCRIPTION_PLAN_UP,SUBSCRIPTION_PLAN.PHOTO,[// standalone desktop app
SUBSCRIPTION_PLAN.DESIGNER,SUBSCRIPTION_PLAN.TEAM_PLUS,SUBSCRIPTION_PLAN.ENTERPRISE]),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_SUBSCRIPTION_PLAN_UP,SUBSCRIPTION_PLAN.DESIGNER,[// standalone desktop app
SUBSCRIPTION_PLAN.TEAM_PLUS,SUBSCRIPTION_PLAN.ENTERPRISE]),__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineEnumerableProperties___default()(_SUBSCRIPTION_PLAN_UP,_mutatorMap),_SUBSCRIPTION_PLAN_UP);var PHOTO_PERPETUAL_LATEST_VERSION=20;var WEB_PERPETUAL_LATEST_VERSION=20;var DESIGNER_PERPETUAL_LATEST_VERSION=20;var MAP_ADDON_TO_LATEST_VERSION=(_MAP_ADDON_TO_LATEST_={},__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_MAP_ADDON_TO_LATEST_,SUBSCRIPTION_PLAN.WEB_PERPETUAL,"webl_".concat(WEB_PERPETUAL_LATEST_VERSION)),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_MAP_ADDON_TO_LATEST_,SUBSCRIPTION_PLAN.PHOTO_PERPETUAL,"photol_".concat(PHOTO_PERPETUAL_LATEST_VERSION)),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_MAP_ADDON_TO_LATEST_,SUBSCRIPTION_PLAN.DESIGNER_PERPETUAL,"designerl_".concat(DESIGNER_PERPETUAL_LATEST_VERSION)),_MAP_ADDON_TO_LATEST_);var SUBSCRIPTION_PERIOD={MONTHLY:'monthly',ANNUAL:'annual',PERPETUAL:'per'};var MEMBER_ADDONS_DISCOUNT_DESKTOP_PLUS=0.6;var SUBSCRIPTION_PRICES=(_SUBSCRIPTION_PRICES={},_SUBSCRIPTION_PLAN$TE2=SUBSCRIPTION_PLAN.TEAM_PLUS,_mutatorMap2={},_mutatorMap2[_SUBSCRIPTION_PLAN$TE2]=_mutatorMap2[_SUBSCRIPTION_PLAN$TE2]||{},_mutatorMap2[_SUBSCRIPTION_PLAN$TE2].get=function(){return this[SUBSCRIPTION_PLAN.SCALE];},__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_SUBSCRIPTION_PRICES,SUBSCRIPTION_PLAN.ESSENTIAL,(_SUBSCRIPTION_PLAN$ES={},__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_SUBSCRIPTION_PLAN$ES,SUBSCRIPTION_PERIOD.MONTHLY,16.80),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_SUBSCRIPTION_PLAN$ES,SUBSCRIPTION_PERIOD.ANNUAL,12.00),_SUBSCRIPTION_PLAN$ES)),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_SUBSCRIPTION_PRICES,SUBSCRIPTION_PLAN.SCALE,(_SUBSCRIPTION_PLAN$SC={},__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_SUBSCRIPTION_PLAN$SC,SUBSCRIPTION_PERIOD.MONTHLY,28.00),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_SUBSCRIPTION_PLAN$SC,SUBSCRIPTION_PERIOD.ANNUAL,20.00),_SUBSCRIPTION_PLAN$SC)),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_SUBSCRIPTION_PRICES,SUBSCRIPTION_PLAN.BROKERAGES,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()({},SUBSCRIPTION_PERIOD.MONTHLY,129.00)),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_SUBSCRIPTION_PRICES,SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()({},SUBSCRIPTION_PERIOD.MONTHLY,99.00)),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_SUBSCRIPTION_PRICES,SUBSCRIPTION_PLAN.PHOTO,(_SUBSCRIPTION_PLAN$PH={},__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_SUBSCRIPTION_PLAN$PH,SUBSCRIPTION_PERIOD.MONTHLY,9.00),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_SUBSCRIPTION_PLAN$PH,SUBSCRIPTION_PERIOD.ANNUAL,6.00),_SUBSCRIPTION_PLAN$PH)),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_SUBSCRIPTION_PRICES,SUBSCRIPTION_PLAN.WEB,(_SUBSCRIPTION_PLAN$WE={},__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_SUBSCRIPTION_PLAN$WE,SUBSCRIPTION_PERIOD.MONTHLY,17.00),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_SUBSCRIPTION_PLAN$WE,SUBSCRIPTION_PERIOD.ANNUAL,12.00),_SUBSCRIPTION_PLAN$WE)),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_SUBSCRIPTION_PRICES,SUBSCRIPTION_PLAN.DESIGNER,(_SUBSCRIPTION_PLAN$DE={},__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_SUBSCRIPTION_PLAN$DE,SUBSCRIPTION_PERIOD.MONTHLY,22.00),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_SUBSCRIPTION_PLAN$DE,SUBSCRIPTION_PERIOD.ANNUAL,16.00),_SUBSCRIPTION_PLAN$DE)),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_SUBSCRIPTION_PRICES,SUBSCRIPTION_PLAN.WEB_PERPETUAL,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()({},SUBSCRIPTION_PERIOD.PERPETUAL,199.00)),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_SUBSCRIPTION_PRICES,SUBSCRIPTION_PLAN.PHOTO_PERPETUAL,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()({},SUBSCRIPTION_PERIOD.PERPETUAL,119.00)),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_SUBSCRIPTION_PRICES,SUBSCRIPTION_PLAN.DESIGNER_PERPETUAL,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()({},SUBSCRIPTION_PERIOD.PERPETUAL,299.00)),__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineEnumerableProperties___default()(_SUBSCRIPTION_PRICES,_mutatorMap2),_SUBSCRIPTION_PRICES);var PACKAGES_CONFIG=(_PACKAGES_CONFIG={},_SUBSCRIPTION_PLAN$TE3=SUBSCRIPTION_PLAN.TEAM_PLUS,_mutatorMap3={},_mutatorMap3[_SUBSCRIPTION_PLAN$TE3]=_mutatorMap3[_SUBSCRIPTION_PLAN$TE3]||{},_mutatorMap3[_SUBSCRIPTION_PLAN$TE3].get=function(){return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},this[SUBSCRIPTION_PLAN.SCALE],{proxy:true});},__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_PACKAGES_CONFIG,SUBSCRIPTION_PLAN.ESSENTIAL,{className:'essentialBox',title:'Essential',description:localize('subscription-plan-essential-description'),optionsTitle:localize('subscription-plan-essential-options-title'),optionsTitleActive:localize('subscription-plan-essential-options-title-active'),membersIncludedInfo:[{label:localize('subscription-plan-essential-includes-1'),tooltip:localize('subscription-plan-essential-includes-1-tooltip')},{label:localize('subscription-plan-essential-includes-2'),rolesTooltip:true}],featuresListAdvanced:[{type:PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,label:localize('subscription-plan-essential-bullet-brand-kit-title'),id:'subscription-plan-essential-bullet-brand-kit-title',description:localize('subscription-plan-essential-bullet-brand-kit-description')},{type:PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,label:localize('subscription-plan-essential-bullet-document-resizing-title'),id:'subscription-plan-essential-bullet-document-resizing-title',description:localize('subscription-plan-essential-bullet-document-resizing-description')},{type:PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,label:localize('subscription-plan-essential-bullet-social-media-title'),id:'subscription-plan-essential-bullet-social-media-title',description:localize('subscription-plan-essential-bullet-social-media-description')},{type:PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,label:localize('subscription-plan-essential-bullet-ai-title'),id:'subscription-plan-essential-bullet-ai-title',description:localize('subscription-plan-essential-bullet-ai-description')},{type:PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,label:localize('subscription-plan-essential-bullet-shared-assets-title'),id:'subscription-plan-essential-bullet-shared-assets-title',description:localize('subscription-plan-essential-bullet-shared-assets-description')},{type:PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,label:localize('subscription-plan-essential-bullet-import-export-title'),id:'subscription-plan-essential-bullet-import-export-title',description:localize('subscription-plan-essential-bullet-import-export-description')},{type:PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,label:localize('subscription-plan-essential-bullet-try-for-free-title'),id:'subscription-plan-essential-bullet-try-for-free-title',highlighted:true,tag:localize('subscription-plan-tag-new'),description:localize('subscription-plan-essential-bullet-try-for-free-description')}],isPlusPackage:false,isCloudSuitePlan:true,isCreativeToolsPlan:false,isRealEstatePlan:false,isPerpetual:false,isMultiUser:true,freeSeatsIncluded:3,isEmptySeatsAllowed:true,icon:__WEBPACK_IMPORTED_MODULE_6_theme_icons__["A" /* IconEssential */],isCloudTag:true,isDesktopTag:false,order:4,selectedAddons:{membersess:{isRecurring:true,isObsolete:false}}}),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_PACKAGES_CONFIG,SUBSCRIPTION_PLAN.SCALE,{className:'scaleBox',title:'Scale',description:localize('subscription-plan-scale-description'),descriptionDesktop:localize('subscription-plan-scale-description-desktop'),optionsTitle:localize('subscription-plan-scale-options-title'),optionsTitleDesktop:localize('subscription-plan-scale-options-title-desktop'),membersIncludedInfo:[{label:localize('subscription-plan-scale-includes-1'),tooltip:localize('subscription-plan-scale-includes-1-tooltip')},{label:localize('subscription-plan-scale-includes-2'),rolesTooltip:true}],featuresListMain:[{label:localize('subscription-plan-scale-list-main-1')},{label:localize('subscription-plan-scale-list-main-2')},{label:localize('subscription-plan-scale-list-main-3')},{label:localize('subscription-plan-scale-list-main-4')},{label:localize('subscription-plan-scale-list-main-5')},{label:localize('subscription-plan-scale-list-main-6')}],featuresListAdvanced:[{type:PACKAGE_DESCRIPTION_ITEM_TYPE.SECTION,label:localize('subscription-plan-scale-section-ai-title'),id:'subscription-plan-scale-section-ai-title',description:localize('subscription-plan-scale-section-ai-description'),tag:localize('subscription-plan-tag-new'),bullets:[{type:PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,label:localize('subscription-plan-scale-bullet-ai-writter-title'),id:'subscription-plan-scale-bullet-ai-writter-title',description:localize('subscription-plan-scale-bullet-ai-writter-description')},{type:PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,label:localize('subscription-plan-scale-bullet-ai-translator-title'),id:'subscription-plan-scale-bullet-ai-translator-title',description:localize('subscription-plan-scale-bullet-ai-translator-description')}]},{type:PACKAGE_DESCRIPTION_ITEM_TYPE.SECTION,label:localize('subscription-plan-scale-section-collaborate-title'),id:'subscription-plan-scale-section-collaborate-title',bullets:[{type:PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,id:'subscription-plan-scale-bullet-library-title',label:localize('subscription-plan-scale-bullet-library-title'),description:localize('subscription-plan-scale-bullet-library-description')},{type:PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,label:localize('subscription-plan-scale-bullet-template-modification-title'),id:'subscription-plan-scale-bullet-template-modification-title',description:localize('subscription-plan-scale-bullet-template-modification-description')},{type:PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,label:localize('subscription-plan-scale-bullet-user-roles-title'),id:'subscription-plan-scale-bullet-user-roles-title',description:localize('subscription-plan-scale-bullet-user-roles-description')},{type:PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,label:localize('subscription-plan-scale-bullet-member-access-title'),id:'subscription-plan-scale-bullet-member-access-title',description:localize('subscription-plan-scale-bullet-member-access-description')},{type:PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,label:localize('subscription-plan-scale-bullet-approved-media-title'),id:'subscription-plan-scale-bullet-approved-media-title',description:localize('subscription-plan-scale-bullet-approved-media-description')},{type:PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,label:localize('subscription-plan-scale-bullet-approved-templates-title'),id:'subscription-plan-scale-bullet-approved-templates-title',description:localize('subscription-plan-scale-bullet-approved-templates-description')},{type:PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,label:localize('subscription-plan-scale-bullet-analytics-title'),id:'subscription-plan-scale-bullet-analytics-title',description:localize('subscription-plan-scale-bullet-analytics-description')}]},{type:PACKAGE_DESCRIPTION_ITEM_TYPE.SECTION,label:localize('subscription-plan-scale-section-content-assistance-title'),id:'subscription-plan-scale-section-content-assistance-title',bullets:[{type:PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,label:localize('subscription-plan-scale-bullet-curated-library-title'),id:'subscription-plan-scale-bullet-curated-library-title',description:localize('subscription-plan-scale-bullet-curated-library-description'),tag:localize('subscription-plan-tag-new')}]}],isPlusPackage:false,/* temporarily disable */isCloudSuitePlan:true,isCreativeToolsPlan:false,/* temporarily disable */isRealEstatePlan:false,isPerpetual:false,isMultiUser:true,isEmptySeatsAllowed:true,freeSeatsIncluded:3,icon:__WEBPACK_IMPORTED_MODULE_6_theme_icons__["I" /* IconScale */],isCloudTag:true,isDesktopTag:true,customPackageTag:localize('subscription-plan-scale-tag'),order:5,selectedAddons:{membersplus:{isRecurring:true,isObsolete:false},members:{isRecurring:true,isObsolete:true}}}),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_PACKAGES_CONFIG,SUBSCRIPTION_PLAN.ENTERPRISE,{className:'enterpriseBox',title:'Enterprise',description:localize('subscription-plan-enterprise-description'),optionsTitle:localize('subscription-plan-enterprise-options-title'),featuresListAdvanced:[{type:PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,label:localize('subscription-plan-enterprise-bullet-flexible-pricing-title'),id:'subscription-plan-enterprise-bullet-flexible-pricing-title',description:localize('subscription-plan-enterprise-bullet-flexible-pricing-description')},{type:PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,label:localize('subscription-plan-enterprise-bullet-unlimited-storage-title'),id:'subscription-plan-enterprise-bullet-unlimited-storage-title',description:localize('subscription-plan-enterprise-bullet-unlimited-storage-description')},{type:PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,label:localize('subscription-plan-enterprise-bullet-sso-title'),id:'subscription-plan-enterprise-bullet-sso-title',description:localize('subscription-plan-enterprise-bullet-sso-description')},{type:PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,label:localize('subscription-plan-enterprise-bullet-custom-integration-title'),id:'subscription-plan-enterprise-bullet-custom-integration-title',description:localize('subscription-plan-enterprise-bullet-custom-integration-description')},{type:PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,label:localize('subscription-plan-enterprise-bullet-multi-team-title'),id:'subscription-plan-enterprise-bullet-multi-team-title',description:localize('subscription-plan-enterprise-bullet-multi-team-description')},{type:PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,label:localize('subscription-plan-enterprise-bullet-api-title'),id:'subscription-plan-enterprise-bullet-api-title',description:localize('subscription-plan-enterprise-bullet-api-description')},{type:PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,label:localize('subscription-plan-enterprise-bullet-playbooks-title'),id:'subscription-plan-enterprise-bullet-playbooks-title',description:localize('subscription-plan-enterprise-bullet-playbooks-description'),tag:localize('subscription-plan-tag-coming-soon')},{type:PACKAGE_DESCRIPTION_ITEM_TYPE.SECTION,label:localize('subscription-plan-enterprise-section-self-service-title'),id:'subscription-plan-enterprise-section-self-service-title',bullets:[{type:PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,label:localize('subscription-plan-enterprise-bullet-campaign-posting-title'),id:'subscription-plan-enterprise-bullet-campaign-posting-title',description:localize('subscription-plan-enterprise-bullet-campaign-posting-description'),tag:localize('subscription-plan-tag-new')},{type:PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,label:localize('subscription-plan-enterprise-bullet-community-campaigns-title'),id:'subscription-plan-enterprise-bullet-community-campaigns-title',description:localize('subscription-plan-enterprise-bullet-community-campaigns-description')}]},{type:PACKAGE_DESCRIPTION_ITEM_TYPE.SECTION,label:localize('subscription-plan-enterprise-section-template-assistance-title'),id:'subscription-plan-enterprise-section-template-assistance-title',bullets:[{type:PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,label:localize('subscription-plan-enterprise-bullet-library-setup-title'),id:'subscription-plan-enterprise-bullet-library-setup-title',description:localize('subscription-plan-enterprise-bullet-library-setup-description')},{type:PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,label:localize('subscription-plan-enterprise-bullet-template-updates-title'),id:'subscription-plan-enterprise-bullet-template-updates-title',description:localize('subscription-plan-enterprise-bullet-template-updates-description')},{type:PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,label:localize('subscription-plan-enterprise-bullet-strategy-definition-title'),id:'subscription-plan-enterprise-bullet-strategy-definition-title',description:localize('subscription-plan-enterprise-bullet-strategy-definition-description')},{type:PACKAGE_DESCRIPTION_ITEM_TYPE.ACCORDION,label:localize('subscription-plan-enterprise-bullet-personalized-training-title'),id:'subscription-plan-enterprise-bullet-personalized-training-title',description:localize('subscription-plan-enterprise-bullet-personalized-training-description')}]}],order:6,icon:__WEBPACK_IMPORTED_MODULE_6_theme_icons__["I" /* IconScale */],isPlusPackage:false,isCloudSuitePlan:true,isCreativeToolsPlan:false,isRealEstatePlan:false,isPerpetual:false,isCloudTag:true,isDesktopTag:true,doesNotExistInCB:true}),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_PACKAGES_CONFIG,SUBSCRIPTION_PLAN.WEB,{/* standalone desktop app (subscription) */className:'webBox',title:'Web<br> Designer+',description:localize('subscription-plan-web-description'),per_user:localize('subscription-plan-web-includes'),optionsTitle:localize('subscription-plan-web-options-title'),featuresListMain:[{label:localize('subscription-plan-web-list-main-1')},{label:localize('subscription-plan-web-list-main-2')},{label:localize('subscription-plan-web-list-main-3')},{label:localize('subscription-plan-web-list-main-4')},{label:localize('subscription-plan-web-list-main-5')},{label:localize('subscription-plan-web-list-main-6')},{label:localize('subscription-plan-web-list-main-7')},{label:localize('subscription-plan-web-list-main-8')},{label:localize('subscription-ovhcloud-discount')}],isPlusPackage:true,isCloudSuitePlan:false,isCreativeToolsPlan:true,isRealEstatePlan:false,isPerpetual:false,isMultiUser:true,freeSeatsIncluded:1,isEmptySeatsAllowed:true,icon:__WEBPACK_IMPORTED_MODULE_6_theme_icons__["L" /* IconWD */],isCloudTag:false,isDesktopTag:true,order:2,selectedAddons:{membersweb:{isRecurring:true,isObsolete:false}}}),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_PACKAGES_CONFIG,SUBSCRIPTION_PLAN.PHOTO,{/* standalone desktop app (subscription) */className:'photoBox',title:'Photo &<br> Graphic Designer+',description:localize('subscription-plan-photo-description'),per_user:localize('subscription-plan-photo-includes'),optionsTitle:localize('subscription-plan-photo-options-title'),featuresListMain:[{label:localize('subscription-plan-photo-list-main-1')},{label:localize('subscription-plan-photo-list-main-2')},{label:localize('subscription-plan-photo-list-main-3')},{label:localize('subscription-plan-photo-list-main-4')},{label:localize('subscription-plan-photo-list-main-5')},{label:localize('subscription-plan-photo-list-main-6')},{label:localize('subscription-plan-photo-list-main-7')},{label:localize('subscription-plan-photo-list-main-8')}],isPlusPackage:true,isCloudSuitePlan:false,isCreativeToolsPlan:true,isRealEstatePlan:false,isPerpetual:false,isMultiUser:true,freeSeatsIncluded:1,isEmptySeatsAllowed:true,icon:__WEBPACK_IMPORTED_MODULE_6_theme_icons__["G" /* IconPGD */],isCloudTag:false,isDesktopTag:true,order:1,selectedAddons:{membersphoto:{isRecurring:true,isObsolete:false}}}),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_PACKAGES_CONFIG,SUBSCRIPTION_PLAN.DESIGNER,{/* standalone desktop app (subscription) */className:'designerBox',title:'Designer Pro+',description:localize('subscription-plan-designer-description'),per_user:localize('subscription-plan-designer-includes'),optionsTitle:localize('subscription-plan-designer-options-title'),featuresListMain:[{label:localize('subscription-plan-designer-list-main-1')},{label:localize('subscription-plan-designer-list-main-2')},{label:localize('subscription-plan-designer-list-main-3')},{label:localize('subscription-plan-designer-list-main-4')},{label:localize('subscription-plan-designer-list-main-5')},{label:localize('subscription-plan-designer-list-main-6')},{label:localize('subscription-plan-designer-list-main-7')},{label:localize('subscription-plan-designer-list-main-8')},{label:localize('subscription-ovhcloud-discount')}],isPlusPackage:true,isCloudSuitePlan:false,isCreativeToolsPlan:true,isRealEstatePlan:false,isPerpetual:false,isMultiUser:true,freeSeatsIncluded:1,isEmptySeatsAllowed:true,icon:__WEBPACK_IMPORTED_MODULE_6_theme_icons__["x" /* IconDP */],isCloudTag:false,isDesktopTag:true,order:3,selectedAddons:{membersdes:{isRecurring:true,isObsolete:false}}}),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_PACKAGES_CONFIG,SUBSCRIPTION_PLAN.WEB_PERPETUAL,{/* standalone desktop app (perpetual) */className:'webBox',title:'Web<br> Designer v_VERSION_',description:localize('subscription-plan-web-per-description'),per_user:localize('subscription-plan-web-per-includes'),featuresListMain:[{label:localize('subscription-plan-web-per-list-main-1')},{label:localize('subscription-plan-web-per-list-main-2')},{label:localize('subscription-plan-web-per-list-main-3')},{label:localize('subscription-plan-web-per-list-main-4'),excluded:true},{label:localize('subscription-plan-web-per-list-main-5')},{label:localize('subscription-ovhcloud-discount')}],isPlusPackage:false,isCloudSuitePlan:false,isCreativeToolsPlan:true,isRealEstatePlan:false,isPerpetual:true,icon:__WEBPACK_IMPORTED_MODULE_6_theme_icons__["M" /* IconWDPerpetual */],isEmptySeatsAllowed:false,isAddon:true,order:2}),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_PACKAGES_CONFIG,SUBSCRIPTION_PLAN.PHOTO_PERPETUAL,{/* standalone desktop app (perpetual) */className:'photoBox',title:'Photo & Graphic<br> Designer v_VERSION_',description:localize('subscription-plan-photo-per-description'),per_user:localize('subscription-plan-photo-per-includes'),featuresListMain:[{label:localize('subscription-plan-photo-per-list-main-1')},{label:localize('subscription-plan-photo-per-list-main-2')},{label:localize('subscription-plan-photo-per-list-main-3')},{label:localize('subscription-plan-photo-per-list-main-4'),excluded:true},{label:localize('subscription-plan-photo-per-list-main-5')}],isPlusPackage:false,isCloudSuitePlan:false,isCreativeToolsPlan:true,isRealEstatePlan:false,isPerpetual:true,icon:__WEBPACK_IMPORTED_MODULE_6_theme_icons__["H" /* IconPGDPerpetual */],isEmptySeatsAllowed:false,isAddon:true,order:1}),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_PACKAGES_CONFIG,SUBSCRIPTION_PLAN.DESIGNER_PERPETUAL,{/* standalone desktop app (perpetual) */className:'designerBox',title:'Designer Pro v_VERSION_',description:localize('subscription-plan-designer-per-description'),per_user:localize('subscription-plan-designer-per-includes'),featuresListMain:[{label:localize('subscription-plan-designer-per-list-main-1')},{label:localize('subscription-plan-designer-per-list-main-2')},{label:localize('subscription-plan-designer-per-list-main-3')},{label:localize('subscription-plan-designer-per-list-main-4')},{label:localize('subscription-plan-designer-per-list-main-5'),excluded:true},{label:localize('subscription-plan-designer-per-list-main-6')},{label:localize('subscription-ovhcloud-discount')}],isPlusPackage:false,isCloudSuitePlan:false,isCreativeToolsPlan:true,isRealEstatePlan:false,isPerpetual:true,icon:__WEBPACK_IMPORTED_MODULE_6_theme_icons__["y" /* IconDPPerpetual */],isEmptySeatsAllowed:false,isAddon:true,order:3}),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_PACKAGES_CONFIG,SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT,{title:localize('package-individual-agents-title'),tag:localize('package-individual-agents-tag'),subtitle:localize('package-individual-agents-subtitle'),whatYouGetTitle:localize('package-individual-agents-what-you-get-title'),basePrice:99,discountPrice:49,individualAgentsFeatureslist:[{title:localize('package-individual-agents-feature-1')},{title:localize('package-individual-agents-feature-2')},{title:localize('package-individual-agents-feature-3')},{title:localize('package-individual-agents-feature-4')},{title:localize('package-individual-agents-feature-5'),description:localize('package-individual-agents-feature-5-description')},{title:localize('package-individual-agents-feature-6')}],individualAgentsWhatToGet:[{title:localize('package-individual-agents-what-you-get-1')},{title:localize('package-individual-agents-what-you-get-2')},{title:localize('package-individual-agents-what-you-get-3')},{title:localize('package-individual-agents-what-you-get-4')}],isPlusPackage:false,isCloudSuitePlan:false,isCreativeToolsPlan:false,isRealEstatePlan:true,isPerpetual:false,isMultiUser:false,freeSeatsIncluded:1,isEmptySeatsAllowed:false,isCloudTag:false,isDesktopTag:false,selectedAddons:{}}),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_PACKAGES_CONFIG,SUBSCRIPTION_PLAN.BROKERAGES,{title:localize('package-brokerages-title'),tag:localize('package-brokerages-tag'),basePrice:129,extraPricePerAgent:20,brokeragesFeatureslist:[{title:localize('package-brokerages-section-1-title'),description:localize('package-brokerages-section-1-description'),featuresList:[{title:localize('package-brokerages-section-1-feature-1-title'),description:localize('package-brokerages-section-1-feature-1-description')},{title:localize('package-brokerages-section-1-feature-2-title')},{title:localize('package-brokerages-section-1-feature-3-title')}]},{title:localize('package-brokerages-section-2-title'),description:localize('package-brokerages-section-2-description'),featuresList:[{title:localize('package-brokerages-section-2-feature-1-title')},{title:localize('package-brokerages-section-2-feature-2-title')},{title:localize('package-brokerages-section-2-feature-3-title')},{title:localize('package-brokerages-section-2-feature-4-title')}]},{title:localize('package-brokerages-section-3-title'),description:localize('package-brokerages-section-3-description'),featuresList:[{title:localize('package-brokerages-section-3-feature-1-title')},{title:localize('package-brokerages-section-3-feature-2-title')},{title:localize('package-brokerages-section-3-feature-3-title')}]},{title:localize('package-brokerages-section-4-title'),description:localize('package-brokerages-section-4-description'),featuresList:[{title:localize('package-brokerages-section-4-feature-1-title')},{title:localize('package-brokerages-section-4-feature-2-title')},{title:localize('package-brokerages-section-4-feature-3-title')}]}],isPlusPackage:false,isCloudSuitePlan:false,isCreativeToolsPlan:false,isRealEstatePlan:true,isPerpetual:false,isMultiUser:true,isEmptySeatsAllowed:true,freeSeatsIncluded:5,isCloudTag:false,isDesktopTag:false,order:2,selectedAddons:{members_brokerages:{isRecurring:true,isObsolete:false}}}),__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineEnumerableProperties___default()(_PACKAGES_CONFIG,_mutatorMap3),_PACKAGES_CONFIG);var getCloudPlans=function getCloudPlans(){var keys=Object.keys(PACKAGES_CONFIG);var result=[];keys.forEach(function(key){if(PACKAGES_CONFIG[key].isCloudSuitePlan){result.push(key);}});return result;};var getRealEstatePlans=function getRealEstatePlans(){var keys=Object.keys(PACKAGES_CONFIG);var result=[];keys.forEach(function(key){if(PACKAGES_CONFIG[key].isRealEstatePlan){result.push(key);}});return result;};var getMemberAddonsIds=function getMemberAddonsIds(){var keys=Object.keys(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.omitBy(PACKAGES_CONFIG,function(item){return Boolean(item.proxy);}));var result=[];keys.forEach(function(packageKey){var selectedAddons=PACKAGES_CONFIG[packageKey].selectedAddons;if(selectedAddons){result.push.apply(result,__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(Object.keys(selectedAddons)));}});return result;};var DEFAULT_SUBSCRIPTION={plan:undefined,period:SUBSCRIPTION_PERIOD.ANNUAL,currency:CURRENCIES.USD.key};var CHARGEBEE_SITE_URL="xara";var CHARGEBEE_ENABLE_GA_TRACKING="true";var CHARGEBEE_ENABLE_REFERSION_TRACKING="true";var SUBSCRIPTION_KEY='subscription';// used as a key to store CAP settings
var CAP_KEY='cap';// used as a key to store CAP settings
var ONBOARDING_KEY='onboarding';// used as a key to store the onboarding state in user settings
// used as a key to store designer pro download data in user settings
var USER_DOWNLOAD_NOTIFICATION_SETTING_KEY='tms:download-notification';var USER_DISCOUNT_BANNER_SETTING_KEY='discount-banner';var FOREVER_HIDDEN_KEY='forever-hidden';var USER_PAGE_SETTINGS_KEY='user-page-settings';var FONTS_ACCEPTED_FILE_TYPES=['.ttf','.otf'];// allowed font extensions
var STATIC_RESOURCE_INDUSTRIES_PATH='/json/companyindustries';var STATIC_RESOURCE_COUNTRIES_PATH='/json/companycountries';var STATIC_RESOURCE_SIZES_PATH='/json/companysizes';var apiStatus={url:"status.xara.com/api/v1/components/",timeout:30000,// 30s
status:{ONLINE:1,OFFLINE:4,MAINTENANCE:3},endpoint:{'camlinux4':6,'camlinux2':8,'camlinux5':10,'ec2linuxstaging':4,'pre-prod-mw':4,'elb':2,'prod-mw':2}};var DESKTOP_APPS={DESIGNER:{title:'Designer Pro+',downloadUrl:'https://xpsupdater.xara.com/Installer/XPSSetup.exe',detailsUrl:'https://www.xara.com/designerpro-plus/',storageKey:'designerProDownloads',// keep this name for backward compatibility with XC client
trackingKey:'pro-plus',// keep this name for backward compatibility with XC client
isPerpetual:false},WEB:{title:'Web Designer+',downloadUrl:'https://xpsupdater.xara.com/Installer/XWDSSetup.exe',detailsUrl:'https://www.xara.com/webdesigner-plus/',storageKey:'WDPlusDownloads',trackingKey:'wd-plus',isPerpetual:false},PHOTO:{title:'Photo & Graphic Designer+',downloadUrl:'https://xpsupdater.xara.com/Installer/PGDSSetup.exe',detailsUrl:'https://www.xara.com/photo-graphic-plus/',storageKey:'PGDPlusDownloads',trackingKey:'pgd-plus',isPerpetual:false},DESIGNERL:{title:'Designer Pro v_VERSION_',downloadUrl:'https://xpsupdater.xara.com/Installer/XPL_VERSION_Setup.exe',storageKey:'designerProPerpetualDownloads',// keep this name for backward compatibility with XC client
trackingKey:'pro-perpetual',// keep this name for backward compatibility with XC client
isPerpetual:true},WEBL:{title:'Web Designer v_VERSION_',downloadUrl:'https://xpsupdater.xara.com/Installer/XWDL_VERSION_Setup.exe',storageKey:'WDPerpetualDownloads',trackingKey:'wd-perpetual',isPerpetual:true},PHOTOL:{title:'Photo & Graphic Designer v_VERSION_',downloadUrl:'https://xpsupdater.xara.com/Installer/XPGDL_VERSION_Setup.exe',storageKey:'PGDPerpetualDownloads',trackingKey:'pgd-perpetual',isPerpetual:true}};var TEMPORARY_COMPANY_PREFIX='tempcomp_';var loggerConfig={errorHistoryStorageKey:'cfg.logger.errorHistory',errorQueueStorageKey:'cfg.logger.errorQueue',endpoint:"https://logs.xara.com:5005"||'https://logs.xara.com:5010'/* cl2 */,sendFromDev:"true"||false};var REACT_APP_BUILD_NUMBER="240"||'not available';var REACT_APP_BRANCH="v0.241.0"||'not available';var REACT_APP_BUILD_VCS_NUMBER="=8549e3d7c1ce041fd223f917537f60b6528fb472"||'not available';var SERIAL_NUMBER_REGEXP=new RegExp(/^[\w-]+$/);var USER_TABLE_ALL='users_all';var USER_TABLE_ADMINS_AND_MEMBERS='admins_and_members';var USER_TABLE_GUESTS='guest';var USER_TABLE_REDUCE_USERS='reduce_users';var USER_TABLE_MANAGE_AGENTS='manage_agents';var USER_TABLES=(_USER_TABLES={},__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_USER_TABLES,USER_TABLE_ADMINS_AND_MEMBERS,{label:localize('users-table-header-admins-and-members')}),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_USER_TABLES,USER_TABLE_GUESTS,{label:localize('users-table-header-guests')}),_USER_TABLES);var TABLE_COLUMNS={FULL_NAME:'full_name',EMAIL:'email',ROLE:'role',MLS_ID:'mls_id',MLS_ID_TYPE2:'mls_id_type2',CONNECTION_STATUS:'connection_status'};var SORT_ORDER={ASC:'ascending',DESC:'descending'};var SUBSCRIPTION_VIEW={CURRENT_PRODUCTS:localize('subscription-your-products-tab'),PURCHASE_OPTIONS:localize('subscription-purchase-options-tab')};var SERIAL_NUMBER_PREFIXES_OLD_PRODUCTS=['X3D','X32','XXP','XX2','XXA','XWS','XMM'];var SERIAL_NUMBER_PREFIXES_NEW_PRODUCTS=['P','P2','P3','S2'];var BUY_MORE_POPUP_TYPE={SEATS:'seats',LICENSES:'licenses'};var QUANTITY_TYPE={SEATS:'seats',LICENSES:'licenses'};var COUPON_TYPE={SEATS:'seats',LICENSES:'licenses'};var REDUCE_ACTION={KEEP_ROLE:'keep-role',CHANGE_TO_GUEST:'change-to-guest',REMOVE:'remove'};var ADDON_TYPE={PERPETUAL:'perpetual',MEMBER:'member'};var ADDONS_LIST={AI:'ai',CLOUD_STORAGE:'cloud_storage',DESIGN_SERVICES:'design_services',HOSTING:'hosting'};var ADDONS_CONFIG=(_ADDONS_CONFIG={},__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_ADDONS_CONFIG,ADDONS_LIST.AI,{title:localize('addon-ai-title'),icon:__WEBPACK_IMPORTED_MODULE_6_theme_icons__["t" /* IconAddonAI */],description:localize('addon-ai-description'),details:'addon-ai-details',featuresList:[{label:localize('addon-ai-details-list-1')},{label:localize('addon-ai-details-list-2')},{label:localize('addon-ai-details-list-3')},{label:localize('addon-ai-details-list-4')},{label:localize('addon-ai-details-list-5')}],featuresNote:localize('addon-ai-details-list-note'),buttonLabel:localize('subscription-contact-sales'),intercomMessage:localize('addon-intercom-message-ai'),isCloudAddon:true,isDesktopAddon:false}),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_ADDONS_CONFIG,ADDONS_LIST.CLOUD_STORAGE,{title:localize('addon-cloud-storage-title'),icon:__WEBPACK_IMPORTED_MODULE_6_theme_icons__["u" /* IconAddonCloudStorage */],description:localize('addon-cloud-storage-description'),details:'addon-cloud-storage-details',buttonLabel:localize('subscription-contact-sales'),intercomMessage:localize('addon-intercom-message-cloud-storage'),isCloudAddon:true,isDesktopAddon:false}),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_ADDONS_CONFIG,ADDONS_LIST.DESIGN_SERVICES,{title:localize('addon-design-service-title'),icon:__WEBPACK_IMPORTED_MODULE_6_theme_icons__["v" /* IconAddonDesignServices */],description:localize('addon-design-service-description'),details:'addon-design-service-details',tag:localize('addon-design-service-tag'),buttonLabel:localize('subscription-get-a-quote'),intercomMessage:localize('addon-intercom-message-design-services'),isCloudAddon:true,isDesktopAddon:false}),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_ADDONS_CONFIG,ADDONS_LIST.HOSTING,{title:localize('addon-hosting-title'),icon:__WEBPACK_IMPORTED_MODULE_6_theme_icons__["w" /* IconAddonHosting */],description:localize('addon-hosting-description'),featuresList:[{label:localize('addon-hosting-details-list-1')},{label:localize('addon-hosting-details-list-2')},{label:localize('addon-hosting-details-list-3')}],tagSubscription:localize('addon-hosting-details-subscription'),tagPerpetual:localize('addon-hosting-details-perpetual'),buttonLabel:localize('addon-hosting-button-label'),buttonURL:HOSTING_BUTTON_URL_EN,isCloudAddon:false,isDesktopAddon:true}),_ADDONS_CONFIG);var ENABLE_MLS_ID_FIELD_FOR_INDUSTRIES=[1/* real estate */];var REAL_ESTATE_INDUSTY_ID=1;var PACKAGES_HIDE_SIDEBAR_BREAKPOINT=1500;// show Reduce Users popup or force checkout with all members and admins
var FORCE_RE_CHECKOUT_WITH_ALL_USERS=true;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "createGenerateClassName", {
  enumerable: true,
  get: function get() {
    return _createGenerateClassName.default;
  }
});
Object.defineProperty(exports, "createMuiTheme", {
  enumerable: true,
  get: function get() {
    return _createMuiTheme.default;
  }
});
Object.defineProperty(exports, "jssPreset", {
  enumerable: true,
  get: function get() {
    return _jssPreset.default;
  }
});
Object.defineProperty(exports, "MuiThemeProvider", {
  enumerable: true,
  get: function get() {
    return _MuiThemeProvider.default;
  }
});
Object.defineProperty(exports, "createStyles", {
  enumerable: true,
  get: function get() {
    return _createStyles.default;
  }
});
Object.defineProperty(exports, "withStyles", {
  enumerable: true,
  get: function get() {
    return _withStyles.default;
  }
});
Object.defineProperty(exports, "withTheme", {
  enumerable: true,
  get: function get() {
    return _withTheme.default;
  }
});

var _createGenerateClassName = _interopRequireDefault(__webpack_require__(363));

var _createMuiTheme = _interopRequireDefault(__webpack_require__(256));

var _jssPreset = _interopRequireDefault(__webpack_require__(369));

var _MuiThemeProvider = _interopRequireDefault(__webpack_require__(253));

var _createStyles = _interopRequireDefault(__webpack_require__(749));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _withTheme = _interopRequireDefault(__webpack_require__(103));

/***/ }),
/* 19 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(8);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

module.exports = _objectSpread;

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(670);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({INVALID_COMPANY_ID_OR_COMPANY_NAME:270403,INVALID_PHONE_NUMBER:270427,INVALID_WEBSITE_URL:270428,INVALID_COMPANY_COUNTRY:270433,INVALID_COMPANY_INDUSTRY:270429,INVALID_COMPANY_SIZE:270430,INVALID_CLOUD_DRIVE_ADDED:50104,INVALID_COMPANY_NAME:270415,INVALID_EMAIL:270423,INVALID_WORKSPACE_NAME:270415,COMPANY_NAME_ALREADY_EXISTS:270416,INSUFFICIENT_USER_RIGHTS:270312,COMPANY_NOT_FOUND:270302,USER_NOT_VALIDATED:270324,DELETE_MYSELF:270320,DELETE_MYSELF_AS_ADMIN:11048,FAILED_TO_CREATE_COMPANY_SUBSCRIPTION:11053,NO_ACTIVE_SUBSCRIPTION:11056,PAYMENT_PROCESSING_FAILED:13005,PAYMENT_METHOD_VERIFICATION_FAILED:13006,PAYMENT_METHOD_NOT_PRESENT:13007,PAYMENT_GATEWAY_CURRENCY_INCOMPATIBLE:13008,PAYMENT_PROVIDER_INTERNAL_ERROR:13001,//CB is the provider in this case
SUBSCRIPTION_ALREADY_EXISTS:13002,SUBSCRIPTION_PLAN_CURRENCY_MISMATCH:11065,THE_NUMBER_OF_THE_USERS_CANNOT_BE_LESS_THAN_THE_NUMBER_OF_USERS_OF_COMPANY:12133,WORKSPACE_NAME_ALREADY_EXISTS:270305,CLOUD_STORAGE_ITEM_NOT_FOLDER:270327,CLOUD_STORAGE_FOLDER_NOT_WRITABLE:270328,COMPANY_ALREADY_EXISTS:270403,USER_ALREADY_EXISTS_IN_COMPANY:270438,DOMAIN_ALREADY_EXISTS_IN_COMPANY:270439,FOLDER_ALREADY_EXISTS_IN_COMPANY:270440,SMART_FIELD_ALREADY_EXISTS_IN_COMPANY:270441,WORKSPACE_ALREADY_EXISTS_IN_COMPANY:270442,USER_ALREADY_EXISTS_IN_WORKSPACE:270443,DOMAIN_ALREADY_EXISTS_IN_WORKSPACE:270444,WRONG_FONT_TYPE_UPLOADED:180008,CHECKSUM_CONFLICT_INVALID_FONT_FILE:180013,WAITING_FOR_API:6035,USER_AUTHENTICATION_REQUIRED:10028,SEGMENT_NOT_LOADED:1001,UNKNOWN:6000,OFFLINE:6017,// client side OFFLINE/CORS/aborted/webdev blocked
XHR_FAILED:6047,// not API error and not OFFLINE but could be 404
CB_NOT_LOADED:6048,REJECTED_API_STATUS_REQUEST:6038,PAYMENT_PROVIDER_INTERNAL_COUPON_ERROR:6056,WRONG_PASSWORD:201105,EMAIL_ALREADY_USED:201118,INVALID_EMAIL_FORMAT:201101,INVALID_FIRST_NAME:201124,INVALID_LAST_NAME:201125,INVALID_PASSWORD:201102,PASSWORDS_NOT_MATCHING:201112,PASSWORD_ALREADY_USED:201117,UNKNOWN_EMAIL:201108,INVALID_TARGET_DOMAIN:201104,// invalid req.body.host request property
NOTIFICATION_SERVICE_INTERNAL_ERROR:201122,METHOD_NOT_SUPPORTED:200114,// checking existence of the target collection in database	 
EMAIL_ASSOCIATED_TO_ANOTHER_USER:201116,COUNTRY_CANNOT_BE_DETECTED:12145,CRS_INFO_REQUEST_FAILED:128001,CRS_INVALID_CREDENTIALS:128002,CRS_CREDENTIALS_ALREADY_USED:128003,FAILED_TO_GET_PAYMENT_COUPON:12092,INVALID_COUPON_SET_ID:270467,INVALID_COUPON_ID:270468,INVALID_COUPON_CODE_ID:12107,//check in MW that the couponId is not an empty string (/payment/chargebee/coupon route)
FAILED_TO_RETRIEVE_COUPON:12106,// non exposable error from other service in /payment/chargebee/coupon route
COUPON_CODE_DOES_NOT_EXIST:13010,//coming from CB, on /payment/chargebee/coupon route,
FAILED_TO_CREATE_COMPANY_ADDON:12091,FAILED_TO_TRIGGER_PAYMENT_FLOW:11023,COUPON_CODE_ALREADY_EXISTS:13009,// Invite users popup
SUBSCRIPTION_PLAN_PROHIBITS_USER_MODIFICATION:11067,FAILED_TO_ADD_USERS_TO_COMPANY:11043,INVALID_USER:270301,INVALID_USERS:270410,// Member addons
THE_MEMBERS_ADDON_QUANTITY_HAS_TO_BE_A_POSITIVE_NUMBER:12134,COMPANY_DOES_NOT_HAVE_A_VALID_SUBSCRIPTION:12129,NOT_ALLOWED_TO_BUY_EMPTY_SEATS_TO_THE_CURRENT_SUBSCRIPTION:12128,FAILED_TO_MODIFY_MEMBERS_ADDON_OF_SUBSCRIPTION:12132,INVALID_ADD_ADDON_PACKET1:270346,INVALID_ADD_ADDON_PACKET2:270465,INVALID_PAYMENT_ACCOUNT_ID:270425,INVALID_PAYMENT_PRODUCT_ID:270431,INVALID_UPDATE_ADDON_PACKET:270345,INVALID_ADDON_USERS_ACTION:270347,ADDON_DOES_NOT_EXIST1:270348,ADDON_DOES_NOT_EXIST2:13011,//coming from CB
FAILED_TO_RETRIEVE_ADDON_DETAILS:12136,INVALID_ADDON_ID:12135,//The validity checked only on the MW side and only that the addonId is not an empty string	
ALL_OF_THE_MEMBERS_ADDON_ALREADY_REMOVED:12130,THE_QUANTITY_OF_THE_MEMBERS_ADDON_CANNOT_BE_LESS_THAN_THE_QUANTITY_OF_USERS_OF_COMPANY:12131,// Estimate endpoint
COMPANY_DOES_NOT_HAVE_AN_ACTIVE_SUBSCRIPTION:12137,FAILED_TO_RETRIEVE_UPCOMING_INVOICE_ESTIMATION:12138,INVALID_PLAN_ID:12139,//The validity checked only on the MW side and only that the planId is not an empty string
FAILED_TO_RETRIEVE_CREATE_SUBSCRIPTION_ESTIMATION:12140,// MISC
USER_NOT_FOUND:270322,CUSTOMER_DOES_NOT_EXIST:13012,//coming from CB
USER_SERVICE_INTERNAL_ERROR:270329,COMPANY_HAS_UNLIMITED_TEAM_SUBSCRIPTION:12141,// Rate limit in variuos endpoints
API_REQUEST_LIMIT_EXCEEDED:13013,// Update externalIds endpoint
EXTERNAL_IDS_INVALID_COMPANY_ID:12070,EXTERNAL_IDS_MUST_BE_AN_ARRAY:12155,EXTERNAL_IDS_TARGET_USER_IS_NOT_IN_THE_COMPANY:12152,FAILED_TO_UPDATE_EXTERNAL_ID:12151,DUPLICATE_MLS_IDS:12166,USER_REACHED_THE_COMPANY_INVITATION_LIMIT:12169,// MLS CONNECTION AND OFFICES related endpoints
MLS_NO_LISTINGS_FOUND:1400104,//Office/Agent has no listings
MLS_CONNECTION_NOT_FOUND:1400106,//Connection missing
MLS_INTERNAL_SERVER_ERROR:1400100,//Server error
EMAIL_NOT_VERIFIED:1400101,//Email verification required
SUBSCRIPTION_NEEDED:1400102,//Active subscription required
MLS_COMPANY_NOT_FOUND:1200101,INVALID_MLS_BOARD_CODE:1400105,//Board code not found
MAX_CONNECTIONS_EXCEEDED:1400103,//Company limit reached
INVALID_ADD_CONNECTION_WITH_OFFICE_ID_PACKET:1400109,//Request validation failed
INVALID_ADD_CONNECTION_WITH_AGENT_ID_PACKET:1400110,//Request validation failed
INVALID_DELETE_CONNECTION_PACKET:1400111,//Request validation failed
OFFICE_NOT_FOUND:1400107,//Office not in connection
INVALID_ADD_OFFICE_ID_PACKET:1400112,//Request validation failed
INVALID_DELETE_OFFICE_ID_PACKET:1400113,//Request validation failed
INVALID_AGENT_ID:1400108,//Agent ID format invalid
TOO_MANY_ATTEMPTS:1400114,//Rate limit exceeded
USER_SESSION_INVALID:1200102,// Invalid user session
// AGENT IDS related endpoints
AGENT_INTERNAL_SERVER_ERROR:1600100,//Server error
AGENT_CONNECTION_NOT_FOUND:1600105,//MLS connection not found
AGENT_NO_LISTINGS_FOUND:1600106,//No listings for agent
AGENT_ID_EXISTS:1600101,//Agent MLS ID already assigned
AGENT_NOT_FOUND:1600102,//Agent does not exist
API_KEY_REQUIRED:1600103,//Missing Real Estate API key
INVALID_CONNECTION_ID:1600104,//Invalid MongoDB ObjectId
AGENT_INVALID_COMPANY_ID:1600110,//Company ID invalid
FAILED_TO_LIST_AGENTS:1600111,//Server error
INVALID_ADD_AGENT_MLS_ID_PACKET:1600107,//Request validation failed
INVALID_DELETE_AGENT_MLS_ID_PACKET:1600108,//Request validation failed
INVALID_EDIT_AGENT_MLS_ID_PACKET:1600109,//Request validation failed
// REAL ESTATE API related
INVALID_MLS_CONNECTION_CONFIG:1500119,INVALID_OFFICE_ID:1500105,INVALID_AGENT_CODE:1500104,INVALID_API_KEY:1500101,RE_API_INTERNAL_SERVER_ERROR:1500100,// NEW HTTP SERVICE RELATED
HTTP_INTERNAL_SERVER_ERROR:1700100,HTTP_MISSING_COMPANY_ID:1700101,HTTP_MISSING_USER_ID:1700102});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(346);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return XaraLogo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return PreloaderIcon; });
/* unused harmony export MicrosoftIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return XaraLogoAnimated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CupIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return UsersIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return MoneyBoxIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DeleteIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return Info; });
/* unused harmony export GoBackIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FolderIcon; });
/* unused harmony export ProtectBrandIcon */
/* unused harmony export TeamIcon */
/* unused harmony export SaveTimeIcon */
/* unused harmony export UpdatedIcon */
/* unused harmony export SubscriptionIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FontsIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return DropboxIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return GoogleDriveIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return OneDriveIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return TeamAssetsLogoIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return TeamAssetsImageIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return TeamAssetsOtherIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CheckIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CheckIcon2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return SmartFieldsIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CustomizeIcon; });
/* unused harmony export CloseIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ClearIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return DownloadIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return SharedIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return NextIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return XDarkLogo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return SuccessIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return SpinnerIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return TemplatesIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DocumentsIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AssetsIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return XIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return VoucherIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return VoucherIconColored; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return SortArrow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return IconInvite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return IconAddUsers; });
/* unused harmony export IconAddMls */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return IconTickRounded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return IconErrorRounded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return IconInfoRounded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return IconNoPackage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return IconEssential; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return IconScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return IconPGD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return IconDP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return IconWD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return IconPGDPerpetual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return IconDPPerpetual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return IconWDPerpetual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return WeAcceptIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return WeAcceptEurIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return IconAddonAI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return IconAddonHosting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return IconAddonCloudStorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return IconAddonDesignServices; });
/* unused harmony export IconAddonMLS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return IconMlsIdDone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return IconTextFieldStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return IconMlsIdAdd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CheckIconRounded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return UpdateSeatsIcon; });
/* unused harmony export SelectArrow */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DeleteIconRounded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return SettingsIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return SearchIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ClearSearchIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return MlsIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CopyIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_preloader_gif__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_preloader_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_preloader_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_microsoft_logo_png__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_microsoft_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_microsoft_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_xara_logo_gif__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_xara_logo_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_xara_logo_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_nopackage_png__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_nopackage_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_nopackage_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_we_accept_png__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_we_accept_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_we_accept_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_we_accept_eur_png__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_we_accept_eur_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_we_accept_eur_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_scale_png__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_scale_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_scale_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_essential_png__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_essential_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_essential_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_wd_plus_png__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_wd_plus_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_wd_plus_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_dp_plus_png__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_dp_plus_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_dp_plus_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_pgd_plus_png__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_pgd_plus_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_pgd_plus_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_wd_perpetual_png__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_wd_perpetual_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_wd_perpetual_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_dp_perpetual_png__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_dp_perpetual_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_dp_perpetual_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_pgd_perpetual_png__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_pgd_perpetual_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_pgd_perpetual_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_addon_ai_png__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_addon_ai_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_addon_ai_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_addon_cloud_storage_png__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_addon_cloud_storage_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_addon_cloud_storage_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_addon_design_services_png__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_addon_design_services_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_addon_design_services_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_addon_mls_png__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_addon_mls_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_addon_mls_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_addon_hosting_png__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_addon_hosting_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_addon_hosting_png__);
/* eslint-disable max-len */var XaraLogo=function XaraLogo(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({version:"1.1",viewBox:"0 0 445.88 162.16",width:"445.88",height:"162.16",xmlns:"http://www.w3.org/2000/svg"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{transform:"translate(-18.87 -31.7)",d:"M338.63,31.7H313.38C297,31.7,284.21,45,284.21,61.82v90.35a7.11,7.11,0,1,0,14.21,0V61.82c0-8.67,6.59-15.45,15-15.45h25.25a7.34,7.34,0,0,0,0-14.67Z"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{transform:"translate(-18.87 -31.7)",d:"m230.2 144.86h-51.31c-8.36 0-15-6.81-15-15.47v-16.29a15.25 15.25 0 0 1 15-15.47h72.65v25.22c0 12.15-9.54 22.01-21.34 22.01zm6.34-113.16h-53.69c-16.37 0-29.2 13.25-29.2 30.12a7.12 7.12 0 1 0 14.23 0c0-8.67 6.57-15.45 15-15.45h53.69c8.4 0 15 6.78 15 15.45v21.18h-72.68c-16.06 0-29.18 13.5-29.18 30.12v16.29c0 16.87 12.83 30.1 29.18 30.1h51.31a34.75 34.75 0 0 0 21.34-7.33 7.1 7.1 0 1 0 14.19 0v-90.36c0-16.82-12.83-30.12-29.19-30.12z"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{transform:"translate(-18.87 -31.7)",d:"M429.24,144.86H378c-8.4,0-15-6.81-15-15.47V113.1a15.25,15.25,0,0,1,15-15.47h72.6v25.22C450.56,135,441,144.86,429.24,144.86ZM435.56,31.7H381.89c-16.37,0-29.2,13.25-29.2,30.12a7.1,7.1,0,1,0,14.19,0,15.08,15.08,0,0,1,15-15.45h53.67c8.4,0,15,6.78,15,15.45V83H378c-16.13,0-29.22,13.5-29.22,30.12v16.29c0,16.87,12.83,30.1,29.22,30.1h51.28a34.6,34.6,0,0,0,21.32-7.33h0a7.1,7.1,0,1,0,14.19,0V61.82C464.75,45,451.92,31.7,435.56,31.7Z"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{transform:"translate(-18.87 -31.7)",d:"m140.44 34.1a7.54 7.54 0 0 0-5.44-2.36 7.56 7.56 0 0 0-5.46 2.35l-48.74 50.2-48.7-50.19a7.63 7.63 0 0 0-5.47-2.36 7.58 7.58 0 0 0-5.49 2.36 8.19 8.19 0 0 0 0 11.29l108.38 111.76a7.52 7.52 0 0 0 5.47 2.31 7.31 7.31 0 0 0 5.45-2.31 8.19 8.19 0 0 0 0-11.31l-48.65-50.23 48.65-50.22a8.15 8.15 0 0 0 0-11.29z"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{transform:"translate(-18.87 -31.7)",d:"m21 157.24a7 7 0 0 0 5.23 2.22 7.16 7.16 0 0 0 5.19-2.22l26-26.82-10.42-10.75-26 26.83a7.79 7.79 0 0 0 0 10.74z"})));};var PreloaderIcon=function PreloaderIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({alt:"Xara for Teams",src:__WEBPACK_IMPORTED_MODULE_2__assets_preloader_gif___default.a},props));};var MicrosoftIcon=function MicrosoftIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({alt:"Microsoft",src:__WEBPACK_IMPORTED_MODULE_3__assets_microsoft_logo_png___default.a},props));};var XaraLogoAnimated=function XaraLogoAnimated(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({alt:"Xara",src:__WEBPACK_IMPORTED_MODULE_4__assets_xara_logo_gif___default.a},props));};var AccountIcon=function AccountIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",width:"50",height:"50",viewBox:"0 0 50 50"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{transform:"translate(-375 -1711)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{fill:"none",stroke:"currentColor",transform:"translate(389.873 1717)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{stroke:"none",cx:"9.921",cy:"9.921",r:"9.921"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{fill:"none",cx:"9.921",cy:"9.921",r:"9.421"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{fill:"none",transform:"translate(-1690 607)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{stroke:"none",d:"M2074,1148.21v-.448c0-.1,0-.207.01-.311.291-8.863,7.247-15.957,15.784-15.957s15.494,7.093,15.784,15.957c.006.1.01.206.01.311v.784a25,25,0,0,1-31.588-.336Z"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fill:"currentColor",d:"M 2089.999755859375 1152.999877929688 C 2092.7685546875 1152.999877929688 2095.482421875 1152.532592773438 2098.0654296875 1151.611083984375 C 2100.412841796875 1150.773681640625 2102.604736328125 1149.579711914063 2104.587890625 1148.05908203125 L 2104.587890625 1147.761962890625 C 2104.587890625 1147.682861328125 2104.585205078125 1147.601440429688 2104.579833984375 1147.513061523438 L 2104.578857421875 1147.498657226563 L 2104.578369140625 1147.484130859375 C 2104.446044921875 1143.442260742188 2102.843505859375 1139.666015625 2100.06640625 1136.851196289063 C 2097.294677734375 1134.041625976563 2093.646484375 1132.494384765625 2089.793701171875 1132.494384765625 C 2085.941162109375 1132.494384765625 2082.29296875 1134.041748046875 2079.52099609375 1136.8515625 C 2076.743896484375 1139.66650390625 2075.1416015625 1143.442626953125 2075.009033203125 1147.484252929688 L 2075.008544921875 1147.498413085938 L 2075.007568359375 1147.5126953125 C 2075.0029296875 1147.589965820313 2075.000244140625 1147.663330078125 2074.999755859375 1147.736083984375 C 2077.01953125 1149.355590820313 2079.267822265625 1150.62841796875 2081.689697265625 1151.522338867188 C 2084.345703125 1152.502807617188 2087.1416015625 1152.999877929688 2089.999755859375 1152.999877929688 M 2089.999755859375 1153.999877929688 C 2083.913818359375 1153.999877929688 2078.335205078125 1151.82470703125 2073.999755859375 1148.2099609375 L 2073.999755859375 1148.029174804688 L 2073.999755859375 1147.761962890625 C 2073.999755859375 1147.657470703125 2074.003173828125 1147.554931640625 2074.009521484375 1147.451416015625 C 2074.30029296875 1138.588256835938 2081.25634765625 1131.494384765625 2089.793701171875 1131.494384765625 C 2098.3310546875 1131.494384765625 2105.287353515625 1138.587280273438 2105.577880859375 1147.451416015625 C 2105.584228515625 1147.554077148438 2105.587890625 1147.657470703125 2105.587890625 1147.761962890625 L 2105.587890625 1148.546264648438 C 2101.313720703125 1151.959106445313 2095.89453125 1153.999877929688 2089.999755859375 1153.999877929688 Z"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{fill:"none",stroke:"currentColor",transform:"translate(375 1711)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{stroke:"none",cx:"25",cy:"25",r:"25"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{fill:"none",cx:"25",cy:"25",r:"24.5"}))));};var CupIcon=function CupIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",width:"21.078",height:"20",viewBox:"0 0 21.078 20"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{transform:"translate(-2.8 -8.3)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fill:"currentColor",d:"M91.765,60.629a.56.56,0,0,0-.276-.151l-1.841-.268-.82-1.657a.641.641,0,0,0-.326-.268.569.569,0,0,0-.452.042.648.648,0,0,0-.234.218L87,60.21l-1.8.259-.033.008a.611.611,0,0,0-.326.2l-.033.042a.59.59,0,0,0-.092.427.635.635,0,0,0,.159.318l1.305,1.272-.31,1.824a.608.608,0,0,0,.1.393L86,65a.592.592,0,0,0,.351.2.376.376,0,0,0,.092.008.521.521,0,0,0,.259-.067l1.607-.845,1.632.862a.558.558,0,0,0,.418.017.608.608,0,0,0,.351-.31.69.69,0,0,0,.05-.335l-.31-1.791,1.322-1.289a.579.579,0,0,0,.151-.393v-.042A.5.5,0,0,0,91.765,60.629Zm-2.184,1.816.3,1.732-1.557-.82-1.557.82.293-1.732-1.255-1.23,1.741-.251.778-1.573.778,1.573,1.741.251Z",transform:"translate(-74.983 -45.82)"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fill:"currentColor",d:"M22.851,11.591H20.4V10.049a.751.751,0,0,0-.749-.749H7.036a.751.751,0,0,0-.749.749v1.541H3.836A1.035,1.035,0,0,0,2.8,12.626v2.139a4.59,4.59,0,0,0,3.756,4.514,6.909,6.909,0,0,0,1.491,2.888,7.018,7.018,0,0,0,3.276,2.088l-1.3,2.8h-.008a.757.757,0,0,0-.758.766V29.3h8.16V27.818a.755.755,0,0,0-.758-.758l-1.305-2.8a7.018,7.018,0,0,0,3.276-2.088,6.909,6.909,0,0,0,1.491-2.888,4.582,4.582,0,0,0,3.756-4.514V12.626A1.023,1.023,0,0,0,22.851,11.591ZM3.634,14.765V12.626a.208.208,0,0,1,.211-.211H6.295v4.556a9.992,9.992,0,0,0,.1,1.415A3.755,3.755,0,0,1,3.634,14.765Zm15.781,3.891a6.116,6.116,0,0,1-1.4,2.956,6.235,6.235,0,0,1-3.074,1.895l-.758.194,1.945,4.185h.463v.581h-6.5v-.581h.463L12.5,23.7l-.749-.194a6.235,6.235,0,0,1-3.074-1.895,6.153,6.153,0,0,1-1.4-2.956,9.355,9.355,0,0,1-.16-1.684V10.125H19.566v6.846A9.281,9.281,0,0,1,19.415,18.656Zm3.638-3.891A3.767,3.767,0,0,1,20.3,18.386a9.816,9.816,0,0,0,.1-1.415V12.416h2.451a.208.208,0,0,1,.211.211v2.139Z",transform:"translate(0 -1)"})));};var UsersIcon=function UsersIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",width:"22.521",height:"20",viewBox:"0 0 22.521 20"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{transform:"translate(-1.6 -15.8)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fill:"currentColor",d:"M105.16,20.12A2.16,2.16,0,1,0,103,17.96,2.161,2.161,0,0,0,105.16,20.12Zm0-3.439a1.279,1.279,0,1,1-1.279,1.279A1.281,1.281,0,0,1,105.16,16.681Z",transform:"translate(-92.299)"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fill:"currentColor",d:"M7.82,84.72a.433.433,0,0,0-.328.4l-.328,5.054a.364.364,0,0,1-.372.346H4.287a.37.37,0,0,1-.372-.346l-.337-5.046a.434.434,0,0,0-.311-.389,1.537,1.537,0,0,1-.415-.164,2.079,2.079,0,0,1-.06-.484l-.3-5.348h0c.432-.13,1.14-.354,1.512-.475l1.235,1.158a.45.45,0,0,0,.6,0l1.235-1.158c.121.035.268.086.432.138a.44.44,0,0,0,.268-.838c-.372-.121-.674-.216-.674-.216a.455.455,0,0,0-.441.1L5.54,78.5,4.416,77.446a.435.435,0,0,0-.441-.1s-1.184.38-1.78.562a.8.8,0,0,0-.6.795v.1h0l.294,5.27a.424.424,0,0,0,.009.1c.052.778.164,1.063.812,1.313l.311,4.752a1.263,1.263,0,0,0,1.253,1.175H6.784a1.263,1.263,0,0,0,1.253-1.175l.32-4.925a.458.458,0,0,0,.009-.285A.443.443,0,0,0,7.82,84.72Z",transform:"translate(0 -55.607)"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fill:"currentColor",d:"M24.26,23.62a2.16,2.16,0,1,0-2.16-2.16A2.161,2.161,0,0,0,24.26,23.62Zm0-3.43a1.279,1.279,0,1,1-1.279,1.279A1.281,1.281,0,0,1,24.26,20.19Z",transform:"translate(-18.729 -3.198)"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fill:"currentColor",d:"M89.683,77.712c-.6-.181-1.78-.562-1.78-.562a.455.455,0,0,0-.441.1L86.34,78.3l-1.123-1.054a.435.435,0,0,0-.441-.1s-1.184.38-1.78.562a.788.788,0,0,0-.6.795l.294,5.382.009.086c.052.778.164,1.071.812,1.313l.311,4.752a1.263,1.263,0,0,0,1.253,1.175h2.514a1.263,1.263,0,0,0,1.253-1.175l.311-4.752c.648-.251.76-.544.812-1.313l.3-5.391v-.078A.766.766,0,0,0,89.683,77.712ZM89.1,83.821l-.009.086a1.977,1.977,0,0,1-.06.467,1.6,1.6,0,0,1-.423.164.436.436,0,0,0-.311.4l-.328,5.046a.364.364,0,0,1-.371.346H85.078a.376.376,0,0,1-.371-.346l-.328-5.046a.455.455,0,0,0-.311-.4,1.537,1.537,0,0,1-.415-.164,2.045,2.045,0,0,1-.06-.467l-.3-5.348v-.026c.432-.13,1.14-.354,1.512-.475l1.235,1.158a.45.45,0,0,0,.6,0l1.235-1.149c.372.121,1.08.346,1.512.475Z",transform:"translate(-73.479 -55.425)"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fill:"currentColor",d:"M181.98,77.712c-.6-.181-1.78-.562-1.78-.562a.455.455,0,0,0-.441.1L178.637,78.3l-1.123-1.054a.435.435,0,0,0-.441-.1s-.3.1-.674.216a.44.44,0,1,0,.268.838c.164-.052.311-.1.432-.138l1.235,1.158a.45.45,0,0,0,.6,0l1.235-1.158c.372.121,1.071.337,1.512.475l-.294,5.279-.009.086a1.976,1.976,0,0,1-.06.467,1.6,1.6,0,0,1-.423.164.436.436,0,0,0-.311.4l-.328,5.046a.375.375,0,0,1-.372.346h-2.514a.382.382,0,0,1-.371-.346l-.337-5.046a.473.473,0,0,0-.328-.4.427.427,0,0,0-.544.285.442.442,0,0,0,0,.259l.328,4.959a1.257,1.257,0,0,0,1.253,1.175h2.514a1.263,1.263,0,0,0,1.253-1.175l.311-4.752c.648-.251.76-.536.812-1.3,0-.035.009-.112.009-.112l.294-5.3V78.5A.787.787,0,0,0,181.98,77.712Z",transform:"translate(-158.447 -55.425)"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fill:"currentColor",d:"M186.06,23.62a2.16,2.16,0,1,0-2.16-2.16A2.161,2.161,0,0,0,186.06,23.62Zm0-3.43a1.279,1.279,0,1,1-1.279,1.279A1.281,1.281,0,0,1,186.06,20.19Z",transform:"translate(-165.87 -3.198)"})));};var MoneyBoxIcon=function MoneyBoxIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",width:"20.769",height:"20",viewBox:"0 0 20.769 20"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{transform:"translate(-7 -11.214)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fill:"currentColor",d:"M182.124,13.367a3.6,3.6,0,0,0-1.982-1.9,3.545,3.545,0,0,0-2.746.06,3.586,3.586,0,0,0-1.1.755.425.425,0,0,0,.6.6,2.714,2.714,0,0,1,.841-.575,2.747,2.747,0,0,1,2.214,5.028,2.857,2.857,0,0,1-1,.232.425.425,0,0,0,.017.85h.017a3.583,3.583,0,0,0,3.132-5.046Z",transform:"translate(-154.658)"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fill:"currentColor",d:"M118.4,39.755a3.628,3.628,0,0,0,1.3.249,3.543,3.543,0,0,0,1.442-.309,3.6,3.6,0,0,0,1.9-1.982,3.545,3.545,0,0,0-.06-2.746,3.6,3.6,0,0,0-1.982-1.9,3.545,3.545,0,0,0-2.746.06h0a3.6,3.6,0,0,0-1.9,1.982,3.6,3.6,0,0,0,2.042,4.651Zm-1.253-4.342a2.737,2.737,0,0,1,1.45-1.519h0a2.744,2.744,0,0,1,1.1-.232,2.663,2.663,0,0,1,1,.189,2.744,2.744,0,1,1-3.51,3.664A2.786,2.786,0,0,1,117.151,35.413Z",transform:"translate(-99.751 -19.747)"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fill:"currentColor",d:"M79.142,72.011a.4.4,0,0,0,.146-.026,7.306,7.306,0,0,1,1.545-.4.421.421,0,0,0-.129-.832,8.562,8.562,0,0,0-1.716.446.43.43,0,0,0-.249.541A.448.448,0,0,0,79.142,72.011Z",transform:"translate(-65.561 -54.436)"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fill:"currentColor",d:"M24.565,81.762a6.284,6.284,0,0,0-.858-1.879.421.421,0,0,0-.7.463,5.587,5.587,0,0,1,.747,1.63,4.486,4.486,0,0,1,.1.463,5.562,5.562,0,0,1-1.467,4.848,1.187,1.187,0,0,0-.3.532L21.3,90.549H19.528l-.206-.807a.423.423,0,0,0-.412-.317l-4.522-.017h0a.43.43,0,0,0-.412.318l-.215.824H12L11.5,88.765a1.281,1.281,0,0,0-.7-.807,15.38,15.38,0,0,1-2.849-1.673.289.289,0,0,1-.112-.232l.009-3.338.455-.009a.445.445,0,0,0,.335-.172l1.811-2.4c.009-.017.026-.034.034-.051a.581.581,0,0,0-.051-.566c-.017-.051-.043-.1-.06-.154l-.034-.077c-.069-.163-.146-.326-.223-.481-.137-.292-.292-.584-.446-.867-.017-.034-.034-.06-.051-.094h.12a3.5,3.5,0,0,1,1.184.189c.1.034.317.137.369.163a.008.008,0,0,1,.009.009c.077.043.532.309.635.386a3.737,3.737,0,0,1,1.1,1.321.422.422,0,0,0,.755-.378A4.648,4.648,0,0,0,12.44,77.91c-.146-.112-.592-.369-.712-.438a2.118,2.118,0,0,0-.532-.24A4.239,4.239,0,0,0,9.772,77c-.1,0-.206,0-.292.009l-.163.009a.109.109,0,0,0-.051.009h0c-.017,0-.034.009-.051.009a.726.726,0,0,0-.506.429A.735.735,0,0,0,8.751,78a1.24,1.24,0,0,0,.129.266c0,.009.017.026.026.034l.026.043c.146.275.292.549.429.832.069.154.146.3.206.446L9.6,79.7a.6.6,0,0,1,.043.112L8.1,81.865l-.669.009a.414.414,0,0,0-.412.42L7,86.062a1.134,1.134,0,0,0,.446.91,16.113,16.113,0,0,0,3.012,1.776.408.408,0,0,1,.223.266l.6,2.085a.422.422,0,0,0,.4.309H14.1a.43.43,0,0,0,.412-.317l.215-.824,3.861.017.206.807a.423.423,0,0,0,.412.317h2.42a.422.422,0,0,0,.4-.309l.884-3.055a.4.4,0,0,1,.086-.154,6.417,6.417,0,0,0,1.7-5.586Q24.643,82.033,24.565,81.762Z",transform:"translate(0 -60.193)"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fill:"currentColor",d:"M49.656,129.278a.678.678,0,1,1-.678-.678A.685.685,0,0,1,49.656,129.278Z",transform:"translate(-37.756 -107.341)"})));};var DeleteIcon=function DeleteIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",width:"20",height:"20",viewBox:"0 0 20 20"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{transform:"translate(-267 -1000)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{fill:"none",stroke:"currentColor",transform:"translate(267 1000)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{stroke:"none",cx:"10",cy:"10",r:"10"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{fill:"none",cx:"10",cy:"10",r:"9.5"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{stroke:"currentColor",strokeLinecap:"round",x1:"9.182",transform:"translate(273.507 1013.186) rotate(-45)"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{stroke:"currentColor",strokeLinecap:"round",x1:"9.182",transform:"translate(273.507 1006.693) rotate(45)"})));};var Info=function Info(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",width:"20",height:"20",viewBox:"0 0 20 20"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{transform:"translate(-690 -220)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{fill:"none",cx:"10",cy:"10",r:"10",transform:"translate(690 220)"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fill:"currentColor",d:"M1.148,6.008q0-1.164,1.3-1.164t1.3,1.164a1.135,1.135,0,0,1-.324.863,1.363,1.363,0,0,1-.973.309Q1.148,7.18,1.148,6.008ZM3.633,17H1.25V8.266H3.633Z",transform:"translate(698 219)"})));};var GoBackIcon=function GoBackIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",width:"27",height:"27",viewBox:"0 0 27 27"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{transform:"translate(-285 -105)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{fill:"none",stroke:"currentColor",strokeWidth:"1.5px",transform:"translate(285 105)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{stroke:"none",cx:"13.5",cy:"13.5",r:"13.5"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{fill:"none",cx:"13.5",cy:"13.5",r:"12.75"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{transform:"translate(292 112)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{fill:"none",stroke:"currentColor",strokeWidth:"1.5px",strokeLinecap:"round",x2:"13.471",transform:"translate(0 6.041)"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{fill:"none",stroke:"currentColor",strokeWidth:"1.5px",strokeLinecap:"round",y1:"6.041",x2:"6.385",transform:"translate(0 0)"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{fill:"none",stroke:"currentColor",strokeWidth:"1.5px",strokeLinecap:"round",x2:"6.385",y2:"6.041",transform:"translate(0 6.049)"}))));};var FolderIcon=function FolderIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",width:"21.083",height:"17.363",viewBox:"0 0 21.083 17.363"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{transform:"translate(-2056 -1110)",fill:"none"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M2058,1127.363a2,2,0,0,1-2-2V1112a2,2,0,0,1,2-2h5.921a2,2,0,0,1,2,2v1.72h9.162a2,2,0,0,1,2,2v9.642a2,2,0,0,1-2,2Z",stroke:"none"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M 2075.083251953125 1126.5625 C 2075.744873046875 1126.5625 2076.282958984375 1126.024291992188 2076.282958984375 1125.362670898438 L 2076.282958984375 1115.721069335938 C 2076.282958984375 1115.058959960938 2075.744873046875 1114.520385742188 2075.083251953125 1114.520385742188 L 2065.921142578125 1114.520385742188 L 2065.12109375 1114.520385742188 L 2065.12109375 1113.720336914063 L 2065.12109375 1112.000366210938 C 2065.12109375 1111.33837890625 2064.5830078125 1110.7998046875 2063.92138671875 1110.7998046875 L 2058.000244140625 1110.7998046875 C 2057.33837890625 1110.7998046875 2056.7998046875 1111.33837890625 2056.7998046875 1112.000366210938 L 2056.7998046875 1115.721069335938 L 2056.7998046875 1125.362670898438 C 2056.7998046875 1126.024291992188 2057.33837890625 1126.5625 2058.000244140625 1126.5625 L 2075.083251953125 1126.5625 M 2075.083251953125 1127.362548828125 L 2058.000244140625 1127.362548828125 C 2056.895263671875 1127.362548828125 2055.999755859375 1126.467041015625 2055.999755859375 1125.362670898438 L 2055.999755859375 1115.721069335938 L 2055.999755859375 1112.000366210938 C 2055.999755859375 1110.895263671875 2056.895263671875 1109.999755859375 2058.000244140625 1109.999755859375 L 2063.92138671875 1109.999755859375 C 2065.025634765625 1109.999755859375 2065.921142578125 1110.895263671875 2065.921142578125 1112.000366210938 L 2065.921142578125 1113.720336914063 L 2075.083251953125 1113.720336914063 C 2076.1875 1113.720336914063 2077.0830078125 1114.615844726563 2077.0830078125 1115.721069335938 L 2077.0830078125 1125.362670898438 C 2077.0830078125 1126.467041015625 2076.1875 1127.362548828125 2075.083251953125 1127.362548828125 Z",stroke:"none",fill:"currentColor"})));};var ProtectBrandIcon=function ProtectBrandIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",width:"29.29",height:"29.29",viewBox:"0 0 52.008 52.687"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{id:"protect_brand",transform:"translate(-52.995 -270.5)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{id:"Path_586","data-name":"Path 586",d:"M54,277.5c9.479-.177,17.58-3.146,25-6,7.693,3.122,16.05,5.733,25,6,0,38-25,44.687-25,44.687S53.5,315.5,54,277.5Z",fill:"none",stroke:"#282828",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"2"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{id:"Path_587","data-name":"Path 587",d:"M70,292.5l7,8,11-15",fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeMiterlimit:"10",strokeWidth:"2"})));};var TeamIcon=function TeamIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",width:"37.37",height:"37.37",viewBox:"0 0 64.646 51.677"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{id:"team_icon",transform:"translate(-211.177 -271)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{id:"Ellipse_126","data-name":"Ellipse 126",cx:"6.21",cy:"6.21",r:"6.21",transform:"translate(259.613 272)",fill:"none",stroke:"currentColor",strokeMiterlimit:"10",strokeWidth:"2"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{id:"Path_591","data-name":"Path 591",d:"M269.823,288.145l-4,3.726-4-3.726-5,2.484,1,19.871a26.386,26.386,0,0,0,16,0l1-19.871Z",fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"2"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{id:"Ellipse_127","data-name":"Ellipse 127",cx:"6.21",cy:"6.21",r:"6.21",transform:"translate(214.968 272)",fill:"none",stroke:"currentColor",strokeMiterlimit:"10",strokeWidth:"2"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{id:"Path_592","data-name":"Path 592",d:"M225.177,288.145l-4,3.726-4-3.726-5,2.484,1,19.871a26.386,26.386,0,0,0,16,0l1-19.871Z",fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"2"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{id:"Path_593","data-name":"Path 593",d:"M247.5,298.081l-4,3.725-4-3.725-5,2.484,1,19.87a26.386,26.386,0,0,0,16,0l1-19.87Z",fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"2"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{id:"Ellipse_128","data-name":"Ellipse 128",cx:"6.21",cy:"6.21",r:"6.21",transform:"translate(237.29 281.935)",fill:"none",stroke:"currentColor",strokeMiterlimit:"10",strokeWidth:"2"})));};var SaveTimeIcon=function SaveTimeIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",width:"30",height:"30",viewBox:"0 0 52 52"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{id:"save_time",transform:"translate(-296 -271)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{id:"Ellipse_129","data-name":"Ellipse 129",cx:"25",cy:"25",r:"25",transform:"translate(297 272)",fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeMiterlimit:"10",strokeWidth:"2"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{id:"Path_594","data-name":"Path 594",d:"M322,283v14l17,9",fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeMiterlimit:"10",strokeWidth:"2"})));};var UpdatedIcon=function UpdatedIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",width:"33.96",height:"27.73",viewBox:"0 0 68 57.139"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{id:"updated_icon",transform:"translate(-460 -268.671)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{id:"Rectangle_233","data-name":"Rectangle 233",width:"61.405",height:"50.127",rx:"5.901",transform:"translate(463.506 272.177)",fill:"none",stroke:"currentColor",strokeMiterlimit:"10",strokeWidth:"2",strokeDasharray:"5"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{id:"Ellipse_130","data-name":"Ellipse 130",cx:"2.297",cy:"2.297",r:"2.297",transform:"translate(461 295.152)",fill:"#fff",stroke:"currentColor",strokeLinecap:"round",strokeMiterlimit:"10",strokeWidth:"2"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{id:"Ellipse_131","data-name":"Ellipse 131",cx:"2.297",cy:"2.297",r:"2.297",transform:"translate(522.405 295.152)",fill:"#fff",stroke:"currentColor",strokeLinecap:"round",strokeMiterlimit:"10",strokeWidth:"2"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{id:"Ellipse_132","data-name":"Ellipse 132",cx:"2.297",cy:"2.297",r:"2.297",transform:"translate(491.911 269.671)",fill:"#fff",stroke:"currentColor",strokeLinecap:"round",strokeMiterlimit:"10",strokeWidth:"2"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{id:"Ellipse_133","data-name":"Ellipse 133",cx:"2.297",cy:"2.297",r:"2.297",transform:"translate(491.911 320.215)",fill:"#fff",stroke:"currentColor",strokeLinecap:"round",strokeMiterlimit:"10",strokeWidth:"2"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{id:"Rectangle_234","data-name":"Rectangle 234",width:"8.772",height:"21.722",rx:"2.604",transform:"translate(476.873 289.722)",fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeMiterlimit:"10",strokeWidth:"2"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{id:"Rectangle_235","data-name":"Rectangle 235",width:"8.772",height:"27.57",rx:"2.624",transform:"translate(489.405 283.873)",fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeMiterlimit:"10",strokeWidth:"2"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{id:"Rectangle_236","data-name":"Rectangle 236",width:"8.772",height:"32.165",rx:"2.612",transform:"translate(501.937 279.278)",fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeMiterlimit:"10",strokeWidth:"2"})));};var SubscriptionIcon=function SubscriptionIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",width:"206.955",height:"199.29",viewBox:"0 0 206.955 199.29"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{transform:"translate(-7 -11.214)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fill:"rgba(47,165,231,0.3)",d:"M235.452,32.664A35.833,35.833,0,0,0,215.7,13.682a35.323,35.323,0,0,0-27.362.6A35.733,35.733,0,0,0,177.393,21.8a4.232,4.232,0,1,0,5.985,5.985,27.043,27.043,0,0,1,8.379-5.729,27.374,27.374,0,0,1,22.061,50.106,28.471,28.471,0,0,1-9.919,2.309,4.235,4.235,0,0,0,.171,8.465h.171a36.442,36.442,0,0,0,13-2.993A36.1,36.1,0,0,0,235.452,32.664Z",transform:"translate(-24.522 0)"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fill:"rgba(47,165,231,0.3)",d:"M138.932,101.976a36.152,36.152,0,0,0,13,2.48,35.3,35.3,0,0,0,14.365-3.078,35.834,35.834,0,0,0,18.982-19.752,35.323,35.323,0,0,0-.6-27.362,35.834,35.834,0,0,0-19.752-18.982,35.323,35.323,0,0,0-27.362.6h0a35.834,35.834,0,0,0-18.982,19.752,35.862,35.862,0,0,0,20.35,46.344ZM126.448,58.71A27.276,27.276,0,0,1,140.9,43.576h0a27.344,27.344,0,0,1,10.944-2.309,26.537,26.537,0,0,1,9.919,1.881A27.343,27.343,0,1,1,126.79,79.659,27.762,27.762,0,0,1,126.448,58.71Z",transform:"translate(-15.816 -3.131)"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fill:"rgba(47,165,231,0.3)",d:"M82.977,83.361a3.993,3.993,0,0,0,1.454-.257,72.8,72.8,0,0,1,15.391-4.019,4.2,4.2,0,0,0-1.283-8.294,85.317,85.317,0,0,0-17.1,4.446,4.285,4.285,0,0,0-2.48,5.387A4.463,4.463,0,0,0,82.977,83.361Z",transform:"translate(-10.395 -8.771)"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fill:"rgba(47,165,231,0.3)",d:"M182.029,124.455a62.615,62.615,0,0,0-8.551-18.726,4.2,4.2,0,0,0-7.011,4.617,55.668,55.668,0,0,1,7.439,16.246,44.71,44.71,0,0,1,1.026,4.617c3.164,17.614-2.48,36.083-14.621,48.31a11.828,11.828,0,0,0-2.993,5.3l-7.866,27.191H131.838l-2.052-8.038a4.211,4.211,0,0,0-4.1-3.164l-45.061-.171h0a4.286,4.286,0,0,0-4.1,3.164l-2.138,8.208H56.85L51.8,194.228a12.76,12.76,0,0,0-6.926-8.037,153.253,153.253,0,0,1-28.388-16.674,2.878,2.878,0,0,1-1.112-2.309l.086-33.261L20,133.861a4.431,4.431,0,0,0,3.335-1.71l18.042-23.941c.086-.171.257-.342.342-.513,1.112-1.967.342-3.848-.513-5.643-.171-.513-.428-1.026-.6-1.539l-.342-.769c-.684-1.625-1.454-3.249-2.223-4.788-1.368-2.907-2.907-5.814-4.446-8.636-.171-.342-.342-.6-.513-.94h1.2a34.858,34.858,0,0,1,11.8,1.881c1.026.342,3.164,1.368,3.677,1.625a.084.084,0,0,1,.085.086c.77.427,5.3,3.078,6.327,3.848A37.234,37.234,0,0,1,67.11,105.986a4.206,4.206,0,1,0,7.524-3.762A46.313,46.313,0,0,0,61.21,86.064c-1.454-1.112-5.9-3.677-7.1-4.361a21.108,21.108,0,0,0-5.3-2.394A42.242,42.242,0,0,0,34.618,77c-1.026,0-2.052,0-2.907.085l-1.625.086a1.084,1.084,0,0,0-.513.086h0c-.171,0-.342.085-.513.085a7.23,7.23,0,0,0-5.045,4.275c-.855,2.223.086,4.361.428,5.3a12.354,12.354,0,0,0,1.283,2.651c0,.086.171.257.257.342l.257.428c1.454,2.736,2.907,5.472,4.275,8.294.684,1.539,1.454,2.993,2.052,4.446l.342.855a5.94,5.94,0,0,1,.428,1.112L17.945,125.481l-6.669.086a4.124,4.124,0,0,0-4.1,4.19L7,167.294a11.3,11.3,0,0,0,4.446,9.063,160.557,160.557,0,0,0,30.012,17.7,4.069,4.069,0,0,1,2.223,2.651l5.985,20.778a4.207,4.207,0,0,0,4.019,3.078H77.713a4.286,4.286,0,0,0,4.1-3.164l2.138-8.208,38.477.171,2.052,8.038a4.211,4.211,0,0,0,4.1,3.164H152.7a4.207,4.207,0,0,0,4.019-3.078l8.807-30.44a3.936,3.936,0,0,1,.855-1.539c14.023-14.023,20.521-35.4,16.93-55.664Q182.8,127.149,182.029,124.455Z",transform:"translate(0 -10.06)"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fill:"rgba(47,165,231,0.3)",d:"M61.81,135.355a6.755,6.755,0,1,1-6.755-6.755A6.825,6.825,0,0,1,61.81,135.355Z",transform:"translate(-5.986 -17.297)"})));};var FontsIcon=function FontsIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",width:"19.6",height:"12.176",viewBox:"0 0 19.6 12.176"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fill:"currentColor",d:"M-5.128-12h1.312L.2-.832l1.04.144V0h-3.9V-.688l1.408-.144L-2.1-3.376H-7.1L-7.944-.848l1.424.16V0h-3.6V-.688L-9.1-.832ZM-4.2-9.536l-.448-1.52L-5.08-9.488l-1.744,5.28h4.432Zm6.048,7.2A2.334,2.334,0,0,1,3.384-4.584a9.771,9.771,0,0,1,3.824-.744v-.5A3.963,3.963,0,0,0,7.04-7.112,1.192,1.192,0,0,0,6.456-7.8a2.576,2.576,0,0,0-1.168-.216,4.2,4.2,0,0,0-1.48.248,9.1,9.1,0,0,0-1.288.6l-.352-.7A3.907,3.907,0,0,1,2.9-8.32a7.994,7.994,0,0,1,1.28-.512,4.677,4.677,0,0,1,1.392-.224,4.025,4.025,0,0,1,1.72.3,1.818,1.818,0,0,1,.912.976,4.8,4.8,0,0,1,.28,1.808v5.28H9.48V-.1a5.83,5.83,0,0,1-1.488.24.853.853,0,0,1-.528-.12Q7.32-.1,7.32-.528V-1.12a7.591,7.591,0,0,1-1.256.9A3.035,3.035,0,0,1,4.52.176a2.866,2.866,0,0,1-1.912-.64A2.31,2.31,0,0,1,1.848-2.336ZM5-.768a2.648,2.648,0,0,0,1.072-.288,5.752,5.752,0,0,0,1.136-.688V-4.576A6.245,6.245,0,0,0,4.272-4a1.685,1.685,0,0,0-1,1.5,1.674,1.674,0,0,0,.464,1.32A1.847,1.847,0,0,0,5-.768Z",transform:"translate(10.12 12)"}));};var DropboxIcon=function DropboxIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",width:"28px",height:"26.25px",viewBox:"0 0 28 26.25"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fill:"#007ee5",d:"M8.265,0L0,5.396l5.715,4.577l8.333-5.146L8.265,0z M0,14.549l8.265,5.398l5.783-4.828L5.715,9.973L0,14.549 z M14.048,15.119l5.784,4.828l8.265-5.398l-5.715-4.576L14.048,15.119z M28.097,5.396L19.832,0l-5.784,4.827l8.334,5.146 L28.097,5.396z M14.066,16.158l-5.801,4.812L5.783,19.35v1.817l8.283,4.967l8.282-4.967V19.35l-2.482,1.621L14.066,16.158z"}));};var GoogleDriveIcon=function GoogleDriveIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 139 120.4"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("radialGradient",{id:"a",cx:"-254.81979",cy:"705.83588",gradientTransform:"matrix(2.827 1.6322 -1.6322 2.827 2092.1199 -1494.5786)",gradientUnits:"userSpaceOnUse",r:"82.978401"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("stop",{offset:"0",stopColor:"#4387fd"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("stop",{offset:".65",stopColor:"#3078f0"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("stop",{offset:".9099",stopColor:"#2b72ea"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("stop",{offset:"1",stopColor:"#286ee6"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("radialGradient",{id:"b",cx:"-254.8174",cy:"705.83691",gradientTransform:"matrix(2.827 1.6322 -1.6322 2.827 2092.1199 -1494.5786)",gradientUnits:"userSpaceOnUse",r:"82.973"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("stop",{offset:"0",stopColor:"#ffd24d"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("stop",{offset:"1",stopColor:"#f6c338"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"m24.2 120.4-24.2-41.9 45.3-78.5 24.2 41.9z",fill:"#0da960"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"m24.2 120.4 24.2-41.9h90.6l-24.2 41.9z",fill:"url(#a)"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"m139 78.5h-48.4l-45.3-78.5h48.4z",fill:"url(#b)"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"m69.5 78.5h-21.1l10.5-18.3-34.7 60.2z",fill:"#2d6fdd"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"m90.6 78.5h48.4l-58.9-18.3z",fill:"#e5b93c"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"m58.9 60.2 10.6-18.3-24.2-41.9z",fill:"#0c9b57"}));};var OneDriveIcon=function OneDriveIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 45 27"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M 10.5,21 C 10.5,17.688 13.188,15 16.5,15 C 16.502,15 16.505,15.001 16.508,15.001 C 16.704,10.827 20.153,7.5 24.375,7.5 C 27.304,7.5 29.861,9.103 31.218,11.478 C 32.161,10.86 33.289,10.5 34.5,10.5 C 37.812,10.5 40.5,13.188 40.5,16.5 C 40.5,16.758 40.483,17.012 40.452,17.261 C 42.99,17.43 45,19.544 45,22.125 C 45,24.816 42.816,27 40.125,27 L 16.5,27 C 13.188,27 10.5,24.312 10.5,21 Z M 0,18.75 C 0,15.678 2.312,13.143 5.291,12.792 C 5.264,12.532 5.25,12.268 5.25,12 C 5.25,7.86 8.61,4.5 12.75,4.5 C 13.947,4.5 15.079,4.781 16.083,5.281 C 17.705,2.145 20.978,0 24.75,0 C 29.879,0 34.088,3.969 34.471,9.001 C 33.724,9.003 33.003,9.116 32.322,9.323 L 31.709,9.558 L 31.057,8.804 C 29.358,7.076 26.992,6 24.375,6 C 19.975,6 16.283,9.033 15.271,13.121 L 15.197,13.634 L 14.993,13.654 C 11.572,14.352 9,17.377 9,21 C 9,22.366 9.365,23.647 10.003,24.75 L 6,24.75 C 2.688,24.75 0,22.062 0,18.75 Z",fill:"#094ab1"})));};var TeamAssetsLogoIcon=function TeamAssetsLogoIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",width:"58.953",height:"58.955",viewBox:"0 0 58.953 58.955"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{transform:"translate(-156.75 -278.75)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{transform:"translate(163.724 284.297)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fill:"currentColor",d:"M8.425,15.362A25.845,25.845,0,0,1,7.266,11.4c-.1-.52-.208-1.024-.3-1.544-.059-.327-.1-.668-.163-1.01-.03-.163-.045-.341-.074-.5v-.1c0-.03-.015-.074-.015-.1a1.146,1.146,0,0,1,.223.03l.134.015c.341.045.668.089,1.01.148.668.1,1.321.223,1.945.356a27.691,27.691,0,0,1,3.831,1.114.714.714,0,0,0,.5-1.336A27.889,27.889,0,0,0,10.34,7.285c-.638-.134-1.321-.267-2.019-.371-.341-.059-.7-.1-1.039-.148l-.148-.015a2.1,2.1,0,0,0-1.218.1A1.193,1.193,0,0,0,5.278,7.89a3.058,3.058,0,0,0,.03.549l.015.089c.03.178.045.356.074.535.045.341.1.7.163,1.039q.134.8.312,1.6a29.358,29.358,0,0,0,1.216,4.2.706.706,0,0,0,.668.46.72.72,0,0,0,.668-.995Z"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fill:"currentColor",d:"M178.239,176.462a3.255,3.255,0,0,1-.579-1.782,9.741,9.741,0,0,0-2.66-5.746,5.1,5.1,0,0,0-2.777-1.277,5.859,5.859,0,0,0-6.37,5.924c.163,3.059,3.059,4.751,5.494,5.286a3.8,3.8,0,0,1,1.782.683.742.742,0,0,0,.52.208.708.708,0,0,0,.3-.059.922.922,0,0,0,.431-.98,2.956,2.956,0,0,0-.98-1.841c-.148-.163-.3-.327-.416-.475a.714.714,0,0,1-.148-.564.644.644,0,0,1,.371-.371,1.533,1.533,0,0,1,1.455.119,3.727,3.727,0,0,1,.653.7,3.914,3.914,0,0,0,1.247,1.158,2.633,2.633,0,0,0,.876.267.883.883,0,0,0,.95-.431.759.759,0,0,0-.149-.819Zm-2.747-2.034a2.965,2.965,0,0,0-2.9-.252,2.077,2.077,0,0,0-1.143,1.292,2.13,2.13,0,0,0,.356,1.737,3.615,3.615,0,0,0,.3.371c-.163-.045-.312-.074-.46-.1-1.945-.416-4.246-1.708-4.38-3.964a4.24,4.24,0,0,1,1.425-3.267,4.3,4.3,0,0,1,2.88-1.2c.148,0,.312.015.46.03a3.736,3.736,0,0,1,2.019.935,8.125,8.125,0,0,1,2.2,4.915c.015.1.03.208.045.327a3.483,3.483,0,0,0-.8-.824Z",transform:"translate(-137.779 -138.051)"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fill:"currentColor",d:"M47.063,42.863,46.376,41c-.286-.759-.6-1.517-.944-2.247L51.183,33a1.486,1.486,0,0,0,.3-1.689,1.507,1.507,0,0,0-1.473-.873l-9.742.716a26.867,26.867,0,0,0-7.51-5.553,1.969,1.969,0,0,0-.243-.114.675.675,0,0,0-.773.129L24.217,33.13a.694.694,0,0,0-.129.787l.1.2a26.85,26.85,0,0,0,5.565,7.542l-.715,9.761a1.5,1.5,0,0,0,.873,1.474,1.4,1.4,0,0,0,.629.143,1.507,1.507,0,0,0,1.059-.444l5.751-5.768c.73.343,1.488.658,2.232.93l1.86.687a.7.7,0,0,0,.715-.157l4.735-4.709a.648.648,0,0,0,.171-.713ZM41.527,47l-1.445-.544c-.858-.315-1.717-.687-2.546-1.088a.7.7,0,0,0-.787.129l-6.094,6.111a.129.129,0,0,1-.157.029c-.086-.043-.086-.1-.072-.129l.73-10.09a.723.723,0,0,0-.215-.558,25.137,25.137,0,0,1-5.408-7.113l6.824-6.827a25.474,25.474,0,0,1,7.139,5.4.675.675,0,0,0,.558.215l10.071-.744h0a.134.134,0,0,1,.129.072.129.129,0,0,1-.029.157l-6.094,6.1A.694.694,0,0,0,44,38.9c.4.83.773,1.689,1.1,2.576l.529,1.445Z",transform:"translate(-15.963 -15.934)"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fill:"currentColor",d:"M77.648,78.914a2.874,2.874,0,0,0-.848,2.041A2.824,2.824,0,0,0,77.648,83a2.874,2.874,0,0,0,2.041.848h0A2.824,2.824,0,0,0,81.731,83a2.887,2.887,0,1,0-4.082-4.082Zm3.246,3.246a1.7,1.7,0,0,1-1.205.5h0a1.654,1.654,0,0,1-1.205-.5,1.7,1.7,0,1,1,2.41,0Z",transform:"translate(-60.685 -60.55)"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fill:"none",fillRule:"evenodd",stroke:"currentColor",strokeWidth:"1.5",transform:"translate(-64.217 504.499)",d:"M221.717-196.269A28.739,28.739,0,0,1,250.441-225a28.743,28.743,0,0,1,28.729,28.73,28.738,28.738,0,0,1-28.729,28.724A28.734,28.734,0,0,1,221.717-196.269Z"})));};var TeamAssetsImageIcon=function TeamAssetsImageIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",width:"46",height:"30",viewBox:"0 0 46 30"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{transform:"translate(-382 -290)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{transform:"translate(382 290)",fill:"none",stroke:"currentColor",strokeWidth:"1.2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{width:"46",height:"30",rx:"3",stroke:"none"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"0.6",y:"0.6",width:"44.8",height:"28.8",rx:"2.4",fill:"none"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{transform:"translate(417 294)",fill:"none",stroke:"currentColor",strokeWidth:"1.2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{cx:"3",cy:"3",r:"3",stroke:"none"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{cx:"3",cy:"3",r:"2.4",fill:"none"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M1832.56,5595.407l.653-.915,14.6-18.66,12.441,18.66,6.639-9.118,6.868,9.118.7.915",transform:"translate(-1449.066 -5276.2)",fill:"none",stroke:"currentColor",strokeWidth:"1.2"})));};var TeamAssetsOtherIcon=function TeamAssetsOtherIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",width:"35.776",height:"29.86",viewBox:"0 0 35.776 29.86"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{transform:"translate(-487 -290)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{transform:"translate(482.9 271.022)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M4.732,42.719A.676.676,0,0,0,5.365,42V17.417a.676.676,0,0,0-.632-.717.676.676,0,0,0-.632.717V42A.676.676,0,0,0,4.732,42.719Z",transform:"translate(0 2.278)",fill:"currentColor"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M8.951,228.5H4.88a.644.644,0,1,0,0,1.258H8.965a.714.714,0,0,0,.78-.629A.728.728,0,0,0,8.951,228.5Z",transform:"translate(0 -180.92)",fill:"currentColor"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M61.151,228.5H57.08a.644.644,0,1,0,0,1.258h4.086a.714.714,0,0,0,.78-.629A.728.728,0,0,0,61.151,228.5Z",transform:"translate(-44.664 -180.92)",fill:"currentColor"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M113.265,228.5H109.18a.644.644,0,1,0,0,1.258h4.086a.644.644,0,1,0,0-1.258Z",transform:"translate(-89.242 -180.92)",fill:"currentColor"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M165.465,228.5H161.38a.644.644,0,1,0,0,1.258h4.086a.644.644,0,1,0,0-1.258Z",transform:"translate(-133.905 -180.92)",fill:"currentColor"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M217.665,228.5H213.58a.644.644,0,1,0,0,1.258h4.086a.644.644,0,1,0,0-1.258Z",transform:"translate(-178.569 -180.92)",fill:"currentColor"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{transform:"translate(1)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{transform:"translate(491 304)",fill:"none",stroke:"currentColor",strokeWidth:"1.2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{cx:"3",cy:"3",r:"3",stroke:"none"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{cx:"3",cy:"3",r:"2.4",fill:"none"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{transform:"translate(499 296)",fill:"none",stroke:"currentColor",strokeWidth:"1.2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{cx:"3",cy:"3",r:"3",stroke:"none"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{cx:"3",cy:"3",r:"2.4",fill:"none"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{transform:"translate(507 304)",fill:"none",stroke:"currentColor",strokeWidth:"1.2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{cx:"3",cy:"3",r:"3",stroke:"none"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{cx:"3",cy:"3",r:"2.4",fill:"none"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{transform:"translate(515 296)",fill:"none",stroke:"currentColor",strokeWidth:"1.2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{cx:"3",cy:"3",r:"3",stroke:"none"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{cx:"3",cy:"3",r:"2.4",fill:"none"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"5",y2:"5",transform:"translate(495.5 300.5)",fill:"none",stroke:"currentColor",strokeWidth:"1.2"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x2:"5",y2:"5",transform:"translate(503.5 300.5)",fill:"none",stroke:"currentColor",strokeWidth:"1.2"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"5",y2:"5",transform:"translate(511.5 300.5)",fill:"none",stroke:"currentColor",strokeWidth:"1.2"}))));};var CheckIcon=function CheckIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",width:"15.213",height:"11.268",viewBox:"0 0 15.213 11.268"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeWidth:"1.5px",d:"M2640.009,518.006l6.242,4.794,6.79-8.487",transform:"matrix(0.998, 0.0695, -0.072, 0.998, -2596.288, -696.418)"}));};var CheckIcon2=function CheckIcon2(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",width:"14",height:"14",viewBox:"0 0 14 14"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M2.91675 7.81658L5.36119 10.3055L11.4723 4.08325",stroke:"white",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round",fill:"none"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M2.91675 7.81658L5.36119 10.3055L11.4723 4.08325",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round",fill:"none"})));};var SmartFieldsIcon=function SmartFieldsIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({width:"32",height:"32",viewBox:"0 0 32 32",fill:"none",xmlns:"http://www.w3.org/2000/svg"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M17.0666 4.8L6.3999 18.24H15.9999L14.9332 27.2L25.5999 13.76H15.9999L17.0666 4.8Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}));};var CustomizeIcon=function CustomizeIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({width:"22",height:"22",viewBox:"0 0 22 22",fill:"none",xmlns:"http://www.w3.org/2000/svg"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M16.1298 1.8356C16.3947 1.57068 16.7092 1.36054 17.0553 1.21716C17.4015 1.07379 17.7725 1 18.1471 1C18.5217 1 18.8927 1.07379 19.2389 1.21716C19.585 1.36054 19.8995 1.57068 20.1644 1.8356C20.4293 2.10051 20.6395 2.41501 20.7828 2.76114C20.9262 3.10727 21 3.47825 21 3.8529C21 4.22755 20.9262 4.59853 20.7828 4.94466C20.6395 5.29079 20.4293 5.60529 20.1644 5.87021L6.54759 19.487L1 21L2.51298 15.4524L16.1298 1.8356Z",stroke:"#616161",strokeLinecap:"round",strokeLinejoin:"round"}));};var CloseIcon=function CloseIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({width:"44",height:"44",viewBox:"0 0 44 44",fill:"none",xmlns:"http://www.w3.org/2000/svg"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M15 15L29 29",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M29 15L15 29",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{cx:"22",cy:"22",r:"15",stroke:"currentColor",strokeWidth:"2"}));};var ClearIcon=function ClearIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({width:"10",height:"10",viewBox:"0 0 10 10",fill:"none",xmlns:"http://www.w3.org/2000/svg"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{id:"Vector",d:"M2.5 2.5L7.5 7.5",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{id:"Vector_2",d:"M7.5 2.5L2.5 7.5",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"}));};var DownloadIcon=function DownloadIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({width:"18.8",height:"18.8",viewBox:"0 0 18.8 18.8",fill:"none",xmlns:"http://www.w3.org/2000/svg"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("defs",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{transform:"translate(-19.6 -357.6)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{transform:"translate(17 355)",strokeWidth:"0.8px"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{className:"a",d:"M21,15v4a2,2,0,0,1-2,2H5a2,2,0,0,1-2-2V15",fill:"none",stroke:"currentColor"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{className:"a",d:"M7,10l5,5,5-5",fill:"none",stroke:"currentColor"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{className:"a",y1:"12",transform:"translate(12 3)",fill:"none",stroke:"currentColor"}))));};var SharedIcon=function SharedIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",width:"19.841",height:"16.415",viewBox:"0 0 19.841 16.415"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{id:"Icon_feather-users",transform:"translate(-1 -4)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{id:"Path_629","data-name":"Path 629",d:"M15.2,27.638V25.926A3.426,3.426,0,0,0,11.777,22.5H4.926A3.426,3.426,0,0,0,1.5,25.926v1.713",transform:"translate(0 -7.723)",fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{id:"Path_630","data-name":"Path 630",d:"M14.351,7.926A3.426,3.426,0,1,1,10.926,4.5a3.426,3.426,0,0,1,3.426,3.426Z",transform:"translate(-2.574)",fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{id:"Path_631","data-name":"Path 631",d:"M32.569,27.722V26.009A3.426,3.426,0,0,0,30,22.7",transform:"translate(-12.229 -7.807)",fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{id:"Path_632","data-name":"Path 632",d:"M24,4.7a3.426,3.426,0,0,1,0,6.637",transform:"translate(-9.654 -0.084)",fill:"none",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"1"})));};var NextIcon=function NextIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",width:"16",height:"16",fill:"none",viewBox:"0 0 16 16"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{cx:"8",cy:"8",r:"7",fill:"currentColor"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M7 11L10 8.00369L7 5",stroke:"white",strokeLinecap:"round",strokeLinejoin:"round"}));};var XDarkLogo=function XDarkLogo(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",width:"56",height:"56",viewBox:"0 0 56 56"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M28 40C34.6274 40 40 34.6274 40 28C40 21.3726 34.6274 16 28 16C21.3726 16 16 21.3726 16 28C16 34.6274 21.3726 40 28 40Z",fill:"#22313E"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M33.5577 22.0655C33.49 21.9939 33.4084 21.9368 33.318 21.8977C33.2276 21.8586 33.1301 21.8382 33.0316 21.8378C32.9332 21.8381 32.8358 21.8584 32.7454 21.8973C32.655 21.9362 32.5734 21.9929 32.5055 22.0642L27.8087 26.9083L23.1138 22.0655C23.0457 21.994 22.9639 21.937 22.8733 21.8978C22.7827 21.8587 22.6851 21.8383 22.5864 21.8378C22.4874 21.838 22.3894 21.8582 22.2984 21.8974C22.2074 21.9365 22.1253 21.9937 22.0571 22.0655C21.9175 22.2125 21.8397 22.4074 21.8397 22.61C21.8397 22.8127 21.9175 23.0076 22.0571 23.1546L32.5068 33.9377C32.575 34.009 32.657 34.0656 32.7478 34.1041C32.8386 34.1426 32.9362 34.1621 33.0348 34.1615C33.133 34.1629 33.2304 34.1437 33.3208 34.1053C33.4111 34.0669 33.4925 34.01 33.5596 33.9384C33.6997 33.7913 33.7779 33.596 33.7779 33.3929C33.7779 33.1897 33.6997 32.9944 33.5596 32.8473L28.8692 28.0013L33.5596 23.1546C33.702 23.0076 33.7807 22.8105 33.7788 22.6058C33.7801 22.4036 33.7013 22.2091 33.5596 22.0649L33.5577 22.0655Z",fill:"white"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M22.0448 33.9481C22.1099 34.0156 22.1879 34.0693 22.2742 34.106C22.3606 34.1426 22.4534 34.1615 22.5472 34.1615C22.641 34.1615 22.7338 34.1426 22.8201 34.106C22.9064 34.0693 22.9844 34.0156 23.0495 33.9481L25.5579 31.3619L24.5525 30.3241L22.0448 32.9103C21.9114 33.0501 21.837 33.2359 21.837 33.4292C21.837 33.6224 21.9114 33.8083 22.0448 33.9481Z",fill:"#2FA5E7"}));};var SuccessIcon=function SuccessIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",width:"56",height:"56",viewBox:"0 0 56 56"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M53 25.7143V28.0143C52.9969 33.4054 51.2513 38.651 48.0233 42.9689C44.7954 47.2867 40.2582 50.4455 35.0884 51.9741C29.9186 53.5026 24.3931 53.3191 19.3362 51.4508C14.2792 49.5825 9.96164 46.1296 7.0274 41.607C4.09317 37.0844 2.69948 31.7345 3.05419 26.3551C3.40891 20.9757 5.49302 15.8551 8.9957 11.757C12.4984 7.65886 17.232 4.80277 22.4905 3.61467C27.749 2.42658 33.2507 2.97015 38.175 5.16431",stroke:"currentColor",strokeWidth:"5",strokeLinecap:"round",strokeLinejoin:"round",fill:"none"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M53 8.01465L28 33.0396L20.5 25.5396",stroke:"currentColor",strokeWidth:"5",strokeLinecap:"round",strokeLinejoin:"round",fill:"none"}));};var SpinnerIcon=function SpinnerIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({width:"1792",height:"1792",viewBox:"0 0 1792 1792",xmlns:"http://www.w3.org/2000/svg"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M526 1394q0 53-37.5 90.5t-90.5 37.5q-52 0-90-38t-38-90q0-53 37.5-90.5t90.5-37.5 90.5 37.5 37.5 90.5zm498 206q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-704-704q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm1202 498q0 52-38 90t-90 38q-53 0-90.5-37.5t-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-964-996q0 66-47 113t-113 47-113-47-47-113 47-113 113-47 113 47 47 113zm1170 498q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-640-704q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm530 206q0 93-66 158.5t-158 65.5q-93 0-158.5-65.5t-65.5-158.5q0-92 65.5-158t158.5-66q92 0 158 66t66 158z"}));};var TemplatesIcon=function TemplatesIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({width:"24",height:"24",viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M7 2C5.34315 2 4 3.34315 4 5V17C4 18.6569 5.34315 20 7 20H10V18H7C6.44772 18 6 17.5523 6 17V5C6 4.44772 6.44772 4 7 4H16C16.5523 4 17 4.44772 17 5V11H19V5C19 3.34315 17.6569 2 16 2H7Z",fill:"currentColor"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M21 21.9998V20.9998C21 20.4693 20.7893 19.9606 20.4142 19.5855C20.0391 19.2105 19.5304 18.9998 19 18.9998H15C14.4696 18.9998 13.9609 19.2105 13.5858 19.5855C13.2107 19.9606 13 20.4693 13 20.9998V21.9998",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M17 17C18.1046 17 19 16.1046 19 15C19 13.8954 18.1046 13 17 13C15.8954 13 15 13.8954 15 15C15 16.1046 15.8954 17 17 17Z",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"9",y1:"7",x2:"14",y2:"7",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"9",y1:"11",x2:"12",y2:"11",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round"}));};var DocumentsIcon=function DocumentsIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({width:"24",height:"24",viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M12 3V9H17.5",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M6.4749 1.8999C5.78273 1.8999 5.12481 2.18298 4.64421 2.67731C4.16455 3.17068 3.8999 3.83398 3.8999 4.5199V17.4799C3.8999 18.1658 4.16455 18.8291 4.64421 19.3225C5.12481 19.8168 5.78273 20.0999 6.4749 20.0999H10V18.0999H6.4749C6.33164 18.0999 6.18835 18.0416 6.0782 17.9283C5.96713 17.8141 5.8999 17.6533 5.8999 17.4799V4.5199C5.8999 4.34652 5.96713 4.18572 6.0782 4.07147C6.18835 3.95818 6.33164 3.8999 6.4749 3.8999H11.5649L16.4999 8.97589V11H18.4999V8.5699C18.4999 8.30956 18.3984 8.05949 18.2169 7.87282L12.7044 2.20282C12.5161 2.00916 12.2575 1.8999 11.9874 1.8999H6.4749Z",fill:"currentColor"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M21 21.9998V20.9998C21 20.4693 20.7893 19.9606 20.4142 19.5855C20.0391 19.2105 19.5304 18.9998 19 18.9998H15C14.4696 18.9998 13.9609 19.2105 13.5858 19.5855C13.2107 19.9606 13 20.4693 13 20.9998V21.9998",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M17 17C18.1046 17 19 16.1046 19 15C19 13.8954 18.1046 13 17 13C15.8954 13 15 13.8954 15 15C15 16.1046 15.8954 17 17 17Z",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"}));};var AssetsIcon=function AssetsIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({width:"24",height:"24",viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M9.3 4L11.1 6.66667H19.2C19.6774 6.66667 20.1352 6.85397 20.4728 7.18737C20.8104 7.52076 21 7.97295 21 8.44444V11H19V8.66667H11.1C10.4354 8.66667 9.81415 8.33649 9.4423 7.78561L8.23701 6H5V18H10V20H4.8C4.32261 20 3.86477 19.8127 3.52721 19.4793C3.18964 19.1459 3 18.6937 3 18.2222V5.77778C3 5.30628 3.18964 4.8541 3.52721 4.5207C3.86477 4.1873 4.32261 4 4.8 4H9.3Z",fill:"currentColor"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M21 21.9998V20.9998C21 20.4693 20.7893 19.9606 20.4142 19.5855C20.0391 19.2105 19.5304 18.9998 19 18.9998H15C14.4696 18.9998 13.9609 19.2105 13.5858 19.5855C13.2107 19.9606 13 20.4693 13 20.9998V21.9998",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M17 17C18.1046 17 19 16.1046 19 15C19 13.8954 18.1046 13 17 13C15.8954 13 15 13.8954 15 15C15 16.1046 15.8954 17 17 17Z",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"}));};var XIcon=function XIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({width:"24",height:"24",viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M6 6L18 18",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M18 6L6 18",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"}));};var VoucherIcon=function VoucherIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({width:"24",height:"24",viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{clipPath:"url(#clip0_229_11786)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M8.57122 12.6113C8.69122 12.6113 8.81123 12.5656 8.90276 12.474C9.0858 12.291 9.0858 11.994 8.90276 11.811L8.68195 11.5902C8.4989 11.4071 8.20224 11.4071 8.01888 11.5902C7.83583 11.7732 7.83583 12.0702 8.01888 12.2532L8.23969 12.474C8.33121 12.5656 8.45121 12.6113 8.57122 12.6113Z",fill:"currentColor"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M10.6909 13.5996L10.4153 13.3238C10.2323 13.1407 9.93532 13.1407 9.75228 13.3238C9.56923 13.5068 9.56923 13.8035 9.75228 13.9868L10.0278 14.2624C10.1196 14.3539 10.2393 14.3997 10.3593 14.3997C10.4793 14.3997 10.5993 14.3539 10.6909 14.2624C10.8739 14.0793 10.8739 13.7827 10.6909 13.5996Z",fill:"currentColor"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M11.4964 15.0678C11.3134 15.2509 11.3134 15.5479 11.4964 15.7309L11.8055 16.0397C11.8971 16.1312 12.0171 16.177 12.1371 16.177C12.2568 16.177 12.3768 16.1312 12.4683 16.0397C12.6513 15.8567 12.6513 15.56 12.4683 15.377L12.1595 15.0678C11.9764 14.8848 11.6795 14.8848 11.4964 15.0678Z",fill:"currentColor"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M23.3683 6.3929L21.8185 4.84307C21.7305 4.75507 21.6114 4.70579 21.4869 4.70579C21.3628 4.70579 21.2434 4.75507 21.1554 4.84307C20.8898 5.10869 20.5365 5.25493 20.1608 5.25493C19.7851 5.25493 19.4318 5.10869 19.1662 4.84307C18.6177 4.29457 18.6177 3.40206 19.1662 2.85356C19.3493 2.67051 19.3493 2.37386 19.1662 2.19049L17.6081 0.632345C16.7648 -0.210888 15.3926 -0.210888 14.5497 0.632345L6.61818 8.56386C6.53018 8.65187 6.4809 8.77123 6.4809 8.8954L6.48058 10.0519H5.32405C5.19989 10.0519 5.08052 10.1015 4.99252 10.1895L0.633307 14.5487C0.22497 14.9571 0 15.5001 0 16.0778C0 16.6557 0.22497 17.1988 0.633307 17.6071L2.19145 19.1652C2.37449 19.3486 2.67147 19.3486 2.85451 19.1652C3.12012 18.8996 3.47342 18.7534 3.84911 18.7534C4.22513 18.7534 4.5781 18.8996 4.84403 19.1652C5.10964 19.4312 5.25589 19.7845 5.25589 20.1602C5.25589 20.5359 5.10964 20.8892 4.84403 21.1548C4.75603 21.2428 4.70643 21.3618 4.70643 21.4863C4.70643 21.6105 4.75603 21.7298 4.84403 21.8178L6.39385 23.3677C6.81531 23.7891 7.36925 24 7.92287 24C8.47682 24 9.03044 23.7891 9.45222 23.3677L13.8114 19.0081C13.8994 18.9204 13.9487 18.8011 13.9487 18.6766V17.5201H15.1056C15.2297 17.5201 15.3491 17.4708 15.4368 17.3828L18.2714 14.5481C18.4545 14.3651 18.4545 14.0684 18.2714 13.8854C18.0884 13.7023 17.7918 13.7023 17.6084 13.8854L14.9113 16.5824H13.4799C13.221 16.5824 13.0111 16.7924 13.0111 17.0512V18.4827L8.78915 22.7046C8.31169 23.1824 7.53438 23.1824 7.05692 22.7046L5.80535 21.4533C6.05784 21.0732 6.19353 20.6271 6.19353 20.1602C6.19353 19.5339 5.94968 18.9454 5.50678 18.5025C5.0642 18.0596 4.47538 17.8158 3.84944 17.8158C3.38254 17.8158 2.93644 17.9514 2.55594 18.2039L1.29637 16.944C0.818914 16.4666 0.818914 15.6893 1.29637 15.2118L5.5183 10.9896H6.94972C7.20829 10.9896 7.41822 10.78 7.41822 10.5211L7.41854 9.08964L15.2124 1.29541C15.6902 0.817635 16.4675 0.817635 16.945 1.29541L18.2052 2.55563C17.6033 3.4651 17.7028 4.70547 18.5031 5.50614C18.946 5.94872 19.5349 6.19257 20.1608 6.19257C20.6277 6.19257 21.0738 6.05688 21.454 5.80439L22.7055 7.05596C23.183 7.53342 23.183 8.31073 22.7055 8.78819L20.5906 10.9028C20.4075 11.0859 20.4075 11.3829 20.5906 11.5659C20.774 11.749 21.0706 11.749 21.2536 11.5659L23.3683 9.45126C24.2115 8.60803 24.2115 7.23613 23.3683 6.3929Z",fill:"currentColor"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M14.1058 6.16531C13.8562 6.23475 13.7103 6.49332 13.7797 6.74261L15.3004 12.2065C15.3584 12.4139 15.5465 12.5496 15.752 12.5496C15.7936 12.5496 15.8358 12.5441 15.8781 12.5323C16.1274 12.4628 16.2733 12.2046 16.2038 11.955L14.6831 6.4914C14.6137 6.24179 14.3551 6.09618 14.1058 6.16531Z",fill:"currentColor"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M16.7322 7.91257C16.184 8.46075 16.184 9.35327 16.7322 9.90177C17.0064 10.1757 17.3668 10.313 17.7268 10.313C18.0871 10.313 18.4471 10.1757 18.7214 9.90145C19.2699 9.35327 19.2699 8.46075 18.7214 7.91257C18.4558 7.64664 18.1025 7.5004 17.7268 7.5004C17.3511 7.5004 16.9978 7.64664 16.7322 7.91257ZM18.0583 9.2387C17.8756 9.42143 17.578 9.42143 17.3952 9.2387C17.2125 9.05566 17.2125 8.75837 17.3952 8.57532C17.4839 8.487 17.6017 8.43803 17.7268 8.43803C17.8522 8.43803 17.97 8.487 18.0583 8.57532C18.2414 8.75837 18.2414 9.05566 18.0583 9.2387Z",fill:"currentColor"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M13.2905 8.07737C13.0249 7.81176 12.6716 7.66519 12.2959 7.66519C11.9202 7.66519 11.5669 7.81176 11.3013 8.07737C10.7528 8.62555 10.7528 9.51806 11.3013 10.0666C11.5755 10.3408 11.9355 10.4778 12.2959 10.4778C12.6559 10.4778 13.0162 10.3405 13.2905 10.0666C13.8387 9.51806 13.8387 8.62555 13.2905 8.07737ZM12.6274 9.4035C12.4447 9.58623 12.1471 9.58623 11.9643 9.4035C11.7813 9.22045 11.7813 8.92316 11.9643 8.74011C12.0527 8.65179 12.1704 8.60283 12.2959 8.60283C12.421 8.60283 12.5388 8.65179 12.6274 8.74011C12.8101 8.92316 12.8101 9.22045 12.6274 9.4035Z",fill:"currentColor"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M7.35589 13.7277C7.17284 13.5446 6.87619 13.5446 6.69282 13.7277L5.1014 15.3191C4.91835 15.5022 4.91835 15.7988 5.1014 15.9819C5.19292 16.0734 5.31293 16.1191 5.43293 16.1191C5.55294 16.1191 5.67294 16.0734 5.76447 15.9819L7.35589 14.3904C7.53894 14.2074 7.53894 13.9107 7.35589 13.7277Z",fill:"currentColor"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M6.89191 17.5779C7.01192 17.5779 7.13193 17.5321 7.22345 17.4406L8.81487 15.8492C8.99792 15.6661 8.99792 15.3692 8.81487 15.1861C8.63182 15.0031 8.33485 15.0031 8.15181 15.1861L6.56038 16.7775C6.37733 16.9606 6.37733 17.2575 6.56038 17.4406C6.6519 17.5321 6.77191 17.5779 6.89191 17.5779Z",fill:"currentColor"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M8.35041 19.0366C8.47041 19.0366 8.59042 18.9909 8.68195 18.8993L10.2734 17.3079C10.4564 17.1249 10.4564 16.8279 10.2734 16.6448C10.0903 16.4618 9.79335 16.4618 9.6103 16.6448L8.01888 18.2363C7.83583 18.4193 7.83583 18.7163 8.01888 18.8993C8.11072 18.9909 8.2304 19.0366 8.35041 19.0366Z",fill:"currentColor"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M19.4307 12.2575C19.3072 12.2575 19.1862 12.3074 19.0992 12.3948C19.0115 12.4818 18.9619 12.6028 18.9619 12.7263C18.9619 12.8495 19.0115 12.9705 19.0992 13.0575C19.1862 13.1449 19.3072 13.1948 19.4307 13.1948C19.5539 13.1948 19.6749 13.1449 19.7619 13.0575C19.8493 12.9705 19.8992 12.8495 19.8992 12.7263C19.8992 12.6028 19.8493 12.4818 19.7619 12.3948C19.6749 12.3074 19.5539 12.2575 19.4307 12.2575Z",fill:"currentColor"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("defs",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("clipPath",{id:"clip0_229_11786"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{width:"24.0006",height:"24",fill:"white"}))));};var VoucherIconColored=function VoucherIconColored(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({fontSize:"16",version:"1.1",overflow:"visible",width:"100.84pt",height:"100.839pt",viewBox:"174.03 -780.877 100.84 100.839",fill:"none",fillRule:"evenodd",stroke:"black",strokeWidth:"0.501",strokeLinejoin:"bevel",strokeMiterlimit:"10",fontFamily:"Times New Roman",xmlns:"http://www.w3.org/2000/svg"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{id:"Page background",transform:"scale(1 -1)"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{id:"Layer 1",transform:"scale(1 -1)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{id:"Group",fillRule:"nonzero",strokeLinejoin:"miter",stroke:"none",strokeWidth:"0.197"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M 250.274,779.956 C 246.38,776.06 240.064,776.06 236.169,779.956 C 236.167,779.958 236.165,779.96 236.163,779.962 C 235.822,780.304 235.272,780.314 234.93,779.973 L 174.934,719.977 C 174.593,719.635 174.603,719.085 174.944,718.743 C 174.947,718.741 174.949,718.739 174.951,718.737 C 178.846,714.842 178.846,708.527 174.951,704.632 C 174.753,704.435 174.55,704.248 174.341,704.072 C 173.953,703.743 173.923,703.156 174.282,702.796 L 196.789,680.289 C 197.149,679.931 197.736,679.96 198.065,680.348 C 198.241,680.557 198.428,680.761 198.625,680.958 C 202.52,684.853 208.835,684.853 212.73,680.958 C 212.732,680.956 212.734,680.954 212.736,680.952 C 213.078,680.61 213.627,680.6 213.969,680.941 L 273.965,740.937 C 274.307,741.279 274.297,741.829 273.955,742.171 C 273.952,742.173 273.95,742.175 273.949,742.177 C 270.053,746.072 270.053,752.387 273.949,756.282 C 274.146,756.479 274.349,756.666 274.559,756.842 C 274.947,757.171 274.977,757.758 274.618,758.118 L 252.11,780.625 C 251.75,780.984 251.163,780.954 250.835,780.566 C 250.658,780.356 250.472,780.153 250.274,779.956 Z",fill:"#e9f1f5",markerStart:"none",markerEnd:"none"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M 274.559,756.842 C 274.947,757.171 274.977,757.758 274.617,758.117 L 252.11,780.625 C 251.75,780.985 251.163,780.955 250.835,780.566 C 250.658,780.356 250.472,780.153 250.274,779.956 C 249.277,778.959 248.121,778.218 246.888,777.731 L 266.501,758.117 C 266.861,757.758 266.831,757.171 266.442,756.842 C 266.233,756.666 266.03,756.479 265.832,756.282 C 261.938,752.387 261.938,746.072 265.832,742.177 L 265.838,742.171 C 266.18,741.828 266.18,741.269 265.839,740.927 L 208.409,683.498 C 209.991,683.049 211.484,682.204 212.73,680.958 L 212.736,680.952 C 213.077,680.61 213.627,680.6 213.969,680.941 L 273.965,740.937 C 274.306,741.279 274.296,741.829 273.955,742.171 C 273.952,742.172 273.95,742.175 273.949,742.177 C 270.053,746.072 270.053,752.387 273.949,756.282 C 274.146,756.479 274.349,756.666 274.559,756.842 Z",fill:"#2e3f4f",markerStart:"none",markerEnd:"none"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M 250.835,780.566 C 250.658,780.356 250.472,780.153 250.274,779.956 C 246.38,776.06 240.064,776.06 236.169,779.956 C 236.167,779.958 236.165,779.96 236.163,779.962 C 235.822,780.304 235.272,780.314 234.93,779.973 L 205.517,750.56 L 244.553,711.524 L 273.965,740.937 C 274.307,741.279 274.297,741.829 273.955,742.17 C 273.952,742.172 273.95,742.175 273.949,742.177 C 270.053,746.071 270.053,752.387 273.949,756.282 C 274.146,756.479 274.349,756.665 274.559,756.842 C 274.947,757.17 274.977,757.757 274.618,758.117 L 252.11,780.625 C 251.751,780.984 251.163,780.954 250.835,780.566 Z",fill:"#62c5fd",markerStart:"none",markerEnd:"none"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M 274.559,756.842 C 274.947,757.171 274.977,757.758 274.617,758.117 L 252.11,780.625 C 251.75,780.985 251.163,780.955 250.835,780.566 C 250.658,780.356 250.472,780.153 250.274,779.956 C 249.277,778.959 248.121,778.218 246.888,777.731 L 265.868,758.75 C 266.549,758.07 266.527,756.974 265.845,756.294 C 265.841,756.291 265.837,756.286 265.833,756.282 C 261.938,752.387 261.938,746.072 265.833,742.177 L 265.839,742.171 C 266.18,741.829 266.19,741.279 265.849,740.937 L 240.494,715.582 L 244.553,711.524 L 273.955,740.928 C 274.298,741.27 274.297,741.829 273.955,742.171 L 273.949,742.177 C 270.053,746.072 270.053,752.387 273.949,756.282 C 274.146,756.479 274.349,756.666 274.559,756.842 Z",fill:"#2fa5e7",markerStart:"none",markerEnd:"none"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M 236.708,742.445 C 233.192,738.929 227.471,738.929 223.955,742.445 C 220.439,745.96 220.439,751.681 223.955,755.197 C 227.471,758.713 233.192,758.713 236.708,755.197 C 240.223,751.681 240.223,745.96 236.708,742.445 Z M 227.632,751.521 C 226.143,750.032 226.143,747.61 227.632,746.121 C 229.12,744.633 231.542,744.633 233.031,746.121 C 234.519,747.61 234.519,750.032 233.031,751.521 C 231.542,753.009 229.12,753.009 227.632,751.521 Z",fill:"#FFD508",markerStart:"none",markerEnd:"none"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M 261.672,742.445 C 258.156,738.929 252.435,738.929 248.919,742.445 C 245.403,745.96 245.403,751.681 248.919,755.197 C 252.435,758.713 258.156,758.713 261.672,755.197 C 265.188,751.681 265.188,745.96 261.672,742.445 Z M 252.596,751.521 C 251.107,750.032 251.107,747.61 252.596,746.121 C 254.085,744.633 256.507,744.633 257.995,746.121 C 259.484,747.61 259.484,750.032 257.995,751.521 C 256.507,753.009 254.085,753.009 252.596,751.521 Z",fill:"#FFD508",markerStart:"none",markerEnd:"none"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M 242.814,727.856 C 241.377,727.856 240.213,729.02 240.213,730.456 L 240.213,767.186 C 240.213,768.622 241.378,769.786 242.814,769.786 C 244.249,769.786 245.413,768.622 245.413,767.186 L 245.413,730.456 C 245.413,729.02 244.249,727.856 242.814,727.856 Z",fill:"#FFD508",markerStart:"none",markerEnd:"none"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M 211.928,729.452 L 189.603,707.127 C 188.524,706.048 186.775,706.048 185.696,707.127 C 184.617,708.205 184.617,709.955 185.696,711.034 L 208.021,733.359 C 209.099,734.437 210.849,734.437 211.928,733.359 C 213.006,732.28 213.006,730.53 211.928,729.452 Z",fill:"#62c5fd",markerStart:"none",markerEnd:"none"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M 219.64,721.74 L 197.315,699.415 C 196.236,698.336 194.486,698.336 193.408,699.415 C 192.329,700.494 192.329,702.243 193.408,703.322 L 215.733,725.647 C 216.811,726.725 218.561,726.725 219.64,725.647 C 220.718,724.568 220.718,722.818 219.64,721.74 Z",fill:"#62c5fd",markerStart:"none",markerEnd:"none"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M 227.351,714.028 L 205.027,691.703 C 203.948,690.624 202.198,690.624 201.12,691.703 C 200.041,692.782 200.041,694.531 201.12,695.61 L 223.445,717.935 C 224.523,719.013 226.272,719.013 227.351,717.935 C 228.43,716.856 228.43,715.107 227.351,714.028 Z",fill:"#62c5fd",markerStart:"none",markerEnd:"none"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{id:"Group_1",fill:"#FFD508"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M 257.581,693.047 L 250.736,699.891 C 249.554,701.073 249.554,702.989 250.736,704.171 C 251.918,705.353 253.833,705.353 255.015,704.171 L 261.86,697.326 C 263.042,696.144 263.042,694.229 261.86,693.047 C 260.678,691.865 258.762,691.865 257.581,693.047 Z",markerStart:"none",markerEnd:"none"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M 268.422,710.854 L 258.742,710.854 C 257.071,710.854 255.717,712.209 255.717,713.88 C 255.717,715.551 257.071,716.906 258.742,716.906 L 268.422,716.906 C 270.093,716.906 271.447,715.551 271.447,713.88 C 271.447,712.209 270.093,710.854 268.422,710.854 Z",markerStart:"none",markerEnd:"none"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M 244.052,686.484 L 244.052,696.164 C 244.052,697.835 242.698,699.19 241.026,699.19 C 239.355,699.19 238,697.835 238,696.164 L 238,686.484 C 238,684.813 239.355,683.459 241.026,683.459 C 242.698,683.459 244.052,684.813 244.052,686.484 Z",markerStart:"none",markerEnd:"none"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M 187.039,763.588 L 193.884,756.744 C 195.066,755.562 196.981,755.562 198.163,756.744 C 199.345,757.925 199.345,759.841 198.163,761.023 L 191.318,767.867 C 190.137,769.049 188.221,769.049 187.039,767.867 C 185.857,766.685 185.857,764.769 187.039,763.588 Z",markerStart:"none",markerEnd:"none"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M 204.847,774.429 L 204.847,764.749 C 204.847,763.078 206.202,761.724 207.873,761.724 C 209.544,761.724 210.899,763.078 210.899,764.749 L 210.899,774.429 C 210.899,776.1 209.544,777.455 207.873,777.455 C 206.202,777.455 204.847,776.1 204.847,774.429 Z",markerStart:"none",markerEnd:"none"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M 180.477,750.06 L 190.157,750.06 C 191.828,750.06 193.183,748.705 193.183,747.034 C 193.183,745.363 191.828,744.008 190.157,744.008 L 180.477,744.008 C 178.806,744.008 177.452,745.363 177.452,747.034 C 177.452,748.705 178.806,750.06 180.477,750.06 Z",markerStart:"none",markerEnd:"none"})))));};var SortArrow=function SortArrow(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",width:"20",height:"20",viewBox:"0 0 20 20"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M9.99992 3.99995L9.99992 15.9999",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M13 12.9999L10 15.9999L7 12.9999",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}));};var IconInvite=function IconInvite(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",width:"20",height:"20",viewBox:"0 0 20 20",fill:"none"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M17.5003 2.5L9.16699 10.8333",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M17.9719 2.66518C18.0354 2.48388 17.9894 2.28227 17.8536 2.14645C17.7177 2.01063 17.5161 1.96462 17.3348 2.02807L2.33482 7.27807C2.14132 7.3458 2.00877 7.52478 2.00042 7.72962C1.99206 7.93446 2.10959 8.12364 2.29693 8.20691L8.8712 11.1288L11.7931 17.7031C11.8764 17.8904 12.0655 18.0079 12.2704 17.9996C12.4752 17.9912 12.6542 17.8587 12.7219 17.6652L17.9719 2.66518Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}));};var IconAddUsers=function IconAddUsers(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({width:"24",height:"24",viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M21 18.3333C21 17.4493 20.6839 16.6014 20.1213 15.9763C19.5587 15.3512 18.7956 15 18 15H12C11.2044 15 10.4413 15.3512 9.87868 15.9763C9.31607 16.6014 9 17.4493 9 18.3333",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M15 12C16.6569 12 18 10.6569 18 9C18 7.34315 16.6569 6 15 6C13.3431 6 12 7.34315 12 9C12 10.6569 13.3431 12 15 12Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M6 9V15",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M3 12H9",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}));};var IconAddMls=function IconAddMls(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({width:"15",height:"15",viewBox:"0 0 15 15",fill:"none",xmlns:"http://www.w3.org/2000/svg"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M7.5 0.5V14.5",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M0.5 7.5H14.5",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}));};var IconTickRounded=function IconTickRounded(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({width:"32",height:"32",viewBox:"0 0 32 32",fill:"none",xmlns:"http://www.w3.org/2000/svg"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M15.9999 1.90735e-06C7.20607 1.90735e-06 0 7.20635 0 16.0001C0 24.7939 7.20607 32 15.9999 32C24.7936 32 32 24.7939 32 16.0001C32 7.20635 24.7936 1.90735e-06 15.9999 1.90735e-06Z",fill:"#39C046"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M31.9999 16.0001C31.9999 24.7939 24.7935 32 15.9998 32V1.90735e-06C24.7935 1.90735e-06 31.9999 7.20635 31.9999 16.0001Z",fill:"#62DB6E"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M25.0187 12.4564L15.9998 21.4563L14.1248 23.3313L6.9812 16.2064L9.64372 13.5439L14.1248 18.0437L15.9998 16.1687L22.3562 9.79391L25.0187 12.4564Z",fill:"white"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M25.0186 12.4567L15.9998 21.4565V16.1689L22.3561 9.79414L25.0186 12.4567Z",fill:"white"}));};var IconErrorRounded=function IconErrorRounded(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({width:"32",height:"32",viewBox:"0 0 32 32",fill:"none",xmlns:"http://www.w3.org/2000/svg"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M16.0003 32C24.8372 32 32 24.8372 32 15.9997C32 7.16281 24.8372 5.72205e-06 16.0003 5.72205e-06C7.16339 5.72205e-06 0 7.16281 0 15.9997C0 24.8372 7.16339 32 16.0003 32Z",fill:"#FF6465"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M19.5876 15.9996L23.8002 11.7876C24.1049 11.4823 24.1049 10.9851 23.8002 10.678L21.3219 8.20025C21.0148 7.89496 20.5176 7.89496 20.2129 8.20025L16.0002 12.4123L11.7876 8.20025C11.4823 7.89496 10.9851 7.89496 10.678 8.20025L8.20028 10.678C7.89499 10.9851 7.89499 11.4823 8.20028 11.7876L12.4129 15.9996L8.20028 20.2123C7.89499 20.5193 7.89499 21.0148 8.20028 21.3218L10.678 23.7996C10.9851 24.1049 11.4823 24.1049 11.7876 23.7996L16.0002 19.5869L20.2129 23.7996C20.5194 24.1049 21.0148 24.1049 21.3219 23.7996L23.8002 21.3218C24.1049 21.0148 24.1049 20.5193 23.8002 20.2123L19.5876 15.9996Z",fill:"white"}));};var IconInfoRounded=function IconInfoRounded(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({width:"32",height:"32",viewBox:"0 0 32 32",fill:"none",xmlns:"http://www.w3.org/2000/svg"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{cx:"16",cy:"16",r:"16",fill:"currentColor"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"18",y:"26",width:"4",height:"14",rx:"2",transform:"rotate(180 18 26)",fill:"white"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"18",y:"10",width:"4",height:"4",rx:"2",transform:"rotate(180 18 10)",fill:"white"}));};var IconNoPackage=function IconNoPackage(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({alt:"",src:__WEBPACK_IMPORTED_MODULE_5__assets_nopackage_png___default.a},props));};var IconEssential=function IconEssential(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({alt:"Essential",src:__WEBPACK_IMPORTED_MODULE_9__assets_essential_png___default.a},props));};var IconScale=function IconScale(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({alt:"Scale",src:__WEBPACK_IMPORTED_MODULE_8__assets_scale_png___default.a},props));};var IconPGD=function IconPGD(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({alt:"Photo & Graphic Designer+",src:__WEBPACK_IMPORTED_MODULE_12__assets_pgd_plus_png___default.a},props));};var IconDP=function IconDP(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({alt:"Designer Pro+",src:__WEBPACK_IMPORTED_MODULE_11__assets_dp_plus_png___default.a},props));};var IconWD=function IconWD(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({alt:"Web Designer+",src:__WEBPACK_IMPORTED_MODULE_10__assets_wd_plus_png___default.a},props));};var IconPGDPerpetual=function IconPGDPerpetual(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({alt:"Photo & Graphic Designer+",src:__WEBPACK_IMPORTED_MODULE_15__assets_pgd_perpetual_png___default.a},props));};var IconDPPerpetual=function IconDPPerpetual(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({alt:"Designer Pro+",src:__WEBPACK_IMPORTED_MODULE_14__assets_dp_perpetual_png___default.a},props));};var IconWDPerpetual=function IconWDPerpetual(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({alt:"Web Designer+",src:__WEBPACK_IMPORTED_MODULE_13__assets_wd_perpetual_png___default.a},props));};var WeAcceptIcon=function WeAcceptIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({alt:"",src:__WEBPACK_IMPORTED_MODULE_6__assets_we_accept_png___default.a},props));};var WeAcceptEurIcon=function WeAcceptEurIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({alt:"",src:__WEBPACK_IMPORTED_MODULE_7__assets_we_accept_eur_png___default.a},props));};var IconAddonAI=function IconAddonAI(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({alt:"AI",src:__WEBPACK_IMPORTED_MODULE_16__assets_addon_ai_png___default.a},props));};var IconAddonHosting=function IconAddonHosting(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({alt:"Hosting",src:__WEBPACK_IMPORTED_MODULE_20__assets_addon_hosting_png___default.a},props));};var IconAddonCloudStorage=function IconAddonCloudStorage(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({alt:"Cloud Storage",src:__WEBPACK_IMPORTED_MODULE_17__assets_addon_cloud_storage_png___default.a},props));};var IconAddonDesignServices=function IconAddonDesignServices(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({alt:"Design Services",src:__WEBPACK_IMPORTED_MODULE_18__assets_addon_design_services_png___default.a},props));};var IconAddonMLS=function IconAddonMLS(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({alt:"MLS Connect",src:__WEBPACK_IMPORTED_MODULE_19__assets_addon_mls_png___default.a},props));};var IconMlsIdDone=function IconMlsIdDone(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",width:"21",height:"20",viewBox:"0 0 21 20",fill:"none"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M4.66602 10.4L8.09459 14L16.666 5",stroke:"currentColor",strokeOpacity:"0.75",strokeLinecap:"round",strokeLinejoin:"round"}));};var IconTextFieldStatus=function IconTextFieldStatus(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",width:"21",height:"20",viewBox:"0 0 21 20",fill:"none"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M4.66602 10.4L8.09459 14L16.666 5",stroke:"currentColor",strokeOpacity:"0.75",strokeLinecap:"round",strokeLinejoin:"round"}));};var IconMlsIdAdd=function IconMlsIdAdd(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",width:"21",height:"20",viewBox:"0 0 21 20",fill:"none"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"4.16602",y1:"10",x2:"17.166",y2:"10",stroke:"currentColor",strokeOpacity:"0.75",strokeLinecap:"round"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"10.666",y1:"3.5",x2:"10.666",y2:"16.5",stroke:"currentColor",strokeOpacity:"0.75",strokeLinecap:"round"}));};var CheckIconRounded=function CheckIconRounded(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",width:"20",height:"20",viewBox:"0 0 20 20"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{id:"Group_2424","data-name":"Group 2424",transform:"translate(-1245 -257)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{id:"Ellipse_57","data-name":"Ellipse 57",cx:"10",cy:"10",r:"10",transform:"translate(1245 257)",fill:"currentColor"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{id:"Path_2416","data-name":"Path 2416",d:"M9742,418.76l2.055,2.608,5.15-5.151",transform:"translate(-8490.603 -151.744)",fill:"none",stroke:"#fff",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:"2"})));};var UpdateSeatsIcon=function UpdateSeatsIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({xmlns:"http://www.w3.org/2000/svg",width:"21.427",height:"18.108",viewBox:"0 0 21.427 18.108"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{id:"refresh",transform:"translate(0 -39.691)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{id:"Path_2460","data-name":"Path 2460",d:"M6.359,50.024a.527.527,0,0,0-.4-.873H4.607c-.009-.134-.014-.269-.014-.405a6.117,6.117,0,0,1,10.314-4.453l1.91-2.234A9.054,9.054,0,0,0,1.659,48.745c0,.136,0,.271.009.405H.528a.527.527,0,0,0-.4.873L2.7,52.976l.541.62,1.941-2.226Z",fill:"currentColor"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{id:"Path_2461","data-name":"Path 2461",d:"M137.2,163.757l-1.92-2.2-1.195-1.37-1.706,1.956-1.409,1.616a.527.527,0,0,0,.4.873h1.353a6.116,6.116,0,0,1-9.85,4.406l-1.91,2.234a9.054,9.054,0,0,0,14.7-6.641H136.8A.527.527,0,0,0,137.2,163.757Z",transform:"translate(-115.903 -115.456)",fill:"currentColor"})));};var SelectArrow=function SelectArrow(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({width:"14",height:"8",viewBox:"0 0 14 8",fill:"none",xmlns:"http://www.w3.org/2000/svg"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M13 1L7.00739 7L1 1",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"}));};var DeleteIconRounded=function DeleteIconRounded(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({width:"24",height:"24",viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{cx:"12",cy:"12",r:"9.5",stroke:"currentColor",strokeOpacity:"0.75"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M8 8L16 16",stroke:"currentColor",strokeOpacity:"0.75",strokeLinecap:"round",strokeLinejoin:"round"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M16 8L8 16",stroke:"currentColor",strokeOpacity:"0.75",strokeLinecap:"round",strokeLinejoin:"round"}));};var SettingsIcon=function SettingsIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({width:"24",height:"24",viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M18.0545 14.4545C17.9456 14.7013 17.9131 14.9751 17.9613 15.2405C18.0094 15.5059 18.1359 15.7508 18.3245 15.9436L18.3736 15.9927C18.5258 16.1447 18.6465 16.3252 18.7288 16.5238C18.8112 16.7225 18.8536 16.9354 18.8536 17.1505C18.8536 17.3655 18.8112 17.5784 18.7288 17.7771C18.6465 17.9757 18.5258 18.1562 18.3736 18.3082C18.2217 18.4603 18.0412 18.581 17.8425 18.6634C17.6439 18.7457 17.431 18.7881 17.2159 18.7881C17.0009 18.7881 16.7879 18.7457 16.5893 18.6634C16.3906 18.581 16.2102 18.4603 16.0582 18.3082L16.0091 18.2591C15.8163 18.0705 15.5714 17.9439 15.3059 17.8958C15.0405 17.8477 14.7668 17.8802 14.52 17.9891C14.278 18.0928 14.0716 18.265 13.9263 18.4845C13.7809 18.704 13.7029 18.9613 13.7018 19.2245V19.3636C13.7018 19.7976 13.5294 20.2138 13.2225 20.5207C12.9157 20.8276 12.4994 21 12.0655 21C11.6315 21 11.2152 20.8276 10.9084 20.5207C10.6015 20.2138 10.4291 19.7976 10.4291 19.3636V19.29C10.4228 19.0192 10.3351 18.7565 10.1775 18.5362C10.0199 18.3159 9.79969 18.1481 9.54545 18.0545C9.29868 17.9456 9.02493 17.9131 8.75952 17.9613C8.4941 18.0094 8.24919 18.1359 8.05636 18.3245L8.00727 18.3736C7.8553 18.5258 7.67483 18.6465 7.47617 18.7288C7.27752 18.8112 7.06459 18.8536 6.84955 18.8536C6.6345 18.8536 6.42157 18.8112 6.22292 18.7288C6.02426 18.6465 5.84379 18.5258 5.69182 18.3736C5.53967 18.2217 5.41898 18.0412 5.33663 17.8425C5.25428 17.6439 5.21189 17.431 5.21189 17.2159C5.21189 17.0009 5.25428 16.7879 5.33663 16.5893C5.41898 16.3906 5.53967 16.2102 5.69182 16.0582L5.74091 16.0091C5.92953 15.8163 6.05606 15.5714 6.10419 15.3059C6.15231 15.0405 6.11982 14.7668 6.01091 14.52C5.90719 14.278 5.73498 14.0716 5.51547 13.9263C5.29596 13.7809 5.03873 13.7029 4.77545 13.7018H4.63636C4.20237 13.7018 3.78616 13.5294 3.47928 13.2225C3.1724 12.9157 3 12.4994 3 12.0655C3 11.6315 3.1724 11.2152 3.47928 10.9084C3.78616 10.6015 4.20237 10.4291 4.63636 10.4291H4.71C4.98081 10.4228 5.24346 10.3351 5.46379 10.1775C5.68412 10.0199 5.85195 9.79969 5.94545 9.54545C6.05437 9.29868 6.08686 9.02493 6.03873 8.75952C5.99061 8.4941 5.86408 8.24919 5.67545 8.05636L5.62636 8.00727C5.47422 7.8553 5.35352 7.67483 5.27118 7.47617C5.18883 7.27752 5.14644 7.06459 5.14644 6.84955C5.14644 6.6345 5.18883 6.42157 5.27118 6.22292C5.35352 6.02426 5.47422 5.84379 5.62636 5.69182C5.77834 5.53967 5.95881 5.41898 6.15746 5.33663C6.35611 5.25428 6.56905 5.21189 6.78409 5.21189C6.99913 5.21189 7.21207 5.25428 7.41072 5.33663C7.60937 5.41898 7.78984 5.53967 7.94182 5.69182L7.99091 5.74091C8.18374 5.92953 8.42865 6.05606 8.69406 6.10419C8.95948 6.15231 9.23322 6.11982 9.48 6.01091H9.54545C9.78745 5.90719 9.99383 5.73498 10.1392 5.51547C10.2846 5.29596 10.3626 5.03873 10.3636 4.77545V4.63636C10.3636 4.20237 10.536 3.78616 10.8429 3.47928C11.1498 3.1724 11.566 3 12 3C12.434 3 12.8502 3.1724 13.1571 3.47928C13.464 3.78616 13.6364 4.20237 13.6364 4.63636V4.71C13.6374 4.97328 13.7154 5.23051 13.8608 5.45002C14.0062 5.66953 14.2126 5.84174 14.4545 5.94545C14.7013 6.05437 14.9751 6.08686 15.2405 6.03873C15.5059 5.99061 15.7508 5.86408 15.9436 5.67545L15.9927 5.62636C16.1447 5.47422 16.3252 5.35352 16.5238 5.27118C16.7225 5.18883 16.9354 5.14644 17.1505 5.14644C17.3655 5.14644 17.5784 5.18883 17.7771 5.27118C17.9757 5.35352 18.1562 5.47422 18.3082 5.62636C18.4603 5.77834 18.581 5.95881 18.6634 6.15746C18.7457 6.35611 18.7881 6.56905 18.7881 6.78409C18.7881 6.99913 18.7457 7.21207 18.6634 7.41072C18.581 7.60937 18.4603 7.78984 18.3082 7.94182L18.2591 7.99091C18.0705 8.18374 17.9439 8.42865 17.8958 8.69406C17.8477 8.95948 17.8802 9.23322 17.9891 9.48V9.54545C18.0928 9.78745 18.265 9.99383 18.4845 10.1392C18.704 10.2846 18.9613 10.3626 19.2245 10.3636H19.3636C19.7976 10.3636 20.2138 10.536 20.5207 10.8429C20.8276 11.1498 21 11.566 21 12C21 12.434 20.8276 12.8502 20.5207 13.1571C20.2138 13.464 19.7976 13.6364 19.3636 13.6364H19.29C19.0267 13.6374 18.7695 13.7154 18.55 13.8608C18.3305 14.0062 18.1583 14.2126 18.0545 14.4545V14.4545Z",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}));};var SearchIcon=function SearchIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({width:"17",height:"18",viewBox:"0 0 17 18",fill:"none",xmlns:"http://www.w3.org/2000/svg"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M7 0C10.866 0 14 3.13401 14 7C14 9.00753 13.1536 10.8163 11.7998 12.0928L16.3535 16.6465C16.5488 16.8417 16.5488 17.1583 16.3535 17.3535C16.1583 17.5488 15.8417 17.5488 15.6465 17.3535L11.0205 12.7275C9.88251 13.5278 8.49693 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0ZM7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13C8.31709 13 9.53387 12.574 10.5234 11.8545C10.5466 11.7786 10.5864 11.7065 10.6465 11.6465C10.7344 11.5586 10.847 11.5117 10.9619 11.5029C12.2106 10.4034 13 8.79458 13 7C13 3.68629 10.3137 1 7 1Z",fill:"currentColor"}));};var ClearSearchIcon=function ClearSearchIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({width:"24",height:"24",viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M6 6L18 18",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M18 6L6 18",stroke:"currentColor",strokeLinecap:"round",strokeLinejoin:"round"}));};var MlsIcon=function MlsIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({width:"40",height:"40",viewBox:"0 0 40 40",fill:"none",xmlns:"http://www.w3.org/2000/svg"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M7.01792 25.8403C6.49257 25.8403 6.09968 25.3579 6.20599 24.8435L8.17282 15.3254C8.31213 14.6512 8.90586 14.1677 9.59428 14.1677C10.3442 14.1677 10.9706 14.7389 11.0396 15.4856L11.7687 23.3733H11.8311L16.026 15.25C16.3693 14.5852 17.0549 14.1677 17.8031 14.1677H18.0207C18.6538 14.1677 19.1276 14.7486 19.0002 15.3688L16.9914 25.1536C16.9093 25.5534 16.5574 25.8403 16.1493 25.8403C15.6047 25.8403 15.1973 25.3402 15.3075 24.8068L16.4132 19.4531C16.4965 19.0486 16.585 18.6467 16.6786 18.2475C16.7723 17.843 16.8634 17.4597 16.9518 17.0978C17.0455 16.7359 17.1288 16.4192 17.2016 16.1477H17.147L12.3998 25.3007C12.2278 25.6322 11.8855 25.8403 11.5121 25.8403H11.4165C10.8996 25.8403 10.4679 25.4464 10.4207 24.9317L9.61419 16.1477H9.55174C9.53092 16.3766 9.49189 16.6747 9.43465 17.0419C9.37741 17.4092 9.31236 17.8057 9.2395 18.2315C9.16664 18.652 9.08858 19.0619 9.00532 19.4611L7.83003 25.1782C7.75078 25.5637 7.41146 25.8403 7.01792 25.8403Z",fill:"currentColor",fillOpacity:"0.75"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M20.6388 25.8403C20.0052 25.8403 19.5313 25.2585 19.6595 24.638L21.6739 14.8899C21.7608 14.4693 22.1311 14.1677 22.5606 14.1677C23.1346 14.1677 23.5637 14.695 23.4471 15.257L21.5889 24.2116H24.8205C25.3363 24.2116 25.7222 24.6851 25.6181 25.1903C25.5401 25.5688 25.2069 25.8403 24.8205 25.8403H20.6388Z",fill:"currentColor",fillOpacity:"0.75"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M29.567 26C28.9946 26 28.482 25.9468 28.0292 25.8403C27.7443 25.7725 27.4794 25.6853 27.2345 25.5787C26.9804 25.4681 26.8349 25.2066 26.8349 24.9294C26.8349 24.3395 27.474 23.9544 28.0318 24.1461C28.0569 24.1547 28.0821 24.1633 28.1073 24.1717C28.56 24.3154 29.0518 24.3872 29.5826 24.3872C29.8949 24.3872 30.1889 24.3553 30.4647 24.2914C30.7405 24.2222 30.9851 24.1158 31.1985 23.9721C31.4118 23.8283 31.5784 23.6474 31.6981 23.4291C31.8177 23.2056 31.8776 22.9421 31.8776 22.6387C31.8776 22.33 31.8151 22.0639 31.6902 21.8403C31.5654 21.6168 31.3806 21.4065 31.136 21.2096C30.8914 21.0073 30.5844 20.7891 30.2149 20.5549C29.861 20.3207 29.5306 20.0625 29.2235 19.7804C28.9165 19.4983 28.6693 19.171 28.482 18.7984C28.2946 18.4205 28.201 17.9734 28.201 17.4571C28.201 16.9248 28.2946 16.4458 28.482 16.02C28.6745 15.5941 28.9425 15.2322 29.286 14.9341C29.6347 14.6307 30.0406 14.3992 30.5037 14.2395C30.9721 14.0798 31.4795 14 32.0259 14C32.6192 14 33.1526 14.0639 33.6261 14.1916C33.8528 14.2502 34.0759 14.3222 34.2955 14.4077C34.7036 14.5665 34.8602 15.0436 34.6796 15.4426C34.484 15.8751 33.9681 16.0526 33.5186 15.9001C33.418 15.8659 33.3159 15.834 33.2124 15.8044C32.8273 15.6873 32.4318 15.6287 32.0259 15.6287C31.7553 15.6287 31.5029 15.666 31.2687 15.7405C31.0397 15.815 30.8394 15.9242 30.6677 16.0679C30.4959 16.2116 30.3606 16.3899 30.2617 16.6028C30.1681 16.8104 30.1212 17.0499 30.1212 17.3214C30.1212 17.6301 30.1811 17.8909 30.3008 18.1038C30.4205 18.3167 30.5948 18.5136 30.8238 18.6946C31.0528 18.8703 31.3312 19.0619 31.659 19.2695C32.1014 19.5516 32.4813 19.8417 32.7987 20.1397C33.1161 20.4378 33.3581 20.7705 33.5247 21.1377C33.6912 21.505 33.7745 21.9388 33.7745 22.4391C33.7745 23.0406 33.6678 23.5649 33.4544 24.012C33.2462 24.4538 32.9496 24.8237 32.5645 25.1218C32.1846 25.4145 31.7397 25.6354 31.2297 25.7844C30.7197 25.9281 30.1655 26 29.567 26Z",fill:"currentColor",fillOpacity:"0.75"}));};var CopyIcon=function CopyIcon(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({width:"15",height:"18",viewBox:"0 0 15 18",fill:"none",xmlns:"http://www.w3.org/2000/svg"},props),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{id:"_01_align_center","data-name":"01 align center",transform:"translate(-2)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{id:"Path_2207","data-name":"Path 2207",d:"M17,3.109,13.99,0H8A2.25,2.25,0,0,0,5.75,2.25V3H4.25A2.25,2.25,0,0,0,2,5.25V18H14V14.25h3ZM12.5,16.5h-9V5.25a.75.75,0,0,1,.75-.75h1.5v9.75H12.5ZM7.25,12.75V2.25A.75.75,0,0,1,8,1.5h4.5v3h3v8.25Z",fill:"#002748"})));};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Typography.default;
  }
});

var _Typography = _interopRequireDefault(__webpack_require__(856));

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return showModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hideModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return resetModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(45);
var initialState={modalShown:false,modalType:null,modalProps:{}};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1?arguments[1]:undefined;switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["_133" /* MODAL_SHOW */]:return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{modalShown:true,modalType:action.modalType,modalProps:__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state.modalProps,action.modalProps)});case __WEBPACK_IMPORTED_MODULE_1__actions__["_131" /* MODAL_HIDE */]:return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{modalShown:false});case __WEBPACK_IMPORTED_MODULE_1__actions__["_132" /* MODAL_RESET */]:return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{modalType:null,modalProps:{}});default:return state;}});var showModal=function showModal(modalType,modalProps){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actions__["_133" /* MODAL_SHOW */],modalType:modalType,modalProps:modalProps});};};var hideModal=function hideModal(){return{type:__WEBPACK_IMPORTED_MODULE_1__actions__["_131" /* MODAL_HIDE */]};};var resetModal=function resetModal(){return{type:__WEBPACK_IMPORTED_MODULE_1__actions__["_132" /* MODAL_RESET */]};};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__colors__);
/* unused harmony reexport colors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles__);
/* unused harmony reexport createGenerateClassName */
/* unused harmony reexport createMuiTheme */
/* unused harmony reexport createStyles */
/* unused harmony reexport jssPreset */
/* unused harmony reexport MuiThemeProvider */
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1__styles__, "withStyles")) __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_1__styles__["withStyles"]; });
/* unused harmony reexport withTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppBar__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AppBar__);
/* unused harmony reexport AppBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Avatar__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Avatar__);
/* unused harmony reexport Avatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Backdrop__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Backdrop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Backdrop__);
/* unused harmony reexport Backdrop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Badge__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Badge__);
/* unused harmony reexport Badge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BottomNavigation__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BottomNavigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__BottomNavigation__);
/* unused harmony reexport BottomNavigation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BottomNavigationAction__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BottomNavigationAction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__BottomNavigationAction__);
/* unused harmony reexport BottomNavigationAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Button__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Button__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_8__Button___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ButtonBase__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ButtonBase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ButtonBase__);
/* unused harmony reexport ButtonBase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Card__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Card__);
/* unused harmony reexport Card */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CardActionArea__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CardActionArea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__CardActionArea__);
/* unused harmony reexport CardActionArea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CardActions__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CardActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__CardActions__);
/* unused harmony reexport CardActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CardContent__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__CardContent__);
/* unused harmony reexport CardContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CardHeader__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CardHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__CardHeader__);
/* unused harmony reexport CardHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CardMedia__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CardMedia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__CardMedia__);
/* unused harmony reexport CardMedia */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Checkbox__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__Checkbox__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_16__Checkbox___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Chip__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Chip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__Chip__);
/* unused harmony reexport Chip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__CircularProgress__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__CircularProgress__);
/* unused harmony reexport CircularProgress */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ClickAwayListener__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ClickAwayListener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__ClickAwayListener__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_19__ClickAwayListener___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Collapse__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__Collapse__);
/* unused harmony reexport Collapse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__CssBaseline__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__CssBaseline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__CssBaseline__);
/* unused harmony reexport CssBaseline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Dialog__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__Dialog__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_22__Dialog___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__DialogActions__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__DialogActions__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_23__DialogActions___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__DialogContent__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__DialogContent__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_24__DialogContent___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__DialogContentText__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__DialogContentText__);
/* unused harmony reexport DialogContentText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__DialogTitle__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__DialogTitle__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_26__DialogTitle___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Divider__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__Divider__);
/* unused harmony reexport Divider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Drawer__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Drawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__Drawer__);
/* unused harmony reexport Drawer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ExpansionPanel__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ExpansionPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__ExpansionPanel__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_29__ExpansionPanel___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ExpansionPanelActions__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ExpansionPanelActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__ExpansionPanelActions__);
/* unused harmony reexport ExpansionPanelActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__ExpansionPanelDetails__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__ExpansionPanelDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__ExpansionPanelDetails__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_31__ExpansionPanelDetails___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__ExpansionPanelSummary__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__ExpansionPanelSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__ExpansionPanelSummary__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_32__ExpansionPanelSummary___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Fab__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Fab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__Fab__);
/* unused harmony reexport Fab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__Fade__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__Fade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__Fade__);
/* unused harmony reexport Fade */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__FilledInput__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__FilledInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__FilledInput__);
/* unused harmony reexport FilledInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__FormControl__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__FormControl__);
/* unused harmony reexport FormControl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__FormControlLabel__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__FormControlLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__FormControlLabel__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_37__FormControlLabel___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__FormGroup__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__FormGroup__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_38__FormGroup___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__FormHelperText__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__FormHelperText__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_39__FormHelperText___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__FormLabel__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__FormLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__FormLabel__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_40__FormLabel___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__Grid__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__Grid__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_41__Grid___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__GridList__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__GridList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__GridList__);
/* unused harmony reexport GridList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__GridListTile__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__GridListTile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__GridListTile__);
/* unused harmony reexport GridListTile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__GridListTileBar__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__GridListTileBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__GridListTileBar__);
/* unused harmony reexport GridListTileBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Grow__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Grow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__Grow__);
/* unused harmony reexport Grow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Hidden__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Hidden___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__Hidden__);
/* unused harmony reexport Hidden */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__Icon__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__Icon__);
/* unused harmony reexport Icon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__IconButton__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__IconButton__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_48__IconButton___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Input__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__Input__);
/* unused harmony reexport Input */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__InputAdornment__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__InputAdornment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__InputAdornment__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_50__InputAdornment___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__InputBase__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__InputBase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__InputBase__);
/* unused harmony reexport InputBase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__InputLabel__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__InputLabel__);
/* unused harmony reexport InputLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__LinearProgress__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__LinearProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__LinearProgress__);
/* unused harmony reexport LinearProgress */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__Link__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__Link__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_54__Link___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__List__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__List__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_55__List___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__ListItem__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__ListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__ListItem__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_56__ListItem___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__ListItemAvatar__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__ListItemAvatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__ListItemAvatar__);
/* unused harmony reexport ListItemAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__ListItemIcon__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__ListItemIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__ListItemIcon__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_58__ListItemIcon___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__ListItemSecondaryAction__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__ListItemSecondaryAction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__ListItemSecondaryAction__);
/* unused harmony reexport ListItemSecondaryAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__ListItemText__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__ListItemText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__ListItemText__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_60__ListItemText___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__ListSubheader__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__ListSubheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__ListSubheader__);
/* unused harmony reexport ListSubheader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__Menu__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__Menu__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_62__Menu___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__MenuItem__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__MenuItem__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_63__MenuItem___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__MenuList__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__MenuList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__MenuList__);
/* unused harmony reexport MenuList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__MobileStepper__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__MobileStepper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__MobileStepper__);
/* unused harmony reexport MobileStepper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__Modal__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__Modal__);
/* unused harmony reexport Modal */
/* unused harmony reexport ModalManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__NativeSelect__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__NativeSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__NativeSelect__);
/* unused harmony reexport NativeSelect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__NoSsr__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__NoSsr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__NoSsr__);
/* unused harmony reexport NoSsr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__OutlinedInput__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__OutlinedInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__OutlinedInput__);
/* unused harmony reexport OutlinedInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__Paper__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__Paper__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_70__Paper___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__Popover__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__Popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__Popover__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_71__Popover___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__Popper__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__Popper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__Popper__);
/* unused harmony reexport Popper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__Portal__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__Portal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__Portal__);
/* unused harmony reexport Portal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__Radio__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__Radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__Radio__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_74__Radio___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__RadioGroup__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__RadioGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__RadioGroup__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_75__RadioGroup___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__RootRef__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__RootRef___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76__RootRef__);
/* unused harmony reexport RootRef */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__Select__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77__Select__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_77__Select___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__Slide__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__Slide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__Slide__);
/* unused harmony reexport Slide */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__Snackbar__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__Snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79__Snackbar__);
/* unused harmony reexport Snackbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__SnackbarContent__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__SnackbarContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80__SnackbarContent__);
/* unused harmony reexport SnackbarContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__Step__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__Step___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81__Step__);
/* unused harmony reexport Step */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__StepButton__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__StepButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82__StepButton__);
/* unused harmony reexport StepButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__StepConnector__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__StepConnector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83__StepConnector__);
/* unused harmony reexport StepConnector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__StepContent__ = __webpack_require__(1056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__StepContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84__StepContent__);
/* unused harmony reexport StepContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__StepIcon__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__StepIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85__StepIcon__);
/* unused harmony reexport StepIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__StepLabel__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__StepLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86__StepLabel__);
/* unused harmony reexport StepLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__Stepper__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__Stepper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87__Stepper__);
/* unused harmony reexport Stepper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__SvgIcon__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__SvgIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88__SvgIcon__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_88__SvgIcon___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__SwipeableDrawer__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__SwipeableDrawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89__SwipeableDrawer__);
/* unused harmony reexport SwipeableDrawer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__Switch__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__Switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90__Switch__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_90__Switch___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__Tab__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91__Tab__);
/* unused harmony reexport Tab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__Table__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92__Table__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_92__Table___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__TableBody__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__TableBody___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_93__TableBody__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_93__TableBody___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__TableCell__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__TableCell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94__TableCell__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_94__TableCell___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__TableFooter__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__TableFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_95__TableFooter__);
/* unused harmony reexport TableFooter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__TableHead__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__TableHead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_96__TableHead__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_96__TableHead___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__TablePagination__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__TablePagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_97__TablePagination__);
/* unused harmony reexport TablePagination */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__TableRow__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__TableRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_98__TableRow__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_98__TableRow___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__TableSortLabel__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__TableSortLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_99__TableSortLabel__);
/* unused harmony reexport TableSortLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__Tabs__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_100__Tabs__);
/* unused harmony reexport Tabs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__TextField__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_101__TextField__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_101__TextField___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__Toolbar__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_102__Toolbar__);
/* unused harmony reexport Toolbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__Tooltip__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_103__Tooltip__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_103__Tooltip___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__Typography__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_104__Typography__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_104__Typography___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__withMobileDialog__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__withMobileDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_105__withMobileDialog__);
/* unused harmony reexport withMobileDialog */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__withWidth__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__withWidth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_106__withWidth__);
/* unused harmony reexport withWidth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__Zoom__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__Zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_107__Zoom__);
/* unused harmony reexport Zoom */
/** @license Material-UI v3.9.2
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */















































































































/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.capitalize = capitalize;
exports.contains = contains;
exports.findIndex = findIndex;
exports.find = find;
exports.createChainedFunction = createChainedFunction;

var _typeof2 = _interopRequireDefault(__webpack_require__(117));

var _warning = _interopRequireDefault(__webpack_require__(27));

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word a the sentence.
// We only handle the first word.
function capitalize(string) {
  if (false) {
    throw new Error('Material-UI: capitalize(string) expects a string argument.');
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

function contains(obj, pred) {
  return Object.keys(pred).every(function (key) {
    return obj.hasOwnProperty(key) && obj[key] === pred[key];
  });
}

function findIndex(arr, pred) {
  var predType = (0, _typeof2.default)(pred);

  for (var i = 0; i < arr.length; i += 1) {
    if (predType === 'function' && !!pred(arr[i], i, arr) === true) {
      return i;
    }

    if (predType === 'object' && contains(arr[i], pred)) {
      return i;
    }

    if (['string', 'number', 'boolean'].indexOf(predType) !== -1) {
      return arr.indexOf(pred);
    }
  }

  return -1;
}

function find(arr, pred) {
  var index = findIndex(arr, pred);
  return index > -1 ? arr[index] : undefined;
}
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */


function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (acc, func) {
    if (func == null) {
      return acc;
    }

     false ? (0, _warning.default)(typeof func === 'function', 'Material-UI: invalid Argument Type, must only provide functions, undefined, or null.') : void 0;
    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function () {});
}

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(33);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__baseerror__ = __webpack_require__(189);
var AppError=/*#__PURE__*/function(_BaseError){__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(AppError,_BaseError);function AppError(_ref){var _this;var message=_ref.message,errorId=_ref.errorId,_ref$name=_ref.name,name=_ref$name===void 0?'AppError':_ref$name,_ref$tag=_ref.tag,tag=_ref$tag===void 0?'':_ref$tag,originalError=_ref.originalError,errorDetails=_ref.errorDetails,details=_ref.details,visualisers=_ref.visualisers,messageType=_ref.messageType,keepOriginalError=_ref.keepOriginalError;__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,AppError);_this=__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_getPrototypeOf___default()(AppError).call(this,{message:message,errorId:errorId,name:name,tag:tag,errorDetails:errorDetails,details:details,visualisers:visualisers,messageType:messageType,keepOriginalError:keepOriginalError}));Object.setPrototypeOf(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this),AppError.prototype);if('captureStackTrace'in Error){Error.captureStackTrace(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_assertThisInitialized___default()(_this),_this.constructor);}originalError&&_this.processOriginalError(originalError);return _this;}return AppError;}(__WEBPACK_IMPORTED_MODULE_5__baseerror__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (AppError);

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(167)('wks');
var uid = __webpack_require__(108);
var Symbol = __webpack_require__(30).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Button.default;
  }
});

var _Button = _interopRequireDefault(__webpack_require__(404));

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(77);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setTrackingId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return identify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return track; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return trackEcommerceData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return trackConfiguratorQuantity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return trackReducedUsersData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getTrackingOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__errors_apperror__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger_logger__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_subscription__ = __webpack_require__(46);
var log=__WEBPACK_IMPORTED_MODULE_2__logger_logger__["a" /* default */].get('segment');var xaraTrackingId;var sendToAnalyticsAndAmplitudeOptions={integrations:{'All':false,'Google Analytics':true,'Google Analytics 4 Web':true,'Amplitude':true}};var sendToGA4Options={integrations:{'All':false,'Google Analytics 4 Web':true}};var excludeAmplitudeOptions={integrations:{'All':true,'Amplitude':false}};var allDestinationsOptions={integrations:{'All':true}};var setTrackingId=function setTrackingId(trackingId){xaraTrackingId=trackingId;};var identify=function identify(attributes,options){// eslint-disable-line
if(!__WEBPACK_IMPORTED_MODULE_0__config__["_28" /* SEGMENT */])return;if(xaraTrackingId){try{window.analytics.identify(xaraTrackingId,attributes,options);}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_1__errors_apperror__["a" /* default */]({message:'Segment.identify() failed',errorId:__WEBPACK_IMPORTED_MODULE_3__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'SEGMENT'}}));console.error('Couldn\'t identify event to Segment',event,data);// eslint-disable-line
}}else{log.send(new __WEBPACK_IMPORTED_MODULE_1__errors_apperror__["a" /* default */]({message:'xaraTrackingId not found',errorId:__WEBPACK_IMPORTED_MODULE_3__errors_errorids__["a" /* default */].UNKNOWN,visualisers:{feature:'SEGMENT'}}));console.error('Missing Xara tracking id');// eslint-disable-line
}};var track=function track(event,data,options){if(!__WEBPACK_IMPORTED_MODULE_0__config__["_28" /* SEGMENT */])return;try{window.analytics.track(event,data,options);// If event contains dash it will be rejected in GA4 property so send it with underscore again
if(event.indexOf('-')!==-1){window.analytics.track(event.replace(/-/g,'_'),data,sendToGA4Options);}}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_1__errors_apperror__["a" /* default */]({message:'Segment.track() failed',errorId:__WEBPACK_IMPORTED_MODULE_3__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'SEGMENT'}}));console.error('Couldn\'t track event to Segment',event,data);// eslint-disable-line
}};var trackEcommerceData=function trackEcommerceData(event,data){if(!__WEBPACK_IMPORTED_MODULE_0__config__["_28" /* SEGMENT */])return;try{window.analytics.track(event,data,sendToAnalyticsAndAmplitudeOptions);}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_1__errors_apperror__["a" /* default */]({message:'trackEcommerceDataFailed failed',errorId:__WEBPACK_IMPORTED_MODULE_3__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'SEGMENT'}}));console.error('Couldn\'t track event to Segment',event,data);// eslint-disable-line
}};var trackConfiguratorQuantity=function trackConfiguratorQuantity(quantityType,value,options){if(!__WEBPACK_IMPORTED_MODULE_0__config__["_28" /* SEGMENT */])return;try{var eventName="cap-change-quantity-".concat(quantityType,"-").concat(value);var trackDestination;if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(options,'integrations.Amplitude')===false){trackDestination=sendToGA4Options;}else{trackDestination=sendToAnalyticsAndAmplitudeOptions;}window.analytics.track(eventName,null,trackDestination);window.analytics.track(eventName.replace(/-/g,'_'),null,sendToGA4Options);}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_1__errors_apperror__["a" /* default */]({message:'trackConfiguratorQuantity failed',errorId:__WEBPACK_IMPORTED_MODULE_3__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'SEGMENT'}}));console.error('Couldn\'t track event to Segment',event,data);// eslint-disable-line
}};var trackReducedUsersData=function trackReducedUsersData(nrOfUsersToTurnToGuest,nrOfUsersToDelete,options){if(!__WEBPACK_IMPORTED_MODULE_0__config__["_28" /* SEGMENT */])return;try{var eventName="cap-reduced-users-".concat(nrOfUsersToTurnToGuest,"-to-guests-").concat(nrOfUsersToDelete,"-deleted");var trackDestination;if(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(options,'integrations.Amplitude')===false){trackDestination=sendToGA4Options;}else{trackDestination=sendToAnalyticsAndAmplitudeOptions;}window.analytics.track(eventName,null,trackDestination);window.analytics.track(eventName.replace(/-/g,'_'),null,sendToGA4Options);}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_1__errors_apperror__["a" /* default */]({message:'trackReducedUsersData failed',errorId:__WEBPACK_IMPORTED_MODULE_3__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'SEGMENT'}}));console.error('Couldn\'t track event to Segment',event,data);// eslint-disable-line
}};var getTrackingOptions=function getTrackingOptions(company){var isDesktopMagix=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(company,'marketingTags.desktop-magix');var isXaraDesktopOrigin=__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(company,'marketingTags.xara-desktop-origin');var _getSubscriptionsAndA=Object(__WEBPACK_IMPORTED_MODULE_5__utils_subscription__["i" /* getSubscriptionsAndAddons */])(company),perpetualAddons=_getSubscriptionsAndA.perpetualAddons;var activeDesktopSubscription=Object(__WEBPACK_IMPORTED_MODULE_5__utils_subscription__["o" /* hasDesktopSubscription */])(company);var hasPerpetualPlan=!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(perpetualAddons);var isDesktopCompanySelected=hasPerpetualPlan||activeDesktopSubscription||isDesktopMagix||isXaraDesktopOrigin;return isDesktopCompanySelected&&!company.hasUnlimitedTeamSubscription?excludeAmplitudeOptions:allDestinationsOptions;};

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return validateCompany; });
/* unused harmony export addCompany */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return updateCompany; });
/* unused harmony export selectCompanies */
/* unused harmony export changeCompany */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return changeCompanyAndNotify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addCompanyUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return sendInviteToUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return estimateCostOnAddCompanyUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return updateUserPhoto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return updateCompanyUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return estimateCostOnUpdateCompanyUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return deleteCompanyUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return estimateCostOnDeleteCompanyUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return updateUserExternalId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return clearExternalIdState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return connectCompanySocketEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return fetchCompaniesIndustries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return fetchCompaniesSizes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return fetchCompaniesCountries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return fetchUserRegion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return createChargeBeeSession; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return createChargeBeeSubscription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getActiveCompanyId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return resolveActiveCompanyId; });
/* unused harmony export getValidCompanyIdFromStorage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addCompanyFont; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return removeCompanyFont; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return updateSmartFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return sendEmailNotification; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return writeCompanySettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return inviteUserUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return inviteUserAdd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return inviteUserRemove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return inviteUserSetMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return inviteUsersClearUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return inviteUsersClearMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return updatePendingReduceUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return batchReduceUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return estimateCostOnAddUserSeats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return purchaseSeats; });
/* unused harmony export fetchAddonDetails */
/* unused harmony export fetchCurrentMemberAddonDetails */
/* unused harmony export clearMemberaddonDetails */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getUpcomingInvoiceEstimate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return showRateLimitError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return showErrorPopup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return showPackageDiscontinuedMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getSubscriptionEstimation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return sendContactSalesRequest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_modules_quickMessages__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__errors_apperror__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__errors_httperror__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__storage__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__redux_store__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux_modules_discount__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_url__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_users__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_subscription__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_i18n_i18n__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lib_StaticResource__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__logger_logger__ = __webpack_require__(40);
var _this=this;var log=__WEBPACK_IMPORTED_MODULE_20__logger_logger__["a" /* default */].get('redux-companies');var localize=__WEBPACK_IMPORTED_MODULE_18_i18n_i18n__["a" /* default */].loc.localize;var initialState={byId:null,// {}
rawDataById:null,// {}
allIds:null,// []
selectedId:undefined,// ''
valid:true,loading:false,companyIsUpdating:false,companyUpdatingErrorId:null,pendingPayingUserQuantity:0,addonsDetails:{},// addon details related to paymentAccount of active/inactive subscription
currentMemberAddonDetails:null,upcomingInvoiceEstimation:null,upcomingInvoiceEstimationXhrInProgress:false,subscriptionEstimation:null,subscriptionEstimationActivePlan:null,pendingReduceUsers:[],userRegion:null,sizes:[],industries:[],countries:[],inviteUsers:[],inviteUsersMessage:null,addCompanyUsersErrorId:null,estimateCostOnAddCompanyUsersErrorId:null,estimateCostOnAddUserSeatsErrorId:null,createChargeBeeSubscriptionErrorId:null,createChargeBeeSubscriptionSuccess:null,batchReduceUsersSuccess:null,batchReduceUsersErrorId:null,purchaseSeatsSuccess:null,purchaseSeatsErrorId:null,fetchAddonDetailsErrorId:null,fetchAddonDetailsSuccess:null,getUpcomingInvoiceEstimateErorId:null,getUpcomingInvoiceSuccess:null,getSubscriptionEstimateXhrInProgress:false,getSubscriptionEstimateUrl:null,getSubscriptionEstimateForPlan:null,getSubscriptionEstimateErrorId:null,getSubscriptionEstimateSuccess:null,getSubscriptionEstimateActivePlanXhrInProgress:false,getSubscriptionEstimateActivePlanErrorId:null,getSubscriptionEstimateActivePlanSuccess:null,fetchCurrentMemberAddonDetailsXhrInProgress:false,fetchCurrentMemberAddonDetailsErrorId:null,fetchCurrentMemberAddonDetailsSuccess:null,contactSalesSuccess:null,contactSalesErrorId:null,contactSalesXhrInProgress:false,updatingExternalIdXhrInProgress:[],updatingExternalIdErrorId:[],updatingExternalIdSuccess:[],updatingUserPhotoInProgress:[],updatingUserPhotoErrorId:[],updatingUserPhotoSuccess:[]};function getUserRole(company,userEmail){var companyUser=company.users.filter(function(u){return u.email===userEmail;});if(companyUser.length){return companyUser[0].role;}}/**
 * Check if the current company has active trial or any paid plan
 *
 * @param { object } { trial, paymentAccount }
 * @returns { bool }
 */function isCompanyActive(company){var _getSubscriptionsAndA=Object(__WEBPACK_IMPORTED_MODULE_17__utils_subscription__["i" /* getSubscriptionsAndAddons */])(company),subscription=_getSubscriptionsAndA.subscription,perpetualAddons=_getSubscriptionsAndA.perpetualAddons;var hasActiveTrial=company.trial&&company.trial.endDate>Date.now();var hasActivePlan=!__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.isEmpty(subscription)||!__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.isEmpty(perpetualAddons);return Boolean(hasActiveTrial||hasActivePlan);}function hasTrial(_ref){var trial=_ref.trial;return trial&&trial.startDate<=Date.now()&&trial.endDate>Date.now();}function getTrialDays(_ref2){var trial=_ref2.trial;if(!hasTrial({trial:trial})){return;}var ONE_DAY=1000*60*60*24;var days=trial.endDate-Date.now();return days<=0?0:Math.ceil(days/ONE_DAY);}var getCompany=function getCompany(company,userEmail){var id=company._id,workspaces=company.workspaces;var _getSubscriptionsAndA2=Object(__WEBPACK_IMPORTED_MODULE_17__utils_subscription__["i" /* getSubscriptionsAndAddons */])(company,true),subscription=_getSubscriptionsAndA2.subscription,perpetualAddons=_getSubscriptionsAndA2.perpetualAddons,memberAddons=_getSubscriptionsAndA2.memberAddons;var userRole=getUserRole(company,userEmail);return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({id:id},company,{isActive:isCompanyActive(company),subscription:subscription,perpetualAddons:perpetualAddons,memberAddons:memberAddons,hasActiveSubscription:subscription&&subscription.active,hasTrial:subscription&&subscription.active?null:hasTrial(company),trialDays:getTrialDays(company),email:company.email||'',address1:company.address1||'',address2:company.address2||'',city:company.city||'',region:company.region||'',postcode:company.postcode||'',country:company.country||'',phone:company.phone||'',website:company.website||'',industry:company.industry||null,industryId:company.industryId||'',size:company.size||'',workspaces:workspaces.map(function(workspace){return workspace._id;}),userRole:userRole,userIsAdmin:userRole===__WEBPACK_IMPORTED_MODULE_14__config__["_54" /* USER_ROLE_ADMIN */],userIsGuest:userRole===__WEBPACK_IMPORTED_MODULE_14__config__["_56" /* USER_ROLE_GUEST */],_id:undefined,companySettingsUpdateSuccess:null});};var initializeFromSession=function initializeFromSession(state,session){var byId={};var rawDataById={};var allIds=[];var companies=session.companies,user=session.user;var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=companies[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var company=_step.value;var _getCompany=getCompany(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},company),user.mainEmail),id=_getCompany.id,props=__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(_getCompany,["id"]);if([__WEBPACK_IMPORTED_MODULE_14__config__["_54" /* USER_ROLE_ADMIN */],__WEBPACK_IMPORTED_MODULE_14__config__["_55" /* USER_ROLE_BASIC */]].indexOf(props.userRole)>-1){allIds.push(id);byId[id]=__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({id:id},props);}rawDataById[id]=__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({id:id},props);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator["return"]!=null){_iterator["return"]();}}finally{if(_didIteratorError){throw _iteratorError;}}}return{byId:byId,allIds:allIds,rawDataById:rawDataById};};var updateReducedUsers=function updateReducedUsers(reduceUsersState,email,userId,externalIds,action){if(action===__WEBPACK_IMPORTED_MODULE_14__config__["_27" /* REDUCE_ACTION */].KEEP_ROLE){return reduceUsersState.filter(function(user){return user.email!==email;});}else if([__WEBPACK_IMPORTED_MODULE_14__config__["_27" /* REDUCE_ACTION */].CHANGE_TO_GUEST,__WEBPACK_IMPORTED_MODULE_14__config__["_27" /* REDUCE_ACTION */].REMOVE].includes(action)){var userExistsInReduceUsersArray=reduceUsersState.find(function(user){return user.email===email;});if(userExistsInReduceUsersArray){return reduceUsersState.map(function(user){if(user.email===email){return{email:email,action:action,userId:userId,externalIds:externalIds};}else{return user;}});}else{var newReduceUsersState=__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.clone(reduceUsersState);newReduceUsersState.push({email:email,action:action,userId:userId,externalIds:externalIds});return newReduceUsersState;}}};/* harmony default export */ __webpack_exports__["i"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1?arguments[1]:undefined;switch(action.type){case __WEBPACK_IMPORTED_MODULE_4__actions__["_3" /* COMPANIES_GET_ACTIVE_COMPANY_ID */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{selectedId:action.payload});case __WEBPACK_IMPORTED_MODULE_4__actions__["_153" /* SESSION_FETCH_SUCCESS */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,initializeFromSession(state,action.result));case __WEBPACK_IMPORTED_MODULE_4__actions__["Q" /* COMPANIES_ESTIMATE_USER_ADD */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{estimateCostOnAddCompanyUsersErrorId:null,loading:true});case __WEBPACK_IMPORTED_MODULE_4__actions__["R" /* COMPANIES_ESTIMATE_USER_ADD_FAIL */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{estimateCostOnAddCompanyUsersErrorId:__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(action,'error.errorId'),loading:false});case __WEBPACK_IMPORTED_MODULE_4__actions__["N" /* COMPANIES_ESTIMATE_SEAT */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{estimateCostOnAddUserSeatsErrorId:null,loading:true});case __WEBPACK_IMPORTED_MODULE_4__actions__["O" /* COMPANIES_ESTIMATE_SEAT_FAIL */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{estimateCostOnAddUserSeatsErrorId:__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(action,'error.errorId'),loading:false});case __WEBPACK_IMPORTED_MODULE_4__actions__["_4" /* COMPANIES_GET_CURRENT_MEMBER_ADDON_DETAILS */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{fetchCurrentMemberAddonDetailsErrorId:null,fetchCurrentMemberAddonDetailsXhrInProgress:true,loading:true});case __WEBPACK_IMPORTED_MODULE_4__actions__["_5" /* COMPANIES_GET_CURRENT_MEMBER_ADDON_DETAILS_FAIL */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{fetchCurrentMemberAddonDetailsErrorId:__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(action,'error.errorId'),fetchCurrentMemberAddonDetailsXhrInProgress:false,loading:false});case __WEBPACK_IMPORTED_MODULE_4__actions__["_16" /* COMPANIES_PURCHASE_SEAT */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{purchaseSeatsErrorId:null,purchaseSeatsSuccess:null,loading:true});case __WEBPACK_IMPORTED_MODULE_4__actions__["_17" /* COMPANIES_PURCHASE_SEAT_FAIL */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{purchaseSeatsErrorId:__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(action,'error.errorId'),loading:false});case __WEBPACK_IMPORTED_MODULE_4__actions__["p" /* ADDON_GET_DETAILS */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{fetchAddonDetailsErrorId:null,fetchAddonDetailsSuccess:null,loading:true});case __WEBPACK_IMPORTED_MODULE_4__actions__["q" /* ADDON_GET_DETAILS_FAIL */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{fetchAddonDetailsErrorId:__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(action,'error.errorId'),loading:false});case __WEBPACK_IMPORTED_MODULE_4__actions__["_174" /* UPCOMING_INVOICE_GET_ESTIMATE */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{getUpcomingInvoiceErorId:null,getUpcomingInvoiceSuccess:null,loading:true,upcomingInvoiceEstimationXhrInProgress:true});case __WEBPACK_IMPORTED_MODULE_4__actions__["_175" /* UPCOMING_INVOICE_GET_ESTIMATE_FAIL */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{getUpcomingInvoiceErorId:__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(action,'error.errorId'),loading:false,upcomingInvoiceEstimationXhrInProgress:false});case __WEBPACK_IMPORTED_MODULE_4__actions__["B" /* COMPANIES_CONTACT_SALES */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{contactSalesSuccess:null,contactSalesErrorId:null,contactSalesXhrInProgress:true,loading:true});case __WEBPACK_IMPORTED_MODULE_4__actions__["C" /* COMPANIES_CONTACT_SALES_FAIL */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{contactSalesErrorId:__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(action,'error.errorId'),contactSalesXhrInProgress:false,loading:false});case __WEBPACK_IMPORTED_MODULE_4__actions__["_165" /* SUBSCRIPTION_GET_ESTIMATE_ACTIVE_PLAN */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{getSubscriptionEstimateActivePlanErrorId:null,getSubscriptionEstimateActivePlanSuccess:null,getSubscriptionEstimateActivePlanXhrInProgress:true,loading:true});case __WEBPACK_IMPORTED_MODULE_4__actions__["_166" /* SUBSCRIPTION_GET_ESTIMATE_ACTIVE_PLAN_FAIL */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{getSubscriptionEstimateActivePlanErrorId:__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(action,'error.errorId'),getSubscriptionEstimateActivePlanXhrInProgress:false,loading:false});case __WEBPACK_IMPORTED_MODULE_4__actions__["_164" /* SUBSCRIPTION_GET_ESTIMATE */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{getSubscriptionEstimateErrorId:null,getSubscriptionEstimateSuccess:null,getSubscriptionEstimateXhrInProgress:true,getSubscriptionEstimateUrl:action.payload.requestUrl,getSubscriptionEstimateForPlan:action.payload.currentPlanId,loading:true});case __WEBPACK_IMPORTED_MODULE_4__actions__["_168" /* SUBSCRIPTION_GET_ESTIMATE_FAIL */]:{return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{getSubscriptionEstimateErrorId:__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(action,'error.errorId'),getSubscriptionEstimateXhrInProgress:false,getSubscriptionEstimateUrl:null,getSubscriptionEstimateForPlan:null,loading:false});}case __WEBPACK_IMPORTED_MODULE_4__actions__["_74" /* DISCOUNT_CLEAR_APPLIED */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{getSubscriptionEstimateUrl:null,loading:false});case __WEBPACK_IMPORTED_MODULE_4__actions__["_41" /* COMPANIES_USER_ADD */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{addCompanyUsersErrorId:null,loading:true},action.payload.hasPlan&&action.payload.targetUsersPayingQuantity&&{pendingPayingUserQuantity:action.payload.targetUsersPayingQuantity});case __WEBPACK_IMPORTED_MODULE_4__actions__["K" /* COMPANIES_CREATE_CHARGEBEE_SUBSCRIPTION */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{createChargeBeeSubscriptionErrorId:null,createChargeBeeSubscriptionSuccess:null,loading:true});case __WEBPACK_IMPORTED_MODULE_4__actions__["_40" /* COMPANIES_USERS_REDUCE_SUCCESS */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{loading:false,batchReduceUsersSuccess:true,// clear state saved in Reduce users popup
pendingReduceUsers:[]});case __WEBPACK_IMPORTED_MODULE_4__actions__["_38" /* COMPANIES_USERS_REDUCE */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{batchReduceUsersErrorId:null,batchReduceUsersSuccess:null,loading:true});case __WEBPACK_IMPORTED_MODULE_4__actions__["_44" /* COMPANIES_USER_DELETE */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["_47" /* COMPANIES_USER_UPDATE */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["_50" /* COMPANIES_VALIDATE */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["s" /* COMPANIES_ADD */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["W" /* COMPANIES_ESTIMATE_USER_UPDATE */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["T" /* COMPANIES_ESTIMATE_USER_DELETE */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["H" /* COMPANIES_CREATE_CHARGEBEE_SESSION */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["_7" /* COMPANIES_INDUSTRIES_FETCH */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["_27" /* COMPANIES_SIZES_FETCH */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["E" /* COMPANIES_COUNTRIES_FETCH */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["_183" /* USER_REGION_FETCH */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["Z" /* COMPANIES_FONT_ADD */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["_1" /* COMPANIES_FONT_REMOVE */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["_148" /* SEND_EMAIL */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{loading:true});case __WEBPACK_IMPORTED_MODULE_4__actions__["_32" /* COMPANIES_UPDATE */]:{return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{companyUpdatingErrorId:null,companyIsUpdating:true});}case __WEBPACK_IMPORTED_MODULE_4__actions__["_34" /* COMPANIES_UPDATE_SUCCESS */]:{var _action$payload=action.payload,companyId=_action$payload.companyId,data=_action$payload.data;var updatedPayingUserQuantity=0;var subscriptionPlan=null;if(state.byId){var _getSubscriptionsAndA3=Object(__WEBPACK_IMPORTED_MODULE_17__utils_subscription__["i" /* getSubscriptionsAndAddons */])(state.byId[state.selectedId]),subscription=_getSubscriptionsAndA3.subscription,memberAddons=_getSubscriptionsAndA3.memberAddons;if(!__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.isEmpty(memberAddons)){memberAddons.forEach(function(addon){updatedPayingUserQuantity+=addon.paidQuantity;});}if(!__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.isEmpty(subscription)){var _convertPlanIdIntoSub=Object(__WEBPACK_IMPORTED_MODULE_17__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(subscription.planId);subscriptionPlan=_convertPlanIdIntoSub.plan;}}var shouldDeletePendingState;if(subscriptionPlan&&state.pendingPayingUserQuantity&&state.pendingPayingUserQuantity<=updatedPayingUserQuantity+__WEBPACK_IMPORTED_MODULE_14__config__["_3" /* PACKAGES_CONFIG */][subscriptionPlan].freeSeatsIncluded){shouldDeletePendingState=true;}// Preserve user's profile photo and external ids when doing the merge
if(!__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.isEmpty(state.byId[companyId])){var existingUsers=state.byId[companyId].users;data.users.forEach(function(user,index,theArray){var oldUser=existingUsers.find(function(u){return u.email===user.email;});theArray[index].profilePhotoUri=user.profilePhotoUri||__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(oldUser,'profilePhotoUri');theArray[index].externalIds=user.externalIds||__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(oldUser,'externalIds');theArray[index].lastSessionTime=user.lastSessionTime||__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(oldUser,'lastSessionTime');theArray[index].inviteCounter=user.inviteCounter||__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(oldUser,'inviteCounter');});}return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,shouldDeletePendingState&&{pendingPayingUserQuantity:null},{byId:__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.byId,__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({},companyId,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.byId[companyId],data))),rawDataById:__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.rawDataById,__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({},companyId,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.rawDataById[companyId],data))),companyIsUpdating:false});}case __WEBPACK_IMPORTED_MODULE_4__actions__["M" /* COMPANIES_CREATE_CHARGEBEE_SUBSCRIPTION_SUCCESS */]:{return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{paymentRedirectUrl:action.result['paymentRedirectUrl'],createChargeBeeSubscriptionErrorId:false,createChargeBeeSubscriptionSuccess:true,loading:false});}case __WEBPACK_IMPORTED_MODULE_4__actions__["L" /* COMPANIES_CREATE_CHARGEBEE_SUBSCRIPTION_FAIL */]:{return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{paymentRedirectUrl:action.result['paymentRedirectUrl'],createChargeBeeSubscriptionErrorId:__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(action,'error.errorId'),createChargeBeeSubscriptionSuccess:false,loading:false});}case __WEBPACK_IMPORTED_MODULE_4__actions__["J" /* COMPANIES_CREATE_CHARGEBEE_SESSION_SUCCESS */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["I" /* COMPANIES_CREATE_CHARGEBEE_SESSION_FAIL */]:{var portal_session=action.result.portal_session;return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{portal_session:portal_session,loading:false});}case __WEBPACK_IMPORTED_MODULE_4__actions__["_33" /* COMPANIES_UPDATE_FAIL */]:{return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{companyIsUpdating:false,companyUpdatingErrorId:__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(action,'error.errorId'),loading:false});}case __WEBPACK_IMPORTED_MODULE_4__actions__["_52" /* COMPANIES_VALIDATE_SUCCESS */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{loading:false,valid:true});case __WEBPACK_IMPORTED_MODULE_4__actions__["_51" /* COMPANIES_VALIDATE_FAIL */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{loading:false,valid:false});case __WEBPACK_IMPORTED_MODULE_4__actions__["u" /* COMPANIES_ADD_SUCCESS */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{allIds:[].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.allIds),[action.result._id]),byId:__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.byId,__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({},action.result._id,getCompany(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},action.result),action.result.email))),rawDataById:__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.rawDataById,__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({},action.result._id,getCompany(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},action.result),action.result.email))),selectedId:action.result._id,loading:false});case __WEBPACK_IMPORTED_MODULE_4__actions__["_19" /* COMPANIES_REMOVE_SUCCESS */]:{var _companyId=action.result;var index=Object(__WEBPACK_IMPORTED_MODULE_13_lodash__["findIndex"])(state.allIds,function(id){return id===_companyId;});var selectedId=state.allIds[index-1]||state.allIds[index+1];return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{allIds:state.allIds.filter(function(id){return id!==_companyId;}),byId:Object(__WEBPACK_IMPORTED_MODULE_13_lodash__["omit"])(state.byId,_companyId),rawDataById:Object(__WEBPACK_IMPORTED_MODULE_13_lodash__["omit"])(state.rawDataById,_companyId),selectedId:selectedId});}case __WEBPACK_IMPORTED_MODULE_4__actions__["_42" /* COMPANIES_USER_ADD_FAIL */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{addCompanyUsersErrorId:__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(action,'error.errorId'),loading:false,pendingPayingUserQuantity:0});case __WEBPACK_IMPORTED_MODULE_4__actions__["_39" /* COMPANIES_USERS_REDUCE_FAIL */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{loading:false,batchReduceUsersErrorId:__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(action,'error.errorId')});case __WEBPACK_IMPORTED_MODULE_4__actions__["_48" /* COMPANIES_USER_UPDATE_FAIL */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["_45" /* COMPANIES_USER_DELETE_FAIL */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["t" /* COMPANIES_ADD_FAIL */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["_0" /* COMPANIES_FONT_ADD_FAIL */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["_2" /* COMPANIES_FONT_REMOVE_FAIL */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["_43" /* COMPANIES_USER_ADD_SUCCESS */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["_49" /* COMPANIES_USER_UPDATE_SUCCESS */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["_145" /* REQUEST_FINISHED */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["_150" /* SEND_EMAIL_SUCCESS */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["_149" /* SEND_EMAIL_FAIL */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{loading:false});case __WEBPACK_IMPORTED_MODULE_4__actions__["_46" /* COMPANIES_USER_DELETE_SUCCESS */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{byId:__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.byId,__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({},state.selectedId,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.byId[state.selectedId],{users:state.byId[state.selectedId].users.filter(function(user){return user.email!==action.payload.email;})}))),rawDataById:__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.rawDataById,__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({},state.selectedId,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.rawDataById[state.selectedId],{users:state.rawDataById[state.selectedId].users.filter(function(user){return user.email!==action.payload.email;})}))),loading:false});case __WEBPACK_IMPORTED_MODULE_4__actions__["_179" /* USER_EXTERNAL_ID_UPDATE */]:{return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{updatingExternalIdXhrInProgress:[].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.updatingExternalIdXhrInProgress),[action.payload.userId]),updatingExternalIdErrorId:state.updatingExternalIdErrorId.filter(function(user){return user.userId!==action.payload.userId;}),updatingExternalIdSuccess:state.updatingExternalIdSuccess.filter(function(userId){return userId!==action.payload.userId;})});}case __WEBPACK_IMPORTED_MODULE_4__actions__["_180" /* USER_EXTERNAL_ID_UPDATE_FAIL */]:{return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{updatingExternalIdErrorId:[].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.updatingExternalIdErrorId),[{userId:action.payload.userId,errorId:__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(action,'error.errorId')}]),updatingExternalIdXhrInProgress:state.updatingExternalIdXhrInProgress.filter(function(userId){return userId!==action.payload.userId;})});}case __WEBPACK_IMPORTED_MODULE_4__actions__["_178" /* USER_EXTERNAL_ID_STATE_CLEAR */]:{return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{updatingExternalIdXhrInProgress:[],updatingExternalIdErrorId:[],updatingExternalIdSuccess:[]});}case __WEBPACK_IMPORTED_MODULE_4__actions__["_181" /* USER_EXTERNAL_ID_UPDATE_SUCCESS */]:{return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{updatingExternalIdSuccess:[].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.updatingExternalIdSuccess),[action.payload.userId]),updatingExternalIdXhrInProgress:state.updatingExternalIdXhrInProgress.filter(function(userId){return userId!==action.payload.userId;}),byId:__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.byId,__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({},state.selectedId,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.byId[state.selectedId],{users:state.byId[state.selectedId].users.map(function(user){return user.userId===action.payload.userId?__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},user,{externalIds:action.payload.externalIds}):__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},user);})}))),rawDataById:__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.rawDataById,__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({},state.selectedId,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.rawDataById[state.selectedId],{users:state.rawDataById[state.selectedId].users.map(function(user){return user.userId===action.payload.userId?__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},user,{externalIds:action.payload.externalIds}):__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},user);})}))),loading:false});}case __WEBPACK_IMPORTED_MODULE_4__actions__["_35" /* COMPANIES_UPDATE_USER_PHOTO */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{updatingUserPhotoInProgress:[].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.updatingUserPhotoInProgress),[action.payload.userId]),updatingUserPhotoErrorId:state.updatingUserPhotoErrorId.filter(function(user){return user.userId!==action.payload.userId;}),updatingUserPhotoSuccess:state.updatingUserPhotoSuccess.filter(function(userId){return userId!==action.payload.userId;})});case __WEBPACK_IMPORTED_MODULE_4__actions__["_36" /* COMPANIES_UPDATE_USER_PHOTO_FAIL */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{updatingUserPhotoErrorId:[].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.updatingUserPhotoErrorId),[{userId:action.payload.userId,errorId:__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(action,'error.errorId')}]),updatingUserPhotoInProgress:state.updatingUserPhotoInProgress.filter(function(userId){return userId!==action.payload.userId;})});case __WEBPACK_IMPORTED_MODULE_4__actions__["_37" /* COMPANIES_UPDATE_USER_PHOTO_SUCCESS */]:{return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{updatingUserPhotoSuccess:[].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.updatingUserPhotoSuccess),[action.payload.userId]),updatingUserPhotoInProgress:state.updatingUserPhotoInProgress.filter(function(userId){return userId!==action.payload.userId;}),byId:__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.byId,__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({},state.selectedId,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.byId[state.selectedId],{users:state.byId[state.selectedId].users.map(function(user){return user.userId===action.payload.userId?__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},user,{profilePhotoUri:action.result.profilePhotoThumbnailsURLs?action.result.profilePhotoThumbnailsURLs.original:undefined}):__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},user);})}))),rawDataById:__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.rawDataById,__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({},state.selectedId,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.rawDataById[state.selectedId],{users:state.rawDataById[state.selectedId].users.map(function(user){return user.userId===action.payload.userId?__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},user,{profilePhotoUri:action.result.profilePhotoThumbnailsURLs?action.result.profilePhotoThumbnailsURLs.original:undefined}):__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},user);})}))),loading:false});}case __WEBPACK_IMPORTED_MODULE_4__actions__["v" /* COMPANIES_CHANGE */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{selectedId:action.result.company&&action.result.company.id});case __WEBPACK_IMPORTED_MODULE_4__actions__["_198" /* WORKSPACE_ADD_SUCCESS */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{byId:__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.byId,__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({},state.selectedId,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.byId[state.selectedId],{workspaces:[].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.byId[state.selectedId].workspaces),[action.result._id])}))),rawDataById:__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.rawDataById,__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({},state.selectedId,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.rawDataById[state.selectedId],{workspaces:[].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.rawDataById[state.selectedId].workspaces),[action.result._id])})))});case __WEBPACK_IMPORTED_MODULE_4__actions__["_201" /* WORKSPACE_DELETE_SUCCESS */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{byId:__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.byId,__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({},state.selectedId,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.byId[state.selectedId],{workspaces:state.byId[state.selectedId].workspaces.filter(function(id){return id!==action.result;})}))),rawDataById:__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.rawDataById,__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({},state.selectedId,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.rawDataById[state.selectedId],{workspaces:state.rawDataById[state.selectedId].workspaces.filter(function(id){return id!==action.result;})})))});case __WEBPACK_IMPORTED_MODULE_4__actions__["_9" /* COMPANIES_INDUSTRIES_FETCH_SUCCESS */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{industries:action.result,loading:false});case __WEBPACK_IMPORTED_MODULE_4__actions__["_29" /* COMPANIES_SIZES_FETCH_SUCCESS */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{sizes:action.result,loading:false});case __WEBPACK_IMPORTED_MODULE_4__actions__["_185" /* USER_REGION_FETCH_SUCCESS */]:{if(window.location.href.indexOf('user-region')!==-1){return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{userRegion:window.location.href.split('?')[1].replace('user-region=','').toUpperCase(),loading:false});}else{return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{userRegion:action.result.country.toUpperCase(),loading:false});}}case __WEBPACK_IMPORTED_MODULE_4__actions__["_184" /* USER_REGION_FETCH_FAIL */]:{var hostName=window.location.hostname;if(window.location.href.indexOf('user-region')!==-1){return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{userRegion:window.location.href.split('?')[1].replace('user-region=','').toUpperCase(),loading:false});}else{if(hostName.indexOf('localhost')!==-1||hostName.indexOf('staging')!==-1){var demoCountryCodes=['CA','US','GB','DE'];var randomCountryCode=demoCountryCodes[Math.floor(Math.random()*demoCountryCodes.length)];return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{userRegion:randomCountryCode,loading:false});}else{return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{userRegion:false,loading:false});}}}case __WEBPACK_IMPORTED_MODULE_4__actions__["G" /* COMPANIES_COUNTRIES_FETCH_SUCCESS */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{countries:action.result,loading:false});case __WEBPACK_IMPORTED_MODULE_4__actions__["P" /* COMPANIES_ESTIMATE_SEAT_SUCCESS */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["S" /* COMPANIES_ESTIMATE_USER_ADD_SUCCESS */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["Y" /* COMPANIES_ESTIMATE_USER_UPDATE_SUCCESS */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["V" /* COMPANIES_ESTIMATE_USER_DELETE_SUCCESS */]:{return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{loading:false});}case __WEBPACK_IMPORTED_MODULE_4__actions__["_18" /* COMPANIES_PURCHASE_SEAT_SUCCESS */]:{return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{loading:false,purchaseSeatsSuccess:true,pendingPayingUserQuantity:action.payload.targetUsersPayingQuantity});}case __WEBPACK_IMPORTED_MODULE_4__actions__["r" /* ADDON_GET_DETAILS_SUCCESS */]:{return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{loading:false,fetchAddonDetailsSuccess:true,addonsDetails:action.result});}case __WEBPACK_IMPORTED_MODULE_4__actions__["_6" /* COMPANIES_GET_CURRENT_MEMBER_ADDON_DETAILS_SUCCESS */]:{return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{loading:false,fetchCurrentMemberAddonDetailsSuccess:true,fetchCurrentMemberAddonDetailsXhrInProgress:false,// eslint-disable-next-line max-len
currentMemberAddonDetails:__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({},"".concat(Object(__WEBPACK_IMPORTED_MODULE_17__utils_subscription__["f" /* getNonObsoleteMemberAddonForPlan */])(action.payload.plan),"-").concat(action.payload.period,"-").concat(action.payload.currency),action.result)});}case __WEBPACK_IMPORTED_MODULE_4__actions__["x" /* COMPANIES_CLEAR_CURRENT_MEMBER_ADDON_DETAILS */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{currentMemberAddonDetails:null});case __WEBPACK_IMPORTED_MODULE_4__actions__["_176" /* UPCOMING_INVOICE_GET_ESTIMATE_SUCCESS */]:{return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{loading:false,getUpcomingInvoiceSuccess:true,upcomingInvoiceEstimation:action.result,upcomingInvoiceEstimationXhrInProgress:false});}case __WEBPACK_IMPORTED_MODULE_4__actions__["D" /* COMPANIES_CONTACT_SALES_SUCCESS */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{contactSalesErrorId:null,contactSalesSuccess:true,contactSalesXhrInProgress:false,loading:false});case __WEBPACK_IMPORTED_MODULE_4__actions__["_167" /* SUBSCRIPTION_GET_ESTIMATE_ACTIVE_PLAN_SUCCESS */]:{return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{loading:false,getSubscriptionEstimateActivePlanErrorId:null,getSubscriptionEstimateActivePlanSuccess:true,getSubscriptionEstimateActivePlanXhrInProgress:false,subscriptionEstimationActivePlan:__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},action.result)});}case __WEBPACK_IMPORTED_MODULE_4__actions__["_169" /* SUBSCRIPTION_GET_ESTIMATE_SUCCESS */]:{return state.getSubscriptionEstimateUrl===action.payload.requestUrl&&state.getSubscriptionEstimateForPlan===action.payload.currentPlanId?__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{loading:false,getSubscriptionEstimateErrorId:false,subscriptionEstimation:__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},action.result,action.payload.currentPlanId!=='all'&&__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(state.subscriptionEstimation,'['+action.payload.currentPlanId+']')&&__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({},action.payload.currentPlanId,state.subscriptionEstimation[action.payload.currentPlanId])),getSubscriptionEstimateXhrInProgress:false}):__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state);}case __WEBPACK_IMPORTED_MODULE_4__actions__["_24" /* COMPANIES_SETTING_WRITE */]:{var _companyId2=action.payload.companyId;return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{byId:__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.byId,__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({},_companyId2,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.byId[_companyId2],{companySettingsUpdateSuccess:null}))),rawDataById:__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.rawDataById,__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({},_companyId2,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.rawDataById[_companyId2],{companySettingsUpdateSuccess:null}))),loading:true});}case __WEBPACK_IMPORTED_MODULE_4__actions__["_26" /* COMPANIES_SETTING_WRITE_SUCCESS */]:{var _action$payload2=action.payload,newSettings=_action$payload2.newSettings,_companyId3=_action$payload2.companyId;return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{byId:__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.byId,__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({},_companyId3,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.byId[_companyId3],{companySettingsUpdateSuccess:true,companySettingsUpdatingErrorId:null,settings:__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.byId[_companyId3].settings,newSettings)}))),rawDataById:__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.rawDataById,__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({},_companyId3,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.rawDataById[_companyId3],{companySettingsUpdateSuccess:true,companySettingsUpdatingErrorId:null,settings:__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.rawDataById[_companyId3].settings,newSettings)}))),loading:false});}case __WEBPACK_IMPORTED_MODULE_4__actions__["_25" /* COMPANIES_SETTING_WRITE_FAIL */]:{var _companyId4=action.payload.companyId;return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{byId:__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.byId,__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({},_companyId4,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.byId[_companyId4],{companySettingsUpdateSuccess:false,companySettingsUpdatingErrorId:__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(action,'error.errorId')}))),rawDataById:__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.rawDataById,__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({},_companyId4,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state.rawDataById[_companyId4],{companySettingsUpdateSuccess:false,companySettingsUpdatingErrorId:__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(action,'error.errorId')}))),loading:false});}case __WEBPACK_IMPORTED_MODULE_4__actions__["_10" /* COMPANIES_INVITE_USER_ADD */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{inviteUsers:[].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.inviteUsers),[action.payload.user])});case __WEBPACK_IMPORTED_MODULE_4__actions__["_15" /* COMPANIES_INVITE_USER_UPDATE */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{inviteUsers:state.inviteUsers.map(function(user){if(user.id===action.payload.user.id){return{id:user.id,role:action.payload.user.role,email:action.payload.user.email};}else{return user;}})});case __WEBPACK_IMPORTED_MODULE_4__actions__["_14" /* COMPANIES_INVITE_USER_REMOVE */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{inviteUsers:__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.inviteUsers.filter(function(user){return user.id!==action.payload.id;}))});case __WEBPACK_IMPORTED_MODULE_4__actions__["_13" /* COMPANIES_INVITE_USER_MESSAGE_SET */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{inviteUsersMessage:action.payload.message});case __WEBPACK_IMPORTED_MODULE_4__actions__["_12" /* COMPANIES_INVITE_USER_CLEAR_USERS */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{inviteUsers:[]});case __WEBPACK_IMPORTED_MODULE_4__actions__["_11" /* COMPANIES_INVITE_USER_CLEAR_MESSAGE */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{inviteUsersMessage:null});case __WEBPACK_IMPORTED_MODULE_4__actions__["_182" /* USER_REDUCE_UPDATE */]:return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({},state,{pendingReduceUsers:updateReducedUsers(state.pendingReduceUsers,action.payload.email,action.payload.userId,action.payload.externalIds,action.payload.action)});default:return state;}});var validateCompany=function validateCompany(name){return{types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_50" /* COMPANIES_VALIDATE */],__WEBPACK_IMPORTED_MODULE_4__actions__["_52" /* COMPANIES_VALIDATE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_51" /* COMPANIES_VALIDATE_FAIL */]],promise:function promise(client){return client.get('/companies/validation',{params:{name:name}})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({message:'companies.validateCompany() failed',errorId:__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_9__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}};};var addCompany=function addCompany(data){return{types:[__WEBPACK_IMPORTED_MODULE_4__actions__["s" /* COMPANIES_ADD */],__WEBPACK_IMPORTED_MODULE_4__actions__["_145" /* REQUEST_FINISHED */],__WEBPACK_IMPORTED_MODULE_4__actions__["t" /* COMPANIES_ADD_FAIL */]],promise:function promise(client){return client.post('/companies',{data:data})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({message:'companies.addCompany() failed',errorId:__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_9__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}};};var updateCompany=function updateCompany(companyId,clientData){//[P9052-11080] industry name is clientside only, do not send to server
var data=__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.omit(clientData,['industry']);return function(dispatch){return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_32" /* COMPANIES_UPDATE */],__WEBPACK_IMPORTED_MODULE_4__actions__["_145" /* REQUEST_FINISHED */],__WEBPACK_IMPORTED_MODULE_4__actions__["_33" /* COMPANIES_UPDATE_FAIL */]],payload:{companyId:companyId,clientData:clientData},promise:function promise(client){return client.patch("/companies/".concat(companyId),{data:{data:data}}).then(function(){if(clientData&&clientData.displayName){document.title='Xara Workspace | '+clientData.displayName;}Object(__WEBPACK_IMPORTED_MODULE_5_redux_modules_quickMessages__["b" /* showQuickMessage */])(localize('company-profile-updated')).call(_this,dispatch);})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({message:'companies.updateCompany() failed',errorId:__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_9__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};var selectCompanies=function selectCompanies(companies){return{type:__WEBPACK_IMPORTED_MODULE_4__actions__["_23" /* COMPANIES_SET */],result:{companies:companies}};};var changeCompany=function changeCompany(company){return{type:__WEBPACK_IMPORTED_MODULE_4__actions__["v" /* COMPANIES_CHANGE */],result:{company:company}};};var changeCompanyAndNotify=function changeCompanyAndNotify(company){return function(dispatch,getState){if(company){Object(__WEBPACK_IMPORTED_MODULE_10__storage__["b" /* setItem */])('selectedCompany',company.id);dispatch(changeCompany(company));}var _getState=getState(),companies=_getState.companies;if(companies.selectedId&&companies.rawDataById[companies.selectedId]){Object(__WEBPACK_IMPORTED_MODULE_10__storage__["b" /* setItem */])('selectedCompany',companies.selectedId);dispatch({type:__WEBPACK_IMPORTED_MODULE_4__actions__["w" /* COMPANIES_CHANGED */],result:{company:companies.rawDataById[companies.selectedId]}});}};};// USERS
var addCompanyUsers=function addCompanyUsers(users,invitationMsg,hasPlan,targetUsersPayingQuantity){return function(dispatch,getState){var _getState$companies=getState().companies,selectedId=_getState$companies.selectedId,rawDataById=_getState$companies.rawDataById;var displayName=rawDataById[selectedId].displayName;var postData=__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({users:users,host:__WEBPACK_IMPORTED_MODULE_14__config__["_65" /* XC_URL */]+"?company=".concat(encodeURIComponent(displayName))},invitationMsg&&{invitationMsg:invitationMsg});return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_41" /* COMPANIES_USER_ADD */],__WEBPACK_IMPORTED_MODULE_4__actions__["_43" /* COMPANIES_USER_ADD_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_42" /* COMPANIES_USER_ADD_FAIL */]],payload:__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({users:users,hasPlan:hasPlan},targetUsersPayingQuantity&&{targetUsersPayingQuantity:targetUsersPayingQuantity}),promise:function promise(client){return client.post("/companies/".concat(selectedId,"/users"),{data:postData}).then(function(){var nonGuestUsers=Object(__WEBPACK_IMPORTED_MODULE_16__utils_users__["e" /* filterNonGuestUsers */])(users);if(nonGuestUsers.length>0){Object(__WEBPACK_IMPORTED_MODULE_5_redux_modules_quickMessages__["b" /* showQuickMessage */])(localize('users-user-added',nonGuestUsers.map(function(u){return u.email;}).join(', '))).call(_this,dispatch);}})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({message:'companies.addCompanyUser() failed',errorId:__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_9__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};var sendInviteToUsers=function sendInviteToUsers(users,invitationMsg,hasPlan,targetUsersPayingQuantity){return function(dispatch,getState){var _getState$companies2=getState().companies,selectedId=_getState$companies2.selectedId,rawDataById=_getState$companies2.rawDataById;var displayName=rawDataById[selectedId].displayName;if(!users||!users.length){return Object(__WEBPACK_IMPORTED_MODULE_5_redux_modules_quickMessages__["b" /* showQuickMessage */])(localize('users-no-users-invited')).call(_this,dispatch);}var postData=__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({users:users,host:__WEBPACK_IMPORTED_MODULE_14__config__["_65" /* XC_URL */]+"?company=".concat(encodeURIComponent(displayName))},invitationMsg&&{invitationMsg:invitationMsg});return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_41" /* COMPANIES_USER_ADD */],__WEBPACK_IMPORTED_MODULE_4__actions__["_43" /* COMPANIES_USER_ADD_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_42" /* COMPANIES_USER_ADD_FAIL */]],payload:__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()({users:users,hasPlan:hasPlan},targetUsersPayingQuantity&&{targetUsersPayingQuantity:targetUsersPayingQuantity}),promise:function promise(client){return client.post("/companies/".concat(selectedId,"/users"),{data:postData}).then(function(){var nonGuestUsers=Object(__WEBPACK_IMPORTED_MODULE_16__utils_users__["e" /* filterNonGuestUsers */])(users);if(nonGuestUsers.length>0){Object(__WEBPACK_IMPORTED_MODULE_5_redux_modules_quickMessages__["b" /* showQuickMessage */])(localize('users-users-invited',nonGuestUsers.length)).call(_this,dispatch);}})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({message:'companies.sendInviteToUsers() failed',errorId:__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_9__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};var estimateCostOnAddCompanyUsers=function estimateCostOnAddCompanyUsers(usersParams){var users=[];users.push.apply(users,__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(usersParams));return function(dispatch,getState){var selectedId=getState().companies.selectedId;return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["Q" /* COMPANIES_ESTIMATE_USER_ADD */],__WEBPACK_IMPORTED_MODULE_4__actions__["_145" /* REQUEST_FINISHED */],__WEBPACK_IMPORTED_MODULE_4__actions__["R" /* COMPANIES_ESTIMATE_USER_ADD_FAIL */]],payload:{users:users},promise:function promise(client){return client.post("/companies/".concat(selectedId,"/estimate/users"),{data:{users:users,host:__WEBPACK_IMPORTED_MODULE_14__config__["_65" /* XC_URL */]}})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({message:'companies.estimateCostOnAddCompanyUsers() failed',errorId:httpErrorProps.errorId||__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_9__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};var updateUserPhoto=function updateUserPhoto(file,companyId,userId){return function(dispatch,getState){var method=file?'post':'delete';var data=file?new FormData():undefined;if(file){data.append('file',file);data={data:data};}else{data={data:{companyId:companyId,userId:userId}};}return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_35" /* COMPANIES_UPDATE_USER_PHOTO */],__WEBPACK_IMPORTED_MODULE_4__actions__["_37" /* COMPANIES_UPDATE_USER_PHOTO_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_36" /* COMPANIES_UPDATE_USER_PHOTO_FAIL */]],payload:{companyId:companyId,userId:userId},promise:function promise(client){return client[method]("/account/photo?companyId=".concat(companyId,"&userId=").concat(userId),data).then(function(response){Object(__WEBPACK_IMPORTED_MODULE_5_redux_modules_quickMessages__["b" /* showQuickMessage */])(localize(file?'users-user-photo-updated':'users-user-photo-removed')).call(_this,dispatch);return response;})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var errorId=httpErrorProps.errorId||__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].UNKNOWN;Object(__WEBPACK_IMPORTED_MODULE_5_redux_modules_quickMessages__["b" /* showQuickMessage */])(localize(file?'users-user-photo-update-error':'users-user-photo-remove-error')).call(_this,dispatch);var nError=new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({message:'companies.updateUserPhoto() failed',errorId:errorId,originalError:new __WEBPACK_IMPORTED_MODULE_9__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};var updateCompanyUser=function updateCompanyUser(data,updatedUser){return function(dispatch,getState){if(Array.isArray(data)){data=data.map(function(item){item.trackingName&&delete item.trackingName;item.action&&delete item.action;return item;});}var selectedId=getState().companies.selectedId;var email=updatedUser.email,role=updatedUser.role;return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_47" /* COMPANIES_USER_UPDATE */],__WEBPACK_IMPORTED_MODULE_4__actions__["_49" /* COMPANIES_USER_UPDATE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_48" /* COMPANIES_USER_UPDATE_FAIL */]],payload:{id:selectedId,data:data},promise:function promise(client){return client.patch("/companies/".concat(selectedId,"/users/").concat(email),{data:{role:role,host:__WEBPACK_IMPORTED_MODULE_14__config__["_65" /* XC_URL */]}}).then(function(){return Object(__WEBPACK_IMPORTED_MODULE_5_redux_modules_quickMessages__["b" /* showQuickMessage */])(localize('users-user-role-updated'))(dispatch);})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({message:'companies.updateCompanyUser() failed',errorId:httpErrorProps.errorId||__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_9__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};var estimateCostOnUpdateCompanyUser=function estimateCostOnUpdateCompanyUser(data,updatedUser){return function(dispatch,getState){var selectedId=getState().companies.selectedId;var email=updatedUser.email,role=updatedUser.role;return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["W" /* COMPANIES_ESTIMATE_USER_UPDATE */],__WEBPACK_IMPORTED_MODULE_4__actions__["_145" /* REQUEST_FINISHED */],__WEBPACK_IMPORTED_MODULE_4__actions__["X" /* COMPANIES_ESTIMATE_USER_UPDATE_FAIL */]],payload:{id:selectedId,data:data},promise:function promise(client){return client.patch("/companies/".concat(selectedId,"/estimate/users/").concat(email),{data:{role:role,host:__WEBPACK_IMPORTED_MODULE_14__config__["_65" /* XC_URL */]}})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({message:'companies.estimateCostOnUpdateCompanyUser() failed',errorId:httpErrorProps.errorId||__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_9__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};var deleteCompanyUser=function deleteCompanyUser(email){return function(dispatch,getState){var selectedId=getState().companies.selectedId;return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_44" /* COMPANIES_USER_DELETE */],__WEBPACK_IMPORTED_MODULE_4__actions__["_145" /* REQUEST_FINISHED */],__WEBPACK_IMPORTED_MODULE_4__actions__["_45" /* COMPANIES_USER_DELETE_FAIL */]],payload:{email:email},promise:function promise(client){return client["delete"]("/companies/".concat(selectedId,"/users/").concat(email)).then(function(){Object(__WEBPACK_IMPORTED_MODULE_5_redux_modules_quickMessages__["b" /* showQuickMessage */])(localize('users-user-removed',email)).call(_this,dispatch);})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({message:'companies.deleteCompanyUser() failed',errorId:httpErrorProps.errorId||__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_9__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};var estimateCostOnDeleteCompanyUser=function estimateCostOnDeleteCompanyUser(email){return function(dispatch,getState){var selectedId=getState().companies.selectedId;return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["T" /* COMPANIES_ESTIMATE_USER_DELETE */],__WEBPACK_IMPORTED_MODULE_4__actions__["_145" /* REQUEST_FINISHED */],__WEBPACK_IMPORTED_MODULE_4__actions__["U" /* COMPANIES_ESTIMATE_USER_DELETE_FAIL */]],payload:{email:email},promise:function promise(client){return client["delete"]("/companies/".concat(selectedId,"/estimate/users/").concat(email))["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({message:'companies.estimateCostOnDeleteCompanyUser() failed',errorId:httpErrorProps.errorId||__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_9__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};var updateUserExternalId=function updateUserExternalId(companyId,userId,externalIds){return function(dispatch){return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_179" /* USER_EXTERNAL_ID_UPDATE */],__WEBPACK_IMPORTED_MODULE_4__actions__["_181" /* USER_EXTERNAL_ID_UPDATE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_180" /* USER_EXTERNAL_ID_UPDATE_FAIL */]],payload:{companyId:companyId,userId:userId,externalIds:externalIds},promise:function promise(client){return client.patch(__WEBPACK_IMPORTED_MODULE_14__config__["b" /* ACCOUNT_UPDATE_EXTERNAL_IDS_ENDPOINT */],{data:{companyId:companyId,userId:userId,externalIds:externalIds}})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({message:'companies.updateUserExternalId() failed',errorId:__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_9__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};var clearExternalIdState=function clearExternalIdState(){return{type:__WEBPACK_IMPORTED_MODULE_4__actions__["_178" /* USER_EXTERNAL_ID_STATE_CLEAR */]};};// SOCKET EVENTS
var connectCompanySocketEvents=function connectCompanySocketEvents(){return function(dispatch,getState){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__actions__["_159" /* SOCKET_SUBSCRIBE */],event:'company:added',callback:__WEBPACK_IMPORTED_MODULE_4__actions__["u" /* COMPANIES_ADD_SUCCESS */]});dispatch({type:__WEBPACK_IMPORTED_MODULE_4__actions__["_159" /* SOCKET_SUBSCRIBE */],event:'company:updated',callback:function callback(payload){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__actions__["_34" /* COMPANIES_UPDATE_SUCCESS */],payload:{companyId:payload._id,data:getCompany(payload,getState().session.user.mainEmail)}});}});dispatch({type:__WEBPACK_IMPORTED_MODULE_4__actions__["_159" /* SOCKET_SUBSCRIBE */],event:'company:removed',callback:__WEBPACK_IMPORTED_MODULE_4__actions__["_19" /* COMPANIES_REMOVE_SUCCESS */]});};};var fetchCompaniesIndustries=function fetchCompaniesIndustries(){return{types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_7" /* COMPANIES_INDUSTRIES_FETCH */],__WEBPACK_IMPORTED_MODULE_4__actions__["_9" /* COMPANIES_INDUSTRIES_FETCH_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_8" /* COMPANIES_INDUSTRIES_FETCH_FAIL */]],promise:function promise(){return new Promise(function(resolve,reject){__WEBPACK_IMPORTED_MODULE_19_lib_StaticResource__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_14__config__["_39" /* STATIC_RESOURCE_INDUSTRIES_PATH */]).then(function(response){resolve(response.data.industries);})["catch"](function(error){reject(error);});});}};};var fetchCompaniesSizes=function fetchCompaniesSizes(){return{types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_27" /* COMPANIES_SIZES_FETCH */],__WEBPACK_IMPORTED_MODULE_4__actions__["_29" /* COMPANIES_SIZES_FETCH_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_28" /* COMPANIES_SIZES_FETCH_FAIL */]],promise:function promise(){return new Promise(function(resolve,reject){__WEBPACK_IMPORTED_MODULE_19_lib_StaticResource__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_14__config__["_40" /* STATIC_RESOURCE_SIZES_PATH */]).then(function(response){resolve(response.data.sizes);})["catch"](function(error){reject(error);});});}};};var fetchCompaniesCountries=function fetchCompaniesCountries(){return{types:[__WEBPACK_IMPORTED_MODULE_4__actions__["E" /* COMPANIES_COUNTRIES_FETCH */],__WEBPACK_IMPORTED_MODULE_4__actions__["G" /* COMPANIES_COUNTRIES_FETCH_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["F" /* COMPANIES_COUNTRIES_FETCH_FAIL */]],promise:function promise(){return new Promise(function(resolve,reject){__WEBPACK_IMPORTED_MODULE_19_lib_StaticResource__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_14__config__["_38" /* STATIC_RESOURCE_COUNTRIES_PATH */]).then(function(response){resolve(response.data.countries);})["catch"](function(error){reject(error);});});}};};var fetchUserRegion=function fetchUserRegion(){return{types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_183" /* USER_REGION_FETCH */],__WEBPACK_IMPORTED_MODULE_4__actions__["_185" /* USER_REGION_FETCH_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_184" /* USER_REGION_FETCH_FAIL */]],promise:function promise(client){return client.get(__WEBPACK_IMPORTED_MODULE_14__config__["s" /* COUNTRY_DETECTION_ENDPOINT */])["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({message:'user.fetchUserRegion() failed',errorId:httpErrorProps.errorId||__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_9__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_USER'}});throw nError;});}};};/**
 * Create the ChargeBee session
 *
 * @param {string} planid plan details
 * in format: team-[payment period]-[payment currency] (for example, team-monthly-usd)
 * @returns portal-session
 */var createChargeBeeSession=function createChargeBeeSession(planid){return function(dispatch,getState){var _getState2=getState(),companies=_getState2.companies;var selectedId=companies.selectedId;return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["H" /* COMPANIES_CREATE_CHARGEBEE_SESSION */],__WEBPACK_IMPORTED_MODULE_4__actions__["J" /* COMPANIES_CREATE_CHARGEBEE_SESSION_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["I" /* COMPANIES_CREATE_CHARGEBEE_SESSION_FAIL */]],promise:function promise(client){return client.get('/payment/chargebee/portal-session',{params:{'id':selectedId,planid:planid}})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({message:'companies.createChargeBeeSession() failed',errorId:httpErrorProps.errorId||__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_9__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};/**
 * Create the ChargeBee Subscription
 *
 * @param {string} chargebee_plan_or_addon_id plan details
 * in format: team-[payment period]-[payment currency] (for example, team-monthly-usd)
 * @param {bool} upgrade whether this is an upgrade of an existing subscription or not.
 * @param {string} host host for redirection after the subscription is created without GET attributes
 * @param {string} couponSetId coupon set id, MW will skip it if couponId is also set in same request
 * @param {string} couponId coupon id
 * @param {string} host host for redirection after the subscription is created without GET attributes
 * @returns dispatch
 */var createChargeBeeSubscription=function createChargeBeeSubscription(hasPlan,chargebee_plan_or_addon_id){var upgrade=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var host=arguments.length>3&&arguments[3]!==undefined?arguments[3]:window.location.href.split('?')[0];var couponSetId=arguments.length>4?arguments[4]:undefined;var couponId=arguments.length>5?arguments[5]:undefined;var isAddon=arguments.length>6?arguments[6]:undefined;var itemsNumber=arguments.length>7?arguments[7]:undefined;var lang=arguments.length>8?arguments[8]:undefined;return function(dispatch,getState){var _getState3=getState(),companies=_getState3.companies;var _convertPlanIdIntoSub2=Object(__WEBPACK_IMPORTED_MODULE_17__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(chargebee_plan_or_addon_id),plan=_convertPlanIdIntoSub2.plan;return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["K" /* COMPANIES_CREATE_CHARGEBEE_SUBSCRIPTION */],__WEBPACK_IMPORTED_MODULE_4__actions__["M" /* COMPANIES_CREATE_CHARGEBEE_SUBSCRIPTION_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["L" /* COMPANIES_CREATE_CHARGEBEE_SUBSCRIPTION_FAIL */]],payload:{couponId:couponId,couponSetId:couponSetId},promise:function promise(client){var _objectSpread22;return client.get("/companies/".concat(companies.selectedId,"/").concat(isAddon?'addon':'subscription'),{params:__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectSpread___default()((_objectSpread22={},__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_objectSpread22,"chargebee-".concat(isAddon?'addon':'plan',"-id"),chargebee_plan_or_addon_id),__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(_objectSpread22,"host",host),_objectSpread22),lang&&{locale:lang},upgrade===true&&{upgrade:true},couponSetId&&{couponSetId:encodeURIComponent(couponSetId)},couponId&&{couponId:encodeURIComponent(couponId)},!upgrade&&itemsNumber&&(isAddon||hasPlan)&&{quantity:itemsNumber},upgrade&&itemsNumber&&plan===__WEBPACK_IMPORTED_MODULE_14__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES&&{numberOfUsers:itemsNumber},!isAddon&&!hasPlan&&itemsNumber&&{numberOfUsers:itemsNumber})})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var errorId;if(httpErrorProps.errorId&&(couponId||couponSetId)&&httpErrorProps.errorId===__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].PAYMENT_PROVIDER_INTERNAL_ERROR){errorId=__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].PAYMENT_PROVIDER_INTERNAL_COUPON_ERROR;}else{errorId=httpErrorProps.errorId||__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].UNKNOWN;}var nError=new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({errorId:errorId,message:"companies.createChargeBeeSubscription() failed for ".concat(isAddon?'addon':'subscription'),originalError:new __WEBPACK_IMPORTED_MODULE_9__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});if(errorId===__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].PAYMENT_PROVIDER_INTERNAL_COUPON_ERROR){var _convertPlanIdIntoSub3=Object(__WEBPACK_IMPORTED_MODULE_17__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(chargebee_plan_or_addon_id),_plan=_convertPlanIdIntoSub3.plan;var payload={productType:isAddon?'perpetual':'subscription',lang:__WEBPACK_IMPORTED_MODULE_18_i18n_i18n__["a" /* default */].getCurrentLanguage(),coupon:couponId||couponSetId,email:getState().session.user.mainEmail,type:isAddon||[__WEBPACK_IMPORTED_MODULE_14__config__["_42" /* SUBSCRIPTION_PLAN */].PHOTO,__WEBPACK_IMPORTED_MODULE_14__config__["_42" /* SUBSCRIPTION_PLAN */].WEB,__WEBPACK_IMPORTED_MODULE_14__config__["_42" /* SUBSCRIPTION_PLAN */].DESIGNER].includes(_plan)?'desktop':'cloud'};Object(__WEBPACK_IMPORTED_MODULE_12_redux_modules_discount__["h" /* sendCurrentOfferToUser */])(payload);}throw nError;});}});};};/**
 * Retrieves the active company id from the URL or session data or localstorage
 */var getActiveCompanyId=function getActiveCompanyId(){// P9052-18959 Open the company admin panel to the last selected team for this environment
// It's very possible that the specific property doesn't exist so be defensive - e.g no user, no company, no settings
var activeCompanyId=resolveActiveCompanyId(true);return{type:__WEBPACK_IMPORTED_MODULE_4__actions__["_3" /* COMPANIES_GET_ACTIVE_COMPANY_ID */],payload:activeCompanyId};};var resolveActiveCompanyId=function resolveActiveCompanyId(useUrl){var _ref4=__WEBPACK_IMPORTED_MODULE_11__redux_store__["a" /* default */].getState().companies||{},rawDataById=_ref4.rawDataById;var allRawIds=rawDataById?Object.keys(rawDataById):[];return useUrl&&Object(__WEBPACK_IMPORTED_MODULE_15__utils_url__["a" /* getCompanyIdFromURL */])()||__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_11__redux_store__["a" /* default */].getState(),'session.user.settings.home.companyId')||getValidCompanyIdFromStorage()||allRawIds[0];};/**
 * If company from browser storage is part of existing account then return it, otherwise ignore it
*/var getValidCompanyIdFromStorage=function getValidCompanyIdFromStorage(){var result=null;var _ref5=__WEBPACK_IMPORTED_MODULE_11__redux_store__["a" /* default */].getState().companies||{},rawDataById=_ref5.rawDataById;var allRawIds=rawDataById?Object.keys(rawDataById):[];var companyIdFromStorage=Object(__WEBPACK_IMPORTED_MODULE_10__storage__["a" /* getItem */])('selectedCompany');if(companyIdFromStorage&&allRawIds.includes(companyIdFromStorage)){result=companyIdFromStorage;}return result;};var addCompanyFont=function addCompanyFont(data,replaceMode){return function(dispatch,getState){var selectedId=getState().companies.selectedId;return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["Z" /* COMPANIES_FONT_ADD */],__WEBPACK_IMPORTED_MODULE_4__actions__["_145" /* REQUEST_FINISHED */],__WEBPACK_IMPORTED_MODULE_4__actions__["_0" /* COMPANIES_FONT_ADD_FAIL */]],promise:function promise(client){return client.post("/companies/".concat(selectedId,"/font"),{data:data}).then(function(){var _data$get=data.get('font'),name=_data$get.name;var message=localize(replaceMode?'fonts-replaced':'fonts-added',name.toLowerCase());Object(__WEBPACK_IMPORTED_MODULE_5_redux_modules_quickMessages__["b" /* showQuickMessage */])(message).call(_this,dispatch);})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({message:'companies.addCompanyFont() failed',errorId:__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_9__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};var removeCompanyFont=function removeCompanyFont(font){return function(dispatch,getState){var selectedId=getState().companies.selectedId;var internalFontId=font.internalFontId;return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_1" /* COMPANIES_FONT_REMOVE */],__WEBPACK_IMPORTED_MODULE_4__actions__["_145" /* REQUEST_FINISHED */],__WEBPACK_IMPORTED_MODULE_4__actions__["_2" /* COMPANIES_FONT_REMOVE_FAIL */]],promise:function promise(client){return client["delete"]("/companies/".concat(selectedId,"/font/").concat(internalFontId)).then(function(){Object(__WEBPACK_IMPORTED_MODULE_5_redux_modules_quickMessages__["b" /* showQuickMessage */])(localize('fonts-removed',internalFontId)).call(_this,dispatch);})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({message:'companies.removeCompanyFont() failed',errorId:__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_9__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};var updateSmartFields=function updateSmartFields(smartfields){return function(dispatch,getState){var selectedId=getState().companies.selectedId;return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_30" /* COMPANIES_SMART_FIELDS_UPDATE */],__WEBPACK_IMPORTED_MODULE_4__actions__["_145" /* REQUEST_FINISHED */],__WEBPACK_IMPORTED_MODULE_4__actions__["_31" /* COMPANIES_SMART_FIELDS_UPDATE_FAIL */]],promise:function promise(client){return client.post("/companies/".concat(selectedId,"/smartfields"),{data:{smartfields:smartfields}})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({message:'companies.updateSmartFields() failed',errorId:__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_9__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};/**
 * Send request to trigger Email notification
 *
 * @param {string} type type of Email to send
 * @param {string} quickMessage a quick message text for notifing a user about the result of operation
 * @param {string} host host (URL) for an action button in the Email
 * @returns dispatch
 */var sendEmailNotification=function sendEmailNotification(type){var quickMessage=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var host=arguments.length>2&&arguments[2]!==undefined?arguments[2]:window.location.href;return function(dispatch,getState){var _getState4=getState(),companies=_getState4.companies;return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_148" /* SEND_EMAIL */],__WEBPACK_IMPORTED_MODULE_4__actions__["_150" /* SEND_EMAIL_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_149" /* SEND_EMAIL_FAIL */]],promise:function promise(client){return client.get("/companies/".concat(companies.selectedId,"/request"),{params:{type:type,host:host}}).then(function(){Object(__WEBPACK_IMPORTED_MODULE_5_redux_modules_quickMessages__["b" /* showQuickMessage */])(quickMessage).call(_this,dispatch);})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({message:'companies.sendEmailNotification() failed',errorId:__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_9__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};/**
 * Dispatches a redux action with a promise that will write the company settings to the middleware
 *
 * @param {Function} dispatch provided by Redux' mapDispatchToProps
 * @param {Object} settings the new company settings to be stored on the middleware
 */var writeCompanySettings=function writeCompanySettings(newSettings){return function(dispatch,getState){var selectedId=getState().companies.selectedId;return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_24" /* COMPANIES_SETTING_WRITE */],__WEBPACK_IMPORTED_MODULE_4__actions__["_26" /* COMPANIES_SETTING_WRITE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_25" /* COMPANIES_SETTING_WRITE_FAIL */]],payload:{companyId:selectedId,newSettings:newSettings},promise:function promise(client){return client.patch("/companies/".concat(selectedId,"/settings"),{data:{settings:newSettings}})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({message:'companies.writeCompanySettings() failed',errorId:__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_9__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_SESSION'}});throw nError;});}});};};var inviteUserUpdate=function inviteUserUpdate(user){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__actions__["_15" /* COMPANIES_INVITE_USER_UPDATE */],payload:{user:user}});};};var inviteUserAdd=function inviteUserAdd(user){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__actions__["_10" /* COMPANIES_INVITE_USER_ADD */],payload:{user:user}});};};var inviteUserRemove=function inviteUserRemove(id){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__actions__["_14" /* COMPANIES_INVITE_USER_REMOVE */],payload:{id:id}});};};var inviteUserSetMessage=function inviteUserSetMessage(message){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__actions__["_13" /* COMPANIES_INVITE_USER_MESSAGE_SET */],payload:{message:message}});};};var inviteUsersClearUsers=function inviteUsersClearUsers(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__actions__["_12" /* COMPANIES_INVITE_USER_CLEAR_USERS */]});};};var inviteUsersClearMessage=function inviteUsersClearMessage(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__actions__["_11" /* COMPANIES_INVITE_USER_CLEAR_MESSAGE */]});};};var updatePendingReduceUser=function updatePendingReduceUser(email,userId,externalIds,action){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__actions__["_182" /* USER_REDUCE_UPDATE */],payload:{email:email,userId:userId,externalIds:externalIds,action:action}});};};var batchReduceUsers=function batchReduceUsers(users){return function(dispatch,getState){var selectedId=getState().companies.selectedId;return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_38" /* COMPANIES_USERS_REDUCE */],__WEBPACK_IMPORTED_MODULE_4__actions__["_40" /* COMPANIES_USERS_REDUCE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_39" /* COMPANIES_USERS_REDUCE_FAIL */]],payload:{users:users},promise:function promise(client){var promises=[];users.forEach(function(user){var email=user.email,role=user.role,userId=user.userId,externalIds=user.externalIds;if(user.action===__WEBPACK_IMPORTED_MODULE_14__config__["_27" /* REDUCE_ACTION */].CHANGE_TO_GUEST){promises.push(client.patch("/companies/".concat(selectedId,"/users/").concat(email),{data:{role:role,host:__WEBPACK_IMPORTED_MODULE_14__config__["_65" /* XC_URL */]}}));!__WEBPACK_IMPORTED_MODULE_13_lodash___default.a.isEmpty(externalIds)&&userId&&promises.push(client.patch(__WEBPACK_IMPORTED_MODULE_14__config__["b" /* ACCOUNT_UPDATE_EXTERNAL_IDS_ENDPOINT */],{data:{companyId:selectedId,userId:userId,externalIds:[]}}));}else if(user.action===__WEBPACK_IMPORTED_MODULE_14__config__["_27" /* REDUCE_ACTION */].REMOVE){promises.push(client["delete"]("/companies/".concat(selectedId,"/users/").concat(email)));}});return Promise.all(promises)["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({message:'companies.batchReduceUsers() failed',errorId:__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_9__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_SESSION'}});throw nError;});}});};};var estimateCostOnAddUserSeats=function estimateCostOnAddUserSeats(quantity){return function(dispatch,getState){var selectedId=getState().companies.selectedId;return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["N" /* COMPANIES_ESTIMATE_SEAT */],__WEBPACK_IMPORTED_MODULE_4__actions__["_145" /* REQUEST_FINISHED */],__WEBPACK_IMPORTED_MODULE_4__actions__["O" /* COMPANIES_ESTIMATE_SEAT_FAIL */]],payload:{quantity:quantity},promise:function promise(client){return client.post("/companies/".concat(selectedId,"/licenses/members/estimate"),{data:{quantity:quantity}})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({message:'companies.estimateCostOnAddUserSeats() failed',errorId:__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_9__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};var purchaseSeats=function purchaseSeats(quantity,targetUsersPayingQuantity){return function(dispatch,getState){var selectedId=getState().companies.selectedId;return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_16" /* COMPANIES_PURCHASE_SEAT */],__WEBPACK_IMPORTED_MODULE_4__actions__["_18" /* COMPANIES_PURCHASE_SEAT_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_17" /* COMPANIES_PURCHASE_SEAT_FAIL */]],payload:{quantity:quantity,targetUsersPayingQuantity:targetUsersPayingQuantity},promise:function promise(client){return client.post("/companies/".concat(selectedId,"/licenses/members"),{data:{quantity:quantity}})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({message:'companies.purchaseSeats() failed',errorId:__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_9__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};/**
 * Send request to get CB addons details
 *
 * @param {array} addonId addon id in format members-annual-usd
 * @returns dispatch
 */var fetchAddonDetails=function fetchAddonDetails(addonIds){return function(dispatch,getState){var selectedId=getState().companies.selectedId;var addonIdQueryString=addonIds.reduce(function(accumulator,currentValue){return"".concat(accumulator,"&addonIds[]=").concat(currentValue);},'');return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["p" /* ADDON_GET_DETAILS */],__WEBPACK_IMPORTED_MODULE_4__actions__["r" /* ADDON_GET_DETAILS_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["q" /* ADDON_GET_DETAILS_FAIL */]],promise:function promise(client){return client.get("/payment/chargebee/addonDetails?id=".concat(selectedId).concat(addonIdQueryString)).then(function(response){var result={};var planKeys=Object.keys(response);planKeys.forEach(function(key){if(response[key].addon){// check if it contains errorId or addon data
result[key]=response[key].addon;}else if(response[key].errorId){var nError=new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({message:"fetchAddonDetails failed for addonId ".concat(key),errorId:response[key].errorId,errorDetails:response[key],visualisers:{feature:'REDUX_ADDON'}});log.send(nError);}});return result;})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({message:'companies.fetchAddonDetails() failed',errorId:__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_9__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_ADDON'}});throw nError;});}});};};/**
 * Fetch member addon details for addon in paymmentAccount
 * @returns dispatch
 */var fetchCurrentMemberAddonDetails=function fetchCurrentMemberAddonDetails(plan,period,currency){return function(dispatch,getState){var selectedId=getState().companies.selectedId;return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_4" /* COMPANIES_GET_CURRENT_MEMBER_ADDON_DETAILS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_6" /* COMPANIES_GET_CURRENT_MEMBER_ADDON_DETAILS_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_5" /* COMPANIES_GET_CURRENT_MEMBER_ADDON_DETAILS_FAIL */]],payload:{plan:plan,period:period,currency:currency},promise:function promise(client){return client.post("/companies/".concat(selectedId,"/licenses/members/estimate"),{data:{quantity:1}})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({message:'companies.fetchCurrentMemberAddonDetails() failed',errorId:__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_9__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};var clearMemberaddonDetails=function clearMemberaddonDetails(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__actions__["x" /* COMPANIES_CLEAR_CURRENT_MEMBER_ADDON_DETAILS */]});};};/**
 * Send request to get upcoming invoice estimate
 * Does not require any details (coupon, member addon id etc), only company ID
 * @returns dispatch
 */var getUpcomingInvoiceEstimate=function getUpcomingInvoiceEstimate(){return function(dispatch,getState){var selectedId=getState().companies.selectedId;return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_174" /* UPCOMING_INVOICE_GET_ESTIMATE */],__WEBPACK_IMPORTED_MODULE_4__actions__["_176" /* UPCOMING_INVOICE_GET_ESTIMATE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_175" /* UPCOMING_INVOICE_GET_ESTIMATE_FAIL */]],promise:function promise(client){return client.get("/companies/".concat(selectedId,"/upcomingInvoiceEstimation")).then(function(response){return response.renewalEstimation;})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({message:'companies.getUpcomingInvoiceEstimate() failed',errorId:__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_9__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};/**
 * Show error message in case of "429 Too many requests error" from CB
 */var showRateLimitError=function showRateLimitError(message){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__actions__["_76" /* ERROR_HANDLER_SET */],error:{errorId:__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].API_REQUEST_LIMIT_EXCEEDED}});};};/**
 * Show "package discontinued" error
 */var showErrorPopup=function showErrorPopup(errorId){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__actions__["_76" /* ERROR_HANDLER_SET */],error:{errorId:errorId}});};};/**
 * Show "rate limit" error
 */var showPackageDiscontinuedMessage=function showPackageDiscontinuedMessage(message){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__actions__["_76" /* ERROR_HANDLER_SET */],error:{errorMessage:localize('error-message-discontinued-plan'),errorId:__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].FAILED_TO_CREATE_COMPANY_SUBSCRIPTION}});};};/**
 * This endpoint should be used by companies with active or inactive subscription (plan in paymentAccount exists),
 * when a user wants to buy a subscription for first time or when a user wants to upgrade a subscription. 
 * In this case request url contains companyId.
 * 
 * This endpoint should be used when a user wants to buy a subscription for first time and paymentAccount is empty
 * Endpoint returns same numbers for all companies and they are cached by MW/Nginx.
 * In this case request url does not contain companyId.
 * @param {string} requestUrl
 * @param {string} currentPlanId
 * @param {string} couponId
 * @param {string} couponSetId
 * @param {boolean} onlyActivePlan
 * @returns dispatch
*/var getSubscriptionEstimation=function getSubscriptionEstimation(requestUrl,currentPlanId,discountType,couponSetKey,couponId,couponSetId,couponType,onlyActivePlan){return function(dispatch,getState){return dispatch({types:onlyActivePlan?[__WEBPACK_IMPORTED_MODULE_4__actions__["_165" /* SUBSCRIPTION_GET_ESTIMATE_ACTIVE_PLAN */],__WEBPACK_IMPORTED_MODULE_4__actions__["_167" /* SUBSCRIPTION_GET_ESTIMATE_ACTIVE_PLAN_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_166" /* SUBSCRIPTION_GET_ESTIMATE_ACTIVE_PLAN_FAIL */]]:[__WEBPACK_IMPORTED_MODULE_4__actions__["_164" /* SUBSCRIPTION_GET_ESTIMATE */],__WEBPACK_IMPORTED_MODULE_4__actions__["_169" /* SUBSCRIPTION_GET_ESTIMATE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_168" /* SUBSCRIPTION_GET_ESTIMATE_FAIL */]],payload:{requestUrl:requestUrl,currentPlanId:currentPlanId,couponId:couponId,couponSetId:couponSetId,discountType:discountType,couponSetKey:couponSetKey,couponType:couponType},promise:function promise(client){return client.get(requestUrl)["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({message:"companies.getSubscriptionEstimation() ".concat(onlyActivePlan?'for active plan':''," failed"),errorId:__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_9__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};var sendContactSalesRequest=function sendContactSalesRequest(data){return{types:[__WEBPACK_IMPORTED_MODULE_4__actions__["B" /* COMPANIES_CONTACT_SALES */],__WEBPACK_IMPORTED_MODULE_4__actions__["D" /* COMPANIES_CONTACT_SALES_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["C" /* COMPANIES_CONTACT_SALES_FAIL */]],promise:function promise(client){return client.post(__WEBPACK_IMPORTED_MODULE_14__config__["r" /* CONTACT_SALES */].API_ENDPOINT,data)["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["a" /* extractPropsforAxiosHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({message:'companies.sendContactSalesRequest() failed',errorId:__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_9__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}};};

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setupLogger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__errors_baseerror__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__errors_httperror__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__errors_knownproperties__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__errors_errorhelper__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_clientid__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
var ERROR_HISTORY_STORAGE_KEY=__WEBPACK_IMPORTED_MODULE_6__config__["_70" /* loggerConfig */].errorHistoryStorageKey;var ERROR_QUEUE_STORAGE_KEY=__WEBPACK_IMPORTED_MODULE_6__config__["_70" /* loggerConfig */].errorQueueStorageKey;var MAX_TIME_DIFF_BETWEEN_ERRORS=5000;var ERROR_QUEUE_MAX_RECORDS=1000;var LOGGER_AJAX_RETRY_MAX=5;var LOGGER_AJAX_RETRY_TIMEOUT=7000;var errorsById=Object(__WEBPACK_IMPORTED_MODULE_5__errors_errorhelper__["c" /* getErrorsById */])();var userInfo={};var lastAuthorizedUserEmail;var browserId;var browserTabId;initBrowserDetails();function initUserInfo(userData,companyId,isPayingCompany){if(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(userData))return;userInfo.id=userData.id;userInfo.name=userData.firstName&&userData.lastName?"".concat(userData.firstName," ").concat(userData.lastName):userData.name;userInfo.mail=userData.mainEmail;userInfo.isSignedIn=true;userInfo.relatedCompanyId=companyId;userInfo.isPayingCompany={payingSelectedCompany:Boolean(isPayingCompany)};window.localStorage.setItem('camonlineLastAuthorizedUserEmail',userData.mainEmail);}var isSavedBeingSentStateCleared=false;function clearSavedIsBeingSentState(){// Clear saved isBeingSent state which might be saved before refresh
if(!isSavedBeingSentStateCleared){flagItemInErrorQueuBeingSentStatus('all',false);isSavedBeingSentStateCleared=true;}}function parseMessage(logMessage){var parsedLogMessage={};Object.keys(logMessage).forEach(function(i){if(typeof __WEBPACK_IMPORTED_MODULE_4__errors_knownproperties__["a" /* default */][i]==='function'){if(!__WEBPACK_IMPORTED_MODULE_4__errors_knownproperties__["a" /* default */][i](parsedLogMessage,i,logMessage[i])){__WEBPACK_IMPORTED_MODULE_4__errors_knownproperties__["a" /* default */].miscellaneous(parsedLogMessage,i,logMessage[i]);}}else{__WEBPACK_IMPORTED_MODULE_4__errors_knownproperties__["a" /* default */].miscellaneous(parsedLogMessage,i,logMessage[i]);}});return parsedLogMessage;}// [P9052-15244] disable items field due to it causing logs to not be
// stored in kibana. We will be re-adding this after review so do not delete it yet.
function sendToServer(objectToLog,forceSilentMessageType/*includeItems*/,pastTimestamp,pastBrowserId,pastBrowserTabId,pastLastAuthorizedUserEmail){if(!objectToLog){objectToLog={message:'No message'};}// string passed
if(''+objectToLog===objectToLog){objectToLog={message:objectToLog};}if(objectToLog instanceof ErrorEvent){// In case someone tries to log ErrorEvent directly
// without using custom class (AppError etc)
// then use ErrorEvent.error as object to log
// https://developer.mozilla.org/en-US/docs/Web/API/ErrorEvent
objectToLog=objectToLog.error;}// Always copy props to new object, otherwise props (user, meta etc) added in logger.js 
// to error object will be serialized in baseError.getErrorHistoryToLog()
var packetToLog=objectToLog instanceof Error||objectToLog instanceof Event&&objectToLog.type&&objectToLog.type==='error'||pastTimestamp?{}:objectToLog;// save App data
packetToLog.name=this.componentName;packetToLog.meta={browserId:pastBrowserId||browserId,browserTabId:pastBrowserTabId||browserTabId,timestamp:pastTimestamp||Date.now(),lastAuthorizedUserEmail:pastLastAuthorizedUserEmail||lastAuthorizedUserEmail,url:window.location.href,app:{commit:__WEBPACK_IMPORTED_MODULE_6__config__["_23" /* REACT_APP_BUILD_VCS_NUMBER */],branch:__WEBPACK_IMPORTED_MODULE_6__config__["_21" /* REACT_APP_BRANCH */]},// "online" does not always mean connection to the internet,
// it can also just mean connection to some network.
onLine:navigator.onLine,viewPortWidth:document&&window&&Math.max(document.documentElement.clientWidth,window.innerWidth||0),viewPortHeight:document&&window&&Math.max(document.documentElement.clientHeight,window.innerHeight||0)};packetToLog.visualisers=objectToLog.visualisers||{};// [P9052-12966] improve visualisers for error stats reports
// - add source so we easily can identify our reports
packetToLog.visualisers.source='cap';if(pastTimestamp){// requests saved to storage in bootloader when logger was not available or
// failed ajax request in logger.doAjaxRequest
packetToLog.isRetry=true;}// If passed error is an instance of Error then send only the relevant data.
// ErrorEvent and Event with error.type === 'error' should be send 
// using custom error classes (AppError, ImageResourceError etc)
if(objectToLog instanceof Error){//instanceof Error = DOMException coming from FileReader
var msg=objectToLog.message||objectToLog.name||'message-not-defined';packetToLog.message=msg;packetToLog.errorId=objectToLog.errorId||__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN;objectToLog.tag&&(packetToLog.tag=objectToLog.tag);packetToLog.error={message:msg,name:objectToLog.name,// DOMException.code used for example with FileReader or localStorage exception
code:objectToLog.code,stack:(objectToLog.stack||'unavailable').toString(),file:objectToLog.fileName||'unavailable',line:objectToLog.lineNumber||-1,// -1 by default so it's parsed as a number
column:objectToLog.columnNumber||-1// -1 by default so it's parsed as a number
};if(objectToLog instanceof __WEBPACK_IMPORTED_MODULE_3__errors_httperror__["a" /* default */]){packetToLog.serverStatus=objectToLog.status;packetToLog.apiErrorId=objectToLog.getApiErrorId();if(packetToLog.apiErrorId){packetToLog.apiErrorKey=errorsById[packetToLog.apiErrorId]||'unknown';}}if(objectToLog instanceof __WEBPACK_IMPORTED_MODULE_2__errors_baseerror__["a" /* default */]){var errorHistory=objectToLog.getErrorHistoryToLog();errorHistory&&(packetToLog.errorHistory=errorHistory);var errorDetails=objectToLog.getPropertiesToLogAsJson();errorDetails&&(packetToLog.errorDetails=errorDetails);var details=objectToLog.getPropertiesToLog();details&&(packetToLog.details=details);var previousMessage=objectToLog.getMesageFromHistoryAtIndex(-1);if(previousMessage){packetToLog.previousMessage=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isString(previousMessage)?previousMessage:previousMessage.message||'message-unknown';packetToLog.previousMessageId=previousMessage.errorId;}var firstMessage=objectToLog.getMesageFromHistoryAtIndex(0);if(firstMessage){packetToLog.firstMessage=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isString(firstMessage)?firstMessage:firstMessage.message||'message-unknown';packetToLog.firstMessageId=firstMessage.errorId;if(firstMessage instanceof __WEBPACK_IMPORTED_MODULE_3__errors_httperror__["a" /* default */]){packetToLog.serverStatus=firstMessage.status;packetToLog.apiErrorId=firstMessage.getApiErrorId();if(packetToLog.apiErrorId){packetToLog.apiErrorKey=errorsById[packetToLog.apiErrorId]||'unknown';}}}}else{// from bootloader storage
var propertiesToCopyFromSavedObject=['errorHistory','errorDetails','details','previousMessage','previousMessageId','firstMessage','firstMessageId','serverStatus','apiErrorId'];for(var i=propertiesToCopyFromSavedObject.length-1;i>=0;i--){var propertNameToCopy=propertiesToCopyFromSavedObject[i];if(objectToLog[propertNameToCopy]){packetToLog[propertNameToCopy]=objectToLog[propertNameToCopy];}}}// [P9052-12966] improve visualisers for error stats reports
// - add improved keys for report readability. Instead of using errorId we can stack by key, then message
var key=errorsById[objectToLog.errorId];if(!key||key===errorsById[__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN]){key=msg;}packetToLog.visualisers.key=key;!packetToLog.visualisers.feature&&(packetToLog.visualisers.feature='GENERIC_FEATURE');if(window.hj){var tags=['ErrorKey',''+packetToLog.errorId,__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.snakeCase(key.replace(/[^a-z0-9-_ ]/gi,''))];window.hj('tagRecording',tags);}// Add repeatedError and repeatedAlternatingError flags for kibana
// Ignore "additional details" send from boot.js and REJECTED_API_STATUS_REQUEST as
// they can break the chain of repeatedError
if(!isRejectedAPiStatusRequest(packetToLog)&&!isAdditionalDetailsMessage(packetToLog)){var currentError=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.omitBy(packetToLog.error,__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isNil));delete currentError.isSignedIn;// Compare by key and not stack, as stack can be different for same error,
// for example same error on trailingEdge vs leadingEdge of function
delete currentError.stack;currentError.key=key;var errorHistoryFromStorage=window.localStorage.getItem(ERROR_HISTORY_STORAGE_KEY);var errorHistoryItems=errorHistoryFromStorage?JSON.parse(errorHistoryFromStorage):[];var now=Date.now();if(!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(errorHistoryItems)){// Delete outdated records
for(var _i=errorHistoryItems.length-1;_i>=0;_i--){var historyError=errorHistoryItems[_i];var timeDiff=now-historyError.timestamp;if(timeDiff>MAX_TIME_DIFF_BETWEEN_ERRORS){delete errorHistoryItems[_i];}}errorHistoryItems=errorHistoryItems.filter(function(item){return item!==null;});var previousError=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.last(errorHistoryItems);if(previousError){if(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEqual(previousError.errorData,currentError)){packetToLog.error.repeatedError=true;}else if(errorHistoryItems.length>=2){for(var _i2=errorHistoryItems.length-2/* skip previousError */;_i2>=0;_i2--){var _historyError=errorHistoryItems[_i2];if(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEqual(_historyError.errorData,currentError)){packetToLog.error.repeatedAlternatingError=true;break;}}}}}delete currentError.repeatedError;delete currentError.repeatedAlternatingError;var newErrorToPush={errorData:currentError,timestamp:pastTimestamp||now,errorId:packetToLog.errorId};errorHistoryItems.push(newErrorToPush);try{window.localStorage.setItem(ERROR_HISTORY_STORAGE_KEY,JSON.stringify(errorHistoryItems));}catch(e){// Silent catch
}}}// clientId should be at the top level so it's consistent with server-side logs
packetToLog.clientId=__WEBPACK_IMPORTED_MODULE_7__utils_clientid__["a" /* default */];if(!userInfo.mail&&lastAuthorizedUserEmail){// if user info is not available yet but email is available from local storage
packetToLog.user={mail:lastAuthorizedUserEmail,name:'pending'};}else{packetToLog.user=userInfo;}// don't log from dev machines when loggerConfig.sendFromDev is not set - buildNumber is available only after TC build
if(__WEBPACK_IMPORTED_MODULE_6__config__["_22" /* REACT_APP_BUILD_NUMBER */]!=='not available'||__WEBPACK_IMPORTED_MODULE_6__config__["_70" /* loggerConfig */].sendFromDev){sendViaHttp(parseMessage(packetToLog));}return packetToLog;}function saveErrorToLocalStorageQueue(data){var errorQueue=getErrorQueue();// Clear queue in case of unexpected very large number of errors
if(errorQueue.length>ERROR_QUEUE_MAX_RECORDS){errorQueue=[];}var localStorageId=Date.now()+'-'+Math.random().toString(36).slice(2,7);errorQueue.push({id:localStorageId,type:'parsed',packet:data,timestamp:data.meta.timestamp,browserId:data.meta.browserId,browserTabId:data.meta.browserTabId,lastAuthorizedUserEmail:data.meta.lastAuthorizedUserEmail,buildNumber:__WEBPACK_IMPORTED_MODULE_6__config__["_22" /* REACT_APP_BUILD_NUMBER */]});var isSuccess=saveErrorQueue(errorQueue);return isSuccess?localStorageId:null;}function sendViaHttp(data,localStorageItemId){var resolvedLocalStorageItemId=localStorageItemId;// TODO:start temp flag used to send logs to new kibana index, should be removed in R116/7
if(!data.miscellaneous){data.miscellaneous={};}// also update value in bootloader.js when you change this one
data.miscellaneous.newlog1='true';// TODO:end temp flag used to send logs to new kibana index, should be removed in R116/7
// Save 'parsed' message coming from sendToServer to same localStorage key used to
// save raw message from bootloader (raw message)
// Only save errors to localStorage as they had to be retried when page is refreshed after error popup has been shown
if(!resolvedLocalStorageItemId&&data.error&&!isRejectedAPiStatusRequest(data)){resolvedLocalStorageItemId=saveErrorToLocalStorageQueue(data);}resolvedLocalStorageItemId&&flagItemInErrorQueuBeingSentStatus(resolvedLocalStorageItemId,true);var requestNumber=0;function onRetry(res){setTimeout(function(){doAjaxRequest(requestNumber<LOGGER_AJAX_RETRY_MAX);},LOGGER_AJAX_RETRY_TIMEOUT);}var doAjaxRequest=function doAjaxRequest(shouldRetry){requestNumber++;if(requestNumber>1){data.isRetry=true;}__WEBPACK_IMPORTED_MODULE_8_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_6__config__["_70" /* loggerConfig */].endpoint,data).then(function(){if(resolvedLocalStorageItemId){// We remove retried and type=parsed items from localStorage once axios.then() is here triggered
// and not earlier as user can hit refresh during retrying so log would be lost
deleteItemFromErrorQueue(resolvedLocalStorageItemId);}})["catch"](function(error){if(shouldRetry&&requestNumber<=LOGGER_AJAX_RETRY_MAX){onRetry();}else{resolvedLocalStorageItemId&&flagItemInErrorQueuBeingSentStatus(resolvedLocalStorageItemId,false);//console.log('Logger: XHR failed');
}});};// Retry sending only errors (have errorId), ignore REJECTED_API_STATUS_REQUEST
var shouldRetry=data.errorId&&!isRejectedAPiStatusRequest(data);doAjaxRequest(shouldRetry);}function isRejectedAPiStatusRequest(obj){return obj.errorId===__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].REJECTED_API_STATUS_REQUEST||obj.previousMessageId===__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].REJECTED_API_STATUS_REQUEST;}function isAdditionalDetailsMessage(obj){return obj&&obj.message&&obj.message.includes('additional details');}function isLocalStorageQuoateExceeded(e){// In case of exception, try saving last error
return e instanceof DOMException&&(// everything except Firefox
e.code===22||// Firefox
e.code===1014||// test name field too, because code might not be present
// everything except Firefox
e.name==='QuotaExceededError'||// Firefox
e.name==='NS_ERROR_DOM_QUOTA_REACHED')&&// acknowledge QuotaExceededError only if there's something already stored
window.localStorage&&window.localStorage.length!==0;}function initBrowserDetails(){try{browserId=parseInt(window.localStorage.getItem('camonlineBrowserId'));if(!browserId){browserId=Date.now();window.localStorage.setItem('camonlineBrowserId',browserId);}}catch(ex){browserId='unavailable';}try{browserTabId=parseInt(window.sessionStorage.getItem('camonlineBrowserTabId'));if(!browserTabId){browserTabId=Date.now();window.sessionStorage.setItem('camonlineBrowserTabId',browserTabId);}}catch(ex){browserTabId='unavailable';}try{lastAuthorizedUserEmail=window.localStorage.getItem('camonlineLastAuthorizedUserEmail')||'unavailable';}catch(ex){lastAuthorizedUserEmail='unavailable';}}var componentsCache={};var API={get:function get(componentName){var log=function log(){};// if logger has been already created then return it
if(componentsCache[componentName]){return componentsCache[componentName];}/**
			*
			* @param {object | string} info If this is an error log, it MUST include errorId field as part of the object
			* @param {*} forceSilentMessageType Force use silent message type
		*/log.send=function(info,forceSilentMessageType/*includeItems*/,pastTimestamp,pastBrowserId,pastBrowserTabId,pastLastAuthorizedUserEmail){info=sendToServer.call(this,info,forceSilentMessageType/*includeItems*/,pastTimestamp,pastBrowserId,pastBrowserTabId,pastLastAuthorizedUserEmail);};componentsCache[componentName]=log;return log;}};function getErrorQueue(){var errorQueueFromStorage=window.localStorage.getItem(ERROR_QUEUE_STORAGE_KEY);var errorQueue=!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(errorQueueFromStorage)?JSON.parse(errorQueueFromStorage):[];return errorQueue;}function saveErrorQueue(errorQueue){try{window.localStorage.setItem(ERROR_QUEUE_STORAGE_KEY,JSON.stringify(errorQueue));return true;}catch(e){if(isLocalStorageQuoateExceeded(e)){errorQueue=[];window.localStorage.setItem(ERROR_QUEUE_STORAGE_KEY,JSON.stringify(errorQueue));}return false;}}function flagItemInErrorQueuBeingSentStatus(id,status){var errorQueue=getErrorQueue();if(!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(errorQueue)){for(var i=errorQueue.length-1;i>=0;i--){if(id==='all'||errorQueue[i].id===id){errorQueue[i].isBeingSent=status;}}saveErrorQueue(errorQueue);}}function deleteItemFromErrorQueue(id){var errorQueue=getErrorQueue();if(!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(errorQueue)){for(var i=errorQueue.length-1;i>=0;i--){if(errorQueue[i].id===id){delete errorQueue[i];}}errorQueue=errorQueue.filter(function(item){return item!==null;});saveErrorQueue(errorQueue);}}function sendLogsFromLocalStorageToELK(){var errorQueue=getErrorQueue();if(!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(errorQueue)){var deletedItems=[];for(var i=errorQueue.length-1;i>=0;i--){var pastError=errorQueue[i];if(!pastError.isBeingSent){if(__WEBPACK_IMPORTED_MODULE_6__config__["_22" /* REACT_APP_BUILD_NUMBER */]===pastError.buildNumber){pastError.packet.isRetry=true;sendViaHttp(pastError.packet,pastError.id);}else{// If buildNumber is different, delete item from localstorage as there could be incompatibility
// between older item saved to localStorage and logger logic
deletedItems.push(pastError.id);}}}// We remove type=raw items from localStorage here as these items will be saved as type=parsed
// in localStorage again if ajax request fails
deletedItems.forEach(function(id){deleteItemFromErrorQueue(id);});}}/* harmony default export */ __webpack_exports__["a"] = (API);var setupLogger=function setupLogger(userData,companyId,isPayingCompany){initUserInfo(userData,companyId,isPayingCompany);clearSavedIsBeingSentState();sendLogsFromLocalStorageToELK();};

/***/ }),
/* 41 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return trackUserAdd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return trackUserDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return trackUserEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return trackAddTeamFolder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return trackClickSubscriptionUpgrade; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return trackSubscriptionSuccessful; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return trackVisitedReactivateRouteFromEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return trackVisitedPlusOverview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return trackVisitedPerpetualOverview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return trackVisitedStandardOverview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return trackVisitedRealEstateOverview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return trackRouteMagixDiscount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return trackRouteUpgradePopupDiscount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return trackRouteRealEstatePlanPopup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return trackRouteCouponDiscount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return trackRouteDesktopAppUpgrade; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return trackRouteSource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return trackApplyCouponClicked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return trackActiveOfferLinkClicked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return trackDownloadsAsProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return trackDownloadedProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return trackWrongAccountScreen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return trackWrongAccountScreenUseExistingAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return trackWrongAccountScreenSwitchAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return trackDiscountCouponShown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return trackDiscountCouponError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return trackInvalidSerial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return trackEmailSerialMissmatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return trackContactSalesPopupShown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return trackAddUsersPopupShown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return trackAddMlsConnectionPopupShown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return trackConnectedMlsWithOfficeIdSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return trackConnectedMlsWithAgentIdSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return trackSentConnectionRequestToXaraSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return trackSentReviewMlsToXaraSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return trackConnectedMlsWithOfficeIdFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return trackConnectedMlsWithAgentIdFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return trackSentConnectionRequestToXaraFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return trackSentReviewMlsToXaraFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return trackAddMlsOfficePopupShown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return trackAddMlsOfficeSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return trackAddMlsOfficeFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return trackManageAgentMlsPopupShown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return trackManageAgentMlsPopupAddUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return trackMlsConfirmAgentValidity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return trackConfirmPurchaseChoicePopupShown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return trackBuyMoreSeatsPopupShown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return trackBuyMoreLicensesPopupShown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return trackReduceUsersModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return trackReducedUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return trackQuantityChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return trackCategoryChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return trackDurationChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return trackUsersLimitReachedOnNonPayingAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return trackPaywallConverstion; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_subscription__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__logger_logger__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__errors_apperror__ = __webpack_require__(34);
var log=__WEBPACK_IMPORTED_MODULE_5__logger_logger__["a" /* default */].get('CustomTrackers');function getCurrentTimestampInSeconds(){var currentMs=new Date().getTime();return Math.floor(currentMs/1000);}var getPlanNameForTracking=function getPlanNameForTracking(plan){return plan===__WEBPACK_IMPORTED_MODULE_4__config__["_42" /* SUBSCRIPTION_PLAN */].TEAM_PLUS?__WEBPACK_IMPORTED_MODULE_4__config__["_42" /* SUBSCRIPTION_PLAN */].SCALE:plan;};// USERS AND PERMISSIONS
var trackUserAdd=function trackUserAdd(users,options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-add-users',{total:users.length},options);};var trackUserDelete=function trackUserDelete(user,options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])("cap-delete-".concat(user.trackingName.toLowerCase()),user,options);};var trackUserEdit=function trackUserEdit(previousUser,updatedUser,options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-change-user-role',updatedUser,options);};// TEAM FOLDERS
var trackAddTeamFolder=function trackAddTeamFolder(folder,options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])("cap-add-".concat(folder.type,"-team-folder"),folder,options);};// SUBSCRIPTION
var trackClickSubscriptionUpgrade=function trackClickSubscriptionUpgrade(plan,period,isPerpetual,options){var metaData={plan:plan===__WEBPACK_IMPORTED_MODULE_4__config__["_42" /* SUBSCRIPTION_PLAN */].TEAM_PLUS?__WEBPACK_IMPORTED_MODULE_4__config__["_42" /* SUBSCRIPTION_PLAN */].SCALE:plan,period:isPerpetual?'perpetual':period};Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])("cap-click-".concat(getPlanNameForTracking(plan),"-do-checkout"),metaData,options);};var trackSubscriptionSuccessful=function trackSubscriptionSuccessful(companyId,currentPlanId,eventName,options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])("cap-".concat(eventName,"-successful"),null,options);// Ecommerce tracking
try{var activeSubscription=Object(__WEBPACK_IMPORTED_MODULE_3__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(currentPlanId);var plan=activeSubscription.plan,period=activeSubscription.period,currency=activeSubscription.currency;var currentPrice=__WEBPACK_IMPORTED_MODULE_4__config__["_44" /* SUBSCRIPTION_PRICES */][plan][period];if(period===__WEBPACK_IMPORTED_MODULE_4__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL){currentPrice*=12;}var planName=getPlanNameForTracking(plan);Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["f" /* trackEcommerceData */])('Order Completed',{// Keep this name, see https://segment.com/docs/connections/spec/ecommerce/v2/
order_id:"".concat(companyId,"-").concat(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.now()),currency:__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toUpper(currency),total:parseFloat(currentPrice),products:[{category:planName,name:"".concat(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.upperFirst(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toLower(planName))," ").concat(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.upperFirst(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toLower(period))),price:parseFloat(currentPrice),product_id:"".concat(planName,"-").concat(period),quantity:1,sku:"".concat(planName,"-").concat(period)}]});}catch(error){var nError=new __WEBPACK_IMPORTED_MODULE_7__errors_apperror__["a" /* default */]({message:'trackSubscriptionSuccessful() failed',errorId:__WEBPACK_IMPORTED_MODULE_6_errors_errorids__["a" /* default */].UNKNOWN,originalError:error,visualisers:{feature:'CHARGEBEE'},errorDetails:{currentPlanId:currentPlanId}});log.send(nError);}};var trackVisitedReactivateRouteFromEmail=function trackVisitedReactivateRouteFromEmail(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-visited-reactivate-route-from-email',null,options);};var trackVisitedPlusOverview=function trackVisitedPlusOverview(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-visited-plus-overview',null,options);};var trackVisitedPerpetualOverview=function trackVisitedPerpetualOverview(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-visited-perpetual-overview',null,options);};var trackVisitedStandardOverview=function trackVisitedStandardOverview(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-visited-standard-overview',null,options);};var trackVisitedRealEstateOverview=function trackVisitedRealEstateOverview(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-visited-real-estate-overview',null,options);};var trackRouteMagixDiscount=function trackRouteMagixDiscount(prodCat,options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-entered-route-magix-discount',{prodCat:prodCat},options);};var trackRouteUpgradePopupDiscount=function trackRouteUpgradePopupDiscount(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-entered-route-upgrade-popup-discount',null,options);};var trackRouteRealEstatePlanPopup=function trackRouteRealEstatePlanPopup(plan,options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-entered-route-real-estate-plan',{plan:plan},options);};var trackRouteCouponDiscount=function trackRouteCouponDiscount(cid,options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-entered-route-coupon',{cid:cid},options);};var trackRouteDesktopAppUpgrade=function trackRouteDesktopAppUpgrade(productName,options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-entered-route-desktop-app-upgrade',{productName:productName},options);};var trackRouteSource=function trackRouteSource(productName,productSource,options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])("cap-entered-route-".concat(productSource),{productName:productName},options);};var trackApplyCouponClicked=function trackApplyCouponClicked(coupon,options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-apply-coupon-clicked',{coupon:coupon},options);};var trackActiveOfferLinkClicked=function trackActiveOfferLinkClicked(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-active-offer-link-clicked',null,options);};// DESKTOP_APPS
var trackDownloadsAsProperty=function trackDownloadsAsProperty(companyName,key,options){var _identify;Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["b" /* identify */])((_identify={},__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_identify,"".concat(key,"-downloaded-on"),getCurrentTimestampInSeconds()),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_identify,"".concat(key,"-download-company"),companyName),_identify),options);};var trackDownloadedProduct=function trackDownloadedProduct(trackingKey,options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-downloaded-product',{product:trackingKey},options);};// WRONG ACCOUNT SCREEN
var trackWrongAccountScreen=function trackWrongAccountScreen(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-wrong-account-screen-shown',null,options);};var trackWrongAccountScreenUseExistingAccount=function trackWrongAccountScreenUseExistingAccount(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-wrong-account-screen-use-existing-account',null,options);};var trackWrongAccountScreenSwitchAccount=function trackWrongAccountScreenSwitchAccount(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-wrong-account-screen-use-switch-account',null,options);};// Discount Dialog
var trackDiscountCouponShown=function trackDiscountCouponShown(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-discount-coupon-shown',null,options);};var trackDiscountCouponError=function trackDiscountCouponError(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-discount-coupon-error',null,options);};var trackInvalidSerial=function trackInvalidSerial(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-magix-validation-invalid-serial',null,options);};var trackEmailSerialMissmatch=function trackEmailSerialMissmatch(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-magix-validation-email-serial-missmatch',null,options);};/* Contact Sales Modal */var trackContactSalesPopupShown=function trackContactSalesPopupShown(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-contact-sales-modal-shown',null,options);};/* Add Users Modal */var trackAddUsersPopupShown=function trackAddUsersPopupShown(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-add-users-modal-shown',null,options);};/* Add MLS Connection Modal */var trackAddMlsConnectionPopupShown=function trackAddMlsConnectionPopupShown(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-connect-mls-popup-opened',null,options);};var trackConnectedMlsWithOfficeIdSuccess=function trackConnectedMlsWithOfficeIdSuccess(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-connected-mls-with-office-id-success',null,options);};var trackConnectedMlsWithAgentIdSuccess=function trackConnectedMlsWithAgentIdSuccess(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-connected-mls-with-agent-id-success',null,options);};var trackSentConnectionRequestToXaraSuccess=function trackSentConnectionRequestToXaraSuccess(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-mls-connection-request-form-success',null,options);};var trackSentReviewMlsToXaraSuccess=function trackSentReviewMlsToXaraSuccess(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-mls-review-ids-form-success',null,options);};var trackConnectedMlsWithOfficeIdFailure=function trackConnectedMlsWithOfficeIdFailure(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-connect-mls-with-office-id-failed',null,options);};var trackConnectedMlsWithAgentIdFailure=function trackConnectedMlsWithAgentIdFailure(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-connect-mls-with-agent-id-failed',null,options);};var trackSentConnectionRequestToXaraFailure=function trackSentConnectionRequestToXaraFailure(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-mls-connection-request-form-failed',null,options);};var trackSentReviewMlsToXaraFailure=function trackSentReviewMlsToXaraFailure(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-mls-review-ids-form-failed',null,options);};/* Add MLS Office Modal */var trackAddMlsOfficePopupShown=function trackAddMlsOfficePopupShown(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-add-mls-office-popup-opened',null,options);};var trackAddMlsOfficeSuccess=function trackAddMlsOfficeSuccess(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-add-mls-office-success',null,options);};var trackAddMlsOfficeFailure=function trackAddMlsOfficeFailure(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-add-mls-office-failed',null,options);};/* Manage Agent Ids Popup opened */var trackManageAgentMlsPopupShown=function trackManageAgentMlsPopupShown(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-manage-agents-mls-popup-opened',null,options);};/* Manage Agent Ids Popup - click on Add users */var trackManageAgentMlsPopupAddUsers=function trackManageAgentMlsPopupAddUsers(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-add-users-in-agents-mls-popup-clicked',null,options);};/* Manage Agent Ids Popup - confirm agent mls id validity */var trackMlsConfirmAgentValidity=function trackMlsConfirmAgentValidity(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-mls-confirmed-agents-mls-id-validity',null,options);};/* Confirm Purchase Choice popup */var trackConfirmPurchaseChoicePopupShown=function trackConfirmPurchaseChoicePopupShown(plan,options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-confirm-purchase-choice-popup-shown',{plan:getPlanNameForTracking(plan)},options);};/* Buy more seats / licenses */var trackBuyMoreSeatsPopupShown=function trackBuyMoreSeatsPopupShown(plan,options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-buy-more-seats-popup-shown',{plan:getPlanNameForTracking(plan)},options);};var trackBuyMoreLicensesPopupShown=function trackBuyMoreLicensesPopupShown(plan,options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-buy-more-licenses-popup-shown',{plan:getPlanNameForTracking(plan)},options);};/* Reduce users */var trackReduceUsersModal=function trackReduceUsersModal(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-reduce-users-popup-shown',null,options);};var trackReducedUsers=function trackReducedUsers(nrOfUsersToTurnToGuest,nrOfUsersToDelete,options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-reduced-users',{nrOfUsersToTurnToGuest:nrOfUsersToTurnToGuest,nrOfUsersToDelete:nrOfUsersToDelete},options);Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["g" /* trackReducedUsersData */])(nrOfUsersToTurnToGuest,nrOfUsersToDelete,options);};// Plan configurator change
var trackQuantityChange=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function(quantityType,value,options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])("cap-change-quantity-".concat(quantityType),{quantity:value},options);Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["e" /* trackConfiguratorQuantity */])(quantityType,value,options);},1000);var trackCategoryChange=function trackCategoryChange(category,options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])("cap-category-change-".concat(category.toLowerCase().replace(/ /g,'-')),null,options);};var trackDurationChange=function trackDurationChange(period,options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])("cap-duration-change-".concat(period),null,options);};var trackUsersLimitReachedOnNonPayingAccount=function trackUsersLimitReachedOnNonPayingAccount(options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('cap-users-limit-reached-non-paying-account',null,options);};var trackPaywallConverstion=function trackPaywallConverstion(plan,companyId,options){Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* track */])('paywall-conversion',{plan:plan,companyId:companyId},options);};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(32);
var IE8_DOM_DEFINE = __webpack_require__(305);
var toPrimitive = __webpack_require__(100);
var dP = Object.defineProperty;

exports.f = __webpack_require__(47) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(659);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_158", function() { return SOCKET_EMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_159", function() { return SOCKET_SUBSCRIBE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_151", function() { return SESSION_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_153", function() { return SESSION_FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_152", function() { return SESSION_FETCH_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_190", function() { return VERIFY_ACCOUNT_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_192", function() { return VERIFY_ACCOUNT_FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_191", function() { return VERIFY_ACCOUNT_FETCH_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_193", function() { return VERIFY_ACCOUNT_RESEND_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_195", function() { return VERIFY_ACCOUNT_RESEND_FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_194", function() { return VERIFY_ACCOUNT_RESEND_FETCH_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_186", function() { return USER_SETTING_WRITE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_188", function() { return USER_SETTING_WRITE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_187", function() { return USER_SETTING_WRITE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return DESKTOP_APP_FLAG_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return DESKTOP_APP_FLAG_GET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_155", function() { return SHOW_ALL_PACKAGES_FLAG_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_177", function() { return UPGRADE_POPUP_FLAG_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_134", function() { return PENDING_TRIGGER_CHECKOUT_FLAG_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return COUPON_ID_PROVIDED_FLAG_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_135", function() { return PERPETUAL_APP_FLAG_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return DESKTOP_TRIAL_FLAG_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return DESKTOP_RE_ACCESS_NO_INDUSTRY_FLAG_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_144", function() { return RENEWAL_POPUP_SHOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return COUPON_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return COUPON_FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return COUPON_FETCH_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return COUPON_APPLY_WITHOUT_VALIDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return COUPON_CHANGE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return COUPON_CHANGE_MAGIX_DISCOUNT_PRODUCT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return COMPANIES_GET_ACTIVE_COMPANY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return COMPANIES_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return COMPANIES_VALIDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return COMPANIES_VALIDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return COMPANIES_VALIDATE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return COMPANIES_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return COMPANIES_ADD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return COMPANIES_ADD_FAIL; });
/* unused harmony export COMPANIES_REMOVE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return COMPANIES_REMOVE_SUCCESS; });
/* unused harmony export COMPANIES_REMOVE_FAIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return COMPANIES_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return COMPANIES_CHANGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return COMPANIES_USER_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return COMPANIES_USER_ADD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return COMPANIES_USER_ADD_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return COMPANIES_ESTIMATE_USER_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return COMPANIES_ESTIMATE_USER_ADD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return COMPANIES_ESTIMATE_USER_ADD_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return COMPANIES_ESTIMATE_SEAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return COMPANIES_ESTIMATE_SEAT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return COMPANIES_ESTIMATE_SEAT_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return COMPANIES_PURCHASE_SEAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return COMPANIES_PURCHASE_SEAT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return COMPANIES_PURCHASE_SEAT_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return COMPANIES_USER_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return COMPANIES_USER_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return COMPANIES_USER_UPDATE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return COMPANIES_USERS_REDUCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return COMPANIES_USERS_REDUCE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return COMPANIES_USERS_REDUCE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return COMPANIES_ESTIMATE_USER_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return COMPANIES_ESTIMATE_USER_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return COMPANIES_ESTIMATE_USER_UPDATE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return COMPANIES_USER_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return COMPANIES_USER_DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return COMPANIES_USER_DELETE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return COMPANIES_ESTIMATE_USER_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return COMPANIES_ESTIMATE_USER_DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return COMPANIES_ESTIMATE_USER_DELETE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return COMPANIES_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return COMPANIES_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return COMPANIES_UPDATE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return COMPANIES_INVITE_USER_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return COMPANIES_INVITE_USER_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return COMPANIES_INVITE_USER_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return COMPANIES_INVITE_USER_MESSAGE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return COMPANIES_INVITE_USER_CLEAR_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return COMPANIES_INVITE_USER_CLEAR_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return COMPANIES_GET_CURRENT_MEMBER_ADDON_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return COMPANIES_GET_CURRENT_MEMBER_ADDON_DETAILS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return COMPANIES_GET_CURRENT_MEMBER_ADDON_DETAILS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return COMPANIES_CLEAR_CURRENT_MEMBER_ADDON_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return COMPANIES_CONTACT_SALES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return COMPANIES_CONTACT_SALES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return COMPANIES_CONTACT_SALES_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return COMPANIES_CONNECT_MLS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return COMPANIES_CONNECT_MLS_REQUEST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return COMPANIES_CONNECT_MLS_REQUEST_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return COMPANIES_REVIEW_MLS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return COMPANIES_REVIEW_MLS_REQUEST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return COMPANIES_REVIEW_MLS_REQUEST_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return COMPANIES_UPDATE_USER_PHOTO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return COMPANIES_UPDATE_USER_PHOTO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return COMPANIES_UPDATE_USER_PHOTO_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_111", function() { return MLS_CLEAR_CONNECT_FORM_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_112", function() { return MLS_CLEAR_ERROR_FOR_CONNECTION_AND_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_102", function() { return MLS_ADD_CONNECTION_WITH_OFFICE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_104", function() { return MLS_ADD_CONNECTION_WITH_OFFICE_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_103", function() { return MLS_ADD_CONNECTION_WITH_OFFICE_ID_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return MLS_ADD_CONNECTION_WITH_AGENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_101", function() { return MLS_ADD_CONNECTION_WITH_AGENT_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return MLS_ADD_CONNECTION_WITH_AGENT_ID_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_125", function() { return MLS_GET_CONNECTIONS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_127", function() { return MLS_GET_CONNECTIONS_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_126", function() { return MLS_GET_CONNECTIONS_LIST_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_122", function() { return MLS_GET_AGENTS_FOR_OFFICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_124", function() { return MLS_GET_AGENTS_FOR_OFFICE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_123", function() { return MLS_GET_AGENTS_FOR_OFFICE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_108", function() { return MLS_BOARD_LIST_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_110", function() { return MLS_BOARD_LIST_FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_109", function() { return MLS_BOARD_LIST_FETCH_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_113", function() { return MLS_CONNECTION_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_115", function() { return MLS_CONNECTION_DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_114", function() { return MLS_CONNECTION_DELETE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_128", function() { return MLS_OFFICE_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_130", function() { return MLS_OFFICE_DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_129", function() { return MLS_OFFICE_DELETE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_105", function() { return MLS_ADD_OFFICE_TO_CONNECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_107", function() { return MLS_ADD_OFFICE_TO_CONNECTION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_106", function() { return MLS_ADD_OFFICE_TO_CONNECTION_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return MLS_ADD_AGENT_MLS_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return MLS_ADD_AGENT_MLS_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return MLS_ADD_AGENT_MLS_ID_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_116", function() { return MLS_DELETE_AGENT_MLS_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_118", function() { return MLS_DELETE_AGENT_MLS_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_117", function() { return MLS_DELETE_AGENT_MLS_ID_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_119", function() { return MLS_EDIT_AGENT_MLS_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_121", function() { return MLS_EDIT_AGENT_MLS_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_120", function() { return MLS_EDIT_AGENT_MLS_ID_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return LIST_AGENT_MLS_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return LIST_AGENT_MLS_IDS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return LIST_AGENT_MLS_IDS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_146", function() { return RESOLVE_MLS_UI_TYPE; });
/* unused harmony export USER_UPDATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_189", function() { return USER_UPDATE_SUCCESS; });
/* unused harmony export USER_UPDATE_FAIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_179", function() { return USER_EXTERNAL_ID_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_181", function() { return USER_EXTERNAL_ID_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_180", function() { return USER_EXTERNAL_ID_UPDATE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_178", function() { return USER_EXTERNAL_ID_STATE_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_183", function() { return USER_REGION_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_185", function() { return USER_REGION_FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_184", function() { return USER_REGION_FETCH_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ADDON_GET_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return ADDON_GET_DETAILS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return ADDON_GET_DETAILS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_174", function() { return UPCOMING_INVOICE_GET_ESTIMATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_176", function() { return UPCOMING_INVOICE_GET_ESTIMATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_175", function() { return UPCOMING_INVOICE_GET_ESTIMATE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_164", function() { return SUBSCRIPTION_GET_ESTIMATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_169", function() { return SUBSCRIPTION_GET_ESTIMATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_168", function() { return SUBSCRIPTION_GET_ESTIMATE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_165", function() { return SUBSCRIPTION_GET_ESTIMATE_ACTIVE_PLAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_167", function() { return SUBSCRIPTION_GET_ESTIMATE_ACTIVE_PLAN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_166", function() { return SUBSCRIPTION_GET_ESTIMATE_ACTIVE_PLAN_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ACCOUNT_EMAIL_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ACCOUNT_EMAIL_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ACCOUNT_EMAIL_UPDATE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ACCOUNT_NAME_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ACCOUNT_NAME_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ACCOUNT_NAME_UPDATE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ACCOUNT_PASSWORD_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ACCOUNT_PASSWORD_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ACCOUNT_PASSWORD_UPDATE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ACCOUNT_PASSWORD_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ACCOUNT_PASSWORD_RESET_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ACCOUNT_PASSWORD_RESET_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCOUNT_CHECK_CREDENTIALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ACCOUNT_CHECK_CREDENTIALS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACCOUNT_CHECK_CREDENTIALS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return CRS_CHECK_CREDENTIALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return CRS_CHECK_CREDENTIALS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return CRS_CHECK_CREDENTIALS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return CRS_CLEAR_CREDENTIALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return CRS_SAVE_TAKEOVER_CREDENTIALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return CRS_USAGE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return CRS_USAGE_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return CRS_USAGE_UPDATE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return DISCOUNT_CLEAR_APPLIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return DISCOUNT_APPLY_MAGIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return DISCOUNT_APPLY_COUPON_SET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_140", function() { return REDUCE_USERS_API_ERROR_STATE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_139", function() { return REDUCE_USERS_API_ERROR_STATE_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_154", function() { return SET_USER_SUPPLIED_PROMO_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return COMPANIES_CREATE_CHARGEBEE_SESSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return COMPANIES_CREATE_CHARGEBEE_SESSION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return COMPANIES_CREATE_CHARGEBEE_SESSION_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return COMPANIES_CREATE_CHARGEBEE_SUBSCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return COMPANIES_CREATE_CHARGEBEE_SUBSCRIPTION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return COMPANIES_CREATE_CHARGEBEE_SUBSCRIPTION_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return COMPANIES_INDUSTRIES_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return COMPANIES_INDUSTRIES_FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return COMPANIES_INDUSTRIES_FETCH_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return COMPANIES_SIZES_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return COMPANIES_SIZES_FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return COMPANIES_SIZES_FETCH_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return COMPANIES_COUNTRIES_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return COMPANIES_COUNTRIES_FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return COMPANIES_COUNTRIES_FETCH_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return COMPANIES_FONT_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return COMPANIES_FONT_ADD_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return COMPANIES_FONT_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return COMPANIES_FONT_REMOVE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return COMPANIES_SMART_FIELDS_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return COMPANIES_SMART_FIELDS_UPDATE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return COMPANIES_SETTING_WRITE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return COMPANIES_SETTING_WRITE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return COMPANIES_SETTING_WRITE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_205", function() { return WORKSPACE_VALIDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_207", function() { return WORKSPACE_VALIDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_206", function() { return WORKSPACE_VALIDATE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_196", function() { return WORKSPACE_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_198", function() { return WORKSPACE_ADD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_197", function() { return WORKSPACE_ADD_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_202", function() { return WORKSPACE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_204", function() { return WORKSPACE_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_203", function() { return WORKSPACE_UPDATE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_199", function() { return WORKSPACE_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_201", function() { return WORKSPACE_DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_200", function() { return WORKSPACE_DELETE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return ERROR_HANDLER_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return ERROR_HANDLER_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_133", function() { return MODAL_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_131", function() { return MODAL_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_132", function() { return MODAL_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return FOLDER_GET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return FOLDER_GET_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return FOLDER_GET_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return FOLDER_SET_PARENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_141", function() { return REMOVE_COMPANY_FOLDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_143", function() { return REMOVE_COMPANY_FOLDER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_142", function() { return REMOVE_COMPANY_FOLDER_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return FOLDER_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return FOLDER_ADD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return FOLDER_ADD_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return FOLDER_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return FOLDER_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return FOLDER_UPDATE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return FOLDER_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return FOLDER_DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return FOLDER_DELETE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_145", function() { return REQUEST_FINISHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_137", function() { return QUICK_MESSAGE_ENQUEUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_138", function() { return QUICK_MESSAGE_FADE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_136", function() { return QUICK_MESSAGE_DEQUEUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_157", function() { return SHOW_PRELOADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return HIDE_PRELOADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_156", function() { return SHOW_CB_LOADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return HIDE_CB_LOADER; });
/* unused harmony export SHOW_PROCESSING_ORDER */
/* unused harmony export HIDE_PROCESSING_ORDER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_148", function() { return SEND_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_150", function() { return SEND_EMAIL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_149", function() { return SEND_EMAIL_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_161", function() { return SUBSCRIPTION_CATEGORY_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_170", function() { return SUBSCRIPTION_PERIOD_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_163", function() { return SUBSCRIPTION_CURRENCY_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_162", function() { return SUBSCRIPTION_CLEAR_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_171", function() { return SUBSCRIPTION_PERPETUAL_OVERVIEW_PAGE_VISITED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_172", function() { return SUBSCRIPTION_PLUS_OVERVIEW_PAGE_VISITED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_173", function() { return SUBSCRIPTION_VIEW_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_160", function() { return SUBSCRIPTION_BATCH_PARAMS_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_147", function() { return SEATS_QUANTITY_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return LICENSES_QUANTITY_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_182", function() { return USER_REDUCE_UPDATE; });
// SOCKET
var SOCKET_EMIT='SOCKET:EMIT';var SOCKET_SUBSCRIBE='SOCKET:SUBSCRIBE';// SESSION
var SESSION_FETCH='SESSION:FETCH';var SESSION_FETCH_SUCCESS='SESSION:FETCH_SUCCESS';var SESSION_FETCH_FAIL='SESSION:FETCH_FAIL';var VERIFY_ACCOUNT_FETCH='VERIFY:ACCOUNT_FETCH';var VERIFY_ACCOUNT_FETCH_SUCCESS='VERIFY:ACCOUNT_FETCH_SUCCESS';var VERIFY_ACCOUNT_FETCH_FAIL='VERIFY:ACCOUNT_FETCH_FAIL';var VERIFY_ACCOUNT_RESEND_FETCH='VERIFY:ACCOUNT_RESEND_FETCH';var VERIFY_ACCOUNT_RESEND_FETCH_SUCCESS='VERIFY:ACCOUNT_RESEND_FETCH_SUCCESS';var VERIFY_ACCOUNT_RESEND_FETCH_FAIL='VERIFY:ACCOUNT_RESEND_FETCH_FAIL';var USER_SETTING_WRITE='USER:SETTING_WRITE';var USER_SETTING_WRITE_SUCCESS='USER:SETTING_WRITE_SUCCESS';var USER_SETTING_WRITE_FAIL='USER:SETTING_WRITE_FAIL';// APP
var DESKTOP_APP_FLAG_SET='APP:DESKTOP_APP_FLAG_SET';var DESKTOP_APP_FLAG_GET='APP:DESKTOP_APP_FLAG_GET';var SHOW_ALL_PACKAGES_FLAG_SET='APP:SHOW_ALL_PACKAGES_FLAG_SET';var UPGRADE_POPUP_FLAG_SET='APP:UPGRADE_POPUP_FLAG_SET';var PENDING_TRIGGER_CHECKOUT_FLAG_SET='APP:PENDING_TRIGGER_CHECKOUT_FLAG_SET';var COUPON_ID_PROVIDED_FLAG_SET='APP:COUPON_ID_PROVIDED_FLAG_SET';var PERPETUAL_APP_FLAG_SET='APP:PERPETUAL_APP_FLAG_SET';var DESKTOP_TRIAL_FLAG_SET='APP:DESKTOP_TRIAL_FLAG_SET';var DESKTOP_RE_ACCESS_NO_INDUSTRY_FLAG_SET='APP:DESKTOP_RE_ACCESS_NO_INDUSTRY_FLAG_SET';var RENEWAL_POPUP_SHOWN='APP:RENEWAL_POPUP_SHOWN';// COUPON
var COUPON_FETCH='COUPON:FETCH';var COUPON_FETCH_SUCCESS='COUPON:FETCH:SUCCESS';var COUPON_FETCH_FAIL='COUPON:FETCH:FAIL';var COUPON_APPLY_WITHOUT_VALIDATION='COUPON:APPLY_WITHOUT_VALIDATION:SUCCESS';var COUPON_CHANGE_TYPE='COUPON:CHANGE_TYPE:SUCCESS';var COUPON_CHANGE_MAGIX_DISCOUNT_PRODUCT_TYPE='COUPON:COUPON_CHANGE_MAGIX_DISCOUNT_PRODUCT_TYPE:SUCCESS';// COMPANIES
var COMPANIES_GET_ACTIVE_COMPANY_ID='COMPANIES:GET_ACTIVE_COMPANY_ID';var COMPANIES_SET='COMPANIES:SET';var COMPANIES_VALIDATE='COMPANIES:VALIDATE';var COMPANIES_VALIDATE_SUCCESS='COMPANIES:VALIDATE_SUCCESS';var COMPANIES_VALIDATE_FAIL='COMPANIES:VALIDATE_FAIL';var COMPANIES_ADD='COMPANIES:ADD';var COMPANIES_ADD_SUCCESS='COMPANIES:ADD_SUCCESS';var COMPANIES_ADD_FAIL='COMPANIES:ADD_FAIL';var COMPANIES_REMOVE='COMPANIES:REMOVE';var COMPANIES_REMOVE_SUCCESS='COMPANIES:REMOVE_SUCCESS';var COMPANIES_REMOVE_FAIL='COMPANIES:REMOVE_FAIL';var COMPANIES_CHANGE='COMPANIES:CHANGE';var COMPANIES_CHANGED='COMPANIES:CHANGED';var COMPANIES_USER_ADD='COMPANIES:USER:ADD';var COMPANIES_USER_ADD_SUCCESS='COMPANIES:USER:ADD_SUCCESS';var COMPANIES_USER_ADD_FAIL='COMPANIES:USER:ADD_FAIL';var COMPANIES_ESTIMATE_USER_ADD='COMPANIES:ESTIMATE:USER:ADD';var COMPANIES_ESTIMATE_USER_ADD_SUCCESS='COMPANIES:ESTIMATE:USER:ADD_SUCCESS';var COMPANIES_ESTIMATE_USER_ADD_FAIL='COMPANIES:ESTIMATE:USER:ADD_FAIL';var COMPANIES_ESTIMATE_SEAT='COMPANIES:ESTIMATE:SEAT';var COMPANIES_ESTIMATE_SEAT_SUCCESS='COMPANIES:ESTIMATE:SEAT:SUCCESS';var COMPANIES_ESTIMATE_SEAT_FAIL='COMPANIES:ESTIMATE:SEAT:FAIL';var COMPANIES_PURCHASE_SEAT='COMPANIES:PURCHASE:SEAT';var COMPANIES_PURCHASE_SEAT_SUCCESS='COMPANIES:PURCHASE:SEAT:SUCCESS';var COMPANIES_PURCHASE_SEAT_FAIL='COMPANIES:PURCHASE:SEAT:FAIL';var COMPANIES_USER_UPDATE='COMPANIES:USER:UPDATE';var COMPANIES_USER_UPDATE_SUCCESS='COMPANIES:USER:UPDATE_SUCCESS';var COMPANIES_USER_UPDATE_FAIL='COMPANIES:USER:UPDATE_FAIL';var COMPANIES_USERS_REDUCE='COMPANIES:USER:REDUCE';var COMPANIES_USERS_REDUCE_SUCCESS='COMPANIES:USER:REDUCE_SUCCESS';var COMPANIES_USERS_REDUCE_FAIL='COMPANIES:USER:REDUCE_FAIL';var COMPANIES_ESTIMATE_USER_UPDATE='COMPANIES:ESTIMATE:USER:UPDATE';var COMPANIES_ESTIMATE_USER_UPDATE_SUCCESS='COMPANIES:ESTIMATE:USER:UPDATE_SUCCESS';var COMPANIES_ESTIMATE_USER_UPDATE_FAIL='COMPANIES:ESTIMATE:USER:UPDATE_FAIL';var COMPANIES_USER_DELETE='COMPANIES:USER:DELETE';var COMPANIES_USER_DELETE_SUCCESS='COMPANIES:USER:DELETE_SUCCESS';var COMPANIES_USER_DELETE_FAIL='COMPANIES:USER:DELETE_FAIL';var COMPANIES_ESTIMATE_USER_DELETE='COMPANIES:ESTIMATE:USER:DELETE';var COMPANIES_ESTIMATE_USER_DELETE_SUCCESS='COMPANIES:ESTIMATE:USER:DELETE_SUCCESS';var COMPANIES_ESTIMATE_USER_DELETE_FAIL='COMPANIES:ESTIMATE:USER:DELETE_FAIL';var COMPANIES_UPDATE='COMPANIES:UPDATE';var COMPANIES_UPDATE_SUCCESS='COMPANIES:UPDATE_SUCCESS';var COMPANIES_UPDATE_FAIL='COMPANIES:UPDATE_FAIL';var COMPANIES_INVITE_USER_ADD='COMPANIES:INVITE_USER:ADD';var COMPANIES_INVITE_USER_UPDATE='COMPANIES:INVITE_USER:UPDATE';var COMPANIES_INVITE_USER_REMOVE='COMPANIES:INVITE_USER:REMOVE';var COMPANIES_INVITE_USER_MESSAGE_SET='COMPANIES:INVITE_USER:MESSAGE:SET';var COMPANIES_INVITE_USER_CLEAR_USERS='COMPANIES:INVITE_USER:USERS:CLEAR';var COMPANIES_INVITE_USER_CLEAR_MESSAGE='COMPANIES:INVITE_USER:MESSAGE:CLEAR';var COMPANIES_GET_CURRENT_MEMBER_ADDON_DETAILS='COMPANIES:CURRENT_MEMBER_ADDON:GET';var COMPANIES_GET_CURRENT_MEMBER_ADDON_DETAILS_SUCCESS='COMPANIES:CURRENT_MEMBER_ADDON:GET_SUCCESS';var COMPANIES_GET_CURRENT_MEMBER_ADDON_DETAILS_FAIL='COMPANIES:CURRENT_MEMBER_ADDON:GET_FAIL';var COMPANIES_CLEAR_CURRENT_MEMBER_ADDON_DETAILS='COMPANIES:CURRENT_MEMBER_ADDON:CLEAR';var COMPANIES_CONTACT_SALES='COMPANIES:CONTACT_SALES';var COMPANIES_CONTACT_SALES_SUCCESS='COMPANIES:CONTACT_SALES:SUCCESS';var COMPANIES_CONTACT_SALES_FAIL='COMPANIES:CONTACT_SALES:FAIL';var COMPANIES_CONNECT_MLS_REQUEST='COMPANIES:CONNECT_MLS_REQUEST';var COMPANIES_CONNECT_MLS_REQUEST_SUCCESS='COMPANIES:CONNECT_MLS_REQUEST:SUCCESS';var COMPANIES_CONNECT_MLS_REQUEST_FAIL='COMPANIES:CONNECT_MLS_REQUEST:FAIL';var COMPANIES_REVIEW_MLS_REQUEST='COMPANIES:REVIEW_MLS_REQUEST';var COMPANIES_REVIEW_MLS_REQUEST_SUCCESS='COMPANIES:REVIEW_MLS_REQUEST:SUCCESS';var COMPANIES_REVIEW_MLS_REQUEST_FAIL='COMPANIES:REVIEW_MLS_REQUEST:FAIL';var COMPANIES_UPDATE_USER_PHOTO='COMPANIES:UPDATE_USER_PHOTO';var COMPANIES_UPDATE_USER_PHOTO_SUCCESS='COMPANIES:UPDATE_USER_PHOTO:SUCCESS';var COMPANIES_UPDATE_USER_PHOTO_FAIL='COMPANIES:UPDATE_USER_PHOTO:FAIL';var MLS_CLEAR_CONNECT_FORM_STATE='MLS:CONNECT_MLS_FORM_STATE:CLEAR';var MLS_CLEAR_ERROR_FOR_CONNECTION_AND_USER='MLS:ERROR_FOR_CONNECTION_AND_USER:CLEAR';var MLS_ADD_CONNECTION_WITH_OFFICE_ID='MLS:ADD_CONNECTION_WITH_OFFICE_ID';var MLS_ADD_CONNECTION_WITH_OFFICE_ID_SUCCESS='MLS:ADD_CONNECTION_WITH_OFFICE_ID:SUCCESS';var MLS_ADD_CONNECTION_WITH_OFFICE_ID_FAIL='MLS:ADD_CONNECTION_WITH_OFFICE_ID:FAIL';var MLS_ADD_CONNECTION_WITH_AGENT_ID='MLS:ADD_CONNECTION_WITH_AGENT_ID';var MLS_ADD_CONNECTION_WITH_AGENT_ID_SUCCESS='MLS:ADD_CONNECTION_WITH_AGENT_ID:SUCCESS';var MLS_ADD_CONNECTION_WITH_AGENT_ID_FAIL='MLS:ADD_CONNECTION_WITH_AGENT_ID:FAIL';var MLS_GET_CONNECTIONS_LIST='MLS:CONNECTIONS_LIST:GET';var MLS_GET_CONNECTIONS_LIST_SUCCESS='MLS:CONNECTIONS_LIST:SUCCESS';var MLS_GET_CONNECTIONS_LIST_FAIL='MLS:CONNECTIONS_LIST:FAIL';var MLS_GET_AGENTS_FOR_OFFICE='MLS:AGENTS_FOR_OFFICE:GET';var MLS_GET_AGENTS_FOR_OFFICE_SUCCESS='MLS:AGENTS_FOR_OFFICE:SUCCESS';var MLS_GET_AGENTS_FOR_OFFICE_FAIL='MLS:AGENTS_FOR_OFFICE:FAIL';var MLS_BOARD_LIST_FETCH='MLS:BOARD_LIST:FETCH';var MLS_BOARD_LIST_FETCH_SUCCESS='MLS:BOARD_LIST:FETCH_SUCCESS';var MLS_BOARD_LIST_FETCH_FAIL='MLS:BOARD_LIST:FETCH_FAIL';var MLS_CONNECTION_DELETE='MLS:CONNECTION:DELETE';var MLS_CONNECTION_DELETE_SUCCESS='MLS:CONNECTION:DELETE_SUCCESS';var MLS_CONNECTION_DELETE_FAIL='MLS:CONNECTION:DELETE_FAIL';var MLS_OFFICE_DELETE='MLS:OFFICE:DELETE';var MLS_OFFICE_DELETE_SUCCESS='MLS:OFFICE:DELETE_SUCCESS';var MLS_OFFICE_DELETE_FAIL='MLS:OFFICE:DELETE_FAIL';var MLS_ADD_OFFICE_TO_CONNECTION='MLS:ADD_OFFICE_TO_CONNECTION';var MLS_ADD_OFFICE_TO_CONNECTION_SUCCESS='MLS:ADD_OFFICE_TO_CONNECTION:SUCCESS';var MLS_ADD_OFFICE_TO_CONNECTION_FAIL='MLS:ADD_OFFICE_TO_CONNECTION:FAIL';var MLS_ADD_AGENT_MLS_ID='MLS:MLS_ADD_AGENT_MLS_ID';var MLS_ADD_AGENT_MLS_ID_SUCCESS='MLS:MLS_ADD_AGENT_MLS_ID:SUCCESS';var MLS_ADD_AGENT_MLS_ID_FAIL='MLS:MLS_ADD_AGENT_MLS_ID:FAIL';var MLS_DELETE_AGENT_MLS_ID='MLS:MLS_DELETE_AGENT_MLS_ID';var MLS_DELETE_AGENT_MLS_ID_SUCCESS='MLS:MLS_DELETE_AGENT_MLS_ID:SUCCESS';var MLS_DELETE_AGENT_MLS_ID_FAIL='MLS:MLS_DELETE_AGENT_MLS_ID:FAIL';var MLS_EDIT_AGENT_MLS_ID='MLS:MLS_EDIT_AGENT_MLS_ID';var MLS_EDIT_AGENT_MLS_ID_SUCCESS='MLS:MLS_EDIT_AGENT_MLS_ID:SUCCESS';var MLS_EDIT_AGENT_MLS_ID_FAIL='MLS:MLS_EDIT_AGENT_MLS_ID:FAIL';var LIST_AGENT_MLS_IDS='MLS:LIST_AGENT_MLS_IDS';var LIST_AGENT_MLS_IDS_SUCCESS='MLS:LIST_AGENT_MLS_IDS:SUCCESS';var LIST_AGENT_MLS_IDS_FAIL='MLS:LIST_AGENT_MLS_IDS:FAIL';var RESOLVE_MLS_UI_TYPE='MLS:RESOLVE_MLS_UI_TYPE';var USER_UPDATE='USER:UPDATE';var USER_UPDATE_SUCCESS='USER:UPDATE_SUCCESS';var USER_UPDATE_FAIL='USER:UPDATE_FAIL';var USER_EXTERNAL_ID_UPDATE='USER:EXTERNAL_ID:UPDATE';var USER_EXTERNAL_ID_UPDATE_SUCCESS='USER:EXTERNAL_ID:UPDATE_SUCCESS';var USER_EXTERNAL_ID_UPDATE_FAIL='USER:EXTERNAL_ID:UPDATE_FAIL';var USER_EXTERNAL_ID_STATE_CLEAR='USER:EXTERNAL_ID:STATE_CLEAR';var USER_REGION_FETCH='USER_REGION:FETCH';var USER_REGION_FETCH_SUCCESS='USER_REGION:FETCH_SUCCESS';var USER_REGION_FETCH_FAIL='USER_REGION:FETCH_FAIL';var ADDON_GET_DETAILS='ADDON:GET_DETAILS';var ADDON_GET_DETAILS_SUCCESS='ADDON:GET_DETAILS_SUCCESS';var ADDON_GET_DETAILS_FAIL='ADDON:GET_DETAILS_FAIL';var UPCOMING_INVOICE_GET_ESTIMATE='UPCOMING_INVOICE:GET_ESTIMATE';var UPCOMING_INVOICE_GET_ESTIMATE_SUCCESS='UPCOMING_INVOICE:GET_ESTIMATE_SUCCESS';var UPCOMING_INVOICE_GET_ESTIMATE_FAIL='UPCOMING_INVOICE:GET_ESTIMATE_FAIL';var SUBSCRIPTION_GET_ESTIMATE='SUBSCRIPTION:GET_ESTIMATE';var SUBSCRIPTION_GET_ESTIMATE_SUCCESS='SUBSCRIPTION:GET_ESTIMATE_SUCCESS';var SUBSCRIPTION_GET_ESTIMATE_FAIL='SUBSCRIPTION:GET_ESTIMATE_FAIL';var SUBSCRIPTION_GET_ESTIMATE_ACTIVE_PLAN='SUBSCRIPTION:GET_ESTIMATE_ACTIVE_PLAN';var SUBSCRIPTION_GET_ESTIMATE_ACTIVE_PLAN_SUCCESS='SUBSCRIPTION:GET_ESTIMATE_ACTIVE_PLAN_SUCCESS';var SUBSCRIPTION_GET_ESTIMATE_ACTIVE_PLAN_FAIL='SUBSCRIPTION:GET_ESTIMATE_ACTIVE_PLAN_FAIL';var ACCOUNT_EMAIL_UPDATE='ACCOUNT:EMAIL:UPDATE';var ACCOUNT_EMAIL_UPDATE_SUCCESS='ACCOUNT:EMAIL:UPDATE_SUCCESS';var ACCOUNT_EMAIL_UPDATE_FAIL='ACCOUNT:EMAIL:UPDATE_FAIL';var ACCOUNT_NAME_UPDATE='ACCOUNT:NAME:UPDATE';var ACCOUNT_NAME_UPDATE_SUCCESS='ACCOUNT:NAME:UPDATE_SUCCESS';var ACCOUNT_NAME_UPDATE_FAIL='ACCOUNT:NAME:UPDATE_FAIL';var ACCOUNT_PASSWORD_UPDATE='ACCOUNT:PASSWORD:UPDATE';var ACCOUNT_PASSWORD_UPDATE_SUCCESS='ACCOUNT:PASSWORD:UPDATE_SUCCESS';var ACCOUNT_PASSWORD_UPDATE_FAIL='ACCOUNT:PASSWORD:UPDATE_FAIL';var ACCOUNT_PASSWORD_RESET='ACCOUNT:PASSWORD:RESET';var ACCOUNT_PASSWORD_RESET_SUCCESS='ACCOUNT:PASSWORD:RESET_SUCCESS';var ACCOUNT_PASSWORD_RESET_FAIL='ACCOUNT:PASSWORD:RESET_FAIL';var ACCOUNT_CHECK_CREDENTIALS='ACCOUNT:CHECK_CREDENTIALS';var ACCOUNT_CHECK_CREDENTIALS_SUCCESS='ACCOUNT:CHECK_CREDENTIALS_SUCCESS';var ACCOUNT_CHECK_CREDENTIALS_FAIL='ACCOUNT:CHECK_CREDENTIALS_FAIL';var CRS_CHECK_CREDENTIALS='CRS:CHECK_CREDENTIALS';var CRS_CHECK_CREDENTIALS_SUCCESS='CRS:CHECK_CREDENTIALS_SUCCESS';var CRS_CHECK_CREDENTIALS_FAIL='CRS:CHECK_CREDENTIALS_FAIL';var CRS_CLEAR_CREDENTIALS='CRS:CLEAR_CREDENTIALS';var CRS_SAVE_TAKEOVER_CREDENTIALS='CRS:SAVE_TAKEOVER_CREDENTIALS';var CRS_USAGE_UPDATE='CRS:NAME:UPDATE';var CRS_USAGE_UPDATE_SUCCESS='CRS:NAME:UPDATE_SUCCESS';var CRS_USAGE_UPDATE_FAIL='CRS:NAME:UPDATE_FAIL';var DISCOUNT_CLEAR_APPLIED='DISCOUNT:CLEAR_APPLIED';var DISCOUNT_APPLY_MAGIX='DISCOUNT:APPLY_MAGIX';var DISCOUNT_APPLY_COUPON_SET_ID='DISCOUNT:APPLY_COUPON_SET_ID';var REDUCE_USERS_API_ERROR_STATE_SET='USER:REDUCE_API_ERROR_STATE:SET';var REDUCE_USERS_API_ERROR_STATE_CLEAR='USER:REDUCE_API_ERROR_STATE:CLEAR';var SET_USER_SUPPLIED_PROMO_CODE='DISCOUNT:SET_USER_SUPPLIED_PROMO_CODE';var COMPANIES_CREATE_CHARGEBEE_SESSION='COMPANIES:CREATE:CHARGEBEE:SESSION';var COMPANIES_CREATE_CHARGEBEE_SESSION_SUCCESS='COMPANIES:CREATE:CHARGEBEE:SESSION:SUCCESS';var COMPANIES_CREATE_CHARGEBEE_SESSION_FAIL='COMPANIES:CREATE:CHARGEBEE:SESSION:FAIL';var COMPANIES_CREATE_CHARGEBEE_SUBSCRIPTION='COMPANIES:CREATE:CHARGEBEE:SUBSCRIPTION';var COMPANIES_CREATE_CHARGEBEE_SUBSCRIPTION_SUCCESS='COMPANIES:CREATE:CHARGEBEE:SUBSCRIPTION:SUCCESS';var COMPANIES_CREATE_CHARGEBEE_SUBSCRIPTION_FAIL='COMPANIES:CREATE:CHARGEBEE:SUBSCRIPTION:FAIL';var COMPANIES_INDUSTRIES_FETCH='COMPANIES:INDUSTRIES:FETCH';var COMPANIES_INDUSTRIES_FETCH_SUCCESS='COMPANIES:INDUSTRIES:FETCH_SUCCESS';var COMPANIES_INDUSTRIES_FETCH_FAIL='COMPANIES:INDUSTRIES:FETCH_FAIL';var COMPANIES_SIZES_FETCH='COMPANIES:SIZES:FETCH';var COMPANIES_SIZES_FETCH_SUCCESS='COMPANIES:SIZES:FETCH_SUCCESS';var COMPANIES_SIZES_FETCH_FAIL='COMPANIES:SIZES:FETCH_FAIL';var COMPANIES_COUNTRIES_FETCH='COMPANIES:COUNTRIES:FETCH';var COMPANIES_COUNTRIES_FETCH_SUCCESS='COMPANIES:COUNTRIES:FETCH_SUCCESS';var COMPANIES_COUNTRIES_FETCH_FAIL='COMPANIES:COUNTRIES:FETCH_FAIL';var COMPANIES_FONT_ADD='COMPANIES:FONT:ADD';var COMPANIES_FONT_ADD_FAIL='COMPANIES:FONT:ADD_FAIL';var COMPANIES_FONT_REMOVE='COMPANIES:FONT:REMOVE';var COMPANIES_FONT_REMOVE_FAIL='COMPANIES:FONT:REMOVE_FAIL';var COMPANIES_SMART_FIELDS_UPDATE='COMPANIES:SMART_FIELDS:UPDATE';var COMPANIES_SMART_FIELDS_UPDATE_FAIL='COMPANIES:SMART_FIELDS:UPDATE_FAIL';var COMPANIES_SETTING_WRITE='COMPANIES:SETTING_WRITE';var COMPANIES_SETTING_WRITE_SUCCESS='COMPANIES:SETTING_WRITE_SUCCESS';var COMPANIES_SETTING_WRITE_FAIL='COMPANIES:SETTING_WRITE_FAIL';// WORKSPACE
var WORKSPACE_VALIDATE='WORKSPACE:VALIDATE';var WORKSPACE_VALIDATE_SUCCESS='WORKSPACE:VALIDATE_SUCCESS';var WORKSPACE_VALIDATE_FAIL='WORKSPACE:VALIDATE_FAIL';var WORKSPACE_ADD='WORKSPACE:ADD';var WORKSPACE_ADD_SUCCESS='WORKSPACE:ADD_SUCCESS';var WORKSPACE_ADD_FAIL='WORKSPACE:ADD_FAIL';var WORKSPACE_UPDATE='WORKSPACE:UPDATE';var WORKSPACE_UPDATE_SUCCESS='WORKSPACE:UPDATE_SUCCESS';var WORKSPACE_UPDATE_FAIL='WORKSPACE:UPDATE_FAIL';var WORKSPACE_DELETE='WORKSPACE:DELETE';var WORKSPACE_DELETE_SUCCESS='WORKSPACE:DELETE_SUCCESS';var WORKSPACE_DELETE_FAIL='WORKSPACE:DELETE_FAIL';// ERROR
var ERROR_HANDLER_SET='ERROR_HANDLER:SET';var ERROR_HANDLER_RESET='ERROR_HANDLER:RESET';// MODAL
var MODAL_SHOW='MODAL:SHOW';var MODAL_HIDE='MODAL:HIDE';var MODAL_RESET='MODAL:RESET';// FOLDERS
var FOLDER_GET='FOLDER:GET';var FOLDER_GET_SUCCESS='FOLDER:GET_SUCCESS';var FOLDER_GET_FAIL='FOLDER:GET_FAIL';var FOLDER_SET_PARENT='FOLDER:SET_PARENT';var REMOVE_COMPANY_FOLDER='FOLDER:REMOVE_COMPANY_FOLDER';var REMOVE_COMPANY_FOLDER_SUCCESS='FOLDER:REMOVE_COMPANY_FOLDER_SUCCESS';var REMOVE_COMPANY_FOLDER_FAIL='FOLDER:REMOVE_COMPANY_FOLDER_FAIL';var FOLDER_ADD='FOLDER:FOLDER_ADD';var FOLDER_ADD_SUCCESS='FOLDER:FOLDER_ADD_SUCCESS';var FOLDER_ADD_FAIL='FOLDER:FOLDER_ADD_FAIL';var FOLDER_UPDATE='FOLDER:FOLDER_UPDATE';var FOLDER_UPDATE_SUCCESS='FOLDER:FOLDER_UPDATE_SUCCESS';var FOLDER_UPDATE_FAIL='FOLDER:FOLDER_UPDATE_FAIL';var FOLDER_DELETE='FOLDER:FOLDER_DELETE';var FOLDER_DELETE_SUCCESS='FOLDER:FOLDER_DELETE_SUCCESS';var FOLDER_DELETE_FAIL='FOLDER:FOLDER_DELETE_FAIL';var REQUEST_FINISHED='REQUEST:FINISHED';// QUICK MESSAGES
var QUICK_MESSAGE_ENQUEUE='QUICK_MESSAGE:ENQUEUE';var QUICK_MESSAGE_FADE='QUICK_MESSAGE:FADE';var QUICK_MESSAGE_DEQUEUE='QUICK_MESSAGE:REMOVE';// PRELOADER
var SHOW_PRELOADER='SHOW:PRELOADER';var HIDE_PRELOADER='HIDE:PRELOADER';// CB PRELOADER
var SHOW_CB_LOADER='SHOW:CB_LOADER';var HIDE_CB_LOADER='HIDE:CB_LOADER';// PROCESSING ORDER
var SHOW_PROCESSING_ORDER='SHOW:PROCESSING_ORDER';var HIDE_PROCESSING_ORDER='HIDE:PROCESSING_ORDER';// EMAILS
var SEND_EMAIL='SEND:EMAIL';var SEND_EMAIL_SUCCESS='SEND:EMAIL:SUCCESS';var SEND_EMAIL_FAIL='SEND:EMAIL:FAIL';// TABS ON SUBSCRIPTION PAGE
var SUBSCRIPTION_CATEGORY_SET='APP:SUBSCRIPTION_CATEGORY_SET';var SUBSCRIPTION_PERIOD_SET='APP:SUBSCRIPTION_PERIOD_SET';var SUBSCRIPTION_CURRENCY_SET='APP:SUBSCRIPTION_CURRENCY_SET';var SUBSCRIPTION_CLEAR_STATE='APP:SUBSCRIPTION_CLEAR_STATE';var SUBSCRIPTION_PERPETUAL_OVERVIEW_PAGE_VISITED='APP:SUBSCRIPTION_PERPETUAL_OVERVIEW_PAGE_VISITED';var SUBSCRIPTION_PLUS_OVERVIEW_PAGE_VISITED='APP:SUBSCRIPTION_PLUS_OVERVIEW_PAGE_VISITED';var SUBSCRIPTION_VIEW_SET='APP:SUBSCRIPTION_VIEW_SET';var SUBSCRIPTION_BATCH_PARAMS_SET='APP:SUBSCRIPTION_BATCH_PARAMS_SET';// SEATS AND LICENSES QUANTITY
var SEATS_QUANTITY_SET='APP:SEATS_QUANTITY_SET';var LICENSES_QUANTITY_SET='APP:LICENSES_QUANTITY_SET';// REDUCE USERS
var USER_REDUCE_UPDATE='USER:REDUCE:UPDATE';

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrencyUsedInCB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getSubscriptionsAndAddons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCurrentPlanId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return convertPlanIdIntoSubscription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCurrentPlanName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getSubscriptionRedirectUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return isDesktopOnlyPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return isPerpetualPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getTotalProductsForCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return isValidNonZeroQuantity; });
/* unused harmony export isPerpetualAddon */
/* unused harmony export isMemberAddon */
/* unused harmony export getAddonType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getMembersPaidQuantity; });
/* unused harmony export getMembersUsedQuantity */
/* unused harmony export getKeysOfMembersAddonObject */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getNonObsoleteMemberAddonForPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return isPerpetualOwner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getPendingPerpetualPlans; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return hasDesktopSubscription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return hasCancelledDesktopSubscription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return hasRealEstateSubscription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return hasCancelledReSubscription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return hasCloudSubscription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return hasCancelledCloudSubscription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return isDesktopTrial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return isReAccessNoIndustry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_routes__ = __webpack_require__(48);
var getCurrentPlan=function getCurrentPlan(company){return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(company,'paymentAccount.products.essential.subscription')||__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(company,'paymentAccount.products.teamplus.subscription')||__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(company,'paymentAccount.products.brokerages.subscription')||__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(company,'paymentAccount.products.individual_agent.subscription')||__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(company,'paymentAccount.products.web.subscription')||__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(company,'paymentAccount.products.photo.subscription')||__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(company,'paymentAccount.products.designer.subscription')||{};};var getCurrencyUsedInCB=function getCurrencyUsedInCB(company){var _getSubscriptionsAndA=getSubscriptionsAndAddons(company,true),perpetualAddons=_getSubscriptionsAndA.perpetualAddons,subscription=_getSubscriptionsAndA.subscription;var result;if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(subscription)){var _convertPlanIdIntoSub=convertPlanIdIntoSubscription(subscription.planId);result=_convertPlanIdIntoSub.currency;}else if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(perpetualAddons)){var _convertPlanIdIntoSub2=convertPlanIdIntoSubscription(perpetualAddons[0].id);result=_convertPlanIdIntoSub2.currency;}return result;};var getSubscriptionsAndAddons=function getSubscriptionsAndAddons(company,includeInactive){var allProducts=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(company,'paymentAccount.products');var memberAddons=null;var perpetualAddons=null;var subscription=null;if(allProducts){var objectKeys=Object.keys(allProducts);objectKeys.forEach(function(key){var addonProduct=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(allProducts[key],'addon');if(addonProduct&&(includeInactive||addonProduct.active)){if(isPerpetualAddon(key)){perpetualAddons=perpetualAddons||[];perpetualAddons.push(addonProduct);}else if(isMemberAddon(key)){memberAddons=memberAddons||[];memberAddons.push(addonProduct);}}var subscriptionProduct=__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(allProducts[key],'subscription');if(subscriptionProduct&&(includeInactive||subscriptionProduct.active)){subscription=subscriptionProduct;}});}return{subscription:subscription,perpetualAddons:perpetualAddons,memberAddons:memberAddons};};/**
 * Get Current planId for the company
 *
 * @param {object} company object
 * @returns planId format [plan-duration-currency]
 */var getCurrentPlanId=function getCurrentPlanId(company){var _getCurrentPlan=getCurrentPlan(company),active=_getCurrentPlan.active,planId=_getCurrentPlan.planId;// P9052-10593: return planId only if subscription is active
if(active){return planId;}};/**
 * Convert planId into subscription object
 *
 * @param {*} planId format [plan-duration-currency]
 * @returns activeSubscription object
 */var convertPlanIdIntoSubscription=function convertPlanIdIntoSubscription(planId){if(planId){var _planId$split=planId.split('-'),_planId$split2=__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_planId$split,3),plan=_planId$split2[0],period=_planId$split2[1],currency=_planId$split2[2];return{plan:plan,period:period,currency:currency};}else{return __WEBPACK_IMPORTED_MODULE_2__config__["z" /* DEFAULT_SUBSCRIPTION */];}};/**
 * Get plan name from planId
 *
 * @param {object} company object
 * @returns plan name
 */var getCurrentPlanName=function getCurrentPlanName(company){var planId=getCurrentPlanId(company);var _convertPlanIdIntoSub3=convertPlanIdIntoSubscription(planId),plan=_convertPlanIdIntoSub3.plan;return plan;};var getSubscriptionRedirectUrl=function getSubscriptionRedirectUrl(planId,companyId,currency,queryVars){var component;if(planId===__WEBPACK_IMPORTED_MODULE_2__config__["_11" /* PLUS_OVERVIEW_PLAN_ID */]){component=__WEBPACK_IMPORTED_MODULE_3_routes__["p" /* SUBSCRIPTION_PLUS_OVERVIEW */];}else if(planId===__WEBPACK_IMPORTED_MODULE_2__config__["_8" /* PERPETUAL_OVERVIEW_PLAN_ID */]){component=__WEBPACK_IMPORTED_MODULE_3_routes__["o" /* SUBSCRIPTION_PERPETUAL_OVERVIEW */];}else if(planId===__WEBPACK_IMPORTED_MODULE_2__config__["_37" /* STANDARD_OVERVIEW_PLAN_ID */]||planId===__WEBPACK_IMPORTED_MODULE_2__config__["_25" /* REAL_ESTATE_OVERVIEW_PLAN_ID */]){component=__WEBPACK_IMPORTED_MODULE_3_routes__["n" /* SUBSCRIPTION */];}else{component=__WEBPACK_IMPORTED_MODULE_3_routes__["r" /* SUBSCRIPTION_UPGRADE */];}var selectedCurrency=(planId===__WEBPACK_IMPORTED_MODULE_2__config__["_11" /* PLUS_OVERVIEW_PLAN_ID */]||planId===__WEBPACK_IMPORTED_MODULE_2__config__["_8" /* PERPETUAL_OVERVIEW_PLAN_ID */]||planId===__WEBPACK_IMPORTED_MODULE_2__config__["_37" /* STANDARD_OVERVIEW_PLAN_ID */]||planId===__WEBPACK_IMPORTED_MODULE_2__config__["_25" /* REAL_ESTATE_OVERVIEW_PLAN_ID */])&&!currency?__WEBPACK_IMPORTED_MODULE_2__config__["z" /* DEFAULT_SUBSCRIPTION */].currency:currency;var componentPath=component.replace(':companyId','#'+companyId).replace(':planId',planId).replace(':currency?',selectedCurrency);if([__WEBPACK_IMPORTED_MODULE_2__config__["_25" /* REAL_ESTATE_OVERVIEW_PLAN_ID */],__WEBPACK_IMPORTED_MODULE_2__config__["_37" /* STANDARD_OVERVIEW_PLAN_ID */]].includes(planId)&&currency){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_2__config__["y" /* CURRENCY_PARAM */],"=").concat(currency));queryVars.currency=currency;}var queryPath=queryVars?"/?".concat(queryVars.join('&')):'';return"".concat(window.location.origin).concat(componentPath).concat(queryPath);};var isDesktopOnlyPlan=function isDesktopOnlyPlan(plan){if(!plan)return false;var planId=plan.split('-')[0];var isDesktopOnlyPlan=__WEBPACK_IMPORTED_MODULE_2__config__["_3" /* PACKAGES_CONFIG */][planId].isPerpetual||__WEBPACK_IMPORTED_MODULE_2__config__["_3" /* PACKAGES_CONFIG */][planId].isCreativeToolsPlan&&!__WEBPACK_IMPORTED_MODULE_2__config__["_3" /* PACKAGES_CONFIG */][planId].isCloudSuitePlan;return isDesktopOnlyPlan;};var isPerpetualPlan=function isPerpetualPlan(plan){if(!plan)return false;var planId=plan.split('-')[0];return __WEBPACK_IMPORTED_MODULE_2__config__["_3" /* PACKAGES_CONFIG */][planId].isPerpetual;};var getTotalProductsForCompany=function getTotalProductsForCompany(company){var _getSubscriptionsAndA2=getSubscriptionsAndAddons(company),subscription=_getSubscriptionsAndA2.subscription,perpetualAddons=_getSubscriptionsAndA2.perpetualAddons;var nrOfProductUserOwns=0;if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(subscription)){nrOfProductUserOwns++;}if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(perpetualAddons)){nrOfProductUserOwns+=perpetualAddons.length;}return nrOfProductUserOwns;};var isValidNonZeroQuantity=function isValidNonZeroQuantity(value){return /^\d+$/.test(value)&&__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isInteger(parseInt(value))&&parseInt(value)>0;};var isPerpetualAddon=function isPerpetualAddon(addonId){return!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_2__config__["C" /* DESKTOP_APPS */][addonId.split('_')[0].toUpperCase()]);};var isMemberAddon=function isMemberAddon(addonId){return Object(__WEBPACK_IMPORTED_MODULE_2__config__["_69" /* getMemberAddonsIds */])().includes(addonId.split('-')[0]);};var getAddonType=function getAddonType(addonId){if(isPerpetualAddon(addonId)){return __WEBPACK_IMPORTED_MODULE_2__config__["e" /* ADDON_TYPE */].PERPETUAL;}else if(isMemberAddon(addonId)){return __WEBPACK_IMPORTED_MODULE_2__config__["e" /* ADDON_TYPE */].MEMBER;}};var getMembersPaidQuantity=function getMembersPaidQuantity(company){var _getSubscriptionsAndA3=getSubscriptionsAndAddons(company),memberAddons=_getSubscriptionsAndA3.memberAddons;var result=0;if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(memberAddons)){memberAddons.forEach(function(addon){result+=addon.paidQuantity;});}return result;};var getMembersUsedQuantity=function getMembersUsedQuantity(company){var _getSubscriptionsAndA4=getSubscriptionsAndAddons(company),memberAddons=_getSubscriptionsAndA4.memberAddons;var result=0;if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(memberAddons)){memberAddons.forEach(function(addon){result+=addon.usedQuantity;});}return result;};var getKeysOfMembersAddonObject=function getKeysOfMembersAddonObject(company){var _getSubscriptionsAndA5=getSubscriptionsAndAddons(company),memberAddons=_getSubscriptionsAndA5.memberAddons;var result=[];if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(memberAddons)){memberAddons.forEach(function(addon){result.push(addon.id.split('-')[0]);});}return result;};var getNonObsoleteMemberAddonForPlan=function getNonObsoleteMemberAddonForPlan(planId){// isObsolete: false is the addon what MW/user can purchase
// isObsolete: true is the addon what user/MW cannot purchase but user can have if user got it earlier.
var result=null;var selectedAddons=__WEBPACK_IMPORTED_MODULE_2__config__["_3" /* PACKAGES_CONFIG */][planId].selectedAddons;if(!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(selectedAddons)){Object.keys(selectedAddons).forEach(function(addonKey){if(!selectedAddons[addonKey].isObsolete){result=addonKey;}});}return result;};var isPerpetualOwner=function isPerpetualOwner(company){var _getSubscriptionsAndA6=getSubscriptionsAndAddons(company),perpetualAddons=_getSubscriptionsAndA6.perpetualAddons;return!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(perpetualAddons);};var getPendingPerpetualPlans=function getPendingPerpetualPlans(company){return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(company,'settings.pendingPerpetualPlans',{});};var hasDesktopSubscription=function hasDesktopSubscription(company){var result=false;var _getSubscriptionsAndA7=getSubscriptionsAndAddons(company),subscription=_getSubscriptionsAndA7.subscription;if(subscription){var _convertPlanIdIntoSub4=convertPlanIdIntoSubscription(subscription.planId),plan=_convertPlanIdIntoSub4.plan;if(plan&&[__WEBPACK_IMPORTED_MODULE_2__config__["_42" /* SUBSCRIPTION_PLAN */].PHOTO,__WEBPACK_IMPORTED_MODULE_2__config__["_42" /* SUBSCRIPTION_PLAN */].WEB,__WEBPACK_IMPORTED_MODULE_2__config__["_42" /* SUBSCRIPTION_PLAN */].DESIGNER].includes(plan)){result=true;}}return result;};var hasCancelledDesktopSubscription=function hasCancelledDesktopSubscription(company){var result=false;var _getSubscriptionsAndA8=getSubscriptionsAndAddons(company,true),cancelledSubscription=_getSubscriptionsAndA8.subscription;if(cancelledSubscription){var _convertPlanIdIntoSub5=convertPlanIdIntoSubscription(cancelledSubscription.planId),plan=_convertPlanIdIntoSub5.plan;if(plan&&[__WEBPACK_IMPORTED_MODULE_2__config__["_42" /* SUBSCRIPTION_PLAN */].PHOTO,__WEBPACK_IMPORTED_MODULE_2__config__["_42" /* SUBSCRIPTION_PLAN */].WEB,__WEBPACK_IMPORTED_MODULE_2__config__["_42" /* SUBSCRIPTION_PLAN */].DESIGNER].includes(plan)){result=true;}}return result;};var hasRealEstateSubscription=function hasRealEstateSubscription(company){var result=false;var _getSubscriptionsAndA9=getSubscriptionsAndAddons(company),subscription=_getSubscriptionsAndA9.subscription;if(subscription){var _convertPlanIdIntoSub6=convertPlanIdIntoSubscription(subscription.planId),plan=_convertPlanIdIntoSub6.plan;if(plan&&[__WEBPACK_IMPORTED_MODULE_2__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES,__WEBPACK_IMPORTED_MODULE_2__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT].includes(plan)){result=true;}}return result;};var hasCancelledReSubscription=function hasCancelledReSubscription(company){var result=false;var _getSubscriptionsAndA10=getSubscriptionsAndAddons(company,true),cancelledSubscription=_getSubscriptionsAndA10.subscription;if(cancelledSubscription){var _convertPlanIdIntoSub7=convertPlanIdIntoSubscription(cancelledSubscription.planId),plan=_convertPlanIdIntoSub7.plan;if(plan&&[__WEBPACK_IMPORTED_MODULE_2__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES,__WEBPACK_IMPORTED_MODULE_2__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT].includes(plan)){result=true;}}return result;};var hasCloudSubscription=function hasCloudSubscription(company){var result=false;var _getSubscriptionsAndA11=getSubscriptionsAndAddons(company),subscription=_getSubscriptionsAndA11.subscription;if(subscription){var _convertPlanIdIntoSub8=convertPlanIdIntoSubscription(subscription.planId),plan=_convertPlanIdIntoSub8.plan;if(plan&&[__WEBPACK_IMPORTED_MODULE_2__config__["_42" /* SUBSCRIPTION_PLAN */].ESSENTIAL,__WEBPACK_IMPORTED_MODULE_2__config__["_42" /* SUBSCRIPTION_PLAN */].SCALE,__WEBPACK_IMPORTED_MODULE_2__config__["_42" /* SUBSCRIPTION_PLAN */].ENTERPRISE,__WEBPACK_IMPORTED_MODULE_2__config__["_42" /* SUBSCRIPTION_PLAN */].TEAM_PLUS].includes(plan)){result=true;}}return result;};var hasCancelledCloudSubscription=function hasCancelledCloudSubscription(company){var result=false;var _getSubscriptionsAndA12=getSubscriptionsAndAddons(company,true),cancelledSubscription=_getSubscriptionsAndA12.subscription;if(cancelledSubscription){var _convertPlanIdIntoSub9=convertPlanIdIntoSubscription(cancelledSubscription.planId),plan=_convertPlanIdIntoSub9.plan;if(plan&&[__WEBPACK_IMPORTED_MODULE_2__config__["_42" /* SUBSCRIPTION_PLAN */].ESSENTIAL,__WEBPACK_IMPORTED_MODULE_2__config__["_42" /* SUBSCRIPTION_PLAN */].SCALE,__WEBPACK_IMPORTED_MODULE_2__config__["_42" /* SUBSCRIPTION_PLAN */].ENTERPRISE,__WEBPACK_IMPORTED_MODULE_2__config__["_42" /* SUBSCRIPTION_PLAN */].TEAM_PLUS].includes(plan)){result=true;}}return result;};var isDesktopTrial=function isDesktopTrial(doesNotOwnProducts,desktopAppFlag,productName,cbPlanId,originId){var result;var plan=cbPlanId&&cbPlanId.split('-')[0];if(doesNotOwnProducts&&(desktopAppFlag||['XPS','XWDS','PGDS','XPL','XWDL','XPGDL'].includes((productName||'').toUpperCase())||[__WEBPACK_IMPORTED_MODULE_2__config__["_42" /* SUBSCRIPTION_PLAN */].WEB,__WEBPACK_IMPORTED_MODULE_2__config__["_42" /* SUBSCRIPTION_PLAN */].PHOTO,__WEBPACK_IMPORTED_MODULE_2__config__["_42" /* SUBSCRIPTION_PLAN */].DESIGNER].includes(plan)||[__WEBPACK_IMPORTED_MODULE_2__config__["_11" /* PLUS_OVERVIEW_PLAN_ID */],__WEBPACK_IMPORTED_MODULE_2__config__["_8" /* PERPETUAL_OVERVIEW_PLAN_ID */]].includes(cbPlanId))||[__WEBPACK_IMPORTED_MODULE_2__config__["_2" /* ORIGIN */].PHOTO,__WEBPACK_IMPORTED_MODULE_2__config__["_2" /* ORIGIN */].WEB,__WEBPACK_IMPORTED_MODULE_2__config__["_2" /* ORIGIN */].DESIGNER,__WEBPACK_IMPORTED_MODULE_2__config__["_2" /* ORIGIN */].PHOTO_PERPETUAL,__WEBPACK_IMPORTED_MODULE_2__config__["_2" /* ORIGIN */].DESIGNER_PERPETUAL,__WEBPACK_IMPORTED_MODULE_2__config__["_2" /* ORIGIN */].WEB_PERPETUAL].includes(originId)){result=true;}else{result=false;}return result;};var isReAccessNoIndustry=function isReAccessNoIndustry(industryId,doesNotOwnProducts,productName,cbPlanId){var result;var plan=cbPlanId&&cbPlanId.split('-')[0];if(doesNotOwnProducts&&!industryId&&([__WEBPACK_IMPORTED_MODULE_2__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES,__WEBPACK_IMPORTED_MODULE_2__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT].includes((productName||'').toLowerCase())||[__WEBPACK_IMPORTED_MODULE_2__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES,__WEBPACK_IMPORTED_MODULE_2__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT].includes((plan||'').toLowerCase())||__WEBPACK_IMPORTED_MODULE_2__config__["_25" /* REAL_ESTATE_OVERVIEW_PLAN_ID */]===cbPlanId)){result=true;}else{result=false;}return result;};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(31)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLOUD_FOLDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLOUD_FOLDER_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CLOUD_FOLDER_TAB_ASSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SUBSCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SUBSCRIPTION_PLUS_OVERVIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SUBSCRIPTION_PERPETUAL_OVERVIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SUBSCRIPTION_UPGRADE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SUBSCRIPTION_SUCCESSFUL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return XC_PLUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MLS_CONNECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FONTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SMART_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return NOT_FOUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return UI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ONBOARDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return NO_PERMISSIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PAGE_NOT_AVAILABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return WRONG_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCOUNT_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CUSTOMIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getRoute; });
/* unused harmony export routeMatches */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(147);
var ROOT='/:companyId';var CLOUD_FOLDER='/:companyId/team-folders';var CLOUD_FOLDER_TAB='/:companyId/team-folders/:tab';var CLOUD_FOLDER_TAB_ASSET='/:companyId/team-folders/:tab/:asset';var SUBSCRIPTION='/:companyId/subscription';var SUBSCRIPTION_PLUS_OVERVIEW='/:companyId/subscription/plus-overview/:currency?';var SUBSCRIPTION_PERPETUAL_OVERVIEW='/:companyId/subscription/perpetual-overview/:currency?';var SUBSCRIPTION_UPGRADE='/:companyId/subscription/:planId';var SUBSCRIPTION_SUCCESSFUL='/:companyId/subscription-successful';var XC_PLUS='/:companyId/xcplus';var USERS='/:companyId/users';var MLS_CONNECTION='/:companyId/mls-connection';var FONTS='/:companyId/fonts';var SMART_FIELDS='/:companyId/smart-fields';var NOT_FOUND='/not-found';var UI='/ui';var ONBOARDING='/onboarding';var NO_PERMISSIONS='/no-permissions';var PAGE_NOT_AVAILABLE='/:companyId/page-not-available';var WRONG_ACCOUNT='/:companyId/wrong-account';var ACCOUNT_DETAILS='/:companyId/account';var CUSTOMIZE='/:companyId/customize';var getRoute=function getRoute(route){for(var _len=arguments.length,params=new Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){params[_key-1]=arguments[_key];}var count=0;return route.replace(/:[a-zA-Z?]+/g,function(match){return params[count++]||match;});};var routeMatches=function routeMatches(route,location,options){var pathname=location.pathname;return Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["b" /* matchPath */])(pathname,__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({path:route,exact:true,strict:false},options))!==null;};

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Grid.default;
  }
});

var _Grid = _interopRequireDefault(__webpack_require__(1004));

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(757);

var iterableToArray = __webpack_require__(758);

var nonIterableSpread = __webpack_require__(759);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _SvgIcon.default;
  }
});

var _SvgIcon = _interopRequireDefault(__webpack_require__(909));

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__);
var _dec,_class;var styles=function styles(){return{inputClass:{fontSize:'14px'}};};var FormField=(_dec=Object(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(FormField,_Component);function FormField(){__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default()(this,FormField);return __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default()(FormField).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default()(FormField,[{key:"render",value:function render(){var _this$props=this.props,classes=_this$props.classes,maxLength=_this$props.maxLength,autosize=_this$props.autosize,inputProps=_this$props.inputProps,passProps=__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(_this$props,["classes","maxLength","autosize","inputProps"]);delete passProps.classes;var dataTid=passProps['data-tid'];return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a,__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({},passProps,autosize?{multiline:true,rowsMax:2}:{},{InputProps:__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},inputProps,{'data-tid':dataTid?"input-".concat(dataTid):undefined,disableUnderline:true,spellCheck:'false'}),inputProps:{maxLength:maxLength}}));}}]);return FormField;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]))||_class);FormField.propTypes={classes:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,maxLength:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,autosize:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,inputProps:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (FormField);

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(86);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchSession; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return verifyUserAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return writeUserSettings; });
/* unused harmony export resetOnBoardingSettings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__storage__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__errors_errorhelper__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__errors_apperror__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__errors_httperror__ = __webpack_require__(68);
var initialState={loading:false,error:false,id:null,user:null};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1?arguments[1]:undefined;switch(action.type){case __WEBPACK_IMPORTED_MODULE_2__actions__["_151" /* SESSION_FETCH */]:case __WEBPACK_IMPORTED_MODULE_2__actions__["_186" /* USER_SETTING_WRITE */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{loading:true});case __WEBPACK_IMPORTED_MODULE_2__actions__["_153" /* SESSION_FETCH_SUCCESS */]:{Object(__WEBPACK_IMPORTED_MODULE_3__storage__["c" /* setKey */])(action.result.user.id);return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{loading:false,id:action.result.id,user:__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},action.result.user)});}case __WEBPACK_IMPORTED_MODULE_2__actions__["_189" /* USER_UPDATE_SUCCESS */]:{var _action$payload=action.payload,firstName=_action$payload.firstName,lastName=_action$payload.lastName,name=_action$payload.name,hasPassword=_action$payload.hasPassword;return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{loading:false,user:__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state.user,{firstName:firstName,lastName:lastName,name:name,hasPassword:hasPassword})});}case __WEBPACK_IMPORTED_MODULE_2__actions__["_152" /* SESSION_FETCH_FAIL */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{loading:false,error:true,id:null,user:null});case __WEBPACK_IMPORTED_MODULE_2__actions__["_188" /* USER_SETTING_WRITE_SUCCESS */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{user:__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state.user,{settings:action.payload})});case __WEBPACK_IMPORTED_MODULE_2__actions__["_187" /* USER_SETTING_WRITE_FAIL */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{loading:false,error:true});default:return state;}});var fetchSession=function fetchSession(){return{types:[__WEBPACK_IMPORTED_MODULE_2__actions__["_151" /* SESSION_FETCH */],__WEBPACK_IMPORTED_MODULE_2__actions__["_153" /* SESSION_FETCH_SUCCESS */],__WEBPACK_IMPORTED_MODULE_2__actions__["_152" /* SESSION_FETCH_FAIL */]],promise:function promise(client){return client.get('/session')["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_5__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_7__errors_apperror__["a" /* default */]({message:'session.fetchSession() failed',errorId:__WEBPACK_IMPORTED_MODULE_6__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_8__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_SESSION'}});throw nError;});}};};var verifyUserAccount=function verifyUserAccount(){var host=__WEBPACK_IMPORTED_MODULE_4_config__["_65" /* XC_URL */].slice(-1)==='/'?__WEBPACK_IMPORTED_MODULE_4_config__["_65" /* XC_URL */].slice(0,-1):__WEBPACK_IMPORTED_MODULE_4_config__["_65" /* XC_URL */];// remove trailing slash
return{types:[__WEBPACK_IMPORTED_MODULE_2__actions__["_190" /* VERIFY_ACCOUNT_FETCH */],__WEBPACK_IMPORTED_MODULE_2__actions__["_192" /* VERIFY_ACCOUNT_FETCH_SUCCESS */],__WEBPACK_IMPORTED_MODULE_2__actions__["_191" /* VERIFY_ACCOUNT_FETCH_FAIL */]],promise:function promise(client){return client.get('/xara-basic/confirmation',{params:{host:host}})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_5__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_7__errors_apperror__["a" /* default */]({message:'session.verifyUserAccount() failed',errorId:__WEBPACK_IMPORTED_MODULE_6__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_8__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_SESSION'}});throw nError;});}};};/**
 * Dispatches a redux action with a promise that will write the user settings to the middleware
 *
 * @param {Function} dispatch provided by Redux' mapDispatchToProps
 * @param {Object} settings the new user settings to be stored on the middleware
 */var dispatchWriteSettings=function dispatchWriteSettings(dispatch,settings){return dispatch({types:[__WEBPACK_IMPORTED_MODULE_2__actions__["_186" /* USER_SETTING_WRITE */],__WEBPACK_IMPORTED_MODULE_2__actions__["_188" /* USER_SETTING_WRITE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_2__actions__["_187" /* USER_SETTING_WRITE_FAIL */]],payload:settings,promise:function promise(client){return client.patch('/settings',{data:{settings:settings}})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_5__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_7__errors_apperror__["a" /* default */]({message:'session.dispatchWriteSettings() failed',errorId:__WEBPACK_IMPORTED_MODULE_6__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_8__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_SESSION'}});throw nError;});}});};/**
 * Writes the provided settings to the user settings object on the middleware, under the CAP_KEY property.
 * @param {Object} newSettings to be recursively merged onto the old ones
 */var writeUserSettings=function writeUserSettings(newSettings){return function(dispatch){return dispatchWriteSettings(dispatch,__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({},__WEBPACK_IMPORTED_MODULE_4_config__["k" /* CAP_KEY */],newSettings));};};/**
 * Resets the existing onboarding settings, by writing the provided object at the CAP_KEY.ONBOARDING_KEY path.
 * @param {Object} newOnboardingSettings to overwrite the previous ones
 */var resetOnBoardingSettings=function resetOnBoardingSettings(newOnboardingSettings){return function(dispatch,getState){return dispatchWriteSettings(dispatch,__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({},"".concat(__WEBPACK_IMPORTED_MODULE_4_config__["k" /* CAP_KEY */],".").concat(__WEBPACK_IMPORTED_MODULE_4_config__["_1" /* ONBOARDING_KEY */]),newOnboardingSettings));};};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(30);
var hide = __webpack_require__(59);
var has = __webpack_require__(58);
var SRC = __webpack_require__(108)('src');
var $toString = __webpack_require__(472);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(41).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);
var fails = __webpack_require__(31);
var defined = __webpack_require__(86);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _shouldUpdate = _interopRequireDefault(__webpack_require__(904));

var _shallowEqual = _interopRequireDefault(__webpack_require__(908));

var _setDisplayName = _interopRequireDefault(__webpack_require__(421));

var _wrapDisplayName = _interopRequireDefault(__webpack_require__(422));

var pure = function pure(BaseComponent) {
  var hoc = (0, _shouldUpdate.default)(function (props, nextProps) {
    return !(0, _shallowEqual.default)(props, nextProps);
  });

  if (false) {
    return (0, _setDisplayName.default)((0, _wrapDisplayName.default)(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

var _default = pure;
exports.default = _default;

/***/ }),
/* 58 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(43);
var createDesc = __webpack_require__(107);
module.exports = __webpack_require__(47) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(142);
var defined = __webpack_require__(86);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(380);
var isBuffer = __webpack_require__(793);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Paper.default;
  }
});

var _Paper = _interopRequireDefault(__webpack_require__(854));

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ButtonBase.default;
  }
});

var _ButtonBase = _interopRequireDefault(__webpack_require__(857));

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(886);
/* unused harmony reexport BrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(888);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(414);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(889);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(890);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(891);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(892);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(415);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(276);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(893);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(894);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(895);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(896);
/* unused harmony reexport withRouter */



























/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(31);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 67 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__baseerror__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
var HttpError=/*#__PURE__*/function(_BaseError){__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(HttpError,_BaseError);function HttpError(_ref){var _this;var message=_ref.message,errorId=_ref.errorId,_ref$name=_ref.name,name=_ref$name===void 0?'HttpError':_ref$name,errorDetails=_ref.errorDetails,details=_ref.details,visualisers=_ref.visualisers,messageType=_ref.messageType,responseText=_ref.responseText,tag=_ref.tag,responseURL=_ref.responseURL,textStatus=_ref.textStatus,responseType=_ref.responseType,status=_ref.status,response=_ref.response,originalError=_ref.originalError;__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this,HttpError);_this=__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(HttpError).call(this,{message:message,errorId:errorId,name:name,tag:tag,errorDetails:errorDetails,details:details,visualisers:visualisers,originalError:originalError,messageType:messageType}));__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this),"status",void 0);__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this),"type",void 0);__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this),"textStatus",void 0);__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this),"responseText",void 0);__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this),"responseURL",void 0);__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this),"errorDetails",void 0);__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this),"responseType",void 0);Object.setPrototypeOf(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this),HttpError.prototype);if('captureStackTrace'in Error){Error.captureStackTrace(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this),_this.constructor);}_this.textStatus=textStatus;_this.status=status;responseText&&(_this.responseText=responseText);responseURL&&(_this.responseURL=responseURL);// responseType: json, document, blob, text, arraybuffer, ''
responseType&&(_this.responseType=responseType);if(response instanceof Response){// used with fetch()
_this.textStatus=response.statusText;_this.status=response.status;// type: basic/cors/error/opaque/opaqueredirect
_this.type=response.type;_this.responseURL=response.url;}return _this;}__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(HttpError,[{key:"getPropertiesToLogAsJson",value:function getPropertiesToLogAsJson(){var results=__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},this.errorDetails);return!__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.isEmpty(results)?results:null;}},{key:"getApiErrorId",value:function getApiErrorId(){var result=null;if(this.responseText){try{var errorResponse=JSON.parse(this.responseText);result=errorResponse&&errorResponse.error&&errorResponse.error.errorid||errorResponse.errorid;}catch(err){//silently ignore error
}}return result;}},{key:"getPropertiesToLog",value:function getPropertiesToLog(){var results=__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},this.details,{responseURL:this.responseURL,responseText:this.responseText,textStatus:this.textStatus,type:this.type,status:this.status,responseType:this.responseType});return!__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.isEmpty(results)?results:null;}}]);return HttpError;}(__WEBPACK_IMPORTED_MODULE_8__baseerror__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (HttpError);

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return topBarHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mainNavWidth; });
/* unused harmony export logoContainerHeight */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return quickMessageDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return quickMessageFadeOutDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return emailValidationPattern; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return typingDebounceTimeout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actionButtonDebounceTimeout; });
var topBarHeight=70;var mainNavWidth=240;var logoContainerHeight='90px';var quickMessageDuration=5000;// how long a quick message is displayed for, in ms
var quickMessageFadeOutDuration=300;// how long a quick message takes to fade out, in ms
var emailValidationPattern=/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,63}$/i;var typingDebounceTimeout=300;var actionButtonDebounceTimeout=500;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cloneElementWithClassName = cloneElementWithClassName;
exports.cloneChildrenWithClassName = cloneChildrenWithClassName;
exports.isMuiElement = isMuiElement;
exports.setRef = setRef;

var _react = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(4));

function cloneElementWithClassName(child, className) {
  return _react.default.cloneElement(child, {
    className: (0, _classnames.default)(child.props.className, className)
  });
}

function cloneChildrenWithClassName(children, className) {
  return _react.default.Children.map(children, function (child) {
    return _react.default.isValidElement(child) && cloneElementWithClassName(child, className);
  });
}

function isMuiElement(element, muiNames) {
  return _react.default.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _IconButton.default;
  }
});

var _IconButton = _interopRequireDefault(__webpack_require__(944));

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Dialog.default;
  }
});

var _Dialog = _interopRequireDefault(__webpack_require__(989));

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _DialogContent.default;
  }
});

var _DialogContent = _interopRequireDefault(__webpack_require__(991));

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(203));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
})), 'KeyboardArrowDown');

exports.default = _default;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(76);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 77 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(143);
var createDesc = __webpack_require__(107);
var toIObject = __webpack_require__(60);
var toPrimitive = __webpack_require__(100);
var has = __webpack_require__(58);
var IE8_DOM_DEFINE = __webpack_require__(305);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(47) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(12);
var core = __webpack_require__(41);
var fails = __webpack_require__(31);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(75);
var IObject = __webpack_require__(142);
var toObject = __webpack_require__(53);
var toLength = __webpack_require__(37);
var asc = __webpack_require__(321);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertHexToRGB = convertHexToRGB;
exports.rgbToHex = rgbToHex;
exports.decomposeColor = decomposeColor;
exports.recomposeColor = recomposeColor;
exports.getContrastRatio = getContrastRatio;
exports.getLuminance = getLuminance;
exports.emphasize = emphasize;
exports.fade = fade;
exports.darken = darken;
exports.lighten = lighten;

var _warning = _interopRequireDefault(__webpack_require__(27));

/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
   false ? (0, _warning.default)(value >= min && value <= max, "Material-UI: the value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "].")) : void 0;

  if (value < min) {
    return min;
  }

  if (value > max) {
    return max;
  }

  return value;
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function convertHexToRGB(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length / 3, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb(".concat(colors.map(function (n) {
    return parseInt(n, 16);
  }).join(', '), ")") : '';
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 *
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */


function rgbToHex(color) {
  // Pass hex straight through
  if (color.indexOf('#') === 0) {
    return color;
  }

  function intToHex(c) {
    var hex = c.toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
  }

  var _decomposeColor = decomposeColor(color),
      values = _decomposeColor.values;

  values = values.map(function (n) {
    return intToHex(n);
  });
  return "#".concat(values.join(''));
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */


function decomposeColor(color) {
  if (color.charAt(0) === '#') {
    return decomposeColor(convertHexToRGB(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);
  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });

  if (false) {
    if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
      throw new Error(["Material-UI: unsupported `".concat(color, "` color."), 'We support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().'].join('\n'));
    }
  }

  return {
    type: type,
    values: values
  };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */


function recomposeColor(color) {
  var type = color.type;
  var values = color.values;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  }

  if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }

  return "".concat(color.type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */


function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */


function getLuminance(color) {
  var decomposedColor = decomposeColor(color);

  if (decomposedColor.type.indexOf('rgb') !== -1) {
    var rgb = decomposedColor.values.map(function (val) {
      val /= 255; // normalized

      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }); // Truncate at 3 digits

    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
  } // else if (decomposedColor.type.indexOf('hsl') !== -1)


  return decomposedColor.values[2] / 100;
}
/**
 * Darken or lighten a colour, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function fade(color, value) {
   false ? (0, _warning.default)(color, "Material-UI: missing color argument in fade(".concat(color, ", ").concat(value, ").")) : void 0;
  if (!color) return color;
  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  color.values[3] = value;
  return recomposeColor(color);
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function darken(color, coefficient) {
   false ? (0, _warning.default)(color, "Material-UI: missing color argument in darken(".concat(color, ", ").concat(coefficient, ").")) : void 0;
  if (!color) return color;
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function lighten(color, coefficient) {
   false ? (0, _warning.default)(color, "Material-UI: missing color argument in lighten(".concat(color, ", ").concat(coefficient, ").")) : void 0;
  if (!color) return color;
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return history; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setConfirmationFunction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__asyncMiddleware__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__trackingMiddleware__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__socketMiddleware__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lib_ApiClient__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_history_createHashHistory__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_clientid__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_logger__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_redux_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_Segment__ = __webpack_require__(385);
var confirmationFn=null;var history=__WEBPACK_IMPORTED_MODULE_7_history_createHashHistory___default()({hashType:'noslash',getUserConfirmation:function getUserConfirmation(message,callback){if(confirmationFn){confirmationFn(message,callback);}else{callback(true);}}});var setConfirmationFunction=function setConfirmationFunction(fn){confirmationFn=fn;};var initialState={};var enhancers=[];var middleware=[Object(__WEBPACK_IMPORTED_MODULE_2__asyncMiddleware__["a" /* default */])(new __WEBPACK_IMPORTED_MODULE_5_lib_ApiClient__["a" /* default */](__WEBPACK_IMPORTED_MODULE_11_config__["P" /* HTTP_API_URL */],__WEBPACK_IMPORTED_MODULE_11_config__["Q" /* HTTP_MLS_API_URL */],__WEBPACK_IMPORTED_MODULE_9_utils_clientid__["a" /* default */]),__WEBPACK_IMPORTED_MODULE_6_axios___default.a),Object(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__["b" /* routerMiddleware */])(history),Object(__WEBPACK_IMPORTED_MODULE_4__socketMiddleware__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_11_config__["_35" /* SOCKET_URL */],__WEBPACK_IMPORTED_MODULE_9_utils_clientid__["a" /* default */])];if(__WEBPACK_IMPORTED_MODULE_11_config__["_28" /* SEGMENT */]){Object(__WEBPACK_IMPORTED_MODULE_12__lib_Segment__["a" /* loadSegment */])();middleware.push(__WEBPACK_IMPORTED_MODULE_3__trackingMiddleware__["a" /* default */]);}if(false){var devToolsExtension=window.devToolsExtension;if(typeof devToolsExtension==='function'){enhancers.push(devToolsExtension());}middleware.push(loggerMiddleware);}var reduxMiddleware=__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */].apply(void 0,middleware);var composedEnhancers=__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* compose */].apply(void 0,[reduxMiddleware].concat(enhancers));var store=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* createStore */])(__WEBPACK_IMPORTED_MODULE_8__modules__["a" /* default */],initialState,composedEnhancers);/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getErrorsById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isNetworkStatusOffline; });
/* unused harmony export resolveErrorId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return extractPropsforAxiosHttpError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return extractPropsforSuperagentHttpError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__errors_baseerror__ = __webpack_require__(189);
var getErrorsById=function getErrorsById(){var flattenErrorIds={};var errorKeys=Object.keys(__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */]);for(var i=errorKeys.length-1;i>=0;i--){var key=errorKeys[i];var currentError=__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */][key];if(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isObject(currentError)){var childKeys=Object.keys(currentError);for(var j=childKeys.length-1;j>=0;j--){var childKey=childKeys[j];var newPropertyKey=key+'_'+childKey;flattenErrorIds[newPropertyKey]=currentError[childKey];}}else{flattenErrorIds[key]=__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */][key];}}return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.invert(flattenErrorIds);};var isNetworkStatusOffline=function isNetworkStatusOffline(error){var _error$message,_error$message2,_error$message3;// Compare by error message to simplify offline case detection in axios vs superagent
return(error===null||error===void 0?void 0:(_error$message=error.message)===null||_error$message===void 0?void 0:_error$message.toLowerCase().includes('offline'))||(error===null||error===void 0?void 0:(_error$message2=error.message)===null||_error$message2===void 0?void 0:_error$message2.toLowerCase().includes('request has been terminated'))||(error===null||error===void 0?void 0:(_error$message3=error.message)===null||_error$message3===void 0?void 0:_error$message3.toLowerCase().includes('network error'));};var resolveErrorId=function resolveErrorId(error){var result;if(error instanceof __WEBPACK_IMPORTED_MODULE_2__errors_baseerror__["a" /* default */]&&error.errorId){result=error.errorId;}else if(error.responseText){try{var errorResponse=JSON.parse(error.responseText);result=errorResponse&&(errorResponse.errorid||errorResponse.errorId);}catch(err){//silently ignore error, fallback value will be assigned by caller
}}else if(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'response.data')){// error id from axios is saved in response.data
result=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'response.data.errorid')||__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'response.data.errorId');}else if(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'response.body')){// error id from superagent is saved in response.body
result=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'response.body.errorid')||__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'response.body.errorId');}return result;};var extractPropsforAxiosHttpError=function extractPropsforAxiosHttpError(error){var errorId;var resolvedId;var isOffline=isNetworkStatusOffline(error);if(isOffline){errorId=__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].OFFLINE;}else if(resolvedId=resolveErrorId(error)){errorId=resolvedId;}else{errorId=__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].XHR_FAILED;}var result={message:isOffline?'Network Error (6017)'//OFFLINE/CORS/webdev blocked
:error.message||'unknown-axios-http-error',errorId:errorId,textStatus:__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'request.statusText'),responseText:__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'response.data')||__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'request.responseText'),status:__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'response.status')||__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'request.status'),responseURL:__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'config.url')||error.request.responseURL,responseType:__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'request.responseType')};return result;};var extractPropsforSuperagentHttpError=function extractPropsforSuperagentHttpError(error){var errorId;var resolvedId;var isOffline=isNetworkStatusOffline(error);if(isOffline){errorId=__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].OFFLINE;}else if(resolvedId=resolveErrorId(error)){errorId=resolvedId;}else{errorId=__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].XHR_FAILED;}var result={message:isOffline?'Network Error (6017)'//OFFLINE/CORS/webdev blocked
:error.message||'unknown-superagent-http-error',errorId:errorId,textStatus:__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'response.statusText'),responseText:__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'response.text'),status:__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'response.status'),responseURL:__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'response.error.url')||__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'url'),responseType:__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(error,'response.type')};return result;};

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__);
var styles=function styles(theme){return{root:__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({margin:'0 5%'},theme.breakpoints.up('md'),{margin:'0 30px'}),withPadding:{padding:"".concat(6*theme.spacing.unit,"px 0")}};};var CenteredContent=function CenteredContent(props){var classes=props.classes,children=props.children,className=props.className,_props$padding=props.padding,padding=_props$padding===void 0?true:_props$padding;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()(classes.root,className,padding&&classes.withPadding)},children);};CenteredContent.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,children:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,padding:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__["withStyles"])(styles)(CenteredContent));

/***/ }),
/* 85 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 86 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(47)) {
  var LIBRARY = __webpack_require__(109);
  var global = __webpack_require__(30);
  var fails = __webpack_require__(31);
  var $export = __webpack_require__(12);
  var $typed = __webpack_require__(178);
  var $buffer = __webpack_require__(241);
  var ctx = __webpack_require__(75);
  var anInstance = __webpack_require__(131);
  var propertyDesc = __webpack_require__(107);
  var hide = __webpack_require__(59);
  var redefineAll = __webpack_require__(132);
  var toInteger = __webpack_require__(77);
  var toLength = __webpack_require__(37);
  var toIndex = __webpack_require__(332);
  var toAbsoluteIndex = __webpack_require__(111);
  var toPrimitive = __webpack_require__(100);
  var has = __webpack_require__(58);
  var classof = __webpack_require__(144);
  var isObject = __webpack_require__(33);
  var toObject = __webpack_require__(53);
  var isArrayIter = __webpack_require__(233);
  var create = __webpack_require__(112);
  var getPrototypeOf = __webpack_require__(114);
  var gOPN = __webpack_require__(113).f;
  var getIterFn = __webpack_require__(235);
  var uid = __webpack_require__(108);
  var wks = __webpack_require__(35);
  var createArrayMethod = __webpack_require__(80);
  var createArrayIncludes = __webpack_require__(168);
  var speciesConstructor = __webpack_require__(145);
  var ArrayIterators = __webpack_require__(237);
  var Iterators = __webpack_require__(129);
  var $iterDetect = __webpack_require__(171);
  var setSpecies = __webpack_require__(130);
  var arrayFill = __webpack_require__(236);
  var arrayCopyWithin = __webpack_require__(323);
  var $DP = __webpack_require__(43);
  var $GOPD = __webpack_require__(78);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.isNumber = exports.isString = exports.formatMs = exports.duration = exports.easing = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _warning = _interopRequireDefault(__webpack_require__(27));

/* eslint-disable no-restricted-globals */
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

exports.easing = easing;
var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
exports.duration = duration;

var formatMs = function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
};

exports.formatMs = formatMs;

var isString = function isString(value) {
  return typeof value === 'string';
};

exports.isString = isString;

var isNumber = function isNumber(value) {
  return !isNaN(parseFloat(value));
};
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */


exports.isNumber = isNumber;
var _default = {
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$duration = options.duration,
        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === void 0 ? 0 : _options$delay,
        other = (0, _objectWithoutProperties2.default)(options, ["duration", "easing", "delay"]);
     false ? (0, _warning.default)(isString(props) || Array.isArray(props), 'Material-UI: argument "props" must be a string or Array.') : void 0;
     false ? (0, _warning.default)(isNumber(durationOption) || isString(durationOption), "Material-UI: argument \"duration\" must be a number or a string but found ".concat(durationOption, ".")) : void 0;
     false ? (0, _warning.default)(isString(easingOption), 'Material-UI: argument "easing" must be a string.') : void 0;
     false ? (0, _warning.default)(isNumber(delay) || isString(delay), 'Material-UI: argument "delay" must be a number or a string.') : void 0;
     false ? (0, _warning.default)(Object.keys(other).length === 0, "Material-UI: unrecognized argument(s) [".concat(Object.keys(other).join(','), "]")) : void 0;
    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
};
exports.default = _default;

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return makeQueryString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCompanyIdFromURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLinkToEditor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parseQuery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config__ = __webpack_require__(17);
var makeQueryString=function makeQueryString(params){return Object.entries(params).map(function(pair){return pair.map(encodeURIComponent).join('=');}).join('&');};/**
 * Extracts the first part of the URL after the hash (#) up to the first slash (/), if available, to be used as a company id
 */var getCompanyIdFromURL=function getCompanyIdFromURL(){var hash=window.location.hash;if(hash.length>1){return hash.split('?')[0].substr(1).split('/')[0];}};var getLinkToEditor=function getLinkToEditor(companyName){var encodedCompanyName=encodeURIComponent(companyName);return"".concat(__WEBPACK_IMPORTED_MODULE_0_config__["_65" /* XC_URL */],"?company=").concat(encodedCompanyName);};/**
 * Parse URL query string, with or without '?'. It is safe to pass document.location.search.
 *
 * For example:
 * parseQuery('?param1=value1&param2=value2')
 * returns:
 * { param1: 'value1', param2: 'value2' }
 *
 * @param queryString string with query parameters from URL
 * @returns Object with parameters as keys and their corresponding values
 */var parseQuery=function parseQuery(queryString){var params={};var i=0;var pair;// initialise to empty string if falsy
queryString||(queryString='');// remove first ? if present
if(queryString.length&&queryString.charAt(0)=='?'){queryString=queryString.substr(1);}// cast to string and split parameter / value pairs
queryString=(queryString+'').split('&');for(;i<queryString.length;i++){// split parameter from value
pair=queryString[i].split('=',2);if(pair[0]){params[pair[0]]=pair[1]?decodeURIComponent(pair[1].replace(/\+/g,' ')):undefined;}}return params;};

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PERMISSION_ROLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return doesUserExist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isDuplicateEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return filterNonGuestUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return encodeUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return decodeUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return sortUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getSavedTableSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getTableStyleProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return sortTable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(17);
var PERMISSION_ROLE=[];Object.keys(__WEBPACK_IMPORTED_MODULE_3__config__["_53" /* USER_ROLES */]).forEach(function(key){PERMISSION_ROLE.push({key:key,value:__WEBPACK_IMPORTED_MODULE_3__config__["_53" /* USER_ROLES */][key].label,trackingName:__WEBPACK_IMPORTED_MODULE_3__config__["_53" /* USER_ROLES */][key].trackingName});});var SMALL_BREAKPOINT_NAME_WIDTH=150;var SMALL_BREAKPOINT_EMAIL_WIDTH=180;/**
 * Check if the user already exists
 * @param {array} users all users in current company
 * @param {string} email user's email
 * @param {string} role The new role
 * @returns bool
 *
 * @memberof Users
 */var doesUserExist=function doesUserExist(users,email,role){// If role is passed, check a user with the passed email and a role.
if(role){return users.some(function(user){return user.email.toLocaleLowerCase()===email.toLocaleLowerCase()&&user.role.toLocaleLowerCase()===role.toLocaleLowerCase();});}return users.some(function(user){return user.email.toLocaleLowerCase()===email.toLocaleLowerCase();});};/**
 * Check if user is already in the invite list
 * @param {array} users users already added to invite popup
 * @param {string} email user's email
 * @returns bool
 *
 * @memberof Users
 */var isDuplicateEntry=function isDuplicateEntry(users,email,id){return users.some(function(user){return user.email.toLocaleLowerCase()===email.toLocaleLowerCase()&&user.id!==id;});};/**
 * Return admins and members only
 * @param {array} users users in company
 * @returns array
 *
 * @memberof Users
 */var filterNonGuestUsers=function filterNonGuestUsers(users){return users?users.filter(function(user){return[__WEBPACK_IMPORTED_MODULE_3__config__["_54" /* USER_ROLE_ADMIN */],__WEBPACK_IMPORTED_MODULE_3__config__["_55" /* USER_ROLE_BASIC */]].includes(user.role);}):[];};// Maps user data from Middleware to data used by UI
var encodeUser=function encodeUser(user){var name=user.name,email=user.email,role=user.role,userId=user.userId,externalIds=user.externalIds,profilePhotoUri=user.profilePhotoUri,inviteCounter=user.inviteCounter,lastSessionTime=user.lastSessionTime;return{name:name,email:email,trackingName:PERMISSION_ROLE.filter(function(item){return item.key==role;})[0].trackingName,role:PERMISSION_ROLE.filter(function(item){return item.key==role;})[0].value,userId:userId,externalIds:externalIds,profilePhotoUri:profilePhotoUri,inviteCounter:inviteCounter,lastSessionTime:lastSessionTime};};// Maps user data from UI to data used by Middleware
var decodeUser=function decodeUser(user){var email=user.email,role=user.role,userId=user.userId,profilePhotoUri=user.profilePhotoUri,lastSessionTime=user.lastSessionTime;return{email:email,userId:userId,trackingName:PERMISSION_ROLE.filter(function(item){return item.value==role;})[0].trackingName,role:PERMISSION_ROLE.filter(function(item){return item.value==role;})[0].key,profilePhotoUri:profilePhotoUri,lastSessionTime:lastSessionTime};};/**
 * Sort users by key/order
*/var sortUsers=function sortUsers(users,sortKey,sortOrder){var result=users.sort(function(a,b){if(!sortKey||sortKey===__WEBPACK_IMPORTED_MODULE_3__config__["_46" /* TABLE_COLUMNS */].FULL_NAME){// sort by name ascending or decending first, then by email ascending
return!sortOrder||sortOrder===__WEBPACK_IMPORTED_MODULE_3__config__["_36" /* SORT_ORDER */].ASC?a.name.localeCompare(b.name)||a.email.localeCompare(b.email):b.name.localeCompare(a.name)||a.email.localeCompare(b.email);}else if(sortKey==__WEBPACK_IMPORTED_MODULE_3__config__["_46" /* TABLE_COLUMNS */].MLS_ID_TYPE2){var firstAKey=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(a,'originalAgentMlsId','');var firstBKey=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(b,'originalAgentMlsId','');return sortOrder===__WEBPACK_IMPORTED_MODULE_3__config__["_36" /* SORT_ORDER */].ASC?firstAKey.localeCompare(firstBKey):firstBKey.localeCompare(firstAKey);}else if(sortKey==__WEBPACK_IMPORTED_MODULE_3__config__["_46" /* TABLE_COLUMNS */].MLS_ID){var _firstAKey=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(a,'externalIds[0]')||'';var _firstBKey=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(b,'externalIds[0]')||'';return sortOrder===__WEBPACK_IMPORTED_MODULE_3__config__["_36" /* SORT_ORDER */].ASC?_firstAKey.localeCompare(_firstBKey):_firstBKey.localeCompare(_firstAKey);}else if(sortKey==__WEBPACK_IMPORTED_MODULE_3__config__["_46" /* TABLE_COLUMNS */].EMAIL){return sortOrder===__WEBPACK_IMPORTED_MODULE_3__config__["_36" /* SORT_ORDER */].ASC?a.email.localeCompare(b.email):b.email.localeCompare(a.email);}else if(sortKey==__WEBPACK_IMPORTED_MODULE_3__config__["_46" /* TABLE_COLUMNS */].CONNECTION_STATUS){return sortOrder===__WEBPACK_IMPORTED_MODULE_3__config__["_36" /* SORT_ORDER */].ASC?Number(b.mlsConnected)-Number(a.mlsConnected):Number(a.mlsConnected)-Number(b.mlsConnected);}else if(sortKey==__WEBPACK_IMPORTED_MODULE_3__config__["_46" /* TABLE_COLUMNS */].ROLE){// sort by role ascending or decending first, then by name and email ascending
return sortOrder===__WEBPACK_IMPORTED_MODULE_3__config__["_36" /* SORT_ORDER */].ASC?a.role.localeCompare(b.role)||a.name.localeCompare(b.name)||a.email.localeCompare(b.email):b.role.localeCompare(a.role)||a.name.localeCompare(b.name)||a.email.localeCompare(b.email);}});if(!sortKey||sortKey==__WEBPACK_IMPORTED_MODULE_3__config__["_46" /* TABLE_COLUMNS */].FULL_NAME||sortKey==__WEBPACK_IMPORTED_MODULE_3__config__["_46" /* TABLE_COLUMNS */].MLS_ID||sortKey==__WEBPACK_IMPORTED_MODULE_3__config__["_46" /* TABLE_COLUMNS */].MLS_ID_TYPE2){// If Name or MLS ID is empty, it should be at the very bottom, but sorted by Email.
result=result.sort(function(a,b){var aNameEmpty=a.name.length===0?1:0;var bNameEmpty=b.name.length===0?1:0;if(aNameEmpty||bNameEmpty){return aNameEmpty-bNameEmpty;}});}return result;};var getSavedTableSettings=function getSavedTableSettings(settings,tableId,property){return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(settings,"cap[".concat(__WEBPACK_IMPORTED_MODULE_3__config__["_52" /* USER_PAGE_SETTINGS_KEY */],"][").concat(tableId,"][").concat(property,"]"));};var getTableStyleProps=function getTableStyleProps(tableId,theme){return{/* no users message */noUsersFound:__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({width:'100%',textAlign:'center'},__WEBPACK_IMPORTED_MODULE_3__config__["_61" /* USER_TABLE_MANAGE_AGENTS */]===tableId&&{opacity:1,font:'13px/19px Open Sans, sans-serif',fontSize:13,fontStyle:'normal',fontWeight:400,display:'inline',marginRight:8}),/* table */table:__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({tableLayout:'fixed'},tableId===__WEBPACK_IMPORTED_MODULE_3__config__["_59" /* USER_TABLE_ALL */]&&{marginBottom:65},[__WEBPACK_IMPORTED_MODULE_3__config__["_61" /* USER_TABLE_MANAGE_AGENTS */],__WEBPACK_IMPORTED_MODULE_3__config__["_62" /* USER_TABLE_REDUCE_USERS */]].includes(tableId)&&{width:'calc(100% - 15px)'}),tableHeadRow:{backgroundColor:'#F4F4F4'},tableBodyRow:{'&.transtionsEnabled':{transitionDuration:'1s !important'},'&:nth-of-type(even)':{backgroundColor:'#F4F4F4'},'&:hover':{backgroundColor:'#e8e8e8 !important'}},tableHasSortArrow:{position:'relative',paddingLeft:52},tableCellHeader:{fontSize:14},tableNameCellHeader:__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},tableId===__WEBPACK_IMPORTED_MODULE_3__config__["_59" /* USER_TABLE_ALL */]&&{width:184},__WEBPACK_IMPORTED_MODULE_3__config__["_61" /* USER_TABLE_MANAGE_AGENTS */]===tableId&&__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({width:200},theme.breakpoints.down('sm'),{width:SMALL_BREAKPOINT_NAME_WIDTH}),__WEBPACK_IMPORTED_MODULE_3__config__["_62" /* USER_TABLE_REDUCE_USERS */]===tableId&&__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({width:230},theme.breakpoints.down('sm'),{width:SMALL_BREAKPOINT_NAME_WIDTH})),tableRoleCellHeader:__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},tableId===__WEBPACK_IMPORTED_MODULE_3__config__["_59" /* USER_TABLE_ALL */]&&{width:120,overflow:'visible',paddingLeft:28}),tableEmailCellHeader:__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},__WEBPACK_IMPORTED_MODULE_3__config__["_61" /* USER_TABLE_MANAGE_AGENTS */]===tableId&&__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({width:250},theme.breakpoints.down('sm'),{width:SMALL_BREAKPOINT_EMAIL_WIDTH}),__WEBPACK_IMPORTED_MODULE_3__config__["_62" /* USER_TABLE_REDUCE_USERS */]===tableId&&__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({width:270},theme.breakpoints.down('sm'),{width:SMALL_BREAKPOINT_EMAIL_WIDTH})),tableMLSCellHeader:{},tableSelectReduceActionCellHeader:{paddingLeft:0,width:205},tableConnectionStatusCellHeader:{width:200},tableCellBody:__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({fontSize:14},__WEBPACK_IMPORTED_MODULE_3__config__["_61" /* USER_TABLE_MANAGE_AGENTS */]===tableId&&{height:68}),tableActionsCell:{width:40},tableCellReduceAction:{paddingRight:'5px !important'},tableNotFoundCellBody:{textAlign:'center'},noBorderedCell:{},verticalTopCell:{verticalAlign:'top',paddingTop:0},tablePhotoCellHeader:{width:184},tableNameCellBody:__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},tableId===__WEBPACK_IMPORTED_MODULE_3__config__["_59" /* USER_TABLE_ALL */]&&{width:184},__WEBPACK_IMPORTED_MODULE_3__config__["_61" /* USER_TABLE_MANAGE_AGENTS */]===tableId&&__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({width:200},theme.breakpoints.down('sm'),{width:SMALL_BREAKPOINT_NAME_WIDTH}),__WEBPACK_IMPORTED_MODULE_3__config__["_62" /* USER_TABLE_REDUCE_USERS */]===tableId&&__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({width:230},theme.breakpoints.down('sm'),{width:SMALL_BREAKPOINT_NAME_WIDTH})),tableEmailCellBody:__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},__WEBPACK_IMPORTED_MODULE_3__config__["_61" /* USER_TABLE_MANAGE_AGENTS */]===tableId&&__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({width:250},theme.breakpoints.down('sm'),{width:SMALL_BREAKPOINT_EMAIL_WIDTH}),__WEBPACK_IMPORTED_MODULE_3__config__["_62" /* USER_TABLE_REDUCE_USERS */]===tableId&&__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({width:270},theme.breakpoints.down('sm'),{width:SMALL_BREAKPOINT_EMAIL_WIDTH})),tableRoleCellBody:{},tableSelectActionCellBody:{width:205},tableConnectionStatusCellBody:{width:190},/* table head */tableHead:{paddingBottom:15},columnTableTitle:{width:'auto'},tableTitle:{fontSize:'15px',lineHeight:'20px',fontWeight:600},columnTableInfo:{width:'auto',alignItems:'center',marginLeft:10},sortArrow:{position:'absolute',top:'50%',transform:'translateY(-50%)',left:18,opacity:0.3,'&.leftAligned':{left:-7},'&.active':{opacity:1},'&.desc':{transform:'translateY(-50%) rotate(-180deg)'}},/* role select */roleSelect:{minWidth:115,'& [class*=MuiSelect-selectMenu]':{fontSize:14}},roleSelectItems:{'& li':{fontSize:14}},/* MLS field */emptySelfStartMlsId:{cursor:'pointer',padding:'11px 7px',maxWidth:185,borderRadius:5,marginLeft:'-6px','&:hover':{background:'#e5eef3'}},nonEmptySelfStartMlsId:{cursor:'pointer',padding:'4px 7px',maxWidth:185,borderRadius:5,minHeight:40,display:'flex',flexDirection:'column',justifyContent:'center',marginLeft:'-6px','&:hover':{background:'#e5eef3'}},noConnectionSelfStartMlsId:{padding:'4px 7px',maxWidth:185,borderRadius:5,minHeight:40,display:'flex',flexDirection:'column',justifyContent:'center',marginLeft:'-6px'},errorSelfStartMlsId:{color:theme.palette.error.main,fontSize:14,lineHeight:1.5,opacity:1},loadingSelfStartMlsId:{textAlign:'left','& svg':{marginLeft:0}},/* MLS field */emptyExternalMlsId:{color:theme.palette.colors.colorWithAlpha(theme.palette.colors.zeta,0.5),paddingTop:8,minHeight:38,font:'13px/19px Open Sans, sans-serif','&:not(:first-child)':{marginTop:10}},updatingMlsIdNode:{maxWidth:370,paddingTop:8,minHeight:38,font:'13px/19px Open Sans, sans-serif','&:not(:first-child)':{marginTop:10}},nonEditableMlsIdValueNode:{maxWidth:370,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',paddingLeft:6,paddingTop:8,minHeight:38,font:'13px/19px Open Sans, sans-serif','&:not(:first-child)':{marginTop:10}},tableMLSCellHeaderLabel:{display:'inline',marginRight:2},/* tooltip content in table cell */tooltipList:{margin:'0 5px'},tooltipListItem:{textAlign:'left',fontSize:12,lineHeight:1.5,position:'relative',padding:'0 0 0 10px','&:before':{content:'""',display:'inline-block',width:'3px',height:'3px',borderRadius:3,background:'#fff',position:'absolute',top:7,left:0}},/* info tooltip for header cell */infoIconButton:{position:'relative',width:16,height:16,margin:'-2px 0 0 5px',color:theme.palette.colors.white,backgroundColor:'#6F99BD',borderColor:'#6F99BD',padding:0,'&:hover':{backgroundColor:"".concat(theme.palette.colors.epsilonHover," !important"),borderColor:"".concat(theme.palette.colors.epsilonHover," !important")}},tooltipArrow:{position:'absolute',fontSize:6,width:'3em',height:'1em',bottom:0,left:'50%',transform:'translateX(-50%)',marginBottom:'-0.95em','&::before':{content:'""',margin:'auto',display:'block',width:0,height:0,borderStyle:'solid',borderWidth:'1em 1em 0 1em',borderColor:"".concat(theme.palette.common.black," transparent transparent transparent")}},infoTooltip:{padding:7,backgroundColor:theme.palette.common.black},infoTooltipText:{color:theme.palette.common.white,opacity:1},infoTooltipCentered:{textAlign:'center'},/* mls tooltips */mlsInfoTooltipTableHead:{padding:7,backgroundColor:theme.palette.common.black,width:170},mlsInfoTooltipTableBody:{padding:7,backgroundColor:theme.palette.common.black,width:140},/* add users button */buttonAddUsers:__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({background:theme.palette.colors.black,paddingLeft:20,paddingRight:20},__WEBPACK_IMPORTED_MODULE_3__config__["_61" /* USER_TABLE_MANAGE_AGENTS */]===tableId&&{maxWidth:195,margin:'20px auto 20px 8px'}),iconAddUsers:{marginRight:5},/* mls fields */mlsPendingPrompt:{opacity:0.32},mlsInputField:{width:'100%','& [id*=helper-text]':{padding:'0 0 10px',whiteSpace:'nowrap'},margin:0,'& input':{borderWidth:1,borderStyle:'solid',borderRadius:5,borderColor:theme.palette.secondary.lighter,color:theme.palette.text.primary,padding:'7px 6px',width:'100%','&:focus':{borderColor:theme.palette.primary.main}}},mlsErrorMessage:{paddingLeft:'0 !important'},updatingMlsUserGrid:{flexFlow:'row nowrap'},updatingMlsUserValue:{paddingRight:10,paddingLeft:6,width:'calc(100% - 24px)',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'},updatingMlsUserIcon:{width:24},updatingUserIcon:{display:'block',height:'24px',width:'24px',margin:'0 auto',fill:'#bdbdbd',animation:'spin 2s linear infinite'},'@keyframes spin':{'0':{transform:'rotate(0deg)'},'100%':{transform:'rotate(360deg)'}},singleMlsIdField:{maxWidth:370,minHeight:38,'&:not(:first-child)':{marginTop:10}},mlsIdFieldGrid:{flexFlow:'row nowrap'},mlsIdFieldWrapper:{width:'calc(100% - 60px)'},mlsFieldActionIcon:{width:30,paddingLeft:7,paddingTop:8},mlsIconDone:{},mlsIconAdd:{},mlsActionIcon:{opacity:0.5,'&.mls-icon-hover:hover':{color:'#2888C3'}},mlsIconEnabled:{opacity:1},/* externalIds error */externalIdsErrorMessage:{color:theme.palette.colors.error,opacity:1,fontFamily:'"Open Sans Xara", Arial, Helvetica, sans-serif',fontWeight:'normal',fontSize:'13px',lineHeight:'18px',whiteSpace:'normal'}};};var sortTable=function sortTable(_this,tableId,newSortColumnKey,writeUserSettings){var _this$state=_this.state,currentSortKey=_this$state.sortKey,currentSortOrder=_this$state.sortOrder;var newState={};if(!currentSortKey){newState.sortKey=newSortColumnKey;newState.sortOrder=__WEBPACK_IMPORTED_MODULE_3__config__["_36" /* SORT_ORDER */].DESC;}else if(currentSortKey===newSortColumnKey){newState.sortOrder=currentSortOrder===__WEBPACK_IMPORTED_MODULE_3__config__["_36" /* SORT_ORDER */].ASC?__WEBPACK_IMPORTED_MODULE_3__config__["_36" /* SORT_ORDER */].DESC:__WEBPACK_IMPORTED_MODULE_3__config__["_36" /* SORT_ORDER */].ASC;newState.sortKey=currentSortKey;}else if(currentSortKey!==newSortColumnKey){newState.sortKey=newSortColumnKey;newState.sortOrder=__WEBPACK_IMPORTED_MODULE_3__config__["_36" /* SORT_ORDER */].ASC;}_this.setState(newState);// use same settings in all companies
var userPageSettings=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.props.settings,"".concat(__WEBPACK_IMPORTED_MODULE_3__config__["k" /* CAP_KEY */],".").concat(__WEBPACK_IMPORTED_MODULE_3__config__["_52" /* USER_PAGE_SETTINGS_KEY */]),{});userPageSettings[tableId]||(userPageSettings[tableId]={});userPageSettings[tableId].sortKey=newState.sortKey;userPageSettings[tableId].sortOrder=newState.sortOrder;writeUserSettings(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({},__WEBPACK_IMPORTED_MODULE_3__config__["_52" /* USER_PAGE_SETTINGS_KEY */],userPageSettings));};

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isAdmin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isGuest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isTempCompany; });
/* unused harmony export getMarketingTags */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return showNewRealEstateUI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isNewRealEstateUiUsed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__subscription__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__storage__ = __webpack_require__(123);
var _this=this;/**
 * Ideally this shouldn't be needed: the reducers should expose this information in a convenient fashion
 * But since with the current design we need to access this nested piece of data from various components, the best option for
 * now is to have an helper to do it in a centralized place.
 *
 * @param {} state of the application
 * @returns {boolean} is the user administrator of the currently selected company?
 */var isAdmin=function isAdmin(state){return state.companies.rawDataById&&state.companies.selectedId&&state.companies.rawDataById[state.companies.selectedId]&&state.companies.rawDataById[state.companies.selectedId].userIsAdmin;};var isGuest=function isGuest(state){return state.companies.rawDataById&&state.companies.selectedId&&state.companies.rawDataById[state.companies.selectedId]&&state.companies.rawDataById[state.companies.selectedId].userIsGuest;};var isTempCompany=function isTempCompany(state){return state.companies.rawDataById&&state.companies.selectedId&&state.companies.rawDataById[state.companies.selectedId]&&state.companies.rawDataById[state.companies.selectedId].displayName.indexOf(__WEBPACK_IMPORTED_MODULE_1__config__["_47" /* TEMPORARY_COMPANY_PREFIX */])==0;};var getMarketingTags=function getMarketingTags(state){return state.companies.rawDataById&&state.companies.selectedId&&state.companies.rawDataById[state.companies.selectedId]&&state.companies.rawDataById[state.companies.selectedId].marketingTags;};var showNewRealEstateUI=function showNewRealEstateUI(company,isDesktopTrial,isReAccessNoIndustry){if(!company){return false;}var hasTrial=company.hasTrial,isActive=company.isActive,industryId=company.industryId;if(isReAccessNoIndustry||Object(__WEBPACK_IMPORTED_MODULE_3__storage__["q" /* getIsReUpgradePopupFlag */])()){return true;}if(industryId===__WEBPACK_IMPORTED_MODULE_1__config__["_24" /* REAL_ESTATE_INDUSTY_ID */]||Object(__WEBPACK_IMPORTED_MODULE_2__subscription__["p" /* hasRealEstateSubscription */])(company)||Object(__WEBPACK_IMPORTED_MODULE_2__subscription__["m" /* hasCancelledReSubscription */])(company)){var _getSubscriptionsAndA=Object(__WEBPACK_IMPORTED_MODULE_2__subscription__["i" /* getSubscriptionsAndAddons */])(company),perpetualAddons=_getSubscriptionsAndA.perpetualAddons;var hasPendingReSubscription=false;var hasPendingDesktopSubscription=false;var pendingSubscription=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(_this.state,'pendingSubscription');if(!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(pendingSubscription)){var _convertPlanIdIntoSub=Object(__WEBPACK_IMPORTED_MODULE_2__subscription__["a" /* convertPlanIdIntoSubscription */])(pendingSubscription),savedCheckoutPlan=_convertPlanIdIntoSub.plan;if([__WEBPACK_IMPORTED_MODULE_1__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT,__WEBPACK_IMPORTED_MODULE_1__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES].includes(savedCheckoutPlan)){hasPendingReSubscription=true;}if([__WEBPACK_IMPORTED_MODULE_1__config__["_42" /* SUBSCRIPTION_PLAN */].PHOTO,__WEBPACK_IMPORTED_MODULE_1__config__["_42" /* SUBSCRIPTION_PLAN */].WEB,__WEBPACK_IMPORTED_MODULE_1__config__["_42" /* SUBSCRIPTION_PLAN */].DESIGNER].includes(savedCheckoutPlan)){hasPendingDesktopSubscription=true;}}var _getSubscriptionsAndA2=Object(__WEBPACK_IMPORTED_MODULE_2__subscription__["i" /* getSubscriptionsAndAddons */])(company,true),cancelledSubscription=_getSubscriptionsAndA2.subscription;var pendingPerpetualPlans=Object(__WEBPACK_IMPORTED_MODULE_2__subscription__["g" /* getPendingPerpetualPlans */])(company);if(company.hasUnlimitedTeamSubscription){return false;}else if(// Keep old UI active for users with existing subscriptions on old packages
Object(__WEBPACK_IMPORTED_MODULE_2__subscription__["n" /* hasCloudSubscription */])(company)||// show old UI to "desktop users" in RE industry
!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(perpetualAddons)||!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(pendingPerpetualPlans)||hasPendingDesktopSubscription||isDesktopTrial&&!cancelledSubscription||Object(__WEBPACK_IMPORTED_MODULE_2__subscription__["o" /* hasDesktopSubscription */])(company)||Object(__WEBPACK_IMPORTED_MODULE_2__subscription__["l" /* hasCancelledDesktopSubscription */])(company)){return false;}else if(hasTrial||!isActive||hasPendingReSubscription||Object(__WEBPACK_IMPORTED_MODULE_2__subscription__["p" /* hasRealEstateSubscription */])(company)||Object(__WEBPACK_IMPORTED_MODULE_2__subscription__["m" /* hasCancelledReSubscription */])(company)||// Once they fully churn, show the new RE UI to Scale/Essential users:
Object(__WEBPACK_IMPORTED_MODULE_2__subscription__["k" /* hasCancelledCloudSubscription */])(company)){// show new RE UI to trials/freee users in RE industry and active subscribers of new RE plans,
return true;}}else{return false;}};var isNewRealEstateUiUsed=function isNewRealEstateUiUsed(store){var state=store.getState();var companiesRawData=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(state,'companies.rawDataById');var selectedCompanyRawData=companiesRawData[state.companies.selectedId];return showNewRealEstateUI(selectedCompanyRawData,state.app.isDesktopTrial,state.app.isReAccessNoIndustry);};

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return sendConnectMlsRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return sendMlsReviewRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return clearConnectMlsState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addMLSConnectionWithAgentId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addMLSConnectionWithOfficeId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getConnectionList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return fetchMlsBoards; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return deleteMLSConnection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return deleteOfficeId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return addOfficeId; });
/* unused harmony export getMlsAgentsForOffice */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addAgentMlsId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return editAgentMlsId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return deleteAgentMlsId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getAgentMlsIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return resolveMLsUiType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return clearErrorsForConnectionAndUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_store__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_state__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__errors_apperror__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__errors_httperror__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__errors_errorhelper__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_modules_quickMessages__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_i18n_i18n__ = __webpack_require__(15);
var _this=this;var localize=__WEBPACK_IMPORTED_MODULE_12_i18n_i18n__["a" /* default */].loc.localize;var setBoardDisplayName=function setBoardDisplayName(mlsBoardList){return mlsBoardList.map(function(board){var systemName=board.systemName||'';var fullName=board.name||'';// Check if one string contains the other
if(fullName.includes(systemName)){// System Name is contained in Full Name, only display Full Name
board.displayName=fullName;}else if(systemName.includes(fullName)){// Full Name is contained in System Name, only display System Name
board.displayName=systemName;}else{// Neither contains the other, display both with separator
board.displayName="".concat(systemName," / ").concat(fullName);}return board;});};var addNameToConnection=function addNameToConnection(mlsBoardList,connections,source){if(mlsBoardList.length&&connections.length){return connections.map(function(connectionItem){var boardListItem=mlsBoardList.find(function(configItem){return configItem.mlsBoardCode===connectionItem.mlsBoardCode;});var connectionName=__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.get(boardListItem,'displayName','unknown');return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({name:connectionName},connectionItem);}).sort(sortByName.bind(_this,'name'));}else{return connections;}};var sortByName=function sortByName(key,a,b){var nameA=a[key].toUpperCase();var nameB=b[key].toUpperCase();if(nameA<nameB){return-1;}if(nameA>nameB){return 1;}return 0;};var initialState={connectMlsSuccess:null,connectMlsErrorId:null,connectMlsXhrInProgress:false,reviewMlsSuccess:null,reviewMlsErrorId:null,reviewMlsXhrInProgress:false,addConnectionWithAgentIdSuccess:null,addConnectionWithAgentIdErrorId:null,addConnectionWithAgentIdXhrInProgress:false,addConnectionWithOfficeIdSuccess:null,addConnectionWithOfficeIdErrorId:null,addConnectionWithOfficeIdXhrInProgress:false,addMlsOfficeIdSuccess:null,addMlsOfficeIdErrorId:null,addMlsOfficeIdXhrInProgress:false,getConnectionsSuccess:null,getConnectionsErrorId:null,getConnectionsInProgress:false,connections:[],getAgentsMlsIdsSuccess:null,getAgentsMlsIdsErrorId:null,getAgentsMlsIdsInProgress:false,agentsMlsIds:null,deletingMlsConnectionErrorId:[],deletingMlsConnectionXhrInProgress:[],deletingMlsOfficeErrorId:[],deletingMlsOfficeXhrInProgress:[],mlsBoardList:[],mlsBoardListFailedToLoad:null,mlsUiType:null,/* adding agent mls id */addingAgentMlsIdXhrInProgress:[],addingAgentMlsIdErrorId:[],addingAgentMlsIdSuccess:[],/* editing agent mls id */editingAgentMlsIdXhrInProgress:[],editingAgentMlsIdErrorId:[],editingAgentMlsIdSuccess:[],/* deleting agent mls id */deletingAgentMlsIdXhrInProgress:[],deletingAgentMlsIdErrorId:[],deletingAgentMlsIdSuccess:[]};var getCompanyIndustry=function getCompanyIndustry(){var result=null;var state=__WEBPACK_IMPORTED_MODULE_2__redux_store__["a" /* default */].getState();var companiesRawData=__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.get(state,'companies.rawDataById');if(companiesRawData){var selectedCompanyRawData=companiesRawData[state.companies.selectedId];result=__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.get(selectedCompanyRawData,'industryId');}return result;};var isUsingCustomMlsIntegration=function isUsingCustomMlsIntegration(){var result=null;var state=__WEBPACK_IMPORTED_MODULE_2__redux_store__["a" /* default */].getState();var companiesRawData=__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.get(state,'companies.rawDataById');if(companiesRawData){var selectedCompanyRawData=companiesRawData[state.companies.selectedId];var selectedCompanyProviders=__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.get(selectedCompanyRawData,'dataProviders');result=Array.isArray(selectedCompanyProviders)&&selectedCompanyProviders.length>0;}return result;};/* harmony default export */ __webpack_exports__["g"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1?arguments[1]:undefined;switch(action.type){case __WEBPACK_IMPORTED_MODULE_4__actions__["_146" /* RESOLVE_MLS_UI_TYPE */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{mlsUiType:action.payload});case __WEBPACK_IMPORTED_MODULE_4__actions__["_111" /* MLS_CLEAR_CONNECT_FORM_STATE */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{connectMlsSuccess:null,connectMlsErrorId:null,connectMlsXhrInProgress:false,reviewMlsSuccess:null,reviewMlsErrorId:null,reviewMlsXhrInProgress:false,addConnectionWithAgentIdSuccess:null,addConnectionWithAgentIdErrorId:null,addConnectionWithAgentIdXhrInProgress:false,addConnectionWithOfficeIdSuccess:null,addConnectionWithOfficeIdErrorId:null,addConnectionWithOfficeIdXhrInProgress:false,addMlsOfficeIdSuccess:null,addMlsOfficeIdErrorId:null,addMlsOfficeIdXhrInProgress:false,addingAgentMlsIdXhrInProgress:[],addingAgentMlsIdErrorId:[],addingAgentMlsIdSuccess:[],editingAgentMlsIdXhrInProgress:[],editingAgentMlsIdErrorId:[],editingAgentMlsIdSuccess:[],deletingAgentMlsIdXhrInProgress:[],deletingAgentMlsIdErrorId:[],deletingAgentMlsIdSuccess:[]});/* COMPANIES_CONNECT_MLS_REQUEST */case __WEBPACK_IMPORTED_MODULE_4__actions__["y" /* COMPANIES_CONNECT_MLS_REQUEST */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{connectMlsSuccess:null,connectMlsErrorId:null,connectMlsXhrInProgress:true,loading:true});case __WEBPACK_IMPORTED_MODULE_4__actions__["z" /* COMPANIES_CONNECT_MLS_REQUEST_FAIL */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{connectMlsErrorId:__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.get(action,'error.errorId'),connectMlsXhrInProgress:false,loading:false});case __WEBPACK_IMPORTED_MODULE_4__actions__["A" /* COMPANIES_CONNECT_MLS_REQUEST_SUCCESS */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{connectMlsErrorId:null,connectMlsSuccess:true,connectMlsXhrInProgress:false,loading:false});/* COMPANIES_REVIEW_MLS_REQUEST */case __WEBPACK_IMPORTED_MODULE_4__actions__["_20" /* COMPANIES_REVIEW_MLS_REQUEST */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{reviewMlsSuccess:null,reviewMlsErrorId:null,reviewMlsXhrInProgress:true,loading:true});case __WEBPACK_IMPORTED_MODULE_4__actions__["_21" /* COMPANIES_REVIEW_MLS_REQUEST_FAIL */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{reviewMlsErrorId:__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.get(action,'error.errorId'),reviewMlsXhrInProgress:false,loading:false});case __WEBPACK_IMPORTED_MODULE_4__actions__["_22" /* COMPANIES_REVIEW_MLS_REQUEST_SUCCESS */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{reviewMlsErrorId:null,reviewMlsSuccess:true,reviewMlsXhrInProgress:false,loading:false});/* MLS_ADD_CONNECTION_WITH_OFFICE_ID */case __WEBPACK_IMPORTED_MODULE_4__actions__["_102" /* MLS_ADD_CONNECTION_WITH_OFFICE_ID */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{addConnectionWithOfficeIdErrorId:null,addConnectionWithOfficeIdSuccess:null,addConnectionWithOfficeIdXhrInProgress:true,loading:true});case __WEBPACK_IMPORTED_MODULE_4__actions__["_104" /* MLS_ADD_CONNECTION_WITH_OFFICE_ID_SUCCESS */]:{return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{loading:false,addConnectionWithOfficeIdSuccess:true,addConnectionWithOfficeIdXhrInProgress:false});}case __WEBPACK_IMPORTED_MODULE_4__actions__["_103" /* MLS_ADD_CONNECTION_WITH_OFFICE_ID_FAIL */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{addConnectionWithOfficeIdErrorId:__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.get(action,'error.errorId'),addConnectionWithOfficeIdXhrInProgress:false,loading:false});/* MLS_ADD_CONNECTION_WITH_AGENT_ID */case __WEBPACK_IMPORTED_MODULE_4__actions__["_99" /* MLS_ADD_CONNECTION_WITH_AGENT_ID */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{addConnectionWithAgentIdErrorId:null,addConnectionWithAgentIdSuccess:null,addConnectionWithAgentIdXhrInProgress:true,loading:true});case __WEBPACK_IMPORTED_MODULE_4__actions__["_101" /* MLS_ADD_CONNECTION_WITH_AGENT_ID_SUCCESS */]:{return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{addConnectionWithAgentIdSuccess:true,addConnectionWithAgentIdXhrInProgress:false,loading:false});}case __WEBPACK_IMPORTED_MODULE_4__actions__["_100" /* MLS_ADD_CONNECTION_WITH_AGENT_ID_FAIL */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{addConnectionWithAgentIdErrorId:__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.get(action,'error.errorId'),addConnectionWithAgentIdXhrInProgress:false,loading:false});/* MLS_ADD_OFFICE_TO_CONNECTION */case __WEBPACK_IMPORTED_MODULE_4__actions__["_105" /* MLS_ADD_OFFICE_TO_CONNECTION */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{addMlsOfficeIdErrorId:null,addMlsOfficeIdSuccess:null,addMlsOfficeIdXhrInProgress:true,loading:true});case __WEBPACK_IMPORTED_MODULE_4__actions__["_107" /* MLS_ADD_OFFICE_TO_CONNECTION_SUCCESS */]:{return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{addMlsOfficeIdSuccess:true,addMlsOfficeIdXhrInProgress:false,loading:false});}case __WEBPACK_IMPORTED_MODULE_4__actions__["_106" /* MLS_ADD_OFFICE_TO_CONNECTION_FAIL */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{addMlsOfficeIdErrorId:__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.get(action,'error.errorId'),addMlsOfficeIdXhrInProgress:false,loading:false});/* MLS_GET_CONNECTIONS_LIST */case __WEBPACK_IMPORTED_MODULE_4__actions__["_125" /* MLS_GET_CONNECTIONS_LIST */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{getConnectionsErrorId:null,getConnectionsSuccess:null,getConnectionsInProgress:true,loading:true});case __WEBPACK_IMPORTED_MODULE_4__actions__["_127" /* MLS_GET_CONNECTIONS_LIST_SUCCESS */]:{return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{loading:false,getConnectionsSuccess:true,getConnectionsInProgress:false,connections:addNameToConnection(state.mlsBoardList,action.result,'list')});}case __WEBPACK_IMPORTED_MODULE_4__actions__["_126" /* MLS_GET_CONNECTIONS_LIST_FAIL */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{getConnectionsErrorId:__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.get(action,'error.errorId'),getConnectionsInProgress:false,loading:false});/* LIST AGENT MLS IDS */case __WEBPACK_IMPORTED_MODULE_4__actions__["_93" /* LIST_AGENT_MLS_IDS */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{getAgentsMlsIdsErrorId:null,getAgentsMlsIdsSuccess:null,getAgentsMlsIdsInProgress:true,loading:true});case __WEBPACK_IMPORTED_MODULE_4__actions__["_95" /* LIST_AGENT_MLS_IDS_SUCCESS */]:{return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{loading:false,getAgentsMlsIdsSuccess:true,getAgentsMlsIdsInProgress:false,agentsMlsIds:action.result});}case __WEBPACK_IMPORTED_MODULE_4__actions__["_94" /* LIST_AGENT_MLS_IDS_FAIL */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{getAgentsMlsIdsErrorId:__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.get(action,'error.errorId'),getAgentsMlsIdsInProgress:false,loading:false});/* MLS BOARD LIST */case __WEBPACK_IMPORTED_MODULE_4__actions__["_108" /* MLS_BOARD_LIST_FETCH */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{loading:true});case __WEBPACK_IMPORTED_MODULE_4__actions__["_110" /* MLS_BOARD_LIST_FETCH_SUCCESS */]:{var boardList=setBoardDisplayName(action.result);return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{mlsBoardList:boardList.sort(sortByName.bind(_this,'displayName')),loading:false,connections:addNameToConnection(action.result,state.connections,'config')});}case __WEBPACK_IMPORTED_MODULE_4__actions__["_109" /* MLS_BOARD_LIST_FETCH_FAIL */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{mlsBoardListFailedToLoad:true,loading:false});/* DELETE MLS CONNECTION */case __WEBPACK_IMPORTED_MODULE_4__actions__["_113" /* MLS_CONNECTION_DELETE */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{deletingMlsConnectionXhrInProgress:[].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.deletingMlsConnectionXhrInProgress),[action.payload.mlsConnectionId]),deletingMlsConnectionErrorId:state.deletingMlsConnectionErrorId.filter(function(item){return item.mlsConnectionId!==action.payload.mlsConnectionId;}),loading:true});case __WEBPACK_IMPORTED_MODULE_4__actions__["_115" /* MLS_CONNECTION_DELETE_SUCCESS */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{connections:state.connections.filter(function(connection){return connection.mlsConnectionId!==action.payload.mlsConnectionId;}),deletingMlsConnectionXhrInProgress:state.deletingMlsConnectionXhrInProgress.filter(function(mlsConnectionId){return mlsConnectionId!==action.payload.mlsConnectionId;}),loading:false});case __WEBPACK_IMPORTED_MODULE_4__actions__["_114" /* MLS_CONNECTION_DELETE_FAIL */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{deletingMlsConnectionErrorId:[].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.deletingMlsConnectionErrorId),[{mlsConnectionId:action.payload.mlsConnectionId,errorId:__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.get(action,'error.errorId')}]),deletingMlsConnectionXhrInProgress:state.deletingMlsConnectionXhrInProgress.filter(function(mlsConnectionId){return mlsConnectionId!==action.payload.mlsConnectionId;}),loading:false});/* DELETE MLS OFFICE */case __WEBPACK_IMPORTED_MODULE_4__actions__["_128" /* MLS_OFFICE_DELETE */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{deletingMlsOfficeXhrInProgress:[].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.deletingMlsOfficeXhrInProgress),[{officeMlsId:action.payload.officeMlsId,mlsConnectionId:action.payload.mlsConnectionId}]),deletingMlsOfficeErrorId:state.deletingMlsOfficeErrorId.filter(function(item){return item.officeMlsId!==action.payload.officeMlsId&&item.mlsConnectionId!==action.payload.mlsConnectionId;}),loading:true});case __WEBPACK_IMPORTED_MODULE_4__actions__["_130" /* MLS_OFFICE_DELETE_SUCCESS */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{connections:state.connections.map(function(connection){if(connection.mlsConnectionId===action.payload.mlsConnectionId){return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},connection,{offices:connection.offices.filter(function(office){return office.officeMlsId!==action.payload.officeMlsId;})});}else{return connection;}}),deletingMlsOfficeXhrInProgress:state.deletingMlsOfficeXhrInProgress.filter(function(item){return item.officeMlsId!==action.payload.officeMlsId&&item.mlsConnectionId!==action.payload.mlsConnectionId;}),loading:false});case __WEBPACK_IMPORTED_MODULE_4__actions__["_129" /* MLS_OFFICE_DELETE_FAIL */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{deletingMlsOfficeErrorId:[].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.deletingMlsOfficeErrorId),[{officeMlsId:action.payload.officeMlsId,mlsConnectionId:action.payload.mlsConnectionId,errorId:__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.get(action,'error.errorId')}]),deletingMlsOfficeXhrInProgress:state.deletingMlsOfficeXhrInProgress.filter(function(item){return item.officeMlsId!==action.payload.officeMlsId&&item.mlsConnectionId!==action.payload.mlsConnectionId;}),loading:false});/* Add agent MLS id */case __WEBPACK_IMPORTED_MODULE_4__actions__["_96" /* MLS_ADD_AGENT_MLS_ID */]:{return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{addingAgentMlsIdXhrInProgress:[].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.addingAgentMlsIdXhrInProgress),[{mlsConnectionId:action.payload.mlsConnectionId,userId:action.payload.userId}]),addingAgentMlsIdErrorId:state.addingAgentMlsIdErrorId.filter(function(item){return item.userId!==action.payload.userId&&item.mlsConnectionId!==action.payload.mlsConnectionId;}),addingAgentMlsIdSuccess:state.addingAgentMlsIdSuccess.filter(function(item){return item.userId!==action.payload.userId&&item.mlsConnectionId!==action.payload.mlsConnectionId;}),// reset edit and delete states for same field
editingAgentMlsIdErrorId:state.editingAgentMlsIdErrorId.filter(function(item){return item.userId!==action.payload.userId&&item.mlsConnectionId!==action.payload.mlsConnectionId;}),deletingAgentMlsIdErrorId:state.deletingAgentMlsIdErrorId.filter(function(item){return item.userId!==action.payload.userId&&item.mlsConnectionId!==action.payload.mlsConnectionId;})});}case __WEBPACK_IMPORTED_MODULE_4__actions__["_98" /* MLS_ADD_AGENT_MLS_ID_SUCCESS */]:{return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{addingAgentMlsIdSuccess:[].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.addingAgentMlsIdSuccess),[{mlsConnectionId:action.payload.mlsConnectionId,userId:action.payload.userId}]),addingAgentMlsIdXhrInProgress:state.addingAgentMlsIdXhrInProgress.filter(function(item){return item.userId!==action.payload.userId&&item.mlsConnectionId!==action.payload.mlsConnectionId;}),agentsMlsIds:[].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.agentsMlsIds),[{_id:action.result.agentMongoId,companyId:action.payload.companyId,userId:action.payload.userId,mlsConnectionId:action.payload.mlsConnectionId,agentMlsId:action.payload.agentMlsId}]),loading:false});}case __WEBPACK_IMPORTED_MODULE_4__actions__["_97" /* MLS_ADD_AGENT_MLS_ID_FAIL */]:{return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{addingAgentMlsIdErrorId:[].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.addingAgentMlsIdErrorId),[{mlsConnectionId:action.payload.mlsConnectionId,userId:action.payload.userId,errorId:__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.get(action,'error.errorId'),agentMlsId:action.payload.agentMlsId,forceAddition:action.payload.forceAddition}]),addingAgentMlsIdXhrInProgress:state.addingAgentMlsIdXhrInProgress.filter(function(item){return item.userId!==action.payload.userId&&item.mlsConnectionId!==action.payload.mlsConnectionId;})});}/* edit agent MLS id */case __WEBPACK_IMPORTED_MODULE_4__actions__["_119" /* MLS_EDIT_AGENT_MLS_ID */]:{return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{editingAgentMlsIdXhrInProgress:[].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.editingAgentMlsIdXhrInProgress),[{mlsConnectionId:action.payload.mlsConnectionId,userId:action.payload.userId,agentMongoId:action.payload.agentMongoId}]),editingAgentMlsIdErrorId:state.editingAgentMlsIdErrorId.filter(function(item){return item.agentMongoId!==action.payload.agentMongoId;}),editingAgentMlsIdSuccess:state.editingAgentMlsIdSuccess.filter(function(item){return item.agentMongoId!==action.payload.agentMongoId;}),// reset add and delete states for same field
addingAgentMlsIdErrorId:state.addingAgentMlsIdErrorId.filter(function(item){return item.userId!==action.payload.userId&&item.mlsConnectionId!==action.payload.mlsConnectionId;}),deletingAgentMlsIdErrorId:state.deletingAgentMlsIdErrorId.filter(function(item){return item.userId!==action.payload.userId&&item.mlsConnectionId!==action.payload.mlsConnectionId;})});}case __WEBPACK_IMPORTED_MODULE_4__actions__["_121" /* MLS_EDIT_AGENT_MLS_ID_SUCCESS */]:{return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{editingAgentMlsIdSuccess:[].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.editingAgentMlsIdSuccess),[{mlsConnectionId:action.payload.mlsConnectionId,userId:action.payload.userId,agentMongoId:action.payload.agentMongoId}]),editingAgentMlsIdXhrInProgress:state.editingAgentMlsIdXhrInProgress.filter(function(item){return item.agentMongoId!==action.payload.agentMongoId;}),agentsMlsIds:state.agentsMlsIds.map(function(agentItem){if(agentItem._id===action.payload.agentMongoId){return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},agentItem,{agentMlsId:action.payload.newAgentMlsId});}else{return agentItem;}}),loading:false});}case __WEBPACK_IMPORTED_MODULE_4__actions__["_120" /* MLS_EDIT_AGENT_MLS_ID_FAIL */]:{return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{editingAgentMlsIdErrorId:[].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.editingAgentMlsIdErrorId),[{mlsConnectionId:action.payload.mlsConnectionId,userId:action.payload.userId,errorId:__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.get(action,'error.errorId'),agentMongoId:action.payload.agentMongoId,agentMlsId:action.payload.newAgentMlsId,forceAddition:action.payload.forceAddition}]),editingAgentMlsIdXhrInProgress:state.editingAgentMlsIdXhrInProgress.filter(function(item){return item.agentMongoId!==action.payload.agentMongoId;})});}/* delete agent MLS id */case __WEBPACK_IMPORTED_MODULE_4__actions__["_116" /* MLS_DELETE_AGENT_MLS_ID */]:{return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{deletingAgentMlsIdXhrInProgress:[].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.deletingAgentMlsIdXhrInProgress),[{mlsConnectionId:action.payload.mlsConnectionId,userId:action.payload.userId,agentMongoId:action.payload.agentMongoId}]),deletingAgentMlsIdErrorId:state.deletingAgentMlsIdErrorId.filter(function(item){return item.agentMongoId!==action.payload.agentMongoId;}),deletingAgentMlsIdSuccess:state.deletingAgentMlsIdSuccess.filter(function(item){return item.agentMongoId!==action.payload.agentMongoId;}),// reset add and edit states for same field
addingAgentMlsIdErrorId:state.addingAgentMlsIdErrorId.filter(function(item){return item.userId!==action.payload.userId&&item.mlsConnectionId!==action.payload.mlsConnectionId;}),editingAgentMlsIdErrorId:state.editingAgentMlsIdErrorId.filter(function(item){return item.userId!==action.payload.userId&&item.mlsConnectionId!==action.payload.mlsConnectionId;})});}case __WEBPACK_IMPORTED_MODULE_4__actions__["_118" /* MLS_DELETE_AGENT_MLS_ID_SUCCESS */]:{return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{deletingAgentMlsIdSuccess:[].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.deletingAgentMlsIdSuccess),[{mlsConnectionId:action.payload.mlsConnectionId,userId:action.payload.userId,agentMongoId:action.payload.agentMongoId}]),deletingAgentMlsIdXhrInProgress:state.deletingAgentMlsIdXhrInProgress.filter(function(item){return item.agentMongoId!==action.payload.agentMongoId;}),agentsMlsIds:state.agentsMlsIds.filter(function(item){return item._id!==action.payload.agentMongoId;}),loading:false});}case __WEBPACK_IMPORTED_MODULE_4__actions__["_117" /* MLS_DELETE_AGENT_MLS_ID_FAIL */]:{return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{deletingAgentMlsIdErrorId:[].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(state.deletingAgentMlsIdErrorId),[{mlsConnectionId:action.payload.mlsConnectionId,userId:action.payload.userId,errorId:__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.get(action,'error.errorId'),agentMongoId:action.payload.agentMongoId}]),deletingAgentMlsIdXhrInProgress:state.deletingAgentMlsIdXhrInProgress.filter(function(item){return item.agentMongoId!==action.payload.agentMongoId;})});}case __WEBPACK_IMPORTED_MODULE_4__actions__["_112" /* MLS_CLEAR_ERROR_FOR_CONNECTION_AND_USER */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{addingAgentMlsIdErrorId:state.addingAgentMlsIdErrorId.filter(function(item){return item.userId!==action.payload.userId&&item.mlsConnectionId!==action.payload.mlsConnectionId;}),editingAgentMlsIdErrorId:state.editingAgentMlsIdErrorId.filter(function(item){return item.userId!==action.payload.userId&&item.mlsConnectionId!==action.payload.mlsConnectionId;}),deletingAgentMlsIdErrorId:state.deletingAgentMlsIdErrorId.filter(function(item){return item.userId!==action.payload.userId&&item.mlsConnectionId!==action.payload.mlsConnectionId;})});default:return state;}});/* used when sending request for mls not listed in RE-api */var sendConnectMlsRequest=function sendConnectMlsRequest(data){return{types:[__WEBPACK_IMPORTED_MODULE_4__actions__["y" /* COMPANIES_CONNECT_MLS_REQUEST */],__WEBPACK_IMPORTED_MODULE_4__actions__["A" /* COMPANIES_CONNECT_MLS_REQUEST_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["z" /* COMPANIES_CONNECT_MLS_REQUEST_FAIL */]],promise:function promise(client){return client.post(__WEBPACK_IMPORTED_MODULE_9__config__["Z" /* MLS_DATA_PROJECT_ENDPOINTS */].CONNECT_MLS,data)["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_8__errors_errorhelper__["a" /* extractPropsforAxiosHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_6__errors_apperror__["a" /* default */]({message:'mls.sendConnectMlsRequest() failed',errorId:__WEBPACK_IMPORTED_MODULE_5__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_7__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}};};/* used when user has invalid officeId or agentId */var sendMlsReviewRequest=function sendMlsReviewRequest(data){return{types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_20" /* COMPANIES_REVIEW_MLS_REQUEST */],__WEBPACK_IMPORTED_MODULE_4__actions__["_22" /* COMPANIES_REVIEW_MLS_REQUEST_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_21" /* COMPANIES_REVIEW_MLS_REQUEST_FAIL */]],promise:function promise(client){return client.post(__WEBPACK_IMPORTED_MODULE_9__config__["Z" /* MLS_DATA_PROJECT_ENDPOINTS */].REVIEW_MLS,data)["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_8__errors_errorhelper__["a" /* extractPropsforAxiosHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_6__errors_apperror__["a" /* default */]({message:'mls.sendMlsReviewRequest() failed',errorId:__WEBPACK_IMPORTED_MODULE_5__errors_errorids__["a" /* default */].UNKNOWN,errorDetails:data,originalError:new __WEBPACK_IMPORTED_MODULE_7__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}};};/**
 * Clear Add MLS form state
 */var clearConnectMlsState=function clearConnectMlsState(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__actions__["_111" /* MLS_CLEAR_CONNECT_FORM_STATE */]});};};var addMLSConnectionWithAgentId=function addMLSConnectionWithAgentId(mlsBoardCode,agentMlsId,forceAddition){return function(dispatch,getState){var selectedId=getState().companies.selectedId;return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_99" /* MLS_ADD_CONNECTION_WITH_AGENT_ID */],__WEBPACK_IMPORTED_MODULE_4__actions__["_101" /* MLS_ADD_CONNECTION_WITH_AGENT_ID_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_100" /* MLS_ADD_CONNECTION_WITH_AGENT_ID_FAIL */]],payload:{mlsBoardCode:mlsBoardCode,agentMlsId:agentMlsId,forceAddition:forceAddition},promise:function promise(client){return client.post("/mls-connections/companies/".concat(selectedId,"/mlsConnections/agents/").concat(encodeURIComponent(agentMlsId)),{data:{mlsBoardCode:mlsBoardCode,forceAddition:forceAddition}})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_8__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_6__errors_apperror__["a" /* default */]({message:'mls.addMLSConnectionWithAgentId() failed',errorId:__WEBPACK_IMPORTED_MODULE_5__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_7__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};var addMLSConnectionWithOfficeId=function addMLSConnectionWithOfficeId(mlsBoardCode,officeMlsId,forceAddition){return function(dispatch,getState){var selectedId=getState().companies.selectedId;return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_102" /* MLS_ADD_CONNECTION_WITH_OFFICE_ID */],__WEBPACK_IMPORTED_MODULE_4__actions__["_104" /* MLS_ADD_CONNECTION_WITH_OFFICE_ID_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_103" /* MLS_ADD_CONNECTION_WITH_OFFICE_ID_FAIL */]],payload:{mlsBoardCode:mlsBoardCode,officeMlsId:officeMlsId,forceAddition:forceAddition},promise:function promise(client){return client.post("/mls-connections/companies/".concat(selectedId,"/mlsConnections/mlsOffices/").concat(encodeURIComponent(officeMlsId)),{data:{mlsBoardCode:mlsBoardCode,forceAddition:forceAddition}})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_8__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_6__errors_apperror__["a" /* default */]({message:'mls.addMLSConnectionWithOfficeId() failed',errorId:__WEBPACK_IMPORTED_MODULE_5__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_7__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};var getConnectionList=function getConnectionList(){return function(dispatch,getState){var selectedId=getState().companies.selectedId;return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_125" /* MLS_GET_CONNECTIONS_LIST */],__WEBPACK_IMPORTED_MODULE_4__actions__["_127" /* MLS_GET_CONNECTIONS_LIST_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_126" /* MLS_GET_CONNECTIONS_LIST_FAIL */]],promise:function promise(client){return client.get("/mls-connections/companies/".concat(selectedId,"/mlsConnections")).then(function(response){return response;})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_8__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_6__errors_apperror__["a" /* default */]({message:'mls.getConnectionList() failed',errorId:__WEBPACK_IMPORTED_MODULE_5__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_7__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};var fetchMlsBoards=function fetchMlsBoards(){return function(dispatch){return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_108" /* MLS_BOARD_LIST_FETCH */],__WEBPACK_IMPORTED_MODULE_4__actions__["_110" /* MLS_BOARD_LIST_FETCH_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_109" /* MLS_BOARD_LIST_FETCH_FAIL */]],promise:function promise(client){return client.get('/mls-connections/mls-boards/config')["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_8__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_6__errors_apperror__["a" /* default */]({message:'mls.fetchMlsBoards() failed',errorId:__WEBPACK_IMPORTED_MODULE_5__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_7__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};var deleteMLSConnection=function deleteMLSConnection(mlsConnectionId,mlsBoardCode){return function(dispatch,getState){var selectedId=getState().companies.selectedId;return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_113" /* MLS_CONNECTION_DELETE */],__WEBPACK_IMPORTED_MODULE_4__actions__["_115" /* MLS_CONNECTION_DELETE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_114" /* MLS_CONNECTION_DELETE_FAIL */]],payload:{mlsConnectionId:mlsConnectionId},promise:function promise(client){return client["delete"]("/mls-connections/companies/".concat(selectedId,"/mlsConnections/").concat(mlsConnectionId)).then(function(){Object(__WEBPACK_IMPORTED_MODULE_10_redux_modules_quickMessages__["b" /* showQuickMessage */])(localize('mls-connection-removed',mlsBoardCode)).call(_this,dispatch);})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_8__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_6__errors_apperror__["a" /* default */]({message:'mls.deleteMLSConnection() failed',errorId:httpErrorProps.errorId||__WEBPACK_IMPORTED_MODULE_5__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_7__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};var deleteOfficeId=function deleteOfficeId(mlsConnectionId,officeMlsId,officeName){return function(dispatch,getState){var selectedId=getState().companies.selectedId;return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_128" /* MLS_OFFICE_DELETE */],__WEBPACK_IMPORTED_MODULE_4__actions__["_130" /* MLS_OFFICE_DELETE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_129" /* MLS_OFFICE_DELETE_FAIL */]],payload:{mlsConnectionId:mlsConnectionId,officeMlsId:officeMlsId},promise:function promise(client){return client["delete"](// eslint-disable-next-line max-len
"/mls-connections/companies/".concat(selectedId,"/mlsConnections/").concat(mlsConnectionId,"/mlsOffices/").concat(encodeURIComponent(officeMlsId))).then(function(){Object(__WEBPACK_IMPORTED_MODULE_10_redux_modules_quickMessages__["b" /* showQuickMessage */])(localize('mls-office-removed',officeName)).call(_this,dispatch);})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_8__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_6__errors_apperror__["a" /* default */]({message:'mls.deleteOfficeId() failed',errorId:httpErrorProps.errorId||__WEBPACK_IMPORTED_MODULE_5__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_7__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};var addOfficeId=function addOfficeId(mlsConnectionId,officeMlsId,forceAddition){return function(dispatch,getState){var selectedId=getState().companies.selectedId;return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_105" /* MLS_ADD_OFFICE_TO_CONNECTION */],__WEBPACK_IMPORTED_MODULE_4__actions__["_107" /* MLS_ADD_OFFICE_TO_CONNECTION_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_106" /* MLS_ADD_OFFICE_TO_CONNECTION_FAIL */]],payload:{mlsConnectionId:mlsConnectionId,officeMlsId:officeMlsId,forceAddition:forceAddition},promise:function promise(client){return client.post(// eslint-disable-next-line max-len
"/mls-connections/companies/".concat(selectedId,"/mlsConnections/").concat(mlsConnectionId,"/mlsOffices/").concat(encodeURIComponent(officeMlsId)),{data:{forceAddition:forceAddition}})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_8__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_6__errors_apperror__["a" /* default */]({message:'mls.addOfficeId() failed',errorId:__WEBPACK_IMPORTED_MODULE_5__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_7__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};/* for mlsStart1 returns only total count */var getMlsAgentsForOffice=function getMlsAgentsForOffice(officeMlsId){return function(dispatch,getState){var selectedId=getState().companies.selectedId;return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_122" /* MLS_GET_AGENTS_FOR_OFFICE */],__WEBPACK_IMPORTED_MODULE_4__actions__["_124" /* MLS_GET_AGENTS_FOR_OFFICE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_123" /* MLS_GET_AGENTS_FOR_OFFICE_FAIL */]],promise:function promise(client){return client.get("/companies/".concat(selectedId,"/connectionlist/").concat(officeMlsId)).then(function(response){return response.agents_count;})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_8__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_6__errors_apperror__["a" /* default */]({message:'mls.getMlsAgentsForOffice() failed',errorId:__WEBPACK_IMPORTED_MODULE_5__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_7__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};var addAgentMlsId=function addAgentMlsId(mlsConnectionId,userId,agentMlsId,forceAddition){return function(dispatch,getState){var selectedId=getState().companies.selectedId;return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_96" /* MLS_ADD_AGENT_MLS_ID */],__WEBPACK_IMPORTED_MODULE_4__actions__["_98" /* MLS_ADD_AGENT_MLS_ID_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_97" /* MLS_ADD_AGENT_MLS_ID_FAIL */]],payload:{mlsConnectionId:mlsConnectionId,userId:userId,agentMlsId:agentMlsId,forceAddition:forceAddition,companyId:selectedId},promise:function promise(client){return client.post("/agent-mls-ids/companies/".concat(selectedId,"/mlsConnections/").concat(mlsConnectionId,"/agents"),{data:{userId:userId,agentMlsId:agentMlsId,forceAddition:forceAddition}})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_8__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_6__errors_apperror__["a" /* default */]({message:'mls.addAgentMlsId() failed',errorId:__WEBPACK_IMPORTED_MODULE_5__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_7__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};var editAgentMlsId=function editAgentMlsId(mlsConnectionId,userId,newAgentMlsId,agentMongoId,forceAddition){return function(dispatch,getState){var selectedId=getState().companies.selectedId;return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_119" /* MLS_EDIT_AGENT_MLS_ID */],__WEBPACK_IMPORTED_MODULE_4__actions__["_121" /* MLS_EDIT_AGENT_MLS_ID_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_120" /* MLS_EDIT_AGENT_MLS_ID_FAIL */]],payload:{mlsConnectionId:mlsConnectionId,userId:userId,newAgentMlsId:newAgentMlsId,agentMongoId:agentMongoId,forceAddition:forceAddition},promise:function promise(client){return client.put("/agent-mls-ids/companies/".concat(selectedId,"/mlsConnections/").concat(mlsConnectionId,"/agents/").concat(agentMongoId),{data:{userId:userId,newAgentMlsId:newAgentMlsId,forceAddition:forceAddition}})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_8__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_6__errors_apperror__["a" /* default */]({message:'mls.editAgentMlsId() failed',errorId:__WEBPACK_IMPORTED_MODULE_5__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_7__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};var deleteAgentMlsId=function deleteAgentMlsId(mlsConnectionId,userId,agentMongoId){return function(dispatch,getState){var selectedId=getState().companies.selectedId;return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_116" /* MLS_DELETE_AGENT_MLS_ID */],__WEBPACK_IMPORTED_MODULE_4__actions__["_118" /* MLS_DELETE_AGENT_MLS_ID_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_117" /* MLS_DELETE_AGENT_MLS_ID_FAIL */]],payload:{mlsConnectionId:mlsConnectionId,userId:userId,agentMongoId:agentMongoId},promise:function promise(client){return client["delete"]("/agent-mls-ids/companies/".concat(selectedId,"/mlsConnections/").concat(mlsConnectionId,"/agents/").concat(agentMongoId),{data:{mlsConnectionId:mlsConnectionId,userId:userId}})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_8__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_6__errors_apperror__["a" /* default */]({message:'mls.deleteAgentMlsId() failed',errorId:__WEBPACK_IMPORTED_MODULE_5__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_7__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};var getAgentMlsIds=function getAgentMlsIds(){return function(dispatch,getState){var selectedId=getState().companies.selectedId;return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_93" /* LIST_AGENT_MLS_IDS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_95" /* LIST_AGENT_MLS_IDS_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_94" /* LIST_AGENT_MLS_IDS_FAIL */]],promise:function promise(client){return client.get("/agent-mls-ids/companies/".concat(selectedId))["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_8__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_6__errors_apperror__["a" /* default */]({message:'mls.getAgentMlsIds() failed',errorId:__WEBPACK_IMPORTED_MODULE_5__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_7__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}});};};/**
 * Resolve MLS UI type
 */var resolveMLsUiType=function resolveMLsUiType(){var isCustomMlsIntegration=isUsingCustomMlsIntegration();var companyIndustry=getCompanyIndustry();var uiType=null;if(companyIndustry===__WEBPACK_IMPORTED_MODULE_9__config__["_24" /* REAL_ESTATE_INDUSTY_ID */]||Object(__WEBPACK_IMPORTED_MODULE_3_utils_state__["c" /* isNewRealEstateUiUsed */])(__WEBPACK_IMPORTED_MODULE_2__redux_store__["a" /* default */])){uiType=isCustomMlsIntegration?__WEBPACK_IMPORTED_MODULE_9__config__["_0" /* MLS_UI */].DIRECT_MLS_API:__WEBPACK_IMPORTED_MODULE_9__config__["_0" /* MLS_UI */].SELF_CONNECT_API;}return{type:__WEBPACK_IMPORTED_MODULE_4__actions__["_146" /* RESOLVE_MLS_UI_TYPE */],payload:uiType};};var clearErrorsForConnectionAndUser=function clearErrorsForConnectionAndUser(mlsConnectionId,userId){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__actions__["_112" /* MLS_CLEAR_ERROR_FOR_CONNECTION_AND_USER */],payload:{mlsConnectionId:mlsConnectionId,userId:userId}});};};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

var _default = ownerDocument;
exports.default = _default;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _classCallCheck = _interopDefault(__webpack_require__(6));
var _createClass = _interopDefault(__webpack_require__(7));
var _possibleConstructorReturn = _interopDefault(__webpack_require__(10));
var _getPrototypeOf = _interopDefault(__webpack_require__(9));
var _inherits = _interopDefault(__webpack_require__(11));
var _typeof = _interopDefault(__webpack_require__(117));
var _objectWithoutProperties = _interopDefault(__webpack_require__(5));
var _extends = _interopDefault(__webpack_require__(3));
var React = _interopDefault(__webpack_require__(1));
var PropTypes = _interopDefault(__webpack_require__(2));
var warning = _interopDefault(__webpack_require__(27));

function defineProperty(object, property, attr) {
  return Object.defineProperty(object, property, attr);
} // Passive options
// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js


var passiveOption = function () {
  var cache = null;
  return function () {
    if (cache !== null) {
      return cache;
    }

    var supportsPassiveOption = false;

    try {
      window.addEventListener('test', null, defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      }));
    } catch (err) {//
    }

    cache = supportsPassiveOption;
    return supportsPassiveOption;
  }();
}();

var defaultEventOptions = {
  capture: false,
  passive: false
};

function mergeDefaultEventOptions(options) {
  return _extends({}, defaultEventOptions, options);
}

function getEventListenerArgs(eventName, callback, options) {
  var args = [eventName, callback];
  args.push(passiveOption ? options : options.capture);
  return args;
}

function on(target, eventName, callback, options) {
  // eslint-disable-next-line prefer-spread
  target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
}

function off(target, eventName, callback, options) {
  // eslint-disable-next-line prefer-spread
  target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
}

function forEachListener(props, iteratee) {
  var children = props.children,
      target = props.target,
      eventProps = _objectWithoutProperties(props, ["children", "target"]);

  Object.keys(eventProps).forEach(function (name) {
    if (name.substring(0, 2) !== 'on') {
      return;
    }

    var prop = eventProps[name];

    var type = _typeof(prop);

    var isObject = type === 'object';
    var isFunction = type === 'function';

    if (!isObject && !isFunction) {
      return;
    }

    var capture = name.substr(-7).toLowerCase() === 'capture';
    var eventName = name.substring(2).toLowerCase();
    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;

    if (isObject) {
      iteratee(eventName, prop.handler, prop.options);
    } else {
      iteratee(eventName, prop, mergeDefaultEventOptions({
        capture: capture
      }));
    }
  });
}

function withOptions(handler, options) {
   false ? warning(options, 'react-event-listener: should be specified options in withOptions.') : void 0;
  return {
    handler: handler,
    options: mergeDefaultEventOptions(options)
  };
}

var EventListener =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(EventListener, _React$PureComponent);

  function EventListener() {
    _classCallCheck(this, EventListener);

    return _possibleConstructorReturn(this, _getPrototypeOf(EventListener).apply(this, arguments));
  }

  _createClass(EventListener, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.applyListeners(on);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.applyListeners(off, prevProps);
      this.applyListeners(on);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.applyListeners(off);
    }
  }, {
    key: "applyListeners",
    value: function applyListeners(onOrOff) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
      var target = props.target;

      if (target) {
        var element = target;

        if (typeof target === 'string') {
          element = window[target];
        }

        forEachListener(props, onOrOff.bind(null, element));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children || null;
    }
  }]);

  return EventListener;
}(React.PureComponent);

EventListener.propTypes =  false ? {
  /**
   * You can provide a single child too.
   */
  children: PropTypes.node,

  /**
   * The DOM target to listen to.
   */
  target: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired
} : {};

exports.withOptions = withOptions;
exports.default = EventListener;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _MenuItem.default;
  }
});

var _MenuItem = _interopRequireDefault(__webpack_require__(900));

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = withFormControlContext;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(1));

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(188));

var _FormControlContext = _interopRequireDefault(__webpack_require__(279));

var _utils = __webpack_require__(14);

function withFormControlContext(Component) {
  var EnhancedComponent = function EnhancedComponent(props) {
    return _react.default.createElement(_FormControlContext.default.Consumer, null, function (context) {
      return _react.default.createElement(Component, (0, _extends2.default)({
        muiFormControl: context
      }, props));
    });
  };

  if (false) {
    EnhancedComponent.displayName = "WithFormControlContext(".concat((0, _utils.getDisplayName)(Component), ")");
  }

  (0, _hoistNonReactStatics.default)(EnhancedComponent, Component);
  return EnhancedComponent;
}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isEmail;

var _assertString = _interopRequireDefault(__webpack_require__(162));

var _merge = _interopRequireDefault(__webpack_require__(283));

var _isByteLength = _interopRequireDefault(__webpack_require__(927));

var _isFQDN = _interopRequireDefault(__webpack_require__(432));

var _isIP = _interopRequireDefault(__webpack_require__(433));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_email_options = {
  allow_display_name: false,
  require_display_name: false,
  allow_utf8_local_part: true,
  require_tld: true
};
/* eslint-disable max-len */

/* eslint-disable no-control-regex */

var displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\,\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;
var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var gmailUserPart = /^[a-z\d]+$/;
var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
/* eslint-enable max-len */

/* eslint-enable no-control-regex */

function isEmail(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_email_options);

  if (options.require_display_name || options.allow_display_name) {
    var display_email = str.match(displayName);

    if (display_email) {
      str = display_email[1];
    } else if (options.require_display_name) {
      return false;
    }
  }

  var parts = str.split('@');
  var domain = parts.pop();
  var user = parts.join('@');
  var lower_domain = domain.toLowerCase();

  if (options.domain_specific_validation && (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com')) {
    /*
      Previously we removed dots for gmail addresses before validating.
      This was removed because it allows `multiple..dots@gmail.com`
      to be reported as valid, but it is not.
      Gmail only normalizes single dots, removing them from here is pointless,
      should be done in normalizeEmail
    */
    user = user.toLowerCase(); // Removing sub-address from username before gmail validation

    var username = user.split('+')[0]; // Dots are not included in gmail length restriction

    if (!(0, _isByteLength.default)(username.replace('.', ''), {
      min: 6,
      max: 30
    })) {
      return false;
    }

    var _user_parts = username.split('.');

    for (var i = 0; i < _user_parts.length; i++) {
      if (!gmailUserPart.test(_user_parts[i])) {
        return false;
      }
    }
  }

  if (!(0, _isByteLength.default)(user, {
    max: 64
  }) || !(0, _isByteLength.default)(domain, {
    max: 254
  })) {
    return false;
  }

  if (!(0, _isFQDN.default)(domain, {
    require_tld: options.require_tld
  })) {
    if (!options.allow_ip_domain) {
      return false;
    }

    if (!(0, _isIP.default)(domain)) {
      if (!domain.startsWith('[') || !domain.endsWith(']')) {
        return false;
      }

      var noBracketdomain = domain.substr(1, domain.length - 2);

      if (noBracketdomain.length === 0 || !(0, _isIP.default)(noBracketdomain)) {
        return false;
      }
    }
  }

  if (user[0] === '"') {
    user = user.slice(1, user.length - 1);
    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
  }

  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;
  var user_parts = user.split('.');

  for (var _i = 0; _i < user_parts.length; _i++) {
    if (!pattern.test(user_parts[_i])) {
      return false;
    }
  }

  return true;
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _DialogActions.default;
  }
});

var _DialogActions = _interopRequireDefault(__webpack_require__(990));

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _DialogContentText.default;
  }
});

var _DialogContentText = _interopRequireDefault(__webpack_require__(992));

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(33);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(108)('meta');
var isObject = __webpack_require__(33);
var has = __webpack_require__(58);
var setDesc = __webpack_require__(43).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(31)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(188));

var _utils = __webpack_require__(14);

var _createMuiTheme = _interopRequireDefault(__webpack_require__(256));

var _themeListener = _interopRequireDefault(__webpack_require__(255));

/* eslint-disable no-underscore-dangle */
var defaultTheme;

function getDefaultTheme() {
  if (defaultTheme) {
    return defaultTheme;
  }

  defaultTheme = (0, _createMuiTheme.default)({
    typography: {
      suppressWarning: true
    }
  });
  return defaultTheme;
} // Provide the theme object as a property to the input component.


var withThemeOld = function withThemeOld() {
  return function (Component) {
    var WithTheme =
    /*#__PURE__*/
    function (_React$Component) {
      (0, _inherits2.default)(WithTheme, _React$Component);

      function WithTheme(props, context) {
        var _this;

        (0, _classCallCheck2.default)(this, WithTheme);
        _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(WithTheme).call(this));
        _this.state = {
          // We use || as the function call is lazy evaluated.
          theme: _themeListener.default.initial(context) || getDefaultTheme()
        };
        return _this;
      }

      (0, _createClass2.default)(WithTheme, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;

          this.unsubscribeId = _themeListener.default.subscribe(this.context, function (theme) {
            _this2.setState({
              theme: theme
            });
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          if (this.unsubscribeId !== null) {
            _themeListener.default.unsubscribe(this.context, this.unsubscribeId);
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props = this.props,
              innerRef = _this$props.innerRef,
              other = (0, _objectWithoutProperties2.default)(_this$props, ["innerRef"]);
          return _react.default.createElement(Component, (0, _extends2.default)({
            theme: this.state.theme,
            ref: innerRef
          }, other));
        }
      }]);
      return WithTheme;
    }(_react.default.Component);

     false ? WithTheme.propTypes = {
      /**
       * Use that property to pass a ref callback to the decorated component.
       */
      innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object])
    } : void 0;
    WithTheme.contextTypes = _themeListener.default.contextTypes;

    if (false) {
      WithTheme.displayName = "WithTheme(".concat((0, _utils.getDisplayName)(Component), ")");
    }

    (0, _hoistNonReactStatics.default)(WithTheme, Component);

    if (false) {
      // Exposed for test purposes.
      WithTheme.Naked = Component;
    }

    return WithTheme;
  };
};
/* istanbul ignore if */


if (!_utils.ponyfillGlobal.__MUI_STYLES__) {
  _utils.ponyfillGlobal.__MUI_STYLES__ = {};
}

if (!_utils.ponyfillGlobal.__MUI_STYLES__.withTheme) {
  _utils.ponyfillGlobal.__MUI_STYLES__.withTheme = withThemeOld;
}

var _default = _utils.ponyfillGlobal.__MUI_STYLES__.withTheme;
exports.default = _default;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Select.default;
  }
});

var _Select = _interopRequireDefault(__webpack_require__(922));

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__);
var _dec,_class;var VENDOR_PREFIXES=['-webkit-','-moz-','-ms-','-o-'];var styles=function styles(theme){return{root:{position:'sticky',top:0,zIndex:theme.zIndex.stickyHeader,paddingTop:"".concat(6*theme.spacing.unit,"px"),marginTop:"-".concat(6*theme.spacing.unit,"px"),backgroundColor:theme.palette.common.white,'&:after':{content:'""',display:'block',backgroundImage:'radial-gradient(ellipse at 50% 0px, rgba(0, 0, 0, 0.06) 0%, transparent 75%)',backgroundPosition:'50% 0',backgroundSize:'150% 5px',backgroundRepeat:'no-repeat',position:'absolute',top:'100%',width:'100%',left:0,right:0,height:24}}};};var StickyHeader=(_dec=Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(StickyHeader,_Component);function StickyHeader(){__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,StickyHeader);return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(StickyHeader).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(StickyHeader,[{key:"render",value:function render(){var _this$props=this.props,classes=_this$props.classes,className=_this$props.className,children=_this$props.children;if(this.isStickyPositionSupported){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:__WEBPACK_IMPORTED_MODULE_7_classnames___default()(classes.root,className)},children);}return children;}},{key:"isStickyPositionSupported",get:function get(){var test=window.document.head.style;for(var _i=0,_arr=[''].concat(VENDOR_PREFIXES);_i<_arr.length;_i++){var prefix=_arr[_i];var position="".concat(prefix,"sticky");test.position=position;if(test.position===position){return true;}}return false;}}]);return StickyHeader;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]))||_class);StickyHeader.propTypes={children:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,classes:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,className:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (StickyHeader);

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
var _dec,_class;var styles=function styles(){return{root:{marginBottom:10}};};var Header=(_dec=Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Header,_Component);function Header(){__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,Header);return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Header).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Header,[{key:"render",value:function render(){var _this$props=this.props,classes=_this$props.classes,children=_this$props.children,className=_this$props.className;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:"h1",className:__WEBPACK_IMPORTED_MODULE_9_classnames___default()(classes.root,className)},children);}}]);return Header;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]))||_class);Header.propTypes={children:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,classes:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,className:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 108 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(307);
var enumBugKeys = __webpack_require__(220);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(77);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(32);
var dPs = __webpack_require__(308);
var enumBugKeys = __webpack_require__(220);
var IE_PROTO = __webpack_require__(219)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(217)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(221).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(307);
var hiddenKeys = __webpack_require__(220).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(58);
var toObject = __webpack_require__(53);
var IE_PROTO = __webpack_require__(219)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(35)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(59)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(33);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 117 */
/***/ (function(module, exports) {

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return applyMagixDiscount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return applyDiscountUsingCouponSetId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return clearAppliedDiscount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyDiscountUsingCouponId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return applyDiscountUsingCouponIdWithoutValidation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setUserSuppliedPromoCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return changeCouponType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return sendCurrentOfferToUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__errors_apperror__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__errors_httperror__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__logger_logger__ = __webpack_require__(40);
var log=__WEBPACK_IMPORTED_MODULE_10__logger_logger__["a" /* default */].get('discount');var initialState={isDiscountApplied:false,discountType:null,couponSetKey:null,couponId:null,failedCouponId:null,couponType:null,/* magix discount props */usedMagixEmail:null,usedProductSerial:null,appliedProdCatOfLastValidCombination:null,appliedProdTypeOfLastValidCombination:null,appliedTierOfLastValidCombination:null,couponCodeFetchSuccess:null,couponCodeFetchErrorId:null,couponCodeInvalidReason:null,couponConfig:null,pendingRequest:null,userSuppliedPromoCode:null,couponAppliedWithoutValidation:null,isResponsePendingFromEstimationEndpoint:null};var getCouponConfig=function getCouponConfig(response){var result=null;var planKeys=Object.keys(response);for(var _i=0,_planKeys=planKeys;_i<_planKeys.length;_i++){var planKey=_planKeys[_i];var _config=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(response[planKey],'estimation.retrievedClientCouponIds[0].couponDetails');var error=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(response[planKey],'estimation.couponRelatedError');// must be used to detect used one time coupons
var showDiscountForPlan=Boolean(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(response[planKey],'estimation.totalDiscountAmountWithoutTax'));if(_config&&!error&&showDiscountForPlan){result=_config;break;}}if(!result){var firstPlan=response[planKeys[0]];var config=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(firstPlan,'estimation.retrievedClientCouponIds[0].couponDetails');var addonList=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(firstPlan,'estimation.retrievedClientCouponIds[0].couponDetails.addon_ids');var isCouponActive=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(firstPlan,'estimation.retrievedClientCouponIds[0].couponDetails.status')==='active';if(isCouponActive&&!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(addonList)){var perpetualAddonFound=addonList.some(function(addon){return addon.indexOf('webl')!==-1||addon.indexOf('designerl')!==-1||addon.indexOf('photol')!==-1;});perpetualAddonFound&&(result=config);}}return result;};var getErrorReason=function getErrorReason(response){var planKeys=Object.keys(response);var firstPlan=response[planKeys[0]];var retrieved_coupons=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(firstPlan,'estimation.retrievedClientCouponIds');var coupon_status=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(firstPlan,'estimation.retrievedClientCouponIds[0].couponDetails.status');var coupon_duration=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(firstPlan,'estimation.retrievedClientCouponIds[0].couponDetails.duration_type');var error=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(firstPlan,'estimation.couponRelatedError');var showDiscountForPlan=Boolean(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(firstPlan,'estimation.totalDiscountAmountWithoutTax'));var hasOldCoupon=!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(firstPlan,'estimation.appliedCouponIds[0].couponDetails'));if(error==='coupon_not_applicable'){return'not-applicable-to-any-of-products';}else if(coupon_status==='expired'){return coupon_status;}else if(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(retrieved_coupons)){return'does-not-exist';}else if(!showDiscountForPlan&&coupon_status==='active'&&hasOldCoupon){// case when company used forever coupon in the past
return'cannot-replace-existing-coupon';}else if(!showDiscountForPlan&&coupon_duration==='one_time'){// case when company used one-time coupon in the past
// in this case MW does not return estimation.appliedCouponIds[0] so hasOldCoupon check cannot be used
return'one-time-coupon-used';}};/* harmony default export */ __webpack_exports__["g"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1?arguments[1]:undefined;var isCouponActive;switch(action.type){case __WEBPACK_IMPORTED_MODULE_5__actions__["_73" /* DISCOUNT_APPLY_MAGIX */]:{// User can check another serial/email for another product and get lower discount,
// so apply it only when clicking on Apply discount button
// user can still close discount popup without applying discount
var tierKey;if(action.payload.prodTypeOfLastValidCombination===__WEBPACK_IMPORTED_MODULE_2__config__["Y" /* MAXIC_DISCOUNT_PROD_TYPE */].SUBSCRIPTION){tierKey=action.payload.tierOfLastValidCombination;}else if(action.payload.prodTypeOfLastValidCombination===__WEBPACK_IMPORTED_MODULE_2__config__["Y" /* MAXIC_DISCOUNT_PROD_TYPE */].PERPETUAL){tierKey=action.payload.prodCatOfLastValidCombination;}var couponSetKey="tier_".concat(tierKey);return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{isDiscountApplied:true,discountType:__WEBPACK_IMPORTED_MODULE_2__config__["F" /* DISCOUNT_TYPE */].MAGIX,couponSetKey:couponSetKey,couponId:null,failedCouponId:null,couponType:null,appliedProdCatOfLastValidCombination:action.payload.prodCatOfLastValidCombination,appliedProdTypeOfLastValidCombination:action.payload.prodTypeOfLastValidCombination,appliedTierOfLastValidCombination:action.payload.tierOfLastValidCombination,usedMagixEmail:action.payload.magixEmail,usedProductSerial:action.payload.productSerial,couponCodeFetchSuccess:null,couponCodeFetchErrorId:null,couponCodeInvalidReason:null,couponConfig:null,pendingRequest:null,userSuppliedPromoCode:null,couponAppliedWithoutValidation:null,isResponsePendingFromEstimationEndpoint:null});}case __WEBPACK_IMPORTED_MODULE_5__actions__["_54" /* COUPON_CHANGE_MAGIX_DISCOUNT_PRODUCT_TYPE */]:{if(state.appliedProdTypeOfLastValidCombination&&state.appliedProdTypeOfLastValidCombination!==action.payload.magixDiscountProdType){var _tierKey=action.payload.tierOfLastValidCombination||action.payload.prodCatOfLastValidCombination;var _couponSetKey="tier_".concat(_tierKey);return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{isDiscountApplied:action.payload.areCredentialsValid,couponSetKey:_couponSetKey,appliedProdTypeOfLastValidCombination:action.payload.magixDiscountProdType});}else{return state;}}case __WEBPACK_IMPORTED_MODULE_5__actions__["_72" /* DISCOUNT_APPLY_COUPON_SET_ID */]:{return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{isDiscountApplied:true,discountType:__WEBPACK_IMPORTED_MODULE_2__config__["F" /* DISCOUNT_TYPE */].COUPON_SET_ID,couponSetKey:action.payload.setId,couponId:null,failedCouponId:null,couponType:null,appliedProdCatOfLastValidCombination:null,appliedProdTypeOfLastValidCombination:null,appliedTierOfLastValidCombination:null,usedMagixEmail:null,usedProductSerial:null,couponCodeFetchSuccess:null,couponCodeFetchErrorId:null,couponCodeInvalidReason:null,couponConfig:null,pendingRequest:null,userSuppliedPromoCode:null,couponAppliedWithoutValidation:null,isResponsePendingFromEstimationEndpoint:null});}case __WEBPACK_IMPORTED_MODULE_5__actions__["_154" /* SET_USER_SUPPLIED_PROMO_CODE */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{userSuppliedPromoCode:action.payload.value});case __WEBPACK_IMPORTED_MODULE_5__actions__["_53" /* COUPON_APPLY_WITHOUT_VALIDATION */]:{return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{couponAppliedWithoutValidation:true,isResponsePendingFromEstimationEndpoint:true,couponCodeFetchSuccess:null,couponCodeFetchErrorId:null,couponCodeInvalidReason:null,couponConfig:null,discountType:action.payload.discountType,couponType:action.payload.couponType,isDiscountApplied:null,couponSetKey:null,usedMagixEmail:null,usedProductSerial:null});}case __WEBPACK_IMPORTED_MODULE_5__actions__["_164" /* SUBSCRIPTION_GET_ESTIMATE */]:{return action.payload.couponId||action.payload.couponSetId?__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{couponCodeFetchSuccess:null,couponCodeFetchErrorId:null,couponCodeInvalidReason:null,couponConfig:null,pendingRequest:true}):__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state);}case __WEBPACK_IMPORTED_MODULE_5__actions__["_56" /* COUPON_FETCH */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{couponCodeFetchSuccess:null,couponCodeFetchErrorId:null,couponCodeInvalidReason:null,couponConfig:null,pendingRequest:true,failedCouponId:null,couponAppliedWithoutValidation:null,isResponsePendingFromEstimationEndpoint:null});case __WEBPACK_IMPORTED_MODULE_5__actions__["_169" /* SUBSCRIPTION_GET_ESTIMATE_SUCCESS */]:{var couponConfig=getCouponConfig(action.result);if(action.payload.couponId){return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{isDiscountApplied:!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(couponConfig),discountType:action.payload.discountType,couponSetKey:null,couponId:action.payload.couponId,failedCouponId:null,couponType:action.payload.couponType,appliedProdCatOfLastValidCombination:null,appliedProdTypeOfLastValidCombination:null,appliedTierOfLastValidCombination:null,usedMagixEmail:null,usedProductSerial:null,couponCodeFetchSuccess:!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(couponConfig),couponCodeFetchErrorId:null,couponCodeInvalidReason:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(couponConfig)?getErrorReason(action.result):null,couponConfig:couponConfig,pendingRequest:false,isResponsePendingFromEstimationEndpoint:false,// Keep true to allow reading coupon input value 
// in Subscription.getCouponDataForSubscriptionEstimate when user changes seats quantity
couponAppliedWithoutValidation:true});}else if(action.payload.couponSetId){return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{isDiscountApplied:!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(couponConfig),discountType:action.payload.discountType,couponSetKey:action.payload.couponSetKey,couponId:null,failedCouponId:null,couponType:action.payload.couponType,appliedTierOfLastValidCombination:null},action.payload.couponSetId!==__WEBPACK_IMPORTED_MODULE_2__config__["D" /* DISCOUNTS_CONFIG */][__WEBPACK_IMPORTED_MODULE_2__config__["E" /* DISCOUNT_KEY */].TIER1].coupon_set_id&&action.payload.couponSetId!==__WEBPACK_IMPORTED_MODULE_2__config__["D" /* DISCOUNTS_CONFIG */][__WEBPACK_IMPORTED_MODULE_2__config__["E" /* DISCOUNT_KEY */].TIER2].coupon_set_id&&action.payload.couponSetId!==__WEBPACK_IMPORTED_MODULE_2__config__["D" /* DISCOUNTS_CONFIG */][__WEBPACK_IMPORTED_MODULE_2__config__["E" /* DISCOUNT_KEY */].TIER3].coupon_set_id&&action.payload.couponSetId!==__WEBPACK_IMPORTED_MODULE_2__config__["D" /* DISCOUNTS_CONFIG */][__WEBPACK_IMPORTED_MODULE_2__config__["E" /* DISCOUNT_KEY */].PHOTOL].coupon_set_id&&action.payload.couponSetId!==__WEBPACK_IMPORTED_MODULE_2__config__["D" /* DISCOUNTS_CONFIG */][__WEBPACK_IMPORTED_MODULE_2__config__["E" /* DISCOUNT_KEY */].WEBL].coupon_set_id&&action.payload.couponSetId!==__WEBPACK_IMPORTED_MODULE_2__config__["D" /* DISCOUNTS_CONFIG */][__WEBPACK_IMPORTED_MODULE_2__config__["E" /* DISCOUNT_KEY */].DESIGNERL].coupon_set_id&&{usedMagixEmail:null,usedProductSerial:null,appliedProdCatOfLastValidCombination:null,appliedProdTypeOfLastValidCombination:null},{couponCodeFetchSuccess:!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(couponConfig),couponCodeFetchErrorId:null,couponCodeInvalidReason:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(couponConfig)?getErrorReason(action.result):null,couponConfig:couponConfig,pendingRequest:false,isResponsePendingFromEstimationEndpoint:false,// Keep true to allow reading coupon input value 
// in Subscription.getCouponDataForSubscriptionEstimate when user changes seats quantity
couponAppliedWithoutValidation:true});}else{return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{isResponsePendingFromEstimationEndpoint:false,couponAppliedWithoutValidation:false});}}case __WEBPACK_IMPORTED_MODULE_5__actions__["_58" /* COUPON_FETCH_SUCCESS */]:isCouponActive=__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(action,'result.coupon.status')==='active';return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{isDiscountApplied:isCouponActive,discountType:__WEBPACK_IMPORTED_MODULE_2__config__["F" /* DISCOUNT_TYPE */].COUPON_ID,couponSetKey:null,couponId:action.payload.couponId,failedCouponId:null,couponType:action.payload.couponType,appliedProdCatOfLastValidCombination:null,appliedProdTypeOfLastValidCombination:null,appliedTierOfLastValidCombination:null,usedMagixEmail:null,usedProductSerial:null,couponCodeFetchSuccess:isCouponActive,couponCodeFetchErrorId:null,couponCodeInvalidReason:!isCouponActive?'expired':null,couponConfig:action.result.coupon,pendingRequest:false});case __WEBPACK_IMPORTED_MODULE_5__actions__["_168" /* SUBSCRIPTION_GET_ESTIMATE_FAIL */]:{return action.payload.couponId||action.payload.couponSetId?__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{isDiscountApplied:false,discountType:null,couponCodeFetchSuccess:false,couponCodeFetchErrorId:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(action,'error.errorId'),couponCodeInvalidReason:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(action,'error.reason'),couponConfig:null,pendingRequest:true,//allow resubmit on offline error - check is done in Subscription.componentDidUpdate
couponAppliedWithoutValidation:false,isResponsePendingFromEstimationEndpoint:false}):__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state);}case __WEBPACK_IMPORTED_MODULE_5__actions__["_57" /* COUPON_FETCH_FAIL */]:{return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{failedCouponId:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(action.payload,'couponId'),isDiscountApplied:false,couponCodeFetchSuccess:false,couponCodeFetchErrorId:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(action,'error.errorId'),couponCodeInvalidReason:__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(action,'error.reason'),couponConfig:null,pendingRequest:false});}case __WEBPACK_IMPORTED_MODULE_5__actions__["_74" /* DISCOUNT_CLEAR_APPLIED */]:{return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},initialState,{pendingRequest:false});}case __WEBPACK_IMPORTED_MODULE_5__actions__["_55" /* COUPON_CHANGE_TYPE */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{couponType:action.payload.couponType});default:return state;}});var applyMagixDiscount=function applyMagixDiscount(magixEmail,productSerial,prodCatOfLastValidCombination,tierOfLastValidCombination,prodTypeOfLastValidCombination){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_5__actions__["_73" /* DISCOUNT_APPLY_MAGIX */],payload:{magixEmail:magixEmail,productSerial:productSerial,prodCatOfLastValidCombination:prodCatOfLastValidCombination,tierOfLastValidCombination:tierOfLastValidCombination,prodTypeOfLastValidCombination:prodTypeOfLastValidCombination}});};};var applyDiscountUsingCouponSetId=function applyDiscountUsingCouponSetId(setId){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_5__actions__["_72" /* DISCOUNT_APPLY_COUPON_SET_ID */],payload:{setId:setId}});};};var clearAppliedDiscount=function clearAppliedDiscount(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_5__actions__["_74" /* DISCOUNT_CLEAR_APPLIED */]});};};/**
 * Validate coupon id and apply it
 *
 * @param {string} coupon_id coupon id
 * @returns dispatch
 */var applyDiscountUsingCouponId=function applyDiscountUsingCouponId(couponId,couponType,isAutoApplied){return function(dispatch,getState){var _getState=getState(),companies=_getState.companies;var url="".concat(__WEBPACK_IMPORTED_MODULE_2__config__["t" /* COUPONS */].GET_COUPON_INFO,"?id=").concat(companies.selectedId,"&couponId=").concat(encodeURIComponent(couponId));if([].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_2__config__["_32" /* SERIAL_NUMBER_PREFIXES_OLD_PRODUCTS */]),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_2__config__["_31" /* SERIAL_NUMBER_PREFIXES_NEW_PRODUCTS */])).includes(couponId.split('-')[0].toUpperCase())){dispatch({type:__WEBPACK_IMPORTED_MODULE_5__actions__["_57" /* COUPON_FETCH_FAIL */],error:{errorId:__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].COUPON_CODE_DOES_NOT_EXIST,reason:'serial-number'}});}else{return dispatch({types:[__WEBPACK_IMPORTED_MODULE_5__actions__["_56" /* COUPON_FETCH */],__WEBPACK_IMPORTED_MODULE_5__actions__["_58" /* COUPON_FETCH_SUCCESS */],__WEBPACK_IMPORTED_MODULE_5__actions__["_57" /* COUPON_FETCH_FAIL */]],payload:{couponId:couponId,couponType:couponType,isAutoApplied:isAutoApplied},promise:function promise(client){return client.get(url)["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({message:'discount.getCouponInfo() failed',errorId:__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_9__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COUPON'}});throw nError;});}});}};};var applyDiscountUsingCouponIdWithoutValidation=function applyDiscountUsingCouponIdWithoutValidation(couponId,couponType,isAutoApplied,discountType){return function(dispatch){if([].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_2__config__["_32" /* SERIAL_NUMBER_PREFIXES_OLD_PRODUCTS */]),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_2__config__["_31" /* SERIAL_NUMBER_PREFIXES_NEW_PRODUCTS */])).includes(couponId.split('-')[0].toUpperCase())){dispatch({type:__WEBPACK_IMPORTED_MODULE_5__actions__["_57" /* COUPON_FETCH_FAIL */],error:{errorId:__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].COUPON_CODE_DOES_NOT_EXIST,reason:'serial-number'}});}else{dispatch({type:__WEBPACK_IMPORTED_MODULE_5__actions__["_53" /* COUPON_APPLY_WITHOUT_VALIDATION */],payload:{couponId:couponId,couponType:couponType,isAutoApplied:isAutoApplied,discountType:discountType}});}};};var setUserSuppliedPromoCode=function setUserSuppliedPromoCode(value){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_5__actions__["_154" /* SET_USER_SUPPLIED_PROMO_CODE */],payload:{value:value}});};};var changeCouponType=function changeCouponType(couponType){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_5__actions__["_55" /* COUPON_CHANGE_TYPE */],payload:{couponType:couponType}});};};var activeCouponSendToUserForType=[];var sendCurrentOfferToUser=function sendCurrentOfferToUser(payload){if(activeCouponSendToUserForType.includes(payload.type))return;activeCouponSendToUserForType.push(payload.type);__WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__config__["_30" /* SEND_CURRENT_OFFERS_URL */],payload)["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["a" /* extractPropsforAxiosHttpError */])(error);log.send(new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({message:'discount.sendCurrentOfferToUser() failed',errorId:__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_9__errors_httperror__["a" /* default */](httpErrorProps),errorDetails:payload,visualisers:{feature:'REDUX_COUPON'}}));});};

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(336);


/***/ }),
/* 121 */
/***/ (function(module, exports) {

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

module.exports = _asyncToGenerator;

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setAllPackagesShownFlag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setDesktopUserFlag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setDesktopTrialFlag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return setReAccessNoIndustry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return setPerpetuallAppFlag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return setUpgradePopupFlag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return setPendingTriggerCheckout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setCouponIdProvidedFlag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDesktopAppFlag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setAppStateParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return setSubscriptionCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return setSubscriptionView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return setSubscriptionPeriod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return setSubscriptionCurrency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clearSubscriptionState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return setPerpetualOverviewPageVisited; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return setPlusOverviewPageVisited; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return setSeatsQuantity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return setLicensesQuantity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return setReduceUsersApiErrorState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearReduceUsersApiErrorState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return setRenewalPopupWasShown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_state__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_users__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_storage__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_modules_companies__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_store__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_subscription__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__errors_apperror__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__logger_logger__ = __webpack_require__(40);
var log=__WEBPACK_IMPORTED_MODULE_12__logger_logger__["a" /* default */].get('redux-app');var initialState={isDesktopApp:false,isPerpetualApp:false,isDesktopTrial:null,isReAccessNoIndustry:null,showAllPackages:false,isUpgradePopup:false,pendingTriggerCheckout:null,isCouponIdProvided:false,subscriptionCategory:null,subscriptionPeriod:null,isPeriodAutoApplied:null,isCategoryAutoApplied:null,isCurrencyAutoApplied:null,isSeatsQuantityAutoApplied:null,isLicensesQuantityAutoApplied:null,isSubscriptionViewAutoApplied:null,subscriptionCurrency:null,subscriptionView:null,seatsQuantity:null,licensesQuantity:null,wasPlusOverviewPageVisited:false,wasPerpetualOverviewPageVisited:false,reduceUsersApiState:null,wasRenewalPopupShown:false};/* harmony default export */ __webpack_exports__["c"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1?arguments[1]:undefined;switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["_140" /* REDUCE_USERS_API_ERROR_STATE_SET */]:{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{reduceUsersApiState:action.payload});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_131" /* MODAL_HIDE */]:case __WEBPACK_IMPORTED_MODULE_1__actions__["_132" /* MODAL_RESET */]:case __WEBPACK_IMPORTED_MODULE_1__actions__["_139" /* REDUCE_USERS_API_ERROR_STATE_CLEAR */]:{if(state.reduceUsersApiState){return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{reduceUsersApiState:null});}else{return state;}}case __WEBPACK_IMPORTED_MODULE_1__actions__["_74" /* DISCOUNT_CLEAR_APPLIED */]:{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{isUpgradePopup:false,isCouponIdProvided:false,isPeriodAutoApplied:false,isCategoryAutoApplied:false});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_135" /* PERPETUAL_APP_FLAG_SET */]:{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{isPerpetualApp:action.payload});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_71" /* DESKTOP_TRIAL_FLAG_SET */]:{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{isDesktopTrial:action.payload});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_70" /* DESKTOP_RE_ACCESS_NO_INDUSTRY_FLAG_SET */]:{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{isReAccessNoIndustry:action.payload});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_69" /* DESKTOP_APP_FLAG_SET */]:{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{isDesktopApp:action.payload});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_68" /* DESKTOP_APP_FLAG_GET */]:{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{isDesktopApp:action.payload});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_155" /* SHOW_ALL_PACKAGES_FLAG_SET */]:{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{showAllPackages:action.payload});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_177" /* UPGRADE_POPUP_FLAG_SET */]:{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{isUpgradePopup:action.payload});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_134" /* PENDING_TRIGGER_CHECKOUT_FLAG_SET */]:{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{pendingTriggerCheckout:action.payload});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_59" /* COUPON_ID_PROVIDED_FLAG_SET */]:{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{isCouponIdProvided:action.payload});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_160" /* SUBSCRIPTION_BATCH_PARAMS_SET */]:{var newState=__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state);if(action.payload.subscriptionCategory){newState.subscriptionCategory=action.payload.subscriptionCategory;newState.isCategoryAutoApplied=true;}if(action.payload.subscriptionView){newState.subscriptionView=action.payload.subscriptionView;newState.isSubscriptionViewAutoApplied=false;}if(action.payload.subscriptionPeriod){newState.subscriptionPeriod=action.payload.subscriptionPeriod;newState.isPeriodAutoApplied=true;}return newState;}case __WEBPACK_IMPORTED_MODULE_1__actions__["_161" /* SUBSCRIPTION_CATEGORY_SET */]:{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{subscriptionCategory:action.payload.value,isCategoryAutoApplied:action.payload.isAutoApplied});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_173" /* SUBSCRIPTION_VIEW_SET */]:{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{subscriptionView:action.payload.value,isSubscriptionViewAutoApplied:action.payload.isAutoApplied});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_170" /* SUBSCRIPTION_PERIOD_SET */]:{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{subscriptionPeriod:action.payload.value,isPeriodAutoApplied:action.payload.isAutoApplied});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_53" /* COUPON_APPLY_WITHOUT_VALIDATION */]:{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{isPeriodAutoApplied:action.payload.isAutoApplied,isCategoryAutoApplied:action.payload.isAutoApplied});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_56" /* COUPON_FETCH */]:{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{isPeriodAutoApplied:false,isCategoryAutoApplied:false});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_58" /* COUPON_FETCH_SUCCESS */]:{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{isPeriodAutoApplied:action.payload.isAutoApplied,isCategoryAutoApplied:action.payload.isAutoApplied});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_144" /* RENEWAL_POPUP_SHOWN */]:{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{wasRenewalPopupShown:true});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_72" /* DISCOUNT_APPLY_COUPON_SET_ID */]:{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{isPeriodAutoApplied:true,isCategoryAutoApplied:true});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_73" /* DISCOUNT_APPLY_MAGIX */]:{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{isPeriodAutoApplied:true,isCategoryAutoApplied:true});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_163" /* SUBSCRIPTION_CURRENCY_SET */]:{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{subscriptionCurrency:action.payload.value,isCurrencyAutoApplied:action.payload.isAutoApplied});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_147" /* SEATS_QUANTITY_SET */]:{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{seatsQuantity:action.payload.value,isSeatsQuantityAutoApplied:action.payload.isAutoApplied});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_92" /* LICENSES_QUANTITY_SET */]:{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{licensesQuantity:action.payload.value,isLicensesQuantityAutoApplied:action.payload.isAutoApplied});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_34" /* COMPANIES_UPDATE_SUCCESS */]:{var companyData=getCompanyData(true);if(companyData.selectedId){var data=action.payload.data;if(!__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(data,'users')){var nError=new __WEBPACK_IMPORTED_MODULE_11__errors_apperror__["a" /* default */]({message:'Missing data.users in COMPANIES_UPDATE_SUCCESS',errorId:__WEBPACK_IMPORTED_MODULE_10__errors_errorids__["a" /* default */].UNKNOWN,details:{action:JSON.stringify(action.payload)},visualisers:{feature:'REDUX_APP'}});log.send(nError);}if(Object(__WEBPACK_IMPORTED_MODULE_2_utils_state__["c" /* isNewRealEstateUiUsed */])(__WEBPACK_IMPORTED_MODULE_6__redux_store__["a" /* default */])){return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state);}else{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{seatsQuantity:Object(__WEBPACK_IMPORTED_MODULE_3_utils_users__["e" /* filterNonGuestUsers */])(data.users).length});}}else{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state);}}case __WEBPACK_IMPORTED_MODULE_1__actions__["_43" /* COMPANIES_USER_ADD_SUCCESS */]:{var _companyData=getCompanyData(true);if(_companyData.selectedId){if(Object(__WEBPACK_IMPORTED_MODULE_2_utils_state__["c" /* isNewRealEstateUiUsed */])(__WEBPACK_IMPORTED_MODULE_6__redux_store__["a" /* default */])){return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{seatsQuantity:0});}else{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{seatsQuantity:_companyData.nrOfUsers});}}else{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state);}}case __WEBPACK_IMPORTED_MODULE_1__actions__["_162" /* SUBSCRIPTION_CLEAR_STATE */]:{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{isPerpetualApp:false,showAllPackages:true,isUpgradePopup:false,subscriptionCategory:null,subscriptionPeriod:null,isPeriodAutoApplied:null,isCategoryAutoApplied:null,wasPlusOverviewPageVisited:false,wasPerpetualOverviewPageVisited:false,//productQuantity: null,
isSubscriptionViewAutoApplied:null,subscriptionView:null});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_171" /* SUBSCRIPTION_PERPETUAL_OVERVIEW_PAGE_VISITED */]:{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{wasPerpetualOverviewPageVisited:true});}case __WEBPACK_IMPORTED_MODULE_1__actions__["_172" /* SUBSCRIPTION_PLUS_OVERVIEW_PAGE_VISITED */]:{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{wasPlusOverviewPageVisited:true});}default:return state;}});var setAllPackagesShownFlag=function setAllPackagesShownFlag(value){return{type:__WEBPACK_IMPORTED_MODULE_1__actions__["_155" /* SHOW_ALL_PACKAGES_FLAG_SET */],payload:value};};var setDesktopUserFlag=function setDesktopUserFlag(value){var result=value&&!isCloudPlan()?true:false;// Save flag when providing ?desktop-app=1 for the first time
var companyId=Object(__WEBPACK_IMPORTED_MODULE_5_redux_modules_companies__["D" /* resolveActiveCompanyId */])(true);result&&Object(__WEBPACK_IMPORTED_MODULE_4_utils_storage__["x" /* saveDesktopAppCompanyId */])(companyId);return{type:__WEBPACK_IMPORTED_MODULE_1__actions__["_69" /* DESKTOP_APP_FLAG_SET */],payload:result};};var setDesktopTrialFlag=function setDesktopTrialFlag(value){return{type:__WEBPACK_IMPORTED_MODULE_1__actions__["_71" /* DESKTOP_TRIAL_FLAG_SET */],payload:value};};var setReAccessNoIndustry=function setReAccessNoIndustry(value){return{type:__WEBPACK_IMPORTED_MODULE_1__actions__["_70" /* DESKTOP_RE_ACCESS_NO_INDUSTRY_FLAG_SET */],payload:value};};var setPerpetuallAppFlag=function setPerpetuallAppFlag(value){return{type:__WEBPACK_IMPORTED_MODULE_1__actions__["_135" /* PERPETUAL_APP_FLAG_SET */],payload:value};};var setUpgradePopupFlag=function setUpgradePopupFlag(value){return{type:__WEBPACK_IMPORTED_MODULE_1__actions__["_177" /* UPGRADE_POPUP_FLAG_SET */],payload:value};};var setPendingTriggerCheckout=function setPendingTriggerCheckout(value){return{type:__WEBPACK_IMPORTED_MODULE_1__actions__["_134" /* PENDING_TRIGGER_CHECKOUT_FLAG_SET */],payload:value};};var setCouponIdProvidedFlag=function setCouponIdProvidedFlag(value){return{type:__WEBPACK_IMPORTED_MODULE_1__actions__["_59" /* COUPON_ID_PROVIDED_FLAG_SET */],payload:value};};/**
 * Retrieves the isDesktopApp flag from sessionstorage
*/var getDesktopAppFlag=function getDesktopAppFlag(){var isDesktopApp=resolveDesktopAppFlag();return{type:__WEBPACK_IMPORTED_MODULE_1__actions__["_68" /* DESKTOP_APP_FLAG_GET */],payload:isDesktopApp};};var isCloudPlan=function isCloudPlan(){var result=false;var state=__WEBPACK_IMPORTED_MODULE_6__redux_store__["a" /* default */].getState();var companiesRawData=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(state,'companies.rawDataById');var selectedPlanId=companiesRawData?Object(__WEBPACK_IMPORTED_MODULE_7_utils_subscription__["c" /* getCurrentPlanId */])(companiesRawData[state.companies.selectedId]):null;if(selectedPlanId){var activeSubscription=Object(__WEBPACK_IMPORTED_MODULE_7_utils_subscription__["a" /* convertPlanIdIntoSubscription */])(selectedPlanId);var plan=activeSubscription.plan;result=__WEBPACK_IMPORTED_MODULE_8_config__["_3" /* PACKAGES_CONFIG */][plan].isCloudSuitePlan;}return result;};var getCompanyData=function getCompanyData(onlyNonGuests){var state=__WEBPACK_IMPORTED_MODULE_6__redux_store__["a" /* default */].getState();var allUsers=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(state,'companies.byId['+state.companies.selectedId+'].users');var selectedPlanId=Object(__WEBPACK_IMPORTED_MODULE_7_utils_subscription__["c" /* getCurrentPlanId */])(state.companies.rawDataById[state.companies.selectedId]);var plan;if(selectedPlanId){var activeSubscription=Object(__WEBPACK_IMPORTED_MODULE_7_utils_subscription__["a" /* convertPlanIdIntoSubscription */])(selectedPlanId);plan=activeSubscription.plan;}return{selectedId:state.companies.selectedId,nrOfUsers:onlyNonGuests?Object(__WEBPACK_IMPORTED_MODULE_3_utils_users__["e" /* filterNonGuestUsers */])(allUsers).length:allUsers.length,plan:plan};};var resolveDesktopAppFlag=function resolveDesktopAppFlag(){var savedDesktopAppCompanyId=Object(__WEBPACK_IMPORTED_MODULE_4_utils_storage__["k" /* getDesktopAppCompanyId */])();if(savedDesktopAppCompanyId){// Check if saved isDesktopApp flag applies to current company
// or company changed in current tab
var companyId=Object(__WEBPACK_IMPORTED_MODULE_5_redux_modules_companies__["D" /* resolveActiveCompanyId */])(true);if(savedDesktopAppCompanyId===companyId&&!isCloudPlan()){return true;}else{Object(__WEBPACK_IMPORTED_MODULE_4_utils_storage__["a" /* clearDesktopAppCompanyId */])();return false;}}else{return false;}};/* only to be used when changing state from Subscription > Your Products > Upgrade plan */var setAppStateParams=function setAppStateParams(props){return{type:__WEBPACK_IMPORTED_MODULE_1__actions__["_160" /* SUBSCRIPTION_BATCH_PARAMS_SET */],payload:props};};var setSubscriptionCategory=function setSubscriptionCategory(value,isAutoApplied){return{type:__WEBPACK_IMPORTED_MODULE_1__actions__["_161" /* SUBSCRIPTION_CATEGORY_SET */],payload:{value:value,isAutoApplied:isAutoApplied}};};var setSubscriptionView=function setSubscriptionView(value,isAutoApplied){return{type:__WEBPACK_IMPORTED_MODULE_1__actions__["_173" /* SUBSCRIPTION_VIEW_SET */],payload:{value:value,isAutoApplied:isAutoApplied}};};var setSubscriptionPeriod=function setSubscriptionPeriod(value,isAutoApplied){return{type:__WEBPACK_IMPORTED_MODULE_1__actions__["_170" /* SUBSCRIPTION_PERIOD_SET */],payload:{value:value,isAutoApplied:isAutoApplied}};};var setSubscriptionCurrency=function setSubscriptionCurrency(value,isAutoApplied){return{type:__WEBPACK_IMPORTED_MODULE_1__actions__["_163" /* SUBSCRIPTION_CURRENCY_SET */],payload:{value:value,isAutoApplied:isAutoApplied}};};var clearSubscriptionState=function clearSubscriptionState(){return{type:__WEBPACK_IMPORTED_MODULE_1__actions__["_162" /* SUBSCRIPTION_CLEAR_STATE */]};};var setPerpetualOverviewPageVisited=function setPerpetualOverviewPageVisited(){return{type:__WEBPACK_IMPORTED_MODULE_1__actions__["_171" /* SUBSCRIPTION_PERPETUAL_OVERVIEW_PAGE_VISITED */]};};var setPlusOverviewPageVisited=function setPlusOverviewPageVisited(){return{type:__WEBPACK_IMPORTED_MODULE_1__actions__["_172" /* SUBSCRIPTION_PLUS_OVERVIEW_PAGE_VISITED */]};};var setSeatsQuantity=function setSeatsQuantity(value,isAutoApplied){return{type:__WEBPACK_IMPORTED_MODULE_1__actions__["_147" /* SEATS_QUANTITY_SET */],payload:{value:value,isAutoApplied:isAutoApplied}};};var setLicensesQuantity=function setLicensesQuantity(value,isAutoApplied){return{type:__WEBPACK_IMPORTED_MODULE_1__actions__["_92" /* LICENSES_QUANTITY_SET */],payload:{value:value,isAutoApplied:isAutoApplied}};};var setReduceUsersApiErrorState=function setReduceUsersApiErrorState(props){return{type:__WEBPACK_IMPORTED_MODULE_1__actions__["_140" /* REDUCE_USERS_API_ERROR_STATE_SET */],payload:props};};var clearReduceUsersApiErrorState=function clearReduceUsersApiErrorState(){return{type:__WEBPACK_IMPORTED_MODULE_1__actions__["_139" /* REDUCE_USERS_API_ERROR_STATE_CLEAR */]};};var setRenewalPopupWasShown=function setRenewalPopupWasShown(props){return{type:__WEBPACK_IMPORTED_MODULE_1__actions__["_144" /* RENEWAL_POPUP_SHOWN */]};};

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return saveDesktopAppCompanyId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getDesktopAppCompanyId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearDesktopAppCompanyId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return saveHideDiscountBannerFlag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return isDiscountBannerTemporarilyHidden; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return saveMagixDiscountCredentials; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getMagixDiscountCredentials; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return clearMagixDiscountCredentials; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getCheckoutPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return saveCheckoutPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return saveCheckoutLang; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getIsFirstOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return setIsFirstOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clearFirstOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getInvitedUsers; });
/* unused harmony export saveInvitedUsers */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return clearInvitedUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getInviteMessage; });
/* unused harmony export saveInviteMessage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearInviteMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getCheckoutSeatsQuantity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return saveCheckoutSeatsQuantity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getReUpgradePopupPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return saveReUpgradePopupPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return clearReUpgradePopupPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getIsReUpgradePopupFlag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return saveIsReUpgradePopupFlag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return clearIsReUpgradePopupFlag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getIsDesktopTrial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return saveIsDesktopTrial; });
/* unused harmony export clearIsDesktopTrial */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getIsReAccessNoIndustry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return saveIsReAccessNoIndustry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return clearIsReAccessNoIndustry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_logger__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__errors_apperror__ = __webpack_require__(34);
var log=__WEBPACK_IMPORTED_MODULE_0__logger_logger__["a" /* default */].get('refersion');var saveDesktopAppCompanyId=function saveDesktopAppCompanyId(companyId){try{return sessionStorage.setItem('isDesktopApp',companyId);}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'saveDesktopAppCompanyId() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var getDesktopAppCompanyId=function getDesktopAppCompanyId(){try{return sessionStorage.getItem('isDesktopApp');}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'getDesktopAppCompanyId() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var clearDesktopAppCompanyId=function clearDesktopAppCompanyId(){try{sessionStorage.removeItem('isDesktopApp');}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'clearDesktopAppCompanyId() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var saveHideDiscountBannerFlag=function saveHideDiscountBannerFlag(){try{return sessionStorage.setItem('hideDiscountBannerTemporarily',true);}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'saveHideDiscountBannerFlag() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var isDiscountBannerTemporarilyHidden=function isDiscountBannerTemporarilyHidden(){try{return sessionStorage.getItem('hideDiscountBannerTemporarily');}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'isDiscountBannerTemporarilyHidden() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var saveMagixDiscountCredentials=function saveMagixDiscountCredentials(email,serial){try{return sessionStorage.setItem('discountCredentials',JSON.stringify({e:window.btoa(email),s:window.btoa(serial)}));}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'saveMagixDiscountCredentials() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var getMagixDiscountCredentials=function getMagixDiscountCredentials(){try{var value=sessionStorage.getItem('discountCredentials');if(!value)return null;var parsedJSON=JSON.parse(value);return{email:window.atob(parsedJSON.e),serial:window.atob(parsedJSON.s)};}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'getMagixDiscountCredentials() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var clearMagixDiscountCredentials=function clearMagixDiscountCredentials(){try{sessionStorage.removeItem('discountCredentials');}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'clearMagixDiscountCredentials() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var getCheckoutPlan=function getCheckoutPlan(){try{return sessionStorage.getItem('cbCheckoutPlan');}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'getCheckoutPlan() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var saveCheckoutPlan=function saveCheckoutPlan(id){try{return sessionStorage.setItem('cbCheckoutPlan',id);}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'saveCheckoutPlan() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var saveCheckoutLang=function saveCheckoutLang(lang){try{return sessionStorage.setItem('checkoutLang',lang);}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'saveCheckoutLang() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var getIsFirstOrder=function getIsFirstOrder(){try{return sessionStorage.getItem('isFirstOrder');}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'getIsFirstOrder() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var setIsFirstOrder=function setIsFirstOrder(value){try{return sessionStorage.setItem('isFirstOrder',value);}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'saveFirstOrder() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var clearFirstOrder=function clearFirstOrder(){try{return sessionStorage.removeItem('isFirstOrder');}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'saveFirstOrder() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var getInvitedUsers=function getInvitedUsers(){try{var savedValue=sessionStorage.getItem('invitedUsers');return savedValue&&JSON.parse(savedValue);}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'getInvitedUsers() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var saveInvitedUsers=function saveInvitedUsers(value){try{return sessionStorage.setItem('invitedUsers',JSON.stringify(value));}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'saveFirstOrder() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var clearInvitedUsers=function clearInvitedUsers(){try{return sessionStorage.removeItem('invitedUsers');}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'clearInvitedUsers() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var getInviteMessage=function getInviteMessage(){try{return sessionStorage.getItem('inviteMessage');}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'getInvitedUsers() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var saveInviteMessage=function saveInviteMessage(value){try{return sessionStorage.setItem('inviteMessage',value);}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'saveFirstOrder() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var clearInviteMessage=function clearInviteMessage(){try{return sessionStorage.removeItem('inviteMessage');}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'clearInvitedUsers() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var getCheckoutSeatsQuantity=function getCheckoutSeatsQuantity(){try{return sessionStorage.getItem('cbCheckoutSeatsQuantity');}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'getCheckoutSeatsQuantity() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var saveCheckoutSeatsQuantity=function saveCheckoutSeatsQuantity(quantity){try{return sessionStorage.setItem('cbCheckoutSeatsQuantity',quantity);}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'saveCheckoutSeatsQuantity() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var getReUpgradePopupPlan=function getReUpgradePopupPlan(){try{return sessionStorage.getItem('ReUpgradePopupPlan');}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'getReUpgradePopupPlan() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var saveReUpgradePopupPlan=function saveReUpgradePopupPlan(plan){try{return sessionStorage.setItem('ReUpgradePopupPlan',plan);}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'saveReUpgradePopupPlan() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var clearReUpgradePopupPlan=function clearReUpgradePopupPlan(){try{sessionStorage.removeItem('ReUpgradePopupPlan');}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'clearReUpgradePopupPlan() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var getIsReUpgradePopupFlag=function getIsReUpgradePopupFlag(){try{return sessionStorage.getItem('isReUpgradePopup');}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'getIsReUpgradePopupFlag() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var saveIsReUpgradePopupFlag=function saveIsReUpgradePopupFlag(plan){try{return sessionStorage.setItem('isReUpgradePopup',plan);}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'saveIsReUpgradePopupFlag() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var clearIsReUpgradePopupFlag=function clearIsReUpgradePopupFlag(){try{sessionStorage.removeItem('isReUpgradePopup');}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'clearIsReUpgradePopupFlag() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var getIsDesktopTrial=function getIsDesktopTrial(){try{return sessionStorage.getItem('isDesktopTrial');}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'getIsDesktopTrial() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var saveIsDesktopTrial=function saveIsDesktopTrial(value){try{return sessionStorage.setItem('isDesktopTrial',value);}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'saveIsDesktopTrial() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var clearIsDesktopTrial=function clearIsDesktopTrial(){try{return sessionStorage.removeItem('isDesktopTrial');}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'clearIsDesktopTrial() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var getIsReAccessNoIndustry=function getIsReAccessNoIndustry(){try{return sessionStorage.getItem('isReAccessNoIndustry');}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'getIsReAccessNoIndustry() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var saveIsReAccessNoIndustry=function saveIsReAccessNoIndustry(value){try{return sessionStorage.setItem('isReAccessNoIndustry',value);}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'saveIsReAccessNoIndustry() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};var clearIsReAccessNoIndustry=function clearIsReAccessNoIndustry(){try{return sessionStorage.removeItem('isReAccessNoIndustry');}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_2__errors_apperror__["a" /* default */]({message:'clearIsReAccessNoIndustry() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}};

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return showPreloader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hidePreloader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(45);
var initialState={loading:true};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1?arguments[1]:undefined;switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["_157" /* SHOW_PRELOADER */]:return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{loading:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["_91" /* HIDE_PRELOADER */]:case __WEBPACK_IMPORTED_MODULE_1__actions__["_34" /* COMPANIES_UPDATE_SUCCESS */]:return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{loading:false});default:return state;}});var showPreloader=function showPreloader(){return{type:__WEBPACK_IMPORTED_MODULE_1__actions__["_157" /* SHOW_PRELOADER */]};};var hidePreloader=function hidePreloader(){return{type:__WEBPACK_IMPORTED_MODULE_1__actions__["_91" /* HIDE_PRELOADER */]};};

/***/ }),
/* 125 */
/***/ (function(module, exports) {

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */
function debounce(func, wait, immediate){
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  };

  var debounced = function(){
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  
  debounced.flush = function() {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;
      
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
};

// Adds compatibility for ES modules
debounce.debounce = debounce;

module.exports = debounce;


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
var _dec,_class;var styles=function styles(theme){return{root:{marginBottom:41,fontSize:15},tip:{fontStyle:'italic',color:theme.palette.secondary.main}};};var Description=(_dec=Object(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(Description,_Component);function Description(){__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this,Description);return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Description).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Description,[{key:"render",value:function render(){var _this$props=this.props,classes=_this$props.classes,children=_this$props.children,dangerousInnerHTML=_this$props.dangerousInnerHTML,tip=_this$props.tip,variant=_this$props.variant,className=_this$props.className;var props={};if(dangerousInnerHTML){props.dangerouslySetInnerHTML={__html:dangerousInnerHTML};}return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({variant:variant,className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()(classes.root,className,tip&&classes.tip)},props),children);}}]);return Description;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]))||_class);Description.defaultProps={variant:'body1'};Description.propTypes={children:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array]),classes:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,dangerousInnerHTML:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,tip:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,variant:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Description);

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(43).f;
var has = __webpack_require__(58);
var TAG = __webpack_require__(35)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);
var defined = __webpack_require__(86);
var fails = __webpack_require__(31);
var spaces = __webpack_require__(223);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(30);
var dP = __webpack_require__(43);
var DESCRIPTORS = __webpack_require__(47);
var SPECIES = __webpack_require__(35)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 131 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(55);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(134);

var _warning2 = _interopRequireDefault(_warning);

var _toCss = __webpack_require__(257);

var _toCss2 = _interopRequireDefault(_toCss);

var _toCssValue = __webpack_require__(185);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StyleRule = function () {
  function StyleRule(key, style, options) {
    _classCallCheck(this, StyleRule);

    this.type = 'style';
    this.isProcessed = false;
    var sheet = options.sheet,
        Renderer = options.Renderer,
        selector = options.selector;

    this.key = key;
    this.options = options;
    this.style = style;
    if (selector) this.selectorText = selector;
    this.renderer = sheet ? sheet.renderer : new Renderer();
  }

  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  _createClass(StyleRule, [{
    key: 'prop',


    /**
     * Get or set a style property.
     */
    value: function prop(name, value) {
      // It's a getter.
      if (value === undefined) return this.style[name];

      // Don't do anything if the value has not changed.
      if (this.style[name] === value) return this;

      value = this.options.jss.plugins.onChangeValue(value, name, this);

      var isEmpty = value == null || value === false;
      var isDefined = name in this.style;

      // Value is empty and wasn't defined before.
      if (isEmpty && !isDefined) return this;

      // We are going to remove this value.
      var remove = isEmpty && isDefined;

      if (remove) delete this.style[name];else this.style[name] = value;

      // Renderable is defined if StyleSheet option `link` is true.
      if (this.renderable) {
        if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, value);
        return this;
      }

      var sheet = this.options.sheet;

      if (sheet && sheet.attached) {
        (0, _warning2['default'])(false, 'Rule is not linked. Missing sheet option "link: true".');
      }
      return this;
    }

    /**
     * Apply rule to an element inline.
     */

  }, {
    key: 'applyTo',
    value: function applyTo(renderable) {
      var json = this.toJSON();
      for (var prop in json) {
        this.renderer.setProperty(renderable, prop, json[prop]);
      }return this;
    }

    /**
     * Returns JSON representation of the rule.
     * Fallbacks are not supported.
     * Useful for inline styles.
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      var json = {};
      for (var prop in this.style) {
        var value = this.style[prop];
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = (0, _toCssValue2['default'])(value);
      }
      return json;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      var sheet = this.options.sheet;

      var link = sheet ? sheet.options.link : false;
      var opts = link ? _extends({}, options, { allowEmpty: true }) : options;
      return (0, _toCss2['default'])(this.selector, this.style, opts);
    }
  }, {
    key: 'selector',
    set: function set(selector) {
      if (selector === this.selectorText) return;

      this.selectorText = selector;

      if (!this.renderable) return;

      var hasChanged = this.renderer.setSelector(this.renderable, selector);

      // If selector setter is not implemented, rerender the rule.
      if (!hasChanged && this.renderable) {
        var renderable = this.renderer.replaceRule(this.renderable, this);
        if (renderable) this.renderable = renderable;
      }
    }

    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}();

exports['default'] = StyleRule;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var keys = __webpack_require__(826);
var hasBinary = __webpack_require__(392);
var sliceBuffer = __webpack_require__(828);
var after = __webpack_require__(829);
var utf8 = __webpack_require__(830);

var base64encoder;
if (typeof ArrayBuffer !== 'undefined') {
  base64encoder = __webpack_require__(831);
}

/**
 * Check if we are running an android browser. That requires us to use
 * ArrayBuffer with polling transports...
 *
 * http://ghinda.net/jpeg-blob-ajax-android/
 */

var isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);

/**
 * Check if we are running in PhantomJS.
 * Uploading a Blob with PhantomJS does not work correctly, as reported here:
 * https://github.com/ariya/phantomjs/issues/11395
 * @type boolean
 */
var isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);

/**
 * When true, avoids using Blobs to encode payloads.
 * @type boolean
 */
var dontSendBlobs = isAndroid || isPhantomJS;

/**
 * Current protocol version.
 */

exports.protocol = 3;

/**
 * Packet types.
 */

var packets = exports.packets = {
    open:     0    // non-ws
  , close:    1    // non-ws
  , ping:     2
  , pong:     3
  , message:  4
  , upgrade:  5
  , noop:     6
};

var packetslist = keys(packets);

/**
 * Premade error packet.
 */

var err = { type: 'error', data: 'parser error' };

/**
 * Create a blob api even for blob builder when vendor prefixes exist
 */

var Blob = __webpack_require__(832);

/**
 * Encodes a packet.
 *
 *     <packet type id> [ <data> ]
 *
 * Example:
 *
 *     5hello world
 *     3
 *     4
 *
 * Binary is encoded in an identical principle
 *
 * @api private
 */

exports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {
  if (typeof supportsBinary === 'function') {
    callback = supportsBinary;
    supportsBinary = false;
  }

  if (typeof utf8encode === 'function') {
    callback = utf8encode;
    utf8encode = null;
  }

  var data = (packet.data === undefined)
    ? undefined
    : packet.data.buffer || packet.data;

  if (typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) {
    return encodeArrayBuffer(packet, supportsBinary, callback);
  } else if (typeof Blob !== 'undefined' && data instanceof Blob) {
    return encodeBlob(packet, supportsBinary, callback);
  }

  // might be an object with { base64: true, data: dataAsBase64String }
  if (data && data.base64) {
    return encodeBase64Object(packet, callback);
  }

  // Sending data as a utf-8 string
  var encoded = packets[packet.type];

  // data fragment is optional
  if (undefined !== packet.data) {
    encoded += utf8encode ? utf8.encode(String(packet.data), { strict: false }) : String(packet.data);
  }

  return callback('' + encoded);

};

function encodeBase64Object(packet, callback) {
  // packet data is an object { base64: true, data: dataAsBase64String }
  var message = 'b' + exports.packets[packet.type] + packet.data.data;
  return callback(message);
}

/**
 * Encode packet helpers for binary types
 */

function encodeArrayBuffer(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  var data = packet.data;
  var contentArray = new Uint8Array(data);
  var resultBuffer = new Uint8Array(1 + data.byteLength);

  resultBuffer[0] = packets[packet.type];
  for (var i = 0; i < contentArray.length; i++) {
    resultBuffer[i+1] = contentArray[i];
  }

  return callback(resultBuffer.buffer);
}

function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  var fr = new FileReader();
  fr.onload = function() {
    exports.encodePacket({ type: packet.type, data: fr.result }, supportsBinary, true, callback);
  };
  return fr.readAsArrayBuffer(packet.data);
}

function encodeBlob(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  if (dontSendBlobs) {
    return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
  }

  var length = new Uint8Array(1);
  length[0] = packets[packet.type];
  var blob = new Blob([length.buffer, packet.data]);

  return callback(blob);
}

/**
 * Encodes a packet with binary data in a base64 string
 *
 * @param {Object} packet, has `type` and `data`
 * @return {String} base64 encoded message
 */

exports.encodeBase64Packet = function(packet, callback) {
  var message = 'b' + exports.packets[packet.type];
  if (typeof Blob !== 'undefined' && packet.data instanceof Blob) {
    var fr = new FileReader();
    fr.onload = function() {
      var b64 = fr.result.split(',')[1];
      callback(message + b64);
    };
    return fr.readAsDataURL(packet.data);
  }

  var b64data;
  try {
    b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
  } catch (e) {
    // iPhone Safari doesn't let you apply with typed arrays
    var typed = new Uint8Array(packet.data);
    var basic = new Array(typed.length);
    for (var i = 0; i < typed.length; i++) {
      basic[i] = typed[i];
    }
    b64data = String.fromCharCode.apply(null, basic);
  }
  message += btoa(b64data);
  return callback(message);
};

/**
 * Decodes a packet. Changes format to Blob if requested.
 *
 * @return {Object} with `type` and `data` (if any)
 * @api private
 */

exports.decodePacket = function (data, binaryType, utf8decode) {
  if (data === undefined) {
    return err;
  }
  // String data
  if (typeof data === 'string') {
    if (data.charAt(0) === 'b') {
      return exports.decodeBase64Packet(data.substr(1), binaryType);
    }

    if (utf8decode) {
      data = tryDecode(data);
      if (data === false) {
        return err;
      }
    }
    var type = data.charAt(0);

    if (Number(type) != type || !packetslist[type]) {
      return err;
    }

    if (data.length > 1) {
      return { type: packetslist[type], data: data.substring(1) };
    } else {
      return { type: packetslist[type] };
    }
  }

  var asArray = new Uint8Array(data);
  var type = asArray[0];
  var rest = sliceBuffer(data, 1);
  if (Blob && binaryType === 'blob') {
    rest = new Blob([rest]);
  }
  return { type: packetslist[type], data: rest };
};

function tryDecode(data) {
  try {
    data = utf8.decode(data, { strict: false });
  } catch (e) {
    return false;
  }
  return data;
}

/**
 * Decodes a packet encoded in a base64 string
 *
 * @param {String} base64 encoded message
 * @return {Object} with `type` and `data` (if any)
 */

exports.decodeBase64Packet = function(msg, binaryType) {
  var type = packetslist[msg.charAt(0)];
  if (!base64encoder) {
    return { type: type, data: { base64: true, data: msg.substr(1) } };
  }

  var data = base64encoder.decode(msg.substr(1));

  if (binaryType === 'blob' && Blob) {
    data = new Blob([data]);
  }

  return { type: type, data: data };
};

/**
 * Encodes multiple messages (payload).
 *
 *     <length>:data
 *
 * Example:
 *
 *     11:hello world2:hi
 *
 * If any contents are binary, they will be encoded as base64 strings. Base64
 * encoded strings are marked with a b before the length specifier
 *
 * @param {Array} packets
 * @api private
 */

exports.encodePayload = function (packets, supportsBinary, callback) {
  if (typeof supportsBinary === 'function') {
    callback = supportsBinary;
    supportsBinary = null;
  }

  var isBinary = hasBinary(packets);

  if (supportsBinary && isBinary) {
    if (Blob && !dontSendBlobs) {
      return exports.encodePayloadAsBlob(packets, callback);
    }

    return exports.encodePayloadAsArrayBuffer(packets, callback);
  }

  if (!packets.length) {
    return callback('0:');
  }

  function setLengthHeader(message) {
    return message.length + ':' + message;
  }

  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, !isBinary ? false : supportsBinary, false, function(message) {
      doneCallback(null, setLengthHeader(message));
    });
  }

  map(packets, encodeOne, function(err, results) {
    return callback(results.join(''));
  });
};

/**
 * Async array map using after
 */

function map(ary, each, done) {
  var result = new Array(ary.length);
  var next = after(ary.length, done);

  var eachWithIndex = function(i, el, cb) {
    each(el, function(error, msg) {
      result[i] = msg;
      cb(error, result);
    });
  };

  for (var i = 0; i < ary.length; i++) {
    eachWithIndex(i, ary[i], next);
  }
}

/*
 * Decodes data when a payload is maybe expected. Possible binary contents are
 * decoded from their base64 representation
 *
 * @param {String} data, callback method
 * @api public
 */

exports.decodePayload = function (data, binaryType, callback) {
  if (typeof data !== 'string') {
    return exports.decodePayloadAsBinary(data, binaryType, callback);
  }

  if (typeof binaryType === 'function') {
    callback = binaryType;
    binaryType = null;
  }

  var packet;
  if (data === '') {
    // parser error - ignoring payload
    return callback(err, 0, 1);
  }

  var length = '', n, msg;

  for (var i = 0, l = data.length; i < l; i++) {
    var chr = data.charAt(i);

    if (chr !== ':') {
      length += chr;
      continue;
    }

    if (length === '' || (length != (n = Number(length)))) {
      // parser error - ignoring payload
      return callback(err, 0, 1);
    }

    msg = data.substr(i + 1, n);

    if (length != msg.length) {
      // parser error - ignoring payload
      return callback(err, 0, 1);
    }

    if (msg.length) {
      packet = exports.decodePacket(msg, binaryType, false);

      if (err.type === packet.type && err.data === packet.data) {
        // parser error in individual packet - ignoring payload
        return callback(err, 0, 1);
      }

      var ret = callback(packet, i + n, l);
      if (false === ret) return;
    }

    // advance cursor
    i += n;
    length = '';
  }

  if (length !== '') {
    // parser error - ignoring payload
    return callback(err, 0, 1);
  }

};

/**
 * Encodes multiple messages (payload) as binary.
 *
 * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number
 * 255><data>
 *
 * Example:
 * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers
 *
 * @param {Array} packets
 * @return {ArrayBuffer} encoded payload
 * @api private
 */

exports.encodePayloadAsArrayBuffer = function(packets, callback) {
  if (!packets.length) {
    return callback(new ArrayBuffer(0));
  }

  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, true, true, function(data) {
      return doneCallback(null, data);
    });
  }

  map(packets, encodeOne, function(err, encodedPackets) {
    var totalLength = encodedPackets.reduce(function(acc, p) {
      var len;
      if (typeof p === 'string'){
        len = p.length;
      } else {
        len = p.byteLength;
      }
      return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2
    }, 0);

    var resultArray = new Uint8Array(totalLength);

    var bufferIndex = 0;
    encodedPackets.forEach(function(p) {
      var isString = typeof p === 'string';
      var ab = p;
      if (isString) {
        var view = new Uint8Array(p.length);
        for (var i = 0; i < p.length; i++) {
          view[i] = p.charCodeAt(i);
        }
        ab = view.buffer;
      }

      if (isString) { // not true binary
        resultArray[bufferIndex++] = 0;
      } else { // true binary
        resultArray[bufferIndex++] = 1;
      }

      var lenStr = ab.byteLength.toString();
      for (var i = 0; i < lenStr.length; i++) {
        resultArray[bufferIndex++] = parseInt(lenStr[i]);
      }
      resultArray[bufferIndex++] = 255;

      var view = new Uint8Array(ab);
      for (var i = 0; i < view.length; i++) {
        resultArray[bufferIndex++] = view[i];
      }
    });

    return callback(resultArray.buffer);
  });
};

/**
 * Encode as Blob
 */

exports.encodePayloadAsBlob = function(packets, callback) {
  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, true, true, function(encoded) {
      var binaryIdentifier = new Uint8Array(1);
      binaryIdentifier[0] = 1;
      if (typeof encoded === 'string') {
        var view = new Uint8Array(encoded.length);
        for (var i = 0; i < encoded.length; i++) {
          view[i] = encoded.charCodeAt(i);
        }
        encoded = view.buffer;
        binaryIdentifier[0] = 0;
      }

      var len = (encoded instanceof ArrayBuffer)
        ? encoded.byteLength
        : encoded.size;

      var lenStr = len.toString();
      var lengthAry = new Uint8Array(lenStr.length + 1);
      for (var i = 0; i < lenStr.length; i++) {
        lengthAry[i] = parseInt(lenStr[i]);
      }
      lengthAry[lenStr.length] = 255;

      if (Blob) {
        var blob = new Blob([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
        doneCallback(null, blob);
      }
    });
  }

  map(packets, encodeOne, function(err, results) {
    return callback(new Blob(results));
  });
};

/*
 * Decodes data when a payload is maybe expected. Strings are decoded by
 * interpreting each byte as a key code for entries marked to start with 0. See
 * description of encodePayloadAsBinary
 *
 * @param {ArrayBuffer} data, callback method
 * @api public
 */

exports.decodePayloadAsBinary = function (data, binaryType, callback) {
  if (typeof binaryType === 'function') {
    callback = binaryType;
    binaryType = null;
  }

  var bufferTail = data;
  var buffers = [];

  while (bufferTail.byteLength > 0) {
    var tailArray = new Uint8Array(bufferTail);
    var isString = tailArray[0] === 0;
    var msgLength = '';

    for (var i = 1; ; i++) {
      if (tailArray[i] === 255) break;

      // 310 = char length of Number.MAX_VALUE
      if (msgLength.length > 310) {
        return callback(err, 0, 1);
      }

      msgLength += tailArray[i];
    }

    bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
    msgLength = parseInt(msgLength);

    var msg = sliceBuffer(bufferTail, 0, msgLength);
    if (isString) {
      try {
        msg = String.fromCharCode.apply(null, new Uint8Array(msg));
      } catch (e) {
        // iPhone Safari doesn't let you apply to typed arrays
        var typed = new Uint8Array(msg);
        msg = '';
        for (var i = 0; i < typed.length; i++) {
          msg += String.fromCharCode(typed[i]);
        }
      }
    }

    buffers.push(msg);
    bufferTail = sliceBuffer(bufferTail, msgLength);
  }

  var total = buffers.length;
  buffers.forEach(function(buffer, i) {
    callback(exports.decodePacket(buffer, binaryType, true), i, total);
  });
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(271));

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactDom = _interopRequireDefault(__webpack_require__(44));

var _reactLifecyclesCompat = __webpack_require__(405);

var _PropTypes = __webpack_require__(866);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }

      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   *  appear: 500,
   * }}
   * ```
   *
   * If the value of appear is not set, then the value from enter is taken.
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    var pt = process.env.NODE_ENV !== "production" ? _PropTypes.timeoutsShape : {};;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTransitionProps = getTransitionProps;
exports.reflow = void 0;

var reflow = function reflow(node) {
  return node.scrollTop;
};

exports.reflow = reflow;

function getTransitionProps(props, options) {
  var timeout = props.timeout,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;
  return {
    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode],
    delay: style.transitionDelay
  };
}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formControlState;

function formControlState(_ref) {
  var props = _ref.props,
      states = _ref.states,
      muiFormControl = _ref.muiFormControl;
  return states.reduce(function (acc, state) {
    acc[state] = props[state];

    if (muiFormControl) {
      if (typeof props[state] === 'undefined') {
        acc[state] = muiFormControl[state];
      }
    }

    return acc;
  }, {});
}

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _DialogTitle.default;
  }
});

var _DialogTitle = _interopRequireDefault(__webpack_require__(993));

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button__ = __webpack_require__(1099);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TextField__ = __webpack_require__(1100);
/* unused harmony reexport TextField */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Select__ = __webpack_require__(1101);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Select__["a"]; });


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(85);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 143 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(85);
var TAG = __webpack_require__(35)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(32);
var aFunction = __webpack_require__(76);
var SPECIES = __webpack_require__(35)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(350);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(353);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(354);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(252);
/* unused harmony reexport Route */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(181);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(356);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(357);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__matchPath__ = __webpack_require__(183);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__withRouter__ = __webpack_require__(358);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_8__withRouter__["a"]; });



















/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 150 */
/***/ (function(module, exports) {

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

module.exports = _interopRequireWildcard;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createBreakpoints;
exports.keys = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

exports.keys = keys;

function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
      other = (0, _objectWithoutProperties2.default)(breakpoints, ["values", "unit", "step"]);

  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }

  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }

  function between(start, end) {
    var endIndex = keys.indexOf(end) + 1;

    if (endIndex === keys.length) {
      return up(start);
    }

    return "@media (min-width:".concat(values[start]).concat(unit, ") and ") + "(max-width:".concat(values[keys[endIndex]] - step / 100).concat(unit, ")");
  }

  function only(key) {
    return between(key, key);
  }

  function width(key) {
    return values[key];
  }

  return (0, _extends2.default)({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _createRule = __webpack_require__(186);

var _createRule2 = _interopRequireDefault(_createRule);

var _linkRule = __webpack_require__(373);

var _linkRule2 = _interopRequireDefault(_linkRule);

var _StyleRule = __webpack_require__(135);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _escape = __webpack_require__(723);

var _escape2 = _interopRequireDefault(_escape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Contains rules objects and allows adding/removing etc.
 * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
 */
var RuleList = function () {

  // Original styles object.
  function RuleList(options) {
    var _this = this;

    _classCallCheck(this, RuleList);

    this.map = {};
    this.raw = {};
    this.index = [];

    this.update = function (name, data) {
      var _options = _this.options,
          plugins = _options.jss.plugins,
          sheet = _options.sheet;

      if (typeof name === 'string') {
        plugins.onUpdate(data, _this.get(name), sheet);
      } else {
        for (var index = 0; index < _this.index.length; index++) {
          plugins.onUpdate(name, _this.index[index], sheet);
        }
      }
    };

    this.options = options;
    this.classes = options.classes;
  }

  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  // Used to ensure correct rules order.

  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.


  _createClass(RuleList, [{
    key: 'add',
    value: function add(name, decl, options) {
      var _options2 = this.options,
          parent = _options2.parent,
          sheet = _options2.sheet,
          jss = _options2.jss,
          Renderer = _options2.Renderer,
          generateClassName = _options2.generateClassName;


      options = _extends({
        classes: this.classes,
        parent: parent,
        sheet: sheet,
        jss: jss,
        Renderer: Renderer,
        generateClassName: generateClassName
      }, options);

      if (!options.selector && this.classes[name]) {
        options.selector = '.' + (0, _escape2['default'])(this.classes[name]);
      }

      this.raw[name] = decl;

      var rule = (0, _createRule2['default'])(name, decl, options);

      var className = void 0;

      if (!options.selector && rule instanceof _StyleRule2['default']) {
        className = generateClassName(rule, sheet);
        rule.selector = '.' + (0, _escape2['default'])(className);
      }

      this.register(rule, className);

      var index = options.index === undefined ? this.index.length : options.index;
      this.index.splice(index, 0, rule);

      return rule;
    }

    /**
     * Get a rule.
     */

  }, {
    key: 'get',
    value: function get(name) {
      return this.map[name];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'remove',
    value: function remove(rule) {
      this.unregister(rule);
      this.index.splice(this.indexOf(rule), 1);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.index.indexOf(rule);
    }

    /**
     * Run `onProcessRule()` plugins on every rule.
     */

  }, {
    key: 'process',
    value: function process() {
      var plugins = this.options.jss.plugins;
      // We need to clone array because if we modify the index somewhere else during a loop
      // we end up with very hard-to-track-down side effects.

      this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    }

    /**
     * Register a rule in `.map` and `.classes` maps.
     */

  }, {
    key: 'register',
    value: function register(rule, className) {
      this.map[rule.key] = rule;
      if (rule instanceof _StyleRule2['default']) {
        this.map[rule.selector] = rule;
        if (className) this.classes[rule.key] = className;
      }
    }

    /**
     * Unregister a rule.
     */

  }, {
    key: 'unregister',
    value: function unregister(rule) {
      delete this.map[rule.key];
      if (rule instanceof _StyleRule2['default']) {
        delete this.map[rule.selector];
        delete this.classes[rule.key];
      }
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'link',


    /**
     * Link renderable rules with CSSRuleList.
     */
    value: function link(cssRules) {
      var map = this.options.sheet.renderer.getUnescapedKeysMap(this.index);

      for (var i = 0; i < cssRules.length; i++) {
        var cssRule = cssRules[i];
        var _key = this.options.sheet.renderer.getKey(cssRule);
        if (map[_key]) _key = map[_key];
        var rule = this.map[_key];
        if (rule) (0, _linkRule2['default'])(rule, cssRule);
      }
    }

    /**
     * Convert rules to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      var str = '';
      var sheet = this.options.sheet;

      var link = sheet ? sheet.options.link : false;

      for (var index = 0; index < this.index.length; index++) {
        var rule = this.index[index];
        var css = rule.toString(options);

        // No need to render an empty rule.
        if (!css && !link) continue;

        if (str) str += '\n';
        str += css;
      }

      return str;
    }
  }]);

  return RuleList;
}();

exports['default'] = RuleList;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(754);

var iterableToArrayLimit = __webpack_require__(755);

var nonIterableRest = __webpack_require__(756);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(792);

/***/ }),
/* 155 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return showQuickMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__theme_uiConfig__ = __webpack_require__(69);
/**
 * Manages a queue of quick temporary notifications.
 * Each notification fades out before being removed from the queue.
 */var initialState={};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1?arguments[1]:undefined;var quickMessages=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(state);switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["_137" /* QUICK_MESSAGE_ENQUEUE */]:quickMessages[action.key]={message:action.message,created:action.created};return quickMessages;case __WEBPACK_IMPORTED_MODULE_1__actions__["_138" /* QUICK_MESSAGE_FADE */]:quickMessages[action.key].fading=true;return quickMessages;case __WEBPACK_IMPORTED_MODULE_1__actions__["_136" /* QUICK_MESSAGE_DEQUEUE */]:delete quickMessages[action.key];return quickMessages;default:return state;}});/**
 * Enqueues a new quick message and schedules its fading and dequeue.
 * @param {string} message
 */var showQuickMessage=function showQuickMessage(message){return function(dispatch){// creation date will be used to determine the display order, since we are storing in an object
var created=new Date().getTime();// it's important to create an unique key here, this will be used as React's key
var key=created.toString(36)+Math.random().toString(36).substr(2,5);dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actions__["_137" /* QUICK_MESSAGE_ENQUEUE */],message:message,created:created,key:key});setTimeout(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actions__["_138" /* QUICK_MESSAGE_FADE */],key:key});},__WEBPACK_IMPORTED_MODULE_2__theme_uiConfig__["d" /* quickMessageDuration */]-__WEBPACK_IMPORTED_MODULE_2__theme_uiConfig__["e" /* quickMessageFadeOutDuration */]);setTimeout(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__actions__["_136" /* QUICK_MESSAGE_DEQUEUE */],key:key});},__WEBPACK_IMPORTED_MODULE_2__theme_uiConfig__["d" /* quickMessageDuration */]);};};

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return updateEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return updateName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return updatePassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return resetPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkCredentials; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return connectUserSocketEventProviderChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return connectUserSocketEventLogout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return sendVerifyAccountEmail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_browser__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_modules_quickMessages__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__errors_errorhelper__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__errors_apperror__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__errors_httperror__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
var _this=this;var initialState={areCredentialsValid:null,checkCredentialsErrorid:null,accountEmailUpdateSuccess:null,accountEmailUpdateErrorId:null,accountNameUpdateSuccess:null,accountNameUpdateErrorId:null,accountPasswordUpdateSuccess:null,accountPasswordUpdateErrorId:null,accountPasswordResetSuccess:null,accountPasswordResetErrorId:null};/* harmony default export */ __webpack_exports__["d"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1?arguments[1]:undefined;switch(action.type){/* credentials check */case __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* ACCOUNT_CHECK_CREDENTIALS */]:return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{areCredentialsValid:null,checkCredentialsErrorid:null});case __WEBPACK_IMPORTED_MODULE_3__actions__["c" /* ACCOUNT_CHECK_CREDENTIALS_SUCCESS */]:{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{areCredentialsValid:true,checkCredentialsErrorid:null});}case __WEBPACK_IMPORTED_MODULE_3__actions__["b" /* ACCOUNT_CHECK_CREDENTIALS_FAIL */]:{return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{areCredentialsValid:false,checkCredentialsErrorid:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(action,'error.errorId')});}/* email update */case __WEBPACK_IMPORTED_MODULE_3__actions__["d" /* ACCOUNT_EMAIL_UPDATE */]:return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{accountEmailUpdateSuccess:null,accountEmailUpdateErrorId:null});case __WEBPACK_IMPORTED_MODULE_3__actions__["f" /* ACCOUNT_EMAIL_UPDATE_SUCCESS */]:return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{accountEmailUpdateSuccess:true,accountEmailUpdateErrorId:null});case __WEBPACK_IMPORTED_MODULE_3__actions__["e" /* ACCOUNT_EMAIL_UPDATE_FAIL */]:return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{accountEmailUpdateSuccess:false,accountEmailUpdateErrorId:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(action,'error.errorId')});/* name update */case __WEBPACK_IMPORTED_MODULE_3__actions__["g" /* ACCOUNT_NAME_UPDATE */]:return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{accountNameUpdateSuccess:null,accountNameUpdateErrorId:null});case __WEBPACK_IMPORTED_MODULE_3__actions__["i" /* ACCOUNT_NAME_UPDATE_SUCCESS */]:return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{accountNameUpdateSuccess:true,accountNameUpdateErrorId:null});case __WEBPACK_IMPORTED_MODULE_3__actions__["h" /* ACCOUNT_NAME_UPDATE_FAIL */]:return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{accountNameUpdateSuccess:false,accountNameUpdateErrorId:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(action,'error.errorId')});/* password update */case __WEBPACK_IMPORTED_MODULE_3__actions__["m" /* ACCOUNT_PASSWORD_UPDATE */]:return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{accountPasswordUpdateSuccess:null,accountPasswordUpdateErrorId:null});case __WEBPACK_IMPORTED_MODULE_3__actions__["o" /* ACCOUNT_PASSWORD_UPDATE_SUCCESS */]:return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{accountPasswordUpdateSuccess:true,accountPasswordUpdateErrorId:null});case __WEBPACK_IMPORTED_MODULE_3__actions__["n" /* ACCOUNT_PASSWORD_UPDATE_FAIL */]:return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{accountPasswordUpdateSuccess:false,accountPasswordUpdateErrorId:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(action,'error.errorId')});/* password reset */case __WEBPACK_IMPORTED_MODULE_3__actions__["j" /* ACCOUNT_PASSWORD_RESET */]:return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{accountPasswordResetSuccess:null,accountPasswordResetErrorId:null});case __WEBPACK_IMPORTED_MODULE_3__actions__["l" /* ACCOUNT_PASSWORD_RESET_SUCCESS */]:return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{accountPasswordResetSuccess:true,accountPasswordResetErrorId:null});case __WEBPACK_IMPORTED_MODULE_3__actions__["k" /* ACCOUNT_PASSWORD_RESET_FAIL */]:return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{accountPasswordResetSuccess:false,accountPasswordResetErrorId:__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(action,'error.errorId')});default:return state;}});var updateEmail=function updateEmail(currentEmail,currentPassword,newEmail){return function(dispatch){return dispatch({types:[__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* ACCOUNT_EMAIL_UPDATE */],__WEBPACK_IMPORTED_MODULE_3__actions__["f" /* ACCOUNT_EMAIL_UPDATE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_3__actions__["e" /* ACCOUNT_EMAIL_UPDATE_FAIL */]],promise:function promise(client){return client.patch(__WEBPACK_IMPORTED_MODULE_2__config__["h" /* AUTHENTICATION */].SIGN_UP_URL,{data:{'host':Object(__WEBPACK_IMPORTED_MODULE_1__utils_browser__["a" /* getHost */])(),'current-email':currentEmail,'current-password':currentPassword,'new-email':newEmail}})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_5__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_7__errors_apperror__["a" /* default */]({message:'user.updateEmail() failed',errorId:__WEBPACK_IMPORTED_MODULE_6__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_8__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_USER'}});throw nError;});}});};};var updateName=function updateName(currentEmail,currentPassword,firstName,lastName){return function(dispatch){return dispatch({types:[__WEBPACK_IMPORTED_MODULE_3__actions__["g" /* ACCOUNT_NAME_UPDATE */],__WEBPACK_IMPORTED_MODULE_3__actions__["i" /* ACCOUNT_NAME_UPDATE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_3__actions__["h" /* ACCOUNT_NAME_UPDATE_FAIL */]],promise:function promise(client){return client.patch(__WEBPACK_IMPORTED_MODULE_2__config__["h" /* AUTHENTICATION */].SIGN_UP_URL,{data:{'host':Object(__WEBPACK_IMPORTED_MODULE_1__utils_browser__["a" /* getHost */])(),'current-email':currentEmail,'current-password':currentPassword,'firstName':firstName,'lastName':lastName}}).then(function(){Object(__WEBPACK_IMPORTED_MODULE_4_redux_modules_quickMessages__["b" /* showQuickMessage */])('Name was successfully updated').call(_this,dispatch);})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_5__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_7__errors_apperror__["a" /* default */]({message:'user.updateName() failed',errorId:__WEBPACK_IMPORTED_MODULE_6__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_8__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_USER'}});throw nError;});}});};};var updatePassword=function updatePassword(currentEmail,currentPassword,newPassword,confirmNewPassword){return function(dispatch){return dispatch({types:[__WEBPACK_IMPORTED_MODULE_3__actions__["m" /* ACCOUNT_PASSWORD_UPDATE */],__WEBPACK_IMPORTED_MODULE_3__actions__["o" /* ACCOUNT_PASSWORD_UPDATE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_3__actions__["n" /* ACCOUNT_PASSWORD_UPDATE_FAIL */]],promise:function promise(client){return client.patch(__WEBPACK_IMPORTED_MODULE_2__config__["h" /* AUTHENTICATION */].SIGN_UP_URL,{data:{'host':Object(__WEBPACK_IMPORTED_MODULE_1__utils_browser__["a" /* getHost */])(),'current-email':currentEmail,'current-password':currentPassword,'new-password':newPassword,'confirm-password':confirmNewPassword}}).then(function(){Object(__WEBPACK_IMPORTED_MODULE_4_redux_modules_quickMessages__["b" /* showQuickMessage */])('Password was successfully updated').call(_this,dispatch);})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_5__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_7__errors_apperror__["a" /* default */]({message:'user.updatePassword() failed',errorId:__WEBPACK_IMPORTED_MODULE_6__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_8__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_USER'}});throw nError;});}});};};var resetPassword=function resetPassword(qs){return function(dispatch){return dispatch({types:[__WEBPACK_IMPORTED_MODULE_3__actions__["j" /* ACCOUNT_PASSWORD_RESET */],__WEBPACK_IMPORTED_MODULE_3__actions__["l" /* ACCOUNT_PASSWORD_RESET_SUCCESS */],__WEBPACK_IMPORTED_MODULE_3__actions__["k" /* ACCOUNT_PASSWORD_RESET_FAIL */]],promise:function promise(client){return client.get(__WEBPACK_IMPORTED_MODULE_2__config__["h" /* AUTHENTICATION */].RESET_PASSWORD_URL+qs,{data:{},headers:{'skip-recaptcha':true}})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_5__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_7__errors_apperror__["a" /* default */]({message:'user.resetPassword() failed',errorId:__WEBPACK_IMPORTED_MODULE_6__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_8__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_USER'}});throw nError;});}});};};var checkCredentials=function checkCredentials(currentEmail,currentPassword){return function(dispatch){return dispatch({types:[__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* ACCOUNT_CHECK_CREDENTIALS */],__WEBPACK_IMPORTED_MODULE_3__actions__["c" /* ACCOUNT_CHECK_CREDENTIALS_SUCCESS */],__WEBPACK_IMPORTED_MODULE_3__actions__["b" /* ACCOUNT_CHECK_CREDENTIALS_FAIL */]],promise:function promise(client){return client.post(__WEBPACK_IMPORTED_MODULE_2__config__["h" /* AUTHENTICATION */].SIGN_IN_URL,{data:{email:currentEmail,password:currentPassword},headers:{'skip-recaptcha':true}})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_5__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_7__errors_apperror__["a" /* default */]({message:'user.checkCredentials() failed',errorId:__WEBPACK_IMPORTED_MODULE_6__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_8__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_USER'}});throw nError;});}});};};// SOCKET EVENTS
var connectUserSocketEventProviderChange=function connectUserSocketEventProviderChange(){return function(dispatch,getState){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__actions__["_159" /* SOCKET_SUBSCRIBE */],// Event happens when password, name, email are updated
event:'user:change:providers',callback:function callback(payload){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__actions__["_189" /* USER_UPDATE_SUCCESS */],payload:{firstName:payload.firstName,lastName:payload.lastName,name:payload.name,hasPassword:payload.hasPassword}});}});};};var connectUserSocketEventLogout=function connectUserSocketEventLogout(){return function(dispatch,getState){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__actions__["_159" /* SOCKET_SUBSCRIBE */],event:'user:logout',callback:function callback(){window.location.href=__WEBPACK_IMPORTED_MODULE_2__config__["_65" /* XC_URL */];}});};};var sendVerifyAccountEmail=function sendVerifyAccountEmail(email){return{types:[__WEBPACK_IMPORTED_MODULE_3__actions__["_193" /* VERIFY_ACCOUNT_RESEND_FETCH */],__WEBPACK_IMPORTED_MODULE_3__actions__["_195" /* VERIFY_ACCOUNT_RESEND_FETCH_SUCCESS */],__WEBPACK_IMPORTED_MODULE_3__actions__["_194" /* VERIFY_ACCOUNT_RESEND_FETCH_FAIL */]],promise:function promise(client){return client.post('/xara-basic/confirmation/resend',{data:{email:email,host:__WEBPACK_IMPORTED_MODULE_2__config__["_65" /* XC_URL */]}})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_5__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_7__errors_apperror__["a" /* default */]({message:'companies.sendVerifyAccountEmail() failed',errorId:__WEBPACK_IMPORTED_MODULE_6__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_8__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_COMPANIES'}});throw nError;});}};};

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return updateUsage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return checkCrsCredentials; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return saveTakeOverCredentials; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearCrsCredentials; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeMagixDiscountProdType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__errors_errorhelper__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__errors_apperror__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__errors_httperror__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__logger_logger__ = __webpack_require__(40);
var log=__WEBPACK_IMPORTED_MODULE_10__logger_logger__["a" /* default */].get('crs');var initialState={areCredentialsValid:null,checkCredentialsErrorid:null,checkCredentialsErrorMessage:null,checkCredentialsInvalidReason:null,crsUsageUpdateSuccess:null,crsUsageUpdateErrorId:null,prodCatOfLastValidCombination:null,tierOfLastValidCombination:null,isFallbackProductReturnedLastValidCombination:null,takeoverMagixEmail:null,takeoverProductSerial:null,prodTypeOfLastValidCombination:null,crsResponseCache:null};function getCredentialsState(state,result,payload){if(payload.magixDiscountProdType===__WEBPACK_IMPORTED_MODULE_3__config__["Y" /* MAXIC_DISCOUNT_PROD_TYPE */].PERPETUAL){return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({},state,{areCredentialsValid:result.valid,checkCredentialsErrorid:!result.valid&&__WEBPACK_IMPORTED_MODULE_6__errors_errorids__["a" /* default */].CRS_INVALID_CREDENTIALS,checkCredentialsErrorMessage:!result.valid&&result.message,checkCredentialsInvalidReason:!result.valid&&result.reason},result.valid&&{tierOfLastValidCombination:result.tier},result.valid&&{isFallbackProductReturnedLastValidCombination:result.fb},result.valid&&{prodCatOfLastValidCombination:result.prod_cat},result.valid&&{prodTypeOfLastValidCombination:payload.magixDiscountProdType},result.valid&&{crsResponseCache:result});}else{var isUsedForSubscription=result.used_for_sub;return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({},state,{areCredentialsValid:result.valid&&!isUsedForSubscription,checkCredentialsErrorid:(!result.valid||isUsedForSubscription)&&(isUsedForSubscription?__WEBPACK_IMPORTED_MODULE_6__errors_errorids__["a" /* default */].CRS_CREDENTIALS_ALREADY_USED:__WEBPACK_IMPORTED_MODULE_6__errors_errorids__["a" /* default */].CRS_INVALID_CREDENTIALS),checkCredentialsErrorMessage:(!result.valid||isUsedForSubscription)&&result.message,checkCredentialsInvalidReason:(!result.valid||isUsedForSubscription)&&result.reason},result.valid&&!isUsedForSubscription&&{tierOfLastValidCombination:result.tier},result.valid&&!isUsedForSubscription&&{isFallbackProductReturnedLastValidCombination:result.fb},result.valid&&!isUsedForSubscription&&{prodCatOfLastValidCombination:result.prod_cat},result.valid&&!isUsedForSubscription&&{prodTypeOfLastValidCombination:payload.magixDiscountProdType},result.valid&&{crsResponseCache:result});}}/* harmony default export */ __webpack_exports__["d"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1?arguments[1]:undefined;switch(action.type){/* credentials check */case __WEBPACK_IMPORTED_MODULE_4__actions__["_60" /* CRS_CHECK_CREDENTIALS */]:return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({},state,{areCredentialsValid:null,checkCredentialsErrorid:null,checkCredentialsErrorMessage:null,checkCredentialsInvalidReason:null});case __WEBPACK_IMPORTED_MODULE_4__actions__["_62" /* CRS_CHECK_CREDENTIALS_SUCCESS */]:{return getCredentialsState(state,action.result,action.payload);}case __WEBPACK_IMPORTED_MODULE_4__actions__["_61" /* CRS_CHECK_CREDENTIALS_FAIL */]:{var messageFromMw;var firstMessageId;if(action.error&&action.error instanceof __WEBPACK_IMPORTED_MODULE_7__errors_apperror__["a" /* default */]){// Extract message from MW response
var firstMessage=action.error.getMesageFromHistoryAtIndex(0);if(firstMessage){messageFromMw=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(firstMessage,'responseText.message')||__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(firstMessage,'responseText');firstMessageId=firstMessage.errorId;}}return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({},state,{areCredentialsValid:false,checkCredentialsErrorid:firstMessageId||__WEBPACK_IMPORTED_MODULE_6__errors_errorids__["a" /* default */].CRS_INFO_REQUEST_FAILED,checkCredentialsErrorMessage:messageFromMw,checkCredentialsInvalidReason:null});}/* save takeover credentials */case __WEBPACK_IMPORTED_MODULE_4__actions__["_64" /* CRS_SAVE_TAKEOVER_CREDENTIALS */]:return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({},state,{takeoverMagixEmail:action.payload.magixEmail,takeoverProductSerial:action.payload.productSerial});/* clear credentials */case __WEBPACK_IMPORTED_MODULE_4__actions__["_63" /* CRS_CLEAR_CREDENTIALS */]:return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({},initialState);/* change product type*/case __WEBPACK_IMPORTED_MODULE_4__actions__["_54" /* COUPON_CHANGE_MAGIX_DISCOUNT_PRODUCT_TYPE */]:{if(state.prodTypeOfLastValidCombination&&state.prodTypeOfLastValidCombination!==action.payload.magixDiscountProdType){var newState=getCredentialsState(state,state.crsResponseCache,action.payload);return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({},newState,{prodTypeOfLastValidCombination:action.payload.magixDiscountProdType});}else{return state;}}default:return state;}});var updateUsage=function updateUsage(magixEmail,productSerial,currentUserEmail,magixDiscountProdType){return function(dispatch){return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_65" /* CRS_USAGE_UPDATE */],__WEBPACK_IMPORTED_MODULE_4__actions__["_67" /* CRS_USAGE_UPDATE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_66" /* CRS_USAGE_UPDATE_FAIL */]],promise:function promise(client){return client.post(__WEBPACK_IMPORTED_MODULE_3__config__["w" /* CRS */].USAGE_URL,{email:magixEmail,serial:productSerial,used_by_email:currentUserEmail,used_for_order_type:magixDiscountProdType,action:'save'})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_5__errors_errorhelper__["a" /* extractPropsforAxiosHttpError */])(error);// don't show error msg to user here as user won't be redoing purchase
log.send(new __WEBPACK_IMPORTED_MODULE_7__errors_apperror__["a" /* default */]({message:'Crs.updateUsage() failed',errorId:__WEBPACK_IMPORTED_MODULE_6__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_8__errors_httperror__["a" /* default */](httpErrorProps),errorDetails:{email:window.btoa(magixEmail),serial:window.btoa(productSerial),used_by_email:currentUserEmail},visualisers:{feature:'CRS'}}));});}});};};var checkCrsCredentials=function checkCrsCredentials(magixEmail,productSerial,currentUserEmail,magixDiscountProdType){return function(dispatch){return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_60" /* CRS_CHECK_CREDENTIALS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_62" /* CRS_CHECK_CREDENTIALS_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_61" /* CRS_CHECK_CREDENTIALS_FAIL */]],payload:{magixDiscountProdType:magixDiscountProdType},promise:function promise(client){return client.post(__WEBPACK_IMPORTED_MODULE_3__config__["w" /* CRS */].INFO_URL,{email:magixEmail,session_email:currentUserEmail,serial:productSerial,action:'get','usage':true}).then(function(response){return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({},response.data,{magixEmail:magixEmail,productSerial:productSerial});})["catch"](/*#__PURE__*/function(){var _ref=__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.mark(function _callee(error){var httpErrorProps,nError;return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_5__errors_errorhelper__["a" /* extractPropsforAxiosHttpError */])(error);nError=new __WEBPACK_IMPORTED_MODULE_7__errors_apperror__["a" /* default */]({message:'user.checkCrsCredentials() failed',errorId:__WEBPACK_IMPORTED_MODULE_6__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_8__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'CRS'}});throw nError;case 3:case"end":return _context.stop();}}},_callee);}));return function(_x){return _ref.apply(this,arguments);};}());}});};};var saveTakeOverCredentials=function saveTakeOverCredentials(magixEmail,productSerial){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__actions__["_64" /* CRS_SAVE_TAKEOVER_CREDENTIALS */],payload:{magixEmail:magixEmail,productSerial:productSerial}});};};var clearCrsCredentials=function clearCrsCredentials(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__actions__["_63" /* CRS_CLEAR_CREDENTIALS */]});};};var changeMagixDiscountProdType=function changeMagixDiscountProdType(magixDiscountProdType,prodCatOfLastValidCombination,tierOfLastValidCombination,areCredentialsValid){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__actions__["_54" /* COUPON_CHANGE_MAGIX_DISCOUNT_PRODUCT_TYPE */],payload:{magixDiscountProdType:magixDiscountProdType,prodCatOfLastValidCombination:prodCatOfLastValidCombination,tierOfLastValidCombination:tierOfLastValidCombination,areCredentialsValid:areCredentialsValid}});};};

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return showChargebeeLoader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hideChargebeeLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(45);
var initialState={loading:false};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1?arguments[1]:undefined;switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["_156" /* SHOW_CB_LOADER */]:return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{loading:true});case __WEBPACK_IMPORTED_MODULE_1__actions__["_33" /* COMPANIES_UPDATE_FAIL */]:case __WEBPACK_IMPORTED_MODULE_1__actions__["_34" /* COMPANIES_UPDATE_SUCCESS */]:case __WEBPACK_IMPORTED_MODULE_1__actions__["_90" /* HIDE_CB_LOADER */]:return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{loading:false});default:return state;}});var showChargebeeLoader=function showChargebeeLoader(){return{type:__WEBPACK_IMPORTED_MODULE_1__actions__["_156" /* SHOW_CB_LOADER */]};};var hideChargebeeLoader=function hideChargebeeLoader(){return{type:__WEBPACK_IMPORTED_MODULE_1__actions__["_90" /* HIDE_CB_LOADER */]};};

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _InputBase.default;
  }
});

var _InputBase = _interopRequireDefault(__webpack_require__(913));

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormHelperText.default;
  }
});

var _FormHelperText = _interopRequireDefault(__webpack_require__(921));

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = assertString;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function assertString(input) {
  var isString = typeof input === 'string' || input instanceof String;

  if (!isString) {
    var invalidType;

    if (input === null) {
      invalidType = 'null';
    } else {
      invalidType = _typeof(input);

      if (invalidType === 'object' && input.constructor && input.constructor.hasOwnProperty('name')) {
        invalidType = input.constructor.name;
      } else {
        invalidType = "a ".concat(invalidType);
      }
    }

    throw new TypeError("Expected string but received ".concat(invalidType, "."));
  }
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

/**
 * @ignore - internal component.
 */
var Tablelvl2Context = _react.default.createContext();

var _default = Tablelvl2Context;
exports.default = _default;

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return focusSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getMlsFormProps; });
var focusSelect=function focusSelect(inputCurrent){inputCurrent.focus();setTimeout(function(){inputCurrent.select();});};var getMlsFormProps=function getMlsFormProps(theme){return{/* dialog content */dialogContent:{overflow:'visible'},dialogTitle:{'& h6':{fontWeight:600,fontSize:'28px',lineHeight:1.4,marginBottom:10,textAlign:'left',display:'flex',alignItems:'center'}},headerIcon:{marginRight:10},headerIconInfo:{color:'#6F99BD'},/* close dialog */closeDialog:{position:'absolute',top:10,right:10},closeDialogIcon:{color:'#6F99BD',width:'20px',height:'20px'},/* input field */field:{width:'100%',margin:0,'& input, & textarea':{border:'1px solid #aabfd1',borderStyle:'solid',borderRadius:5,color:theme.palette.text.primary,padding:'10px','&:focus, &:hover':{color:'#2888c3',borderColor:'#2888c3'},'&::placeholder':{fontFamily:'Open Sans, sans-serif',fontWeight:'normal',fontStyle:'normal',fontSize:'14px',lineHeight:'19px',color:theme.palette.text.primary}},'& textarea':{width:'425px',display:'block'},'& [id*=helper-text]':{paddingLeft:0,color:theme.palette.error.main},'& [class*=error] input':{borderColor:"".concat(theme.palette.error.main," !important")}},/* radio button */radioGroupLabel:{margin:'8px 0 2px'},radioGroupContainer:{marginBottom:16},radioSelectorLabel:{'& span':{opacity:1,fontSize:16,lineHeight:1}},radioSelectorLabelChecked:{'& span':{color:'#2fa5e7',fontSize:16,lineHeight:1,'&[class*=MuiFormControlLabel-label]':{color:'#000'}}},radioSelectorLabelHover:{'&:hover span':{color:'#2888c3 !important'}},radioButton:{root:{'&$checked':{color:'#2FA5E7'}},checked:{}},/* text field */textFieldWrapper:{width:'100%',paddingBottom:12},textFieldWrapperError:{'& input':{borderColor:"".concat(theme.palette.error.main," !important")}},formFieldLabel:{display:'block',textAlign:'left',color:theme.palette.text.primary,opacity:1,margin:'0 0 10px'},/* submit button */buttonsContainer:{paddingBottom:10,'& button:not(:first-child)':{marginLeft:8}},button:{fontFamily:'Open Sans, sans-serif',borderRadius:5,fontWeight:600,fontSize:18,lineHeight:1.3,opacity:'1 !important'},buttonPrimary:{background:theme.palette.primary.main,color:'white',textShadow:'none',paddingLeft:10,paddingRight:15,'&[class*=contained][class*=disabled]':{backgroundColor:'#f4f4f4',color:'#4a5660'}},/* links */linksContainer:{textAlign:'left',padding:'30px 0 0'},link:{'&:first-child':{marginBottom:18}},/* error message */error:{color:"".concat(theme.palette.error.main," !important"),paddingLeft:'0  !important'},errorMessage:{color:theme.palette.error.main,fontSize:14,lineHeight:1.5,opacity:1,textAlign:'left',marginTop:-15,marginBottom:15,'& a':{color:theme.palette.primary.main}},/* loading */loadingContent:{position:'absolute',top:'50%',left:'50%',transform:'translate(-50%, -50%)'},loadingMessage:{fontSize:16,lineHeight:1.5,opacity:1},loadingIcon:{display:'block',height:'24px',width:'24px',margin:'0 auto 10px',fill:'#96DCFD',animation:'spin 2s linear infinite'},'@keyframes spin':{'0':{transform:'rotate(0deg)'},'100%':{transform:'rotate(360deg)'}},/* form message */formMessage:{textAlign:'left','& p:not(:last-child)':{marginBottom:20},'& p':{fontSize:'16px',lineHeight:'22px',opacity:1}},feedbackMessage:{textAlign:'left','& p:not(:last-child)':{marginBottom:20},'& p':{fontSize:'16px',lineHeight:'22px',opacity:1}},/* misc */noMargins:{margin:0}};};

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return openIntercomChat; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__errors_apperror__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger_logger__ = __webpack_require__(40);
/**
 * Asks intercom API to show the Messenger.
 * https://developers.intercom.com/installing-intercom/docs/intercom-javascript#section-intercomshow
 * @param {String} [message] when provided opens Intercom Messenger pre-populated
 * with this message.
 */var log=__WEBPACK_IMPORTED_MODULE_2__logger_logger__["a" /* default */].get('intercom');var openIntercomChat=function openIntercomChat(message,showMessageTab,errorCallback){if(!window.Intercom){errorCallback(__WEBPACK_IMPORTED_MODULE_0_errors_errorids__["a" /* default */].SEGMENT_NOT_LOADED);var nError=new __WEBPACK_IMPORTED_MODULE_1__errors_apperror__["a" /* default */]({message:'openIntercomChat failed',errorId:__WEBPACK_IMPORTED_MODULE_0_errors_errorids__["a" /* default */].UNKNOWN,visualisers:{feature:'INTERCOM'}});log.send(nError);return;}if(message||showMessageTab){window.Intercom('showNewMessage',message||'');}else{window.Intercom('show');}};

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_serialize__ = __webpack_require__(302);


function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__emotion_serialize__["a" /* serializeStyles */])(args);
}

/* harmony default export */ __webpack_exports__["a"] = (css);


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(41);
var global = __webpack_require__(30);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(109) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(60);
var toLength = __webpack_require__(37);
var toAbsoluteIndex = __webpack_require__(111);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 169 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(85);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(35)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(32);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(144);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(325);
var redefine = __webpack_require__(55);
var hide = __webpack_require__(59);
var fails = __webpack_require__(31);
var defined = __webpack_require__(86);
var wks = __webpack_require__(35);
var regexpExec = __webpack_require__(238);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(75);
var call = __webpack_require__(320);
var isArrayIter = __webpack_require__(233);
var anObject = __webpack_require__(32);
var toLength = __webpack_require__(37);
var getIterFn = __webpack_require__(235);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(30);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(30);
var $export = __webpack_require__(12);
var redefine = __webpack_require__(55);
var redefineAll = __webpack_require__(132);
var meta = __webpack_require__(101);
var forOf = __webpack_require__(175);
var anInstance = __webpack_require__(131);
var isObject = __webpack_require__(33);
var fails = __webpack_require__(31);
var $iterDetect = __webpack_require__(171);
var setToStringTag = __webpack_require__(127);
var inheritIfRequired = __webpack_require__(224);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(30);
var hide = __webpack_require__(59);
var uid = __webpack_require__(108);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: '/',
      url: '/',
      params: {},
      isExact: pathname === '/'
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, 'A <Router> may have only one child element');

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, 'You cannot change <Router history>');
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(149);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["default"])(a.state, b.state);
};

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = '' + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options === 'string') options = { path: options };

  var _options = options,
      _options$path = _options.path,
      path = _options$path === undefined ? '/' : _options$path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.deepmerge = factory());
}(this, (function () { 'use strict';

var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

return deepmerge_1;

})));


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCssValue;
var join = function join(value, by) {
  var result = '';
  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }
  return result;
};

/**
 * Converts array values to string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */
function toCssValue(value) {
  var ignoreImportant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!Array.isArray(value)) return value;

  var cssValue = '';

  // Support space separated values via `[['5px', '10px']]`.
  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', ');

  // Add !important, because it was ignored.
  if (!ignoreImportant && value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
}

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = createRule;

var _warning = __webpack_require__(134);

var _warning2 = _interopRequireDefault(_warning);

var _StyleRule = __webpack_require__(135);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _cloneStyle = __webpack_require__(722);

var _cloneStyle2 = _interopRequireDefault(_cloneStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Create a rule instance.
 */
function createRule() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unnamed';
  var decl = arguments[1];
  var options = arguments[2];
  var jss = options.jss;

  var declCopy = (0, _cloneStyle2['default'])(decl);

  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule;

  // It is an at-rule and it has no instance.
  if (name[0] === '@') {
    (0, _warning2['default'])(false, '[JSS] Unknown at-rule %s', name);
  }

  return new _StyleRule2['default'](name, declCopy, options);
}

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBrowser", function() { return isBrowser; });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

/* harmony default export */ __webpack_exports__["default"] = (isBrowser);


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__(361);
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
    if (ReactIs.isMemo(component)) {
        return MEMO_STATICS;
    }
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_wrapNativeSuper__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_wrapNativeSuper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_wrapNativeSuper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
var MESSAGE_CHARACTER_LIMIT=200;var BaseError=/*#__PURE__*/function(_Error){__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(BaseError,_Error);function BaseError(_ref){var _this;var message=_ref.message,errorId=_ref.errorId,_ref$name=_ref.name,name=_ref$name===void 0?'BaseError':_ref$name,_ref$tag=_ref.tag,tag=_ref$tag===void 0?'':_ref$tag,errorDetails=_ref.errorDetails,details=_ref.details,visualisers=_ref.visualisers,messageType=_ref.messageType,_ref$keepOriginalErro=_ref.keepOriginalError,keepOriginalError=_ref$keepOriginalErro===void 0?false:_ref$keepOriginalErro;__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this,BaseError);_this=__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(BaseError).call(this,message===null||message===void 0?void 0:message.substring(0,MESSAGE_CHARACTER_LIMIT)));// Adjust prototype chain:
// github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this),"errorId",void 0);__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this),"visualisers",void 0);__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this),"tag",void 0);__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this),"errorDetails",void 0);__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this),"details",void 0);__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this),"messageType",void 0);__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this),"originalErrors",void 0);__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this),"keepOriginalError",void 0);Object.setPrototypeOf(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this),BaseError.prototype);if('captureStackTrace'in Error){Error.captureStackTrace(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this),_this.constructor);}_this.name=name;_this.errorId=errorId;_this.tag=tag;_this.visualisers=visualisers;_this.messageType=messageType;_this.keepOriginalError=keepOriginalError;if(errorDetails){_this.errorDetails=errorDetails;}if(details){_this.details=details;}return _this;}__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(BaseError,[{key:"processOriginalError",value:function processOriginalError(originalError){var _this2=this;// Push originalError to array of all past errors
var sourceObject=originalError instanceof ErrorEvent?originalError.error:originalError;var previousErrors=__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(sourceObject,'originalErrors');this.originalErrors=[];if(!__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.isEmpty(previousErrors)){var _sourceObject$origina;previousErrors.forEach(function(err){_this2.originalErrors.push(err);});if(sourceObject instanceof BaseError&&sourceObject!==null&&sourceObject!==void 0&&(_sourceObject$origina=sourceObject.originalErrors)!==null&&_sourceObject$origina!==void 0&&_sourceObject$origina.length){if(!this.keepOriginalError){sourceObject.originalErrors=[];}}}var itemToSave;if(typeof sourceObject==='string'){itemToSave=sourceObject===null||sourceObject===void 0?void 0:sourceObject.substring(0,MESSAGE_CHARACTER_LIMIT);}else if(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.get(sourceObject,'message')){if((sourceObject===null||sourceObject===void 0?void 0:sourceObject.message.length)>MESSAGE_CHARACTER_LIMIT){var descriptor=Object.getOwnPropertyDescriptor(sourceObject,'message');if(descriptor&&descriptor.writable){var _sourceObject$message;sourceObject.message=sourceObject===null||sourceObject===void 0?void 0:(_sourceObject$message=sourceObject.message)===null||_sourceObject$message===void 0?void 0:_sourceObject$message.substring(0,MESSAGE_CHARACTER_LIMIT);}}itemToSave=sourceObject;}else{itemToSave=sourceObject;}this.originalErrors.push(itemToSave);}},{key:"getPropertiesToLogAsJson",value:function getPropertiesToLogAsJson(){var results=__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},this.errorDetails);return!__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.isEmpty(results)?results:null;}},{key:"getPropertiesToLog",value:function getPropertiesToLog(){var results=__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},this.details);return!__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.isEmpty(results)?results:null;}},{key:"getErrorHistoryToLog",value:function getErrorHistoryToLog(){var _this$originalErrors,_this3=this;var result;if((_this$originalErrors=this.originalErrors)!==null&&_this$originalErrors!==void 0&&_this$originalErrors.length){result=this.originalErrors.map(function(error,i){try{return JSON.stringify(error,_this3.extractProperties,2);}catch(e){return"JSON.stringify could not serialize object: ".concat(e.message);}});}return result;}},{key:"getMesageFromHistoryAtIndex",value:function getMesageFromHistoryAtIndex(index){var _this$originalErrors2;var result;if((_this$originalErrors2=this.originalErrors)!==null&&_this$originalErrors2!==void 0&&_this$originalErrors2.length){var selectItemAtIndex=index>=0?index:this.originalErrors.length+index;var selectedMessage=this.originalErrors[selectItemAtIndex];result=selectedMessage;}return result;}},{key:"extractProperties",value:function extractProperties(key,errorItem){if(errorItem instanceof Error||errorItem instanceof Event||errorItem instanceof ErrorEvent){var startObject={};if(errorItem instanceof Error){startObject.stack=errorItem.stack;startObject.name=errorItem.name;startObject.message=errorItem.message;}var newValue=Object.getOwnPropertyNames(errorItem).reduce(function(obj,propName){// Remove originalErrors property kept by using 'keepOriginalError' flag
if(propName==='originalErrors'||propName==='keepOriginalError'){return obj;}obj[propName]=errorItem[propName];return obj;},startObject);return newValue;}else{return errorItem;}}},{key:"errorid",get:function get(){// backward compatibility as util was using lowercase errorid
return this.errorId;}}]);return BaseError;}(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_wrapNativeSuper___default()(Error));/* harmony default export */ __webpack_exports__["a"] = (BaseError);

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uuid__ = __webpack_require__(788);
// Look in local storage to see if a client wants to preserve its id
var clientId=window.localStorage.getItem('xc-next-clientid-cap');// None in local storage so just generate a new one
!clientId&&(clientId=__WEBPACK_IMPORTED_MODULE_0__uuid__["a" /* default */]);// We always remove the stored id here so there is no chance of two instances using it
window.localStorage.removeItem('xc-next-clientid-cap');/* harmony default export */ __webpack_exports__["a"] = (clientId);

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(815);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  '#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC',
  '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF',
  '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC',
  '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF',
  '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC',
  '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033',
  '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366',
  '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933',
  '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC',
  '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF',
  '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // Internet Explorer and Edge do not support colors.
  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
    return false;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_PHOTOL_DISCOUNT":"0.2","REACT_APP_HTTP_STATIC_RESOURCES_URL":"https://prod-mw.xara.com/static","REACT_APP_UPGRADE_POPUP_DISCOUNT":"0.2","REACT_APP_SOCKET_URL":"https://prod-mw.xara.com:443","REACT_APP_HTTP_MLS_API_URL":"https://prod-mw.xara.com/3","REACT_APP_DESIGNERL_DISCOUNT":"0.4","REACT_APP_TIER1_DISCOUNT":"0.4","REACT_APP_TIER2_DISCOUNT":"0.5","REACT_APP_TIER3_DISCOUNT":"0.50","REACT_APP_SUBSCRIPTION_ACTIVE_OFFERS_URL":"https://www.xara.com/welcome/","REACT_APP_REVIEW_MLS_API_ENDPOINT":"https://www.xara.com/review-mls-request/","REACT_APP_LOGGER_ENDPOINT":"https://logs.xara.com:5005","REACT_APP_BUILD_NUMBER":"240","REACT_APP_CONTACT_SALES_API_ENDPOINT":"https://www.xara.com/contact-sales-request/","REACT_APP_PHOTOL_ACTIVE_OFFERS_URL":"https://www.xara.com/photo-graphic/v20/","REACT_APP_CRS_USAGE_URL":"https://crs-web.xara.com/usage","REACT_APP_SEGMENT":"true","REACT_APP_WEBL_COUPON_SET_ID":"30_V20","REACT_APP_XC_URL":"https://cloud.xara.com/","REACT_APP_UPGRADE_POPUP_SET_ID":"BOOST_MY_ROI","REACT_APP_DESIGNERL_ACTIVE_OFFERS_URL":"https://www.xara.com/designerpro/v20/","REACT_APP_INTERCOM_WORKSPACE_ID":"w83u8qa8","REACT_APP_CRS_INFO_URL":"https://crs-web.xara.com/crsinfo","REACT_APP_SEND_CURRENT_OFFERS_URL":"https://marketing-web.xara.com/coupons/sendactivecoupons","REACT_APP_WEBL_DISCOUNT":"0.3","REACT_APP_HTTP_API_URL":"https://prod-mw.xara.com/2","REACT_APP_SEGMENT_TOKEN":"rPbjGNElCaBDQdLTczi3f8YdshyWxtsF","REACT_APP_CONNECT_MLS_API_ENDPOINT":"https://www.xara.com/activate-playbooks-request/","REACT_APP_PERPETUAL_FALLBACK_COUPON_ID":"30OFF_PER","REACT_APP_PHOTOL_COUPON_SET_ID":"20_V20","REACT_APP_BRANCH":"v0.241.0","REACT_APP_BUILD_VCS_NUMBER":"=8549e3d7c1ce041fd223f917537f60b6528fb472","REACT_APP_HOTJAR_SITE_ID":"1270301","REACT_APP_TIER1_COUPON_SET_ID":"40_OFFER","REACT_APP_DESIGNERL_COUPON_SET_ID":"30_DPV20","REACT_APP_TIER2_COUPON_SET_ID":"50_OFFER","REACT_APP_CHARGEBEE_SITE_URL":"xara","REACT_APP_WEBL_ACTIVE_OFFERS_URL":"https://www.xara.com/webdesigner/v20/","REACT_APP_TIER3_COUPON_SET_ID":"50_OFFER","REACT_APP_CONTACT_SALES_CALENDLY_LINK":"https://meet.brevo.com/xara-group-ltd/xara-for-enterprise","REACT_APP_SUBSCRIPTION_FALLBACK_COUPON_ID":"30RENEW","REACT_APP_API_STATUS_URL":"status.xara.com/api/v1/components/","REACT_APP_CHARGEBEE_ENABLE_GA_TRACKING":"true","REACT_APP_CHARGEBEE_ENABLE_REFERSION_TRACKING":"true","REACT_APP_LOGGER_SEND_FROM_DEV":"true"}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(155)))

/***/ }),
/* 192 */
/***/ (function(module, exports) {

/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */

exports.encode = function (obj) {
  var str = '';

  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      if (str.length) str += '&';
      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
  }

  return str;
};

/**
 * Parses a simple querystring into an object
 *
 * @param {String} qs
 * @api private
 */

exports.decode = function(qs){
  var qry = {};
  var pairs = qs.split('&');
  for (var i = 0, l = pairs.length; i < l; i++) {
    var pair = pairs[i].split('=');
    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }
  return qry;
};


/***/ }),
/* 193 */
/***/ (function(module, exports) {


module.exports = function(a, b){
  var fn = function(){};
  fn.prototype = b.prototype;
  a.prototype = new fn;
  a.prototype.constructor = a;
};

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(833);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  '#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC',
  '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF',
  '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC',
  '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF',
  '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC',
  '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033',
  '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366',
  '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933',
  '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC',
  '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF',
  '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // Internet Explorer and Edge do not support colors.
  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
    return false;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_PHOTOL_DISCOUNT":"0.2","REACT_APP_HTTP_STATIC_RESOURCES_URL":"https://prod-mw.xara.com/static","REACT_APP_UPGRADE_POPUP_DISCOUNT":"0.2","REACT_APP_SOCKET_URL":"https://prod-mw.xara.com:443","REACT_APP_HTTP_MLS_API_URL":"https://prod-mw.xara.com/3","REACT_APP_DESIGNERL_DISCOUNT":"0.4","REACT_APP_TIER1_DISCOUNT":"0.4","REACT_APP_TIER2_DISCOUNT":"0.5","REACT_APP_TIER3_DISCOUNT":"0.50","REACT_APP_SUBSCRIPTION_ACTIVE_OFFERS_URL":"https://www.xara.com/welcome/","REACT_APP_REVIEW_MLS_API_ENDPOINT":"https://www.xara.com/review-mls-request/","REACT_APP_LOGGER_ENDPOINT":"https://logs.xara.com:5005","REACT_APP_BUILD_NUMBER":"240","REACT_APP_CONTACT_SALES_API_ENDPOINT":"https://www.xara.com/contact-sales-request/","REACT_APP_PHOTOL_ACTIVE_OFFERS_URL":"https://www.xara.com/photo-graphic/v20/","REACT_APP_CRS_USAGE_URL":"https://crs-web.xara.com/usage","REACT_APP_SEGMENT":"true","REACT_APP_WEBL_COUPON_SET_ID":"30_V20","REACT_APP_XC_URL":"https://cloud.xara.com/","REACT_APP_UPGRADE_POPUP_SET_ID":"BOOST_MY_ROI","REACT_APP_DESIGNERL_ACTIVE_OFFERS_URL":"https://www.xara.com/designerpro/v20/","REACT_APP_INTERCOM_WORKSPACE_ID":"w83u8qa8","REACT_APP_CRS_INFO_URL":"https://crs-web.xara.com/crsinfo","REACT_APP_SEND_CURRENT_OFFERS_URL":"https://marketing-web.xara.com/coupons/sendactivecoupons","REACT_APP_WEBL_DISCOUNT":"0.3","REACT_APP_HTTP_API_URL":"https://prod-mw.xara.com/2","REACT_APP_SEGMENT_TOKEN":"rPbjGNElCaBDQdLTczi3f8YdshyWxtsF","REACT_APP_CONNECT_MLS_API_ENDPOINT":"https://www.xara.com/activate-playbooks-request/","REACT_APP_PERPETUAL_FALLBACK_COUPON_ID":"30OFF_PER","REACT_APP_PHOTOL_COUPON_SET_ID":"20_V20","REACT_APP_BRANCH":"v0.241.0","REACT_APP_BUILD_VCS_NUMBER":"=8549e3d7c1ce041fd223f917537f60b6528fb472","REACT_APP_HOTJAR_SITE_ID":"1270301","REACT_APP_TIER1_COUPON_SET_ID":"40_OFFER","REACT_APP_DESIGNERL_COUPON_SET_ID":"30_DPV20","REACT_APP_TIER2_COUPON_SET_ID":"50_OFFER","REACT_APP_CHARGEBEE_SITE_URL":"xara","REACT_APP_WEBL_ACTIVE_OFFERS_URL":"https://www.xara.com/webdesigner/v20/","REACT_APP_TIER3_COUPON_SET_ID":"50_OFFER","REACT_APP_CONTACT_SALES_CALENDLY_LINK":"https://meet.brevo.com/xara-group-ltd/xara-for-enterprise","REACT_APP_SUBSCRIPTION_FALLBACK_COUPON_ID":"30RENEW","REACT_APP_API_STATUS_URL":"status.xara.com/api/v1/components/","REACT_APP_CHARGEBEE_ENABLE_GA_TRACKING":"true","REACT_APP_CHARGEBEE_ENABLE_REFERSION_TRACKING":"true","REACT_APP_LOGGER_SEND_FROM_DEV":"true"}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(155)))

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return makeQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getHost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isChrome; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(17);
var makeQuery=function makeQuery(param){var p;var str='';param||(param={});for(p in param){// when undefined is provided as a value do not include it in resulting query string
if(param.hasOwnProperty(p)&&param[p]!==undefined){str+='&'+p+'='+encodeURIComponent(param[p]);}}return str.length?'?'+str.substr(1):'';};/* always use without trailing slash because of MW requirements */var getHost=function getHost(){var host=__WEBPACK_IMPORTED_MODULE_0__config__["_65" /* XC_URL */];if(host.substr(-1)=='/'){host=host.substr(0,host.length-1);}return host;};var isChrome=function isChrome(){return navigator.userAgent.match(/Chrome\/(\S+)/);};

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeFolder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return updateFolder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return removeFolder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getFolderPaths; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addFolder; });
/* harmony export (immutable) */ __webpack_exports__["b"] = authenticateProvider;
/* harmony export (immutable) */ __webpack_exports__["g"] = removeProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_clientid__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__session__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__companies__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__errors_errorhelper__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__errors_apperror__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__errors_httperror__ = __webpack_require__(68);
var initialState={cloudProviders:[],loading:false,folders:{},parents:{}};function toCloudStore(id){var _id$split=id.split(':'),_id$split2=__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default()(_id$split,1),name=_id$split2[0];return{providerId:id,providerName:name};}function sortByFolderName(first,second){return first.filename.localeCompare(second.filename);}function getFolderData(cloudFolders,fileId,providerId){return cloudFolders.folders[fileId+providerId];}function getTitle(folder,providerId){return folder.fileId==='root'?providerId.split(':')[0]:folder.title;}/* harmony default export */ __webpack_exports__["d"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1?arguments[1]:undefined;switch(action.type){case __WEBPACK_IMPORTED_MODULE_3__actions__["w" /* COMPANIES_CHANGED */]:{var cloudstore=action.result.company.cloudstore.map(toCloudStore);return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{cloudProviders:cloudstore});}case __WEBPACK_IMPORTED_MODULE_3__actions__["_84" /* FOLDER_GET_FAIL */]:{return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{loading:false});}case __WEBPACK_IMPORTED_MODULE_3__actions__["_83" /* FOLDER_GET */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{loading:true});case __WEBPACK_IMPORTED_MODULE_3__actions__["_86" /* FOLDER_SET_PARENT */]:return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{parents:__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state.parents,__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({},action.folderId,action.parentFolder))});case __WEBPACK_IMPORTED_MODULE_3__actions__["_85" /* FOLDER_GET_SUCCESS */]:{var contents=action.result.contents.filter(function(content){return content.isDirectory;}).sort(sortByFolderName);return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state,{loading:false,folders:__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},state.folders,__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({},action.result.directory.fileId+action.result.directory.providerId,__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},action.result.directory,{contents:contents})))});}default:return state;}});var changeFolder=function changeFolder(fileId,providerId,parentFolder){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_3__actions__["_86" /* FOLDER_SET_PARENT */],folderId:fileId+providerId,parentFolder:parentFolder});providerId=encodeURIComponent(providerId);return dispatch({types:[__WEBPACK_IMPORTED_MODULE_3__actions__["_83" /* FOLDER_GET */],__WEBPACK_IMPORTED_MODULE_3__actions__["_85" /* FOLDER_GET_SUCCESS */],__WEBPACK_IMPORTED_MODULE_3__actions__["_84" /* FOLDER_GET_FAIL */]],promise:function promise(client){return client.get("/files?fileid=".concat(fileId,"&providerid=").concat(providerId))["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_8__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_10__errors_apperror__["a" /* default */]({message:'cloudFolders.changeFolder() failed',errorId:__WEBPACK_IMPORTED_MODULE_9__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_11__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_CLOUD_FOLDERS'}});throw nError;});}});};};var updateFolder=function updateFolder(_ref,companyId){var providerId=_ref.providerId,fileId=_ref.fileId,type=_ref.type,name=_ref.name;return function(dispatch){return dispatch({types:[__WEBPACK_IMPORTED_MODULE_3__actions__["_87" /* FOLDER_UPDATE */],__WEBPACK_IMPORTED_MODULE_3__actions__["_89" /* FOLDER_UPDATE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_3__actions__["_88" /* FOLDER_UPDATE_FAIL */]],promise:function promise(client){return client.patch("/companies/".concat(companyId,"/folders"),{data:{providerId:providerId,fileId:fileId,type:type,name:name}})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_8__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_10__errors_apperror__["a" /* default */]({message:'cloudFolders.updateFolder() failed',errorId:__WEBPACK_IMPORTED_MODULE_9__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_11__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_CLOUD_FOLDERS'}});throw nError;});}});};};var removeFolder=function removeFolder(_ref2){var companyId=_ref2.companyId,providerId=_ref2.providerId,fileId=_ref2.fileId,type=_ref2.type;return function(dispatch){return dispatch({types:[__WEBPACK_IMPORTED_MODULE_3__actions__["_80" /* FOLDER_DELETE */],__WEBPACK_IMPORTED_MODULE_3__actions__["_82" /* FOLDER_DELETE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_3__actions__["_81" /* FOLDER_DELETE_FAIL */]],promise:function promise(client){return client["delete"]("/companies/".concat(companyId,"/folders"),{data:{fileId:fileId,type:type,providerId:providerId}})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_8__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_10__errors_apperror__["a" /* default */]({message:'cloudFolders.removeFolder() failed',errorId:__WEBPACK_IMPORTED_MODULE_9__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_11__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_CLOUD_FOLDERS'}});throw nError;});}});};};/**
 * Get folder breadcrumb.
 *
 * @param {Object} cloudFolders
 * @param {Object} currentFolder
 *
 * @returns {Array}
 */var getFolderPaths=function getFolderPaths(cloudFolders,currentFolder){var path=[];var parent=getFolderData(cloudFolders,currentFolder.fileId,currentFolder.providerId);while(parent){path.push({id:parent.fileId,displayName:getTitle(parent,currentFolder.providerId)});parent=cloudFolders.parents[parent.fileId+currentFolder.providerId];if(parent){parent=getFolderData(cloudFolders,parent.fileId,parent.providerId);}}return path;};var addFolder=function addFolder(_ref3){var companyId=_ref3.companyId,providerId=_ref3.providerId,fileId=_ref3.fileId,type=_ref3.type,currentFolder=_ref3.currentFolder;return function(dispatch,getState){var _getState=getState(),cloudFolders=_getState.cloudFolders;var path=getFolderPaths(cloudFolders,currentFolder);return dispatch({types:[__WEBPACK_IMPORTED_MODULE_3__actions__["_77" /* FOLDER_ADD */],__WEBPACK_IMPORTED_MODULE_3__actions__["_79" /* FOLDER_ADD_SUCCESS */],__WEBPACK_IMPORTED_MODULE_3__actions__["_78" /* FOLDER_ADD_FAIL */]],promise:function promise(client){return client.post("/companies/".concat(companyId,"/folders"),{data:{fileId:fileId,type:type,providerId:providerId,path:path.reverse()}})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_8__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_10__errors_apperror__["a" /* default */]({message:'cloudFolders.addFolder() failed',errorId:__WEBPACK_IMPORTED_MODULE_9__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_11__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_CLOUD_FOLDERS'}});throw nError;});}});};};function authenticateProvider(name,companyId){var location=encodeURIComponent(window.location.href);var authUrl="".concat(__WEBPACK_IMPORTED_MODULE_4_config__["P" /* HTTP_API_URL */],"/auth/").concat(name);var qs="?host=".concat(location,"&auth-target=company&company-id=").concat(companyId,"&auth-action=store-provider&clientid=").concat(__WEBPACK_IMPORTED_MODULE_5__utils_clientid__["a" /* default */]);window.location=authUrl+qs;}function removeProvider(providerId,companyId){return function(dispatch){return dispatch({types:[__WEBPACK_IMPORTED_MODULE_3__actions__["_141" /* REMOVE_COMPANY_FOLDER */],__WEBPACK_IMPORTED_MODULE_3__actions__["_143" /* REMOVE_COMPANY_FOLDER_SUCCESS */],__WEBPACK_IMPORTED_MODULE_3__actions__["_142" /* REMOVE_COMPANY_FOLDER_FAIL */]],promise:function promise(client){return client.patch("/companies/".concat(companyId,"/providers"),{data:{providerIds:[providerId]}}).then(function(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__session__["b" /* fetchSession */])());}).then(function(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__companies__["d" /* changeCompanyAndNotify */])());})["catch"](function(error){var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_8__errors_errorhelper__["b" /* extractPropsforSuperagentHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_10__errors_apperror__["a" /* default */]({message:'cloudFolders.removeProvider() failed',errorId:__WEBPACK_IMPORTED_MODULE_9__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_11__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'REDUX_CLOUD_FOLDERS'}});throw nError;});}});};}

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ownerDocument = _interopRequireDefault(__webpack_require__(93));

function ownerWindow(node) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  var doc = (0, _ownerDocument.default)(node);
  return doc.defaultView || doc.parentView || fallback;
}

var _default = ownerWindow;
exports.default = _default;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Modal.default;
  }
});
Object.defineProperty(exports, "ModalManager", {
  enumerable: true,
  get: function get() {
    return _ModalManager.default;
  }
});

var _Modal = _interopRequireDefault(__webpack_require__(870));

var _ModalManager = _interopRequireDefault(__webpack_require__(407));

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Fade.default;
  }
});

var _Fade = _interopRequireDefault(__webpack_require__(884));

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Link.default;
  }
});

var _Link = _interopRequireDefault(__webpack_require__(897));

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

/**
 * @ignore - internal component.
 */
var ListContext = _react.default.createContext({});

var _default = ListContext;
exports.default = _default;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(203));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'ExpandMore');

exports.default = _default;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _pure = _interopRequireDefault(__webpack_require__(57));

var _SvgIcon = _interopRequireDefault(__webpack_require__(51));

function createSvgIcon(path, displayName) {
  var Icon = function Icon(props) {
    return _react.default.createElement(_SvgIcon.default, props, path);
  };

  Icon.displayName = "".concat(displayName, "Icon");
  Icon = (0, _pure.default)(Icon);
  Icon.muiName = 'SvgIcon';
  return Icon;
}

;
var _default = createSvgIcon;
exports.default = _default;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TextField.default;
  }
});

var _TextField = _interopRequireDefault(__webpack_require__(911));

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Input.default;
  }
});

var _Input = _interopRequireDefault(__webpack_require__(912));

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Popover.default;
  }
});

var _Popover = _interopRequireDefault(__webpack_require__(924));

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Tabs.default;
  }
});

var _Tabs = _interopRequireDefault(__webpack_require__(936));

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Tab.default;
  }
});

var _Tab = _interopRequireDefault(__webpack_require__(942));

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableCell.default;
  }
});

var _TableCell = _interopRequireDefault(__webpack_require__(1067));

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTableStyleProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MLS_ERRORS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__errors_errorids__ = __webpack_require__(22);
var _MLS_ERRORS;var SMALL_BREAKPOINT_NAME_WIDTH=150;var getTableStyleProps=function getTableStyleProps(theme){return{/* no users message */noUsersFound:{width:'100%',textAlign:'center'},/* table */table:{tableLayout:'fixed'},tableHeadRow:{backgroundColor:'#F4F4F4'},tableBodyRow:{'&:nth-of-type(even)':{backgroundColor:'#F4F4F4'},'&:hover':{backgroundColor:'#e8e8e8 !important'}},tableCellHeader:{fontSize:14},tableNameCellHeader:__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({width:375},theme.breakpoints.down('sm'),{width:SMALL_BREAKPOINT_NAME_WIDTH}),tableIdCellHeader:{},tableCellBody:{fontSize:14,paddingTop:27,paddingBottom:27},tableNameCellBody:{},tableIdCellBody:{},tableActionsCell:{width:40,textAlign:'right',alignItems:'center','& .errorMessage':__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({width:200,whiteSpace:'wrap',marginTop:10,textAlign:'left'},theme.breakpoints.down('sm'),{width:120})},noBorderedCell:{}};};var MLS_ERRORS=(_MLS_ERRORS={},__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].OFFLINE,'mls-error-offline'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,'mls-error-unknown'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].AGENT_INTERNAL_SERVER_ERROR,'mls-error-internal-server-error'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].AGENT_CONNECTION_NOT_FOUND,'mls-error-connection-not-found'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].AGENT_ID_EXISTS,'mls-error-agent-mls-id-already-assigned'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].AGENT_NOT_FOUND,'mls-error-agent-not-found'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].API_KEY_REQUIRED,'mls-error-api-key-required'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].INVALID_CONNECTION_ID,'mls-error-invalid-connection-id'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].AGENT_INVALID_COMPANY_ID,'mls-error-invalid-company-id'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].FAILED_TO_LIST_AGENTS,'mls-error-failed-to-list-agents'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].INVALID_ADD_AGENT_MLS_ID_PACKET,'mls-error-invalid-add-agent-packet'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].INVALID_DELETE_AGENT_MLS_ID_PACKET,'mls-error-invalid-delete-agent-packet'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].INVALID_EDIT_AGENT_MLS_ID_PACKET,'mls-error-invalid-edit-agent-packet'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].MLS_NO_LISTINGS_FOUND,'mls-popup-no-listings-found'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].INVALID_DELETE_CONNECTION_PACKET,'mls-error-invalid-delete-connection-packet'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].INVALID_DELETE_OFFICE_ID_PACKET,'mls-error-invalid-delete-office-packet'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].INVALID_AGENT_ID,'mls-error-invalid-agent-id-format'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].TOO_MANY_ATTEMPTS,'mls-error-rate-limit-reached'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].AGENT_NO_LISTINGS_FOUND,'mls-popup-no-listings-found-for-agent'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].EMAIL_NOT_VERIFIED,'mls-error-email-not-verified'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].SUBSCRIPTION_NEEDED,'mls-error-subscription-needed'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].MAX_CONNECTIONS_EXCEEDED,'mls-error-connection-limit-reached'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].INVALID_MLS_BOARD_CODE,'mls-error-invalid-mls-board-name'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].MLS_COMPANY_NOT_FOUND,'mls-error-company-not-found'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].INVALID_ADD_CONNECTION_WITH_OFFICE_ID_PACKET,'mls-error-invalid-add-connection-with-office-id-packet'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].INVALID_ADD_CONNECTION_WITH_AGENT_ID_PACKET,'mls-error-invalid-add-connection-with-agent-id-packet'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].INVALID_ADD_OFFICE_ID_PACKET,'mls-error-invalid-add-office-to-connection-packet'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].MLS_INTERNAL_SERVER_ERROR,'mls-error-internal-server-error'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].USER_SESSION_INVALID,'mls-error-invalid-user-session'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].MLS_CONNECTION_NOT_FOUND,'mls-error-connection-not-found'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].OFFICE_NOT_FOUND,'mls-error-office-not-found'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].INVALID_MLS_CONNECTION_CONFIG,'re-api-error-invalid-mls-connection-config'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].INVALID_OFFICE_ID,'re-api-error-invalid-office-id'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].INVALID_AGENT_CODE,'re-api-error-invalid-agent-code'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].INVALID_API_KEY,'re-api-error-invalid-api-key'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].RE_API_INTERNAL_SERVER_ERROR,'re-api-error-re-api-internal-server-error'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].HTTP_INTERNAL_SERVER_ERROR,'http-error-internal-server-error'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].HTTP_MISSING_COMPANY_ID,'http-error-mising-company-id'),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_MLS_ERRORS,__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].HTTP_MISSING_USER_ID,'http-error-missing-user-id'),_MLS_ERRORS);

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return replaceConsecutiveSpaces; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return stripHTML; });
var replaceConsecutiveSpaces=function replaceConsecutiveSpaces(str){return str.replace(/\s\s+/g,' ');};var stripHTML=function stripHTML(str){return str.replace(/<[^>]+>/g,'');};

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf__ = __webpack_require__(1183);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_esm_typeof__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized__ = __webpack_require__(456);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__helpers_esm_typeof__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized__["a" /* default */])(self);
}

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(33);
var document = __webpack_require__(30).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(35);


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(167)('keys');
var uid = __webpack_require__(108);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 220 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(30).document;
module.exports = document && document.documentElement;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(33);
var anObject = __webpack_require__(32);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(75)(Function.call, __webpack_require__(78).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 223 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(33);
var setPrototypeOf = __webpack_require__(222).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(77);
var defined = __webpack_require__(86);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 226 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 227 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(77);
var defined = __webpack_require__(86);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(109);
var $export = __webpack_require__(12);
var redefine = __webpack_require__(55);
var hide = __webpack_require__(59);
var Iterators = __webpack_require__(129);
var $iterCreate = __webpack_require__(319);
var setToStringTag = __webpack_require__(127);
var getPrototypeOf = __webpack_require__(114);
var ITERATOR = __webpack_require__(35)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(231);
var defined = __webpack_require__(86);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(33);
var cof = __webpack_require__(85);
var MATCH = __webpack_require__(35)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(35)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(129);
var ITERATOR = __webpack_require__(35)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(43);
var createDesc = __webpack_require__(107);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(144);
var ITERATOR = __webpack_require__(35)('iterator');
var Iterators = __webpack_require__(129);
module.exports = __webpack_require__(41).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(53);
var toAbsoluteIndex = __webpack_require__(111);
var toLength = __webpack_require__(37);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(115);
var step = __webpack_require__(324);
var Iterators = __webpack_require__(129);
var toIObject = __webpack_require__(60);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(229)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(172);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(228)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(75);
var invoke = __webpack_require__(313);
var html = __webpack_require__(221);
var cel = __webpack_require__(217);
var global = __webpack_require__(30);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(85)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(30);
var DESCRIPTORS = __webpack_require__(47);
var LIBRARY = __webpack_require__(109);
var $typed = __webpack_require__(178);
var hide = __webpack_require__(59);
var redefineAll = __webpack_require__(132);
var fails = __webpack_require__(31);
var anInstance = __webpack_require__(131);
var toInteger = __webpack_require__(77);
var toLength = __webpack_require__(37);
var toIndex = __webpack_require__(332);
var gOPN = __webpack_require__(113).f;
var dP = __webpack_require__(43).f;
var arrayFill = __webpack_require__(236);
var setToStringTag = __webpack_require__(127);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 242 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(338)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(680);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConnectedRouter__ = __webpack_require__(690);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ConnectedRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors__ = __webpack_require__(699);
/* unused harmony reexport getLocation */
/* unused harmony reexport createMatchSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducer__ = __webpack_require__(359);
/* unused harmony reexport LOCATION_CHANGE */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__reducer__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(360);
/* unused harmony reexport CALL_HISTORY_METHOD */
/* unused harmony reexport push */
/* unused harmony reexport replace */
/* unused harmony reexport go */
/* unused harmony reexport goBack */
/* unused harmony reexport goForward */
/* unused harmony reexport routerActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middleware__ = __webpack_require__(700);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__middleware__["a"]; });









/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(351);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(352);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(148);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(102);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(183);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, 'You should not use <Route> or withRouter() outside a <Router>');

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    return component ? // component prop gets first priority, only called if there's a match
    match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
    match ? render(props) : null : children ? // children come last, always called
    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null : null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(150);

var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MuiThemeProviderOld = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _warning = _interopRequireDefault(__webpack_require__(27));

var _brcast = _interopRequireDefault(__webpack_require__(701));

var _utils = __webpack_require__(14);

var _themeListener = _interopRequireWildcard(__webpack_require__(255));

/* eslint-disable no-underscore-dangle */

/**
 * This component takes a `theme` property.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */
var MuiThemeProviderOld =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(MuiThemeProviderOld, _React$Component);

  // We are not using the React state in order to avoid unnecessary rerender.
  function MuiThemeProviderOld(props, context) {
    var _this;

    (0, _classCallCheck2.default)(this, MuiThemeProviderOld);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(MuiThemeProviderOld).call(this)); // Get the outer theme from the context, can be null

    _this.broadcast = (0, _brcast.default)();
    _this.outerTheme = _themeListener.default.initial(context); // Propagate the theme so it can be accessed by the children

    _this.broadcast.setState(_this.mergeOuterLocalTheme(props.theme));

    return _this;
  }

  (0, _createClass2.default)(MuiThemeProviderOld, [{
    key: "getChildContext",
    value: function getChildContext() {
      var _ref;

      var _this$props = this.props,
          disableStylesGeneration = _this$props.disableStylesGeneration,
          sheetsCache = _this$props.sheetsCache,
          sheetsManager = _this$props.sheetsManager;
      var muiThemeProviderOptions = this.context.muiThemeProviderOptions || {};

      if (disableStylesGeneration !== undefined) {
        muiThemeProviderOptions.disableStylesGeneration = disableStylesGeneration;
      }

      if (sheetsCache !== undefined) {
        muiThemeProviderOptions.sheetsCache = sheetsCache;
      }

      if (sheetsManager !== undefined) {
        muiThemeProviderOptions.sheetsManager = sheetsManager;
      }

      return _ref = {}, (0, _defineProperty2.default)(_ref, _themeListener.CHANNEL, this.broadcast), (0, _defineProperty2.default)(_ref, "muiThemeProviderOptions", muiThemeProviderOptions), _ref;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Subscribe on the outer theme, if present
      this.unsubscribeId = _themeListener.default.subscribe(this.context, function (outerTheme) {
        _this2.outerTheme = outerTheme; // Forward the parent theme update to the children

        _this2.broadcast.setState(_this2.mergeOuterLocalTheme(_this2.props.theme));
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // Propagate a local theme update
      if (this.props.theme !== prevProps.theme) {
        this.broadcast.setState(this.mergeOuterLocalTheme(this.props.theme));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.unsubscribeId !== null) {
        _themeListener.default.unsubscribe(this.context, this.unsubscribeId);
      }
    } // Simple merge between the outer theme and the local theme

  }, {
    key: "mergeOuterLocalTheme",
    value: function mergeOuterLocalTheme(localTheme) {
      // To support composition of theme.
      if (typeof localTheme === 'function') {
         false ? (0, _warning.default)(this.outerTheme, ['Material-UI: you are providing a theme function property ' + 'to the MuiThemeProvider component:', '<MuiThemeProvider theme={outerTheme => outerTheme} />', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n')) : void 0;
        return localTheme(this.outerTheme);
      }

      if (!this.outerTheme) {
        return localTheme;
      }

      return (0, _extends2.default)({}, this.outerTheme, localTheme);
    }
  }, {
    key: "render",
    value: function render() {
      // TODO move the sheetsManager property to a different component.
      // warning(
      //   typeof window !== 'undefined' || this.props.sheetsManager,
      //   [
      //     'Material-UI: you need to provide a sheetsManager to the MuiThemeProvider ' +
      //       'when rendering on the server.',
      //     'If you do not, you might experience a memory leak',
      //   ].join('\n'),
      // );
      return this.props.children;
    }
  }]);
  return MuiThemeProviderOld;
}(_react.default.Component);

exports.MuiThemeProviderOld = MuiThemeProviderOld;
 false ? MuiThemeProviderOld.propTypes = {
  /**
   * You can wrap a node.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server-side.
   * You can significantly speed up the traversal with this property.
   */
  disableStylesGeneration: _propTypes.default.bool,

  /**
   * @ignore
   *
   * In beta.
   */
  sheetsCache: _propTypes.default.object,

  /**
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: _propTypes.default.object,

  /**
   * A theme object.
   */
  theme: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]).isRequired
} : void 0;

if (false) {
  process.env.NODE_ENV !== "production" ? MuiThemeProviderOld.propTypes = (0, _utils.exactProp)(MuiThemeProviderOld.propTypes) : void 0;
}

MuiThemeProviderOld.childContextTypes = (0, _extends2.default)({}, _themeListener.default.contextTypes, {
  muiThemeProviderOptions: _propTypes.default.object
});
MuiThemeProviderOld.contextTypes = (0, _extends2.default)({}, _themeListener.default.contextTypes, {
  muiThemeProviderOptions: _propTypes.default.object
});
/* istanbul ignore if */

if (!_utils.ponyfillGlobal.__MUI_STYLES__) {
  _utils.ponyfillGlobal.__MUI_STYLES__ = {};
}

if (!_utils.ponyfillGlobal.__MUI_STYLES__.MuiThemeProvider) {
  _utils.ponyfillGlobal.__MUI_STYLES__.MuiThemeProvider = MuiThemeProviderOld;
}

var _default = _utils.ponyfillGlobal.__MUI_STYLES__.MuiThemeProvider;
exports.default = _default;

/***/ }),
/* 254 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CHANNEL = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

// Same value used by react-jss
var CHANNEL = '__THEMING__';
exports.CHANNEL = CHANNEL;
var themeListener = {
  contextTypes: (0, _defineProperty2.default)({}, CHANNEL, function () {}),
  initial: function initial(context) {
    if (!context[CHANNEL]) {
      return null;
    }

    return context[CHANNEL].getState();
  },
  subscribe: function subscribe(context, cb) {
    if (!context[CHANNEL]) {
      return null;
    }

    return context[CHANNEL].subscribe(cb);
  },
  unsubscribe: function unsubscribe(context, subscriptionId) {
    if (context[CHANNEL]) {
      context[CHANNEL].unsubscribe(subscriptionId);
    }
  }
};
var _default = themeListener;
exports.default = _default;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _deepmerge = _interopRequireDefault(__webpack_require__(184));

var _isPlainObject = _interopRequireDefault(__webpack_require__(710));

var _warning = _interopRequireDefault(__webpack_require__(27));

var _createBreakpoints = _interopRequireDefault(__webpack_require__(151));

var _createMixins = _interopRequireDefault(__webpack_require__(712));

var _createPalette = _interopRequireDefault(__webpack_require__(713));

var _createTypography = _interopRequireDefault(__webpack_require__(714));

var _shadows = _interopRequireDefault(__webpack_require__(715));

var _shape = _interopRequireDefault(__webpack_require__(716));

var _spacing = _interopRequireDefault(__webpack_require__(717));

var _transitions = _interopRequireDefault(__webpack_require__(88));

var _zIndex = _interopRequireDefault(__webpack_require__(718));

// < 1kb payload overhead when lodash/merge is > 3kb.
function createMuiTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      shadowsInput = options.shadows,
      _options$spacing = options.spacing,
      spacingInput = _options$spacing === void 0 ? {} : _options$spacing,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      other = (0, _objectWithoutProperties2.default)(options, ["breakpoints", "mixins", "palette", "shadows", "spacing", "typography"]);
  var palette = (0, _createPalette.default)(paletteInput);
  var breakpoints = (0, _createBreakpoints.default)(breakpointsInput);
  var spacing = (0, _extends2.default)({}, _spacing.default, spacingInput);
  var muiTheme = (0, _extends2.default)({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: (0, _createMixins.default)(breakpoints, spacing, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Inject custom properties
    shadows: shadowsInput || _shadows.default,
    typography: (0, _createTypography.default)(palette, typographyInput)
  }, (0, _deepmerge.default)({
    shape: _shape.default,
    spacing: spacing,
    transitions: _transitions.default,
    zIndex: _zIndex.default
  }, other, {
    isMergeableObject: _isPlainObject.default
  }));

  if (false) {
    var statesWarning = ['disabled', 'focused', 'selected', 'checked'];

    var traverse = function traverse(node, parentKey) {
      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var key; // eslint-disable-next-line guard-for-in, no-restricted-syntax

      for (key in node) {
        var child = node[key];

        if (depth === 1) {
          if (key.indexOf('Mui') === 0 && child) {
            traverse(child, key, depth + 1);
          }
        } else if (statesWarning.indexOf(key) !== -1 && Object.keys(child).length > 0) {
          process.env.NODE_ENV !== "production" ? (0, _warning.default)(false, ["Material-UI: the `".concat(parentKey, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."), 'You can not override it like this: ', JSON.stringify(node, null, 2), '', 'Instead, you need to use the $ruleName syntax:', JSON.stringify((0, _defineProperty2.default)({}, "&$".concat(key), child), null, 2), '', 'https://material-ui.com/customization/overrides#internal-states'].join('\n')) : void 0;
        }
      }
    };

    traverse(other.overrides);
  }

   false ? (0, _warning.default)(muiTheme.shadows.length === 25, 'Material-UI: the shadows array provided to createMuiTheme should support 25 elevations.') : void 0;
  return muiTheme;
}

var _default = createMuiTheme;
exports.default = _default;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCss;

var _toCssValue = __webpack_require__(185);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */
function indentStr(str, indent) {
  var result = '';
  for (var index = 0; index < indent; index++) {
    result += '  ';
  }return result + str;
}

/**
 * Converts a Rule to CSS string.
 */

function toCss(selector, style) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var result = '';

  if (!style) return result;

  var _options$indent = options.indent,
      indent = _options$indent === undefined ? 0 : _options$indent;
  var fallbacks = style.fallbacks;


  indent++;

  // Apply fallbacks first.
  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];
        for (var prop in fallback) {
          var value = fallback[prop];
          if (value != null) {
            result += '\n' + indentStr(prop + ': ' + (0, _toCssValue2['default'])(value) + ';', indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];
        if (_value != null) {
          result += '\n' + indentStr(_prop + ': ' + (0, _toCssValue2['default'])(_value) + ';', indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];
    if (_value2 != null && _prop2 !== 'fallbacks') {
      result += '\n' + indentStr(_prop2 + ': ' + (0, _toCssValue2['default'])(_value2) + ';', indent);
    }
  }

  // Allow empty style in this case, because properties will be added dynamically.
  if (!result && !options.allowEmpty) return result;

  indent--;
  result = indentStr(selector + ' {' + result + '\n', indent) + indentStr('}', indent);

  return result;
}

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SheetsRegistry = __webpack_require__(371);

var _SheetsRegistry2 = _interopRequireDefault(_SheetsRegistry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */
exports['default'] = new _SheetsRegistry2['default']();

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isInBrowser = __webpack_require__(187);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var js = ''; /**
              * Export javascript style and css style vendor prefixes.
              * Based on "transform" support test.
              */

var css = '';

// We should not do anything if required serverside.
if (_isInBrowser2['default']) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    // IE did it wrong again ...
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };
  var style = document.createElement('p').style;
  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  }
}

/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String}}
 * @api public
 */
exports['default'] = { js: js, css: css };

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(62);
var normalizeHeaderName = __webpack_require__(795);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(381);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(381);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(155)))

/***/ }),
/* 261 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var debug = __webpack_require__(816)('socket.io-parser');
var Emitter = __webpack_require__(118);
var binary = __webpack_require__(818);
var isArray = __webpack_require__(387);
var isBuf = __webpack_require__(388);

/**
 * Protocol version.
 *
 * @api public
 */

exports.protocol = 4;

/**
 * Packet types.
 *
 * @api public
 */

exports.types = [
  'CONNECT',
  'DISCONNECT',
  'EVENT',
  'ACK',
  'ERROR',
  'BINARY_EVENT',
  'BINARY_ACK'
];

/**
 * Packet type `connect`.
 *
 * @api public
 */

exports.CONNECT = 0;

/**
 * Packet type `disconnect`.
 *
 * @api public
 */

exports.DISCONNECT = 1;

/**
 * Packet type `event`.
 *
 * @api public
 */

exports.EVENT = 2;

/**
 * Packet type `ack`.
 *
 * @api public
 */

exports.ACK = 3;

/**
 * Packet type `error`.
 *
 * @api public
 */

exports.ERROR = 4;

/**
 * Packet type 'binary event'
 *
 * @api public
 */

exports.BINARY_EVENT = 5;

/**
 * Packet type `binary ack`. For acks with binary arguments.
 *
 * @api public
 */

exports.BINARY_ACK = 6;

/**
 * Encoder constructor.
 *
 * @api public
 */

exports.Encoder = Encoder;

/**
 * Decoder constructor.
 *
 * @api public
 */

exports.Decoder = Decoder;

/**
 * A socket.io Encoder instance
 *
 * @api public
 */

function Encoder() {}

var ERROR_PACKET = exports.ERROR + '"encode error"';

/**
 * Encode a packet as a single string if non-binary, or as a
 * buffer sequence, depending on packet type.
 *
 * @param {Object} obj - packet object
 * @param {Function} callback - function to handle encodings (likely engine.write)
 * @return Calls callback with Array of encodings
 * @api public
 */

Encoder.prototype.encode = function(obj, callback){
  debug('encoding packet %j', obj);

  if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
    encodeAsBinary(obj, callback);
  } else {
    var encoding = encodeAsString(obj);
    callback([encoding]);
  }
};

/**
 * Encode packet as string.
 *
 * @param {Object} packet
 * @return {String} encoded
 * @api private
 */

function encodeAsString(obj) {

  // first is type
  var str = '' + obj.type;

  // attachments if we have them
  if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
    str += obj.attachments + '-';
  }

  // if we have a namespace other than `/`
  // we append it followed by a comma `,`
  if (obj.nsp && '/' !== obj.nsp) {
    str += obj.nsp + ',';
  }

  // immediately followed by the id
  if (null != obj.id) {
    str += obj.id;
  }

  // json data
  if (null != obj.data) {
    var payload = tryStringify(obj.data);
    if (payload !== false) {
      str += payload;
    } else {
      return ERROR_PACKET;
    }
  }

  debug('encoded %j as %s', obj, str);
  return str;
}

function tryStringify(str) {
  try {
    return JSON.stringify(str);
  } catch(e){
    return false;
  }
}

/**
 * Encode packet as 'buffer sequence' by removing blobs, and
 * deconstructing packet into object with placeholders and
 * a list of buffers.
 *
 * @param {Object} packet
 * @return {Buffer} encoded
 * @api private
 */

function encodeAsBinary(obj, callback) {

  function writeEncoding(bloblessData) {
    var deconstruction = binary.deconstructPacket(bloblessData);
    var pack = encodeAsString(deconstruction.packet);
    var buffers = deconstruction.buffers;

    buffers.unshift(pack); // add packet info to beginning of data list
    callback(buffers); // write all the buffers
  }

  binary.removeBlobs(obj, writeEncoding);
}

/**
 * A socket.io Decoder instance
 *
 * @return {Object} decoder
 * @api public
 */

function Decoder() {
  this.reconstructor = null;
}

/**
 * Mix in `Emitter` with Decoder.
 */

Emitter(Decoder.prototype);

/**
 * Decodes an encoded packet string into packet JSON.
 *
 * @param {String} obj - encoded packet
 * @return {Object} packet
 * @api public
 */

Decoder.prototype.add = function(obj) {
  var packet;
  if (typeof obj === 'string') {
    packet = decodeString(obj);
    if (exports.BINARY_EVENT === packet.type || exports.BINARY_ACK === packet.type) { // binary packet's json
      this.reconstructor = new BinaryReconstructor(packet);

      // no attachments, labeled binary but no binary data to follow
      if (this.reconstructor.reconPack.attachments === 0) {
        this.emit('decoded', packet);
      }
    } else { // non-binary full packet
      this.emit('decoded', packet);
    }
  } else if (isBuf(obj) || obj.base64) { // raw binary data
    if (!this.reconstructor) {
      throw new Error('got binary data when not reconstructing a packet');
    } else {
      packet = this.reconstructor.takeBinaryData(obj);
      if (packet) { // received final buffer
        this.reconstructor = null;
        this.emit('decoded', packet);
      }
    }
  } else {
    throw new Error('Unknown type: ' + obj);
  }
};

/**
 * Decode a packet String (JSON data)
 *
 * @param {String} str
 * @return {Object} packet
 * @api private
 */

function decodeString(str) {
  var i = 0;
  // look up type
  var p = {
    type: Number(str.charAt(0))
  };

  if (null == exports.types[p.type]) {
    return error('unknown packet type ' + p.type);
  }

  // look up attachments if type binary
  if (exports.BINARY_EVENT === p.type || exports.BINARY_ACK === p.type) {
    var buf = '';
    while (str.charAt(++i) !== '-') {
      buf += str.charAt(i);
      if (i == str.length) break;
    }
    if (buf != Number(buf) || str.charAt(i) !== '-') {
      throw new Error('Illegal attachments');
    }
    p.attachments = Number(buf);
  }

  // look up namespace (if any)
  if ('/' === str.charAt(i + 1)) {
    p.nsp = '';
    while (++i) {
      var c = str.charAt(i);
      if (',' === c) break;
      p.nsp += c;
      if (i === str.length) break;
    }
  } else {
    p.nsp = '/';
  }

  // look up id
  var next = str.charAt(i + 1);
  if ('' !== next && Number(next) == next) {
    p.id = '';
    while (++i) {
      var c = str.charAt(i);
      if (null == c || Number(c) != c) {
        --i;
        break;
      }
      p.id += str.charAt(i);
      if (i === str.length) break;
    }
    p.id = Number(p.id);
  }

  // look up json data
  if (str.charAt(++i)) {
    var payload = tryParse(str.substr(i));
    var isPayloadValid = payload !== false && (p.type === exports.ERROR || isArray(payload));
    if (isPayloadValid) {
      p.data = payload;
    } else {
      return error('invalid payload');
    }
  }

  debug('decoded %s as %j', str, p);
  return p;
}

function tryParse(str) {
  try {
    return JSON.parse(str);
  } catch(e){
    return false;
  }
}

/**
 * Deallocates a parser's resources
 *
 * @api public
 */

Decoder.prototype.destroy = function() {
  if (this.reconstructor) {
    this.reconstructor.finishedReconstruction();
  }
};

/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 * @api private
 */

function BinaryReconstructor(packet) {
  this.reconPack = packet;
  this.buffers = [];
}

/**
 * Method to be called when binary data received from connection
 * after a BINARY_EVENT packet.
 *
 * @param {Buffer | ArrayBuffer} binData - the raw binary data received
 * @return {null | Object} returns null if more binary data is expected or
 *   a reconstructed packet object if all buffers have been received.
 * @api private
 */

BinaryReconstructor.prototype.takeBinaryData = function(binData) {
  this.buffers.push(binData);
  if (this.buffers.length === this.reconPack.attachments) { // done with buffer list
    var packet = binary.reconstructPacket(this.reconPack, this.buffers);
    this.finishedReconstruction();
    return packet;
  }
  return null;
};

/**
 * Cleans up binary packet reconstruction variables.
 *
 * @api private
 */

BinaryReconstructor.prototype.finishedReconstruction = function() {
  this.reconPack = null;
  this.buffers = [];
};

function error(msg) {
  return {
    type: exports.ERROR,
    data: 'parser error: ' + msg
  };
}


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(819)
var ieee754 = __webpack_require__(820)
var isArray = __webpack_require__(821)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(67)))

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

// browser shim for xmlhttprequest module

var hasCORS = __webpack_require__(824);

module.exports = function (opts) {
  var xdomain = opts.xdomain;

  // scheme must be same when usign XDomainRequest
  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
  var xscheme = opts.xscheme;

  // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
  // https://github.com/Automattic/engine.io-client/pull/217
  var enablesXDR = opts.enablesXDR;

  // XMLHttpRequest can be disabled on IE
  try {
    if ('undefined' !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
      return new XMLHttpRequest();
    }
  } catch (e) { }

  // Use XDomainRequest for IE8 if enablesXDR is true
  // because loading bar keeps flashing when using jsonp-polling
  // https://github.com/yujiosaka/socke.io-ie8-loading-example
  try {
    if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) {
      return new XDomainRequest();
    }
  } catch (e) { }

  if (!xdomain) {
    try {
      return new self[['Active'].concat('Object').join('X')]('Microsoft.XMLHTTP');
    } catch (e) { }
  }
};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var parser = __webpack_require__(136);
var Emitter = __webpack_require__(118);

/**
 * Module exports.
 */

module.exports = Transport;

/**
 * Transport abstract constructor.
 *
 * @param {Object} options.
 * @api private
 */

function Transport (opts) {
  this.path = opts.path;
  this.hostname = opts.hostname;
  this.port = opts.port;
  this.secure = opts.secure;
  this.query = opts.query;
  this.timestampParam = opts.timestampParam;
  this.timestampRequests = opts.timestampRequests;
  this.readyState = '';
  this.agent = opts.agent || false;
  this.socket = opts.socket;
  this.enablesXDR = opts.enablesXDR;

  // SSL options for Node.js client
  this.pfx = opts.pfx;
  this.key = opts.key;
  this.passphrase = opts.passphrase;
  this.cert = opts.cert;
  this.ca = opts.ca;
  this.ciphers = opts.ciphers;
  this.rejectUnauthorized = opts.rejectUnauthorized;
  this.forceNode = opts.forceNode;

  // results of ReactNative environment detection
  this.isReactNative = opts.isReactNative;

  // other options for Node.js client
  this.extraHeaders = opts.extraHeaders;
  this.localAddress = opts.localAddress;
}

/**
 * Mix in `Emitter`.
 */

Emitter(Transport.prototype);

/**
 * Emits an error.
 *
 * @param {String} str
 * @return {Transport} for chaining
 * @api public
 */

Transport.prototype.onError = function (msg, desc) {
  var err = new Error(msg);
  err.type = 'TransportError';
  err.description = desc;
  this.emit('error', err);
  return this;
};

/**
 * Opens the transport.
 *
 * @api public
 */

Transport.prototype.open = function () {
  if ('closed' === this.readyState || '' === this.readyState) {
    this.readyState = 'opening';
    this.doOpen();
  }

  return this;
};

/**
 * Closes the transport.
 *
 * @api private
 */

Transport.prototype.close = function () {
  if ('opening' === this.readyState || 'open' === this.readyState) {
    this.doClose();
    this.onClose();
  }

  return this;
};

/**
 * Sends multiple packets.
 *
 * @param {Array} packets
 * @api private
 */

Transport.prototype.send = function (packets) {
  if ('open' === this.readyState) {
    this.write(packets);
  } else {
    throw new Error('Transport not open');
  }
};

/**
 * Called upon open
 *
 * @api private
 */

Transport.prototype.onOpen = function () {
  this.readyState = 'open';
  this.writable = true;
  this.emit('open');
};

/**
 * Called with data.
 *
 * @param {String} data
 * @api private
 */

Transport.prototype.onData = function (data) {
  var packet = parser.decodePacket(data, this.socket.binaryType);
  this.onPacket(packet);
};

/**
 * Called with a decoded packet.
 */

Transport.prototype.onPacket = function (packet) {
  this.emit('packet', packet);
};

/**
 * Called upon close.
 *
 * @api private
 */

Transport.prototype.onClose = function () {
  this.readyState = 'closed';
  this.emit('close');
};


/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = setItem;
/* harmony export (immutable) */ __webpack_exports__["a"] = getItem;
/* harmony export (immutable) */ __webpack_exports__["c"] = setKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__errors_apperror__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger_logger__ = __webpack_require__(40);
var log=__WEBPACK_IMPORTED_MODULE_2__logger_logger__["a" /* default */].get('storage');var userKey;//not user id, instead md5 hash
function getUserStorage(){var userStorage=window.localStorage.getItem(userKey);try{return JSON.parse(userStorage)||{};}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_0__errors_apperror__["a" /* default */]({message:'Storage.getUserStorage() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}return{};}function setItem(key,value,json){value=json?JSON.stringify(value):value;var userStorage=getUserStorage();userStorage[key]=value;try{window.localStorage.setItem(userKey,JSON.stringify(userStorage));}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_0__errors_apperror__["a" /* default */]({message:'Storage.setItem() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}}function getItem(key,json){var item=getUserStorage()[key];if(json){try{return JSON.parse(item);}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_0__errors_apperror__["a" /* default */]({message:'Storage.getItem() failed',errorId:__WEBPACK_IMPORTED_MODULE_1__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'STORAGE'}}));}}return item;}function setKey(key){userKey=key;}

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export addWorkspace */
/* unused harmony export updateWorkspace */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return deleteWorkspace; });
/* unused harmony export validateWorkspace */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return connectWorkspacesSocketEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_modules_quickMessages__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__storage__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
var _this=this;var initialState={byId:null,allIds:null,rawDataById:null,valid:false,loading:false};// Company ID may be passes as a workspace prop (from socket) or as a second argument (from session)
var getWorkspace=function getWorkspace(workspace,companyId){var id=workspace._id,props=__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default()(workspace,["_id"]);return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({id:id,companyId:companyId},props);};var getState=function getState(companies){var byId={};var rawDataById={};var allIds=[];var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=companies[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var company=_step.value;var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=company.workspaces[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var workspace=_step2.value;var _getWorkspace=getWorkspace(workspace,company._id),id=_getWorkspace.id,props=__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_objectWithoutProperties___default()(_getWorkspace,["id"]);allIds.push(id);byId[id]=__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({id:id},props);rawDataById[id]=__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({id:id},props);}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2["return"]!=null){_iterator2["return"]();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator["return"]!=null){_iterator["return"]();}}finally{if(_didIteratorError){throw _iteratorError;}}}return{byId:byId,allIds:allIds,rawDataById:rawDataById};};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1?arguments[1]:undefined;switch(action.type){case __WEBPACK_IMPORTED_MODULE_4__actions__["_153" /* SESSION_FETCH_SUCCESS */]:return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({},state,getState(action.result.companies));case __WEBPACK_IMPORTED_MODULE_4__actions__["_196" /* WORKSPACE_ADD */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["_202" /* WORKSPACE_UPDATE */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["_199" /* WORKSPACE_DELETE */]:return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({},state,{loading:true});case __WEBPACK_IMPORTED_MODULE_4__actions__["_205" /* WORKSPACE_VALIDATE */]:return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({},state,{loading:true,valid:false});case __WEBPACK_IMPORTED_MODULE_4__actions__["_207" /* WORKSPACE_VALIDATE_SUCCESS */]:return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({},state,{loading:false,valid:true});case __WEBPACK_IMPORTED_MODULE_4__actions__["_206" /* WORKSPACE_VALIDATE_FAIL */]:return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({},state,{loading:false,valid:false});case __WEBPACK_IMPORTED_MODULE_4__actions__["_198" /* WORKSPACE_ADD_SUCCESS */]:Object(__WEBPACK_IMPORTED_MODULE_6__storage__["b" /* setItem */])('selectedWorkspace',action.result._id);return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({},state,{allIds:[].concat(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(state.allIds),[action.result._id]),byId:__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({},state.byId,__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({},action.result._id,getWorkspace(action.result))),rawDataById:__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({},state.rawDataById,__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({},action.result._id,getWorkspace(action.result))),loading:false});case __WEBPACK_IMPORTED_MODULE_4__actions__["_204" /* WORKSPACE_UPDATE_SUCCESS */]:return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({},state,{byId:__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({},state.byId,__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({},action.payload.id,__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({},state.byId[action.payload.id],action.payload.data))),rawDataById:__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({},state.rawDataById,__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({},action.payload.id,__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({},state.rawDataById[action.payload.id],action.payload.data))),loading:false,valid:true});case __WEBPACK_IMPORTED_MODULE_4__actions__["_201" /* WORKSPACE_DELETE_SUCCESS */]:{var workspaceId=action.result;return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({},state,{allIds:state.allIds.filter(function(id){return id!==workspaceId;}),byId:Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["omit"])(state.byId,workspaceId),rawDataById:Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["omit"])(state.rawDataById,workspaceId),loading:false});}case __WEBPACK_IMPORTED_MODULE_4__actions__["_145" /* REQUEST_FINISHED */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["_197" /* WORKSPACE_ADD_FAIL */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["_203" /* WORKSPACE_UPDATE_FAIL */]:case __WEBPACK_IMPORTED_MODULE_4__actions__["_200" /* WORKSPACE_DELETE_FAIL */]:return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({},state,{loading:false});case __WEBPACK_IMPORTED_MODULE_4__actions__["_19" /* COMPANIES_REMOVE_SUCCESS */]:{var companyId=action.result;var workspacesIdToRemove=state.allIds.filter(function(workspaceId){var workspace=state.rawDataById[workspaceId];return workspace.companyId===companyId;});return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({},state,{allIds:state.allIds.filter(function(id){return workspacesIdToRemove.indexOf(id)===-1;}),byId:Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["omit"])(state.byId,workspacesIdToRemove),rawDataById:Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["omit"])(state.rawDataById,workspacesIdToRemove)});}default:return state;}});// WORKSPACES
var addWorkspace=function addWorkspace(name,description){return function(dispatch,getState){var _getState=getState(),companies=_getState.companies;return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_196" /* WORKSPACE_ADD */],__WEBPACK_IMPORTED_MODULE_4__actions__["_145" /* REQUEST_FINISHED */],__WEBPACK_IMPORTED_MODULE_4__actions__["_197" /* WORKSPACE_ADD_FAIL */]],promise:function promise(client){return client.post('/workspaces',{data:{id:companies.selectedId,name:name,description:description}});}});};};var updateWorkspace=function updateWorkspace(id,data){return function(dispatch){return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_202" /* WORKSPACE_UPDATE */],__WEBPACK_IMPORTED_MODULE_4__actions__["_145" /* REQUEST_FINISHED */],__WEBPACK_IMPORTED_MODULE_4__actions__["_203" /* WORKSPACE_UPDATE_FAIL */]],payload:{id:id,data:data},promise:function promise(client){return client.patch("/workspaces/".concat(id),{data:{data:data}});}});};};var deleteWorkspace=function deleteWorkspace(id){return function(dispatch){return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_199" /* WORKSPACE_DELETE */],__WEBPACK_IMPORTED_MODULE_4__actions__["_145" /* REQUEST_FINISHED */],__WEBPACK_IMPORTED_MODULE_4__actions__["_200" /* WORKSPACE_DELETE_FAIL */]],payload:{id:id},promise:function promise(client){return client["delete"]("/workspaces/".concat(id));}});};};var validateWorkspace=function validateWorkspace(companyId,name){return function(dispatch,getState){var _getState2=getState(),companies=_getState2.companies;return dispatch({types:[__WEBPACK_IMPORTED_MODULE_4__actions__["_205" /* WORKSPACE_VALIDATE */],__WEBPACK_IMPORTED_MODULE_4__actions__["_207" /* WORKSPACE_VALIDATE_SUCCESS */],__WEBPACK_IMPORTED_MODULE_4__actions__["_206" /* WORKSPACE_VALIDATE_FAIL */]],promise:function promise(client){return client.get('/workspaces/validation',{params:{id:companyId||companies.selectedId,name:name}});}});};};// SOCKET EVENTS
var connectWorkspacesSocketEvents=function connectWorkspacesSocketEvents(){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__actions__["_159" /* SOCKET_SUBSCRIBE */],event:'company:workspace:added',callback:__WEBPACK_IMPORTED_MODULE_4__actions__["_198" /* WORKSPACE_ADD_SUCCESS */]});dispatch({type:__WEBPACK_IMPORTED_MODULE_4__actions__["_159" /* SOCKET_SUBSCRIBE */],event:'company:workspace:updated',callback:function callback(payload){dispatch({type:__WEBPACK_IMPORTED_MODULE_4__actions__["_204" /* WORKSPACE_UPDATE_SUCCESS */],payload:{id:payload._id,data:getWorkspace(payload)}});Object(__WEBPACK_IMPORTED_MODULE_5_redux_modules_quickMessages__["b" /* showQuickMessage */])('Changes were saved').call(_this,dispatch);}});dispatch({type:__WEBPACK_IMPORTED_MODULE_4__actions__["_159" /* SOCKET_SUBSCRIBE */],event:'company:workspace:removed',callback:__WEBPACK_IMPORTED_MODULE_4__actions__["_201" /* WORKSPACE_DELETE_SUCCESS */]});};};

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return resetErrorId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setErrorId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
var initialState={errorId:null};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1?arguments[1]:undefined;switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["_76" /* ERROR_HANDLER_SET */]:return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{errorId:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(action,'error.errorId'),errorMessage:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(action,'error.errorMessage')});case __WEBPACK_IMPORTED_MODULE_1__actions__["_75" /* ERROR_HANDLER_RESET */]:return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state,{errorId:null});default:return state;}});var resetErrorId=function resetErrorId(){return{type:__WEBPACK_IMPORTED_MODULE_1__actions__["_75" /* ERROR_HANDLER_RESET */]};};var setErrorId=function setErrorId(errorId){return{type:__WEBPACK_IMPORTED_MODULE_1__actions__["_76" /* ERROR_HANDLER_SET */],error:{errorId:errorId}};};

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Toolbar.default;
  }
});

var _Toolbar = _interopRequireDefault(__webpack_require__(855));

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _NoSsr.default;
  }
});

var _NoSsr = _interopRequireDefault(__webpack_require__(858));

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(862)();
}


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isHorizontal = isHorizontal;
exports.getAnchor = getAnchor;
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _Modal = _interopRequireDefault(__webpack_require__(198));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _Slide = _interopRequireDefault(__webpack_require__(275));

var _Paper = _interopRequireDefault(__webpack_require__(63));

var _helpers = __webpack_require__(29);

var _transitions = __webpack_require__(88);

var oppositeDirection = {
  left: 'right',
  right: 'left',
  top: 'down',
  bottom: 'up'
};

function isHorizontal(props) {
  return ['left', 'right'].indexOf(props.anchor) !== -1;
}

function getAnchor(props) {
  return props.theme.direction === 'rtl' && isHorizontal(props) ? oppositeDirection[props.anchor] : props.anchor;
}

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {},

    /* Styles applied to the root element if `variant="permanent or persistent"`. */
    docked: {
      flex: '0 0 auto'
    },

    /* Styles applied to the `Paper` component. */
    paper: {
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      flex: '1 0 auto',
      zIndex: theme.zIndex.drawer,
      WebkitOverflowScrolling: 'touch',
      // Add iOS momentum scrolling.
      // temporary style
      position: 'fixed',
      top: 0,
      // We disable the focus ring for mouse, touch and keyboard users.
      // At some point, it would be better to keep it for keyboard users.
      // :focus-ring CSS pseudo-class will help.
      outline: 'none'
    },

    /* Styles applied to the `Paper` component if `anchor="left"`. */
    paperAnchorLeft: {
      left: 0,
      right: 'auto'
    },

    /* Styles applied to the `Paper` component if `anchor="right"`. */
    paperAnchorRight: {
      left: 'auto',
      right: 0
    },

    /* Styles applied to the `Paper` component if `anchor="top"`. */
    paperAnchorTop: {
      top: 0,
      left: 0,
      bottom: 'auto',
      right: 0,
      height: 'auto',
      maxHeight: '100%'
    },

    /* Styles applied to the `Paper` component if `anchor="bottom"`. */
    paperAnchorBottom: {
      top: 'auto',
      left: 0,
      bottom: 0,
      right: 0,
      height: 'auto',
      maxHeight: '100%'
    },

    /* Styles applied to the `Paper` component if `anchor="left"` & `variant` is not "temporary". */
    paperAnchorDockedLeft: {
      borderRight: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Paper` component if `anchor="top"` & `variant` is not "temporary". */
    paperAnchorDockedTop: {
      borderBottom: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Paper` component if `anchor="right"` & `variant` is not "temporary". */
    paperAnchorDockedRight: {
      borderLeft: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Paper` component if `anchor="bottom"` & `variant` is not "temporary". */
    paperAnchorDockedBottom: {
      borderTop: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Modal` component. */
    modal: {}
  };
};
/**
 * The properties of the [Modal](/api/modal/) component are available
 * when `variant="temporary"` is set.
 */


exports.styles = styles;

var Drawer =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Drawer, _React$Component);

  function Drawer() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Drawer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Drawer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.mounted = false;
    return _this;
  }

  (0, _createClass2.default)(Drawer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          anchorProp = _this$props.anchor,
          BackdropProps = _this$props.BackdropProps,
          children = _this$props.children,
          classes = _this$props.classes,
          className = _this$props.className,
          elevation = _this$props.elevation,
          _this$props$ModalProp = _this$props.ModalProps;
      _this$props$ModalProp = _this$props$ModalProp === void 0 ? {} : _this$props$ModalProp;
      var BackdropPropsProp = _this$props$ModalProp.BackdropProps,
          ModalProps = (0, _objectWithoutProperties2.default)(_this$props$ModalProp, ["BackdropProps"]),
          onClose = _this$props.onClose,
          open = _this$props.open,
          PaperProps = _this$props.PaperProps,
          SlideProps = _this$props.SlideProps,
          theme = _this$props.theme,
          transitionDuration = _this$props.transitionDuration,
          variant = _this$props.variant,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["anchor", "BackdropProps", "children", "classes", "className", "elevation", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "theme", "transitionDuration", "variant"]);
      var anchor = getAnchor(this.props);

      var drawer = _react.default.createElement(_Paper.default, (0, _extends2.default)({
        elevation: variant === 'temporary' ? elevation : 0,
        square: true,
        className: (0, _classnames.default)(classes.paper, classes["paperAnchor".concat((0, _helpers.capitalize)(anchor))], (0, _defineProperty2.default)({}, classes["paperAnchorDocked".concat((0, _helpers.capitalize)(anchor))], variant !== 'temporary'))
      }, PaperProps), children);

      if (variant === 'permanent') {
        return _react.default.createElement("div", (0, _extends2.default)({
          className: (0, _classnames.default)(classes.root, classes.docked, className)
        }, other), drawer);
      }

      var slidingDrawer = _react.default.createElement(_Slide.default, (0, _extends2.default)({
        in: open,
        direction: oppositeDirection[anchor],
        timeout: transitionDuration,
        appear: this.mounted
      }, SlideProps), drawer);

      if (variant === 'persistent') {
        return _react.default.createElement("div", (0, _extends2.default)({
          className: (0, _classnames.default)(classes.root, classes.docked, className)
        }, other), slidingDrawer);
      } // variant === temporary


      return _react.default.createElement(_Modal.default, (0, _extends2.default)({
        BackdropProps: (0, _extends2.default)({}, BackdropProps, BackdropPropsProp, {
          transitionDuration: transitionDuration
        }),
        className: (0, _classnames.default)(classes.root, classes.modal, className),
        open: open,
        onClose: onClose
      }, other, ModalProps), slidingDrawer);
    }
  }]);
  return Drawer;
}(_react.default.Component);

 false ? Drawer.propTypes = {
  /**
   * Side from which the drawer will appear.
   */
  anchor: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']),

  /**
   * @ignore
   */
  BackdropProps: _propTypes.default.object,

  /**
   * The contents of the drawer.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The elevation of the drawer.
   */
  elevation: _propTypes.default.number,

  /**
   * Properties applied to the [`Modal`](/api/modal/) element.
   */
  ModalProps: _propTypes.default.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * If `true`, the drawer is open.
   */
  open: _propTypes.default.bool,

  /**
   * Properties applied to the [`Paper`](/api/paper/) element.
   */
  PaperProps: _propTypes.default.object,

  /**
   * Properties applied to the [`Slide`](/api/slide/) element.
   */
  SlideProps: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })]),

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['permanent', 'persistent', 'temporary'])
} : void 0;
Drawer.defaultProps = {
  anchor: 'left',
  elevation: 16,
  open: false,
  transitionDuration: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  },
  variant: 'temporary' // Mobile first.

};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDrawer',
  flip: false,
  withTheme: true
})(Drawer);

exports.default = _default;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _RootRef.default;
  }
});

var _RootRef = _interopRequireDefault(__webpack_require__(871));

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Portal.default;
  }
});

var _Portal = _interopRequireDefault(__webpack_require__(872));

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Slide.default;
  }
});

var _Slide = _interopRequireDefault(__webpack_require__(885));

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(181);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _MenuList.default;
  }
});

var _MenuList = _interopRequireDefault(__webpack_require__(898));

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TeamMembersStep__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreateBrandspaceStep__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CongratulationsStep__ = __webpack_require__(931);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TeamMembersStep__["a"]; });
/* unused harmony reexport CreateBrandspaceStep */
/**
 * File that gathers all the steps and by default exports the array of them in the given order.
 * Some of the steps are also exported individually to easily access the step identifier,
 * for example by the left menu to set correct data-oid attributes.
 *//* harmony default export */ __webpack_exports__["b"] = ([__WEBPACK_IMPORTED_MODULE_0__TeamMembersStep__["a" /* default */],__WEBPACK_IMPORTED_MODULE_1__CreateBrandspaceStep__["a" /* default */],__WEBPACK_IMPORTED_MODULE_2__CongratulationsStep__["a" /* default */]]);

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

/**
 * @ignore - internal component.
 */
var FormControlContext = _react.default.createContext();

var _default = FormControlContext;
exports.default = _default;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasValue = hasValue;
exports.isFilled = isFilled;
exports.isAdornedStart = isAdornedStart;

// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function hasValue(value) {
  return value != null && !(Array.isArray(value) && value.length === 0);
} // Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.


function isFilled(obj) {
  var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
} // Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.


function isAdornedStart(obj) {
  return obj.startAdornment;
}

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Grow.default;
  }
});

var _Grow = _interopRequireDefault(__webpack_require__(925));

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CircularProgress.default;
  }
});

var _CircularProgress = _interopRequireDefault(__webpack_require__(926));

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = merge;

function merge() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaults = arguments.length > 1 ? arguments[1] : undefined;

  for (var key in defaults) {
    if (typeof obj[key] === 'undefined') {
      obj[key] = defaults[key];
    }
  }

  return obj;
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function unsupportedProp(props, propName, componentName, location, propFullName) {
  /* istanbul ignore if */
  if (true) {
    return null;
  }

  var propFullNameSafe = propFullName || propName;

  if (typeof props[propName] !== 'undefined') {
    return new Error("The property `".concat(propFullNameSafe, "` is not supported. Please remove it."));
  }

  return null;
}

var _default = unsupportedProp;
exports.default = _default;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withFormControlContext = _interopRequireDefault(__webpack_require__(96));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _IconButton = _interopRequireDefault(__webpack_require__(71));

// @inheritedComponent IconButton
var styles = {
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    transition: 'none',
    '&:hover': {
      // Disable the hover effect for the IconButton.
      backgroundColor: 'transparent'
    }
  },
  checked: {},
  disabled: {},
  input: {
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0
  }
};
/**
 * @ignore - internal component.
 */

exports.styles = styles;

var SwitchBase =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(SwitchBase, _React$Component);

  function SwitchBase(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SwitchBase);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SwitchBase).call(this));

    _this.handleFocus = function (event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }

      var muiFormControl = _this.props.muiFormControl;

      if (muiFormControl && muiFormControl.onFocus) {
        muiFormControl.onFocus(event);
      }
    };

    _this.handleBlur = function (event) {
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }

      var muiFormControl = _this.props.muiFormControl;

      if (muiFormControl && muiFormControl.onBlur) {
        muiFormControl.onBlur(event);
      }
    };

    _this.handleInputChange = function (event) {
      var checked = event.target.checked;

      if (!_this.isControlled) {
        _this.setState({
          checked: checked
        });
      }

      if (_this.props.onChange) {
        _this.props.onChange(event, checked);
      }
    };

    _this.isControlled = props.checked != null;
    _this.state = {};

    if (!_this.isControlled) {
      // not controlled, use internal state
      _this.state.checked = props.defaultChecked !== undefined ? props.defaultChecked : false;
    }

    return _this;
  }

  (0, _createClass2.default)(SwitchBase, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          autoFocus = _this$props.autoFocus,
          checkedProp = _this$props.checked,
          checkedIcon = _this$props.checkedIcon,
          classes = _this$props.classes,
          classNameProp = _this$props.className,
          defaultChecked = _this$props.defaultChecked,
          disabledProp = _this$props.disabled,
          icon = _this$props.icon,
          id = _this$props.id,
          inputProps = _this$props.inputProps,
          inputRef = _this$props.inputRef,
          muiFormControl = _this$props.muiFormControl,
          name = _this$props.name,
          onBlur = _this$props.onBlur,
          onChange = _this$props.onChange,
          onFocus = _this$props.onFocus,
          readOnly = _this$props.readOnly,
          required = _this$props.required,
          tabIndex = _this$props.tabIndex,
          type = _this$props.type,
          value = _this$props.value,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["autoFocus", "checked", "checkedIcon", "classes", "className", "defaultChecked", "disabled", "icon", "id", "inputProps", "inputRef", "muiFormControl", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"]);
      var disabled = disabledProp;

      if (muiFormControl) {
        if (typeof disabled === 'undefined') {
          disabled = muiFormControl.disabled;
        }
      }

      var checked = this.isControlled ? checkedProp : this.state.checked;
      var hasLabelFor = type === 'checkbox' || type === 'radio';
      return _react.default.createElement(_IconButton.default, (0, _extends2.default)({
        component: "span",
        className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.checked, checked), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), classNameProp),
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      }, other), checked ? checkedIcon : icon, _react.default.createElement("input", (0, _extends2.default)({
        autoFocus: autoFocus,
        checked: checkedProp,
        defaultChecked: defaultChecked,
        className: classes.input,
        disabled: disabled,
        id: hasLabelFor && id,
        name: name,
        onChange: this.handleInputChange,
        readOnly: readOnly,
        ref: inputRef,
        required: required,
        tabIndex: tabIndex,
        type: type,
        value: value
      }, inputProps)));
    }
  }]);
  return SwitchBase;
}(_react.default.Component); // NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.


 false ? SwitchBase.propTypes = {
  /**
   * If `true`, the input will be focused during the first mount.
   */
  autoFocus: _propTypes.default.bool,

  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   */
  defaultChecked: _propTypes.default.bool,

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes.default.node.isRequired,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,

  /**
   * Attributes applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * @ignore
   */
  muiFormControl: _propTypes.default.object,

  /*
   * @ignore
   */
  name: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.checked`.
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: _propTypes.default.bool,

  /**
   * If `true`, the input will be required.
   */
  required: _propTypes.default.bool,

  /**
   * @ignore
   */
  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * The input component property `type`.
   */
  type: _propTypes.default.string.isRequired,

  /**
   * The value of the component.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool])
} : void 0;

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiPrivateSwitchBase'
})((0, _withFormControlContext.default)(SwitchBase));

exports.default = _default;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Collapse.default;
  }
});

var _Collapse = _interopRequireDefault(__webpack_require__(988));

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ExpansionPanel.default;
  }
});

var _ExpansionPanel = _interopRequireDefault(__webpack_require__(994));

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ExpansionPanelDetails.default;
  }
});

var _ExpansionPanelDetails = _interopRequireDefault(__webpack_require__(997));

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ExpansionPanelSummary.default;
  }
});

var _ExpansionPanelSummary = _interopRequireDefault(__webpack_require__(998));

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(150);

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _withWidth.default;
  }
});

var _withWidth = _interopRequireWildcard(__webpack_require__(1015));

Object.keys(_withWidth).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _withWidth[key];
    }
  });
});

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Table.default;
  }
});

var _Table = _interopRequireDefault(__webpack_require__(1065));

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableBody.default;
  }
});

var _TableBody = _interopRequireDefault(__webpack_require__(1066));

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableHead.default;
  }
});

var _TableHead = _interopRequireDefault(__webpack_require__(1070));

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableRow.default;
  }
});

var _TableRow = _interopRequireDefault(__webpack_require__(1074));

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_theme_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_i18n_i18n__ = __webpack_require__(15);
var _dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_11_i18n_i18n__["a" /* default */].loc.localize;var styles=function styles(theme){return{infoIcon:{width:16,height:16,color:theme.palette.colors.white,backgroundColor:'#6F99BD',borderColor:'#6F99BD',padding:0,'&:hover':{backgroundColor:"".concat(theme.palette.colors.epsilonHover," !important"),borderColor:"".concat(theme.palette.colors.epsilonHover," !important")}},infoIconWhite:{width:15,height:15,color:'#6F99BD',border:'1px solid #6F99BD',padding:0,marginLeft:10},/* popover */popover:{pointerEvents:'none'},popoverText:{textAlign:'left',marginBottom:10},popoverTextSimple:{textAlign:'left'}};};var RolesTooltip=(_dec=Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["N" /* withStyles */])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(RolesTooltip,_Component);function RolesTooltip(props){var _this;__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,RolesTooltip);_this=__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(RolesTooltip).call(this,props));_this.handlePopoverClose=_this.handlePopoverClose.bind(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.handlePopoverOpen=_this.handlePopoverOpen.bind(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.state={infoAnchor:null};return _this;}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(RolesTooltip,[{key:"handlePopoverOpen",value:function handlePopoverOpen(event){this.setState({infoAnchor:event.currentTarget});}},{key:"handlePopoverClose",value:function handlePopoverClose(){this.setState({infoAnchor:null});}},{key:"render",value:function render(){var _this2=this;var infoAnchor=this.state.infoAnchor;var open=Boolean(infoAnchor);var _this$props=this.props,classes=_this$props.classes,tableId=_this$props.tableId;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["p" /* IconButton */],{className:this.props.showGuestTooltip||this.props.text?classes.infoIconWhite:classes.infoIcon,color:"primary",component:"span",disableRipple:true,"aria-owns":open?"info-popover-".concat(tableId||'generic'):undefined,"aria-haspopup":"true",onMouseEnter:function onMouseEnter(e){return _this2.handlePopoverOpen(e);},onMouseLeave:function onMouseLeave(){return _this2.handlePopoverClose();}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_theme_icons__["N" /* Info */],null)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["z" /* Popover */],{id:"info-popover-".concat(tableId||'generic'),className:classes.popover,open:open,anchorEl:infoAnchor,anchorOrigin:{vertical:'top',horizontal:'center'},transformOrigin:{vertical:'bottom',horizontal:'center'},disableRestoreFocus:true,PaperProps:{style:{width:300,padding:20}},onClose:this.handlePopoverClose},!this.props.text&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["M" /* Typography */],{variant:"subtitle1",gutterBottom:true},localize('users-roles-popover-title')),[__WEBPACK_IMPORTED_MODULE_9__config__["_62" /* USER_TABLE_REDUCE_USERS */],__WEBPACK_IMPORTED_MODULE_9__config__["_58" /* USER_TABLE_ADMINS_AND_MEMBERS */]].includes(tableId)&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["M" /* Typography */],{variant:"body2",className:classes.popoverText},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("strong",null,localize('users-roles-popover-admin'),": "),localize('users-roles-popover-admin-description')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["M" /* Typography */],{variant:"body2",className:classes.popoverText},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("strong",null,localize('users-roles-popover-member'),": "),localize('users-roles-popover-member-description'))),this.props.text&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["M" /* Typography */],{variant:"body2",className:classes.popoverTextSimple},this.props.text),([__WEBPACK_IMPORTED_MODULE_9__config__["_62" /* USER_TABLE_REDUCE_USERS */],__WEBPACK_IMPORTED_MODULE_9__config__["_60" /* USER_TABLE_GUESTS */]].includes(tableId)||this.props.showGuestTooltip)&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["M" /* Typography */],{variant:"body2",className:classes.popoverText},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("strong",null,localize('users-roles-popover-guest'),": "),localize('users-roles-popover-guest-description'))));}}]);return RolesTooltip;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]))||_class);RolesTooltip.propTypes={classes:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,maxLength:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,tableId:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,infoAnchor:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,showGuestTooltip:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,text:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (RolesTooltip);

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PERMISSIONS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hasFeature; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redux_store__ = __webpack_require__(82);
var _permissionMap;/**
 * Add permission here
 *
 */var PERMISSIONS={COMPANY:{ADD_USER_TO_COMPANY:'ADD_USER_TO_COMPANY',CREATE_BRANDSPACE:'CREATE_BRANDSPACE',DELETE_BRANDSPACE:'DELETE_BRANDSPACE',EDIT_BRANDSPACE:'EDIT_BRANDSPACE',FONT_UPLOAD:'FONT_UPLOAD'}};/**
 * Map permission to property in redux store.
 *
 */var permissionMap=(_permissionMap={},__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_permissionMap,PERMISSIONS.COMPANY.ADD_USER_TO_COMPANY,function(_ref){var company=_ref.company;return true;}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_permissionMap,PERMISSIONS.COMPANY.CREATE_BRANDSPACE,function(_ref2){var company=_ref2.company;return company.isActive;}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_permissionMap,PERMISSIONS.COMPANY.DELETE_BRANDSPACE,function(_ref3){var company=_ref3.company;return company.isActive;}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_permissionMap,PERMISSIONS.COMPANY.EDIT_BRANDSPACE,function(_ref4){var company=_ref4.company;return company.isActive;}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_permissionMap,PERMISSIONS.COMPANY.FONT_UPLOAD,function(_ref5){var company=_ref5.company;return company.isActive;}),_permissionMap);/**
 * Get context from redux store.
 *
 * @returns {{company: *}}
 */function createContext(){var _store$getState=__WEBPACK_IMPORTED_MODULE_1__redux_store__["a" /* default */].getState(),_store$getState$compa=_store$getState.companies,selectedId=_store$getState$compa.selectedId,rawDataById=_store$getState$compa.rawDataById;return{company:rawDataById[selectedId]};}/**
 * Check if feature is available for user.
 *
 * @param feature
 * @returns {*}
 */var hasFeature=function hasFeature(_ref6){var feature=_ref6.feature;if(!feature||!permissionMap[feature]){return undefined;}return permissionMap[feature](createContext());};

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_i18n_i18n__ = __webpack_require__(15);
var _dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_10_i18n_i18n__["a" /* default */].loc.localize;var styles=function styles(){return{root:{marginLeft:18,fontSize:16,fontWeight:'bold',marginTop:30,padding:'10px 0'},requiredIndicator:{fontSize:'60%',verticalAlign:'super',marginLeft:3}};};var FormLabel=(_dec=Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(FormLabel,_Component);function FormLabel(){__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,FormLabel);return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(FormLabel).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(FormLabel,[{key:"render",value:function render(){var _this$props=this.props,classes=_this$props.classes,children=_this$props.children,className=_this$props.className,required=_this$props.required;var requiredIndicator=__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span",{className:classes.requiredIndicator},"*");return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{title:required&&localize('required-field'),className:__WEBPACK_IMPORTED_MODULE_9_classnames___default()(classes.root,className)},children,required&&requiredIndicator);}}]);return FormLabel;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]))||_class);FormLabel.propTypes={children:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,classes:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,className:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,required:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (FormLabel);

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = compareObjects;
function compareObjects(objA, objB) {
  var keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (objA === objB) {
    return false;
  }

  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);

  if (aKeys.length !== bKeys.length) {
    return true;
  }

  var keysMap = {};
  var i = void 0,
      len = void 0;

  for (i = 0, len = keys.length; i < len; i++) {
    keysMap[keys[i]] = true;
  }

  for (i = 0, len = aKeys.length; i < len; i++) {
    var key = aKeys[i];
    var aValue = objA[key];
    var bValue = objB[key];

    if (aValue === bValue) {
      continue;
    }

    if (!keysMap[key] || aValue === null || bValue === null || (typeof aValue === 'undefined' ? 'undefined' : _typeof(aValue)) !== 'object' || (typeof bValue === 'undefined' ? 'undefined' : _typeof(bValue)) !== 'object') {
      return true;
    }

    var aValueKeys = Object.keys(aValue);
    var bValueKeys = Object.keys(bValue);

    if (aValueKeys.length !== bValueKeys.length) {
      return true;
    }

    for (var n = 0, length = aValueKeys.length; n < length; n++) {
      var aValueKey = aValueKeys[n];

      if (aValue[aValueKey] !== bValue[aValueKey]) {
        return true;
      }
    }
  }

  return false;
}

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Scrollbars = undefined;

var _Scrollbars = __webpack_require__(1163);

var _Scrollbars2 = _interopRequireDefault(_Scrollbars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Scrollbars2["default"];
exports.Scrollbars = _Scrollbars2["default"];

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ClassNames; });
/* unused harmony export Global */
/* unused harmony export createElement */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return jsx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return keyframes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_cache__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_element_04d85134_browser_esm_js__ = __webpack_require__(459);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__emotion_element_04d85134_browser_esm_js__["a"]; });
/* unused harmony reexport ThemeContext */
/* unused harmony reexport withEmotionCache */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__emotion_utils__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__emotion_serialize__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__emotion_sheet__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__emotion_css__ = __webpack_require__(166);
/* unused harmony reexport css */











var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !__WEBPACK_IMPORTED_MODULE_3__emotion_element_04d85134_browser_esm_js__["e" /* h */].call(props, 'css')) {
    // $FlowFixMe
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"].apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = __WEBPACK_IMPORTED_MODULE_3__emotion_element_04d85134_browser_esm_js__["b" /* E */];
  createElementArgArray[1] = Object(__WEBPACK_IMPORTED_MODULE_3__emotion_element_04d85134_browser_esm_js__["d" /* c */])(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"].apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false;
var Global = /* #__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_3__emotion_element_04d85134_browser_esm_js__["f" /* w */])(function (props, cache) {
  if (false) {
    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
    warnedAboutCssPropForGlobal = true;
  }

  var styles = props.styles;

  if (typeof styles === 'function') {
    return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_3__emotion_element_04d85134_browser_esm_js__["c" /* T */].Consumer, null, function (theme) {
      var serialized = Object(__WEBPACK_IMPORTED_MODULE_5__emotion_serialize__["a" /* serializeStyles */])([styles(theme)]);
      return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(InnerGlobal, {
        serialized: serialized,
        cache: cache
      });
    });
  }

  var serialized = Object(__WEBPACK_IMPORTED_MODULE_5__emotion_serialize__["a" /* serializeStyles */])([styles]);
  return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(InnerGlobal, {
    serialized: serialized,
    cache: cache
  });
});

// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var InnerGlobal = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(InnerGlobal, _React$Component);

  function InnerGlobal(props, context, updater) {
    return _React$Component.call(this, props, context, updater) || this;
  }

  var _proto = InnerGlobal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.sheet = new __WEBPACK_IMPORTED_MODULE_6__emotion_sheet__["a" /* StyleSheet */]({
      key: this.props.cache.key + "-global",
      nonce: this.props.cache.sheet.nonce,
      container: this.props.cache.sheet.container
    }); // $FlowFixMe

    var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");

    if (node !== null) {
      this.sheet.tags.push(node);
    }

    if (this.props.cache.sheet.tags.length) {
      this.sheet.before = this.props.cache.sheet.tags[0];
    }

    this.insertStyles();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.serialized.name !== this.props.serialized.name) {
      this.insertStyles();
    }
  };

  _proto.insertStyles = function insertStyles$1() {
    if (this.props.serialized.next !== undefined) {
      // insert keyframes
      Object(__WEBPACK_IMPORTED_MODULE_4__emotion_utils__["b" /* insertStyles */])(this.props.cache, this.props.serialized.next, true);
    }

    if (this.sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
      this.sheet.before = element;
      this.sheet.flush();
    }

    this.props.cache.insert("", this.props.serialized, this.sheet, false);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.sheet.flush();
  };

  _proto.render = function render() {

    return null;
  };

  return InnerGlobal;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var keyframes = function keyframes() {
  var insertable = __WEBPACK_IMPORTED_MODULE_7__emotion_css__["a" /* default */].apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = Object(__WEBPACK_IMPORTED_MODULE_4__emotion_utils__["a" /* getRegisteredStyles */])(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var Noop = function Noop() {
  return null;
};

var ClassNames = Object(__WEBPACK_IMPORTED_MODULE_3__emotion_element_04d85134_browser_esm_js__["f" /* w */])(function (props, context) {
  return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_3__emotion_element_04d85134_browser_esm_js__["c" /* T */].Consumer, null, function (theme) {
    var hasRendered = false;

    var css = function css() {
      if (hasRendered && "production" !== 'production') {
        throw new Error('css can only be used during render');
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var serialized = Object(__WEBPACK_IMPORTED_MODULE_5__emotion_serialize__["a" /* serializeStyles */])(args, context.registered);

      {
        Object(__WEBPACK_IMPORTED_MODULE_4__emotion_utils__["b" /* insertStyles */])(context, serialized, false);
      }

      return context.key + "-" + serialized.name;
    };

    var cx = function cx() {
      if (hasRendered && "production" !== 'production') {
        throw new Error('cx can only be used during render');
      }

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return merge(context.registered, css, classnames(args));
    };

    var content = {
      css: css,
      cx: cx,
      theme: theme
    };
    var ele = props.children(content);
    hasRendered = true;
    var possiblyStyleElement = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(Noop, null);


    return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null, possiblyStyleElement, ele);
  });
});




/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_sheet__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_stylis__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_weak_memoize__ = __webpack_require__(1187);




// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = '/*|*/';
var needle = delimiter + '}';

function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + '}');
  }
}

var Sheet = {
  current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    // property
    case 1:
      {
        switch (content.charCodeAt(0)) {
          case 64:
            {
              // @import
              Sheet.current.insert(content + ';');
              return '';
            }
          // charcode for l

          case 108:
            {
              // charcode for b
              // this ignores label
              if (content.charCodeAt(2) === 98) {
                return '';
              }
            }
        }

        break;
      }
    // selector

    case 2:
      {
        if (ns === 0) return content + delimiter;
        break;
      }
    // at-rule

    case 3:
      {
        switch (ns) {
          // @font-face, @page
          case 102:
          case 112:
            {
              Sheet.current.insert(selectors[0] + content);
              return '';
            }

          default:
            {
              return content + (at === 0 ? delimiter : '');
            }
        }
      }

    case -2:
      {
        content.split(needle).forEach(toSheet);
      }
  }
};

var createCache = function createCache(options) {
  if (options === undefined) options = {};
  var key = options.key || 'css';
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var stylis = new __WEBPACK_IMPORTED_MODULE_1__emotion_stylis__["a" /* default */](stylisOptions);

  if (false) {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {}; // $FlowFixMe

  var container;

  {
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function (node) {
      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe

      attrib.split(' ').forEach(function (id) {
        inserted[id] = true;
      });

      if (node.parentNode !== container) {
        container.appendChild(node);
      }
    });
  }

  var _insert;

  {
    stylis.use(options.stylisPlugins)(ruleSheet);

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      Sheet.current = sheet;

      if (false) {
        var map = serialized.map;
        Sheet.current = {
          insert: function insert(rule) {
            sheet.insert(rule + map);
          }
        };
      }

      stylis(selector, serialized.styles);

      if (shouldCache) {
        cache.inserted[name] = true;
      }
    };
  }

  if (false) {
    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
    var commentStart = /\/\*/g;
    var commentEnd = /\*\//g;
    stylis.use(function (context, content) {
      switch (context) {
        case -1:
          {
            while (commentStart.test(content)) {
              commentEnd.lastIndex = commentStart.lastIndex;

              if (commentEnd.test(content)) {
                commentStart.lastIndex = commentEnd.lastIndex;
                continue;
              }

              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
            }

            commentStart.lastIndex = 0;
            break;
          }
      }
    });
    stylis.use(function (context, content, selectors) {
      switch (context) {
        case -1:
          {
            var flag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
            var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);

            if (unsafePseudoClasses && cache.compat !== true) {
              unsafePseudoClasses.forEach(function (unsafePseudoClass) {
                var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
                var ignore = ignoreRegExp.test(content);

                if (unsafePseudoClass && !ignore) {
                  console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
                }
              });
            }

            break;
          }
      }
    });
  }

  var cache = {
    key: key,
    sheet: new __WEBPACK_IMPORTED_MODULE_0__emotion_sheet__["a" /* StyleSheet */]({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};

/* harmony default export */ __webpack_exports__["a"] = (createCache);


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return serializeStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_hash__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_unitless__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_memoize__ = __webpack_require__(1192);




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = Object(__WEBPACK_IMPORTED_MODULE_2__emotion_memoize__["a" /* default */])(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (__WEBPACK_IMPORTED_MODULE_1__emotion_unitless__["a" /* default */][key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var shouldWarnAboutInterpolatingClassNameFromCss = true;

function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {
      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else if (false) {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (false) {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];

  if (false) {
    console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
    shouldWarnAboutInterpolatingClassNameFromCss = false;
  }

  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;

if (false) {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    if (false) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

    if (stringMode) {
      if (false) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_hash__["a" /* default */])(styles) + identifierName;

  if (false) {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};




/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose__ = __webpack_require__(1193);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose__["a" /* default */])(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(47) && !__webpack_require__(31)(function () {
  return Object.defineProperty(__webpack_require__(217)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(30);
var core = __webpack_require__(41);
var LIBRARY = __webpack_require__(109);
var wksExt = __webpack_require__(218);
var defineProperty = __webpack_require__(43).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(58);
var toIObject = __webpack_require__(60);
var arrayIndexOf = __webpack_require__(168)(false);
var IE_PROTO = __webpack_require__(219)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(43);
var anObject = __webpack_require__(32);
var getKeys = __webpack_require__(110);

module.exports = __webpack_require__(47) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(60);
var gOPN = __webpack_require__(113).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(110);
var gOPS = __webpack_require__(169);
var pIE = __webpack_require__(143);
var toObject = __webpack_require__(53);
var IObject = __webpack_require__(142);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(31)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 311 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(76);
var isObject = __webpack_require__(33);
var invoke = __webpack_require__(313);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 313 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(30).parseInt;
var $trim = __webpack_require__(128).trim;
var ws = __webpack_require__(223);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(30).parseFloat;
var $trim = __webpack_require__(128).trim;

module.exports = 1 / $parseFloat(__webpack_require__(223) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(85);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(33);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 318 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(112);
var descriptor = __webpack_require__(107);
var setToStringTag = __webpack_require__(127);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(59)(IteratorPrototype, __webpack_require__(35)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(32);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(562);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(76);
var toObject = __webpack_require__(53);
var IObject = __webpack_require__(142);
var toLength = __webpack_require__(37);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(53);
var toAbsoluteIndex = __webpack_require__(111);
var toLength = __webpack_require__(37);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(238);
__webpack_require__(12)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(47) && /./g.flags != 'g') __webpack_require__(43).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(172)
});


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(109);
var global = __webpack_require__(30);
var ctx = __webpack_require__(75);
var classof = __webpack_require__(144);
var $export = __webpack_require__(12);
var isObject = __webpack_require__(33);
var aFunction = __webpack_require__(76);
var anInstance = __webpack_require__(131);
var forOf = __webpack_require__(175);
var speciesConstructor = __webpack_require__(145);
var task = __webpack_require__(240).set;
var microtask = __webpack_require__(582)();
var newPromiseCapabilityModule = __webpack_require__(328);
var perform = __webpack_require__(583);
var userAgent = __webpack_require__(176);
var promiseResolve = __webpack_require__(329);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(35)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(132)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(127)($Promise, PROMISE);
__webpack_require__(130)(PROMISE);
Wrapper = __webpack_require__(41)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(171)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(76);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(32);
var isObject = __webpack_require__(33);
var newPromiseCapability = __webpack_require__(328);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(43).f;
var create = __webpack_require__(112);
var redefineAll = __webpack_require__(132);
var ctx = __webpack_require__(75);
var anInstance = __webpack_require__(131);
var forOf = __webpack_require__(175);
var $iterDefine = __webpack_require__(229);
var step = __webpack_require__(324);
var setSpecies = __webpack_require__(130);
var DESCRIPTORS = __webpack_require__(47);
var fastKey = __webpack_require__(101).fastKey;
var validate = __webpack_require__(116);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(132);
var getWeak = __webpack_require__(101).getWeak;
var anObject = __webpack_require__(32);
var isObject = __webpack_require__(33);
var anInstance = __webpack_require__(131);
var forOf = __webpack_require__(175);
var createArrayMethod = __webpack_require__(80);
var $has = __webpack_require__(58);
var validate = __webpack_require__(116);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(77);
var toLength = __webpack_require__(37);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(113);
var gOPS = __webpack_require__(169);
var anObject = __webpack_require__(32);
var Reflect = __webpack_require__(30).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(37);
var repeat = __webpack_require__(225);
var defined = __webpack_require__(86);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(110);
var toIObject = __webpack_require__(60);
var isEnum = __webpack_require__(143).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : {}
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}


/***/ }),
/* 337 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 338 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(654);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(341);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(345);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["default"]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["default"]] = observable, _ref2;
}

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(674);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(682);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["default"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(67), __webpack_require__(681)(module)))

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(349);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(246);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(181);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Prompt> outside a <Router>');

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(692);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Redirect> outside a <Router>');

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
      return;
    }

    this.perform();
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var _props = this.props,
        push = _props.push,
        to = _props.to;


    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(181);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var normalizeLocation = function normalizeLocation(object) {
  var _object$pathname = object.pathname,
      pathname = _object$pathname === undefined ? '/' : _object$pathname,
      _object$search = object.search,
      search = _object$search === undefined ? '' : _object$search,
      _object$hash = object.hash,
      hash = _object$hash === undefined ? '' : _object$hash;


  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createLocation = function createLocation(location) {
  return typeof location === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["parsePath"])(location) : normalizeLocation(location);
};

var createURL = function createURL(location) {
  return typeof location === 'string' ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["createPath"])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, 'You cannot %s with <StaticRouter>', methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = 'PUSH';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = 'REPLACE';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);

    var history = {
      createHref: this.createHref,
      action: 'POP',
      location: stripBasename(basename, createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler('go'),
      goBack: staticHandler('goBack'),
      goForward: staticHandler('goForward'),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: '',
  location: '/'
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(183);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Switch> outside a <Router>');
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) return;

      var _element$props = element.props,
          pathProp = _element$props.path,
          exact = _element$props.exact,
          strict = _element$props.strict,
          sensitive = _element$props.sensitive,
          from = _element$props.from;

      var path = pathProp || from;

      if (match == null) {
        child = element;
        match = path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(252);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], { render: function render(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
      } });
  };

  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOCATION_CHANGE; });
/* harmony export (immutable) */ __webpack_exports__["b"] = routerReducer;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  location: null

  /**
   * This reducer will update the state with the most recent location history
   * has transitioned to. This may not be in sync with the router, particularly
   * if you have asynchronously-loaded routes, so reading from and relying on
   * this state is discouraged.
   */
};function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { location: payload });
  }

  return state;
}

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CALL_HISTORY_METHOD; });
/* unused harmony export push */
/* unused harmony export replace */
/* unused harmony export go */
/* unused harmony export goBack */
/* unused harmony export goForward */
/* unused harmony export routerActions */

/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = updateLocation('push');
var replace = updateLocation('replace');
var go = updateLocation('go');
var goBack = updateLocation('goBack');
var goForward = updateLocation('goForward');

var routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(703);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CssBaseline.default;
  }
});

var _CssBaseline = _interopRequireDefault(__webpack_require__(708));

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createGenerateClassName;

var _warning = _interopRequireDefault(__webpack_require__(27));

var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;

function safePrefix(classNamePrefix) {
  var prefix = String(classNamePrefix);
   false ? (0, _warning.default)(prefix.length < 256, "Material-UI: the class name prefix is too long: ".concat(prefix, ".")) : void 0; // Sanitize the string as will be used to prefix the generated class name.

  return prefix.replace(escapeRegex, '-');
} // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js


function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$dangerouslyU = options.dangerouslyUseGlobalCSS,
      dangerouslyUseGlobalCSS = _options$dangerouslyU === void 0 ? false : _options$dangerouslyU,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
      _options$seed = options.seed,
      seed = _options$seed === void 0 ? '' : _options$seed;
  var ruleCounter = 0;
  return function (rule, styleSheet) {
    ruleCounter += 1;
     false ? (0, _warning.default)(ruleCounter < 1e10, ['Material-UI: you might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join('')) : void 0;

    if (dangerouslyUseGlobalCSS && styleSheet && styleSheet.options.name) {
      return "".concat(safePrefix(styleSheet.options.name), "-").concat(rule.key);
    }

    if (true) {
      return "".concat(productionPrefix).concat(seed).concat(ruleCounter);
    } // Help with debuggability.


    if (styleSheet && styleSheet.options.classNamePrefix) {
      return "".concat(safePrefix(styleSheet.options.classNamePrefix), "-").concat(rule.key, "-").concat(seed).concat(ruleCounter);
    }

    return "".concat(rule.key, "-").concat(seed).concat(ruleCounter);
  };
}

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};
var _default = indigo;
exports.default = _default;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};
var _default = pink;
exports.default = _default;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};
var _default = grey;
exports.default = _default;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
var _default = red;
exports.default = _default;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var common = {
  black: '#000',
  white: '#fff'
};
var _default = common;
exports.default = _default;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jssGlobal = _interopRequireDefault(__webpack_require__(719));

var _jssNested = _interopRequireDefault(__webpack_require__(737));

var _jssCamelCase = _interopRequireDefault(__webpack_require__(739));

var _jssDefaultUnit = _interopRequireDefault(__webpack_require__(741));

var _jssVendorPrefixer = _interopRequireDefault(__webpack_require__(743));

var _jssPropsSort = _interopRequireDefault(__webpack_require__(748));

// Subset of jss-preset-default with only the plugins the Material-UI components are using.
function jssPreset() {
  return {
    plugins: [(0, _jssGlobal.default)(), (0, _jssNested.default)(), (0, _jssCamelCase.default)(), (0, _jssDefaultUnit.default)(), // Disable the vendor prefixer server-side, it does nothing.
    // This way, we can get a performance boost.
    // In the documentation, we are using `autoprefixer` to solve this problem.
    typeof window === 'undefined' ? null : (0, _jssVendorPrefixer.default)(), (0, _jssPropsSort.default)()]
  };
}

var _default = jssPreset;
exports.default = _default;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = exports.createGenerateClassName = exports.sheets = exports.RuleList = exports.SheetsManager = exports.SheetsRegistry = exports.toCssValue = exports.getDynamicStyles = undefined;

var _getDynamicStyles = __webpack_require__(720);

Object.defineProperty(exports, 'getDynamicStyles', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getDynamicStyles)['default'];
  }
});

var _toCssValue = __webpack_require__(185);

Object.defineProperty(exports, 'toCssValue', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_toCssValue)['default'];
  }
});

var _SheetsRegistry = __webpack_require__(371);

Object.defineProperty(exports, 'SheetsRegistry', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetsRegistry)['default'];
  }
});

var _SheetsManager = __webpack_require__(721);

Object.defineProperty(exports, 'SheetsManager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetsManager)['default'];
  }
});

var _RuleList = __webpack_require__(152);

Object.defineProperty(exports, 'RuleList', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RuleList)['default'];
  }
});

var _sheets = __webpack_require__(258);

Object.defineProperty(exports, 'sheets', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_sheets)['default'];
  }
});

var _createGenerateClassName = __webpack_require__(374);

Object.defineProperty(exports, 'createGenerateClassName', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createGenerateClassName)['default'];
  }
});

var _Jss = __webpack_require__(725);

var _Jss2 = _interopRequireDefault(_Jss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Creates a new instance of Jss.
 */
var create = exports.create = function create(options) {
  return new _Jss2['default'](options);
};

/**
 * A global Jss instance.
 */
exports['default'] = create();

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Sheets registry to access them all at one place.
 */
var SheetsRegistry = function () {
  function SheetsRegistry() {
    _classCallCheck(this, SheetsRegistry);

    this.registry = [];
  }

  _createClass(SheetsRegistry, [{
    key: 'add',


    /**
     * Register a Style Sheet.
     */
    value: function add(sheet) {
      var registry = this.registry;
      var index = sheet.options.index;


      if (registry.indexOf(sheet) !== -1) return;

      if (registry.length === 0 || index >= this.index) {
        registry.push(sheet);
        return;
      }

      // Find a position.
      for (var i = 0; i < registry.length; i++) {
        if (registry[i].options.index > index) {
          registry.splice(i, 0, sheet);
          return;
        }
      }
    }

    /**
     * Reset the registry.
     */

  }, {
    key: 'reset',
    value: function reset() {
      this.registry = [];
    }

    /**
     * Remove a Style Sheet.
     */

  }, {
    key: 'remove',
    value: function remove(sheet) {
      var index = this.registry.indexOf(sheet);
      this.registry.splice(index, 1);
    }

    /**
     * Convert all attached sheets to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      return this.registry.filter(function (sheet) {
        return sheet.attached;
      }).map(function (sheet) {
        return sheet.toString(options);
      }).join('\n');
    }
  }, {
    key: 'index',


    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

exports['default'] = SheetsRegistry;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _symbolObservable = __webpack_require__(345);

var _symbolObservable2 = _interopRequireDefault(_symbolObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = function (value) {
  return value && value[_symbolObservable2['default']] && value === value[_symbolObservable2['default']]();
};

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = linkRule;
/**
 * Link rule with CSSStyleRule and nested rules with corresponding nested cssRules if both exists.
 */
function linkRule(rule, cssRule) {
  rule.renderable = cssRule;
  if (rule.rules && cssRule.cssRules) rule.rules.link(cssRule.cssRules);
}

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _warning = __webpack_require__(134);

var _warning2 = _interopRequireDefault(_warning);

var _StyleSheet = __webpack_require__(375);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _moduleId = __webpack_require__(724);

var _moduleId2 = _interopRequireDefault(_moduleId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var maxRules = 1e10;


var env = "production";

/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */

exports['default'] = function () {
  var ruleCounter = 0;
  var defaultPrefix = env === 'production' ? 'c' : '';

  return function (rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
      (0, _warning2['default'])(false, '[JSS] You might have a memory leak. Rule counter is at %s.', ruleCounter);
    }

    var prefix = defaultPrefix;
    var jssId = '';

    if (sheet) {
      prefix = sheet.options.classNamePrefix || defaultPrefix;
      if (sheet.options.jss.id != null) jssId += sheet.options.jss.id;
    }

    if (env === 'production') {
      return '' + prefix + _moduleId2['default'] + jssId + ruleCounter;
    }

    return prefix + rule.key + '-' + _moduleId2['default'] + (jssId && '-' + jssId) + '-' + ruleCounter;
  };
};

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _linkRule = __webpack_require__(373);

var _linkRule2 = _interopRequireDefault(_linkRule);

var _RuleList = __webpack_require__(152);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable-next-line no-use-before-define */
var StyleSheet = function () {
  function StyleSheet(styles, options) {
    var _this = this;

    _classCallCheck(this, StyleSheet);

    this.update = function (name, data) {
      if (typeof name === 'string') {
        _this.rules.update(name, data);
      } else {
        _this.rules.update(name);
      }
      return _this;
    };

    this.attached = false;
    this.deployed = false;
    this.linked = false;
    this.classes = {};
    this.options = _extends({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes
    });
    this.renderer = new options.Renderer(this);
    this.rules = new _RuleList2['default'](this.options);

    for (var _name in styles) {
      this.rules.add(_name, styles[_name]);
    }

    this.rules.process();
  }

  /**
   * Attach renderable to the render tree.
   */


  _createClass(StyleSheet, [{
    key: 'attach',
    value: function attach() {
      if (this.attached) return this;
      if (!this.deployed) this.deploy();
      this.renderer.attach();
      if (!this.linked && this.options.link) this.link();
      this.attached = true;
      return this;
    }

    /**
     * Remove renderable from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      if (!this.attached) return this;
      this.renderer.detach();
      this.attached = false;
      return this;
    }

    /**
     * Add a rule to the current stylesheet.
     * Will insert a rule also after the stylesheet has been rendered first time.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, decl, options) {
      var queue = this.queue;

      // Plugins can create rules.
      // In order to preserve the right order, we need to queue all `.addRule` calls,
      // which happen after the first `rules.add()` call.

      if (this.attached && !queue) this.queue = [];

      var rule = this.rules.add(name, decl, options);
      this.options.jss.plugins.onProcessRule(rule);

      if (this.attached) {
        if (!this.deployed) return rule;
        // Don't insert rule directly if there is no stringified version yet.
        // It will be inserted all together when .attach is called.
        if (queue) queue.push(rule);else {
          this.insertRule(rule);
          if (this.queue) {
            this.queue.forEach(this.insertRule, this);
            this.queue = undefined;
          }
        }
        return rule;
      }

      // We can't add rules to a detached style node.
      // We will redeploy the sheet once user will attach it.
      this.deployed = false;

      return rule;
    }

    /**
     * Insert rule into the StyleSheet
     */

  }, {
    key: 'insertRule',
    value: function insertRule(rule) {
      var renderable = this.renderer.insertRule(rule);
      if (renderable && this.options.link) (0, _linkRule2['default'])(rule, renderable);
    }

    /**
     * Create and add rules.
     * Will render also after Style Sheet was rendered the first time.
     */

  }, {
    key: 'addRules',
    value: function addRules(styles, options) {
      var added = [];
      for (var _name2 in styles) {
        added.push(this.addRule(_name2, styles[_name2], options));
      }
      return added;
    }

    /**
     * Get a rule by name.
     */

  }, {
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Delete a rule by name.
     * Returns `true`: if rule has been deleted from the DOM.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(name) {
      var rule = this.rules.get(name);

      if (!rule) return false;

      this.rules.remove(rule);

      if (this.attached && rule.renderable) {
        return this.renderer.deleteRule(rule.renderable);
      }

      return true;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Deploy pure CSS string to a renderable.
     */

  }, {
    key: 'deploy',
    value: function deploy() {
      this.renderer.deploy();
      this.deployed = true;
      return this;
    }

    /**
     * Link renderable CSS rules from sheet with their corresponding models.
     */

  }, {
    key: 'link',
    value: function link() {
      var cssRules = this.renderer.getRules();

      // Is undefined when VirtualRenderer is used.
      if (cssRules) this.rules.link(cssRules);
      this.linked = true;
      return this;
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'toString',


    /**
     * Convert rules to a CSS string.
     */
    value: function toString(options) {
      return this.rules.toString(options);
    }
  }]);

  return StyleSheet;
}();

exports['default'] = StyleSheet;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _warning = _interopRequireDefault(__webpack_require__(27));

var _utils = __webpack_require__(14);

function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseClasses = options.baseClasses,
      newClasses = options.newClasses,
      Component = options.Component;

  if (!newClasses) {
    return baseClasses;
  }

  var nextClasses = (0, _extends2.default)({}, baseClasses);

  if (false) {
    process.env.NODE_ENV !== "production" ? (0, _warning.default)(false, ["Material-UI: the value `".concat(newClasses, "` ") + "provided to the classes property of ".concat((0, _utils.getDisplayName)(Component), " is incorrect."), 'You might want to use the className property instead.'].join('\n')) : void 0;
    return baseClasses;
  }

  Object.keys(newClasses).forEach(function (key) {
     false ? (0, _warning.default)(baseClasses[key] || !newClasses[key], ["Material-UI: the key `".concat(key, "` ") + "provided to the classes property is not implemented in ".concat((0, _utils.getDisplayName)(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','), ".")].join('\n')) : void 0;
     false ? (0, _warning.default)(!newClasses[key] || typeof newClasses[key] === 'string', ["Material-UI: the key `".concat(key, "` ") + "provided to the classes property is not valid for ".concat((0, _utils.getDisplayName)(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n')) : void 0;

    if (newClasses[key]) {
      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }
  });
  return nextClasses;
}

var _default = mergeClasses;
exports.default = _default;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* eslint-disable no-restricted-syntax */
function getThemeProps(params) {
  var theme = params.theme,
      name = params.name,
      props = params.props;

  if (!theme.props || !name || !theme.props[name]) {
    return props;
  } // Resolve default props, code borrow from React source.
  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221


  var defaultProps = theme.props[name];
  var propName;

  for (propName in defaultProps) {
    if (props[propName] === undefined) {
      props[propName] = defaultProps[propName];
    }
  }

  return props;
}

var _default = getThemeProps;
exports.default = _default;

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handledErrors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__errormessages__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__errorids__ = __webpack_require__(22);
var handledErrors=[__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].USER_AUTHENTICATION_REQUIRED,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].WORKSPACE_NAME_ALREADY_EXISTS,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].COMPANY_NAME_ALREADY_EXISTS,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].USER_REACHED_THE_COMPANY_INVITATION_LIMIT];function getErrorMessageById(id){return __WEBPACK_IMPORTED_MODULE_0__errormessages__["a" /* default */][id]||__WEBPACK_IMPORTED_MODULE_0__errormessages__["a" /* default */].UNHANDLED_ERROR(id);}/* harmony default export */ __webpack_exports__["a"] = (getErrorMessageById);

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_routes__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_i18n_i18n__ = __webpack_require__(15);
var _ERROR_MESSAGES;var localize=__WEBPACK_IMPORTED_MODULE_4_i18n_i18n__["a" /* default */].loc.localize;var RELOAD_URL='/?reload-app=true';var DEFAULT_BUTTONS={CLOSE:{label:localize('close'),close:true,autoFocus:true,primary:false},CLOSE_REDIRECT:{label:localize('close'),close:true,autoFocus:true,redirect:__WEBPACK_IMPORTED_MODULE_2_config__["_65" /* XC_URL */],primary:false},UPGRADE:{label:localize('upgrade'),close:true,autoFocus:true,redirect:__WEBPACK_IMPORTED_MODULE_3_routes__["n" /* SUBSCRIPTION */],primary:true},OK:{label:localize('ok'),close:true,autoFocus:true,primary:false},RELOAD:{label:localize('error-messages-button-reload'),close:true,autoFocus:true,redirect:RELOAD_URL,primary:false}};var ERROR_MESSAGES=(_ERROR_MESSAGES={UNHANDLED_ERROR:function UNHANDLED_ERROR(errorId){return{message:localize('error-message-unhandled',errorId),buttons:[DEFAULT_BUTTONS.RELOAD]};}},__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].SEGMENT_NOT_LOADED,{message:localize('subscriptions-error-segment-disabled'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].OFFLINE,{message:localize('error-message-offline'),buttons:[DEFAULT_BUTTONS.RELOAD]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].XHR_FAILED,{message:localize('error-message-xhr-failed'),buttons:[DEFAULT_BUTTONS.RELOAD]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].INVALID_COMPANY_ID_OR_COMPANY_NAME,{message:localize('error-message-invalid-company-id-or-company-name'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].INSUFFICIENT_USER_RIGHTS,{message:localize('error-message-insufficient-rights'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].COMPANY_NOT_FOUND,{message:localize('error-message-company-not-found'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].USER_NOT_VALIDATED,{message:localize('error-message-user-not-validated'),buttons:[{label:localize('error-user-not-validated-resend-button')},DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].DELETE_MYSELF,{message:localize('error-message-delete-myself'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].INVALID_PHONE_NUMBER,{message:localize('error-message-invalid-phone-number'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].INVALID_WEBSITE_URL,{message:localize('error-message-invalid-website-url'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].INVALID_COMPANY_COUNTRY,{message:localize('error-message-.invalid-company-country'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].INVALID_COMPANY_INDUSTRY,{message:localize('error-message-invalid-company-industry'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].INVALID_COMPANY_SIZE,{message:localize('error-message-invalid-company-size'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].FAILED_TO_CREATE_COMPANY_SUBSCRIPTION,{message:localize('error-message-failed-to-create-company-subscription'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].NO_ACTIVE_SUBSCRIPTION,{message:localize('error-message-no-active-subscription'),buttons:[DEFAULT_BUTTONS.UPGRADE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].INVALID_CLOUD_DRIVE_ADDED,{message:localize('error-message-invalid-cloud-drive-added'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].PAYMENT_PROCESSING_FAILED,{message:localize('error-message-payment-processing-failed'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].PAYMENT_METHOD_VERIFICATION_FAILED,{message:localize('error-message-payment-method-verification-failed'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].PAYMENT_METHOD_NOT_PRESENT,{message:localize('error-message-payment-method-not-present'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].PAYMENT_GATEWAY_CURRENCY_INCOMPATIBLE,{message:localize('error-message-payment-gateway-currency-incompatible'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].PAYMENT_PROVIDER_INTERNAL_ERROR,{// eslint-disable-next-line max-len
message:localize('error-message-payment-provider-internal-error'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].PAYMENT_PROVIDER_INTERNAL_COUPON_ERROR,{// eslint-disable-next-line max-len
message:localize('error-message-payment-provider-internal-coupon-error'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].WRONG_FONT_TYPE_UPLOADED,{message:localize('error-message-wrong-font-type-uploaded'),buttons:[DEFAULT_BUTTONS.OK]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].CHECKSUM_CONFLICT_INVALID_FONT_FILE,{message:localize('error-message-checksum-conflict-invalid-font-file'),buttons:[DEFAULT_BUTTONS.OK]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].WORKSPACE_NAME_ALREADY_EXISTS,{message:localize('error-message-workspace-name-already-exists'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].CLOUD_STORAGE_ITEM_NOT_FOLDER,{message:localize('error-message-cloud-storage-item-not-folder'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].CLOUD_STORAGE_FOLDER_NOT_WRITABLE,{message:localize('error-message-cloud-storage-folder-not-writable'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].COMPANY_NAME_ALREADY_EXISTS,{message:localize('error-message-company-name-already-exists'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].INVALID_COMPANY_NAME,{message:localize('error-message-invalid-company-name'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].INVALID_EMAIL,{message:localize('error-message-invalid-email'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].INVALID_WORKSPACE_NAME,{message:localize('error-message-invalid-workspace-name'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].SUBSCRIPTION_PLAN_CURRENCY_MISMATCH,{message:localize('error-message-subscription-plan-currency-mismatch'),buttons:[Object.assign({},DEFAULT_BUTTONS.OK,{redirect:__WEBPACK_IMPORTED_MODULE_3_routes__["n" /* SUBSCRIPTION */]})]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].COMPANY_ALREADY_EXISTS,{message:localize('error-message-company-already-exists'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].USER_ALREADY_EXISTS_IN_COMPANY,{message:localize('error-message-user-already-exists-in-company'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].DOMAIN_ALREADY_EXISTS_IN_COMPANY,{message:localize('error-message-domain-already-exists-in-company'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].FOLDER_ALREADY_EXISTS_IN_COMPANY,{message:localize('error-message-folder-already-exists-in-company'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].SMART_FIELD_ALREADY_EXISTS_IN_COMPANY,{message:localize('error-message-smart-field-already-exists-in-company'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].WORKSPACE_ALREADY_EXISTS_IN_COMPANY,{message:localize('error-message-workspace-already-exists-in-company'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].USER_ALREADY_EXISTS_IN_WORKSPACE,{message:localize('error-message-user-already-exists-in-workspace'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].DOMAIN_ALREADY_EXISTS_IN_WORKSPACE,{message:localize('error-message-domain-already-exists-in-workspace'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].WAITING_FOR_API,{// eslint-disable-next-line max-len
message:localize('error-message-waiting-for-api')}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].CB_NOT_LOADED,{message:localize('error-message-cb-not-loaded',__WEBPACK_IMPORTED_MODULE_4_i18n_i18n__["a" /* default */].getCurrentLanguage()==='de'?__WEBPACK_IMPORTED_MODULE_2_config__["m" /* CB_LIBRARY_SUPPORT_ARTICLE_DE */]:__WEBPACK_IMPORTED_MODULE_2_config__["n" /* CB_LIBRARY_SUPPORT_ARTICLE_EN */]),buttons:[DEFAULT_BUTTONS.RELOAD]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].FAILED_TO_GET_PAYMENT_COUPON,{message:localize('error-message-failed-to-get-payment-coupon'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].INVALID_COUPON_SET_ID,{message:localize('error-message-invalid-coupon-set-id'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].INVALID_COUPON_ID,{message:localize('error-message-invalid-coupon-id'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].FAILED_TO_CREATE_COMPANY_ADDON,{message:localize('error-message-failed-to-create-order-in-payment-gateway'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].FAILED_TO_TRIGGER_PAYMENT_FLOW,{message:localize('error-message-failed-to-create-order-in-payment-gateway'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].COUPON_CODE_ALREADY_EXISTS,{message:localize('error-message-duplicate-coupon-id'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].THE_NUMBER_OF_THE_USERS_CANNOT_BE_LESS_THAN_THE_NUMBER_OF_USERS_OF_COMPANY,{message:localize('error-message-invalid-number-of-users-during-checkout'),buttons:[DEFAULT_BUTTONS.CLOSE]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].API_REQUEST_LIMIT_EXCEEDED,{message:localize('error-cb-api-rate-limit-reached'),buttons:[DEFAULT_BUTTONS.RELOAD]}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_ERROR_MESSAGES,__WEBPACK_IMPORTED_MODULE_1__errorids__["a" /* default */].USER_REACHED_THE_COMPANY_INVITATION_LIMIT,{message:localize('error-number-of-users-on-non-paying-account-exceeded'),buttons:[DEFAULT_BUTTONS.UPGRADE,DEFAULT_BUTTONS.CLOSE]}),_ERROR_MESSAGES);/* harmony default export */ __webpack_exports__["a"] = (ERROR_MESSAGES);

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62);
var settle = __webpack_require__(796);
var buildURL = __webpack_require__(798);
var parseHeaders = __webpack_require__(799);
var isURLSameOrigin = __webpack_require__(800);
var createError = __webpack_require__(382);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(801);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(802);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(797);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadSegment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return trackAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reduxTrackers__ = __webpack_require__(811);
var _this=this;/**
 * Loads the Segment library: the body of the function is taken from
 * https://segment.com/docs/sources/website/analytics.js/quickstart/
 */var loadSegment=function loadSegment(){/* eslint-disable no-console */(function(){/*
		COPY-PASTE NON-MINIFIED SEGMENT SNIPPET (START)
		https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/quickstart/
		*/ // Create a queue, but don't obliterate an existing one!
var analytics=window.analytics=window.analytics||[];// If the real analytics.js is already on the page return.
if(analytics.initialize)return;// If the snippet was invoked already show an error.
if(analytics.invoked){if(window.console&&console.error){console.error('Segment snippet included twice.');}return;}// Invoked flag, to make sure the snippet
// is never invoked twice.
analytics.invoked=true;// A list of the methods in Analytics.js to stub.
analytics.methods=['trackSubmit','trackClick','trackLink','trackForm','pageview','identify','reset','group','track','ready','alias','debug','page','once','off','on','addSourceMiddleware','addIntegrationMiddleware','setAnonymousId','addDestinationMiddleware'];// Define a factory to create stubs. These are placeholders
// for methods in Analytics.js so that you never have to wait
// for it to load to actually record data. The `method` is
// stored as the first argument, so we can replay the data.
analytics.factory=function(method){return function(){var args=Array.prototype.slice.call(arguments);args.unshift(method);analytics.push(args);return analytics;};};// For each of our methods, generate a queueing stub.
for(var i=0;i<analytics.methods.length;i++){var key=analytics.methods[i];analytics[key]=analytics.factory(key);}// Define a method to load Analytics.js from our CDN,
// and that will be sure to only ever load it once.
analytics.load=function(key,options){// Create an async script element based on your key.
var script=document.createElement('script');script.type='text/javascript';script.async=true;script.src='https://cdn.segment.com/analytics.js/v1/'+key+'/analytics.min.js';// Insert our script next to the first script element.
var first=document.getElementsByTagName('script')[0];first.parentNode.insertBefore(script,first);analytics._loadOptions=options;};analytics._writeKey=__WEBPACK_IMPORTED_MODULE_0__config__["_29" /* SEGMENT_TOKEN */];// Add a version to keep track of what's in the wild.
analytics.SNIPPET_VERSION='4.15.3';// Load Analytics.js with your key, which will automatically
// load the tools you've enabled for your account. Boosh!
analytics.load(__WEBPACK_IMPORTED_MODULE_0__config__["_29" /* SEGMENT_TOKEN */]);// Make the first page call to load the integrations. If
// you'd like to manually name or tag the page, edit or
// move this call however you'd like.
analytics.page();/* COPY-PASTE NON-MINIFIED SEGMENT SNIPPET (END) */})();/* eslint-enable no-console */if(false){// Add some logging to Segment's identify and track methods to facilitate inspection and debugging
window.analytics.ready(function(){var actualIdentify=window.analytics.identify;window.analytics.identify=function(){for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}console.log('[Segment] identify',args);// eslint-disable-line
actualIdentify.apply(_this,args);};var actualTrack=window.analytics.track;window.analytics.track=function(){for(var _len2=arguments.length,args=new Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}console.log('[Segment] track',args);// eslint-disable-line
actualTrack.apply(_this,args);};});}};/**
 * Tracks a Redux action with Segment, if an handler for that action is specified in actionHandlers
 * @param {*} action
 */var trackAction=function trackAction(action){__WEBPACK_IMPORTED_MODULE_1__reduxTrackers__["a" /* reduxHandlers */][action.type]&&__WEBPACK_IMPORTED_MODULE_1__reduxTrackers__["a" /* reduxHandlers */][action.type](action);};

/***/ }),
/* 386 */
/***/ (function(module, exports) {

/**
 * Parses an URI
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */

var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;

var parts = [
    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
];

module.exports = function parseuri(str) {
    var src = str,
        b = str.indexOf('['),
        e = str.indexOf(']');

    if (b != -1 && e != -1) {
        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    }

    var m = re.exec(str || ''),
        uri = {},
        i = 14;

    while (i--) {
        uri[parts[i]] = m[i] || '';
    }

    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }

    return uri;
};


/***/ }),
/* 387 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {
module.exports = isBuf;

var withNativeBuffer = typeof Buffer === 'function' && typeof Buffer.isBuffer === 'function';
var withNativeArrayBuffer = typeof ArrayBuffer === 'function';

var isView = function (obj) {
  return typeof ArrayBuffer.isView === 'function' ? ArrayBuffer.isView(obj) : (obj.buffer instanceof ArrayBuffer);
};

/**
 * Returns true if obj is a buffer or an arraybuffer.
 *
 * @api private
 */

function isBuf(obj) {
  return (withNativeBuffer && Buffer.isBuffer(obj)) ||
          (withNativeArrayBuffer && (obj instanceof ArrayBuffer || isView(obj)));
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(263).Buffer))

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var eio = __webpack_require__(822);
var Socket = __webpack_require__(395);
var Emitter = __webpack_require__(118);
var parser = __webpack_require__(262);
var on = __webpack_require__(396);
var bind = __webpack_require__(397);
var debug = __webpack_require__(191)('socket.io-client:manager');
var indexOf = __webpack_require__(394);
var Backoff = __webpack_require__(838);

/**
 * IE6+ hasOwnProperty
 */

var has = Object.prototype.hasOwnProperty;

/**
 * Module exports
 */

module.exports = Manager;

/**
 * `Manager` constructor.
 *
 * @param {String} engine instance or engine uri/opts
 * @param {Object} options
 * @api public
 */

function Manager (uri, opts) {
  if (!(this instanceof Manager)) return new Manager(uri, opts);
  if (uri && ('object' === typeof uri)) {
    opts = uri;
    uri = undefined;
  }
  opts = opts || {};

  opts.path = opts.path || '/socket.io';
  this.nsps = {};
  this.subs = [];
  this.opts = opts;
  this.reconnection(opts.reconnection !== false);
  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
  this.reconnectionDelay(opts.reconnectionDelay || 1000);
  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
  this.randomizationFactor(opts.randomizationFactor || 0.5);
  this.backoff = new Backoff({
    min: this.reconnectionDelay(),
    max: this.reconnectionDelayMax(),
    jitter: this.randomizationFactor()
  });
  this.timeout(null == opts.timeout ? 20000 : opts.timeout);
  this.readyState = 'closed';
  this.uri = uri;
  this.connecting = [];
  this.lastPing = null;
  this.encoding = false;
  this.packetBuffer = [];
  var _parser = opts.parser || parser;
  this.encoder = new _parser.Encoder();
  this.decoder = new _parser.Decoder();
  this.autoConnect = opts.autoConnect !== false;
  if (this.autoConnect) this.open();
}

/**
 * Propagate given event to sockets and emit on `this`
 *
 * @api private
 */

Manager.prototype.emitAll = function () {
  this.emit.apply(this, arguments);
  for (var nsp in this.nsps) {
    if (has.call(this.nsps, nsp)) {
      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
    }
  }
};

/**
 * Update `socket.id` of all sockets
 *
 * @api private
 */

Manager.prototype.updateSocketIds = function () {
  for (var nsp in this.nsps) {
    if (has.call(this.nsps, nsp)) {
      this.nsps[nsp].id = this.generateId(nsp);
    }
  }
};

/**
 * generate `socket.id` for the given `nsp`
 *
 * @param {String} nsp
 * @return {String}
 * @api private
 */

Manager.prototype.generateId = function (nsp) {
  return (nsp === '/' ? '' : (nsp + '#')) + this.engine.id;
};

/**
 * Mix in `Emitter`.
 */

Emitter(Manager.prototype);

/**
 * Sets the `reconnection` config.
 *
 * @param {Boolean} true/false if it should automatically reconnect
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnection = function (v) {
  if (!arguments.length) return this._reconnection;
  this._reconnection = !!v;
  return this;
};

/**
 * Sets the reconnection attempts config.
 *
 * @param {Number} max reconnection attempts before giving up
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionAttempts = function (v) {
  if (!arguments.length) return this._reconnectionAttempts;
  this._reconnectionAttempts = v;
  return this;
};

/**
 * Sets the delay between reconnections.
 *
 * @param {Number} delay
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionDelay = function (v) {
  if (!arguments.length) return this._reconnectionDelay;
  this._reconnectionDelay = v;
  this.backoff && this.backoff.setMin(v);
  return this;
};

Manager.prototype.randomizationFactor = function (v) {
  if (!arguments.length) return this._randomizationFactor;
  this._randomizationFactor = v;
  this.backoff && this.backoff.setJitter(v);
  return this;
};

/**
 * Sets the maximum delay between reconnections.
 *
 * @param {Number} delay
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionDelayMax = function (v) {
  if (!arguments.length) return this._reconnectionDelayMax;
  this._reconnectionDelayMax = v;
  this.backoff && this.backoff.setMax(v);
  return this;
};

/**
 * Sets the connection timeout. `false` to disable
 *
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.timeout = function (v) {
  if (!arguments.length) return this._timeout;
  this._timeout = v;
  return this;
};

/**
 * Starts trying to reconnect if reconnection is enabled and we have not
 * started reconnecting yet
 *
 * @api private
 */

Manager.prototype.maybeReconnectOnOpen = function () {
  // Only try to reconnect if it's the first time we're connecting
  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
    // keeps reconnection from firing twice for the same reconnection loop
    this.reconnect();
  }
};

/**
 * Sets the current transport `socket`.
 *
 * @param {Function} optional, callback
 * @return {Manager} self
 * @api public
 */

Manager.prototype.open =
Manager.prototype.connect = function (fn, opts) {
  debug('readyState %s', this.readyState);
  if (~this.readyState.indexOf('open')) return this;

  debug('opening %s', this.uri);
  this.engine = eio(this.uri, this.opts);
  var socket = this.engine;
  var self = this;
  this.readyState = 'opening';
  this.skipReconnect = false;

  // emit `open`
  var openSub = on(socket, 'open', function () {
    self.onopen();
    fn && fn();
  });

  // emit `connect_error`
  var errorSub = on(socket, 'error', function (data) {
    debug('connect_error');
    self.cleanup();
    self.readyState = 'closed';
    self.emitAll('connect_error', data);
    if (fn) {
      var err = new Error('Connection error');
      err.data = data;
      fn(err);
    } else {
      // Only do this if there is no fn to handle the error
      self.maybeReconnectOnOpen();
    }
  });

  // emit `connect_timeout`
  if (false !== this._timeout) {
    var timeout = this._timeout;
    debug('connect attempt will timeout after %d', timeout);

    // set timer
    var timer = setTimeout(function () {
      debug('connect attempt timed out after %d', timeout);
      openSub.destroy();
      socket.close();
      socket.emit('error', 'timeout');
      self.emitAll('connect_timeout', timeout);
    }, timeout);

    this.subs.push({
      destroy: function () {
        clearTimeout(timer);
      }
    });
  }

  this.subs.push(openSub);
  this.subs.push(errorSub);

  return this;
};

/**
 * Called upon transport open.
 *
 * @api private
 */

Manager.prototype.onopen = function () {
  debug('open');

  // clear old subs
  this.cleanup();

  // mark as open
  this.readyState = 'open';
  this.emit('open');

  // add new subs
  var socket = this.engine;
  this.subs.push(on(socket, 'data', bind(this, 'ondata')));
  this.subs.push(on(socket, 'ping', bind(this, 'onping')));
  this.subs.push(on(socket, 'pong', bind(this, 'onpong')));
  this.subs.push(on(socket, 'error', bind(this, 'onerror')));
  this.subs.push(on(socket, 'close', bind(this, 'onclose')));
  this.subs.push(on(this.decoder, 'decoded', bind(this, 'ondecoded')));
};

/**
 * Called upon a ping.
 *
 * @api private
 */

Manager.prototype.onping = function () {
  this.lastPing = new Date();
  this.emitAll('ping');
};

/**
 * Called upon a packet.
 *
 * @api private
 */

Manager.prototype.onpong = function () {
  this.emitAll('pong', new Date() - this.lastPing);
};

/**
 * Called with data.
 *
 * @api private
 */

Manager.prototype.ondata = function (data) {
  this.decoder.add(data);
};

/**
 * Called when parser fully decodes a packet.
 *
 * @api private
 */

Manager.prototype.ondecoded = function (packet) {
  this.emit('packet', packet);
};

/**
 * Called upon socket error.
 *
 * @api private
 */

Manager.prototype.onerror = function (err) {
  debug('error', err);
  this.emitAll('error', err);
};

/**
 * Creates a new socket for the given `nsp`.
 *
 * @return {Socket}
 * @api public
 */

Manager.prototype.socket = function (nsp, opts) {
  var socket = this.nsps[nsp];
  if (!socket) {
    socket = new Socket(this, nsp, opts);
    this.nsps[nsp] = socket;
    var self = this;
    socket.on('connecting', onConnecting);
    socket.on('connect', function () {
      socket.id = self.generateId(nsp);
    });

    if (this.autoConnect) {
      // manually call here since connecting event is fired before listening
      onConnecting();
    }
  }

  function onConnecting () {
    if (!~indexOf(self.connecting, socket)) {
      self.connecting.push(socket);
    }
  }

  return socket;
};

/**
 * Called upon a socket close.
 *
 * @param {Socket} socket
 */

Manager.prototype.destroy = function (socket) {
  var index = indexOf(this.connecting, socket);
  if (~index) this.connecting.splice(index, 1);
  if (this.connecting.length) return;

  this.close();
};

/**
 * Writes a packet.
 *
 * @param {Object} packet
 * @api private
 */

Manager.prototype.packet = function (packet) {
  debug('writing packet %j', packet);
  var self = this;
  if (packet.query && packet.type === 0) packet.nsp += '?' + packet.query;

  if (!self.encoding) {
    // encode, then write to engine with result
    self.encoding = true;
    this.encoder.encode(packet, function (encodedPackets) {
      for (var i = 0; i < encodedPackets.length; i++) {
        self.engine.write(encodedPackets[i], packet.options);
      }
      self.encoding = false;
      self.processPacketQueue();
    });
  } else { // add packet to the queue
    self.packetBuffer.push(packet);
  }
};

/**
 * If packet buffer is non-empty, begins encoding the
 * next packet in line.
 *
 * @api private
 */

Manager.prototype.processPacketQueue = function () {
  if (this.packetBuffer.length > 0 && !this.encoding) {
    var pack = this.packetBuffer.shift();
    this.packet(pack);
  }
};

/**
 * Clean up transport subscriptions and packet buffer.
 *
 * @api private
 */

Manager.prototype.cleanup = function () {
  debug('cleanup');

  var subsLength = this.subs.length;
  for (var i = 0; i < subsLength; i++) {
    var sub = this.subs.shift();
    sub.destroy();
  }

  this.packetBuffer = [];
  this.encoding = false;
  this.lastPing = null;

  this.decoder.destroy();
};

/**
 * Close the current socket.
 *
 * @api private
 */

Manager.prototype.close =
Manager.prototype.disconnect = function () {
  debug('disconnect');
  this.skipReconnect = true;
  this.reconnecting = false;
  if ('opening' === this.readyState) {
    // `onclose` will not fire because
    // an open event never happened
    this.cleanup();
  }
  this.backoff.reset();
  this.readyState = 'closed';
  if (this.engine) this.engine.close();
};

/**
 * Called upon engine close.
 *
 * @api private
 */

Manager.prototype.onclose = function (reason) {
  debug('onclose');

  this.cleanup();
  this.backoff.reset();
  this.readyState = 'closed';
  this.emit('close', reason);

  if (this._reconnection && !this.skipReconnect) {
    this.reconnect();
  }
};

/**
 * Attempt a reconnection.
 *
 * @api private
 */

Manager.prototype.reconnect = function () {
  if (this.reconnecting || this.skipReconnect) return this;

  var self = this;

  if (this.backoff.attempts >= this._reconnectionAttempts) {
    debug('reconnect failed');
    this.backoff.reset();
    this.emitAll('reconnect_failed');
    this.reconnecting = false;
  } else {
    var delay = this.backoff.duration();
    debug('will wait %dms before reconnect attempt', delay);

    this.reconnecting = true;
    var timer = setTimeout(function () {
      if (self.skipReconnect) return;

      debug('attempting reconnect');
      self.emitAll('reconnect_attempt', self.backoff.attempts);
      self.emitAll('reconnecting', self.backoff.attempts);

      // check again for the case socket closed in above events
      if (self.skipReconnect) return;

      self.open(function (err) {
        if (err) {
          debug('reconnect attempt error');
          self.reconnecting = false;
          self.reconnect();
          self.emitAll('reconnect_error', err.data);
        } else {
          debug('reconnect success');
          self.onreconnect();
        }
      });
    }, delay);

    this.subs.push({
      destroy: function () {
        clearTimeout(timer);
      }
    });
  }
};

/**
 * Called upon successful reconnect.
 *
 * @api private
 */

Manager.prototype.onreconnect = function () {
  var attempt = this.backoff.attempts;
  this.reconnecting = false;
  this.backoff.reset();
  this.updateSocketIds();
  this.emitAll('reconnect', attempt);
};


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies
 */

var XMLHttpRequest = __webpack_require__(264);
var XHR = __webpack_require__(825);
var JSONP = __webpack_require__(834);
var websocket = __webpack_require__(835);

/**
 * Export transports.
 */

exports.polling = polling;
exports.websocket = websocket;

/**
 * Polling transport polymorphic constructor.
 * Decides on xhr vs jsonp based on feature detection.
 *
 * @api private
 */

function polling (opts) {
  var xhr;
  var xd = false;
  var xs = false;
  var jsonp = false !== opts.jsonp;

  if (typeof location !== 'undefined') {
    var isSSL = 'https:' === location.protocol;
    var port = location.port;

    // some user agents have empty `location.port`
    if (!port) {
      port = isSSL ? 443 : 80;
    }

    xd = opts.hostname !== location.hostname || port !== opts.port;
    xs = opts.secure !== isSSL;
  }

  opts.xdomain = xd;
  opts.xscheme = xs;
  xhr = new XMLHttpRequest(opts);

  if ('open' in xhr && !opts.forceJSONP) {
    return new XHR(opts);
  } else {
    if (!jsonp) throw new Error('JSONP disabled');
    return new JSONP(opts);
  }
}


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var Transport = __webpack_require__(265);
var parseqs = __webpack_require__(192);
var parser = __webpack_require__(136);
var inherit = __webpack_require__(193);
var yeast = __webpack_require__(393);
var debug = __webpack_require__(194)('engine.io-client:polling');

/**
 * Module exports.
 */

module.exports = Polling;

/**
 * Is XHR2 supported?
 */

var hasXHR2 = (function () {
  var XMLHttpRequest = __webpack_require__(264);
  var xhr = new XMLHttpRequest({ xdomain: false });
  return null != xhr.responseType;
})();

/**
 * Polling interface.
 *
 * @param {Object} opts
 * @api private
 */

function Polling (opts) {
  var forceBase64 = (opts && opts.forceBase64);
  if (!hasXHR2 || forceBase64) {
    this.supportsBinary = false;
  }
  Transport.call(this, opts);
}

/**
 * Inherits from Transport.
 */

inherit(Polling, Transport);

/**
 * Transport name.
 */

Polling.prototype.name = 'polling';

/**
 * Opens the socket (triggers polling). We write a PING message to determine
 * when the transport is open.
 *
 * @api private
 */

Polling.prototype.doOpen = function () {
  this.poll();
};

/**
 * Pauses polling.
 *
 * @param {Function} callback upon buffers are flushed and transport is paused
 * @api private
 */

Polling.prototype.pause = function (onPause) {
  var self = this;

  this.readyState = 'pausing';

  function pause () {
    debug('paused');
    self.readyState = 'paused';
    onPause();
  }

  if (this.polling || !this.writable) {
    var total = 0;

    if (this.polling) {
      debug('we are currently polling - waiting to pause');
      total++;
      this.once('pollComplete', function () {
        debug('pre-pause polling complete');
        --total || pause();
      });
    }

    if (!this.writable) {
      debug('we are currently writing - waiting to pause');
      total++;
      this.once('drain', function () {
        debug('pre-pause writing complete');
        --total || pause();
      });
    }
  } else {
    pause();
  }
};

/**
 * Starts polling cycle.
 *
 * @api public
 */

Polling.prototype.poll = function () {
  debug('polling');
  this.polling = true;
  this.doPoll();
  this.emit('poll');
};

/**
 * Overloads onData to detect payloads.
 *
 * @api private
 */

Polling.prototype.onData = function (data) {
  var self = this;
  debug('polling got data %s', data);
  var callback = function (packet, index, total) {
    // if its the first message we consider the transport open
    if ('opening' === self.readyState) {
      self.onOpen();
    }

    // if its a close packet, we close the ongoing requests
    if ('close' === packet.type) {
      self.onClose();
      return false;
    }

    // otherwise bypass onData and handle the message
    self.onPacket(packet);
  };

  // decode payload
  parser.decodePayload(data, this.socket.binaryType, callback);

  // if an event did not trigger closing
  if ('closed' !== this.readyState) {
    // if we got data we're not polling
    this.polling = false;
    this.emit('pollComplete');

    if ('open' === this.readyState) {
      this.poll();
    } else {
      debug('ignoring poll - transport state "%s"', this.readyState);
    }
  }
};

/**
 * For polling, send a close packet.
 *
 * @api private
 */

Polling.prototype.doClose = function () {
  var self = this;

  function close () {
    debug('writing close packet');
    self.write([{ type: 'close' }]);
  }

  if ('open' === this.readyState) {
    debug('transport open - closing');
    close();
  } else {
    // in case we're trying to close while
    // handshaking is in progress (GH-164)
    debug('transport not open - deferring close');
    this.once('open', close);
  }
};

/**
 * Writes a packets payload.
 *
 * @param {Array} data packets
 * @param {Function} drain callback
 * @api private
 */

Polling.prototype.write = function (packets) {
  var self = this;
  this.writable = false;
  var callbackfn = function () {
    self.writable = true;
    self.emit('drain');
  };

  parser.encodePayload(packets, this.supportsBinary, function (data) {
    self.doWrite(data, callbackfn);
  });
};

/**
 * Generates uri for connection.
 *
 * @api private
 */

Polling.prototype.uri = function () {
  var query = this.query || {};
  var schema = this.secure ? 'https' : 'http';
  var port = '';

  // cache busting is forced
  if (false !== this.timestampRequests) {
    query[this.timestampParam] = yeast();
  }

  if (!this.supportsBinary && !query.sid) {
    query.b64 = 1;
  }

  query = parseqs.encode(query);

  // avoid port if default for schema
  if (this.port && (('https' === schema && Number(this.port) !== 443) ||
     ('http' === schema && Number(this.port) !== 80))) {
    port = ':' + this.port;
  }

  // prepend ? to query
  if (query.length) {
    query = '?' + query;
  }

  var ipv6 = this.hostname.indexOf(':') !== -1;
  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
};


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/* global Blob File */

/*
 * Module requirements.
 */

var isArray = __webpack_require__(827);

var toString = Object.prototype.toString;
var withNativeBlob = typeof Blob === 'function' ||
                        typeof Blob !== 'undefined' && toString.call(Blob) === '[object BlobConstructor]';
var withNativeFile = typeof File === 'function' ||
                        typeof File !== 'undefined' && toString.call(File) === '[object FileConstructor]';

/**
 * Module exports.
 */

module.exports = hasBinary;

/**
 * Checks for binary data.
 *
 * Supports Buffer, ArrayBuffer, Blob and File.
 *
 * @param {Object} anything
 * @api public
 */

function hasBinary (obj) {
  if (!obj || typeof obj !== 'object') {
    return false;
  }

  if (isArray(obj)) {
    for (var i = 0, l = obj.length; i < l; i++) {
      if (hasBinary(obj[i])) {
        return true;
      }
    }
    return false;
  }

  if ((typeof Buffer === 'function' && Buffer.isBuffer && Buffer.isBuffer(obj)) ||
    (typeof ArrayBuffer === 'function' && obj instanceof ArrayBuffer) ||
    (withNativeBlob && obj instanceof Blob) ||
    (withNativeFile && obj instanceof File)
  ) {
    return true;
  }

  // see: https://github.com/Automattic/has-binary/pull/4
  if (obj.toJSON && typeof obj.toJSON === 'function' && arguments.length === 1) {
    return hasBinary(obj.toJSON(), true);
  }

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key) && hasBinary(obj[key])) {
      return true;
    }
  }

  return false;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(263).Buffer))

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')
  , length = 64
  , map = {}
  , seed = 0
  , i = 0
  , prev;

/**
 * Return a string representing the specified number.
 *
 * @param {Number} num The number to convert.
 * @returns {String} The string representation of the number.
 * @api public
 */
function encode(num) {
  var encoded = '';

  do {
    encoded = alphabet[num % length] + encoded;
    num = Math.floor(num / length);
  } while (num > 0);

  return encoded;
}

/**
 * Return the integer value specified by the given string.
 *
 * @param {String} str The string to convert.
 * @returns {Number} The integer value represented by the string.
 * @api public
 */
function decode(str) {
  var decoded = 0;

  for (i = 0; i < str.length; i++) {
    decoded = decoded * length + map[str.charAt(i)];
  }

  return decoded;
}

/**
 * Yeast: A tiny growing id generator.
 *
 * @returns {String} A unique id.
 * @api public
 */
function yeast() {
  var now = encode(+new Date());

  if (now !== prev) return seed = 0, prev = now;
  return now +'.'+ encode(seed++);
}

//
// Map each character to its index.
//
for (; i < length; i++) map[alphabet[i]] = i;

//
// Expose the `yeast`, `encode` and `decode` functions.
//
yeast.encode = encode;
yeast.decode = decode;
module.exports = yeast;


/***/ }),
/* 394 */
/***/ (function(module, exports) {


var indexOf = [].indexOf;

module.exports = function(arr, obj){
  if (indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var parser = __webpack_require__(262);
var Emitter = __webpack_require__(118);
var toArray = __webpack_require__(837);
var on = __webpack_require__(396);
var bind = __webpack_require__(397);
var debug = __webpack_require__(191)('socket.io-client:socket');
var parseqs = __webpack_require__(192);
var hasBin = __webpack_require__(392);

/**
 * Module exports.
 */

module.exports = exports = Socket;

/**
 * Internal events (blacklisted).
 * These events can't be emitted by the user.
 *
 * @api private
 */

var events = {
  connect: 1,
  connect_error: 1,
  connect_timeout: 1,
  connecting: 1,
  disconnect: 1,
  error: 1,
  reconnect: 1,
  reconnect_attempt: 1,
  reconnect_failed: 1,
  reconnect_error: 1,
  reconnecting: 1,
  ping: 1,
  pong: 1
};

/**
 * Shortcut to `Emitter#emit`.
 */

var emit = Emitter.prototype.emit;

/**
 * `Socket` constructor.
 *
 * @api public
 */

function Socket (io, nsp, opts) {
  this.io = io;
  this.nsp = nsp;
  this.json = this; // compat
  this.ids = 0;
  this.acks = {};
  this.receiveBuffer = [];
  this.sendBuffer = [];
  this.connected = false;
  this.disconnected = true;
  this.flags = {};
  if (opts && opts.query) {
    this.query = opts.query;
  }
  if (this.io.autoConnect) this.open();
}

/**
 * Mix in `Emitter`.
 */

Emitter(Socket.prototype);

/**
 * Subscribe to open, close and packet events
 *
 * @api private
 */

Socket.prototype.subEvents = function () {
  if (this.subs) return;

  var io = this.io;
  this.subs = [
    on(io, 'open', bind(this, 'onopen')),
    on(io, 'packet', bind(this, 'onpacket')),
    on(io, 'close', bind(this, 'onclose'))
  ];
};

/**
 * "Opens" the socket.
 *
 * @api public
 */

Socket.prototype.open =
Socket.prototype.connect = function () {
  if (this.connected) return this;

  this.subEvents();
  this.io.open(); // ensure open
  if ('open' === this.io.readyState) this.onopen();
  this.emit('connecting');
  return this;
};

/**
 * Sends a `message` event.
 *
 * @return {Socket} self
 * @api public
 */

Socket.prototype.send = function () {
  var args = toArray(arguments);
  args.unshift('message');
  this.emit.apply(this, args);
  return this;
};

/**
 * Override `emit`.
 * If the event is in `events`, it's emitted normally.
 *
 * @param {String} event name
 * @return {Socket} self
 * @api public
 */

Socket.prototype.emit = function (ev) {
  if (events.hasOwnProperty(ev)) {
    emit.apply(this, arguments);
    return this;
  }

  var args = toArray(arguments);
  var packet = {
    type: (this.flags.binary !== undefined ? this.flags.binary : hasBin(args)) ? parser.BINARY_EVENT : parser.EVENT,
    data: args
  };

  packet.options = {};
  packet.options.compress = !this.flags || false !== this.flags.compress;

  // event ack callback
  if ('function' === typeof args[args.length - 1]) {
    debug('emitting packet with ack id %d', this.ids);
    this.acks[this.ids] = args.pop();
    packet.id = this.ids++;
  }

  if (this.connected) {
    this.packet(packet);
  } else {
    this.sendBuffer.push(packet);
  }

  this.flags = {};

  return this;
};

/**
 * Sends a packet.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.packet = function (packet) {
  packet.nsp = this.nsp;
  this.io.packet(packet);
};

/**
 * Called upon engine `open`.
 *
 * @api private
 */

Socket.prototype.onopen = function () {
  debug('transport is open - connecting');

  // write connect packet if necessary
  if ('/' !== this.nsp) {
    if (this.query) {
      var query = typeof this.query === 'object' ? parseqs.encode(this.query) : this.query;
      debug('sending connect packet with query %s', query);
      this.packet({type: parser.CONNECT, query: query});
    } else {
      this.packet({type: parser.CONNECT});
    }
  }
};

/**
 * Called upon engine `close`.
 *
 * @param {String} reason
 * @api private
 */

Socket.prototype.onclose = function (reason) {
  debug('close (%s)', reason);
  this.connected = false;
  this.disconnected = true;
  delete this.id;
  this.emit('disconnect', reason);
};

/**
 * Called with socket packet.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onpacket = function (packet) {
  var sameNamespace = packet.nsp === this.nsp;
  var rootNamespaceError = packet.type === parser.ERROR && packet.nsp === '/';

  if (!sameNamespace && !rootNamespaceError) return;

  switch (packet.type) {
    case parser.CONNECT:
      this.onconnect();
      break;

    case parser.EVENT:
      this.onevent(packet);
      break;

    case parser.BINARY_EVENT:
      this.onevent(packet);
      break;

    case parser.ACK:
      this.onack(packet);
      break;

    case parser.BINARY_ACK:
      this.onack(packet);
      break;

    case parser.DISCONNECT:
      this.ondisconnect();
      break;

    case parser.ERROR:
      this.emit('error', packet.data);
      break;
  }
};

/**
 * Called upon a server event.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onevent = function (packet) {
  var args = packet.data || [];
  debug('emitting event %j', args);

  if (null != packet.id) {
    debug('attaching ack callback to event');
    args.push(this.ack(packet.id));
  }

  if (this.connected) {
    emit.apply(this, args);
  } else {
    this.receiveBuffer.push(args);
  }
};

/**
 * Produces an ack callback to emit with an event.
 *
 * @api private
 */

Socket.prototype.ack = function (id) {
  var self = this;
  var sent = false;
  return function () {
    // prevent double callbacks
    if (sent) return;
    sent = true;
    var args = toArray(arguments);
    debug('sending ack %j', args);

    self.packet({
      type: hasBin(args) ? parser.BINARY_ACK : parser.ACK,
      id: id,
      data: args
    });
  };
};

/**
 * Called upon a server acknowlegement.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onack = function (packet) {
  var ack = this.acks[packet.id];
  if ('function' === typeof ack) {
    debug('calling ack %s with %j', packet.id, packet.data);
    ack.apply(this, packet.data);
    delete this.acks[packet.id];
  } else {
    debug('bad ack %s', packet.id);
  }
};

/**
 * Called upon server connect.
 *
 * @api private
 */

Socket.prototype.onconnect = function () {
  this.connected = true;
  this.disconnected = false;
  this.emit('connect');
  this.emitBuffered();
};

/**
 * Emit buffered events (received and emitted).
 *
 * @api private
 */

Socket.prototype.emitBuffered = function () {
  var i;
  for (i = 0; i < this.receiveBuffer.length; i++) {
    emit.apply(this, this.receiveBuffer[i]);
  }
  this.receiveBuffer = [];

  for (i = 0; i < this.sendBuffer.length; i++) {
    this.packet(this.sendBuffer[i]);
  }
  this.sendBuffer = [];
};

/**
 * Called upon server disconnect.
 *
 * @api private
 */

Socket.prototype.ondisconnect = function () {
  debug('server disconnect (%s)', this.nsp);
  this.destroy();
  this.onclose('io server disconnect');
};

/**
 * Called upon forced client/server side disconnections,
 * this method ensures the manager stops tracking us and
 * that reconnections don't get triggered for this.
 *
 * @api private.
 */

Socket.prototype.destroy = function () {
  if (this.subs) {
    // clean subscriptions to avoid reconnections
    for (var i = 0; i < this.subs.length; i++) {
      this.subs[i].destroy();
    }
    this.subs = null;
  }

  this.io.destroy(this);
};

/**
 * Disconnects the socket manually.
 *
 * @return {Socket} self
 * @api public
 */

Socket.prototype.close =
Socket.prototype.disconnect = function () {
  if (this.connected) {
    debug('performing disconnect (%s)', this.nsp);
    this.packet({ type: parser.DISCONNECT });
  }

  // remove socket from pool
  this.destroy();

  if (this.connected) {
    // fire events
    this.onclose('io client disconnect');
  }
  return this;
};

/**
 * Sets the compress flag.
 *
 * @param {Boolean} if `true`, compresses the sending data
 * @return {Socket} self
 * @api public
 */

Socket.prototype.compress = function (compress) {
  this.flags.compress = compress;
  return this;
};

/**
 * Sets the binary flag
 *
 * @param {Boolean} whether the emitted data contains binary
 * @return {Socket} self
 * @api public
 */

Socket.prototype.binary = function (binary) {
  this.flags.binary = binary;
  return this;
};


/***/ }),
/* 396 */
/***/ (function(module, exports) {


/**
 * Module exports.
 */

module.exports = on;

/**
 * Helper for subscriptions.
 *
 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
 * @param {String} event name
 * @param {Function} callback
 * @api public
 */

function on (obj, ev, fn) {
  obj.on(ev, fn);
  return {
    destroy: function () {
      obj.removeListener(ev, fn);
    }
  };
}


/***/ }),
/* 397 */
/***/ (function(module, exports) {

/**
 * Slice reference.
 */

var slice = [].slice;

/**
 * Bind `obj` to `fn`.
 *
 * @param {Object} obj
 * @param {Function|String} fn or string
 * @return {Function}
 * @api public
 */

module.exports = function(obj, fn){
  if ('string' == typeof fn) fn = obj[fn];
  if ('function' != typeof fn) throw new Error('bind() requires a function');
  var args = slice.call(arguments, 2);
  return function(){
    return fn.apply(obj, args.concat(slice.call(arguments)));
  }
};


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function isObject(obj) {
  return null !== obj && 'object' === typeof obj;
}

module.exports = isObject;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    var obj;

    while (queue.length) {
        var item = queue.pop();
        obj = item.obj[item.prop];

        if (Array.isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }

    return obj;
};

exports.arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

exports.merge = function merge(target, source, options) {
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (Array.isArray(target)) {
            target.push(source);
        } else if (typeof target === 'object') {
            if (options.plainObjects || options.allowPrototypes || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (Array.isArray(target) && !Array.isArray(source)) {
        mergeTarget = exports.arrayToObject(target, options);
    }

    if (Array.isArray(target) && Array.isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                if (target[i] && typeof target[i] === 'object') {
                    target[i] = exports.merge(target[i], item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = exports.merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

exports.assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

exports.decode = function (str) {
    try {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    } catch (e) {
        return str;
    }
};

exports.encode = function encode(str) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = typeof str === 'string' ? str : String(str);

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

exports.compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    return compactQueue(queue);
};

exports.isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

exports.isBuffer = function isBuffer(obj) {
    if (obj === null || typeof obj === 'undefined') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

module.exports = {
    'default': 'RFC3986',
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return value;
        }
    },
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(102);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(61);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(249);

var _PathUtils = __webpack_require__(148);

var _createTransitionManager = __webpack_require__(250);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(402);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _AppBar.default;
  }
});

var _AppBar = _interopRequireDefault(__webpack_require__(853));

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _colorManipulator = __webpack_require__(81);

var _ButtonBase = _interopRequireDefault(__webpack_require__(64));

var _helpers = __webpack_require__(29);

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0, _extends2.default)({
      lineHeight: 1.75
    }, theme.typography.button, {
      boxSizing: 'border-box',
      minWidth: 64,
      padding: '6px 16px',
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.text.primary,
      transition: theme.transitions.create(['background-color', 'box-shadow', 'border'], {
        duration: theme.transitions.duration.short
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        },
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }),

    /* Styles applied to the span element that wraps the children. */
    label: {
      width: '100%',
      // assure the correct width for iOS Safari
      display: 'inherit',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    },

    /* Styles applied to the root element if `variant="text"`. */
    text: {
      padding: '6px 8px'
    },

    /* Styles applied to the root element if `variant="text"` and `color="primary"`. */
    textPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */
    textSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
    flat: {},

    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
    flatPrimary: {},

    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
    flatSecondary: {},

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      padding: '5px 16px',
      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
      '&$disabled': {
        border: "1px solid ".concat(theme.palette.action.disabled)
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      color: theme.palette.primary.main,
      border: "1px solid ".concat((0, _colorManipulator.fade)(theme.palette.primary.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.primary.main),
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      color: theme.palette.secondary.main,
      border: "1px solid ".concat((0, _colorManipulator.fade)(theme.palette.secondary.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.secondary.main),
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        border: "1px solid ".concat(theme.palette.action.disabled)
      }
    },

    /* Styles applied to the root element if `variant="[contained | fab]"`. */
    contained: {
      color: theme.palette.getContrastText(theme.palette.grey[300]),
      backgroundColor: theme.palette.grey[300],
      boxShadow: theme.shadows[2],
      '&$focusVisible': {
        boxShadow: theme.shadows[6]
      },
      '&:active': {
        boxShadow: theme.shadows[8]
      },
      '&$disabled': {
        color: theme.palette.action.disabled,
        boxShadow: theme.shadows[0],
        backgroundColor: theme.palette.action.disabledBackground
      },
      '&:hover': {
        backgroundColor: theme.palette.grey.A100,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.grey[300]
        },
        '&$disabled': {
          backgroundColor: theme.palette.action.disabledBackground
        }
      }
    },

    /* Styles applied to the root element if `variant="[contained | fab]"` and `color="primary"`. */
    containedPrimary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.primary.main
        }
      }
    },

    /* Styles applied to the root element if `variant="[contained | fab]"` and `color="secondary"`. */
    containedSecondary: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.secondary.main
        }
      }
    },

    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
    raised: {},
    // legacy

    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
    raisedPrimary: {},
    // legacy

    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
    raisedSecondary: {},
    // legacy

    /* Styles applied to the root element if `variant="[fab | extendedFab]"`. */
    fab: {
      borderRadius: '50%',
      padding: 0,
      minWidth: 0,
      width: 56,
      height: 56,
      boxShadow: theme.shadows[6],
      '&:active': {
        boxShadow: theme.shadows[12]
      }
    },

    /* Styles applied to the root element if `variant="extendedFab"`. */
    extendedFab: {
      borderRadius: 48 / 2,
      padding: '0 16px',
      width: 'auto',
      minWidth: 48,
      height: 48
    },

    /* Styles applied to the ButtonBase root element if the button is keyboard focused. */
    focusVisible: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit',
      borderColor: 'currentColor'
    },

    /* Styles applied to the root element if `mini={true}` & `variant="[fab | extendedFab]"`. */
    mini: {
      width: 40,
      height: 40
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: '4px 8px',
      minWidth: 64,
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"`. */
    sizeLarge: {
      padding: '8px 24px',
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    }
  };
};

exports.styles = styles;

function Button(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      disabled = props.disabled,
      disableFocusRipple = props.disableFocusRipple,
      focusVisibleClassName = props.focusVisibleClassName,
      fullWidth = props.fullWidth,
      mini = props.mini,
      size = props.size,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "disabled", "disableFocusRipple", "focusVisibleClassName", "fullWidth", "mini", "size", "variant"]);
  var fab = variant === 'fab' || variant === 'extendedFab';
  var contained = variant === 'contained' || variant === 'raised';
  var text = variant === 'text' || variant === 'flat';
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.fab, fab), (0, _defineProperty2.default)(_classNames, classes.mini, fab && mini), (0, _defineProperty2.default)(_classNames, classes.extendedFab, variant === 'extendedFab'), (0, _defineProperty2.default)(_classNames, classes.text, text), (0, _defineProperty2.default)(_classNames, classes.textPrimary, text && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.textSecondary, text && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.flat, text), (0, _defineProperty2.default)(_classNames, classes.flatPrimary, text && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.flatSecondary, text && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.contained, contained || fab), (0, _defineProperty2.default)(_classNames, classes.containedPrimary, (contained || fab) && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.containedSecondary, (contained || fab) && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.raised, contained || fab), (0, _defineProperty2.default)(_classNames, classes.raisedPrimary, (contained || fab) && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.raisedSecondary, (contained || fab) && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.outlined, variant === 'outlined'), (0, _defineProperty2.default)(_classNames, classes.outlinedPrimary, variant === 'outlined' && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.outlinedSecondary, variant === 'outlined' && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes["size".concat((0, _helpers.capitalize)(size))], size !== 'medium'), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.fullWidth, fullWidth), (0, _defineProperty2.default)(_classNames, classes.colorInherit, color === 'inherit'), _classNames), classNameProp);
  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
    className: className,
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: (0, _classnames.default)(classes.focusVisible, focusVisibleClassName)
  }, other), _react.default.createElement("span", {
    className: classes.label
  }, children));
}

 false ? Button.propTypes = {
  /**
   * The content of the button.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * If `true`, the button will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   * `disableRipple` must also be true.
   */
  disableFocusRipple: _propTypes.default.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * @ignore
   */
  focusVisibleClassName: _propTypes.default.string,

  /**
   * If `true`, the button will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: _propTypes.default.string,

  /**
   * If `true`, and `variant` is `'fab'`, will use mini floating action button styling.
   */
  mini: _propTypes.default.bool,

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),

  /**
   * @ignore
   */
  type: _propTypes.default.string,

  /**
   * The variant to use.
   * __WARNING__: `flat` and `raised` are deprecated.
   * Instead use `text` and `contained` respectively.
   * `fab` and `extendedFab` are deprecated.
   * Instead use `<Fab>` and `<Fab variant="extended">`
   */
  variant: (0, _utils.chainPropTypes)(_propTypes.default.oneOf(['text', 'outlined', 'contained', 'fab', 'extendedFab', 'flat', 'raised']), function (props) {
    if (props.variant === 'flat') {
      return new Error('Material-UI: the `flat` variant will be removed in the next major release. ' + '`text` is equivalent and should be used instead.');
    }

    if (props.variant === 'raised') {
      return new Error('Material-UI: the `raised` variant will be removed in the next major release. ' + '`contained` is equivalent and should be used instead.');
    }

    if (props.variant === 'fab') {
      return new Error('Material-UI: the `fab` variant will be removed in the next major release. ' + 'The `<Fab>` component is equivalent and should be used instead.');
    }

    if (props.variant === 'extendedFab') {
      return new Error('Material-UI: the `fab` variant will be removed in the next major release. ' + 'The `<Fab>` component with `variant="extended"` is equivalent ' + 'and should be used instead.');
    }

    return null;
  })
} : void 0;
Button.defaultProps = {
  color: 'default',
  component: 'button',
  disabled: false,
  disableFocusRipple: false,
  fullWidth: false,
  mini: false,
  size: 'medium',
  type: 'button',
  variant: 'text'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiButton'
})(Button);

exports.default = _default;

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Drawer.default;
  }
});

var _Drawer = _interopRequireDefault(__webpack_require__(272));

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _style = _interopRequireDefault(__webpack_require__(873));

var _scrollbarSize = _interopRequireDefault(__webpack_require__(410));

var _ownerDocument = _interopRequireDefault(__webpack_require__(93));

var _isOverflowing = _interopRequireDefault(__webpack_require__(881));

var _manageAriaHidden = __webpack_require__(411);

function findIndexOf(data, callback) {
  var idx = -1;
  data.some(function (item, index) {
    if (callback(item)) {
      idx = index;
      return true;
    }

    return false;
  });
  return idx;
}

function getPaddingRight(node) {
  return parseInt((0, _style.default)(node, 'paddingRight') || 0, 10);
}

function setContainerStyle(data) {
  // We are only interested in the actual `style` here because we will override it.
  data.style = {
    overflow: data.container.style.overflow,
    paddingRight: data.container.style.paddingRight
  };
  var style = {
    overflow: 'hidden'
  };

  if (data.overflowing) {
    var scrollbarSize = (0, _scrollbarSize.default)(); // Use computed style, here to get the real padding to add our scrollbar width.

    style.paddingRight = "".concat(getPaddingRight(data.container) + scrollbarSize, "px"); // .mui-fixed is a global helper.

    var fixedNodes = (0, _ownerDocument.default)(data.container).querySelectorAll('.mui-fixed');

    for (var i = 0; i < fixedNodes.length; i += 1) {
      var paddingRight = getPaddingRight(fixedNodes[i]);
      data.prevPaddings.push(paddingRight);
      fixedNodes[i].style.paddingRight = "".concat(paddingRight + scrollbarSize, "px");
    }
  }

  Object.keys(style).forEach(function (key) {
    data.container.style[key] = style[key];
  });
}

function removeContainerStyle(data) {
  // The modal might be closed before it had the chance to be mounted in the DOM.
  if (data.style) {
    Object.keys(data.style).forEach(function (key) {
      data.container.style[key] = data.style[key];
    });
  }

  var fixedNodes = (0, _ownerDocument.default)(data.container).querySelectorAll('.mui-fixed');

  for (var i = 0; i < fixedNodes.length; i += 1) {
    fixedNodes[i].style.paddingRight = "".concat(data.prevPaddings[i], "px");
  }
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */


var ModalManager =
/*#__PURE__*/
function () {
  function ModalManager() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2.default)(this, ModalManager);
    var _options$hideSiblingN = options.hideSiblingNodes,
        hideSiblingNodes = _options$hideSiblingN === void 0 ? true : _options$hideSiblingN,
        _options$handleContai = options.handleContainerOverflow,
        handleContainerOverflow = _options$handleContai === void 0 ? true : _options$handleContai;
    this.hideSiblingNodes = hideSiblingNodes;
    this.handleContainerOverflow = handleContainerOverflow; // this.modals[modalIdx] = modal

    this.modals = []; // this.data[containerIdx] = {
    //   modals: [],
    //   container,
    //   overflowing,
    //   prevPaddings,
    // }

    this.data = [];
  }

  (0, _createClass2.default)(ModalManager, [{
    key: "add",
    value: function add(modal, container) {
      var modalIdx = this.modals.indexOf(modal);

      if (modalIdx !== -1) {
        return modalIdx;
      }

      modalIdx = this.modals.length;
      this.modals.push(modal); // If the modal we are adding is already in the DOM.

      if (modal.modalRef) {
        (0, _manageAriaHidden.ariaHidden)(modal.modalRef, false);
      }

      if (this.hideSiblingNodes) {
        (0, _manageAriaHidden.ariaHiddenSiblings)(container, modal.mountNode, modal.modalRef, true);
      }

      var containerIdx = findIndexOf(this.data, function (item) {
        return item.container === container;
      });

      if (containerIdx !== -1) {
        this.data[containerIdx].modals.push(modal);
        return modalIdx;
      }

      var data = {
        modals: [modal],
        container: container,
        overflowing: (0, _isOverflowing.default)(container),
        prevPaddings: []
      };
      this.data.push(data);
      return modalIdx;
    }
  }, {
    key: "mount",
    value: function mount(modal) {
      var containerIdx = findIndexOf(this.data, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var data = this.data[containerIdx];

      if (!data.style && this.handleContainerOverflow) {
        setContainerStyle(data);
      }
    }
  }, {
    key: "remove",
    value: function remove(modal) {
      var modalIdx = this.modals.indexOf(modal);

      if (modalIdx === -1) {
        return modalIdx;
      }

      var containerIdx = findIndexOf(this.data, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var data = this.data[containerIdx];
      data.modals.splice(data.modals.indexOf(modal), 1);
      this.modals.splice(modalIdx, 1); // If that was the last modal in a container, clean up the container.

      if (data.modals.length === 0) {
        if (this.handleContainerOverflow) {
          removeContainerStyle(data);
        } // In case the modal wasn't in the DOM yet.


        if (modal.modalRef) {
          (0, _manageAriaHidden.ariaHidden)(modal.modalRef, true);
        }

        if (this.hideSiblingNodes) {
          (0, _manageAriaHidden.ariaHiddenSiblings)(data.container, modal.mountNode, modal.modalRef, false);
        }

        this.data.splice(containerIdx, 1);
      } else if (this.hideSiblingNodes) {
        // Otherwise make sure the next top modal is visible to a screen reader.
        var nextTop = data.modals[data.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
        // aria-hidden because the dom element doesn't exist either
        // when modal was unmounted before modalRef gets null

        if (nextTop.modalRef) {
          (0, _manageAriaHidden.ariaHidden)(nextTop.modalRef, false);
        }
      }

      return modalIdx;
    }
  }, {
    key: "isTopModal",
    value: function isTopModal(modal) {
      return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
  }]);
  return ModalManager;
}();

var _default = ModalManager;
exports.default = _default;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = camelizeStyleName;

var _camelize = _interopRequireDefault(__webpack_require__(874));

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
 */
var msPattern = /^-ms-/;

function camelizeStyleName(string) {
  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
}

module.exports = exports["default"];

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = scrollbarSize;

var _inDOM = _interopRequireDefault(__webpack_require__(409));

var size;

function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM.default) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

module.exports = exports["default"];

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ariaHidden = ariaHidden;
exports.ariaHiddenSiblings = ariaHiddenSiblings;
var BLACKLIST = ['template', 'script', 'style'];

function isHideable(node) {
  return node.nodeType === 1 && BLACKLIST.indexOf(node.tagName.toLowerCase()) === -1;
}

function siblings(container, mount, currentNode, callback) {
  var blacklist = [mount, currentNode];
  [].forEach.call(container.children, function (node) {
    if (blacklist.indexOf(node) === -1 && isHideable(node)) {
      callback(node);
    }
  });
}

function ariaHidden(node, show) {
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function ariaHiddenSiblings(container, mountNode, currentNode, show) {
  siblings(container, mountNode, currentNode, function (node) {
    return ariaHidden(node, show);
  });
}

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Backdrop.default;
  }
});

var _Backdrop = _interopRequireDefault(__webpack_require__(883));

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Link> outside a <Router>');

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(252);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _List.default;
  }
});

var _List = _interopRequireDefault(__webpack_require__(899));

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ListItem.default;
  }
});

var _ListItem = _interopRequireDefault(__webpack_require__(901));

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Avatar.default;
  }
});

var _Avatar = _interopRequireDefault(__webpack_require__(419));

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      width: 40,
      height: 40,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(20),
      borderRadius: '50%',
      overflow: 'hidden',
      userSelect: 'none'
    },

    /* Styles applied to the root element if there are children and not `src` or `srcSet`. */
    colorDefault: {
      color: theme.palette.background.default,
      backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
    },

    /* Styles applied to the img element if either `src` or `srcSet` is defined. */
    img: {
      width: '100%',
      height: '100%',
      textAlign: 'center',
      // Handle non-square image. The property isn't supported by IE 11.
      objectFit: 'cover'
    }
  };
};

exports.styles = styles;

function Avatar(props) {
  var alt = props.alt,
      childrenProp = props.children,
      childrenClassNameProp = props.childrenClassName,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      imgProps = props.imgProps,
      sizes = props.sizes,
      src = props.src,
      srcSet = props.srcSet,
      other = (0, _objectWithoutProperties2.default)(props, ["alt", "children", "childrenClassName", "classes", "className", "component", "imgProps", "sizes", "src", "srcSet"]);
  var children = null;
  var img = src || srcSet;

  if (img) {
    children = _react.default.createElement("img", (0, _extends2.default)({
      alt: alt,
      src: src,
      srcSet: srcSet,
      sizes: sizes,
      className: classes.img
    }, imgProps));
  } else if (childrenClassNameProp && _react.default.isValidElement(childrenProp)) {
    children = _react.default.cloneElement(childrenProp, {
      className: (0, _classnames.default)(childrenClassNameProp, childrenProp.props.className)
    });
  } else {
    children = childrenProp;
  }

  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, classes.system, (0, _defineProperty2.default)({}, classes.colorDefault, !img), classNameProp)
  }, other), children);
}

 false ? Avatar.propTypes = {
  /**
   * Used in combination with `src` or `srcSet` to
   * provide an alt attribute for the rendered `img` element.
   */
  alt: _propTypes.default.string,

  /**
   * Used to render icon or text elements inside the Avatar.
   * `src` and `alt` props will not be used and no `img` will
   * be rendered by default.
   *
   * This can be an element, or just a string.
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   * The className of the child element.
   * Used by Chip and ListItemIcon to style the Avatar icon.
   */
  childrenClassName: _propTypes.default.string,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * Attributes applied to the `img` element if the component
   * is used to display an image.
   */
  imgProps: _propTypes.default.object,

  /**
   * The `sizes` attribute for the `img` element.
   */
  sizes: _propTypes.default.string,

  /**
   * The `src` attribute for the `img` element.
   */
  src: _propTypes.default.string,

  /**
   * The `srcSet` attribute for the `img` element.
   */
  srcSet: _propTypes.default.string
} : void 0;
Avatar.defaultProps = {
  component: 'div'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiAvatar'
})(Avatar);

exports.default = _default;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Divider.default;
  }
});

var _Divider = _interopRequireDefault(__webpack_require__(903));

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _setStatic = _interopRequireDefault(__webpack_require__(906));

var setDisplayName = function setDisplayName(displayName) {
  return (0, _setStatic.default)('displayName', displayName);
};

var _default = setDisplayName;
exports.default = _default;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _getDisplayName = _interopRequireDefault(__webpack_require__(907));

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + "(" + (0, _getDisplayName.default)(BaseComponent) + ")";
};

var _default = wrapDisplayName;
exports.default = _default;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FilledInput.default;
  }
});

var _FilledInput = _interopRequireDefault(__webpack_require__(915));

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _OutlinedInput.default;
  }
});

var _OutlinedInput = _interopRequireDefault(__webpack_require__(916));

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _InputLabel.default;
  }
});

var _InputLabel = _interopRequireDefault(__webpack_require__(918));

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormLabel.default;
  }
});

var _FormLabel = _interopRequireDefault(__webpack_require__(919));

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormControl.default;
  }
});

var _FormControl = _interopRequireDefault(__webpack_require__(920));

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(44));

var _scrollbarSize = _interopRequireDefault(__webpack_require__(410));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _Popover = _interopRequireDefault(__webpack_require__(206));

var _MenuList = _interopRequireDefault(__webpack_require__(277));

// @inheritedComponent Popover
var RTL_ORIGIN = {
  vertical: 'top',
  horizontal: 'right'
};
var LTR_ORIGIN = {
  vertical: 'top',
  horizontal: 'left'
};
var styles = {
  /* Styles applied to the `Paper` component. */
  paper: {
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tapable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling.
    WebkitOverflowScrolling: 'touch'
  }
};
exports.styles = styles;

var Menu =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Menu, _React$Component);

  function Menu() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Menu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Menu)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.getContentAnchorEl = function () {
      if (_this.menuListRef.selectedItemRef) {
        return _reactDom.default.findDOMNode(_this.menuListRef.selectedItemRef);
      }

      return _reactDom.default.findDOMNode(_this.menuListRef).firstChild;
    };

    _this.focus = function () {
      if (_this.menuListRef && _this.menuListRef.selectedItemRef) {
        _reactDom.default.findDOMNode(_this.menuListRef.selectedItemRef).focus();

        return;
      }

      var menuList = _reactDom.default.findDOMNode(_this.menuListRef);

      if (menuList && menuList.firstChild) {
        menuList.firstChild.focus();
      }
    };

    _this.handleMenuListRef = function (ref) {
      _this.menuListRef = ref;
    };

    _this.handleEntering = function (element) {
      var _this$props = _this.props,
          disableAutoFocusItem = _this$props.disableAutoFocusItem,
          theme = _this$props.theme;

      var menuList = _reactDom.default.findDOMNode(_this.menuListRef); // Focus so the scroll computation of the Popover works as expected.


      if (disableAutoFocusItem !== true) {
        _this.focus();
      } // Let's ignore that piece of logic if users are already overriding the width
      // of the menu.


      if (menuList && element.clientHeight < menuList.clientHeight && !menuList.style.width) {
        var size = "".concat((0, _scrollbarSize.default)(), "px");
        menuList.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = size;
        menuList.style.width = "calc(100% + ".concat(size, ")");
      }

      if (_this.props.onEntering) {
        _this.props.onEntering(element);
      }
    };

    _this.handleListKeyDown = function (event) {
      if (event.key === 'Tab') {
        event.preventDefault();

        if (_this.props.onClose) {
          _this.props.onClose(event, 'tabKeyDown');
        }
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Menu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.open && this.props.disableAutoFocusItem !== true) {
        this.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          classes = _this$props2.classes,
          disableAutoFocusItem = _this$props2.disableAutoFocusItem,
          MenuListProps = _this$props2.MenuListProps,
          onEntering = _this$props2.onEntering,
          _this$props2$PaperPro = _this$props2.PaperProps,
          PaperProps = _this$props2$PaperPro === void 0 ? {} : _this$props2$PaperPro,
          PopoverClasses = _this$props2.PopoverClasses,
          theme = _this$props2.theme,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["children", "classes", "disableAutoFocusItem", "MenuListProps", "onEntering", "PaperProps", "PopoverClasses", "theme"]);
      return _react.default.createElement(_Popover.default, (0, _extends2.default)({
        getContentAnchorEl: this.getContentAnchorEl,
        classes: PopoverClasses,
        onEntering: this.handleEntering,
        anchorOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
        transformOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
        PaperProps: (0, _extends2.default)({}, PaperProps, {
          classes: (0, _extends2.default)({}, PaperProps.classes, {
            root: classes.paper
          })
        })
      }, other), _react.default.createElement(_MenuList.default, (0, _extends2.default)({
        onKeyDown: this.handleListKeyDown
      }, MenuListProps, {
        ref: this.handleMenuListRef
      }), children));
    }
  }]);
  return Menu;
}(_react.default.Component);

 false ? Menu.propTypes = {
  /**
   * The DOM element used to set the position of the menu.
   */
  anchorEl: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * If `true`, the selected / first menu item will not be auto focused.
   */
  disableAutoFocusItem: _propTypes.default.bool,

  /**
   * Properties applied to the [`MenuList`](/api/menu-list/) element.
   */
  MenuListProps: _propTypes.default.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback
   * @param {string} reason Can be:`"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired before the Menu enters.
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired when the Menu has entered.
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired when the Menu is entering.
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired before the Menu exits.
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired when the Menu has exited.
   */
  onExited: _propTypes.default.func,

  /**
   * Callback fired when the Menu is exiting.
   */
  onExiting: _propTypes.default.func,

  /**
   * If `true`, the menu is visible.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * @ignore
   */
  PaperProps: _propTypes.default.object,

  /**
   * `classes` property applied to the [`Popover`](/api/popover/) element.
   */
  PopoverClasses: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The length of the transition in `ms`, or 'auto'
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])])
} : void 0;
Menu.defaultProps = {
  disableAutoFocusItem: false,
  transitionDuration: 'auto'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiMenu',
  withTheme: true
})(Menu);

exports.default = _default;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _pure = _interopRequireDefault(__webpack_require__(57));

var _SvgIcon = _interopRequireDefault(__webpack_require__(51));

var _ref = _react.default.createElement("path", {
  d: "M7 10l5 5 5-5z"
});

/**
 * @ignore - internal component.
 */
var ArrowDropDown = function ArrowDropDown(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

ArrowDropDown = (0, _pure.default)(ArrowDropDown);
ArrowDropDown.muiName = 'SvgIcon';
var _default = ArrowDropDown;
exports.default = _default;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _utils = __webpack_require__(14);

var _NativeSelectInput = _interopRequireDefault(__webpack_require__(431));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _formControlState = _interopRequireDefault(__webpack_require__(139));

var _withFormControlContext = _interopRequireDefault(__webpack_require__(96));

var _ArrowDropDown = _interopRequireDefault(__webpack_require__(429));

var _Input = _interopRequireDefault(__webpack_require__(205));

// @inheritedComponent Input
var styles = function styles(theme) {
  return {
    /* Styles applied to the `Input` component `root` class. */
    root: {
      position: 'relative',
      width: '100%'
    },

    /* Styles applied to the `Input` component `select` class. */
    select: {
      '-moz-appearance': 'none',
      // Reset
      '-webkit-appearance': 'none',
      // Reset
      // When interacting quickly, the text can end up selected.
      // Native select can't be selected either.
      userSelect: 'none',
      paddingRight: 32,
      borderRadius: 0,
      // Reset
      height: '1.1875em',
      // Reset (19px), match the native input line-height
      width: 'calc(100% - 32px)',
      minWidth: 16,
      // So it doesn't collapse.
      cursor: 'pointer',
      '&:focus': {
        // Show that it's not an text input
        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
        borderRadius: 0 // Reset Chrome style

      },
      // Remove IE 11 arrow
      '&::-ms-expand': {
        display: 'none'
      },
      '&$disabled': {
        cursor: 'default'
      },
      '&[multiple]': {
        height: 'auto'
      },
      '&:not([multiple]) option, &:not([multiple]) optgroup': {
        backgroundColor: theme.palette.background.paper
      }
    },

    /* Styles applied to the `Input` component if `variant="filled"`. */
    filled: {
      width: 'calc(100% - 44px)'
    },

    /* Styles applied to the `Input` component if `variant="outlined"`. */
    outlined: {
      width: 'calc(100% - 46px)',
      borderRadius: theme.shape.borderRadius
    },

    /* Styles applied to the `Input` component `selectMenu` class. */
    selectMenu: {
      width: 'auto',
      // Fix Safari textOverflow
      height: 'auto',
      // Reset
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      minHeight: '1.1875em' // Reset (19px), match the native input line-height

    },

    /* Styles applied to the `Input` component `disabled` class. */
    disabled: {},

    /* Styles applied to the `Input` component `icon` class. */
    icon: {
      // We use a position absolute over a flexbox in order to forward the pointer events
      // to the input.
      position: 'absolute',
      right: 0,
      top: 'calc(50% - 12px)',
      // Center vertically
      color: theme.palette.action.active,
      'pointer-events': 'none' // Don't block pointer events on the select under the icon.

    }
  };
};
/**
 * An alternative to `<Select native />` with a much smaller bundle size footprint.
 */


exports.styles = styles;

function NativeSelect(props) {
  var children = props.children,
      classes = props.classes,
      IconComponent = props.IconComponent,
      input = props.input,
      inputProps = props.inputProps,
      muiFormControl = props.muiFormControl,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "IconComponent", "input", "inputProps", "muiFormControl", "variant"]);
  var fcs = (0, _formControlState.default)({
    props: props,
    muiFormControl: muiFormControl,
    states: ['variant']
  });
  return _react.default.cloneElement(input, (0, _extends2.default)({
    // Most of the logic is implemented in `NativeSelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: _NativeSelectInput.default,
    inputProps: (0, _extends2.default)({
      children: children,
      classes: classes,
      IconComponent: IconComponent,
      variant: fcs.variant,
      type: undefined
    }, inputProps, input ? input.props.inputProps : {})
  }, other));
}

 false ? NativeSelect.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: _utils.componentPropType,

  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: _propTypes.default.element,

  /**
   * Attributes applied to the `select` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * @ignore
   */
  muiFormControl: _propTypes.default.object,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes.default.func,

  /**
   * The input value.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]))]),

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
NativeSelect.defaultProps = {
  IconComponent: _ArrowDropDown.default,
  input: _react.default.createElement(_Input.default, null)
};
NativeSelect.muiName = 'Select';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiNativeSelect'
})((0, _withFormControlContext.default)(NativeSelect));

exports.default = _default;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

/**
 * @ignore - internal component.
 */
function NativeSelectInput(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      className = props.className,
      disabled = props.disabled,
      IconComponent = props.IconComponent,
      inputRef = props.inputRef,
      name = props.name,
      onChange = props.onChange,
      value = props.value,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disabled", "IconComponent", "inputRef", "name", "onChange", "value", "variant"]);
  return _react.default.createElement("div", {
    className: classes.root
  }, _react.default.createElement("select", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.select, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.filled, variant === 'filled'), (0, _defineProperty2.default)(_classNames, classes.outlined, variant === 'outlined'), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), className),
    name: name,
    disabled: disabled,
    onChange: onChange,
    value: value,
    ref: inputRef
  }, other), children), _react.default.createElement(IconComponent, {
    className: classes.icon
  }));
}

 false ? NativeSelectInput.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The CSS class name of the select element.
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the select will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: _utils.componentPropType,

  /**
   * Use that property to pass a ref callback to the native select element.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: _propTypes.default.string,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes.default.func,

  /**
   * The input value.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]))]),

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
var _default = NativeSelectInput;
exports.default = _default;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFQDN;

var _assertString = _interopRequireDefault(__webpack_require__(162));

var _merge = _interopRequireDefault(__webpack_require__(283));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_fqdn_options = {
  require_tld: true,
  allow_underscores: false,
  allow_trailing_dot: false
};

function isFQDN(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_fqdn_options);
  /* Remove the optional trailing dot before checking validity */

  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
    str = str.substring(0, str.length - 1);
  }

  var parts = str.split('.');

  for (var i = 0; i < parts.length; i++) {
    if (parts[i].length > 63) {
      return false;
    }
  }

  if (options.require_tld) {
    var tld = parts.pop();

    if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
      return false;
    } // disallow spaces


    if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20]/.test(tld)) {
      return false;
    }
  }

  for (var part, _i = 0; _i < parts.length; _i++) {
    part = parts[_i];

    if (options.allow_underscores) {
      part = part.replace(/_/g, '');
    }

    if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
      return false;
    } // disallow full-width chars


    if (/[\uff01-\uff5e]/.test(part)) {
      return false;
    }

    if (part[0] === '-' || part[part.length - 1] === '-') {
      return false;
    }
  }

  return true;
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isIP;

var _assertString = _interopRequireDefault(__webpack_require__(162));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ipv4Maybe = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
var ipv6Block = /^[0-9A-F]{1,4}$/i;

function isIP(str) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  (0, _assertString.default)(str);
  version = String(version);

  if (!version) {
    return isIP(str, 4) || isIP(str, 6);
  } else if (version === '4') {
    if (!ipv4Maybe.test(str)) {
      return false;
    }

    var parts = str.split('.').sort(function (a, b) {
      return a - b;
    });
    return parts[3] <= 255;
  } else if (version === '6') {
    var blocks = str.split(':');
    var foundOmissionBlock = false; // marker to indicate ::
    // At least some OS accept the last 32 bits of an IPv6 address
    // (i.e. 2 of the blocks) in IPv4 notation, and RFC 3493 says
    // that '::ffff:a.b.c.d' is valid for IPv4-mapped IPv6 addresses,
    // and '::a.b.c.d' is deprecated, but also valid.

    var foundIPv4TransitionBlock = isIP(blocks[blocks.length - 1], 4);
    var expectedNumberOfBlocks = foundIPv4TransitionBlock ? 7 : 8;

    if (blocks.length > expectedNumberOfBlocks) {
      return false;
    } // initial or final ::


    if (str === '::') {
      return true;
    } else if (str.substr(0, 2) === '::') {
      blocks.shift();
      blocks.shift();
      foundOmissionBlock = true;
    } else if (str.substr(str.length - 2) === '::') {
      blocks.pop();
      blocks.pop();
      foundOmissionBlock = true;
    }

    for (var i = 0; i < blocks.length; ++i) {
      // test for a :: which can not be at the string start/end
      // since those cases have been handled above
      if (blocks[i] === '' && i > 0 && i < blocks.length - 1) {
        if (foundOmissionBlock) {
          return false; // multiple :: in address
        }

        foundOmissionBlock = true;
      } else if (foundIPv4TransitionBlock && i === blocks.length - 1) {// it has been checked before that the last
        // block is a valid IPv4 address
      } else if (!ipv6Block.test(blocks[i])) {
        return false;
      }
    }

    if (foundOmissionBlock) {
      return blocks.length >= 1;
    }

    return blocks.length === expectedNumberOfBlocks;
  }

  return false;
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _pure = _interopRequireDefault(__webpack_require__(57));

var _SvgIcon = _interopRequireDefault(__webpack_require__(51));

var _ref = _react.default.createElement("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
});

/**
 * @ignore - internal component.
 */
var KeyboardArrowLeft = function KeyboardArrowLeft(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

KeyboardArrowLeft = (0, _pure.default)(KeyboardArrowLeft);
KeyboardArrowLeft.muiName = 'SvgIcon';
var _default = KeyboardArrowLeft;
exports.default = _default;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _pure = _interopRequireDefault(__webpack_require__(57));

var _SvgIcon = _interopRequireDefault(__webpack_require__(51));

var _ref = _react.default.createElement("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
});

/**
 * @ignore - internal component.
 */
var KeyboardArrowRight = function KeyboardArrowRight(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

KeyboardArrowRight = (0, _pure.default)(KeyboardArrowRight);
KeyboardArrowRight.muiName = 'SvgIcon';
var _default = KeyboardArrowRight;
exports.default = _default;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function deprecatedPropType(validator, reason) {
  /* istanbul ignore if */
  if (true) {
    return function () {
      return null;
    };
  }

  return function (props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (typeof props[propName] !== 'undefined') {
      return new Error("The ".concat(location, " `").concat(propFullNameSafe, "` of ") + "`".concat(componentNameSafe, "` is deprecated. ").concat(reason));
    }

    return null;
  };
}

var _default = deprecatedPropType;
exports.default = _default;

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_theme_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_Button__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_redux_modules_cloudFolders__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_CircularProgress__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_router_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_routes__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lib_Segment_customTrackers__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lib_Segment_helpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_redux_modules_session__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__images_empty_folder_png__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__images_empty_folder_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__images_empty_folder_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_i18n_i18n__ = __webpack_require__(15);
var _dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_27_i18n_i18n__["a" /* default */].loc.localize;var PARENT_FOLDER='parentFolderId';var SHARED_FOLDER_FILEID='shared';var isSharedFolder=function isSharedFolder(_ref){var fileId=_ref.fileId;return fileId&&fileId.toLowerCase()===SHARED_FOLDER_FILEID;};var styles=function styles(theme){return{tableCellBorder:{border:'none'},button:{minWidth:105,margin:'8px 0'},hide:{visibility:'hidden'},breadcrumbRoot:{display:'flex',marginLeft:theme.spacing.unit},capitalize:{textTransform:'capitalize'},providersSection:{display:'flex'},breadcrumbContainer:{display:'flex'},breadCrumbClickableItem:{cursor:'pointer'},breadCrumbSeparator:{margin:"0 ".concat(theme.spacing.unit/2,"px")},breadCrumbItem:{fontWeight:'bold',color:theme.palette.colors.zeta},emptyFolderInfo:{display:'flex',justifyContent:'center',flexDirection:'column',alignItems:'center'},folderLabel:{fontSize:13,textDecoration:'none'},sectionContainer:{marginTop:theme.spacing.unit,display:'flex'},folderIcon:{marginRight:theme.spacing.unit,color:theme.palette.colors.grey},driveAddPopover:{backgroundColor:'#253440',padding:theme.spacing.unit},buttonRoot:{textDecoration:'none'},folder:{},folderButton:{width:350,display:'flex',justifyContent:'flex-start'},providerButton:{paddingLeft:theme.spacing.unit}};};var CloudBrowser=(_dec=Object(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(CloudBrowser,_Component);function CloudBrowser(){var _getPrototypeOf2;var _this;__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this,CloudBrowser);for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}_this=__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this,(_getPrototypeOf2=__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(CloudBrowser)).call.apply(_getPrototypeOf2,[this].concat(args)));__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this),"state",{selectedFolder:null,showButton:{},popoverAnchorEl:undefined,popoverRemoveAnchorEl:undefined});return _this;}__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(CloudBrowser,[{key:"handlePopoverClose",value:function handlePopoverClose(){this.setState({popoverAnchorEl:null,popoverRemoveAnchorEl:null});}},{key:"cancelFolderSelection",value:function cancelFolderSelection(){return this.setState({cancel:true});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps,nextContext){if(!this.state.fileId&&!this.state.providerId&&nextProps.selectedFolder&&nextProps.folders){var folder=nextProps.folders[nextProps.selectedFolder];if(folder){this.setState({fileId:folder.fileId,providerId:folder.providerId});}}}},{key:"changeFolder",value:function changeFolder(event,fileId,providerId){var _this$props=this.props,changeFolder=_this$props.changeFolder,folders=_this$props.folders;// Go to select drive state.
if(fileId===null){this.cancelFolderSelection();return;}// We downloaded already this folder get it from store.
if(!folders[fileId+providerId]){changeFolder(fileId,providerId,{fileId:this.state.fileId||null,providerId:this.state.providerId||providerId});}this.setState({fileId:fileId,providerId:providerId,selectedFolder:fileId+providerId});}},{key:"addFolder",value:function addFolder(fileId,providerId){var _this2=this;var _this$props2=this.props,type=_this$props2.type,companyId=_this$props2.companyId,addFolder=_this$props2.addFolder;var folder={fileId:fileId,providerId:providerId,type:type,companyId:companyId,currentFolder:{fileId:this.state.fileId,providerId:this.state.providerId}};addFolder(folder).then(function(response){if(response&&response.result&&response.result.ok){Object(__WEBPACK_IMPORTED_MODULE_20_lib_Segment_customTrackers__["f" /* trackAddTeamFolder */])(__WEBPACK_IMPORTED_MODULE_26_lodash___default.a.pick(folder,['fileId','type','providerId','companyId']),Object(__WEBPACK_IMPORTED_MODULE_21_lib_Segment_helpers__["a" /* getTrackingOptions */])(_this2.props.company));_this2.cancelFolderSelection();return Object(__WEBPACK_IMPORTED_MODULE_22_redux_modules_session__["b" /* fetchSession */])();}});}/**
	 * Render folder button.
	 *
	 * content.fileId === null means that we are on top level then render empty element.
	 *
	 * @param {Object} content
	 * @param {number} index
	 * @returns {*}
	 */},{key:"renderFolderButton",value:function renderFolderButton(content,index){var _this3=this;var classes=this.props.classes;if(content.fileId===null){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",null);}else if(content.goBack){return;}return isSharedFolder(content)?__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_Button___default.a,{"data-tid":"button-cloud-browser-shared-folder-".concat(index),className:classes.folderButton,classes:{root:classes.buttonRoot},onClick:function onClick(event){return _this3.changeFolder(event,content.fileId,content.providerId);}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_theme_icons__["V" /* SharedIcon */],{className:classes.folderIcon}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{className:classes.folderLabel},localize('cloud-browser-shared'))):__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_Button___default.a,{"data-tid":"button-cloud-browser-folder-".concat(index),className:classes.folderButton,classes:{root:classes.buttonRoot},onClick:function onClick(event){return _this3.changeFolder(event,content.fileId,content.providerId);}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_theme_icons__["p" /* FolderIcon */],{className:classes.folderIcon}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{className:classes.folderLabel},content.title));}/**
	 * Creates redirect url.
	 *
	 * If {props.match.tab} is set url will redirect to Documents|Asset tab.
	 * If {props.match.asset} is set url will redirect to Logo|Image|Other section.
	 *
	 * @returns {string}
	 */},{key:"createRedirectUrl",value:function createRedirectUrl(){var _this$props3=this.props,companyId=_this$props3.companyId,match=_this$props3.match;var path=__WEBPACK_IMPORTED_MODULE_19_routes__["b" /* CLOUD_FOLDER */].replace(':companyId',companyId);if(match.params.tab){path+="/".concat(match.params.tab);if(match.params.asset){path+="/".concat(match.params.asset);}}return path;}},{key:"renderEmptyFolderInfo",value:function renderEmptyFolderInfo(){var emptyFolderInfo=this.props.classes.emptyFolderInfo;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:emptyFolderInfo},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_24__images_empty_folder_png___default.a})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,null,localize('cloud-browser-no-subfolders')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,null,localize('cloud-browser-go-back')));}},{key:"changePath",value:function changePath(providerId,path){var folders=this.props.folders;var folder=folders[path+providerId];this.changeFolder(null,folder.fileId,folder.providerId);}},{key:"renderBreadCrumbs",value:function renderBreadCrumbs(content,providerId,fileId){var _this4=this;if(!content.goBack){return;}var _this$props4=this.props,parents=_this$props4.parents,folders=_this$props4.folders,_this$props4$classes=_this$props4.classes,breadcrumbRoot=_this$props4$classes.breadcrumbRoot,breadcrumbContainer=_this$props4$classes.breadcrumbContainer,breadCrumbItem=_this$props4$classes.breadCrumbItem,breadCrumbClickableItem=_this$props4$classes.breadCrumbClickableItem,breadCrumbSeparator=_this$props4$classes.breadCrumbSeparator,capitalize=_this$props4$classes.capitalize;var breadcrumbs=Object(__WEBPACK_IMPORTED_MODULE_16_redux_modules_cloudFolders__["e" /* getFolderPaths */])({parents:parents,folders:folders},{providerId:providerId,fileId:fileId}).reverse();return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:breadcrumbRoot},breadcrumbs.map(function(breadcrumb,index){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{key:breadcrumb.id},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:breadcrumbContainer},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{className:__WEBPACK_IMPORTED_MODULE_25_classnames___default()(breadCrumbItem,breadCrumbClickableItem,index===0&&capitalize),onClick:function onClick(){return _this4.changePath(providerId,breadcrumb.id);}},breadcrumb.displayName),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{className:__WEBPACK_IMPORTED_MODULE_25_classnames___default()(breadCrumbSeparator,breadCrumbItem)},index<breadcrumbs.length-1?'>':'')));}));}},{key:"renderFolderButtons",value:function renderFolderButtons(content,providerId){var _this5=this;var classes=this.props.classes;if(isSharedFolder(content)){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_Button___default.a,{variant:"contained","data-tid":"button-cloud-browser-open-".concat(content.fileId),color:"primary",className:classes.button,onClick:function onClick(event){return _this5.changeFolder(event,content.fileId,content.providerId);}},localize('cloud-browser-open-button'));}else if(content.filename!==PARENT_FOLDER){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_Button___default.a,{variant:"contained","data-tid":"button-cloud-browser-".concat(content.fileId),color:"primary",className:classes.button,onClick:function onClick(){return _this5.addFolder(content.fileId,providerId);}},localize('cloud-browser-add-button'));}else if(content.goBack){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_Button___default.a,{variant:"contained","data-tid":"button-cloud-browser-cancel",className:classes.button,onClick:this.cancelFolderSelection.bind(this)},localize('cancel'));}}},{key:"renderFolders",value:function renderFolders(_ref2){var _this6=this;var contents=_ref2.contents,providerId=_ref2.providerId,fileId=_ref2.fileId;var _this$props5=this.props,classes=_this$props5.classes,parents=_this$props5.parents;var parent=parents[fileId+providerId];var hasContent=contents.length>0;contents=[{filename:PARENT_FOLDER,fileId:parent.fileId,providerId:parent.providerId,goBack:true}].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(contents));return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_core__["F" /* Table */],{className:classes.table},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_core__["G" /* TableBody */],null,contents.map(function(content,index){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_core__["J" /* TableRow */],{key:content.fileId||'root',hover:!content.goBack},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_core__["H" /* TableCell */],{padding:"none",classes:{root:hasContent?null:classes.tableCellBorder}},_this6.renderBreadCrumbs(content,providerId,fileId),_this6.renderFolderButton(content,index)),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_core__["H" /* TableCell */],{padding:"none",align:"right",className:__WEBPACK_IMPORTED_MODULE_25_classnames___default()(content.goBack&&!hasContent&&classes.hide)},_this6.renderFolderButtons(content,providerId)));})));}},{key:"render",value:function render(){var _this$props6=this.props,cloudProviders=_this$props6.cloudProviders,loading=_this$props6.loading,folders=_this$props6.folders;var _this$state=this.state,selectedFolder=_this$state.selectedFolder,cancel=_this$state.cancel;if(cancel){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_router_dom__["c" /* Redirect */],{to:this.createRedirectUrl()});}if(!selectedFolder){selectedFolder=this.props.selectedFolder;}var isLoading=loading&&selectedFolder&&!folders[selectedFolder];var currentFolderData=selectedFolder&&folders[selectedFolder];var hasContent=currentFolderData&&currentFolderData.contents.length>0;var addRemoveButton=cloudProviders.length>0;var cloudStores=[].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(cloudProviders),[{providerName:'add',providerId:'add-new'}]);if(addRemoveButton){cloudStores.push({providerName:'remove',providerId:'remove'});}return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",null,currentFolderData&&this.renderFolders(currentFolderData),!hasContent&&!loading&&this.renderEmptyFolderInfo()),isLoading&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_CircularProgress___default.a,null));}}]);return CloudBrowser;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]))||_class);var mapStateToProps=function mapStateToProps(state){return{cloudProviders:state.cloudFolders.cloudProviders,loading:state.cloudFolders.loading,folders:state.cloudFolders.folders,parents:state.cloudFolders.parents,companyId:state.companies.selectedId,company:state.companies.rawDataById?state.companies.rawDataById[state.companies.selectedId]:null};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_13_redux__["b" /* bindActionCreators */])({fetchSession:__WEBPACK_IMPORTED_MODULE_22_redux_modules_session__["b" /* fetchSession */],addFolder:__WEBPACK_IMPORTED_MODULE_16_redux_modules_cloudFolders__["a" /* addFolder */],changeFolder:__WEBPACK_IMPORTED_MODULE_16_redux_modules_cloudFolders__["c" /* changeFolder */],removeProvider:__WEBPACK_IMPORTED_MODULE_16_redux_modules_cloudFolders__["g" /* removeProvider */]},dispatch);};CloudBrowser.propTypes={fetchSession:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,addFolder:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,type:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string.isRequired,selectedFolder:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string,loading:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.bool,changeFolder:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func.isRequired,removeProvider:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func.isRequired,classes:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.object,parents:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.object,cloudProviders:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.array,folders:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.object,companyId:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string,company:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.object,match:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(CloudBrowser));

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ClickAwayListener.default;
  }
});

var _ClickAwayListener = _interopRequireDefault(__webpack_require__(987));

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormGroup.default;
  }
});

var _FormGroup = _interopRequireDefault(__webpack_require__(1003));

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _LinearProgress.default;
  }
});

var _LinearProgress = _interopRequireDefault(__webpack_require__(1021));

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Popper.default;
  }
});

var _Popper = _interopRequireDefault(__webpack_require__(1036));

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _SnackbarContent.default;
  }
});

var _SnackbarContent = _interopRequireDefault(__webpack_require__(1046));

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _StepLabel.default;
  }
});

var _StepLabel = _interopRequireDefault(__webpack_require__(1051));

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _StepIcon.default;
  }
});

var _StepIcon = _interopRequireDefault(__webpack_require__(1052));

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _StepConnector.default;
  }
});

var _StepConnector = _interopRequireDefault(__webpack_require__(1055));

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

/**
 * @ignore - internal component.
 */
var TableContext = _react.default.createContext();

var _default = TableContext;
exports.default = _default;

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Typography__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Button__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Path__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_FormField__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__errors_apperror__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__logger_logger__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_i18n_i18n__ = __webpack_require__(15);
var localize=__WEBPACK_IMPORTED_MODULE_21_i18n_i18n__["a" /* default */].loc.localize;var log=__WEBPACK_IMPORTED_MODULE_20__logger_logger__["a" /* default */].get('BaseAsset');/**
 * Base class for asset allows to update asset properties.
 */var BaseAsset=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits___default()(BaseAsset,_Component);function BaseAsset(){var _getPrototypeOf2;var _this;__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default()(this,BaseAsset);for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}_this=__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default()(this,(_getPrototypeOf2=__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default()(BaseAsset)).call.apply(_getPrototypeOf2,[this].concat(args)));__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this),"editFolder",{});return _this;}__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default()(BaseAsset,[{key:"updateFolderState",/**
	 * Update internal state of asset then notify component to update state.
	 *
	 * @param {Object} editFolder
	 */value:function updateFolderState(editFolder){this.editFolder=editFolder;this.setState({editFolder:this.editFolder});}/**
	 * Render save folder button.
	 *
	 * @param {Object} document
	 *
	 * @returns {Object}
	 */},{key:"renderSaveButton",value:function renderSaveButton(document){var _this2=this;if(!this.editFolder[document.fileId]){return;}return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Button___default.a,{variant:"outlined","data-tid":"button-base-asset-save",color:"primary",onClick:function onClick(){return _this2.saveFolder(document);}},localize('save'));}/**
	 * Render rename folder button.
	 *
	 * @param {Object} document
	 * @returns {Object}
	 */},{key:"renderRenameButton",value:function renderRenameButton(document){var _this3=this;if(this.editFolder[document.fileId]){return;}return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Button___default.a,{variant:"outlined","data-tid":"button-base-asset-rename",color:"primary",onClick:function onClick(){return _this3.updateFolderState(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({},_this3.editFolder,__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({},document.fileId,{name:document.displayName})));}},localize('rename'));}/**
	 * Render folder info.
	 *
	 * @param {Object} document
	 * @returns {Object}
	 */},{key:"renderFolderInfo",value:function renderFolderInfo(document){var classes=this.props.classes;if(this.editFolder[document.fileId]){return;}return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{container:true,className:classes.fullHeight,alignContent:"center"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Typography___default.a,{className:__WEBPACK_IMPORTED_MODULE_15_classnames___default()(classes.label,classes.bold)},localize('base-asset-display-name')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Typography___default.a,{className:__WEBPACK_IMPORTED_MODULE_15_classnames___default()(classes.label)},document.displayName))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Path__["a" /* default */],{document:document})))));}/**
	 * Render edit folder text field.
	 *
	 * @param {Object} document
	 * @param {number} index
	 *
	 * @returns {Object}
	 */},{key:"renderEditFolderField",value:function renderEditFolderField(document){var _this4=this;var index=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var classes=this.props.classes;if(!this.editFolder[document.fileId]){return;}return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_FormField__["a" /* default */],{"data-tid":"input-base-asset-rename-".concat(index),value:this.editFolder[document.fileId].name,onChange:function onChange(_ref){var value=_ref.target.value;return _this4.updateFolderState(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({},_this4.editFolder,__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({},document.fileId,{name:value})));},className:classes.field,id:name,margin:"normal"});}/**
	 * Save folder
	 * @param document
	 * @returns {Promise<void>}
	 */},{key:"saveFolder",value:function(){var _saveFolder=__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.mark(function _callee(document){var _this$props,id,type,updateFolder,newName,nError;return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this$props=this.props,id=_this$props.company.id,type=_this$props.type,updateFolder=_this$props.updateFolder;newName=this.editFolder[document.fileId].name;if(!(newName&&newName!==document.displayName)){_context.next=13;break;}_context.prev=3;_context.next=6;return updateFolder(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({},document,{name:this.editFolder[document.fileId].name,type:type}),id);case 6:_context.next=13;break;case 8:_context.prev=8;_context.t0=_context["catch"](3);nError=new __WEBPACK_IMPORTED_MODULE_19__errors_apperror__["a" /* default */]({message:'BaseAsset.saveFolder() failed',errorId:__WEBPACK_IMPORTED_MODULE_18__errors_errorids__["a" /* default */].UNKNOWN,originalError:_context.t0,visualisers:{feature:'BASE_ASSET'}});log.send(nError);throw nError;case 13:this.updateFolderState(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({},this.editFolder,__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({},document.fileId,false)));case 14:case"end":return _context.stop();}}},_callee,this,[[3,8]]);}));function saveFolder(_x){return _saveFolder.apply(this,arguments);}return saveFolder;}()}]);return BaseAsset;}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);BaseAsset.propTypes={classes:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.object,updateFolder:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (BaseAsset);

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1),__webpack_require__(2),__webpack_require__(1092)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = factory(require('react'),require('prop-types'),require('create-react-class'));
  } else {
    root.ReactSlider = factory(root.React,root.PropTypes,root.createReactClass);
  }
}(this, function (React, PropTypes, createReactClass) {

  /**
   * To prevent text selection while dragging.
   * http://stackoverflow.com/questions/5429827/how-can-i-prevent-text-element-selection-with-cursor-drag
   */
  function pauseEvent(e) {
    if (e.stopPropagation) e.stopPropagation();
    if (e.preventDefault) e.preventDefault();
    return false;
  }

  function stopPropagation(e) {
    if (e.stopPropagation) e.stopPropagation();
  }

  /**
   * Spreads `count` values equally between `min` and `max`.
   */
  function linspace(min, max, count) {
    var range = (max - min) / (count - 1);
    var res = [];
    for (var i = 0; i < count; i++) {
      res.push(min + range * i);
    }
    return res;
  }

  function ensureArray(x) {
    return x == null ? [] : Array.isArray(x) ? x : [x];
  }

  function undoEnsureArray(x) {
    return x != null && x.length === 1 ? x[0] : x;
  }

  var isArray = Array.isArray || function(x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };

  // undoEnsureArray(ensureArray(x)) === x

  var ReactSlider = createReactClass({
    displayName: 'ReactSlider',

    propTypes: {

      /**
       * The minimum value of the slider.
       */
      min: PropTypes.number,

      /**
       * The maximum value of the slider.
       */
      max: PropTypes.number,

      /**
       * Value to be added or subtracted on each step the slider makes.
       * Must be greater than zero.
       * `max - min` should be evenly divisible by the step value.
       */
      step: PropTypes.number,

      /**
       * The minimal distance between any pair of handles.
       * Must be positive, but zero means they can sit on top of each other.
       */
      minDistance: PropTypes.number,

      /**
       * Determines the initial positions of the handles and the number of handles if the component has no children.
       *
       * If a number is passed a slider with one handle will be rendered.
       * If an array is passed each value will determine the position of one handle.
       * The values in the array must be sorted.
       * If the component has children, the length of the array must match the number of children.
       */
      defaultValue: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.arrayOf(PropTypes.number)
      ]),

      /**
       * Like `defaultValue` but for [controlled components](http://facebook.github.io/react/docs/forms.html#controlled-components).
       */
      value: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.arrayOf(PropTypes.number)
      ]),

      /**
       * Determines whether the slider moves horizontally (from left to right) or vertically (from top to bottom).
       */
      orientation: PropTypes.oneOf(['horizontal', 'vertical']),

      /**
       * The css class set on the slider node.
       */
      className: PropTypes.string,

      /**
       * The css class set on each handle node.
       *
       * In addition each handle will receive a numbered css class of the form `${handleClassName}-${i}`,
       * e.g. `handle-0`, `handle-1`, ...
       */
      handleClassName: PropTypes.string,

      /**
       * The css class set on the handle that is currently being moved.
       */
      handleActiveClassName: PropTypes.string,

      /**
       * If `true` bars between the handles will be rendered.
       */
      withBars: PropTypes.bool,

      /**
       * The css class set on the bars between the handles.
       * In addition bar fragment will receive a numbered css class of the form `${barClassName}-${i}`,
       * e.g. `bar-0`, `bar-1`, ...
       */
      barClassName: PropTypes.string,

      /**
       * If `true` the active handle will push other handles
       * within the constraints of `min`, `max`, `step` and `minDistance`.
       */
      pearling: PropTypes.bool,

      /**
       * If `true` the handles can't be moved.
       */
      disabled: PropTypes.bool,

      /**
       * Disables handle move when clicking the slider bar
       */
      snapDragDisabled: PropTypes.bool,

      /**
       * Inverts the slider.
       */
      invert: PropTypes.bool,

      /**
       * Callback called before starting to move a handle.
       */
      onBeforeChange: PropTypes.func,

      /**
       * Callback called on every value change.
       */
      onChange: PropTypes.func,

      /**
       * Callback called only after moving a handle has ended.
       */
      onAfterChange: PropTypes.func,

      /**
       *  Callback called when the the slider is clicked (handle or bars).
       *  Receives the value at the clicked position as argument.
       */
      onSliderClick: PropTypes.func
    },

    getDefaultProps: function () {
      return {
        min: 0,
        max: 100,
        step: 1,
        minDistance: 0,
        defaultValue: 0,
        orientation: 'horizontal',
        className: 'slider',
        handleClassName: 'handle',
        handleActiveClassName: 'active',
        barClassName: 'bar',
        withBars: false,
        pearling: false,
        disabled: false,
        snapDragDisabled: false,
        invert: false
      };
    },

    getInitialState: function () {
      var value = this._or(ensureArray(this.props.value), ensureArray(this.props.defaultValue));

      // reused throughout the component to store results of iterations over `value`
      this.tempArray = value.slice();

      // array for storing resize timeouts ids
      this.pendingResizeTimeouts = [];

      var zIndices = [];
      for (var i = 0; i < value.length; i++) {
        value[i] = this._trimAlignValue(value[i], this.props);
        zIndices.push(i);
      }

      return {
        index: -1,
        upperBound: 0,
        sliderLength: 0,
        value: value,
        zIndices: zIndices
      };
    },

    // Keep the internal `value` consistent with an outside `value` if present.
    // This basically allows the slider to be a controlled component.
    componentWillReceiveProps: function (newProps) {
      var value = this._or(ensureArray(newProps.value), this.state.value);

      // ensure the array keeps the same size as `value`
      this.tempArray = value.slice();

      for (var i = 0; i < value.length; i++) {
        this.state.value[i] = this._trimAlignValue(value[i], newProps);
      }
      if (this.state.value.length > value.length)
        this.state.value.length = value.length;

      // If an upperBound has not yet been determined (due to the component being hidden
      // during the mount event, or during the last resize), then calculate it now
      if (this.state.upperBound === 0) {
        this._resize();
      }
    },

    // Check if the arity of `value` or `defaultValue` matches the number of children (= number of custom handles).
    // If no custom handles are provided, just returns `value` if present and `defaultValue` otherwise.
    // If custom handles are present but neither `value` nor `defaultValue` are applicable the handles are spread out
    // equally.
    // TODO: better name? better solution?
    _or: function (value, defaultValue) {
      var count = React.Children.count(this.props.children);
      switch (count) {
        case 0:
          return value.length > 0 ? value : defaultValue;
        case value.length:
          return value;
        case defaultValue.length:
          return defaultValue;
        default:
          if (value.length !== count || defaultValue.length !== count) {
            console.warn(this.constructor.displayName + ": Number of values does not match number of children.");
          }
          return linspace(this.props.min, this.props.max, count);
      }
    },

    componentDidMount: function () {
      window.addEventListener('resize', this._handleResize);
      this._resize();
    },

    componentWillUnmount: function () {
      this._clearPendingResizeTimeouts();
      window.removeEventListener('resize', this._handleResize);
    },

    getValue: function () {
      return undoEnsureArray(this.state.value);
    },

    _resize: function () {
      var slider = this.slider;
      var handle = this.handle0;
      var rect = slider.getBoundingClientRect();

      var size = this._sizeKey();

      var sliderMax = rect[this._posMaxKey()];
      var sliderMin = rect[this._posMinKey()];

      this.setState({
        upperBound: slider[size] - handle[size],
        sliderLength: Math.abs(sliderMax - sliderMin),
        handleSize: handle[size],
        sliderStart: this.props.invert ? sliderMax : sliderMin
      });
    },

    _handleResize: function () {
      // setTimeout of 0 gives element enough time to have assumed its new size if it is being resized
      var resizeTimeout = window.setTimeout(function() {
        // drop this timeout from pendingResizeTimeouts to reduce memory usage
        this.pendingResizeTimeouts.shift();
        this._resize();
      }.bind(this), 0);

      this.pendingResizeTimeouts.push(resizeTimeout);
    },

    // clear all pending timeouts to avoid error messages after unmounting
    _clearPendingResizeTimeouts: function() {
      do {
        var nextTimeout = this.pendingResizeTimeouts.shift();

        clearTimeout(nextTimeout);
      } while (this.pendingResizeTimeouts.length);
    },

    // calculates the offset of a handle in pixels based on its value.
    _calcOffset: function (value) {
      var range = this.props.max - this.props.min;
      if (range === 0) {
        return 0;
      }
      var ratio = (value - this.props.min) / range;
      return ratio * this.state.upperBound;
    },

    // calculates the value corresponding to a given pixel offset, i.e. the inverse of `_calcOffset`.
    _calcValue: function (offset) {
      var ratio = offset / this.state.upperBound;
      return ratio * (this.props.max - this.props.min) + this.props.min;
    },

    _buildHandleStyle: function (offset, i) {
      var style = {
        position: 'absolute',
        willChange: this.state.index >= 0 ? this._posMinKey() : '',
        zIndex: this.state.zIndices.indexOf(i) + 1
      };
      style[this._posMinKey()] = offset + 'px';
      return style;
    },

    _buildBarStyle: function (min, max) {
      var obj = {
        position: 'absolute',
        willChange: this.state.index >= 0 ? this._posMinKey() + ',' + this._posMaxKey() : ''
      };
      obj[this._posMinKey()] = min;
      obj[this._posMaxKey()] = max;
      return obj;
    },

    _getClosestIndex: function (pixelOffset) {
      var minDist = Number.MAX_VALUE;
      var closestIndex = -1;

      var value = this.state.value;
      var l = value.length;

      for (var i = 0; i < l; i++) {
        var offset = this._calcOffset(value[i]);
        var dist = Math.abs(pixelOffset - offset);
        if (dist < minDist) {
          minDist = dist;
          closestIndex = i;
        }
      }

      return closestIndex;
    },

    _calcOffsetFromPosition: function (position) {
      var pixelOffset = position - this.state.sliderStart;
      if (this.props.invert) pixelOffset = this.state.sliderLength - pixelOffset;
      pixelOffset -= (this.state.handleSize / 2);
      return pixelOffset;
    },

    // Snaps the nearest handle to the value corresponding to `position` and calls `callback` with that handle's index.
    _forceValueFromPosition: function (position, callback) {
      var pixelOffset = this._calcOffsetFromPosition(position);
      var closestIndex = this._getClosestIndex(pixelOffset);
      var nextValue = this._trimAlignValue(this._calcValue(pixelOffset));

      var value = this.state.value.slice(); // Clone this.state.value since we'll modify it temporarily
      value[closestIndex] = nextValue;

      // Prevents the slider from shrinking below `props.minDistance`
      for (var i = 0; i < value.length - 1; i += 1) {
        if (value[i + 1] - value[i] < this.props.minDistance) return;
      }

      this.setState({value: value}, callback.bind(this, closestIndex));
    },

    _getMousePosition: function (e) {
      return [
        e['page' + this._axisKey()],
        e['page' + this._orthogonalAxisKey()]
      ];
    },

    _getTouchPosition: function (e) {
      var touch = e.touches[0];
      return [
        touch['page' + this._axisKey()],
        touch['page' + this._orthogonalAxisKey()]
      ];
    },

    _getKeyDownEventMap: function () {
      return {
        'keydown': this._onKeyDown,
        'focusout': this._onBlur
      }
    },

    _getMouseEventMap: function () {
      return {
        'mousemove': this._onMouseMove,
        'mouseup': this._onMouseUp
      }
    },

    _getTouchEventMap: function () {
      return {
        'touchmove': this._onTouchMove,
        'touchend': this._onTouchEnd
      }
    },

    // create the `keydown` handler for the i-th handle
    _createOnKeyDown: function (i) {
      return function (e) {
        if (this.props.disabled) return;
        this._start(i);
        this._addHandlers(this._getKeyDownEventMap());
        pauseEvent(e);
      }.bind(this);
    },

    // create the `mousedown` handler for the i-th handle
    _createOnMouseDown: function (i) {
      return function (e) {
        if (this.props.disabled) return;
        var position = this._getMousePosition(e);
        this._start(i, position[0]);
        this._addHandlers(this._getMouseEventMap());
        pauseEvent(e);
      }.bind(this);
    },

    // create the `touchstart` handler for the i-th handle
    _createOnTouchStart: function (i) {
      return function (e) {
        if (this.props.disabled || e.touches.length > 1) return;
        var position = this._getTouchPosition(e);
        this.startPosition = position;
        this.isScrolling = undefined; // don't know yet if the user is trying to scroll
        this._start(i, position[0]);
        this._addHandlers(this._getTouchEventMap());
        stopPropagation(e);
      }.bind(this);
    },

    _addHandlers: function (eventMap) {
      for (var key in eventMap) {
        document.addEventListener(key, eventMap[key], false);
      }
    },

    _removeHandlers: function (eventMap) {
      for (var key in eventMap) {
        document.removeEventListener(key, eventMap[key], false);
      }
    },

    _start: function (i, position) {
      var activeEl = document.activeElement;
      var handleRef = this['handle' + i];
      // if activeElement is body window will lost focus in IE9
      if (activeEl && activeEl != document.body && activeEl != handleRef) {
        activeEl.blur && activeEl.blur();
      }

      this.hasMoved = false;

      this._fireChangeEvent('onBeforeChange');

      var zIndices = this.state.zIndices;
      zIndices.splice(zIndices.indexOf(i), 1); // remove wherever the element is
      zIndices.push(i); // add to end

      this.setState(function (prevState) {
        return {
          startValue: this.state.value[i],
          startPosition: position !== undefined ? position : prevState.startPosition,
          index: i,
          zIndices: zIndices
        };
      });
    },

    _onMouseUp: function () {
      this._onEnd(this._getMouseEventMap());
    },

    _onTouchEnd: function () {
      this._onEnd(this._getTouchEventMap());
    },

    _onBlur: function () {
      this._onEnd(this._getKeyDownEventMap());
    },

    _onEnd: function (eventMap) {
      this._removeHandlers(eventMap);
      this.setState({index: -1}, this._fireChangeEvent.bind(this, 'onAfterChange'));
    },

    _onMouseMove: function (e) {
      var position = this._getMousePosition(e);
      var diffPosition = this._getDiffPosition(position[0]);
      var newValue = this._getValueFromPosition(diffPosition);
      this._move(newValue);
    },

    _onTouchMove: function (e) {
      if (e.touches.length > 1) return;

      var position = this._getTouchPosition(e);

      if (typeof this.isScrolling === 'undefined') {
        var diffMainDir = position[0] - this.startPosition[0];
        var diffScrollDir = position[1] - this.startPosition[1];
        this.isScrolling = Math.abs(diffScrollDir) > Math.abs(diffMainDir);
      }

      if (this.isScrolling) {
        this.setState({index: -1});
        return;
      }

      pauseEvent(e);

      var diffPosition = this._getDiffPosition(position[0]);
      var newValue = this._getValueFromPosition(diffPosition);

      this._move(newValue);
    },

    _onKeyDown: function (e) {
      if (e.ctrlKey || e.shiftKey || e.altKey) return;
      switch (e.key) {
        case "ArrowLeft":
        case "ArrowUp":
          e.preventDefault();
          return this._moveDownOneStep();
        case "ArrowRight":
        case "ArrowDown":
          e.preventDefault();
          return this._moveUpOneStep();
        case "Home":
          return this._move(this.props.min);
        case "End":
          return this._move(this.props.max);
        default:
          return;
      }
    },

    _moveUpOneStep: function () {
      var oldValue = this.state.value[this.state.index];
      var newValue = oldValue + this.props.step;
      this._move(Math.min(newValue, this.props.max));
    },

    _moveDownOneStep: function () {
      var oldValue = this.state.value[this.state.index];
      var newValue = oldValue - this.props.step;
      this._move(Math.max(newValue, this.props.min));
    },

    _getValueFromPosition: function (position) {
      var diffValue = position / (this.state.sliderLength - this.state.handleSize) * (this.props.max - this.props.min);
      return this._trimAlignValue(this.state.startValue + diffValue);
    },

    _getDiffPosition: function (position) {
      var diffPosition = position - this.state.startPosition;
      if (this.props.invert) diffPosition *= -1;
      return diffPosition;
    },

    _move: function (newValue) {
      this.hasMoved = true;

      var props = this.props;
      var state = this.state;
      var index = state.index;

      var value = state.value;
      var length = value.length;
      var oldValue = value[index];

      var minDistance = props.minDistance;

      // if "pearling" (= handles pushing each other) is disabled,
      // prevent the handle from getting closer than `minDistance` to the previous or next handle.
      if (!props.pearling) {
        if (index > 0) {
          var valueBefore = value[index - 1];
          if (newValue < valueBefore + minDistance) {
            newValue = valueBefore + minDistance;
          }
        }

        if (index < length - 1) {
          var valueAfter = value[index + 1];
          if (newValue > valueAfter - minDistance) {
            newValue = valueAfter - minDistance;
          }
        }
      }

      value[index] = newValue;

      // if "pearling" is enabled, let the current handle push the pre- and succeeding handles.
      if (props.pearling && length > 1) {
        if (newValue > oldValue) {
          this._pushSucceeding(value, minDistance, index);
          this._trimSucceeding(length, value, minDistance, props.max);
        }
        else if (newValue < oldValue) {
          this._pushPreceding(value, minDistance, index);
          this._trimPreceding(length, value, minDistance, props.min);
        }
      }

      // Normally you would use `shouldComponentUpdate`, but since the slider is a low-level component,
      // the extra complexity might be worth the extra performance.
      if (newValue !== oldValue) {
        this.setState({value: value}, this._fireChangeEvent.bind(this, 'onChange'));
      }
    },

    _pushSucceeding: function (value, minDistance, index) {
      var i, padding;
      for (i = index, padding = value[i] + minDistance;
           value[i + 1] != null && padding > value[i + 1];
           i++, padding = value[i] + minDistance) {
        value[i + 1] = this._alignValue(padding);
      }
    },

    _trimSucceeding: function (length, nextValue, minDistance, max) {
      for (var i = 0; i < length; i++) {
        var padding = max - i * minDistance;
        if (nextValue[length - 1 - i] > padding) {
          nextValue[length - 1 - i] = padding;
        }
      }
    },

    _pushPreceding: function (value, minDistance, index) {
      var i, padding;
      for (i = index, padding = value[i] - minDistance;
           value[i - 1] != null && padding < value[i - 1];
           i--, padding = value[i] - minDistance) {
        value[i - 1] = this._alignValue(padding);
      }
    },

    _trimPreceding: function (length, nextValue, minDistance, min) {
      for (var i = 0; i < length; i++) {
        var padding = min + i * minDistance;
        if (nextValue[i] < padding) {
          nextValue[i] = padding;
        }
      }
    },

    _axisKey: function () {
      var orientation = this.props.orientation;
      if (orientation === 'horizontal') return 'X';
      if (orientation === 'vertical') return 'Y';
    },

    _orthogonalAxisKey: function () {
      var orientation = this.props.orientation;
      if (orientation === 'horizontal') return 'Y';
      if (orientation === 'vertical') return 'X';
    },

    _posMinKey: function () {
      var orientation = this.props.orientation;
      if (orientation === 'horizontal') return this.props.invert ? 'right' : 'left';
      if (orientation === 'vertical') return this.props.invert ? 'bottom' : 'top';
    },

    _posMaxKey: function () {
      var orientation = this.props.orientation;
      if (orientation === 'horizontal') return this.props.invert ? 'left' : 'right';
      if (orientation === 'vertical') return this.props.invert ? 'top' : 'bottom';
    },

    _sizeKey: function () {
      var orientation = this.props.orientation;
      if (orientation === 'horizontal') return 'clientWidth';
      if (orientation === 'vertical') return 'clientHeight';
    },

    _trimAlignValue: function (val, props) {
      return this._alignValue(this._trimValue(val, props), props);
    },

    _trimValue: function (val, props) {
      props = props || this.props;

      if (val <= props.min) val = props.min;
      if (val >= props.max) val = props.max;

      return val;
    },

    _alignValue: function (val, props) {
      props = props || this.props;

      var valModStep = (val - props.min) % props.step;
      var alignValue = val - valModStep;

      if (Math.abs(valModStep) * 2 >= props.step) {
        alignValue += (valModStep > 0) ? props.step : (-props.step);
      }

      return parseFloat(alignValue.toFixed(5));
    },

    _renderHandle: function (style, child, i) {
      var self = this;
      var className = this.props.handleClassName + ' ' +
        (this.props.handleClassName + '-' + i) + ' ' +
        (this.state.index === i ? this.props.handleActiveClassName : '');

      return (
        React.createElement('div', {
            ref: function (r) {
              self['handle' + i] = r;
            },
            key: 'handle' + i,
            className: className,
            style: style,
            onMouseDown: this._createOnMouseDown(i),
            onTouchStart: this._createOnTouchStart(i),
            onFocus: this._createOnKeyDown(i),
            tabIndex: 0,
            role: "slider",
            "aria-valuenow": this.state.value[i],
            "aria-valuemin": this.props.min,
            "aria-valuemax": this.props.max,
            "aria-label": isArray(this.props.ariaLabel) ? this.props.ariaLabel[i] : this.props.ariaLabel,
            "aria-valuetext": this.props.ariaValuetext,
          },
          child
        )
      );
    },

    _renderHandles: function (offset) {
      var length = offset.length;

      var styles = this.tempArray;
      for (var i = 0; i < length; i++) {
        styles[i] = this._buildHandleStyle(offset[i], i);
      }

      var res = [];
      var renderHandle = this._renderHandle;
      if (React.Children.count(this.props.children) > 0) {
        React.Children.forEach(this.props.children, function (child, i) {
          res[i] = renderHandle(styles[i], child, i);
        });
      } else {
        for (i = 0; i < length; i++) {
          res[i] = renderHandle(styles[i], null, i);
        }
      }
      return res;
    },

    _renderBar: function (i, offsetFrom, offsetTo) {
      var self = this;
      return (
        React.createElement('div', {
          key: 'bar' + i,
          ref: function (r) {
            self['bar' + i] = r;
          },
          className: this.props.barClassName + ' ' + this.props.barClassName + '-' + i,
          style: this._buildBarStyle(offsetFrom, this.state.upperBound - offsetTo)
        })
      );
    },

    _renderBars: function (offset) {
      var bars = [];
      var lastIndex = offset.length - 1;

      bars.push(this._renderBar(0, 0, offset[0]));

      for (var i = 0; i < lastIndex; i++) {
        bars.push(this._renderBar(i + 1, offset[i], offset[i + 1]));
      }

      bars.push(this._renderBar(lastIndex + 1, offset[lastIndex], this.state.upperBound));

      return bars;
    },

    _onSliderMouseDown: function (e) {
      if (this.props.disabled) return;
      this.hasMoved = false;
      if (!this.props.snapDragDisabled) {
        var position = this._getMousePosition(e);
        this._forceValueFromPosition(position[0], function (i) {
          this._start(i, position[0]);
          this._fireChangeEvent('onChange');
          this._addHandlers(this._getMouseEventMap());
        }.bind(this));
      }

      pauseEvent(e);
    },

    _onSliderClick: function (e) {
      if (this.props.disabled) return;

      if (this.props.onSliderClick && !this.hasMoved) {
        var position = this._getMousePosition(e);
        var valueAtPos = this._trimAlignValue(this._calcValue(this._calcOffsetFromPosition(position[0])));
        this.props.onSliderClick(valueAtPos);
      }
    },

    _fireChangeEvent: function (event) {
      if (this.props[event]) {
        this.props[event](undoEnsureArray(this.state.value));
      }
    },

    render: function () {
      var self = this;
      var state = this.state;
      var props = this.props;

      var offset = this.tempArray;
      var value = state.value;
      var l = value.length;
      for (var i = 0; i < l; i++) {
        offset[i] = this._calcOffset(value[i], i);
      }

      var bars = props.withBars ? this._renderBars(offset) : null;
      var handles = this._renderHandles(offset);

      return (
        React.createElement('div', {
            ref: function (r) {
              self.slider = r;
            },
            style: {position: 'relative'},
            className: props.className + (props.disabled ? ' disabled' : ''),
            onMouseDown: this._onSliderMouseDown,
            onClick: this._onSliderClick
          },
          bars,
          handles
        )
      );
    }
  });

  return ReactSlider;
}));


/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return trackAndDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAddonDataForDownload; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_Segment_customTrackers__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(17);
var trackAndDownload=function trackAndDownload(props,downloadUrl,storageKey,trackingKey,options){var downloadNotificationSettings=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(props.settings,"".concat(__WEBPACK_IMPORTED_MODULE_3__config__["k" /* CAP_KEY */],".").concat(__WEBPACK_IMPORTED_MODULE_3__config__["_51" /* USER_DOWNLOAD_NOTIFICATION_SETTING_KEY */]),{});var companySettings=downloadNotificationSettings[props.company.id]||{};companySettings[storageKey]||(companySettings[storageKey]=[]);companySettings[storageKey].push({date:new Date()});downloadNotificationSettings[props.company.id]=companySettings;props.writeUserSettings(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({},__WEBPACK_IMPORTED_MODULE_3__config__["_51" /* USER_DOWNLOAD_NOTIFICATION_SETTING_KEY */],downloadNotificationSettings));var newWindow=window.open(downloadUrl,'_blank');newWindow&&newWindow.focus();Object(__WEBPACK_IMPORTED_MODULE_1_lib_Segment_customTrackers__["v" /* trackDownloadsAsProperty */])(props.company.displayName,trackingKey,options);Object(__WEBPACK_IMPORTED_MODULE_1_lib_Segment_customTrackers__["u" /* trackDownloadedProduct */])(trackingKey,options);};var getAddonDataForDownload=function getAddonDataForDownload(plan_or_addonid,version){var productKey=plan_or_addonid.split(plan_or_addonid.indexOf('_')!==-1?'_':'-')[0].toUpperCase();var productVersion=parseInt(plan_or_addonid.split('_')[1]);var addonData=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_3__config__["C" /* DESKTOP_APPS */][productKey]);addonData.downloadUrl=addonData.downloadUrl.replace('_VERSION_',version||productVersion);addonData.title=addonData.title.replace('_VERSION_',version||productVersion);addonData.itemKey="".concat(productKey,"-").concat(version||productVersion);addonData.productVersion=productVersion;addonData.productKey=productKey;return addonData;};

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isURL;

var _assertString = _interopRequireDefault(__webpack_require__(162));

var _isFQDN = _interopRequireDefault(__webpack_require__(432));

var _isIP = _interopRequireDefault(__webpack_require__(433));

var _merge = _interopRequireDefault(__webpack_require__(283));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_url_options = {
  protocols: ['http', 'https', 'ftp'],
  require_tld: true,
  require_protocol: false,
  require_host: true,
  require_valid_protocol: true,
  allow_underscores: false,
  allow_trailing_dot: false,
  allow_protocol_relative_urls: false
};
var wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;

function isRegExp(obj) {
  return Object.prototype.toString.call(obj) === '[object RegExp]';
}

function checkHost(host, matches) {
  for (var i = 0; i < matches.length; i++) {
    var match = matches[i];

    if (host === match || isRegExp(match) && match.test(host)) {
      return true;
    }
  }

  return false;
}

function isURL(url, options) {
  (0, _assertString.default)(url);

  if (!url || url.length >= 2083 || /[\s<>]/.test(url)) {
    return false;
  }

  if (url.indexOf('mailto:') === 0) {
    return false;
  }

  options = (0, _merge.default)(options, default_url_options);
  var protocol, auth, host, hostname, port, port_str, split, ipv6;
  split = url.split('#');
  url = split.shift();
  split = url.split('?');
  url = split.shift();
  split = url.split('://');

  if (split.length > 1) {
    protocol = split.shift().toLowerCase();

    if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) {
      return false;
    }
  } else if (options.require_protocol) {
    return false;
  } else if (url.substr(0, 2) === '//') {
    if (!options.allow_protocol_relative_urls) {
      return false;
    }

    split[0] = url.substr(2);
  }

  url = split.join('://');

  if (url === '') {
    return false;
  }

  split = url.split('/');
  url = split.shift();

  if (url === '' && !options.require_host) {
    return true;
  }

  split = url.split('@');

  if (split.length > 1) {
    if (options.disallow_auth) {
      return false;
    }

    auth = split.shift();

    if (auth.indexOf(':') >= 0 && auth.split(':').length > 2) {
      return false;
    }
  }

  hostname = split.join('@');
  port_str = null;
  ipv6 = null;
  var ipv6_match = hostname.match(wrapped_ipv6);

  if (ipv6_match) {
    host = '';
    ipv6 = ipv6_match[1];
    port_str = ipv6_match[2] || null;
  } else {
    split = hostname.split(':');
    host = split.shift();

    if (split.length) {
      port_str = split.join(':');
    }
  }

  if (port_str !== null) {
    port = parseInt(port_str, 10);

    if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) {
      return false;
    }
  }

  if (!(0, _isIP.default)(host) && !(0, _isFQDN.default)(host, options) && (!ipv6 || !(0, _isIP.default)(ipv6, 6))) {
    return false;
  }

  host = host || ipv6;

  if (options.host_whitelist && !checkHost(host, options.host_whitelist)) {
    return false;
  }

  if (options.host_blacklist && checkHost(host, options.host_blacklist)) {
    return false;
  }

  return true;
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_utils_string__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_routes__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__theme_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_FormField__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lib_Segment_customTrackers__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lib_Segment_helpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_redux_modules_app__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_redux_modules_discount__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_i18n_i18n__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_errors_apperror__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_logger_logger__ = __webpack_require__(40);
var _errors,_dec,_class;var WEBL_ACTIVE_OFFERS_URL="https://www.xara.com/webdesigner/v20/";var PHOTOL_ACTIVE_OFFERS_URL="https://www.xara.com/photo-graphic/v20/";var DESIGNERL_ACTIVE_OFFERS_URL="https://www.xara.com/designerpro/v20/";var SUBSCRIPTION_ACTIVE_OFFERS_URL="https://www.xara.com/welcome/";var log=__WEBPACK_IMPORTED_MODULE_29_logger_logger__["a" /* default */].get('promoform');var localize=__WEBPACK_IMPORTED_MODULE_26_i18n_i18n__["a" /* default */].loc.localize;var BREAKPOINT_SM_DIFFERENCE=70;var errors=(_errors={},__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_27_errors_errorids__["a" /* default */].OFFLINE,'subscriptions-error-offline'),__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_27_errors_errorids__["a" /* default */].INVALID_COUPON_CODE_ID,'subscriptions-error-invalid-coupon-code'),__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_27_errors_errorids__["a" /* default */].FAILED_TO_RETRIEVE_COUPON,'subscriptions-error-failed-to-retrieve-coupon'),__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_27_errors_errorids__["a" /* default */].COUPON_CODE_DOES_NOT_EXIST,'subscriptions-error-coupon-does-not-exist'),__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_27_errors_errorids__["a" /* default */].API_REQUEST_LIMIT_EXCEEDED,'error-cb-api-rate-limit-reached'),_errors);var invalidReason={'does-not-exist':'subscriptions-error-coupon-does-not-exist','expired':'subscriptions-error-coupon-code-expired','serial-number':'subscriptions-error-coupon-code-is-serial-number','one-time-coupon-used':'subscriptions-error-coupon-one-time-already-used','cannot-replace-existing-coupon':'subscriptions-error-cannot-replace-existing-coupon','not-applicable-to-any-of-products':'subscriptions-error-coupon-does-not-qualify-for-any-product','not-applicable-to-this-product':'subscriptions-error-coupon-does-not-qualify-for-this-product','applicable-to-products-in-different-currency':'subscriptions-error-applicable-to-products-in-different-currency','applicable-to-products-in-different-route':'subscriptions-error-coupon-does-not-qualify-fallback','applicable-to-this-product-in-different-currency':'subscriptions-error-applicable-to-this-product-in-different-currency'};var styles=function styles(theme){var _columnPromoFormInput;return{promoForm:__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()({},theme.breakpoints.down(theme.breakpoints.values.sm+BREAKPOINT_SM_DIFFERENCE),{flexDirection:'column'}),columnPromoFormInputColumn:(_columnPromoFormInput={width:188},__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_columnPromoFormInput,theme.breakpoints.down(theme.breakpoints.values.sm+BREAKPOINT_SM_DIFFERENCE),{width:'100%',marginBottom:10}),__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_columnPromoFormInput,"position",'relative'),_columnPromoFormInput),columnPromoFormInputRoot:{},columnPromoFormInput:{width:'100%','& input':{'&::placeholder':{fontFamily:'Open Sans, sans-serif',fontWeight:'normal',fontStyle:'normal',fontSize:'14px',lineHeight:'19px',color:theme.palette.text.primary}},'& [id*=helper-text]':{paddingLeft:0}},errorHelperText:{color:theme.palette.colors.error,opacity:1,fontFamily:'"Open Sans Xara", Arial, Helvetica, sans-serif',fontWeight:'normal',fontSize:'13px',lineHeight:'18px'},errorMessageLink:{fontSize:'inherit','&:hover':{color:'#2888C3'}},activeOfferLink:{fontSize:'inherit','&:hover':{color:'#2888C3'}},activeOfferMessage:{display:'block',marginBottom:10},fallbackCouponMessage:{display:'block',width:320},fallbackCouponMessageLink:{margin:'0 0 0 5px',fontSize:'inherit','&:hover':{color:'#2888C3'}},textInput:{margin:0,'& input':{borderWidth:1,borderStyle:'solid',borderRadius:5,borderColor:theme.palette.secondary.lighter,color:theme.palette.text.primary,padding:'7px 10px','&:focus':{borderColor:theme.palette.primary.main},'&::placeholder':{fontFamily:'Open Sans, sans-serif',fontWeight:'normal',fontStyle:'normal',fontSize:'14px',lineHeight:'19px',color:theme.palette.text.primary}}},button:{padding:'0 15px 1px',borderRadius:'21px',background:'#000',fontSize:'14px',lineHeight:'35px',fontWeight:600,textTransform:'uppercase',textShadow:'none','&:hover':{backgroundColor:theme.palette.colors.darkPurpleHover}},clearPromoCodeButton:{fontSize:'10px',lineHeight:'34px',textTransform:'uppercase',position:'absolute',top:1,right:1,width:'30px',height:'32px',borderRadius:5,color:theme.palette.text.primary,background:'#fff',opacity:1},columnPromoFormSubmitColumn:__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()({paddingLeft:'10px'},theme.breakpoints.down(theme.breakpoints.values.sm+BREAKPOINT_SM_DIFFERENCE),{paddingLeft:0,textAlign:'center'}),columnPromoFormSubmit:{paddingLeft:20,paddingRight:20,letterSpacing:0,'&:disabled':{backgroundColor:'#F4F4F4',color:'rgba(34, 49, 62, 0.6)'}}};};var PromoForm=(_dec=Object(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(PromoForm,_Component);function PromoForm(props){var _this;__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this,PromoForm);_this=__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(PromoForm).call(this,props));_this.state={alternateCoupon:null,redirectToCloudSubscriptions:null,alternateRoute:null,productsString:null,promoFormError:false};_this.changePromoCode=_this.changePromoCode.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.clearPromoCode=_this.clearPromoCode.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.sendCurrentOffer=_this.sendCurrentOffer.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));return _this;}__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(PromoForm,[{key:"componentDidMount",value:function componentDidMount(){this.handleCouponApplied(this.props);}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState){if(this.props.discount.couponCodeFetchSuccess!==prevProps.discount.couponCodeFetchSuccess||this.props.nrOfQualifyingProductsForCoupon!==prevProps.nrOfQualifyingProductsForCoupon||this.props.nrOfQualifyingProductsForCouponInAllCurrencies!==prevProps.nrOfQualifyingProductsForCouponInAllCurrencies||this.props.nrOfQualifyingSubscriptions!==prevProps.nrOfQualifyingSubscriptions||this.props.nrOfQualifyingPerpetualProducts!==prevProps.nrOfQualifyingPerpetualProducts||this.props.type!==prevProps.type||this.props.discount.isDiscountApplied!==prevProps.discount.isDiscountApplied){this.handleCouponApplied(this.props);}}},{key:"handleCouponApplied",value:function handleCouponApplied(nextProps){var _this2=this;var _nextProps$discount=nextProps.discount,discountType=_nextProps$discount.discountType,isDiscountApplied=_nextProps$discount.isDiscountApplied,couponSetKey=_nextProps$discount.couponSetKey,couponConfig=_nextProps$discount.couponConfig;var alternateCoupon;var redirectToCloudSubscriptions;var alternateRoute;var productsString;if(nextProps.discount.couponCodeFetchSuccess===true||// No fetch is done for UPGRADE_POPUP;
// for DISCOUNT_TYPE.MAGIX we don't show PromoForm so we don't check for this case;
// clear expired coupon error message after user applies magix discount for perpetual products
isDiscountApplied&&(discountType===__WEBPACK_IMPORTED_MODULE_21__config__["F" /* DISCOUNT_TYPE */].COUPON_SET_ID&&couponSetKey===__WEBPACK_IMPORTED_MODULE_21__config__["E" /* DISCOUNT_KEY */].UPGRADE_POPUP||// Clear coupon error field when user enters email/serial for perpetual or desktop+ product
discountType===__WEBPACK_IMPORTED_MODULE_21__config__["F" /* DISCOUNT_TYPE */].MAGIX)){if(isDiscountApplied&&nextProps.nrOfQualifyingProductsForCoupon===0&&// P9052-25481 Exclude temporary redux-state value when users goes from My products and Plans to Purchase options,
// and client still didn't update appliedProdTypeOfLastValidCombination to MAXIC_DISCOUNT_PROD_TYPE.SUBSCRIPTION
!(this.props.type===__WEBPACK_IMPORTED_MODULE_21__config__["v" /* COUPON_TYPE */].SEATS&&nextProps.appliedProdTypeOfLastValidCombination===__WEBPACK_IMPORTED_MODULE_21__config__["Y" /* MAXIC_DISCOUNT_PROD_TYPE */].PERPETUAL)&&// Exclude temporary redux-state value when users goes from perpetual to subscription,
// in handleUpdateLastPageVisited.changeCouponType and client still didn't update coupon type to COUPON_TYPE.SEATS
!(this.props.type===__WEBPACK_IMPORTED_MODULE_21__config__["v" /* COUPON_TYPE */].LICENSES&&nextProps.nrOfQualifyingPerpetualProducts)||discountType===__WEBPACK_IMPORTED_MODULE_21__config__["F" /* DISCOUNT_TYPE */].COUPON_ID&&nextProps.nrOfQualifyingProductsForCoupon===0&&nextProps.nrOfQualifyingPerpetualProducts&&!nextProps.isPerpetualCheckbox||discountType===__WEBPACK_IMPORTED_MODULE_21__config__["F" /* DISCOUNT_TYPE */].COUPON_ID&&nextProps.nrOfQualifyingProductsForCoupon===0&&nextProps.nrOfQualifyingSubscriptions){var errorMessageKey;var errorMessage;var logError=true;var sendCurrentOffer=false;if(this.props.plan&&nextProps.nrOfQualifyingProductsForCoupon===0&&nextProps.nrOfQualifyingSubscriptions===0){// User enters coupon that can be used only for Designer Perpetual to 'Buy more lincenses' popup for PGD v20
if(nextProps.nrOfQualifyingProductsForCouponInAllCurrencies){errorMessageKey='applicable-to-this-product-in-different-currency';var firstPerpetualAddon=__WEBPACK_IMPORTED_MODULE_19_lodash___default.a.get(couponConfig,'addon_ids[0]');var currency_code=firstPerpetualAddon.split('-')[2].toUpperCase();errorMessage="".concat(localize(invalidReason[errorMessageKey])," ").concat(currency_code);}else{errorMessageKey='not-applicable-to-this-product';errorMessage=localize(invalidReason[errorMessageKey]);sendCurrentOffer=true;}}else if(nextProps.nrOfQualifyingSubscriptions&&this.props.type===__WEBPACK_IMPORTED_MODULE_21__config__["v" /* COUPON_TYPE */].LICENSES||nextProps.nrOfQualifyingPerpetualProducts&&this.props.type===__WEBPACK_IMPORTED_MODULE_21__config__["v" /* COUPON_TYPE */].SEATS){errorMessageKey='applicable-to-products-in-different-route';var applicableProducts=this.props.type===__WEBPACK_IMPORTED_MODULE_21__config__["v" /* COUPON_TYPE */].SEATS?this.props.getQualifyingProductsForCoupon(true,false,true):this.props.getQualifyingProductsForCoupon(true,true,false);applicableProducts=applicableProducts.map(function(planId){return Object(__WEBPACK_IMPORTED_MODULE_15_utils_string__["b" /* stripHTML */])(_this2.props.addVersionToTitle(planId,__WEBPACK_IMPORTED_MODULE_21__config__["_3" /* PACKAGES_CONFIG */][planId].title));});productsString=applicableProducts.join(', ');var pos=productsString.lastIndexOf(',');if(pos!=-1){productsString=productsString.substring(0,pos)+' '+localize('and')+' '+productsString.substring(pos+1);}var fallbackCoupon=this.props.type===__WEBPACK_IMPORTED_MODULE_21__config__["v" /* COUPON_TYPE */].SEATS?__WEBPACK_IMPORTED_MODULE_21__config__["I" /* FALLBACK_COUPON */].SUBSCRIPTION:__WEBPACK_IMPORTED_MODULE_21__config__["I" /* FALLBACK_COUPON */].PERPETUAL;errorMessage=localize(invalidReason[errorMessageKey],[productsString,fallbackCoupon]);alternateCoupon=fallbackCoupon;if(this.props.plan){redirectToCloudSubscriptions=true;}else{alternateRoute=this.props.type===__WEBPACK_IMPORTED_MODULE_21__config__["v" /* COUPON_TYPE */].SEATS?__WEBPACK_IMPORTED_MODULE_16_routes__["o" /* SUBSCRIPTION_PERPETUAL_OVERVIEW */]:__WEBPACK_IMPORTED_MODULE_16_routes__["n" /* SUBSCRIPTION */];}}else if(nextProps.nrOfQualifyingProductsForCouponInAllCurrencies){errorMessageKey='applicable-to-products-in-different-currency';var _firstPerpetualAddon=__WEBPACK_IMPORTED_MODULE_19_lodash___default.a.get(couponConfig,'addon_ids[0]');var _currency_code=_firstPerpetualAddon.split('-')[2].toUpperCase();errorMessage="".concat(localize(invalidReason[errorMessageKey])," ").concat(_currency_code);}else if(discountType!==__WEBPACK_IMPORTED_MODULE_21__config__["F" /* DISCOUNT_TYPE */].MAGIX){errorMessageKey='not-applicable-to-any-of-products';errorMessage=localize(invalidReason[errorMessageKey]);sendCurrentOffer=true;}else if(discountType===__WEBPACK_IMPORTED_MODULE_21__config__["F" /* DISCOUNT_TYPE */].MAGIX){// for maxic discount clear existing coupon error field
logError=false;}if(logError){var nError=new __WEBPACK_IMPORTED_MODULE_28_errors_apperror__["a" /* default */]({message:"Coupon error after successful fetch (".concat(errorMessageKey,")"),details:{plan:this.props.plan,couponId:this.getPromoCode(),alternateCouponOffered:alternateCoupon,applicableProducts:productsString},errorId:__WEBPACK_IMPORTED_MODULE_27_errors_errorids__["a" /* default */].UNKNOWN,visualisers:{feature:'COUPON'}});log.send(nError);}this.setState(function(prevState){return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},prevState,{redirectToCloudSubscriptions:redirectToCloudSubscriptions,alternateCoupon:alternateCoupon,alternateRoute:alternateRoute,productsString:productsString,promoFormError:errorMessage});});if(this.props.plan){this.props.hasCouponError(true);}sendCurrentOffer&&this.sendCurrentOffer();}else{this.setState({redirectToCloudSubscriptions:redirectToCloudSubscriptions,alternateCoupon:alternateCoupon,alternateRoute:alternateRoute,productsString:productsString,promoFormError:false});if(this.props.plan){this.props.hasCouponError(false);}}}else if(nextProps.discount.couponCodeFetchSuccess===false){var _errorMessageKey=nextProps.discount.couponCodeInvalidReason||nextProps.discount.couponCodeFetchErrorId&&errors[nextProps.discount.couponCodeFetchErrorId]||'subscriptions-error-unknown';var _errorMessage=nextProps.discount.couponCodeInvalidReason&&invalidReason[nextProps.discount.couponCodeInvalidReason]&&localize(invalidReason[nextProps.discount.couponCodeInvalidReason])||nextProps.discount.couponCodeFetchErrorId&&errors[nextProps.discount.couponCodeFetchErrorId]&&localize(errors[nextProps.discount.couponCodeFetchErrorId])||localize('subscriptions-error-unknown');var _nError=new __WEBPACK_IMPORTED_MODULE_28_errors_apperror__["a" /* default */]({message:"Coupon error after failed fetch (".concat(_errorMessageKey,")"),errorId:__WEBPACK_IMPORTED_MODULE_27_errors_errorids__["a" /* default */].UNKNOWN,details:{couponCodeInvalidReason:nextProps.discount.couponCodeInvalidReason,couponCodeFetchErrorId:nextProps.discount.couponCodeFetchErrorId,couponId:this.getPromoCode()},visualisers:{feature:'COUPON'}});log.send(_nError);this.setState(function(prevState){return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},prevState,{redirectToCloudSubscriptions:redirectToCloudSubscriptions,alternateCoupon:alternateCoupon,alternateRoute:alternateRoute,productsString:productsString,promoFormError:_errorMessage});});if(['not-applicable-to-any-of-products','not-applicable-to-this-product',errors[__WEBPACK_IMPORTED_MODULE_27_errors_errorids__["a" /* default */].INVALID_COUPON_CODE_ID],errors[__WEBPACK_IMPORTED_MODULE_27_errors_errorids__["a" /* default */].COUPON_CODE_DOES_NOT_EXIST],'does-not-exist','serial-number','expired'].includes(_errorMessageKey)){this.sendCurrentOffer();}}}},{key:"sendCurrentOffer",value:function sendCurrentOffer(){var payload={productType:this.props.type===__WEBPACK_IMPORTED_MODULE_21__config__["v" /* COUPON_TYPE */].SEATS?'subscription':'perpetual',lang:__WEBPACK_IMPORTED_MODULE_26_i18n_i18n__["a" /* default */].getCurrentLanguage(),coupon:this.getPromoCode(),email:__WEBPACK_IMPORTED_MODULE_19_lodash___default.a.get(this.props.user,'mainEmail'),type:this.props.isPerpetualCheckbox||this.props.type===__WEBPACK_IMPORTED_MODULE_21__config__["v" /* COUPON_TYPE */].LICENSES||this.props.category===__WEBPACK_IMPORTED_MODULE_21__config__["_10" /* PLAN_CATEGORIES */].CREATIVE_TOOLS?'desktop':'cloud'};Object(__WEBPACK_IMPORTED_MODULE_25_redux_modules_discount__["h" /* sendCurrentOfferToUser */])(payload);}},{key:"onPromoCodeApply",value:function onPromoCodeApply(value){// When coupon on Desktop > One-time purchase is submited, request is made to subscriptionEstimation endpoint
// as in this case returned couponConfig will be used for both subscriptions and perpetual addons
if(this.props.type===__WEBPACK_IMPORTED_MODULE_21__config__["v" /* COUPON_TYPE */].LICENSES&&!this.props.isPerpetualCheckbox){// here we first fetch and validate coupon (check expired date, if coupon exists etc),
// then if it's valid we apply it to perpetual producs
this.props.applyDiscountUsingCouponId(value||this.props.discount.userSuppliedPromoCode,__WEBPACK_IMPORTED_MODULE_21__config__["v" /* COUPON_TYPE */].LICENSES,true);}else{// "without validation" means we don't do initial fetching and validation before using coupon
// (ie when sending to estimation endpoint)
this.props.applyDiscountUsingCouponIdWithoutValidation(value||this.props.discount.userSuppliedPromoCode,__WEBPACK_IMPORTED_MODULE_21__config__["v" /* COUPON_TYPE */].SEATS,true,__WEBPACK_IMPORTED_MODULE_21__config__["F" /* DISCOUNT_TYPE */].COUPON_ID);}Object(__WEBPACK_IMPORTED_MODULE_22_lib_Segment_customTrackers__["h" /* trackApplyCouponClicked */])(value||this.props.discount.userSuppliedPromoCode,Object(__WEBPACK_IMPORTED_MODULE_23_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}},{key:"clearPromoCode",value:function clearPromoCode(){this.props.clearAppliedDiscount();this.setState({promoFormError:false});if(this.props.plan){this.props.hasCouponError(false);}}},{key:"changePromoCode",value:function changePromoCode(value){this.props.setUserSuppliedPromoCode(value);this.onPromoCodeApply(value);}},{key:"onPromoCodeChange",value:function onPromoCodeChange(event){this.props.setUserSuppliedPromoCode(event.target.value);// delete discount when user backspaces and deletes coupon code
this.props.discount.isDiscountApplied&&!event.target.value&&this.props.clearAppliedDiscount();}},{key:"onPromoCodeKeyPress",value:function onPromoCodeKeyPress(event){if(!this.isPromoFormSubmitEnabled())return;if(event.key==='Enter'){this.onPromoCodeApply();}}},{key:"isPromoFormSubmitEnabled",value:function isPromoFormSubmitEnabled(){var _this$props$discount=this.props.discount,discountType=_this$props$discount.discountType,userSuppliedPromoCode=_this$props$discount.userSuppliedPromoCode;// allow entering coupon when magix discount is applied,
// otherwise in case of DISCOUNT_TYPE.COUPON_ID and discountType === DISCOUNT_TYPE.COUPON_SET_ID
// user has first to clear existing coupon
return(!this.props.discount.isDiscountApplied||discountType===__WEBPACK_IMPORTED_MODULE_21__config__["F" /* DISCOUNT_TYPE */].MAGIX)&&(!this.state.promoFormError||this.state.promoFormError===localize(errors[__WEBPACK_IMPORTED_MODULE_27_errors_errorids__["a" /* default */].OFFLINE])||this.state.promoFormError===localize(errors[__WEBPACK_IMPORTED_MODULE_27_errors_errorids__["a" /* default */].API_REQUEST_LIMIT_EXCEEDED]))&&userSuppliedPromoCode&&userSuppliedPromoCode.replace(/[\r\n\t\s]/g,'').length>0;}},{key:"getPromoCode",value:function getPromoCode(){var _this$props$discount2=this.props.discount,discountType=_this$props$discount2.discountType,couponId=_this$props$discount2.couponId,couponSetKey=_this$props$discount2.couponSetKey,userSuppliedPromoCode=_this$props$discount2.userSuppliedPromoCode,failedCouponId=_this$props$discount2.failedCouponId;var promoCodeValue='';if(userSuppliedPromoCode){promoCodeValue=userSuppliedPromoCode;}else if(couponSetKey&&discountType===__WEBPACK_IMPORTED_MODULE_21__config__["F" /* DISCOUNT_TYPE */].COUPON_SET_ID){promoCodeValue=__WEBPACK_IMPORTED_MODULE_21__config__["D" /* DISCOUNTS_CONFIG */][couponSetKey].coupon_set_id;}else if(couponId||failedCouponId){promoCodeValue=couponId||failedCouponId;}return promoCodeValue;}},{key:"renderActiveOfferLink",value:function renderActiveOfferLink(){var _this3=this;var classes=this.props.classes;if(this.props.plan||this.props.type===__WEBPACK_IMPORTED_MODULE_21__config__["v" /* COUPON_TYPE */].LICENSES){var couponConfig=this.props.discount.couponConfig;var addonList;if(this.props.isPerpetualCheckbox){addonList=[__WEBPACK_IMPORTED_MODULE_21__config__["_42" /* SUBSCRIPTION_PLAN */].PHOTO_PERPETUAL,__WEBPACK_IMPORTED_MODULE_21__config__["_42" /* SUBSCRIPTION_PLAN */].WEB_PERPETUAL,__WEBPACK_IMPORTED_MODULE_21__config__["_42" /* SUBSCRIPTION_PLAN */].DESIGNER_PERPETUAL];}else if(this.props.plan){addonList=[this.props.plan];}else{addonList=__WEBPACK_IMPORTED_MODULE_19_lodash___default.a.get(couponConfig,'addon_ids');// case when expired cloud coupon is entered
if(!addonList){addonList=[__WEBPACK_IMPORTED_MODULE_21__config__["_42" /* SUBSCRIPTION_PLAN */].PHOTO_PERPETUAL,__WEBPACK_IMPORTED_MODULE_21__config__["_42" /* SUBSCRIPTION_PLAN */].WEB_PERPETUAL,__WEBPACK_IMPORTED_MODULE_21__config__["_42" /* SUBSCRIPTION_PLAN */].DESIGNER_PERPETUAL];}}if(!__WEBPACK_IMPORTED_MODULE_19_lodash___default.a.isEmpty(addonList)){var applicableProducts=[];addonList.forEach(function(addon){var singleAddonId=addon.split('_')[0].toLowerCase();if([__WEBPACK_IMPORTED_MODULE_21__config__["_42" /* SUBSCRIPTION_PLAN */].PHOTO_PERPETUAL,__WEBPACK_IMPORTED_MODULE_21__config__["_42" /* SUBSCRIPTION_PLAN */].WEB_PERPETUAL,__WEBPACK_IMPORTED_MODULE_21__config__["_42" /* SUBSCRIPTION_PLAN */].DESIGNER_PERPETUAL].includes(singleAddonId)){applicableProducts.push(singleAddonId);}});applicableProducts=__WEBPACK_IMPORTED_MODULE_19_lodash___default.a.uniq(applicableProducts);applicableProducts=applicableProducts.map(function(planId,index){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Fragment,{key:"active-offer-link-".concat(index)},applicableProducts.length>1&&index===applicableProducts.length-1&&" ".concat(localize('and')," "),applicableProducts.length>1&&index>0&&index<applicableProducts.length-1&&', ',__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["r" /* Link */],{component:"button",variant:"body2","data-tid":"active-offer-url",className:classes.activeOfferLink,underline:"always",onClick:function onClick(){var url;Object(__WEBPACK_IMPORTED_MODULE_22_lib_Segment_customTrackers__["a" /* trackActiveOfferLinkClicked */])(Object(__WEBPACK_IMPORTED_MODULE_23_lib_Segment_helpers__["a" /* getTrackingOptions */])(_this3.props.company));if(planId===__WEBPACK_IMPORTED_MODULE_21__config__["_42" /* SUBSCRIPTION_PLAN */].PHOTO_PERPETUAL){url=PHOTOL_ACTIVE_OFFERS_URL;}else if(planId===__WEBPACK_IMPORTED_MODULE_21__config__["_42" /* SUBSCRIPTION_PLAN */].WEB_PERPETUAL){url=WEBL_ACTIVE_OFFERS_URL;}else if(planId===__WEBPACK_IMPORTED_MODULE_21__config__["_42" /* SUBSCRIPTION_PLAN */].DESIGNER_PERPETUAL){url=DESIGNERL_ACTIVE_OFFERS_URL;}if(__WEBPACK_IMPORTED_MODULE_26_i18n_i18n__["a" /* default */].getCurrentLanguage(false)==='de'){url=url.replace('xara.com','xara.com/de');}window.open(url,'_blank');}},Object(__WEBPACK_IMPORTED_MODULE_15_utils_string__["b" /* stripHTML */])(_this3.props.addVersionToTitle(planId,__WEBPACK_IMPORTED_MODULE_21__config__["_3" /* PACKAGES_CONFIG */][planId].title))));});if(!__WEBPACK_IMPORTED_MODULE_19_lodash___default.a.isEmpty(applicableProducts)){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:classes.activeOfferMessage},localize('subscription-active-offers-perpetual')," \xA0",applicableProducts));}}}else{return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["r" /* Link */],{component:"button",variant:"body2","data-tid":"active-offer-url",className:__WEBPACK_IMPORTED_MODULE_13_classnames___default()(classes.activeOfferLink,classes.activeOfferMessage),underline:"always",onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_22_lib_Segment_customTrackers__["a" /* trackActiveOfferLinkClicked */])(Object(__WEBPACK_IMPORTED_MODULE_23_lib_Segment_helpers__["a" /* getTrackingOptions */])(_this3.props.company));var url=SUBSCRIPTION_ACTIVE_OFFERS_URL;if(__WEBPACK_IMPORTED_MODULE_26_i18n_i18n__["a" /* default */].getCurrentLanguage(false)==='de'){url=url.replace('xara.com','xara.com/de');}window.open(url,'_blank');}},localize('subscription-active-offers-cloud'));}}},{key:"render",value:function render(){var _this4=this;var classes=this.props.classes;var _this$props$discount3=this.props.discount,isDiscountApplied=_this$props$discount3.isDiscountApplied,discountType=_this$props$discount3.discountType,couponId=_this$props$discount3.couponId,userSuppliedPromoCode=_this$props$discount3.userSuppliedPromoCode;var errorClasses={root:classes.columnPromoFormInputRoot,error:classes.error};var promoCodeValue=this.getPromoCode();var buttonLabel;if(isDiscountApplied&&(discountType===__WEBPACK_IMPORTED_MODULE_21__config__["F" /* DISCOUNT_TYPE */].COUPON_ID||discountType===__WEBPACK_IMPORTED_MODULE_21__config__["F" /* DISCOUNT_TYPE */].COUPON_SET_ID)){if(discountType===__WEBPACK_IMPORTED_MODULE_21__config__["F" /* DISCOUNT_TYPE */].COUPON_ID){if(userSuppliedPromoCode){buttonLabel=userSuppliedPromoCode!==couponId?localize('subscription-promo-section-apply'):localize('subscription-promo-section-applied');}else if(couponId){buttonLabel=localize('subscription-promo-section-applied');}}else if(discountType===__WEBPACK_IMPORTED_MODULE_21__config__["F" /* DISCOUNT_TYPE */].COUPON_SET_ID){buttonLabel=localize('subscription-promo-section-applied');}}else{buttonLabel=localize('subscription-promo-section-apply');}var hasAppliedData=isDiscountApplied&&(discountType===__WEBPACK_IMPORTED_MODULE_21__config__["F" /* DISCOUNT_TYPE */].COUPON_ID||discountType===__WEBPACK_IMPORTED_MODULE_21__config__["F" /* DISCOUNT_TYPE */].COUPON_SET_ID)||this.state.promoFormError&&this.state.promoFormError!==localize(errors[__WEBPACK_IMPORTED_MODULE_27_errors_errorids__["a" /* default */].OFFLINE])&&this.state.promoFormError!==localize(errors[__WEBPACK_IMPORTED_MODULE_27_errors_errorids__["a" /* default */].API_REQUEST_LIMIT_EXCEEDED]);var renderErrorMessage=function renderErrorMessage(){if(_this4.state.alternateCoupon||_this4.state.redirectToCloudSubscriptions){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span",{className:classes.fallbackCouponMessage},localize('subscriptions-error-coupon-does-not-qualify-fallback-1',_this4.state.productsString),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["r" /* Link */],{component:"button",variant:"body2","data-tid":"apply-coupon-link",className:classes.fallbackCouponMessageLink,underline:"always",onClick:function onClick(){if(_this4.state.redirectToCloudSubscriptions){_this4.props.handleSwitchToPlansFromBuyMoreLicensesPopup();}else{_this4.props.changeRoute({pathname:Object(__WEBPACK_IMPORTED_MODULE_16_routes__["w" /* getRoute */])(_this4.state.alternateRoute.replace(':currency?',_this4.props.currency.key),_this4.props.company.id),state:{// todo - resolve category based on coupon config
preselectCategory:__WEBPACK_IMPORTED_MODULE_21__config__["_10" /* PLAN_CATEGORIES */].CREATIVE_TOOLS,isCouponMissmatchRedirect:true}});}}},"(",localize('subscriptions-error-coupon-does-not-qualify-view-products'),")"),".\xA0",localize('subscriptions-error-coupon-does-not-qualify-fallback-2',_this4.state.alternateCoupon),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["r" /* Link */],{component:"button",variant:"body2","data-tid":"apply-coupon-link",className:classes.fallbackCouponMessageLink,underline:"always",onClick:function onClick(){_this4.changePromoCode(_this4.state.alternateCoupon);}},"(",localize('subscription-promo-section-apply-coupon'),")."));}else{return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Fragment,null,_this4.state.promoFormError,"\xA0",_this4.state.promoFormError===localize(invalidReason['expired'])&&_this4.renderActiveOfferLink(),_this4.state.promoFormError!==localize(errors[__WEBPACK_IMPORTED_MODULE_27_errors_errorids__["a" /* default */].OFFLINE])&&_this4.state.promoFormError!==localize(errors[__WEBPACK_IMPORTED_MODULE_27_errors_errorids__["a" /* default */].API_REQUEST_LIMIT_EXCEEDED])&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["r" /* Link */],{component:"button",variant:"body2","data-tid":"have-questions-link",className:classes.errorMessageLink,underline:"always",onClick:function onClick(){return _this4.props.contactUsHandler(localize('subscription-contact-support-message',[promoCodeValue,_this4.state.promoFormError]));}},localize('subscription-contact-support')));}};return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{container:true,direction:"row",className:classes.promoForm},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true,className:classes.columnPromoFormInputColumn},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_FormField__["a" /* default */],{value:promoCodeValue,autoComplete:"off",className:__WEBPACK_IMPORTED_MODULE_13_classnames___default()(classes.columnPromoFormInput,classes.textInput),"data-tid":'input-coupon-code',onChange:function onChange(event){return _this4.onPromoCodeChange(event);},onKeyPress:function onKeyPress(event){return _this4.onPromoCodeKeyPress(event);},id:'input-coupon-code',placeholder:localize('subscription-coupon-code-placeholder'),margin:"normal",helperText:this.state.promoFormError&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{variant:"body2",className:classes.errorHelperText},renderErrorMessage()),error:!!this.state.promoFormError,FormHelperTextProps:{classes:errorClasses},inputRef:this['input-coupon-code'],disabled:hasAppliedData}),hasAppliedData&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["r" /* Link */],{component:"button",variant:"body2","data-tid":"clear-promo-code-button",className:classes.clearPromoCodeButton,underline:"none",onClick:function onClick(){return _this4.clearPromoCode();}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__theme_icons__["f" /* ClearIcon */],null))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true,className:classes.columnPromoFormSubmitColumn},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["a" /* Button */],{variant:"contained","data-tid":"button-apply-coupon",color:"primary",onClick:function onClick(){return _this4.onPromoCodeApply();},className:__WEBPACK_IMPORTED_MODULE_13_classnames___default()(classes.columnPromoFormSubmit,classes.button),disabled:!this.isPromoFormSubmitEnabled()},buttonLabel)));}}]);return PromoForm;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]))||_class);PromoForm.propTypes={company:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,classes:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,discount:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object.isRequired,contactUsHandler:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,setUserSuppliedPromoCode:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,clearAppliedDiscount:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,setSubscriptionPeriod:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,applyDiscountUsingCouponIdWithoutValidation:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,applyDiscountUsingCouponId:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,nrOfQualifyingProductsForCoupon:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,nrOfQualifyingProductsForCouponInAllCurrencies:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,nrOfQualifyingSubscriptions:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,nrOfQualifyingPerpetualProducts:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,type:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,isPerpetualCheckbox:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,getQualifyingProductsForCoupon:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,addVersionToTitle:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,plan:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,changeRoute:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,handleSwitchToPlansFromBuyMoreLicensesPopup:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,currency:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,hasCouponError:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,appliedProdTypeOfLastValidCombination:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,user:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object.isRequired,category:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string};var mapStateToProps=function mapStateToProps(state){return{company:state.companies.rawDataById[state.companies.selectedId],crs:state.crs,discount:state.discount,app:state.app,user:state.session.user,selectedCompanyId:state.companies.selectedId};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_11_redux__["b" /* bindActionCreators */])({setUserSuppliedPromoCode:__WEBPACK_IMPORTED_MODULE_25_redux_modules_discount__["i" /* setUserSuppliedPromoCode */],clearAppliedDiscount:__WEBPACK_IMPORTED_MODULE_25_redux_modules_discount__["f" /* clearAppliedDiscount */],setSubscriptionPeriod:__WEBPACK_IMPORTED_MODULE_24_redux_modules_app__["u" /* setSubscriptionPeriod */],applyDiscountUsingCouponId:__WEBPACK_IMPORTED_MODULE_25_redux_modules_discount__["a" /* applyDiscountUsingCouponId */],applyDiscountUsingCouponIdWithoutValidation:__WEBPACK_IMPORTED_MODULE_25_redux_modules_discount__["b" /* applyDiscountUsingCouponIdWithoutValidation */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(PromoForm));

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_FormField__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils_users__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_redux_modules_app__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_subscription__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_i18n_i18n__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lib_Segment_customTrackers__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lib_Segment_helpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__redux_modules_modal__ = __webpack_require__(26);
var _dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_18_i18n_i18n__["a" /* default */].loc.localize;var styles=function styles(theme){return{quantityFieldContainer:{display:'flex',marginBottom:15},itemsQuantityLabel:{display:'flex',textTransform:'uppercase',paddingTop:10,fontWeight:600,paddingRight:10,opacity:1,fontSize:15,color:'#000'},itemsQuantityModalLabel:{textTransform:'none',fontSize:16,fontWeight:'normal',paddingTop:8},quantityField:{width:72,'& [id*=helper-text]':{padding:'0 0 10px',whiteSpace:'nowrap'}},columnItemsQuantityInputRoot:{},textInput:{margin:0,'& input':{borderWidth:1,borderStyle:'solid',borderRadius:5,borderColor:theme.palette.secondary.lighter,color:theme.palette.text.primary,padding:'7px 10px','&:focus':{borderColor:theme.palette.primary.main},'&::placeholder':{fontFamily:'Open Sans, sans-serif',fontWeight:'normal',fontStyle:'normal',fontSize:'14px',lineHeight:'19px',color:theme.palette.text.primary}}},reminderMesesage:{fontFamily:'"Open Sans Xara", Arial, Helvetica, sans-serif',fontWeight:'normal',fontSize:14,lineHeight:1.5,opacity:1,padding:'8px 0 0 10px',display:'inline-block'},/* discount tooltip */arrow:{position:'absolute',fontSize:6,width:'3em',height:'1em',top:0,left:'50%',transform:'translateX(-50%)',marginTop:'-0.95em','&::before':{content:'""',margin:'auto',display:'block',width:0,height:0,borderStyle:'solid',borderWidth:'0 1em 1em 1em',borderColor:"transparent transparent ".concat(theme.palette.common.black," transparent")}},infoTooltip:{padding:7,backgroundColor:theme.palette.common.black},infoTooltipText:{color:theme.palette.common.white,opacity:1,pointerEvents:'auto'},contactUsLink:{color:theme.palette.common.white,textDecoration:'underline',opacity:1,margin:'-3px 0 0'}};};var SHOW_BULK_DISCOUNT_FOR_QUANTITY=15;var ItemsQuantityField=(_dec=Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ItemsQuantityField,_Component);function ItemsQuantityField(props){var _this;__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,ItemsQuantityField);_this=__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(ItemsQuantityField).call(this,props));_this['input-product-quantity']=__WEBPACK_IMPORTED_MODULE_6_react___default.a.createRef();_this.handleBulkDiscountTooltipClose=_this.handleBulkDiscountTooltipClose.bind(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.state={itemsQuantity:_this.props.quantity,itemsQuantityError:false,showBulkDiscountTooltip:props.enableBulkDiscountTooltip&&props.quantity>=SHOW_BULK_DISCOUNT_FOR_QUANTITY};return _this;}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ItemsQuantityField,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(this.props.quantity!==nextProps.quantity){this.setState({itemsQuantity:nextProps.quantity,showBulkDiscountTooltip:nextProps.quantity>=SHOW_BULK_DISCOUNT_FOR_QUANTITY&&nextProps.enableBulkDiscountTooltip});}}},{key:"componentDidMount",value:function componentDidMount(){this.validate(this.props.quantity);if(this.props.enableBulkDiscountTooltip){window.addEventListener('resize',this.handleBulkDiscountTooltipClose);}}},{key:"componentWillUnmount",value:function componentWillUnmount(){window.removeEventListener('resize',this.handleBulkDiscountTooltipClose);}},{key:"render",value:function render(){var _this2=this;var classes=this.props.classes;var errorClasses={root:classes.columnItemsQuantityInputRoot,error:classes.error};var labelKey;if(this.props.isBuyMorePopup){if(this.props.quantityType==__WEBPACK_IMPORTED_MODULE_17__config__["_19" /* QUANTITY_TYPE */].LICENSES){labelKey='subscription-extra-licenses-quantity-label';}else if(this.props.quantityType==__WEBPACK_IMPORTED_MODULE_17__config__["_19" /* QUANTITY_TYPE */].SEATS){labelKey='subscription-extra-users-quantity-label';}}else if(this.props.isPerpetualOverviewMode){labelKey='product-quantity-licenses-label';}else{labelKey='product-quantity-users-label';}var tooltipKey,tooltipPlan;if(this.props.isPerpetualOverviewMode||this.props.quantityType==__WEBPACK_IMPORTED_MODULE_17__config__["_19" /* QUANTITY_TYPE */].LICENSES){tooltipKey='perpetual';}else if(this.props.isBuyMorePopup&&this.props.quantityType==__WEBPACK_IMPORTED_MODULE_17__config__["_19" /* QUANTITY_TYPE */].SEATS){tooltipPlan=this.props.plan;}else if(this.props.category===__WEBPACK_IMPORTED_MODULE_17__config__["_10" /* PLAN_CATEGORIES */].CREATIVE_TOOLS){// shows under Creative tools
tooltipKey='desktop-plus-extended';}var getFormField=function getFormField(){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_FormField__["a" /* default */],{value:_this2.state.itemsQuantity,autoComplete:"off",className:__WEBPACK_IMPORTED_MODULE_11_classnames___default()(classes.quantityField,classes.textInput),"data-tid":'input-product-quantity',onChange:function onChange(event){return _this2.onQuantityChange(event);},onFocus:function onFocus(event){return _this2.onFieldFocus(event);},onClick:function onClick(event){return _this2.onFieldFocus(event);},onKeyPress:function onKeyPress(event){return _this2.onQuantityKeyPress(event);},id:'input-product-quantity',margin:"normal",helperText:_this2.state.itemsQuantityError,error:!!_this2.state.itemsQuantityError,FormHelperTextProps:{classes:errorClasses},inputRef:_this2['input-product-quantity']});};var renderQuantityField=function renderQuantityField(){if(_this2.props.enableBulkDiscountTooltip){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["c" /* ClickAwayListener */],{onClickAway:_this2.handleBulkDiscountTooltipClose},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["L" /* Tooltip */],{placement:"bottom",open:_this2.state.showBulkDiscountTooltip,title:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["M" /* Typography */],{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_11_classnames___default()(classes.infoTooltipText)},localize('subscription-need-a-bulk-discount'),"\xA0",__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["r" /* Link */],{component:"button",variant:"body2","data-tid":"bulk-discount-button",className:__WEBPACK_IMPORTED_MODULE_11_classnames___default()(classes.contactUsLink),onClick:function onClick(){return _this2.props.showModal('CONTACT_SALES_MODAL',{title:localize('contact-sales-form-title-bulk-discount')});}},localize('subscription-contact-sales'))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("span",{className:classes.arrow})),classes:{tooltip:classes.infoTooltip}},getFormField()));}else{return getFormField();}};return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:classes.quantityFieldContainer},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["M" /* Typography */],{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_11_classnames___default()(classes.itemsQuantityLabel,this.props.isBuyMorePopup?classes.itemsQuantityModalLabel:null)},localize(labelKey)),renderQuantityField(),this.props.renderInfoTooltip(tooltipKey,true,tooltipPlan),!this.props.isBuyMorePopup&&this.props.quantityType==__WEBPACK_IMPORTED_MODULE_17__config__["_19" /* QUANTITY_TYPE */].SEATS&&this.renderUserNumberReminder());}},{key:"handleBulkDiscountTooltipClose",value:function handleBulkDiscountTooltipClose(){if(this.state.showBulkDiscountTooltip){this.setState({showBulkDiscountTooltip:false});}}},{key:"onFieldFocus",value:function onFieldFocus(){this.setState({showBulkDiscountTooltip:this.props.enableBulkDiscountTooltip&&this.state.itemsQuantity>=SHOW_BULK_DISCOUNT_FOR_QUANTITY});}},{key:"renderUserNumberReminder",value:function renderUserNumberReminder(){var nonGuestUsers=Object(__WEBPACK_IMPORTED_MODULE_13_utils_users__["e" /* filterNonGuestUsers */])(this.props.company.users);var classes=this.props.classes;if(this.state.itemsQuantity<nonGuestUsers.length){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["M" /* Typography */],{className:classes.reminderMesesage},localize('product-quantity-numbers-of-users-reminder',nonGuestUsers.length));}}},{key:"onQuantityChange",value:function onQuantityChange(event){if(this.props.quantityType===__WEBPACK_IMPORTED_MODULE_17__config__["_19" /* QUANTITY_TYPE */].LICENSES){this.props.setLicensesQuantity(event.target.value);}else{this.props.setSeatsQuantity(event.target.value);}this.validate(event.target.value);}},{key:"validate",value:function validate(value){if(Object(__WEBPACK_IMPORTED_MODULE_16__utils_subscription__["v" /* isValidNonZeroQuantity */])(value)){this.setState({itemsQuantityError:false});}else{this.setState({itemsQuantityError:localize('product-quantity-error')});}}},{key:"onQuantityKeyPress",value:function onQuantityKeyPress(event){var _this3=this;if(event.key==='Enter')return;if(this.state.itemsQuantity!==1){setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_19_lib_Segment_customTrackers__["D" /* trackQuantityChange */])(_this3.props.quantityType,_this3['input-product-quantity'].current&&_this3['input-product-quantity'].current.value,Object(__WEBPACK_IMPORTED_MODULE_20_lib_Segment_helpers__["a" /* getTrackingOptions */])(_this3.props.company));},250);}}}]);return ItemsQuantityField;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]))||_class);ItemsQuantityField.propTypes={company:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,classes:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,quantity:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number]),plan:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,quantityType:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,setSeatsQuantity:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,setLicensesQuantity:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,renderInfoTooltip:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,isPerpetualOverviewMode:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,isBuyMorePopup:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,category:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,enableBulkDiscountTooltip:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,showModal:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func};var mapStateToProps=function mapStateToProps(state){return{company:state.companies.rawDataById[state.companies.selectedId]};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])({setSeatsQuantity:__WEBPACK_IMPORTED_MODULE_15_redux_modules_app__["r" /* setSeatsQuantity */],setLicensesQuantity:__WEBPACK_IMPORTED_MODULE_15_redux_modules_app__["j" /* setLicensesQuantity */],showModal:__WEBPACK_IMPORTED_MODULE_21__redux_modules_modal__["d" /* showModal */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ItemsQuantityField));

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])('AppContext'));

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var prefix = __webpack_require__(1166)
var toCamelCase = __webpack_require__(1167)
var cache = { 'float': 'cssFloat' }
var addPxToStyle = __webpack_require__(1170)

function style (element, property, value) {
  var camel = cache[property]
  if (typeof camel === 'undefined') {
    camel = detect(property)
  }

  // may be false if CSS prop is unsupported
  if (camel) {
    if (value === undefined) {
      return element.style[camel]
    }

    element.style[camel] = addPxToStyle(camel, value)
  }
}

function each (element, properties) {
  for (var k in properties) {
    if (properties.hasOwnProperty(k)) {
      style(element, k, properties[k])
    }
  }
}

function detect (cssProp) {
  var camel = toCamelCase(cssProp)
  var result = prefix(camel)
  cache[camel] = cache[cssProp] = cache[result] = result
  return result
}

function set () {
  if (arguments.length === 2) {
    if (typeof arguments[1] === 'string') {
      arguments[0].style.cssText = arguments[1]
    } else {
      each(arguments[0], arguments[1])
    }
  } else {
    style(arguments[0], arguments[1], arguments[2])
  }
}

module.exports = set
module.exports.set = set

module.exports.get = function (element, properties) {
  if (Array.isArray(properties)) {
    return properties.reduce(function (obj, prop) {
      obj[prop] = style(element, prop || '')
      return obj
    }, {})
  } else {
    return style(element, properties || '')
  }
}


/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/* harmony default export */ __webpack_exports__["a"] = (memoizeOne);


/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyleSheet; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      var _tag = createStyleElement(this);

      var before;

      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }

      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is a really hot path
        // we check the second character first because having "i"
        // as the second character will happen less often than
        // having "@" as the first character
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools

        sheet.insertRule(rule, // we need to insert @import rules before anything else
        // otherwise there will be an error
        // technically this means that the @import rules will
        // _usually_(not always since there could be multiple style tags)
        // be the first ones in prod and generally later in dev
        // this shouldn't really matter in the real world though
        // @import is generally only used for font faces from google fonts and etc.
        // so while this could be technically correct then it would be slower and larger
        // for a tiny bit of correctness that won't matter in the real world
        isImportRule ? 0 : sheet.cssRules.length);
      } catch (e) {
        if (false) {
          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();




/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CacheProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Emotion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ThemeContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createEmotionProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hasOwnProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return withEmotionCache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_cache__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_utils__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__emotion_serialize__ = __webpack_require__(302);






var hasOwnProperty = Object.prototype.hasOwnProperty;

var EmotionCacheContext = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createContext"])( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? Object(__WEBPACK_IMPORTED_MODULE_2__emotion_cache__["a" /* default */])() : null);
var ThemeContext = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createContext"])({});
var CacheProvider = EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  var render = function render(props, ref) {
    return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(EmotionCacheContext.Consumer, null, function (cache) {
      return func(props, cache, ref);
    });
  }; // $FlowFixMe


  return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["forwardRef"])(render);
};

// thus we only need to replace what is a valid character for JS, but not for CSS

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (false) {
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/css' like this: css`" + props.css + "`");
  }

  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // TODO: check if this still works with all of those different JSX functions

  if (false) {
    var error = new Error();

    if (error.stack) {
      // chrome
      var match = error.stack.match(/at (?:Object\.|Module\.|)(?:jsx|createEmotionProps).*\n\s+at (?:Object\.|)([A-Z][A-Za-z$]+) /);

      if (!match) {
        // safari and firefox
        match = error.stack.match(/.*\n([A-Z][A-Za-z$]+)@/);
      }

      if (match) {
        newProps[labelPropName] = sanitizeIdentifier(match[1]);
      }
    }
  }

  return newProps;
};

var Noop = function Noop() {
  return null;
};

var render = function render(cache, props, theme, ref) {
  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = Object(__WEBPACK_IMPORTED_MODULE_3__emotion_utils__["a" /* getRegisteredStyles */])(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = Object(__WEBPACK_IMPORTED_MODULE_4__emotion_serialize__["a" /* serializeStyles */])(registeredStyles);

  if (false) {
    var labelFromStack = props[labelPropName];

    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }

  var rules = Object(__WEBPACK_IMPORTED_MODULE_3__emotion_utils__["b" /* insertStyles */])(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ("production" === 'production' || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  var ele = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(type, newProps);
  var possiblyStyleElement = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(Noop, null);


  return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null, possiblyStyleElement, ele);
}; // eslint-disable-next-line no-undef


var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  if (typeof props.css === 'function') {
    return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(ThemeContext.Consumer, null, function (theme) {
      return render(cache, props, theme, ref);
    });
  }

  return render(cache, props, null, ref);
});

if (false) {
  Emotion.displayName = 'EmotionCssPropInternal';
}




/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRegisteredStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return insertStyles; });
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};




/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isDocumentElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return exportedEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cleanValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return scrollIntoView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return noop; });
/* unused harmony export F */
/* unused harmony export G */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MenuPlacer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return containerCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return clearIndicatorCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return dropdownIndicatorCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return groupHeadingCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return indicatorSeparatorCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return groupCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return inputCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return indicatorsContainerCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return loadingMessageCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return menuListCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return loadingIndicatorCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return menuCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return menuPortalCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return multiValueCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return multiValueLabelCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return multiValueRemoveCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return noOptionsMessageCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return optionCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return placeholderCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return css$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return valueContainerCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return isTouchCapable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return isMobileDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return defaultComponents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return classNames; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__emotion_core__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_esm_typeof__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__emotion_css__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__babel_runtime_helpers_esm_taggedTemplateLiteral__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_input_autosize__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_input_autosize__);
















// ==============================
// NO OP
// ==============================
var noop = function noop() {};
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/

function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}

function classNames(prefix, state, className) {
  var arr = [className];

  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix, key)));
      }
    }
  }

  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
} // ==============================
// Clean Value
// ==============================

var cleanValue = function cleanValue(value) {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (Object(__WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_esm_typeof__["a" /* default */])(value) === 'object' && value !== null) return [value];
  return [];
}; // ==============================
// Handle Input Change
// ==============================

function handleInputChange(inputValue, actionMeta, onInputChange) {
  if (onInputChange) {
    var newValue = onInputChange(inputValue, actionMeta);
    if (typeof newValue === 'string') return newValue;
  }

  return inputValue;
} // ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
} // Normalized Scroll Top
// ------------------------------

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }

  return el.scrollTop;
}
function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }

  el.scrollTop = top;
} // Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  var docEl = document.documentElement; // suck it, flow...

  if (style.position === 'fixed') return docEl;

  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);

    if (excludeStaticParent && style.position === 'static') {
      continue;
    }

    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }

  return docEl;
} // Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/

function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}

function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;

  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);

    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      callback(element);
    }
  }

  animateScroll();
} // Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;

  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
} // ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect

function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
} // ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e) {
    return false;
  }
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
function getMenuPlacement(_ref) {
  var maxHeight = _ref.maxHeight,
      menuEl = _ref.menuEl,
      minHeight = _ref.minHeight,
      placement = _ref.placement,
      shouldScroll = _ref.shouldScroll,
      isFixedPosition = _ref.isFixedPosition,
      theme = _ref.theme;
  var spacing = theme.spacing;
  var scrollParent = getScrollParent(menuEl);
  var defaultState = {
    placement: 'bottom',
    maxHeight: maxHeight
  }; // something went wrong, return default state

  if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered

  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
      scrollHeight = _scrollParent$getBoun.height;

  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
      menuBottom = _menuEl$getBoundingCl.bottom,
      menuHeight = _menuEl$getBoundingCl.height,
      menuTop = _menuEl$getBoundingCl.top;

  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
      containerTop = _menuEl$offsetParent$.top;

  var viewHeight = window.innerHeight;
  var scrollTop = getScrollTop(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;

  switch (placement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        } // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.


        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      } // 4. Forked beviour when there isn't enough space below
      // AUTO: flip the menu, render above


      if (placement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = maxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;

        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight
        };
      } // BOTTOM: allow browser to increase scrollable area and immediately set scroll


      if (placement === 'bottom') {
        scrollTo(scrollParent, scrollDown);
        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      }

      break;

    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.

        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }

        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      } // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below


      return {
        placement: 'bottom',
        maxHeight: maxHeight
      };

    default:
      throw new Error("Invalid placement provided \"".concat(placement, "\"."));
  } // fulfil contract with flow: implicit return value of undefined


  return defaultState;
} // Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: 'top',
    top: 'bottom'
  };
  return placement ? placementToCSSProp[placement] : 'bottom';
}

var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};

var menuCSS = function menuCSS(_ref2) {
  var _ref3;

  var placement = _ref2.placement,
      _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      spacing = _ref2$theme.spacing,
      colors = _ref2$theme.colors;
  return _ref3 = {
    label: 'menu'
  }, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, alignToControl(placement), '100%'), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "backgroundColor", colors.neutral0), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "borderRadius", borderRadius), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "boxShadow", '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "marginBottom", spacing.menuGutter), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "marginTop", spacing.menuGutter), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "position", 'absolute'), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "width", '100%'), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "zIndex", 1), _ref3;
};
var PortalPlacementContext = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_8_react__["createContext"])({
  getPortalPlacement: null
}); // NOTE: internal only

var MenuPlacer = /*#__PURE__*/function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__["a" /* default */])(MenuPlacer, _Component);

  var _super = _createSuper(MenuPlacer);

  function MenuPlacer() {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, MenuPlacer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      maxHeight: _this.props.maxMenuHeight,
      placement: null
    };

    _this.getPlacement = function (ref) {
      var _this$props = _this.props,
          minMenuHeight = _this$props.minMenuHeight,
          maxMenuHeight = _this$props.maxMenuHeight,
          menuPlacement = _this$props.menuPlacement,
          menuPosition = _this$props.menuPosition,
          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
          theme = _this$props.theme;
      if (!ref) return; // DO NOT scroll if position is fixed

      var isFixedPosition = menuPosition === 'fixed';
      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
      var state = getMenuPlacement({
        maxHeight: maxMenuHeight,
        menuEl: ref,
        minHeight: minMenuHeight,
        placement: menuPlacement,
        shouldScroll: shouldScroll,
        isFixedPosition: isFixedPosition,
        theme: theme
      });
      var getPortalPlacement = _this.context.getPortalPlacement;
      if (getPortalPlacement) getPortalPlacement(state);

      _this.setState(state);
    };

    _this.getUpdatedProps = function () {
      var menuPlacement = _this.props.menuPlacement;
      var placement = _this.state.placement || coercePlacement(menuPlacement);
      return _objectSpread(_objectSpread({}, _this.props), {}, {
        placement: placement,
        maxHeight: _this.state.maxHeight
      });
    };

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(MenuPlacer, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        ref: this.getPlacement,
        placerProps: this.getUpdatedProps()
      });
    }
  }]);

  return MenuPlacer;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);
MenuPlacer.contextType = PortalPlacementContext;

var Menu = function Menu(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('menu', props),
    className: cx({
      menu: true
    }, className)
  }, innerProps, {
    ref: innerRef
  }), children);
};
// Menu List
// ==============================

var menuListCSS = function menuListCSS(_ref4) {
  var maxHeight = _ref4.maxHeight,
      baseUnit = _ref4.theme.spacing.baseUnit;
  return {
    maxHeight: maxHeight,
    overflowY: 'auto',
    paddingBottom: baseUnit,
    paddingTop: baseUnit,
    position: 'relative',
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  };
};
var MenuList = function MenuList(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isMulti = props.isMulti,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('menuList', props),
    className: cx({
      'menu-list': true,
      'menu-list--is-multi': isMulti
    }, className),
    ref: innerRef
  }, innerProps), children);
}; // ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS(_ref5) {
  var _ref5$theme = _ref5.theme,
      baseUnit = _ref5$theme.spacing.baseUnit,
      colors = _ref5$theme.colors;
  return {
    color: colors.neutral40,
    padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
    textAlign: 'center'
  };
};

var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('noOptionsMessage', props),
    className: cx({
      'menu-notice': true,
      'menu-notice--no-options': true
    }, className)
  }, innerProps), children);
};
NoOptionsMessage.defaultProps = {
  children: 'No options'
};
var LoadingMessage = function LoadingMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('loadingMessage', props),
    className: cx({
      'menu-notice': true,
      'menu-notice--loading': true
    }, className)
  }, innerProps), children);
};
LoadingMessage.defaultProps = {
  children: 'Loading...'
}; // ==============================
// Menu Portal
// ==============================

var menuPortalCSS = function menuPortalCSS(_ref6) {
  var rect = _ref6.rect,
      offset = _ref6.offset,
      position = _ref6.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal = /*#__PURE__*/function (_Component2) {
  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_inherits__["a" /* default */])(MenuPortal, _Component2);

  var _super2 = _createSuper(MenuPortal);

  function MenuPortal() {
    var _this2;

    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, MenuPortal);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _this2.state = {
      placement: null
    };

    _this2.getPortalPlacement = function (_ref7) {
      var placement = _ref7.placement;
      var initialPlacement = coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed

      if (placement !== initialPlacement) {
        _this2.setState({
          placement: placement
        });
      }
    };

    return _this2;
  }

  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(MenuPortal, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          appendTo = _this$props2.appendTo,
          children = _this$props2.children,
          controlElement = _this$props2.controlElement,
          menuPlacement = _this$props2.menuPlacement,
          position = _this$props2.menuPosition,
          getStyles = _this$props2.getStyles;
      var isFixed = position === 'fixed'; // bail early if required elements aren't present

      if (!appendTo && !isFixed || !controlElement) {
        return null;
      }

      var placement = this.state.placement || coercePlacement(menuPlacement);
      var rect = getBoundingClientObj(controlElement);
      var scrollDistance = isFixed ? 0 : window.pageYOffset;
      var offset = rect[placement] + scrollDistance;
      var state = {
        offset: offset,
        position: position,
        rect: rect
      }; // same wrapper element whether fixed or portalled

      var menuWrapper = Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])("div", {
        css: getStyles('menuPortal', state)
      }, children);
      return Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])(PortalPlacementContext.Provider, {
        value: {
          getPortalPlacement: this.getPortalPlacement
        }
      }, appendTo ? /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_10_react_dom__["createPortal"])(menuWrapper, appendTo) : menuWrapper);
    }
  }]);

  return MenuPortal;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && Object(__WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_esm_typeof__["a" /* default */])(a) == 'object' && Object(__WEBPACK_IMPORTED_MODULE_11__babel_runtime_helpers_esm_typeof__["a" /* default */])(b) == 'object') {
    var arrA = isArray(a),
        arrB = isArray(b),
        i,
        length,
        key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;

      for (i = length; i-- !== 0;) {
        if (!equal(a[i], b[i])) return false;
      }

      return true;
    }

    if (arrA != arrB) return false;
    var dateA = a instanceof Date,
        dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();
    var regexpA = a instanceof RegExp,
        regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();
    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length) {
      return false;
    }

    for (i = length; i-- !== 0;) {
      if (!hasProp.call(b, keys[i])) return false;
    } // end fast-deep-equal
    // Custom handling for React


    for (i = length; i-- !== 0;) {
      key = keys[i];

      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    } // fast-deep-equal index.js 2.0.1


    return true;
  }

  return a !== a && b !== b;
} // end fast-deep-equal


function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (error.message && error.message.match(/stack|recursion/i)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    } // some other error. we should definitely know about these


    throw error;
  }
}

var containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isRtl = _ref.isRtl;
  return {
    label: 'container',
    direction: isRtl ? 'rtl' : null,
    pointerEvents: isDisabled ? 'none' : null,
    // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = function SelectContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      isRtl = props.isRtl;
  return Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('container', props),
    className: cx({
      '--is-disabled': isDisabled,
      '--is-rtl': isRtl
    }, className)
  }, innerProps), children);
}; // ==============================
// Value Container
// ==============================

var valueContainerCSS = function valueContainerCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
    WebkitOverflowScrolling: 'touch',
    position: 'relative',
    overflow: 'hidden'
  };
};
var ValueContainer = function ValueContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      isMulti = props.isMulti,
      getStyles = props.getStyles,
      hasValue = props.hasValue;
  return Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])("div", {
    css: getStyles('valueContainer', props),
    className: cx({
      'value-container': true,
      'value-container--is-multi': isMulti,
      'value-container--has-value': hasValue
    }, className)
  }, children);
}; // ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles;
  return Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])("div", {
    css: getStyles('indicatorsContainer', props),
    className: cx({
      indicators: true
    }, className)
  }, children);
};

function _templateObject() {
  var data = Object(__WEBPACK_IMPORTED_MODULE_13__babel_runtime_helpers_esm_taggedTemplateLiteral__["a" /* default */])(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref2 =  true ? {
  name: "19bqh2r",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;"
} : {
  name: "19bqh2r",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

// ==============================
// Dropdown & Clear Icons
// ==============================
var Svg = function Svg(_ref) {
  var size = _ref.size,
      props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref, ["size"]);

  return Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])("svg", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2
  }, props));
};

var CrossIcon = function CrossIcon(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])(Svg, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    size: 20
  }, props), Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])(Svg, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    size: 20
  }, props), Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}; // ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref3) {
  var isFocused = _ref3.isFocused,
      _ref3$theme = _ref3.theme,
      baseUnit = _ref3$theme.spacing.baseUnit,
      colors = _ref3$theme.colors;
  return {
    label: 'indicatorContainer',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    ':hover': {
      color: isFocused ? colors.neutral80 : colors.neutral40
    }
  };
};

var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, innerProps, {
    css: getStyles('dropdownIndicator', props),
    className: cx({
      indicator: true,
      'dropdown-indicator': true
    }, className)
  }), children || Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, innerProps, {
    css: getStyles('clearIndicator', props),
    className: cx({
      indicator: true,
      'clear-indicator': true
    }, className)
  }), children || Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])(CrossIcon, null));
}; // ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4) {
  var isDisabled = _ref4.isDisabled,
      _ref4$theme = _ref4.theme,
      baseUnit = _ref4$theme.spacing.baseUnit,
      colors = _ref4$theme.colors;
  return {
    label: 'indicatorSeparator',
    alignSelf: 'stretch',
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: baseUnit * 2,
    marginTop: baseUnit * 2,
    width: 1
  };
};
var IndicatorSeparator = function IndicatorSeparator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])("span", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, innerProps, {
    css: getStyles('indicatorSeparator', props),
    className: cx({
      'indicator-separator': true
    }, className)
  }));
}; // ==============================
// Loading
// ==============================

var loadingDotAnimations = Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["d" /* keyframes */])(_templateObject());
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5) {
  var isFocused = _ref5.isFocused,
      size = _ref5.size,
      _ref5$theme = _ref5.theme,
      colors = _ref5$theme.colors,
      baseUnit = _ref5$theme.spacing.baseUnit;
  return {
    label: 'loadingIndicator',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  };
};

var LoadingDot = function LoadingDot(_ref6) {
  var delay = _ref6.delay,
      offset = _ref6.offset;
  return Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])("span", {
    css: /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_12__emotion_css__["a" /* default */])({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
      backgroundColor: 'currentColor',
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : null,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    },  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
};

var LoadingIndicator = function LoadingIndicator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isRtl = props.isRtl;
  return Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, innerProps, {
    css: getStyles('loadingIndicator', props),
    className: cx({
      indicator: true,
      'loading-indicator': true
    }, className)
  }), Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])(LoadingDot, {
    delay: 0,
    offset: isRtl
  }), Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])(LoadingDot, {
    delay: 160,
    offset: true
  }), Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])(LoadingDot, {
    delay: 320,
    offset: !isRtl
  }));
};
LoadingIndicator.defaultProps = {
  size: 4
};

var css = function css(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      borderRadius = _ref$theme.borderRadius,
      spacing = _ref$theme.spacing;
  return {
    label: 'control',
    alignItems: 'center',
    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : null,
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms',
    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  };
};

var Control = function Control(props) {
  var children = props.children,
      cx = props.cx,
      getStyles = props.getStyles,
      className = props.className,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      innerRef = props.innerRef,
      innerProps = props.innerProps,
      menuIsOpen = props.menuIsOpen;
  return Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: innerRef,
    css: getStyles('control', props),
    className: cx({
      control: true,
      'control--is-disabled': isDisabled,
      'control--is-focused': isFocused,
      'control--menu-is-open': menuIsOpen
    }, className)
  }, innerProps), children);
};

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var groupCSS = function groupCSS(_ref) {
  var spacing = _ref.theme.spacing;
  return {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};

var Group = function Group(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      Heading = props.Heading,
      headingProps = props.headingProps,
      label = props.label,
      theme = props.theme,
      selectProps = props.selectProps;
  return Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])("div", {
    css: getStyles('group', props),
    className: cx({
      group: true
    }, className)
  }, Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])(Heading, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, headingProps, {
    selectProps: selectProps,
    theme: theme,
    getStyles: getStyles,
    cx: cx
  }), label), Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])("div", null, children));
};

var groupHeadingCSS = function groupHeadingCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    label: 'group',
    color: '#999',
    cursor: 'default',
    display: 'block',
    fontSize: '75%',
    fontWeight: '500',
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  };
};
var GroupHeading = function GroupHeading(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      theme = props.theme,
      selectProps = props.selectProps,
      cleanProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["className", "cx", "getStyles", "theme", "selectProps"]);

  return Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('groupHeading', _objectSpread$1({
      theme: theme
    }, cleanProps)),
    className: cx({
      'group-heading': true
    }, className)
  }, cleanProps));
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var inputCSS = function inputCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    visibility: isDisabled ? 'hidden' : 'visible',
    color: colors.neutral80
  };
};

var inputStyle = function inputStyle(isHidden) {
  return {
    label: 'input',
    background: 0,
    border: 0,
    fontSize: 'inherit',
    opacity: isHidden ? 0 : 1,
    outline: 0,
    padding: 0,
    color: 'inherit'
  };
};

var Input = function Input(_ref2) {
  var className = _ref2.className,
      cx = _ref2.cx,
      getStyles = _ref2.getStyles,
      innerRef = _ref2.innerRef,
      isHidden = _ref2.isHidden,
      isDisabled = _ref2.isDisabled,
      theme = _ref2.theme,
      selectProps = _ref2.selectProps,
      props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref2, ["className", "cx", "getStyles", "innerRef", "isHidden", "isDisabled", "theme", "selectProps"]);

  return Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])("div", {
    css: getStyles('input', _objectSpread$2({
      theme: theme
    }, props))
  }, Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])(__WEBPACK_IMPORTED_MODULE_14_react_input_autosize___default.a, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: cx({
      input: true
    }, className),
    inputRef: innerRef,
    inputStyle: inputStyle(isHidden),
    disabled: isDisabled
  }, props)));
};

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var multiValueCSS = function multiValueCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      borderRadius = _ref$theme.borderRadius,
      colors = _ref$theme.colors;
  return {
    label: 'multiValue',
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    display: 'flex',
    margin: spacing.baseUnit / 2,
    minWidth: 0 // resolves flex/text-overflow bug

  };
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
  var _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      colors = _ref2$theme.colors,
      cropWithEllipsis = _ref2.cropWithEllipsis;
  return {
    borderRadius: borderRadius / 2,
    color: colors.neutral80,
    fontSize: '85%',
    overflow: 'hidden',
    padding: 3,
    paddingLeft: 6,
    textOverflow: cropWithEllipsis ? 'ellipsis' : null,
    whiteSpace: 'nowrap'
  };
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
  var _ref3$theme = _ref3.theme,
      spacing = _ref3$theme.spacing,
      borderRadius = _ref3$theme.borderRadius,
      colors = _ref3$theme.colors,
      isFocused = _ref3.isFocused;
  return {
    alignItems: 'center',
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused && colors.dangerLight,
    display: 'flex',
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  };
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
  var children = _ref4.children,
      innerProps = _ref4.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
  var children = _ref5.children,
      innerProps = _ref5.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])("div", innerProps, children || Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])(CrossIcon, {
    size: 14
  }));
}

var MultiValue = function MultiValue(props) {
  var children = props.children,
      className = props.className,
      components = props.components,
      cx = props.cx,
      data = props.data,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      removeProps = props.removeProps,
      selectProps = props.selectProps;
  var Container = components.Container,
      Label = components.Label,
      Remove = components.Remove;
  return Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["b" /* ClassNames */], null, function (_ref6) {
    var css = _ref6.css,
        emotionCx = _ref6.cx;
    return Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])(Container, {
      data: data,
      innerProps: _objectSpread$3(_objectSpread$3({}, innerProps), {}, {
        className: emotionCx(css(getStyles('multiValue', props)), cx({
          'multi-value': true,
          'multi-value--is-disabled': isDisabled
        }, className))
      }),
      selectProps: selectProps
    }, Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])(Label, {
      data: data,
      innerProps: {
        className: emotionCx(css(getStyles('multiValueLabel', props)), cx({
          'multi-value__label': true
        }, className))
      },
      selectProps: selectProps
    }, children), Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])(Remove, {
      data: data,
      innerProps: _objectSpread$3({
        className: emotionCx(css(getStyles('multiValueRemove', props)), cx({
          'multi-value__remove': true
        }, className))
      }, removeProps),
      selectProps: selectProps
    }));
  });
};

MultiValue.defaultProps = {
  cropWithEllipsis: true
};

var optionCSS = function optionCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      isSelected = _ref.isSelected,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'option',
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
    // provide some affordance on touch devices
    ':active': {
      backgroundColor: !isDisabled && (isSelected ? colors.primary : colors.primary50)
    }
  };
};

var Option = function Option(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('option', props),
    className: cx({
      option: true,
      'option--is-disabled': isDisabled,
      'option--is-focused': isFocused,
      'option--is-selected': isSelected
    }, className),
    ref: innerRef
  }, innerProps), children);
};

var placeholderCSS = function placeholderCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'placeholder',
    color: colors.neutral50,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var Placeholder = function Placeholder(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('placeholder', props),
    className: cx({
      placeholder: true
    }, className)
  }, innerProps), children);
};

var css$1 = function css(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'singleValue',
    color: isDisabled ? colors.neutral40 : colors.neutral80,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    maxWidth: "calc(100% - ".concat(spacing.baseUnit * 2, "px)"),
    overflow: 'hidden',
    position: 'absolute',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var SingleValue = function SingleValue(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_9__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('singleValue', props),
    className: cx({
      'single-value': true,
      'single-value--is-disabled': isDisabled
    }, className)
  }, innerProps), children);
};

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var components = {
  ClearIndicator: ClearIndicator,
  Control: Control,
  DropdownIndicator: DropdownIndicator,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option,
  Placeholder: Placeholder,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
  return _objectSpread$4(_objectSpread$4({}, components), props.components);
};




/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	_createClass(AutosizeInput, null, [{
		key: 'getDerivedStateFromProps',
		value: function getDerivedStateFromProps(props, state) {
			var id = props.id;

			return id !== state.prevId ? { inputId: id || generateId(), prevId: id } : null;
		}
	}]);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId(),
			prevId: props.id
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Select; });
/* unused harmony export a */
/* unused harmony export c */
/* unused harmony export d */
/* unused harmony export m */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createClass__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_memoize_one__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__emotion_core__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_dom__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__emotion_css__ = __webpack_require__(166);


















var diacritics = [{
  base: 'A',
  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
}, {
  base: 'AA',
  letters: "\uA732"
}, {
  base: 'AE',
  letters: "\xC6\u01FC\u01E2"
}, {
  base: 'AO',
  letters: "\uA734"
}, {
  base: 'AU',
  letters: "\uA736"
}, {
  base: 'AV',
  letters: "\uA738\uA73A"
}, {
  base: 'AY',
  letters: "\uA73C"
}, {
  base: 'B',
  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
}, {
  base: 'C',
  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
}, {
  base: 'D',
  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
}, {
  base: 'DZ',
  letters: "\u01F1\u01C4"
}, {
  base: 'Dz',
  letters: "\u01F2\u01C5"
}, {
  base: 'E',
  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
}, {
  base: 'F',
  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
}, {
  base: 'G',
  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
}, {
  base: 'H',
  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
}, {
  base: 'I',
  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
}, {
  base: 'J',
  letters: "J\u24BF\uFF2A\u0134\u0248"
}, {
  base: 'K',
  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
}, {
  base: 'L',
  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
}, {
  base: 'LJ',
  letters: "\u01C7"
}, {
  base: 'Lj',
  letters: "\u01C8"
}, {
  base: 'M',
  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
}, {
  base: 'N',
  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
}, {
  base: 'NJ',
  letters: "\u01CA"
}, {
  base: 'Nj',
  letters: "\u01CB"
}, {
  base: 'O',
  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
}, {
  base: 'OI',
  letters: "\u01A2"
}, {
  base: 'OO',
  letters: "\uA74E"
}, {
  base: 'OU',
  letters: "\u0222"
}, {
  base: 'P',
  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
}, {
  base: 'Q',
  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
}, {
  base: 'R',
  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
}, {
  base: 'S',
  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
}, {
  base: 'T',
  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
}, {
  base: 'TZ',
  letters: "\uA728"
}, {
  base: 'U',
  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
}, {
  base: 'V',
  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
}, {
  base: 'VY',
  letters: "\uA760"
}, {
  base: 'W',
  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
}, {
  base: 'X',
  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
}, {
  base: 'Y',
  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
}, {
  base: 'Z',
  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
}, {
  base: 'a',
  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
}, {
  base: 'aa',
  letters: "\uA733"
}, {
  base: 'ae',
  letters: "\xE6\u01FD\u01E3"
}, {
  base: 'ao',
  letters: "\uA735"
}, {
  base: 'au',
  letters: "\uA737"
}, {
  base: 'av',
  letters: "\uA739\uA73B"
}, {
  base: 'ay',
  letters: "\uA73D"
}, {
  base: 'b',
  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
}, {
  base: 'c',
  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
}, {
  base: 'd',
  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
}, {
  base: 'dz',
  letters: "\u01F3\u01C6"
}, {
  base: 'e',
  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
}, {
  base: 'f',
  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
}, {
  base: 'g',
  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
}, {
  base: 'h',
  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
}, {
  base: 'hv',
  letters: "\u0195"
}, {
  base: 'i',
  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
}, {
  base: 'j',
  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
}, {
  base: 'k',
  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
}, {
  base: 'l',
  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
}, {
  base: 'lj',
  letters: "\u01C9"
}, {
  base: 'm',
  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
}, {
  base: 'n',
  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
}, {
  base: 'nj',
  letters: "\u01CC"
}, {
  base: 'o',
  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
}, {
  base: 'oi',
  letters: "\u01A3"
}, {
  base: 'ou',
  letters: "\u0223"
}, {
  base: 'oo',
  letters: "\uA74F"
}, {
  base: 'p',
  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
}, {
  base: 'q',
  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
}, {
  base: 'r',
  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
}, {
  base: 's',
  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
}, {
  base: 't',
  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
}, {
  base: 'tz',
  letters: "\uA729"
}, {
  base: 'u',
  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
}, {
  base: 'v',
  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
}, {
  base: 'vy',
  letters: "\uA761"
}, {
  base: 'w',
  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
}, {
  base: 'x',
  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
}, {
  base: 'y',
  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
}, {
  base: 'z',
  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
}];
var anyDiacritic = new RegExp('[' + diacritics.map(function (d) {
  return d.letters;
}).join('') + ']', 'g');
var diacriticToBase = {};

for (var i = 0; i < diacritics.length; i++) {
  var diacritic = diacritics[i];

  for (var j = 0; j < diacritic.letters.length; j++) {
    diacriticToBase[diacritic.letters[j]] = diacritic.base;
  }
}

var stripDiacritics = function stripDiacritics(str) {
  return str.replace(anyDiacritic, function (match) {
    return diacriticToBase[match];
  });
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var trimString = function trimString(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var defaultStringify = function defaultStringify(option) {
  return "".concat(option.label, " ").concat(option.value);
};

var createFilter = function createFilter(config) {
  return function (option, rawInput) {
    var _ignoreCase$ignoreAcc = _objectSpread({
      ignoreCase: true,
      ignoreAccents: true,
      stringify: defaultStringify,
      trim: true,
      matchFrom: 'any'
    }, config),
        ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
        ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
        stringify = _ignoreCase$ignoreAcc.stringify,
        trim = _ignoreCase$ignoreAcc.trim,
        matchFrom = _ignoreCase$ignoreAcc.matchFrom;

    var input = trim ? trimString(rawInput) : rawInput;
    var candidate = trim ? trimString(stringify(option)) : stringify(option);

    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }

    if (ignoreAccents) {
      input = stripDiacritics(input);
      candidate = stripDiacritics(candidate);
    }

    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref =  true ? {
  name: "1laao21-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;"
} : {
  name: "1laao21-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVFJIiwiZmlsZSI6IkExMXlUZXh0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgdHlwZSBFbGVtZW50Q29uZmlnIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vY29yZSc7XG5cbi8vIEFzc2lzdGl2ZSB0ZXh0IHRvIGRlc2NyaWJlIHZpc3VhbCBlbGVtZW50cy4gSGlkZGVuIGZvciBzaWdodGVkIHVzZXJzLlxuY29uc3QgQTExeVRleHQgPSAocHJvcHM6IEVsZW1lbnRDb25maWc8J3NwYW4nPikgPT4gKFxuICA8c3BhblxuICAgIGNzcz17e1xuICAgICAgbGFiZWw6ICdhMTF5VGV4dCcsXG4gICAgICB6SW5kZXg6IDk5OTksXG4gICAgICBib3JkZXI6IDAsXG4gICAgICBjbGlwOiAncmVjdCgxcHgsIDFweCwgMXB4LCAxcHgpJyxcbiAgICAgIGhlaWdodDogMSxcbiAgICAgIHdpZHRoOiAxLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBvdmVyZmxvdzogJ2hpZGRlbicsXG4gICAgICBwYWRkaW5nOiAwLFxuICAgICAgd2hpdGVTcGFjZTogJ25vd3JhcCcsXG4gICAgfX1cbiAgICB7Li4ucHJvcHN9XG4gIC8+XG4pO1xuXG5leHBvcnQgZGVmYXVsdCBBMTF5VGV4dDtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var A11yText = function A11yText(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_13__emotion_core__["c" /* jsx */])("span", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: _ref
  }, props));
};

function DummyInput(_ref) {
  var inProp = _ref.in,
      out = _ref.out,
      onExited = _ref.onExited,
      appear = _ref.appear,
      enter = _ref.enter,
      exit = _ref.exit,
      innerRef = _ref.innerRef,
      emotion = _ref.emotion,
      props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref, ["in", "out", "onExited", "appear", "enter", "exit", "innerRef", "emotion"]);

  return Object(__WEBPACK_IMPORTED_MODULE_13__emotion_core__["c" /* jsx */])("input", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: innerRef
  }, props, {
    css: /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_16__emotion_css__["a" /* default */])({
      label: 'dummyInput',
      // get rid of any default styles
      background: 0,
      border: 0,
      fontSize: 'inherit',
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: 'transparent',
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: 'relative',
      transform: 'scale(0)'
    },  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBbUJNIiwiZmlsZSI6IkR1bW15SW5wdXQuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9jb3JlJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gRHVtbXlJbnB1dCh7XG4gIGluOiBpblByb3AsXG4gIG91dCxcbiAgb25FeGl0ZWQsXG4gIGFwcGVhcixcbiAgZW50ZXIsXG4gIGV4aXQsXG4gIGlubmVyUmVmLFxuICBlbW90aW9uLFxuICAuLi5wcm9wc1xufTogYW55KSB7XG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLnByb3BzfVxuICAgICAgY3NzPXt7XG4gICAgICAgIGxhYmVsOiAnZHVtbXlJbnB1dCcsXG4gICAgICAgIC8vIGdldCByaWQgb2YgYW55IGRlZmF1bHQgc3R5bGVzXG4gICAgICAgIGJhY2tncm91bmQ6IDAsXG4gICAgICAgIGJvcmRlcjogMCxcbiAgICAgICAgZm9udFNpemU6ICdpbmhlcml0JyxcbiAgICAgICAgb3V0bGluZTogMCxcbiAgICAgICAgcGFkZGluZzogMCxcbiAgICAgICAgLy8gaW1wb3J0YW50ISB3aXRob3V0IGB3aWR0aGAgYnJvd3NlcnMgd29uJ3QgYWxsb3cgZm9jdXNcbiAgICAgICAgd2lkdGg6IDEsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBkZXNrdG9wXG4gICAgICAgIGNvbG9yOiAndHJhbnNwYXJlbnQnLFxuXG4gICAgICAgIC8vIHJlbW92ZSBjdXJzb3Igb24gbW9iaWxlIHdoaWxzdCBtYWludGFpbmluZyBcInNjcm9sbCBpbnRvIHZpZXdcIiBiZWhhdmlvdXJcbiAgICAgICAgbGVmdDogLTEwMCxcbiAgICAgICAgb3BhY2l0eTogMCxcbiAgICAgICAgcG9zaXRpb246ICdyZWxhdGl2ZScsXG4gICAgICAgIHRyYW5zZm9ybTogJ3NjYWxlKDApJyxcbiAgICAgIH19XG4gICAgLz5cbiAgKTtcbn1cbiJdfQ== */")
  }));
}

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var NodeResolver = /*#__PURE__*/function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(NodeResolver, _Component);

  var _super = _createSuper(NodeResolver);

  function NodeResolver() {
    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, NodeResolver);

    return _super.apply(this, arguments);
  }

  Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createClass__["a" /* default */])(NodeResolver, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.innerRef(Object(__WEBPACK_IMPORTED_MODULE_14_react_dom__["findDOMNode"])(this));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.innerRef(null);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return NodeResolver;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
var LOCK_STYLES = {
  boxSizing: 'border-box',
  // account for possible declaration `width: 100%;` on body
  overflow: 'hidden',
  position: 'relative',
  height: '100%'
};

function preventTouchMove(e) {
  e.preventDefault();
}
function allowTouchMove(e) {
  e.stopPropagation();
}
function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;

  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
} // `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface

function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var canUseDOM = !!( window.document && window.document.createElement);
var activeScrollLocks = 0;

var ScrollLock = /*#__PURE__*/function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(ScrollLock, _Component);

  var _super = _createSuper$1(ScrollLock);

  function ScrollLock() {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ScrollLock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.originalStyles = {};
    _this.listenerOptions = {
      capture: false,
      passive: false
    };
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createClass__["a" /* default */])(ScrollLock, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (!canUseDOM) return;
      var _this$props = this.props,
          accountForScrollbars = _this$props.accountForScrollbars,
          touchScrollTarget = _this$props.touchScrollTarget;
      var target = document.body;
      var targetStyle = target && target.style;

      if (accountForScrollbars) {
        // store any styles already applied to the body
        STYLE_KEYS.forEach(function (key) {
          var val = targetStyle && targetStyle[key];
          _this2.originalStyles[key] = val;
        });
      } // apply the lock styles and padding if this is the first scroll lock


      if (accountForScrollbars && activeScrollLocks < 1) {
        var currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
        var clientWidth = document.body ? document.body.clientWidth : 0;
        var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
        Object.keys(LOCK_STYLES).forEach(function (key) {
          var val = LOCK_STYLES[key];

          if (targetStyle) {
            targetStyle[key] = val;
          }
        });

        if (targetStyle) {
          targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
      } // account for touch devices


      if (target && isTouchDevice()) {
        // Mobile Safari ignores { overflow: hidden } declaration on the body.
        target.addEventListener('touchmove', preventTouchMove, this.listenerOptions); // Allow scroll on provided target

        if (touchScrollTarget) {
          touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.addEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      } // increment active scroll locks


      activeScrollLocks += 1;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      if (!canUseDOM) return;
      var _this$props2 = this.props,
          accountForScrollbars = _this$props2.accountForScrollbars,
          touchScrollTarget = _this$props2.touchScrollTarget;
      var target = document.body;
      var targetStyle = target && target.style; // safely decrement active scroll locks

      activeScrollLocks = Math.max(activeScrollLocks - 1, 0); // reapply original body styles, if any

      if (accountForScrollbars && activeScrollLocks < 1) {
        STYLE_KEYS.forEach(function (key) {
          var val = _this3.originalStyles[key];

          if (targetStyle) {
            targetStyle[key] = val;
          }
        });
      } // remove touch listeners


      if (target && isTouchDevice()) {
        target.removeEventListener('touchmove', preventTouchMove, this.listenerOptions);

        if (touchScrollTarget) {
          touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.removeEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return ScrollLock;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

ScrollLock.defaultProps = {
  accountForScrollbars: true
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _ref$1 =  true ? {
  name: "1dsbpcp",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;"
} : {
  name: "1dsbpcp",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
};

// NOTE:
// We shouldn't need this after updating to React v16.3.0, which introduces:
// - createRef() https://reactjs.org/docs/react-api.html#reactcreateref
// - forwardRef() https://reactjs.org/docs/react-api.html#reactforwardref
var ScrollBlock = /*#__PURE__*/function (_PureComponent) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(ScrollBlock, _PureComponent);

  var _super = _createSuper$2(ScrollBlock);

  function ScrollBlock() {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ScrollBlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      touchScrollTarget: null
    };

    _this.getScrollTarget = function (ref) {
      if (ref === _this.state.touchScrollTarget) return;

      _this.setState({
        touchScrollTarget: ref
      });
    };

    _this.blurSelectInput = function () {
      if (document.activeElement) {
        document.activeElement.blur();
      }
    };

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createClass__["a" /* default */])(ScrollBlock, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          isEnabled = _this$props.isEnabled;
      var touchScrollTarget = this.state.touchScrollTarget; // bail early if not enabled

      if (!isEnabled) return children;
      /*
       * Div
       * ------------------------------
       * blocks scrolling on non-body elements behind the menu
        * NodeResolver
       * ------------------------------
       * we need a reference to the scrollable element to "unlock" scroll on
       * mobile devices
        * ScrollLock
       * ------------------------------
       * actually does the scroll locking
       */

      return Object(__WEBPACK_IMPORTED_MODULE_13__emotion_core__["c" /* jsx */])("div", null, Object(__WEBPACK_IMPORTED_MODULE_13__emotion_core__["c" /* jsx */])("div", {
        onClick: this.blurSelectInput,
        css: _ref$1
      }), Object(__WEBPACK_IMPORTED_MODULE_13__emotion_core__["c" /* jsx */])(NodeResolver, {
        innerRef: this.getScrollTarget
      }, children), touchScrollTarget ? Object(__WEBPACK_IMPORTED_MODULE_13__emotion_core__["c" /* jsx */])(ScrollLock, {
        touchScrollTarget: touchScrollTarget
      }) : null);
    }
  }]);

  return ScrollBlock;
}(__WEBPACK_IMPORTED_MODULE_11_react__["PureComponent"]);

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ScrollCaptor = /*#__PURE__*/function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(ScrollCaptor, _Component);

  var _super = _createSuper$3(ScrollCaptor);

  function ScrollCaptor() {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ScrollCaptor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.isBottom = false;
    _this.isTop = false;
    _this.scrollTarget = void 0;
    _this.touchStart = void 0;

    _this.cancelScroll = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };

    _this.handleEventDelta = function (event, delta) {
      var _this$props = _this.props,
          onBottomArrive = _this$props.onBottomArrive,
          onBottomLeave = _this$props.onBottomLeave,
          onTopArrive = _this$props.onTopArrive,
          onTopLeave = _this$props.onTopLeave;
      var _this$scrollTarget = _this.scrollTarget,
          scrollTop = _this$scrollTarget.scrollTop,
          scrollHeight = _this$scrollTarget.scrollHeight,
          clientHeight = _this$scrollTarget.clientHeight;
      var target = _this.scrollTarget;
      var isDeltaPositive = delta > 0;
      var availableScroll = scrollHeight - clientHeight - scrollTop;
      var shouldCancelScroll = false; // reset bottom/top flags

      if (availableScroll > delta && _this.isBottom) {
        if (onBottomLeave) onBottomLeave(event);
        _this.isBottom = false;
      }

      if (isDeltaPositive && _this.isTop) {
        if (onTopLeave) onTopLeave(event);
        _this.isTop = false;
      } // bottom limit


      if (isDeltaPositive && delta > availableScroll) {
        if (onBottomArrive && !_this.isBottom) {
          onBottomArrive(event);
        }

        target.scrollTop = scrollHeight;
        shouldCancelScroll = true;
        _this.isBottom = true; // top limit
      } else if (!isDeltaPositive && -delta > scrollTop) {
        if (onTopArrive && !_this.isTop) {
          onTopArrive(event);
        }

        target.scrollTop = 0;
        shouldCancelScroll = true;
        _this.isTop = true;
      } // cancel scroll


      if (shouldCancelScroll) {
        _this.cancelScroll(event);
      }
    };

    _this.onWheel = function (event) {
      _this.handleEventDelta(event, event.deltaY);
    };

    _this.onTouchStart = function (event) {
      // set touch start so we can calculate touchmove delta
      _this.touchStart = event.changedTouches[0].clientY;
    };

    _this.onTouchMove = function (event) {
      var deltaY = _this.touchStart - event.changedTouches[0].clientY;

      _this.handleEventDelta(event, deltaY);
    };

    _this.getScrollTarget = function (ref) {
      _this.scrollTarget = ref;
    };

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createClass__["a" /* default */])(ScrollCaptor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListening(this.scrollTarget);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListening(this.scrollTarget);
    }
  }, {
    key: "startListening",
    value: function startListening(el) {
      // bail early if no element is available to attach to
      if (!el) return; // all the if statements are to appease Flow 😢

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('wheel', this.onWheel, false);
      }

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchstart', this.onTouchStart, false);
      }

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: "stopListening",
    value: function stopListening(el) {
      if (!el) return; // all the if statements are to appease Flow 😢

      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('wheel', this.onWheel, false);
      }

      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchstart', this.onTouchStart, false);
      }

      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(NodeResolver, {
        innerRef: this.getScrollTarget
      }, this.props.children);
    }
  }]);

  return ScrollCaptor;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

function ScrollCaptorSwitch(_ref) {
  var _ref$isEnabled = _ref.isEnabled,
      isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled,
      props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref, ["isEnabled"]);

  return isEnabled ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ScrollCaptor, props) : props.children;
}

var instructionsAriaMessage = function instructionsAriaMessage(event) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isSearchable = context.isSearchable,
      isMulti = context.isMulti,
      label = context.label,
      isDisabled = context.isDisabled,
      tabSelectsValue = context.tabSelectsValue;

  switch (event) {
    case 'menu':
      return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");

    case 'input':
      return "".concat(label ? label : 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');

    case 'value':
      return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
  }
};
var valueEventAriaMessage = function valueEventAriaMessage(event, context) {
  var value = context.value,
      isDisabled = context.isDisabled;
  if (!value) return;

  switch (event) {
    case 'deselect-option':
    case 'pop-value':
    case 'remove-value':
      return "option ".concat(value, ", deselected.");

    case 'select-option':
      return isDisabled ? "option ".concat(value, " is disabled. Select another option.") : "option ".concat(value, ", selected.");
  }
};
var valueFocusAriaMessage = function valueFocusAriaMessage(_ref) {
  var focusedValue = _ref.focusedValue,
      getOptionLabel = _ref.getOptionLabel,
      selectValue = _ref.selectValue;
  return "value ".concat(getOptionLabel(focusedValue), " focused, ").concat(selectValue.indexOf(focusedValue) + 1, " of ").concat(selectValue.length, ".");
};
var optionFocusAriaMessage = function optionFocusAriaMessage(_ref2) {
  var focusedOption = _ref2.focusedOption,
      getOptionLabel = _ref2.getOptionLabel,
      options = _ref2.options;
  return "option ".concat(getOptionLabel(focusedOption), " focused").concat(focusedOption.isDisabled ? ' disabled' : '', ", ").concat(options.indexOf(focusedOption) + 1, " of ").concat(options.length, ".");
};
var resultsAriaMessage = function resultsAriaMessage(_ref3) {
  var inputValue = _ref3.inputValue,
      screenReaderMessage = _ref3.screenReaderMessage;
  return "".concat(screenReaderMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
};

var formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};
var getOptionLabel = function getOptionLabel(option) {
  return option.label;
};
var getOptionValue = function getOptionValue(option) {
  return option.value;
};
var isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var defaultStyles = {
  clearIndicator: __WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["i" /* c */],
  container: __WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["g" /* a */],
  control: __WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["h" /* b */],
  dropdownIndicator: __WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["j" /* d */],
  group: __WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["m" /* g */],
  groupHeading: __WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["k" /* e */],
  indicatorsContainer: __WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["o" /* i */],
  indicatorSeparator: __WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["l" /* f */],
  input: __WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["n" /* h */],
  loadingIndicator: __WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["r" /* l */],
  loadingMessage: __WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["p" /* j */],
  menu: __WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["s" /* m */],
  menuList: __WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["q" /* k */],
  menuPortal: __WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["t" /* n */],
  multiValue: __WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["u" /* o */],
  multiValueLabel: __WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["v" /* p */],
  multiValueRemove: __WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["w" /* q */],
  noOptionsMessage: __WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["x" /* r */],
  option: __WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["y" /* s */],
  placeholder: __WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["z" /* t */],
  singleValue: __WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["A" /* u */],
  valueContainer: __WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["B" /* v */]
}; // Merge Utility
// Allows consumers to extend a base Select with additional styles

function mergeStyles(source) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // initialize with source styles
  var styles = _objectSpread$1({}, source); // massage in target styles


  Object.keys(target).forEach(function (key) {
    if (source[key]) {
      styles[key] = function (rsCss, props) {
        return target[key](source[key](rsCss, props), props);
      };
    } else {
      styles[key] = target[key];
    }
  });
  return styles;
}

var colors = {
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',
  danger: '#DE350B',
  dangerLight: '#FFBDAD',
  neutral0: 'hsl(0, 0%, 100%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)'
};
var borderRadius = 4; // Used to calculate consistent margin/padding on elements

var baseUnit = 4; // The minimum height of the control

var controlHeight = 38; // The amount of space between the control and menu */

var menuGutter = baseUnit * 2;
var spacing = {
  baseUnit: baseUnit,
  controlHeight: controlHeight,
  menuGutter: menuGutter
};
var defaultTheme = {
  borderRadius: borderRadius,
  colors: colors,
  spacing: spacing
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$4(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4(); return function _createSuperInternal() { var Super = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var defaultProps = {
  backspaceRemovesValue: true,
  blurInputOnSelect: Object(__WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["C" /* w */])(),
  captureMenuScroll: !Object(__WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["C" /* w */])(),
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel: formatGroupLabel,
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return 'Loading...';
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: 'bottom',
  menuPosition: 'absolute',
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !Object(__WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["D" /* x */])(),
  noOptionsMessage: function noOptionsMessage() {
    return 'No options';
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: 'Select...',
  screenReaderStatus: function screenReaderStatus(_ref) {
    var count = _ref.count;
    return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
  },
  styles: {},
  tabIndex: '0',
  tabSelectsValue: true
};
var instanceId = 1;

var Select = /*#__PURE__*/function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(Select, _Component);

  var _super = _createSuper$4(Select);

  // Misc. Instance Properties
  // ------------------------------
  // TODO
  // Refs
  // ------------------------------
  // Lifecycle
  // ------------------------------
  function Select(_props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Select);

    _this = _super.call(this, _props);
    _this.state = {
      ariaLiveSelection: '',
      ariaLiveContext: '',
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      menuOptions: {
        render: [],
        focusable: []
      },
      selectValue: []
    };
    _this.blockOptionHover = false;
    _this.isComposing = false;
    _this.clearFocusValueOnUpdate = false;
    _this.commonProps = void 0;
    _this.components = void 0;
    _this.hasGroups = false;
    _this.initialTouchX = 0;
    _this.initialTouchY = 0;
    _this.inputIsHiddenAfterUpdate = void 0;
    _this.instancePrefix = '';
    _this.openAfterFocus = false;
    _this.scrollToFocusedOptionOnUpdate = false;
    _this.userIsDragging = void 0;
    _this.controlRef = null;

    _this.getControlRef = function (ref) {
      _this.controlRef = ref;
    };

    _this.focusedOptionRef = null;

    _this.getFocusedOptionRef = function (ref) {
      _this.focusedOptionRef = ref;
    };

    _this.menuListRef = null;

    _this.getMenuListRef = function (ref) {
      _this.menuListRef = ref;
    };

    _this.inputRef = null;

    _this.getInputRef = function (ref) {
      _this.inputRef = ref;
    };

    _this.cacheComponents = function (components) {
      _this.components = Object(__WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["E" /* y */])({
        components: components
      });
    };

    _this.focus = _this.focusInput;
    _this.blur = _this.blurInput;

    _this.onChange = function (newValue, actionMeta) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          name = _this$props.name;
      onChange(newValue, _objectSpread$2(_objectSpread$2({}, actionMeta), {}, {
        name: name
      }));
    };

    _this.setValue = function (newValue) {
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set-value';
      var option = arguments.length > 2 ? arguments[2] : undefined;
      var _this$props2 = _this.props,
          closeMenuOnSelect = _this$props2.closeMenuOnSelect,
          isMulti = _this$props2.isMulti;

      _this.onInputChange('', {
        action: 'set-value'
      });

      if (closeMenuOnSelect) {
        _this.inputIsHiddenAfterUpdate = !isMulti;

        _this.onMenuClose();
      } // when the select value should change, we should reset focusedValue


      _this.clearFocusValueOnUpdate = true;

      _this.onChange(newValue, {
        action: action,
        option: option
      });
    };

    _this.selectOption = function (newValue) {
      var _this$props3 = _this.props,
          blurInputOnSelect = _this$props3.blurInputOnSelect,
          isMulti = _this$props3.isMulti;
      var selectValue = _this.state.selectValue;

      if (isMulti) {
        if (_this.isOptionSelected(newValue, selectValue)) {
          var candidate = _this.getOptionValue(newValue);

          _this.setValue(selectValue.filter(function (i) {
            return _this.getOptionValue(i) !== candidate;
          }), 'deselect-option', newValue);

          _this.announceAriaLiveSelection({
            event: 'deselect-option',
            context: {
              value: _this.getOptionLabel(newValue)
            }
          });
        } else {
          if (!_this.isOptionDisabled(newValue, selectValue)) {
            _this.setValue([].concat(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(selectValue), [newValue]), 'select-option', newValue);

            _this.announceAriaLiveSelection({
              event: 'select-option',
              context: {
                value: _this.getOptionLabel(newValue)
              }
            });
          } else {
            // announce that option is disabled
            _this.announceAriaLiveSelection({
              event: 'select-option',
              context: {
                value: _this.getOptionLabel(newValue),
                isDisabled: true
              }
            });
          }
        }
      } else {
        if (!_this.isOptionDisabled(newValue, selectValue)) {
          _this.setValue(newValue, 'select-option');

          _this.announceAriaLiveSelection({
            event: 'select-option',
            context: {
              value: _this.getOptionLabel(newValue)
            }
          });
        } else {
          // announce that option is disabled
          _this.announceAriaLiveSelection({
            event: 'select-option',
            context: {
              value: _this.getOptionLabel(newValue),
              isDisabled: true
            }
          });
        }
      }

      if (blurInputOnSelect) {
        _this.blurInput();
      }
    };

    _this.removeValue = function (removedValue) {
      var selectValue = _this.state.selectValue;

      var candidate = _this.getOptionValue(removedValue);

      var newValue = selectValue.filter(function (i) {
        return _this.getOptionValue(i) !== candidate;
      });

      _this.onChange(newValue.length ? newValue : null, {
        action: 'remove-value',
        removedValue: removedValue
      });

      _this.announceAriaLiveSelection({
        event: 'remove-value',
        context: {
          value: removedValue ? _this.getOptionLabel(removedValue) : ''
        }
      });

      _this.focusInput();
    };

    _this.clearValue = function () {
      _this.onChange(null, {
        action: 'clear'
      });
    };

    _this.popValue = function () {
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];
      var newValue = selectValue.slice(0, selectValue.length - 1);

      _this.announceAriaLiveSelection({
        event: 'pop-value',
        context: {
          value: lastSelectedValue ? _this.getOptionLabel(lastSelectedValue) : ''
        }
      });

      _this.onChange(newValue.length ? newValue : null, {
        action: 'pop-value',
        removedValue: lastSelectedValue
      });
    };

    _this.getValue = function () {
      return _this.state.selectValue;
    };

    _this.cx = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return __WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["F" /* z */].apply(void 0, [_this.props.classNamePrefix].concat(args));
    };

    _this.getOptionLabel = function (data) {
      return _this.props.getOptionLabel(data);
    };

    _this.getOptionValue = function (data) {
      return _this.props.getOptionValue(data);
    };

    _this.getStyles = function (key, props) {
      var base = defaultStyles[key](props);
      base.boxSizing = 'border-box';
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    };

    _this.getElementId = function (element) {
      return "".concat(_this.instancePrefix, "-").concat(element);
    };

    _this.getActiveDescendentId = function () {
      var menuIsOpen = _this.props.menuIsOpen;
      var _this$state = _this.state,
          menuOptions = _this$state.menuOptions,
          focusedOption = _this$state.focusedOption;
      if (!focusedOption || !menuIsOpen) return undefined;
      var index = menuOptions.focusable.indexOf(focusedOption);
      var option = menuOptions.render[index];
      return option && option.key;
    };

    _this.announceAriaLiveSelection = function (_ref2) {
      var event = _ref2.event,
          context = _ref2.context;

      _this.setState({
        ariaLiveSelection: valueEventAriaMessage(event, context)
      });
    };

    _this.announceAriaLiveContext = function (_ref3) {
      var event = _ref3.event,
          context = _ref3.context;

      _this.setState({
        ariaLiveContext: instructionsAriaMessage(event, _objectSpread$2(_objectSpread$2({}, context), {}, {
          label: _this.props['aria-label']
        }))
      });
    };

    _this.onMenuMouseDown = function (event) {
      if (event.button !== 0) {
        return;
      }

      event.stopPropagation();
      event.preventDefault();

      _this.focusInput();
    };

    _this.onMenuMouseMove = function (event) {
      _this.blockOptionHover = false;
    };

    _this.onControlMouseDown = function (event) {
      var openMenuOnClick = _this.props.openMenuOnClick;

      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }

        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu('first');
        }
      } else {
        if ( // $FlowFixMe
        event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
          _this.onMenuClose();
        }
      }

      if ( // $FlowFixMe
      event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
        event.preventDefault();
      }
    };

    _this.onDropdownIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      if (_this.props.isDisabled) return;
      var _this$props4 = _this.props,
          isMulti = _this$props4.isMulti,
          menuIsOpen = _this$props4.menuIsOpen;

      _this.focusInput();

      if (menuIsOpen) {
        _this.inputIsHiddenAfterUpdate = !isMulti;

        _this.onMenuClose();
      } else {
        _this.openMenu('first');
      }

      event.preventDefault();
      event.stopPropagation();
    };

    _this.onClearIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      _this.clearValue();

      event.stopPropagation();
      _this.openAfterFocus = false;

      if (event.type === 'touchend') {
        _this.focusInput();
      } else {
        setTimeout(function () {
          return _this.focusInput();
        });
      }
    };

    _this.onScroll = function (event) {
      if (typeof _this.props.closeMenuOnScroll === 'boolean') {
        if (event.target instanceof HTMLElement && Object(__WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["a" /* A */])(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === 'function') {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    };

    _this.onCompositionStart = function () {
      _this.isComposing = true;
    };

    _this.onCompositionEnd = function () {
      _this.isComposing = false;
    };

    _this.onTouchStart = function (_ref4) {
      var touches = _ref4.touches;
      var touch = touches && touches.item(0);

      if (!touch) {
        return;
      }

      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    };

    _this.onTouchMove = function (_ref5) {
      var touches = _ref5.touches;
      var touch = touches && touches.item(0);

      if (!touch) {
        return;
      }

      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    };

    _this.onTouchEnd = function (event) {
      if (_this.userIsDragging) return; // close the menu if the user taps outside
      // we're checking on event.target here instead of event.currentTarget, because we want to assert information
      // on events on child elements, not the document (which we've attached this handler to).

      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      } // reset move vars


      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    };

    _this.onControlTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      _this.onControlMouseDown(event);
    };

    _this.onClearIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      _this.onClearIndicatorMouseDown(event);
    };

    _this.onDropdownIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      _this.onDropdownIndicatorMouseDown(event);
    };

    _this.handleInputChange = function (event) {
      var inputValue = event.currentTarget.value;
      _this.inputIsHiddenAfterUpdate = false;

      _this.onInputChange(inputValue, {
        action: 'input-change'
      });

      if (!_this.props.menuIsOpen) {
        _this.onMenuOpen();
      }
    };

    _this.onInputFocus = function (event) {
      var _this$props5 = _this.props,
          isSearchable = _this$props5.isSearchable,
          isMulti = _this$props5.isMulti;

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }

      _this.inputIsHiddenAfterUpdate = false;

      _this.announceAriaLiveContext({
        event: 'input',
        context: {
          isSearchable: isSearchable,
          isMulti: isMulti
        }
      });

      _this.setState({
        isFocused: true
      });

      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu('first');
      }

      _this.openAfterFocus = false;
    };

    _this.onInputBlur = function (event) {
      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();

        return;
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }

      _this.onInputChange('', {
        action: 'input-blur'
      });

      _this.onMenuClose();

      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    };

    _this.onOptionHover = function (focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }

      _this.setState({
        focusedOption: focusedOption
      });
    };

    _this.shouldHideSelectedOptions = function () {
      var _this$props6 = _this.props,
          hideSelectedOptions = _this$props6.hideSelectedOptions,
          isMulti = _this$props6.isMulti;
      if (hideSelectedOptions === undefined) return isMulti;
      return hideSelectedOptions;
    };

    _this.onKeyDown = function (event) {
      var _this$props7 = _this.props,
          isMulti = _this$props7.isMulti,
          backspaceRemovesValue = _this$props7.backspaceRemovesValue,
          escapeClearsValue = _this$props7.escapeClearsValue,
          inputValue = _this$props7.inputValue,
          isClearable = _this$props7.isClearable,
          isDisabled = _this$props7.isDisabled,
          menuIsOpen = _this$props7.menuIsOpen,
          onKeyDown = _this$props7.onKeyDown,
          tabSelectsValue = _this$props7.tabSelectsValue,
          openMenuOnFocus = _this$props7.openMenuOnFocus;
      var _this$state2 = _this.state,
          focusedOption = _this$state2.focusedOption,
          focusedValue = _this$state2.focusedValue,
          selectValue = _this$state2.selectValue;
      if (isDisabled) return;

      if (typeof onKeyDown === 'function') {
        onKeyDown(event);

        if (event.defaultPrevented) {
          return;
        }
      } // Block option hover events when the user has just pressed a key


      _this.blockOptionHover = true;

      switch (event.key) {
        case 'ArrowLeft':
          if (!isMulti || inputValue) return;

          _this.focusValue('previous');

          break;

        case 'ArrowRight':
          if (!isMulti || inputValue) return;

          _this.focusValue('next');

          break;

        case 'Delete':
        case 'Backspace':
          if (inputValue) return;

          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue) return;

            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }

          break;

        case 'Tab':
          if (_this.isComposing) return;

          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
          // option is already selected; it breaks the flow of navigation
          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }

          _this.selectOption(focusedOption);

          break;

        case 'Enter':
          if (event.keyCode === 229) {
            // ignore the keydown event from an Input Method Editor(IME)
            // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
            break;
          }

          if (menuIsOpen) {
            if (!focusedOption) return;
            if (_this.isComposing) return;

            _this.selectOption(focusedOption);

            break;
          }

          return;

        case 'Escape':
          if (menuIsOpen) {
            _this.inputIsHiddenAfterUpdate = false;

            _this.onInputChange('', {
              action: 'menu-close'
            });

            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }

          break;

        case ' ':
          // space
          if (inputValue) {
            return;
          }

          if (!menuIsOpen) {
            _this.openMenu('first');

            break;
          }

          if (!focusedOption) return;

          _this.selectOption(focusedOption);

          break;

        case 'ArrowUp':
          if (menuIsOpen) {
            _this.focusOption('up');
          } else {
            _this.openMenu('last');
          }

          break;

        case 'ArrowDown':
          if (menuIsOpen) {
            _this.focusOption('down');
          } else {
            _this.openMenu('first');
          }

          break;

        case 'PageUp':
          if (!menuIsOpen) return;

          _this.focusOption('pageup');

          break;

        case 'PageDown':
          if (!menuIsOpen) return;

          _this.focusOption('pagedown');

          break;

        case 'Home':
          if (!menuIsOpen) return;

          _this.focusOption('first');

          break;

        case 'End':
          if (!menuIsOpen) return;

          _this.focusOption('last');

          break;

        default:
          return;
      }

      event.preventDefault();
    };

    _this.buildMenuOptions = function (props, selectValue) {
      var _props$inputValue = props.inputValue,
          inputValue = _props$inputValue === void 0 ? '' : _props$inputValue,
          options = props.options;

      var toOption = function toOption(option, id) {
        var isDisabled = _this.isOptionDisabled(option, selectValue);

        var isSelected = _this.isOptionSelected(option, selectValue);

        var label = _this.getOptionLabel(option);

        var value = _this.getOptionValue(option);

        if (_this.shouldHideSelectedOptions() && isSelected || !_this.filterOption({
          label: label,
          value: value,
          data: option
        }, inputValue)) {
          return;
        }

        var onHover = isDisabled ? undefined : function () {
          return _this.onOptionHover(option);
        };
        var onSelect = isDisabled ? undefined : function () {
          return _this.selectOption(option);
        };
        var optionId = "".concat(_this.getElementId('option'), "-").concat(id);
        return {
          innerProps: {
            id: optionId,
            onClick: onSelect,
            onMouseMove: onHover,
            onMouseOver: onHover,
            tabIndex: -1
          },
          data: option,
          isDisabled: isDisabled,
          isSelected: isSelected,
          key: optionId,
          label: label,
          type: 'option',
          value: value
        };
      };

      return options.reduce(function (acc, item, itemIndex) {
        if (item.options) {
          // TODO needs a tidier implementation
          if (!_this.hasGroups) _this.hasGroups = true;
          var items = item.options;
          var children = items.map(function (child, i) {
            var option = toOption(child, "".concat(itemIndex, "-").concat(i));
            if (option) acc.focusable.push(child);
            return option;
          }).filter(Boolean);

          if (children.length) {
            var groupId = "".concat(_this.getElementId('group'), "-").concat(itemIndex);
            acc.render.push({
              type: 'group',
              key: groupId,
              data: item,
              options: children
            });
          }
        } else {
          var option = toOption(item, "".concat(itemIndex));

          if (option) {
            acc.render.push(option);
            acc.focusable.push(item);
          }
        }

        return acc;
      }, {
        render: [],
        focusable: []
      });
    };

    var _value = _props.value;
    _this.cacheComponents = Object(__WEBPACK_IMPORTED_MODULE_12_memoize_one__["a" /* default */])(_this.cacheComponents, __WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["b" /* B */]).bind(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));

    _this.cacheComponents(_props.components);

    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);

    var _selectValue = Object(__WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["c" /* C */])(_value);

    _this.buildMenuOptions = Object(__WEBPACK_IMPORTED_MODULE_12_memoize_one__["a" /* default */])(_this.buildMenuOptions, function (newArgs, lastArgs) {
      var _ref6 = newArgs,
          _ref7 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_ref6, 2),
          newProps = _ref7[0],
          newSelectValue = _ref7[1];

      var _ref8 = lastArgs,
          _ref9 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_ref8, 2),
          lastProps = _ref9[0],
          lastSelectValue = _ref9[1];

      return newSelectValue === lastSelectValue && newProps.inputValue === lastProps.inputValue && newProps.options === lastProps.options;
    }).bind(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));

    var _menuOptions = _props.menuIsOpen ? _this.buildMenuOptions(_props, _selectValue) : {
      render: [],
      focusable: []
    };

    _this.state.menuOptions = _menuOptions;
    _this.state.selectValue = _selectValue;
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createClass__["a" /* default */])(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();

      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        // Listen to all scroll events, and filter them out inside of 'onScroll'
        document.addEventListener('scroll', this.onScroll, true);
      }

      if (this.props.autoFocus) {
        this.focusInput();
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this$props8 = this.props,
          options = _this$props8.options,
          value = _this$props8.value,
          menuIsOpen = _this$props8.menuIsOpen,
          inputValue = _this$props8.inputValue; // re-cache custom components

      this.cacheComponents(nextProps.components); // rebuild the menu options

      if (nextProps.value !== value || nextProps.options !== options || nextProps.menuIsOpen !== menuIsOpen || nextProps.inputValue !== inputValue) {
        var selectValue = Object(__WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["c" /* C */])(nextProps.value);
        var menuOptions = nextProps.menuIsOpen ? this.buildMenuOptions(nextProps, selectValue) : {
          render: [],
          focusable: []
        };
        var focusedValue = this.getNextFocusedValue(selectValue);
        var focusedOption = this.getNextFocusedOption(menuOptions.focusable);
        this.setState({
          menuOptions: menuOptions,
          selectValue: selectValue,
          focusedOption: focusedOption,
          focusedValue: focusedValue
        });
      } // some updates should toggle the state of the input visibility


      if (this.inputIsHiddenAfterUpdate != null) {
        this.setState({
          inputIsHidden: this.inputIsHiddenAfterUpdate
        });
        delete this.inputIsHiddenAfterUpdate;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props9 = this.props,
          isDisabled = _this$props9.isDisabled,
          menuIsOpen = _this$props9.menuIsOpen;
      var isFocused = this.state.isFocused;

      if ( // ensure focus is restored correctly when the control becomes enabled
      isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      }

      if (isFocused && isDisabled && !prevProps.isDisabled) {
        // ensure select state gets blurred in case Select is programatically disabled while focused
        this.setState({
          isFocused: false
        }, this.onMenuClose);
      } // scroll the focused option into view if necessary


      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        Object(__WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["d" /* D */])(this.menuListRef, this.focusedOptionRef);
        this.scrollToFocusedOptionOnUpdate = false;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener('scroll', this.onScroll, true);
    }
  }, {
    key: "onMenuOpen",
    // ==============================
    // Consumer Handlers
    // ==============================
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      var _this$props10 = this.props,
          isSearchable = _this$props10.isSearchable,
          isMulti = _this$props10.isMulti;
      this.announceAriaLiveContext({
        event: 'input',
        context: {
          isSearchable: isSearchable,
          isMulti: isMulti
        }
      });
      this.onInputChange('', {
        action: 'menu-close'
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    } // ==============================
    // Methods
    // ==============================

  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    } // aliased for consumers

  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this2 = this;

      var _this$state3 = this.state,
          selectValue = _this$state3.selectValue,
          isFocused = _this$state3.isFocused;
      var menuOptions = this.buildMenuOptions(this.props, selectValue);
      var _this$props11 = this.props,
          isMulti = _this$props11.isMulti,
          tabSelectsValue = _this$props11.tabSelectsValue;
      var openAtIndex = focusOption === 'first' ? 0 : menuOptions.focusable.length - 1;

      if (!isMulti) {
        var selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);

        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      } // only scroll if the menu isn't already open


      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.inputIsHiddenAfterUpdate = false;
      this.setState({
        menuOptions: menuOptions,
        focusedValue: null,
        focusedOption: menuOptions.focusable[openAtIndex]
      }, function () {
        _this2.onMenuOpen();

        _this2.announceAriaLiveContext({
          event: 'menu',
          context: {
            tabSelectsValue: tabSelectsValue
          }
        });
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$props12 = this.props,
          isMulti = _this$props12.isMulti,
          isSearchable = _this$props12.isSearchable;
      var _this$state4 = this.state,
          selectValue = _this$state4.selectValue,
          focusedValue = _this$state4.focusedValue; // Only multiselects support value focusing

      if (!isMulti) return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);

      if (!focusedValue) {
        focusedIndex = -1;
        this.announceAriaLiveContext({
          event: 'value'
        });
      }

      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;

      switch (direction) {
        case 'previous':
          if (focusedIndex === 0) {
            // don't cycle from the start to the end
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            // if nothing is focused, focus the last value first
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }

          break;

        case 'next':
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }

          break;
      }

      if (nextFocus === -1) {
        this.announceAriaLiveContext({
          event: 'input',
          context: {
            isSearchable: isSearchable,
            isMulti: isMulti
          }
        });
      }

      this.setState({
        inputIsHidden: nextFocus !== -1,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
      var _this$props13 = this.props,
          pageSize = _this$props13.pageSize,
          tabSelectsValue = _this$props13.tabSelectsValue;
      var _this$state5 = this.state,
          focusedOption = _this$state5.focusedOption,
          menuOptions = _this$state5.menuOptions;
      var options = menuOptions.focusable;
      if (!options.length) return;
      var nextFocus = 0; // handles 'first'

      var focusedIndex = options.indexOf(focusedOption);

      if (!focusedOption) {
        focusedIndex = -1;
        this.announceAriaLiveContext({
          event: 'menu',
          context: {
            tabSelectsValue: tabSelectsValue
          }
        });
      }

      if (direction === 'up') {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === 'down') {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === 'pageup') {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === 'pagedown') {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
      } else if (direction === 'last') {
        nextFocus = options.length - 1;
      }

      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null
      });
      this.announceAriaLiveContext({
        event: 'menu',
        context: {
          isDisabled: isOptionDisabled(options[nextFocus]),
          tabSelectsValue: tabSelectsValue
        }
      });
    }
  }, {
    key: "getTheme",
    // ==============================
    // Getters
    // ==============================
    value: function getTheme() {
      // Use the default theme if there are no customizations.
      if (!this.props.theme) {
        return defaultTheme;
      } // If the theme prop is a function, assume the function
      // knows how to merge the passed-in default theme with
      // its own modifications.


      if (typeof this.props.theme === 'function') {
        return this.props.theme(defaultTheme);
      } // Otherwise, if a plain theme object was passed in,
      // overlay it with the default theme.


      return _objectSpread$2(_objectSpread$2({}, defaultTheme), this.props.theme);
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue,
          cx = this.cx,
          getStyles = this.getStyles,
          getValue = this.getValue,
          setValue = this.setValue,
          selectOption = this.selectOption,
          props = this.props;
      var isMulti = props.isMulti,
          isRtl = props.isRtl,
          options = props.options;
      var hasValue = this.hasValue();
      return {
        cx: cx,
        clearValue: clearValue,
        getStyles: getStyles,
        getValue: getValue,
        hasValue: hasValue,
        isMulti: isMulti,
        isRtl: isRtl,
        options: options,
        selectOption: selectOption,
        setValue: setValue,
        selectProps: props,
        theme: this.getTheme()
      };
    }
  }, {
    key: "getNextFocusedValue",
    value: function getNextFocusedValue(nextSelectValue) {
      if (this.clearFocusValueOnUpdate) {
        this.clearFocusValueOnUpdate = false;
        return null;
      }

      var _this$state6 = this.state,
          focusedValue = _this$state6.focusedValue,
          lastSelectValue = _this$state6.selectValue;
      var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);

      if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);

        if (nextFocusedIndex > -1) {
          // the focused value is still in the selectValue, return it
          return focusedValue;
        } else if (lastFocusedIndex < nextSelectValue.length) {
          // the focusedValue is not present in the next selectValue array by
          // reference, so return the new value at the same index
          return nextSelectValue[lastFocusedIndex];
        }
      }

      return null;
    }
  }, {
    key: "getNextFocusedOption",
    value: function getNextFocusedOption(options) {
      var lastFocusedOption = this.state.focusedOption;
      return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.state.menuOptions.render.length;
    }
  }, {
    key: "countOptions",
    value: function countOptions() {
      return this.state.menuOptions.focusable.length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props14 = this.props,
          isClearable = _this$props14.isClearable,
          isMulti = _this$props14.isMulti; // single select, by default, IS NOT clearable
      // multi select, by default, IS clearable

      if (isClearable === undefined) return isMulti;
      return isClearable;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled(option, selectValue) {
      return typeof this.props.isOptionDisabled === 'function' ? this.props.isOptionDisabled(option, selectValue) : false;
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      var _this3 = this;

      if (selectValue.indexOf(option) > -1) return true;

      if (typeof this.props.isOptionSelected === 'function') {
        return this.props.isOptionSelected(option, selectValue);
      }

      var candidate = this.getOptionValue(option);
      return selectValue.some(function (i) {
        return _this3.getOptionValue(i) === candidate;
      });
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === 'function') {
        var inputValue = this.props.inputValue;
        var selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data, {
          context: context,
          inputValue: inputValue,
          selectValue: selectValue
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel(data) {
      return this.props.formatGroupLabel(data);
    } // ==============================
    // Mouse Handlers
    // ==============================

  }, {
    key: "startListeningComposition",
    // ==============================
    // Composition Handlers
    // ==============================
    value: function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener('compositionstart', this.onCompositionStart, false);
        document.addEventListener('compositionend', this.onCompositionEnd, false);
      }
    }
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener('compositionstart', this.onCompositionStart);
        document.removeEventListener('compositionend', this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    // ==============================
    // Touch Handlers
    // ==============================
    value: function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener('touchstart', this.onTouchStart, false);
        document.addEventListener('touchmove', this.onTouchMove, false);
        document.addEventListener('touchend', this.onTouchEnd, false);
      }
    }
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    }
  }, {
    key: "constructAriaLiveMessage",
    // ==============================
    // Renderers
    // ==============================
    value: function constructAriaLiveMessage() {
      var _this$state7 = this.state,
          ariaLiveContext = _this$state7.ariaLiveContext,
          selectValue = _this$state7.selectValue,
          focusedValue = _this$state7.focusedValue,
          focusedOption = _this$state7.focusedOption;
      var _this$props15 = this.props,
          options = _this$props15.options,
          menuIsOpen = _this$props15.menuIsOpen,
          inputValue = _this$props15.inputValue,
          screenReaderStatus = _this$props15.screenReaderStatus; // An aria live message representing the currently focused value in the select.

      var focusedValueMsg = focusedValue ? valueFocusAriaMessage({
        focusedValue: focusedValue,
        getOptionLabel: this.getOptionLabel,
        selectValue: selectValue
      }) : ''; // An aria live message representing the currently focused option in the select.

      var focusedOptionMsg = focusedOption && menuIsOpen ? optionFocusAriaMessage({
        focusedOption: focusedOption,
        getOptionLabel: this.getOptionLabel,
        options: options
      }) : ''; // An aria live message representing the set of focusable results and current searchterm/inputvalue.

      var resultsMsg = resultsAriaMessage({
        inputValue: inputValue,
        screenReaderMessage: screenReaderStatus({
          count: this.countOptions()
        })
      });
      return "".concat(focusedValueMsg, " ").concat(focusedOptionMsg, " ").concat(resultsMsg, " ").concat(ariaLiveContext);
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var _this$props16 = this.props,
          isDisabled = _this$props16.isDisabled,
          isSearchable = _this$props16.isSearchable,
          inputId = _this$props16.inputId,
          inputValue = _this$props16.inputValue,
          tabIndex = _this$props16.tabIndex,
          form = _this$props16.form;
      var Input = this.components.Input;
      var inputIsHidden = this.state.inputIsHidden;
      var id = inputId || this.getElementId('input'); // aria attributes makes the JSX "noisy", separated for clarity

      var ariaAttributes = {
        'aria-autocomplete': 'list',
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby']
      };

      if (!isSearchable) {
        // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(DummyInput, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
          id: id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: __WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["e" /* E */],
          onFocus: this.onInputFocus,
          readOnly: true,
          disabled: isDisabled,
          tabIndex: tabIndex,
          form: form,
          value: ""
        }, ariaAttributes));
      }

      var _this$commonProps = this.commonProps,
          cx = _this$commonProps.cx,
          theme = _this$commonProps.theme,
          selectProps = _this$commonProps.selectProps;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(Input, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        cx: cx,
        getStyles: this.getStyles,
        id: id,
        innerRef: this.getInputRef,
        isDisabled: isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        selectProps: selectProps,
        spellCheck: "false",
        tabIndex: tabIndex,
        form: form,
        theme: theme,
        type: "text",
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this4 = this;

      var _this$components = this.components,
          MultiValue = _this$components.MultiValue,
          MultiValueContainer = _this$components.MultiValueContainer,
          MultiValueLabel = _this$components.MultiValueLabel,
          MultiValueRemove = _this$components.MultiValueRemove,
          SingleValue = _this$components.SingleValue,
          Placeholder = _this$components.Placeholder;
      var commonProps = this.commonProps;
      var _this$props17 = this.props,
          controlShouldRenderValue = _this$props17.controlShouldRenderValue,
          isDisabled = _this$props17.isDisabled,
          isMulti = _this$props17.isMulti,
          inputValue = _this$props17.inputValue,
          placeholder = _this$props17.placeholder;
      var _this$state8 = this.state,
          selectValue = _this$state8.selectValue,
          focusedValue = _this$state8.focusedValue,
          isFocused = _this$state8.isFocused;

      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(Placeholder, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
          key: "placeholder",
          isDisabled: isDisabled,
          isFocused: isFocused
        }), placeholder);
      }

      if (isMulti) {
        var selectValues = selectValue.map(function (opt, index) {
          var isOptionFocused = opt === focusedValue;
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(MultiValue, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
            components: {
              Container: MultiValueContainer,
              Label: MultiValueLabel,
              Remove: MultiValueRemove
            },
            isFocused: isOptionFocused,
            isDisabled: isDisabled,
            key: "".concat(_this4.getOptionValue(opt)).concat(index),
            index: index,
            removeProps: {
              onClick: function onClick() {
                return _this4.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this4.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e) {
                e.preventDefault();
                e.stopPropagation();
              }
            },
            data: opt
          }), _this4.formatOptionLabel(opt, 'value'));
        });
        return selectValues;
      }

      if (inputValue) {
        return null;
      }

      var singleValue = selectValue[0];
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(SingleValue, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        data: singleValue,
        isDisabled: isDisabled
      }), this.formatOptionLabel(singleValue, 'value'));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var ClearIndicator = this.components.ClearIndicator;
      var commonProps = this.commonProps;
      var _this$props18 = this.props,
          isDisabled = _this$props18.isDisabled,
          isLoading = _this$props18.isLoading;
      var isFocused = this.state.isFocused;

      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }

      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ClearIndicator, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        innerProps: innerProps,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var LoadingIndicator = this.components.LoadingIndicator;
      var commonProps = this.commonProps;
      var _this$props19 = this.props,
          isDisabled = _this$props19.isDisabled,
          isLoading = _this$props19.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator || !isLoading) return null;
      var innerProps = {
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(LoadingIndicator, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$components2 = this.components,
          DropdownIndicator = _this$components2.DropdownIndicator,
          IndicatorSeparator = _this$components2.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator

      if (!DropdownIndicator || !IndicatorSeparator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(IndicatorSeparator, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var DropdownIndicator = this.components.DropdownIndicator;
      if (!DropdownIndicator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(DropdownIndicator, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this5 = this;

      var _this$components3 = this.components,
          Group = _this$components3.Group,
          GroupHeading = _this$components3.GroupHeading,
          Menu = _this$components3.Menu,
          MenuList = _this$components3.MenuList,
          MenuPortal = _this$components3.MenuPortal,
          LoadingMessage = _this$components3.LoadingMessage,
          NoOptionsMessage = _this$components3.NoOptionsMessage,
          Option = _this$components3.Option;
      var commonProps = this.commonProps;
      var _this$state9 = this.state,
          focusedOption = _this$state9.focusedOption,
          menuOptions = _this$state9.menuOptions;
      var _this$props20 = this.props,
          captureMenuScroll = _this$props20.captureMenuScroll,
          inputValue = _this$props20.inputValue,
          isLoading = _this$props20.isLoading,
          loadingMessage = _this$props20.loadingMessage,
          minMenuHeight = _this$props20.minMenuHeight,
          maxMenuHeight = _this$props20.maxMenuHeight,
          menuIsOpen = _this$props20.menuIsOpen,
          menuPlacement = _this$props20.menuPlacement,
          menuPosition = _this$props20.menuPosition,
          menuPortalTarget = _this$props20.menuPortalTarget,
          menuShouldBlockScroll = _this$props20.menuShouldBlockScroll,
          menuShouldScrollIntoView = _this$props20.menuShouldScrollIntoView,
          noOptionsMessage = _this$props20.noOptionsMessage,
          onMenuScrollToTop = _this$props20.onMenuScrollToTop,
          onMenuScrollToBottom = _this$props20.onMenuScrollToBottom;
      if (!menuIsOpen) return null; // TODO: Internal Option Type here

      var render = function render(props) {
        // for performance, the menu options in state aren't changed when the
        // focused option changes so we calculate additional props based on that
        var isFocused = focusedOption === props.data;
        props.innerRef = isFocused ? _this5.getFocusedOptionRef : undefined;
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(Option, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, props, {
          isFocused: isFocused
        }), _this5.formatOptionLabel(props.data, 'menu'));
      };

      var menuUI;

      if (this.hasOptions()) {
        menuUI = menuOptions.render.map(function (item) {
          if (item.type === 'group') {
            var type = item.type,
                group = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(item, ["type"]);

            var headingId = "".concat(item.key, "-heading");
            return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(Group, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, group, {
              Heading: GroupHeading,
              headingProps: {
                id: headingId,
                data: item.data
              },
              label: _this5.formatGroupLabel(item.data)
            }), item.options.map(function (option) {
              return render(option);
            }));
          } else if (item.type === 'option') {
            return render(item);
          }
        });
      } else if (isLoading) {
        var message = loadingMessage({
          inputValue: inputValue
        });
        if (message === null) return null;
        menuUI = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(LoadingMessage, commonProps, message);
      } else {
        var _message = noOptionsMessage({
          inputValue: inputValue
        });

        if (_message === null) return null;
        menuUI = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(NoOptionsMessage, commonProps, _message);
      }

      var menuPlacementProps = {
        minMenuHeight: minMenuHeight,
        maxMenuHeight: maxMenuHeight,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition,
        menuShouldScrollIntoView: menuShouldScrollIntoView
      };
      var menuElement = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__index_75b02bac_browser_esm_js__["f" /* M */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, menuPlacementProps), function (_ref10) {
        var ref = _ref10.ref,
            _ref10$placerProps = _ref10.placerProps,
            placement = _ref10$placerProps.placement,
            maxHeight = _ref10$placerProps.maxHeight;
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(Menu, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, menuPlacementProps, {
          innerRef: ref,
          innerProps: {
            onMouseDown: _this5.onMenuMouseDown,
            onMouseMove: _this5.onMenuMouseMove
          },
          isLoading: isLoading,
          placement: placement
        }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ScrollCaptorSwitch, {
          isEnabled: captureMenuScroll,
          onTopArrive: onMenuScrollToTop,
          onBottomArrive: onMenuScrollToBottom
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ScrollBlock, {
          isEnabled: menuShouldBlockScroll
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(MenuList, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
          innerRef: _this5.getMenuListRef,
          isLoading: isLoading,
          maxHeight: maxHeight
        }), menuUI))));
      }); // positioning behaviour is almost identical for portalled and fixed,
      // so we use the same component. the actual portalling logic is forked
      // within the component based on `menuPosition`

      return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(MenuPortal, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition
      }), menuElement) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this6 = this;

      var _this$props21 = this.props,
          delimiter = _this$props21.delimiter,
          isDisabled = _this$props21.isDisabled,
          isMulti = _this$props21.isMulti,
          name = _this$props21.name;
      var selectValue = this.state.selectValue;
      if (!name || isDisabled) return;

      if (isMulti) {
        if (delimiter) {
          var value = selectValue.map(function (opt) {
            return _this6.getOptionValue(opt);
          }).join(delimiter);
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("input", {
            name: name,
            type: "hidden",
            value: value
          });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
            return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("input", {
              key: "i-".concat(i),
              name: name,
              type: "hidden",
              value: _this6.getOptionValue(opt)
            });
          }) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("input", {
            name: name,
            type: "hidden"
          });
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div", null, input);
        }
      } else {
        var _value2 = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';

        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("input", {
          name: name,
          type: "hidden",
          value: _value2
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      if (!this.state.isFocused) return null;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(A11yText, {
        "aria-live": "polite"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("span", {
        id: "aria-selection-event"
      }, "\xA0", this.state.ariaLiveSelection), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("span", {
        id: "aria-context"
      }, "\xA0", this.constructAriaLiveMessage()));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$components4 = this.components,
          Control = _this$components4.Control,
          IndicatorsContainer = _this$components4.IndicatorsContainer,
          SelectContainer = _this$components4.SelectContainer,
          ValueContainer = _this$components4.ValueContainer;
      var _this$props22 = this.props,
          className = _this$props22.className,
          id = _this$props22.id,
          isDisabled = _this$props22.isDisabled,
          menuIsOpen = _this$props22.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(SelectContainer, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        className: className,
        innerProps: {
          id: id,
          onKeyDown: this.onKeyDown
        },
        isDisabled: isDisabled,
        isFocused: isFocused
      }), this.renderLiveRegion(), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(Control, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: isDisabled,
        isFocused: isFocused,
        menuIsOpen: menuIsOpen
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ValueContainer, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(IndicatorsContainer, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }]);

  return Select;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

Select.defaultProps = defaultProps;




/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_color__ = __webpack_require__(1217);
// See http://www.material-ui.com/#/customization/themes for the customisation guide
// More on Colors: http://www.material-ui.com/#/customization/colors
var colors={alpha:'#2fa5e7',beta:'#4acfce',gamma:'#f7f7f7',delta:'#999999',epsilon:'#c7ebff',epsilonHover:'#a1bfcf',zeta:'#282828',eta:'#80ffff',theta:'#ff6060',white:'#ffffff',black:'#000000',gradient:['#2778ff','#2fa5e7'],purple:'#bb6efe',purpleHover:'#9056c2',darkPurple:'#632ACF',darkPurpleHover:'#5525b0',grey:'rgba(40, 40, 40, 0.75)',error:'#bc1d1d'};var colorWithAlpha=function colorWithAlpha(hex){var alpha=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var _hex2rgb=Object(__WEBPACK_IMPORTED_MODULE_3__utils_color__["a" /* hex2rgb */])(hex),r=_hex2rgb.r,g=_hex2rgb.g,b=_hex2rgb.b;return"rgba(".concat(r,", ").concat(g,", ").concat(b,", ").concat(alpha,")");};var defaultTheme=Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["createMuiTheme"])({typography:{useNextVariants:true}});var muiTheme=Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["createMuiTheme"])({typography:{useNextVariants:true,fontFamily:'"Open Sans Xara", Arial, Helvetica, sans-serif'},overrides:{MuiTypography:{h1:{fontFamily:'Lato, "Open Sans Xara", Arial, Helvetica, sans-serif',fontWeight:'bold',fontSize:'32px',lineHeight:'39px',color:colors.zeta},h2:{fontFamily:'Lato, "Open Sans Xara", Arial, Helvetica, sans-serif',fontWeight:'normal',fontSize:'28px',lineHeight:'34px',color:colors.zeta},h3:{fontFamily:'Lato, "Open Sans Xara", Arial, Helvetica, sans-serif',fontWeight:'normal',fontSize:'24px',lineHeight:'29px',color:colors.zeta},h4:{fontFamily:'Lato, "Open Sans Xara", Arial, Helvetica, sans-serif',fontWeight:'bold',fontSize:'16px',lineHeight:'28px',color:colors.zeta},caption:{fontFamily:'Lato, "Open Sans Xara", Arial, Helvetica, sans-serif',fontWeight:'bold',fontSize:'12px',lineHeight:'15px',color:colors.zeta,textTransform:'uppercase'},subtitle1:{fontFamily:'"Open Sans Xara", Arial, Helvetica, sans-serif',fontWeight:'normal',fontSize:'18px',lineHeight:'24px',color:colorWithAlpha(colors.zeta,0.9)},body1:{fontFamily:'"Open Sans Xara", Arial, Helvetica, sans-serif',fontWeight:'normal',fontSize:'16px',lineHeight:'22px',color:colorWithAlpha(colors.zeta,0.75)},body2:{fontFamily:'"Open Sans Xara", Arial, Helvetica, sans-serif',fontWeight:'normal',fontSize:'13px',lineHeight:'18px',opacity:0.75}},MuiAppBar:{colorPrimary:{backgroundColor:'transparent',backgroundImage:"linear-gradient(to bottom, ".concat(colors.gradient[0]," 0%, ").concat(colors.gradient[1]," 100%);"),boxShadow:"0 2px 3px ".concat(colorWithAlpha(defaultTheme.palette.common.black,0.25))}},MuiButton:{root:{borderRadius:'21px',textTransform:'none',fontFamily:'Lato, "Open Sans Xara", Arial, Helvetica, sans-serif',fontSize:'16px',padding:'6px 25px',minWidth:'120px',whiteSpace:'nowrap',color:colors.delta,transition:defaultTheme.transitions.create(['background-color','box-shadow','border','color']),textDecoration:'underline','&:hover':{color:colors.alpha,backgroundColor:'transparent',textDecoration:'underline'}},contained:{boxShadow:'none',color:defaultTheme.palette.common.white,backgroundColor:'#c7c7c7',textShadow:"1px 1px 2px ".concat(colorWithAlpha(defaultTheme.palette.common.black,0.18)),textDecoration:'none','&$disabled':{color:defaultTheme.palette.common.white,backgroundColor:colorWithAlpha(defaultTheme.palette.common.black,0.26)},'&:hover':{color:defaultTheme.palette.common.white,textDecoration:'none',backgroundColor:'#8b8a8a',boxShadow:"1px 1px 3px ".concat(colorWithAlpha(defaultTheme.palette.common.black,0.16))}},containedPrimary:{backgroundColor:colors.alpha,'&$disabled':{backgroundColor:colorWithAlpha(colors.alpha,0.32),color:defaultTheme.palette.common.white},'&:hover':{backgroundColor:'#1d79ac',boxShadow:"1px 1px 3px ".concat(colorWithAlpha(defaultTheme.palette.common.black,0.16))}},containedSecondary:{backgroundColor:colors.theta,'&$disabled':{backgroundColor:colorWithAlpha('#d54f4f',0.3),color:defaultTheme.palette.common.white},'&:hover':{backgroundColor:'#d54f4f',boxShadow:'none'}},outlinedPrimary:{color:colors.black,borderColor:colors.alpha,borderWidth:2,textDecoration:'none',padding:'4px 16px','&:hover':{color:'#000',borderWidth:2,backgroundColor:'#fff',borderColor:'#2888C3',textDecoration:'none'}},sizeSmall:{padding:'6px 15px',borderRadius:'18px',fontSize:'13px'},sizeLarge:{minWidth:'210px'}},MuiInput:{root:{fontFamily:'"Open Sans Xara", Arial, Helvetica, sans-serif'},input:{width:'100%',fontSize:'13px',border:"1px solid ".concat(colorWithAlpha(colors.delta,0.32)),padding:'7px 17px',borderRadius:'20px',color:colorWithAlpha(colors.zeta,0.75),background:defaultTheme.palette.common.white,transition:defaultTheme.transitions.create(['box-shadow','border-color']),'&::-webkit-input-placeholder':{color:colors.delta,fontStyle:'italic'},'&::-moz-placeholder':{color:colors.delta,fontStyle:'italic'},'&:-ms-input-placeholder':{color:colors.delta,fontStyle:'italic',opacity:1},'&::-ms-input-placeholder':{color:colors.delta,fontStyle:'italic',opacity:1},'&:focus':{borderColor:colors.epsilon,boxShadow:"1px 1px 2px ".concat(colors.epsilon)},'&$disabled':{color:colorWithAlpha(colors.delta,0.85)},'&:-webkit-autofill':{'-webkit-box-shadow':'0 0 0 30px white inset !important','-webkit-text-fill-color':"".concat(colorWithAlpha(colors.zeta,0.75)," !important")},'&:-webkit-autofill:hover':{'-webkit-box-shadow':'0 0 0 30px white inset !important','-webkit-text-fill-color':"".concat(colorWithAlpha(colors.zeta,0.75)," !important")},'&:-webkit-autofill:focus':{'-webkit-box-shadow':'0 0 0 30px white inset !important','-webkit-text-fill-color':"".concat(colorWithAlpha(colors.zeta,0.75)," !important")},'&:-webkit-autofill:active':{'-webkit-box-shadow':'0 0 0 30px white inset !important','-webkit-text-fill-color':"".concat(colorWithAlpha(colors.zeta,0.75)," !important")}},fullWidth:{width:'100%'},multiline:{padding:0}},MuiFormLabel:{asterisk:{color:'#db3131','&$error':{color:'#db3131'}}},MuiFormHelperText:{root:{'&$error':{color:colors.error,fontStyle:'italic',paddingLeft:'20px',marginBottom:'5px'}}},MuiSelect:{select:{borderRadius:'20px',paddingRight:'40px',boxShadow:"1px 1px 2px ".concat(colorWithAlpha(defaultTheme.palette.common.black,0.16)),'&:focus':{borderRadius:'20px',backgroundColor:defaultTheme.palette.common.white,boxShadow:"1px 1px 2px ".concat(colorWithAlpha(defaultTheme.palette.common.black,0.16)),borderColor:colorWithAlpha(colors.delta,0.32)}},icon:{right:'14px',color:colors.delta}},MuiMenu:{paper:{padding:0,borderColor:colorWithAlpha(colors.delta,0.16),borderRadius:18,boxShadow:"1px 1px 2px ".concat(colorWithAlpha(defaultTheme.palette.common.black,0.16))}},MuiMenuItem:{root:{fontFamily:'"Open Sans Xara", Arial, Helvetica, sans-serif',fontSize:'13px',color:colorWithAlpha(colors.zeta,0.75),'&$selected, &$selected:hover, &$selected:focus':{background:'none'}}},MuiDivider:{root:{backgroundColor:colorWithAlpha(colors.delta,0.2)}},MuiBackdrop:{root:{backgroundColor:colorWithAlpha(defaultTheme.palette.common.white,0.85)}},MuiDialog:{paper:{boxShadow:'none',borderRadius:'9px',border:"1px solid ".concat(colors.alpha)},paperWidthSm:{maxWidth:330}},MuiDialogTitle:{root:{padding:'20px 20px 0',textAlign:'center'}},MuiDialogContent:{root:{padding:'10px 20px 0',textAlign:'center','&:first-child':{paddingTop:14},'&:last-child':{paddingBottom:14}}},MuiDialogContentText:{root:{color:colorWithAlpha(colors.zeta,0.75)}},MuiDialogActions:{root:{margin:'15px 20px 20px',justifyContent:'center'},action:{margin:'0 10px'}},MuiLink:{root:{cursor:'pointer',display:'inline-block'}},MuiPopover:{paper:{padding:'18px 28px',boxShadow:'none',borderRadius:'9px',border:"1px solid ".concat(colors.alpha),textAlign:'center'}},MuiTabs:{root:{color:colorWithAlpha(colors.zeta,0.75)},indicator:{display:'none'}},MuiTab:{root:__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({borderRadius:'15px 15px 0 0',transition:defaultTheme.transitions.create('background-color'),textTransform:'none',fontSize:'16px'},defaultTheme.breakpoints.up('md'),{fontSize:'16px',minWidth:160}),textColorInherit:{opacity:1,'&$selected':{fontWeight:'bold',backgroundColor:defaultTheme.palette.common.white}},labelIcon:{minHeight:48,paddingTop:0},labelContainer:__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()({},defaultTheme.breakpoints.up('md'),{padding:'6px 12px'})},MuiTableRow:{root:{transition:defaultTheme.transitions.create('background-color'),'&$hover:hover':{backgroundColor:colorWithAlpha(colors.epsilon,0.16)}}},MuiTableCell:{root:{textOverflow:'ellipsis',overflow:'hidden',whiteSpace:'nowrap',borderBottom:"1px solid ".concat(colorWithAlpha(colors.zeta,0.15))},head:{color:colorWithAlpha(colors.zeta,0.75),fontSize:'13px',fontWeight:'bold'},body:{color:colorWithAlpha(colors.zeta,0.75),fontSize:'13px'}},MuiIconButton:{root:{padding:6},colorSecondary:{color:colors.delta,transition:defaultTheme.transitions.create('color'),'&:hover':{backgroundColor:'transparent',color:colors.theta}}}},palette:{colors:__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},colors,{colorWithAlpha:colorWithAlpha}),primary:{main:colors.alpha,contrastText:defaultTheme.palette.common.white},secondary:{main:colors.theta,contrastText:defaultTheme.palette.common.white},tertiary:{main:colors.alpha,contrastText:defaultTheme.palette.common.white},background:{'default':defaultTheme.palette.common.white}},zIndex:{appBar:1250,xaraLogo:1250,stickyHeader:1000}});/* harmony default export */ __webpack_exports__["a"] = (muiTheme);

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(467);
module.exports = __webpack_require__(657);


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(468);

if (typeof Promise === 'undefined') {
	// Rejection tracking prevents a common issue where React gets into an
	// inconsistent state due to an error, but it gets swallowed by a Promise,
	// and the user has no idea what causes React's erratic future behavior.
	__webpack_require__(653).enable();
	window.Promise = __webpack_require__(655);
}

// fetch() polyfill for making API calls.
__webpack_require__(656);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(146);

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(469);

var _global = _interopRequireDefault(__webpack_require__(640));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (_global.default._babelPolyfill && typeof console !== "undefined" && console.warn) {
  console.warn("@babel/polyfill is loaded more than once on this page. This is probably not desirable/intended " + "and may have consequences if different versions of the polyfills are applied sequentially. " + "If you do need to load the polyfill more than once, use @babel/polyfill/noConflict " + "instead to bypass the warning.");
}

_global.default._babelPolyfill = true;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(470);

__webpack_require__(613);

__webpack_require__(615);

__webpack_require__(618);

__webpack_require__(620);

__webpack_require__(622);

__webpack_require__(624);

__webpack_require__(626);

__webpack_require__(628);

__webpack_require__(630);

__webpack_require__(632);

__webpack_require__(634);

__webpack_require__(636);

__webpack_require__(336);

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(471);
__webpack_require__(474);
__webpack_require__(475);
__webpack_require__(476);
__webpack_require__(477);
__webpack_require__(478);
__webpack_require__(479);
__webpack_require__(480);
__webpack_require__(481);
__webpack_require__(482);
__webpack_require__(483);
__webpack_require__(484);
__webpack_require__(485);
__webpack_require__(486);
__webpack_require__(487);
__webpack_require__(488);
__webpack_require__(489);
__webpack_require__(490);
__webpack_require__(491);
__webpack_require__(492);
__webpack_require__(493);
__webpack_require__(494);
__webpack_require__(495);
__webpack_require__(496);
__webpack_require__(497);
__webpack_require__(498);
__webpack_require__(499);
__webpack_require__(500);
__webpack_require__(501);
__webpack_require__(502);
__webpack_require__(503);
__webpack_require__(504);
__webpack_require__(505);
__webpack_require__(506);
__webpack_require__(507);
__webpack_require__(508);
__webpack_require__(509);
__webpack_require__(510);
__webpack_require__(511);
__webpack_require__(512);
__webpack_require__(513);
__webpack_require__(514);
__webpack_require__(515);
__webpack_require__(517);
__webpack_require__(518);
__webpack_require__(519);
__webpack_require__(520);
__webpack_require__(521);
__webpack_require__(522);
__webpack_require__(523);
__webpack_require__(524);
__webpack_require__(525);
__webpack_require__(526);
__webpack_require__(527);
__webpack_require__(528);
__webpack_require__(529);
__webpack_require__(530);
__webpack_require__(531);
__webpack_require__(532);
__webpack_require__(533);
__webpack_require__(534);
__webpack_require__(535);
__webpack_require__(536);
__webpack_require__(537);
__webpack_require__(538);
__webpack_require__(539);
__webpack_require__(540);
__webpack_require__(541);
__webpack_require__(542);
__webpack_require__(543);
__webpack_require__(544);
__webpack_require__(545);
__webpack_require__(546);
__webpack_require__(547);
__webpack_require__(548);
__webpack_require__(549);
__webpack_require__(550);
__webpack_require__(552);
__webpack_require__(553);
__webpack_require__(555);
__webpack_require__(556);
__webpack_require__(557);
__webpack_require__(558);
__webpack_require__(559);
__webpack_require__(560);
__webpack_require__(561);
__webpack_require__(563);
__webpack_require__(564);
__webpack_require__(565);
__webpack_require__(566);
__webpack_require__(567);
__webpack_require__(568);
__webpack_require__(569);
__webpack_require__(570);
__webpack_require__(571);
__webpack_require__(572);
__webpack_require__(573);
__webpack_require__(574);
__webpack_require__(575);
__webpack_require__(237);
__webpack_require__(576);
__webpack_require__(325);
__webpack_require__(577);
__webpack_require__(326);
__webpack_require__(578);
__webpack_require__(579);
__webpack_require__(580);
__webpack_require__(581);
__webpack_require__(327);
__webpack_require__(584);
__webpack_require__(585);
__webpack_require__(586);
__webpack_require__(587);
__webpack_require__(588);
__webpack_require__(589);
__webpack_require__(590);
__webpack_require__(591);
__webpack_require__(592);
__webpack_require__(593);
__webpack_require__(594);
__webpack_require__(595);
__webpack_require__(596);
__webpack_require__(597);
__webpack_require__(598);
__webpack_require__(599);
__webpack_require__(600);
__webpack_require__(601);
__webpack_require__(602);
__webpack_require__(603);
__webpack_require__(604);
__webpack_require__(605);
__webpack_require__(606);
__webpack_require__(607);
__webpack_require__(608);
__webpack_require__(609);
__webpack_require__(610);
__webpack_require__(611);
__webpack_require__(612);
module.exports = __webpack_require__(41);


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(30);
var has = __webpack_require__(58);
var DESCRIPTORS = __webpack_require__(47);
var $export = __webpack_require__(12);
var redefine = __webpack_require__(55);
var META = __webpack_require__(101).KEY;
var $fails = __webpack_require__(31);
var shared = __webpack_require__(167);
var setToStringTag = __webpack_require__(127);
var uid = __webpack_require__(108);
var wks = __webpack_require__(35);
var wksExt = __webpack_require__(218);
var wksDefine = __webpack_require__(306);
var enumKeys = __webpack_require__(473);
var isArray = __webpack_require__(170);
var anObject = __webpack_require__(32);
var isObject = __webpack_require__(33);
var toIObject = __webpack_require__(60);
var toPrimitive = __webpack_require__(100);
var createDesc = __webpack_require__(107);
var _create = __webpack_require__(112);
var gOPNExt = __webpack_require__(309);
var $GOPD = __webpack_require__(78);
var $DP = __webpack_require__(43);
var $keys = __webpack_require__(110);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(113).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(143).f = $propertyIsEnumerable;
  __webpack_require__(169).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(109)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(59)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(167)('native-function-to-string', Function.toString);


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(110);
var gOPS = __webpack_require__(169);
var pIE = __webpack_require__(143);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(112) });


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(47), 'Object', { defineProperty: __webpack_require__(43).f });


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(47), 'Object', { defineProperties: __webpack_require__(308) });


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(60);
var $getOwnPropertyDescriptor = __webpack_require__(78).f;

__webpack_require__(79)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(53);
var $getPrototypeOf = __webpack_require__(114);

__webpack_require__(79)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(53);
var $keys = __webpack_require__(110);

__webpack_require__(79)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(79)('getOwnPropertyNames', function () {
  return __webpack_require__(309).f;
});


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(33);
var meta = __webpack_require__(101).onFreeze;

__webpack_require__(79)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(33);
var meta = __webpack_require__(101).onFreeze;

__webpack_require__(79)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(33);
var meta = __webpack_require__(101).onFreeze;

__webpack_require__(79)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(33);

__webpack_require__(79)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(33);

__webpack_require__(79)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(33);

__webpack_require__(79)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(12);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(310) });


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(12);
$export($export.S, 'Object', { is: __webpack_require__(311) });


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(12);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(222).set });


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(144);
var test = {};
test[__webpack_require__(35)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(55)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(12);

$export($export.P, 'Function', { bind: __webpack_require__(312) });


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(43).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(47) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(33);
var getPrototypeOf = __webpack_require__(114);
var HAS_INSTANCE = __webpack_require__(35)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(43).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);
var $parseInt = __webpack_require__(314);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);
var $parseFloat = __webpack_require__(315);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(30);
var has = __webpack_require__(58);
var cof = __webpack_require__(85);
var inheritIfRequired = __webpack_require__(224);
var toPrimitive = __webpack_require__(100);
var fails = __webpack_require__(31);
var gOPN = __webpack_require__(113).f;
var gOPD = __webpack_require__(78).f;
var dP = __webpack_require__(43).f;
var $trim = __webpack_require__(128).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(112)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(47) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(55)(global, NUMBER, $Number);
}


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var toInteger = __webpack_require__(77);
var aNumberValue = __webpack_require__(316);
var repeat = __webpack_require__(225);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(31)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var $fails = __webpack_require__(31);
var aNumberValue = __webpack_require__(316);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(12);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(12);
var _isFinite = __webpack_require__(30).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(12);

$export($export.S, 'Number', { isInteger: __webpack_require__(317) });


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(12);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(12);
var isInteger = __webpack_require__(317);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(12);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(12);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);
var $parseFloat = __webpack_require__(315);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);
var $parseInt = __webpack_require__(314);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(12);
var log1p = __webpack_require__(318);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(12);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(12);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(12);
var sign = __webpack_require__(226);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(12);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(12);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(12);
var $expm1 = __webpack_require__(227);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(12);

$export($export.S, 'Math', { fround: __webpack_require__(516) });


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(226);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(12);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(12);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(31)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(12);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(12);

$export($export.S, 'Math', { log1p: __webpack_require__(318) });


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(12);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(12);

$export($export.S, 'Math', { sign: __webpack_require__(226) });


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(12);
var expm1 = __webpack_require__(227);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(31)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(12);
var expm1 = __webpack_require__(227);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(12);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);
var toAbsoluteIndex = __webpack_require__(111);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);
var toIObject = __webpack_require__(60);
var toLength = __webpack_require__(37);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(128)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(228)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(229)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var $at = __webpack_require__(228)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(12);
var toLength = __webpack_require__(37);
var context = __webpack_require__(230);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(232)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(12);
var context = __webpack_require__(230);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(232)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(225)
});


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(12);
var toLength = __webpack_require__(37);
var context = __webpack_require__(230);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(232)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(56)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(56)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(56)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(56)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(56)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(56)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(56)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(56)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(56)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(56)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(56)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(56)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(56)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(12);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var toObject = __webpack_require__(53);
var toPrimitive = __webpack_require__(100);

$export($export.P + $export.F * __webpack_require__(31)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(12);
var toISOString = __webpack_require__(551);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(31);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(55)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(35)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(59)(proto, TO_PRIMITIVE, __webpack_require__(554));


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(32);
var toPrimitive = __webpack_require__(100);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(12);

$export($export.S, 'Array', { isArray: __webpack_require__(170) });


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(75);
var $export = __webpack_require__(12);
var toObject = __webpack_require__(53);
var call = __webpack_require__(320);
var isArrayIter = __webpack_require__(233);
var toLength = __webpack_require__(37);
var createProperty = __webpack_require__(234);
var getIterFn = __webpack_require__(235);

$export($export.S + $export.F * !__webpack_require__(171)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var createProperty = __webpack_require__(234);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(31)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(12);
var toIObject = __webpack_require__(60);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(142) != Object || !__webpack_require__(66)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var html = __webpack_require__(221);
var cof = __webpack_require__(85);
var toAbsoluteIndex = __webpack_require__(111);
var toLength = __webpack_require__(37);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(31)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var aFunction = __webpack_require__(76);
var toObject = __webpack_require__(53);
var fails = __webpack_require__(31);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(66)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var $forEach = __webpack_require__(80)(0);
var STRICT = __webpack_require__(66)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(33);
var isArray = __webpack_require__(170);
var SPECIES = __webpack_require__(35)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var $map = __webpack_require__(80)(1);

$export($export.P + $export.F * !__webpack_require__(66)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var $filter = __webpack_require__(80)(2);

$export($export.P + $export.F * !__webpack_require__(66)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var $some = __webpack_require__(80)(3);

$export($export.P + $export.F * !__webpack_require__(66)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var $every = __webpack_require__(80)(4);

$export($export.P + $export.F * !__webpack_require__(66)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var $reduce = __webpack_require__(322);

$export($export.P + $export.F * !__webpack_require__(66)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var $reduce = __webpack_require__(322);

$export($export.P + $export.F * !__webpack_require__(66)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var $indexOf = __webpack_require__(168)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(66)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var toIObject = __webpack_require__(60);
var toInteger = __webpack_require__(77);
var toLength = __webpack_require__(37);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(66)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(12);

$export($export.P, 'Array', { copyWithin: __webpack_require__(323) });

__webpack_require__(115)('copyWithin');


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(12);

$export($export.P, 'Array', { fill: __webpack_require__(236) });

__webpack_require__(115)('fill');


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(12);
var $find = __webpack_require__(80)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(115)(KEY);


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(12);
var $find = __webpack_require__(80)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(115)(KEY);


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(130)('Array');


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(30);
var inheritIfRequired = __webpack_require__(224);
var dP = __webpack_require__(43).f;
var gOPN = __webpack_require__(113).f;
var isRegExp = __webpack_require__(231);
var $flags = __webpack_require__(172);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(47) && (!CORRECT_NEW || __webpack_require__(31)(function () {
  re2[__webpack_require__(35)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(55)(global, 'RegExp', $RegExp);
}

__webpack_require__(130)('RegExp');


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(326);
var anObject = __webpack_require__(32);
var $flags = __webpack_require__(172);
var DESCRIPTORS = __webpack_require__(47);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(55)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(31)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(32);
var toLength = __webpack_require__(37);
var advanceStringIndex = __webpack_require__(239);
var regExpExec = __webpack_require__(173);

// @@match logic
__webpack_require__(174)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(32);
var toObject = __webpack_require__(53);
var toLength = __webpack_require__(37);
var toInteger = __webpack_require__(77);
var advanceStringIndex = __webpack_require__(239);
var regExpExec = __webpack_require__(173);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(174)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(32);
var sameValue = __webpack_require__(311);
var regExpExec = __webpack_require__(173);

// @@search logic
__webpack_require__(174)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(231);
var anObject = __webpack_require__(32);
var speciesConstructor = __webpack_require__(145);
var advanceStringIndex = __webpack_require__(239);
var toLength = __webpack_require__(37);
var callRegExpExec = __webpack_require__(173);
var regexpExec = __webpack_require__(238);
var fails = __webpack_require__(31);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(174)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(30);
var macrotask = __webpack_require__(240).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(85)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 583 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(330);
var validate = __webpack_require__(116);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(177)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(330);
var validate = __webpack_require__(116);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(177)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(30);
var each = __webpack_require__(80)(0);
var redefine = __webpack_require__(55);
var meta = __webpack_require__(101);
var assign = __webpack_require__(310);
var weak = __webpack_require__(331);
var isObject = __webpack_require__(33);
var validate = __webpack_require__(116);
var NATIVE_WEAK_MAP = __webpack_require__(116);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(177)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(331);
var validate = __webpack_require__(116);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(177)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(12);
var $typed = __webpack_require__(178);
var buffer = __webpack_require__(241);
var anObject = __webpack_require__(32);
var toAbsoluteIndex = __webpack_require__(111);
var toLength = __webpack_require__(37);
var isObject = __webpack_require__(33);
var ArrayBuffer = __webpack_require__(30).ArrayBuffer;
var speciesConstructor = __webpack_require__(145);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(31)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(130)(ARRAY_BUFFER);


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);
$export($export.G + $export.W + $export.F * !__webpack_require__(178).ABV, {
  DataView: __webpack_require__(241).DataView
});


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(87)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(87)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(87)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(87)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(87)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(87)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(87)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(87)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(87)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(12);
var aFunction = __webpack_require__(76);
var anObject = __webpack_require__(32);
var rApply = (__webpack_require__(30).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(31)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(12);
var create = __webpack_require__(112);
var aFunction = __webpack_require__(76);
var anObject = __webpack_require__(32);
var isObject = __webpack_require__(33);
var fails = __webpack_require__(31);
var bind = __webpack_require__(312);
var rConstruct = (__webpack_require__(30).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(43);
var $export = __webpack_require__(12);
var anObject = __webpack_require__(32);
var toPrimitive = __webpack_require__(100);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(31)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(12);
var gOPD = __webpack_require__(78).f;
var anObject = __webpack_require__(32);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(12);
var anObject = __webpack_require__(32);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(319)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(78);
var getPrototypeOf = __webpack_require__(114);
var has = __webpack_require__(58);
var $export = __webpack_require__(12);
var isObject = __webpack_require__(33);
var anObject = __webpack_require__(32);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(78);
var $export = __webpack_require__(12);
var anObject = __webpack_require__(32);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(12);
var getProto = __webpack_require__(114);
var anObject = __webpack_require__(32);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(12);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(12);
var anObject = __webpack_require__(32);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(12);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(333) });


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(12);
var anObject = __webpack_require__(32);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(43);
var gOPD = __webpack_require__(78);
var getPrototypeOf = __webpack_require__(114);
var has = __webpack_require__(58);
var $export = __webpack_require__(12);
var createDesc = __webpack_require__(107);
var anObject = __webpack_require__(32);
var isObject = __webpack_require__(33);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(12);
var setProto = __webpack_require__(222);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(614);
module.exports = __webpack_require__(41).Array.includes;


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(12);
var $includes = __webpack_require__(168)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(115)('includes');


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(616);
module.exports = __webpack_require__(41).Array.flatMap;


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(12);
var flattenIntoArray = __webpack_require__(617);
var toObject = __webpack_require__(53);
var toLength = __webpack_require__(37);
var aFunction = __webpack_require__(76);
var arraySpeciesCreate = __webpack_require__(321);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(115)('flatMap');


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(170);
var isObject = __webpack_require__(33);
var toLength = __webpack_require__(37);
var ctx = __webpack_require__(75);
var IS_CONCAT_SPREADABLE = __webpack_require__(35)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(619);
module.exports = __webpack_require__(41).String.padStart;


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(12);
var $pad = __webpack_require__(334);
var userAgent = __webpack_require__(176);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(621);
module.exports = __webpack_require__(41).String.padEnd;


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(12);
var $pad = __webpack_require__(334);
var userAgent = __webpack_require__(176);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(623);
module.exports = __webpack_require__(41).String.trimLeft;


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(128)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(625);
module.exports = __webpack_require__(41).String.trimRight;


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(128)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(627);
module.exports = __webpack_require__(218).f('asyncIterator');


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(306)('asyncIterator');


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(629);
module.exports = __webpack_require__(41).Object.getOwnPropertyDescriptors;


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(12);
var ownKeys = __webpack_require__(333);
var toIObject = __webpack_require__(60);
var gOPD = __webpack_require__(78);
var createProperty = __webpack_require__(234);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(631);
module.exports = __webpack_require__(41).Object.values;


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(12);
var $values = __webpack_require__(335)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(633);
module.exports = __webpack_require__(41).Object.entries;


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(12);
var $entries = __webpack_require__(335)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(327);
__webpack_require__(635);
module.exports = __webpack_require__(41).Promise['finally'];


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(12);
var core = __webpack_require__(41);
var global = __webpack_require__(30);
var speciesConstructor = __webpack_require__(145);
var promiseResolve = __webpack_require__(329);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(637);
__webpack_require__(638);
__webpack_require__(639);
module.exports = __webpack_require__(41);


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(30);
var $export = __webpack_require__(12);
var userAgent = __webpack_require__(176);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);
var $task = __webpack_require__(240);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(237);
var getKeys = __webpack_require__(110);
var redefine = __webpack_require__(55);
var global = __webpack_require__(30);
var hide = __webpack_require__(59);
var Iterators = __webpack_require__(129);
var wks = __webpack_require__(35);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(641);
module.exports = __webpack_require__(337).global;


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(642);

$export($export.G, { global: __webpack_require__(242) });


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(242);
var core = __webpack_require__(337);
var ctx = __webpack_require__(643);
var hide = __webpack_require__(645);
var has = __webpack_require__(652);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(644);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 644 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(646);
var createDesc = __webpack_require__(651);
module.exports = __webpack_require__(244) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(647);
var IE8_DOM_DEFINE = __webpack_require__(648);
var toPrimitive = __webpack_require__(650);
var dP = Object.defineProperty;

exports.f = __webpack_require__(244) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(243);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(244) && !__webpack_require__(338)(function () {
  return Object.defineProperty(__webpack_require__(649)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(243);
var document = __webpack_require__(242).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(243);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 652 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(339);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(67)))

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(339);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 656 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_MuiThemeProvider__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_MuiThemeProvider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_MuiThemeProvider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_CssBaseline__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_CssBaseline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_CssBaseline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_store__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_containers_App_App__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_containers_ErrorBoundary_ErrorBoundary__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_registerServiceWorker__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_theme_muiTheme__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils_refersion__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils_url__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__index_scss__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_beforeunload__ = __webpack_require__(1222);
// eslint-disable-next-line no-unused-vars
var target=document.querySelector('#root');window.addEventListener('error',function(event){__WEBPACK_IMPORTED_MODULE_8_containers_ErrorBoundary_ErrorBoundary__["a" /* default */].handleUncaughtError(event,target);});window.addEventListener('unhandledrejection',function(event){__WEBPACK_IMPORTED_MODULE_8_containers_ErrorBoundary_ErrorBoundary__["a" /* default */].handleUnhandledPromiseRejection(event,target);});/**
 * Adds Hotjar tracking code to document's head. Docs:
 * https://help.hotjar.com/hc/en-us/articles/115009499088-The-Hotjar-Tracking-Code
 */var addHotjarScript=function addHotjarScript(){// Don't track session on dev environment or if there's no key
if("production"==='development'||!__WEBPACK_IMPORTED_MODULE_11__config__["O" /* HOTJAR_SITE_ID */]){return;}var script=document.createElement('script');var head=document.getElementsByTagName('head')[0];script.innerHTML='(function(h,o,t,j,a,r){'+'h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};'+'h._hjSettings={hjid:'+__WEBPACK_IMPORTED_MODULE_11__config__["O" /* HOTJAR_SITE_ID */]+',hjsv:6};'+'a=o.getElementsByTagName(\'head\')[0];'+'r=o.createElement(\'script\');r.async=1;'+'r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;'+'a.appendChild(r);'+'})(window,document,\'https://static.hotjar.com/c/hotjar-\',\'.js?sv=\');';head.appendChild(script);};var originalSearch=window.location.search;var originalHash=window.location.hash;// Remove query string from URL
var queryParams=Object(__WEBPACK_IMPORTED_MODULE_13_utils_url__["d" /* parseQuery */])(window.location.search);window.history.replaceState({},document.title,"/".concat(window.location.hash));var lang=queryParams['lang'];lang&&window.localStorage.setItem('lang',lang);var isDiscountTakeoverFromWebsite=window.location.href.indexOf('pserial')!==-1&&window.location.href.indexOf('pemail')!==-1;var isUpgradePopup=window.location.href.indexOf('upgrade-popup')!==-1;var isReUpgradePopup=window.location.href.indexOf('is-re-popup')!==-1;var isCouponIdProvided=window.location.href.indexOf('cid')!==-1;var isDesktopApp=(window.location.href.indexOf('desktop-app')!==-1||window.location.href.indexOf('prod=')!==-1||queryParams['prod']||queryParams['desktop-app']||isDiscountTakeoverFromWebsite)&&window.location.href.indexOf('source=pricing')===-1&&window.location.href.indexOf('BROKERAGE')===-1&&window.location.href.indexOf('INDIVIDUAL_AGENT')===-1;var isCbPlanProvided=window.location.href.indexOf('chargebee-plan-id')!==-1;Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux__["a" /* Provider */],{store:__WEBPACK_IMPORTED_MODULE_6_redux_store__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["a" /* ConnectedRouter */],{history:__WEBPACK_IMPORTED_MODULE_6_redux_store__["b" /* history */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles_MuiThemeProvider___default.a,{theme:__WEBPACK_IMPORTED_MODULE_10_theme_muiTheme__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_CssBaseline___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_containers_App_App__["a" /* default */],{reloadApp:Boolean(queryParams['reload-app']),isDesktopApp:isDesktopApp,isCbPlanProvided:isCbPlanProvided,isDiscountTakeoverFromWebsite:isDiscountTakeoverFromWebsite,isUpgradePopup:isUpgradePopup,isReUpgradePopup:isReUpgradePopup,isCouponIdProvided:isCouponIdProvided,originalSearch:originalSearch,originalHash:originalHash})))),target);Object(__WEBPACK_IMPORTED_MODULE_9_registerServiceWorker__["a" /* unregister */])();addHotjarScript();Object(__WEBPACK_IMPORTED_MODULE_12_utils_refersion__["a" /* saveRefersionFieldsToStorage */])();

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.2
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(146),n=__webpack_require__(179),p=__webpack_require__(245),q=__webpack_require__(180),r="function"===typeof Symbol&&Symbol["for"],t=r?Symbol["for"]("react.element"):60103,u=r?Symbol["for"]("react.portal"):60106,v=r?Symbol["for"]("react.fragment"):60107,w=r?Symbol["for"]("react.strict_mode"):60108,x=r?Symbol["for"]("react.provider"):60109,y=r?Symbol["for"]("react.context"):60110,z=r?Symbol["for"]("react.async_mode"):60111,A=r?Symbol["for"]("react.forward_ref"):
60112,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b=arguments.length-1,e="http://reactjs.org/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};
function E(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||D}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?C("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||D}var H=G.prototype=new F;
H.constructor=G;m(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J=Object.prototype.hasOwnProperty,K={key:!0,ref:!0,__self:!0,__source:!0};
function L(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)J.call(b,c)&&!K.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var k=Array(f),l=0;l<f;l++)k[l]=arguments[l+2];d.children=k}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:I.current}}
function M(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var N=/\/+/g,O=[];function P(a,b,e,c){if(O.length){var d=O.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function Q(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>O.length&&O.push(a)}
function R(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+S(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+S(d,h);g+=R(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+S(d,h++),g+=R(d,f,e,c);else"object"===d&&(e=""+a,C("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function S(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function T(a,b){a.func.call(a.context,b,a.count++)}
function U(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,e,q.thatReturnsArgument):null!=a&&(M(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(N,"$\x26/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function V(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(N,"$\x26/")+"/");b=P(b,g,c,d);null==a||R(a,"",U,b);Q(b)}
var W={Children:{map:function(a,b,e){if(null==a)return a;var c=[];V(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=P(null,null,b,e);null==a||R(a,"",T,b);Q(b)},count:function(a){return null==a?0:R(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];V(a,b,null,q.thatReturnsArgument);return b},only:function(a){M(a)?void 0:C("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:y,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_changedBits:0,Provider:null,Consumer:null};a.Provider={$$typeof:x,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:A,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:z,createElement:L,cloneElement:function(a,b,e){null===a||void 0===a?C("267",a):void 0;var c=void 0,d=m({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=I.current);void 0!==b.key&&(g=""+b.key);var k=void 0;a.type&&a.type.defaultProps&&
(k=a.type.defaultProps);for(c in b)J.call(b,c)&&!K.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==k?k[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){k=Array(c);for(var l=0;l<c;l++)k[l]=arguments[l+2];d.children=k}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=L.bind(null,a);b.type=a;return b},isValidElement:M,version:"16.3.2",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:I,assign:m}},X=Object.freeze({default:W}),
Y=X&&W||X;module.exports=Y["default"]?Y["default"]:Y;


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.2
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var ba=__webpack_require__(179),ea=__webpack_require__(1),m=__webpack_require__(660),A=__webpack_require__(146),C=__webpack_require__(180),fa=__webpack_require__(661),ha=__webpack_require__(340),ja=__webpack_require__(662),ka=__webpack_require__(245);
function D(a){for(var b=arguments.length-1,c="http://reactjs.org/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);ba(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ea?void 0:D("227");
function ma(a,b,c,d,e,f,h,g,k){this._hasCaughtError=!1;this._caughtError=null;var v=Array.prototype.slice.call(arguments,3);try{b.apply(c,v)}catch(l){this._caughtError=l,this._hasCaughtError=!0}}
var E={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,h,g,k){ma.apply(E,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,h,g,k){E.invokeGuardedCallback.apply(this,arguments);if(E.hasCaughtError()){var v=E.clearCaughtError();E._hasRethrowError||(E._hasRethrowError=!0,E._rethrowError=v)}},rethrowCaughtError:function(){return na.apply(E,arguments)},hasCaughtError:function(){return E._hasCaughtError},clearCaughtError:function(){if(E._hasCaughtError){var a=
E._caughtError;E._caughtError=null;E._hasCaughtError=!1;return a}D("198")}};function na(){if(E._hasRethrowError){var a=E._rethrowError;E._rethrowError=null;E._hasRethrowError=!1;throw a;}}var oa=null,pa={};
function qa(){if(oa)for(var a in pa){var b=pa[a],c=oa.indexOf(a);-1<c?void 0:D("96",a);if(!ra[c]){b.extractEvents?void 0:D("97",a);ra[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],h=b,g=d;sa.hasOwnProperty(g)?D("99",g):void 0;sa[g]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ta(k[e],h,g);e=!0}else f.registrationName?(ta(f.registrationName,h,g),e=!0):e=!1;e?void 0:D("98",d,a)}}}}
function ta(a,b,c){ua[a]?D("100",a):void 0;ua[a]=b;va[a]=b.eventTypes[c].dependencies}var ra=[],sa={},ua={},va={};function wa(a){oa?D("101"):void 0;oa=Array.prototype.slice.call(a);qa()}function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];pa.hasOwnProperty(c)&&pa[c]===d||(pa[c]?D("102",c):void 0,pa[c]=d,b=!0)}b&&qa()}
var Ca=Object.freeze({plugins:ra,eventNameDispatchConfigs:sa,registrationNameModules:ua,registrationNameDependencies:va,possibleRegistrationNames:null,injectEventPluginOrder:wa,injectEventPluginsByName:xa}),Da=null,Ea=null,Fa=null;function Ga(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Fa(d);E.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Ha(a,b){null==b?D("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ia(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ja=null;
function Ka(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Ga(a,b,c[e],d[e]);else c&&Ga(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function La(a){return Ka(a,!0)}function Ma(a){return Ka(a,!1)}var Na={injectEventPluginOrder:wa,injectEventPluginsByName:xa};
function Oa(a,b){var c=a.stateNode;if(!c)return null;var d=Da(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?D("231",b,typeof c):void 0;
return c}function Pa(a,b){null!==a&&(Ja=Ha(Ja,a));a=Ja;Ja=null;a&&(b?Ia(a,La):Ia(a,Ma),Ja?D("95"):void 0,E.rethrowCaughtError())}function Qa(a,b,c,d){for(var e=null,f=0;f<ra.length;f++){var h=ra[f];h&&(h=h.extractEvents(a,b,c,d))&&(e=Ha(e,h))}Pa(e,!1)}var Ra=Object.freeze({injection:Na,getListener:Oa,runEventsInBatch:Pa,runExtractedEventsInBatch:Qa}),Sa=Math.random().toString(36).slice(2),F="__reactInternalInstance$"+Sa,Ta="__reactEventHandlers$"+Sa;
function Ua(a){if(a[F])return a[F];for(;!a[F];)if(a.parentNode)a=a.parentNode;else return null;a=a[F];return 5===a.tag||6===a.tag?a:null}function Va(a){if(5===a.tag||6===a.tag)return a.stateNode;D("33")}function Xa(a){return a[Ta]||null}var bb=Object.freeze({precacheFiberNode:function(a,b){b[F]=a},getClosestInstanceFromNode:Ua,getInstanceFromNode:function(a){a=a[F];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Va,getFiberCurrentPropsFromNode:Xa,updateFiberProps:function(a,b){a[Ta]=b}});
function L(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function cb(a,b,c){for(var d=[];a;)d.push(a),a=L(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function db(a,b,c){if(b=Oa(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Ha(c._dispatchListeners,b),c._dispatchInstances=Ha(c._dispatchInstances,a)}function eb(a){a&&a.dispatchConfig.phasedRegistrationNames&&cb(a._targetInst,db,a)}
function fb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?L(b):null;cb(b,db,a)}}function gb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Oa(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Ha(c._dispatchListeners,b),c._dispatchInstances=Ha(c._dispatchInstances,a))}function hb(a){a&&a.dispatchConfig.registrationName&&gb(a._targetInst,null,a)}function ib(a){Ia(a,eb)}
function jb(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,h=0,g=e;g;g=L(g))h++;g=0;for(var k=f;k;k=L(k))g++;for(;0<h-g;)e=L(e),h--;for(;0<g-h;)f=L(f),g--;for(;h--;){if(e===f||e===f.alternate)break a;e=L(e);f=L(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){h=c.alternate;if(null!==h&&h===f)break;e.push(c);c=L(c)}for(c=[];d&&d!==f;){h=d.alternate;if(null!==h&&h===f)break;c.push(d);d=L(d)}for(d=0;d<e.length;d++)gb(e[d],"bubbled",a);for(a=c.length;0<a--;)gb(c[a],"captured",b)}
var kb=Object.freeze({accumulateTwoPhaseDispatches:ib,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ia(a,fb)},accumulateEnterLeaveDispatches:jb,accumulateDirectDispatches:function(a){Ia(a,hb)}}),lb=null;function mb(){!lb&&m.canUseDOM&&(lb="textContent"in document.documentElement?"textContent":"innerText");return lb}var M={_root:null,_startText:null,_fallbackText:null};
function nb(){if(M._fallbackText)return M._fallbackText;var a,b=M._startText,c=b.length,d,e=ob(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var h=c-a;for(d=1;d<=h&&b[c-d]===e[f-d];d++);M._fallbackText=e.slice(a,1<d?1-d:void 0);return M._fallbackText}function ob(){return"value"in M._root?M._root.value:M._root[mb()]}
var pb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),qb={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function N(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
A(N.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<pb.length;a++)this[pb[a]]=null}});N.Interface=qb;N.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;A(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=A({},d.Interface,a);c.extend=d.extend;rb(c);return c};rb(N);
function sb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function tb(a){a instanceof this?void 0:D("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function rb(a){a.eventPool=[];a.getPooled=sb;a.release=tb}var ub=N.extend({data:null}),vb=N.extend({data:null}),wb=[9,13,27,32],xb=m.canUseDOM&&"CompositionEvent"in window,yb=null;m.canUseDOM&&"documentMode"in document&&(yb=document.documentMode);
var zb=m.canUseDOM&&"TextEvent"in window&&!yb,Ab=m.canUseDOM&&(!xb||yb&&8<yb&&11>=yb),Bb=String.fromCharCode(32),Kb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},Lb=!1;
function Mb(a,b){switch(a){case "topKeyUp":return-1!==wb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function Nb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Ob=!1;function Pb(a,b){switch(a){case "topCompositionEnd":return Nb(b);case "topKeyPress":if(32!==b.which)return null;Lb=!0;return Bb;case "topTextInput":return a=b.data,a===Bb&&Lb?null:a;default:return null}}
function Qb(a,b){if(Ob)return"topCompositionEnd"===a||!xb&&Mb(a,b)?(a=nb(),M._root=null,M._startText=null,M._fallbackText=null,Ob=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return Ab?null:b.data;default:return null}}
var Rb={eventTypes:Kb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(xb)b:{switch(a){case "topCompositionStart":e=Kb.compositionStart;break b;case "topCompositionEnd":e=Kb.compositionEnd;break b;case "topCompositionUpdate":e=Kb.compositionUpdate;break b}e=void 0}else Ob?Mb(a,c)&&(e=Kb.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(e=Kb.compositionStart);e?(Ab&&(Ob||e!==Kb.compositionStart?e===Kb.compositionEnd&&Ob&&(f=nb()):(M._root=d,M._startText=ob(),Ob=!0)),e=ub.getPooled(e,
b,c,d),f?e.data=f:(f=Nb(c),null!==f&&(e.data=f)),ib(e),f=e):f=null;(a=zb?Pb(a,c):Qb(a,c))?(b=vb.getPooled(Kb.beforeInput,b,c,d),b.data=a,ib(b)):b=null;return null===f?b:null===b?f:[f,b]}},Sb=null,Tb={injectFiberControlledHostComponent:function(a){Sb=a}},Ub=null,Vb=null;function Wb(a){if(a=Ea(a)){Sb&&"function"===typeof Sb.restoreControlledState?void 0:D("194");var b=Da(a.stateNode);Sb.restoreControlledState(a.stateNode,a.type,b)}}function Xb(a){Ub?Vb?Vb.push(a):Vb=[a]:Ub=a}
function Yb(){return null!==Ub||null!==Vb}function Zb(){if(Ub){var a=Ub,b=Vb;Vb=Ub=null;Wb(a);if(b)for(a=0;a<b.length;a++)Wb(b[a])}}var $b=Object.freeze({injection:Tb,enqueueStateRestore:Xb,needsStateRestore:Yb,restoreStateIfNeeded:Zb});function ac(a,b){return a(b)}function bc(a,b,c){return a(b,c)}function cc(){}var dc=!1;function ec(a,b){if(dc)return a(b);dc=!0;try{return ac(a,b)}finally{dc=!1,Yb()&&(cc(),Zb())}}
var fc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function gc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!fc[a.type]:"textarea"===b?!0:!1}function hc(a){a=a.target||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
function ic(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function jc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function kc(a){var b=jc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),Object.defineProperty(a,b,{enumerable:c.enumerable}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
function lc(a){a._valueTracker||(a._valueTracker=kc(a))}function mc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=jc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var nc=ea.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,O="function"===typeof Symbol&&Symbol["for"],oc=O?Symbol["for"]("react.element"):60103,pc=O?Symbol["for"]("react.call"):60104,qc=O?Symbol["for"]("react.return"):60105,rc=O?Symbol["for"]("react.portal"):60106,sc=O?Symbol["for"]("react.fragment"):60107,tc=O?Symbol["for"]("react.strict_mode"):60108,uc=O?Symbol["for"]("react.provider"):60109,vc=O?Symbol["for"]("react.context"):60110,wc=O?Symbol["for"]("react.async_mode"):60111,
xc=O?Symbol["for"]("react.forward_ref"):60112,yc="function"===typeof Symbol&&Symbol.iterator;function zc(a){if(null===a||"undefined"===typeof a)return null;a=yc&&a[yc]||a["@@iterator"];return"function"===typeof a?a:null}
function Ac(a){a=a.type;if("function"===typeof a)return a.displayName||a.name;if("string"===typeof a)return a;switch(a){case sc:return"ReactFragment";case rc:return"ReactPortal";case pc:return"ReactCall";case qc:return"ReactReturn"}if("object"===typeof a&&null!==a)switch(a.$$typeof){case xc:return a=a.render.displayName||a.render.name||"",""!==a?"ForwardRef("+a+")":"ForwardRef"}return null}
function Bc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=Ac(a);var f=null;c&&(f=Ac(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a["return"]}while(a);return b}
var Cc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Dc={},Ec={};function Fc(a){if(Ec.hasOwnProperty(a))return!0;if(Dc.hasOwnProperty(a))return!1;if(Cc.test(a))return Ec[a]=!0;Dc[a]=!0;return!1}
function Gc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}function Hc(a,b,c,d){if(null===b||"undefined"===typeof b||Gc(a,b,c,d))return!0;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}
function U(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var V={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){V[a]=new U(a,0,!1,a,null)});
[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];V[b]=new U(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){V[a]=new U(a,2,!1,a.toLowerCase(),null)});["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){V[a]=new U(a,2,!1,a,null)});
"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){V[a]=new U(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){V[a]=new U(a,3,!0,a.toLowerCase(),null)});["capture","download"].forEach(function(a){V[a]=new U(a,4,!1,a.toLowerCase(),null)});
["cols","rows","size","span"].forEach(function(a){V[a]=new U(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){V[a]=new U(a,5,!1,a.toLowerCase(),null)});var Sc=/[\-:]([a-z])/g;function Tc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Sc,
Tc);V[b]=new U(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Sc,Tc);V[b]=new U(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Sc,Tc);V[b]=new U(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});V.tabIndex=new U("tabIndex",1,!1,"tabindex",null);
function Uc(a,b,c,d){var e=V.hasOwnProperty(b)?V[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Hc(b,c,e,d)&&(c=null),d||null===e?Fc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Vc(a,b){var c=b.checked;return A({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Wc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Xc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Yc(a,b){b=b.checked;null!=b&&Uc(a,"checked",b,!1)}
function Zc(a,b){Yc(a,b);var c=Xc(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?$c(a,b.type,c):b.hasOwnProperty("defaultValue")&&$c(a,b.type,Xc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function ad(a,b){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue"))""===a.value&&(a.value=""+a._wrapperState.initialValue),a.defaultValue=""+a._wrapperState.initialValue;b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function $c(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
function Xc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var bd={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};function cd(a,b,c){a=N.getPooled(bd.change,a,b,c);a.type="change";Xb(c);ib(a);return a}var dd=null,ed=null;function fd(a){Pa(a,!1)}
function gd(a){var b=Va(a);if(mc(b))return a}function hd(a,b){if("topChange"===a)return b}var id=!1;m.canUseDOM&&(id=ic("input")&&(!document.documentMode||9<document.documentMode));function jd(){dd&&(dd.detachEvent("onpropertychange",kd),ed=dd=null)}function kd(a){"value"===a.propertyName&&gd(ed)&&(a=cd(ed,a,hc(a)),ec(fd,a))}function ld(a,b,c){"topFocus"===a?(jd(),dd=b,ed=c,dd.attachEvent("onpropertychange",kd)):"topBlur"===a&&jd()}
function md(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return gd(ed)}function nd(a,b){if("topClick"===a)return gd(b)}function od(a,b){if("topInput"===a||"topChange"===a)return gd(b)}
var pd={eventTypes:bd,_isInputEventSupported:id,extractEvents:function(a,b,c,d){var e=b?Va(b):window,f=void 0,h=void 0,g=e.nodeName&&e.nodeName.toLowerCase();"select"===g||"input"===g&&"file"===e.type?f=hd:gc(e)?id?f=od:(f=md,h=ld):(g=e.nodeName)&&"input"===g.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=nd);if(f&&(f=f(a,b)))return cd(f,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&$c(e,"number",e.value)}},qd=N.extend({view:null,
detail:null}),rd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function sd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=rd[a])?!!b[a]:!1}function td(){return sd}
var ud=qd.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:td,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),vd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},wd={eventTypes:vd,extractEvents:function(a,
b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?Ua(b):null):a=null;if(a===b)return null;var f=null==a?e:Va(a);e=null==b?e:Va(b);var h=ud.getPooled(vd.mouseLeave,a,c,d);h.type="mouseleave";h.target=f;h.relatedTarget=e;c=ud.getPooled(vd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=
f;jb(h,c,a,b);return[h,c]}};function xd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function yd(a){return(a=a._reactInternalFiber)?2===xd(a):!1}function zd(a){2!==xd(a)?D("188"):void 0}
function Ad(a){var b=a.alternate;if(!b)return b=xd(a),3===b?D("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var h=e.child;h;){if(h===c)return zd(e),a;if(h===d)return zd(e),b;h=h.sibling}D("188")}if(c["return"]!==d["return"])c=e,d=f;else{h=!1;for(var g=e.child;g;){if(g===c){h=!0;c=e;d=f;break}if(g===d){h=!0;d=e;c=f;break}g=g.sibling}if(!h){for(g=f.child;g;){if(g===c){h=!0;c=f;d=e;break}if(g===d){h=!0;d=f;c=e;break}g=g.sibling}h?
void 0:D("189")}}c.alternate!==d?D("190"):void 0}3!==c.tag?D("188"):void 0;return c.stateNode.current===c?a:b}function Bd(a){a=Ad(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
function Cd(a){a=Ad(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var Dd=N.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Ed=N.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),Fd=qd.extend({relatedTarget:null});
function Gd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var Hd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Id={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Jd=qd.extend({key:function(a){if(a.key){var b=Hd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Gd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Id[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:td,charCode:function(a){return"keypress"===
a.type?Gd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?Gd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),Kd=ud.extend({dataTransfer:null}),Ld=qd.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:td}),Md=N.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),Nd=ud.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),Od={},Pd={};function Qd(a,b){var c=a[0].toUpperCase()+a.slice(1),d="on"+c;c="top"+c;b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Od[a]=b;Pd[c]=b}
"blur cancel click close contextMenu copy cut doubleClick dragEnd dragStart drop focus input invalid keyDown keyPress keyUp mouseDown mouseUp paste pause play rateChange reset seeked submit touchCancel touchEnd touchStart volumeChange".split(" ").forEach(function(a){Qd(a,!0)});
"abort animationEnd animationIteration animationStart canPlay canPlayThrough drag dragEnter dragExit dragLeave dragOver durationChange emptied encrypted ended error load loadedData loadedMetadata loadStart mouseMove mouseOut mouseOver playing progress scroll seeking stalled suspend timeUpdate toggle touchMove transitionEnd waiting wheel".split(" ").forEach(function(a){Qd(a,!1)});
var Rd={eventTypes:Od,isInteractiveTopLevelEventType:function(a){a=Pd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Pd[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Gd(c))return null;case "topKeyDown":case "topKeyUp":a=Jd;break;case "topBlur":case "topFocus":a=Fd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=
ud;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=Kd;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=Ld;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Dd;break;case "topTransitionEnd":a=Md;break;case "topScroll":a=qd;break;case "topWheel":a=Nd;break;case "topCopy":case "topCut":case "topPaste":a=Ed;break;default:a=
N}b=a.getPooled(e,b,c,d);ib(b);return b}},Sd=Rd.isInteractiveTopLevelEventType,Td=[];function Ud(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Ua(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Qa(a.topLevelType,b,a.nativeEvent,hc(a.nativeEvent))}var Vd=!0;function Wd(a){Vd=!!a}
function W(a,b,c){if(!c)return null;a=(Sd(a)?Xd:Yd).bind(null,a);c.addEventListener(b,a,!1)}function Zd(a,b,c){if(!c)return null;a=(Sd(a)?Xd:Yd).bind(null,a);c.addEventListener(b,a,!0)}function Xd(a,b){bc(Yd,a,b)}
function Yd(a,b){if(Vd){var c=hc(b);c=Ua(c);null!==c&&"number"===typeof c.tag&&2!==xd(c)&&(c=null);if(Td.length){var d=Td.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{ec(Ud,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Td.length&&Td.push(a)}}}
var $d=Object.freeze({get _enabled(){return Vd},setEnabled:Wd,isEnabled:function(){return Vd},trapBubbledEvent:W,trapCapturedEvent:Zd,dispatchEvent:Yd});function ae(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var be={animationend:ae("Animation","AnimationEnd"),animationiteration:ae("Animation","AnimationIteration"),animationstart:ae("Animation","AnimationStart"),transitionend:ae("Transition","TransitionEnd")},ce={},de={};m.canUseDOM&&(de=document.createElement("div").style,"AnimationEvent"in window||(delete be.animationend.animation,delete be.animationiteration.animation,delete be.animationstart.animation),"TransitionEvent"in window||delete be.transitionend.transition);
function ee(a){if(ce[a])return ce[a];if(!be[a])return a;var b=be[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in de)return ce[a]=b[c];return a}
var fe={topAnimationEnd:ee("animationend"),topAnimationIteration:ee("animationiteration"),topAnimationStart:ee("animationstart"),topBlur:"blur",topCancel:"cancel",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",
topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoad:"load",topLoadStart:"loadstart",topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topScroll:"scroll",topSelectionChange:"selectionchange",topTextInput:"textInput",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:ee("transitionend"),topWheel:"wheel"},ge={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",
topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",topWaiting:"waiting"},he={},ie=0,je="_reactListenersID"+(""+Math.random()).slice(2);function ke(a){Object.prototype.hasOwnProperty.call(a,je)||(a[je]=ie++,he[a[je]]={});return he[a[je]]}function le(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function me(a,b){var c=le(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=le(c)}}function ne(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var oe=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,pe={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},qe=null,re=null,se=null,te=!1;
function ue(a,b){if(te||null==qe||qe!==fa())return null;var c=qe;"selectionStart"in c&&ne(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return se&&ha(se,c)?null:(se=c,a=N.getPooled(pe.select,re,a,b),a.type="select",a.target=qe,ib(a),a)}
var ve={eventTypes:pe,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=ke(e);f=va.onSelect;for(var h=0;h<f.length;h++){var g=f[h];if(!e.hasOwnProperty(g)||!e[g]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Va(b):window;switch(a){case "topFocus":if(gc(e)||"true"===e.contentEditable)qe=e,re=b,se=null;break;case "topBlur":se=re=qe=null;break;case "topMouseDown":te=!0;break;case "topContextMenu":case "topMouseUp":return te=!1,ue(c,d);case "topSelectionChange":if(oe)break;
case "topKeyDown":case "topKeyUp":return ue(c,d)}return null}};Na.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));Da=bb.getFiberCurrentPropsFromNode;Ea=bb.getInstanceFromNode;Fa=bb.getNodeFromInstance;Na.injectEventPluginsByName({SimpleEventPlugin:Rd,EnterLeaveEventPlugin:wd,ChangeEventPlugin:pd,SelectEventPlugin:ve,BeforeInputEventPlugin:Rb});
function xe(a,b,c,d){this.tag=a;this.key=c;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function ze(a,b,c){var d=a.alternate;null===d?(d=new xe(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function Ae(a,b,c){var d=a.type,e=a.key;a=a.props;var f=void 0;if("function"===typeof d)f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case sc:return Be(a.children,b,c,e);case wc:f=11;b|=3;break;case tc:f=11;b|=2;break;case pc:f=7;break;case qc:f=9;break;default:if("object"===typeof d&&null!==d)switch(d.$$typeof){case uc:f=13;break;case vc:f=12;break;case xc:f=14;break;default:if("number"===typeof d.tag)return b=d,b.pendingProps=a,b.expirationTime=c,
b;D("130",null==d?d:typeof d,"")}else D("130",null==d?d:typeof d,"")}b=new xe(f,a,e,b);b.type=d;b.expirationTime=c;return b}function Be(a,b,c,d){a=new xe(10,a,d,b);a.expirationTime=c;return a}function Ce(a,b,c){a=new xe(6,a,null,b);a.expirationTime=c;return a}function De(a,b,c){b=new xe(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var Ee=null,Fe=null;
function Ge(a){return function(b){try{return a(b)}catch(c){}}}function He(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Ee=Ge(function(a){return b.onCommitFiberRoot(c,a)});Fe=Ge(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Ie(a){"function"===typeof Ee&&Ee(a)}function Je(a){"function"===typeof Fe&&Fe(a)}new Set;
function Ke(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1,capturedValues:null}}function Le(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}var Me=void 0,Ne=void 0;
function Oe(a){Me=Ne=null;var b=a.alternate,c=a.updateQueue;null===c&&(c=a.updateQueue=Ke(null));null!==b?(a=b.updateQueue,null===a&&(a=b.updateQueue=Ke(null))):a=null;Me=c;Ne=a!==c?a:null}function Pe(a,b){Oe(a);a=Me;var c=Ne;null===c?Le(a,b):null===a.last||null===c.last?(Le(a,b),Le(c,b)):(Le(a,b),c.last=b)}function Qe(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
function Re(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,capturedValues:c.capturedValues,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var h=!0,g=c.first,k=!1;null!==g;){var v=g.expirationTime;if(v>f){var l=c.expirationTime;if(0===l||l>v)c.expirationTime=v;k||(k=!0,c.baseState=a)}else{k||
(c.first=g.next,null===c.first&&(c.last=null));if(g.isReplace)a=Qe(g,d,a,e),h=!0;else if(v=Qe(g,d,a,e))a=h?A({},a,v):A(a,v),h=!1;g.isForced&&(c.hasForceUpdate=!0);null!==g.callback&&(v=c.callbackList,null===v&&(v=c.callbackList=[]),v.push(g));null!==g.capturedValue&&(v=c.capturedValues,null===v?c.capturedValues=[g.capturedValue]:v.push(g.capturedValue))}g=g.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||null!==c.capturedValues||(b.updateQueue=null);k||(c.baseState=a);
return a}function Se(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?D("191",e):void 0;e.call(b)}}
function Te(a,b,c,d,e){function f(a,b,c,d,e,f){if(null===b||null!==a.updateQueue&&a.updateQueue.hasForceUpdate)return!0;var n=a.stateNode;a=a.type;return"function"===typeof n.shouldComponentUpdate?n.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ha(b,c)||!ha(d,e):!0}function h(a,b){b.updater=r;a.stateNode=b;b._reactInternalFiber=a}function g(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&
b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&r.enqueueReplaceState(b,b.state,null)}function k(a,b,c,d){a=a.type;if("function"===typeof a.getDerivedStateFromProps)return a.getDerivedStateFromProps.call(null,c,d)}var v=a.cacheContext,l=a.getMaskedContext,p=a.getUnmaskedContext,z=a.isContextConsumer,B=a.hasContextChanged,r={isMounted:yd,enqueueSetState:function(a,d,e){a=a._reactInternalFiber;e=void 0===e?null:e;var f=c(a);Pe(a,{expirationTime:f,partialState:d,callback:e,isReplace:!1,isForced:!1,
capturedValue:null,next:null});b(a,f)},enqueueReplaceState:function(a,d,e){a=a._reactInternalFiber;e=void 0===e?null:e;var f=c(a);Pe(a,{expirationTime:f,partialState:d,callback:e,isReplace:!0,isForced:!1,capturedValue:null,next:null});b(a,f)},enqueueForceUpdate:function(a,d){a=a._reactInternalFiber;d=void 0===d?null:d;var e=c(a);Pe(a,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,capturedValue:null,next:null});b(a,e)}};return{adoptClassInstance:h,callGetDerivedStateFromProps:k,
constructClassInstance:function(a,b){var c=a.type,d=p(a),e=z(a),f=e?l(a,d):ka;c=new c(b,f);var n=null!==c.state&&void 0!==c.state?c.state:null;h(a,c);a.memoizedState=n;b=k(a,c,b,n);null!==b&&void 0!==b&&(a.memoizedState=A({},a.memoizedState,b));e&&v(a,d,f);return c},mountClassInstance:function(a,b){var c=a.type,d=a.alternate,e=a.stateNode,f=a.pendingProps,n=p(a);e.props=f;e.state=a.memoizedState;e.refs=ka;e.context=l(a,n);"function"===typeof c.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||
"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||(c=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),c!==e.state&&r.enqueueReplaceState(e,e.state,null),c=a.updateQueue,null!==c&&(e.state=Re(d,a,c,e,f,b)));"function"===typeof e.componentDidMount&&(a.effectTag|=4)},resumeMountClassInstance:function(a,b){var c=a.type,n=a.stateNode;n.props=a.memoizedProps;n.state=
a.memoizedState;var h=a.memoizedProps,r=a.pendingProps,z=n.context,q=p(a);q=l(a,q);(c="function"===typeof c.getDerivedStateFromProps||"function"===typeof n.getSnapshotBeforeUpdate)||"function"!==typeof n.UNSAFE_componentWillReceiveProps&&"function"!==typeof n.componentWillReceiveProps||(h!==r||z!==q)&&g(a,n,r,q);z=a.memoizedState;b=null!==a.updateQueue?Re(null,a,a.updateQueue,n,r,b):z;var u=void 0;h!==r&&(u=k(a,n,r,b));if(null!==u&&void 0!==u){b=null===b||void 0===b?u:A({},b,u);var t=a.updateQueue;
null!==t&&(t.baseState=A({},t.baseState,u))}if(!(h!==r||z!==b||B()||null!==a.updateQueue&&a.updateQueue.hasForceUpdate))return"function"===typeof n.componentDidMount&&(a.effectTag|=4),!1;(h=f(a,h,r,z,b,q))?(c||"function"!==typeof n.UNSAFE_componentWillMount&&"function"!==typeof n.componentWillMount||("function"===typeof n.componentWillMount&&n.componentWillMount(),"function"===typeof n.UNSAFE_componentWillMount&&n.UNSAFE_componentWillMount()),"function"===typeof n.componentDidMount&&(a.effectTag|=
4)):("function"===typeof n.componentDidMount&&(a.effectTag|=4),d(a,r),e(a,b));n.props=r;n.state=b;n.context=q;return h},updateClassInstance:function(a,b,c){var n=b.type,x=b.stateNode;x.props=b.memoizedProps;x.state=b.memoizedState;var h=b.memoizedProps,r=b.pendingProps,q=x.context,u=p(b);u=l(b,u);(n="function"===typeof n.getDerivedStateFromProps||"function"===typeof x.getSnapshotBeforeUpdate)||"function"!==typeof x.UNSAFE_componentWillReceiveProps&&"function"!==typeof x.componentWillReceiveProps||
(h!==r||q!==u)&&g(b,x,r,u);q=b.memoizedState;c=null!==b.updateQueue?Re(a,b,b.updateQueue,x,r,c):q;var t=void 0;h!==r&&(t=k(b,x,r,c));if(null!==t&&void 0!==t){c=null===c||void 0===c?t:A({},c,t);var y=b.updateQueue;null!==y&&(y.baseState=A({},y.baseState,t))}if(!(h!==r||q!==c||B()||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==typeof x.componentDidUpdate||h===a.memoizedProps&&q===a.memoizedState||(b.effectTag|=4),"function"!==typeof x.getSnapshotBeforeUpdate||h===a.memoizedProps&&
q===a.memoizedState||(b.effectTag|=2048),!1;(t=f(b,h,r,q,c,u))?(n||"function"!==typeof x.UNSAFE_componentWillUpdate&&"function"!==typeof x.componentWillUpdate||("function"===typeof x.componentWillUpdate&&x.componentWillUpdate(r,c,u),"function"===typeof x.UNSAFE_componentWillUpdate&&x.UNSAFE_componentWillUpdate(r,c,u)),"function"===typeof x.componentDidUpdate&&(b.effectTag|=4),"function"===typeof x.getSnapshotBeforeUpdate&&(b.effectTag|=2048)):("function"!==typeof x.componentDidUpdate||h===a.memoizedProps&&
q===a.memoizedState||(b.effectTag|=4),"function"!==typeof x.getSnapshotBeforeUpdate||h===a.memoizedProps&&q===a.memoizedState||(b.effectTag|=2048),d(b,r),e(b,c));x.props=r;x.state=c;x.context=u;return t}}}var Ue=Array.isArray;
function Ve(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?D("110"):void 0,d=c.stateNode);d?void 0:D("147",a);var e=""+a;if(null!==b&&null!==b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ka?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?D("148"):void 0;c._owner?void 0:D("254",a)}return a}
function We(a,b){"textarea"!==a.type&&D("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Xe(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=ze(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function h(b){a&&null===b.alternate&&(b.effectTag=2);return b}function g(a,b,c,d){if(null===b||6!==b.tag)return b=Ce(c,a.mode,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ve(a,b,c),d["return"]=a,d;d=Ae(c,a.mode,d);d.ref=Ve(a,b,c);d["return"]=a;return d}function v(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
De(c,a.mode,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function l(a,b,c,d,f){if(null===b||10!==b.tag)return b=Be(c,a.mode,d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Ce(""+b,a.mode,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case oc:return c=Ae(b,a.mode,c),c.ref=Ve(a,null,b),c["return"]=a,c;case rc:return b=De(b,a.mode,c),b["return"]=a,b}if(Ue(b)||zc(b))return b=Be(b,
a.mode,c,null),b["return"]=a,b;We(a,b)}return null}function z(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:g(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case oc:return c.key===e?c.type===sc?l(a,b,c.props.children,d,e):k(a,b,c,d):null;case rc:return c.key===e?v(a,b,c,d):null}if(Ue(c)||zc(c))return null!==e?null:l(a,b,c,d,null);We(a,c)}return null}function B(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||
null,g(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case oc:return a=a.get(null===d.key?c:d.key)||null,d.type===sc?l(b,a,d.props.children,e,d.key):k(b,a,d,e);case rc:return a=a.get(null===d.key?c:d.key)||null,v(b,a,d,e)}if(Ue(d)||zc(d))return a=a.get(c)||null,l(b,a,d,e,null);We(b,d)}return null}function r(e,l,g,h){for(var r=null,k=null,q=l,u=l=0,t=null;null!==q&&u<g.length;u++){q.index>u?(t=q,q=null):t=q.sibling;var n=z(e,q,g[u],h);if(null===n){null===q&&(q=t);break}a&&q&&null===
n.alternate&&b(e,q);l=f(n,l,u);null===k?r=n:k.sibling=n;k=n;q=t}if(u===g.length)return c(e,q),r;if(null===q){for(;u<g.length;u++)if(q=p(e,g[u],h))l=f(q,l,u),null===k?r=q:k.sibling=q,k=q;return r}for(q=d(e,q);u<g.length;u++)if(t=B(q,e,u,g[u],h)){if(a&&null!==t.alternate)q["delete"](null===t.key?u:t.key);l=f(t,l,u);null===k?r=t:k.sibling=t;k=t}a&&q.forEach(function(a){return b(e,a)});return r}function Q(e,l,g,h){var r=zc(g);"function"!==typeof r?D("150"):void 0;g=r.call(g);null==g?D("151"):void 0;for(var k=
r=null,q=l,u=l=0,t=null,n=g.next();null!==q&&!n.done;u++,n=g.next()){q.index>u?(t=q,q=null):t=q.sibling;var H=z(e,q,n.value,h);if(null===H){q||(q=t);break}a&&q&&null===H.alternate&&b(e,q);l=f(H,l,u);null===k?r=H:k.sibling=H;k=H;q=t}if(n.done)return c(e,q),r;if(null===q){for(;!n.done;u++,n=g.next())n=p(e,n.value,h),null!==n&&(l=f(n,l,u),null===k?r=n:k.sibling=n,k=n);return r}for(q=d(e,q);!n.done;u++,n=g.next())if(n=B(q,e,u,n.value,h),null!==n){if(a&&null!==n.alternate)q["delete"](null===n.key?u:n.key);
l=f(n,l,u);null===k?r=n:k.sibling=n;k=n}a&&q.forEach(function(a){return b(e,a)});return r}return function(a,d,f,l){"object"===typeof f&&null!==f&&f.type===sc&&null===f.key&&(f=f.props.children);var g="object"===typeof f&&null!==f;if(g)switch(f.$$typeof){case oc:a:{var k=f.key;for(g=d;null!==g;){if(g.key===k)if(10===g.tag?f.type===sc:g.type===f.type){c(a,g.sibling);d=e(g,f.type===sc?f.props.children:f.props,l);d.ref=Ve(a,g,f);d["return"]=a;a=d;break a}else{c(a,g);break}else b(a,g);g=g.sibling}f.type===
sc?(d=Be(f.props.children,a.mode,l,f.key),d["return"]=a,a=d):(l=Ae(f,a.mode,l),l.ref=Ve(a,d,f),l["return"]=a,a=l)}return h(a);case rc:a:{for(g=f.key;null!==d;){if(d.key===g)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],l);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=De(f,a.mode,l);d["return"]=a;a=d}return h(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&
6===d.tag?(c(a,d.sibling),d=e(d,f,l),d["return"]=a,a=d):(c(a,d),d=Ce(f,a.mode,l),d["return"]=a,a=d),h(a);if(Ue(f))return r(a,d,f,l);if(zc(f))return Q(a,d,f,l);g&&We(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:l=a.type,D("152",l.displayName||l.name||"Component")}return c(a,d)}}var Ye=Xe(!0),Ze=Xe(!1);
function $e(a,b,c,d,e,f,h){function g(a,b,c){k(a,b,c,b.expirationTime)}function k(a,b,c,d){b.child=null===a?Ze(b,null,c,d):Ye(b,a.child,c,d)}function v(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function l(a,b,c,d,e,f){v(a,b);if(!c&&!e)return d&&y(b,!1),r(a,b);c=b.stateNode;nc.current=b;var l=e?null:c.render();b.effectTag|=1;e&&(k(a,b,null,f),b.child=null);k(a,b,l,f);b.memoizedState=c.state;b.memoizedProps=c.props;d&&y(b,!0);return b.child}function p(a){var b=a.stateNode;
b.pendingContext?t(a,b.pendingContext,b.pendingContext!==b.context):b.context&&t(a,b.context,!1);Y(a,b.containerInfo)}function z(a,b,c,d){var e=a.child;for(null!==e&&(e["return"]=a);null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var l=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==l&&(0===l.expirationTime||l.expirationTime>d)&&(l.expirationTime=d);else if(null!==l&&(0===l.expirationTime||l.expirationTime>d))l.expirationTime=
d;else break;f=f["return"]}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=e.child}if(null!==f)f["return"]=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){f=e;break}f=f["return"]}e=f}}function B(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps;if(!q()&&f===e)return b.stateNode=0,G(b),r(a,b);var l=e.value;b.memoizedProps=e;if(null===f)l=1073741823;else if(f.value===e.value){if(f.children===e.children)return b.stateNode=0,G(b),
r(a,b);l=0}else{var h=f.value;if(h===l&&(0!==h||1/h===1/l)||h!==h&&l!==l){if(f.children===e.children)return b.stateNode=0,G(b),r(a,b);l=0}else if(l="function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,l):1073741823,l|=0,0===l){if(f.children===e.children)return b.stateNode=0,G(b),r(a,b)}else z(b,d,l,c)}b.stateNode=l;G(b);g(a,b,e.children);return b.child}function r(a,b){null!==a&&b.child!==a.child?D("153"):void 0;if(null!==b.child){a=b.child;var c=ze(a,a.pendingProps,a.expirationTime);
b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ze(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}var Q=a.shouldSetTextContent,n=a.shouldDeprioritizeSubtree,x=b.pushHostContext,Y=b.pushHostContainer,G=d.pushProvider,R=c.getMaskedContext,S=c.getUnmaskedContext,q=c.hasContextChanged,u=c.pushContextProvider,t=c.pushTopLevelContextObject,y=c.invalidateContextProvider,H=e.enterHydrationState,Wa=e.resetHydrationState,Cb=e.tryToClaimNextHydratableInstance;
a=Te(c,f,h,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var Jc=a.adoptClassInstance,Kc=a.callGetDerivedStateFromProps,Lc=a.constructClassInstance,Db=a.mountClassInstance,Mc=a.resumeMountClassInstance,Eb=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:p(b);break;case 2:u(b);break;case 4:Y(b,b.stateNode.containerInfo);break;case 13:G(b)}return null}switch(b.tag){case 0:null!==a?D("155"):void 0;var d=b.type,
e=b.pendingProps,f=S(b);f=R(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,"function"===typeof f.getDerivedStateFromProps&&(e=Kc(b,d,e,b.memoizedState),null!==e&&void 0!==e&&(b.memoizedState=A({},b.memoizedState,e))),e=u(b),Jc(b,d),Db(b,c),a=l(a,b,!0,e,!1,c)):(b.tag=1,g(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,q()||
b.memoizedProps!==c?(d=S(b),d=R(b,d),e=e(c,d),b.effectTag|=1,g(a,b,e),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 2:e=u(b);null===a?null===b.stateNode?(Lc(b,b.pendingProps),Db(b,c),d=!0):d=Mc(b,c):d=Eb(a,b,c);f=!1;var h=b.updateQueue;null!==h&&null!==h.capturedValues&&(f=d=!0);return l(a,b,d,e,f,c);case 3:a:if(p(b),d=b.updateQueue,null!==d){f=b.memoizedState;e=Re(a,b,d,null,null,c);b.memoizedState=e;d=b.updateQueue;if(null!==d&&null!==d.capturedValues)d=null;else if(f===e){Wa();a=r(a,b);break a}else d=
e.element;f=b.stateNode;(null===a||null===a.child)&&f.hydrate&&H(b)?(b.effectTag|=2,b.child=Ze(b,null,d,c)):(Wa(),g(a,b,d));b.memoizedState=e;a=b.child}else Wa(),a=r(a,b);return a;case 5:a:{x(b);null===a&&Cb(b);e=b.type;h=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!q()&&h===d){if(h=b.mode&1&&n(e,d))b.expirationTime=1073741823;if(!h||1073741823!==c){a=r(a,b);break a}}h=d.children;Q(e,d)?h=null:f&&Q(e,f)&&(b.effectTag|=16);v(a,b);1073741823!==c&&b.mode&1&&n(e,d)?(b.expirationTime=
1073741823,b.memoizedProps=d,a=null):(g(a,b,h),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Cb(b),b.memoizedProps=b.pendingProps,null;case 8:b.tag=7;case 7:return e=b.pendingProps,q()||b.memoizedProps!==e||(e=b.memoizedProps),d=e.children,b.stateNode=null===a?Ze(b,b.stateNode,d,c):Ye(b,a.stateNode,d,c),b.memoizedProps=e,b.stateNode;case 9:return null;case 4:return Y(b,b.stateNode.containerInfo),e=b.pendingProps,q()||b.memoizedProps!==e?(null===a?b.child=Ye(b,null,e,c):g(a,b,e),b.memoizedProps=
e,a=b.child):a=r(a,b),a;case 14:return c=b.type.render,c=c(b.pendingProps,b.ref),g(a,b,c),b.memoizedProps=c,b.child;case 10:return c=b.pendingProps,q()||b.memoizedProps!==c?(g(a,b,c),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 11:return c=b.pendingProps.children,q()||null!==c&&b.memoizedProps!==c?(g(a,b,c),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 13:return B(a,b,c);case 12:a:{d=b.type;f=b.pendingProps;h=b.memoizedProps;e=d._currentValue;var t=d._changedBits;if(q()||0!==t||h!==f){b.memoizedProps=
f;var k=f.unstable_observedBits;if(void 0===k||null===k)k=1073741823;b.stateNode=k;if(0!==(t&k))z(b,d,t,c);else if(h===f){a=r(a,b);break a}c=f.children;c=c(e);g(a,b,c);a=b.child}else a=r(a,b)}return a;default:D("156")}}}}
function af(a,b,c,d,e){function f(a){a.effectTag|=4}var h=a.createInstance,g=a.createTextInstance,k=a.appendInitialChild,v=a.finalizeInitialChildren,l=a.prepareUpdate,p=a.persistence,z=b.getRootHostContainer,B=b.popHostContext,r=b.getHostContext,Q=b.popHostContainer,n=c.popContextProvider,x=c.popTopLevelContextObject,Y=d.popProvider,G=e.prepareToHydrateHostInstance,R=e.prepareToHydrateHostTextInstance,S=e.popHydrationState,q=void 0,u=void 0,t=void 0;a.mutation?(q=function(){},u=function(a,b,c){(b.updateQueue=
c)&&f(b)},t=function(a,b,c,d){c!==d&&f(b)}):p?D("235"):D("236");return{completeWork:function(a,b,c){var d=b.pendingProps;switch(b.tag){case 1:return null;case 2:return n(b),a=b.stateNode,d=b.updateQueue,null!==d&&null!==d.capturedValues&&(b.effectTag&=-65,"function"===typeof a.componentDidCatch?b.effectTag|=256:d.capturedValues=null),null;case 3:Q(b);x(b);d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)S(b),b.effectTag&=-3;q(b);a=b.updateQueue;
null!==a&&null!==a.capturedValues&&(b.effectTag|=256);return null;case 5:B(b);c=z();var e=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,H=b.stateNode,y=r();H=l(H,e,p,d,c,y);u(a,b,H,e,p,d,c,y);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!d)return null===b.stateNode?D("166"):void 0,null;a=r();if(S(b))G(b,c,a)&&f(b);else{p=h(e,d,c,a,b);a:for(y=b.child;null!==y;){if(5===y.tag||6===y.tag)k(p,y.stateNode);else if(4!==y.tag&&null!==y.child){y.child["return"]=y;y=y.child;continue}if(y===b)break;
for(;null===y.sibling;){if(null===y["return"]||y["return"]===b)break a;y=y["return"]}y.sibling["return"]=y["return"];y=y.sibling}v(p,e,d,c,a)&&f(b);b.stateNode=p}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)t(a,b,a.memoizedProps,d);else{if("string"!==typeof d)return null===b.stateNode?D("166"):void 0,null;a=z();c=r();S(b)?R(b)&&f(b):b.stateNode=g(d,a,c,b)}return null;case 7:(d=b.memoizedProps)?void 0:D("165");b.tag=8;e=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==
p;){if(5===p.tag||6===p.tag||4===p.tag)D("247");else if(9===p.tag)e.push(p.pendingProps.value);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=d.handler;d=p(d.props,e);b.child=Ye(b,null!==a?a.child:null,d,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 14:return null;case 10:return null;case 11:return null;case 4:return Q(b),q(b),null;
case 13:return Y(b),null;case 12:return null;case 0:D("167");default:D("156")}}}}
function bf(a,b,c,d,e){var f=a.popHostContainer,h=a.popHostContext,g=b.popContextProvider,k=b.popTopLevelContextObject,v=c.popProvider;return{throwException:function(a,b,c){b.effectTag|=512;b.firstEffect=b.lastEffect=null;b={value:c,source:b,stack:Bc(b)};do{switch(a.tag){case 3:Oe(a);a.updateQueue.capturedValues=[b];a.effectTag|=1024;return;case 2:if(c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&!e(c)){Oe(a);c=a.updateQueue;var d=c.capturedValues;null===d?
c.capturedValues=[b]:d.push(b);a.effectTag|=1024;return}}a=a["return"]}while(null!==a)},unwindWork:function(a){switch(a.tag){case 2:g(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return f(a),k(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return h(a),null;case 4:return f(a),null;case 13:return v(a),null;default:return null}},unwindInterruptedWork:function(a){switch(a.tag){case 2:g(a);break;case 3:f(a);k(a);break;case 5:h(a);break;case 4:f(a);break;case 13:v(a)}}}}
function cf(a,b){var c=b.source;null===b.stack&&Bc(c);null!==c&&Ac(c);b=b.value;null!==a&&2===a.tag&&Ac(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}
function df(a,b,c,d,e){function f(a){var c=a.ref;if(null!==c)if("function"===typeof c)try{c(null)}catch(t){b(a,t)}else c.current=null}function h(a){"function"===typeof Je&&Je(a);switch(a.tag){case 2:f(a);var c=a.stateNode;if("function"===typeof c.componentWillUnmount)try{c.props=a.memoizedProps,c.state=a.memoizedState,c.componentWillUnmount()}catch(t){b(a,t)}break;case 5:f(a);break;case 7:g(a.stateNode);break;case 4:p&&v(a)}}function g(a){for(var b=a;;)if(h(b),null===b.child||p&&4===b.tag){if(b===
a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function k(a){return 5===a.tag||3===a.tag||4===a.tag}function v(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?D("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c["return"]}c=!0}if(5===
b.tag||6===b.tag)g(b),e?S(d,b.stateNode):R(d,b.stateNode);else if(4===b.tag?d=b.stateNode.containerInfo:h(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var l=a.getPublicInstance,p=a.mutation;a=a.persistence;p||(a?D("235"):D("236"));var z=p.commitMount,B=p.commitUpdate,r=p.resetTextContent,Q=p.commitTextUpdate,n=p.appendChild,
x=p.appendChildToContainer,Y=p.insertBefore,G=p.insertInContainerBefore,R=p.removeChild,S=p.removeChildFromContainer;return{commitBeforeMutationLifeCycles:function(a,b){switch(b.tag){case 2:if(b.effectTag&2048&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;a.props=b.memoizedProps;a.state=b.memoizedState;b=a.getSnapshotBeforeUpdate(c,d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:break;default:D("163")}},commitResetTextContent:function(a){r(a.stateNode)},
commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(k(b)){var c=b;break a}b=b["return"]}D("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:D("161")}c.effectTag&16&&(r(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||k(c["return"])){c=null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==
c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?G(b,e.stateNode,c):Y(b,e.stateNode,c):d?x(b,e.stateNode):n(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){v(a);
a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&B(c,f,e,a,d,b)}break;case 6:null===b.stateNode?D("162"):void 0;c=b.memoizedProps;Q(b.stateNode,null!==a?a.memoizedProps:c,c);break;case 3:break;default:D("163")}},commitLifeCycles:function(a,b,c){switch(c.tag){case 2:a=
c.stateNode;if(c.effectTag&4)if(null===b)a.props=c.memoizedProps,a.state=c.memoizedState,a.componentDidMount();else{var d=b.memoizedProps;b=b.memoizedState;a.props=c.memoizedProps;a.state=c.memoizedState;a.componentDidUpdate(d,b,a.__reactInternalSnapshotBeforeUpdate)}c=c.updateQueue;null!==c&&Se(c,a);break;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=l(c.child.stateNode);break;case 2:a=c.child.stateNode}Se(b,a)}break;case 5:a=c.stateNode;null===b&&c.effectTag&
4&&z(a,c.type,c.memoizedProps,c);break;case 6:break;case 4:break;default:D("163")}},commitErrorLogging:function(a,b){switch(a.tag){case 2:var c=a.type;b=a.stateNode;var d=a.updateQueue;null===d||null===d.capturedValues?D("264"):void 0;var f=d.capturedValues;d.capturedValues=null;"function"!==typeof c.getDerivedStateFromCatch&&e(b);b.props=a.memoizedProps;b.state=a.memoizedState;for(c=0;c<f.length;c++){d=f[c];var l=d.value,g=d.stack;cf(a,d);b.componentDidCatch(l,{componentStack:null!==g?g:""})}break;
case 3:c=a.updateQueue;null===c||null===c.capturedValues?D("264"):void 0;f=c.capturedValues;c.capturedValues=null;for(c=0;c<f.length;c++)d=f[c],cf(a,d),b(d.value);break;default:D("265")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:a=l(c);break;default:a=c}"function"===typeof b?b(a):b.current=a}},commitDetachRef:function(a){a=a.ref;null!==a&&("function"===typeof a?a(null):a.current=null)}}}var ef={};
function ff(a,b){function c(a){a===ef?D("174"):void 0;return a}var d=a.getChildHostContext,e=a.getRootHostContext;a=b.createCursor;var f=b.push,h=b.pop,g=a(ef),k=a(ef),v=a(ef);return{getHostContext:function(){return c(g.current)},getRootHostContainer:function(){return c(v.current)},popHostContainer:function(a){h(g,a);h(k,a);h(v,a)},popHostContext:function(a){k.current===a&&(h(g,a),h(k,a))},pushHostContainer:function(a,b){f(v,b,a);f(k,a,a);f(g,ef,a);b=e(b);h(g,a);f(g,b,a)},pushHostContext:function(a){var b=
c(v.current),e=c(g.current);b=d(e,a.type,b);e!==b&&(f(k,a,a),f(g,b,a))}}}
function gf(a){function b(a,b){var c=new xe(5,null,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=h(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];p=a}var e=a.shouldSetTextContent;
a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){D("175")},prepareToHydrateHostTextInstance:function(){D("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,h=a.canHydrateTextInstance,g=a.getNextHydratableSibling,k=a.getFirstHydratableChild,v=a.hydrateInstance,l=a.hydrateTextInstance,p=null,z=null,B=!1;return{enterHydrationState:function(a){z=
k(a.stateNode.containerInfo);p=a;return B=!0},resetHydrationState:function(){z=p=null;B=!1},tryToClaimNextHydratableInstance:function(a){if(B){var d=z;if(d){if(!c(a,d)){d=g(d);if(!d||!c(a,d)){a.effectTag|=2;B=!1;p=a;return}b(p,z)}p=a;z=k(d)}else a.effectTag|=2,B=!1,p=a}},prepareToHydrateHostInstance:function(a,b,c){b=v(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return l(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
p)return!1;if(!B)return d(a),B=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=z;c;)b(a,c),c=g(c);d(a);z=p?g(a.stateNode):null;return!0}}}
function hf(a){function b(a,b,c){a=a.stateNode;a.__reactInternalMemoizedUnmaskedChildContext=b;a.__reactInternalMemoizedMaskedChildContext=c}function c(a){return 2===a.tag&&null!=a.type.childContextTypes}function d(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:D("108",Ac(a)||"Unknown",e);return A({},b,c)}var e=a.createCursor,f=a.push,h=a.pop,g=e(ka),k=e(!1),v=ka;return{getUnmaskedContext:function(a){return c(a)?
v:g.current},cacheContext:b,getMaskedContext:function(a,c){var d=a.type.contextTypes;if(!d)return ka;var e=a.stateNode;if(e&&e.__reactInternalMemoizedUnmaskedChildContext===c)return e.__reactInternalMemoizedMaskedChildContext;var f={},g;for(g in d)f[g]=c[g];e&&b(a,c,f);return f},hasContextChanged:function(){return k.current},isContextConsumer:function(a){return 2===a.tag&&null!=a.type.contextTypes},isContextProvider:c,popContextProvider:function(a){c(a)&&(h(k,a),h(g,a))},popTopLevelContextObject:function(a){h(k,
a);h(g,a)},pushTopLevelContextObject:function(a,b,c){null!=g.cursor?D("168"):void 0;f(g,b,a);f(k,c,a)},processChildContext:d,pushContextProvider:function(a){if(!c(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ka;v=g.current;f(g,b,a);f(k,k.current,a);return!0},invalidateContextProvider:function(a,b){var c=a.stateNode;c?void 0:D("169");if(b){var e=d(a,v);c.__reactInternalMemoizedMergedChildContext=e;h(k,a);h(g,a);f(g,e,a)}else h(k,a);f(k,b,a)},findCurrentUnmaskedContext:function(a){for(2!==
xd(a)||2!==a.tag?D("170"):void 0;3!==a.tag;){if(c(a))return a.stateNode.__reactInternalMemoizedMergedChildContext;(a=a["return"])?void 0:D("171")}return a.stateNode.context}}}
function jf(a){var b=a.createCursor,c=a.push,d=a.pop,e=b(null),f=b(null),h=b(0);return{pushProvider:function(a){var b=a.type._context;c(h,b._changedBits,a);c(f,b._currentValue,a);c(e,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode},popProvider:function(a){var b=h.current,c=f.current;d(e,a);d(f,a);d(h,a);a=a.type._context;a._currentValue=c;a._changedBits=b}}}
function kf(){var a=[],b=-1;return{createCursor:function(a){return{current:a}},isEmpty:function(){return-1===b},pop:function(c){0>b||(c.current=a[b],a[b]=null,b--)},push:function(c,d){b++;a[b]=c.current;c.current=d},checkThatStackIsEmpty:function(){},resetStackAfterFatalErrorInDev:function(){}}}
function lf(a){function b(){if(null!==I)for(var a=I["return"];null!==a;)Lc(a),a=a["return"];Ya=null;Z=0;I=null;Nc=!1}function c(a){return null!==ya&&ya.has(a)}function d(a){for(;;){var b=a.alternate,c=a["return"],d=a.sibling;if(0===(a.effectTag&512)){b=Cb(b,a,Z);var e=a;if(1073741823===Z||1073741823!==e.expirationTime){b:switch(e.tag){case 3:case 2:var f=e.updateQueue;f=null===f?0:f.expirationTime;break b;default:f=0}for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=
g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{Nc=!0;break}}else{a=Kc(a);if(null!==a)return a.effectTag&=2559,a;null!==c&&(c.firstEffect=c.lastEffect=
null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}function e(a){var b=Wa(a.alternate,a,Z);null===b&&(b=d(a));nc.current=null;return b}function f(a,c,f){ca?D("243"):void 0;ca=!0;if(c!==Z||a!==Ya||null===I)b(),Ya=a,Z=c,I=ze(Ya.current,null,Z),a.pendingCommitExpirationTime=0;var g=!1;do{try{if(f)for(;null!==I&&!S();)I=e(I);else for(;null!==I;)I=e(I)}catch(Oc){if(null===I){g=!0;q(Oc);break}f=I;var h=f["return"];if(null===h){g=!0;q(Oc);break}Jc(h,f,Oc);I=d(f)}break}while(1);
ca=!1;if(g||null!==I)return null;if(Nc)return a.pendingCommitExpirationTime=c,a.current.alternate;D("262")}function h(a,b,c,d){a={value:c,source:a,stack:Bc(a)};Pe(b,{expirationTime:d,partialState:null,callback:null,isReplace:!1,isForced:!1,capturedValue:a,next:null});v(b,d)}function g(a,b){a:{ca&&!Za?D("263"):void 0;for(var d=a["return"];null!==d;){switch(d.tag){case 2:var e=d.stateNode;if("function"===typeof d.type.getDerivedStateFromCatch||"function"===typeof e.componentDidCatch&&!c(e)){h(a,d,b,
1);a=void 0;break a}break;case 3:h(a,d,b,1);a=void 0;break a}d=d["return"]}3===a.tag&&h(a,a,b,1);a=void 0}return a}function k(a){a=0!==ia?ia:ca?Za?1:Z:a.mode&1?za?10*(((l()+15)/10|0)+1):25*(((l()+500)/25|0)+1):1;za&&(0===da||a>da)&&(da=a);return a}function v(a,c){a:{for(;null!==a;){if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>c)&&(a.alternate.expirationTime=c);if(null===a["return"])if(3===a.tag){var d=
a.stateNode;!ca&&0!==Z&&c<Z&&b();ca&&!Za&&Ya===d||B(d,c);Fb>xg&&D("185")}else{c=void 0;break a}a=a["return"]}c=void 0}return c}function l(){ye=Ic()-Pc;return yg=(ye/10|0)+2}function p(a,b,c,d,e){var f=ia;ia=1;try{return a(b,c,d,e)}finally{ia=f}}function z(a){if(0!==Gb){if(a>Gb)return;mg(Qc)}var b=Ic()-Pc;Gb=a;Qc=lg(Q,{timeout:10*(a-2)-b})}function B(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===K?(la=K=a,a.nextScheduledRoot=a):(K=K.nextScheduledRoot=a,K.nextScheduledRoot=la);
else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}T||(J?Hb&&(aa=a,P=1,G(a,1,!1)):1===b?n():z(b))}function r(){var a=0,b=null;if(null!==K)for(var c=K,d=la;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===K?D("244"):void 0;if(d===d.nextScheduledRoot){la=K=d.nextScheduledRoot=null;break}else if(d===la)la=e=d.nextScheduledRoot,K.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===K){K=c;K.nextScheduledRoot=la;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=
d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===K)break;c=d;d=d.nextScheduledRoot}}c=aa;null!==c&&c===b&&1===a?Fb++:Fb=0;aa=b;P=a}function Q(a){x(0,!0,a)}function n(){x(1,!1,null)}function x(a,b,c){$a=c;r();if(b)for(;null!==aa&&0!==P&&(0===a||a>=P)&&(!Ib||l()>=P);)G(aa,P,!Ib),r();else for(;null!==aa&&0!==P&&(0===a||a>=P);)G(aa,P,!1),r();null!==$a&&(Gb=0,Qc=-1);0!==P&&z(P);$a=null;Ib=!1;Y()}function Y(){Fb=0;if(null!==Aa){var a=Aa;Aa=null;for(var b=
0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(wg){Ba||(Ba=!0,Jb=wg)}}}if(Ba)throw a=Jb,Jb=null,Ba=!1,a;}function G(a,b,c){T?D("245"):void 0;T=!0;c?(c=a.finishedWork,null!==c?R(a,c,b):(a.finishedWork=null,c=f(a,b,!0),null!==c&&(S()?a.finishedWork=c:R(a,c,b)))):(c=a.finishedWork,null!==c?R(a,c,b):(a.finishedWork=null,c=f(a,b,!1),null!==c&&R(a,c,b)));T=!1}function R(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Aa?Aa=[d]:Aa.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=
0;return}a.finishedWork=null;Za=ca=!0;c=b.stateNode;c.current===b?D("177"):void 0;d=c.pendingCommitExpirationTime;0===d?D("261"):void 0;c.pendingCommitExpirationTime=0;var e=l();nc.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var f=b.firstEffect}else f=b;else f=b.firstEffect;zg(c.containerInfo);for(w=f;null!==w;){var h=!1,k=void 0;try{for(;null!==w;)w.effectTag&2048&&Db(w.alternate,w),w=w.nextEffect}catch(ab){h=!0,k=ab}h&&(null===w?D("178"):void 0,g(w,k),null!==
w&&(w=w.nextEffect))}for(w=f;null!==w;){h=!1;k=void 0;try{for(;null!==w;){var p=w.effectTag;p&16&&Mc(w);if(p&128){var n=w.alternate;null!==n&&kg(n)}switch(p&14){case 2:Eb(w);w.effectTag&=-3;break;case 6:Eb(w);w.effectTag&=-3;we(w.alternate,w);break;case 4:we(w.alternate,w);break;case 8:gg(w)}w=w.nextEffect}}catch(ab){h=!0,k=ab}h&&(null===w?D("178"):void 0,g(w,k),null!==w&&(w=w.nextEffect))}Ag(c.containerInfo);c.current=b;for(w=f;null!==w;){p=!1;n=void 0;try{for(f=c,h=e,k=d;null!==w;){var r=w.effectTag;
r&36&&hg(f,w.alternate,w,h,k);r&256&&ig(w,q);r&128&&jg(w);var t=w.nextEffect;w.nextEffect=null;w=t}}catch(ab){p=!0,n=ab}p&&(null===w?D("178"):void 0,g(w,n),null!==w&&(w=w.nextEffect))}ca=Za=!1;"function"===typeof Ie&&Ie(b.stateNode);b=c.current.expirationTime;0===b&&(ya=null);a.remainingExpirationTime=b}function S(){return null===$a||$a.timeRemaining()>Bg?!1:Ib=!0}function q(a){null===aa?D("246"):void 0;aa.remainingExpirationTime=0;Ba||(Ba=!0,Jb=a)}var u=kf(),t=ff(a,u),y=hf(u);u=jf(u);var H=gf(a),
Wa=$e(a,t,y,u,H,v,k).beginWork,Cb=af(a,t,y,u,H).completeWork;t=bf(t,y,u,v,c);var Jc=t.throwException,Kc=t.unwindWork,Lc=t.unwindInterruptedWork;t=df(a,g,v,k,function(a){null===ya?ya=new Set([a]):ya.add(a)},l);var Db=t.commitBeforeMutationLifeCycles,Mc=t.commitResetTextContent,Eb=t.commitPlacement,gg=t.commitDeletion,we=t.commitWork,hg=t.commitLifeCycles,ig=t.commitErrorLogging,jg=t.commitAttachRef,kg=t.commitDetachRef,Ic=a.now,lg=a.scheduleDeferredCallback,mg=a.cancelDeferredCallback,zg=a.prepareForCommit,
Ag=a.resetAfterCommit,Pc=Ic(),yg=2,ye=Pc,Rc=0,ia=0,ca=!1,I=null,Ya=null,Z=0,w=null,Za=!1,Nc=!1,ya=null,la=null,K=null,Gb=0,Qc=-1,T=!1,aa=null,P=0,da=0,Ib=!1,Ba=!1,Jb=null,$a=null,J=!1,Hb=!1,za=!1,Aa=null,xg=1E3,Fb=0,Bg=1;return{recalculateCurrentTime:l,computeExpirationForFiber:k,scheduleWork:v,requestWork:B,flushRoot:function(a,b){T?D("253"):void 0;aa=a;P=b;G(a,b,!1);n();Y()},batchedUpdates:function(a,b){var c=J;J=!0;try{return a(b)}finally{(J=c)||T||n()}},unbatchedUpdates:function(a,b){if(J&&!Hb){Hb=
!0;try{return a(b)}finally{Hb=!1}}return a(b)},flushSync:function(a,b){T?D("187"):void 0;var c=J;J=!0;try{return p(a,b)}finally{J=c,n()}},flushControlled:function(a){var b=J;J=!0;try{p(a)}finally{(J=b)||T||x(1,!1,null)}},deferredUpdates:function(a){var b=ia;ia=25*(((l()+500)/25|0)+1);try{return a()}finally{ia=b}},syncUpdates:p,interactiveUpdates:function(a,b,c){if(za)return a(b,c);J||T||0===da||(x(da,!1,null),da=0);var d=za,e=J;J=za=!0;try{return a(b,c)}finally{za=d,(J=e)||T||n()}},flushInteractiveUpdates:function(){T||
0===da||(x(da,!1,null),da=0)},computeUniqueAsyncExpiration:function(){var a=25*(((l()+500)/25|0)+1);a<=Rc&&(a=Rc+1);return Rc=a},legacyContext:y}}
function mf(a){function b(a,b,c,d,e,h){d=b.current;if(c){c=c._reactInternalFiber;var l=g(c);c=k(c)?v(c,l):l}else c=ka;null===b.context?b.context=c:b.pendingContext=c;b=h;Pe(d,{expirationTime:e,partialState:{element:a},callback:void 0===b?null:b,isReplace:!1,isForced:!1,capturedValue:null,next:null});f(d,e);return e}var c=a.getPublicInstance;a=lf(a);var d=a.recalculateCurrentTime,e=a.computeExpirationForFiber,f=a.scheduleWork,h=a.legacyContext,g=h.findCurrentUnmaskedContext,k=h.isContextProvider,v=
h.processChildContext;return{createContainer:function(a,b,c){b=new xe(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a},updateContainer:function(a,c,f,h){var g=c.current,k=d();g=e(g);return b(a,c,f,k,g,h)},updateContainerAtExpirationTime:function(a,c,e,f,g){var h=d();return b(a,c,e,h,f,g)},flushRoot:a.flushRoot,
requestWork:a.requestWork,computeUniqueAsyncExpiration:a.computeUniqueAsyncExpiration,batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,syncUpdates:a.syncUpdates,interactiveUpdates:a.interactiveUpdates,flushInteractiveUpdates:a.flushInteractiveUpdates,flushControlled:a.flushControlled,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},
findHostInstance:function(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?D("188"):D("268",Object.keys(a)));a=Bd(b);return null===a?null:a.stateNode},findHostInstanceWithNoPortals:function(a){a=Cd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var b=a.findFiberByHostInstance;return He(A({},a,{findHostInstanceByFiber:function(a){a=Bd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}}}
var nf=Object.freeze({default:mf}),of=nf&&mf||nf,pf=of["default"]?of["default"]:of;function qf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:rc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var rf="object"===typeof performance&&"function"===typeof performance.now,sf=void 0;sf=rf?function(){return performance.now()}:function(){return Date.now()};var tf=void 0,uf=void 0;
if(m.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var vf=null,wf=!1,xf=-1,yf=!1,zf=0,Af=33,Bf=33,Cf=void 0;Cf=rf?{didTimeout:!1,timeRemaining:function(){var a=zf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=zf-Date.now();return 0<a?a:0}};var Df="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Df){wf=!1;a=sf();if(0>=zf-a)if(-1!==
xf&&xf<=a)Cf.didTimeout=!0;else{yf||(yf=!0,requestAnimationFrame(Ef));return}else Cf.didTimeout=!1;xf=-1;a=vf;vf=null;null!==a&&a(Cf)}},!1);var Ef=function(a){yf=!1;var b=a-zf+Bf;b<Bf&&Af<Bf?(8>b&&(b=8),Bf=b<Af?Af:b):Af=b;zf=a+Bf;wf||(wf=!0,window.postMessage(Df,"*"))};tf=function(a,b){vf=a;null!=b&&"number"===typeof b.timeout&&(xf=sf()+b.timeout);yf||(yf=!0,requestAnimationFrame(Ef));return 0};uf=function(){vf=null;wf=!1;xf=-1}}else tf=window.requestIdleCallback,uf=window.cancelIdleCallback;else tf=
function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity},didTimeout:!1})})},uf=function(a){clearTimeout(a)};function Ff(a){var b="";ea.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function Gf(a,b){a=A({children:void 0},b);if(b=Ff(b.children))a.children=b;return a}
function Hf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function If(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Jf(a,b){null!=b.dangerouslySetInnerHTML?D("91"):void 0;return A({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Kf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?D("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:D("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Lf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Mf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Nf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Of(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Pf(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Of(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Qf=void 0,Rf=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Nf.svg||"innerHTML"in a)a.innerHTML=b;else{Qf=Qf||document.createElement("div");Qf.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=Qf.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Sf(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var Tf={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Uf=["Webkit","ms","Moz","O"];Object.keys(Tf).forEach(function(a){Uf.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Tf[b]=Tf[a]})});
function Vf(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Tf.hasOwnProperty(e)&&Tf[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Wf=A({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Xf(a,b,c){b&&(Wf[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?D("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?D("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:D("61")),null!=b.style&&"object"!==typeof b.style?D("62",c()):void 0)}
function Yf(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Zf=C.thatReturns("");
function $f(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=ke(a);b=va[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?Zd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(Zd("topFocus","focus",a),Zd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(ic("cancel",!0)&&Zd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(ic("close",!0)&&Zd("topClose","close",a),c.topClose=!0):fe.hasOwnProperty(e)&&W(e,fe[e],a),c[e]=!0)}}
function ag(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Nf.html&&(d=Of(a));d===Nf.html?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function bg(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function cg(a,b,c,d){var e=Yf(b,c);switch(b){case "iframe":case "object":W("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in ge)ge.hasOwnProperty(f)&&W(f,ge[f],a);f=c;break;case "source":W("topError","error",a);f=c;break;case "img":case "image":case "link":W("topError","error",a);W("topLoad","load",a);f=c;break;case "form":W("topReset","reset",a);W("topSubmit","submit",a);f=c;break;case "details":W("topToggle","toggle",a);f=c;break;case "input":Wc(a,c);f=Vc(a,c);W("topInvalid",
"invalid",a);$f(d,"onChange");break;case "option":f=Gf(a,c);break;case "select":If(a,c);f=A({},c,{value:void 0});W("topInvalid","invalid",a);$f(d,"onChange");break;case "textarea":Kf(a,c);f=Jf(a,c);W("topInvalid","invalid",a);$f(d,"onChange");break;default:f=c}Xf(b,f,Zf);var h=f,g;for(g in h)if(h.hasOwnProperty(g)){var k=h[g];"style"===g?Vf(a,k,Zf):"dangerouslySetInnerHTML"===g?(k=k?k.__html:void 0,null!=k&&Rf(a,k)):"children"===g?"string"===typeof k?("textarea"!==b||""!==k)&&Sf(a,k):"number"===typeof k&&
Sf(a,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(ua.hasOwnProperty(g)?null!=k&&$f(d,g):null!=k&&Uc(a,g,k,e))}switch(b){case "input":lc(a);ad(a,c);break;case "textarea":lc(a);Mf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Hf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Hf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=C)}}
function dg(a,b,c,d,e){var f=null;switch(b){case "input":c=Vc(a,c);d=Vc(a,d);f=[];break;case "option":c=Gf(a,c);d=Gf(a,d);f=[];break;case "select":c=A({},c,{value:void 0});d=A({},d,{value:void 0});f=[];break;case "textarea":c=Jf(a,c);d=Jf(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}Xf(b,d,Zf);b=a=void 0;var h=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var g=c[a];for(b in g)g.hasOwnProperty(b)&&(h||
(h={}),h[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ua.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];g=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==g&&(null!=k||null!=g))if("style"===a)if(g){for(b in g)!g.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(h||(h={}),h[b]="");for(b in k)k.hasOwnProperty(b)&&g[b]!==k[b]&&(h||(h={}),h[b]=k[b])}else h||(f||(f=[]),f.push(a,h)),
h=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,g=g?g.__html:void 0,null!=k&&g!==k&&(f=f||[]).push(a,""+k)):"children"===a?g===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ua.hasOwnProperty(a)?(null!=k&&$f(e,a),f||g===k||(f=[])):(f=f||[]).push(a,k))}h&&(f=f||[]).push("style",h);return f}
function eg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Yc(a,e);Yf(c,d);d=Yf(c,e);for(var f=0;f<b.length;f+=2){var h=b[f],g=b[f+1];"style"===h?Vf(a,g,Zf):"dangerouslySetInnerHTML"===h?Rf(a,g):"children"===h?Sf(a,g):Uc(a,h,g,d)}switch(c){case "input":Zc(a,e);break;case "textarea":Lf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Hf(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
Hf(a,!!e.multiple,e.defaultValue,!0):Hf(a,!!e.multiple,e.multiple?[]:"",!1))}}
function fg(a,b,c,d,e){switch(b){case "iframe":case "object":W("topLoad","load",a);break;case "video":case "audio":for(var f in ge)ge.hasOwnProperty(f)&&W(f,ge[f],a);break;case "source":W("topError","error",a);break;case "img":case "image":case "link":W("topError","error",a);W("topLoad","load",a);break;case "form":W("topReset","reset",a);W("topSubmit","submit",a);break;case "details":W("topToggle","toggle",a);break;case "input":Wc(a,c);W("topInvalid","invalid",a);$f(e,"onChange");break;case "select":If(a,
c);W("topInvalid","invalid",a);$f(e,"onChange");break;case "textarea":Kf(a,c),W("topInvalid","invalid",a),$f(e,"onChange")}Xf(b,c,Zf);d=null;for(var h in c)c.hasOwnProperty(h)&&(f=c[h],"children"===h?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):ua.hasOwnProperty(h)&&null!=f&&$f(e,h));switch(b){case "input":lc(a);ad(a,c);break;case "textarea":lc(a);Mf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
(a.onclick=C)}return d}function ng(a,b){return a.nodeValue!==b}
var og=Object.freeze({createElement:ag,createTextNode:bg,setInitialProperties:cg,diffProperties:dg,updateProperties:eg,diffHydratedProperties:fg,diffHydratedText:ng,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Zc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Xa(d);e?void 0:D("90");mc(d);Zc(d,e)}}}break;case "textarea":Lf(a,c);break;case "select":b=c.value,null!=b&&Hf(a,!!c.multiple,b,!1)}}});Tb.injectFiberControlledHostComponent(og);var pg=null,qg=null;
function rg(a){this._expirationTime=X.computeUniqueAsyncExpiration();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}rg.prototype.render=function(a){this._defer?void 0:D("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new sg;X.updateContainerAtExpirationTime(a,b,null,c,d._onCommit);return d};
rg.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
rg.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:D("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?D("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;X.flushRoot(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};rg.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function sg(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}sg.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
sg.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?D("191",c):void 0;c()}}};function tg(a,b,c){this._internalRoot=X.createContainer(a,b,c)}tg.prototype.render=function(a,b){var c=this._internalRoot,d=new sg;b=void 0===b?null:b;null!==b&&d.then(b);X.updateContainer(a,c,null,d._onCommit);return d};
tg.prototype.unmount=function(a){var b=this._internalRoot,c=new sg;a=void 0===a?null:a;null!==a&&c.then(a);X.updateContainer(null,b,null,c._onCommit);return c};tg.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new sg;c=void 0===c?null:c;null!==c&&e.then(c);X.updateContainer(b,d,a,e._onCommit);return e};
tg.prototype.createBatch=function(){var a=new rg(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function ug(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function vg(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
var X=pf({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:Pf(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=Pf(a,b)}return a},getChildHostContext:function(a,b){return Pf(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){pg=Vd;var a=fa();if(ne(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(B){b=null;break a}var f=0,h=-1,g=-1,k=0,v=0,l=a,p=null;b:for(;;){for(var z;;){l!==b||0!==d&&3!==l.nodeType||(h=f+d);l!==e||0!==c&&3!==l.nodeType||(g=f+c);3===l.nodeType&&(f+=l.nodeValue.length);if(null===(z=l.firstChild))break;p=l;l=z}for(;;){if(l===a)break b;p===b&&++k===d&&(h=f);p===e&&++v===c&&(g=f);if(null!==(z=l.nextSibling))break;l=p;p=l.parentNode}l=z}b=-1===h||-1===g?null:
{start:h,end:g}}else b=null}b=b||{start:0,end:0}}else b=null;qg={focusedElem:a,selectionRange:b};Wd(!1)},resetAfterCommit:function(){var a=qg,b=fa(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&ja(document.documentElement,c)){if(ne(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[mb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
d&&(e=d,d=a,a=e);e=me(c,a);var f=me(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var h=document.createRange();h.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(h),b.extend(f.node,f.offset)):(h.setEnd(f.node,f.offset),b.addRange(h))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,
a.element.scrollTop=a.top}qg=null;Wd(pg);pg=null},createInstance:function(a,b,c,d,e){a=ag(a,b,c,d);a[F]=e;a[Ta]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){cg(a,b,c,d);return vg(b,c)},prepareUpdate:function(a,b,c,d,e){return dg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===
typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=bg(a,b);a[F]=d;return a},now:sf,mutation:{commitMount:function(a,b,c){vg(b,c)&&a.focus()},commitUpdate:function(a,b,c,d,e){a[Ta]=e;eg(a,b,c,d,e)},resetTextContent:function(a){Sf(a,"")},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},
insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=
a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[F]=f;a[Ta]=c;return fg(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[F]=c;return ng(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},
didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:tf,cancelDeferredCallback:uf}),Cg=X;ac=Cg.batchedUpdates;bc=Cg.interactiveUpdates;cc=Cg.flushInteractiveUpdates;
function Dg(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new tg(a,!1,b)}
function Eg(a,b,c,d,e){ug(c)?void 0:D("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var h=e;e=function(){var a=X.getPublicRootInstance(f._internalRoot);h.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Dg(c,d);if("function"===typeof e){var g=e;e=function(){var a=X.getPublicRootInstance(f._internalRoot);g.call(a)}}X.unbatchedUpdates(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return X.getPublicRootInstance(f._internalRoot)}
function Fg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;ug(b)?void 0:D("200");return qf(a,b,null,c)}
var Gg={createPortal:Fg,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:X.findHostInstance(a)},hydrate:function(a,b,c){return Eg(null,a,b,!0,c)},render:function(a,b,c){return Eg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?D("38"):void 0;return Eg(a,b,c,!1,d)},unmountComponentAtNode:function(a){ug(a)?void 0:D("40");return a._reactRootContainer?(X.unbatchedUpdates(function(){Eg(null,null,a,!1,function(){a._reactRootContainer=
null})}),!0):!1},unstable_createPortal:function(){return Fg.apply(void 0,arguments)},unstable_batchedUpdates:X.batchedUpdates,unstable_deferredUpdates:X.deferredUpdates,flushSync:X.flushSync,unstable_flushControlled:X.flushControlled,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ra,EventPluginRegistry:Ca,EventPropagators:kb,ReactControlledComponent:$b,ReactDOMComponentTree:bb,ReactDOMEventListener:$d},unstable_createRoot:function(a,b){return new tg(a,!0,null!=b&&!0===b.hydrate)}};
X.injectIntoDevTools({findFiberByHostInstance:Ua,bundleType:0,version:"16.3.2",rendererPackageName:"react-dom"});var Hg=Object.freeze({default:Gg}),Ig=Hg&&Gg||Hg;module.exports=Ig["default"]?Ig["default"]:Ig;


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(663);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(664);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(246);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(180);
var invariant = __webpack_require__(179);
var ReactPropTypesSecret = __webpack_require__(667);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(688);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(348);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(677);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(675);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(67)))

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(344);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(679);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 681 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(346);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(347);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(348);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(349);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(689);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(246);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__(359);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ConnectedRouter = function (_Component) {
  _inherits(ConnectedRouter, _Component);

  function ConnectedRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, ConnectedRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleLocationChange = function (location) {
      _this.store.dispatch({
        type: __WEBPACK_IMPORTED_MODULE_3__reducer__["a" /* LOCATION_CHANGE */],
        payload: location
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ConnectedRouter.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        propsStore = _props.store,
        history = _props.history,
        isSSR = _props.isSSR;

    this.store = propsStore || this.context.store;
    this.handleLocationChange(history.location);

    if (!isSSR) this.unsubscribeFromHistory = history.listen(this.handleLocationChange);
  };

  ConnectedRouter.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeFromHistory) this.unsubscribeFromHistory();
  };

  ConnectedRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Router */], this.props);
  };

  return ConnectedRouter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ConnectedRouter.propTypes = {
  store: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  isSSR: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
ConnectedRouter.contextTypes = {
  store: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (ConnectedRouter);

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(102);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(148);

var _LocationUtils = __webpack_require__(249);

var _createTransitionManager = __webpack_require__(250);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(693);
/* unused harmony reexport createBrowserHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(694);
/* unused harmony reexport createHashHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(695);
/* unused harmony reexport createMemoryHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(182);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(149);
/* unused harmony reexport parsePath */
/* unused harmony reexport createPath */










/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(355);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createBrowserHistory);

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(355);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createHashHistory);

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(251);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createMemoryHistory);

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(697)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 697 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getLocation */
/* unused harmony export createMatchSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(147);


var getLocation = function getLocation(state) {
  return state.router.location;
};

var createMatchSelector = function createMatchSelector(path) {
  var lastPathname = null;
  var lastMatch = null;
  return function (state) {
    var _ref = getLocation(state) || {},
        pathname = _ref.pathname;

    if (pathname === lastPathname) {
      return lastMatch;
    }
    lastPathname = pathname;
    var match = Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["b" /* matchPath */])(pathname, path);
    if (!match || !lastMatch || match.url !== lastMatch.url) {
      lastMatch = match;
    }
    return lastMatch;
  };
};

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = routerMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(360);


/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* CALL_HISTORY_METHOD */]) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, args);
      };
    };
  };
}

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function createBroadcast (initialState) {
  var listeners = {};
  var id = 1;
  var _state = initialState;

  function getState () {
    return _state
  }

  function setState (state) {
    _state = state;
    var keys = Object.keys(listeners);
    var i = 0;
    var len = keys.length;
    for (; i < len; i++) {
      // if a listener gets unsubscribed during setState we just skip it
      if (listeners[keys[i]]) { listeners[keys[i]](state); }
    }
  }

  // subscribe to changes and return the subscriptionId
  function subscribe (listener) {
    if (typeof listener !== 'function') {
      throw new Error('listener must be a function.')
    }
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    return currentId
  }

  // remove subscription by removing the listener function
  function unsubscribe (id) {
    listeners[id] = undefined;
  }

  return { getState: getState, setState: setState, subscribe: subscribe, unsubscribe: unsubscribe }
}

/* harmony default export */ __webpack_exports__["default"] = (createBroadcast);


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(__webpack_require__(117));

var _reactIs = __webpack_require__(361);

/**
 * A factory that returns a propTypes validator that only accepts values that
 * are also accepted by React.createElement
 * e.g. "div", functional, class components, forwardRef etc.
 *
 * @param {boolean} isRequired If `true` returns a validator
 *                             that will throw if nullish values are passed
 */
function createComponentProp(isRequired) {
  /* istanbul ignore if */
  if (true) {
    return function () {
      return null;
    };
  }

  return function componentPropType(props, key, componentName, location, propFullName) {
    var prop = props[key];
    var propName = propFullName || key;
    var message;

    if (prop == null) {
      if (isRequired) {
        message = "The ".concat(location, " `").concat(propName, "` is marked as required in `").concat(componentName, "`, ") + "but its value is `".concat((0, _typeof2.default)(prop), "`.");
      }
    } else if (!(0, _reactIs.isValidElementType)(prop)) {
      var preciseType = (0, _typeof2.default)(prop);
      message = "Invalid ".concat(location, " `").concat(propName, "` of type `").concat(preciseType, "` ") + "supplied to `".concat(componentName, "`, expected a component.");
    }

    if (message != null) {
      // change error message slightly on every check to prevent caching when testing
      // which would not trigger console errors on subsequent fails
      return new Error("".concat(message).concat( false ? Date.now() : ''));
    }

    return null;
  };
}

var componentPropType = createComponentProp(false);
componentPropType.isRequired = createComponentProp(true);
var _default = componentPropType;
exports.default = _default;

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.3
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
exports.isSuspense=function(a){return t(a)===p};


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function chainPropTypes(propType1, propType2) {
  /* istanbul ignore if */
  if (true) {
    return function () {
      return null;
    };
  }

  return function validate() {
    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
  };
}

var _default = chainPropTypes;
exports.default = _default;

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.specialProperty = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _extends3 = _interopRequireDefault(__webpack_require__(3));

// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
// Only exported for test purposes.
var specialProperty = "exact-prop: \u200B";
exports.specialProperty = specialProperty;

function exactProp(propTypes) {
  /* istanbul ignore if */
  if (true) {
    return propTypes;
  }

  return (0, _extends3.default)({}, propTypes, (0, _defineProperty2.default)({}, specialProperty, function (props) {
    var unsupportedProps = Object.keys(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });

    if (unsupportedProps.length > 0) {
      return new Error("The following properties are not supported: ".concat(unsupportedProps.map(function (prop) {
        return "`".concat(prop, "`");
      }).join(', '), ". Please remove them."));
    }

    return null;
  }));
}

var _default = exactProp;
exports.default = _default;

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFunctionName = getFunctionName;
exports.default = void 0;
// Fork of recompose/getDisplayName with added IE 11 support
// Simplified polyfill for IE 11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;

function getFunctionName(fn) {
  var match = "".concat(fn).match(fnNameMatchRegex);
  var name = match && match[1];
  return name || '';
}

function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || getFunctionName(Component) || 'Component';
}

var _default = getDisplayName;
exports.default = _default;

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* eslint-disable */
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var _default = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();

exports.default = _default;

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _styles = __webpack_require__(18);

var _utils = __webpack_require__(14);

/* eslint-disable react/no-unused-prop-types */
var styles = function styles(theme) {
  return {
    '@global': {
      html: {
        WebkitFontSmoothing: 'antialiased',
        // Antialiasing.
        MozOsxFontSmoothing: 'grayscale',
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: 'border-box'
      },
      '*, *::before, *::after': {
        boxSizing: 'inherit'
      },
      body: {
        margin: 0,
        // Remove the margin in all browsers.
        backgroundColor: theme.palette.background.default,
        '@media print': {
          // Save printer ink.
          backgroundColor: theme.palette.common.white
        }
      }
    }
  };
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */


var CssBaseline =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CssBaseline, _React$Component);

  function CssBaseline() {
    (0, _classCallCheck2.default)(this, CssBaseline);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CssBaseline).apply(this, arguments));
  }

  (0, _createClass2.default)(CssBaseline, [{
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return CssBaseline;
}(_react.default.Component);

 false ? CssBaseline.propTypes = {
  /**
   * You can wrap a node.
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   */
  classes: _propTypes.default.object.isRequired
} : void 0;

if (false) {
  process.env.NODE_ENV !== "production" ? CssBaseline.propTypes = (0, _utils.exactProp)(CssBaseline.propTypes) : void 0;
}

CssBaseline.defaultProps = {
  children: null
};

var _default = (0, _styles.withStyles)(styles, {
  name: 'MuiCssBaseline'
})(CssBaseline);

exports.default = _default;

/***/ }),
/* 709 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



var isObject = __webpack_require__(711);

function isObjectObject(o) {
  return isObject(o) === true
    && Object.prototype.toString.call(o) === '[object Object]';
}

module.exports = function isPlainObject(o) {
  var ctor,prot;

  if (isObjectObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (typeof ctor !== 'function') return false;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObjectObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
};


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



module.exports = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createMixins;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _extends3 = _interopRequireDefault(__webpack_require__(3));

function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return (0, _extends3.default)({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (0, _extends3.default)({
        paddingLeft: spacing.unit * 2,
        paddingRight: spacing.unit * 2
      }, styles, (0, _defineProperty2.default)({}, breakpoints.up('sm'), (0, _extends3.default)({
        paddingLeft: spacing.unit * 3,
        paddingRight: spacing.unit * 3
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, (0, _defineProperty2.default)(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), (0, _defineProperty2.default)(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPalette;
exports.dark = exports.light = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _warning = _interopRequireDefault(__webpack_require__(27));

var _deepmerge = _interopRequireDefault(__webpack_require__(184));

var _indigo = _interopRequireDefault(__webpack_require__(364));

var _pink = _interopRequireDefault(__webpack_require__(365));

var _grey = _interopRequireDefault(__webpack_require__(366));

var _red = _interopRequireDefault(__webpack_require__(367));

var _common = _interopRequireDefault(__webpack_require__(368));

var _colorManipulator = __webpack_require__(81);

// < 1kb payload overhead when lodash/merge is > 3kb.
var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: _common.default.white,
    default: _grey.default[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.08)',
    hoverOpacity: 0.08,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.14)',
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)'
  }
};
exports.light = light;
var dark = {
  text: {
    primary: _common.default.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: _grey.default[800],
    default: '#303030'
  },
  action: {
    active: _common.default.white,
    hover: 'rgba(255, 255, 255, 0.1)',
    hoverOpacity: 0.1,
    selected: 'rgba(255, 255, 255, 0.2)',
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)'
  }
};
exports.dark = dark;

function addLightOrDark(intent, direction, shade, tonalOffset) {
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = (0, _colorManipulator.lighten)(intent.main, tonalOffset);
    } else if (direction === 'dark') {
      intent.dark = (0, _colorManipulator.darken)(intent.main, tonalOffset * 1.5);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === void 0 ? {
    light: _indigo.default[300],
    main: _indigo.default[500],
    dark: _indigo.default[700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === void 0 ? {
    light: _pink.default.A200,
    main: _pink.default.A400,
    dark: _pink.default.A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === void 0 ? {
    light: _red.default[300],
    main: _red.default[500],
    dark: _red.default[700]
  } : _palette$error,
      _palette$type = palette.type,
      type = _palette$type === void 0 ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
      other = (0, _objectWithoutProperties2.default)(palette, ["primary", "secondary", "error", "type", "contrastThreshold", "tonalOffset"]);

  function getContrastText(background) {
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    var contrastText = (0, _colorManipulator.getContrastRatio)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (false) {
      var contrast = (0, _colorManipulator.getContrastRatio)(background, contrastText);
      process.env.NODE_ENV !== "production" ? (0, _warning.default)(contrast >= 3, ["Material-UI: the contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WACG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n')) : void 0;
    }

    return contrastText;
  }

  function augmentColor(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (false) {
      throw new Error(['Material-UI: the color provided to augmentColor(color) is invalid.', "The color object needs to have a `main` property or a `".concat(mainShade, "` property.")].join('\n'));
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }

    return color;
  }

  augmentColor(primary);
  augmentColor(secondary, 'A400', 'A200', 'A700');
  augmentColor(error);
  var types = {
    dark: dark,
    light: light
  };
   false ? (0, _warning.default)(types[type], "Material-UI: the palette type `".concat(type, "` is not supported.")) : void 0;
  var paletteOutput = (0, _deepmerge.default)((0, _extends2.default)({
    // A collection of common colors.
    common: _common.default,
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: primary,
    // The colors used to represent secondary interface elements for a user.
    secondary: secondary,
    // The colors used to represent interface elements that the user should be made aware of.
    error: error,
    // The grey colors.
    grey: _grey.default,
    // Used by `getContrastText()` to maximize the contrast between the background and
    // the text.
    contrastThreshold: contrastThreshold,
    // Take a background color and return the color of the text to maximize the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other, {
    clone: false // No need to clone deep

  });
  return paletteOutput;
}

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createTypography;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _deepmerge = _interopRequireDefault(__webpack_require__(184));

var _warning = _interopRequireDefault(__webpack_require__(27));

var _utils = __webpack_require__(14);

// < 1kb payload overhead when lodash/merge is > 3kb.
function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

var caseAllCaps = {
  textTransform: 'uppercase'
};
var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      _ref$useNextVariants = _ref.useNextVariants,
      useNextVariants = _ref$useNextVariants === void 0 ? Boolean(_utils.ponyfillGlobal.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__) : _ref$useNextVariants,
      _ref$suppressWarning = _ref.suppressWarning,
      suppressWarning = _ref$suppressWarning === void 0 ? false : _ref$suppressWarning,
      allVariants = _ref.allVariants,
      other = (0, _objectWithoutProperties2.default)(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "htmlFontSize", "useNextVariants", "suppressWarning", "allVariants"]);

   false ? (0, _warning.default)(useNextVariants || suppressWarning, 'Material-UI: you are using the deprecated typography variants ' + 'that will be removed in the next major release.' + '\nPlease read the migration guide under https://material-ui.com/style/typography#migration-to-typography-v2') : void 0;
  var coef = fontSize / 14;

  var pxToRem = function pxToRem(size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };

  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
    return (0, _extends2.default)({
      color: palette.text.primary,
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontSize: pxToRem(size),
      // Unitless following http://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round(letterSpacing / size), "em")
    } : {}, casing, allVariants);
  };

  var nextVariants = {
    h1: buildVariant(fontWeightLight, 96, 1, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.04, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.17, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.33, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1Next: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2Next: buildVariant(fontWeightRegular, 14, 1.5, 0.15),
    buttonNext: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    captionNext: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  }; // To remove in v4

  var oldVariants = {
    display4: (0, _extends2.default)({
      fontSize: pxToRem(112),
      fontWeight: fontWeightLight,
      fontFamily: fontFamily,
      letterSpacing: '-.04em',
      lineHeight: "".concat(round(128 / 112), "em"),
      marginLeft: '-.04em',
      color: palette.text.secondary
    }, allVariants),
    display3: (0, _extends2.default)({
      fontSize: pxToRem(56),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      letterSpacing: '-.02em',
      lineHeight: "".concat(round(73 / 56), "em"),
      marginLeft: '-.02em',
      color: palette.text.secondary
    }, allVariants),
    display2: (0, _extends2.default)({
      fontSize: pxToRem(45),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(51 / 45), "em"),
      marginLeft: '-.02em',
      color: palette.text.secondary
    }, allVariants),
    display1: (0, _extends2.default)({
      fontSize: pxToRem(34),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(41 / 34), "em"),
      color: palette.text.secondary
    }, allVariants),
    headline: (0, _extends2.default)({
      fontSize: pxToRem(24),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(32.5 / 24), "em"),
      color: palette.text.primary
    }, allVariants),
    title: (0, _extends2.default)({
      fontSize: pxToRem(21),
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(24.5 / 21), "em"),
      color: palette.text.primary
    }, allVariants),
    subheading: (0, _extends2.default)({
      fontSize: pxToRem(16),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(24 / 16), "em"),
      color: palette.text.primary
    }, allVariants),
    body2: (0, _extends2.default)({
      fontSize: pxToRem(14),
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(24 / 14), "em"),
      color: palette.text.primary
    }, allVariants),
    body1: (0, _extends2.default)({
      fontSize: pxToRem(14),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(20.5 / 14), "em"),
      color: palette.text.primary
    }, allVariants),
    caption: (0, _extends2.default)({
      fontSize: pxToRem(12),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(16.5 / 12), "em"),
      color: palette.text.secondary
    }, allVariants),
    button: (0, _extends2.default)({
      fontSize: pxToRem(14),
      textTransform: 'uppercase',
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      color: palette.text.primary
    }, allVariants)
  };
  return (0, _deepmerge.default)((0, _extends2.default)({
    pxToRem: pxToRem,
    round: round,
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium
  }, oldVariants, nextVariants, useNextVariants ? {
    body1: nextVariants.body1Next,
    body2: nextVariants.body2Next,
    button: nextVariants.buttonNext,
    caption: nextVariants.captionNext
  } : {}, {
    useNextVariants: useNextVariants
  }), other, {
    clone: false // No need to clone deep

  });
}

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
}

var shadows = ['none', createShadow(0, 1, 3, 0, 0, 1, 1, 0, 0, 2, 1, -1), createShadow(0, 1, 5, 0, 0, 2, 2, 0, 0, 3, 1, -2), createShadow(0, 1, 8, 0, 0, 3, 4, 0, 0, 3, 3, -2), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
var _default = shadows;
exports.default = _default;

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var shape = {
  borderRadius: 4
};
var _default = shape;
exports.default = _default;

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var spacing = {
  // All components align to an 8dp square baseline grid for mobile, tablet, and desktop.
  // https://material.io/design/layout/understanding-layout.html#pixel-density
  unit: 8
};
var _default = spacing;
exports.default = _default;

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
var _default = zIndex;
exports.default = _default;

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports['default'] = jssGlobal;

var _jss = __webpack_require__(370);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var propKey = '@global';
var prefixKey = '@global ';

var GlobalContainerRule = function () {
  function GlobalContainerRule(key, styles, options) {
    _classCallCheck(this, GlobalContainerRule);

    this.type = 'global';

    this.key = key;
    this.options = options;
    this.rules = new _jss.RuleList(_extends({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector], { selector: selector });
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */


  _createClass(GlobalContainerRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      return this.rules.toString();
    }
  }]);

  return GlobalContainerRule;
}();

var GlobalPrefixedRule = function () {
  function GlobalPrefixedRule(name, style, options) {
    _classCallCheck(this, GlobalPrefixedRule);

    this.name = name;
    this.options = options;
    var selector = name.substr(prefixKey.length);
    this.rule = options.jss.createRule(selector, style, _extends({}, options, {
      parent: this,
      selector: selector
    }));
  }

  _createClass(GlobalPrefixedRule, [{
    key: 'toString',
    value: function toString(options) {
      return this.rule.toString(options);
    }
  }]);

  return GlobalPrefixedRule;
}();

var separatorRegExp = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';
  for (var i = 0; i < parts.length; i++) {
    scoped += scope + ' ' + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }
  return scoped;
}

function handleNestedGlobalContainerRule(rule) {
  var options = rule.options,
      style = rule.style;

  var rules = style[propKey];

  if (!rules) return;

  for (var name in rules) {
    options.sheet.addRule(name, rules[name], _extends({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[propKey];
}

function handlePrefixedGlobalRule(rule) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop.substr(0, propKey.length) !== propKey) continue;

    var selector = addScope(prop.substr(propKey.length), rule.selector);
    options.sheet.addRule(selector, style[prop], _extends({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (name === propKey) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, prefixKey.length) === prefixKey) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;


    if (parent) {
      if (parent.type === 'global' || parent.options.parent.type === 'global') {
        options.global = true;
      }
    }

    if (options.global) options.selector = name;

    return null;
  }

  function onProcessRule(rule) {
    if (rule.type !== 'style') return;

    handleNestedGlobalContainerRule(rule);
    handlePrefixedGlobalRule(rule);
  }

  return { onCreateRule: onCreateRule, onProcessRule: onProcessRule };
}

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = getDynamicStyles;
/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);
      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(134);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 */
var SheetsManager = function () {
  function SheetsManager() {
    _classCallCheck(this, SheetsManager);

    this.sheets = [];
    this.refs = [];
    this.keys = [];
  }

  _createClass(SheetsManager, [{
    key: 'get',
    value: function get(key) {
      var index = this.keys.indexOf(key);
      return this.sheets[index];
    }
  }, {
    key: 'add',
    value: function add(key, sheet) {
      var sheets = this.sheets,
          refs = this.refs,
          keys = this.keys;

      var index = sheets.indexOf(sheet);

      if (index !== -1) return index;

      sheets.push(sheet);
      refs.push(0);
      keys.push(key);

      return sheets.length - 1;
    }
  }, {
    key: 'manage',
    value: function manage(key) {
      var index = this.keys.indexOf(key);
      var sheet = this.sheets[index];
      if (this.refs[index] === 0) sheet.attach();
      this.refs[index]++;
      if (!this.keys[index]) this.keys.splice(index, 0, key);
      return sheet;
    }
  }, {
    key: 'unmanage',
    value: function unmanage(key) {
      var index = this.keys.indexOf(key);
      if (index === -1) {
        // eslint-ignore-next-line no-console
        (0, _warning2['default'])(false, "SheetsManager: can't find sheet to unmanage");
        return;
      }
      if (this.refs[index] > 0) {
        this.refs[index]--;
        if (this.refs[index] === 0) this.sheets[index].detach();
      }
    }
  }, {
    key: 'size',
    get: function get() {
      return this.keys.length;
    }
  }]);

  return SheetsManager;
}();

exports['default'] = SheetsManager;

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = cloneStyle;

var _isObservable = __webpack_require__(372);

var _isObservable2 = _interopRequireDefault(_isObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var isArray = Array.isArray;
function cloneStyle(style) {
  // Support empty values in case user ends up with them by accident.
  if (style == null) return style;

  // Support string value for SimpleRule.
  var typeOfStyle = typeof style === 'undefined' ? 'undefined' : _typeof(style);

  if (typeOfStyle === 'string' || typeOfStyle === 'number' || typeOfStyle === 'function') {
    return style;
  }

  // Support array for FontFaceRule.
  if (isArray(style)) return style.map(cloneStyle);

  // Support Observable styles.  Observables are immutable, so we don't need to
  // copy them.
  if ((0, _isObservable2['default'])(style)) return style;

  var newStyle = {};
  for (var name in style) {
    var value = style[name];
    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
      newStyle[name] = cloneStyle(value);
      continue;
    }
    newStyle[name] = value;
  }

  return newStyle;
}

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CSS = global.CSS;

var env = "production";

var escapeRegex = /([[\].#*$><+~=|^:(),"'`])/g;

exports['default'] = function (str) {
  // We don't need to escape it in production, because we are not using user's
  // input for selectors, we are generating a valid selector.
  if (env === 'production') return str;

  if (!CSS || !CSS.escape) {
    return str.replace(escapeRegex, '\\$1');
  }

  return CSS.escape(str);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(67)))

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (global[ns] == null) global[ns] = 0;

// Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
exports['default'] = global[ns]++;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(67)))

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isInBrowser = __webpack_require__(187);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _StyleSheet = __webpack_require__(375);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _PluginsRegistry = __webpack_require__(726);

var _PluginsRegistry2 = _interopRequireDefault(_PluginsRegistry);

var _rules = __webpack_require__(727);

var _rules2 = _interopRequireDefault(_rules);

var _observables = __webpack_require__(733);

var _observables2 = _interopRequireDefault(_observables);

var _functions = __webpack_require__(734);

var _functions2 = _interopRequireDefault(_functions);

var _sheets = __webpack_require__(258);

var _sheets2 = _interopRequireDefault(_sheets);

var _StyleRule = __webpack_require__(135);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createGenerateClassName = __webpack_require__(374);

var _createGenerateClassName2 = _interopRequireDefault(_createGenerateClassName);

var _createRule2 = __webpack_require__(186);

var _createRule3 = _interopRequireDefault(_createRule2);

var _DomRenderer = __webpack_require__(735);

var _DomRenderer2 = _interopRequireDefault(_DomRenderer);

var _VirtualRenderer = __webpack_require__(736);

var _VirtualRenderer2 = _interopRequireDefault(_VirtualRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultPlugins = _rules2['default'].concat([_observables2['default'], _functions2['default']]);

var instanceCounter = 0;

var Jss = function () {
  function Jss(options) {
    _classCallCheck(this, Jss);

    this.id = instanceCounter++;
    this.version = "9.8.7";
    this.plugins = new _PluginsRegistry2['default']();
    this.options = {
      createGenerateClassName: _createGenerateClassName2['default'],
      Renderer: _isInBrowser2['default'] ? _DomRenderer2['default'] : _VirtualRenderer2['default'],
      plugins: []
    };
    this.generateClassName = (0, _createGenerateClassName2['default'])();

    // eslint-disable-next-line prefer-spread
    this.use.apply(this, defaultPlugins);
    this.setup(options);
  }

  _createClass(Jss, [{
    key: 'setup',
    value: function setup() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (options.createGenerateClassName) {
        this.options.createGenerateClassName = options.createGenerateClassName;
        // $FlowFixMe
        this.generateClassName = options.createGenerateClassName();
      }

      if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
      if (options.virtual || options.Renderer) {
        this.options.Renderer = options.Renderer || (options.virtual ? _VirtualRenderer2['default'] : _DomRenderer2['default']);
      }

      // eslint-disable-next-line prefer-spread
      if (options.plugins) this.use.apply(this, options.plugins);

      return this;
    }

    /**
     * Create a Style Sheet.
     */

  }, {
    key: 'createStyleSheet',
    value: function createStyleSheet(styles) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var index = options.index;
      if (typeof index !== 'number') {
        index = _sheets2['default'].index === 0 ? 0 : _sheets2['default'].index + 1;
      }
      var sheet = new _StyleSheet2['default'](styles, _extends({}, options, {
        jss: this,
        generateClassName: options.generateClassName || this.generateClassName,
        insertionPoint: this.options.insertionPoint,
        Renderer: this.options.Renderer,
        index: index
      }));
      this.plugins.onProcessSheet(sheet);

      return sheet;
    }

    /**
     * Detach the Style Sheet and remove it from the registry.
     */

  }, {
    key: 'removeStyleSheet',
    value: function removeStyleSheet(sheet) {
      sheet.detach();
      _sheets2['default'].remove(sheet);
      return this;
    }

    /**
     * Create a rule without a Style Sheet.
     */

  }, {
    key: 'createRule',
    value: function createRule(name) {
      var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      // Enable rule without name for inline styles.
      if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
        options = style;
        style = name;
        name = undefined;
      }

      // Cast from RuleFactoryOptions to RuleOptions
      // https://stackoverflow.com/questions/41328728/force-casting-in-flow
      var ruleOptions = options;

      ruleOptions.jss = this;
      ruleOptions.Renderer = this.options.Renderer;
      if (!ruleOptions.generateClassName) ruleOptions.generateClassName = this.generateClassName;
      if (!ruleOptions.classes) ruleOptions.classes = {};
      var rule = (0, _createRule3['default'])(name, style, ruleOptions);

      if (!ruleOptions.selector && rule instanceof _StyleRule2['default']) {
        rule.selector = '.' + ruleOptions.generateClassName(rule);
      }

      this.plugins.onProcessRule(rule);

      return rule;
    }

    /**
     * Register plugin. Passed function will be invoked with a rule instance.
     */

  }, {
    key: 'use',
    value: function use() {
      var _this = this;

      for (var _len = arguments.length, plugins = Array(_len), _key = 0; _key < _len; _key++) {
        plugins[_key] = arguments[_key];
      }

      plugins.forEach(function (plugin) {
        // Avoids applying same plugin twice, at least based on ref.
        if (_this.options.plugins.indexOf(plugin) === -1) {
          _this.options.plugins.push(plugin);
          _this.plugins.use(plugin);
        }
      });

      return this;
    }
  }]);

  return Jss;
}();

exports['default'] = Jss;

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(134);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PluginsRegistry = function () {
  function PluginsRegistry() {
    _classCallCheck(this, PluginsRegistry);

    this.hooks = {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []

      /**
       * Call `onCreateRule` hooks and return an object if returned by a hook.
       */
    };
  }

  _createClass(PluginsRegistry, [{
    key: 'onCreateRule',
    value: function onCreateRule(name, decl, options) {
      for (var i = 0; i < this.hooks.onCreateRule.length; i++) {
        var rule = this.hooks.onCreateRule[i](name, decl, options);
        if (rule) return rule;
      }
      return null;
    }

    /**
     * Call `onProcessRule` hooks.
     */

  }, {
    key: 'onProcessRule',
    value: function onProcessRule(rule) {
      if (rule.isProcessed) return;
      var sheet = rule.options.sheet;

      for (var i = 0; i < this.hooks.onProcessRule.length; i++) {
        this.hooks.onProcessRule[i](rule, sheet);
      }

      // $FlowFixMe
      if (rule.style) this.onProcessStyle(rule.style, rule, sheet);

      rule.isProcessed = true;
    }

    /**
     * Call `onProcessStyle` hooks.
     */

  }, {
    key: 'onProcessStyle',
    value: function onProcessStyle(style, rule, sheet) {
      var nextStyle = style;

      for (var i = 0; i < this.hooks.onProcessStyle.length; i++) {
        nextStyle = this.hooks.onProcessStyle[i](nextStyle, rule, sheet);
        // $FlowFixMe
        rule.style = nextStyle;
      }
    }

    /**
     * Call `onProcessSheet` hooks.
     */

  }, {
    key: 'onProcessSheet',
    value: function onProcessSheet(sheet) {
      for (var i = 0; i < this.hooks.onProcessSheet.length; i++) {
        this.hooks.onProcessSheet[i](sheet);
      }
    }

    /**
     * Call `onUpdate` hooks.
     */

  }, {
    key: 'onUpdate',
    value: function onUpdate(data, rule, sheet) {
      for (var i = 0; i < this.hooks.onUpdate.length; i++) {
        this.hooks.onUpdate[i](data, rule, sheet);
      }
    }

    /**
     * Call `onChangeValue` hooks.
     */

  }, {
    key: 'onChangeValue',
    value: function onChangeValue(value, prop, rule) {
      var processedValue = value;
      for (var i = 0; i < this.hooks.onChangeValue.length; i++) {
        processedValue = this.hooks.onChangeValue[i](processedValue, prop, rule);
      }
      return processedValue;
    }

    /**
     * Register a plugin.
     * If function is passed, it is a shortcut for `{onProcessRule}`.
     */

  }, {
    key: 'use',
    value: function use(plugin) {
      for (var name in plugin) {
        if (this.hooks[name]) this.hooks[name].push(plugin[name]);else (0, _warning2['default'])(false, '[JSS] Unknown hook "%s".', name);
      }
    }
  }]);

  return PluginsRegistry;
}();

exports['default'] = PluginsRegistry;

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SimpleRule = __webpack_require__(728);

var _SimpleRule2 = _interopRequireDefault(_SimpleRule);

var _KeyframesRule = __webpack_require__(729);

var _KeyframesRule2 = _interopRequireDefault(_KeyframesRule);

var _ConditionalRule = __webpack_require__(730);

var _ConditionalRule2 = _interopRequireDefault(_ConditionalRule);

var _FontFaceRule = __webpack_require__(731);

var _FontFaceRule2 = _interopRequireDefault(_FontFaceRule);

var _ViewportRule = __webpack_require__(732);

var _ViewportRule2 = _interopRequireDefault(_ViewportRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var classes = {
  '@charset': _SimpleRule2['default'],
  '@import': _SimpleRule2['default'],
  '@namespace': _SimpleRule2['default'],
  '@keyframes': _KeyframesRule2['default'],
  '@media': _ConditionalRule2['default'],
  '@supports': _ConditionalRule2['default'],
  '@font-face': _FontFaceRule2['default'],
  '@viewport': _ViewportRule2['default'],
  '@-ms-viewport': _ViewportRule2['default']

  /**
   * Generate plugins which will register all rules.
   */
};
var plugins = Object.keys(classes).map(function (key) {
  // https://jsperf.com/indexof-vs-substr-vs-regex-at-the-beginning-3
  var re = new RegExp('^' + key);
  var RuleClass = classes[key];
  var onCreateRule = function onCreateRule(name, decl, options) {
    return re.test(name) ? new RuleClass(name, decl, options) : null;
  };
  return { onCreateRule: onCreateRule };
});

exports['default'] = plugins;

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SimpleRule = function () {
  function SimpleRule(key, value, options) {
    _classCallCheck(this, SimpleRule);

    this.type = 'simple';
    this.isProcessed = false;

    this.key = key;
    this.value = value;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  _createClass(SimpleRule, [{
    key: 'toString',
    value: function toString(options) {
      if (Array.isArray(this.value)) {
        var str = '';
        for (var index = 0; index < this.value.length; index++) {
          str += this.key + ' ' + this.value[index] + ';';
          if (this.value[index + 1]) str += '\n';
        }
        return str;
      }

      return this.key + ' ' + this.value + ';';
    }
  }]);

  return SimpleRule;
}();

exports['default'] = SimpleRule;

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RuleList = __webpack_require__(152);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Rule for @keyframes
 */
var KeyframesRule = function () {
  function KeyframesRule(key, frames, options) {
    _classCallCheck(this, KeyframesRule);

    this.type = 'keyframes';
    this.isProcessed = false;

    this.key = key;
    this.options = options;
    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));

    for (var name in frames) {
      this.rules.add(name, frames[name], _extends({}, this.options, {
        parent: this,
        selector: name
      }));
    }

    this.rules.process();
  }

  /**
   * Generates a CSS string.
   */


  _createClass(KeyframesRule, [{
    key: 'toString',
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };

      var inner = this.rules.toString(options);
      if (inner) inner += '\n';
      return this.key + ' {\n' + inner + '}';
    }
  }]);

  return KeyframesRule;
}();

exports['default'] = KeyframesRule;

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RuleList = __webpack_require__(152);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Conditional rule for @media, @supports
 */
var ConditionalRule = function () {
  function ConditionalRule(key, styles, options) {
    _classCallCheck(this, ConditionalRule);

    this.type = 'conditional';
    this.isProcessed = false;

    this.key = key;
    this.options = options;
    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */


  _createClass(ConditionalRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };

      var inner = this.rules.toString(options);
      return inner ? this.key + ' {\n' + inner + '\n}' : '';
    }
  }]);

  return ConditionalRule;
}();

exports['default'] = ConditionalRule;

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(257);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FontFaceRule = function () {
  function FontFaceRule(key, style, options) {
    _classCallCheck(this, FontFaceRule);

    this.type = 'font-face';
    this.isProcessed = false;

    this.key = key;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */


  _createClass(FontFaceRule, [{
    key: 'toString',
    value: function toString(options) {
      if (Array.isArray(this.style)) {
        var str = '';
        for (var index = 0; index < this.style.length; index++) {
          str += (0, _toCss2['default'])(this.key, this.style[index]);
          if (this.style[index + 1]) str += '\n';
        }
        return str;
      }

      return (0, _toCss2['default'])(this.key, this.style, options);
    }
  }]);

  return FontFaceRule;
}();

exports['default'] = FontFaceRule;

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(257);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ViewportRule = function () {
  function ViewportRule(key, style, options) {
    _classCallCheck(this, ViewportRule);

    this.type = 'viewport';
    this.isProcessed = false;

    this.key = key;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */


  _createClass(ViewportRule, [{
    key: 'toString',
    value: function toString(options) {
      return (0, _toCss2['default'])(this.key, this.style, options);
    }
  }]);

  return ViewportRule;
}();

exports['default'] = ViewportRule;

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StyleRule = __webpack_require__(135);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createRule = __webpack_require__(186);

var _createRule2 = _interopRequireDefault(_createRule);

var _isObservable = __webpack_require__(372);

var _isObservable2 = _interopRequireDefault(_isObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  onCreateRule: function onCreateRule(name, decl, options) {
    if (!(0, _isObservable2['default'])(decl)) return null;

    // Cast `decl` to `Observable`, since it passed the type guard.
    var style$ = decl;

    var rule = (0, _createRule2['default'])(name, {}, options);

    // TODO
    // Call `stream.subscribe()` returns a subscription, which should be explicitly
    // unsubscribed from when we know this sheet is no longer needed.
    style$.subscribe(function (style) {
      for (var prop in style) {
        rule.prop(prop, style[prop]);
      }
    });

    return rule;
  },
  onProcessRule: function onProcessRule(rule) {
    if (!(rule instanceof _StyleRule2['default'])) return;
    var styleRule = rule;
    var style = styleRule.style;

    var _loop = function _loop(prop) {
      var value = style[prop];
      if (!(0, _isObservable2['default'])(value)) return 'continue';
      delete style[prop];
      value.subscribe({
        next: function next(nextValue) {
          styleRule.prop(prop, nextValue);
        }
      });
    };

    for (var prop in style) {
      var _ret = _loop(prop);

      if (_ret === 'continue') continue;
    }
  }
};

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RuleList = __webpack_require__(152);

var _RuleList2 = _interopRequireDefault(_RuleList);

var _StyleRule = __webpack_require__(135);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createRule = __webpack_require__(186);

var _createRule2 = _interopRequireDefault(_createRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// A symbol replacement.
var now = Date.now();

var fnValuesNs = 'fnValues' + now;
var fnStyleNs = 'fnStyle' + ++now;

exports['default'] = {
  onCreateRule: function onCreateRule(name, decl, options) {
    if (typeof decl !== 'function') return null;
    var rule = (0, _createRule2['default'])(name, {}, options);
    rule[fnStyleNs] = decl;
    return rule;
  },
  onProcessStyle: function onProcessStyle(style, rule) {
    var fn = {};
    for (var prop in style) {
      var value = style[prop];
      if (typeof value !== 'function') continue;
      delete style[prop];
      fn[prop] = value;
    }
    rule = rule;
    rule[fnValuesNs] = fn;
    return style;
  },
  onUpdate: function onUpdate(data, rule) {
    // It is a rules container like for e.g. ConditionalRule.
    if (rule.rules instanceof _RuleList2['default']) {
      rule.rules.update(data);
      return;
    }
    if (!(rule instanceof _StyleRule2['default'])) return;

    rule = rule;

    // If we have a fn values map, it is a rule with function values.
    if (rule[fnValuesNs]) {
      for (var prop in rule[fnValuesNs]) {
        rule.prop(prop, rule[fnValuesNs][prop](data));
      }
    }

    rule = rule;

    var fnStyle = rule[fnStyleNs];

    // If we have a style function, the entire rule is dynamic and style object
    // will be returned from that function.
    if (fnStyle) {
      var style = fnStyle(data);
      for (var _prop in style) {
        rule.prop(_prop, style[_prop]);
      }
    }
  }
};

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(134);

var _warning2 = _interopRequireDefault(_warning);

var _sheets = __webpack_require__(258);

var _sheets2 = _interopRequireDefault(_sheets);

var _StyleRule = __webpack_require__(135);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _toCssValue = __webpack_require__(185);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Cache the value from the first time a function is called.
 */
var memoize = function memoize(fn) {
  var value = void 0;
  return function () {
    if (!value) value = fn();
    return value;
  };
};

/**
 * Get a style property value.
 */
function getPropertyValue(cssRule, prop) {
  try {
    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
}

/**
 * Set a style property.
 */
function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = (0, _toCssValue2['default'])(value, true);

      if (value[value.length - 1] === '!important') {
        cssRule.style.setProperty(prop, cssValue, 'important');
        return true;
      }
    }

    cssRule.style.setProperty(prop, cssValue);
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }
  return true;
}

/**
 * Remove a style property.
 */
function removeProperty(cssRule, prop) {
  try {
    cssRule.style.removeProperty(prop);
  } catch (err) {
    (0, _warning2['default'])(false, '[JSS] DOMException "%s" was thrown. Tried to remove property "%s".', err.message, prop);
  }
}

var CSSRuleTypes = {
  STYLE_RULE: 1,
  KEYFRAMES_RULE: 7

  /**
   * Get the CSS Rule key.
   */

};var getKey = function () {
  var extractKey = function extractKey(cssText) {
    var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return cssText.substr(from, cssText.indexOf('{') - 1);
  };

  return function (cssRule) {
    if (cssRule.type === CSSRuleTypes.STYLE_RULE) return cssRule.selectorText;
    if (cssRule.type === CSSRuleTypes.KEYFRAMES_RULE) {
      var name = cssRule.name;

      if (name) return '@keyframes ' + name;

      // There is no rule.name in the following browsers:
      // - IE 9
      // - Safari 7.1.8
      // - Mobile Safari 9.0.0
      var cssText = cssRule.cssText;

      return '@' + extractKey(cssText, cssText.indexOf('keyframes'));
    }

    // Conditionals.
    return extractKey(cssRule.cssText);
  };
}();

/**
 * Set the selector.
 */
function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText;

  // Return false if setter was not successful.
  // Currently works in chrome only.
  return cssRule.selectorText === selectorText;
}

/**
 * Gets the `head` element upon the first call and caches it.
 */
var getHead = memoize(function () {
  return document.head || document.getElementsByTagName('head')[0];
});

/**
 * Gets a map of rule keys, where the property is an unescaped key and value
 * is a potentially escaped one.
 * It is used to identify CSS rules and the corresponding JSS rules. As an identifier
 * for CSSStyleRule we normally use `selectorText`. Though if original selector text
 * contains escaped code points e.g. `:not(#\\20)`, CSSOM will compile it to `:not(# )`
 * and so CSS rule's `selectorText` won't match JSS rule selector.
 *
 * https://www.w3.org/International/questions/qa-escapes#cssescapes
 */
var getUnescapedKeysMap = function () {
  var style = void 0;
  var isAttached = false;

  return function (rules) {
    var map = {};
    // https://github.com/facebook/flow/issues/2696
    if (!style) style = document.createElement('style');
    for (var i = 0; i < rules.length; i++) {
      var rule = rules[i];
      if (!(rule instanceof _StyleRule2['default'])) continue;
      var selector = rule.selector;
      // Only unescape selector over CSSOM if it contains a back slash.

      if (selector && selector.indexOf('\\') !== -1) {
        // Lazilly attach when needed.
        if (!isAttached) {
          getHead().appendChild(style);
          isAttached = true;
        }
        style.textContent = selector + ' {}';
        var _style = style,
            sheet = _style.sheet;

        if (sheet) {
          var cssRules = sheet.cssRules;

          if (cssRules) map[cssRules[0].selectorText] = rule.key;
        }
      }
    }
    if (isAttached) {
      getHead().removeChild(style);
      isAttached = false;
    }
    return map;
  };
}();

/**
 * Find attached sheet with an index higher than the passed one.
 */
function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find attached sheet with the highest index.
 */
function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find a comment with "jss" inside.
 */
function findCommentNode(text) {
  var head = getHead();
  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];
    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }
  return null;
}

/**
 * Find a node before which we can insert the sheet.
 */
function findPrevNode(options) {
  var registry = _sheets2['default'].registry;


  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);
    if (sheet) return sheet.renderer.element;

    // Otherwise insert after the last attached.
    sheet = findHighestSheet(registry, options);
    if (sheet) return sheet.renderer.element.nextElementSibling;
  }

  // Try to find a comment placeholder if registry is empty.
  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);
    if (comment) return comment.nextSibling;
    // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.
    (0, _warning2['default'])(insertionPoint === 'jss', '[JSS] Insertion point "%s" not found.', insertionPoint);
  }

  return null;
}

/**
 * Insert style element into the DOM.
 */
function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;

  var prevNode = findPrevNode(options);

  if (prevNode) {
    var parentNode = prevNode.parentNode;

    if (parentNode) parentNode.insertBefore(style, prevNode);
    return;
  }

  // Works with iframes and any node types.
  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
    var insertionPointElement = insertionPoint;
    var _parentNode = insertionPointElement.parentNode;

    if (_parentNode) _parentNode.insertBefore(style, insertionPointElement.nextSibling);else (0, _warning2['default'])(false, '[JSS] Insertion point is not in the DOM.');
    return;
  }

  getHead().insertBefore(style, prevNode);
}

/**
 * Read jss nonce setting from the page if the user has set it.
 */
var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var DomRenderer = function () {
  function DomRenderer(sheet) {
    _classCallCheck(this, DomRenderer);

    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.getKey = getKey;
    this.getUnescapedKeysMap = getUnescapedKeysMap;
    this.hasInsertedRules = false;

    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) _sheets2['default'].add(sheet);

    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || document.createElement('style');
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }

  /**
   * Insert style element into render tree.
   */


  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696


  _createClass(DomRenderer, [{
    key: 'attach',
    value: function attach() {
      // In the case the element node is external and it is already in the DOM.
      if (this.element.parentNode || !this.sheet) return;

      // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
      // browsers remove those rules.
      // TODO figure out if its a bug and if it is known.
      // Workaround is to redeploy the sheet before attaching as a string.
      if (this.hasInsertedRules) {
        this.deploy();
        this.hasInsertedRules = false;
      }

      insertStyle(this.element, this.sheet.options);
    }

    /**
     * Remove style element from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      this.element.parentNode.removeChild(this.element);
    }

    /**
     * Inject CSS string into element.
     */

  }, {
    key: 'deploy',
    value: function deploy() {
      if (!this.sheet) return;
      this.element.textContent = '\n' + this.sheet.toString() + '\n';
    }

    /**
     * Insert a rule into element.
     */

  }, {
    key: 'insertRule',
    value: function insertRule(rule, index) {
      var sheet = this.element.sheet;
      var cssRules = sheet.cssRules;

      var str = rule.toString();
      if (!index) index = cssRules.length;

      if (!str) return false;

      try {
        sheet.insertRule(str, index);
      } catch (err) {
        (0, _warning2['default'])(false, '[JSS] Can not insert an unsupported rule \n\r%s', rule);
        return false;
      }
      this.hasInsertedRules = true;

      return cssRules[index];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(cssRule) {
      var sheet = this.element.sheet;

      var index = this.indexOf(cssRule);
      if (index === -1) return false;
      sheet.deleteRule(index);
      return true;
    }

    /**
     * Get index of a CSS Rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(cssRule) {
      var cssRules = this.element.sheet.cssRules;

      for (var _index = 0; _index < cssRules.length; _index++) {
        if (cssRule === cssRules[_index]) return _index;
      }
      return -1;
    }

    /**
     * Generate a new CSS rule and replace the existing one.
     */

  }, {
    key: 'replaceRule',
    value: function replaceRule(cssRule, rule) {
      var index = this.indexOf(cssRule);
      var newCssRule = this.insertRule(rule, index);
      this.element.sheet.deleteRule(index);
      return newCssRule;
    }

    /**
     * Get all rules elements.
     */

  }, {
    key: 'getRules',
    value: function getRules() {
      return this.element.sheet.cssRules;
    }
  }]);

  return DomRenderer;
}();

exports['default'] = DomRenderer;

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this */

/**
 * Rendering backend to do nothing in nodejs.
 */
var VirtualRenderer = function () {
  function VirtualRenderer() {
    _classCallCheck(this, VirtualRenderer);
  }

  _createClass(VirtualRenderer, [{
    key: 'setProperty',
    value: function setProperty() {
      return true;
    }
  }, {
    key: 'getPropertyValue',
    value: function getPropertyValue() {
      return '';
    }
  }, {
    key: 'removeProperty',
    value: function removeProperty() {}
  }, {
    key: 'setSelector',
    value: function setSelector() {
      return true;
    }
  }, {
    key: 'getKey',
    value: function getKey() {
      return '';
    }
  }, {
    key: 'attach',
    value: function attach() {}
  }, {
    key: 'detach',
    value: function detach() {}
  }, {
    key: 'deploy',
    value: function deploy() {}
  }, {
    key: 'insertRule',
    value: function insertRule() {
      return false;
    }
  }, {
    key: 'deleteRule',
    value: function deleteRule() {
      return true;
    }
  }, {
    key: 'replaceRule',
    value: function replaceRule() {
      return false;
    }
  }, {
    key: 'getRules',
    value: function getRules() {}
  }, {
    key: 'indexOf',
    value: function indexOf() {
      return -1;
    }
  }]);

  return VirtualRenderer;
}();

exports['default'] = VirtualRenderer;

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = jssNested;

var _warning = __webpack_require__(738);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container) {
    return function (match, key) {
      var rule = container.getRule(key);
      if (rule) return rule.selector;
      (0, _warning2.default)(false, '[JSS] Could not find the referenced rule %s in %s.', key, container.options.meta || container);
      return key;
    };
  }

  var hasAnd = function hasAnd(str) {
    return str.indexOf('&') !== -1;
  };

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);

    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', ';
        // Replace all & by the parent or prefix & with the parent.
        result += hasAnd(nested) ? nested.replace(parentRegExp, parent) : parent + ' ' + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, options) {
    // Options has been already created, now we only increase index.
    if (options) return _extends({}, options, { index: options.index + 1 });

    var nestingLevel = rule.options.nestingLevel;

    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    return _extends({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1
    });
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    var container = rule.options.parent;
    var options = void 0;
    var replaceRef = void 0;
    for (var prop in style) {
      var isNested = hasAnd(prop);
      var isNestedConditional = prop[0] === '@';

      if (!isNested && !isNestedConditional) continue;

      options = getOptions(rule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, rule.selector
        // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.
        );if (!replaceRef) replaceRef = getReplaceRef(container
        // Replace all $refs.
        );selector = selector.replace(refRegExp, replaceRef);

        container.addRule(selector, style[prop], _extends({}, options, { selector: selector }));
      } else if (isNestedConditional) {
        container
        // Place conditional right after the parent rule to ensure right ordering.
        .addRule(prop, null, options).addRule(rule.key, style[prop], { selector: rule.selector });
      }

      delete style[prop];
    }

    return style;
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = camelCase;

var _hyphenateStyleName = __webpack_require__(740);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Convert camel cased property names to dash separated.
 *
 * @param {Object} style
 * @return {Object}
 */
function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    converted[(0, _hyphenateStyleName2['default'])(prop)] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}

/**
 * Allow camel cased property names by converting them back to dasherized.
 *
 * @param {Rule} rule
 */
function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }
      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    var hyphenatedProp = (0, _hyphenateStyleName2['default'])(prop);

    // There was no camel case in place
    if (prop === hyphenatedProp) return value;

    rule.prop(hyphenatedProp, value);

    // Core will ignore that property value we set the proper one above.
    return null;
  }

  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g
var msPattern = /^ms-/
var cache = {}

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower)
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/* harmony default export */ __webpack_exports__["default"] = (hyphenateStyleName);


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = defaultUnit;

var _defaultUnits = __webpack_require__(742);

var _defaultUnits2 = _interopRequireDefault(_defaultUnits);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Clones the object and adds a camel cased property version.
 */
function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;
  var replace = function replace(str) {
    return str[1].toUpperCase();
  };
  var newObj = {};
  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }
  return newObj;
}

var units = addCamelCasedVersion(_defaultUnits2['default']);

/**
 * Recursive deep style passing function
 *
 * @param {String} current property
 * @param {(Object|Array|Number|String)} property value
 * @param {Object} options
 * @return {(Object|Array|Number|String)} resulting value
 */
function iterate(prop, value, options) {
  if (!value) return value;

  var convertedValue = value;

  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  if (type === 'object' && Array.isArray(value)) type = 'array';

  switch (type) {
    case 'object':
      if (prop === 'fallbacks') {
        for (var innerProp in value) {
          value[innerProp] = iterate(innerProp, value[innerProp], options);
        }
        break;
      }
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + '-' + _innerProp, value[_innerProp], options);
      }
      break;
    case 'array':
      for (var i = 0; i < value.length; i++) {
        value[i] = iterate(prop, value[i], options);
      }
      break;
    case 'number':
      if (value !== 0) {
        convertedValue = value + (options[prop] || units[prop] || '');
      }
      break;
    default:
      break;
  }

  return convertedValue;
}

/**
 * Add unit to numeric values.
 */
function defaultUnit() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Generated jss-default-unit CSS property units
 *
 * @type object
 */
exports['default'] = {
  'animation-delay': 'ms',
  'animation-duration': 'ms',
  'background-position': 'px',
  'background-position-x': 'px',
  'background-position-y': 'px',
  'background-size': 'px',
  border: 'px',
  'border-bottom': 'px',
  'border-bottom-left-radius': 'px',
  'border-bottom-right-radius': 'px',
  'border-bottom-width': 'px',
  'border-left': 'px',
  'border-left-width': 'px',
  'border-radius': 'px',
  'border-right': 'px',
  'border-right-width': 'px',
  'border-spacing': 'px',
  'border-top': 'px',
  'border-top-left-radius': 'px',
  'border-top-right-radius': 'px',
  'border-top-width': 'px',
  'border-width': 'px',
  'border-after-width': 'px',
  'border-before-width': 'px',
  'border-end-width': 'px',
  'border-horizontal-spacing': 'px',
  'border-start-width': 'px',
  'border-vertical-spacing': 'px',
  bottom: 'px',
  'box-shadow': 'px',
  'column-gap': 'px',
  'column-rule': 'px',
  'column-rule-width': 'px',
  'column-width': 'px',
  'flex-basis': 'px',
  'font-size': 'px',
  'font-size-delta': 'px',
  height: 'px',
  left: 'px',
  'letter-spacing': 'px',
  'logical-height': 'px',
  'logical-width': 'px',
  margin: 'px',
  'margin-after': 'px',
  'margin-before': 'px',
  'margin-bottom': 'px',
  'margin-left': 'px',
  'margin-right': 'px',
  'margin-top': 'px',
  'max-height': 'px',
  'max-width': 'px',
  'margin-end': 'px',
  'margin-start': 'px',
  'mask-position-x': 'px',
  'mask-position-y': 'px',
  'mask-size': 'px',
  'max-logical-height': 'px',
  'max-logical-width': 'px',
  'min-height': 'px',
  'min-width': 'px',
  'min-logical-height': 'px',
  'min-logical-width': 'px',
  motion: 'px',
  'motion-offset': 'px',
  outline: 'px',
  'outline-offset': 'px',
  'outline-width': 'px',
  padding: 'px',
  'padding-bottom': 'px',
  'padding-left': 'px',
  'padding-right': 'px',
  'padding-top': 'px',
  'padding-after': 'px',
  'padding-before': 'px',
  'padding-end': 'px',
  'padding-start': 'px',
  'perspective-origin-x': '%',
  'perspective-origin-y': '%',
  perspective: 'px',
  right: 'px',
  'shape-margin': 'px',
  size: 'px',
  'text-indent': 'px',
  'text-stroke': 'px',
  'text-stroke-width': 'px',
  top: 'px',
  'transform-origin': '%',
  'transform-origin-x': '%',
  'transform-origin-y': '%',
  'transform-origin-z': '%',
  'transition-delay': 'ms',
  'transition-duration': 'ms',
  'vertical-align': 'px',
  width: 'px',
  'word-spacing': 'px',
  // Not existing properties.
  // Used to avoid issues with jss-expand intergration.
  'box-shadow-x': 'px',
  'box-shadow-y': 'px',
  'box-shadow-blur': 'px',
  'box-shadow-spread': 'px',
  'font-line-height': 'px',
  'text-shadow-x': 'px',
  'text-shadow-y': 'px',
  'text-shadow-blur': 'px'
};

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssVendorPrefixer;

var _cssVendor = __webpack_require__(744);

var vendor = _interopRequireWildcard(_cssVendor);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 * Add vendor prefix to a property name when needed.
 *
 * @param {Rule} rule
 * @api public
 */
function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      rule.key = '@' + vendor.prefix.css + rule.key.substr(1);
    }
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      var value = style[prop];

      var changeProp = false;
      var supportedProp = vendor.supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;

      var changeValue = false;
      var supportedValue = vendor.supportedValue(supportedProp, value);
      if (supportedValue && supportedValue !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue || value;
      }
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return vendor.supportedValue(prop, value);
  }

  return { onProcessRule: onProcessRule, onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportedValue = exports.supportedProperty = exports.prefix = undefined;

var _prefix = __webpack_require__(259);

var _prefix2 = _interopRequireDefault(_prefix);

var _supportedProperty = __webpack_require__(745);

var _supportedProperty2 = _interopRequireDefault(_supportedProperty);

var _supportedValue = __webpack_require__(747);

var _supportedValue2 = _interopRequireDefault(_supportedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  prefix: _prefix2['default'],
  supportedProperty: _supportedProperty2['default'],
  supportedValue: _supportedValue2['default']
}; /**
    * CSS Vendor prefix detection and property feature testing.
    *
    * @copyright Oleg Slobodskoi 2015
    * @website https://github.com/jsstyles/css-vendor
    * @license MIT
    */

exports.prefix = _prefix2['default'];
exports.supportedProperty = _supportedProperty2['default'];
exports.supportedValue = _supportedValue2['default'];

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedProperty;

var _isInBrowser = __webpack_require__(187);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(259);

var _prefix2 = _interopRequireDefault(_prefix);

var _camelize = __webpack_require__(746);

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var el = void 0;
var cache = {};

if (_isInBrowser2['default']) {
  el = document.createElement('p');

  /**
   * We test every property on vendor prefix requirement.
   * Once tested, result is cached. It gives us up to 70% perf boost.
   * http://jsperf.com/element-style-object-access-vs-plain-object
   *
   * Prefill cache with known css properties to reduce amount of
   * properties we need to feature test at runtime.
   * http://davidwalsh.name/vendor-prefix
   */
  var computed = window.getComputedStyle(document.documentElement, '');
  for (var key in computed) {
    if (!isNaN(key)) cache[computed[key]] = computed[key];
  }
}

/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @return {String|Boolean}
 * @api public
 */
function supportedProperty(prop) {
  // For server-side rendering.
  if (!el) return prop;

  // We have not tested this prop yet, lets do the test.
  if (cache[prop] != null) return cache[prop];

  // Camelization is required because we can't test using
  // css syntax for e.g. in FF.
  // Test if property is supported as it is.
  if ((0, _camelize2['default'])(prop) in el.style) {
    cache[prop] = prop;
  }
  // Test if property is supported with vendor prefix.
  else if (_prefix2['default'].js + (0, _camelize2['default'])('-' + prop) in el.style) {
      cache[prop] = _prefix2['default'].css + prop;
    } else {
      cache[prop] = false;
    }

  return cache[prop];
}

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = camelize;
var regExp = /[-\s]+(.)?/g;

/**
 * Convert dash separated strings to camel cased.
 *
 * @param {String} str
 * @return {String}
 */
function camelize(str) {
  return str.replace(regExp, toUpper);
}

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedValue;

var _isInBrowser = __webpack_require__(187);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(259);

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var cache = {};
var el = void 0;

if (_isInBrowser2['default']) el = document.createElement('p');

/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */
function supportedValue(property, value) {
  // For server-side rendering.
  if (!el) return value;

  // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  if (typeof value !== 'string' || !isNaN(parseInt(value, 10))) return value;

  var cacheKey = property + value;

  if (cache[cacheKey] != null) return cache[cacheKey];

  // IE can even throw an error in some cases, for e.g. style.content = 'bar'
  try {
    // Test value as it is.
    el.style[property] = value;
  } catch (err) {
    cache[cacheKey] = false;
    return false;
  }

  // Value is supported as it is.
  if (el.style[property] !== '') {
    cache[cacheKey] = value;
  } else {
    // Test value with vendor prefix.
    value = _prefix2['default'].css + value;

    // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
    if (value === '-ms-flex') value = '-ms-flexbox';

    el.style[property] = value;

    // Value is supported with vendor prefix.
    if (el.style[property] !== '') cache[cacheKey] = value;
  }

  if (!cache[cacheKey]) cache[cacheKey] = false;

  // Reset style value.
  el.style[property] = '';

  return cache[cacheKey];
}

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssPropsSort;
/**
 * Sort props by length.
 */
function jssPropsSort() {
  function sort(prop0, prop1) {
    return prop0.length - prop1.length;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    var newStyle = {};
    var props = Object.keys(style).sort(sort);
    for (var prop in props) {
      newStyle[props[prop]] = style[props[prop]];
    }
    return newStyle;
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createStyles;

function createStyles(styles) {
  return styles;
}

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Share the same values than in
// https://github.com/cssinjs/jss/blob/master/packages/react-jss/src/ns.js
var ns = {
  jss: '64a55d578f856d258dc345b094a2a2b3',
  sheetsRegistry: 'd4bd0baacbc52bbd48bbb9eb24344ecd',
  sheetOptions: '6fc570d6bd61383819d0f9e7407c452d'
};
var _default = ns;
exports.default = _default;

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var multiKeyStore = {
  set: function set(cache, key1, key2, value) {
    var subCache = cache.get(key1);

    if (!subCache) {
      subCache = new Map();
      cache.set(key1, subCache);
    }

    subCache.set(key2, value);
  },
  get: function get(cache, key1, key2) {
    var subCache = cache.get(key1);
    return subCache ? subCache.get(key2) : undefined;
  },
  delete: function _delete(cache, key1, key2) {
    var subCache = cache.get(key1);
    subCache.delete(key2);
  }
};
var _default = multiKeyStore;
exports.default = _default;

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _typeof2 = _interopRequireDefault(__webpack_require__(117));

var _warning = _interopRequireDefault(__webpack_require__(27));

var _deepmerge = _interopRequireDefault(__webpack_require__(184));

// < 1kb payload overhead when lodash/merge is > 3kb.
// Support for the jss-expand plugin.
function arrayMerge(destination, source) {
  return source;
}

function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';
   false ? (0, _warning.default)((0, _typeof2.default)(stylesOrCreator) === 'object' || themingEnabled, ['Material-UI: the first argument provided to withStyles() is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n')) : void 0;

  function create(theme, name) {
    var styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;

    if (!name || !theme.overrides || !theme.overrides[name]) {
      return styles;
    }

    var overrides = theme.overrides[name];
    var stylesWithOverrides = (0, _extends2.default)({}, styles);
    Object.keys(overrides).forEach(function (key) {
       false ? (0, _warning.default)(stylesWithOverrides[key], ['Material-UI: you are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n')) : void 0;
      stylesWithOverrides[key] = (0, _deepmerge.default)(stylesWithOverrides[key], overrides[key], {
        arrayMerge: arrayMerge
      });
    });
    return stylesWithOverrides;
  }

  return {
    create: create,
    options: {},
    themingEnabled: themingEnabled
  };
}

var _default = getStylesCreator;
exports.default = _default;

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = asyncMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_actions__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_errors_errors__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__errors_apperror__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__logger_logger__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__errors_errormessages__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(17);
var log=__WEBPACK_IMPORTED_MODULE_7__logger_logger__["a" /* default */].get('asyncMiddleware');function asyncMiddleware(apiClient,axiosClient){return function(_ref){var dispatch=_ref.dispatch,getState=_ref.getState;return function(next){return function(action){if(typeof action==='function'){return action(dispatch,getState);}var promise=action.promise,types=action.types,rest=__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(action,["promise","types"]);// eslint-disable-line no-redeclare
if(!promise){return next(action);}// todo catch infinite loop here
var _types=__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(types,3),REQUEST=_types[0],SUCCESS=_types[1],FAILURE=_types[2];try{next(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},rest,{type:REQUEST}));var client=REQUEST===__WEBPACK_IMPORTED_MODULE_3__modules_actions__["_60" /* CRS_CHECK_CREDENTIALS */]||REQUEST===__WEBPACK_IMPORTED_MODULE_3__modules_actions__["_65" /* CRS_USAGE_UPDATE */]||REQUEST===__WEBPACK_IMPORTED_MODULE_3__modules_actions__["B" /* COMPANIES_CONTACT_SALES */]||REQUEST===__WEBPACK_IMPORTED_MODULE_3__modules_actions__["_20" /* COMPANIES_REVIEW_MLS_REQUEST */]||REQUEST===__WEBPACK_IMPORTED_MODULE_3__modules_actions__["y" /* COMPANIES_CONNECT_MLS_REQUEST */]?axiosClient:apiClient;return promise(client).then(function(result){return next(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},rest,{result:result,type:SUCCESS}));})["catch"](function(error,body,xhr){var state=getState();var firstMessageId;var messageFromMw;if(error instanceof __WEBPACK_IMPORTED_MODULE_6__errors_apperror__["a" /* default */]){// Extract message from MW response to be used in modal popup
var firstMessage=error.getMesageFromHistoryAtIndex(0);if(firstMessage){firstMessageId=firstMessage.errorId;try{var responseJSON=JSON.parse(__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(firstMessage,'responseText'));messageFromMw=responseJSON.errormessage;}catch(e){// Silent catch
}}}var errorIdToLog=firstMessageId||__WEBPACK_IMPORTED_MODULE_5__errors_errorids__["a" /* default */].UNKNOWN;var errorProps={message:'Redux Error (promise-catch)',errorId:errorIdToLog,originalError:error,keepOriginalError:true,visualisers:{feature:errorIdToLog===__WEBPACK_IMPORTED_MODULE_5__errors_errorids__["a" /* default */].USER_AUTHENTICATION_REQUIRED||REQUEST===__WEBPACK_IMPORTED_MODULE_3__modules_actions__["_183" /* USER_REGION_FETCH */]&&firstMessageId===__WEBPACK_IMPORTED_MODULE_5__errors_errorids__["a" /* default */].COUNTRY_CANNOT_BE_DETECTED?'SUPPRESSED_ERROR':'REDUX'}};var responseURL=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(error,'originalErrors[0].responseURL');if(FAILURE===__WEBPACK_IMPORTED_MODULE_3__modules_actions__["_57" /* COUPON_FETCH_FAIL */]||(FAILURE===__WEBPACK_IMPORTED_MODULE_3__modules_actions__["_168" /* SUBSCRIPTION_GET_ESTIMATE_FAIL */]||FAILURE===__WEBPACK_IMPORTED_MODULE_3__modules_actions__["L" /* COMPANIES_CREATE_CHARGEBEE_SUBSCRIPTION_FAIL */])&&(responseURL.indexOf('couponId')!==-1||responseURL.indexOf('couponSetId')!==-1)){errorProps.details={};errorProps.details.couponId=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(rest,'payload.couponId')||__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(rest,'payload.couponSetId');errorProps.visualisers.feature='COUPON';}var nError=new __WEBPACK_IMPORTED_MODULE_6__errors_apperror__["a" /* default */](errorProps);log.send(nError);if(!firstMessageId){// Ask user to refresh app because of runtime erros (invalid Redux state)
throw nError;}// Sets inline state for components (updates related redux module ie. COMPANIES:VALIDATE_FAIL)
next(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},rest,{error:nError,result:{},type:FAILURE}));// - For API errors or known client side errors (OFFLINE, XHR_ABORTED) show popup
// - Don't do anything for handledErrors like COMPANY_NAME_ALREADY_EXISTS, as they are
//   handled in different way (COMPANY_NAME_ALREADY_EXISTS shows inline error
//   above company name input field etc)
// - Errors from CRS-WEB shows inline error in the discount form
// - Errors from COMPANIES_USER_ADD && REQUEST and COMPANIES_ESTIMATE_USER_ADD actions
// 	 are shown inline in Invite user popup
// - Errors from COMPANIES_CREATE_CHARGEBEE_SUBSCRIPTION, COMPANIES_PURCHASE_SEAT and 
//   COMPANIES_ESTIMATE_SEAT actions 	are shown inline in BuyMoreLicensesOrSeatsModal popup 
//   if that modal is shown
// - Errors from COMPANIES_USERS_REDUCE
// - Errors from https://www.xara.com/contact-sales-request/ endpoint on website
// - Errors from ACCOUNT_UPDATE_EXTERNAL_IDS_ENDPOINT endpoint
var isBuyLicensesModalShown=state.modal.modalShown&&['CONFIRM_PURCHASE_CHOICE','BUY_MORE_LICENSES_OR_SEATS'].includes(state.modal.modalType);if(__WEBPACK_IMPORTED_MODULE_4_errors_errors__["b" /* handledErrors */].indexOf(firstMessageId)===-1&&// All errors coming from CRS-WEB page are handled errors
responseURL.indexOf(__WEBPACK_IMPORTED_MODULE_10__config__["w" /* CRS */].INFO_URL)===-1&&// All errors coming from COUPONS.GET_COUPON_INFO route are handled errors
responseURL.indexOf(__WEBPACK_IMPORTED_MODULE_10__config__["t" /* COUPONS */].GET_COUPON_INFO)===-1&&// Errors during externalIds update are shown inline
responseURL.indexOf(__WEBPACK_IMPORTED_MODULE_10__config__["b" /* ACCOUNT_UPDATE_EXTERNAL_IDS_ENDPOINT */])===-1&&// Errors from subscription estimation endpoint when there is couponId or couponSetId sent
responseURL.indexOf('createSubscriptionEstimation')!==-1&&responseURL.indexOf('couponId')===-1&&responseURL.indexOf('couponSetId')===-1&&// All errors coming from CONTACT_SALES.API_ENDPOINT route are handled errors
responseURL.indexOf(__WEBPACK_IMPORTED_MODULE_10__config__["r" /* CONTACT_SALES */].API_ENDPOINT)===-1&&// All errors coming from CONNECT_MLS.API_ENDPOINT route are handled errors
responseURL.indexOf(__WEBPACK_IMPORTED_MODULE_10__config__["Z" /* MLS_DATA_PROJECT_ENDPOINTS */].CONNECT_MLS)===-1&&responseURL.indexOf(__WEBPACK_IMPORTED_MODULE_10__config__["Z" /* MLS_DATA_PROJECT_ENDPOINTS */].REVIEW_MLS)===-1&&// All errors coming from 'Change sign-in details' page are handled errors
responseURL.indexOf(__WEBPACK_IMPORTED_MODULE_10__config__["h" /* AUTHENTICATION */].SIGN_IN_URL)===-1&&responseURL.indexOf(__WEBPACK_IMPORTED_MODULE_10__config__["h" /* AUTHENTICATION */].SIGN_UP_URL)===-1&&responseURL.indexOf(__WEBPACK_IMPORTED_MODULE_10__config__["h" /* AUTHENTICATION */].RESET_PASSWORD_URL)===-1&&REQUEST!==__WEBPACK_IMPORTED_MODULE_3__modules_actions__["_41" /* COMPANIES_USER_ADD */]&&REQUEST!==__WEBPACK_IMPORTED_MODULE_3__modules_actions__["Q" /* COMPANIES_ESTIMATE_USER_ADD */]&&(REQUEST!==__WEBPACK_IMPORTED_MODULE_3__modules_actions__["K" /* COMPANIES_CREATE_CHARGEBEE_SUBSCRIPTION */]||!isBuyLicensesModalShown)&&REQUEST!==__WEBPACK_IMPORTED_MODULE_3__modules_actions__["N" /* COMPANIES_ESTIMATE_SEAT */]&&REQUEST!==__WEBPACK_IMPORTED_MODULE_3__modules_actions__["_16" /* COMPANIES_PURCHASE_SEAT */]&&REQUEST!==__WEBPACK_IMPORTED_MODULE_3__modules_actions__["_38" /* COMPANIES_USERS_REDUCE */]){var isErrorMessageInConfig=__WEBPACK_IMPORTED_MODULE_9__errors_errormessages__["a" /* default */][firstMessageId];var reduxObject=__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({errorId:firstMessageId},!isErrorMessageInConfig&&messageFromMw&&{errorMessage:messageFromMw});// Sets props for ErrorModal
next({type:__WEBPACK_IMPORTED_MODULE_3__modules_actions__["_76" /* ERROR_HANDLER_SET */],error:reduxObject,result:{}});}return error;});}catch(error){throw new __WEBPACK_IMPORTED_MODULE_6__errors_apperror__["a" /* default */]({message:'Redux error (try-catch)',errorId:__WEBPACK_IMPORTED_MODULE_5__errors_errorids__["a" /* default */].UNKNOWN,originalError:error,visualisers:{feature:'REDUX'}});}};};};}

/***/ }),
/* 754 */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;

/***/ }),
/* 755 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;

/***/ }),
/* 756 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

module.exports = _nonIterableRest;

/***/ }),
/* 757 */
/***/ (function(module, exports) {

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

module.exports = _arrayWithoutHoles;

/***/ }),
/* 758 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

module.exports = _iterableToArray;

/***/ }),
/* 759 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

module.exports = _nonIterableSpread;

/***/ }),
/* 760 */
/***/ (function(module, exports) {

function _defineEnumerableProperties(obj, descs) {
  for (var key in descs) {
    var desc = descs[key];
    desc.configurable = desc.enumerable = true;
    if ("value" in desc) desc.writable = true;
    Object.defineProperty(obj, key, desc);
  }

  if (Object.getOwnPropertySymbols) {
    var objectSymbols = Object.getOwnPropertySymbols(descs);

    for (var i = 0; i < objectSymbols.length; i++) {
      var sym = objectSymbols[i];
      var desc = descs[sym];
      desc.configurable = desc.enumerable = true;
      if ("value" in desc) desc.writable = true;
      Object.defineProperty(obj, sym, desc);
    }
  }

  return obj;
}

module.exports = _defineEnumerableProperties;

/***/ }),
/* 761 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 762 */
/***/ (function(module, exports) {

/*eslint no-underscore-dangle:0*/(function(){'use strict';var module='localiser';var exports={};var AVAILABLE_LANGUAGES=['en','de'];var months=['January','February','March','April','May','June','July','August','September','October','November','December'];var Localiser={// map translation strings
strings:{},string:function string(key){var strings=Localiser.strings;var strings_en=Localiser.strings_en;var args=[].slice.call(arguments,1);if(strings.hasOwnProperty(key)){if(typeof strings[key]==='function'){return strings[key](args);}else{return Localiser.replace(strings[key],args);}}else if(strings_en&&strings_en.hasOwnProperty(key)){// Fall back to English
if(typeof strings_en[key]==='function'){return strings_en[key](args);}else{return Localiser.replace(strings_en[key],args);}}else{// todo: debug mode
// console.log('Not found i18n key:', key);
return key;}},localize:function localize(key,args){// cast key to string - well key SHOULD be string, but we should not crash if not and output correct error string
key=[String(key).trim()];if(args){key=key.concat(args);}return Localiser.string.apply(Localiser,key);},replace:function replace(str,args){for(var i=0,len=args.length;i<len;i++){str=str.replaceAll('{'+i+'}',args[i]);}return str;},add:function add(key,fn){Localiser.strings[key]=fn;},setLanguage:function setLanguage(langCode,langContent){exports.language=langCode;exports.loc.strings=langContent;},translateTemplate:function translateTemplate(templateContent){var codeRegexp=/\{\{str-(.*?)\}\}/gi;var translatedTemplate=templateContent.replace(codeRegexp,function(match,key){return Localiser.string(key);}.bind(this));return translatedTemplate;},/**
		 * Simple date formatter
		 * @param d - Date object or timestamp
		 * @param format:
		 *  YYYY - year
		 *  MM - month number
		 *  MMMM - full month name
		 *  MMM - short month name
		 *  DD - day
		 *  HH - hours (24h format)
		 *  hh - hours (12h format)
		 *  mm - minutes
		 *  ss - seconds
		 *  A - AM/PM
		 *  a - am/pm
		 */date:function date(d,format){// support for timestamp
+d===d&&(d=new Date(d));var year=d.getFullYear();var month=d.getMonth()+1;var day=d.getDate();var hours=d.getHours();var minutes=d.getMinutes();var seconds=d.getSeconds();var ampm=hours>=12?'PM':'AM';month<10&&(month='0'+month);hours<10&&(hours='0'+hours);minutes<10&&(minutes='0'+minutes);seconds<10&&(seconds='0'+seconds);return format.replace('a',ampm.toLowerCase()).replace('A',ampm).replace('YYYY',year).replace('MMMM',this.string(months[month-1])).replace('MMM',this.string('short-'+months[month-1])).replace('MM',month).replace('DD',day).replace('HH',hours).replace('hh',(parseInt(hours,10)+11)%12+1).replace('mm',minutes).replace('ss',seconds);}};exports.getCurrentLanguage=function(isoCode){// use lang from query parameters from desktop app
var urlParams;if(window.location.search){urlParams=new URLSearchParams(window.location.search);}else{// cover case when there is also #hash in URL, then we have to extract query params in different way
var queryStrings=window.location.href.indexOf('?')?window.location.href.split('?')[1]:null;urlParams=new URLSearchParams(queryStrings);}var lang=urlParams.get('lang');if(!lang){lang=window.sessionStorage.getItem('checkoutLang');}// if this is not available then try to set lang based on
// browser's data (only if we have translation for browser language)
if(!lang){var browserSettingsLang=(window.navigator.userLanguage||window.navigator.language).toLowerCase().substr(0,2);if(AVAILABLE_LANGUAGES.indexOf(browserSettingsLang)){lang=browserSettingsLang;}}if(!lang){// If we don't have translation for browser langauge (ie. Norwegian) then use language from XC user settings (English)
lang=window.localStorage.getItem('lang');}// language can be de/en (from newsletter) or deu/enu (from desktop app)
if(lang==='deu'){lang='de';}else if(lang==='enu'||lang==='eng'){lang='en';}// make sure that the language can be used
if(AVAILABLE_LANGUAGES.indexOf(lang)==-1){lang='en';}if(isoCode){if(lang==='en'){return'en-GB';}else if(lang==='de'){return'de-DE';}}else{return lang;}};// !! DO NOT REMOVE COMMENTS - THEY ARE USED TO INJECT TRANSLATION VARIABLES
exports.loc=Localiser;exports.loc.language=/*lang*/''/*lang*/;exports.loc.strings=/*localisedStrings*/{}/*localisedStrings*/;exports.tpl=/*templates*/{}/*templates*/;if(!exports.loc.language){exports.loc.language='en';}/*extraContent*/ /*extraContent*/this[module]=exports;}).call(this);

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*eslint-disable max-len, quotes*/(function(){var exports={'yes':'Yes','no':'No','ok':'OK','cancel':'Cancel','save':'Save','submit':'Submit','delete':'Delete','replace':'Replace','skip':'Skip','close':'Close','pay-now':'Pay now','continue':'Continue','rename':'Rename','upgrade':'Upgrade','great':'Great!','more-info':'More info','required-field':'This field is required','leave-page-confirmation':'You have unsaved changes, are you sure you want to leave this page?','leave-page':'Leave page','stay-on-page':'Stay on page','continue-to-checkout':'Continue to check out','go-back':'Go back','reduce-users':'Reduce users','save-and-continue':'Save and continue','and':'and','config-user-roles-admin':'Admin','config-user-roles-member':'Member','config-user-roles-guest':'Guest','top-bar-upgrade-button-day':'day','top-bar-upgrade-button-days':'days','top-bar-upgrade-button-week':'week',// For testing Crowdin integration only.
'main-nav-avatar-alt':'User profile','main-nav-change-sign-in-details':'Change sign-in details','main-nav-team-profile':'Team profile','main-nav-users':'Users & Permissions','main-nav-mls-connection':'MLS connection','main-nav-fonts':'Custom fonts','main-nav-folders':'Team folders','main-nav-smartfields':'SmartFields','main-nav-customize':'Customize','main-nav-subscription':'Billing & Plans','main-nav-downloads':'Downloads','main-nav-new':'new','company-profile-header':'Team profile','company-profile-description':'Fill out your team information.','company-profile-description-read-only':'Team information is read-only, only team administrators can modify this.','company-profile-team-name':'Team Name','company-profile-team-name-placeholder':'Team Name','company-profile-team-name-taken':'This name is already taken, please choose another team name.','company-profile-team-name-length':'Please enter more than 3 characters.','company-profile-team-name-consecutive-spaces':'You may not have multiple consecutive spaces.','company-profile-team-name-leading-trailing-spaces':'You may not have a name that starts or ends with space.','company-profile-email':'Contact email','company-profile-email-placeholder':'Email address','company-profile-email-description':'This is the main email and billing address for {0}.','company-profile-email-invalid':'Invalid email address','company-profile-address':'Address','company-profile-address1-placeholder':'Address line 1','company-profile-address2-placeholder':'Address line 2','company-profile-city-placeholder':'City','company-profile-region-placeholder':'State/Region','company-profile-postcode-placeholder':'Postcode','company-profile-country-placeholder':'Country','company-profile-country-invalid':'The country provided is not valid. Please start typing and select an entry from the list.','company-profile-phone':'Phone number','company-profile-phone-placeholder':'Phone number','company-profile-phone-invalid':'The phone number provided is not valid. Please enter a different number, using numbers and the - + ( ) characters.','company-profile-website':'Website','company-profile-website-placeholder':'https://www.yourdomain.com','company-profile-website-invalid':'The website provided is not valid. Please enter a valid website format with http:// or https://.','company-profile-industry':'Industry','company-profile-industry-selector':'Please select','company-profile-industry-invalid':'The team industry provided is not valid. Please start typing and select an entry from the list.','company-profile-size':'Team size','company-profile-size-selector':'Select...','company-profile-language':'Language','company-profile-language-selector':'Select...','company-profile-updated':'Team profile was updated','company-profile-settings-error':'Error saving team settings','users-header':'Users & Permissions','users-description':'Manage users and permissions.','users-email-placeholder':'Enter an email address','users-email-error-invalid':'Invalid email address.','users-email-error-exists':'This user already exists.','users-email-already-exists-in-invite-list':'Duplicate entry.','users-message-empty':'Message should not be empty.','users-roles-popover-title':'Roles','users-roles-popover-admin':'Admin','users-roles-popover-admin-description':'Full admin rights. Manage team and team files.','users-roles-popover-member':'Member','users-roles-popover-member-description':'Full document editing rights. Access to team files.','users-roles-popover-guest':'Guest','users-roles-popover-guest-description':'No access to team files, templates or assets. Can comment and collaborate on selected documents with limited editing capabilities. Guests don\'t use user licenses.','users-add':'Add users','users-send-invitations':'Send invitations','users-confirm-role-upgrade':'Are you sure you want to add {0} as a Team Member?','users-inactive-company-information-1':'Your plan has expired. Please','users-inactive-company-information-2':'select a subscription','users-inactive-company-information-3':'or','users-inactive-company-information-4':'update the payment details','users-inactive-company-information-5':'to reactivate it. Contact us with any questions.','smartfield-photo-picker-upload-photo':'Upload photo','smartfield-photo-picker-crop-photo':'Crop photo','smartfield-photo-picker-crop-photo-drag-prompt':'Drag to reposition your photo','smartfield-photo-picker-remove-photo':'Remove photo','users-table-header-name':'Name','users-table-header-photo':'Photo','users-table-header-email':'Email','users-table-header-user-role':'Role','users-table-header-last-seen':'Last seen','users-table-header-mls':'MLS ID','users-table-header-connection-status':'Connection status','users-table-header-mls-tooltip':'Enter MLS ID to get automatic Playbooks','users-table-header-mls-tooltip-agents-modal':'Required for automatic Playbook generation.<br>When a valid ID is entered, the MLS<br> connection is set.','users-table-header-select-action':'Select action','users-table-name-you':'{0} (You)','users-table-enter-agent-mls-id':'Enter Agent MLS ID','users-table-click-to-enter-agent-mls-id':'Click to enter','users-table-mls-no-connections':'No MLS connections','users-table-mls-id-invalid-value':'Invalid format.','users-table-mls-id-already-used':'This MLS ID has already been used.','users-table-mls-id-done':'Done','users-table-mls-id-add':'Add MLS ID','users-remove-member-confirmation':'Are you sure you want to remove {0} from your Member list?','users-increase-confirm':'Increase my plan from {0} to {1} users.<br/><br/>The prorated amount is {2}{3}.','users-complete-team-profile':'Before adding members to your team, please give your team a name using the <strong>Team Profile</strong> option','users-team-profile':'Team Profile','users-user-added':'An e-mail has been sent to notify {0}','users-users-invited':'An email is sent to all {0} users that haven\'t signed in to Xara.','users-no-users-invited':'All users are already in the team. No email sent.','users-user-role-updated':'Role was changed','users-user-photo-updated':'Photo has been updated','users-user-photo-removed':'Photo has been removed','users-user-photo-update-error':'Error happened during photo upload/update, please try again or contact suppport.','users-user-photo-remove-error':'Error happened during photo removal, please try again or contact suppport.','users-user-removed':'{0} was removed','users-table-header-admins-and-members':'Admins & Members','users-table-header-guests':'Guests','users-table-no-guests-found':'No guests found','users-table-change-sorting-order':'Change sorting order','users-table-mls-connected':'Connected','users-table-mls-not-connected':'Not connected','users-popup-header':'Invite users','user-type-all':'All','user-type-admins':'Admins','user-type-members':'Members','user-type-pending':'Pending','user-type-no-invitation':'No invitation sent','user-type-invitation-sent':'Invitation sent','user-type-type':'Type: ','user-menu-send-invite':'Send invitation','user-menu-resend-invite':'Resend invitation','user-table-username-pending-prompt':'(Pending sign up)','user-table-photo-pending-prompt':'Upload after sign up','user-table-mls-pending-prompt':'Enter after sign up','user-last-login-never':'Never','user-last-login-just-now':'Just now','user-last-login-yesterday':'Yesterday','user-last-login-minute':'minute','user-last-login-minutes':'minutes','user-last-login-hour':'hour','user-last-login-hours':'hours','user-last-login-week':'week','user-last-login-weeks':'weeks','user-last-login-month':'month','user-last-login-months':'months','user-last-login-over-a-year':'>12 Months ago','user-last-login-at':'at','users-popup-invite-all':'Invite all','users-popup-invitation-email-message-label':'Invitation email message:','users-popup-invitation-email-message-value':'(Default invitation message)','users-popup-new-user-email-address':'Enter an email address','users-popup-add-another':'Add another','users-popup-saving-users':'Saving users','users-batch-add-error-offline':'Cannot reach server. Please check your network connection and try again in a few seconds.','users-batch-add-error-unknown':'An unknown error occurred.','users-batch-add-error-cant-modify-users':'Can\'t modify users. Please try again. If the problem continues, contact us.','users-batch-add-error-failed-to-add-user-to-company':'Failed to add user to company. Please try again. If the problem continues, contact us.','users-batch-add-error-invalid-user':'Invalid user. Please try again. If the problem continues, contact us.','users-batch-add-error-invalid-users':'Invalid users. Please try again. If the problem continues, contact us.','users-batch-add-error-user-already-exists':'One of more users already exist. Please try again. If the problem continues, contact us.','users-batch-add-error-plan-prohibits-user-modification':'Subscription plan prohibits user modification','users-external-id-error-invalid-company-id':'Invalid company ID','users-external-id-error-external-ids-must-be-an-array':'External IDs must be an array','users-external-id-error-target-user-not-in-the-company':'Target user not in the company','users-external-id-error-failed-to-update-external-id':'Failed to update external IDs','users-external-id-error-unknown':'Failed to update external IDs. Unknown error.','users-external-id-duplicates':'This MLS ID has already been used.','users-please-errors-found-in-the-form':'There\'s an issue with one or more invites.','product-quantity-error':'Invalid number','product-quantity-licenses-label':'Number of licenses to buy','product-quantity-users-label':'Number of user licenses','product-quantity-numbers-of-users-reminder':'Reminder: You currently have {0} users on the team.','license-info-perpetual':'Install on up to 2 devices with each license.','license-info-desktop-plus':'Each user can install the product on up to 2 devices.','license-info-desktop-plus-extended':'For Photo & Graphic Designer+, Web Designer+, and Designer Pro+, each user can Install on up to 2 devices.','license-info-scale':'Each user can install the product on up to 2 devices.','fonts-header':'Custom fonts','fonts-description':'Upload your team fonts to make them available for the whole team.<br />Xara Cloud can add the following file types: .ttf .otf.','fonts-upload-button':'Upload team font','fonts-table-header':'Uploaded team fonts','fonts-delete-confirmation':'Do you want to delete this font?','fonts-font-exists-confirmation':'{0} is already in the font list. Do you want to replace the file?','fonts-size-exceeded':'The font file you tried to upload is larger than the 20MB maximum size.','fonts-added':'{0} was added','fonts-replaced':'{0} has been replaced','fonts-removed':'{0} was removed','cloud-folders-documents':'Documents','cloud-folders-assets':'Assets','base-asset-display-name':'Display name:','documents-description':'<span>Select a folder from your cloud storage to create a central storage location for your team.</span><br/><br/><span>All team members and team admins will have full read and write access to this folder and all sub folders through Xara Cloud.</span>','documents-your-document-folder':'Your document folder','documents-remove-folder-message':'Do you want to remove this folder - {0}','documents-remove-folder-cta':'Remove folder','documents-browse-drives':'Browse drives','documents-error-limited':'You are limited to one document folder.<br/>Please remove the current folder to add a new one.','assets-description-not-selected':'Asset folders are automatic one-click links in Xara Cloud for users to add team assets like logos, images, diagrams, graphics and more, to any document.','assets-description-logo':'Select a folder that contains logos you want to share with your team.<br/>Supported file types: png, jpg, jpeg, bmp, tiff, xar, web, svg.','assets-description-image':'Select a folder that contains images you want to share with your team.<br/>Supported file types: jpg, jpeg, tiff, png, svg, tif, bmp.','assets-description-component':'Set additional folders with assets your team uses frequently.<br/>Supported file types: svg, ai, pptx, xar, web.','assets-step-1':'Step 1','assets-step-1-description':'Select assets category type.','assets-step-2':'Step 2','assets-step-2-description':'Select the cloud storage where the assets are located.','asset-browse-drives':'Browse drives','asset-folders':'Your {0} folders','asset-folder-remove-message':'Do you want to remove this folder - {0}?','asset-folder-remove-button-remove':'Remove folder','asset-folder-add-button':'+ Add','cloud-browser-shared':'Shared','cloud-browser-no-subfolders':'This folder contains no more subfolders.','cloud-browser-go-back':' Please select the arrow to go back','cloud-browser-open-button':'Open','cloud-browser-add-button':'+ Add','company-create-title':'What\'s the name of your company?','company-create-placeholder':'Company name','company-create-button':'Create','creator-welcome-title':'Welcome','creator-welcome-description':'to Xara for Teams','smartfields-tab':'Team SmartFields','smartfields-description':'SmartFields get automatically applied to dynamic fields included in templates.','smartfields-info':'SmartFields can auto-populate your documents with<br />personalized information, including name, phone number, email<br />address, and many more. Team admins can set Team<br />SmartFields that everyone in their team can implement.','smartfields-error':'Please check your entries','smartfields-team-name':'Team Name','smartfields-team-name-placeholder':'Team Name','smartfields-email':'Contact email','smartfields-email-placeholder':'Email address','smartfields-email-invalid':'Invalid email address','smartfields-address':'Address','smartfields-address1-placeholder':'Street name','smartfields-city-placeholder':'City','smartfields-region-placeholder':'State / Region','smartfields-postcode-placeholder':'Postcode','smartfields-country-placeholder':'Country','smartfields-phone':'Phone number','smartfields-phone-placeholder':'Phone number','smartfields-phone-invalid':'The phone number provided is not valid. Please enter a different number, using numbers and the - + ( ) characters.','smartfields-website':'Website','smartfields-website-placeholder':'https://www.yourdomain.com','smartfields-website-invalid':'Please enter a valid web link.','smartfields-social-link-description':'Link to your profile','smartfields-social-name-description':'Profile name (displayed in templates)','smartfields-instagram':'Instagram','smartfields-instagram-link-placeholder':'https://www.instagram.com/yourprofile','smartfields-instagram-link-invalid':'Please enter a valid web link e. g. www.instagram.com/your_profile/ .','smartfields-instagram-name-placeholder':'@yourinstagramprofile','smartfields-facebook':'Facebook','smartfields-facebook-link-placeholder':'https://facebook.com/yourprofile','smartfields-facebook-link-invalid':'Please enter a valid web link e. g. www.facebook.com/your_profile/ .','smartfields-facebook-name-placeholder':'@yourfacebookprofile','smartfields-twitter':'Twitter','smartfields-twitter-link-placeholder':'https://twitter.com/yourprofile','smartfields-twitter-link-invalid':'Please enter a valid web link e. g. www.twitter.com/your_profile/ .','smartfields-twitter-name-placeholder':'@yourtwitterprofile','smartfields-linkedin':'LinkedIn','smartfields-linkedin-link-placeholder':'https://linkedin.com/yourprofile','smartfields-linkedin-link-invalid':'Please enter a valid web link e. g. www.linkedin.com/your_profile/ .','smartfields-linkedin-name-placeholder':'yourlinkedinprofile','customize-header':'Customize','customize-home-screen':'Home screen','customize-files':'{0} files','customize-documents':'Documents','customize-templates':'Templates','customize-assets':'Assets','customize-xara-templates':'Xara templates','customize-show-in-home-screen':'Show in home screen','customize-show-to-admins-only':'Show to admins only','customize-show-playbook-folders-to-admins-only':'Show Playbook folders to admins only','customize-editor':'Editor','customize-automatically-save-images-info':'Only the images uploaded by the team admin will be saved. Assets are shared with all team members.','customize-automatically-save-images':'Automatically save images to assets','customize-admins-only-publish-team-docs':'Only admins can publish / delete team documents','customize-admins-only-import-docs':'Only admins can import documents','customize-other':'Other','customize-show-commercial-printing':'Show \'Commercial printing\' in print options','customize-xpressdocs-integration':'Xpressdocs integration','customize-default-print-document-recipient':'Default print document recipient','customize-default-print-document-recipient-info':'This is the default email all team members see, when they send a print document through email','customize-default-print-document-recipient-placeholder':'Enter email address','customize-text-field-save':'Save','customize-default-print-document-recipient-email-invalid':'Please enter a valid email','customize-default-print-document-recipient-email-the-same':'Error: The new email is the same as the current.','subscription-category-cloud':'Cloud','subscription-category-desktop':'Desktop','subscription-tag-desktop-only':'Desktop only','subscription-tag-cloud-only':'Cloud only','subscription-tag-cloud-and-desktop':'Cloud + Desktop','subscription-header':'Billing & Plans','subscription-current-plan':'Your current plan:','subscription-trial':' Trial','subscription-free':'Free (trial expired)','subscription-upgrade-options':'Your upgrade options:','subscription-period-selector-annual':'Yearly','subscription-period-selector-annual-discount':'Up to 45% off','subscription-period-selector-monthly':'Monthly','subscription-period-selector-perpetual':'One-time purchase','subscription-box-per-month':' / mo','subscription-box-yearly':'yearly','subscription-box-monthly':'monthly','subscription-box-billed':'{0}, billed {1}','subscription-box-change-to-this-plan':'Change to this plan','subscription-box-upgrade':'Upgrade','subscription-box-subscribe':'Subscribe now','subscription-box-buy':'Buy now','subscription-box-view-current-plan':'View current plan','subscription-box-view-change-to-yearly-subscription':'Change to yearly subscription','subscription-box-more-info':'More information','subscription-box-less-info':'Less information','subscription-discount-magix':'Magix customer?','subscription-discount-get':'Get discount now','subscription-discount-applied':'{0}% off discount applied to your annual plans.','subscription-discount-applied-perpetual':'{0}% off discount applied to your products.','subscription-discount-applied-perpetual-generic':'Discount has been applied to your products.','subscription-discount-try-another-serial':'Try another serial number','subscription-no-upgrade-options':'No further upgrade options available.<br />Thanks for choosing us!','subscription-not-admin':'You are not an admin of this team. Only admins are authorized to upgrade a subscription.<br />Let your team admin know that you would like to upgrade.','subscription-notify-admin':'Notify team admin','subscription-admin-notified':'Your admin was notified to upgrade the subscription.','subscription-your-current-plan':'Your current plan','subscription-no-access-to-desktop-apps-plus':'Any desktop products you might have activated (Designer Pro+, Photo & Graphic Designer+, Web Designer+)','subscription-no-access-to-desktop-apps-perpetual':'Any desktop products you might have activated (Designer Pro, Photo & Graphic Designer, Web Designer)','subscription-continue-to-use-desktop-apps-plus':'Demo Mode of desktop products you might have activated (Photo & Graphic Designer+, Web Designer+, Designer Pro+)','subscription-continue-to-use-desktop-apps-perpetual':'Demo Mode of desktop products you might have activated (Photo & Graphic Designer, Web Designer, Designer Pro)','subscription-currency':'Currency','subscription-currency-usd':'US Dollar','subscription-currency-gbp':'Pound Sterling','subscription-currency-eur':'Euro','subscription-duration-lifetime':'Lifetime','subscription-total-licenses':'Total licenses','subscription-used-licenses':'{0} out of {1} licenses are in use.','subscription-used-licenses-single-user':'License is in use.','subscription-used-licenses-single-user-not-used':'License is not in use.','subscription-user-licenses-stats':'User licenses: {0} ({1} in use)','subscription-total-users':'Users','subscription-single-user':'Single user','subscription-billing-total':'Billing total','subscription-next-billing-issue-date':'Next billing issue date','subscription-current-billing-period-yearly':'Billed yearly','subscription-current-billing-period-monthly':'Billed monthly','subscription-calculating-renewal':'Calculating...','subscription-current-billing-period-perpetual':'One-time purchase','subscription-cancellation-date':'Subscription will be canceled on {0}','re-subscription-cancellation-date':'You are on a legacy plan. You will lose your discounted pricing once it cancels on {0}','subscription-revoke-cancellation-info':'To revoke cancellation, go to \'View details & manage\' > your plan > \'Remove scheduled cancellation\'.','subscription-undo-cancellation-info-real-estate':'To undo cancellation, click on \'Undo cancellation\' link below, go to \'View details & manage\' > your plan > \'Remove scheduled cancellation\'.','subscription-reactivate-plan-info-real-estate':'To resubscribe click on \'Reactivate plan\' link below.','subscription-renewal-date':'Subscription renewal date','subscription-list-see-all-products':'See all products','subscription-no-products-found':'No products found','subscription-action-view-details-and-manage':'View details & manage','subscription-action-add-more-seats':'Purchase user licenses','subscription-action-update-credit-card':'Update credit card','subscription-action-upgrade':'Upgrade plan','subscription-action-upgrade-now':'Upgrade now','subscription-action-update-seats':'Update seats','subscription-action-talk-to-sales':'Talk to Sales','subscription-action-upgrade-to-brokerage':'Upgrade to Brokerage','subscription-action-downgrade-to-individual-agent':'Downgrade to Individual Plan','subscription-switch-to-yearly-and-save':'Switch to yearly subscription and save up to 45%!','subscription-reactivate-my-plan':'Reactivate my plan ({0})','re-packages-ends-on':'Ends on','subscription-billing-year':'year','subscription-billing-month':'month','subscription-including-vat':'incl. VAT','subscription-plus-vat':'+ VAT if applicable','subscription-payment-methods-accepted':'We accept','subscription-got-questions-general':'Got questions?','subscription-contact-us':'Contact us','subscription-contact-support':'Contact support','subscription-contact-support-message':'Hi Xara team, I have trouble using coupon {0}. It returns an error that says "{1}". Can you help me?','subscription-contact-sales':'Contact sales','subscription-learn-more':'Learn more','subscription-get-a-quote':'Get a quote','subscription-need-a-bulk-discount':'Need Bulk Discount?','subscription-active-offers-cloud':'See all active offers','subscription-active-offers-perpetual':'See all active offers for','subscription-trial-expires-on':'Trial expires on','subscription-trial-you-have-full-access-to':'After that, you will lose full access to','subscription-free-you-can-continue-to-use':'You can continue to use','subscription-xara-cloud-free-plan':'Xara Cloud Free Plan','subscription-xara-cloud':'Xara Cloud','subscription-pending-subscription':'Please wait, updating subscription status...','subscription-confirm-choice-title':'Confirm choice','subscription-confirm-choice-selected':'You have selected','subscription-confirm-choice-licenses-total':'{0} license(s)','subscription-confirm-choice-one-agent':'1 agent','subscription-confirm-choice-users-total':'{0} user(s)','subscription-confirm-choice-users-total-including-free':'{0} users ({1} included for free)','subscription-confirm-choice-12-months-commitment':'12-month commitment','subscription-confirm-choice-agents-total':'{0} agent(s)','subscription-confirm-choice-agents-total-including-free':'{0} agents ({1} included for free)','subscription-confirm-number-of-users-title':'Confirm number of users','subscription-confirm-number-of-users-description':'<p>Your team has {0} users currently, but you want to subscribe with {1} user license(s).</p><p>Please subscribe with no less than {0} user licenses, or reduce the current users on your team.</p>','subscription-reduce-users-title':'Reduce users','subscription-reduce-users-description':'The plan you choose allows you to have up to {0} users without extra cost. Please select what to do with each user.','subscription-reduce-seats-remaining':'You still need to reduce <span>{0}</span> admins / members.','subscription-reduce-about-roles':'About roles','subscription-reduce-action-keep-role':'Keep role','subscription-reduce-action-change-to-guest':'Change to guest','subscription-reduce-action-remove':'Remove','subscription-reduce-reduce-users-action-info-keep-role':'Keep role: user keeps the current role.','subscription-reduce-reduce-users-action-info-change-to-guest':'Change to guest: no access to team files, templates or assets. Can comment and collaborate on selected documents with limited editing capabilities.','subscription-reduce-reduce-users-action-info-remove':'Remove: user will be removed from the team and lose access to everything under this team.','subscription-extra-licenses-title':'Purchase extra licenses','subscription-extra-licenses-quantity-label':'Enter quantity','subscription-extra-licenses-cost-per-license':'{0}{1} for each license.','subscription-extra-licenses-discount-applied':'Discount applied','subscription-extra-licenses-discount-use':'Use a coupon','subscription-extra-licenses-change-coupon':'Change coupon','subscription-extra-users-title':'Purchase user licenses','subscription-extra-users-quantity-label':'Enter quantity','subscription-extra-users-total-users-after-purchase':'Your team will have a total of {0} user licenses.','subscription-extra-users-admin-member-usage':'Each admin / member uses 1 user license.','subscription-extra-users-role-info':'A user can be an admin or a member.','subscription-extra-users-total':'Total','subscription-extra-users-total-until-renewal':'Total until renewal','subscription-extra-users-seat-discount-applied':'discount applied','subscription-extra-users-calculating-total':'Calculating...','subscription-extra-users-error-calculating':'Error fetching data.','subscription-plan-tag-new':'New','subscription-plan-tag-coming-soon':'Coming soon','subscription-plan-tag-current-plan':'Current plan','subscription-ovhcloud-discount':'20% off website hosting plans with OVHcloud','subscription-plan-essential-description':'For teams. Deliver engaging content, always on-brand.','subscription-plan-essential-options-title':'All the features in your free plan, plus...','subscription-plan-essential-options-title-active':'All the features in your current plan, plus...','subscription-plan-essential-includes-1':'3 seats included','subscription-plan-essential-includes-1-tooltip':'Invite up to 2 team members for free','subscription-plan-essential-includes-2':'Unlimited guests included','subscription-plan-essential-bullet-brand-kit-title':'Brand kit & auto-branding','subscription-plan-essential-bullet-brand-kit-description':'Automatically brand your content & keep everyone on-brand by enforcing brand standards.','subscription-plan-essential-bullet-document-resizing-title':'One-click document re-sizing','subscription-plan-essential-bullet-document-resizing-description':'Resize a doc into different formats for other channels.','subscription-plan-essential-bullet-social-media-title':'Publish to all social media channels','subscription-plan-essential-bullet-social-media-description':'Resize a doc into different formats for other channels.','subscription-plan-essential-bullet-ai-title':'AI Social Media Post Writer','subscription-plan-essential-bullet-ai-description':'Generate engaging social media posts tailored to your audience in seconds.','subscription-plan-essential-bullet-shared-assets-title':'Shared Asset Library','subscription-plan-essential-bullet-shared-assets-description':'Store, share and keep all your approved design components','subscription-plan-essential-bullet-import-export-title':'Import & Export PDF, PPT, Word, PNG, JPG, and more.','subscription-plan-essential-bullet-import-export-description':'Edit and improve your brand\'s current documents and designs.','subscription-plan-essential-bullet-try-for-free-title':'Try Xara AI for free','subscription-plan-essential-bullet-try-for-free-description':'<span>100 complimentary credits</span><span>Write high-quality text, fix errors, and translate your content in seconds.</span>','subscription-plan-scale-description':'Scale your brand\'s content, & measure performance.','subscription-plan-scale-description-desktop':'Transform designs into brand experiences and automate marketing workflows with our Cloud Platform','subscription-plan-scale-options-title':'All the features in Essential, plus...','subscription-plan-scale-options-title-desktop':'Pair Designer Pro+ with Xara Cloud:','subscription-plan-scale-includes-1':'3 seats included','subscription-plan-scale-includes-1-tooltip':'Invite up to 2 team members for free','subscription-plan-scale-includes-2':'Unlimited guests included','subscription-plan-scale-tag':'Most productive','subscription-plan-scale-list-main-1':'Work online with Xara Cloud','subscription-plan-scale-list-main-2':'Collaborate with your team','subscription-plan-scale-list-main-3':'Automatically brand content','subscription-plan-scale-list-main-4':'Easily find and manage your content','subscription-plan-scale-list-main-5':'Turn one design into many formats with a click','subscription-plan-scale-list-main-6':'Post directly to all social media channels','subscription-plan-scale-section-ai-title':'XARA AI included','subscription-plan-scale-section-ai-description':'100 credits per month.','subscription-plan-scale-bullet-ai-writter-title':'AI Writer & reviewer','subscription-plan-scale-bullet-ai-writter-description':'Write, review and deliver your marketing in seconds, not hours.','subscription-plan-scale-bullet-ai-translator-title':'AI Translator','subscription-plan-scale-bullet-ai-translator-description':'Immediately localize your content and reach audiences in their language.','subscription-plan-scale-section-collaborate-title':'Collaborate at scale','subscription-plan-scale-bullet-library-title':'Company Template & Asset Library','subscription-plan-scale-bullet-library-description':'Let everyone personalize ready-to-go content with a centralized library of branded templates and assets.','subscription-plan-scale-bullet-template-modification-title':'Define how templates are modified','subscription-plan-scale-bullet-template-modification-description':'Control template modifications with template and object locking.','subscription-plan-scale-bullet-user-roles-title':'Define user roles: Admins, members, guests.','subscription-plan-scale-bullet-user-roles-description':'Assign specific roles and access levels: Admin, Member, or Guest.','subscription-plan-scale-bullet-member-access-title':'Customize what members can see','subscription-plan-scale-bullet-member-access-description':'Manage what types of template member can access','subscription-plan-scale-bullet-approved-media-title':'Work with approved media only','subscription-plan-scale-bullet-approved-media-description':'Ensure brand consistency by using only pre-approved media assets','subscription-plan-scale-bullet-approved-templates-title':'Give your team approved templates','subscription-plan-scale-bullet-approved-templates-description':'Ensure everyone\'s creating on-brand marketing with vetted templates.','subscription-plan-scale-bullet-analytics-title':'Viewer analytics','subscription-plan-scale-bullet-analytics-description':'Publish interactive documents online and gather reader engagement insights.','subscription-plan-scale-section-content-assistance-title':'Template & Content assistance','subscription-plan-scale-bullet-curated-library-title':'Your Template Library Set up by Experts','subscription-plan-scale-bullet-curated-library-description':'Get a professionally curated template library, tailored for your brand and company needs.','subscription-plan-enterprise-description':'Need multiple teams? Enterprise Features? Can\'t find a matching requirement?','subscription-plan-enterprise-includes':'Invite up to 2 teammates for free.','subscription-plan-enterprise-options-title':'All the features in Scale, plus...','subscription-plan-enterprise-price':'Custom','subscription-plan-enterprise-bullet-flexible-pricing-title':'Usage based pricing','subscription-plan-enterprise-bullet-flexible-pricing-description':'Flexible pricing that scales with your team\'s usage.','subscription-plan-enterprise-bullet-unlimited-storage-title':'Unlimited Storage','subscription-plan-enterprise-bullet-unlimited-storage-description':'Store all your assets without any limitations.','subscription-plan-enterprise-bullet-sso-title':'SSO','subscription-plan-enterprise-bullet-sso-description':'Secure single sign-on for simplified access across your organization.','subscription-plan-enterprise-bullet-custom-integration-title':'Custom Integrations','subscription-plan-enterprise-bullet-custom-integration-description':'Integrate seamlessly with your existing enterprise tools.','subscription-plan-enterprise-bullet-multi-team-title':'Multi-team management','subscription-plan-enterprise-bullet-multi-team-description':'Manage multiple teams and projects under one umbrella.','subscription-plan-enterprise-bullet-api-title':'API & White Label Platform','subscription-plan-enterprise-bullet-api-description':'Customize the platform with your branding for a cohesive experience','subscription-plan-enterprise-bullet-playbooks-title':'Custom Playbooks','subscription-plan-enterprise-bullet-playbooks-description':'Automated workflows tailored to your business needs and strategies.','subscription-plan-enterprise-section-self-service-title':'Self-service portal','subscription-plan-enterprise-bullet-campaign-posting-title':'Direct campaign posting & download','subscription-plan-enterprise-bullet-campaign-posting-description':'Deliver ready-to-share content for everyone to post, print and publish effortlessly','subscription-plan-enterprise-bullet-community-campaigns-title':'Community engagement campaigns','subscription-plan-enterprise-bullet-community-campaigns-description':'Increase brand reach, engagement and employee thought leadership.','subscription-plan-enterprise-section-template-assistance-title':'Template & Content assistance','subscription-plan-enterprise-bullet-library-setup-title':'Your Template Library Set up by Experts','subscription-plan-enterprise-bullet-library-setup-description':'Professionally designed templates customized for your brand.','subscription-plan-enterprise-bullet-template-updates-title':'Monthly Template Updates','subscription-plan-enterprise-bullet-template-updates-description':'Keep your content fresh with regular template additions, improvements and requests.','subscription-plan-enterprise-bullet-strategy-definition-title':'Strategy Definition','subscription-plan-enterprise-bullet-strategy-definition-description':'Define your content strategy with expert assistance','subscription-plan-enterprise-bullet-personalized-training-title':'Personalized Training & Onboarding','subscription-plan-enterprise-bullet-personalized-training-description':'Tailored training programs to get your team up to speed quickly','subscription-plan-web-description':'Design and launch websites you are proud of. Unlimited creation and customization without coding hassles.','subscription-plan-web-includes':'Per single user','subscription-plan-web-options-title':'What\'s included?','subscription-plan-web-list-main-1':'Unlimited websites included','subscription-plan-web-list-main-2':'WYSIWYG Drag-and-Drop editor','subscription-plan-web-list-main-3':'Fast & responsive design','subscription-plan-web-list-main-4':'Live prototyping and multi-version creation','subscription-plan-web-list-main-5':'Built-in graphics editor and optimization','subscription-plan-web-list-main-6':'SEO, marketing, and e-commerce tools','subscription-plan-web-list-main-7':'Ever-growing template and asset library','subscription-plan-web-list-main-8':'Google Drive, Dropbox & OneDrive integration','subscription-plan-photo-description':'Combine all your photo editing and illustration tools into one simple workflow.','subscription-plan-photo-includes':'Per single user','subscription-plan-photo-options-title':'What\'s included?','subscription-plan-photo-list-main-1':'Advanced photo manipulation & color correction','subscription-plan-photo-list-main-2':'Multi-layer compositions','subscription-plan-photo-list-main-3':'Background remover & Magic Erasing','subscription-plan-photo-list-main-4':'Intelligent image scaling','subscription-plan-photo-list-main-5':'High-quality vector illustration','subscription-plan-photo-list-main-6':'Infinite undo & redo','subscription-plan-photo-list-main-7':'Ever-growing template, live effects & asset library','subscription-plan-photo-list-main-8':'Google Drive, Dropbox & OneDrive integration','subscription-plan-designer-description':'Create with unlimited flexibility. Desktop publishing, web design, photo-editing, and graphic design – all in one place.','subscription-plan-designer-includes':'Per single user','subscription-plan-designer-options-title':'What\'s included?','subscription-plan-designer-list-main-1':'Unlimited websites included','subscription-plan-designer-list-main-2':'WYSIWYG Drag-and-Drop editor','subscription-plan-designer-list-main-3':'Fast & responsive design','subscription-plan-designer-list-main-4':'Live prototyping and multi-version creation','subscription-plan-designer-list-main-5':'Built-in graphics editor and optimization','subscription-plan-designer-list-main-6':'SEO, marketing, and e-commerce tools','subscription-plan-designer-list-main-7':'Ever-growing template and asset library','subscription-plan-designer-list-main-8':'Google Drive, Dropbox & OneDrive integration','subscription-plan-web-per-description':'Design and customize websites.','subscription-plan-web-per-includes':'Per single user','subscription-plan-web-per-list-main-1':'Fast & responsive web design','subscription-plan-web-per-list-main-2':'Basic set of text, illustration, and photo tools','subscription-plan-web-per-list-main-3':'Publish to any hosting provider','subscription-plan-web-per-list-main-4':'Template library and blocks not included','subscription-plan-web-per-list-main-5':'Released in 2023','subscription-plan-photo-per-description':'Photo editing and illustration tools in one platform.','subscription-plan-photo-per-includes':'Per single user','subscription-plan-photo-per-list-main-1':'Advanced photo editing tools','subscription-plan-photo-per-list-main-2':'Easy, high-quality vector design','subscription-plan-photo-per-list-main-3':'Powerful text tools for design and layout','subscription-plan-photo-per-list-main-4':'Elements (formerly Online Content Catalog) not included','subscription-plan-photo-per-list-main-5':'Released in 2023','subscription-plan-designer-per-description':'One product for all your graphic and web design needs.','subscription-plan-designer-per-includes':'Per single user','subscription-plan-designer-per-list-main-1':'Desktop publishing','subscription-plan-designer-per-list-main-2':'Advanced photo editing','subscription-plan-designer-per-list-main-3':'Vector drawing','subscription-plan-designer-per-list-main-4':'Website Builder (no coding)','subscription-plan-designer-per-list-main-5':'Elements (formerly Online Content Catalog) not included','subscription-plan-designer-per-list-main-6':'Released in 2023','subscription-ribbon-save-money':'save money','subscription-ribbon-creativity':'power up your creativity','subscription-ribbon-popular':'popular','subscription-ribbon-best-value':'best value','subscription-successful-not-found':'Updating, please wait a moment.','subscription-successful-thanks':'Thanks for subscribing!','purchase-successful-thanks':'Thanks for your purchase!','subscription-successful-upgraded-to':'You have successfully upgraded to','subscription-successful-purchased':'You have successfully purchased','subscription-successful-upgraded':'You have successfully upgraded.','subscription-successful-see-plans':'See Billing & Plans','subscription-successful-start-creating':'Start creating','subscription-successful-download-products':'Download product','subscription-successful-activation-email':'Please use <strong>{0}</strong> when activating your product.','subscription-promo-section-apply':'Apply discount','subscription-promo-section-apply-coupon':'apply coupon','subscription-promo-section-applied':'Applied','subscription-coupon-code-placeholder':'COUPON CODE','subscription-saving-regular-price':'Regular price','subscription-saving-you-save':'You save','subscription-amount-per-month':'Month','subscription-amount-per-year':'Year','subscription-your-products-tab':'My Products and Plan','subscription-purchase-options-tab':'Purchase Options','subscription-price-for-number-of-licenses':'for {0} licenses','subscription-billed-annually-as-one-payment-of':'Billed annually as one payment of','subscription-calculating-price':'Please wait, fetching price...','subscription-your-producs-buy-more-licenses':'Purchase extra licenses','saving-subscription-per-year':'You save <strong>{0}</strong> per year on your subscription with your discount.','saving-subscription-per-month':'You save <strong>{0}</strong> per month on your subscription with your discount.','saving-subscription-per-limited-period':'You save <strong>{0}</strong> for limited period with your discount.','saving-subscription-per-year-first-order-only':'You save <strong>{0}</strong> on the first year of your subscription with your discount.','saving-subscription-per-month-first-order-only':'You save <strong>{0}</strong> on the first month of your subscription with your discount.','saving-once-off':'You save <strong>{0}</strong> with your discount.','saving-once-off-per-limited-period':'You save <strong>{0}</strong> with your discount.','subscriptions-modal-fetching-data':'Please wait, updating seats...','subscriptions-modal-updating-users':'Please wait, updating users...','subscriptions-error-unknown':'An unknown error occurred, please try again or contact support.','subscriptions-error-offline':'Error: Cannot reach server. Please check your network connection and try again in a few seconds.','subscriptions-error-invalid-numbers-of-users':'Error: The number of the users cannot be less than the number of users in the company','subscriptions-error-invalid-coupon-code':'Error: Invalid coupon id.','subscriptions-error-failed-to-retrieve-coupon':'Error: Failed to retrieve coupon.','subscriptions-error-coupon-does-not-exist':'Error: Coupon code does not exist.','subscriptions-error-coupon-does-not-qualify-for-any-product':'Error: Coupon does not qualify for any of the products.','subscriptions-error-coupon-does-not-qualify-for-this-product':'Error: Coupon does not qualify for this product.','subscriptions-error-coupon-does-not-qualify-fallback':'This coupon only applies to {0}. We\'ve found a coupon for your selected product: {1}','subscriptions-error-coupon-does-not-qualify-fallback-1':'This coupon only applies to {0}','subscriptions-error-coupon-does-not-qualify-fallback-2':'We\'ve found a coupon for your selected product: {0}','subscriptions-error-coupon-does-not-qualify-view-products':'view products','subscriptions-error-applicable-to-products-in-different-currency':'Coupon qualifies only for products in currency:','subscriptions-error-applicable-to-this-product-in-different-currency':'Coupon qualifies for this products in currency:','subscriptions-error-coupon-code-expired':'Error: Coupon code expired.','subscriptions-error-coupon-code-is-serial-number':'Error: Product serial number is not valid coupon code.','subscriptions-error-coupon-one-time-already-used':'Error: One time coupon has already been used.','subscriptions-error-cannot-replace-existing-coupon':'Error: Another coupon has already been applied to your account. Please contact support to resolve the issue.','subscriptions-error-segment-disabled':'Please contact us at support@xara.com','subscriptions-error-reduce-users-invalid-coupon':'Invalid coupon. Checkout will proceed without coupon being applied.','addons-section-title':'Add-ons','addon-ai-title':'Get More XARA AI Credits','addon-ai-description':'Gives Essential & Scale teams more Xara AI credits.','addon-ai-details':'Add unlimited credits to your Essential or Scale plan for {0}8 per team / month (annually). {0}10 per team / month (monthly)','addon-ai-details-list-1':'Write with AI','addon-ai-details-list-2':'Find and fix grammar, image & document errors','addon-ai-details-list-3':'Improve your writing','addon-ai-details-list-4':'Translate your documents','addon-ai-details-list-5':'Add more credits to your document generator*','addon-ai-details-list-note':'* The Document Generator is available for Real Estate Users on the Scale Plan','addon-cloud-storage-title':'Cloud storage','addon-cloud-storage-description':'Gives Essential & Scale teams more Xara Cloud Storage.','addon-cloud-storage-details':'Starting at {0}5 / 100 GB / month','addon-design-service-title':'Design service','addon-design-service-description':'Professional-looking templates for your marketing activities.','addon-design-service-details':'By request','addon-design-service-tag':'For Real Estate','addon-hosting-title':'OVHcloud Hosting (20% Off)','addon-hosting-description':'Publish Your Website Easily. Xara users get 20% off OVHCloud hosting plans.','addon-hosting-details-list-1':'Domain name and SSL certificate','addon-hosting-details-list-2':'Up to 500GB of storage','addon-hosting-details-list-3':'Email accounts for your domain','addon-hosting-details-subscription':'Web Designer+ and Designer Pro+','addon-hosting-details-perpetual':'Web Designer v20 and Designer Pro v20','addon-hosting-button-label':'Get your discount code','addon-intercom-message-ai':'Hey Xara Team, I\'d like to add unlimited AI Credits to my workspace, can we activate this?','addon-intercom-message-cloud-storage':'Hey Xara Team, I would like to add more storage space to my workspace, how much does it cost?','addon-intercom-message-design-services':'Hey Xara Team, I will need help creating or improving my documents. I\'m in [Enter Industry] and I use [Enter type of content] to reach my clients. Can you get in touch with me?','addon-intercom-message-mls':'Hey Xara Team, I\'m interested in auto-filling my docs with the MLS addon. My MLS is [MLS NAME], it\'s website is [MLS WEBSITE URL], and I have [NUMBER] agents.','discount-modal-title':'Check your eligible discount','discount-modal-email-placeholder':'Enter email for Magix license','discount-modal-email-invalid':'Invalid email address','discount-modal-serial-placeholder':'Enter product serial number','discount-modal-serial-invalid-format':'Serial number is in invalid format.','discount-modal-checking':'Checking your credential','discount-modal-success-title':'Here\'s your {0}% OFF coupon!','discount-modal-success-title-generic':'Here\'s your coupon!','discount-modal-success-message-subscription':'Coupon will be applied automatically when you purchase a subscription plan.','discount-modal-success-message-perpetual':'Coupon will be applied automatically when you purchase a desktop product.','discount-modal-invalid-serial':'This license key doesn\'t look right. Please check and try again.','discount-modal-serial-email-missmatch':'This license key and email address don\'t match. Please check and try again.','discount-modal-error-offline':'Cannot reach server. Please check your network connection and try again in a few seconds.','discount-modal-error-crs-info-request-failed':'Internal Error. Please <a target="_blank" href="https://www.xara.com/contact-us/" underline="always">contact support</a>','discount-modal-error-crs-invalid-credentials':'No credentials found. Please check your information and try again or <a target="_blank" href="https://www.xara.com/contact-us/" underline="always">contact support</a>','discount-modal-error-crs-credentials-already-used':'Discount code has already been used for these credentials.','discount-modal-error-unknown':'An unknown error occurred.','discount-modal-serial-number-format-example':'Serial number needs to be in one of the following formats:','re-packages-slider-title':'How many agents are in your brokerage?','re-packages-slider-subtitle':'Move the slider to adjust your team size and see pricing. All plans require a 12-month commitment.','re-packages-choose-team-size':'Choose a team size to view pricing.','re-packages-per-month':'per month','re-packages-per-agent':'per agent','re-packages-lets-talk':'Let\'s Talk','re-packages-custom-pricing':'Custom pricing for large teams.','re-packages-legend-agent':'{0} agent','re-packages-legend-agents':'{0} agents','re-packages-legend-up-to-agents':'Up to {0} agents','re-packages-legend-label':'Agents','re-packages-legend-click-info':'Click the number to type','re-packages-legend-save-info':'Press Enter to apply, Esc to cancel','package-with-code':'With code','coupon-copied':'Copied!','coupon-copy':'Copy','package-individual-agents-title':'For Individual Agents','package-individual-agents-tag':'Solo agent','package-individual-agents-subtitle':'Everything you need to promote listings and grow your brand.','package-individual-agents-feature-1':'Auto-post listings and expert content daily on Facebook, LinkedIn, and Instagram','package-individual-agents-feature-2':'Automatic marketing campaign generation','package-individual-agents-feature-3':'Unique local expert content, 7 posts per week','package-individual-agents-feature-4':'Branded print materials','package-individual-agents-feature-5':'Send listing email campaigns with 1 click','package-individual-agents-feature-5-description':'Works with: Follow Up Boss, Brevo, Constant Contact','package-individual-agents-feature-6':'Custom designs matching your brand','package-individual-agents-what-you-get-title':'What You Get','package-individual-agents-what-you-get-1':'Every listing marketed across all channels automatically','package-individual-agents-what-you-get-2':'Consistent social presence without daily work','package-individual-agents-what-you-get-3':'Professional brand appearance across all materials','package-individual-agents-what-you-get-4':'More buyer inquiries per listing','package-brokerages-title':'For Brokerages','package-brokerages-tag':'Multiply agent success','package-brokerages-subtitle':'Choose a team size to view pricing.','package-brokerages-section-1-title':'Listing Marketing Automation','package-brokerages-section-1-description':'Help agents sell faster without adding staff or tools.','package-brokerages-section-1-feature-1-title':'Delivers personalized marketing materials for every agent','package-brokerages-section-1-feature-1-description':'Detects new and updated MLS listings automatically.','package-brokerages-section-1-feature-2-title':'Promotes listings across each agent\'s social media profiles','package-brokerages-section-1-feature-3-title':'Includes print-ready flyers, postcards, and mailers for every property','package-brokerages-section-2-title':'Social Media Management','package-brokerages-section-2-description':'Automatically promote your agents\' listings and your brand across every channel.','package-brokerages-section-2-feature-1-title':'Schedules and posts listings for each agent','package-brokerages-section-2-feature-2-title':'Positions agents as experts with curated content','package-brokerages-section-2-feature-3-title':'Agent and agency level profiles','package-brokerages-section-2-feature-4-title':'Central content library','package-brokerages-section-3-title':'Email Marketing','package-brokerages-section-3-description':'Showcase listings and reach more clients with automated emails.','package-brokerages-section-3-feature-1-title':'Branded email templates','package-brokerages-section-3-feature-2-title':'MLS listing email campaigns','package-brokerages-section-3-feature-3-title':'Open and click analytics','package-brokerages-section-4-title':'Brokerage Support','package-brokerages-section-4-description':'Setup, integration, and ongoing help so your team stays focused on sales.','package-brokerages-section-4-feature-1-title':'White glove onboarding','package-brokerages-section-4-feature-2-title':'Integration assistance','package-brokerages-section-4-feature-3-title':'Priority support','package-brokerages-upgrade-intercom-message':"Hi there \uD83D\uDC4B I\u2019d like to buy Xara for my brokerage.\nI currently manage about {0} agents in my brokerage and we'd like to discuss custom pricing.\nMy email is {1}. \nCould someone from sales help me set up a plan for {0} users?",'package-brokerages-downgrade-intercom-message':"Hi there \uD83D\uDC4B I\u2019d like to downgrade from Brokerage to Individual Agent package. My email is {0}. \nCould someone from sales help me with downgrade?",'package-brokerages-downgrade-seats-message':"Hi there \uD83D\uDC4B I\u2019d like to downgrade from {0} to {1} agent(s). My email is {2}. \nCould someone from sales help me with downgrade?",'re-packages-add-more-seats':'Your plan will be updated to {0} seats. Proration applies. Your new price {1}','re-packages-add-more-seats-difference':'Increase my plan from {0} to {1} users.','re-packages-add-more-seats-new-price':'Your new price {0}.','re-packages-next-billing':'Next billing','re-packages-status':'Status','re-packages-status-active':'Active','re-packages-status-cancelled':'Cancelled','re-packages-status-pending-cancellation':'Scheduled cancellation','re-packages-manage-payment-method':'Manage payment method','re-packages-view-invoices':'View invoices','re-packages-cancel-plan':'Cancel plan','re-packages-reactivate-plan':'Reactivate plan','re-packages-plan-disabled':'Not available','re-packages-revoke-cancellation':'Undo cancellation','re-upgrade-to-brokerage-to-add-more-users':'On this plan you can add only Guests. Please upgrade to Brokerage plan to add admins and members.','re-packages-success-purchasing-seats':'Thank you for your purchase! Your seats have been successfully purchased.','download-header':'Download','download-description1':'Take your designs to the next level with our photo editing, illustration, and web design tools.','download-description2':'Get all the capabilities in one place with Designer Pro+.','download-description3':'(Desktop application for Windows only)','download-download':'Download {0}','download-find-out-more':'Find out more','download-you-own-this-product':'You own this product','account-header':'Sign-in details','account-current-password-description':'To make changes, please verify your password','account-current-password-placeholder':'Current password','account-current-password-button':'Verify','account-email-label':'Sign in email ','account-email-placeholder':'Email','account-email-button':'Change Email','account-email-invalid':'Invalid email address','account-email-the-same':'Error: The new email is the same as the current.','account-name-label':'Name ','account-name-first-placeholder':'First name','account-name-last-placeholder':'Last name','account-name-button':'Change Name','account-name-consecutive-spaces':'You may not have multiple consecutive spaces.','account-name-first-leading-trailing-spaces':'You may not have a first name that starts or ends with space.','account-name-last-leading-trailing-spaces':'You may not have a last name that starts or ends with space.','account-password-label':'Password ','account-password-description':'Please choose a password, between {0} and {1} characters long','account-password-placeholder':'New password','account-password-repeat-placeholder':'Repeat new password','account-password-button':'Change Password','account-password-too-short':'Password should have at least {0} characters.','account-password-too-long':'Password should have no more than {0} characters.','account-password-popup-title':'Set password','account-password-popup-message':'For security, Xara Cloud requires you to set a password to make changes to your sign-in details.<br/><br/> Xara Cloud will send an email to {0} to verify your account. You may need to check your spam folder.','account-password-popup-button':'Send Email','account-confirm-email-popup-title':'Confirm your email address','account-confirm-email-popup-message':'We sent an email to <b>{0}</b> with a link. To confirm this change please click the link in the email. Until you do this your account will still use <b>{1}</b>.','account-reset-password-success':'An email has been sent to the provided email address, please check your inbox.','account-reset-password-error':'An error occurred, please reload page and try again. If the problem continues, contact us.','account-new-email-success':'An email has been sent to the new email address, please check your inbox.','account-error-offline':'Error: Cannot reach server. Please check your network connection and try again in a few seconds.','account-error-invalid-password':'Error: The provided password is invalid.','account-error-passwords-not-matching':'Error: The provided passwords do not match.','account-error-password-already-used':'Error: Could not update your password: the new one is the same as the current.','account-error-wrong-password':'Error: The password is incorrect','account-error-email-already-used':'Error: The new email is the same as the current.','account-error-invalid-email-format':'Error: Invalid email format.','account-error-invalid-first-name':'Error: Invalid first name.','account-error-invalid-last-name':'Error: Invalid last name.','account-error-unknown-email':'Error: We couldn\'t find an account with the email you entered.','account-error-email-associated-to-another-user':'Error: New email is already associated to another user.','account-error-notification-service-internal-error':'Error: Failed to send share email to the following email addresses. Please correct the addresses or try again later.','account-error-unknown':'An unknown error occurred, please try again.','contact-sales-form-title':'Contact our Sales Team','contact-sales-form-title-bulk-discount':'Ask for a bulk price','contact-sales-form-first-name':'First name','contact-sales-form-last-name':'Last name','contact-sales-form-company-name':'Company name','contact-sales-form-number-of-users':'Number of users','contact-sales-form-number-of-users-select':'Please select','contact-sales-form-work-email':'Work email','contact-sales-form-job-title':'Job Title','contact-sales-form-phone-number':'Phone number','contact-sales-form-usage-info':'Tell us about your team, workflow, and goals for using Xara Cloud so we can connect you to the best representative.','contact-sales-form-demo-link':'Skip & get on a 1-on-1 DEMO','contact-sales-form-submit':'Submit','contact-sales-email-invalid':'Invalid email address','contact-sales-phone-invalid':'The phone number provided is not valid. Please enter a different number, using numbers and the - + ( ) characters.','contact-sales-please-errors-found-in-the-form':'There\'s an issue with one or more fields.','contact-sales-saving-form':'Please wait, sending data...','contact-sales-error-unknown':'An unknown error occurred.','contact-sales-error-offline':'Cannot reach server. Please check your network connection and try again in a few seconds.','contact-sales-form-success-title':'Speak Soon!','contact-sales-form-success-description':'We got your message and a representative will get in touch soon. If you need a quick 1-on-1 right now, please <a href="#">check our availability here!</a>','mls-connection-header':'MLS connection','mls-connection-popup-header':'Connect MLS','custom-mls-connection-popup-header':'Tell us which MLS you use','mls-add-button':'Add MLS','mls-office-popup-header':'Add MLS office','mls-office-popup-description':'Add an office to <strong>{0}</strong>.<br><br>If you have multiple offices, add one at a time.','mls-manage-agents-popup-header':'Manage agent MLS connection','mls-manage-agents-popup-add-users-1':'Add users','mls-manage-agents-popup-add-users-2':'if they are not yet in the team.','mls-popup-connect':'Connect','mls-popup-submit-request':'Submit connection request','mls-popup-sending-request':'Sending','mls-connection-popup-mls-not-in-the-list':'My MLS is not in the list','mls-popup-contact-us':'Contact us','your-mls-label':'Your MLS','your-mls-placeholder':'Please select or type','mls-connect-with-label':'Connect with','mls-office-id-label':'MLS office ID','mls-agent-id-label':'Agent MLS ID','mls-listing-number-label':'Listing MLS number (optional)','mls-office-id-placeholder':'Enter an MLS office ID','mls-agent-id-placeholder':'Enter your agent MLS ID','mls-office-other-placeholder':'E.g. Office 01, Office 02','mls-listing-number-placeholder':'Enter one listing MLS number to test connection','mls-search-for-agent-placeholder':'Search for user name or email','mls-clear-search':'Clear search','mls-please-select-mls-connection':'Please select MLS connection','mls-popup-saving-form':'Please wait, sending data...','mls-popup-errors-found-in-the-form':'There\'s an issue with one or more fields.','mls-connection-success-screen-title':'MLS connected','mls-connection-success-screen-description':'You can now auto-generate materials in bulk with <strong>Playbooks</strong>.','mls-connection-success-screen-run-playbooks':'Run Playbooks','mls-request-success-screen-title':'We\'ll get in touch!','mls-request-success-screen-description':'Your automated marketing is on its way!<br><br>We will contact you regarding your MLS connection. Keep an eye on your email inbox in the upcoming days.','mls-request-success-screen-got-it':'Got it','mls-request-success-screen-close':'Close','mls-office-success-screen-title':'Office added','mls-office-success-screen-description':'Office <strong>{0}</strong> has been added to <strong>{1}</strong>.','mls-error-manage-agents-screen-title-no-listings-found':'Please check ID validity','mls-error-manage-agents-no-listings-found':'Agent MLS ID <strong>{0}</strong> is saved, but we couldn\'t find any recent listings for this agent in <strong>{1}</strong>.<br><br>As soon as a listing is added for this agent, we\'ll automatically detect it and run Playbooks.','mls-error-manage-agents-no-listings-found-force-addition':'Error saving MLS ID <strong>{0}</strong> in <strong>{1}</strong>.','mls-error-connection-screen-title':'Couldn\'t connect your MLS','mls-error-connection-screen-title-no-listings-found':'Review needed','mls-error-office-screen-title':'Couldn\'t add office','mls-error-screen-contact-for-help-1':'Contact us','mls-error-screen-contact-for-help-2':'if you need help.','mls-error-screen-close':'Close','mls-error-screen-send-to-review':'Send to review','mls-error-screen-back':'Go back','mls-error-screen-confirm':'Confirm','mls-error-screen-remove-mls-id':'Remove MLS ID','mls-error-unknown':'An unknown error occurred, please try again or contact support.','mls-error-offline':'Cannot reach server. Please check your network connection and try again in a few seconds.','mls-error-company-not-found':'Company not found. Please try again or contact support.','mls-error-internal-server-error':'Internal server error. Please try again or contact support.','mls-error-invalid-add-connection-with-office-id-packet':'Bad request. Please try again or contact support.','mls-error-invalid-add-connection-with-agent-id-packet':'Bad request. Please try again or contact support.','mls-error-invalid-add-office-to-connection-packet':'Bad request. Please try again or contact support.','mls-error-invalid-delete-connection-packet':'Bad request. Please try again or contact support.','mls-error-invalid-delete-office-packet':'Bad request. Please try again or contact support.','mls-error-invalid-add-agent-packet':'Bad request. Please try again or contact support.','mls-error-invalid-delete-agent-packet':'Bad request. Please try again or contact support.','mls-error-invalid-edit-agent-packet':'Bad request. Please try again or contact support.','mls-error-invalid-connection-id':'Bad request. Please try again or contact support.','mls-error-invalid-company-id':'Bad request. Please try again or contact support.','mls-error-invalid-user-session':'Invalid user session. Please try again or contact support.','mls-error-connection-not-found':'Error, connection not found. Please try again or contact support.','mls-error-office-not-found':'Error, office not in connection. Please try again or contact support.','mls-error-agent-not-found':'Agent not found. Please try again or contact support.','mls-error-api-key-required':'Missing Real Estate API key','mls-error-agent-mls-id-already-assigned':'This ID is already taken. Contact us if this is your ID.','mls-error-failed-to-list-agents':'Server error. Please try again or contact support.','mls-error-invalid-agent-id-format':'Agent ID format invalid','mls-error-rate-limit-reached':'Maximum number of attempts reached, please contact Xara support.','mls-connection-popup-error-failed-to-load-mls-board-list':'Failed to load MLS config list. Please check your network connection and try again in a few seconds or contact Xara support.','mls-error-loading-mls-data':'MLS data failed to load. Please check your network connection and try again in a few seconds or contact Xara support.','mls-field-error-data-not-loaded':'Error loading data.','mls-error-email-not-verified':'Your email must be verified first. We sent you an email to verify your email address. Please click on the link in email and try again.','mls-error-subscription-needed':'Please upgrade to add more than five connections.','mls-error-connection-limit-reached':'Maximum number of connections reached, please contact Xara support.','mls-popup-no-listings-found':'We couldn\'t find listings','mls-popup-no-listings-found-for-agent':'We couldn\'t find listings for agent MLS ID.','mls-popup-no-listings-found-for-office-id':'We couldn\'t find listings in <strong>{0}</strong> for office ID <strong>{1}</strong>.<br><br>Please check that the correct MLS is selected and the ID is entered exactly (including any prefixes or hyphens).<br><br>If everything looks right, we can review it for you.','mls-popup-no-listings-found-for-agent-id':'We couldn\'t find listings in <strong>{0}</strong> for agent MLS ID <strong>{1}</strong>.<br><br>Please check that the correct MLS is selected and the ID is entered exactly (including any prefixes or hyphens).<br><br>If you know your office ID, click \'Go back\' and enter the office ID.<br><br>If everything looks right, we can review it for you.','mls-error-invalid-mls-board-name':'You provided invalid MLS board.<br><br>Please make sure the information you give is correct and try again.','mls-popup-agent-already-exists':'Agent already exists.','mls-list-loading':'Please wait, loading MLS data...','mls-list-no-mls-connected':'No MLS connected','mls-list-office-name':'Office name','mls-list-office-id':'Office ID','mls-list-office-delete-office':'Delete office','mls-list-add-office':'Add office','mls-list-manage-agents':'Manage agents','mls-connection-removed':'Connection {0} was removed','mls-office-removed':'Office {0} was removed','remove-mls-confirmation-title':'Delete {0}?','remove-mls-confirmation-description':'All agent IDs saved for this MLS across your team will be deleted.<br><br>If you\'re updating the office, add the new one before removing this.','remove-mls-confirmation':'Are you sure you want to delete <strong>{0}</strong>?','remove-office-confirmation':'Are you sure you want to delete office <strong>{0}</strong>?','mls-agents-table-no-users-found':'No users found','mls-agents-table-add-user-to-team':'Add user to team','re-api-error-invalid-mls-connection-config':'Server error: Invalid MLS connection config. Please contact Xara support.','re-api-error-invalid-office-id':'Server error: invalid office ID.','re-api-error-invalid-agent-code':'Server error: Invalid agent code.','re-api-error-invalid-api-key':'Server error: Invalid API key. Please contact Xara support.','re-api-error-re-api-internal-server-error':'API internal server error. Please contact Xara support.','http-error-internal-server-error':'Internal server error. Please contact Xara support.','http-error-mising-company-id':'Error: missing company ID','http-error-missing-user-id':'Error: missing user ID','onboarding-members-title':'Invite your team members!','onboarding-members-email-placeholder':'Email Address','onboarding-members-email-invalid':'Invalid email address','onboarding-members-email-duplicate':'Email is already on the list','onboarding-members-add-more':'Add more','onboarding-members-next':'Next','onboarding-members-skip':'Skip for now','onboarding-members-o-title':'Invite team members','onboarding-members-o-message':'To ensure your team is on the same page and being productive add them now.','onboarding-brandspace-image-alt':'Create a Theme','onboarding-brandspace-title':'Create your first Theme','onboarding-brandspace-text':'Themes automatically apply your style across all the graphics and documents your team creates, to ensure a consistent look and feel.','onboarding-brandspace-skip':'Skip for now','onboarding-brandspace-go-to-style-editor':'Go to theme style editor','onboarding-brandspace-o-title':'Create a Theme','onboarding-brandspace-o-message':'To enable auto branding we recommend setting up a Theme - it takes seconds.','onboarding-congratulations-title':'Congratulations!','onboarding-congratulations-subtitle':'We are ready to go.','onboarding-congratulations-complete-profile1':'Do you want to complete your ','onboarding-congratulations-complete-profile2':'team profile','onboarding-congratulations-skipped-title':'Your team was created successfully!','onboarding-congratulations-skipped-subtitle':'Next steps to enjoy the full power of Xara Cloud for Teams:','onboarding-congratulations-or':'or','onboarding-congratulations-start-creating':'Start creating!','company-create-error-min-max-chars':'Please enter more than 3 characters.','company-create-error-multiple-spaces':'You may not have multiple consecutive spaces.','company-create-error-invalid-name':'This name is already taken, please choose another company name.','showcase-headline1':'Headline 1','showcase-headline2':'Headline 2','showcase-headline3':'Headline 3','showcase-caption':'Caption','showcase-explanation':'Explanation','showcase-body1':'Body 1','showcase-body2':'Body 2','showcase-launch-editor':'Launch Editor','showcase-email-placeholder':'Email Address','showcase-email-value':'example@mail.com','showcase-disabled-placeholder':'Disabled','showcase-disabled-value':'Disabled','showcase-select-placeholder':'Placeholder','showcase-select-option-10':'Ten','showcase-select-option-20':'Twenty','showcase-select-option-30':'Thirty','showcase-multiline-placeholder':'Description','showcase-confirmation-popup':'Confirmation popup','showcase-confirmation-popup-title':'Confirmation','showcase-confirmation-popup-message':'Confirmation message. It may contain HTML, use { __html: [message] } notation.<br />You can show modal by passing the following props:<br /><br />title (optional)<br />message<br />buttons (array of React Components)<br />hideModalOnButtonClick','showcase-confirmation-popup-confirm':'Confirm','showcase-error-popup':'Error popup','showcase-info-link':'Some info','showcase-info-title':'Account types:','showcase-info-text1':'<strong>Admin</strong>: Full admin rights (add member and manage themes).','showcase-info-text2':'<strong>Member</strong>: Full access and management rights to all Themes.','showcase-info-text3':'<strong>Guest</strong>: Can be invited to edit a team document.','showcase-tab1':'Tab 1','showcase-tab2':'Tab 2','showcase-tab3':'Tab 3','showcase-table-head-email':'Email','showcase-table-head-account-type':'Account type','showcase-table-body-email':'example@mail.com','showcase-table-select-option1':'Account type','showcase-table-select-option2':'Admin','showcase-table-select-option3':'Guest','company-selection-modal-select-team':'You are admin of multiple teams. Please select the team you would like to access.','company-selection-modal-selector':'Please select','guest-modal-message':'You are a Guest of the team but you are not an Administrator so cannot manage the team.','guest-modal-message-can-select-different-team':'You can select a different team or create a new team.','guest-modal-create-new-team':'Create new Team','guest-modal-selector':'Please select','upgrade-company-modal-admin-message':'Please select the team you want to upgrade.','upgrade-company-modal-upgrade':'Upgrade','upgrade-company-modal-member-message':'You are a Member of the team but you are not an Administrator so cannot manage the team\'s subscription. You can inform an Admin, select a different team or create a new team to start a subscription.','upgrade-company-modal-create-new-team':'Create new Team','upgrade-company-modal-selector':'Please select','processing-order':'Processing order','wrong-account-title':'Welcome to Xara!','wrong-account-signed-in-title':'You are currently signed in as:','wrong-account-use-existing-account':'Continue with this account','wrong-account-change-account':'Sign out and sign in with a different account','fallback-screen-message':'Oops! Looks like something went wrong. Let\'s try it again!','fallback-screen-message-browser-extension':'A browser extension has crashed and is impacting your use of Xara Workspaces. Please refresh to continue. If this occurs again please disable one or more of your extensions.','fallback-screen-reload':'Reload the application','no-permissions-admin-only':'This section is only available to Team Admins','not-found-title':'Page not found','not-found-message1':'We\'re sorry you didn\'t find what you were looking for.','not-found-message2':'Please use the navigation menu on the left to choose another page.','page-not-available-image-alt':'Sorry, this page is not available.','page-not-available-message':'Sorry, this page is not available.','page-not-available-refresh':'Refresh','error-modal-title':'Xara Cloud just had a hiccup','error-modal-account-confirmation-message':'We sent you a confirmation e-mail to {0}. Please check your inbox. If you\'re still not receiving the email, please check your spam folder to be sure that our emails are not being detected as spam.','error-messages-button-reload':'Reload the application','error-message-unhandled':'Oops! Looks like something went wrong. Let\'s try it again! - {0}','error-message-offline':'Cannot reach server. Please check your network connection and try again in a few seconds.','error-cb-api-rate-limit-reached':'Sorry, the server is busy, please try again in 5 minutes.','error-number-of-users-on-non-paying-account-exceeded':'Please upgrade to invite more than 2 collaborators.','error-message-xhr-failed':'Network request failed, please try again in a few seconds. Contact us immediately if you are unable to continue.','error-message-invalid-company-id-or-company-name':'This team name is already taken. Please enter a different name.','error-message-insufficient-rights':'You do not have permission to make changes. Please contact your administrator.','error-message-company-not-found':'The requested company was not found.','error-message-user-not-validated':'You must confirm your e-mail first.','error-user-not-validated-resend-button':'Resend e-mail','error-message-delete-myself':'You cannot delete yourself!','error-message-invalid-phone-number':'The phone number provided is not valid. Please enter a different number.','error-message-invalid-website-url':'The website provided is not valid. Please enter a valid website format.','error-message-.invalid-company-country':'The country provided is not valid. Please start typing and select an entry from the list.','error-message-invalid-company-industry':'The team industry provided is not valid. Please start typing and select an entry from the list.','error-message-invalid-company-size':'The team size provided is not valid. Please select an entry from the list.','error-message-failed-to-create-company-subscription':'The selected plan is not available at the moment. Please select a different plan.','error-message-discontinued-plan':'The selected plan has been discontinued. Please select a different plan.','error-message-no-active-subscription':'No access without a valid team subscription.','error-message-invalid-cloud-drive-added':'Oops! Looks like your cloud storage is empty. Please, go to your cloud storage and create a folder.','error-message-payment-processing-failed':'Transaction declined, please check the card details entered or contact your card issuer to check that the card is working correctly.','error-message-payment-method-verification-failed':'Transaction declined, please check the card details entered.','error-message-payment-method-not-present':'There is no payment method associated with your account or your credit card has expired.','error-message-payment-gateway-currency-incompatible':'The selected currency is not supported.','error-message-payment-provider-internal-error':'Payment provider internal error, please contact Xara support.','error-message-payment-provider-internal-coupon-error':'Payment provider internal error. Most likely coupon is not valid. Please contact Xara support.','error-message-wrong-font-type-uploaded':'This file format is not supported. Xara Cloud can add the following file types: .ttf .otf.','error-message-checksum-conflict-invalid-font-file':'Sorry, we could not upload this file. The file is corrupted, please upload a different file.','error-message-workspace-name-already-exists':'This name is already taken, please chose another BrandSpace name.','error-message-cloud-storage-item-not-folder':'You cannot add files. Please select a folder.','error-message-cloud-storage-folder-not-writable':'You do not have write permissions for this folder. Please select a different folder.','error-message-company-name-already-exists':'This name is already taken, please choose another team name.','error-message-invalid-company-name':'You may only use characters from A to Z, and 0 to 9 (no spaces and special characters allowed).','error-message-invalid-email':'Invalid email address.','error-message-invalid-workspace-name':'Please use only letters and digits.','error-message-subscription-plan-currency-mismatch':'The selected currency does not match your previous subscription. Please change your currency selection.','error-message-company-already-exists':'This name is already taken, please choose another team name.','error-message-user-already-exists-in-company':'This user already exists.','error-message-domain-already-exists-in-company':'This domain was already added.','error-message-folder-already-exists-in-company':'This folder was already added.','error-message-smart-field-already-exists-in-company':'This SmartField already exists.','error-message-workspace-already-exists-in-company':'This name is already taken, please choose another Theme name.','error-message-user-already-exists-in-workspace':'This user already exists.','error-message-domain-already-exists-in-workspace':'This domain was already added.','error-message-waiting-for-api':'Sorry for the inconvenience, we are currently maintaining Xara Cloud. We will be back and running shortly.','error-message-cb-not-loaded':'Could not load subscription billing library, please try again in a few seconds or see our <a href="{0}" target="_blank">support article</a>. Contact us immediately if you are unable to continue.','error-message-failed-to-get-payment-coupon':'Failed to get payment coupon. Please try again or contact support.','error-message-invalid-coupon-set-id':'Invalid coupon set id. Please try again or contact support.','error-message-invalid-coupon-id':'Invalid coupon id. Please try again or contact support.','error-message-failed-to-create-order-in-payment-gateway':'Error creating order in payment gateway. Please try again or contact support.','error-message-duplicate-coupon-id':'Duplicate coupon id. Please try again or contact support.','error-message-invalid-number-of-users-during-checkout':'The number of the users cannot be less than the number of users in the company'};if(true){!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return exports;}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}else{this[module]=exports;}}).call(this);

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*eslint-disable max-len, quotes*/(function(){var exports={'yes':'Ja','no':'Nein','ok':'OK','cancel':'Abbrechen','save':'Speichern','submit':'Einreichen','delete':'Löschen','replace':'Ersetzen','skip':'Überspringen','close':'Schließen','pay-now':'Jetzt bezahlen','continue':'Weiter','rename':'Umbenennen','upgrade':'Upgrade','great':'Großartig!','more-info':'Mehr Infos','required-field':'Dieses Feld ist erforderlich','leave-page-confirmation':'Sie haben ungespeicherte Änderungen, sind Sie sicher, dass Sie diese Seite verlassen wollen?','leave-page':'Seite verlassen','stay-on-page':'Auf der Seite bleiben','continue-to-checkout':'Weiter zum Checkout','go-back':'Zurückgehen','reduce-users':'Benutzer reduzieren','save-and-continue':'Speichern und fortfahren','and':'und','config-user-roles-admin':'Admin','config-user-roles-member':'Mitglied','config-user-roles-guest':'Gast','top-bar-upgrade-button-day':'Tag','top-bar-upgrade-button-days':'Tage','top-bar-upgrade-button-week':'Woche',// For testing Crowdin integration only.
'main-nav-avatar-alt':'Benutzerprofil','main-nav-change-sign-in-details':'Anmeldedaten ändern','main-nav-team-profile':'Teamprofil','main-nav-users':'Benutzer und Rechte','main-nav-mls-connection':'MLS-Verbindung','main-nav-fonts':'Eigene Schriftarten','main-nav-folders':'Team-Ordner','main-nav-smartfields':'SmartFields','main-nav-customize':'Anpassen','main-nav-subscription':'Abrechnung & Pläne','main-nav-downloads':'Downloads','main-nav-new':'neu','company-profile-header':'Teamprofil','company-profile-description':'Füllen Sie die Informationen zu Ihrem Team aus.','company-profile-description-read-only':'Teaminformationen sind schreibgeschützt, nur Teamadministratoren können sie ändern.','company-profile-team-name':'Teamname','company-profile-team-name-placeholder':'Teamname','company-profile-team-name-taken':'Dieser Name ist bereits vergeben, bitte wählen Sie einen anderen Teamnamen.','company-profile-team-name-length':'Bitte geben Sie mehr als 3 Zeichen ein.','company-profile-team-name-consecutive-spaces':'Es dürfen nicht mehrere aufeinanderfolgende Leerzeichen vorhanden sein.','company-profile-team-name-leading-trailing-spaces':'Sie dürfen keinen Namen haben, der mit einem Leerzeichen beginnt oder endet.','company-profile-email':'Kontakt-E-Mail','company-profile-email-placeholder':'E-Mail-Adresse','company-profile-email-description':'Dies ist die Haupt-E-Mail- und Rechnungsadresse für {0}.','company-profile-email-invalid':'Ungültige E-Mail-Adresse','company-profile-address':'Adresse','company-profile-address1-placeholder':'Adresszeile 1','company-profile-address2-placeholder':'Adresszeile 2','company-profile-city-placeholder':'Stadt','company-profile-region-placeholder':'Staat / Region','company-profile-postcode-placeholder':'Postleitzahl','company-profile-country-placeholder':'Land','company-profile-country-invalid':'Das angegebene Land ist nicht gültig. Bitte beginnen Sie mit der Eingabe und wählen Sie einen Eintrag aus der Liste.','company-profile-phone':'Telefonnummer','company-profile-phone-placeholder':'Telefonnummer','company-profile-phone-invalid':'Die angegebene Rufnummer ist ungültig. Bitte geben Sie eine andere Nummer ein und verwenden Sie Zahlen und die Zeichen - + ( ).','company-profile-website':'Website','company-profile-website-placeholder':'https://www.yourdomain.com','company-profile-website-invalid':'Die angegebene Website ist nicht gültig. Bitte geben Sie ein gültiges Website-Format mit http:// oder https:// ein.','company-profile-industry':'Industrie','company-profile-industry-selector':'Bitte auswählen','company-profile-industry-invalid':'Die angegebene Teambranche ist nicht gültig. Bitte fangen Sie an zu tippen und wählen Sie einen Eintrag aus der Liste.','company-profile-size':'Teamgröße','company-profile-size-selector':'Wählen Sie...','company-profile-language':'Sprache','company-profile-language-selector':'Wählen Sie...','company-profile-updated':'Teamprofil wurde aktualisiert','company-profile-settings-error':'Fehler beim Speichern der Teameinstellungen','users-header':'Benutzer und Berechtigungen','users-description':'Verwalten Sie Benutzer und Berechtigungen.','users-email-placeholder':'E-Mail Adresse eingeben','users-email-error-invalid':'Ungültige E-Mail Adresse.','users-email-error-exists':'Dieser Benutzer existiert bereits.','users-email-already-exists-in-invite-list':'Duplizierter Eintrag.','users-message-empty':'Die Nachricht sollte nicht leer sein.','users-roles-popover-title':'Kontotypen','users-roles-popover-admin':'Admin','users-roles-popover-admin-description':'Vollständige Administratorrechte (Mitglieder hinzufügen und Themen verwalten).','users-roles-popover-member':'Mitglied','users-roles-popover-member-description':'Vollständige Dokumentbearbeitungsfunktionen.','users-roles-popover-guest':'Gast','users-roles-popover-guest-description':'Kann eingeladen werden, ein Teamdokument zu bearbeiten.','users-add':'Benutzer hinzufügen','users-send-invitations':'Einladungen verschicken','users-confirm-role-upgrade':'Sind Sie sicher, dass Sie {0} als Teammitglied hinzufügen möchten?','users-inactive-company-information-1':'Ihr Plan ist abgelaufen. Bitte','users-inactive-company-information-2':'wählen Sie ein Abonnement','users-inactive-company-information-3':'oder','users-inactive-company-information-4':'aktualisieren Sie die Zahlungsdaten','users-inactive-company-information-5':'um sie zu reaktivieren. Kontaktieren Sie uns bei Fragen.','smartfield-photo-picker-upload-photo':'Foto hochladen','smartfield-photo-picker-crop-photo':'Foto ausschneiden','smartfield-photo-picker-crop-photo-drag-prompt':'Ziehen, um Ihr Foto neu zu positionieren','smartfield-photo-picker-remove-photo':'Foto entfernen','users-table-header-name':'Name','users-table-header-photo':'Foto','users-table-header-email':'E-Mail','users-table-header-user-role':'Rolle','users-table-header-last-seen':'Last seen','users-table-header-mls':'MLS-ID','users-table-header-connection-status':'Status der Verbindung','users-table-header-mls-tooltip':'Geben Sie die MLS-IDs der Agenten ein, um Xara optimal nutzen zu können.','users-table-header-mls-tooltip-agents-modal':'Erforderlich für die automatische Playbook-Generierung.<br>Wenn eine gültige ID eingegeben wird, wird die Verbindung zu MLS<br> hergestellt.','users-table-header-select-action':'Aktion auswählen','users-table-name-you':'{0} (Sie)','users-table-enter-agent-mls-id':'Eingabe der MLS-ID des Agenten','users-table-click-to-enter-agent-mls-id':'Klicken Sie zum Eintreten','users-table-mls-no-connections':'Keine MLS-Verbindungen','users-table-mls-id-invalid-value':'Ungültiges Format.','users-table-mls-id-already-used':'Diese MLS-ID wurde bereits verwendet.','users-table-mls-id-done':'Fertig','users-table-mls-id-add':'MLS-ID hinzufügen','users-remove-member-confirmation':'Sind Sie sicher, dass Sie {0} von Ihrer Mitgliederliste entfernen möchten?','users-increase-confirm':'Erhöhen Sie meinen Plan von {0} auf {1} Benutzer.<br/><br/>Der anteilige Betrag ist {2}{3}.','users-complete-team-profile':'Bitte geben Sie Ihrem Team einen Namen, bevor Sie Mitglieder zu Ihrem Team hinzufügen, indem Sie <strong>Teamprofil</strong> verwenden','users-team-profile':'Teamprofil','users-user-added':'Eine E-Mail wurde verschickt, um {0}zu benachrichtigen','users-users-invited':'Eine E-Mail wird an alle {0} Benutzer gesendet, die sich nicht bei Xara angemeldet haben.','users-no-users-invited':'Alle Benutzer sind bereits im Team. Keine E-Mail gesendet.','users-user-role-updated':'Die Rolle wurde geändert','users-user-photo-updated':'Foto wurde aktualisiert','users-user-photo-removed':'Foto wurde entfernt','users-user-photo-update-error':'Beim Hochladen/Aktualisieren der Fotos ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder wenden Sie sich an den Support.','users-user-photo-remove-error':'Beim Entfernen des Fotos ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.','users-user-removed':'{0} wurde entfernt','users-table-header-admins-and-members':'Admins & Mitglieder','users-table-header-guests':'Gäste','users-table-no-guests-found':'Keine Gäste gefunden','users-table-change-sorting-order':'Sortierreihenfolge ändern','users-table-mls-connected':'Verbunden','users-table-mls-not-connected':'Nicht verbunden','users-popup-header':'Benutzer einladen','user-type-all':'Allen','user-type-admins':'Admins','user-type-members':'Mitglieder','user-type-pending':'Ausstehend','user-type-no-invitation':'Keine Einladung verschickt','user-type-invitation-sent':'Einladung verschickt','user-type-type':'Typ: ','user-menu-send-invite':'Einladung verschicken','user-menu-resend-invite':'Einladung erneut senden','user-table-username-pending-prompt':'(Anmeldung ausstehend)','user-table-photo-pending-prompt':'Hochladen nach Anmeldung','user-table-mls-pending-prompt':'Eingabe nach Anmeldung','user-last-login-never':'Nie','user-last-login-just-now':'Gerade jetzt','user-last-login-yesterday':'Gestern','user-last-login-minute':'minute','user-last-login-minutes':'minutes','user-last-login-hour':'hour','user-last-login-hours':'hours','user-last-login-week':'Woche','user-last-login-weeks':'weeks','user-last-login-month':'Monat','user-last-login-months':'Monate','user-last-login-over-a-year':'>12 Months ago','user-last-login-at':'at','users-popup-invite-all':'Alle einladen','users-popup-invitation-email-message-label':'Einladungs-E-Mail-Nachricht:','users-popup-invitation-email-message-value':'(Standard-Einladungsnachricht)','users-popup-new-user-email-address':'E-Mail Adresse eingeben','users-popup-add-another':'Weitere hinzufügen','users-popup-saving-users':'Benutzer werden gespeichert','users-batch-add-error-offline':'Der Server kann nicht erreicht werden. Bitte überprüfen Sie Ihre Netzwerkverbindung und versuchen Sie es in ein paar Sekunden erneut.','users-batch-add-error-unknown':'Ein unbekannter Fehler ist aufgetreten.','users-batch-add-error-cant-modify-users':'Benutzer können nicht geändert werden. Bitte versuchen Sie es erneut. Wenn das Problem weiterhin besteht, kontaktieren Sie uns.','users-batch-add-error-failed-to-add-user-to-company':'Benutzer kann nicht zum Unternehmen hinzugefügt werden. Bitte versuchen Sie es erneut. Wenn das Problem weiterhin besteht, kontaktieren Sie uns.','users-batch-add-error-invalid-user':'Ungültiger Benutzer. Bitte versuchen Sie es erneut. Wenn das Problem weiterhin besteht, kontaktieren Sie uns.','users-batch-add-error-invalid-users':'Ungültige Benutzer. Bitte versuchen Sie es erneut. Wenn das Problem weiterhin besteht, kontaktieren Sie uns.','users-batch-add-error-user-already-exists':'Es existieren bereits einer oder mehrere Benutzer. Bitte versuchen Sie es erneut. Wenn das Problem weiterhin besteht, kontaktieren Sie uns.','users-batch-add-error-plan-prohibits-user-modification':'Abonnementplan verbietet Benutzeränderung','users-external-id-error-invalid-company-id':'Ungültige Unternehmens-ID','users-external-id-error-external-ids-must-be-an-array':'Externe IDs müssen ein Feld sein','users-external-id-error-target-user-not-in-the-company':'Zielbenutzer nicht im Unternehmen','users-external-id-error-failed-to-update-external-id':'Externe IDs konnten nicht aktualisiert werden','users-external-id-error-unknown':'Externe IDs konnten nicht aktualisiert werden. Unbekannter Fehler.','users-external-id-duplicates':'Diese MLS-ID wurde bereits verwendet.','users-please-errors-found-in-the-form':'Bitte korrigieren Sie alle Fehler im Formular.','product-quantity-error':'Ungültige Nummer','product-quantity-licenses-label':'Anzahl der zu kaufenden Lizenzen','product-quantity-users-label':'Anzahl der Benutzerlizenzen','product-quantity-numbers-of-users-reminder':'Zur Erinnerung: Sie haben derzeit {0} Benutzer im Team.','license-info-perpetual':'Installation auf bis zu 2 Geräten mit jeder Lizenz.','license-info-desktop-plus':'Jeder Benutzer kann das Produkt auf bis zu 2 Geräten installieren.','license-info-desktop-plus-extended':'Bei Photo & Graphic Designer+, Web Designer+ und Designer Pro+ kann jeder Benutzer auf bis zu 2 Geräten installieren.','license-info-scale':'Jeder Benutzer kann das Produkt auf bis zu 2 Geräten installieren.','fonts-header':'Eigene Schriftarten','fonts-description':'Laden Sie Ihre Team-Schriften hoch, um sie für das gesamte Team verfügbar zu machen.<br />Xara Cloud kann die folgenden Dateitypen hinzufügen: .ttf .otf.','fonts-upload-button':'Laden Sie Ihre Schriftart hoch','fonts-table-header':'Hochgeladene Team-Schriftarten','fonts-delete-confirmation':'Möchten Sie diese Schriftart löschen?','fonts-font-exists-confirmation':'{0} ist bereits in der Schriftartenliste. Möchten Sie die Datei ersetzen?','fonts-size-exceeded':'Die Schriftdatei, die Sie hochladen wollten, ist größer als die maximale Größe von 20 MB.','fonts-added':'{0} wurde hinzugefügt','fonts-replaced':'{0} wurde ersetzt','fonts-removed':'{0} wurde entfernt','cloud-folders-documents':'Dokumente','cloud-folders-assets':'Assets','base-asset-display-name':'Anzeigename:','documents-description':'<span>Wählen Sie einen Ordner aus Ihrem Cloud-Speicher, um einen zentralen Speicherort für Ihr Team zu erstellen.</span><br/><br/><span>Alle Teammitglieder und Teamadministratoren haben vollen Lese- und Schreibzugriff auf diesen Ordner und alle Unterordner über Xara Cloud.</span>','documents-your-document-folder':'Ihr Dokumentenordner','documents-remove-folder-message':'Möchten Sie diesen Ordner entfernen - {0}','documents-remove-folder-cta':'Ordner entfernen','documents-browse-drives':'Laufwerke durchsuchen','documents-error-limited':'Sie sind auf einen Dokumentenordner beschränkt.<br/>Bitte entfernen Sie den aktuellen Ordner, um einen neuen Ordner hinzuzufügen.','assets-description-not-selected':'Asset-Ordner sind automatische Links in Xara Cloud, mit denen Benutzer Team-Assets wie Logos, Bilder, Diagramme, Grafiken und mehr zu jedem Dokument hinzufügen können.','assets-description-logo':'Wählen Sie einen Ordner aus, der Logos enthält, die Sie mit Ihrem Team teilen möchten.<br/>Unterstützte Dateitypen: png, jpg, jpeg, bmp, tiff, xar, web, svg.','assets-description-image':'Wählen Sie einen Ordner aus, der Bilder enthält, die Sie mit Ihrem Team teilen möchten.<br/>Unterstützte Dateitypen: jpg, jpeg, tiff, png, svg, tif, bmp.','assets-description-component':'Legen Sie zusätzliche Ordner mit Assets an, die Ihr Team häufig verwendet.<br/>Unterstützte Dateitypen: svg, ai, pptx, xar, web.','assets-step-1':'Schritt 1','assets-step-1-description':'Wählen Sie den Typ der Asset-Kategorie.','assets-step-2':'Schritt 2','assets-step-2-description':'Wählen Sie den Cloud-Speicher, in dem sich die Assets befinden.','asset-browse-drives':'Laufwerke durchsuchen','asset-folders':'Ihre {0} Ordner','asset-folder-remove-message':'Möchten Sie diesen Ordner entfernen - {0}?','asset-folder-remove-button-remove':'Ordner entfernen','asset-folder-add-button':'+ Hinzufügen','cloud-browser-shared':'Geteilt','cloud-browser-no-subfolders':'Dieser Ordner enthält keine weiteren Unterordner.','cloud-browser-go-back':' Bitte wählen Sie den Pfeil, um zurückzugehen','cloud-browser-open-button':'Öffnen','cloud-browser-add-button':'+ Hinzufügen','company-create-title':'Wie lautet der Name Ihres Unternehmens?','company-create-placeholder':'Name des Unternehmens','company-create-button':'Erstellen','creator-welcome-title':'Willkommen','creator-welcome-description':'zu Xara für Teams','smartfields-tab':'Team-SmartFields','smartfields-description':'SmartFields werden automatisch auf dynamische Felder angewendet, die in Vorlagen enthalten sind.','smartfields-info':'SmartFields können Ihre Dokumente automatisch mit<br />personalisierten Informationen ausfüllen, darunter Name, Telefonnummer, E-Mail<br />und vieles mehr. Team-Administratoren können <br />intelligente Felder für das Team einrichten, die jeder in ihrem Team verwenden kann.','smartfields-error':'Bitte überprüfen Sie Ihre Angaben','smartfields-team-name':'Teamname','smartfields-team-name-placeholder':'Teamname','smartfields-email':'Kontakt E-Mail','smartfields-email-placeholder':'E-Mail Adresse','smartfields-email-invalid':'Ungültige E-Mail Adresse','smartfields-address':'Adresse','smartfields-address1-placeholder':'Name der Straße','smartfields-city-placeholder':'Stadt','smartfields-region-placeholder':'Staat / Region','smartfields-postcode-placeholder':'Postleitzahl','smartfields-country-placeholder':'Land','smartfields-phone':'Telefonnummer','smartfields-phone-placeholder':'Telefonnummer','smartfields-phone-invalid':'Die angegebene Rufnummer ist ungültig. Bitte geben Sie eine andere Nummer ein und verwenden Sie Zahlen und die Zeichen - + ( ).','smartfields-website':'Website','smartfields-website-placeholder':'https://www.yourdomain.com','smartfields-website-invalid':'Bitte geben Sie einen gültigen Weblink ein.','smartfields-social-link-description':'Link zu Ihrem Profil','smartfields-social-name-description':'Profilname (wird in Vorlagen angezeigt)','smartfields-instagram':'Instagram','smartfields-instagram-link-placeholder':'https://www.instagram.com/yourprofile','smartfields-instagram-link-invalid':'Bitte geben Sie einen gültigen Weblink ein, z.B. www.instagram.com/your_profile/.','smartfields-instagram-name-placeholder':'@IhrInstagramprofil','smartfields-facebook':'Facebook','smartfields-facebook-link-placeholder':'https://facebook.com/yourprofile','smartfields-facebook-link-invalid':'Bitte geben Sie einen gültigen Weblink ein, z.B. www.facebook.com/your_profile/.','smartfields-facebook-name-placeholder':'@IhrFacebookprofil','smartfields-twitter':'Twitter','smartfields-twitter-link-placeholder':'https://twitter.com/yourprofile','smartfields-twitter-link-invalid':'Bitte geben Sie einen gültigen Weblink ein, z.B. www.twitter.com/your_profile/.','smartfields-twitter-name-placeholder':'@ihrtwitterprofil','smartfields-linkedin':'LinkedIn','smartfields-linkedin-link-placeholder':'https://linkedin.com/yourprofile','smartfields-linkedin-link-invalid':'Bitte geben Sie einen gültigen Weblink ein, z.B. www.linkedin.com/your_profile/.','smartfields-linkedin-name-placeholder':'ihrlinkedinprofil','customize-header':'Anpassen','customize-home-screen':'Startbildschirm','customize-files':'{0} Dateien','customize-documents':'Dokumente','customize-templates':'Vorlagen','customize-assets':'Assets','customize-xara-templates':'Xara-Vorlagen','customize-show-in-home-screen':'Im Startbildschirm anzeigen','customize-show-to-admins-only':'Nur für Administratoren anzeigen','customize-show-playbook-folders-to-admins-only':'Playbook-Ordner nur für Administratoren anzeigen','customize-editor':'Editor','customize-automatically-save-images-info':'Es werden nur die vom Teamadministrator hochgeladenen Bilder gespeichert. Assets werden für alle Teammitglieder freigegeben.','customize-automatically-save-images':'Automatisches Speichern von Bildern in Assets','customize-admins-only-publish-team-docs':'Nur Administratoren können Teamdokumente veröffentlichen/löschen','customize-admins-only-import-docs':'Nur Administratoren können Dokumente importieren','customize-other':'Andere','customize-show-commercial-printing':'Kommerzieller Druck" in den Druckoptionen anzeigen','customize-xpressdocs-integration':'Xpressdocs-Integration','customize-default-print-document-recipient':'Standardempfänger für Druckdokumente','customize-default-print-document-recipient-info':'Dies ist die Standard-E-Mail, die alle Teammitglieder sehen, wenn sie ein Druckdokument per E-Mail versenden','customize-default-print-document-recipient-placeholder':'E-Mail Adresse eingeben','customize-text-field-save':'Speichern','customize-default-print-document-recipient-email-invalid':'Bitte geben Sie eine gültige E-Mail ein','customize-default-print-document-recipient-email-the-same':'Fehler: Die neue E-Mail ist die gleiche wie die aktuelle.','subscription-category-cloud':'Cloud','subscription-category-desktop':'Desktop','subscription-tag-desktop-only':'Nur Desktop','subscription-tag-cloud-only':'Nur Cloud','subscription-tag-cloud-and-desktop':'Cloud + Desktop','subscription-header':'Abrechnung & Pläne','subscription-current-plan':'Ihr aktueller Plan:','subscription-trial':' Kostenlose Testversion','subscription-free':' Kostenlos','subscription-upgrade-options':'Ihre Upgrade-Optionen:','subscription-period-selector-annual':'Jährlich','subscription-period-selector-annual-discount':'Bis zu 45% Rabatt','subscription-period-selector-monthly':'Monatlich','subscription-period-selector-perpetual':'Dauerhaft','subscription-box-per-month':' / mo','subscription-box-yearly':'jährlich','subscription-box-monthly':'monatlich','subscription-box-billed':'{0}, in Rechnung gestellt {1}','subscription-box-change-to-this-plan':'Änderung des Plans','subscription-box-upgrade':'Upgrade','subscription-box-subscribe':'Jetzt abonnieren','subscription-box-buy':'Jetzt kaufen','subscription-box-view-current-plan':'Aktuellen Plan anzeigen','subscription-box-view-change-to-yearly-subscription':'Wechsel zum Jahresabonnement','subscription-box-more-info':'Weitere Informationen','subscription-box-less-info':'Weniger Informationen','subscription-discount-magix':'Waren Sie ein Magix-Kunde?','subscription-discount-get':'Jetzt Rabatt erhalten','subscription-discount-applied':'{0}% Rabatt auf Ihre Jahrespläne.','subscription-discount-applied-perpetual':'{0}% Rabatt auf Ihre Produkte.','subscription-discount-applied-perpetual-generic':'Der Rabatt wurde auf Ihre Produkte angewendet.','subscription-discount-try-another-serial':'Versuchen Sie eine andere Seriennummer','subscription-no-upgrade-options':'Keine weiteren Upgrade-Optionen verfügbar.<br />Danke, dass Sie uns gewählt haben!','subscription-not-admin':'Sie sind kein Administrator dieses Teams. Nur Administratoren sind berechtigt, ein Abonnement zu aktualisieren.<br />Teilen Sie Ihrem Team-Administrator mit, dass Sie ein Upgrade durchführen möchten.','subscription-notify-admin':'Teamadministrator benachrichtigen','subscription-admin-notified':'Ihr Administrator wurde benachrichtigt, das Abonnement zu aktualisieren.','subscription-your-current-plan':'Ihr aktueller Plan','subscription-no-access-to-desktop-apps-plus':'Alle Desktop-Produkte, die Sie möglicherweise aktiviert haben (Designer Pro+, Photo & Graphic Designer+, Web Designer+)','subscription-no-access-to-desktop-apps-perpetual':'Alle Desktop-Produkte, die Sie möglicherweise aktiviert haben (Designer Pro, Photo & Graphic Designer, Web Designer)','subscription-continue-to-use-desktop-apps-plus':'Demo-Modus von Desktop-Produkten, die Sie möglicherweise aktiviert haben (Photo & Graphic Designer+, Web Designer+, Designer Pro+)','subscription-continue-to-use-desktop-apps-perpetual':'Demo-Modus von Desktop-Produkten, die Sie möglicherweise aktiviert haben (Photo & Graphic Designer, Web Designer, Designer Pro)','subscription-currency':'Währung','subscription-currency-usd':'US Dollar','subscription-currency-gbp':'Britische Pfund','subscription-currency-eur':'Euro','subscription-duration-lifetime':'lebenszeit','subscription-total-licenses':'Lizenzen insgesamt','subscription-used-licenses':'{0} von {1} Lizenzen werden verwendet.','subscription-used-licenses-single-user':'Die Lizenz ist in Verwendung.','subscription-used-licenses-single-user-not-used':'Die Lizenz ist nicht in Verwendung.','subscription-user-licenses-stats':'Benutzerlizenzen: {0} ({1} in Verwendung)','subscription-total-users':'Benutzer','subscription-single-user':'Einzelner Benutzer','subscription-billing-total':'Gesamtbetrag der Rechnung','subscription-next-billing-issue-date':'Datum der nächsten Rechnungsstellung','subscription-current-billing-period-yearly':'Jährliche Abrechnung','subscription-current-billing-period-monthly':'Monatliche Abrechnung','subscription-calculating-renewal':'Berechnen...','subscription-current-billing-period-perpetual':'Einmaliger Kauf','subscription-cancellation-date':'Abonnement wird gekündigt am {0}','re-subscription-cancellation-date':'Sie haben einen alten Tarif. Sie verlieren Ihren ermäßigten Preis, sobald er auf {0} gekündigt wird.','subscription-revoke-cancellation-info':'Um die Stornierung zu widerrufen, gehen Sie zu "Details anzeigen & verwalten" > Ihr Tarif > "Geplante Stornierung entfernen".','subscription-undo-cancellation-info-real-estate':'Um die Stornierung rückgängig zu machen, klicken Sie unten auf den Link "Stornierung rückgängig machen", gehen Sie zu "Details anzeigen & verwalten" > Ihr Plan > "Geplante Stornierung entfernen".','subscription-reactivate-plan-info-real-estate':'Zum erneuten Anmelden klicken Sie auf den Link \'Plan reaktivieren\'.','subscription-renewal-date':'Datum der Abonnementverlängerung','subscription-list-see-all-products':'Alle Produkte anzeigen','subscription-no-products-found':'Keine Produkte gefunden','subscription-action-view-details-and-manage':'Details ansehen & verwalten','subscription-action-add-more-seats':'Kauf von Benutzerlizenzen','subscription-action-update-credit-card':'Kreditkarte aktualisieren','subscription-action-upgrade':'Upgrade-Plan','subscription-action-upgrade-now':'Jetzt upgraden','subscription-action-update-seats':'Sitze aktualisieren','subscription-action-talk-to-sales':'Mit dem Vertrieb sprechen','subscription-action-upgrade-to-brokerage':'Upgrade auf Brokerage','subscription-action-downgrade-to-individual-agent':'Herabstufung auf individuellen Plan','subscription-switch-to-yearly-and-save':'Wechseln Sie zum Jahresabonnement und sparen Sie bis zu 45%!','subscription-reactivate-my-plan':'Meinen Plan reaktivieren ({0})','re-packages-ends-on':'Endet am','subscription-billing-year':'Jahr','subscription-billing-month':'Monat','subscription-including-vat':'inkl. MwSt.','subscription-plus-vat':'+ MwSt. falls zutreffend','subscription-payment-methods-accepted':'Wir akzeptieren','subscription-got-questions-general':'Haben Sie Fragen?','subscription-contact-us':'Kontaktieren Sie uns','subscription-contact-support':'Kontakt zum Support','subscription-contact-support-message':'Hallo Xara-Team, ich habe Probleme mit dem Coupon {0}. Es wird die Fehlermeldung "{1}" angezeigt. Können Sie mir helfen?','subscription-contact-sales':'Kontakt Vertrieb','subscription-learn-more':'Mehr erfahren','subscription-get-a-quote':'Angebot einholen','subscription-need-a-bulk-discount':'Benötigen Sie einen Mengenrabatt?','subscription-active-offers-cloud':'Alle aktiven Angebote anzeigen','subscription-active-offers-perpetual':'Alle aktiven Angebote anzeigen für','subscription-trial-expires-on':'Die Testphase endet am','subscription-trial-you-have-full-access-to':'Danach verlieren Sie den vollen Zugriff auf','subscription-free-you-can-continue-to-use':'Sie können weiterhin verwenden','subscription-xara-cloud-free-plan':'Xara Cloud Free Plan','subscription-xara-cloud':'Xara Cloud','subscription-pending-subscription':'Bitte warten, Aktualisierung des Abonnementstatus...','subscription-confirm-choice-title':'Auswahl bestätigen','subscription-confirm-choice-selected':'Sie haben ausgewählt','subscription-confirm-choice-licenses-total':'{0} Lizenz(en)','subscription-confirm-choice-one-agent':'1 Agent','subscription-confirm-choice-users-total':'{0} Nutzer(innen)','subscription-confirm-choice-users-total-including-free':'{0} Benutzer ({1} kostenlos enthalten)','subscription-confirm-choice-12-months-commitment':'12-monatige Verpflichtung','subscription-confirm-choice-agents-total':'{0} Agent','subscription-confirm-choice-agents-total-including-free':'{0} Agenten ({1} kostenlos enthalten)','subscription-confirm-number-of-users-title':'Bestätigen Sie die Anzahl der Benutzer','subscription-confirm-number-of-users-description':'<p>Ihr Team hat derzeit {0} Benutzer, aber Sie möchten {1} Benutzerlizenz(en) abonnieren.</p><p>Bitte abonnieren Sie nicht weniger als {0} Benutzerlizenzen, oder reduzieren Sie die Anzahl der aktuellen Benutzer in Ihrem Team.</p>','subscription-reduce-users-title':'Benutzer reduzieren','subscription-reduce-users-description':'Der von Ihnen gewählte Plan erlaubt Ihnen, bis zu {0} Benutzer ohne zusätzliche Kosten zu haben. Bitte wählen Sie aus, was mit jedem Benutzer geschehen soll.','subscription-reduce-seats-remaining':'Sie müssen noch <span>{0}</span> Admins / Mitglieder reduzieren.','subscription-reduce-about-roles':'Über Rollen','subscription-reduce-action-keep-role':'Rolle behalten','subscription-reduce-action-change-to-guest':'Zu Gast wechseln','subscription-reduce-action-remove':'Entfernen','subscription-reduce-reduce-users-action-info-keep-role':'Rolle behalten: Der Benutzer behält seine aktuelle Rolle.','subscription-reduce-reduce-users-action-info-change-to-guest':'Wechsel zu Gast: kein Zugriff auf Teamdateien, Vorlagen oder Assets. Kann ausgewählte Dokumente mit eingeschränkten Bearbeitungsmöglichkeiten kommentieren und gemeinsam bearbeiten.','subscription-reduce-reduce-users-action-info-remove':'Entfernen: Der Benutzer wird aus dem Team entfernt und verliert den Zugriff auf alle Inhalte dieses Teams.','subscription-extra-licenses-title':'Zusätzliche Lizenzen erwerben','subscription-extra-licenses-quantity-label':'Menge eingeben','subscription-extra-licenses-cost-per-license':'{0}{1} für jede Lizenz.','subscription-extra-licenses-discount-applied':'Rabatt angewendet','subscription-extra-licenses-discount-use':'Coupon verwenden','subscription-extra-licenses-change-coupon':'Coupon ändern','subscription-extra-users-title':'Kauf von Benutzerlizenzen','subscription-extra-users-quantity-label':'Menge eingeben','subscription-extra-users-total-users-after-purchase':'Ihr Team verfügt über insgesamt {0} Benutzerlizenzen.','subscription-extra-users-admin-member-usage':'Jeder Administrator/Mitglied verwendet 1 Benutzerlizenz.','subscription-extra-users-role-info':'Ein Benutzer kann ein Administrator oder ein Mitglied sein.','subscription-extra-users-total':'Insgesamt','subscription-extra-users-total-until-renewal':'Insgesamt bis zur Erneuerung','subscription-extra-users-seat-discount-applied':'angewandter Rabatt','subscription-extra-users-calculating-total':'Berechnen...','subscription-extra-users-error-calculating':'Fehler beim Abrufen von Daten.','subscription-plan-tag-new':'Neu','subscription-plan-tag-coming-soon':'Demnächst verfügbar','subscription-plan-tag-current-plan':'Ihr aktueller Plan','subscription-ovhcloud-discount':'20% Rabatt auf Website-Hosting-Pakete mit OVHcloud','subscription-plan-essential-description':'Für Teams. Liefern Sie ansprechende Inhalte, die stets der Marke entsprechen.','subscription-plan-essential-options-title':'Alle Funktionen des kostenlosen Tarifs, plus...','subscription-plan-essential-options-title-active':'Alle Funktionen Ihres aktuellen Tarifs, plus...','subscription-plan-essential-includes-1':'3 Plätze inklusive','subscription-plan-essential-includes-1-tooltip':'Laden Sie bis zu 2 Teammitglieder kostenlos ein','subscription-plan-essential-includes-2':'Unbegrenzte Anzahl von Gästen inklusive','subscription-plan-essential-bullet-brand-kit-title':'Marken-Kit & Auto-Branding','subscription-plan-essential-bullet-brand-kit-description':'Verleihen Sie Ihren Inhalten automatisch einen Markennamen und sorgen Sie dafür, dass alle Beteiligten denselben Markennamen verwenden, indem Sie Markenstandards durchsetzen.','subscription-plan-essential-bullet-document-resizing-title':'Größenänderung des Dokuments mit einem Klick','subscription-plan-essential-bullet-document-resizing-description':'Ändern Sie die Größe eines Dokuments in verschiedene Formate für andere Kanäle.','subscription-plan-essential-bullet-social-media-title':'Veröffentlichung auf allen sozialen Medienkanälen','subscription-plan-essential-bullet-social-media-description':'Ändern Sie die Größe eines Dokuments in verschiedene Formate für andere Kanäle.','subscription-plan-essential-bullet-ai-title':'AI Schreiber von Social-Media-Beiträgen','subscription-plan-essential-bullet-ai-description':'Erstellen Sie in Sekundenschnelle ansprechende Beiträge für soziale Medien, die auf Ihre Zielgruppe zugeschnitten sind.','subscription-plan-essential-bullet-shared-assets-title':'Gemeinsame Asset-Bibliothek','subscription-plan-essential-bullet-shared-assets-description':'Alle genehmigten Entwurfskomponenten speichern, gemeinsam nutzen und aufbewahren','subscription-plan-essential-bullet-import-export-title':'Importieren und exportieren Sie PDF, PPT, Word, PNG, JPG und mehr.','subscription-plan-essential-bullet-import-export-description':'Bearbeiten und verbessern Sie die aktuellen Dokumente und Designs Ihrer Marke.','subscription-plan-essential-bullet-try-for-free-title':'Xara AI kostenlos testen','subscription-plan-essential-bullet-try-for-free-description':'<span>100 kostenlose Credits</span><span>Schreiben Sie hochwertige Texte, korrigieren Sie Fehler und übersetzen Sie Ihre Inhalte in Sekundenschnelle.</span>','subscription-plan-scale-description':'Skalieren Sie die Inhalte Ihrer Marke und messen Sie die Leistung.','subscription-plan-scale-description-desktop':'Verwandeln Sie Designs in Markenerlebnisse und automatisieren Sie Marketingabläufe mit unserer Cloud Plattform','subscription-plan-scale-options-title':'Alle Funktionen von Essential, plus...','subscription-plan-scale-options-title-desktop':'Koppeln Sie Designer Pro+ mit Xara Cloud:','subscription-plan-scale-includes-1':'3 Plätze inklusive','subscription-plan-scale-includes-1-tooltip':'Laden Sie bis zu 2 Teammitglieder kostenlos ein','subscription-plan-scale-includes-2':'Unbegrenzte Anzahl von Gästen inklusive','subscription-plan-scale-tag':'Am produktivsten','subscription-plan-scale-list-main-1':'Online arbeiten mit Xara Cloud','subscription-plan-scale-list-main-2':'Arbeiten Sie mit Ihrem Team zusammen','subscription-plan-scale-list-main-3':'Automatisch Inhalte kennzeichnen','subscription-plan-scale-list-main-4':'Einfaches Auffinden und Verwalten Ihrer Inhalte','subscription-plan-scale-list-main-5':'Verwandeln Sie ein Design mit einem Klick in viele Formate','subscription-plan-scale-list-main-6':'Posten Sie direkt auf allen sozialen Medienkanälen','subscription-plan-scale-section-ai-title':'XARA AI inklusive','subscription-plan-scale-section-ai-description':'100 Credits pro Monat.','subscription-plan-scale-bullet-ai-writter-title':'AI Verfasser & Prüfer','subscription-plan-scale-bullet-ai-writter-description':'Schreiben, prüfen und liefern Sie Ihr Marketing in Sekunden, nicht in Stunden.','subscription-plan-scale-bullet-ai-translator-title':'AI-Übersetzer','subscription-plan-scale-bullet-ai-translator-description':'Lokalisieren Sie Ihre Inhalte sofort und erreichen Sie Ihr Publikum in dessen Sprache.','subscription-plan-scale-section-collaborate-title':'Skalierbare Zusammenarbeit','subscription-plan-scale-bullet-library-title':'Unternehmensvorlage & Asset-Bibliothek','subscription-plan-scale-bullet-library-description':'Lassen Sie jeden Mitarbeiter fertige Inhalte mit einer zentralen Bibliothek von Markenvorlagen und Assets personalisieren.','subscription-plan-scale-bullet-template-modification-title':'Definieren Sie, wie Vorlagen geändert werden','subscription-plan-scale-bullet-template-modification-description':'Kontrollieren Sie Vorlagenänderungen mit Vorlagen- und Objektsperren.','subscription-plan-scale-bullet-user-roles-title':'Definieren Sie Benutzerrollen: Admins, Mitglieder, Gäste.','subscription-plan-scale-bullet-user-roles-description':'Weisen Sie bestimmte Rollen und Zugriffsebenen zu: Admin, Mitglied oder Gast.','subscription-plan-scale-bullet-member-access-title':'Anpassen, was Mitglieder sehen können','subscription-plan-scale-bullet-member-access-description':'Verwalten, auf welche Vorlagentypen Mitglieder zugreifen können','subscription-plan-scale-bullet-approved-media-title':'Arbeiten Sie nur mit zugelassenen Medien','subscription-plan-scale-bullet-approved-media-description':'Sicherstellung der Markenkonsistenz durch Verwendung nur vorab genehmigter Medieninhalte','subscription-plan-scale-bullet-approved-templates-title':'Geben Sie Ihrem Team genehmigte Vorlagen','subscription-plan-scale-bullet-approved-templates-description':'Stellen Sie sicher, dass alle Mitarbeiter mit geprüften Vorlagen markenkonformes Marketing betreiben.','subscription-plan-scale-bullet-analytics-title':'Analyse der Besucher','subscription-plan-scale-bullet-analytics-description':'Veröffentlichen Sie interaktive Dokumente online und sammeln Sie Erkenntnisse über das Engagement der Leser.','subscription-plan-scale-section-content-assistance-title':'Unterstützung bei Vorlagen und Inhalten','subscription-plan-scale-bullet-curated-library-title':'Ihre von Experten eingerichtete Vorlagenbibliothek','subscription-plan-scale-bullet-curated-library-description':'Holen Sie sich eine professionell zusammengestellte Vorlagenbibliothek, die auf Ihre Marke und die Bedürfnisse Ihres Unternehmens zugeschnitten ist.','subscription-plan-enterprise-description':'Brauchen Sie mehrere Teams? Unternehmensfunktionen? Sie können keine passende Anforderung finden?','subscription-plan-enterprise-includes':'Laden Sie bis zu 2 Teamkollegen kostenlos ein.','subscription-plan-enterprise-options-title':'Alle Funktionen von Scale, plus...','subscription-plan-enterprise-price':'Benutzerdefiniert','subscription-plan-enterprise-bullet-flexible-pricing-title':'Verbrauchsabhängige Preisgestaltung','subscription-plan-enterprise-bullet-flexible-pricing-description':'Flexible Preise, die sich nach der Nutzung durch Ihr Team richten.','subscription-plan-enterprise-bullet-unlimited-storage-title':'Unbegrenzter Speicherplatz','subscription-plan-enterprise-bullet-unlimited-storage-description':'Speichern Sie alle Ihre Vermögenswerte ohne jegliche Einschränkungen.','subscription-plan-enterprise-bullet-sso-title':'SSO','subscription-plan-enterprise-bullet-sso-description':'Sicheres Single Sign-On für einen vereinfachten Zugriff in Ihrem Unternehmen.','subscription-plan-enterprise-bullet-custom-integration-title':'Benutzerdefinierte Integrationen','subscription-plan-enterprise-bullet-custom-integration-description':'Nahtlose Integration in Ihre vorhandenen Unternehmenstools.','subscription-plan-enterprise-bullet-multi-team-title':'Verwaltung mehrerer Teams','subscription-plan-enterprise-bullet-multi-team-description':'Verwalten Sie mehrere Teams und Projekte unter einem Dach.','subscription-plan-enterprise-bullet-api-title':'API & White-Label-Plattform','subscription-plan-enterprise-bullet-api-description':'Anpassung der Plattform an Ihr Branding für ein einheitliches Erscheinungsbild','subscription-plan-enterprise-bullet-playbooks-title':'Benutzerdefinierte Playbooks','subscription-plan-enterprise-bullet-playbooks-description':'Automatisierte Workflows, die auf Ihre geschäftlichen Anforderungen und Strategien zugeschnitten sind.','subscription-plan-enterprise-section-self-service-title':'Selbstbedienungsportal','subscription-plan-enterprise-bullet-campaign-posting-title':'Direkte Kampagnenbuchung & Download','subscription-plan-enterprise-bullet-campaign-posting-description':'Bereitstellen von Inhalten, die mühelos gepostet, gedruckt und veröffentlicht werden können','subscription-plan-enterprise-bullet-community-campaigns-title':'Kampagnen zum Engagement in der Gemeinschaft','subscription-plan-enterprise-bullet-community-campaigns-description':'Steigern Sie die Reichweite Ihrer Marke, Ihr Engagement und die Vordenkerrolle Ihrer Mitarbeiter.','subscription-plan-enterprise-section-template-assistance-title':'Unterstützung bei Vorlagen und Inhalten','subscription-plan-enterprise-bullet-library-setup-title':'Ihre von Experten eingerichtete Vorlagenbibliothek','subscription-plan-enterprise-bullet-library-setup-description':'Professionell gestaltete Vorlagen, die auf Ihre Marke zugeschnitten sind.','subscription-plan-enterprise-bullet-template-updates-title':'Monatliche Vorlagenaktualisierungen','subscription-plan-enterprise-bullet-template-updates-description':'Halten Sie Ihre Inhalte mit regelmäßigen Vorlagenergänzungen, Verbesserungen und Anfragen frisch.','subscription-plan-enterprise-bullet-strategy-definition-title':'Strategie Definition','subscription-plan-enterprise-bullet-strategy-definition-description':'Definieren Sie Ihre Content-Strategie mit Unterstützung von Experten','subscription-plan-enterprise-bullet-personalized-training-title':'Personalisiertes Training & Onboarding','subscription-plan-enterprise-bullet-personalized-training-description':'Maßgeschneiderte Schulungsprogramme, um Ihr Team schnell auf den neuesten Stand zu bringen','subscription-plan-web-description':'Entwerfen und erstellen Sie Websites, auf die Sie stolz sein können. Unbegrenzte Erstellung und Anpassung ohne Programmieraufwand.','subscription-plan-web-includes':'Pro Einzelnutzer','subscription-plan-web-options-title':'Was ist inbegriffen?','subscription-plan-web-list-main-1':'Unbegrenzte Anzahl von Websites inklusive','subscription-plan-web-list-main-2':'WYSIWYG Drag-and-Drop-Editor','subscription-plan-web-list-main-3':'Schnelles und reaktionsschnelles Webdesign','subscription-plan-web-list-main-4':'Live-Prototyping und Erstellung mehrerer Versionen','subscription-plan-web-list-main-5':'Integrierter Grafik-Editor und Optimierung','subscription-plan-web-list-main-6':'SEO, Marketing und E-Commerce-Werkzeuge','subscription-plan-web-list-main-7':'Ständig wachsende Vorlagen- und Asset-Bibliothek','subscription-plan-web-list-main-8':'Integration von Google Drive, Dropbox und OneDrive','subscription-plan-photo-description':'Kombinieren Sie alle Ihre Bildbearbeitungs- und Illustrationswerkzeuge in einem einfachen Arbeitsablauf.','subscription-plan-photo-includes':'Pro Einzelnutzer','subscription-plan-photo-options-title':'Was ist inbegriffen?','subscription-plan-photo-list-main-1':'Fortgeschrittene Fotobearbeitung und Farbkorrektur','subscription-plan-photo-list-main-2':'Multilayer-Kompositionen','subscription-plan-photo-list-main-3':'Hintergrundentferner & Magic Erasing','subscription-plan-photo-list-main-4':'Intelligente Bildskalierung','subscription-plan-photo-list-main-5':'Hochwertige Vektorillustration','subscription-plan-photo-list-main-6':'Unendliches Rückgängigmachen und Wiederherstellen','subscription-plan-photo-list-main-7':'Ständig wachsende Vorlagen-, Live-Effekt- und Asset-Bibliothek','subscription-plan-photo-list-main-8':'Integration von Google Drive, Dropbox und OneDrive','subscription-plan-designer-description':'Erstellen Sie mit unbegrenzter Flexibilität. Desktop-Publishing, Webdesign, Fotobearbeitung und Grafikdesign - alles an einem Ort.','subscription-plan-designer-includes':'Pro Einzelnutzer','subscription-plan-designer-options-title':'Was ist inbegriffen?','subscription-plan-designer-list-main-1':'Unbegrenzte Anzahl von Websites inklusive','subscription-plan-designer-list-main-2':'WYSIWYG Drag-and-Drop-Editor','subscription-plan-designer-list-main-3':'Schnelles und reaktionsschnelles Webdesign','subscription-plan-designer-list-main-4':'Live-Prototyping und Erstellung mehrerer Versionen','subscription-plan-designer-list-main-5':'Integrierter Grafik-Editor und Optimierung','subscription-plan-designer-list-main-6':'SEO, Marketing und E-Commerce-Werkzeuge','subscription-plan-designer-list-main-7':'Ständig wachsende Vorlagen- und Asset-Bibliothek','subscription-plan-designer-list-main-8':'Integration von Google Drive, Dropbox und OneDrive','subscription-plan-web-per-description':'Websites entwerfen und anpassen.','subscription-plan-web-per-includes':'Pro Einzelnutzer','subscription-plan-web-per-list-main-1':'Schnelles und reaktionsschnelles Webdesign','subscription-plan-web-per-list-main-2':'Grundausstattung an Text-, Illustrations- und Fotowerkzeugen','subscription-plan-web-per-list-main-3':'Veröffentlichen bei einem beliebigen Hosting-Anbieter','subscription-plan-web-per-list-main-4':'Vorlagenbibliothek und Blöcke nicht enthalten','subscription-plan-web-per-list-main-5':'Veröffentlicht im Jahr 2023','subscription-plan-photo-per-description':'Bildbearbeitungs- und Illustrationswerkzeuge in einer Plattform.','subscription-plan-photo-per-includes':'Pro Einzelnutzer','subscription-plan-photo-per-list-main-1':'Erweiterte Fotobearbeitungswerkzeuge','subscription-plan-photo-per-list-main-2':'Einfaches, hochwertiges Vektordesign','subscription-plan-photo-per-list-main-3':'Leistungsstarke Textwerkzeuge für Design und Layout','subscription-plan-photo-per-list-main-4':'Elements (ehemals Online Content Catalog) nicht enthalten','subscription-plan-photo-per-list-main-5':'Veröffentlicht im Jahr 2023','subscription-plan-designer-per-description':'Ein Produkt für alle Ihre Bedürfnisse im Bereich Grafik- und Webdesign.','subscription-plan-designer-per-includes':'Pro Einzelnutzer','subscription-plan-designer-per-list-main-1':'Desktop-Veröffentlichung','subscription-plan-designer-per-list-main-2':'Erweiterte Fotobearbeitung','subscription-plan-designer-per-list-main-3':'Vektorzeichnung','subscription-plan-designer-per-list-main-4':'Website-Baukasten (keine Kodierung)','subscription-plan-designer-per-list-main-5':'Elements (ehemals Online Content Catalog) nicht enthalten','subscription-plan-designer-per-list-main-6':'Veröffentlicht im Jahr 2023','subscription-ribbon-save-money':'Geld sparen','subscription-ribbon-creativity':'steigern Sie Ihre Kreativität','subscription-ribbon-popular':'beliebt','subscription-ribbon-best-value':'bester Wert','subscription-successful-not-found':'Aktualisierung, bitte warten Sie einen Moment.','subscription-successful-thanks':'Vielen Dank für Ihr Abonnement!','purchase-successful-thanks':'Vielen Dank für Ihren Kauf!','subscription-successful-upgraded-to':'Sie haben erfolgreich ein Upgrade auf','subscription-successful-purchased':'Sie haben erfolgreich erworben','subscription-successful-upgraded':'Sie haben das Upgrade erfolgreich durchgeführt.','subscription-successful-see-plans':'Rechnungen & Pläne ansehen','subscription-successful-start-creating':'Fangen Sie an zu gestalten','subscription-successful-download-products':'Produkt herunterladen','subscription-successful-activation-email':'Bitte verwenden Sie <strong>{0}</strong>, um Ihr Produkt zu aktivieren.','subscription-promo-section-apply':'Anwenden','subscription-promo-section-apply-coupon':'Kupon anwenden','subscription-promo-section-applied':'Angewandt','subscription-coupon-code-placeholder':'COUPON CODE','subscription-saving-regular-price':'Regulärer Preis','subscription-saving-you-save':'Sie speichern','subscription-amount-per-month':'Monat','subscription-amount-per-year':'Jahr','subscription-your-products-tab':'Ihre Produkte','subscription-purchase-options-tab':'Kaufoptionen','subscription-price-for-number-of-licenses':'für {0} Lizenzen','subscription-billed-annually-as-one-payment-of':'Jährlich in Rechnung gestellt als einmalige Zahlung von','subscription-calculating-price':'Bitte warten, der Preis wird abgerufen...\n','subscription-your-producs-buy-more-licenses':'Zusätzliche Lizenzen erwerben','saving-subscription-per-year':'Sie sparen <strong>{0}</strong> pro Jahr mit Ihrem Rabatt auf Ihr Abonnement.','saving-subscription-per-month':'Sie sparen <strong>{0}</strong> pro Monat mit Ihrem Rabatt.','saving-subscription-per-limited-period':'Sie sparen <strong>{0}</strong> für einen begrenzten Zeitraum mit Ihrem Rabatt.','saving-subscription-per-year-first-order-only':'Sie sparen <strong>{0}</strong> im ersten Jahr Ihres Abonnements mit Ihrem Rabatt.','saving-subscription-per-month-first-order-only':'Sie sparen <strong>{0}</strong> im ersten Monat Ihres Abonnements mit Ihrem Rabatt.','saving-once-off':'Sie sparen <strong>{0}</strong> mit Ihrem Rabatt.','saving-once-off-per-limited-period':'Sie sparen <strong>{0}</strong> mit Ihrem Rabatt.','subscriptions-modal-fetching-data':'Bitte warten, Sitzplätze werden aktualisiert...','subscriptions-modal-updating-users':'Bitte warten, Aktualisierung der Benutzer...','subscriptions-error-unknown':'Es ist ein unbekannter Fehler aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.','subscriptions-error-offline':'Fehler: Der Server kann nicht erreicht werden. Bitte überprüfen Sie Ihre Netzwerkverbindung und versuchen Sie es in ein paar Sekunden erneut.','subscriptions-error-invalid-numbers-of-users':'Fehler: Die Anzahl der Benutzer kann nicht kleiner sein als die Anzahl der Benutzer in der Firma','subscriptions-error-invalid-coupon-code':'Fehler: Ungültige Gutschein-Id.','subscriptions-error-failed-to-retrieve-coupon':'Fehler: Gutschein konnte nicht abgerufen werden.','subscriptions-error-coupon-does-not-exist':'Fehler: Der Gutscheincode existiert nicht.','subscriptions-error-coupon-does-not-qualify-for-any-product':'Fehler: Der Coupon ist für keines der Produkte gültig.','subscriptions-error-coupon-does-not-qualify-for-this-product':'Fehler: Der Coupon ist für dieses Produkt nicht gültig.','subscriptions-error-coupon-does-not-qualify-fallback':'Dieser Coupon gilt nur für {0}. Wir haben einen Gutschein für Ihr ausgewähltes Produkt gefunden: {1}','subscriptions-error-coupon-does-not-qualify-fallback-1':'Dieser Coupon gilt nur für {0}','subscriptions-error-coupon-does-not-qualify-fallback-2':'Wir haben einen Gutschein für Ihr ausgewähltes Produkt gefunden: {0}','subscriptions-error-coupon-does-not-qualify-view-products':'Produkte ansehen','subscriptions-error-applicable-to-products-in-different-currency':'Der Coupon gilt nur für Produkte in der jeweiligen Währung:','subscriptions-error-applicable-to-this-product-in-different-currency':'Der Coupon gilt für diese Produkte in der jeweiligen Währung:','subscriptions-error-coupon-code-expired':'Fehler: Gutscheincode ist abgelaufen.','subscriptions-error-coupon-code-is-serial-number':'Fehler: Die Seriennummer des Produkts ist kein gültiger Coupon-Code.','subscriptions-error-coupon-one-time-already-used':'Fehler: Der einmalige Coupon wurde bereits verwendet.','subscriptions-error-cannot-replace-existing-coupon':'Fehler: Ein anderer Coupon wurde bereits auf Ihr Konto angewendet. Bitte kontaktieren Sie den Support, um das Problem zu lösen.','subscriptions-error-segment-disabled':'Bitte kontaktieren Sie uns unter support@xara.com','subscriptions-error-reduce-users-invalid-coupon':'Ungültiger Coupon. Der Checkout wird ohne Anwendung des Coupons fortgesetzt.','addons-section-title':'Add-ons','addon-ai-title':'Mehr XARA AI Credits erhalten','addon-ai-description':'Ermöglicht Essential & Skaliert Teams mehr Xara AI Credits.','addon-ai-details':'Fügen Sie Ihrem Essential- oder Scale-Tarif unbegrenzte Credits hinzu für {0}8 pro Team / Monat (jährlich). {0}10 pro Team / Monat (monatlich)','addon-ai-details-list-1':'Schreiben Sie mit Xara AI','addon-ai-details-list-2':'Finden und korrigieren Sie Grammatik-, Bild- und Dokumentfehler','addon-ai-details-list-3':'Verbessern Sie Ihr Schreiben','addon-ai-details-list-4':'Übersetzen Sie Ihre Dokumente','addon-ai-details-list-5':'Fügen Sie Ihrem Dokumentgenerator weitere Credits hinzu*','addon-ai-details-list-note':'* Der Dokumentengenerator ist für Immobiliennutzer auf der Plattform Scale Plan verfügbar','addon-cloud-storage-title':'Cloud-Speicher','addon-cloud-storage-description':'Ermöglicht Essential & Skaliert Teams mehr Xara AI Credits.','addon-cloud-storage-details':'Ab {0}5 / 100 GB / Monat','addon-design-service-title':'Entwurfsdienstleistung','addon-design-service-description':'Professionell gestaltete Vorlagen für Ihre Marketingaktivitäten.','addon-design-service-details':'Auf Anfrage','addon-design-service-tag':'Für Immobilien','addon-hosting-title':'OVHcloud-Hosting (20% Rabatt)','addon-hosting-description':'Veröffentlichen Sie Ihre Website auf einfache Weise. Xara-Benutzer erhalten 20% Rabatt auf OVHCloud-Hosting-Pläne.','addon-hosting-details-list-1':'Domänenname und SSL-Zertifikat','addon-hosting-details-list-2':'Bis zu 500 GB Speicherplatz','addon-hosting-details-list-3':'E-Mail-Konten für Ihre Domain','addon-hosting-details-subscription':'Web Designer+ und Designer Pro+','addon-hosting-details-perpetual':'Web Designer v20 und Designer Pro v20','addon-hosting-button-label':'Holen Sie sich Ihren Rabattcode','addon-intercom-message-ai':'Hallo Xara-Team, ich möchte meinem Arbeitsbereich unbegrenzte AI-Credits hinzufügen, können wir das aktivieren?','addon-intercom-message-cloud-storage':'Hallo Xara Team, ich würde gerne mehr Speicherplatz zu meinem Arbeitsbereich hinzufügen, wie viel kostet das?','addon-intercom-message-design-services':'Hallo Xara Team, ich brauche Hilfe bei der Erstellung oder Verbesserung meiner Dokumente. Ich bin in [Branche eingeben] und verwende [Art des Inhalts eingeben], um meine Kunden zu erreichen. Können Sie sich mit mir in Verbindung setzen?','addon-intercom-message-mls':'Hallo Xara-Team, ich bin daran interessiert, meine Dokumente mit dem MLS-Addon automatisch auszufüllen. Mein MLS ist [MLS NAME], die Website ist [MLS WEBSITE URL], und ich habe [ANZAHL] Agenten.','discount-modal-title':'Prüfen Sie Ihren Rabattanspruch','discount-modal-email-placeholder':'E-Mail für Magix-Lizenz eingeben','discount-modal-email-invalid':'Ungültige E-Mail Adresse','discount-modal-serial-placeholder':'Seriennummer des Produkts eingeben','discount-modal-serial-invalid-format':'Die Seriennummer hat ein ungültiges Format.','discount-modal-checking':'Überprüfung Ihres Ausweises','discount-modal-success-title':'Hier ist Ihr {0}% OFF-Gutschein!','discount-modal-success-title-generic':'Hier ist Ihr Coupon!','discount-modal-success-message-subscription':'Der Coupon wird automatisch angewendet, wenn Sie einen Abonnementplan kaufen.','discount-modal-success-message-perpetual':'Der Coupon wird beim Kauf eines Desktop-Produkts automatisch angewendet.','discount-modal-invalid-serial':'Dieser Lizenzschlüssel sieht nicht richtig aus. Bitte überprüfen Sie ihn und versuchen Sie es erneut.','discount-modal-serial-email-missmatch':'Dieser Lizenzschlüssel und die E-Mail-Adresse stimmen nicht überein. Bitte überprüfen Sie dies und versuchen Sie es erneut.','discount-modal-error-offline':'Der Server kann nicht erreicht werden. Bitte überprüfen Sie Ihre Netzwerkverbindung und versuchen Sie es in ein paar Sekunden erneut.','discount-modal-error-crs-info-request-failed':'Interner Fehler. Bitte <a target="_blank" href="https://www.xara.com/contact-us/" underline="always">kontaktieren Sie den Support</a>','discount-modal-error-crs-invalid-credentials':'Keine Anmeldeinformationen gefunden. Bitte überprüfen Sie Ihre Angaben und versuchen Sie es erneut oder <a target="_blank" href="https://www.xara.com/contact-us/" underline="always">kontaktieren Sie den Support</a>','discount-modal-error-crs-credentials-already-used':'Der Rabattcode wurde bereits für diese Berechtigungsnachweise verwendet.','discount-modal-error-unknown':'Ein unbekannter Fehler ist aufgetreten.','discount-modal-serial-number-format-example':'Die Seriennummer muss in einem der folgenden Formate vorliegen:','re-packages-slider-title':'Wie viele Agenten sind in Ihrem Unternehmen tätig?','re-packages-slider-subtitle':'Bewegen Sie den Schieberegler, um Ihre Teamgröße anzupassen und die Preise zu sehen. Alle Pläne erfordern eine 12-monatige Verpflichtung.','re-packages-choose-team-size':'Wählen Sie eine Teamgröße, um die Preise anzuzeigen.','re-packages-per-month':'pro Monat','re-packages-per-agent':'pro Agent','re-packages-lets-talk':'Lassen Sie uns reden','re-packages-custom-pricing':'Individuelle Preise für große Teams.','re-packages-legend-agent':'{0} Agent','re-packages-legend-agents':'{0} Agenten','re-packages-legend-up-to-agents':'Bis zu {0} Agenten','re-packages-legend-label':'Agenten','re-packages-legend-click-info':'Klicken Sie auf die Zahl, um sie einzugeben','re-packages-legend-save-info':'Drücken Sie Enter zum Übernehmen, Esc zum Abbrechen','package-with-code':'Mit Code','coupon-copied':'Kopiert!','coupon-copy':'Kopieren','package-individual-agents-title':'Für Einzelagenten','package-individual-agents-tag':'Solo-Agent','package-individual-agents-subtitle':'Alles, was Sie brauchen, um Ihre Inserate zu bewerben und Ihre Marke zu stärken.','package-individual-agents-feature-1':'Tägliches automatisches Veröffentlichen von Angeboten und Experteninhalten auf Facebook, LinkedIn und Instagram','package-individual-agents-feature-2':'Automatische Erstellung von Marketingkampagnen','package-individual-agents-feature-3':'Einzigartige Inhalte für lokale Experten, 7 Beiträge pro Woche','package-individual-agents-feature-4':'Markenspezifische Drucksachen','package-individual-agents-feature-5':'Senden Sie E-Mail-Kampagnen mit 1 Klick','package-individual-agents-feature-5-description':'Arbeitet mit: Follow Up Boss, Brevo, Constant Contact','package-individual-agents-feature-6':'Individuelle Designs passend zu Ihrer Marke','package-individual-agents-what-you-get-title':'Was Sie bekommen','package-individual-agents-what-you-get-1':'Jedes Angebot wird automatisch über alle Kanäle vermarktet','package-individual-agents-what-you-get-2':'Konstante soziale Präsenz ohne tägliche Arbeit','package-individual-agents-what-you-get-3':'Professioneller Markenauftritt in allen Materialien','package-individual-agents-what-you-get-4':'Mehr Käuferanfragen pro Angebot','package-brokerages-title':'Für Immobilienmakler','package-brokerages-tag':'Multiplikation des Erfolgs von Makler','package-brokerages-subtitle':'Wählen Sie eine Teamgröße, um die Preise anzuzeigen.','package-brokerages-section-1-title':'Auflistung Marketing-Automatisierung','package-brokerages-section-1-description':'Helfen Sie Makler, schneller zu verkaufen, ohne zusätzliches Personal oder Tools.','package-brokerages-section-1-feature-1-title':'Liefert personalisierte Marketingmaterialien für jeden Agenten','package-brokerages-section-1-feature-1-description':'Erkennt neue und aktualisierte MLS-Inserate automatisch.','package-brokerages-section-1-feature-2-title':'Förderung von Angeboten über die Profile der einzelnen Agenten in den sozialen Medien','package-brokerages-section-1-feature-3-title':'Enthält druckfertige Flyer, Postkarten und Mailer für jede Immobilie','package-brokerages-section-2-title':'Social Media Manager','package-brokerages-section-2-description':'Bewerben Sie die Angebote Ihrer Agenten und Ihre Marke automatisch auf allen Kanälen.','package-brokerages-section-2-feature-1-title':'Plant und veröffentlicht Angebote für jeden Agenten','package-brokerages-section-2-feature-2-title':'Positionierung von Agenten als Experten mit kuratierten Inhalten','package-brokerages-section-2-feature-3-title':'Profile auf Agenten- und Agenturebene','package-brokerages-section-2-feature-4-title':'Zentrale Inhaltsbibliothek','package-brokerages-section-3-title':'E-Mail-Marketing','package-brokerages-section-3-description':'Präsentieren Sie Ihre Angebote und erreichen Sie mehr Kunden mit automatisierten E-Mails.','package-brokerages-section-3-feature-1-title':'Markenspezifische E-Mail-Vorlagen','package-brokerages-section-3-feature-2-title':'MLS-Listing-E-Mail-Kampagnen','package-brokerages-section-3-feature-3-title':'Öffnen Sie und klicken Sie auf Analytik','package-brokerages-section-4-title':'Brokerage-Unterstützung','package-brokerages-section-4-description':'Einrichtung, Integration und laufende Unterstützung, damit sich Ihr Team auf den Verkauf konzentrieren kann.','package-brokerages-section-4-feature-1-title':'Onboarding mit weißem Handschuh','package-brokerages-section-4-feature-2-title':'Unterstützung bei der Integration','package-brokerages-section-4-feature-3-title':'Vorrangige Unterstützung','package-brokerages-upgrade-intercom-message':"Hallo \uD83D\uDC4B Ich w\xFCrde gerne Xara f\xFCr mein Maklerb\xFCro kaufen.\nIch verwalte derzeit etwa {0} Agenten in meinem Maklerb\xFCro und wir w\xFCrden gerne \xFCber eine individuelle Preisgestaltung sprechen.\nMeine E-Mail-Adresse lautet {1}. \nK\xF6nnte mir jemand aus dem Vertrieb dabei helfen, einen Plan f\xFCr {0} Benutzer zu erstellen?",'package-brokerages-downgrade-intercom-message':"Hallo \uD83D\uDC4B Ich w\xFCrde gerne vom Maklerpaket zum Einzelagentenpaket wechseln. Meine E-Mail lautet {0}. \nK\xF6nnte mir jemand vom Vertrieb bei der Herabstufung helfen?",'package-brokerages-downgrade-seats-message':"Hallo \uD83D\uDC4B Ich w\xFCrde gerne von {0} auf {1} umsteigen. Meine E-Mail lautet {2}. \nK\xF6nnte mir jemand vom Vertrieb bei der Herabstufung helfen?",'re-packages-add-more-seats':'Ihr Plan wird auf {0} Plätze aktualisiert. Es gilt die Proration. Ihr neuer Preis {1}','re-packages-add-more-seats-difference':'Erhöhen Sie meinen Plan von {0} auf {1} Benutzer.','re-packages-add-more-seats-new-price':'Ihr neuer Preis {0}.','re-packages-next-billing':'Nächste Abrechnung','re-packages-status':'Status','re-packages-status-active':'Aktiv','re-packages-status-cancelled':'Abgebrochen','re-packages-status-pending-cancellation':'Planmäßige Annullierung','re-packages-manage-payment-method':'Zahlungsmethode verwalten','re-packages-view-invoices':'Rechnungen ansehen','re-packages-cancel-plan':'Plan stornieren','re-packages-reactivate-plan':'Meinen Plan reaktivieren','re-packages-plan-disabled':'Nicht verfügbar','re-packages-revoke-cancellation':'Stornierung rückgängig machen','re-upgrade-to-brokerage-to-add-more-users':'Mit diesem Plan können Sie nur Gäste hinzufügen. Bitte upgraden Sie auf den Brokerage-Plan, um Admins und Mitglieder hinzuzufügen.','re-packages-success-purchasing-seats':'Vielen Dank für Ihren Kauf! Ihre Plätze wurden erfolgreich gekauft.','download-header':'Herunterladen','download-description1':'Bringen Sie Ihre Entwürfe mit unseren Tools für Fotobearbeitung, Illustration und Webdesign auf die nächste Stufe.','download-description2':'Mit Designer Pro+ erhalten Sie alle Funktionen an einem Ort.','download-description3':'(Desktop-Anwendung nur für Windows)','download-download':'Herunterladen {0}','download-find-out-more':'Weitere Informationen','download-you-own-this-product':'Sie besitzen dieses Produkt','account-header':'Details zur Anmeldung','account-current-password-description':'Um Änderungen vorzunehmen, überprüfen Sie bitte Ihr Passwort','account-current-password-placeholder':'Aktuelles Passwort','account-current-password-button':'Überprüfen Sie','account-email-label':'E-Mail anmelden ','account-email-placeholder':'E-Mail','account-email-button':'E-Mail ändern','account-email-invalid':'Ungültige E-Mail Adresse','account-email-the-same':'Fehler: Die neue E-Mail ist die gleiche wie die aktuelle.','account-name-label':'Name ','account-name-first-placeholder':'Vorname','account-name-last-placeholder':'Nachname','account-name-button':'Namen ändern','account-name-consecutive-spaces':'Es dürfen nicht mehrere aufeinanderfolgende Leerzeichen vorhanden sein.','account-name-first-leading-trailing-spaces':'Sie dürfen keinen Vornamen haben, der mit einem Leerzeichen beginnt oder endet.','account-name-last-leading-trailing-spaces':'Sie dürfen keinen Nachnamen haben, der mit einem Leerzeichen beginnt oder endet.','account-password-label':'Passwort ','account-password-description':'Bitte wählen Sie ein Passwort mit einer Länge zwischen {0} und {1}','account-password-placeholder':'Neues Passwort','account-password-repeat-placeholder':'Neues Passwort wiederholen','account-password-button':'Passwort ändern','account-password-too-short':'Das Passwort sollte mindestens {0} Zeichen enthalten.','account-password-too-long':'Das Passwort sollte nicht mehr als {0} Zeichen enthalten.','account-password-popup-title':'Passwort festlegen','account-password-popup-message':'Aus Sicherheitsgründen müssen Sie in Xara Cloud ein Passwort festlegen, um Änderungen an Ihren Anmeldedaten vorzunehmen.<br/><br/>Xara Cloud sendet eine E-Mail an {0} , um Ihr Konto zu verifizieren. Sie müssen möglicherweise Ihren Spam-Ordner überprüfen.','account-password-popup-button':'E-Mail senden','account-confirm-email-popup-title':'Bestätigen Sie Ihre E-Mail Adresse','account-confirm-email-popup-message':'Wir haben eine E-Mail mit einem Link an <b>{0}</b> geschickt. Um diese Änderung zu bestätigen, klicken Sie bitte auf den Link in der E-Mail. Bis Sie dies tun, wird Ihr Konto weiterhin <b>{1}</b>verwenden.','account-reset-password-success':'Es wurde eine E-Mail an die angegebene E-Mail-Adresse gesendet. Bitte überprüfen Sie Ihren Posteingang.','account-reset-password-error':'Es ist ein Fehler aufgetreten, bitte laden Sie die Seite neu und versuchen Sie es erneut. Wenn das Problem weiterhin besteht, kontaktieren Sie uns.','account-new-email-success':'Es wurde eine E-Mail an die neue E-Mail-Adresse gesendet. Bitte prüfen Sie Ihren Posteingang.','account-error-offline':'Fehler: Der Server kann nicht erreicht werden. Bitte überprüfen Sie Ihre Netzwerkverbindung und versuchen Sie es in ein paar Sekunden erneut.','account-error-invalid-password':'Fehler: Das angegebene Passwort ist ungültig.','account-error-passwords-not-matching':'Fehler: Die angegebenen Passwörter stimmen nicht überein.','account-error-password-already-used':'Fehler: Ihr Passwort konnte nicht aktualisiert werden: Das neue Passwort ist dasselbe wie das aktuelle.','account-error-wrong-password':'Fehler: Das Passwort ist falsch','account-error-email-already-used':'Fehler: Die neue E-Mail ist die gleiche wie die aktuelle.','account-error-invalid-email-format':'Fehler: Ungültiges E-Mail-Format.','account-error-invalid-first-name':'Fehler: Ungültiger Vorname.','account-error-invalid-last-name':'Fehler: Ungültiger Nachname.','account-error-unknown-email':'Fehler: Wir konnten kein Konto mit der von Ihnen eingegebenen E-Mail-Adresse finden.','account-error-email-associated-to-another-user':'Fehler: Die neue E-Mail ist bereits einem anderen Benutzer zugeordnet.','account-error-notification-service-internal-error':'Fehler: Die Freigabe-E-Mail konnte nicht an die folgenden E-Mail-Adressen gesendet werden. Bitte korrigieren Sie die Adressen oder versuchen Sie es später erneut.','account-error-unknown':'Es ist ein unbekannter Fehler aufgetreten, versuchen Sie es bitte noch einmal.','contact-sales-form-title':'Kontakt zu unserem Vertriebsteam','contact-sales-form-title-bulk-discount':'Fragen Sie nach einem Mengenpreis','contact-sales-form-first-name':'Vorname','contact-sales-form-last-name':'Nachname','contact-sales-form-company-name':'Firmenname','contact-sales-form-number-of-users':'Anzahl der Nutzer','contact-sales-form-number-of-users-select':'Bitte auswählen','contact-sales-form-work-email':'Arbeit E-Mail','contact-sales-form-job-title':'Berufsbezeichnung','contact-sales-form-phone-number':'Telefonnummer','contact-sales-form-usage-info':'Erzählen Sie uns etwas über Ihr Team, Ihren Arbeitsablauf und Ihre Ziele bei der Verwendung von Xara Cloud, damit wir Sie mit dem besten Vertreter zusammenbringen können.','contact-sales-form-demo-link':'Überspringen Sie & steigen Sie in ein 1-zu-1-DEMO ein','contact-sales-form-submit':'Einreichen','contact-sales-email-invalid':'Ungültige E-Mail-Adresse','contact-sales-phone-invalid':'Die angegebene Rufnummer ist ungültig. Bitte geben Sie eine andere Nummer ein und verwenden Sie Zahlen und die Zeichen - + ( ).','contact-sales-please-errors-found-in-the-form':'Bitte korrigieren Sie alle Fehler im Formular.','contact-sales-saving-form':'Bitte warten, Daten werden gesendet...','contact-sales-error-unknown':'Ein unbekannter Fehler ist aufgetreten.','contact-sales-error-offline':'Der Server kann nicht erreicht werden. Bitte überprüfen Sie Ihre Netzwerkverbindung und versuchen Sie es in ein paar Sekunden erneut.','contact-sales-form-success-title':'Bald sprechen!','contact-sales-form-success-description':'Wir haben Ihre Nachricht erhalten und ein Mitarbeiter wird sich bald mit Ihnen in Verbindung setzen. Wenn Sie jetzt ein schnelles 1-zu-1 benötigen, <a href="#">prüfen</a> Sie bitte <a href="#">hier unsere Verfügbarkeit!</a>','mls-connection-header':'MLS-Verbindung','mls-connection-popup-header':'MLS verbinden','custom-mls-connection-popup-header':'Sagen Sie uns, welches MLS Sie verwenden','mls-add-button':'MLS hinzufügen','mls-office-popup-header':'MLS-Büro hinzufügen','mls-office-popup-description':'Ein Büro hinzufügen zu <strong>{0}</strong>.<br><br>Wenn Sie mehrere Büros haben, fügen Sie eines nach dem anderen hinzu.','mls-manage-agents-popup-header':'Verwalten der MLS-Verbindung von Agenten','mls-manage-agents-popup-add-users-1':'Benutzer hinzufügen','mls-manage-agents-popup-add-users-2':'wenn sie noch nicht in der Mannschaft sind.','mls-popup-connect':'Verbinden','mls-popup-submit-request':'Verbindungsanfrage abschicken','mls-popup-sending-request':'Senden von','mls-connection-popup-mls-not-in-the-list':'Mein MLS ist nicht auf der Liste','mls-popup-contact-us':'Kontaktieren Sie uns','your-mls-label':'Geben Sie Ihr MLS-System ein','your-mls-placeholder':'Bitte auswählen oder eingeben','mls-connect-with-label':'Verbinden mit','mls-office-id-label':'MLS-Büro-ID','mls-agent-id-label':'Agent MLS ID','mls-listing-number-label':'Listing MLS-Nummer (optional)','mls-office-id-placeholder':'Eingabe einer MLS-Büro-ID','mls-agent-id-placeholder':'Geben Sie die MLS-ID Ihres Agenten ein','mls-office-other-placeholder':'Z.B. Büro 01, Büro 02','mls-listing-number-placeholder':'Geben Sie eine MLS-Nummer ein, um die Verbindung zu testen','mls-search-for-agent-placeholder':'Suche nach Benutzernamen oder E-Mail','mls-clear-search':'Suche löschen','mls-please-select-mls-connection':'Bitte wählen Sie die MLS-Verbindung','mls-popup-saving-form':'Bitte warten, Daten werden gesendet...','mls-popup-errors-found-in-the-form':'Bitte korrigieren Sie alle Fehler im Formular.','mls-connection-success-screen-title':'MLS verbunden','mls-connection-success-screen-description':'Mit <strong>Playbooks</strong> können Sie jetzt Materialien in großen Mengen automatisch generieren.','mls-connection-success-screen-run-playbooks':'Playbooks ausführen','mls-request-success-screen-title':'Wir melden uns bei Ihnen!','mls-request-success-screen-description':'Ihr automatisiertes Marketing ist auf dem Weg!<br><br>Wir werden Sie bezüglich Ihrer MLS-Anbindung kontaktieren. Achten Sie in den nächsten Tagen auf Ihren E-Mail-Posteingang.','mls-request-success-screen-got-it':'Verstanden','mls-request-success-screen-close':'Schließen','mls-office-success-screen-title':'Büro hinzugefügt','mls-office-success-screen-description':'Büro <strong>{0}</strong> wurde hinzugefügt zu <strong>{1}</strong>.','mls-error-manage-agents-screen-title-no-listings-found':'Bitte überprüfen Sie die Gültigkeit Ihrer ID','mls-error-manage-agents-no-listings-found':'Vertreter MLS ID <strong>{0}</strong> ist gespeichert, aber wir konnten keine neuen Inserate für diesen Agenten finden in <strong>{1}</strong>.<br><br>Sobald ein Angebot für diesen Agenten hinzugefügt wird, erkennen wir es automatisch und führen Playbooks aus.','mls-error-manage-agents-no-listings-found-force-addition':'Fehler beim Speichern der MLS-ID <strong>{0}</strong> in <strong>{1}</strong>.','mls-error-connection-screen-title':'Ihr MLS konnte nicht verbunden werden','mls-error-connection-screen-title-no-listings-found':'Überprüfung erforderlich','mls-error-office-screen-title':'Konnte kein Büro hinzufügen','mls-error-screen-contact-for-help-1':'Kontaktieren Sie uns','mls-error-screen-contact-for-help-2':'wenn Sie Hilfe benötigen.','mls-error-screen-close':'Schließen','mls-error-screen-send-to-review':'Zur Überprüfung senden','mls-error-screen-back':'Zurückgehen','mls-error-screen-confirm':'Bestätigen','mls-error-screen-remove-mls-id':'MLS-ID entfernen','mls-error-unknown':'Es ist ein unbekannter Fehler aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.','mls-error-offline':'Der Server kann nicht erreicht werden. Bitte überprüfen Sie Ihre Netzwerkverbindung und versuchen Sie es in ein paar Sekunden erneut.','mls-error-company-not-found':'Unternehmen nicht gefunden. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.','mls-error-internal-server-error':'Interner Serverfehler. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.','mls-error-invalid-add-connection-with-office-id-packet':'Fehlerhafte Anfrage. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.','mls-error-invalid-add-connection-with-agent-id-packet':'Fehlerhafte Anfrage. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.','mls-error-invalid-add-office-to-connection-packet':'Fehlerhafte Anfrage. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.','mls-error-invalid-delete-connection-packet':'Fehlerhafte Anfrage. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.','mls-error-invalid-delete-office-packet':'Fehlerhafte Anfrage. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.','mls-error-invalid-add-agent-packet':'Fehlerhafte Anfrage. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.','mls-error-invalid-delete-agent-packet':'Fehlerhafte Anfrage. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.','mls-error-invalid-edit-agent-packet':'Fehlerhafte Anfrage. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.','mls-error-invalid-connection-id':'Fehlerhafte Anfrage. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.','mls-error-invalid-company-id':'Fehlerhafte Anfrage. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.','mls-error-invalid-user-session':'Ungültige Benutzersitzung. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.','mls-error-connection-not-found':'Fehler, Verbindung nicht gefunden. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.','mls-error-office-not-found':'Fehler, Büro nicht in Verbindung. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.','mls-error-agent-not-found':'Agent nicht gefunden. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.','mls-error-api-key-required':'Fehlender Real Estate API-Schlüssel','mls-error-agent-mls-id-already-assigned':'Diese ID ist bereits vergeben. Kontaktieren Sie uns, wenn dies Ihre ID ist.','mls-error-failed-to-list-agents':'Server-Fehler. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.','mls-error-invalid-agent-id-format':'Agent-ID-Format ungültig','mls-error-rate-limit-reached':'Maximale Anzahl von Versuchen erreicht, bitte kontaktieren Sie den Xara-Support.','mls-connection-popup-error-failed-to-load-mls-board-list':'MLS-Konfigurationsliste konnte nicht geladen werden. Bitte überprüfen Sie Ihre Netzwerkverbindung und versuchen Sie es in ein paar Sekunden erneut oder wenden Sie sich an den Xara-Support.','mls-error-loading-mls-data':'MLS-Daten konnten nicht geladen werden. Bitte überprüfen Sie Ihre Netzwerkverbindung und versuchen Sie es in ein paar Sekunden erneut oder kontaktieren Sie den Xara-Support.','mls-field-error-data-not-loaded':'Fehler beim Laden von Daten.','mls-error-email-not-verified':'Ihre E-Mail muss zuerst verifiziert werden. Wir haben Ihnen eine E-Mail geschickt, um Ihre E-Mail-Adresse zu verifizieren. Bitte klicken Sie auf den Link in der E-Mail und versuchen Sie es erneut.','mls-error-subscription-needed':'Bitte führen Sie ein Upgrade durch, um mehr als fünf Verbindungen hinzufügen zu können.','mls-error-connection-limit-reached':'Maximale Anzahl von Verbindungen erreicht, bitte kontaktieren Sie den Xara-Support.','mls-popup-no-listings-found':'Wir konnten keine Inserate finden','mls-popup-no-listings-found-for-agent':'Wir konnten keine Inserate für Agent MLS ID finden.','mls-popup-no-listings-found-for-office-id':'Wir konnten keine Einträge finden in <strong>{0}</strong> für die Büro-ID <strong>{1}</strong>.<br><br>Bitte überprüfen Sie, ob das richtige MLS ausgewählt und die ID genau eingegeben wurde (einschließlich aller Präfixe oder Bindestriche).<br><br>Wenn alles richtig aussieht, können wir es für Sie überprüfen.','mls-popup-no-listings-found-for-agent-id':'Wir konnten keine Inserate finden in <strong>{0}</strong> für Makler MLS ID <strong>{1}</strong>.<br><br>Bitte überprüfen Sie, ob das richtige MLS ausgewählt und die ID genau eingegeben wurde (einschließlich aller Präfixe oder Bindestriche).<br><br>Wenn Sie Ihre Büro-ID kennen, klicken Sie auf "Zurück" und geben Sie die Büro-ID ein.<br><br>Wenn alles richtig aussieht, können wir es für Sie überprüfen.','mls-error-invalid-mls-board-name':'Sie haben eine ungültige MLS-Karte angegeben.<br><br>Bitte stellen Sie sicher, dass Ihre Angaben korrekt sind und versuchen Sie es erneut.','mls-popup-agent-already-exists':'Agent existiert bereits.','mls-list-loading':'Bitte warten, MLS-Daten werden geladen...','mls-list-no-mls-connected':'Keine MLS-Verbindung','mls-list-office-name':'Name des Büros','mls-list-office-id':'Büro-ID','mls-list-office-delete-office':'Büro löschen','mls-list-add-office':'Büro hinzufügen','mls-list-manage-agents':'Agenten verwalten','mls-connection-removed':'Die Verbindung {0} wurde entfernt.','mls-office-removed':'Büro {0} wurde entfernt','remove-mls-confirmation-title':'{0} löschen?','remove-mls-confirmation-description':'Alle Agenten-IDs, die für dieses MLS in Ihrem Team gespeichert sind, werden gelöscht.<br><br>Wenn Sie das Büro aktualisieren, fügen Sie die neue ID hinzu, bevor Sie diese entfernen.','remove-mls-confirmation':'Sind Sie sicher, dass Sie löschen möchten? <strong>{0}</strong>?','remove-office-confirmation':'Sind Sie sicher, dass Sie das Büro löschen wollen? <strong>{0}</strong>?','mls-agents-table-no-users-found':'Keine Benutzer gefunden','mls-agents-table-add-user-to-team':'Benutzer zum Team hinzufügen','re-api-error-invalid-mls-connection-config':'Server-Fehler: Ungültige MLS-Verbindungskonfiguration. Bitte kontaktieren Sie den Xara-Support.','re-api-error-invalid-office-id':'Serverfehler: Ungültige Büro-ID.','re-api-error-invalid-agent-code':'Server-Fehler: Ungültiger Agentencode.','re-api-error-invalid-api-key':'Server-Fehler: Ungültiger API-Schlüssel. Bitte kontaktieren Sie den Xara-Support.','re-api-error-re-api-internal-server-error':'API interner Serverfehler. Bitte kontaktieren Sie den Xara-Support.','http-error-internal-server-error':'Interner Serverfehler. Bitte kontaktieren Sie den Xara-Support.','http-error-mising-company-id':'Fehler: fehlende Unternehmens-ID','http-error-missing-user-id':'Fehler: fehlende Benutzer-ID','onboarding-members-title':'Laden Sie Ihre Teammitglieder ein!','onboarding-members-email-placeholder':'E-Mail Adresse','onboarding-members-email-invalid':'Ungültige E-Mail Adresse','onboarding-members-email-duplicate':'E-Mail steht bereits auf der Liste','onboarding-members-add-more':'Mehr hinzufügen','onboarding-members-next':'Nächstes','onboarding-members-skip':'Vorerst überspringen','onboarding-members-o-title':'Teammitglieder einladen','onboarding-members-o-message':'Um sicherzustellen, dass Ihr Team auf derselben Seite steht und produktiv ist, fügen Sie sie jetzt hinzu.','onboarding-brandspace-image-alt':'Ein Thema erstellen','onboarding-brandspace-title':'Erstellen Sie Ihr erstes Thema','onboarding-brandspace-text':'Themes wenden Ihren Stil automatisch auf alle Grafiken und Dokumente an, die Ihr Team erstellt, um ein einheitliches Erscheinungsbild zu gewährleisten.','onboarding-brandspace-skip':'Vorerst überspringen','onboarding-brandspace-go-to-style-editor':'Zum Designstil-Editor gehen','onboarding-brandspace-o-title':'Ein Thema erstellen','onboarding-brandspace-o-message':'Um das automatische Branding zu aktivieren, empfehlen wir, ein Thema einzurichten - das dauert nur wenige Sekunden.','onboarding-congratulations-title':'Herzlichen Glückwunsch!','onboarding-congratulations-subtitle':'Wir sind einsatzbereit.','onboarding-congratulations-complete-profile1':'Möchten Sie abschließen, Ihr   ','onboarding-congratulations-complete-profile2':'Teamprofil','onboarding-congratulations-skipped-title':'Ihr Team wurde erfolgreich erstellt!','onboarding-congratulations-skipped-subtitle':'Nächste Schritte, um die volle Leistung von Xara Cloud für Teams zu nutzen:','onboarding-congratulations-or':'oder','onboarding-congratulations-start-creating':'Fangen Sie an zu gestalten!','company-create-error-min-max-chars':'Bitte geben Sie mehr als 3 Zeichen ein.','company-create-error-multiple-spaces':'Es dürfen nicht mehrere aufeinanderfolgende Leerzeichen vorhanden sein.','company-create-error-invalid-name':'Dieser Name ist bereits vergeben, bitte wählen Sie einen anderen Firmennamen.','showcase-headline1':'Überschrift 1','showcase-headline2':'Überschrift 2','showcase-headline3':'Überschrift 3','showcase-caption':'Bildunterschrift','showcase-explanation':'Erläuterung','showcase-body1':'Körper 1','showcase-body2':'Körper 2','showcase-launch-editor':'Editor starten','showcase-email-placeholder':'E-Mail Adresse','showcase-email-value':'example@mail.com','showcase-disabled-placeholder':'Deaktiviert','showcase-disabled-value':'Deaktiviert','showcase-select-placeholder':'Platzhalter','showcase-select-option-10':'Zehn','showcase-select-option-20':'Zwanzig','showcase-select-option-30':'Dreißig','showcase-multiline-placeholder':'Beschreibung','showcase-confirmation-popup':'Bestätigungs-Popup','showcase-confirmation-popup-title':'Bestätigung','showcase-confirmation-popup-message':'Bestätigungsnachricht. Sie kann HTML enthalten, verwenden Sie { __html: [message] } Bezeichnung.<br />Sie können ein Modal anzeigen, indem Sie die folgenden Requisiten übergeben:<br /><br />title (optional)<br />Nachricht<br />Schaltflächen (array of React Components)<br />hideModalOnButtonClick','showcase-confirmation-popup-confirm':'Bestätigen Sie','showcase-error-popup':'Fehler-Popup','showcase-info-link':'Einige Informationen','showcase-info-title':'Kontotypen:','showcase-info-text1':'<strong>Admin</strong>: Volle Adminrechte (Mitglieder hinzufügen und Themen verwalten).','showcase-info-text2':'<strong>Mitglied</strong>: Volle Zugriffs- und Verwaltungsrechte für alle Themen.','showcase-info-text3':'<strong>Gast</strong>: Kann eingeladen werden, ein Teamdokument zu bearbeiten.','showcase-tab1':'Registerkarte 1','showcase-tab2':'Registerkarte 2','showcase-tab3':'Registerkarte 3','showcase-table-head-email':'E-Mail','showcase-table-head-account-type':'Konto-Typ','showcase-table-body-email':'example@mail.com','showcase-table-select-option1':'Konto-Typ','showcase-table-select-option2':'Admin','showcase-table-select-option3':'Gast','company-selection-modal-select-team':'Sie sind Administrator von mehreren Teams. Bitte wählen Sie das Team, auf das Sie zugreifen möchten.','company-selection-modal-selector':'Bitte auswählen','guest-modal-message':'Sie sind ein Gast des Teams, aber Sie sind kein Administrator und können das Team nicht verwalten.','guest-modal-message-can-select-different-team':'Sie können ein anderes Team auswählen oder ein neues Team erstellen.','guest-modal-create-new-team':'Neues Team erstellen','guest-modal-selector':'Bitte auswählen','upgrade-company-modal-admin-message':'Bitte wählen Sie das Team aus, das Sie aktualisieren möchten.','upgrade-company-modal-upgrade':'Upgrade','upgrade-company-modal-member-message':'Sie sind Mitglied des Teams, aber Sie sind kein Administrator und können daher das Abonnement des Teams nicht verwalten. Sie können einen Administrator informieren, ein anderes Team auswählen oder ein neues Team erstellen, um ein Abonnement zu starten.','upgrade-company-modal-create-new-team':'Neues Team erstellen','upgrade-company-modal-selector':'Bitte auswählen','processing-order':'Auftragsbearbeitung','wrong-account-title':'Willkommen bei Xara!','wrong-account-signed-in-title':'Sie sind derzeit angemeldet als:','wrong-account-use-existing-account':'Weiter mit diesem Konto','wrong-account-change-account':'Abmelden und mit einem anderen Konto anmelden','fallback-screen-message':'Ups! Sieht aus, als wäre etwas schief gelaufen. Versuchen wir es noch einmal!','fallback-screen-message-browser-extension':'Eine Browsererweiterung ist abgestürzt und beeinträchtigt Ihre Nutzung von Xara Workspaces. Bitte aktualisieren Sie, um fortzufahren. Wenn dies erneut auftritt, deaktivieren Sie bitte eine oder mehrere Ihrer Erweiterungen.','fallback-screen-reload':'Laden Sie die Anwendung neu','no-permissions-admin-only':'Dieser Bereich ist nur für Teamadministratoren zugänglich','not-found-title':'Seite nicht gefunden','not-found-message1':'Es tut uns leid, dass Sie nicht gefunden haben, was Sie suchten.','not-found-message2':'Bitte verwenden Sie das Navigationsmenü auf der linken Seite, um eine andere Seite auszuwählen.','page-not-available-image-alt':'Diese Seite ist leider nicht verfügbar.','page-not-available-message':'Diese Seite ist leider nicht verfügbar.','page-not-available-refresh':'Aktualisieren','error-modal-title':'Xara Cloud hatte gerade einen Fehler','error-modal-account-confirmation-message':'Wir haben Ihnen eine Bestätigungs-E-Mail an {0}geschickt. Bitte überprüfen Sie Ihren Posteingang. Wenn Sie die E-Mail immer noch nicht erhalten, überprüfen Sie bitte Ihren Spam-Ordner, um sicherzustellen, dass unsere E-Mails nicht als Spam erkannt werden.','error-messages-button-reload':'Laden Sie die Anwendung neu','error-message-unhandled':'Ups! Sieht aus, als wäre etwas schief gelaufen. Versuchen wir es noch einmal! - {0}','error-message-offline':'Der Server kann nicht erreicht werden. Bitte überprüfen Sie Ihre Netzwerkverbindung und versuchen Sie es in ein paar Sekunden erneut.','error-cb-api-rate-limit-reached':'Entschuldigung, der Server ist ausgelastet, bitte versuchen Sie es in 5 Minuten erneut.','error-number-of-users-on-non-paying-account-exceeded':'Bitte upgraden, um mehr als 2 Mitarbeiter einzuladen.','error-message-xhr-failed':'Netzwerkanfrage fehlgeschlagen, bitte versuchen Sie es in ein paar Sekunden erneut. Kontaktieren Sie uns sofort, wenn Sie nicht fortfahren können.','error-message-invalid-company-id-or-company-name':'Dieser Teamname ist bereits vergeben. Bitte geben Sie einen anderen Namen ein.','error-message-insufficient-rights':'Sie sind nicht berechtigt, Änderungen vorzunehmen. Bitte wenden Sie sich an Ihren Administrator.','error-message-company-not-found':'Das gesuchte Unternehmen wurde nicht gefunden.','error-message-user-not-validated':'Sie müssen Ihre E-Mail zunächst bestätigen.','error-user-not-validated-resend-button':'E-Mail erneut senden','error-message-delete-myself':'Sie können sich nicht selbst löschen!','error-message-invalid-phone-number':'Die angegebene Rufnummer ist ungültig. Bitte geben Sie eine andere Nummer ein.','error-message-invalid-website-url':'Die angegebene Website ist nicht gültig. Bitte geben Sie ein gültiges Website-Format ein.','error-message-.invalid-company-country':'Das angegebene Land ist nicht gültig. Bitte beginnen Sie mit der Eingabe und wählen Sie einen Eintrag aus der Liste.','error-message-invalid-company-industry':'Die angegebene Teambranche ist nicht gültig. Bitte fangen Sie an zu tippen und wählen Sie einen Eintrag aus der Liste.','error-message-invalid-company-size':'Die angegebene Teamgröße ist nicht gültig. Bitte wählen Sie einen Eintrag aus der Liste.','error-message-failed-to-create-company-subscription':'Der gewählte Tarif ist im Moment nicht verfügbar. Bitte wählen Sie einen anderen Tarif.','error-message-discontinued-plan':'Der ausgewählte Tarif wurde eingestellt. Bitte wählen Sie einen anderen Tarif.','error-message-no-active-subscription':'Kein Zugang ohne gültiges Team-Abonnement.','error-message-invalid-cloud-drive-added':'Huch! Sieht so aus, als wäre Ihr Cloud-Speicher leer. Bitte gehen Sie zu Ihrem Cloud-Speicher und erstellen Sie einen Ordner.','error-message-payment-processing-failed':'Die Transaktion wurde abgelehnt. Bitte überprüfen Sie die eingegebenen Kartendaten oder wenden Sie sich an Ihren Kartenaussteller, um zu prüfen, ob die Karte korrekt funktioniert.','error-message-payment-method-verification-failed':'Transaktion abgelehnt, bitte überprüfen Sie die eingegebenen Kartendaten.','error-message-payment-method-not-present':'Mit Ihrem Konto ist keine Zahlungsmethode verknüpft oder Ihre Kreditkarte ist abgelaufen.','error-message-payment-gateway-currency-incompatible':'Die ausgewählte Währung wird nicht unterstützt.','error-message-payment-provider-internal-error':'Der Gutscheincode ist ungültig oder es ist keine Zahlungsmethode mit Ihrem Konto verknüpft. Bitte kontaktieren Sie den Xara-Support.','error-message-payment-provider-internal-coupon-error':'Interner Fehler des Zahlungsanbieters. Wahrscheinlich ist der Coupon nicht gültig. Bitte kontaktieren Sie den Xara-Support.','error-message-wrong-font-type-uploaded':'Dieses Dateiformat wird nicht unterstützt. Xara Cloud kann die folgenden Dateitypen hinzufügen: .ttf .otf.','error-message-checksum-conflict-invalid-font-file':'Leider konnten wir diese Datei nicht hochladen. Die Datei ist beschädigt. Bitte laden Sie eine andere Datei hoch.','error-message-workspace-name-already-exists':'Dieser Name ist bereits vergeben, bitte wählen Sie einen anderen BrandSpace Namen.','error-message-cloud-storage-item-not-folder':'Sie können keine Dateien hinzufügen. Bitte wählen Sie einen Ordner.','error-message-cloud-storage-folder-not-writable':'Sie haben keine Schreibrechte für diesen Ordner. Bitte wählen Sie einen anderen Ordner.','error-message-company-name-already-exists':'Dieser Name ist bereits vergeben, bitte wählen Sie einen anderen Teamnamen.','error-message-invalid-company-name':'Sie dürfen nur Zeichen von A bis Z und 0 bis 9 verwenden (keine Leerzeichen und Sonderzeichen).','error-message-invalid-email':'Ungültige E-Mail Adresse.','error-message-invalid-workspace-name':'Bitte verwenden Sie nur Buchstaben und Ziffern.','error-message-subscription-plan-currency-mismatch':'Die gewählte Währung stimmt nicht mit Ihrem bisherigen Abonnement überein. Bitte ändern Sie Ihre Währungsauswahl.','error-message-company-already-exists':'Dieser Name ist bereits vergeben, bitte wählen Sie einen anderen Teamnamen.','error-message-user-already-exists-in-company':'Dieser Benutzer existiert bereits.','error-message-domain-already-exists-in-company':'Dieser Bereich wurde bereits hinzugefügt.','error-message-folder-already-exists-in-company':'Dieser Ordner wurde bereits hinzugefügt.','error-message-smart-field-already-exists-in-company':'Dieses SmartField existiert bereits.','error-message-workspace-already-exists-in-company':'Dieser Name ist bereits vergeben, bitte wählen Sie einen anderen Themennamen.','error-message-user-already-exists-in-workspace':'Dieser Benutzer existiert bereits.','error-message-domain-already-exists-in-workspace':'Dieser Bereich wurde bereits hinzugefügt.','error-message-waiting-for-api':'Wir entschuldigen uns für die Unannehmlichkeiten, wir warten derzeit Xara Cloud. Wir werden in Kürze wieder einsatzbereit sein.','error-message-cb-not-loaded':'Die Bibliothek für die Abonnementabrechnung konnte nicht geladen werden. Bitte versuchen Sie es in ein paar Sekunden erneut oder lesen Sie unseren <a href="{0}" target="_blank">Support-Artikel</a>. Kontaktieren Sie uns sofort, wenn Sie nicht weitermachen können.','error-message-failed-to-get-payment-coupon':'Der Zahlungsgutschein konnte nicht eingelöst werden. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.','error-message-invalid-coupon-set-id':'Ungültige Coupon-Set-ID. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.','error-message-invalid-coupon-id':'Ungültige Coupon-ID. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.','error-message-failed-to-create-order-in-payment-gateway':'Fehler beim Erstellen der Bestellung im Zahlungs-Gateway. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.','error-message-duplicate-coupon-id':'Doppelte Gutschein-ID. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.','error-message-invalid-number-of-users-during-checkout':'Die Anzahl der Nutzer darf nicht geringer sein als die Anzahl der Nutzer im Unternehmen'};if(true){!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return exports;}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}else{this[module]=exports;}}).call(this);

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/preloader.781e2e79.gif";

/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/xara-logo.b0d7bd47.gif";

/***/ }),
/* 768 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAciSURBVHgB3ZtLbBNXFIbPPPx2YhuDadKWOIsmEgWaiNBFF9RZVQJBW5V023TLpl206hJ13Q0syqpSYQ0SEhJVu4rpgkqFKGkCaQFRT6AEAgmxE48f8+w9Eyb4PXc84yTkkyYzY8+M888595xz751hwIKVjB6FoJrSVCXJckwUthusngWNF0CTp2M9AcHqcKbRh1NTU9Fd0Z7xWCj+sQ6QgtcEIiatgn4xlvBeaHFMNZn7j1Ld4V0/85w3Ca8rDExrivJpI4uzlTuZB/Nnot2JiddaLKLDEMt5Jlb+k4Zqv9qw8IN/Ml/tivWeZRkWdhBZTdJHY295p80PDMErT4pJDfQMz3lg58EImsgNx/qZLO6Z5jyzM8UiehKC0tfmHoPWZTk+AzubrCby/WhlVlHVT2DnE4VAeRw3eJ/Xh7m2Y5RFHRbmZMg/U2FZUGHtuVr1vTfEQDzJQ+9+j7H2hRjoDEyK/DnL5J4pGcPPXQRFCjfLcC9dNsTaAYUPpHwwmPKDuzBCJMH3E8GyawZGobd/KcLstSKUC84u27WHhcNjQVeFRxIehnmxIOkc79yNFu7IkD6/RlxWAzdB4SfORKArwYFTDMFP/y3pgbCzi926VIBJsnSSEWJttLgTUDBbKiig6e27H1q102IRvKl/XBDBKSxqLYvtuSGKvUsC02YxQ+JD+sc8OMGotNqx8g1ytzdTrMnd6yVHljYE27Xy7LUSzJK7vVWgpdv9/Y2uEa2V10gBMXnJWVvyd7HG4gRs0/i/2IU3N0wrW0XsyUv2c6yvi4G9gzxZPMZ2JeKyBrkFFRZmFCit0XuZRHL+jYsifPRtN9iBr9xBK/tCLLBM47yMdxTbEPXFfQzsG/FA78HmPbFQnDUWPGZhRoaHkzIoZbobKtyUjPzf+y59T6/Kr6zaMlqXFrTk8KlAS7G19B7yGOfYcXe7bbnuykZbVuvvsB3rothDJwN17kt77sGTfmrRWKvbaWJ1V0Ur51eVhhempV2xJnjuO6NeqmOxLd9L0zezhrdRkTSQpeq7JvxJJzhBgpMTsSaRXs64Fg1LAn20buo34qpclaaeUFq4b4TOMjTspRT85I4EtDQVjO24lF8PYOg25YJ1ykCruGHdyuthBLcCe2i07bjl1TCAKYpOXEYBGkJx90crIm/SBa/akZRmWPqMmJNBp6wHQrud91lroY3WUp7OwpaCVWLhRYG+jbgN53XXa6huX5mRoCBtjWhVcneIkUpwZI8Hnq6RWUmt9Y+LS/aLeSvs1Nc0UAn2k/paVlV4nHvR8jhx2f0B39xjOsHxfroURiU4SiyMoguyBMviWtPjsNdDW/jTUF7Tjd6UFV17SDoM0rV16ip9b5/PWC+J+ZbtGXs7bjF/iy5uxJP02YFa8MCR8Mb249yK4eKNwC6euOS83aFln92ly//JI/TVHbXg9z6MbGxrJDE/yi43DWJzv5UMd2wXPPfvX+nHy9ruD7cC23Df/sDGfqsghv/wzNViW6LxnNmrJeroPEBmJrAN02JrYOnoWLxqH4PY09Vsw2NN0YuUbokszCowdbloKxWNjAXADnSx/CV9+4OGlefnXo0y5EpF8HAcxENddcej6PsTZXhIgs8+0osK43DObrbumGVSq9sd00LsWhdhMrN5W36XfS7DT9/NQ6lmKGh3KNxQdC04zsW/LBcVUkW1m8Z8QRY++yFiS7Ax1QI2wZx89FS87nNMV61ytAkKREvi4iRnH/48YNu6SFuDw+8fi5GoXT88SivaKQeP+clir+2atD0afuL0G1VR26TTogfJZPkH42FoF0fD/2PfvLmplkaxqdPWcaIVjgRjbkZL16YrBEVjyrLqYdGC88NOxSK2o3Qz5ucKcPX8IuSeV9fSfp7MPERiRupqBwxMqdNhW9VUM4wnANwSbPL75WX4K71aJRzFvh2N2xKNaefAcRKcjgeoe0JWdESwycz1nCG8skhJhLshFgy1PK+HWLKfFCkDo37XhJqsC76dz4AOSegQWKgsCuX1Zb4EQZ3MHTF+kIs6hIm7mn1ZfFyp54DHdZGvWH9siSdzK9NkJwkdAgsVXAYrupcsx0B3zGOsNwsddMH4bdCY67DJ4CB/dkmCouj+GFgzdFW/iGsiWL5A1lnYAop5xRDeaLbSfdQ0/mX7h2NErH4OtgjT2uKq0jHhmgbnzNcB1gsPRTlLnFyALaRcVGF1RTbWrqIzAuhE30s2okZmKj9EescTgI/abjEYzAIhEr0DjqduspqqDFe+7FEVJg3RHFwhnyZhG+BQeFYDfTSWePW+A1L/Gs/UShJ4zxWyOQTbBFO4188Cw1inMhIJ0rqqfNnoNZ6mZ2dm8uPk2y9gG72oxbAMeH0s+IMcNHoCeF0ofB/r8aSbXgMsMCzOcUOgs/jmy7Z5Fc9Pau1gN48PpWSB4QUocGnzzZVW/A/AAzLa8cF7rAAAAABJRU5ErkJggg=="

/***/ }),
/* 769 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/we-accept-eur.df16c057.png";

/***/ }),
/* 771 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 772 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 773 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 774 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 775 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 776 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 777 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 778 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/addon-ai.58b9f551.png";

/***/ }),
/* 780 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 781 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 782 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 783 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

var getPrototypeOf = __webpack_require__(9);

var setPrototypeOf = __webpack_require__(254);

var isNativeFunction = __webpack_require__(785);

var construct = __webpack_require__(786);

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  module.exports = _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return construct(Class, arguments, getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

module.exports = _wrapNativeSuper;

/***/ }),
/* 785 */
/***/ (function(module, exports) {

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

module.exports = _isNativeFunction;

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(254);

function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    module.exports = _construct = Reflect.construct;
  } else {
    module.exports = _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

module.exports = _construct;

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
var CONVERSIONS={TOP_PROPERTY:{STRING:function STRING(result,prop,value){if(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isString(value)&&value.length){result[prop]=value;return true;}return false;},NUMBER:function NUMBER(result,prop,value){if(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isNumber(value)){result[prop]=value;return true;}return false;},OBJECT:function OBJECT(result,prop,value){if(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isObject(value)){result[prop]=value;return true;}return false;},ARRAY:function ARRAY(result,prop,value){if(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isArray(value)){result[prop]=value;return true;}return false;},BOOLEAN:function BOOLEAN(result,prop,value){if(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isBoolean(value)){result[prop]=value;return true;}return false;},UNDEFINED:function UNDEFINED(result,prop,value){if(value===undefined){result[prop]=value;return true;}return false;}}};var knownProperties={message:function message(result,prop,value){return CONVERSIONS.TOP_PROPERTY.STRING.apply(null,arguments);},/* {message, file, line column, stack, messageType} custom created object with error related properties */error:function error(result,prop,value){return CONVERSIONS.TOP_PROPERTY.OBJECT.apply(null,arguments);},errorId:function errorId(result,prop,value){return CONVERSIONS.TOP_PROPERTY.NUMBER.apply(null,arguments);},/* details for error log */errorDetails:function errorDetails(result,prop,value){if(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isObject(value)){try{result[prop]=JSON.stringify(value);}catch(e){result[prop]="JSON.stringify could not serialize object: ".concat(e.message);}return true;}return false;},errorHistory:function errorHistory(result,prop,value){return CONVERSIONS.TOP_PROPERTY.ARRAY.apply(null,arguments);},// P9052-20271 this should always be JSON and not JSON.stringified to not make conflict with mw details key
// If object needs to be stringified then use additionalData below
details:function details(result,prop,value){if(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isObject(value)){result[prop]=value;return true;}return false;},// details field but stringified
additionalData:function additionalData(result,prop,value){if(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isObject(value)){try{result[prop]=JSON.stringify(value);}catch(e){result[prop]="JSON.stringify could not serialize object: ".concat(e.message);}return true;}return false;},visualisers:function visualisers(result,prop,value){if(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isObject(value)){result[prop]=value;return true;}return false;},tag:function tag(result,prop,value){return CONVERSIONS.TOP_PROPERTY.STRING.apply(null,arguments);},miscellaneous:function miscellaneous(result,prop,value){result.miscellaneous=result.miscellaneous||{};result.miscellaneous[prop]=value;return true;},user:function user(result,prop,value){return CONVERSIONS.TOP_PROPERTY.OBJECT.apply(null,arguments);},clientId:function clientId(result,prop,value){return CONVERSIONS.TOP_PROPERTY.STRING.apply(null,arguments);},name:function name(result,prop,value){// componentName
return CONVERSIONS.TOP_PROPERTY.STRING.apply(null,arguments)||CONVERSIONS.TOP_PROPERTY.UNDEFINED.apply(null,arguments);},meta:function meta(result,prop,value){return CONVERSIONS.TOP_PROPERTY.OBJECT.apply(null,arguments);},isSignedIn:function isSignedIn(result,prop,value){return CONVERSIONS.TOP_PROPERTY.BOOLEAN.apply(null,arguments);},isRetry:function isRetry(result,prop,value){return CONVERSIONS.TOP_PROPERTY.BOOLEAN.apply(null,arguments);},previousMessage:function previousMessage(result,prop,value){return CONVERSIONS.TOP_PROPERTY.STRING.apply(null,arguments);},previousMessageId:function previousMessageId(result,prop,value){return CONVERSIONS.TOP_PROPERTY.NUMBER.apply(null,arguments);},firstMessage:function firstMessage(result,prop,value){return CONVERSIONS.TOP_PROPERTY.STRING.apply(null,arguments);},firstMessageId:function firstMessageId(result,prop,value){return CONVERSIONS.TOP_PROPERTY.NUMBER.apply(null,arguments);},serverStatus:function serverStatus(result,prop,value){return CONVERSIONS.TOP_PROPERTY.NUMBER.apply(null,arguments);},apiErrorId:function apiErrorId(result,prop,value){return CONVERSIONS.TOP_PROPERTY.NUMBER.apply(null,arguments);},apiErrorKey:function apiErrorKey(result,prop,value){return CONVERSIONS.TOP_PROPERTY.STRING.apply(null,arguments);}};/* harmony default export */ __webpack_exports__["a"] = (knownProperties);

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid_v4__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uuid_v4__);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_uuid_v4___default()());

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(790);
var bytesToUuid = __webpack_require__(791);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 790 */
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),
/* 791 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([bth[buf[i++]], bth[buf[i++]], 
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]]]).join('');
}

module.exports = bytesToUuid;


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62);
var bind = __webpack_require__(380);
var Axios = __webpack_require__(794);
var defaults = __webpack_require__(260);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(384);
axios.CancelToken = __webpack_require__(808);
axios.isCancel = __webpack_require__(383);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(809);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 793 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(260);
var utils = __webpack_require__(62);
var InterceptorManager = __webpack_require__(803);
var dispatchRequest = __webpack_require__(804);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(382);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62);
var transformData = __webpack_require__(805);
var isCancel = __webpack_require__(383);
var defaults = __webpack_require__(260);
var isAbsoluteURL = __webpack_require__(806);
var combineURLs = __webpack_require__(807);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(384);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_Segment__ = __webpack_require__(385);
var trackingMiddleware=function trackingMiddleware(store){return function(next){return function(action){Object(__WEBPACK_IMPORTED_MODULE_0__lib_Segment__["b" /* trackAction */])(action);return next(action);};};};/* harmony default export */ __webpack_exports__["a"] = (trackingMiddleware);

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reduxHandlers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_modules_actions__ = __webpack_require__(45);
var reduxHandlers={};reduxHandlers[__WEBPACK_IMPORTED_MODULE_2__redux_modules_actions__["_153" /* SESSION_FETCH_SUCCESS */]]=function handleSessionFetch(action){var xaraTrackingId=__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(action,'result.user.trackingId');Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["c" /* setTrackingId */])(xaraTrackingId);};

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_socket_io_client__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_socket_io_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_socket_io_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_actions__ = __webpack_require__(45);
var socketMiddleware=function socketMiddleware(url,clientId){var socket=__WEBPACK_IMPORTED_MODULE_0_socket_io_client___default()("".concat(url,"?clientId=").concat(clientId),{transports:['polling','websocket']});return function(_ref){var dispatch=_ref.dispatch;return function(next){return function(action){if(typeof action==='function'){return next(action);}var type=action.type,event=action.event,packet=action.packet,off=action.off,callback=action.callback;if(event&&type===__WEBPACK_IMPORTED_MODULE_1__modules_actions__["_159" /* SOCKET_SUBSCRIBE */]){off&&socket.off(event);if(callback&&typeof callback==='string'){var _type=callback;callback=function callback(payload){dispatch({type:_type,result:payload});};}socket.on(event,callback);}if(event&&type===__WEBPACK_IMPORTED_MODULE_1__modules_actions__["_158" /* SOCKET_EMIT */]){socket.emit(event,packet,callback);return;}return next(action);};};};};/* harmony default export */ __webpack_exports__["a"] = (socketMiddleware);

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var url = __webpack_require__(814);
var parser = __webpack_require__(262);
var Manager = __webpack_require__(389);
var debug = __webpack_require__(191)('socket.io-client');

/**
 * Module exports.
 */

module.exports = exports = lookup;

/**
 * Managers cache.
 */

var cache = exports.managers = {};

/**
 * Looks up an existing `Manager` for multiplexing.
 * If the user summons:
 *
 *   `io('http://localhost/a');`
 *   `io('http://localhost/b');`
 *
 * We reuse the existing instance based on same scheme/port/host,
 * and we initialize sockets for each namespace.
 *
 * @api public
 */

function lookup (uri, opts) {
  if (typeof uri === 'object') {
    opts = uri;
    uri = undefined;
  }

  opts = opts || {};

  var parsed = url(uri);
  var source = parsed.source;
  var id = parsed.id;
  var path = parsed.path;
  var sameNamespace = cache[id] && path in cache[id].nsps;
  var newConnection = opts.forceNew || opts['force new connection'] ||
                      false === opts.multiplex || sameNamespace;

  var io;

  if (newConnection) {
    debug('ignoring socket cache for %s', source);
    io = Manager(source, opts);
  } else {
    if (!cache[id]) {
      debug('new io instance for %s', source);
      cache[id] = Manager(source, opts);
    }
    io = cache[id];
  }
  if (parsed.query && !opts.query) {
    opts.query = parsed.query;
  }
  return io.socket(parsed.path, opts);
}

/**
 * Protocol version.
 *
 * @api public
 */

exports.protocol = parser.protocol;

/**
 * `connect`.
 *
 * @param {String} uri
 * @api public
 */

exports.connect = lookup;

/**
 * Expose constructors for standalone build.
 *
 * @api public
 */

exports.Manager = __webpack_require__(389);
exports.Socket = __webpack_require__(395);


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var parseuri = __webpack_require__(386);
var debug = __webpack_require__(191)('socket.io-client:url');

/**
 * Module exports.
 */

module.exports = url;

/**
 * URL parser.
 *
 * @param {String} url
 * @param {Object} An object meant to mimic window.location.
 *                 Defaults to window.location.
 * @api public
 */

function url (uri, loc) {
  var obj = uri;

  // default to window.location
  loc = loc || (typeof location !== 'undefined' && location);
  if (null == uri) uri = loc.protocol + '//' + loc.host;

  // relative path support
  if ('string' === typeof uri) {
    if ('/' === uri.charAt(0)) {
      if ('/' === uri.charAt(1)) {
        uri = loc.protocol + uri;
      } else {
        uri = loc.host + uri;
      }
    }

    if (!/^(https?|wss?):\/\//.test(uri)) {
      debug('protocol-less url %s', uri);
      if ('undefined' !== typeof loc) {
        uri = loc.protocol + '//' + uri;
      } else {
        uri = 'https://' + uri;
      }
    }

    // parse
    debug('parse %s', uri);
    obj = parseuri(uri);
  }

  // make sure we treat `localhost:80` and `localhost` equally
  if (!obj.port) {
    if (/^(http|ws)$/.test(obj.protocol)) {
      obj.port = '80';
    } else if (/^(http|ws)s$/.test(obj.protocol)) {
      obj.port = '443';
    }
  }

  obj.path = obj.path || '/';

  var ipv6 = obj.host.indexOf(':') !== -1;
  var host = ipv6 ? '[' + obj.host + ']' : obj.host;

  // define unique id
  obj.id = obj.protocol + '://' + host + ':' + obj.port;
  // define href
  obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : (':' + obj.port));

  return obj;
}


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(261);

/**
 * Active `debug` instances.
 */
exports.instances = [];

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  var prevTime;

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);
  debug.destroy = destroy;

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  exports.instances.push(debug);

  return debug;
}

function destroy () {
  var index = exports.instances.indexOf(this);
  if (index !== -1) {
    exports.instances.splice(index, 1);
    return true;
  } else {
    return false;
  }
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var i;
  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }

  for (i = 0; i < exports.instances.length; i++) {
    var instance = exports.instances[i];
    instance.enabled = exports.enabled(instance.namespace);
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  if (name[name.length - 1] === '*') {
    return true;
  }
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(817);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  '#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC',
  '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF',
  '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC',
  '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF',
  '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC',
  '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033',
  '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366',
  '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933',
  '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC',
  '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF',
  '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // Internet Explorer and Edge do not support colors.
  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
    return false;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_PHOTOL_DISCOUNT":"0.2","REACT_APP_HTTP_STATIC_RESOURCES_URL":"https://prod-mw.xara.com/static","REACT_APP_UPGRADE_POPUP_DISCOUNT":"0.2","REACT_APP_SOCKET_URL":"https://prod-mw.xara.com:443","REACT_APP_HTTP_MLS_API_URL":"https://prod-mw.xara.com/3","REACT_APP_DESIGNERL_DISCOUNT":"0.4","REACT_APP_TIER1_DISCOUNT":"0.4","REACT_APP_TIER2_DISCOUNT":"0.5","REACT_APP_TIER3_DISCOUNT":"0.50","REACT_APP_SUBSCRIPTION_ACTIVE_OFFERS_URL":"https://www.xara.com/welcome/","REACT_APP_REVIEW_MLS_API_ENDPOINT":"https://www.xara.com/review-mls-request/","REACT_APP_LOGGER_ENDPOINT":"https://logs.xara.com:5005","REACT_APP_BUILD_NUMBER":"240","REACT_APP_CONTACT_SALES_API_ENDPOINT":"https://www.xara.com/contact-sales-request/","REACT_APP_PHOTOL_ACTIVE_OFFERS_URL":"https://www.xara.com/photo-graphic/v20/","REACT_APP_CRS_USAGE_URL":"https://crs-web.xara.com/usage","REACT_APP_SEGMENT":"true","REACT_APP_WEBL_COUPON_SET_ID":"30_V20","REACT_APP_XC_URL":"https://cloud.xara.com/","REACT_APP_UPGRADE_POPUP_SET_ID":"BOOST_MY_ROI","REACT_APP_DESIGNERL_ACTIVE_OFFERS_URL":"https://www.xara.com/designerpro/v20/","REACT_APP_INTERCOM_WORKSPACE_ID":"w83u8qa8","REACT_APP_CRS_INFO_URL":"https://crs-web.xara.com/crsinfo","REACT_APP_SEND_CURRENT_OFFERS_URL":"https://marketing-web.xara.com/coupons/sendactivecoupons","REACT_APP_WEBL_DISCOUNT":"0.3","REACT_APP_HTTP_API_URL":"https://prod-mw.xara.com/2","REACT_APP_SEGMENT_TOKEN":"rPbjGNElCaBDQdLTczi3f8YdshyWxtsF","REACT_APP_CONNECT_MLS_API_ENDPOINT":"https://www.xara.com/activate-playbooks-request/","REACT_APP_PERPETUAL_FALLBACK_COUPON_ID":"30OFF_PER","REACT_APP_PHOTOL_COUPON_SET_ID":"20_V20","REACT_APP_BRANCH":"v0.241.0","REACT_APP_BUILD_VCS_NUMBER":"=8549e3d7c1ce041fd223f917537f60b6528fb472","REACT_APP_HOTJAR_SITE_ID":"1270301","REACT_APP_TIER1_COUPON_SET_ID":"40_OFFER","REACT_APP_DESIGNERL_COUPON_SET_ID":"30_DPV20","REACT_APP_TIER2_COUPON_SET_ID":"50_OFFER","REACT_APP_CHARGEBEE_SITE_URL":"xara","REACT_APP_WEBL_ACTIVE_OFFERS_URL":"https://www.xara.com/webdesigner/v20/","REACT_APP_TIER3_COUPON_SET_ID":"50_OFFER","REACT_APP_CONTACT_SALES_CALENDLY_LINK":"https://meet.brevo.com/xara-group-ltd/xara-for-enterprise","REACT_APP_SUBSCRIPTION_FALLBACK_COUPON_ID":"30RENEW","REACT_APP_API_STATUS_URL":"status.xara.com/api/v1/components/","REACT_APP_CHARGEBEE_ENABLE_GA_TRACKING":"true","REACT_APP_CHARGEBEE_ENABLE_REFERSION_TRACKING":"true","REACT_APP_LOGGER_SEND_FROM_DEV":"true"}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(155)))

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(261);

/**
 * Active `debug` instances.
 */
exports.instances = [];

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  var prevTime;

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);
  debug.destroy = destroy;

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  exports.instances.push(debug);

  return debug;
}

function destroy () {
  var index = exports.instances.indexOf(this);
  if (index !== -1) {
    exports.instances.splice(index, 1);
    return true;
  } else {
    return false;
  }
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var i;
  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }

  for (i = 0; i < exports.instances.length; i++) {
    var instance = exports.instances[i];
    instance.enabled = exports.enabled(instance.namespace);
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  if (name[name.length - 1] === '*') {
    return true;
  }
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

/*global Blob,File*/

/**
 * Module requirements
 */

var isArray = __webpack_require__(387);
var isBuf = __webpack_require__(388);
var toString = Object.prototype.toString;
var withNativeBlob = typeof Blob === 'function' || (typeof Blob !== 'undefined' && toString.call(Blob) === '[object BlobConstructor]');
var withNativeFile = typeof File === 'function' || (typeof File !== 'undefined' && toString.call(File) === '[object FileConstructor]');

/**
 * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.
 * Anything with blobs or files should be fed through removeBlobs before coming
 * here.
 *
 * @param {Object} packet - socket.io event packet
 * @return {Object} with deconstructed packet and list of buffers
 * @api public
 */

exports.deconstructPacket = function(packet) {
  var buffers = [];
  var packetData = packet.data;
  var pack = packet;
  pack.data = _deconstructPacket(packetData, buffers);
  pack.attachments = buffers.length; // number of binary 'attachments'
  return {packet: pack, buffers: buffers};
};

function _deconstructPacket(data, buffers) {
  if (!data) return data;

  if (isBuf(data)) {
    var placeholder = { _placeholder: true, num: buffers.length };
    buffers.push(data);
    return placeholder;
  } else if (isArray(data)) {
    var newData = new Array(data.length);
    for (var i = 0; i < data.length; i++) {
      newData[i] = _deconstructPacket(data[i], buffers);
    }
    return newData;
  } else if (typeof data === 'object' && !(data instanceof Date)) {
    var newData = {};
    for (var key in data) {
      newData[key] = _deconstructPacket(data[key], buffers);
    }
    return newData;
  }
  return data;
}

/**
 * Reconstructs a binary packet from its placeholder packet and buffers
 *
 * @param {Object} packet - event packet with placeholders
 * @param {Array} buffers - binary buffers to put in placeholder positions
 * @return {Object} reconstructed packet
 * @api public
 */

exports.reconstructPacket = function(packet, buffers) {
  packet.data = _reconstructPacket(packet.data, buffers);
  packet.attachments = undefined; // no longer useful
  return packet;
};

function _reconstructPacket(data, buffers) {
  if (!data) return data;

  if (data && data._placeholder) {
    return buffers[data.num]; // appropriate buffer (should be natural order anyway)
  } else if (isArray(data)) {
    for (var i = 0; i < data.length; i++) {
      data[i] = _reconstructPacket(data[i], buffers);
    }
  } else if (typeof data === 'object') {
    for (var key in data) {
      data[key] = _reconstructPacket(data[key], buffers);
    }
  }

  return data;
}

/**
 * Asynchronously removes Blobs or Files from data via
 * FileReader's readAsArrayBuffer method. Used before encoding
 * data as msgpack. Calls callback with the blobless data.
 *
 * @param {Object} data
 * @param {Function} callback
 * @api private
 */

exports.removeBlobs = function(data, callback) {
  function _removeBlobs(obj, curKey, containingObject) {
    if (!obj) return obj;

    // convert any blob
    if ((withNativeBlob && obj instanceof Blob) ||
        (withNativeFile && obj instanceof File)) {
      pendingBlobs++;

      // async filereader
      var fileReader = new FileReader();
      fileReader.onload = function() { // this.result == arraybuffer
        if (containingObject) {
          containingObject[curKey] = this.result;
        }
        else {
          bloblessData = this.result;
        }

        // if nothing pending its callback time
        if(! --pendingBlobs) {
          callback(bloblessData);
        }
      };

      fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer
    } else if (isArray(obj)) { // handle array
      for (var i = 0; i < obj.length; i++) {
        _removeBlobs(obj[i], i, obj);
      }
    } else if (typeof obj === 'object' && !isBuf(obj)) { // and object
      for (var key in obj) {
        _removeBlobs(obj[key], key, obj);
      }
    }
  }

  var pendingBlobs = 0;
  var bloblessData = data;
  _removeBlobs(bloblessData);
  if (!pendingBlobs) {
    callback(bloblessData);
  }
};


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  for (var i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 820 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 821 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {


module.exports = __webpack_require__(823);

/**
 * Exports parser
 *
 * @api public
 *
 */
module.exports.parser = __webpack_require__(136);


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var transports = __webpack_require__(390);
var Emitter = __webpack_require__(118);
var debug = __webpack_require__(194)('engine.io-client:socket');
var index = __webpack_require__(394);
var parser = __webpack_require__(136);
var parseuri = __webpack_require__(386);
var parseqs = __webpack_require__(192);

/**
 * Module exports.
 */

module.exports = Socket;

/**
 * Socket constructor.
 *
 * @param {String|Object} uri or options
 * @param {Object} options
 * @api public
 */

function Socket (uri, opts) {
  if (!(this instanceof Socket)) return new Socket(uri, opts);

  opts = opts || {};

  if (uri && 'object' === typeof uri) {
    opts = uri;
    uri = null;
  }

  if (uri) {
    uri = parseuri(uri);
    opts.hostname = uri.host;
    opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';
    opts.port = uri.port;
    if (uri.query) opts.query = uri.query;
  } else if (opts.host) {
    opts.hostname = parseuri(opts.host).host;
  }

  this.secure = null != opts.secure ? opts.secure
    : (typeof location !== 'undefined' && 'https:' === location.protocol);

  if (opts.hostname && !opts.port) {
    // if no port is specified manually, use the protocol default
    opts.port = this.secure ? '443' : '80';
  }

  this.agent = opts.agent || false;
  this.hostname = opts.hostname ||
    (typeof location !== 'undefined' ? location.hostname : 'localhost');
  this.port = opts.port || (typeof location !== 'undefined' && location.port
      ? location.port
      : (this.secure ? 443 : 80));
  this.query = opts.query || {};
  if ('string' === typeof this.query) this.query = parseqs.decode(this.query);
  this.upgrade = false !== opts.upgrade;
  this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
  this.forceJSONP = !!opts.forceJSONP;
  this.jsonp = false !== opts.jsonp;
  this.forceBase64 = !!opts.forceBase64;
  this.enablesXDR = !!opts.enablesXDR;
  this.timestampParam = opts.timestampParam || 't';
  this.timestampRequests = opts.timestampRequests;
  this.transports = opts.transports || ['polling', 'websocket'];
  this.transportOptions = opts.transportOptions || {};
  this.readyState = '';
  this.writeBuffer = [];
  this.prevBufferLen = 0;
  this.policyPort = opts.policyPort || 843;
  this.rememberUpgrade = opts.rememberUpgrade || false;
  this.binaryType = null;
  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
  this.perMessageDeflate = false !== opts.perMessageDeflate ? (opts.perMessageDeflate || {}) : false;

  if (true === this.perMessageDeflate) this.perMessageDeflate = {};
  if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {
    this.perMessageDeflate.threshold = 1024;
  }

  // SSL options for Node.js client
  this.pfx = opts.pfx || null;
  this.key = opts.key || null;
  this.passphrase = opts.passphrase || null;
  this.cert = opts.cert || null;
  this.ca = opts.ca || null;
  this.ciphers = opts.ciphers || null;
  this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? true : opts.rejectUnauthorized;
  this.forceNode = !!opts.forceNode;

  // detect ReactNative environment
  this.isReactNative = (typeof navigator !== 'undefined' && typeof navigator.product === 'string' && navigator.product.toLowerCase() === 'reactnative');

  // other options for Node.js or ReactNative client
  if (typeof self === 'undefined' || this.isReactNative) {
    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
      this.extraHeaders = opts.extraHeaders;
    }

    if (opts.localAddress) {
      this.localAddress = opts.localAddress;
    }
  }

  // set on handshake
  this.id = null;
  this.upgrades = null;
  this.pingInterval = null;
  this.pingTimeout = null;

  // set on heartbeat
  this.pingIntervalTimer = null;
  this.pingTimeoutTimer = null;

  this.open();
}

Socket.priorWebsocketSuccess = false;

/**
 * Mix in `Emitter`.
 */

Emitter(Socket.prototype);

/**
 * Protocol version.
 *
 * @api public
 */

Socket.protocol = parser.protocol; // this is an int

/**
 * Expose deps for legacy compatibility
 * and standalone browser access.
 */

Socket.Socket = Socket;
Socket.Transport = __webpack_require__(265);
Socket.transports = __webpack_require__(390);
Socket.parser = __webpack_require__(136);

/**
 * Creates transport of the given type.
 *
 * @param {String} transport name
 * @return {Transport}
 * @api private
 */

Socket.prototype.createTransport = function (name) {
  debug('creating transport "%s"', name);
  var query = clone(this.query);

  // append engine.io protocol identifier
  query.EIO = parser.protocol;

  // transport name
  query.transport = name;

  // per-transport options
  var options = this.transportOptions[name] || {};

  // session id if we already have one
  if (this.id) query.sid = this.id;

  var transport = new transports[name]({
    query: query,
    socket: this,
    agent: options.agent || this.agent,
    hostname: options.hostname || this.hostname,
    port: options.port || this.port,
    secure: options.secure || this.secure,
    path: options.path || this.path,
    forceJSONP: options.forceJSONP || this.forceJSONP,
    jsonp: options.jsonp || this.jsonp,
    forceBase64: options.forceBase64 || this.forceBase64,
    enablesXDR: options.enablesXDR || this.enablesXDR,
    timestampRequests: options.timestampRequests || this.timestampRequests,
    timestampParam: options.timestampParam || this.timestampParam,
    policyPort: options.policyPort || this.policyPort,
    pfx: options.pfx || this.pfx,
    key: options.key || this.key,
    passphrase: options.passphrase || this.passphrase,
    cert: options.cert || this.cert,
    ca: options.ca || this.ca,
    ciphers: options.ciphers || this.ciphers,
    rejectUnauthorized: options.rejectUnauthorized || this.rejectUnauthorized,
    perMessageDeflate: options.perMessageDeflate || this.perMessageDeflate,
    extraHeaders: options.extraHeaders || this.extraHeaders,
    forceNode: options.forceNode || this.forceNode,
    localAddress: options.localAddress || this.localAddress,
    requestTimeout: options.requestTimeout || this.requestTimeout,
    protocols: options.protocols || void (0),
    isReactNative: this.isReactNative
  });

  return transport;
};

function clone (obj) {
  var o = {};
  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      o[i] = obj[i];
    }
  }
  return o;
}

/**
 * Initializes transport to use and starts probe.
 *
 * @api private
 */
Socket.prototype.open = function () {
  var transport;
  if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) {
    transport = 'websocket';
  } else if (0 === this.transports.length) {
    // Emit error on next tick so it can be listened to
    var self = this;
    setTimeout(function () {
      self.emit('error', 'No transports available');
    }, 0);
    return;
  } else {
    transport = this.transports[0];
  }
  this.readyState = 'opening';

  // Retry with the next transport if the transport is disabled (jsonp: false)
  try {
    transport = this.createTransport(transport);
  } catch (e) {
    this.transports.shift();
    this.open();
    return;
  }

  transport.open();
  this.setTransport(transport);
};

/**
 * Sets the current transport. Disables the existing one (if any).
 *
 * @api private
 */

Socket.prototype.setTransport = function (transport) {
  debug('setting transport %s', transport.name);
  var self = this;

  if (this.transport) {
    debug('clearing existing transport %s', this.transport.name);
    this.transport.removeAllListeners();
  }

  // set up transport
  this.transport = transport;

  // set up transport listeners
  transport
  .on('drain', function () {
    self.onDrain();
  })
  .on('packet', function (packet) {
    self.onPacket(packet);
  })
  .on('error', function (e) {
    self.onError(e);
  })
  .on('close', function () {
    self.onClose('transport close');
  });
};

/**
 * Probes a transport.
 *
 * @param {String} transport name
 * @api private
 */

Socket.prototype.probe = function (name) {
  debug('probing transport "%s"', name);
  var transport = this.createTransport(name, { probe: 1 });
  var failed = false;
  var self = this;

  Socket.priorWebsocketSuccess = false;

  function onTransportOpen () {
    if (self.onlyBinaryUpgrades) {
      var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;
      failed = failed || upgradeLosesBinary;
    }
    if (failed) return;

    debug('probe transport "%s" opened', name);
    transport.send([{ type: 'ping', data: 'probe' }]);
    transport.once('packet', function (msg) {
      if (failed) return;
      if ('pong' === msg.type && 'probe' === msg.data) {
        debug('probe transport "%s" pong', name);
        self.upgrading = true;
        self.emit('upgrading', transport);
        if (!transport) return;
        Socket.priorWebsocketSuccess = 'websocket' === transport.name;

        debug('pausing current transport "%s"', self.transport.name);
        self.transport.pause(function () {
          if (failed) return;
          if ('closed' === self.readyState) return;
          debug('changing transport and sending upgrade packet');

          cleanup();

          self.setTransport(transport);
          transport.send([{ type: 'upgrade' }]);
          self.emit('upgrade', transport);
          transport = null;
          self.upgrading = false;
          self.flush();
        });
      } else {
        debug('probe transport "%s" failed', name);
        var err = new Error('probe error');
        err.transport = transport.name;
        self.emit('upgradeError', err);
      }
    });
  }

  function freezeTransport () {
    if (failed) return;

    // Any callback called by transport should be ignored since now
    failed = true;

    cleanup();

    transport.close();
    transport = null;
  }

  // Handle any error that happens while probing
  function onerror (err) {
    var error = new Error('probe error: ' + err);
    error.transport = transport.name;

    freezeTransport();

    debug('probe transport "%s" failed because of error: %s', name, err);

    self.emit('upgradeError', error);
  }

  function onTransportClose () {
    onerror('transport closed');
  }

  // When the socket is closed while we're probing
  function onclose () {
    onerror('socket closed');
  }

  // When the socket is upgraded while we're probing
  function onupgrade (to) {
    if (transport && to.name !== transport.name) {
      debug('"%s" works - aborting "%s"', to.name, transport.name);
      freezeTransport();
    }
  }

  // Remove all listeners on the transport and on self
  function cleanup () {
    transport.removeListener('open', onTransportOpen);
    transport.removeListener('error', onerror);
    transport.removeListener('close', onTransportClose);
    self.removeListener('close', onclose);
    self.removeListener('upgrading', onupgrade);
  }

  transport.once('open', onTransportOpen);
  transport.once('error', onerror);
  transport.once('close', onTransportClose);

  this.once('close', onclose);
  this.once('upgrading', onupgrade);

  transport.open();
};

/**
 * Called when connection is deemed open.
 *
 * @api public
 */

Socket.prototype.onOpen = function () {
  debug('socket open');
  this.readyState = 'open';
  Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;
  this.emit('open');
  this.flush();

  // we check for `readyState` in case an `open`
  // listener already closed the socket
  if ('open' === this.readyState && this.upgrade && this.transport.pause) {
    debug('starting upgrade probes');
    for (var i = 0, l = this.upgrades.length; i < l; i++) {
      this.probe(this.upgrades[i]);
    }
  }
};

/**
 * Handles a packet.
 *
 * @api private
 */

Socket.prototype.onPacket = function (packet) {
  if ('opening' === this.readyState || 'open' === this.readyState ||
      'closing' === this.readyState) {
    debug('socket receive: type "%s", data "%s"', packet.type, packet.data);

    this.emit('packet', packet);

    // Socket is live - any packet counts
    this.emit('heartbeat');

    switch (packet.type) {
      case 'open':
        this.onHandshake(JSON.parse(packet.data));
        break;

      case 'pong':
        this.setPing();
        this.emit('pong');
        break;

      case 'error':
        var err = new Error('server error');
        err.code = packet.data;
        this.onError(err);
        break;

      case 'message':
        this.emit('data', packet.data);
        this.emit('message', packet.data);
        break;
    }
  } else {
    debug('packet received with socket readyState "%s"', this.readyState);
  }
};

/**
 * Called upon handshake completion.
 *
 * @param {Object} handshake obj
 * @api private
 */

Socket.prototype.onHandshake = function (data) {
  this.emit('handshake', data);
  this.id = data.sid;
  this.transport.query.sid = data.sid;
  this.upgrades = this.filterUpgrades(data.upgrades);
  this.pingInterval = data.pingInterval;
  this.pingTimeout = data.pingTimeout;
  this.onOpen();
  // In case open handler closes socket
  if ('closed' === this.readyState) return;
  this.setPing();

  // Prolong liveness of socket on heartbeat
  this.removeListener('heartbeat', this.onHeartbeat);
  this.on('heartbeat', this.onHeartbeat);
};

/**
 * Resets ping timeout.
 *
 * @api private
 */

Socket.prototype.onHeartbeat = function (timeout) {
  clearTimeout(this.pingTimeoutTimer);
  var self = this;
  self.pingTimeoutTimer = setTimeout(function () {
    if ('closed' === self.readyState) return;
    self.onClose('ping timeout');
  }, timeout || (self.pingInterval + self.pingTimeout));
};

/**
 * Pings server every `this.pingInterval` and expects response
 * within `this.pingTimeout` or closes connection.
 *
 * @api private
 */

Socket.prototype.setPing = function () {
  var self = this;
  clearTimeout(self.pingIntervalTimer);
  self.pingIntervalTimer = setTimeout(function () {
    debug('writing ping packet - expecting pong within %sms', self.pingTimeout);
    self.ping();
    self.onHeartbeat(self.pingTimeout);
  }, self.pingInterval);
};

/**
* Sends a ping packet.
*
* @api private
*/

Socket.prototype.ping = function () {
  var self = this;
  this.sendPacket('ping', function () {
    self.emit('ping');
  });
};

/**
 * Called on `drain` event
 *
 * @api private
 */

Socket.prototype.onDrain = function () {
  this.writeBuffer.splice(0, this.prevBufferLen);

  // setting prevBufferLen = 0 is very important
  // for example, when upgrading, upgrade packet is sent over,
  // and a nonzero prevBufferLen could cause problems on `drain`
  this.prevBufferLen = 0;

  if (0 === this.writeBuffer.length) {
    this.emit('drain');
  } else {
    this.flush();
  }
};

/**
 * Flush write buffers.
 *
 * @api private
 */

Socket.prototype.flush = function () {
  if ('closed' !== this.readyState && this.transport.writable &&
    !this.upgrading && this.writeBuffer.length) {
    debug('flushing %d packets in socket', this.writeBuffer.length);
    this.transport.send(this.writeBuffer);
    // keep track of current length of writeBuffer
    // splice writeBuffer and callbackBuffer on `drain`
    this.prevBufferLen = this.writeBuffer.length;
    this.emit('flush');
  }
};

/**
 * Sends a message.
 *
 * @param {String} message.
 * @param {Function} callback function.
 * @param {Object} options.
 * @return {Socket} for chaining.
 * @api public
 */

Socket.prototype.write =
Socket.prototype.send = function (msg, options, fn) {
  this.sendPacket('message', msg, options, fn);
  return this;
};

/**
 * Sends a packet.
 *
 * @param {String} packet type.
 * @param {String} data.
 * @param {Object} options.
 * @param {Function} callback function.
 * @api private
 */

Socket.prototype.sendPacket = function (type, data, options, fn) {
  if ('function' === typeof data) {
    fn = data;
    data = undefined;
  }

  if ('function' === typeof options) {
    fn = options;
    options = null;
  }

  if ('closing' === this.readyState || 'closed' === this.readyState) {
    return;
  }

  options = options || {};
  options.compress = false !== options.compress;

  var packet = {
    type: type,
    data: data,
    options: options
  };
  this.emit('packetCreate', packet);
  this.writeBuffer.push(packet);
  if (fn) this.once('flush', fn);
  this.flush();
};

/**
 * Closes the connection.
 *
 * @api private
 */

Socket.prototype.close = function () {
  if ('opening' === this.readyState || 'open' === this.readyState) {
    this.readyState = 'closing';

    var self = this;

    if (this.writeBuffer.length) {
      this.once('drain', function () {
        if (this.upgrading) {
          waitForUpgrade();
        } else {
          close();
        }
      });
    } else if (this.upgrading) {
      waitForUpgrade();
    } else {
      close();
    }
  }

  function close () {
    self.onClose('forced close');
    debug('socket closing - telling transport to close');
    self.transport.close();
  }

  function cleanupAndClose () {
    self.removeListener('upgrade', cleanupAndClose);
    self.removeListener('upgradeError', cleanupAndClose);
    close();
  }

  function waitForUpgrade () {
    // wait for upgrade to finish since we can't send packets while pausing a transport
    self.once('upgrade', cleanupAndClose);
    self.once('upgradeError', cleanupAndClose);
  }

  return this;
};

/**
 * Called upon transport error
 *
 * @api private
 */

Socket.prototype.onError = function (err) {
  debug('socket error %j', err);
  Socket.priorWebsocketSuccess = false;
  this.emit('error', err);
  this.onClose('transport error', err);
};

/**
 * Called upon transport close.
 *
 * @api private
 */

Socket.prototype.onClose = function (reason, desc) {
  if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
    debug('socket close with reason: "%s"', reason);
    var self = this;

    // clear timers
    clearTimeout(this.pingIntervalTimer);
    clearTimeout(this.pingTimeoutTimer);

    // stop event from firing again for transport
    this.transport.removeAllListeners('close');

    // ensure transport won't stay open
    this.transport.close();

    // ignore further transport communication
    this.transport.removeAllListeners();

    // set ready state
    this.readyState = 'closed';

    // clear session id
    this.id = null;

    // emit close event
    this.emit('close', reason, desc);

    // clean buffers after, so users can still
    // grab the buffers on `close` event
    self.writeBuffer = [];
    self.prevBufferLen = 0;
  }
};

/**
 * Filters upgrades, returning only those matching client transports.
 *
 * @param {Array} server upgrades
 * @api private
 *
 */

Socket.prototype.filterUpgrades = function (upgrades) {
  var filteredUpgrades = [];
  for (var i = 0, j = upgrades.length; i < j; i++) {
    if (~index(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);
  }
  return filteredUpgrades;
};


/***/ }),
/* 824 */
/***/ (function(module, exports) {


/**
 * Module exports.
 *
 * Logic borrowed from Modernizr:
 *
 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
 */

try {
  module.exports = typeof XMLHttpRequest !== 'undefined' &&
    'withCredentials' in new XMLHttpRequest();
} catch (err) {
  // if XMLHttp support is disabled in IE then it will throw
  // when trying to create
  module.exports = false;
}


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

/* global attachEvent */

/**
 * Module requirements.
 */

var XMLHttpRequest = __webpack_require__(264);
var Polling = __webpack_require__(391);
var Emitter = __webpack_require__(118);
var inherit = __webpack_require__(193);
var debug = __webpack_require__(194)('engine.io-client:polling-xhr');

/**
 * Module exports.
 */

module.exports = XHR;
module.exports.Request = Request;

/**
 * Empty function
 */

function empty () {}

/**
 * XHR Polling constructor.
 *
 * @param {Object} opts
 * @api public
 */

function XHR (opts) {
  Polling.call(this, opts);
  this.requestTimeout = opts.requestTimeout;
  this.extraHeaders = opts.extraHeaders;

  if (typeof location !== 'undefined') {
    var isSSL = 'https:' === location.protocol;
    var port = location.port;

    // some user agents have empty `location.port`
    if (!port) {
      port = isSSL ? 443 : 80;
    }

    this.xd = (typeof location !== 'undefined' && opts.hostname !== location.hostname) ||
      port !== opts.port;
    this.xs = opts.secure !== isSSL;
  }
}

/**
 * Inherits from Polling.
 */

inherit(XHR, Polling);

/**
 * XHR supports binary
 */

XHR.prototype.supportsBinary = true;

/**
 * Creates a request.
 *
 * @param {String} method
 * @api private
 */

XHR.prototype.request = function (opts) {
  opts = opts || {};
  opts.uri = this.uri();
  opts.xd = this.xd;
  opts.xs = this.xs;
  opts.agent = this.agent || false;
  opts.supportsBinary = this.supportsBinary;
  opts.enablesXDR = this.enablesXDR;

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;
  opts.requestTimeout = this.requestTimeout;

  // other options for Node.js client
  opts.extraHeaders = this.extraHeaders;

  return new Request(opts);
};

/**
 * Sends data.
 *
 * @param {String} data to send.
 * @param {Function} called upon flush.
 * @api private
 */

XHR.prototype.doWrite = function (data, fn) {
  var isBinary = typeof data !== 'string' && data !== undefined;
  var req = this.request({ method: 'POST', data: data, isBinary: isBinary });
  var self = this;
  req.on('success', fn);
  req.on('error', function (err) {
    self.onError('xhr post error', err);
  });
  this.sendXhr = req;
};

/**
 * Starts a poll cycle.
 *
 * @api private
 */

XHR.prototype.doPoll = function () {
  debug('xhr poll');
  var req = this.request();
  var self = this;
  req.on('data', function (data) {
    self.onData(data);
  });
  req.on('error', function (err) {
    self.onError('xhr poll error', err);
  });
  this.pollXhr = req;
};

/**
 * Request constructor
 *
 * @param {Object} options
 * @api public
 */

function Request (opts) {
  this.method = opts.method || 'GET';
  this.uri = opts.uri;
  this.xd = !!opts.xd;
  this.xs = !!opts.xs;
  this.async = false !== opts.async;
  this.data = undefined !== opts.data ? opts.data : null;
  this.agent = opts.agent;
  this.isBinary = opts.isBinary;
  this.supportsBinary = opts.supportsBinary;
  this.enablesXDR = opts.enablesXDR;
  this.requestTimeout = opts.requestTimeout;

  // SSL options for Node.js client
  this.pfx = opts.pfx;
  this.key = opts.key;
  this.passphrase = opts.passphrase;
  this.cert = opts.cert;
  this.ca = opts.ca;
  this.ciphers = opts.ciphers;
  this.rejectUnauthorized = opts.rejectUnauthorized;

  // other options for Node.js client
  this.extraHeaders = opts.extraHeaders;

  this.create();
}

/**
 * Mix in `Emitter`.
 */

Emitter(Request.prototype);

/**
 * Creates the XHR object and sends the request.
 *
 * @api private
 */

Request.prototype.create = function () {
  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;

  var xhr = this.xhr = new XMLHttpRequest(opts);
  var self = this;

  try {
    debug('xhr open %s: %s', this.method, this.uri);
    xhr.open(this.method, this.uri, this.async);
    try {
      if (this.extraHeaders) {
        xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
        for (var i in this.extraHeaders) {
          if (this.extraHeaders.hasOwnProperty(i)) {
            xhr.setRequestHeader(i, this.extraHeaders[i]);
          }
        }
      }
    } catch (e) {}

    if ('POST' === this.method) {
      try {
        if (this.isBinary) {
          xhr.setRequestHeader('Content-type', 'application/octet-stream');
        } else {
          xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
        }
      } catch (e) {}
    }

    try {
      xhr.setRequestHeader('Accept', '*/*');
    } catch (e) {}

    // ie6 check
    if ('withCredentials' in xhr) {
      xhr.withCredentials = true;
    }

    if (this.requestTimeout) {
      xhr.timeout = this.requestTimeout;
    }

    if (this.hasXDR()) {
      xhr.onload = function () {
        self.onLoad();
      };
      xhr.onerror = function () {
        self.onError(xhr.responseText);
      };
    } else {
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 2) {
          try {
            var contentType = xhr.getResponseHeader('Content-Type');
            if (self.supportsBinary && contentType === 'application/octet-stream') {
              xhr.responseType = 'arraybuffer';
            }
          } catch (e) {}
        }
        if (4 !== xhr.readyState) return;
        if (200 === xhr.status || 1223 === xhr.status) {
          self.onLoad();
        } else {
          // make sure the `error` event handler that's user-set
          // does not throw in the same tick and gets caught here
          setTimeout(function () {
            self.onError(xhr.status);
          }, 0);
        }
      };
    }

    debug('xhr data %s', this.data);
    xhr.send(this.data);
  } catch (e) {
    // Need to defer since .create() is called directly fhrom the constructor
    // and thus the 'error' event can only be only bound *after* this exception
    // occurs.  Therefore, also, we cannot throw here at all.
    setTimeout(function () {
      self.onError(e);
    }, 0);
    return;
  }

  if (typeof document !== 'undefined') {
    this.index = Request.requestsCount++;
    Request.requests[this.index] = this;
  }
};

/**
 * Called upon successful response.
 *
 * @api private
 */

Request.prototype.onSuccess = function () {
  this.emit('success');
  this.cleanup();
};

/**
 * Called if we have data.
 *
 * @api private
 */

Request.prototype.onData = function (data) {
  this.emit('data', data);
  this.onSuccess();
};

/**
 * Called upon error.
 *
 * @api private
 */

Request.prototype.onError = function (err) {
  this.emit('error', err);
  this.cleanup(true);
};

/**
 * Cleans up house.
 *
 * @api private
 */

Request.prototype.cleanup = function (fromError) {
  if ('undefined' === typeof this.xhr || null === this.xhr) {
    return;
  }
  // xmlhttprequest
  if (this.hasXDR()) {
    this.xhr.onload = this.xhr.onerror = empty;
  } else {
    this.xhr.onreadystatechange = empty;
  }

  if (fromError) {
    try {
      this.xhr.abort();
    } catch (e) {}
  }

  if (typeof document !== 'undefined') {
    delete Request.requests[this.index];
  }

  this.xhr = null;
};

/**
 * Called upon load.
 *
 * @api private
 */

Request.prototype.onLoad = function () {
  var data;
  try {
    var contentType;
    try {
      contentType = this.xhr.getResponseHeader('Content-Type');
    } catch (e) {}
    if (contentType === 'application/octet-stream') {
      data = this.xhr.response || this.xhr.responseText;
    } else {
      data = this.xhr.responseText;
    }
  } catch (e) {
    this.onError(e);
  }
  if (null != data) {
    this.onData(data);
  }
};

/**
 * Check if it has XDomainRequest.
 *
 * @api private
 */

Request.prototype.hasXDR = function () {
  return typeof XDomainRequest !== 'undefined' && !this.xs && this.enablesXDR;
};

/**
 * Aborts the request.
 *
 * @api public
 */

Request.prototype.abort = function () {
  this.cleanup();
};

/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */

Request.requestsCount = 0;
Request.requests = {};

if (typeof document !== 'undefined') {
  if (typeof attachEvent === 'function') {
    attachEvent('onunload', unloadHandler);
  } else if (typeof addEventListener === 'function') {
    var terminationEvent = 'onpagehide' in self ? 'pagehide' : 'unload';
    addEventListener(terminationEvent, unloadHandler, false);
  }
}

function unloadHandler () {
  for (var i in Request.requests) {
    if (Request.requests.hasOwnProperty(i)) {
      Request.requests[i].abort();
    }
  }
}


/***/ }),
/* 826 */
/***/ (function(module, exports) {


/**
 * Gets the keys for an object.
 *
 * @return {Array} keys
 * @api private
 */

module.exports = Object.keys || function keys (obj){
  var arr = [];
  var has = Object.prototype.hasOwnProperty;

  for (var i in obj) {
    if (has.call(obj, i)) {
      arr.push(i);
    }
  }
  return arr;
};


/***/ }),
/* 827 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 828 */
/***/ (function(module, exports) {

/**
 * An abstraction for slicing an arraybuffer even when
 * ArrayBuffer.prototype.slice is not supported
 *
 * @api public
 */

module.exports = function(arraybuffer, start, end) {
  var bytes = arraybuffer.byteLength;
  start = start || 0;
  end = end || bytes;

  if (arraybuffer.slice) { return arraybuffer.slice(start, end); }

  if (start < 0) { start += bytes; }
  if (end < 0) { end += bytes; }
  if (end > bytes) { end = bytes; }

  if (start >= bytes || start >= end || bytes === 0) {
    return new ArrayBuffer(0);
  }

  var abv = new Uint8Array(arraybuffer);
  var result = new Uint8Array(end - start);
  for (var i = start, ii = 0; i < end; i++, ii++) {
    result[ii] = abv[i];
  }
  return result.buffer;
};


/***/ }),
/* 829 */
/***/ (function(module, exports) {

module.exports = after

function after(count, callback, err_cb) {
    var bail = false
    err_cb = err_cb || noop
    proxy.count = count

    return (count === 0) ? callback() : proxy

    function proxy(err, result) {
        if (proxy.count <= 0) {
            throw new Error('after called too many times')
        }
        --proxy.count

        // after first error, rest are passed to err_cb
        if (err) {
            bail = true
            callback(err)
            // future error callbacks will go to error handler
            callback = err_cb
        } else if (proxy.count === 0 && !bail) {
            callback(null, result)
        }
    }
}

function noop() {}


/***/ }),
/* 830 */
/***/ (function(module, exports) {

/*! https://mths.be/utf8js v2.1.2 by @mathias */

var stringFromCharCode = String.fromCharCode;

// Taken from https://mths.be/punycode
function ucs2decode(string) {
	var output = [];
	var counter = 0;
	var length = string.length;
	var value;
	var extra;
	while (counter < length) {
		value = string.charCodeAt(counter++);
		if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
			// high surrogate, and there is a next character
			extra = string.charCodeAt(counter++);
			if ((extra & 0xFC00) == 0xDC00) { // low surrogate
				output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
			} else {
				// unmatched surrogate; only append this code unit, in case the next
				// code unit is the high surrogate of a surrogate pair
				output.push(value);
				counter--;
			}
		} else {
			output.push(value);
		}
	}
	return output;
}

// Taken from https://mths.be/punycode
function ucs2encode(array) {
	var length = array.length;
	var index = -1;
	var value;
	var output = '';
	while (++index < length) {
		value = array[index];
		if (value > 0xFFFF) {
			value -= 0x10000;
			output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
			value = 0xDC00 | value & 0x3FF;
		}
		output += stringFromCharCode(value);
	}
	return output;
}

function checkScalarValue(codePoint, strict) {
	if (codePoint >= 0xD800 && codePoint <= 0xDFFF) {
		if (strict) {
			throw Error(
				'Lone surrogate U+' + codePoint.toString(16).toUpperCase() +
				' is not a scalar value'
			);
		}
		return false;
	}
	return true;
}
/*--------------------------------------------------------------------------*/

function createByte(codePoint, shift) {
	return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
}

function encodeCodePoint(codePoint, strict) {
	if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
		return stringFromCharCode(codePoint);
	}
	var symbol = '';
	if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
		symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
	}
	else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
		if (!checkScalarValue(codePoint, strict)) {
			codePoint = 0xFFFD;
		}
		symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
		symbol += createByte(codePoint, 6);
	}
	else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
		symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
		symbol += createByte(codePoint, 12);
		symbol += createByte(codePoint, 6);
	}
	symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
	return symbol;
}

function utf8encode(string, opts) {
	opts = opts || {};
	var strict = false !== opts.strict;

	var codePoints = ucs2decode(string);
	var length = codePoints.length;
	var index = -1;
	var codePoint;
	var byteString = '';
	while (++index < length) {
		codePoint = codePoints[index];
		byteString += encodeCodePoint(codePoint, strict);
	}
	return byteString;
}

/*--------------------------------------------------------------------------*/

function readContinuationByte() {
	if (byteIndex >= byteCount) {
		throw Error('Invalid byte index');
	}

	var continuationByte = byteArray[byteIndex] & 0xFF;
	byteIndex++;

	if ((continuationByte & 0xC0) == 0x80) {
		return continuationByte & 0x3F;
	}

	// If we end up here, it’s not a continuation byte
	throw Error('Invalid continuation byte');
}

function decodeSymbol(strict) {
	var byte1;
	var byte2;
	var byte3;
	var byte4;
	var codePoint;

	if (byteIndex > byteCount) {
		throw Error('Invalid byte index');
	}

	if (byteIndex == byteCount) {
		return false;
	}

	// Read first byte
	byte1 = byteArray[byteIndex] & 0xFF;
	byteIndex++;

	// 1-byte sequence (no continuation bytes)
	if ((byte1 & 0x80) == 0) {
		return byte1;
	}

	// 2-byte sequence
	if ((byte1 & 0xE0) == 0xC0) {
		byte2 = readContinuationByte();
		codePoint = ((byte1 & 0x1F) << 6) | byte2;
		if (codePoint >= 0x80) {
			return codePoint;
		} else {
			throw Error('Invalid continuation byte');
		}
	}

	// 3-byte sequence (may include unpaired surrogates)
	if ((byte1 & 0xF0) == 0xE0) {
		byte2 = readContinuationByte();
		byte3 = readContinuationByte();
		codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
		if (codePoint >= 0x0800) {
			return checkScalarValue(codePoint, strict) ? codePoint : 0xFFFD;
		} else {
			throw Error('Invalid continuation byte');
		}
	}

	// 4-byte sequence
	if ((byte1 & 0xF8) == 0xF0) {
		byte2 = readContinuationByte();
		byte3 = readContinuationByte();
		byte4 = readContinuationByte();
		codePoint = ((byte1 & 0x07) << 0x12) | (byte2 << 0x0C) |
			(byte3 << 0x06) | byte4;
		if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
			return codePoint;
		}
	}

	throw Error('Invalid UTF-8 detected');
}

var byteArray;
var byteCount;
var byteIndex;
function utf8decode(byteString, opts) {
	opts = opts || {};
	var strict = false !== opts.strict;

	byteArray = ucs2decode(byteString);
	byteCount = byteArray.length;
	byteIndex = 0;
	var codePoints = [];
	var tmp;
	while ((tmp = decodeSymbol(strict)) !== false) {
		codePoints.push(tmp);
	}
	return ucs2encode(codePoints);
}

module.exports = {
	version: '2.1.2',
	encode: utf8encode,
	decode: utf8decode
};


/***/ }),
/* 831 */
/***/ (function(module, exports) {

/*
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */
(function(){
  "use strict";

  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

  // Use a lookup table to find the index.
  var lookup = new Uint8Array(256);
  for (var i = 0; i < chars.length; i++) {
    lookup[chars.charCodeAt(i)] = i;
  }

  exports.encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer),
    i, len = bytes.length, base64 = "";

    for (i = 0; i < len; i+=3) {
      base64 += chars[bytes[i] >> 2];
      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
      base64 += chars[bytes[i + 2] & 63];
    }

    if ((len % 3) === 2) {
      base64 = base64.substring(0, base64.length - 1) + "=";
    } else if (len % 3 === 1) {
      base64 = base64.substring(0, base64.length - 2) + "==";
    }

    return base64;
  };

  exports.decode =  function(base64) {
    var bufferLength = base64.length * 0.75,
    len = base64.length, i, p = 0,
    encoded1, encoded2, encoded3, encoded4;

    if (base64[base64.length - 1] === "=") {
      bufferLength--;
      if (base64[base64.length - 2] === "=") {
        bufferLength--;
      }
    }

    var arraybuffer = new ArrayBuffer(bufferLength),
    bytes = new Uint8Array(arraybuffer);

    for (i = 0; i < len; i+=4) {
      encoded1 = lookup[base64.charCodeAt(i)];
      encoded2 = lookup[base64.charCodeAt(i+1)];
      encoded3 = lookup[base64.charCodeAt(i+2)];
      encoded4 = lookup[base64.charCodeAt(i+3)];

      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
    }

    return arraybuffer;
  };
})();


/***/ }),
/* 832 */
/***/ (function(module, exports) {

/**
 * Create a blob builder even when vendor prefixes exist
 */

var BlobBuilder = typeof BlobBuilder !== 'undefined' ? BlobBuilder :
  typeof WebKitBlobBuilder !== 'undefined' ? WebKitBlobBuilder :
  typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder :
  typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : 
  false;

/**
 * Check if Blob constructor is supported
 */

var blobSupported = (function() {
  try {
    var a = new Blob(['hi']);
    return a.size === 2;
  } catch(e) {
    return false;
  }
})();

/**
 * Check if Blob constructor supports ArrayBufferViews
 * Fails in Safari 6, so we need to map to ArrayBuffers there.
 */

var blobSupportsArrayBufferView = blobSupported && (function() {
  try {
    var b = new Blob([new Uint8Array([1,2])]);
    return b.size === 2;
  } catch(e) {
    return false;
  }
})();

/**
 * Check if BlobBuilder is supported
 */

var blobBuilderSupported = BlobBuilder
  && BlobBuilder.prototype.append
  && BlobBuilder.prototype.getBlob;

/**
 * Helper function that maps ArrayBufferViews to ArrayBuffers
 * Used by BlobBuilder constructor and old browsers that didn't
 * support it in the Blob constructor.
 */

function mapArrayBufferViews(ary) {
  return ary.map(function(chunk) {
    if (chunk.buffer instanceof ArrayBuffer) {
      var buf = chunk.buffer;

      // if this is a subarray, make a copy so we only
      // include the subarray region from the underlying buffer
      if (chunk.byteLength !== buf.byteLength) {
        var copy = new Uint8Array(chunk.byteLength);
        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
        buf = copy.buffer;
      }

      return buf;
    }

    return chunk;
  });
}

function BlobBuilderConstructor(ary, options) {
  options = options || {};

  var bb = new BlobBuilder();
  mapArrayBufferViews(ary).forEach(function(part) {
    bb.append(part);
  });

  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();
};

function BlobConstructor(ary, options) {
  return new Blob(mapArrayBufferViews(ary), options || {});
};

if (typeof Blob !== 'undefined') {
  BlobBuilderConstructor.prototype = Blob.prototype;
  BlobConstructor.prototype = Blob.prototype;
}

module.exports = (function() {
  if (blobSupported) {
    return blobSupportsArrayBufferView ? Blob : BlobConstructor;
  } else if (blobBuilderSupported) {
    return BlobBuilderConstructor;
  } else {
    return undefined;
  }
})();


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(261);

/**
 * Active `debug` instances.
 */
exports.instances = [];

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  var prevTime;

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);
  debug.destroy = destroy;

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  exports.instances.push(debug);

  return debug;
}

function destroy () {
  var index = exports.instances.indexOf(this);
  if (index !== -1) {
    exports.instances.splice(index, 1);
    return true;
  } else {
    return false;
  }
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var i;
  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }

  for (i = 0; i < exports.instances.length; i++) {
    var instance = exports.instances[i];
    instance.enabled = exports.enabled(instance.namespace);
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  if (name[name.length - 1] === '*') {
    return true;
  }
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Module requirements.
 */

var Polling = __webpack_require__(391);
var inherit = __webpack_require__(193);

/**
 * Module exports.
 */

module.exports = JSONPPolling;

/**
 * Cached regular expressions.
 */

var rNewline = /\n/g;
var rEscapedNewline = /\\n/g;

/**
 * Global JSONP callbacks.
 */

var callbacks;

/**
 * Noop.
 */

function empty () { }

/**
 * Until https://github.com/tc39/proposal-global is shipped.
 */
function glob () {
  return typeof self !== 'undefined' ? self
      : typeof window !== 'undefined' ? window
      : typeof global !== 'undefined' ? global : {};
}

/**
 * JSONP Polling constructor.
 *
 * @param {Object} opts.
 * @api public
 */

function JSONPPolling (opts) {
  Polling.call(this, opts);

  this.query = this.query || {};

  // define global callbacks array if not present
  // we do this here (lazily) to avoid unneeded global pollution
  if (!callbacks) {
    // we need to consider multiple engines in the same page
    var global = glob();
    callbacks = global.___eio = (global.___eio || []);
  }

  // callback identifier
  this.index = callbacks.length;

  // add callback to jsonp global
  var self = this;
  callbacks.push(function (msg) {
    self.onData(msg);
  });

  // append to query string
  this.query.j = this.index;

  // prevent spurious errors from being emitted when the window is unloaded
  if (typeof addEventListener === 'function') {
    addEventListener('beforeunload', function () {
      if (self.script) self.script.onerror = empty;
    }, false);
  }
}

/**
 * Inherits from Polling.
 */

inherit(JSONPPolling, Polling);

/*
 * JSONP only supports binary as base64 encoded strings
 */

JSONPPolling.prototype.supportsBinary = false;

/**
 * Closes the socket.
 *
 * @api private
 */

JSONPPolling.prototype.doClose = function () {
  if (this.script) {
    this.script.parentNode.removeChild(this.script);
    this.script = null;
  }

  if (this.form) {
    this.form.parentNode.removeChild(this.form);
    this.form = null;
    this.iframe = null;
  }

  Polling.prototype.doClose.call(this);
};

/**
 * Starts a poll cycle.
 *
 * @api private
 */

JSONPPolling.prototype.doPoll = function () {
  var self = this;
  var script = document.createElement('script');

  if (this.script) {
    this.script.parentNode.removeChild(this.script);
    this.script = null;
  }

  script.async = true;
  script.src = this.uri();
  script.onerror = function (e) {
    self.onError('jsonp poll error', e);
  };

  var insertAt = document.getElementsByTagName('script')[0];
  if (insertAt) {
    insertAt.parentNode.insertBefore(script, insertAt);
  } else {
    (document.head || document.body).appendChild(script);
  }
  this.script = script;

  var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);

  if (isUAgecko) {
    setTimeout(function () {
      var iframe = document.createElement('iframe');
      document.body.appendChild(iframe);
      document.body.removeChild(iframe);
    }, 100);
  }
};

/**
 * Writes with a hidden iframe.
 *
 * @param {String} data to send
 * @param {Function} called upon flush.
 * @api private
 */

JSONPPolling.prototype.doWrite = function (data, fn) {
  var self = this;

  if (!this.form) {
    var form = document.createElement('form');
    var area = document.createElement('textarea');
    var id = this.iframeId = 'eio_iframe_' + this.index;
    var iframe;

    form.className = 'socketio';
    form.style.position = 'absolute';
    form.style.top = '-1000px';
    form.style.left = '-1000px';
    form.target = id;
    form.method = 'POST';
    form.setAttribute('accept-charset', 'utf-8');
    area.name = 'd';
    form.appendChild(area);
    document.body.appendChild(form);

    this.form = form;
    this.area = area;
  }

  this.form.action = this.uri();

  function complete () {
    initIframe();
    fn();
  }

  function initIframe () {
    if (self.iframe) {
      try {
        self.form.removeChild(self.iframe);
      } catch (e) {
        self.onError('jsonp polling iframe removal error', e);
      }
    }

    try {
      // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
      var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
      iframe = document.createElement(html);
    } catch (e) {
      iframe = document.createElement('iframe');
      iframe.name = self.iframeId;
      iframe.src = 'javascript:0';
    }

    iframe.id = self.iframeId;

    self.form.appendChild(iframe);
    self.iframe = iframe;
  }

  initIframe();

  // escape \n to prevent it from being converted into \r\n by some UAs
  // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side
  data = data.replace(rEscapedNewline, '\\\n');
  this.area.value = data.replace(rNewline, '\\n');

  try {
    this.form.submit();
  } catch (e) {}

  if (this.iframe.attachEvent) {
    this.iframe.onreadystatechange = function () {
      if (self.iframe.readyState === 'complete') {
        complete();
      }
    };
  } else {
    this.iframe.onload = complete;
  }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(67)))

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/**
 * Module dependencies.
 */

var Transport = __webpack_require__(265);
var parser = __webpack_require__(136);
var parseqs = __webpack_require__(192);
var inherit = __webpack_require__(193);
var yeast = __webpack_require__(393);
var debug = __webpack_require__(194)('engine.io-client:websocket');

var BrowserWebSocket, NodeWebSocket;

if (typeof WebSocket !== 'undefined') {
  BrowserWebSocket = WebSocket;
} else if (typeof self !== 'undefined') {
  BrowserWebSocket = self.WebSocket || self.MozWebSocket;
} else {
  try {
    NodeWebSocket = __webpack_require__(836);
  } catch (e) { }
}

/**
 * Get either the `WebSocket` or `MozWebSocket` globals
 * in the browser or try to resolve WebSocket-compatible
 * interface exposed by `ws` for Node-like environment.
 */

var WebSocketImpl = BrowserWebSocket || NodeWebSocket;

/**
 * Module exports.
 */

module.exports = WS;

/**
 * WebSocket transport constructor.
 *
 * @api {Object} connection options
 * @api public
 */

function WS (opts) {
  var forceBase64 = (opts && opts.forceBase64);
  if (forceBase64) {
    this.supportsBinary = false;
  }
  this.perMessageDeflate = opts.perMessageDeflate;
  this.usingBrowserWebSocket = BrowserWebSocket && !opts.forceNode;
  this.protocols = opts.protocols;
  if (!this.usingBrowserWebSocket) {
    WebSocketImpl = NodeWebSocket;
  }
  Transport.call(this, opts);
}

/**
 * Inherits from Transport.
 */

inherit(WS, Transport);

/**
 * Transport name.
 *
 * @api public
 */

WS.prototype.name = 'websocket';

/*
 * WebSockets support binary
 */

WS.prototype.supportsBinary = true;

/**
 * Opens socket.
 *
 * @api private
 */

WS.prototype.doOpen = function () {
  if (!this.check()) {
    // let probe timeout
    return;
  }

  var uri = this.uri();
  var protocols = this.protocols;
  var opts = {
    agent: this.agent,
    perMessageDeflate: this.perMessageDeflate
  };

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;
  if (this.extraHeaders) {
    opts.headers = this.extraHeaders;
  }
  if (this.localAddress) {
    opts.localAddress = this.localAddress;
  }

  try {
    this.ws =
      this.usingBrowserWebSocket && !this.isReactNative
        ? protocols
          ? new WebSocketImpl(uri, protocols)
          : new WebSocketImpl(uri)
        : new WebSocketImpl(uri, protocols, opts);
  } catch (err) {
    return this.emit('error', err);
  }

  if (this.ws.binaryType === undefined) {
    this.supportsBinary = false;
  }

  if (this.ws.supports && this.ws.supports.binary) {
    this.supportsBinary = true;
    this.ws.binaryType = 'nodebuffer';
  } else {
    this.ws.binaryType = 'arraybuffer';
  }

  this.addEventListeners();
};

/**
 * Adds event listeners to the socket
 *
 * @api private
 */

WS.prototype.addEventListeners = function () {
  var self = this;

  this.ws.onopen = function () {
    self.onOpen();
  };
  this.ws.onclose = function () {
    self.onClose();
  };
  this.ws.onmessage = function (ev) {
    self.onData(ev.data);
  };
  this.ws.onerror = function (e) {
    self.onError('websocket error', e);
  };
};

/**
 * Writes data to socket.
 *
 * @param {Array} array of packets.
 * @api private
 */

WS.prototype.write = function (packets) {
  var self = this;
  this.writable = false;

  // encodePacket efficient as it uses WS framing
  // no need for encodePayload
  var total = packets.length;
  for (var i = 0, l = total; i < l; i++) {
    (function (packet) {
      parser.encodePacket(packet, self.supportsBinary, function (data) {
        if (!self.usingBrowserWebSocket) {
          // always create a new object (GH-437)
          var opts = {};
          if (packet.options) {
            opts.compress = packet.options.compress;
          }

          if (self.perMessageDeflate) {
            var len = 'string' === typeof data ? Buffer.byteLength(data) : data.length;
            if (len < self.perMessageDeflate.threshold) {
              opts.compress = false;
            }
          }
        }

        // Sometimes the websocket has already been closed but the browser didn't
        // have a chance of informing us about it yet, in that case send will
        // throw an error
        try {
          if (self.usingBrowserWebSocket) {
            // TypeError is thrown when passing the second argument on Safari
            self.ws.send(data);
          } else {
            self.ws.send(data, opts);
          }
        } catch (e) {
          debug('websocket closed before onclose event');
        }

        --total || done();
      });
    })(packets[i]);
  }

  function done () {
    self.emit('flush');

    // fake drain
    // defer to next tick to allow Socket to clear writeBuffer
    setTimeout(function () {
      self.writable = true;
      self.emit('drain');
    }, 0);
  }
};

/**
 * Called upon close
 *
 * @api private
 */

WS.prototype.onClose = function () {
  Transport.prototype.onClose.call(this);
};

/**
 * Closes socket.
 *
 * @api private
 */

WS.prototype.doClose = function () {
  if (typeof this.ws !== 'undefined') {
    this.ws.close();
  }
};

/**
 * Generates uri for connection.
 *
 * @api private
 */

WS.prototype.uri = function () {
  var query = this.query || {};
  var schema = this.secure ? 'wss' : 'ws';
  var port = '';

  // avoid port if default for schema
  if (this.port && (('wss' === schema && Number(this.port) !== 443) ||
    ('ws' === schema && Number(this.port) !== 80))) {
    port = ':' + this.port;
  }

  // append timestamp to URI
  if (this.timestampRequests) {
    query[this.timestampParam] = yeast();
  }

  // communicate binary support capabilities
  if (!this.supportsBinary) {
    query.b64 = 1;
  }

  query = parseqs.encode(query);

  // prepend ? to query
  if (query.length) {
    query = '?' + query;
  }

  var ipv6 = this.hostname.indexOf(':') !== -1;
  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
};

/**
 * Feature detection for WebSocket.
 *
 * @return {Boolean} whether this transport is available.
 * @api public
 */

WS.prototype.check = function () {
  return !!WebSocketImpl && !('__initialize' in WebSocketImpl && this.name === WS.prototype.name);
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(263).Buffer))

/***/ }),
/* 836 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 837 */
/***/ (function(module, exports) {

module.exports = toArray

function toArray(list, index) {
    var array = []

    index = index || 0

    for (var i = index || 0; i < list.length; i++) {
        array[i - index] = list[i]
    }

    return array
}


/***/ }),
/* 838 */
/***/ (function(module, exports) {


/**
 * Expose `Backoff`.
 */

module.exports = Backoff;

/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */

function Backoff(opts) {
  opts = opts || {};
  this.ms = opts.min || 100;
  this.max = opts.max || 10000;
  this.factor = opts.factor || 2;
  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
  this.attempts = 0;
}

/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */

Backoff.prototype.duration = function(){
  var ms = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var rand =  Math.random();
    var deviation = Math.floor(rand * this.jitter * ms);
    ms = (Math.floor(rand * 10) & 1) == 0  ? ms - deviation : ms + deviation;
  }
  return Math.min(ms, this.max) | 0;
};

/**
 * Reset the number of attempts.
 *
 * @api public
 */

Backoff.prototype.reset = function(){
  this.attempts = 0;
};

/**
 * Set the minimum duration
 *
 * @api public
 */

Backoff.prototype.setMin = function(min){
  this.ms = min;
};

/**
 * Set the maximum duration
 *
 * @api public
 */

Backoff.prototype.setMax = function(max){
  this.max = max;
};

/**
 * Set the jitter
 *
 * @api public
 */

Backoff.prototype.setJitter = function(jitter){
  this.jitter = jitter;
};



/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApiClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_superagent__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qs__);
var methods=['get','post','delete','put','patch'];var ApiClient=/*#__PURE__*/function(){function ApiClient(apiHost,mlsApiHost,clientId){var _this=this;__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,ApiClient);this.clientid=clientId;methods.forEach(function(method){return _this[method]=function(path){var _ref=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{},_ref$params=_ref.params,params=_ref$params===void 0?{}:_ref$params,data=_ref.data,headers=_ref.headers;var host=path.indexOf('mls-connection')!==-1||path.indexOf('agent-mls-ids')!==-1?mlsApiHost:apiHost;return _this.handleCall(method,host+path,params,data,headers);};});}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ApiClient,[{key:"handleCall",value:function handleCall(method,path,params,data,headers){var _this2=this;return new Promise(function(resolve,reject){var request=__WEBPACK_IMPORTED_MODULE_2_superagent___default.a[method](path).withCredentials();var clientid=_this2.clientid;if(params){request.query(__WEBPACK_IMPORTED_MODULE_3_qs___default.a.stringify(params));}request.set('Accept','application/json');// Add cache control to avoid problems in IE 11 and older
request.set('Cache-Control','private, no-cache, no-store, must-revalidate');request.set('Expires','0');request.set('Pragma','no-cache');request.set('clientid',clientid);for(var header in headers){if(headers.hasOwnProperty(header)){request.set(header,headers[header]);}}if(data){request.send(data);}request.end(function(err){var res=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};if(err){err.statusCode=res.statusCode;}return err?reject(err):resolve(res.body);});});}}]);return ApiClient;}();

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Root reference for iframes.
 */

var root;
if (typeof window !== 'undefined') { // Browser window
  root = window;
} else if (typeof self !== 'undefined') { // Web Worker
  root = self;
} else { // Other environments
  console.warn("Using browser-only version of superagent in non-browser environment");
  root = this;
}

var Emitter = __webpack_require__(118);
var RequestBase = __webpack_require__(841);
var isObject = __webpack_require__(398);
var ResponseBase = __webpack_require__(842);
var Agent = __webpack_require__(844);

/**
 * Noop.
 */

function noop(){};

/**
 * Expose `request`.
 */

var request = exports = module.exports = function(method, url) {
  // callback
  if ('function' == typeof url) {
    return new exports.Request('GET', method).end(url);
  }

  // url first
  if (1 == arguments.length) {
    return new exports.Request('GET', method);
  }

  return new exports.Request(method, url);
}

exports.Request = Request;

/**
 * Determine XHR.
 */

request.getXHR = function () {
  if (root.XMLHttpRequest
      && (!root.location || 'file:' != root.location.protocol
          || !root.ActiveXObject)) {
    return new XMLHttpRequest;
  } else {
    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
  }
  throw Error("Browser-only version of superagent could not find XHR");
};

/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */

var trim = ''.trim
  ? function(s) { return s.trim(); }
  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };

/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(obj) {
  if (!isObject(obj)) return obj;
  var pairs = [];
  for (var key in obj) {
    pushEncodedKeyValuePair(pairs, key, obj[key]);
  }
  return pairs.join('&');
}

/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */

function pushEncodedKeyValuePair(pairs, key, val) {
  if (val != null) {
    if (Array.isArray(val)) {
      val.forEach(function(v) {
        pushEncodedKeyValuePair(pairs, key, v);
      });
    } else if (isObject(val)) {
      for(var subkey in val) {
        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
      }
    } else {
      pairs.push(encodeURIComponent(key)
        + '=' + encodeURIComponent(val));
    }
  } else if (val === null) {
    pairs.push(encodeURIComponent(key));
  }
}

/**
 * Expose serialization method.
 */

request.serializeObject = serialize;

/**
  * Parse the given x-www-form-urlencoded `str`.
  *
  * @param {String} str
  * @return {Object}
  * @api private
  */

function parseString(str) {
  var obj = {};
  var pairs = str.split('&');
  var pair;
  var pos;

  for (var i = 0, len = pairs.length; i < len; ++i) {
    pair = pairs[i];
    pos = pair.indexOf('=');
    if (pos == -1) {
      obj[decodeURIComponent(pair)] = '';
    } else {
      obj[decodeURIComponent(pair.slice(0, pos))] =
        decodeURIComponent(pair.slice(pos + 1));
    }
  }

  return obj;
}

/**
 * Expose parser.
 */

request.parseString = parseString;

/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'text/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  'form': 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};

/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

request.serialize = {
  'application/x-www-form-urlencoded': serialize,
  'application/json': JSON.stringify,
};

/**
  * Default parsers.
  *
  *     superagent.parse['application/xml'] = function(str){
  *       return { object parsed from str };
  *     };
  *
  */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse,
};

/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(str) {
  var lines = str.split(/\r?\n/);
  var fields = {};
  var index;
  var line;
  var field;
  var val;

  for (var i = 0, len = lines.length; i < len; ++i) {
    line = lines[i];
    index = line.indexOf(':');
    if (index === -1) { // could be empty line, just skip it
      continue;
    }
    field = line.slice(0, index).toLowerCase();
    val = trim(line.slice(index + 1));
    fields[field] = val;
  }

  return fields;
}

/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */

function isJSON(mime) {
  // should match /json or +json
  // but not /json-seq
  return /[\/+]json($|[^-\w])/.test(mime);
}

/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */

function Response(req) {
  this.req = req;
  this.xhr = this.req.xhr;
  // responseText is accessible only if responseType is '' or 'text' and on older browsers
  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
     ? this.xhr.responseText
     : null;
  this.statusText = this.req.xhr.statusText;
  var status = this.xhr.status;
  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
  if (status === 1223) {
    status = 204;
  }
  this._setStatusProperties(status);
  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.
  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
  this._setHeaderProperties(this.header);

  if (null === this.text && req._responseType) {
    this.body = this.xhr.response;
  } else {
    this.body = this.req.method != 'HEAD'
      ? this._parseBody(this.text ? this.text : this.xhr.response)
      : null;
  }
}

ResponseBase(Response.prototype);

/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype._parseBody = function(str) {
  var parse = request.parse[this.type];
  if (this.req._parser) {
    return this.req._parser(this, str);
  }
  if (!parse && isJSON(this.type)) {
    parse = request.parse['application/json'];
  }
  return parse && str && (str.length || str instanceof Object)
    ? parse(str)
    : null;
};

/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */

Response.prototype.toError = function(){
  var req = this.req;
  var method = req.method;
  var url = req.url;

  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
  var err = new Error(msg);
  err.status = this.status;
  err.method = method;
  err.url = url;

  return err;
};

/**
 * Expose `Response`.
 */

request.Response = Response;

/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  var self = this;
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {}; // preserves header name case
  this._header = {}; // coerces header names to lowercase
  this.on('end', function(){
    var err = null;
    var res = null;

    try {
      res = new Response(self);
    } catch(e) {
      err = new Error('Parser is unable to parse the response');
      err.parse = true;
      err.original = e;
      // issue #675: return the raw response if the response parsing fails
      if (self.xhr) {
        // ie9 doesn't have 'response' property
        err.rawResponse = typeof self.xhr.responseType == 'undefined' ? self.xhr.responseText : self.xhr.response;
        // issue #876: return the http status code if the response parsing fails
        err.status = self.xhr.status ? self.xhr.status : null;
        err.statusCode = err.status; // backwards-compat only
      } else {
        err.rawResponse = null;
        err.status = null;
      }

      return self.callback(err);
    }

    self.emit('response', res);

    var new_err;
    try {
      if (!self._isResponseOK(res)) {
        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
      }
    } catch(custom_err) {
      new_err = custom_err; // ok() callback can throw
    }

    // #1000 don't catch errors from the callback to avoid double calling it
    if (new_err) {
      new_err.original = err;
      new_err.response = res;
      new_err.status = res.status;
      self.callback(new_err, res);
    } else {
      self.callback(null, res);
    }
  });
}

/**
 * Mixin `Emitter` and `RequestBase`.
 */

Emitter(Request.prototype);
RequestBase(Request.prototype);

/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function(type){
  this.set('Content-Type', request.types[type] || type);
  return this;
};

/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.accept = function(type){
  this.set('Accept', request.types[type] || type);
  return this;
};

/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} [pass] optional in case of using 'bearer' as type
 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.auth = function(user, pass, options){
  if (1 === arguments.length) pass = '';
  if (typeof pass === 'object' && pass !== null) { // pass is optional and can be replaced with options
    options = pass;
    pass = '';
  }
  if (!options) {
    options = {
      type: 'function' === typeof btoa ? 'basic' : 'auto',
    };
  }

  var encoder = function(string) {
    if ('function' === typeof btoa) {
      return btoa(string);
    }
    throw new Error('Cannot use basic auth, btoa is not a function');
  };

  return this._auth(user, pass, options, encoder);
};

/**
 * Add query-string `val`.
 *
 * Examples:
 *
 *   request.get('/shoes')
 *     .query('size=10')
 *     .query({ color: 'blue' })
 *
 * @param {Object|String} val
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.query = function(val){
  if ('string' != typeof val) val = serialize(val);
  if (val) this._query.push(val);
  return this;
};

/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `options` (or filename).
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String|Object} options
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.attach = function(field, file, options){
  if (file) {
    if (this._data) {
      throw Error("superagent can't mix .send() and .attach()");
    }

    this._getFormData().append(field, file, options || file.name);
  }
  return this;
};

Request.prototype._getFormData = function(){
  if (!this._formData) {
    this._formData = new root.FormData();
  }
  return this._formData;
};

/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */

Request.prototype.callback = function(err, res){
  if (this._shouldRetry(err, res)) {
    return this._retry();
  }

  var fn = this._callback;
  this.clearTimeout();

  if (err) {
    if (this._maxRetries) err.retries = this._retries - 1;
    this.emit('error', err);
  }

  fn(err, res);
};

/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */

Request.prototype.crossDomainError = function(){
  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
  err.crossDomain = true;

  err.status = this.status;
  err.method = this.method;
  err.url = this.url;

  this.callback(err);
};

// This only warns, because the request is still likely to work
Request.prototype.buffer = Request.prototype.ca = Request.prototype.agent = function(){
  console.warn("This is not supported in browser version of superagent");
  return this;
};

// This throws, because it can't send/receive data as expected
Request.prototype.pipe = Request.prototype.write = function(){
  throw Error("Streaming is not supported in browser version of superagent");
};

/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */
Request.prototype._isHost = function _isHost(obj) {
  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
  return obj && 'object' === typeof obj && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
}

/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.end = function(fn){
  if (this._endCalled) {
    console.warn("Warning: .end() was called twice. This is not supported in superagent");
  }
  this._endCalled = true;

  // store callback
  this._callback = fn || noop;

  // querystring
  this._finalizeQueryString();

  return this._end();
};

Request.prototype._end = function() {
  var self = this;
  var xhr = (this.xhr = request.getXHR());
  var data = this._formData || this._data;

  this._setTimeouts();

  // state change
  xhr.onreadystatechange = function(){
    var readyState = xhr.readyState;
    if (readyState >= 2 && self._responseTimeoutTimer) {
      clearTimeout(self._responseTimeoutTimer);
    }
    if (4 != readyState) {
      return;
    }

    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"
    var status;
    try { status = xhr.status } catch(e) { status = 0; }

    if (!status) {
      if (self.timedout || self._aborted) return;
      return self.crossDomainError();
    }
    self.emit('end');
  };

  // progress
  var handleProgress = function(direction, e) {
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;
    }
    e.direction = direction;
    self.emit('progress', e);
  };
  if (this.hasListeners('progress')) {
    try {
      xhr.onprogress = handleProgress.bind(null, 'download');
      if (xhr.upload) {
        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
      }
    } catch(e) {
      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
      // Reported here:
      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
  }

  // initiate request
  try {
    if (this.username && this.password) {
      xhr.open(this.method, this.url, true, this.username, this.password);
    } else {
      xhr.open(this.method, this.url, true);
    }
  } catch (err) {
    // see #1149
    return this.callback(err);
  }

  // CORS
  if (this._withCredentials) xhr.withCredentials = true;

  // body
  if (!this._formData && 'GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
    // serialize stuff
    var contentType = this._header['content-type'];
    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
    if (!serialize && isJSON(contentType)) {
      serialize = request.serialize['application/json'];
    }
    if (serialize) data = serialize(data);
  }

  // set header fields
  for (var field in this.header) {
    if (null == this.header[field]) continue;

    if (this.header.hasOwnProperty(field))
      xhr.setRequestHeader(field, this.header[field]);
  }

  if (this._responseType) {
    xhr.responseType = this._responseType;
  }

  // send stuff
  this.emit('request', this);

  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
  // We need null here if data is undefined
  xhr.send(typeof data !== 'undefined' ? data : null);
  return this;
};

request.agent = function() {
  return new Agent();
};

["GET", "POST", "OPTIONS", "PATCH", "PUT", "DELETE"].forEach(function(method) {
  Agent.prototype[method.toLowerCase()] = function(url, fn) {
    var req = new request.Request(method, url);
    this._setDefaults(req);
    if (fn) {
      req.end(fn);
    }
    return req;
  };
});

Agent.prototype.del = Agent.prototype['delete'];

/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.get = function(url, data, fn) {
  var req = request('GET', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.head = function(url, data, fn) {
  var req = request('HEAD', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.options = function(url, data, fn) {
  var req = request('OPTIONS', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * DELETE `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

function del(url, data, fn) {
  var req = request('DELETE', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
}

request['del'] = del;
request['delete'] = del;

/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.patch = function(url, data, fn) {
  var req = request('PATCH', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.post = function(url, data, fn) {
  var req = request('POST', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.put = function(url, data, fn) {
  var req = request('PUT', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Module of mixed-in functions shared between node and client code
 */
var isObject = __webpack_require__(398);

/**
 * Expose `RequestBase`.
 */

module.exports = RequestBase;

/**
 * Initialize a new `RequestBase`.
 *
 * @api public
 */

function RequestBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in RequestBase.prototype) {
    obj[key] = RequestBase.prototype[key];
  }
  return obj;
}

/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.clearTimeout = function _clearTimeout(){
  clearTimeout(this._timer);
  clearTimeout(this._responseTimeoutTimer);
  delete this._timer;
  delete this._responseTimeoutTimer;
  return this;
};

/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.parse = function parse(fn){
  this._parser = fn;
  return this;
};

/**
 * Set format of binary response body.
 * In browser valid formats are 'blob' and 'arraybuffer',
 * which return Blob and ArrayBuffer, respectively.
 *
 * In Node all values result in Buffer.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.responseType = function(val){
  this._responseType = val;
  return this;
};

/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.serialize = function serialize(fn){
  this._serializer = fn;
  return this;
};

/**
 * Set timeouts.
 *
 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
 *
 * Value of 0 or false means no timeout.
 *
 * @param {Number|Object} ms or {response, deadline}
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.timeout = function timeout(options){
  if (!options || 'object' !== typeof options) {
    this._timeout = options;
    this._responseTimeout = 0;
    return this;
  }

  for(var option in options) {
    switch(option) {
      case 'deadline':
        this._timeout = options.deadline;
        break;
      case 'response':
        this._responseTimeout = options.response;
        break;
      default:
        console.warn("Unknown timeout option", option);
    }
  }
  return this;
};

/**
 * Set number of retry attempts on error.
 *
 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
 *
 * @param {Number} count
 * @param {Function} [fn]
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.retry = function retry(count, fn){
  // Default to 1 if no count passed or true
  if (arguments.length === 0 || count === true) count = 1;
  if (count <= 0) count = 0;
  this._maxRetries = count;
  this._retries = 0;
  this._retryCallback = fn;
  return this;
};

var ERROR_CODES = [
  'ECONNRESET',
  'ETIMEDOUT',
  'EADDRINFO',
  'ESOCKETTIMEDOUT'
];

/**
 * Determine if a request should be retried.
 * (Borrowed from segmentio/superagent-retry)
 *
 * @param {Error} err
 * @param {Response} [res]
 * @returns {Boolean}
 */
RequestBase.prototype._shouldRetry = function(err, res) {
  if (!this._maxRetries || this._retries++ >= this._maxRetries) {
    return false;
  }
  if (this._retryCallback) {
    try {
      var override = this._retryCallback(err, res);
      if (override === true) return true;
      if (override === false) return false;
      // undefined falls back to defaults
    } catch(e) {
      console.error(e);
    }
  }
  if (res && res.status && res.status >= 500 && res.status != 501) return true;
  if (err) {
    if (err.code && ~ERROR_CODES.indexOf(err.code)) return true;
    // Superagent timeout
    if (err.timeout && err.code == 'ECONNABORTED') return true;
    if (err.crossDomain) return true;
  }
  return false;
};

/**
 * Retry request
 *
 * @return {Request} for chaining
 * @api private
 */

RequestBase.prototype._retry = function() {

  this.clearTimeout();

  // node
  if (this.req) {
    this.req = null;
    this.req = this.request();
  }

  this._aborted = false;
  this.timedout = false;

  return this._end();
};

/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} [reject]
 * @return {Request}
 */

RequestBase.prototype.then = function then(resolve, reject) {
  if (!this._fullfilledPromise) {
    var self = this;
    if (this._endCalled) {
      console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
    }
    this._fullfilledPromise = new Promise(function(innerResolve, innerReject) {
      self.end(function(err, res) {
        if (err) innerReject(err);
        else innerResolve(res);
      });
    });
  }
  return this._fullfilledPromise.then(resolve, reject);
};

RequestBase.prototype.catch = function(cb) {
  return this.then(undefined, cb);
};

/**
 * Allow for extension
 */

RequestBase.prototype.use = function use(fn) {
  fn(this);
  return this;
};

RequestBase.prototype.ok = function(cb) {
  if ('function' !== typeof cb) throw Error("Callback required");
  this._okCallback = cb;
  return this;
};

RequestBase.prototype._isResponseOK = function(res) {
  if (!res) {
    return false;
  }

  if (this._okCallback) {
    return this._okCallback(res);
  }

  return res.status >= 200 && res.status < 300;
};

/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

RequestBase.prototype.get = function(field){
  return this._header[field.toLowerCase()];
};

/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */

RequestBase.prototype.getHeader = RequestBase.prototype.get;

/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.set = function(field, val){
  if (isObject(field)) {
    for (var key in field) {
      this.set(key, field[key]);
    }
    return this;
  }
  this._header[field.toLowerCase()] = val;
  this.header[field] = val;
  return this;
};

/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field
 */
RequestBase.prototype.unset = function(field){
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};

/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name
 * @param {String|Blob|File|Buffer|fs.ReadStream} val
 * @return {Request} for chaining
 * @api public
 */
RequestBase.prototype.field = function(name, val) {
  // name should be either a string or an object.
  if (null === name || undefined === name) {
    throw new Error('.field(name, val) name can not be empty');
  }

  if (this._data) {
    console.error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObject(name)) {
    for (var key in name) {
      this.field(key, name[key]);
    }
    return this;
  }

  if (Array.isArray(val)) {
    for (var i in val) {
      this.field(name, val[i]);
    }
    return this;
  }

  // val should be defined now
  if (null === val || undefined === val) {
    throw new Error('.field(name, val) val can not be empty');
  }
  if ('boolean' === typeof val) {
    val = '' + val;
  }
  this._getFormData().append(name, val);
  return this;
};

/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request}
 * @api public
 */
RequestBase.prototype.abort = function(){
  if (this._aborted) {
    return this;
  }
  this._aborted = true;
  this.xhr && this.xhr.abort(); // browser
  this.req && this.req.abort(); // node
  this.clearTimeout();
  this.emit('abort');
  return this;
};

RequestBase.prototype._auth = function(user, pass, options, base64Encoder) {
  switch (options.type) {
    case 'basic':
      this.set('Authorization', 'Basic ' + base64Encoder(user + ':' + pass));
      break;

    case 'auto':
      this.username = user;
      this.password = pass;
      break;

    case 'bearer': // usage would be .auth(accessToken, { type: 'bearer' })
      this.set('Authorization', 'Bearer ' + user);
      break;
  }
  return this;
};

/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */

RequestBase.prototype.withCredentials = function(on) {
  // This is browser-only functionality. Node side is no-op.
  if (on == undefined) on = true;
  this._withCredentials = on;
  return this;
};

/**
 * Set the max redirects to `n`. Does noting in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.redirects = function(n){
  this._maxRedirects = n;
  return this;
};

/**
 * Maximum size of buffered response body, in bytes. Counts uncompressed size.
 * Default 200MB.
 *
 * @param {Number} n
 * @return {Request} for chaining
 */
RequestBase.prototype.maxResponseSize = function(n){
  if ('number' !== typeof n) {
    throw TypeError("Invalid argument");
  }
  this._maxResponseSize = n;
  return this;
};

/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */

RequestBase.prototype.toJSON = function() {
  return {
    method: this.method,
    url: this.url,
    data: this._data,
    headers: this._header,
  };
};

/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.send = function(data){
  var isObj = isObject(data);
  var type = this._header['content-type'];

  if (this._formData) {
    console.error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObj && !this._data) {
    if (Array.isArray(data)) {
      this._data = [];
    } else if (!this._isHost(data)) {
      this._data = {};
    }
  } else if (data && this._data && this._isHost(this._data)) {
    throw Error("Can't merge these send calls");
  }

  // merge
  if (isObj && isObject(this._data)) {
    for (var key in data) {
      this._data[key] = data[key];
    }
  } else if ('string' == typeof data) {
    // default to x-www-form-urlencoded
    if (!type) this.type('form');
    type = this._header['content-type'];
    if ('application/x-www-form-urlencoded' == type) {
      this._data = this._data
        ? this._data + '&' + data
        : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }

  if (!isObj || this._isHost(data)) {
    return this;
  }

  // default to json
  if (!type) this.type('json');
  return this;
};

/**
 * Sort `querystring` by the sort function
 *
 *
 * Examples:
 *
 *       // default order
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery()
 *         .end(callback)
 *
 *       // customized sort function
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery(function(a, b){
 *           return a.length - b.length;
 *         })
 *         .end(callback)
 *
 *
 * @param {Function} sort
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.sortQuery = function(sort) {
  // _sort default to true but otherwise can be a function or boolean
  this._sort = typeof sort === 'undefined' ? true : sort;
  return this;
};

/**
 * Compose querystring to append to req.url
 *
 * @api private
 */
RequestBase.prototype._finalizeQueryString = function(){
  var query = this._query.join('&');
  if (query) {
    this.url += (this.url.indexOf('?') >= 0 ? '&' : '?') + query;
  }
  this._query.length = 0; // Makes the call idempotent

  if (this._sort) {
    var index = this.url.indexOf('?');
    if (index >= 0) {
      var queryArr = this.url.substring(index + 1).split('&');
      if ('function' === typeof this._sort) {
        queryArr.sort(this._sort);
      } else {
        queryArr.sort();
      }
      this.url = this.url.substring(0, index) + '?' + queryArr.join('&');
    }
  }
};

// For backwards compat only
RequestBase.prototype._appendQueryString = function() {console.trace("Unsupported");}

/**
 * Invoke callback with timeout error.
 *
 * @api private
 */

RequestBase.prototype._timeoutError = function(reason, timeout, errno){
  if (this._aborted) {
    return;
  }
  var err = new Error(reason + timeout + 'ms exceeded');
  err.timeout = timeout;
  err.code = 'ECONNABORTED';
  err.errno = errno;
  this.timedout = true;
  this.abort();
  this.callback(err);
};

RequestBase.prototype._setTimeouts = function() {
  var self = this;

  // deadline
  if (this._timeout && !this._timer) {
    this._timer = setTimeout(function(){
      self._timeoutError('Timeout of ', self._timeout, 'ETIME');
    }, this._timeout);
  }
  // response timeout
  if (this._responseTimeout && !this._responseTimeoutTimer) {
    this._responseTimeoutTimer = setTimeout(function(){
      self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
    }, this._responseTimeout);
  }
};


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Module dependencies.
 */

var utils = __webpack_require__(843);

/**
 * Expose `ResponseBase`.
 */

module.exports = ResponseBase;

/**
 * Initialize a new `ResponseBase`.
 *
 * @api public
 */

function ResponseBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in ResponseBase.prototype) {
    obj[key] = ResponseBase.prototype[key];
  }
  return obj;
}

/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

ResponseBase.prototype.get = function(field) {
  return this.header[field.toLowerCase()];
};

/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */

ResponseBase.prototype._setHeaderProperties = function(header){
    // TODO: moar!
    // TODO: make this a util

    // content-type
    var ct = header['content-type'] || '';
    this.type = utils.type(ct);

    // params
    var params = utils.params(ct);
    for (var key in params) this[key] = params[key];

    this.links = {};

    // links
    try {
        if (header.link) {
            this.links = utils.parseLinks(header.link);
        }
    } catch (err) {
        // ignore
    }
};

/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */

ResponseBase.prototype._setStatusProperties = function(status){
    var type = status / 100 | 0;

    // status / class
    this.status = this.statusCode = status;
    this.statusType = type;

    // basics
    this.info = 1 == type;
    this.ok = 2 == type;
    this.redirect = 3 == type;
    this.clientError = 4 == type;
    this.serverError = 5 == type;
    this.error = (4 == type || 5 == type)
        ? this.toError()
        : false;

    // sugar
    this.accepted = 202 == status;
    this.noContent = 204 == status;
    this.badRequest = 400 == status;
    this.unauthorized = 401 == status;
    this.notAcceptable = 406 == status;
    this.forbidden = 403 == status;
    this.notFound = 404 == status;
};


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

exports.type = function(str){
  return str.split(/ *; */).shift();
};

/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.params = function(str){
  return str.split(/ *; */).reduce(function(obj, str){
    var parts = str.split(/ *= */);
    var key = parts.shift();
    var val = parts.shift();

    if (key && val) obj[key] = val;
    return obj;
  }, {});
};

/**
 * Parse Link header fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.parseLinks = function(str){
  return str.split(/ *, */).reduce(function(obj, str){
    var parts = str.split(/ *; */);
    var url = parts[0].slice(1, -1);
    var rel = parts[1].split(/ *= */)[1].slice(1, -1);
    obj[rel] = url;
    return obj;
  }, {});
};

/**
 * Strip content related fields from `header`.
 *
 * @param {Object} header
 * @return {Object} header
 * @api private
 */

exports.cleanHeader = function(header, changesOrigin){
  delete header['content-type'];
  delete header['content-length'];
  delete header['transfer-encoding'];
  delete header['host'];
  // secuirty
  if (changesOrigin) {
    delete header['authorization'];
    delete header['cookie'];
  }
  return header;
};


/***/ }),
/* 844 */
/***/ (function(module, exports) {

function Agent() {
  this._defaults = [];
}

["use", "on", "once", "set", "query", "type", "accept", "auth", "withCredentials", "sortQuery", "retry", "ok", "redirects",
 "timeout", "buffer", "serialize", "parse", "ca", "key", "pfx", "cert"].forEach(function(fn) {
  /** Default setting for all requests from this agent */
  Agent.prototype[fn] = function(/*varargs*/) {
    this._defaults.push({fn:fn, arguments:arguments});
    return this;
  }
});

Agent.prototype._setDefaults = function(req) {
    this._defaults.forEach(function(def) {
      req[def.fn].apply(req, def.arguments);
    });
};

module.exports = Agent;


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(846);
var parse = __webpack_require__(847);
var formats = __webpack_require__(400);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(399);
var formats = __webpack_require__(400);

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
        return prefix + '[]';
    },
    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
        return prefix;
    }
};

var toISO = Date.prototype.toISOString;

var defaults = {
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var stringify = function stringify( // eslint-disable-line func-name-matching
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    formatter,
    encodeValuesOnly
) {
    var obj = object;
    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder) : prefix;
        }

        obj = '';
    }

    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (Array.isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        if (Array.isArray(obj)) {
            values = values.concat(stringify(
                obj[key],
                generateArrayPrefix(prefix, key),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly
            ));
        } else {
            values = values.concat(stringify(
                obj[key],
                prefix + (allowDots ? '.' + key : '[' + key + ']'),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly
            ));
        }
    }

    return values;
};

module.exports = function (object, opts) {
    var obj = object;
    var options = opts ? utils.assign({}, opts) : {};

    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
    var encoder = typeof options.encoder === 'function' ? options.encoder : defaults.encoder;
    var sort = typeof options.sort === 'function' ? options.sort : null;
    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults.encodeValuesOnly;
    if (typeof options.format === 'undefined') {
        options.format = formats['default'];
    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
        throw new TypeError('Unknown format option provided.');
    }
    var formatter = formats.formatters[options.format];
    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (Array.isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (options.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = options.arrayFormat;
    } else if ('indices' in options) {
        arrayFormat = options.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (sort) {
        objKeys.sort(sort);
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        keys = keys.concat(stringify(
            obj[key],
            key,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encode ? encoder : null,
            filter,
            sort,
            allowDots,
            serializeDate,
            formatter,
            encodeValuesOnly
        ));
    }

    var joined = keys.join(delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(399);

var has = Object.prototype.hasOwnProperty;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    parameterLimit: 1000,
    plainObjects: false,
    strictNullHandling: false
};

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);

    for (var i = 0; i < parts.length; ++i) {
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder);
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder);
            val = options.decoder(part.slice(pos + 1), defaults.decoder);
        }
        if (has.call(obj, key)) {
            obj[key] = [].concat(obj[key]).concat(val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options) {
    var leaf = val;

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]') {
            obj = [];
            obj = obj.concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys
        // that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options);
};

module.exports = function (str, opts) {
    var options = opts ? utils.assign({}, opts) : {};

    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    options.ignoreQueryPrefix = options.ignoreQueryPrefix === true;
    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
    options.parseArrays = options.parseArrays !== false;
    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options);
        obj = utils.merge(obj, newObj, options);
    }

    return utils.compact(obj);
};


/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__session__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__companies__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__account__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__crs__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__discount__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__workspaces__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__error__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__cloudFolders__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__quickMessages__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__preloader__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__chargebeeLoader__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mls__ = __webpack_require__(92);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({routing:__WEBPACK_IMPORTED_MODULE_1_react_router_redux__["c" /* routerReducer */],session:__WEBPACK_IMPORTED_MODULE_2__session__["a" /* default */],companies:__WEBPACK_IMPORTED_MODULE_3__companies__["i" /* default */],account:__WEBPACK_IMPORTED_MODULE_4__account__["d" /* default */],app:__WEBPACK_IMPORTED_MODULE_7__app__["c" /* default */],crs:__WEBPACK_IMPORTED_MODULE_5__crs__["d" /* default */],discount:__WEBPACK_IMPORTED_MODULE_6__discount__["g" /* default */],workspaces:__WEBPACK_IMPORTED_MODULE_8__workspaces__["b" /* default */],modal:__WEBPACK_IMPORTED_MODULE_9__modal__["a" /* default */],error:__WEBPACK_IMPORTED_MODULE_10__error__["a" /* default */],cloudFolders:__WEBPACK_IMPORTED_MODULE_11__cloudFolders__["d" /* default */],quickMessages:__WEBPACK_IMPORTED_MODULE_12__quickMessages__["a" /* default */],preloader:__WEBPACK_IMPORTED_MODULE_13__preloader__["a" /* default */],chargebeeLoader:__WEBPACK_IMPORTED_MODULE_14__chargebeeLoader__["a" /* default */],mls:__WEBPACK_IMPORTED_MODULE_15__mls__["g" /* default */]}));

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__errors_apperror__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__errors_httperror__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__logger_logger__ = __webpack_require__(40);
var log=__WEBPACK_IMPORTED_MODULE_10__logger_logger__["a" /* default */].get('staticresource');var RETRY_TIMEOUT=1000;var RETRY_MAX=5;var StaticResource=/*#__PURE__*/function(){function StaticResource(){__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this,StaticResource);}__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(StaticResource,[{key:"get",value:function get(path){var requestNumber=0;return new Promise(function(resolve,reject){var onRetry=function onRetry(res){setTimeout(function(){doAjaxRequest(requestNumber<RETRY_MAX);},RETRY_TIMEOUT);};var doAjaxRequest=function doAjaxRequest(shouldRetry){requestNumber++;__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__config__["R" /* HTTP_STATIC_RESOURCES_URL */]+path).then(resolve)["catch"](/*#__PURE__*/function(){var _ref=__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.mark(function _callee(error){var httpErrorProps,nError;return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["d" /* isNetworkStatusOffline */])(error)&&shouldRetry&&requestNumber<=RETRY_MAX){onRetry();}else{httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_6__errors_errorhelper__["a" /* extractPropsforAxiosHttpError */])(error);nError=new __WEBPACK_IMPORTED_MODULE_8__errors_apperror__["a" /* default */]({message:'Static Resources failed',errorId:__WEBPACK_IMPORTED_MODULE_7__errors_errorids__["a" /* default */].UNKNOWN,originalError:new __WEBPACK_IMPORTED_MODULE_9__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:'STATIC_RESOURCE'}});log.send(nError);reject(nError);}case 1:case"end":return _context.stop();}}},_callee);}));return function(_x){return _ref.apply(this,arguments);};}());};doAjaxRequest(true);});}}]);return StaticResource;}();/* harmony default export */ __webpack_exports__["a"] = (new StaticResource());

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(67)))

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_TopBar_TopBar__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_MainNav_MainNav__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_MainContent_MainContent__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Preloader_Preloader__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_ProcessingOrder_ProcessingOrder__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Modal_Modal__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_QuickMessages_QuickMessages__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_router__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_redux_modules_session__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_router_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lib_Segment_helpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_i18n_i18n__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_routes__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_redux_modules_mls__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_redux_modules_companies__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_redux_modules_app__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_redux_modules_account__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_redux_modules_workspaces__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_redux_modules_preloader__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_redux_modules_chargebeeLoader__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_redux_modules_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_theme_uiConfig__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__AppContext__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_utils_state__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_utils_storage__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_utils_url__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_lib_Segment_customTrackers__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_redux_modules_apistatustester__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__utils_subscription__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__utils_users__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__logger_logger__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__errors_apperror__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__errors_httperror__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_validator_lib_isEmail__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_validator_lib_isEmail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49_validator_lib_isEmail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_redux_modules_crs__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_redux_modules_discount__ = __webpack_require__(119);
var _dec,_class;var log=__WEBPACK_IMPORTED_MODULE_46__logger_logger__["a" /* default */].get('App');var styles=function styles(theme){return{root:{position:'relative',display:'flex',width:'100%',height:'100vh'},topBarPadding:{paddingTop:__WEBPACK_IMPORTED_MODULE_36_theme_uiConfig__["f" /* topBarHeight */]},content:{flexGrow:1,transition:theme.transitions.create('margin',{easing:theme.transitions.easing.sharp,duration:theme.transitions.duration.leavingScreen}),marginLeft:"-".concat(__WEBPACK_IMPORTED_MODULE_36_theme_uiConfig__["c" /* mainNavWidth */],"px"),overflow:'auto'},contentShift:{transition:theme.transitions.create('margin',{easing:theme.transitions.easing.easeOut,duration:theme.transitions.duration.enteringScreen}),marginLeft:0},maxWidth:{width:'100%'}};};var App=(_dec=Object(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(App,_Component);function App(props){var _this;__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this,App);_this=__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(App).call(this,props));_this.handleWindowResizeDebounced=__WEBPACK_IMPORTED_MODULE_37_lodash___default.a.debounce(_this.handleWindowResize.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)),500);_this.toggleNav=_this.toggleNav.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.scrollContentToTop=_this.scrollContentToTop.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.setMainRef=_this.setMainRef.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.redirectToXC=_this.redirectToXC.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.main=null;var isConfirmedSubscription=false;var isInitialSubscription=false;var isPerpetualSubscription=false;var subscriptionId=null;var cid=null;var realEstatePlan=null;var productName=null;var magixCat=null;var askForCompany=null;var isDiscountTakeoverFromWebsite=false;var redirectRoute=null;var showInvalidQueryPlanIdMessage;var isCBPlanExternalRedirect;var isCBPlanInternalRedirect;var productQuantity;var productSource;var productPeriod;var reactivateSubscription;var queryParams=Object(__WEBPACK_IMPORTED_MODULE_41_utils_url__["d" /* parseQuery */])(props.location.search);if(queryParams['confirm-subscription']==='true'){isConfirmedSubscription=true;var savedCheckoutPlanId=Object(__WEBPACK_IMPORTED_MODULE_40_utils_storage__["i" /* getCheckoutPlan */])();if(savedCheckoutPlanId){if(Object(__WEBPACK_IMPORTED_MODULE_44__utils_subscription__["t" /* isPerpetualPlan */])(savedCheckoutPlanId)){isPerpetualSubscription=true;}else{isInitialSubscription=true;}}// remove query parameters from the hash
subscriptionId=queryParams['subscription-id'];window.location.hash=window.location.hash.split('?')[0];}if(queryParams['cid']){cid=queryParams['cid'];}if(queryParams[__WEBPACK_IMPORTED_MODULE_33_config__["_26" /* REAL_ESTATE_PLAN_PARAM */]]){realEstatePlan=queryParams[__WEBPACK_IMPORTED_MODULE_33_config__["_26" /* REAL_ESTATE_PLAN_PARAM */]];}if(queryParams[__WEBPACK_IMPORTED_MODULE_33_config__["T" /* IS_REAL_ESTATE_POPUP */]]){Object(__WEBPACK_IMPORTED_MODULE_40_utils_storage__["B" /* saveIsReUpgradePopupFlag */])(true);}else{Object(__WEBPACK_IMPORTED_MODULE_40_utils_storage__["f" /* clearIsReUpgradePopupFlag */])();}if(queryParams['prod']){productName=queryParams['prod'];if(['XPL','XWDL','XPGDL'].includes(productName.toUpperCase())){_this.props.setPerpetuallAppFlag(true);}}if(queryParams[__WEBPACK_IMPORTED_MODULE_33_config__["_20" /* REACTIVATE_PARAM */]]){reactivateSubscription=true;}if(queryParams['source']){productSource=queryParams['source'];}if(queryParams['period']){productPeriod=queryParams['period'];}if(queryParams['quantity']){productQuantity=queryParams['quantity'];}if(queryParams['pcat']){magixCat=queryParams['pcat'];}if(queryParams['select-company']){askForCompany=queryParams['select-company'];}// remove some query params from URL
if(queryParams[__WEBPACK_IMPORTED_MODULE_33_config__["_20" /* REACTIVATE_PARAM */]]||queryParams[__WEBPACK_IMPORTED_MODULE_33_config__["_26" /* REAL_ESTATE_PLAN_PARAM */]]||queryParams[__WEBPACK_IMPORTED_MODULE_33_config__["T" /* IS_REAL_ESTATE_POPUP */]]||queryParams[__WEBPACK_IMPORTED_MODULE_33_config__["B" /* DESKTOP_APPLICATION_PARAM */]]||_this.props.isDesktopApp||productSource||_this.props.isDiscountTakeoverFromWebsite||_this.props.isUpgradePopup||_this.props.isCouponIdProvided){if(queryParams[__WEBPACK_IMPORTED_MODULE_33_config__["B" /* DESKTOP_APPLICATION_PARAM */]]||_this.props.isDesktopApp){_this.props.setDesktopUserFlag(true);}if(_this.props.isDiscountTakeoverFromWebsite){isDiscountTakeoverFromWebsite=true;}if(_this.props.isUpgradePopup){_this.props.setUpgradePopupFlag(true);}if(_this.props.isCouponIdProvided){_this.props.setCouponIdProvidedFlag(true);}var queryParamsCleaned=[];if(!__WEBPACK_IMPORTED_MODULE_37_lodash___default.a.isEmpty(queryParams)){Object.keys(queryParams).forEach(function(key){if(key===__WEBPACK_IMPORTED_MODULE_33_config__["_17" /* PRODUCT_QUANTITY_PARAM */]||key===__WEBPACK_IMPORTED_MODULE_33_config__["_18" /* PRODUCT_SOURCE_PARAM */]||key===__WEBPACK_IMPORTED_MODULE_33_config__["B" /* DESKTOP_APPLICATION_PARAM */]||key===__WEBPACK_IMPORTED_MODULE_33_config__["_49" /* UPGRADE_POPUP_PARAM */]||key===__WEBPACK_IMPORTED_MODULE_33_config__["T" /* IS_REAL_ESTATE_POPUP */]||key===__WEBPACK_IMPORTED_MODULE_33_config__["_26" /* REAL_ESTATE_PLAN_PARAM */]||key===__WEBPACK_IMPORTED_MODULE_33_config__["u" /* COUPON_ID_PARAM */]||key===__WEBPACK_IMPORTED_MODULE_33_config__["_20" /* REACTIVATE_PARAM */]||key===__WEBPACK_IMPORTED_MODULE_33_config__["g" /* ASK_FOR_COMPANY_PARAM */]||_this.isPlusOverview&&[__WEBPACK_IMPORTED_MODULE_33_config__["W" /* MAGIX_SERIAL_PARAM */],__WEBPACK_IMPORTED_MODULE_33_config__["V" /* MAGIX_EMAIL_PARAM */],__WEBPACK_IMPORTED_MODULE_33_config__["U" /* MAGIX_CATEGORY_PARAM */]].includes(key))return;queryParamsCleaned.push("".concat(key,"=").concat(queryParams[key]));});}window.location.hash=window.location.hash.split('?')[0]+_this.flattenQueryParams(queryParamsCleaned);}if(isDiscountTakeoverFromWebsite&&_this.isPlusOverview){var magixSerial=queryParams.pserial&&window.atob(queryParams.pserial);var magixEmail=queryParams.pemail&&window.atob(queryParams.pemail);if(magixSerial&&magixEmail&&__WEBPACK_IMPORTED_MODULE_49_validator_lib_isEmail___default()(magixEmail)&&__WEBPACK_IMPORTED_MODULE_33_config__["_33" /* SERIAL_NUMBER_REGEXP */].test(magixSerial)){_this.props.saveTakeOverCredentials(magixEmail,magixSerial);_this.props.checkCrsCredentials(magixEmail,magixSerial,__WEBPACK_IMPORTED_MODULE_37_lodash___default.a.get(_this.props.user,'mainEmail'),__WEBPACK_IMPORTED_MODULE_33_config__["Y" /* MAXIC_DISCOUNT_PROD_TYPE */].SUBSCRIPTION);}}var cbPlanId=queryParams['chargebee-plan-id'];if(props.isCbPlanProvided&&cbPlanId){if(cbPlanId.indexOf('plus-overview')!==-1||cbPlanId.indexOf('perpetual-overview')!==-1||cbPlanId.indexOf('real-estate-overview')!==-1||cbPlanId.indexOf('standard-overview')!==-1){isCBPlanInternalRedirect=true;}else if(Object.values(__WEBPACK_IMPORTED_MODULE_33_config__["_42" /* SUBSCRIPTION_PLAN */]).includes(cbPlanId.split('-')[0])){isCBPlanExternalRedirect=true;}else{redirectRoute=__WEBPACK_IMPORTED_MODULE_23_routes__["n" /* SUBSCRIPTION */];showInvalidQueryPlanIdMessage=true;}}if(queryParams[__WEBPACK_IMPORTED_MODULE_33_config__["H" /* EXTERNAL_REDIRECT_PARAM */]]){isCBPlanExternalRedirect=true;}if(queryParams[__WEBPACK_IMPORTED_MODULE_33_config__["S" /* INTERNAL_REDIRECT_PARAM */]]){isCBPlanInternalRedirect=true;}_this.state={loading:true,navOpen:true,hasCompany:false,companyFoundInSession:false,isInitialSubscription:isInitialSubscription,isConfirmedSubscription:isConfirmedSubscription,isPerpetualSubscription:isPerpetualSubscription,askForCompany:askForCompany,isDiscountTakeoverFromWebsite:isDiscountTakeoverFromWebsite,isCBPlanExternalRedirect:isCBPlanExternalRedirect,isCBPlanInternalRedirect:isCBPlanInternalRedirect,isCbPlanProvided:props.isCbPlanProvided,subscriptionId:subscriptionId,cid:cid,realEstatePlan:realEstatePlan,productName:productName,productSource:productSource,productPeriod:productPeriod,productQuantity:productQuantity,magixCat:magixCat,redirectRoute:redirectRoute,showInvalidQueryPlanIdMessage:showInvalidQueryPlanIdMessage,redirectToXC:null,reloadApp:props.reloadApp,cbPlanId:cbPlanId,externalDiscountApplied:false,reactivateSubscription:reactivateSubscription};return _this;}__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(App,[{key:"setMainRef",value:function setMainRef(element){this.main=element;}},{key:"componentWillMount",value:function componentWillMount(){var _this2=this;this.props.fetchSession().then(function(data){if(data.result){// Update current language to user settings language
var serverLanguage=__WEBPACK_IMPORTED_MODULE_37_lodash___default.a.get(data,'result.user.settings.language');if(serverLanguage&&serverLanguage!==window.localStorage.getItem('lang')){window.localStorage.setItem('lang',serverLanguage);if(_this2.props.originalHash||_this2.props.originalSearch){var newLocation=_this2.props.originalHash||_this2.props.originalSearch;if(newLocation.indexOf('?')===-1){newLocation+='?ts='+new Date().getTime();}else{newLocation+='&ts='+new Date().getTime();}window.location.href=newLocation;window.location.reload();}else{window.location.href='?ts='+new Date().getTime();}}var companyId=Object(__WEBPACK_IMPORTED_MODULE_26_redux_modules_companies__["D" /* resolveActiveCompanyId */])(true);var isPayingCompany=__WEBPACK_IMPORTED_MODULE_37_lodash___default.a.get(_this2.props,'companies.byId['+companyId+'].hasActiveSubscription');Object(__WEBPACK_IMPORTED_MODULE_46__logger_logger__["b" /* setupLogger */])(_this2.props.user,companyId,isPayingCompany);var company=data.result.companies.find(function(company){return company._id===companyId;});if(company&&company.displayName){document.title='Xara Workspace | '+company.displayName;}_this2.props.getActiveCompanyId();_this2.props.getDesktopAppFlag();_this2.props.changeCompanyAndNotify();_this2.props.connectCompanySocketEvents();_this2.props.connectUserSocketEventProviderChange();_this2.props.connectUserSocketEventLogout();_this2.props.connectWorkspacesSocketEvents();_this2.props.fetchCompaniesIndustries();_this2.props.fetchCompaniesSizes();_this2.props.fetchUserRegion();_this2.props.fetchCompaniesCountries();_this2.props.fetchMlsBoards();_this2.props.resolveMLsUiType();_this2.props.hidePreloader();var userInfo={email:__WEBPACK_IMPORTED_MODULE_37_lodash___default.a.get(_this2.props.user,'mainEmail'),name:__WEBPACK_IMPORTED_MODULE_37_lodash___default.a.get(_this2.props.user,'name')};Object(__WEBPACK_IMPORTED_MODULE_21_lib_Segment_helpers__["b" /* identify */])(userInfo,Object(__WEBPACK_IMPORTED_MODULE_21_lib_Segment_helpers__["a" /* getTrackingOptions */])(_this2.props.company));}else{if(data instanceof __WEBPACK_IMPORTED_MODULE_47__errors_apperror__["a" /* default */]){var firstMessage=data.getMesageFromHistoryAtIndex(0);if(firstMessage instanceof __WEBPACK_IMPORTED_MODULE_48__errors_httperror__["a" /* default */]&&firstMessage.status===403){var trackingId=localStorage.getItem('ajs_user_id');if(trackingId&&trackingId!=='null'&&!trackingId.match(/^"[a-f\d]{24}"$/i)){window.analytics&&window.analytics.reset&&window.analytics.reset();window.Intercom&&window.Intercom('shutdown');// Give Segment and Intercom the time to clear cookies and localstorage before redirecting
setTimeout(function(){return _this2.setState({redirectToXC:true});},1000);}else{_this2.setState({redirectToXC:true});}}}}});}},{key:"toggleNav",value:function toggleNav(){this.setState({navOpen:!this.state.navOpen});}},{key:"hideNav",value:function hideNav(){this.setState({navOpen:false});}},{key:"showNav",value:function showNav(){this.setState({navOpen:true});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _nextProps$companies=nextProps.companies,selectedId=_nextProps$companies.selectedId,rawDataById=_nextProps$companies.rawDataById,allIds=_nextProps$companies.allIds;var allRawIds=rawDataById?Object.keys(rawDataById):[];var errorId=nextProps.errorId,isGuest=nextProps.isGuest,reloadApp=nextProps.reloadApp;var _this$state=this.state,loading=_this$state.loading,externalDiscountApplied=_this$state.externalDiscountApplied;if(!externalDiscountApplied){if(this.state.isDiscountTakeoverFromWebsite&&this.isPlusOverview&&this.props.crs.areCredentialsValid!==nextProps.crs.areCredentialsValid&&nextProps.crs.areCredentialsValid===true&&this.props.modalShown===false){this.props.applyMagixDiscount(nextProps.crs.takeoverMagixEmail,nextProps.crs.takeoverProductSerial,nextProps.crs.prodCatOfLastValidCombination,nextProps.crs.tierOfLastValidCombination,__WEBPACK_IMPORTED_MODULE_33_config__["Y" /* MAXIC_DISCOUNT_PROD_TYPE */].SUBSCRIPTION);Object(__WEBPACK_IMPORTED_MODULE_42_lib_Segment_customTrackers__["I" /* trackRouteMagixDiscount */])(nextProps.crs.prodCatOfLastValidCombination,Object(__WEBPACK_IMPORTED_MODULE_21_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));this.setState({externalDiscountApplied:true});}else if(this.props.app.isUpgradePopup&&this.isStandardProductOverview&&!nextProps.discount.isDiscountApplied){this.props.applyDiscountUsingCouponSetId(__WEBPACK_IMPORTED_MODULE_33_config__["E" /* DISCOUNT_KEY */].UPGRADE_POPUP);this.setState({externalDiscountApplied:true});}else if(selectedId&&this.props.app.isCouponIdProvided&&(this.isStandardProductOverview||this.isPlusOverview||this.isPerpetualOverview)&&this.props.discount.pendingRequest===null){if(!this.state.isCBPlanExternalRedirect){this.props.applyDiscountUsingCouponId(this.state.cid,this.isPerpetualOverview?__WEBPACK_IMPORTED_MODULE_33_config__["v" /* COUPON_TYPE */].LICENSES:__WEBPACK_IMPORTED_MODULE_33_config__["v" /* COUPON_TYPE */].SEATS,true);}this.setState({externalDiscountApplied:true});}}if(nextProps.paymentRedirectUrl){// This is charbee redirect url in format https://xara-test.chargebee.com/pages/v3/ID/
window.location=nextProps.paymentRedirectUrl;return;}if(this.props.company&&this.state.productQuantity&&this.state.productSource==='pricing'){if(this.props.selectedCompanyId){var isPayingCompany=__WEBPACK_IMPORTED_MODULE_37_lodash___default.a.get(this.props,'companies.byId['+this.props.selectedCompanyId+'].hasActiveSubscription');if(!isPayingCompany){var nonGuestUsers=Object(__WEBPACK_IMPORTED_MODULE_45__utils_users__["e" /* filterNonGuestUsers */])(this.props.company.users);if(nonGuestUsers.length>this.state.productQuantity){this.setState({productQuantity:nonGuestUsers.length});}}}}if(errorId){this.props.showModal('ERROR_MODAL');}else if(loading&&reloadApp){// Reload app on error
if(allIds.length>1){this.props.showModal('COMPANY_SELECTION_MODAL',{redirectURL:__WEBPACK_IMPORTED_MODULE_23_routes__["l" /* ROOT */]});}else{window.location.href=window.location.origin+__WEBPACK_IMPORTED_MODULE_23_routes__["l" /* ROOT */].replace(':companyId','#'+Object(__WEBPACK_IMPORTED_MODULE_26_redux_modules_companies__["D" /* resolveActiveCompanyId */])(false));}}else if(isGuest){this.props.showModal('GUEST_MODAL');}else if(!this.state.redirectRoute){this.renderUpgradePopup();}if(allRawIds){// There are companies returned by session, but user could not have admin/member permission to any of them.
// We get selectedId using getActiveCompanyId and initializeFromSession, selectedId might be defined or not but
// we also check if companyId is not found in session to offer user to switch accounts
this.setState({reloadApp:false,loading:false,hasCompany:!!selectedId,companyFoundInSession:allRawIds.includes(selectedId)});if(!loading&&!allRawIds.includes(selectedId)){var nError=new __WEBPACK_IMPORTED_MODULE_47__errors_apperror__["a" /* default */]({message:'Company not found in session in App.js',errorId:__WEBPACK_IMPORTED_MODULE_24_errors_errorids__["a" /* default */].UNKNOWN,visualisers:{feature:'APP'},errorDetails:{allRawIds:allRawIds,selectedId:selectedId,resolvedActiveCompanyId:Object(__WEBPACK_IMPORTED_MODULE_26_redux_modules_companies__["D" /* resolveActiveCompanyId */])(true)}});log.send(nError);}}}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){var _this$state2=this.state,redirectRoute=_this$state2.redirectRoute,isConfirmedSubscription=_this$state2.isConfirmedSubscription;var selectedCompanyId=this.props.selectedCompanyId;if(this.props.location.pathname!==prevProps.location.pathname){this.scrollContentToTop();this.handleWindowResizeDebounced();}if(selectedCompanyId){if(!redirectRoute&&isConfirmedSubscription){this.setState({redirectRoute:__WEBPACK_IMPORTED_MODULE_23_routes__["q" /* SUBSCRIPTION_SUCCESSFUL */],isInitialSubscription:false,isConfirmedSubscription:false,isPerpetualSubscription:false});}if(redirectRoute&&(this.isSubscriptionSuccessView||this.isStandardProductOverview)){this.setState({redirectRoute:null,showInvalidQueryPlanIdMessage:null});}if(this.props.selectedPlanId&&this.props.isAdmin&&!__WEBPACK_IMPORTED_MODULE_37_lodash___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_44__utils_subscription__["i" /* getSubscriptionsAndAddons */])(this.props.company),'subscription.cancellationPending')&&!this.props.companies.upcomingInvoiceEstimationXhrInProgress&&!this.props.company.hasUnlimitedTeamSubscription&&(!this.props.companies.getUpcomingInvoiceErorId||this.props.companies.getUpcomingInvoiceErorId!==__WEBPACK_IMPORTED_MODULE_24_errors_errorids__["a" /* default */].OFFLINE&&this.props.companies.getUpcomingInvoiceErorId!==__WEBPACK_IMPORTED_MODULE_24_errors_errorids__["a" /* default */].API_REQUEST_LIMIT_EXCEEDED)&&(Object(__WEBPACK_IMPORTED_MODULE_44__utils_subscription__["e" /* getMembersPaidQuantity */])(this.props.company)!==Object(__WEBPACK_IMPORTED_MODULE_44__utils_subscription__["e" /* getMembersPaidQuantity */])(prevProps.company)||__WEBPACK_IMPORTED_MODULE_37_lodash___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_44__utils_subscription__["i" /* getSubscriptionsAndAddons */])(prevProps.company),'subscription.cancellationPending')&&!__WEBPACK_IMPORTED_MODULE_37_lodash___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_44__utils_subscription__["i" /* getSubscriptionsAndAddons */])(this.props.company),'subscription.cancellationPending')||this.props.selectedPlanId!==prevProps.selectedPlanId)){this.props.getUpcomingInvoiceEstimate();}}if(this.isPlusOverview&&!this.props.app.wasPlusOverviewPageVisited){this.props.setPlusOverviewPageVisited();}else if(this.isPerpetualOverview&&!this.props.app.wasPerpetualOverviewPageVisited){this.props.setPerpetualOverviewPageVisited();}if(this.props.company&&this.props.app.isDesktopTrial===null){var desktopFlagValue=// check first in session storage
Object(__WEBPACK_IMPORTED_MODULE_40_utils_storage__["n" /* getIsDesktopTrial */])()||// then check query params
Object(__WEBPACK_IMPORTED_MODULE_44__utils_subscription__["r" /* isDesktopTrial */])(this.props.company.hasTrial||!this.props.company.isActive,this.props.isDesktopApp||this.props.app.isDesktopApp,this.state.productName,this.state.cbPlanId,this.props.user.originId);if(desktopFlagValue){Object(__WEBPACK_IMPORTED_MODULE_40_utils_storage__["z" /* saveIsDesktopTrial */])(true);}this.props.setDesktopTrialFlag(desktopFlagValue);}if(this.props.company&&this.props.company.industryId&&this.props.company.industryId!==__WEBPACK_IMPORTED_MODULE_33_config__["_24" /* REAL_ESTATE_INDUSTY_ID */]&&this.props.app.isReAccessNoIndustry){Object(__WEBPACK_IMPORTED_MODULE_40_utils_storage__["e" /* clearIsReAccessNoIndustry */])();this.props.setReAccessNoIndustry(false);}if(this.props.mls.mlsUiType===__WEBPACK_IMPORTED_MODULE_33_config__["_0" /* MLS_UI */].SELF_CONNECT_API){if(!this.props.mls.getConnectionsSuccess&&!this.props.mls.getConnectionsInProgress&&!this.props.mls.getConnectionsErrorId){this.props.getConnectionList();}if(!this.props.mls.getAgentsMlsIdsSuccess&&!this.props.mls.getAgentsMlsIdsInProgress&&!this.props.mls.getAgentsMlsIdsErrorId){this.props.getAgentMlsIds();}}if(this.props.company&&this.props.app.isReAccessNoIndustry===null){var reAccessNoIndustryValue=// check first in session storage
// then check query params
Object(__WEBPACK_IMPORTED_MODULE_40_utils_storage__["p" /* getIsReAccessNoIndustry */])()||Object(__WEBPACK_IMPORTED_MODULE_44__utils_subscription__["u" /* isReAccessNoIndustry */])(this.props.company.industryId,this.props.company.hasTrial||!this.props.company.isActive,this.state.productName,this.state.cbPlanId);if(reAccessNoIndustryValue){Object(__WEBPACK_IMPORTED_MODULE_40_utils_storage__["A" /* saveIsReAccessNoIndustry */])(true);}this.props.setReAccessNoIndustry(reAccessNoIndustryValue);}if(this.props.company&&__WEBPACK_IMPORTED_MODULE_37_lodash___default.a.get(prevProps.company,'industryId')&&__WEBPACK_IMPORTED_MODULE_37_lodash___default.a.get(this.props.company,'industryId')!==__WEBPACK_IMPORTED_MODULE_37_lodash___default.a.get(prevProps.company,'industryId')){this.props.resolveMLsUiType();}}},{key:"componentDidMount",value:function componentDidMount(){if(this.props.isUpgradePopup&&this.isStandardProductOverview){Object(__WEBPACK_IMPORTED_MODULE_42_lib_Segment_customTrackers__["L" /* trackRouteUpgradePopupDiscount */])(Object(__WEBPACK_IMPORTED_MODULE_21_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}else if(this.props.isReUpgradePopup){Object(__WEBPACK_IMPORTED_MODULE_42_lib_Segment_customTrackers__["J" /* trackRouteRealEstatePlanPopup */])(this.state.realEstatePlan,Object(__WEBPACK_IMPORTED_MODULE_21_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}else if(this.state.cid&&(this.isStandardProductOverview||this.isPlusOverview||this.isPerpetualOverview)){Object(__WEBPACK_IMPORTED_MODULE_42_lib_Segment_customTrackers__["G" /* trackRouteCouponDiscount */])(this.state.cid,Object(__WEBPACK_IMPORTED_MODULE_21_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}else if((this.isPlusOverview||this.isPerpetualOverview)&&this.state.productName&&(this.props.isDesktopApp||this.props.app.isDesktopApp)){Object(__WEBPACK_IMPORTED_MODULE_42_lib_Segment_customTrackers__["H" /* trackRouteDesktopAppUpgrade */])(this.state.productName,Object(__WEBPACK_IMPORTED_MODULE_21_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}else if(this.state.productName&&this.state.productSource&&(this.isStandardProductOverview||this.isPlusOverview||this.isPerpetualOverview)){Object(__WEBPACK_IMPORTED_MODULE_42_lib_Segment_customTrackers__["K" /* trackRouteSource */])(this.state.productName,this.state.productSource,Object(__WEBPACK_IMPORTED_MODULE_21_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}if(this.isPlusOverview){this.props.setPlusOverviewPageVisited();}else if(this.isPerpetualOverview){this.props.setPerpetualOverviewPageVisited();}window.addEventListener('resize',this.handleWindowResizeDebounced);this.handleWindowResizeDebounced();document.querySelector('html').setAttribute('lang',__WEBPACK_IMPORTED_MODULE_22_i18n_i18n__["a" /* default */].getCurrentLanguage(false));}},{key:"componentWillUnmount",value:function componentWillUnmount(){window.removeEventListener('resize',this.handleWindowResizeDebounced);}},{key:"scrollContentToTop",value:function scrollContentToTop(){this.main&&(this.main.scrollTop=0);}},{key:"redirectToXC",value:function redirectToXC(){var isDesktopApp=this.props.app.isDesktopApp;var urlParams=[];var queryParams=Object(__WEBPACK_IMPORTED_MODULE_41_utils_url__["d" /* parseQuery */])(this.props.location.search);var addSkipOnboardingParam=queryParams[__WEBPACK_IMPORTED_MODULE_33_config__["_34" /* SKIP_ONBOARDING_PARAM */]]==='1';if(addSkipOnboardingParam||isDesktopApp){urlParams.push("".concat(__WEBPACK_IMPORTED_MODULE_33_config__["_34" /* SKIP_ONBOARDING_PARAM */],"=1"));}var planId=queryParams['chargebee-plan-id'];var pathArray=this.locationPathArray;var showComponent=pathArray[1]?"/".concat(pathArray[1]):'/';if(pathArray[1]===__WEBPACK_IMPORTED_MODULE_23_routes__["n" /* SUBSCRIPTION */].replace('/:companyId/','')&&pathArray.length>=3){showComponent+="/".concat(pathArray[2]);if(pathArray.length===4){//accept currency
showComponent+="/".concat(pathArray[3]);}}urlParams.push("".concat(__WEBPACK_IMPORTED_MODULE_33_config__["i" /* BACK_TO_PARAM */],"=").concat(encodeURIComponent(showComponent)));// Add plan ID
planId&&urlParams.push("chargebee-plan-id=".concat(planId));// Add company ID
if(isDesktopApp){urlParams.push("".concat(__WEBPACK_IMPORTED_MODULE_33_config__["f" /* APP_COMPANY_ID_PARAM */],"=").concat(pathArray[0]));}var productName=queryParams[__WEBPACK_IMPORTED_MODULE_33_config__["_15" /* PRODUCT_NAME_PARAM */]];if(productName){urlParams.push("".concat(__WEBPACK_IMPORTED_MODULE_33_config__["_15" /* PRODUCT_NAME_PARAM */],"=").concat(productName));}var productSource=queryParams[__WEBPACK_IMPORTED_MODULE_33_config__["_18" /* PRODUCT_SOURCE_PARAM */]];if(productSource){urlParams.push("".concat(__WEBPACK_IMPORTED_MODULE_33_config__["_18" /* PRODUCT_SOURCE_PARAM */],"=").concat(productSource));}var productPeriod=queryParams[__WEBPACK_IMPORTED_MODULE_33_config__["_6" /* PERIOD_PARAM */]];if(productPeriod){urlParams.push("".concat(__WEBPACK_IMPORTED_MODULE_33_config__["_6" /* PERIOD_PARAM */],"=").concat(productPeriod));}var productQuantity=this.state.productQuantity;if(productQuantity){urlParams.push("".concat(__WEBPACK_IMPORTED_MODULE_33_config__["_17" /* PRODUCT_QUANTITY_PARAM */],"=").concat(productQuantity));}var prodLang=queryParams[__WEBPACK_IMPORTED_MODULE_33_config__["_14" /* PRODUCT_LANGUAGE_PARAM */]];if(prodLang){urlParams.push("".concat(__WEBPACK_IMPORTED_MODULE_33_config__["_14" /* PRODUCT_LANGUAGE_PARAM */],"=").concat(prodLang));}var magixSerial=queryParams[__WEBPACK_IMPORTED_MODULE_33_config__["W" /* MAGIX_SERIAL_PARAM */]];if(magixSerial){urlParams.push("".concat(__WEBPACK_IMPORTED_MODULE_33_config__["W" /* MAGIX_SERIAL_PARAM */],"=").concat(magixSerial));}var magixEmail=queryParams[__WEBPACK_IMPORTED_MODULE_33_config__["V" /* MAGIX_EMAIL_PARAM */]];if(magixEmail){urlParams.push("".concat(__WEBPACK_IMPORTED_MODULE_33_config__["V" /* MAGIX_EMAIL_PARAM */],"=").concat(magixEmail));}var magixCat=queryParams[__WEBPACK_IMPORTED_MODULE_33_config__["U" /* MAGIX_CATEGORY_PARAM */]];if(magixCat){urlParams.push("".concat(__WEBPACK_IMPORTED_MODULE_33_config__["U" /* MAGIX_CATEGORY_PARAM */],"=").concat(magixCat));}var couponId=queryParams[__WEBPACK_IMPORTED_MODULE_33_config__["u" /* COUPON_ID_PARAM */]];if(couponId){urlParams.push("".concat(__WEBPACK_IMPORTED_MODULE_33_config__["u" /* COUPON_ID_PARAM */],"=").concat(couponId));}var xcUserFound=queryParams[__WEBPACK_IMPORTED_MODULE_33_config__["_66" /* XC_USER_FOUND */]];if(xcUserFound){urlParams.push("".concat(__WEBPACK_IMPORTED_MODULE_33_config__["_66" /* XC_USER_FOUND */],"=").concat(xcUserFound));}var currency=queryParams[__WEBPACK_IMPORTED_MODULE_33_config__["y" /* CURRENCY_PARAM */]];if(currency){urlParams.push("".concat(__WEBPACK_IMPORTED_MODULE_33_config__["y" /* CURRENCY_PARAM */],"=").concat(currency));}/* Forward UTM params to XC which might be coming from noticeboard or email campaigns */var utm_source=Object(__WEBPACK_IMPORTED_MODULE_41_utils_url__["d" /* parseQuery */])(this.props.location.search)['utm_source'];if(utm_source){urlParams.push("utm_source=".concat(encodeURIComponent(utm_source)));}var utm_medium=Object(__WEBPACK_IMPORTED_MODULE_41_utils_url__["d" /* parseQuery */])(this.props.location.search)['utm_medium'];if(utm_medium){urlParams.push("utm_medium=".concat(encodeURIComponent(utm_medium)));}var utm_campaign=Object(__WEBPACK_IMPORTED_MODULE_41_utils_url__["d" /* parseQuery */])(this.props.location.search)['utm_campaign'];if(utm_campaign){urlParams.push("utm_campaign=".concat(encodeURIComponent(utm_campaign)));}var utm_content=Object(__WEBPACK_IMPORTED_MODULE_41_utils_url__["d" /* parseQuery */])(this.props.location.search)['utm_content'];if(utm_content){urlParams.push("utm_content=".concat(encodeURIComponent(utm_content)));}var utm_term=Object(__WEBPACK_IMPORTED_MODULE_41_utils_url__["d" /* parseQuery */])(this.props.location.search)['utm_term'];if(utm_term){urlParams.push("utm_term=".concat(encodeURIComponent(utm_term)));}var redirectURL=urlParams.length?"".concat(__WEBPACK_IMPORTED_MODULE_33_config__["_65" /* XC_URL */],"?").concat(urlParams.join('&')):"".concat(__WEBPACK_IMPORTED_MODULE_33_config__["_65" /* XC_URL */]);window.location.href=redirectURL;}},{key:"render",value:function render(){var _classNames;var _this$props=this.props,classes=_this$props.classes,isAdmin=_this$props.isAdmin,isTempCompany=_this$props.isTempCompany,preloader=_this$props.preloader,chargebeeLoader=_this$props.chargebeeLoader,selectedCompanyId=_this$props.selectedCompanyId,errorId=_this$props.errorId;var _this$state3=this.state,redirectRoute=_this$state3.redirectRoute,redirectToXC=_this$state3.redirectToXC,navOpen=_this$state3.navOpen;if(redirectToXC){this.redirectToXC();}if(selectedCompanyId&&redirectRoute&&!this.isSubscriptionSuccessView&&!(this.isStandardProductOverview&&this.state.showInvalidQueryPlanIdMessage)){// Redirect to /#subscription-successful page after purchase
return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_router_dom__["c" /* Redirect */],{to:{pathname:Object(__WEBPACK_IMPORTED_MODULE_23_routes__["w" /* getRoute */])(redirectRoute,selectedCompanyId),state:{showInvalidQueryPlanIdMessage:this.state.showInvalidQueryPlanIdMessage}}});}var isDesktopApp=this.props.app.isDesktopApp;var onBoarding=this.shouldStartOnBoarding;var shouldRenderNav;if(!errorId){if(chargebeeLoader.loading){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_ProcessingOrder_ProcessingOrder__["a" /* default */],null);}if(preloader.loading){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Preloader_Preloader__["a" /* default */],null);}}shouldRenderNav=this.shouldRenderNavigation();var contentClasses=__WEBPACK_IMPORTED_MODULE_35_classnames___default()(classes.content,(_classNames={},__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_classNames,classes.maxWidth,!shouldRenderNav),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_classNames,classes.contentShift,navOpen),_classNames));return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__AppContext__["a" /* default */].Provider,{value:this.appContext},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{className:__WEBPACK_IMPORTED_MODULE_35_classnames___default()(classes.root,shouldRenderNav&&classes.topBarPadding)},shouldRenderNav&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_TopBar_TopBar__["a" /* default */],{navOpen:navOpen,navToggle:this.toggleNav,onBoardingEnabled:onBoarding}),shouldRenderNav&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_MainNav_MainNav__["a" /* default */],{productName:this.state.productName,isDesktopApp:isDesktopApp,isPerpetualOwner:Object(__WEBPACK_IMPORTED_MODULE_44__utils_subscription__["s" /* isPerpetualOwner */])(this.props.company),navOpen:navOpen,disabled:onBoarding,isAdmin:isAdmin,isTempCompany:isTempCompany}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("main",{className:contentClasses,ref:this.setMainRef},this.renderContent()),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Modal_Modal__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_QuickMessages_QuickMessages__["a" /* default */],null)));}},{key:"renderUpgradePopup",value:function renderUpgradePopup(){var _this$state4=this.state,askForCompany=_this$state4.askForCompany,isConfirmedSubscription=_this$state4.isConfirmedSubscription;var searchQuery=Object(__WEBPACK_IMPORTED_MODULE_41_utils_url__["d" /* parseQuery */])(this.props.location.search);var planId=searchQuery['chargebee-plan-id'];var currency=searchQuery['currency'];var productName=searchQuery['prod'];var productLang=searchQuery['lang'];var magixEmail=searchQuery['pemail'];var magixSerial=searchQuery['pserial'];var magixCat=searchQuery['pcat'];var productSource=searchQuery['source']||this.state.productSource;var productQuantity=searchQuery['quantity']||this.state.productQuantity;var pathArray=this.locationPathArray;if(!planId&&!this.state.isInitialSubscription&&!Object(__WEBPACK_IMPORTED_MODULE_41_utils_url__["d" /* parseQuery */])(this.props.location.search)['company-known']){// There is no props.match available outside of Router, so we have to manually detect
// plus-overview route and currency from url like
// CAP_URL/#62daae6a61ad68e6caab4339/subscription/plus-overview/eur
if(this.props.location.pathname.indexOf(__WEBPACK_IMPORTED_MODULE_33_config__["_11" /* PLUS_OVERVIEW_PLAN_ID */])!==-1){planId=__WEBPACK_IMPORTED_MODULE_33_config__["_11" /* PLUS_OVERVIEW_PLAN_ID */];if(pathArray[pathArray.length-1]!==__WEBPACK_IMPORTED_MODULE_33_config__["_11" /* PLUS_OVERVIEW_PLAN_ID */]){currency=pathArray[pathArray.length-1];}}else if(this.props.location.pathname.indexOf(__WEBPACK_IMPORTED_MODULE_33_config__["_8" /* PERPETUAL_OVERVIEW_PLAN_ID */])!==-1){planId=__WEBPACK_IMPORTED_MODULE_33_config__["_8" /* PERPETUAL_OVERVIEW_PLAN_ID */];if(pathArray[pathArray.length-1]!==__WEBPACK_IMPORTED_MODULE_33_config__["_8" /* PERPETUAL_OVERVIEW_PLAN_ID */]){currency=pathArray[pathArray.length-1];}}}var pathRedirectRoute;if(pathArray[1]===__WEBPACK_IMPORTED_MODULE_23_routes__["t" /* USERS */].replace('/:companyId/','')){pathRedirectRoute=__WEBPACK_IMPORTED_MODULE_23_routes__["t" /* USERS */];}else if(pathArray[1]===__WEBPACK_IMPORTED_MODULE_23_routes__["v" /* XC_PLUS */].replace('/:companyId/','')){pathRedirectRoute=__WEBPACK_IMPORTED_MODULE_23_routes__["v" /* XC_PLUS */];}if(pathRedirectRoute&&askForCompany){var rawDataById=this.props.companies.rawDataById;var adminOfCompanies=rawDataById?Object.values(rawDataById).filter(function(company){return[__WEBPACK_IMPORTED_MODULE_33_config__["_54" /* USER_ROLE_ADMIN */]].includes(company.userRole);}):[];if(adminOfCompanies.length>1){this.props.showModal('COMPANY_SELECTION_MODAL',{redirectURL:pathRedirectRoute});}}// Take currency from existing plan (as it can't be changed), 
// otherwise from URL (for plus-overview package), defaults to USD
if(!__WEBPACK_IMPORTED_MODULE_37_lodash___default.a.get(this.props.location,'state.isCouponMissmatchRedirect')&&planId&&this.hasCompany&&this.isCompanyFoundInSession&&!this.props.isGuest&&!isConfirmedSubscription){this.props.showModal('UPGRADE_COMPANY_MODAL',{planId:planId,currency:currency,isDesktopApp:this.props.isDesktopApp||this.props.app.isDesktopApp,productName:productName,productLang:productLang,magixSerial:magixSerial,magixEmail:magixEmail,magixCat:magixCat,couponId:this.state.cid,productPeriod:this.state.productPeriod,isUpgradePopup:this.props.app.isUpgradePopup,realEstatePlan:this.state.realEstatePlan,isCBPlanExternalRedirect:this.state.isCBPlanExternalRedirect,isCBPlanInternalRedirect:this.state.isCBPlanInternalRedirect,productQuantity:productQuantity,productSource:productSource});}}},{key:"renderContent",value:function renderContent(){if(this.hasCompany&&!this.props.isGuest){// show content only for guests
var selectedPlanId=this.props.selectedPlanId;var activeSubscription=Object(__WEBPACK_IMPORTED_MODULE_44__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(selectedPlanId);var plan=activeSubscription.plan;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_MainContent_MainContent__["a" /* default */],{isRealEstateIndustry:__WEBPACK_IMPORTED_MODULE_37_lodash___default.a.get(this.props.company,'industryId')===__WEBPACK_IMPORTED_MODULE_33_config__["_24" /* REAL_ESTATE_INDUSTY_ID */],agentsMlsIds:this.props.mls.agentsMlsIds,mlsUiType:this.props.mls.mlsUiType,isReAccessNoIndustry:this.props.app.isReAccessNoIndustry,isPerpetualOwner:Object(__WEBPACK_IMPORTED_MODULE_44__utils_subscription__["s" /* isPerpetualOwner */])(this.props.company),navOpen:this.state.navOpen,isCBPlanInternalRedirect:this.state.isCBPlanInternalRedirect,isCBPlanExternalRedirect:this.state.isCBPlanExternalRedirect,cbPlanId:this.state.cbPlanId,plan:plan,selectedId:this.props.companies.selectedId,isCompanyFoundInSession:this.isCompanyFoundInSession,isDesktopApp:this.props.app.isDesktopApp,couponId:this.state.cid,realEstatePlan:this.state.realEstatePlan,productPeriod:this.state.productPeriod,isDiscountTakeoverFromWebsite:this.props.isDiscountTakeoverFromWebsite,productName:this.state.productName,productSource:this.state.productSource,productQuantity:this.state.productQuantity,isUpgradePopup:this.props.app.isUpgradePopup,magixCat:this.state.magixCat,isAdmin:this.props.isAdmin,isTempCompany:this.props.isTempCompany,subscriptionId:this.state.subscriptionId,reactivateSubscription:this.state.reactivateSubscription,onBoarding:this.shouldStartOnBoarding});}}},{key:"flattenQueryParams",value:function flattenQueryParams(params){var result='';if(params.length){result='?';result+=params.join('&');}return result;}},{key:"shouldRenderNavigation",value:function shouldRenderNavigation(){return this.hasCompany&&this.isCompanyFoundInSession&&!this.props.isGuest&&!this.isSubscriptionSuccessView;}},{key:"handleWindowResize",value:function handleWindowResize(){var viewPortWidth=document&&window&&Math.max(document.documentElement.clientWidth,window.innerWidth||0);if(viewPortWidth<=__WEBPACK_IMPORTED_MODULE_33_config__["_4" /* PACKAGES_HIDE_SIDEBAR_BREAKPOINT */]){var pathArray=this.locationPathArray;if(pathArray[1]===__WEBPACK_IMPORTED_MODULE_23_routes__["n" /* SUBSCRIPTION */].replace('/:companyId/','')&&this.state.navOpen){this.hideNav();}}else{this.showNav();}}},{key:"isPlusOverview",get:function get(){return this.props.location.pathname.indexOf(__WEBPACK_IMPORTED_MODULE_33_config__["_11" /* PLUS_OVERVIEW_PLAN_ID */])!==-1;}},{key:"isPerpetualOverview",get:function get(){return this.props.location.pathname.indexOf(__WEBPACK_IMPORTED_MODULE_33_config__["_8" /* PERPETUAL_OVERVIEW_PLAN_ID */])!==-1;}},{key:"isStandardProductOverview",get:function get(){var pathArray=this.locationPathArray;var nextPath=pathArray[2]||'';return pathArray[1]===__WEBPACK_IMPORTED_MODULE_23_routes__["n" /* SUBSCRIPTION */].replace('/:companyId/','')&&nextPath.indexOf('plus-overview')===-1&&nextPath.indexOf('perpetual-overview')===-1&&nextPath.indexOf('monthly')===-1&&nextPath.indexOf('annual')===-1;}},{key:"isSubscriptionSuccessView",get:function get(){return this.props.location.pathname.indexOf('subscription-successful')!==-1;}},{key:"hasCompany",get:function get(){return this.state.hasCompany;}},{key:"isCompanyFoundInSession",get:function get(){return this.state.companyFoundInSession;}},{key:"shouldStartOnBoarding",get:function get(){// [P9052-11082] Disable the onboarding.
return false;}},{key:"appContext",get:function get(){return{navOpen:this.state.navOpen,scrollContentToTop:this.scrollContentToTop};}},{key:"locationPathArray",get:function get(){var pathArray=[];this.props.location.pathname.split('/').forEach(function(path){if(path){// remove "" from array
pathArray.push(path);}});return pathArray;}}]);return App;}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]))||_class);App.propTypes={classes:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,onBoardingSettings:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,fetchSession:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,changeCompanyAndNotify:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,companies:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,location:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,history:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,errorId:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,showModal:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,connectCompanySocketEvents:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,connectUserSocketEventProviderChange:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,connectUserSocketEventLogout:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,fetchCompaniesIndustries:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,fetchCompaniesSizes:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,fetchMlsBoards:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,getConnectionList:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,getAgentMlsIds:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,fetchUserRegion:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,fetchCompaniesCountries:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,connectWorkspacesSocketEvents:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,resolveMLsUiType:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,getActiveCompanyId:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,getDesktopAppFlag:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,setPerpetuallAppFlag:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,setPlusOverviewPageVisited:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,setPerpetualOverviewPageVisited:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,setDesktopUserFlag:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,setDesktopTrialFlag:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,setReAccessNoIndustry:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,setUpgradePopupFlag:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,setPendingTriggerCheckout:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,setCouponIdProvidedFlag:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,isAdmin:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,isGuest:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,isTempCompany:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,preloader:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,showPreloader:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,hidePreloader:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,setupLogger:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,processingOrder:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,chargebeeLoader:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,showChargebeeLoader:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,hideChargebeeLoader:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,selectedPlanId:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,paymentRedirectUrl:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,redirectRoute:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.element,selectedCompanyId:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,reloadApp:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,isDesktopApp:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,isDiscountTakeoverFromWebsite:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,isCbPlanProvided:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,productName:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,productSource:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,isUpgradePopup:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,isReUpgradePopup:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,isCouponIdProvided:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,checkCrsCredentials:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,saveTakeOverCredentials:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,crs:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object.isRequired,discount:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object.isRequired,app:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object.isRequired,applyMagixDiscount:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,applyDiscountUsingCouponSetId:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,applyDiscountUsingCouponId:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,modalShown:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,originalSearch:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,originalHash:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,company:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,match:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object.isRequired,getUpcomingInvoiceEstimate:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,user:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,mls:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object};App.defaultProps={classes:{}};var mapStateToProps=function mapStateToProps(state){return{company:state.companies.rawDataById?state.companies.rawDataById[state.companies.selectedId]:null,errorId:state.error.errorId,companies:state.companies,onBoardingSettings:__WEBPACK_IMPORTED_MODULE_37_lodash___default.a.get(state.session,"user.settings.".concat(__WEBPACK_IMPORTED_MODULE_33_config__["k" /* CAP_KEY */],".").concat(__WEBPACK_IMPORTED_MODULE_33_config__["_1" /* ONBOARDING_KEY */])),isAdmin:Object(__WEBPACK_IMPORTED_MODULE_39_utils_state__["a" /* isAdmin */])(state),isGuest:Object(__WEBPACK_IMPORTED_MODULE_39_utils_state__["b" /* isGuest */])(state),isTempCompany:Object(__WEBPACK_IMPORTED_MODULE_39_utils_state__["d" /* isTempCompany */])(state),preloader:state.preloader,processingOrder:state.processingOrder,chargebeeLoader:state.chargebeeLoader,selectedCompanyId:state.companies.selectedId,selectedPlanId:state.companies.rawDataById?Object(__WEBPACK_IMPORTED_MODULE_44__utils_subscription__["c" /* getCurrentPlanId */])(state.companies.rawDataById[state.companies.selectedId]):null,paymentRedirectUrl:state.companies.paymentRedirectUrl,modalShown:state.modal.modalShown,crs:state.crs,app:state.app,discount:state.discount,user:__WEBPACK_IMPORTED_MODULE_37_lodash___default.a.get(state.session,'user'),mls:state.mls};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_32_redux__["b" /* bindActionCreators */])({fetchSession:__WEBPACK_IMPORTED_MODULE_19_redux_modules_session__["b" /* fetchSession */],changeCompanyAndNotify:__WEBPACK_IMPORTED_MODULE_26_redux_modules_companies__["d" /* changeCompanyAndNotify */],showModal:__WEBPACK_IMPORTED_MODULE_34_redux_modules_modal__["d" /* showModal */],connectCompanySocketEvents:__WEBPACK_IMPORTED_MODULE_26_redux_modules_companies__["f" /* connectCompanySocketEvents */],connectUserSocketEventProviderChange:__WEBPACK_IMPORTED_MODULE_28_redux_modules_account__["c" /* connectUserSocketEventProviderChange */],connectUserSocketEventLogout:__WEBPACK_IMPORTED_MODULE_28_redux_modules_account__["b" /* connectUserSocketEventLogout */],fetchCompaniesIndustries:__WEBPACK_IMPORTED_MODULE_26_redux_modules_companies__["p" /* fetchCompaniesIndustries */],fetchMlsBoards:__WEBPACK_IMPORTED_MODULE_25_redux_modules_mls__["l" /* fetchMlsBoards */],fetchCompaniesSizes:__WEBPACK_IMPORTED_MODULE_26_redux_modules_companies__["q" /* fetchCompaniesSizes */],fetchUserRegion:__WEBPACK_IMPORTED_MODULE_26_redux_modules_companies__["r" /* fetchUserRegion */],fetchCompaniesCountries:__WEBPACK_IMPORTED_MODULE_26_redux_modules_companies__["o" /* fetchCompaniesCountries */],resolveMLsUiType:__WEBPACK_IMPORTED_MODULE_25_redux_modules_mls__["o" /* resolveMLsUiType */],getActiveCompanyId:__WEBPACK_IMPORTED_MODULE_26_redux_modules_companies__["s" /* getActiveCompanyId */],getDesktopAppFlag:__WEBPACK_IMPORTED_MODULE_27_redux_modules_app__["d" /* getDesktopAppFlag */],setPerpetuallAppFlag:__WEBPACK_IMPORTED_MODULE_27_redux_modules_app__["m" /* setPerpetuallAppFlag */],setPlusOverviewPageVisited:__WEBPACK_IMPORTED_MODULE_27_redux_modules_app__["n" /* setPlusOverviewPageVisited */],setPerpetualOverviewPageVisited:__WEBPACK_IMPORTED_MODULE_27_redux_modules_app__["l" /* setPerpetualOverviewPageVisited */],setDesktopUserFlag:__WEBPACK_IMPORTED_MODULE_27_redux_modules_app__["i" /* setDesktopUserFlag */],setDesktopTrialFlag:__WEBPACK_IMPORTED_MODULE_27_redux_modules_app__["h" /* setDesktopTrialFlag */],setReAccessNoIndustry:__WEBPACK_IMPORTED_MODULE_27_redux_modules_app__["o" /* setReAccessNoIndustry */],setUpgradePopupFlag:__WEBPACK_IMPORTED_MODULE_27_redux_modules_app__["w" /* setUpgradePopupFlag */],setPendingTriggerCheckout:__WEBPACK_IMPORTED_MODULE_27_redux_modules_app__["k" /* setPendingTriggerCheckout */],setCouponIdProvidedFlag:__WEBPACK_IMPORTED_MODULE_27_redux_modules_app__["g" /* setCouponIdProvidedFlag */],connectWorkspacesSocketEvents:__WEBPACK_IMPORTED_MODULE_29_redux_modules_workspaces__["a" /* connectWorkspacesSocketEvents */],showPreloader:__WEBPACK_IMPORTED_MODULE_30_redux_modules_preloader__["c" /* showPreloader */],hidePreloader:__WEBPACK_IMPORTED_MODULE_30_redux_modules_preloader__["b" /* hidePreloader */],showChargebeeLoader:__WEBPACK_IMPORTED_MODULE_31_redux_modules_chargebeeLoader__["c" /* showChargebeeLoader */],hideChargebeeLoader:__WEBPACK_IMPORTED_MODULE_31_redux_modules_chargebeeLoader__["b" /* hideChargebeeLoader */],checkCrsCredentials:__WEBPACK_IMPORTED_MODULE_50_redux_modules_crs__["b" /* checkCrsCredentials */],saveTakeOverCredentials:__WEBPACK_IMPORTED_MODULE_50_redux_modules_crs__["e" /* saveTakeOverCredentials */],applyMagixDiscount:__WEBPACK_IMPORTED_MODULE_51_redux_modules_discount__["d" /* applyMagixDiscount */],applyDiscountUsingCouponSetId:__WEBPACK_IMPORTED_MODULE_51_redux_modules_discount__["c" /* applyDiscountUsingCouponSetId */],applyDiscountUsingCouponId:__WEBPACK_IMPORTED_MODULE_51_redux_modules_discount__["a" /* applyDiscountUsingCouponId */],getUpcomingInvoiceEstimate:__WEBPACK_IMPORTED_MODULE_26_redux_modules_companies__["u" /* getUpcomingInvoiceEstimate */],getConnectionList:__WEBPACK_IMPORTED_MODULE_25_redux_modules_mls__["n" /* getConnectionList */],getAgentMlsIds:__WEBPACK_IMPORTED_MODULE_25_redux_modules_mls__["m" /* getAgentMlsIds */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_17_react_router__["c" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_18_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(App)));

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_AppBar__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_AppBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_AppBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Toolbar__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_theme_uiConfig__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_styles_colorManipulator__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_styles_colorManipulator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_styles_colorManipulator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_HamburgerButton_HamburgerButton__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_utils_state__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_i18n_i18n__ = __webpack_require__(15);
var _dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_18_i18n_i18n__["a" /* default */].loc.localize;var styles=function styles(theme){return{toolbar:{minHeight:__WEBPACK_IMPORTED_MODULE_12_theme_uiConfig__["f" /* topBarHeight */]},title:{fontSize:18,fontWeight:'normal',fontFamily:'"Open Sans Xara"',width:260},hamburgerButton:{'& + h1':{marginLeft:30}},link:{color:theme.palette.common.white,backgroundColor:theme.palette.colors.beta,'&:disabled':{backgroundColor:Object(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_styles_colorManipulator__["fade"])(theme.palette.colors.beta,0.3)},'&:hover':{backgroundColor:theme.palette.colors.eta}},toolbarGutters:{paddingLeft:30,paddingRight:30},trialButton:{marginRight:15,fontSize:16,backgroundColor:theme.palette.colors.purple,'&:hover':{backgroundColor:theme.palette.colors.purpleHover,boxShadow:'none'},minWidth:50},closeIcon:{color:'#F7F7F7','&:hover':{color:'#BAE6FF'}},buttonsContainer:{marginLeft:'auto'},disabled:{}};};var TopBar=(_dec=Object(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(TopBar,_Component);function TopBar(props){var _this;__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,TopBar);_this=__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(TopBar).call(this,props));_this.state={selected:-1};return _this;}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(TopBar,[{key:"renderUpgradeButton",value:function renderUpgradeButton(){var _this$props=this.props,classes=_this$props.classes,_this$props$company=_this$props.company,hasTrial=_this$props$company.hasTrial,trialDays=_this$props$company.trialDays,id=_this$props$company.id,isAdmin=_this$props.isAdmin;if(!hasTrial||!isAdmin){return null;}return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default.a,{"data-tid":"button-top-bar-subscription",href:"#".concat(id,"/subscription"),variant:"contained",className:classes.trialButton},trialDays," ",localize(trialDays===1?'top-bar-upgrade-button-day':'top-bar-upgrade-button-days'));}},{key:"render",value:function render(){var _this$props2=this.props,classes=_this$props2.classes,navOpen=_this$props2.navOpen,navToggle=_this$props2.navToggle,company=_this$props2.company,onBoardingEnabled=_this$props2.onBoardingEnabled;var shouldRenderButtons=!onBoardingEnabled;var shouldRenderTeamName=!company.displayName.includes(__WEBPACK_IMPORTED_MODULE_17_config__["_48" /* TEMP_COMP_PREFIX */]);return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_AppBar___default.a,{className:classes.root},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Toolbar___default.a,{classes:{root:classes.toolbar,gutters:classes.toolbarGutters}},shouldRenderButtons&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_HamburgerButton_HamburgerButton__["a" /* default */],{open:navOpen,onChange:!onBoardingEnabled?navToggle:undefined,classes:{root:classes.hamburgerButton}}),shouldRenderTeamName&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:"h1",color:"inherit",noWrap:true,className:classes.title},company.displayName),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:classes.buttonsContainer},shouldRenderButtons&&this.renderUpgradeButton())));}}]);return TopBar;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]))||_class);TopBar.propTypes={classes:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,navToggle:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,navOpen:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,workspace:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,company:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,onBoardingEnabled:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,isAdmin:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool};TopBar.defaultProps={company:{},workspace:{},navBar:true,onBoardingEnabled:false,isAdmin:false};var mapStateToProps=function mapStateToProps(state){return{company:state.companies.rawDataById[state.companies.selectedId],workspace:state.workspaces.rawDataById[state.workspaces.selectedId],isAdmin:Object(__WEBPACK_IMPORTED_MODULE_16_utils_state__["a" /* isAdmin */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13_react_redux__["b" /* connect */])(mapStateToProps,undefined)(TopBar));

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _helpers = __webpack_require__(29);

var _Paper = _interopRequireDefault(__webpack_require__(63));

// @inheritedComponent Paper
var styles = function styles(theme) {
  var backgroundColorDefault = theme.palette.type === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      boxSizing: 'border-box',
      // Prevent padding issue with the Modal and fixed positioned AppBar.
      zIndex: theme.zIndex.appBar,
      flexShrink: 0
    },

    /* Styles applied to the root element if `position="fixed"`. */
    positionFixed: {
      position: 'fixed',
      top: 0,
      left: 'auto',
      right: 0
    },

    /* Styles applied to the root element if `position="absolute"`. */
    positionAbsolute: {
      position: 'absolute',
      top: 0,
      left: 'auto',
      right: 0
    },

    /* Styles applied to the root element if `position="sticky"`. */
    positionSticky: {
      position: 'sticky',
      top: 0,
      left: 'auto',
      right: 0
    },

    /* Styles applied to the root element if `position="static"`. */
    positionStatic: {
      position: 'static'
    },

    /* Styles applied to the root element if `position="relative"`. */
    positionRelative: {
      position: 'relative'
    },

    /* Styles applied to the root element if `color="default"`. */
    colorDefault: {
      backgroundColor: backgroundColorDefault,
      color: theme.palette.getContrastText(backgroundColorDefault)
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    }
  };
};

exports.styles = styles;

function AppBar(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      position = props.position,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "position"]);
  var className = (0, _classnames.default)(classes.root, classes["position".concat((0, _helpers.capitalize)(position))], (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), (0, _defineProperty2.default)(_classNames, 'mui-fixed', position === 'fixed'), _classNames), classNameProp);
  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
    square: true,
    component: "header",
    elevation: 4,
    className: className
  }, other), children);
}

 false ? AppBar.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary', 'default']),

  /**
   * The positioning type. The behavior of the different options is described
   * [in the MDN web docs](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
   */
  position: _propTypes.default.oneOf(['fixed', 'absolute', 'sticky', 'static', 'relative'])
} : void 0;
AppBar.defaultProps = {
  color: 'primary',
  position: 'fixed'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiAppBar'
})(AppBar);

exports.default = _default;

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _warning = _interopRequireDefault(__webpack_require__(27));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var styles = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return (0, _extends2.default)({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    }
  }, elevations);
};

exports.styles = styles;

function Paper(props) {
  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      square = props.square,
      elevation = props.elevation,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "square", "elevation"]);
   false ? (0, _warning.default)(elevation >= 0 && elevation < 25, "Material-UI: this elevation `".concat(elevation, "` is not implemented.")) : void 0;
  var className = (0, _classnames.default)(classes.root, classes["elevation".concat(elevation)], (0, _defineProperty2.default)({}, classes.rounded, !square), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

 false ? Paper.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It's accepting values between 0 and 24 inclusive.
   */
  elevation: _propTypes.default.number,

  /**
   * If `true`, rounded corners are disabled.
   */
  square: _propTypes.default.bool
} : void 0;
Paper.defaultProps = {
  component: 'div',
  elevation: 2,
  square: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiPaper'
})(Paper);

exports.default = _default;

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center'
    },

    /* Styles applied to the root element if `disableGutters={false}`. */
    gutters: theme.mixins.gutters(),

    /* Styles applied to the root element if `variant="regular"`. */
    regular: theme.mixins.toolbar,

    /* Styles applied to the root element if `variant="dense"`. */
    dense: {
      minHeight: 48
    }
  };
};

exports.styles = styles;

function Toolbar(props) {
  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      disableGutters = props.disableGutters,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableGutters", "variant"]);
  var className = (0, _classnames.default)(classes.root, classes[variant], (0, _defineProperty2.default)({}, classes.gutters, !disableGutters), classNameProp);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: className
  }, other), children);
}

 false ? Toolbar.propTypes = {
  /**
   * Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, disables gutter padding.
   */
  disableGutters: _propTypes.default.bool,

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['regular', 'dense'])
} : void 0;
Toolbar.defaultProps = {
  disableGutters: false,
  variant: 'regular'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiToolbar'
})(Toolbar);

exports.default = _default;

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _helpers = __webpack_require__(29);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      margin: 0
    },

    /* Styles applied to the root element if `variant="display4"`. */
    display4: theme.typography.display4,

    /* Styles applied to the root element if `variant="display3"`. */
    display3: theme.typography.display3,

    /* Styles applied to the root element if `variant="display2"`. */
    display2: theme.typography.display2,

    /* Styles applied to the root element if `variant="display1"`. */
    display1: theme.typography.display1,

    /* Styles applied to the root element if `variant="headline"`. */
    headline: theme.typography.headline,

    /* Styles applied to the root element if `variant="title"`. */
    title: theme.typography.title,

    /* Styles applied to the root element if `variant="subheading"`. */
    subheading: theme.typography.subheading,

    /* Styles applied to the root element if `variant="body2"`. */
    body2: theme.typography.body2,

    /* Styles applied to the root element if `variant="body1"`. */
    body1: theme.typography.body1,

    /* Styles applied to the root element if `variant="caption"`. */
    caption: theme.typography.caption,

    /* Styles applied to the root element if `variant="button"`. */
    button: theme.typography.button,

    /* Styles applied to the root element if `variant="h1"`. */
    h1: theme.typography.h1,

    /* Styles applied to the root element if `variant="h2"`. */
    h2: theme.typography.h2,

    /* Styles applied to the root element if `variant="h3"`. */
    h3: theme.typography.h3,

    /* Styles applied to the root element if `variant="h4"`. */
    h4: theme.typography.h4,

    /* Styles applied to the root element if `variant="h5"`. */
    h5: theme.typography.h5,

    /* Styles applied to the root element if `variant="h6"`. */
    h6: theme.typography.h6,

    /* Styles applied to the root element if `variant="subtitle1"`. */
    subtitle1: theme.typography.subtitle1,

    /* Styles applied to the root element if `variant="subtitle2"`. */
    subtitle2: theme.typography.subtitle2,

    /* Styles applied to the root element if `variant="overline"`. */
    overline: theme.typography.overline,

    /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */
    srOnly: {
      position: 'absolute',
      height: 1,
      width: 1,
      overflow: 'hidden'
    },

    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: 'left'
    },

    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: 'center'
    },

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: 'right'
    },

    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: 'justify'
    },

    /* Styles applied to the root element if `align="nowrap"`. */
    noWrap: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the root element if `gutterBottom={true}`. */
    gutterBottom: {
      marginBottom: '0.35em'
    },

    /* Styles applied to the root element if `paragraph={true}`. */
    paragraph: {
      marginBottom: 16
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="textPrimary"`. */
    colorTextPrimary: {
      color: theme.palette.text.primary
    },

    /* Styles applied to the root element if `color="textSecondary"`. */
    colorTextSecondary: {
      color: theme.palette.text.secondary
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `inline={true}`. */
    inline: {
      display: 'inline'
    }
  };
};

exports.styles = styles;
var nextVariants = {
  display4: 'h1',
  display3: 'h2',
  display2: 'h3',
  display1: 'h4',
  headline: 'h5',
  title: 'h6',
  subheading: 'subtitle1'
};

function getVariant(theme, variantProp) {
  var typography = theme.typography;
  var variant = variantProp;

  if (!variant) {
    variant = typography.useNextVariants ? 'body2' : 'body1';
  } // complete v2 switch


  if (typography.useNextVariants) {
    variant = nextVariants[variant] || variant;
  }

  return variant;
}

var defaultHeadlineMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'h6',
  subtitle2: 'h6',
  body1: 'p',
  body2: 'p',
  // deprecated
  display4: 'h1',
  display3: 'h1',
  display2: 'h1',
  display1: 'h1',
  headline: 'h1',
  title: 'h2',
  subheading: 'h3'
};

function Typography(props) {
  var _classNames;

  var align = props.align,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      componentProp = props.component,
      gutterBottom = props.gutterBottom,
      headlineMapping = props.headlineMapping,
      inline = props.inline,
      internalDeprecatedVariant = props.internalDeprecatedVariant,
      noWrap = props.noWrap,
      paragraph = props.paragraph,
      theme = props.theme,
      variantProp = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["align", "classes", "className", "color", "component", "gutterBottom", "headlineMapping", "inline", "internalDeprecatedVariant", "noWrap", "paragraph", "theme", "variant"]);
  var variant = getVariant(theme, variantProp);
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes[variant], variant !== 'inherit'), (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'default'), (0, _defineProperty2.default)(_classNames, classes.noWrap, noWrap), (0, _defineProperty2.default)(_classNames, classes.gutterBottom, gutterBottom), (0, _defineProperty2.default)(_classNames, classes.paragraph, paragraph), (0, _defineProperty2.default)(_classNames, classes["align".concat((0, _helpers.capitalize)(align))], align !== 'inherit'), (0, _defineProperty2.default)(_classNames, classes.inline, inline), _classNames), classNameProp);
  var Component = componentProp || (paragraph ? 'p' : headlineMapping[variant] || defaultHeadlineMapping[variant]) || 'span';
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

 false ? Typography.propTypes = {
  /**
   * Set the text-align on the component.
   */
  align: _propTypes.default.oneOf(['inherit', 'left', 'center', 'right', 'justify']),

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['default', 'error', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * By default, it maps the variant to a good default headline component.
   */
  component: _utils.componentPropType,

  /**
   * If `true`, the text will have a bottom margin.
   */
  gutterBottom: _propTypes.default.bool,

  /**
   * We are empirically mapping the variant property to a range of different DOM element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` property.
   * The default mapping is the following:
   */
  headlineMapping: _propTypes.default.object,

  /**
   *  Controls whether the Typography is inline or not.
   */
  inline: _propTypes.default.bool,

  /**
   * A deprecated variant is used from an internal component. Users don't need
   * a deprecation warning here if they switched to the v2 theme. They already
   * get the mapping that will be applied in the next major release.
   *
   * @internal
   */
  internalDeprecatedVariant: _propTypes.default.bool,

  /**
   * If `true`, the text will not wrap, but instead will truncate with an ellipsis.
   */
  noWrap: _propTypes.default.bool,

  /**
   * If `true`, the text will have a bottom margin.
   */
  paragraph: _propTypes.default.bool,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * Applies the theme typography styles.
   * Use `body1` as the default value with the legacy implementation and `body2` with the new one.
   */
  variant: (0, _utils.chainPropTypes)(_propTypes.default.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline', 'srOnly', 'inherit', // deprecated
  'display4', 'display3', 'display2', 'display1', 'headline', 'title', 'subheading']), function (props) {
    var deprecatedVariants = ['display4', 'display3', 'display2', 'display1', 'headline', 'title', 'subheading'];

    if (props.theme.typography.useNextVariants && !props.internalDeprecatedVariant && deprecatedVariants.indexOf(props.variant) !== -1) {
      return new Error('Material-UI: you are using a deprecated typography variant: ' + "`".concat(props.variant, "` that will be removed in the next major release.\n") + 'Please read the migration guide under https://material-ui.com/style/typography#migration-to-typography-v2.');
    }

    return null;
  })
} : void 0;
Typography.defaultProps = {
  align: 'inherit',
  color: 'default',
  gutterBottom: false,
  headlineMapping: defaultHeadlineMapping,
  inline: false,
  noWrap: false,
  paragraph: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTypography',
  withTheme: true
})(Typography);

exports.default = _default;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(19));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(44));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _ownerWindow = _interopRequireDefault(__webpack_require__(197));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _NoSsr = _interopRequireDefault(__webpack_require__(270));

var _focusVisible = __webpack_require__(859);

var _TouchRipple = _interopRequireDefault(__webpack_require__(860));

var _createRippleHandler = _interopRequireDefault(__webpack_require__(867));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    // Remove grey highlight
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 'none',
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    '-moz-appearance': 'none',
    // Reset
    '-webkit-appearance': 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    },
    '&$disabled': {
      pointerEvents: 'none',
      // Disable link interactions
      cursor: 'default'
    }
  },

  /* Styles applied to the root element if `disabled={true}`. */
  disabled: {},

  /* Styles applied to the root element if keyboard focused. */
  focusVisible: {}
};
/* istanbul ignore if */

exports.styles = styles;

if (false) {
  throw new Error('Material-UI: react@16.3.0 or greater is required.');
}
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */


var ButtonBase =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ButtonBase, _React$Component);

  function ButtonBase() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ButtonBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ButtonBase)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {};
    _this.keyDown = false;
    _this.focusVisibleCheckTime = 50;
    _this.focusVisibleMaxCheckTimes = 5;
    _this.handleMouseDown = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'MouseDown', 'start', function () {
      clearTimeout(_this.focusVisibleTimeout);

      if (_this.state.focusVisible) {
        _this.setState({
          focusVisible: false
        });
      }
    });
    _this.handleMouseUp = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'MouseUp', 'stop');
    _this.handleMouseLeave = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'MouseLeave', 'stop', function (event) {
      if (_this.state.focusVisible) {
        event.preventDefault();
      }
    });
    _this.handleTouchStart = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'TouchStart', 'start');
    _this.handleTouchEnd = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'TouchEnd', 'stop');
    _this.handleTouchMove = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'TouchMove', 'stop');
    _this.handleContextMenu = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'ContextMenu', 'stop');
    _this.handleBlur = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'Blur', 'stop', function () {
      clearTimeout(_this.focusVisibleTimeout);

      if (_this.state.focusVisible) {
        _this.setState({
          focusVisible: false
        });
      }
    });

    _this.onRippleRef = function (node) {
      _this.ripple = node;
    };

    _this.onFocusVisibleHandler = function (event) {
      _this.keyDown = false;

      _this.setState({
        focusVisible: true
      });

      if (_this.props.onFocusVisible) {
        _this.props.onFocusVisible(event);
      }
    };

    _this.handleKeyDown = function (event) {
      var _this$props = _this.props,
          component = _this$props.component,
          focusRipple = _this$props.focusRipple,
          onKeyDown = _this$props.onKeyDown,
          onClick = _this$props.onClick; // Check if key is already down to avoid repeats being counted as multiple activations

      if (focusRipple && !_this.keyDown && _this.state.focusVisible && _this.ripple && event.key === ' ') {
        _this.keyDown = true;
        event.persist();

        _this.ripple.stop(event, function () {
          _this.ripple.start(event);
        });
      }

      if (onKeyDown) {
        onKeyDown(event);
      } // Keyboard accessibility for non interactive elements


      if (event.target === event.currentTarget && component && component !== 'button' && (event.key === ' ' || event.key === 'Enter') && !(_this.button.tagName === 'A' && _this.button.href)) {
        event.preventDefault();

        if (onClick) {
          onClick(event);
        }
      }
    };

    _this.handleKeyUp = function (event) {
      if (_this.props.focusRipple && event.key === ' ' && _this.ripple && _this.state.focusVisible) {
        _this.keyDown = false;
        event.persist();

        _this.ripple.stop(event, function () {
          _this.ripple.pulsate(event);
        });
      }

      if (_this.props.onKeyUp) {
        _this.props.onKeyUp(event);
      }
    };

    _this.handleFocus = function (event) {
      if (_this.props.disabled) {
        return;
      } // Fix for https://github.com/facebook/react/issues/7769


      if (!_this.button) {
        _this.button = event.currentTarget;
      }

      event.persist();
      (0, _focusVisible.detectFocusVisible)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), _this.button, function () {
        _this.onFocusVisibleHandler(event);
      });

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(ButtonBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.button = _reactDom.default.findDOMNode(this);
      (0, _focusVisible.listenForFocusKeys)((0, _ownerWindow.default)(this.button));

      if (this.props.action) {
        this.props.action({
          focusVisible: function focusVisible() {
            _this2.setState({
              focusVisible: true
            });

            _this2.button.focus();
          }
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.focusRipple && !this.props.disableRipple && !prevState.focusVisible && this.state.focusVisible) {
        this.ripple.pulsate();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.focusVisibleTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props2 = this.props,
          action = _this$props2.action,
          buttonRef = _this$props2.buttonRef,
          centerRipple = _this$props2.centerRipple,
          children = _this$props2.children,
          classes = _this$props2.classes,
          classNameProp = _this$props2.className,
          component = _this$props2.component,
          disabled = _this$props2.disabled,
          disableRipple = _this$props2.disableRipple,
          disableTouchRipple = _this$props2.disableTouchRipple,
          focusRipple = _this$props2.focusRipple,
          focusVisibleClassName = _this$props2.focusVisibleClassName,
          onBlur = _this$props2.onBlur,
          onFocus = _this$props2.onFocus,
          onFocusVisible = _this$props2.onFocusVisible,
          onKeyDown = _this$props2.onKeyDown,
          onKeyUp = _this$props2.onKeyUp,
          onMouseDown = _this$props2.onMouseDown,
          onMouseLeave = _this$props2.onMouseLeave,
          onMouseUp = _this$props2.onMouseUp,
          onTouchEnd = _this$props2.onTouchEnd,
          onTouchMove = _this$props2.onTouchMove,
          onTouchStart = _this$props2.onTouchStart,
          tabIndex = _this$props2.tabIndex,
          TouchRippleProps = _this$props2.TouchRippleProps,
          type = _this$props2.type,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "type"]);
      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.focusVisible, this.state.focusVisible), (0, _defineProperty2.default)(_classNames, focusVisibleClassName, this.state.focusVisible), _classNames), classNameProp);
      var ComponentProp = component;

      if (ComponentProp === 'button' && other.href) {
        ComponentProp = 'a';
      }

      var buttonProps = {};

      if (ComponentProp === 'button') {
        buttonProps.type = type || 'button';
        buttonProps.disabled = disabled;
      } else {
        buttonProps.role = 'button';
      }

      return _react.default.createElement(ComponentProp, (0, _extends2.default)({
        className: className,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        onMouseDown: this.handleMouseDown,
        onMouseLeave: this.handleMouseLeave,
        onMouseUp: this.handleMouseUp,
        onTouchEnd: this.handleTouchEnd,
        onTouchMove: this.handleTouchMove,
        onTouchStart: this.handleTouchStart,
        onContextMenu: this.handleContextMenu,
        ref: buttonRef,
        tabIndex: disabled ? '-1' : tabIndex
      }, buttonProps, other), children, !disableRipple && !disabled ? _react.default.createElement(_NoSsr.default, null, _react.default.createElement(_TouchRipple.default, (0, _extends2.default)({
        innerRef: this.onRippleRef,
        center: centerRipple
      }, TouchRippleProps))) : null);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (typeof prevState.focusVisible === 'undefined') {
        return {
          focusVisible: false,
          lastDisabled: nextProps.disabled
        };
      } // The blur won't fire when the disabled state is set on a focused input.
      // We need to book keep the focused state manually.


      if (!prevState.prevState && nextProps.disabled && prevState.focusVisible) {
        return {
          focusVisible: false,
          lastDisabled: nextProps.disabled
        };
      }

      return {
        lastDisabled: nextProps.disabled
      };
    }
  }]);
  return ButtonBase;
}(_react.default.Component);

 false ? ButtonBase.propTypes = {
  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It currently only supports `focusVisible()` action.
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: _propTypes.default.func,

  /**
   * Use that property to pass a ref callback to the native button component.
   */
  buttonRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the ripples will be centered.
   * They won't start at the cursor interaction position.
   */
  centerRipple: _propTypes.default.bool,

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * If `true`, the base button will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * If `true`, the touch ripple effect will be disabled.
   */
  disableTouchRipple: _propTypes.default.bool,

  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * `disableRipple` must also be `false`.
   */
  focusRipple: _propTypes.default.bool,

  /**
   * This property can help a person know which element has the keyboard focus.
   * The class name will be applied when the element gain the focus through a keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * @ignore
   */
  onClick: _propTypes.default.func,

  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyDown: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyUp: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseDown: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseLeave: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseUp: _propTypes.default.func,

  /**
   * @ignore
   */
  onTouchEnd: _propTypes.default.func,

  /**
   * @ignore
   */
  onTouchMove: _propTypes.default.func,

  /**
   * @ignore
   */
  onTouchStart: _propTypes.default.func,

  /**
   * @ignore
   */
  role: _propTypes.default.string,

  /**
   * @ignore
   */
  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * Properties applied to the `TouchRipple` element.
   */
  TouchRippleProps: _propTypes.default.object,

  /**
   * Used to control the button's purpose.
   * This property passes the value to the `type` attribute of the native button component.
   * Valid property values include `button`, `submit`, and `reset`.
   */
  type: _propTypes.default.string
} : void 0;
ButtonBase.defaultProps = {
  centerRipple: false,
  component: 'button',
  disableRipple: false,
  disableTouchRipple: false,
  focusRipple: false,
  tabIndex: '0',
  type: 'button'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiButtonBase'
})(ButtonBase);

exports.default = _default;

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _utils = __webpack_require__(14);

/**
 * NoSsr purposely removes components from the subject of Server Side Rendering (SSR).
 *
 * This component can be useful in a variety of situations:
 * - Escape hatch for broken dependencies not supporting SSR.
 * - Improve the time-to-first paint on the client by only rendering above the fold.
 * - Reduce the rendering time on the server.
 * - Under too heavy server load, you can turn on service degradation.
 */
var NoSsr =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(NoSsr, _React$Component);

  function NoSsr() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, NoSsr);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(NoSsr)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.mounted = false;
    _this.state = {
      mounted: false
    };
    return _this;
  }

  (0, _createClass2.default)(NoSsr, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.mounted = true;

      if (this.props.defer) {
        // Wondering why we use two RAFs? Check this video out:
        // https://www.youtube.com/watch?v=cCOL7MC4Pl0
        //
        // The componentDidMount() method is called after the DOM nodes are inserted.
        // The UI might not have rendering the changes. We request a frame.
        requestAnimationFrame(function () {
          // The browser should be about to render the DOM nodes
          // that React committed at this point.
          // We don't want to interrupt. Let's wait the next frame.
          requestAnimationFrame(function () {
            // The UI is up-to-date at this point.
            // We can continue rendering the children.
            if (_this2.mounted) {
              _this2.setState({
                mounted: true
              });
            }
          });
        });
      } else {
        this.setState({
          mounted: true
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          fallback = _this$props.fallback;
      return this.state.mounted ? children : fallback;
    }
  }]);
  return NoSsr;
}(_react.default.Component);

 false ? NoSsr.propTypes = {
  children: _propTypes.default.node.isRequired,

  /**
   * If `true`, the component will not only prevent server-side rendering.
   * It will also defer the rendering of the children into a different screen frame.
   */
  defer: _propTypes.default.bool,

  /**
   * The fallback content to display.
   */
  fallback: _propTypes.default.node
} : void 0;

if (false) {
  process.env.NODE_ENV !== "production" ? NoSsr.propTypes = (0, _utils.exactProp)(NoSsr.propTypes) : void 0;
}

NoSsr.defaultProps = {
  defer: false,
  fallback: null
};
var _default = NoSsr;
exports.default = _default;

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.detectFocusVisible = detectFocusVisible;
exports.listenForFocusKeys = listenForFocusKeys;

var _warning = _interopRequireDefault(__webpack_require__(27));

var _ownerDocument = _interopRequireDefault(__webpack_require__(93));

var internal = {
  focusKeyPressed: false,
  keyUpEventTimeout: -1
};

function findActiveElement(doc) {
  var activeElement = doc.activeElement;

  while (activeElement && activeElement.shadowRoot && activeElement.shadowRoot.activeElement) {
    activeElement = activeElement.shadowRoot.activeElement;
  }

  return activeElement;
}

function detectFocusVisible(instance, element, callback) {
  var attempt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
   false ? (0, _warning.default)(instance.focusVisibleCheckTime, 'Material-UI: missing instance.focusVisibleCheckTime.') : void 0;
   false ? (0, _warning.default)(instance.focusVisibleMaxCheckTimes, 'Material-UI: missing instance.focusVisibleMaxCheckTimes.') : void 0;
  instance.focusVisibleTimeout = setTimeout(function () {
    var doc = (0, _ownerDocument.default)(element);
    var activeElement = findActiveElement(doc);

    if (internal.focusKeyPressed && (activeElement === element || element.contains(activeElement))) {
      callback();
    } else if (attempt < instance.focusVisibleMaxCheckTimes) {
      detectFocusVisible(instance, element, callback, attempt + 1);
    }
  }, instance.focusVisibleCheckTime);
}

var FOCUS_KEYS = [9, // 'Tab',
13, // 'Enter',
27, // 'Escape',
32, // ' ',
37, // 'ArrowLeft',
38, // 'ArrowUp',
39, // 'ArrowRight',
40];

function isFocusKey(event) {
  // Use event.keyCode to support IE 11
  return FOCUS_KEYS.indexOf(event.keyCode) > -1;
}

var handleKeyUpEvent = function handleKeyUpEvent(event) {
  if (isFocusKey(event)) {
    internal.focusKeyPressed = true; // Let's consider that the user is using a keyboard during a window frame of 500ms.

    clearTimeout(internal.keyUpEventTimeout);
    internal.keyUpEventTimeout = setTimeout(function () {
      internal.focusKeyPressed = false;
    }, 500);
  }
};

function listenForFocusKeys(win) {
  // The event listener will only be added once per window.
  // Duplicate event listeners will be ignored by addEventListener.
  // Also, this logic is client side only, we don't need a teardown.
  win.addEventListener('keyup', handleKeyUpEvent);
}

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = exports.DELAY_RIPPLE = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(50));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(19));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(44));

var _TransitionGroup = _interopRequireDefault(__webpack_require__(861));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _Ripple = _interopRequireDefault(__webpack_require__(865));

var DURATION = 550;
var DELAY_RIPPLE = 80;
exports.DELAY_RIPPLE = DELAY_RIPPLE;

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      position: 'absolute',
      overflow: 'hidden',
      borderRadius: 'inherit',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      pointerEvents: 'none',
      zIndex: 0
    },

    /* Styles applied to the internal `Ripple` components `ripple` class. */
    ripple: {
      width: 50,
      height: 50,
      left: 0,
      top: 0,
      opacity: 0,
      position: 'absolute'
    },

    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
    rippleVisible: {
      opacity: 0.3,
      transform: 'scale(1)',
      animation: "mui-ripple-enter ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut),
      // Backward compatible logic between JSS v9 and v10.
      // To remove with the release of Material-UI v4
      animationName: '$mui-ripple-enter'
    },

    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
    ripplePulsate: {
      animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
    },

    /* Styles applied to the internal `Ripple` components `child` class. */
    child: {
      opacity: 1,
      display: 'block',
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      backgroundColor: 'currentColor'
    },

    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
    childLeaving: {
      opacity: 0,
      animation: "mui-ripple-exit ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut),
      // Backward compatible logic between JSS v9 and v10.
      // To remove with the release of Material-UI v4
      animationName: '$mui-ripple-exit'
    },

    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
    childPulsate: {
      position: 'absolute',
      left: 0,
      top: 0,
      animation: "mui-ripple-pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite"),
      // Backward compatible logic between JSS v9 and v10.
      // To remove with the release of Material-UI v4
      animationName: '$mui-ripple-pulsate'
    },
    '@keyframes mui-ripple-enter': {
      '0%': {
        transform: 'scale(0)',
        opacity: 0.1
      },
      '100%': {
        transform: 'scale(1)',
        opacity: 0.3
      }
    },
    '@keyframes mui-ripple-exit': {
      '0%': {
        opacity: 1
      },
      '100%': {
        opacity: 0
      }
    },
    '@keyframes mui-ripple-pulsate': {
      '0%': {
        transform: 'scale(1)'
      },
      '50%': {
        transform: 'scale(0.92)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    }
  };
};

exports.styles = styles;

var TouchRipple =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(TouchRipple, _React$PureComponent);

  function TouchRipple() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, TouchRipple);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(TouchRipple)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      nextKey: 0,
      ripples: []
    };

    _this.pulsate = function () {
      _this.start({}, {
        pulsate: true
      });
    };

    _this.start = function () {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cb = arguments.length > 2 ? arguments[2] : undefined;
      var _options$pulsate = options.pulsate,
          pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
          _options$center = options.center,
          center = _options$center === void 0 ? _this.props.center || options.pulsate : _options$center,
          _options$fakeElement = options.fakeElement,
          fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;

      if (event.type === 'mousedown' && _this.ignoringMouseDown) {
        _this.ignoringMouseDown = false;
        return;
      }

      if (event.type === 'touchstart') {
        _this.ignoringMouseDown = true;
      }

      var element = fakeElement ? null : _reactDom.default.findDOMNode((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
      var rect = element ? element.getBoundingClientRect() : {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      }; // Get the size of the ripple

      var rippleX;
      var rippleY;
      var rippleSize;

      if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
        rippleX = Math.round(rect.width / 2);
        rippleY = Math.round(rect.height / 2);
      } else {
        var clientX = event.clientX ? event.clientX : event.touches[0].clientX;
        var clientY = event.clientY ? event.clientY : event.touches[0].clientY;
        rippleX = Math.round(clientX - rect.left);
        rippleY = Math.round(clientY - rect.top);
      }

      if (center) {
        rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.

        if (rippleSize % 2 === 0) {
          rippleSize += 1;
        }
      } else {
        var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
        var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
        rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
      } // Touche devices


      if (event.touches) {
        // Prepare the ripple effect.
        _this.startTimerCommit = function () {
          _this.startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
          });
        }; // Delay the execution of the ripple effect.


        _this.startTimer = setTimeout(function () {
          if (_this.startTimerCommit) {
            _this.startTimerCommit();

            _this.startTimerCommit = null;
          }
        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
      } else {
        _this.startCommit({
          pulsate: pulsate,
          rippleX: rippleX,
          rippleY: rippleY,
          rippleSize: rippleSize,
          cb: cb
        });
      }
    };

    _this.startCommit = function (params) {
      var pulsate = params.pulsate,
          rippleX = params.rippleX,
          rippleY = params.rippleY,
          rippleSize = params.rippleSize,
          cb = params.cb;

      _this.setState(function (state) {
        return {
          nextKey: state.nextKey + 1,
          ripples: [].concat((0, _toConsumableArray2.default)(state.ripples), [_react.default.createElement(_Ripple.default, {
            key: state.nextKey,
            classes: _this.props.classes,
            timeout: {
              exit: DURATION,
              enter: DURATION
            },
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize
          })])
        };
      }, cb);
    };

    _this.stop = function (event, cb) {
      clearTimeout(_this.startTimer);
      var ripples = _this.state.ripples; // The touch interaction occurs too quickly.
      // We still want to show ripple effect.

      if (event.type === 'touchend' && _this.startTimerCommit) {
        event.persist();

        _this.startTimerCommit();

        _this.startTimerCommit = null;
        _this.startTimer = setTimeout(function () {
          _this.stop(event, cb);
        });
        return;
      }

      _this.startTimerCommit = null;

      if (ripples && ripples.length) {
        _this.setState({
          ripples: ripples.slice(1)
        }, cb);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(TouchRipple, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.startTimer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          center = _this$props.center,
          classes = _this$props.classes,
          className = _this$props.className,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["center", "classes", "className"]);
      return _react.default.createElement(_TransitionGroup.default, (0, _extends2.default)({
        component: "span",
        enter: true,
        exit: true,
        className: (0, _classnames.default)(classes.root, className)
      }, other), this.state.ripples);
    }
  }]);
  return TouchRipple;
}(_react.default.PureComponent);

 false ? TouchRipple.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: _propTypes.default.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : void 0;
TouchRipple.defaultProps = {
  center: false
};

var _default = (0, _withStyles.default)(styles, {
  flip: false,
  name: 'MuiTouchRipple'
})(TouchRipple);

exports.default = _default;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(271));

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactLifecyclesCompat = __webpack_require__(405);

var _ChildMapping = __webpack_require__(864);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(863);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(1);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _Transition = _interopRequireDefault(__webpack_require__(137));

/**
 * @ignore - internal component.
 */
var Ripple =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Ripple, _React$Component);

  function Ripple() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Ripple);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Ripple)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      visible: false,
      leaving: false
    };

    _this.handleEnter = function () {
      _this.setState({
        visible: true
      });
    };

    _this.handleExit = function () {
      _this.setState({
        leaving: true
      });
    };

    return _this;
  }

  (0, _createClass2.default)(Ripple, [{
    key: "render",
    value: function render() {
      var _classNames, _classNames2;

      var _this$props = this.props,
          classes = _this$props.classes,
          classNameProp = _this$props.className,
          pulsate = _this$props.pulsate,
          rippleX = _this$props.rippleX,
          rippleY = _this$props.rippleY,
          rippleSize = _this$props.rippleSize,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "className", "pulsate", "rippleX", "rippleY", "rippleSize"]);
      var _this$state = this.state,
          visible = _this$state.visible,
          leaving = _this$state.leaving;
      var rippleClassName = (0, _classnames.default)(classes.ripple, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.rippleVisible, visible), (0, _defineProperty2.default)(_classNames, classes.ripplePulsate, pulsate), _classNames), classNameProp);
      var rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
      };
      var childClassName = (0, _classnames.default)(classes.child, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.childLeaving, leaving), (0, _defineProperty2.default)(_classNames2, classes.childPulsate, pulsate), _classNames2));
      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
        onEnter: this.handleEnter,
        onExit: this.handleExit
      }, other), _react.default.createElement("span", {
        className: rippleClassName,
        style: rippleStyles
      }, _react.default.createElement("span", {
        className: childClassName
      })));
    }
  }]);
  return Ripple;
}(_react.default.Component);

 false ? Ripple.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: _propTypes.default.bool,

  /**
   * Diameter of the ripple.
   */
  rippleSize: _propTypes.default.number,

  /**
   * Horizontal position of the ripple center.
   */
  rippleX: _propTypes.default.number,

  /**
   * Vertical position of the ripple center.
   */
  rippleY: _propTypes.default.number
} : void 0;
Ripple.defaultProps = {
  pulsate: false
};
var _default = Ripple;
exports.default = _default;

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(271));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* eslint-disable import/no-mutable-exports */
var createRippleHandler = function createRippleHandler(instance, eventName, action, cb) {
  return function (event) {
    if (cb) {
      cb.call(instance, event);
    }

    var ignore = false; // Ignore events that have been `event.preventDefault()` marked.

    if (event.defaultPrevented) {
      ignore = true;
    }

    if (instance.props.disableTouchRipple && eventName !== 'Blur') {
      ignore = true;
    }

    if (!ignore && instance.ripple) {
      instance.ripple[action](event);
    }

    if (typeof instance.props["on".concat(eventName)] === 'function') {
      instance.props["on".concat(eventName)](event);
    }

    return true;
  };
};
/* istanbul ignore if */


if (typeof window === 'undefined') {
  createRippleHandler = function createRippleHandler() {
    return function () {};
  };
}

var _default = createRippleHandler;
exports.default = _default;

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__);
var _dec,_class;var BAR_WIDTH=40;var styles=function styles(theme){return{root:{width:BAR_WIDTH,height:'24px',position:'relative',cursor:'pointer',display:'flex',flexDirection:'column',justifyContent:'space-between'},bar:{display:'block',height:'4px',width:BAR_WIDTH,background:theme.palette.common.white,borderRadius:'4px',transition:'width .25s linear','&:after':{content:'""',display:'block',position:'absolute',height:'4px',width:0,background:theme.palette.common.white,borderRadius:'4px',transition:'width .25s linear',right:0},'&$barOpen':{width:BAR_WIDTH,'&:after':{width:0},'&:nth-child(1)':{transitionDelay:'.25s'},'&:nth-child(2)':{transitionDelay:'.33s','&:after':{transitionDelay:'.08s'}},'&:nth-child(3)':{transitionDelay:'.41s','&:after':{transitionDelay:'.16s'}}},'&$barClose':{width:0,'&:after':{width:BAR_WIDTH},'&:nth-child(1)':{'&:after':{transitionDelay:'.25s'}},'&:nth-child(2)':{transitionDelay:'.08s','&:after':{transitionDelay:'.33s'}},'&:nth-child(3)':{transitionDelay:'.16s','&:after':{transitionDelay:'.41s'}}}},barOpen:{},barClose:{}};};var HamburgerButton=(_dec=Object(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(HamburgerButton,_Component);function HamburgerButton(){__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this,HamburgerButton);return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(HamburgerButton).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(HamburgerButton,[{key:"render",value:function render(){var _barClasses;var _this$props=this.props,classes=_this$props.classes,onChange=_this$props.onChange,open=_this$props.open;var barClasses=(_barClasses={},__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_barClasses,classes.bar,true),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_barClasses,classes.barOpen,open),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_barClasses,classes.barClose,!open),_barClasses);return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:classes.root,onClick:onChange,"data-tid":"button-hamburger-button"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("span",{className:__WEBPACK_IMPORTED_MODULE_8_classnames___default()(barClasses)}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("span",{className:__WEBPACK_IMPORTED_MODULE_8_classnames___default()(barClasses)}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("span",{className:__WEBPACK_IMPORTED_MODULE_8_classnames___default()(barClasses)}));}}]);return HamburgerButton;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]))||_class);HamburgerButton.defaultProps={open:true,onChange:function onChange(){}};HamburgerButton.propTypes={classes:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,open:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,onChange:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (HamburgerButton);

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Drawer__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Drawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Drawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Link__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_MenuList__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_MenuList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_MenuList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_MenuItem__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_Avatar__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_Avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_Divider__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_redux_modules_workspaces__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_subscription__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_icons_ExpandMore__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_icons_ExpandMore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__material_ui_icons_ExpandMore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_utils_state__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_theme_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__material_ui_core_Typography__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_theme_uiConfig__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_routes__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_containers_OnBoarding_Steps__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_i18n_i18n__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_components_XaraLogo_XaraLogo__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_classnames__);
var _dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_30_i18n_i18n__["a" /* default */].loc.localize;var USERS_LAST_SEEN_COLUMN_VISIBILITY_CHANGED_EVENT='users-last-seen-column-visibility-changed';var styles=function styles(theme){return{drawer:{width:__WEBPACK_IMPORTED_MODULE_26_theme_uiConfig__["c" /* mainNavWidth */],flexShrink:0},drawerPaper:{width:__WEBPACK_IMPORTED_MODULE_26_theme_uiConfig__["c" /* mainNavWidth */],height:"calc(100% - ".concat(__WEBPACK_IMPORTED_MODULE_26_theme_uiConfig__["f" /* topBarHeight */],"px)"),top:__WEBPACK_IMPORTED_MODULE_26_theme_uiConfig__["f" /* topBarHeight */],padding:'0 15px'},userInfo:{display:'flex',position:'relative',alignItems:'center',margin:'30px 0 15px',paddingBottom:'25px',color:theme.palette.colors.colorWithAlpha(theme.palette.colors.zeta,0.75),userSelect:'none','&.isOpened':{'& .userProfileDropdown':{'visibility':'visible','opacity':1},'& .expandUserProfile':{transform:'rotate(180deg)'}},'& .avatar':{color:theme.palette.colors.delta},'&:hover':{cursor:'pointer',color:'#2888C3','& .avatar':{color:'#2888C3'}}},userName:{fontFamily:'"Open Sans Xara"',fontWeight:'bold',fontSize:'16px',lineHeight:'22px',color:'inherit',paddingRight:'23px'},userSubtitle:{opacity:1,color:'inherit'},navLink:{fontSize:'16px','&$navLinkSelected':{fontWeight:'bold',background:'none'},'&$navLinkSelected:hover':{background:'none'},'&:hover':{background:'none',fontWeight:'bold'},'&:focus':{backgroundColor:'transparent',fontWeight:'bold'}},navLinkIcon:{width:40,marginRight:15},navLinkSelected:{},avatar:{marginRight:5,width:50,height:50,background:'none',transform:'scale(0.8)',color:'inherit'},userNameAndRole:{position:'relative',width:'100%'},expandUserProfile:{'position':'absolute','top':0,'right':0,transition:'transform 0.2s'},userProfileDropdown:{transition:'opacity 0.2s','opacity':0,'visibility':'hidden',position:'absolute',left:0,bottom:0,width:'100%',paddingLeft:'50px','& a':{color:theme.palette.colors.colorWithAlpha(theme.palette.colors.zeta,0.75),'&:hover':{color:'#616161',textDecoration:'none'}}},"new":{'&:after':{padding:2,background:theme.palette.colors.alpha,color:theme.palette.colors.white,content:"\"".concat(localize('main-nav-new'),"\""),display:'block',fontSize:8,lineHeight:'12px',fontWeight:'normal',borderRadius:3,position:'relative',top:-8,left:3}}};};var NAV=[{path:__WEBPACK_IMPORTED_MODULE_27_routes__["l" /* ROOT */],tid:'main-nav-team-profile',text:localize('main-nav-team-profile'),icon:__WEBPACK_IMPORTED_MODULE_24_theme_icons__["i" /* CupIcon */],exact:true,onlyAdminVisible:false,showForTempCompanyOnPlan:[__WEBPACK_IMPORTED_MODULE_29__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT,__WEBPACK_IMPORTED_MODULE_29__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES,__WEBPACK_IMPORTED_MODULE_29__config__["_42" /* SUBSCRIPTION_PLAN */].TEAM_PLUS,__WEBPACK_IMPORTED_MODULE_29__config__["_42" /* SUBSCRIPTION_PLAN */].ESSENTIAL,__WEBPACK_IMPORTED_MODULE_29__config__["_42" /* SUBSCRIPTION_PLAN */].WEB,__WEBPACK_IMPORTED_MODULE_29__config__["_42" /* SUBSCRIPTION_PLAN */].DESIGNER,__WEBPACK_IMPORTED_MODULE_29__config__["_42" /* SUBSCRIPTION_PLAN */].PHOTO],showForPerpetualOwners:true,isVisibleForDesktopTempTeams:true,showInIsReAccessNoIndustryMode:true},{path:__WEBPACK_IMPORTED_MODULE_27_routes__["t" /* USERS */],tid:'main-nav-users',text:localize('main-nav-users'),icon:__WEBPACK_IMPORTED_MODULE_24_theme_icons__["_5" /* UsersIcon */],oId:__WEBPACK_IMPORTED_MODULE_28_containers_OnBoarding_Steps__["a" /* TeamMembersStep */].oId,onlyAdminVisible:true,showForPerpetualOwners:true,showForTempCompanyOnPlan:[__WEBPACK_IMPORTED_MODULE_29__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT,__WEBPACK_IMPORTED_MODULE_29__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES,__WEBPACK_IMPORTED_MODULE_29__config__["_42" /* SUBSCRIPTION_PLAN */].TEAM_PLUS,__WEBPACK_IMPORTED_MODULE_29__config__["_42" /* SUBSCRIPTION_PLAN */].ESSENTIAL,__WEBPACK_IMPORTED_MODULE_29__config__["_42" /* SUBSCRIPTION_PLAN */].WEB,__WEBPACK_IMPORTED_MODULE_29__config__["_42" /* SUBSCRIPTION_PLAN */].DESIGNER,__WEBPACK_IMPORTED_MODULE_29__config__["_42" /* SUBSCRIPTION_PLAN */].PHOTO],isVisibleForDesktopTempTeams:true,showInIsReAccessNoIndustryMode:true},{tid:'main-nav-mls-connection',path:__WEBPACK_IMPORTED_MODULE_27_routes__["g" /* MLS_CONNECTION */],text:localize('main-nav-mls-connection'),icon:__WEBPACK_IMPORTED_MODULE_24_theme_icons__["O" /* MlsIcon */],onlyAdminVisible:true,hideForDesktop:true,showForType2Only:true},{tid:'main-nav-fonts',path:__WEBPACK_IMPORTED_MODULE_27_routes__["f" /* FONTS */],text:localize('main-nav-fonts'),icon:__WEBPACK_IMPORTED_MODULE_24_theme_icons__["q" /* FontsIcon */],onlyAdminVisible:true,hideForDesktop:true,showForTempCompanyOnPlan:Object(__WEBPACK_IMPORTED_MODULE_29__config__["_68" /* getCloudPlans */])()},{tid:'main-nav-folders',path:__WEBPACK_IMPORTED_MODULE_27_routes__["b" /* CLOUD_FOLDER */],text:localize('main-nav-folders'),icon:__WEBPACK_IMPORTED_MODULE_24_theme_icons__["p" /* FolderIcon */],onlyAdminVisible:true,hideForDesktop:true,showForTempCompanyOnPlan:Object(__WEBPACK_IMPORTED_MODULE_29__config__["_68" /* getCloudPlans */])()},{tid:'main-nav-smartfields',path:__WEBPACK_IMPORTED_MODULE_27_routes__["m" /* SMART_FIELDS */],text:localize('main-nav-smartfields'),icon:__WEBPACK_IMPORTED_MODULE_24_theme_icons__["W" /* SmartFieldsIcon */],onlyAdminVisible:true,hideForDesktop:true,showForTempCompanyOnPlan:Object(__WEBPACK_IMPORTED_MODULE_29__config__["_68" /* getCloudPlans */])()},{tid:'main-nav-customize',path:__WEBPACK_IMPORTED_MODULE_27_routes__["e" /* CUSTOMIZE */],text:localize('main-nav-customize'),icon:__WEBPACK_IMPORTED_MODULE_24_theme_icons__["j" /* CustomizeIcon */],onlyAdminVisible:true,hideForDesktop:true,showForTempCompanyOnPlan:Object(__WEBPACK_IMPORTED_MODULE_29__config__["_68" /* getCloudPlans */])()},{tid:'main-nav-subscription',path:__WEBPACK_IMPORTED_MODULE_27_routes__["n" /* SUBSCRIPTION */],text:localize('main-nav-subscription'),icon:__WEBPACK_IMPORTED_MODULE_24_theme_icons__["P" /* MoneyBoxIcon */],onlyAdminVisible:true,isVisibleForTempTeams:true},{tid:'main-nav-downloads',path:__WEBPACK_IMPORTED_MODULE_27_routes__["v" /* XC_PLUS */],text:localize('main-nav-downloads'),icon:__WEBPACK_IMPORTED_MODULE_24_theme_icons__["n" /* DownloadIcon */],onlyAdminVisible:false,hideInNewReUI:true,customClassName:'new',isVisibleForTempTeams:true}];var MainNav=(_dec=Object(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__["withStyles"])(styles),Object(__WEBPACK_IMPORTED_MODULE_12_react_router__["c" /* withRouter */])(_class=_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(MainNav,_Component);function MainNav(props){var _this;__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,MainNav);_this=__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(MainNav).call(this,props));__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this),"handleUsersNavClick",function(event,companyPath){event.preventDefault();window.showUsersLastSeenColumn=event.ctrlKey;window.dispatchEvent(new Event(USERS_LAST_SEEN_COLUMN_VISIBILITY_CHANGED_EVENT));_this.props.history.push(companyPath);});_this.state={isUserProfileDropdownOpen:false};return _this;}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(MainNav,[{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){if(prevProps.location.pathname!==this.props.location.pathname){this.setState({isUserProfileDropdownOpen:false});}}},{key:"render",value:function render(){var _this$props=this.props,classes=_this$props.classes,navOpen=_this$props.navOpen;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Drawer___default.a,{variant:"persistent",anchor:"left",open:navOpen,classes:{root:classes.drawer,paper:classes.drawerPaper}},this.renderContent(),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32_components_XaraLogo_XaraLogo__["a" /* default */],null));}},{key:"handleProfileDropdownClick",value:function handleProfileDropdownClick(isUserProfileDropdownOpen){this.setState({isUserProfileDropdownOpen:isUserProfileDropdownOpen});}},{key:"renderUserInfo",value:function renderUserInfo(){var _classNames,_this2=this,_classNames2,_classNames3,_classNames4;var _this$props2=this.props,classes=_this$props2.classes,company=_this$props2.company,user=_this$props2.user;var userRole=__WEBPACK_IMPORTED_MODULE_31_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_29__config__["_53" /* USER_ROLES */],"".concat(company.userRole,".label"));var isUserProfileDropdownOpen=this.state.isUserProfileDropdownOpen;var accountDetailsPath=Object(__WEBPACK_IMPORTED_MODULE_27_routes__["w" /* getRoute */])(__WEBPACK_IMPORTED_MODULE_27_routes__["a" /* ACCOUNT_DETAILS */],company.id);accountDetailsPath=accountDetailsPath.replace(/\//,'#');return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("section",{className:__WEBPACK_IMPORTED_MODULE_33_classnames___default()((_classNames={},__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_classNames,classes.userInfo,true),__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_classNames,'isOpened',isUserProfileDropdownOpen),_classNames)),key:"user-profile",onClick:function onClick(){return _this2.handleProfileDropdownClick(!isUserProfileDropdownOpen);}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_Avatar___default.a,{alt:localize('main-nav-avatar-alt'),className:__WEBPACK_IMPORTED_MODULE_33_classnames___default()((_classNames2={},__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_classNames2,classes.avatar,true),__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_classNames2,'avatar',true),_classNames2))},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_theme_icons__["a" /* AccountIcon */],null)),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{className:classes.userNameAndRole},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core_Typography___default.a,{variant:"h1",className:classes.userName},user.name),userRole&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core_Typography___default.a,{variant:"body2",className:classes.userSubtitle},userRole),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_icons_ExpandMore___default.a,{className:__WEBPACK_IMPORTED_MODULE_33_classnames___default()((_classNames3={},__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_classNames3,classes.expandUserProfile,true),__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_classNames3,'expandUserProfile',true),_classNames3))})),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{className:__WEBPACK_IMPORTED_MODULE_33_classnames___default()((_classNames4={},__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_classNames4,classes.userProfileDropdown,true),__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_classNames4,'userProfileDropdown',true),_classNames4))},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Link___default.a,{href:accountDetailsPath},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core_Typography___default.a,{variant:"body2",className:classes.userSubtitle},localize('main-nav-change-sign-in-details')))));}},{key:"renderContent",value:function renderContent(){return[this.renderUserInfo(),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_Divider___default.a,{key:"divider"}),this.renderNav()];}},{key:"renderNav",value:function renderNav(){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_MenuList___default.a,{key:"nav",component:"nav",disablePadding:true},NAV.filter(function(item){return item;}).map(this.renderNavLink,this));}},{key:"renderNavLink",value:function renderNavLink(navLink,navLinkIndex){var _this3=this,_classNames5;var _this$props3=this.props,classes=_this$props3.classes,company=_this$props3.company,disabled=_this$props3.disabled,isAdmin=_this$props3.isAdmin,isTempCompany=_this$props3.isTempCompany,currentPlanId=_this$props3.currentPlanId,isDesktopApp=_this$props3.isDesktopApp,isPerpetualOwner=_this$props3.isPerpetualOwner;var activeSubscription=Object(__WEBPACK_IMPORTED_MODULE_21__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(currentPlanId);var plan=activeSubscription.plan;var tid=navLink.tid,path=navLink.path,text=navLink.text,separator=navLink.separator,_navLink$exact=navLink.exact,exact=_navLink$exact===void 0?false:_navLink$exact,Icon=navLink.icon,oId=navLink.oId,onlyAdminVisible=navLink.onlyAdminVisible,customClassName=navLink.customClassName,isVisibleForTempTeams=navLink.isVisibleForTempTeams,isVisibleForDesktopTempTeams=navLink.isVisibleForDesktopTempTeams,hideForDesktop=navLink.hideForDesktop,hideInNewReUI=navLink.hideInNewReUI,showForTempCompanyOnPlan=navLink.showForTempCompanyOnPlan,showForPerpetualOwners=navLink.showForPerpetualOwners,showInIsReAccessNoIndustryMode=navLink.showInIsReAccessNoIndustryMode,showForType2Only=navLink.showForType2Only;// Prevent rendering the menu item,
// if this menu item should be shown anly for admins
// and the current user is not an Admin)
// OR Route is not available for companies with a temporary name ([P9052-15208] PDF simplified workflow)
// Always show Team profile and Users and permissions tab for Team/Team+ [P9052-20321]
if(onlyAdminVisible&&!isAdmin||showForType2Only&&this.props.mls.mlsUiType!==__WEBPACK_IMPORTED_MODULE_29__config__["_0" /* MLS_UI */].SELF_CONNECT_API||isDesktopApp&&hideForDesktop||Object(__WEBPACK_IMPORTED_MODULE_23_utils_state__["e" /* showNewRealEstateUI */])(this.props.company,this.props.app.isDesktopTrial,this.props.app.isReAccessNoIndustry)&&hideInNewReUI||isTempCompany&&isVisibleForTempTeams!==true&&!(isVisibleForDesktopTempTeams&&isDesktopApp)&&!(showForPerpetualOwners&&isPerpetualOwner)&&!(showInIsReAccessNoIndustryMode&&this.props.app.isReAccessNoIndustry)&&(!showForTempCompanyOnPlan||!showForTempCompanyOnPlan.includes(plan))){return;}var key="nav-link-".concat(navLinkIndex);var companyPath=Object(__WEBPACK_IMPORTED_MODULE_27_routes__["w" /* getRoute */])(path,company.id);if(separator){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("hr",{key:key,className:classes.separator});}return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_MenuItem___default.a,{key:key,component:__WEBPACK_IMPORTED_MODULE_11_react_router_dom__["b" /* NavLink */],to:companyPath,button:true,disableGutters:true,disableRipple:true,exact:exact,"data-tid":tid,onClick:function onClick(event){if(path===__WEBPACK_IMPORTED_MODULE_27_routes__["t" /* USERS */]){_this3.handleUsersNavClick(event,companyPath);}},className:__WEBPACK_IMPORTED_MODULE_33_classnames___default()((_classNames5={},__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_classNames5,classes.navLink,true),__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_classNames5,classes[customClassName],!!customClassName),_classNames5)),activeClassName:!disabled?classes.navLinkSelected:'',"data-oid":oId},Icon?__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Icon,{key:"".concat(key,"-icon"),className:classes.navLinkIcon}):null,text);}},{key:"selectedWorkspaceName",get:function get(){var _this$props$workspace=this.props.workspaces,rawDataById=_this$props$workspace.rawDataById,selectedId=_this$props$workspace.selectedId;return rawDataById&&rawDataById[selectedId]?rawDataById[selectedId].displayName:'';}}]);return MainNav;}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]))||_class)||_class);MainNav.propTypes={classes:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,location:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,history:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,navOpen:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool.isRequired,deleteWorkspace:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,company:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object.isRequired,workspaces:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object.isRequired,user:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object.isRequired,disabled:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,isAdmin:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,isTempCompany:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,currentPlanId:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,isDesktopApp:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,isPerpetualOwner:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,app:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object.isRequired,mls:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object};var mapStateToProps=function mapStateToProps(state){return{company:state.companies.rawDataById[state.companies.selectedId],workspaces:state.workspaces,user:state.session.user,app:state.app,currentPlanId:Object(__WEBPACK_IMPORTED_MODULE_21__utils_subscription__["c" /* getCurrentPlanId */])(state.companies.rawDataById[state.companies.selectedId]),mls:state.mls};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_19_redux__["b" /* bindActionCreators */])({deleteWorkspace:__WEBPACK_IMPORTED_MODULE_20_redux_modules_workspaces__["c" /* deleteWorkspace */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_react_router__["c" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_18_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(MainNav)));

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(19));

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactDom = _interopRequireDefault(__webpack_require__(44));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _warning = _interopRequireDefault(__webpack_require__(27));

var _utils = __webpack_require__(14);

var _ownerDocument = _interopRequireDefault(__webpack_require__(93));

var _RootRef = _interopRequireDefault(__webpack_require__(273));

var _Portal = _interopRequireDefault(__webpack_require__(274));

var _helpers = __webpack_require__(29);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _ModalManager = _interopRequireDefault(__webpack_require__(407));

var _Backdrop = _interopRequireDefault(__webpack_require__(412));

var _manageAriaHidden = __webpack_require__(411);

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom.default.findDOMNode(container) || defaultContainer;
}

function getHasTransition(props) {
  return props.children ? props.children.props.hasOwnProperty('in') : false;
}

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'fixed',
      zIndex: theme.zIndex.modal,
      right: 0,
      bottom: 0,
      top: 0,
      left: 0
    },

    /* Styles applied to the root element if the `Modal` has exited. */
    hidden: {
      visibility: 'hidden'
    }
  };
};
/* istanbul ignore if */


exports.styles = styles;

if (false) {
  throw new Error('Material-UI: react@16.3.0 or greater is required.');
}
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/api/dialog/)
 * - [Drawer](/api/drawer/)
 * - [Menu](/api/menu/)
 * - [Popover](/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */


var Modal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Modal, _React$Component);

  function Modal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Modal);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Modal).call(this));
    _this.mounted = false;

    _this.handleOpen = function () {
      var doc = (0, _ownerDocument.default)(_this.mountNode);
      var container = getContainer(_this.props.container, doc.body);

      _this.props.manager.add((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), container);

      doc.addEventListener('focus', _this.enforceFocus, true);

      if (_this.dialogRef) {
        _this.handleOpened();
      }
    };

    _this.handleRendered = function () {
      if (_this.props.onRendered) {
        _this.props.onRendered();
      }

      if (_this.props.open) {
        _this.handleOpened();
      } else {
        (0, _manageAriaHidden.ariaHidden)(_this.modalRef, true);
      }
    };

    _this.handleOpened = function () {
      _this.autoFocus();

      _this.props.manager.mount((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this))); // Fix a bug on Chrome where the scroll isn't initially 0.


      _this.modalRef.scrollTop = 0;
    };

    _this.handleClose = function (reason) {
      var hasTransition = getHasTransition(_this.props);
      /* If the component does not have a transition or is unmounting remove the Modal
      otherwise let the transition handle removing the style, this prevents elements
      moving around when the Modal is closed. */

      if (!(hasTransition && _this.props.closeAfterTransition) || reason === 'unmount') {
        _this.props.manager.remove((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
      }

      var doc = (0, _ownerDocument.default)(_this.mountNode);
      doc.removeEventListener('focus', _this.enforceFocus, true);

      _this.restoreLastFocus();
    };

    _this.handleExited = function () {
      if (_this.props.closeAfterTransition) {
        _this.props.manager.remove((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
      }

      _this.setState({
        exited: true
      });
    };

    _this.handleBackdropClick = function (event) {
      if (event.target !== event.currentTarget) {
        return;
      }

      if (_this.props.onBackdropClick) {
        _this.props.onBackdropClick(event);
      }

      if (!_this.props.disableBackdropClick && _this.props.onClose) {
        _this.props.onClose(event, 'backdropClick');
      }
    };

    _this.handleKeyDown = function (event) {
      // event.defaultPrevented:
      //
      // Ignore events that have been `event.preventDefault()` marked.
      // preventDefault() is meant to stop default behaviours like
      // clicking a checkbox to check it, hitting a button to submit a form,
      // and hitting left arrow to move the cursor in a text input etc.
      // Only special HTML elements have these default bahaviours.
      //
      // To remove in v4.
      if (event.key !== 'Escape' || !_this.isTopModal() || event.defaultPrevented) {
        return;
      } // Swallow the event, in case someone is listening for the escape key on the body.


      event.stopPropagation();

      if (_this.props.onEscapeKeyDown) {
        _this.props.onEscapeKeyDown(event);
      }

      if (!_this.props.disableEscapeKeyDown && _this.props.onClose) {
        _this.props.onClose(event, 'escapeKeyDown');
      }
    };

    _this.enforceFocus = function () {
      // The Modal might not already be mounted.
      if (!_this.isTopModal() || _this.props.disableEnforceFocus || !_this.mounted || !_this.dialogRef) {
        return;
      }

      var currentActiveElement = (0, _ownerDocument.default)(_this.mountNode).activeElement;

      if (!_this.dialogRef.contains(currentActiveElement)) {
        _this.dialogRef.focus();
      }
    };

    _this.handlePortalRef = function (ref) {
      _this.mountNode = ref ? ref.getMountNode() : ref;
    };

    _this.handleModalRef = function (ref) {
      _this.modalRef = ref;
    };

    _this.onRootRef = function (ref) {
      _this.dialogRef = ref;
    };

    _this.state = {
      exited: !props.open
    };
    return _this;
  }

  (0, _createClass2.default)(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;

      if (this.props.open) {
        this.handleOpen();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.open && !this.props.open) {
        this.handleClose();
      } else if (!prevProps.open && this.props.open) {
        this.lastFocus = (0, _ownerDocument.default)(this.mountNode).activeElement;
        this.handleOpen();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;

      if (this.props.open || getHasTransition(this.props) && !this.state.exited) {
        this.handleClose('unmount');
      }
    }
  }, {
    key: "autoFocus",
    value: function autoFocus() {
      // We might render an empty child.
      if (this.props.disableAutoFocus || !this.dialogRef) {
        return;
      }

      var currentActiveElement = (0, _ownerDocument.default)(this.mountNode).activeElement;

      if (!this.dialogRef.contains(currentActiveElement)) {
        if (!this.dialogRef.hasAttribute('tabIndex')) {
           false ? (0, _warning.default)(false, ['Material-UI: the modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n')) : void 0;
          this.dialogRef.setAttribute('tabIndex', -1);
        }

        this.lastFocus = currentActiveElement;
        this.dialogRef.focus();
      }
    }
  }, {
    key: "restoreLastFocus",
    value: function restoreLastFocus() {
      if (this.props.disableRestoreFocus || !this.lastFocus) {
        return;
      } // Not all elements in IE 11 have a focus method.
      // Because IE 11 market share is low, we accept the restore focus being broken
      // and we silent the issue.


      if (this.lastFocus.focus) {
        this.lastFocus.focus();
      }

      this.lastFocus = null;
    }
  }, {
    key: "isTopModal",
    value: function isTopModal() {
      return this.props.manager.isTopModal(this);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          BackdropComponent = _this$props.BackdropComponent,
          BackdropProps = _this$props.BackdropProps,
          children = _this$props.children,
          classes = _this$props.classes,
          className = _this$props.className,
          closeAfterTransition = _this$props.closeAfterTransition,
          container = _this$props.container,
          disableAutoFocus = _this$props.disableAutoFocus,
          disableBackdropClick = _this$props.disableBackdropClick,
          disableEnforceFocus = _this$props.disableEnforceFocus,
          disableEscapeKeyDown = _this$props.disableEscapeKeyDown,
          disablePortal = _this$props.disablePortal,
          disableRestoreFocus = _this$props.disableRestoreFocus,
          hideBackdrop = _this$props.hideBackdrop,
          keepMounted = _this$props.keepMounted,
          manager = _this$props.manager,
          onBackdropClick = _this$props.onBackdropClick,
          onClose = _this$props.onClose,
          onEscapeKeyDown = _this$props.onEscapeKeyDown,
          onRendered = _this$props.onRendered,
          open = _this$props.open,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["BackdropComponent", "BackdropProps", "children", "classes", "className", "closeAfterTransition", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]);
      var exited = this.state.exited;
      var hasTransition = getHasTransition(this.props);

      if (!keepMounted && !open && (!hasTransition || exited)) {
        return null;
      }

      var childProps = {}; // It's a Transition like component

      if (hasTransition) {
        childProps.onExited = (0, _helpers.createChainedFunction)(this.handleExited, children.props.onExited);
      }

      if (children.props.role === undefined) {
        childProps.role = children.props.role || 'document';
      }

      if (children.props.tabIndex === undefined) {
        childProps.tabIndex = children.props.tabIndex || '-1';
      }

      return _react.default.createElement(_Portal.default, {
        ref: this.handlePortalRef,
        container: container,
        disablePortal: disablePortal,
        onRendered: this.handleRendered
      }, _react.default.createElement("div", (0, _extends2.default)({
        ref: this.handleModalRef,
        onKeyDown: this.handleKeyDown,
        role: "presentation",
        className: (0, _classnames.default)(classes.root, className, (0, _defineProperty2.default)({}, classes.hidden, exited))
      }, other), hideBackdrop ? null : _react.default.createElement(BackdropComponent, (0, _extends2.default)({
        open: open,
        onClick: this.handleBackdropClick
      }, BackdropProps)), _react.default.createElement(_RootRef.default, {
        rootRef: this.onRootRef
      }, _react.default.cloneElement(children, childProps))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if (nextProps.open) {
        return {
          exited: false
        };
      }

      if (!getHasTransition(nextProps)) {
        // Otherwise let handleExited take care of marking exited.
        return {
          exited: true
        };
      }

      return null;
    }
  }]);
  return Modal;
}(_react.default.Component);

 false ? Modal.propTypes = {
  /**
   * A backdrop component. This property enables custom backdrop rendering.
   */
  BackdropComponent: _utils.componentPropType,

  /**
   * Properties applied to the [`Backdrop`](/api/backdrop/) element.
   */
  BackdropProps: _propTypes.default.object,

  /**
   * A single child content element.
   */
  children: _propTypes.default.element,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   */
  closeAfterTransition: _propTypes.default.bool,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   */
  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableAutoFocus: _propTypes.default.bool,

  /**
   * If `true`, clicking the backdrop will not fire any callback.
   */
  disableBackdropClick: _propTypes.default.bool,

  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableEnforceFocus: _propTypes.default.bool,

  /**
   * If `true`, hitting escape will not fire any callback.
   */
  disableEscapeKeyDown: _propTypes.default.bool,

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: _propTypes.default.bool,

  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden.
   */
  disableRestoreFocus: _propTypes.default.bool,

  /**
   * If `true`, the backdrop is not rendered.
   */
  hideBackdrop: _propTypes.default.bool,

  /**
   * Always keep the children in the DOM.
   * This property can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   */
  keepMounted: _propTypes.default.bool,

  /**
   * @ignore
   *
   * A modal manager used to track and manage the state of open
   * Modals. This enables customizing how modals interact within a container.
   */
  manager: _propTypes.default.object,

  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback
   * @param {string} reason Can be:`"escapeKeyDown"`, `"backdropClick"`
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired when the escape key is pressed,
   * `disableEscapeKeyDown` is false and the modal is in focus.
   */
  onEscapeKeyDown: _propTypes.default.func,

  /**
   * Callback fired once the children has been mounted into the `container`.
   * It signals that the `open={true}` property took effect.
   */
  onRendered: _propTypes.default.func,

  /**
   * If `true`, the modal is open.
   */
  open: _propTypes.default.bool.isRequired
} : void 0;
Modal.defaultProps = {
  BackdropComponent: _Backdrop.default,
  closeAfterTransition: false,
  disableAutoFocus: false,
  disableBackdropClick: false,
  disableEnforceFocus: false,
  disableEscapeKeyDown: false,
  disablePortal: false,
  disableRestoreFocus: false,
  hideBackdrop: false,
  keepMounted: false,
  // Modals don't open on the server so this won't conflict with concurrent requests.
  manager: new _ModalManager.default()
};

var _default = (0, _withStyles.default)(styles, {
  flip: false,
  name: 'MuiModal'
})(Modal);

exports.default = _default;

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactDom = _interopRequireDefault(__webpack_require__(44));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _utils = __webpack_require__(14);

var _reactHelpers = __webpack_require__(70);

/**
 * Helper component to allow attaching a ref to a
 * wrapped element to access the underlying DOM element.
 *
 * It's highly inspired by https://github.com/facebook/react/issues/11401#issuecomment-340543801.
 * For example:
 * ```jsx
 * import React from 'react';
 * import RootRef from '@material-ui/core/RootRef';
 *
 * class MyComponent extends React.Component {
 *   constructor() {
 *     super();
 *     this.domRef = React.createRef();
 *   }
 *
 *   componentDidMount() {
 *     console.log(this.domRef.current); // DOM node
 *   }
 *
 *   render() {
 *     return (
 *       <RootRef rootRef={this.domRef}>
 *         <SomeChildComponent />
 *       </RootRef>
 *     );
 *   }
 * }
 * ```
 */
var RootRef =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(RootRef, _React$Component);

  function RootRef() {
    (0, _classCallCheck2.default)(this, RootRef);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RootRef).apply(this, arguments));
  }

  (0, _createClass2.default)(RootRef, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.ref = _reactDom.default.findDOMNode(this);
      (0, _reactHelpers.setRef)(this.props.rootRef, this.ref);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var ref = _reactDom.default.findDOMNode(this);

      if (prevProps.rootRef !== this.props.rootRef || this.ref !== ref) {
        if (prevProps.rootRef !== this.props.rootRef) {
          (0, _reactHelpers.setRef)(prevProps.rootRef, null);
        }

        this.ref = ref;
        (0, _reactHelpers.setRef)(this.props.rootRef, this.ref);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.ref = null;
      (0, _reactHelpers.setRef)(this.props.rootRef, null);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return RootRef;
}(_react.default.Component);

 false ? RootRef.propTypes = {
  /**
   * The wrapped element.
   */
  children: _propTypes.default.element.isRequired,

  /**
   * Provide a way to access the DOM node of the wrapped element.
   * You can provide a callback ref or a `React.createRef()` ref.
   */
  rootRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]).isRequired
} : void 0;

if (false) {
  process.env.NODE_ENV !== "production" ? RootRef.propTypes = (0, _utils.exactProp)(RootRef.propTypes) : void 0;
}

var _default = RootRef;
exports.default = _default;

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactDom = _interopRequireDefault(__webpack_require__(44));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _ownerDocument = _interopRequireDefault(__webpack_require__(93));

var _utils = __webpack_require__(14);

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom.default.findDOMNode(container) || defaultContainer;
}

function getOwnerDocument(element) {
  return (0, _ownerDocument.default)(_reactDom.default.findDOMNode(element));
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */


var Portal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Portal, _React$Component);

  function Portal() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Portal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Portal)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.getMountNode = function () {
      return _this.mountNode;
    };

    return _this;
  }

  (0, _createClass2.default)(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setMountNode(this.props.container); // Only rerender if needed

      if (!this.props.disablePortal) {
        this.forceUpdate(this.props.onRendered);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (prevProps.container !== this.props.container || prevProps.disablePortal !== this.props.disablePortal) {
        this.setMountNode(this.props.container); // Only rerender if needed

        if (!this.props.disablePortal) {
          this.forceUpdate(function () {
            if (_this2.props.onRendered) {
              // This might be triggered earlier than the componentDidUpdate of a parent element.
              // We need to account for it.
              clearTimeout(_this2.renderedTimer);
              _this2.renderedTimer = setTimeout(_this2.props.onRendered);
            }
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mountNode = null;
      clearTimeout(this.renderedTimer);
    }
  }, {
    key: "setMountNode",
    value: function setMountNode(container) {
      if (this.props.disablePortal) {
        this.mountNode = _reactDom.default.findDOMNode(this).parentElement;
        return;
      }

      this.mountNode = getContainer(container, getOwnerDocument(this).body);
    }
    /**
     * @public
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          disablePortal = _this$props.disablePortal;

      if (disablePortal) {
        return children;
      }

      return this.mountNode ? _reactDom.default.createPortal(children, this.mountNode) : null;
    }
  }]);
  return Portal;
}(_react.default.Component);

 false ? Portal.propTypes = {
  /**
   * The children to render into the `container`.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: _propTypes.default.bool,

  /**
   * Callback fired once the children has been mounted into the `container`.
   */
  onRendered: _propTypes.default.func
} : void 0;
Portal.defaultProps = {
  disablePortal: false
};

if (false) {
  process.env.NODE_ENV !== "production" ? Portal.propTypes = (0, _utils.exactProp)(Portal.propTypes) : void 0;
}

var _default = Portal;
exports.default = _default;

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = style;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(408));

var _hyphenateStyle = _interopRequireDefault(__webpack_require__(875));

var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(877));

var _removeStyle = _interopRequireDefault(__webpack_require__(878));

var _properties = __webpack_require__(879);

var _isTransform = _interopRequireDefault(__webpack_require__(880));

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];

    if (!value && value !== 0) {
      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
    } else if ((0, _isTransform.default)(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += _properties.transform + ": " + transforms + ";";
  }

  node.style.cssText += ';' + css;
}

module.exports = exports["default"];

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}

module.exports = exports["default"];

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = hyphenateStyleName;

var _hyphenate = _interopRequireDefault(__webpack_require__(876));

/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */
var msPattern = /^ms-/;

function hyphenateStyleName(string) {
  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
}

module.exports = exports["default"];

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hyphenate;
var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}

module.exports = exports["default"];

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = _getComputedStyle;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(408));

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;
  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;
      prop = (0, _camelizeStyle.default)(prop);
      if (prop == 'float') prop = 'styleFloat';
      var current = node.currentStyle[prop] || null;
      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out

        if (rsLeft) runStyle.left = node.currentStyle.left;
        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px'; // Revert the changed values

        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}

module.exports = exports["default"];

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = removeStyle;

function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}

module.exports = exports["default"];

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(409));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}

module.exports = exports["default"];

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBody = isBody;
exports.default = isOverflowing;

var _isWindow = _interopRequireDefault(__webpack_require__(882));

var _ownerDocument = _interopRequireDefault(__webpack_require__(93));

var _ownerWindow = _interopRequireDefault(__webpack_require__(197));

function isBody(node) {
  return node && node.tagName.toLowerCase() === 'body';
} // Do we have a vertical scroll bar?


function isOverflowing(container) {
  var doc = (0, _ownerDocument.default)(container);
  var win = (0, _ownerWindow.default)(doc);
  /* istanbul ignore next */

  if (!(0, _isWindow.default)(doc) && !isBody(container)) {
    return container.scrollHeight > container.clientHeight;
  } // Takes in account potential non zero margin on the body.


  var style = win.getComputedStyle(doc.body);
  var marginLeft = parseInt(style.getPropertyValue('margin-left'), 10);
  var marginRight = parseInt(style.getPropertyValue('margin-right'), 10);
  return marginLeft + doc.body.clientWidth + marginRight < win.innerWidth;
}

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getWindow;

function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}

module.exports = exports["default"];

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _Fade = _interopRequireDefault(__webpack_require__(199));

var styles = {
  /* Styles applied to the root element. */
  root: {
    zIndex: -1,
    position: 'fixed',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    // Remove grey highlight
    WebkitTapHighlightColor: 'transparent',
    // Disable scroll capabilities.
    touchAction: 'none'
  },

  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: 'transparent'
  }
};
exports.styles = styles;

function Backdrop(props) {
  var classes = props.classes,
      className = props.className,
      invisible = props.invisible,
      open = props.open,
      transitionDuration = props.transitionDuration,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "invisible", "open", "transitionDuration"]);
  return _react.default.createElement(_Fade.default, (0, _extends2.default)({
    in: open,
    timeout: transitionDuration
  }, other), _react.default.createElement("div", {
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.invisible, invisible), className),
    "aria-hidden": "true"
  }));
}

 false ? Backdrop.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   */
  invisible: _propTypes.default.bool,

  /**
   * If `true`, the backdrop is open.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })])
} : void 0;
Backdrop.defaultProps = {
  invisible: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiBackdrop'
})(Backdrop);

exports.default = _default;

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _Transition = _interopRequireDefault(__webpack_require__(137));

var _transitions = __webpack_require__(88);

var _withTheme = _interopRequireDefault(__webpack_require__(103));

var _utils = __webpack_require__(138);

// @inheritedComponent Transition
var styles = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};
/**
 * The Fade transition is used by the [Modal](/utils/modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Fade =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Fade, _React$Component);

  function Fade() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Fade);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Fade)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleEnter = function (node) {
      var theme = _this.props.theme;
      (0, _utils.reflow)(node); // So the animation always start from the start.

      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      });
      node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
      node.style.transition = theme.transitions.create('opacity', transitionProps);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    };

    _this.handleExit = function (node) {
      var theme = _this.props.theme;
      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      });
      node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
      node.style.transition = theme.transitions.create('opacity', transitionProps);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Fade, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          onEnter = _this$props.onEnter,
          onExit = _this$props.onExit,
          styleProp = _this$props.style,
          theme = _this$props.theme,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "onEnter", "onExit", "style", "theme"]);
      var style = (0, _extends2.default)({}, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
        appear: true,
        onEnter: this.handleEnter,
        onExit: this.handleExit
      }, other), function (state, childProps) {
        return _react.default.cloneElement(children, (0, _extends2.default)({
          style: (0, _extends2.default)({
            opacity: 0
          }, styles[state], style)
        }, childProps));
      });
    }
  }]);
  return Fade;
}(_react.default.Component);

 false ? Fade.propTypes = {
  /**
   * A single child content element.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),

  /**
   * If `true`, the component will transition in.
   */
  in: _propTypes.default.bool,

  /**
   * @ignore
   */
  onEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onExit: _propTypes.default.func,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })])
} : void 0;
Fade.defaultProps = {
  timeout: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

var _default = (0, _withTheme.default)()(Fade);

exports.default = _default;

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTranslateValue = setTranslateValue;
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(44));

var _reactEventListener = _interopRequireDefault(__webpack_require__(94));

var _debounce = _interopRequireDefault(__webpack_require__(125));

var _Transition = _interopRequireDefault(__webpack_require__(137));

var _ownerWindow = _interopRequireDefault(__webpack_require__(197));

var _withTheme = _interopRequireDefault(__webpack_require__(103));

var _transitions = __webpack_require__(88);

var _utils = __webpack_require__(138);

// @inheritedComponent Transition
// < 1kb payload overhead when lodash/debounce is > 3kb.
var GUTTER = 24; // Translate the node so he can't be seen on the screen.
// Later, we gonna translate back the node to his original location
// with `translate3d(0, 0, 0)`.`

function getTranslateValue(props, node) {
  var direction = props.direction;
  var rect = node.getBoundingClientRect();
  var transform;

  if (node.fakeTransform) {
    transform = node.fakeTransform;
  } else {
    var computedStyle = (0, _ownerWindow.default)(node).getComputedStyle(node);
    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
  }

  var offsetX = 0;
  var offsetY = 0;

  if (transform && transform !== 'none' && typeof transform === 'string') {
    var transformValues = transform.split('(')[1].split(')')[0].split(',');
    offsetX = parseInt(transformValues[4], 10);
    offsetY = parseInt(transformValues[5], 10);
  }

  if (direction === 'left') {
    return "translateX(100vw) translateX(-".concat(rect.left - offsetX, "px)");
  }

  if (direction === 'right') {
    return "translateX(-".concat(rect.left + rect.width + GUTTER - offsetX, "px)");
  }

  if (direction === 'up') {
    return "translateY(100vh) translateY(-".concat(rect.top - offsetY, "px)");
  } // direction === 'down'


  return "translateY(-".concat(rect.top + rect.height + GUTTER - offsetY, "px)");
}

function setTranslateValue(props, node) {
  var transform = getTranslateValue(props, node);

  if (transform) {
    node.style.webkitTransform = transform;
    node.style.transform = transform;
  }
}
/**
 * The Slide transition is used by the [Snackbar](/demos/snackbars/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */


var Slide =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Slide, _React$Component);

  function Slide() {
    var _this;

    (0, _classCallCheck2.default)(this, Slide);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Slide).call(this));
    _this.mounted = false;

    _this.handleEnter = function (node) {
      setTranslateValue(_this.props, node);
      (0, _utils.reflow)(node);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    };

    _this.handleEntering = function (node) {
      var theme = _this.props.theme;
      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      });
      node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _extends2.default)({}, transitionProps, {
        easing: theme.transitions.easing.easeOut
      }));
      node.style.transition = theme.transitions.create('transform', (0, _extends2.default)({}, transitionProps, {
        easing: theme.transitions.easing.easeOut
      }));
      node.style.webkitTransform = 'translate(0, 0)';
      node.style.transform = 'translate(0, 0)';

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    };

    _this.handleExit = function (node) {
      var theme = _this.props.theme;
      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      });
      node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _extends2.default)({}, transitionProps, {
        easing: theme.transitions.easing.sharp
      }));
      node.style.transition = theme.transitions.create('transform', (0, _extends2.default)({}, transitionProps, {
        easing: theme.transitions.easing.sharp
      }));
      setTranslateValue(_this.props, node);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.handleExited = function (node) {
      // No need for transitions when the component is hidden
      node.style.webkitTransition = '';
      node.style.transition = '';

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    if (typeof window !== 'undefined') {
      _this.handleResize = (0, _debounce.default)(function () {
        // Skip configuration where the position is screen size invariant.
        if (_this.props.in || _this.props.direction === 'down' || _this.props.direction === 'right') {
          return;
        }

        if (_this.transitionRef) {
          setTranslateValue(_this.props, _this.transitionRef);
        }
      }, 166); // Corresponds to 10 frames at 60 Hz.
    }

    return _this;
  }

  (0, _createClass2.default)(Slide, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true; // state.mounted handle SSR, once the component is mounted, we need
      // to properly hide it.

      if (!this.props.in) {
        // We need to set initial translate values of transition element
        // otherwise component will be shown when in=false.
        this.updatePosition();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.direction !== this.props.direction && !this.props.in) {
        // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        this.updatePosition();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleResize.clear();
    }
  }, {
    key: "updatePosition",
    value: function updatePosition() {
      if (this.transitionRef) {
        this.transitionRef.style.visibility = 'inherit';
        setTranslateValue(this.props, this.transitionRef);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          direction = _this$props.direction,
          onEnter = _this$props.onEnter,
          onEntering = _this$props.onEntering,
          onExit = _this$props.onExit,
          onExited = _this$props.onExited,
          styleProp = _this$props.style,
          theme = _this$props.theme,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "direction", "onEnter", "onEntering", "onExit", "onExited", "style", "theme"]);
      var style = {}; // We use this state to handle the server-side rendering.
      // We don't know the width of the children ahead of time.
      // We need to render it.

      if (!this.props.in && !this.mounted) {
        style.visibility = 'hidden';
      }

      style = (0, _extends2.default)({}, style, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
      return _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }, _react.default.createElement(_Transition.default, (0, _extends2.default)({
        onEnter: this.handleEnter,
        onEntering: this.handleEntering,
        onExit: this.handleExit,
        onExited: this.handleExited,
        appear: true,
        style: style,
        ref: function ref(_ref) {
          _this2.transitionRef = _reactDom.default.findDOMNode(_ref);
        }
      }, other), children));
    }
  }]);
  return Slide;
}(_react.default.Component);

 false ? Slide.propTypes = {
  /**
   * A single child content element.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),

  /**
   * Direction the child node will enter from.
   */
  direction: _propTypes.default.oneOf(['left', 'right', 'up', 'down']),

  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: _propTypes.default.bool,

  /**
   * @ignore
   */
  onEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onEntering: _propTypes.default.func,

  /**
   * @ignore
   */
  onExit: _propTypes.default.func,

  /**
   * @ignore
   */
  onExited: _propTypes.default.func,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })])
} : void 0;
Slide.defaultProps = {
  direction: 'down',
  timeout: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

var _default = (0, _withTheme.default)()(Slide);

exports.default = _default;

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(276);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (BrowserRouter);

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(102);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(61);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(249);

var _PathUtils = __webpack_require__(148);

var _createTransitionManager = __webpack_require__(250);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(402);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(276);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(350);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(414);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref.ariaCurrent,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        'aria-current': isActive && ariaCurrent
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  ariaCurrent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['page', 'step', 'location', 'true'])
};

NavLink.defaultProps = {
  activeClassName: 'active',
  ariaCurrent: 'true'
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(353);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(354);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(356);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(357);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(183);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(358);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _utils = __webpack_require__(14);

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _helpers = __webpack_require__(29);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _Typography = _interopRequireDefault(__webpack_require__(25));

// @inheritedComponent Typography
var styles = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the root element if `underline="none"`. */
  underlineNone: {
    textDecoration: 'none'
  },

  /* Styles applied to the root element if `underline="hover"`. */
  underlineHover: {
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  },

  /* Styles applied to the root element if `underline="always"`. */
  underlineAlways: {
    textDecoration: 'underline'
  },
  // Same reset as ButtonBase.root

  /* Styles applied to the root element if `component="button"`. */
  button: {
    position: 'relative',
    // Remove grey highlight
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 'none',
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    '-moz-appearance': 'none',
    // Reset
    '-webkit-appearance': 'none',
    // Reset
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    }
  }
};
exports.styles = styles;

function Link(props) {
  var block = props.block,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      component = props.component,
      TypographyClasses = props.TypographyClasses,
      underline = props.underline,
      other = (0, _objectWithoutProperties2.default)(props, ["block", "children", "classes", "className", "component", "TypographyClasses", "underline"]);
  return _react.default.createElement(_Typography.default, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.button, component === 'button'), classes["underline".concat((0, _helpers.capitalize)(underline))], classNameProp),
    classes: TypographyClasses,
    component: component,
    inline: !block
  }, other), children);
}

 false ? Link.propTypes = {
  /**
   *  Controls whether the link is inline or not. When `block` is true the link is not inline
   *  when `block` is false it is.
   */
  block: _propTypes.default.bool,

  /**
   * The content of the link.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the link.
   */
  color: _propTypes.default.oneOf(['error', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * `classes` property applied to the [`Typography`](/api/typography/) element.
   */
  TypographyClasses: _propTypes.default.object,

  /**
   *  Controls when the link should have an underline.
   */
  underline: _propTypes.default.oneOf(['none', 'hover', 'always']),

  /**
   * Applies the theme typography styles.
   */
  variant: _propTypes.default.string
} : void 0;
Link.defaultProps = {
  block: false,
  color: 'primary',
  component: 'a',
  underline: 'hover',
  variant: 'inherit'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiLink'
})(Link);

exports.default = _default;

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(44));

var _warning = _interopRequireDefault(__webpack_require__(27));

var _ownerDocument = _interopRequireDefault(__webpack_require__(93));

var _List = _interopRequireDefault(__webpack_require__(416));

// @inheritedComponent List
var MenuList =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(MenuList, _React$Component);

  function MenuList() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, MenuList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(MenuList)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      currentTabIndex: null
    };

    _this.handleBlur = function (event) {
      _this.blurTimer = setTimeout(function () {
        if (_this.listRef) {
          var list = _this.listRef;
          var currentFocus = (0, _ownerDocument.default)(list).activeElement;

          if (!list.contains(currentFocus)) {
            _this.resetTabIndex();
          }
        }
      }, 30);

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    };

    _this.handleKeyDown = function (event) {
      var list = _this.listRef;
      var key = event.key;
      var currentFocus = (0, _ownerDocument.default)(list).activeElement;

      if ((key === 'ArrowUp' || key === 'ArrowDown') && (!currentFocus || currentFocus && !list.contains(currentFocus))) {
        if (_this.selectedItemRef) {
          _this.selectedItemRef.focus();
        } else {
          list.firstChild.focus();
        }
      } else if (key === 'ArrowDown') {
        event.preventDefault();

        if (currentFocus.nextElementSibling) {
          currentFocus.nextElementSibling.focus();
        } else if (!_this.props.disableListWrap) {
          list.firstChild.focus();
        }
      } else if (key === 'ArrowUp') {
        event.preventDefault();

        if (currentFocus.previousElementSibling) {
          currentFocus.previousElementSibling.focus();
        } else if (!_this.props.disableListWrap) {
          list.lastChild.focus();
        }
      } else if (key === 'Home') {
        event.preventDefault();
        list.firstChild.focus();
      } else if (key === 'End') {
        event.preventDefault();
        list.lastChild.focus();
      }

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(event);
      }
    };

    _this.handleItemFocus = function (event) {
      var list = _this.listRef;

      if (list) {
        for (var i = 0; i < list.children.length; i += 1) {
          if (list.children[i] === event.currentTarget) {
            _this.setTabIndex(i);

            break;
          }
        }
      }
    };

    return _this;
  }

  (0, _createClass2.default)(MenuList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.resetTabIndex();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.blurTimer);
    }
  }, {
    key: "setTabIndex",
    value: function setTabIndex(index) {
      this.setState({
        currentTabIndex: index
      });
    }
  }, {
    key: "focus",
    value: function focus() {
      var currentTabIndex = this.state.currentTabIndex;
      var list = this.listRef;

      if (!list || !list.children || !list.firstChild) {
        return;
      }

      if (currentTabIndex && currentTabIndex >= 0) {
        list.children[currentTabIndex].focus();
      } else {
        list.firstChild.focus();
      }
    }
  }, {
    key: "resetTabIndex",
    value: function resetTabIndex() {
      var list = this.listRef;
      var currentFocus = (0, _ownerDocument.default)(list).activeElement;
      var items = [];

      for (var i = 0; i < list.children.length; i += 1) {
        items.push(list.children[i]);
      }

      var currentFocusIndex = items.indexOf(currentFocus);

      if (currentFocusIndex !== -1) {
        return this.setTabIndex(currentFocusIndex);
      }

      if (this.selectedItemRef) {
        return this.setTabIndex(items.indexOf(this.selectedItemRef));
      }

      return this.setTabIndex(0);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          onBlur = _this$props.onBlur,
          onKeyDown = _this$props.onKeyDown,
          disableListWrap = _this$props.disableListWrap,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "onBlur", "onKeyDown", "disableListWrap"]);
      return _react.default.createElement(_List.default, (0, _extends2.default)({
        role: "menu",
        ref: function ref(_ref) {
          _this2.listRef = _reactDom.default.findDOMNode(_ref);
        },
        className: className,
        onKeyDown: this.handleKeyDown,
        onBlur: this.handleBlur
      }, other), _react.default.Children.map(children, function (child, index) {
        if (!_react.default.isValidElement(child)) {
          return null;
        }

         false ? (0, _warning.default)(child.type !== _react.default.Fragment, ["Material-UI: the MenuList component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n')) : void 0;
        return _react.default.cloneElement(child, {
          tabIndex: index === _this2.state.currentTabIndex ? 0 : -1,
          ref: child.props.selected ? function (ref) {
            _this2.selectedItemRef = _reactDom.default.findDOMNode(ref);
          } : undefined,
          onFocus: _this2.handleItemFocus
        });
      }));
    }
  }]);
  return MenuList;
}(_react.default.Component);

 false ? MenuList.propTypes = {
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the menu items will not wrap focus.
   */
  disableListWrap: _propTypes.default.bool,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyDown: _propTypes.default.func
} : void 0;
MenuList.defaultProps = {
  disableListWrap: false
};
var _default = MenuList;
exports.default = _default;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _ListContext = _interopRequireDefault(__webpack_require__(201));

var styles = {
  /* Styles applied to the root element. */
  root: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative'
  },

  /* Styles applied to the root element if `disablePadding={false}`. */
  padding: {
    paddingTop: 8,
    paddingBottom: 8
  },

  /* Styles applied to the root element if `dense={true}` & `disablePadding={false}`. */
  dense: {
    paddingTop: 4,
    paddingBottom: 4
  },

  /* Styles applied to the root element if a `subheader` is provided. */
  subheader: {
    paddingTop: 0
  }
};
exports.styles = styles;

function List(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      className = props.className,
      Component = props.component,
      dense = props.dense,
      disablePadding = props.disablePadding,
      subheader = props.subheader,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.dense, dense && !disablePadding), (0, _defineProperty2.default)(_classNames, classes.padding, !disablePadding), (0, _defineProperty2.default)(_classNames, classes.subheader, subheader), _classNames), className)
  }, other), _react.default.createElement(_ListContext.default.Provider, {
    value: {
      dense: dense
    }
  }, subheader, children));
}

 false ? List.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
   * the list and list items. The property is available to descendant components as the
   * `dense` context.
   */
  dense: _propTypes.default.bool,

  /**
   * If `true`, vertical padding will be removed from the list.
   */
  disablePadding: _propTypes.default.bool,

  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: _propTypes.default.node
} : void 0;
List.defaultProps = {
  component: 'ul',
  dense: false,
  disablePadding: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiList'
})(List);

exports.default = _default;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _ListItem = _interopRequireDefault(__webpack_require__(417));

// @inheritedComponent ListItem
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0, _extends2.default)({}, theme.typography.subheading, {
      height: 24,
      boxSizing: 'content-box',
      width: 'auto',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      '&$selected': {}
    }),

    /* Styles applied to the root element if `disableGutters={false}`. */
    gutters: {
      paddingLeft: 16,
      paddingRight: 16
    },

    /* Styles applied to the root element if `selected={true}`. */
    selected: {}
  };
};

exports.styles = styles;

function MenuItem(props) {
  var _classNames;

  var classes = props.classes,
      className = props.className,
      component = props.component,
      disableGutters = props.disableGutters,
      role = props.role,
      selected = props.selected,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "disableGutters", "role", "selected"]);
  return _react.default.createElement(_ListItem.default, (0, _extends2.default)({
    button: true,
    role: role,
    tabIndex: -1,
    component: component,
    selected: selected,
    disableGutters: disableGutters,
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.selected, selected), (0, _defineProperty2.default)(_classNames, classes.gutters, !disableGutters), _classNames), className)
  }, other));
}

 false ? MenuItem.propTypes = {
  /**
   * Menu item contents.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * If `true`, the left and right padding is removed.
   */
  disableGutters: _propTypes.default.bool,

  /**
   * @ignore
   */
  role: _propTypes.default.string,

  /**
   * @ignore
   */
  selected: _propTypes.default.bool
} : void 0;
MenuItem.defaultProps = {
  component: 'li',
  disableGutters: false,
  role: 'menuitem'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiMenuItem'
})(MenuItem);

exports.default = _default;

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _ButtonBase = _interopRequireDefault(__webpack_require__(64));

var _reactHelpers = __webpack_require__(70);

var _MergeListContext = _interopRequireDefault(__webpack_require__(902));

var styles = function styles(theme) {
  return {
    /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      position: 'relative',
      textDecoration: 'none',
      width: '100%',
      boxSizing: 'border-box',
      textAlign: 'left',
      paddingTop: 11,
      // To use 10px in v4
      paddingBottom: 11,
      // To use 10px in v4
      '&$selected, &$selected:hover, &$selected:focus': {
        backgroundColor: theme.palette.action.selected
      }
    },

    /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */
    container: {
      position: 'relative'
    },
    // To remove in v4

    /* Styles applied to the `component`'s `focusVisibleClassName` property if `button={true}`. */
    focusVisible: {},

    /* Legacy styles applied to the root element. Use `root` instead. */
    default: {},

    /* Styles applied to the `component` element if `dense={true}` or `children` includes `Avatar`. */
    dense: {
      paddingTop: 8,
      paddingBottom: 8
    },

    /* Styles applied to the `component` element if `alignItems="flex-start"`. */
    alignItemsFlexStart: {
      alignItems: 'flex-start'
    },

    /* Styles applied to the inner `component` element if `disabled={true}`. */
    disabled: {
      opacity: 0.5
    },

    /* Styles applied to the inner `component` element if `divider={true}`. */
    divider: {
      borderBottom: "1px solid ".concat(theme.palette.divider),
      backgroundClip: 'padding-box'
    },

    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: {
      paddingLeft: 16,
      paddingRight: 16
    },

    /* Styles applied to the inner `component` element if `button={true}`. */
    button: {
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: theme.palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&:focus': {
        backgroundColor: theme.palette.action.hover
      }
    },

    /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */
    secondaryAction: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 32
    },

    /* Styles applied to the root element if `selected={true}`. */
    selected: {}
  };
};
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */


exports.styles = styles;

function ListItem(props) {
  var alignItems = props.alignItems,
      button = props.button,
      childrenProp = props.children,
      classes = props.classes,
      classNameProp = props.className,
      componentProp = props.component,
      ContainerComponent = props.ContainerComponent,
      _props$ContainerProps = props.ContainerProps;
  _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;
  var ContainerClassName = _props$ContainerProps.className,
      ContainerProps = (0, _objectWithoutProperties2.default)(_props$ContainerProps, ["className"]),
      denseProp = props.dense,
      disabled = props.disabled,
      disableGutters = props.disableGutters,
      divider = props.divider,
      focusVisibleClassName = props.focusVisibleClassName,
      selected = props.selected,
      other = (0, _objectWithoutProperties2.default)(props, ["alignItems", "button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName", "selected"]);
  return _react.default.createElement(_MergeListContext.default, {
    dense: denseProp,
    alignItems: alignItems
  }, function (_ref) {
    var _classNames;

    var dense = _ref.dense;

    var children = _react.default.Children.toArray(childrenProp);

    var hasAvatar = children.some(function (value) {
      return (0, _reactHelpers.isMuiElement)(value, ['ListItemAvatar']);
    });
    var hasSecondaryAction = children.length && (0, _reactHelpers.isMuiElement)(children[children.length - 1], ['ListItemSecondaryAction']);
    var className = (0, _classnames.default)(classes.root, classes.default, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.dense, dense || hasAvatar), (0, _defineProperty2.default)(_classNames, classes.gutters, !disableGutters), (0, _defineProperty2.default)(_classNames, classes.divider, divider), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.button, button), (0, _defineProperty2.default)(_classNames, classes.alignItemsFlexStart, alignItems === 'flex-start'), (0, _defineProperty2.default)(_classNames, classes.secondaryAction, hasSecondaryAction), (0, _defineProperty2.default)(_classNames, classes.selected, selected), _classNames), classNameProp);
    var componentProps = (0, _extends2.default)({
      className: className,
      disabled: disabled
    }, other);
    var Component = componentProp || 'li';

    if (button) {
      componentProps.component = componentProp || 'div';
      componentProps.focusVisibleClassName = (0, _classnames.default)(classes.focusVisible, focusVisibleClassName);
      Component = _ButtonBase.default;
    }

    if (hasSecondaryAction) {
      // Use div by default.
      Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.

      if (ContainerComponent === 'li') {
        if (Component === 'li') {
          Component = 'div';
        } else if (componentProps.component === 'li') {
          componentProps.component = 'div';
        }
      }

      return _react.default.createElement(ContainerComponent, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.container, ContainerClassName)
      }, ContainerProps), _react.default.createElement(Component, componentProps, children), children.pop());
    }

    return _react.default.createElement(Component, componentProps, children);
  });
}

 false ? ListItem.propTypes = {
  /**
   * Defines the `align-items` style property.
   */
  alignItems: _propTypes.default.oneOf(['flex-start', 'center']),

  /**
   * If `true`, the list item will be a button (using `ButtonBase`).
   */
  button: _propTypes.default.bool,

  /**
   * The content of the component. If a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: (0, _utils.chainPropTypes)(_propTypes.default.node, function (props) {
    var children = _react.default.Children.toArray(props.children); // React.Children.toArray(props.children).findLastIndex(isListItemSecondaryAction)


    var secondaryActionIndex = -1;

    for (var i = children.length - 1; i >= 0; i -= 1) {
      var child = children[i];

      if ((0, _reactHelpers.isMuiElement)(child, ['ListItemSecondaryAction'])) {
        secondaryActionIndex = i;
        break;
      }
    } //  is ListItemSecondaryAction the last child of ListItem


    if (secondaryActionIndex !== -1 && secondaryActionIndex !== children.length - 1) {
      return new Error('Material-UI: you used an element after ListItemSecondaryAction. ' + 'For ListItem to detect that it has a secondary action ' + "you must pass it has the last children to ListItem.".concat(process.env.NODE_ENV === 'test' ? Date.now() : ''));
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * By default, it's a `li` when `button` is `false` and a `div` when `button` is `true`.
   */
  component: _utils.componentPropType,

  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   */
  ContainerComponent: _utils.componentPropType,

  /**
   * Properties applied to the container component if used.
   */
  ContainerProps: _propTypes.default.object,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
   */
  dense: _propTypes.default.bool,

  /**
   * If `true`, the list item will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the left and right padding is removed.
   */
  disableGutters: _propTypes.default.bool,

  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   */
  divider: _propTypes.default.bool,

  /**
   * @ignore
   */
  focusVisibleClassName: _propTypes.default.string,

  /**
   * Use to apply selected styling.
   */
  selected: _propTypes.default.bool
} : void 0;
ListItem.defaultProps = {
  alignItems: 'center',
  button: false,
  ContainerComponent: 'li',
  dense: false,
  disabled: false,
  disableGutters: false,
  divider: false,
  selected: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiListItem'
})(ListItem);

exports.default = _default;

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _ListContext = _interopRequireDefault(__webpack_require__(201));

/**
 * @ignore - internal component.
 *
 * Consumes a context and passes that context merged with its props.
 */
function MergeListContext(props) {
  var alignItems = props.alignItems,
      children = props.children,
      dense = props.dense;
  return _react.default.createElement(_ListContext.default.Consumer, null, function (context) {
    var childContext = {
      dense: dense || context.dense || false,
      alignItems: alignItems
    };
    return _react.default.createElement(_ListContext.default.Provider, {
      value: childContext
    }, children(childContext));
  });
}

 false ? MergeListContext.propTypes = {
  alignItems: _propTypes.default.oneOf(['flex-start', 'center']).isRequired,
  children: _propTypes.default.func.isRequired,
  dense: _propTypes.default.bool.isRequired
} : void 0;
var _default = MergeListContext;
exports.default = _default;

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _colorManipulator = __webpack_require__(81);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      height: 1,
      margin: 0,
      // Reset browser default style.
      border: 'none',
      flexShrink: 0,
      backgroundColor: theme.palette.divider
    },

    /* Styles applied to the root element if `absolute={true}`. */
    absolute: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%'
    },

    /* Styles applied to the root element if `variant="inset"`. */
    inset: {
      marginLeft: 72
    },

    /* Styles applied to the root element if `light={true}`. */
    light: {
      backgroundColor: (0, _colorManipulator.fade)(theme.palette.divider, 0.08)
    },

    /* Styles applied to the root element if `variant="middle"`. */
    middle: {
      marginLeft: theme.spacing.unit * 2,
      marginRight: theme.spacing.unit * 2
    }
  };
};

exports.styles = styles;

function Divider(props) {
  var _classNames;

  var absolute = props.absolute,
      classes = props.classes,
      className = props.className,
      Component = props.component,
      inset = props.inset,
      light = props.light,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["absolute", "classes", "className", "component", "inset", "light", "variant"]);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.inset, inset || variant === 'inset'), (0, _defineProperty2.default)(_classNames, classes.middle, variant === 'middle'), (0, _defineProperty2.default)(_classNames, classes.absolute, absolute), (0, _defineProperty2.default)(_classNames, classes.light, light), _classNames), className)
  }, other));
}

 false ? Divider.propTypes = {
  /**
   * Absolutely position the element.
   */
  absolute: _propTypes.default.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * If `true`, the divider will be indented.
   * __WARNING__: `inset` is deprecated.
   * Instead use `variant="inset"`.
   */
  inset: (0, _utils.chainPropTypes)(_propTypes.default.bool, function (props) {
    /* istanbul ignore if */
    if (props.inset) {
      return new Error('Material-UI: you are using the deprecated `inset` property ' + 'that will be removed in the next major release. The property `variant="inset"` ' + 'is equivalent and should be used instead.');
    }

    return null;
  }),

  /**
   * If `true`, the divider will have a lighter color.
   */
  light: _propTypes.default.bool,

  /**
   *  The variant to use.
   */
  variant: _propTypes.default.oneOf(['fullWidth', 'inset', 'middle'])
} : void 0;
Divider.defaultProps = {
  absolute: false,
  component: 'hr',
  light: false,
  variant: 'fullWidth'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDivider'
})(Divider);

exports.default = _default;

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(905));

var _react = __webpack_require__(1);

var _setDisplayName = _interopRequireDefault(__webpack_require__(421));

var _wrapDisplayName = _interopRequireDefault(__webpack_require__(422));

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);

    var ShouldUpdate =
    /*#__PURE__*/
    function (_Component) {
      (0, _inheritsLoose2.default)(ShouldUpdate, _Component);

      function ShouldUpdate() {
        return _Component.apply(this, arguments) || this;
      }

      var _proto = ShouldUpdate.prototype;

      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      _proto.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(_react.Component);

    if (false) {
      return (0, _setDisplayName.default)((0, _wrapDisplayName.default)(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }

    return ShouldUpdate;
  };
};

var _default = shouldUpdate;
exports.default = _default;

/***/ }),
/* 905 */
/***/ (function(module, exports) {

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */

    return BaseComponent;
  };
};

var _default = setStatic;
exports.default = _default;

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

var _default = getDisplayName;
exports.default = _default;

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _shallowEqual = _interopRequireDefault(__webpack_require__(340));

var _default = _shallowEqual.default;
exports.default = _default;

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _helpers = __webpack_require__(29);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fill: 'currentColor',
      flexShrink: 0,
      fontSize: 24,
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      })
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },

    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: 'inherit'
    },

    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: 20
    },

    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: 35
    }
  };
};

exports.styles = styles;

function SvgIcon(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      className = props.className,
      color = props.color,
      Component = props.component,
      fontSize = props.fontSize,
      nativeColor = props.nativeColor,
      titleAccess = props.titleAccess,
      viewBox = props.viewBox,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "fontSize", "nativeColor", "titleAccess", "viewBox"]);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), (0, _defineProperty2.default)(_classNames, classes["fontSize".concat((0, _helpers.capitalize)(fontSize))], fontSize !== 'default'), _classNames), className),
    focusable: "false",
    viewBox: viewBox,
    color: nativeColor,
    "aria-hidden": titleAccess ? 'false' : 'true',
    role: titleAccess ? 'img' : 'presentation'
  }, other), children, titleAccess ? _react.default.createElement("title", null, titleAccess) : null);
}

 false ? SvgIcon.propTypes = {
  /**
   * Node passed into the SVG element.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `nativeColor` property to apply a color attribute to the SVG element.
   */
  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary', 'action', 'error', 'disabled']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: _propTypes.default.oneOf(['inherit', 'default', 'small', 'large']),

  /**
   * Applies a color attribute to the SVG element.
   */
  nativeColor: _propTypes.default.string,

  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this property.
   */
  shapeRendering: _propTypes.default.string,

  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: _propTypes.default.string,

  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: _propTypes.default.string
} : void 0;
SvgIcon.defaultProps = {
  color: 'inherit',
  component: 'svg',
  fontSize: 'default',
  viewBox: '0 0 24 24'
};
SvgIcon.muiName = 'SvgIcon';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiSvgIcon'
})(SvgIcon);

exports.default = _default;

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Button__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_CircularProgress__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_validator_lib_isEmail__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_validator_lib_isEmail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_validator_lib_isEmail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_redux_modules_companies__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_routes__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_TeamMembersAvatars_svg__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_TeamMembersAvatars_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_TeamMembersAvatars_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_theme_uiConfig__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_i18n_i18n__ = __webpack_require__(15);
var _dec,_class;/**
 * The onboarding step that allows to invite a company members
 */var localize=__WEBPACK_IMPORTED_MODULE_22_i18n_i18n__["a" /* default */].loc.localize;var styles={root:{flexGrow:'1',display:'flex',flexDirection:'column',alignItems:'center'},avatars:{width:332,height:52,margin:'40px 0 25px',background:"no-repeat url(".concat(__WEBPACK_IMPORTED_MODULE_20__assets_TeamMembersAvatars_svg___default.a,") center")},title:{fontWeight:'bold',marginBottom:63},fields:{display:'flex',flexDirection:'column',marginBottom:20},field:{margin:'0 auto 10px'},navigation:{marginTop:'auto',display:'flex',flexDirection:'column',paddingTop:20}};var ValidationSchema={email:function email(value){if(value&&!__WEBPACK_IMPORTED_MODULE_14_validator_lib_isEmail___default()(value)){return localize('onboarding-members-email-invalid');}},duplicate:function duplicate(duplicatedIndices,currentIndex){if(duplicatedIndices.indexOf(currentIndex)!==-1){return localize('onboarding-members-email-duplicate');}}};var DEFAULT_NUMBER_OF_FIELDS=3;var MAX_NUMBER_OF_FIELDS=8;var TeamMembersStep=(_dec=Object(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(TeamMembersStep,_Component);function TeamMembersStep(){var _this;__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this,TeamMembersStep);_this=__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(TeamMembersStep).call(this));_this.onFieldAdd=_this.onFieldAdd.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.onSave=_this.onSave.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.onStepSkipped=_this.onStepSkipped.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.validateFields=Object(__WEBPACK_IMPORTED_MODULE_19_lodash__["debounce"])(_this.validateFields.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)),__WEBPACK_IMPORTED_MODULE_21_theme_uiConfig__["g" /* typingDebounceTimeout */]);_this.state={saving:false,valid:false,values:Object(__WEBPACK_IMPORTED_MODULE_19_lodash__["fill"])(Array(DEFAULT_NUMBER_OF_FIELDS),''),errors:Object(__WEBPACK_IMPORTED_MODULE_19_lodash__["fill"])(Array(DEFAULT_NUMBER_OF_FIELDS),'')};return _this;}__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(TeamMembersStep,[{key:"render",value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{className:classes.root},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{className:classes.avatars}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:"h3",align:"center",className:classes.title,gutterBottom:true},localize('onboarding-members-title')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{className:classes.fields},this.renderFields()),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Button___default.a,{variant:"contained",color:"primary","data-tid":"button-add-more-members",onClick:this.onFieldAdd,disabled:this.state.values.length===MAX_NUMBER_OF_FIELDS},localize('onboarding-members-add-more')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{className:classes.navigation},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Button___default.a,{variant:"contained",size:"large","data-tid":"button-team-members-step-next",color:"primary",onClick:this.onSave,disabled:!this.state.valid||this.state.saving},this.state.saving?__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_CircularProgress___default.a,{size:26,color:"inherit"}):localize('onboarding-members-next')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Button___default.a,{disableRipple:true,"data-tid":"button-add-more-members-skip",onClick:this.onStepSkipped,size:"small"},localize('onboarding-members-skip'))));}},{key:"renderFields",value:function renderFields(){var _this2=this;var classes=this.props.classes;var _this$state=this.state,values=_this$state.values,errors=_this$state.errors;return values.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a,{key:"email-".concat(index),type:"email",placeholder:localize('onboarding-members-email-placeholder'),className:classes.field,value:value,onChange:_this2.onFieldChange(index),helperText:errors[index],error:!!errors[index],InputProps:{disableUnderline:true},inputProps:{'data-tid':"input-invite-email-address-".concat(index)},autoComplete:"new-password"});});}},{key:"onFieldChange",value:function onFieldChange(index){var _this3=this;return function(event){var value=event.target.value;var values=__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(_this3.state.values);values[index]=value;_this3.setState({values:values,valid:false},function(){return _this3.validateFields();});};}},{key:"onFieldAdd",value:function onFieldAdd(){if(this.state.values.length<=MAX_NUMBER_OF_FIELDS){this.setState({values:[].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(this.state.values),['']),errors:[].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(this.state.errors),[''])});}}},{key:"onSave",value:function onSave(){var _this4=this;if(this.state.valid){var members=[];var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=this.state.values[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var value=_step.value;if(value&&value.length>2){members.push({email:value,role:'basic'});}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator["return"]!=null){_iterator["return"]();}}finally{if(_didIteratorError){throw _iteratorError;}}}if(members.length){var _this$props;this.setState({saving:true});(_this$props=this.props).addCompanyUsers.apply(_this$props,members).then(function(){_this4.props.onboarding.fulfillStep();});}}}},{key:"onStepSkipped",value:function onStepSkipped(){this.props.onboarding.skipStep();}},{key:"validateFields",value:function validateFields(){var values=this.state.values;/*
			Map is an object where keys are field values and values are arrays of the indexes:
			{
				'email@example.net': [0, 2],
				'test@xara.com': [1]
			}
			This means there are 3 fields, where the 1st and 3rd fields have same value:
				email@example.net
				test@xara.com
				email@example.net
		*/var map=values.reduce(function(accumulator,value,index){value&&(accumulator[value]=[].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(accumulator[value]||[]),[index]));return accumulator;},{});// Filters map object by checking duplicates and creates a flat array of duplicated indices
var duplicatedIndices=Object(__WEBPACK_IMPORTED_MODULE_19_lodash__["flatten"])(Object.values(map).filter(function(value){return value.length>1;}));var errors=values.map(function(value,index){var formatError=ValidationSchema.email(value);var duplicateError=ValidationSchema.duplicate(duplicatedIndices,index);// Set errors for non-empty field
if(value.length){if(formatError){return formatError;}else if(duplicateError){return duplicateError;}}return'';});this.setState({errors:errors,valid:this.areValid(errors)});}},{key:"areValid",value:function areValid(errors){var values=this.state.values;return errors.filter(function(error){return error;}).length===0&&values.filter(function(value){return value;}).length>0;}}]);return TeamMembersStep;}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]))||_class);TeamMembersStep.propTypes={classes:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,onboarding:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,addCompanyUsers:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func};TeamMembersStep.oId='team-members';TeamMembersStep.oTitle=localize('onboarding-members-o-title');TeamMembersStep.oMessage=localize('onboarding-members-o-message');TeamMembersStep.oRoute=__WEBPACK_IMPORTED_MODULE_18_routes__["t" /* USERS */];var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_16_redux__["b" /* bindActionCreators */])({addCompanyUsers:__WEBPACK_IMPORTED_MODULE_15_redux_modules_companies__["b" /* addCompanyUsers */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_17_react_redux__["b" /* connect */])(undefined,mapDispatchToProps)(TeamMembersStep));

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactDom = _interopRequireDefault(__webpack_require__(44));

var _warning = _interopRequireDefault(__webpack_require__(27));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _Input = _interopRequireDefault(__webpack_require__(205));

var _FilledInput = _interopRequireDefault(__webpack_require__(423));

var _OutlinedInput = _interopRequireDefault(__webpack_require__(424));

var _InputLabel = _interopRequireDefault(__webpack_require__(425));

var _FormControl = _interopRequireDefault(__webpack_require__(427));

var _FormHelperText = _interopRequireDefault(__webpack_require__(161));

var _Select = _interopRequireDefault(__webpack_require__(104));

// @inheritedComponent FormControl
var variantComponent = {
  standard: _Input.default,
  filled: _FilledInput.default,
  outlined: _OutlinedInput.default
};
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 * - [FormControl](/api/form-control/)
 * - [InputLabel](/api/input-label/)
 * - [Input](/api/input/)
 * - [FormHelperText](/api/form-helper-text/)
 *
 * If you wish to alter the properties applied to the native input, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */

var TextField =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(TextField, _React$Component);

  function TextField(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TextField);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TextField).call(this, props));
    _this.labelRef = _react.default.createRef();
    return _this;
  }

  (0, _createClass2.default)(TextField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.variant === 'outlined') {
        this.labelNode = _reactDom.default.findDOMNode(this.labelRef.current);
        this.forceUpdate();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          autoComplete = _this$props.autoComplete,
          autoFocus = _this$props.autoFocus,
          children = _this$props.children,
          className = _this$props.className,
          defaultValue = _this$props.defaultValue,
          error = _this$props.error,
          FormHelperTextProps = _this$props.FormHelperTextProps,
          fullWidth = _this$props.fullWidth,
          helperText = _this$props.helperText,
          id = _this$props.id,
          InputLabelProps = _this$props.InputLabelProps,
          inputProps = _this$props.inputProps,
          InputProps = _this$props.InputProps,
          inputRef = _this$props.inputRef,
          label = _this$props.label,
          multiline = _this$props.multiline,
          name = _this$props.name,
          onBlur = _this$props.onBlur,
          onChange = _this$props.onChange,
          onFocus = _this$props.onFocus,
          placeholder = _this$props.placeholder,
          required = _this$props.required,
          rows = _this$props.rows,
          rowsMax = _this$props.rowsMax,
          select = _this$props.select,
          SelectProps = _this$props.SelectProps,
          type = _this$props.type,
          value = _this$props.value,
          variant = _this$props.variant,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["autoComplete", "autoFocus", "children", "className", "defaultValue", "error", "FormHelperTextProps", "fullWidth", "helperText", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "rowsMax", "select", "SelectProps", "type", "value", "variant"]);
       false ? (0, _warning.default)(!select || Boolean(children), 'Material-UI: `children` must be passed when using the `TextField` component with `select`.') : void 0;
      var InputMore = {};

      if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') {
          InputMore.notched = InputLabelProps.shrink;
        }

        InputMore.labelWidth = this.labelNode && this.labelNode.offsetWidth || 0;
      }

      var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
      var InputComponent = variantComponent[variant];

      var InputElement = _react.default.createElement(InputComponent, (0, _extends2.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        rowsMax: rowsMax,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
      }, InputMore, InputProps));

      return _react.default.createElement(_FormControl.default, (0, _extends2.default)({
        className: className,
        error: error,
        fullWidth: fullWidth,
        required: required,
        variant: variant
      }, other), label && _react.default.createElement(_InputLabel.default, (0, _extends2.default)({
        htmlFor: id,
        ref: this.labelRef
      }, InputLabelProps), label), select ? _react.default.createElement(_Select.default, (0, _extends2.default)({
        "aria-describedby": helperTextId,
        value: value,
        input: InputElement
      }, SelectProps), children) : InputElement, helperText && _react.default.createElement(_FormHelperText.default, (0, _extends2.default)({
        id: helperTextId
      }, FormHelperTextProps), helperText));
    }
  }]);
  return TextField;
}(_react.default.Component);

 false ? TextField.propTypes = {
  /**
   * This property helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it here:
   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
   */
  autoComplete: _propTypes.default.string,

  /**
   * If `true`, the input will be focused during the first mount.
   */
  autoFocus: _propTypes.default.bool,

  /**
   * @ignore
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The default value of the `Input` element.
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * If `true`, the input will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: _propTypes.default.bool,

  /**
   * Properties applied to the [`FormHelperText`](/api/form-helper-text/) element.
   */
  FormHelperTextProps: _propTypes.default.object,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The helper text content.
   */
  helperText: _propTypes.default.node,

  /**
   * The id of the `input` element.
   * Use this property to make `label` and `helperText` accessible for screen readers.
   */
  id: _propTypes.default.string,

  /**
   * Properties applied to the [`InputLabel`](/api/input-label/) element.
   */
  InputLabelProps: _propTypes.default.object,

  /**
   * Properties applied to the `Input` element.
   */
  InputProps: _propTypes.default.object,

  /**
   * Attributes applied to the native `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use this property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * The label content.
   */
  label: _propTypes.default.node,

  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: _propTypes.default.oneOf(['none', 'dense', 'normal']),

  /**
   * If `true`, a textarea element will be rendered instead of an input.
   */
  multiline: _propTypes.default.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _propTypes.default.string,

  /**
   * If `true`, the label is displayed as required and the input will be required.
   */
  required: _propTypes.default.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Render a `Select` element while passing the `Input` element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   */
  select: _propTypes.default.bool,

  /**
   * Properties applied to the [`Select`](/api/select/) element.
   */
  SelectProps: _propTypes.default.object,

  /**
   * Type attribute of the `Input` element. It should be a valid HTML5 input type.
   */
  type: _propTypes.default.string,

  /**
   * The value of the `Input` element, required for a controlled component.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]))]),

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
TextField.defaultProps = {
  required: false,
  select: false,
  variant: 'standard'
};
var _default = TextField;
exports.default = _default;

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _InputBase = _interopRequireDefault(__webpack_require__(160));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

// @inheritedComponent InputBase
var styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative'
    },

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      'label + &': {
        marginTop: 16
      }
    },

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `disableUnderline={false}`. */
    underline: {
      '&:after': {
        borderBottom: "2px solid ".concat(theme.palette.primary[light ? 'dark' : 'light']),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.main,
        transform: 'scaleX(1)' // error is always underlined in red

      },
      '&:before': {
        borderBottom: "1px solid ".concat(bottomLineColor),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('border-bottom-color', {
          duration: theme.transitions.duration.shorter
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&:hover:not($disabled):not($focused):not($error):before': {
        borderBottom: "2px solid ".concat(theme.palette.text.primary),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          borderBottom: "1px solid ".concat(bottomLineColor)
        }
      },
      '&$disabled:before': {
        borderBottomStyle: 'dotted'
      }
    },

    /* Styles applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {},

    /* Styles applied to the `input` element. */
    input: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {},

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {},

    /* Styles applied to the `input` element if `type` is not "text"`. */
    inputType: {},

    /* Styles applied to the `input` element if `type="search"`. */
    inputTypeSearch: {}
  };
};

exports.styles = styles;

function Input(props) {
  var disableUnderline = props.disableUnderline,
      classes = props.classes,
      other = (0, _objectWithoutProperties2.default)(props, ["disableUnderline", "classes"]);
  return _react.default.createElement(_InputBase.default, (0, _extends2.default)({
    classes: (0, _extends2.default)({}, classes, {
      root: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.underline, !disableUnderline)),
      underline: null
    })
  }, other));
}

 false ? Input.propTypes = {
  /**
   * This property helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it here:
   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
   */
  autoComplete: _propTypes.default.string,

  /**
   * If `true`, the input will be focused during the first mount.
   */
  autoFocus: _propTypes.default.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The CSS class name of the wrapper element.
   */
  className: _propTypes.default.string,

  /**
   * The default input value, useful when not controlling the component.
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.object, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.object]))]),

  /**
   * If `true`, the input will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: _propTypes.default.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: _propTypes.default.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,

  /**
   * The component used for the native input.
   * Either a string to use a DOM element or a component.
   */
  inputComponent: _utils.componentPropType,

  /**
   * Attributes applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes.default.oneOf(['dense', 'none']),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: _propTypes.default.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes.default.string,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes.default.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _propTypes.default.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: _propTypes.default.bool,

  /**
   * If `true`, the input will be required.
   */
  required: _propTypes.default.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: _propTypes.default.node,

  /**
   * Type of the input element. It should be a valid HTML5 input type.
   */
  type: _propTypes.default.string,

  /**
   * The input value, required for a controlled component.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.object, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.object]))])
} : void 0;
_InputBase.default.defaultProps = {
  fullWidth: false,
  inputComponent: 'input',
  multiline: false,
  type: 'text'
};
Input.muiName = 'Input';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiInput'
})(Input);

exports.default = _default;

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(9));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _warning = _interopRequireDefault(__webpack_require__(27));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _formControlState = _interopRequireDefault(__webpack_require__(139));

var _FormControlContext = _interopRequireDefault(__webpack_require__(279));

var _withFormControlContext = _interopRequireDefault(__webpack_require__(96));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _reactHelpers = __webpack_require__(70);

var _Textarea = _interopRequireDefault(__webpack_require__(914));

var _utils2 = __webpack_require__(280);

/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
var styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var placeholder = {
    color: 'currentColor',
    opacity: light ? 0.42 : 0.5,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter
    })
  };
  var placeholderHidden = {
    opacity: 0
  };
  var placeholderVisible = {
    opacity: light ? 0.42 : 0.5
  };
  return {
    /* Styles applied to the root element. */
    root: {
      // Mimics the default input display property used by browsers for an input.
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.text.primary,
      fontSize: theme.typography.pxToRem(16),
      lineHeight: '1.1875em',
      // Reset (19px), match the native input line-height
      cursor: 'text',
      display: 'inline-flex',
      alignItems: 'center',
      '&$disabled': {
        color: theme.palette.text.disabled,
        cursor: 'default'
      }
    },

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {},

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {},

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {},

    /* Styles applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px")
    },

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },

    /* Styles applied to the `input` element. */
    input: {
      font: 'inherit',
      color: 'currentColor',
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
      border: 0,
      boxSizing: 'content-box',
      background: 'none',
      margin: 0,
      // Reset for Safari
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      display: 'block',
      // Make the flex item shrink with Firefox
      minWidth: 0,
      width: '100%',
      // Fix IE 11 width issue
      '&::-webkit-input-placeholder': placeholder,
      '&::-moz-placeholder': placeholder,
      // Firefox 19+
      '&:-ms-input-placeholder': placeholder,
      // IE 11
      '&::-ms-input-placeholder': placeholder,
      // Edge
      '&:focus': {
        outline: 0
      },
      // Reset Firefox invalid required input style
      '&:invalid': {
        boxShadow: 'none'
      },
      '&::-webkit-search-decoration': {
        // Remove the padding when type=search.
        '-webkit-appearance': 'none'
      },
      // Show and hide the placeholder logic
      'label[data-shrink=false] + $formControl &': {
        '&::-webkit-input-placeholder': placeholderHidden,
        '&::-moz-placeholder': placeholderHidden,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholderHidden,
        // IE 11
        '&::-ms-input-placeholder': placeholderHidden,
        // Edge
        '&:focus::-webkit-input-placeholder': placeholderVisible,
        '&:focus::-moz-placeholder': placeholderVisible,
        // Firefox 19+
        '&:focus:-ms-input-placeholder': placeholderVisible,
        // IE 11
        '&:focus::-ms-input-placeholder': placeholderVisible // Edge

      },
      '&$disabled': {
        opacity: 1 // Reset iOS opacity

      }
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 4 - 1
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      resize: 'none',
      padding: 0
    },

    /* Styles applied to the `input` element if `type` is not "text"`. */
    inputType: {
      // type="date" or type="time", etc. have specific styles we need to reset.
      height: '1.1875em' // Reset (19px), match the native input line-height

    },

    /* Styles applied to the `input` element if `type="search"`. */
    inputTypeSearch: {
      // Improve type search style.
      '-moz-appearance': 'textfield',
      '-webkit-appearance': 'textfield'
    },

    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {},

    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {}
  };
};
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */


exports.styles = styles;

var InputBase =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(InputBase, _React$Component);
  (0, _createClass2.default)(InputBase, null, [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      // The blur won't fire when the disabled state is set on a focused input.
      // We need to book keep the focused state manually.
      if (props.disabled && state.focused) {
        return {
          focused: false
        };
      }

      return null;
    }
  }]);

  function InputBase(props) {
    var _this;

    (0, _classCallCheck2.default)(this, InputBase);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(InputBase).call(this, props));
    _this.state = {
      focused: false
    };

    _this.handleFocus = function (event) {
      var muiFormControl = _this.props.muiFormControl; // Fix a bug with IE 11 where the focus/blur events are triggered
      // while the input is disabled.

      if ((0, _formControlState.default)({
        props: _this.props,
        muiFormControl: muiFormControl,
        states: ['disabled']
      }).disabled) {
        event.stopPropagation();
        return;
      }

      _this.setState({
        focused: true
      });

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }

      if (muiFormControl && muiFormControl.onFocus) {
        muiFormControl.onFocus(event);
      }
    };

    _this.handleBlur = function (event) {
      _this.setState({
        focused: false
      });

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }

      var muiFormControl = _this.props.muiFormControl;

      if (muiFormControl && muiFormControl.onBlur) {
        muiFormControl.onBlur(event);
      }
    };

    _this.handleChange = function () {
      if (!_this.isControlled) {
        _this.checkDirty(_this.inputRef);
      } // Perform in the willUpdate


      if (_this.props.onChange) {
        var _this$props;

        (_this$props = _this.props).onChange.apply(_this$props, arguments);
      }
    };

    _this.handleRefInput = function (ref) {
      _this.inputRef = ref;
       false ? (0, _warning.default)(!ref || ref instanceof HTMLInputElement || ref.focus, ['Material-UI: you have provided a `inputComponent` to the input component', 'that does not correctly handle the `inputRef` property.', 'Make sure the `inputRef` property is called with a HTMLInputElement.'].join('\n')) : void 0;
      var refProp;

      if (_this.props.inputRef) {
        refProp = _this.props.inputRef;
      } else if (_this.props.inputProps && _this.props.inputProps.ref) {
        refProp = _this.props.inputProps.ref;
      }

      (0, _reactHelpers.setRef)(refProp, ref);
    };

    _this.handleClick = function (event) {
      if (_this.inputRef && event.currentTarget === event.target) {
        _this.inputRef.focus();
      }

      if (_this.props.onClick) {
        _this.props.onClick(event);
      }
    };

    _this.isControlled = props.value != null;

    if (_this.isControlled) {
      _this.checkDirty(props);
    }

    return _this;
  }

  (0, _createClass2.default)(InputBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.isControlled) {
        this.checkDirty(this.inputRef);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // Book keep the focused state.
      if (!prevProps.disabled && this.props.disabled) {
        var muiFormControl = this.props.muiFormControl;

        if (muiFormControl && muiFormControl.onBlur) {
          muiFormControl.onBlur();
        }
      }

      if (this.isControlled) {
        this.checkDirty(this.props);
      } // else performed in the onChange

    }
  }, {
    key: "checkDirty",
    value: function checkDirty(obj) {
      var muiFormControl = this.props.muiFormControl;

      if ((0, _utils2.isFilled)(obj)) {
        if (muiFormControl && muiFormControl.onFilled) {
          muiFormControl.onFilled();
        }

        if (this.props.onFilled) {
          this.props.onFilled();
        }

        return;
      }

      if (muiFormControl && muiFormControl.onEmpty) {
        muiFormControl.onEmpty();
      }

      if (this.props.onEmpty) {
        this.props.onEmpty();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames, _classNames2;

      var _this$props2 = this.props,
          autoComplete = _this$props2.autoComplete,
          autoFocus = _this$props2.autoFocus,
          classes = _this$props2.classes,
          classNameProp = _this$props2.className,
          defaultValue = _this$props2.defaultValue,
          disabled = _this$props2.disabled,
          endAdornment = _this$props2.endAdornment,
          error = _this$props2.error,
          fullWidth = _this$props2.fullWidth,
          id = _this$props2.id,
          inputComponent = _this$props2.inputComponent,
          _this$props2$inputPro = _this$props2.inputProps;
      _this$props2$inputPro = _this$props2$inputPro === void 0 ? {} : _this$props2$inputPro;
      var inputPropsClassName = _this$props2$inputPro.className,
          inputPropsProp = (0, _objectWithoutProperties2.default)(_this$props2$inputPro, ["className"]),
          inputRef = _this$props2.inputRef,
          margin = _this$props2.margin,
          muiFormControl = _this$props2.muiFormControl,
          multiline = _this$props2.multiline,
          name = _this$props2.name,
          onBlur = _this$props2.onBlur,
          onChange = _this$props2.onChange,
          onClick = _this$props2.onClick,
          onEmpty = _this$props2.onEmpty,
          onFilled = _this$props2.onFilled,
          onFocus = _this$props2.onFocus,
          onKeyDown = _this$props2.onKeyDown,
          onKeyUp = _this$props2.onKeyUp,
          placeholder = _this$props2.placeholder,
          readOnly = _this$props2.readOnly,
          renderPrefix = _this$props2.renderPrefix,
          rows = _this$props2.rows,
          rowsMax = _this$props2.rowsMax,
          startAdornment = _this$props2.startAdornment,
          type = _this$props2.type,
          value = _this$props2.value,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["autoComplete", "autoFocus", "classes", "className", "defaultValue", "disabled", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "muiFormControl", "multiline", "name", "onBlur", "onChange", "onClick", "onEmpty", "onFilled", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderPrefix", "rows", "rowsMax", "startAdornment", "type", "value"]);
      var ariaDescribedby = other['aria-describedby'];
      delete other['aria-describedby'];
      var fcs = (0, _formControlState.default)({
        props: this.props,
        muiFormControl: muiFormControl,
        states: ['disabled', 'error', 'margin', 'required', 'filled']
      });
      var focused = muiFormControl ? muiFormControl.focused : this.state.focused;
      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, fcs.disabled), (0, _defineProperty2.default)(_classNames, classes.error, fcs.error), (0, _defineProperty2.default)(_classNames, classes.fullWidth, fullWidth), (0, _defineProperty2.default)(_classNames, classes.focused, focused), (0, _defineProperty2.default)(_classNames, classes.formControl, muiFormControl), (0, _defineProperty2.default)(_classNames, classes.marginDense, fcs.margin === 'dense'), (0, _defineProperty2.default)(_classNames, classes.multiline, multiline), (0, _defineProperty2.default)(_classNames, classes.adornedStart, startAdornment), (0, _defineProperty2.default)(_classNames, classes.adornedEnd, endAdornment), _classNames), classNameProp);
      var inputClassName = (0, _classnames.default)(classes.input, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.disabled, fcs.disabled), (0, _defineProperty2.default)(_classNames2, classes.inputType, type !== 'text'), (0, _defineProperty2.default)(_classNames2, classes.inputTypeSearch, type === 'search'), (0, _defineProperty2.default)(_classNames2, classes.inputMultiline, multiline), (0, _defineProperty2.default)(_classNames2, classes.inputMarginDense, fcs.margin === 'dense'), (0, _defineProperty2.default)(_classNames2, classes.inputAdornedStart, startAdornment), (0, _defineProperty2.default)(_classNames2, classes.inputAdornedEnd, endAdornment), _classNames2), inputPropsClassName);
      var InputComponent = inputComponent;
      var inputProps = (0, _extends2.default)({}, inputPropsProp, {
        ref: this.handleRefInput
      });

      if (typeof InputComponent !== 'string') {
        inputProps = (0, _extends2.default)({
          // Rename ref to inputRef as we don't know the
          // provided `inputComponent` structure.
          inputRef: this.handleRefInput,
          type: type
        }, inputProps, {
          ref: null
        });
      } else if (multiline) {
        if (rows && !rowsMax) {
          InputComponent = 'textarea';
        } else {
          inputProps = (0, _extends2.default)({
            rowsMax: rowsMax,
            textareaRef: this.handleRefInput
          }, inputProps, {
            ref: null
          });
          InputComponent = _Textarea.default;
        }
      } else {
        inputProps = (0, _extends2.default)({
          type: type
        }, inputProps);
      }

      return _react.default.createElement("div", (0, _extends2.default)({
        className: className,
        onClick: this.handleClick
      }, other), renderPrefix ? renderPrefix((0, _extends2.default)({}, fcs, {
        startAdornment: startAdornment,
        focused: focused
      })) : null, startAdornment, _react.default.createElement(_FormControlContext.default.Provider, {
        value: null
      }, _react.default.createElement(InputComponent, (0, _extends2.default)({
        "aria-invalid": fcs.error,
        "aria-describedby": ariaDescribedby,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        className: inputClassName,
        defaultValue: defaultValue,
        disabled: fcs.disabled,
        id: id,
        name: name,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        placeholder: placeholder,
        readOnly: readOnly,
        required: fcs.required,
        rows: rows,
        value: value
      }, inputProps))), endAdornment);
    }
  }]);
  return InputBase;
}(_react.default.Component);

 false ? InputBase.propTypes = {
  /**
   * This property helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it here:
   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
   */
  autoComplete: _propTypes.default.string,

  /**
   * If `true`, the input will be focused during the first mount.
   */
  autoFocus: _propTypes.default.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The CSS class name of the wrapper element.
   */
  className: _propTypes.default.string,

  /**
   * The default input value, useful when not controlling the component.
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.object, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.object]))]),

  /**
   * If `true`, the input will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: _propTypes.default.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,

  /**
   * The component used for the native input.
   * Either a string to use a DOM element or a component.
   */
  inputComponent: _utils.componentPropType,

  /**
   * Attributes applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes.default.oneOf(['dense', 'none']),

  /**
   * @ignore
   */
  muiFormControl: _propTypes.default.object,

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: _propTypes.default.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onClick: _propTypes.default.func,

  /**
   * @ignore
   */
  onEmpty: _propTypes.default.func,

  /**
   * @ignore
   */
  onFilled: _propTypes.default.func,

  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyDown: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyUp: _propTypes.default.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _propTypes.default.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: _propTypes.default.bool,

  /**
   * @ignore
   */
  renderPrefix: _propTypes.default.func,

  /**
   * If `true`, the input will be required.
   */
  required: _propTypes.default.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: _propTypes.default.node,

  /**
   * Type of the input element. It should be a valid HTML5 input type.
   */
  type: _propTypes.default.string,

  /**
   * The input value, required for a controlled component.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.object, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.object]))])
} : void 0;
InputBase.defaultProps = {
  fullWidth: false,
  inputComponent: 'input',
  multiline: false,
  type: 'text'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiInputBase'
})((0, _withFormControlContext.default)(InputBase));

exports.default = _default;

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _debounce = _interopRequireDefault(__webpack_require__(125));

var _reactEventListener = _interopRequireDefault(__webpack_require__(94));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _reactHelpers = __webpack_require__(70);

// < 1kb payload overhead when lodash/debounce is > 3kb.
var ROWS_HEIGHT = 19;
var styles = {
  /* Styles applied to the root element. */
  root: {
    position: 'relative',
    // because the shadow has position: 'absolute',
    width: '100%'
  },
  textarea: {
    width: '100%',
    height: '100%',
    resize: 'none',
    font: 'inherit',
    padding: 0,
    cursor: 'inherit',
    boxSizing: 'border-box',
    lineHeight: 'inherit',
    border: 'none',
    outline: 'none',
    background: 'transparent'
  },
  shadow: {
    // Overflow also needed to here to remove the extra row
    // added to textareas in Firefox.
    overflow: 'hidden',
    // Visibility needed to hide the extra text area on iPads
    visibility: 'hidden',
    position: 'absolute',
    height: 'auto',
    whiteSpace: 'pre-wrap'
  }
};
/**
 * @ignore - internal component.
 */

exports.styles = styles;

var Textarea =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Textarea, _React$Component);

  function Textarea(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Textarea);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Textarea).call(this));

    _this.handleRefInput = function (ref) {
      _this.inputRef = ref;
      (0, _reactHelpers.setRef)(_this.props.textareaRef, ref);
    };

    _this.handleRefSinglelineShadow = function (ref) {
      _this.singlelineShadowRef = ref;
    };

    _this.handleRefShadow = function (ref) {
      _this.shadowRef = ref;
    };

    _this.handleChange = function (event) {
      _this.value = event.target.value;

      if (!_this.isControlled) {
        // The component is not controlled, we need to update the shallow value.
        _this.shadowRef.value = _this.value;

        _this.syncHeightWithShadow();
      }

      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    };

    _this.isControlled = props.value != null; // <Input> expects the components it renders to respond to 'value'
    // so that it can check whether they are filled.

    _this.value = props.value || props.defaultValue || '';
    _this.state = {
      height: Number(props.rows) * ROWS_HEIGHT
    };

    if (typeof window !== 'undefined') {
      _this.handleResize = (0, _debounce.default)(function () {
        _this.syncHeightWithShadow();
      }, 166); // Corresponds to 10 frames at 60 Hz.
    }

    return _this;
  }

  (0, _createClass2.default)(Textarea, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.syncHeightWithShadow();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.syncHeightWithShadow();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleResize.clear();
    }
  }, {
    key: "syncHeightWithShadow",
    value: function syncHeightWithShadow() {
      var props = this.props; // Guarding for **broken** shallow rendering method that call componentDidMount
      // but doesn't handle refs correctly.
      // To remove once the shallow rendering has been fixed.

      if (!this.shadowRef) {
        return;
      }

      if (this.isControlled) {
        // The component is controlled, we need to update the shallow value.
        this.shadowRef.value = props.value == null ? '' : String(props.value);
      }

      var lineHeight = this.singlelineShadowRef.scrollHeight; // The Textarea might not be visible (p.ex: display: none).
      // In this case, the layout values read from the DOM will be 0.

      lineHeight = lineHeight === 0 ? ROWS_HEIGHT : lineHeight;
      var newHeight = this.shadowRef.scrollHeight; // Guarding for jsdom, where scrollHeight isn't present.
      // See https://github.com/tmpvar/jsdom/issues/1013

      if (newHeight === undefined) {
        return;
      }

      if (Number(props.rowsMax) >= Number(props.rows)) {
        newHeight = Math.min(Number(props.rowsMax) * lineHeight, newHeight);
      }

      newHeight = Math.max(newHeight, lineHeight); // Need a large enough different to update the height.
      // This prevents infinite rendering loop.

      if (Math.abs(this.state.height - newHeight) > 1) {
        this.setState({
          height: newHeight
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          className = _this$props.className,
          defaultValue = _this$props.defaultValue,
          onChange = _this$props.onChange,
          rows = _this$props.rows,
          rowsMax = _this$props.rowsMax,
          style = _this$props.style,
          textareaRef = _this$props.textareaRef,
          value = _this$props.value,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "className", "defaultValue", "onChange", "rows", "rowsMax", "style", "textareaRef", "value"]);
      return _react.default.createElement("div", {
        className: classes.root
      }, _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }), _react.default.createElement("textarea", {
        "aria-hidden": "true",
        className: (0, _classnames.default)(classes.textarea, classes.shadow),
        readOnly: true,
        ref: this.handleRefSinglelineShadow,
        rows: "1",
        tabIndex: -1,
        value: ""
      }), _react.default.createElement("textarea", {
        "aria-hidden": "true",
        className: (0, _classnames.default)(classes.textarea, classes.shadow),
        defaultValue: defaultValue,
        readOnly: true,
        ref: this.handleRefShadow,
        rows: rows,
        tabIndex: -1,
        value: value
      }), _react.default.createElement("textarea", (0, _extends2.default)({
        rows: rows,
        className: (0, _classnames.default)(classes.textarea, className),
        defaultValue: defaultValue,
        value: value,
        onChange: this.handleChange,
        ref: this.handleRefInput,
        style: (0, _extends2.default)({
          height: this.state.height
        }, style)
      }, other)));
    }
  }]);
  return Textarea;
}(_react.default.Component);

 false ? Textarea.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * @ignore
   */
  disabled: _propTypes.default.bool,

  /**
   * @ignore
   */
  onChange: _propTypes.default.func,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native textarea element.
   */
  textareaRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * @ignore
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
} : void 0;
Textarea.defaultProps = {
  rows: 1
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiPrivateTextarea'
})(Textarea);

exports.default = _default;

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _InputBase = _interopRequireDefault(__webpack_require__(160));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

// @inheritedComponent InputBase
var styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  var backgroundColor = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      backgroundColor: backgroundColor,
      borderTopLeftRadius: theme.shape.borderRadius,
      borderTopRightRadius: theme.shape.borderRadius,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      }),
      '&:hover': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.13)' : 'rgba(255, 255, 255, 0.13)',
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: backgroundColor
        }
      },
      '&$focused': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)'
      },
      '&$disabled': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)'
      }
    },

    /* Styles applied to the root element if `disableUnderline={false}`. */
    underline: {
      '&:after': {
        borderBottom: "2px solid ".concat(theme.palette.primary[light ? 'dark' : 'light']),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.main,
        transform: 'scaleX(1)' // error is always underlined in red

      },
      '&:before': {
        borderBottom: "1px solid ".concat(bottomLineColor),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('border-bottom-color', {
          duration: theme.transitions.duration.shorter
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&:hover:not($disabled):not($focused):not($error):before': {
        borderBottom: "1px solid ".concat(theme.palette.text.primary)
      },
      '&$disabled:before': {
        borderBottom: "1px dotted ".concat(bottomLineColor)
      }
    },

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {
      paddingLeft: 12
    },

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {
      paddingRight: 12
    },

    /* Styles applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: '27px 12px 10px',
      boxSizing: 'border-box' // Prevent padding issue with fullWidth.

    },

    /* Styles applied to the `input` element. */
    input: {
      padding: '27px 12px 10px'
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 24,
      paddingBottom: 6
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      padding: 0
    },

    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {
      paddingLeft: 0
    },

    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {
      paddingRight: 0
    }
  };
};

exports.styles = styles;

function FilledInput(props) {
  var disableUnderline = props.disableUnderline,
      classes = props.classes,
      other = (0, _objectWithoutProperties2.default)(props, ["disableUnderline", "classes"]);
  return _react.default.createElement(_InputBase.default, (0, _extends2.default)({
    classes: (0, _extends2.default)({}, classes, {
      root: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.underline, !disableUnderline)),
      underline: null
    })
  }, other));
}

 false ? FilledInput.propTypes = {
  /**
   * This property helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it here:
   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
   */
  autoComplete: _propTypes.default.string,

  /**
   * If `true`, the input will be focused during the first mount.
   */
  autoFocus: _propTypes.default.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The CSS class name of the wrapper element.
   */
  className: _propTypes.default.string,

  /**
   * The default input value, useful when not controlling the component.
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.object, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.object]))]),

  /**
   * If `true`, the input will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: _propTypes.default.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: _propTypes.default.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,

  /**
   * The component used for the native input.
   * Either a string to use a DOM element or a component.
   */
  inputComponent: _utils.componentPropType,

  /**
   * Attributes applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes.default.oneOf(['dense', 'none']),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: _propTypes.default.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes.default.string,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes.default.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _propTypes.default.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: _propTypes.default.bool,

  /**
   * If `true`, the input will be required.
   */
  required: _propTypes.default.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: _propTypes.default.node,

  /**
   * Type of the input element. It should be a valid HTML5 input type.
   */
  type: _propTypes.default.string,

  /**
   * The input value, required for a controlled component.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.object, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.object]))])
} : void 0;
_InputBase.default.defaultProps = {
  fullWidth: false,
  inputComponent: 'input',
  multiline: false,
  type: 'text'
};
FilledInput.muiName = 'Input';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiFilledInput'
})(FilledInput);

exports.default = _default;

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _InputBase = _interopRequireDefault(__webpack_require__(160));

var _NotchedOutline = _interopRequireDefault(__webpack_require__(917));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

// @inheritedComponent InputBase
var styles = function styles(theme) {
  var borderColor = theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      '& $notchedOutline': {
        borderColor: borderColor
      },
      '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
        borderColor: theme.palette.text.primary,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          borderColor: borderColor
        }
      },
      '&$focused $notchedOutline': {
        borderColor: theme.palette.primary.main,
        borderWidth: 2
      },
      '&$error $notchedOutline': {
        borderColor: theme.palette.error.main
      },
      '&$disabled $notchedOutline': {
        borderColor: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {
      paddingLeft: 14
    },

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {
      paddingRight: 14
    },

    /* Styles applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: '18.5px 14px',
      boxSizing: 'border-box' // Prevent padding issue with fullWidth.

    },

    /* Styles applied to the `NotchedOutline` element. */
    notchedOutline: {},

    /* Styles applied to the `input` element. */
    input: {
      padding: '18.5px 14px'
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 15,
      paddingBottom: 15
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      padding: 0
    },

    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {
      paddingLeft: 0
    },

    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {
      paddingRight: 0
    }
  };
};

exports.styles = styles;

function OutlinedInput(props) {
  var classes = props.classes,
      labelWidth = props.labelWidth,
      notched = props.notched,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "labelWidth", "notched"]);
  return _react.default.createElement(_InputBase.default, (0, _extends2.default)({
    renderPrefix: function renderPrefix(state) {
      return _react.default.createElement(_NotchedOutline.default, {
        className: classes.notchedOutline,
        labelWidth: labelWidth,
        notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
      });
    },
    classes: (0, _extends2.default)({}, classes, {
      root: (0, _classnames.default)(classes.root, classes.underline),
      notchedOutline: null
    })
  }, other));
}

 false ? OutlinedInput.propTypes = {
  /**
   * This property helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it here:
   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
   */
  autoComplete: _propTypes.default.string,

  /**
   * If `true`, the input will be focused during the first mount.
   */
  autoFocus: _propTypes.default.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The CSS class name of the wrapper element.
   */
  className: _propTypes.default.string,

  /**
   * The default input value, useful when not controlling the component.
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.object, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.object]))]),

  /**
   * If `true`, the input will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: _propTypes.default.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,

  /**
   * The component used for the native input.
   * Either a string to use a DOM element or a component.
   */
  inputComponent: _utils.componentPropType,

  /**
   * Attributes applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * The width of the legend.
   */
  labelWidth: _propTypes.default.number.isRequired,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes.default.oneOf(['dense', 'none']),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: _propTypes.default.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes.default.string,

  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: _propTypes.default.bool,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes.default.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _propTypes.default.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: _propTypes.default.bool,

  /**
   * If `true`, the input will be required.
   */
  required: _propTypes.default.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: _propTypes.default.node,

  /**
   * Type of the input element. It should be a valid HTML5 input type.
   */
  type: _propTypes.default.string,

  /**
   * The input value, required for a controlled component.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.object, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.object]))])
} : void 0;
_InputBase.default.defaultProps = {
  fullWidth: false,
  inputComponent: 'input',
  multiline: false,
  type: 'text'
};
OutlinedInput.muiName = 'Input';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiOutlinedInput'
})(OutlinedInput);

exports.default = _default;

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _extends3 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _styles = __webpack_require__(18);

var _helpers = __webpack_require__(29);

var styles = function styles(theme) {
  var align = theme.direction === 'rtl' ? 'right' : 'left';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      top: -5,
      left: 0,
      margin: 0,
      padding: 0,
      pointerEvents: 'none',
      borderRadius: theme.shape.borderRadius,
      borderStyle: 'solid',
      borderWidth: 1,
      // Match the Input Label
      transition: theme.transitions.create(["padding-".concat(align), 'border-color', 'border-width'], {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      })
    },

    /* Styles applied to the legend element. */
    legend: {
      textAlign: 'left',
      padding: 0,
      lineHeight: '11px',
      transition: theme.transitions.create('width', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      })
    }
  };
};
/**
 * @ignore - internal component.
 */


exports.styles = styles;

function NotchedOutline(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      labelWidthProp = props.labelWidth,
      notched = props.notched,
      style = props.style,
      theme = props.theme,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "labelWidth", "notched", "style", "theme"]);
  var align = theme.direction === 'rtl' ? 'right' : 'left';
  var labelWidth = labelWidthProp > 0 ? labelWidthProp * 0.75 + 8 : 0;
  return _react.default.createElement("fieldset", (0, _extends3.default)({
    "aria-hidden": true,
    style: (0, _extends3.default)((0, _defineProperty2.default)({}, "padding".concat((0, _helpers.capitalize)(align)), 8 + (notched ? 0 : labelWidth / 2)), style),
    className: (0, _classnames.default)(classes.root, className)
  }, other), _react.default.createElement("legend", {
    className: classes.legend,
    style: {
      // IE 11: fieldset with legend does not render
      // a border radius. This maintains consistency
      // by always having a legend rendered
      width: notched ? labelWidth : 0.01
    }
  }, _react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: '&#8203;'
    }
  })));
}

 false ? NotchedOutline.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The width of the legend.
   */
  labelWidth: _propTypes.default.number.isRequired,

  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: _propTypes.default.bool.isRequired,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object
} : void 0;

var _default = (0, _styles.withStyles)(styles, {
  name: 'MuiPrivateNotchedOutline',
  withTheme: true
})(NotchedOutline);

exports.default = _default;

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _formControlState = _interopRequireDefault(__webpack_require__(139));

var _withFormControlContext = _interopRequireDefault(__webpack_require__(96));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _FormLabel = _interopRequireDefault(__webpack_require__(426));

// @inheritedComponent FormLabel
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      transformOrigin: 'top left'
    },

    /* Styles applied to the root element if `focused={true}`. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the root element if `required={true}`. */
    required: {},

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      position: 'absolute',
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: 'translate(0, 24px) scale(1)'
    },

    /* Styles applied to the root element if `margin="dense"`. */
    marginDense: {
      // Compensation for the `Input.inputDense` style.
      transform: 'translate(0, 21px) scale(1)'
    },

    /* Styles applied to the `input` element if `shrink={true}`. */
    shrink: {
      transform: 'translate(0, 1.5px) scale(0.75)',
      transformOrigin: 'top left'
    },

    /* Styles applied to the `input` element if `disableAnimation={false}`. */
    animated: {
      transition: theme.transitions.create(['color', 'transform'], {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      })
    },

    /* Styles applied to the root element if `variant="filled"`. */
    filled: {
      // Chrome's autofill feature gives the input field a yellow background.
      // Since the input field is behind the label in the HTML tree,
      // the input field is drawn last and hides the label with an opaque background color.
      // zIndex: 1 will raise the label above opaque background-colors of input.
      zIndex: 1,
      pointerEvents: 'none',
      transform: 'translate(12px, 20px) scale(1)',
      '&$marginDense': {
        transform: 'translate(12px, 17px) scale(1)'
      },
      '&$shrink': {
        transform: 'translate(12px, 10px) scale(0.75)',
        '&$marginDense': {
          transform: 'translate(12px, 7px) scale(0.75)'
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      // see comment above on filled.zIndex
      zIndex: 1,
      pointerEvents: 'none',
      transform: 'translate(14px, 20px) scale(1)',
      '&$marginDense': {
        transform: 'translate(14px, 17px) scale(1)'
      },
      '&$shrink': {
        transform: 'translate(14px, -6px) scale(0.75)'
      }
    }
  };
};

exports.styles = styles;

function InputLabel(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      disableAnimation = props.disableAnimation,
      FormLabelClasses = props.FormLabelClasses,
      margin = props.margin,
      muiFormControl = props.muiFormControl,
      shrinkProp = props.shrink,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableAnimation", "FormLabelClasses", "margin", "muiFormControl", "shrink", "variant"]);
  var shrink = shrinkProp;

  if (typeof shrink === 'undefined' && muiFormControl) {
    shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
  }

  var fcs = (0, _formControlState.default)({
    props: props,
    muiFormControl: muiFormControl,
    states: ['margin', 'variant']
  });
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.formControl, muiFormControl), (0, _defineProperty2.default)(_classNames, classes.animated, !disableAnimation), (0, _defineProperty2.default)(_classNames, classes.shrink, shrink), (0, _defineProperty2.default)(_classNames, classes.marginDense, fcs.margin === 'dense'), (0, _defineProperty2.default)(_classNames, classes.filled, fcs.variant === 'filled'), (0, _defineProperty2.default)(_classNames, classes.outlined, fcs.variant === 'outlined'), _classNames), classNameProp);
  return _react.default.createElement(_FormLabel.default, (0, _extends2.default)({
    "data-shrink": shrink,
    className: className,
    classes: (0, _extends2.default)({
      focused: classes.focused,
      disabled: classes.disabled,
      error: classes.error,
      required: classes.required
    }, FormLabelClasses)
  }, other), children);
}

 false ? InputLabel.propTypes = {
  /**
   * The contents of the `InputLabel`.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the transition animation is disabled.
   */
  disableAnimation: _propTypes.default.bool,

  /**
   * If `true`, apply disabled class.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the input of this label is focused.
   */
  focused: _propTypes.default.bool,

  /**
   * `classes` property applied to the [`FormLabel`](/api/form-label/) element.
   */
  FormLabelClasses: _propTypes.default.object,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes.default.oneOf(['dense']),

  /**
   * @ignore
   */
  muiFormControl: _propTypes.default.object,

  /**
   * if `true`, the label will indicate that the input is required.
   */
  required: _propTypes.default.bool,

  /**
   * If `true`, the label is shrunk.
   */
  shrink: _propTypes.default.bool,

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
InputLabel.defaultProps = {
  disableAnimation: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiInputLabel'
})((0, _withFormControlContext.default)(InputLabel));

exports.default = _default;

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _formControlState = _interopRequireDefault(__webpack_require__(139));

var _withFormControlContext = _interopRequireDefault(__webpack_require__(96));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(16),
      lineHeight: 1,
      padding: 0,
      '&$focused': {
        color: theme.palette.primary[theme.palette.type === 'light' ? 'dark' : 'light']
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      },
      '&$error': {
        color: theme.palette.error.main
      }
    },

    /* Styles applied to the root element if `focused={true}`. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the root element if `filled={true}`. */
    filled: {},

    /* Styles applied to the root element if `required={true}`. */
    required: {},
    asterisk: {
      '&$error': {
        color: theme.palette.error.main
      }
    }
  };
};

exports.styles = styles;

function FormLabel(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      disabled = props.disabled,
      error = props.error,
      filled = props.filled,
      focused = props.focused,
      muiFormControl = props.muiFormControl,
      required = props.required,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "disabled", "error", "filled", "focused", "muiFormControl", "required"]);
  var fcs = (0, _formControlState.default)({
    props: props,
    muiFormControl: muiFormControl,
    states: ['required', 'focused', 'disabled', 'error', 'filled']
  });
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, fcs.disabled), (0, _defineProperty2.default)(_classNames, classes.error, fcs.error), (0, _defineProperty2.default)(_classNames, classes.filled, fcs.filled), (0, _defineProperty2.default)(_classNames, classes.focused, fcs.focused), (0, _defineProperty2.default)(_classNames, classes.required, fcs.required), _classNames), classNameProp)
  }, other), children, fcs.required && _react.default.createElement("span", {
    className: (0, _classnames.default)(classes.asterisk, (0, _defineProperty2.default)({}, classes.error, fcs.error))
  }, "\u2009*"));
}

 false ? FormLabel.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the label should use filled classes key.
   */
  filled: _propTypes.default.bool,

  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: _propTypes.default.bool,

  /**
   * @ignore
   */
  muiFormControl: _propTypes.default.object,

  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: _propTypes.default.bool
} : void 0;
FormLabel.defaultProps = {
  component: 'label'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiFormLabel'
})((0, _withFormControlContext.default)(FormLabel));

exports.default = _default;

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(9));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _utils2 = __webpack_require__(280);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _helpers = __webpack_require__(29);

var _reactHelpers = __webpack_require__(70);

var _FormControlContext = _interopRequireDefault(__webpack_require__(279));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top' // Fix alignment issue on Safari.

  },

  /* Styles applied to the root element if `margin="normal"`. */
  marginNormal: {
    marginTop: 16,
    marginBottom: 8
  },

  /* Styles applied to the root element if `margin="dense"`. */
  marginDense: {
    marginTop: 8,
    marginBottom: 4
  },

  /* Styles applied to the root element if `fullWidth={true}`. */
  fullWidth: {
    width: '100%'
  }
};
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * ⚠️ Only one input can be used within a FormControl.
 */

exports.styles = styles;

var FormControl =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(FormControl, _React$Component);
  (0, _createClass2.default)(FormControl, null, [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.disabled && state.focused) {
        return {
          focused: false
        };
      }

      return null;
    }
  }]);

  function FormControl(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FormControl);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FormControl).call(this));

    _this.handleFocus = function () {
      _this.setState(function (state) {
        return !state.focused ? {
          focused: true
        } : null;
      });
    };

    _this.handleBlur = function () {
      _this.setState(function (state) {
        return state.focused ? {
          focused: false
        } : null;
      });
    };

    _this.handleDirty = function () {
      if (!_this.state.filled) {
        _this.setState({
          filled: true
        });
      }
    };

    _this.handleClean = function () {
      if (_this.state.filled) {
        _this.setState({
          filled: false
        });
      }
    };

    _this.state = {
      adornedStart: false,
      filled: false,
      focused: false
    }; // We need to iterate through the children and find the Input in order
    // to fully support server-side rendering.

    var children = props.children;

    if (children) {
      _react.default.Children.forEach(children, function (child) {
        if (!(0, _reactHelpers.isMuiElement)(child, ['Input', 'Select'])) {
          return;
        }

        if ((0, _utils2.isFilled)(child.props, true)) {
          _this.state.filled = true;
        }

        var input = (0, _reactHelpers.isMuiElement)(child, ['Select']) ? child.props.input : child;

        if (input && (0, _utils2.isAdornedStart)(input.props)) {
          _this.state.adornedStart = true;
        }
      });
    }

    return _this;
  }

  (0, _createClass2.default)(FormControl, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          classes = _this$props.classes,
          className = _this$props.className,
          Component = _this$props.component,
          disabled = _this$props.disabled,
          error = _this$props.error,
          fullWidth = _this$props.fullWidth,
          margin = _this$props.margin,
          required = _this$props.required,
          variant = _this$props.variant,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "className", "component", "disabled", "error", "fullWidth", "margin", "required", "variant"]);
      var _this$state = this.state,
          adornedStart = _this$state.adornedStart,
          filled = _this$state.filled,
          focused = _this$state.focused;
      var childContext = {
        adornedStart: adornedStart,
        disabled: disabled,
        error: error,
        filled: filled,
        focused: focused,
        margin: margin,
        onBlur: this.handleBlur,
        onEmpty: this.handleClean,
        onFilled: this.handleDirty,
        onFocus: this.handleFocus,
        required: required,
        variant: variant
      };
      return _react.default.createElement(_FormControlContext.default.Provider, {
        value: childContext
      }, _react.default.createElement(Component, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["margin".concat((0, _helpers.capitalize)(margin))], margin !== 'none'), (0, _defineProperty2.default)(_classNames, classes.fullWidth, fullWidth), _classNames), className)
      }, other)));
    }
  }]);
  return FormControl;
}(_react.default.Component);

 false ? FormControl.propTypes = {
  /**
   * The contents of the form control.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the component will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: _propTypes.default.oneOf(['none', 'dense', 'normal']),

  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: _propTypes.default.bool,

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
FormControl.defaultProps = {
  component: 'div',
  disabled: false,
  error: false,
  fullWidth: false,
  margin: 'none',
  required: false,
  variant: 'standard'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiFormControl'
})(FormControl);

exports.default = _default;

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _formControlState = _interopRequireDefault(__webpack_require__(139));

var _withFormControlContext = _interopRequireDefault(__webpack_require__(96));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(12),
      textAlign: 'left',
      marginTop: 8,
      lineHeight: '1em',
      minHeight: '1em',
      margin: 0,
      '&$disabled': {
        color: theme.palette.text.disabled
      },
      '&$error': {
        color: theme.palette.error.main
      }
    },

    /* Styles applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `margin="dense"`. */
    marginDense: {
      marginTop: 4
    },

    /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */
    contained: {
      margin: '8px 12px 0'
    },

    /* Styles applied to the root element if `focused={true}`. */
    focused: {},

    /* Styles applied to the root element if `filled={true}`. */
    filled: {},

    /* Styles applied to the root element if `required={true}`. */
    required: {}
  };
};

exports.styles = styles;

function FormHelperText(props) {
  var _classNames;

  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      disabled = props.disabled,
      error = props.error,
      filled = props.filled,
      focused = props.focused,
      margin = props.margin,
      muiFormControl = props.muiFormControl,
      required = props.required,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "disabled", "error", "filled", "focused", "margin", "muiFormControl", "required", "variant"]);
  var fcs = (0, _formControlState.default)({
    props: props,
    muiFormControl: muiFormControl,
    states: ['variant', 'margin', 'disabled', 'error', 'filled', 'focused', 'required']
  });
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.contained, fcs.variant === 'filled' || fcs.variant === 'outlined'), (0, _defineProperty2.default)(_classNames, classes.marginDense, fcs.margin === 'dense'), (0, _defineProperty2.default)(_classNames, classes.disabled, fcs.disabled), (0, _defineProperty2.default)(_classNames, classes.error, fcs.error), (0, _defineProperty2.default)(_classNames, classes.filled, fcs.filled), (0, _defineProperty2.default)(_classNames, classes.focused, fcs.focused), (0, _defineProperty2.default)(_classNames, classes.required, fcs.required), _classNames), classNameProp)
  }, other));
}

 false ? FormHelperText.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: _propTypes.default.bool,

  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: _propTypes.default.bool,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes.default.oneOf(['dense']),

  /**
   * @ignore
   */
  muiFormControl: _propTypes.default.object,

  /**
   * If `true`, the helper text should use required classes key.
   */
  required: _propTypes.default.bool,

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
FormHelperText.defaultProps = {
  component: 'p'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiFormHelperText'
})((0, _withFormControlContext.default)(FormHelperText));

exports.default = _default;

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _utils = __webpack_require__(14);

var _SelectInput = _interopRequireDefault(__webpack_require__(923));

var _formControlState = _interopRequireDefault(__webpack_require__(139));

var _withFormControlContext = _interopRequireDefault(__webpack_require__(96));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _mergeClasses = _interopRequireDefault(__webpack_require__(376));

var _ArrowDropDown = _interopRequireDefault(__webpack_require__(429));

var _Input = _interopRequireDefault(__webpack_require__(205));

var _NativeSelect = __webpack_require__(430);

var _NativeSelectInput = _interopRequireDefault(__webpack_require__(431));

// @inheritedComponent Input
// To replace with InputBase in v4
var styles = _NativeSelect.styles;
exports.styles = styles;

function Select(props) {
  var autoWidth = props.autoWidth,
      children = props.children,
      classes = props.classes,
      displayEmpty = props.displayEmpty,
      IconComponent = props.IconComponent,
      input = props.input,
      inputProps = props.inputProps,
      MenuProps = props.MenuProps,
      muiFormControl = props.muiFormControl,
      multiple = props.multiple,
      native = props.native,
      onClose = props.onClose,
      onOpen = props.onOpen,
      open = props.open,
      renderValue = props.renderValue,
      SelectDisplayProps = props.SelectDisplayProps,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["autoWidth", "children", "classes", "displayEmpty", "IconComponent", "input", "inputProps", "MenuProps", "muiFormControl", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"]);
  var inputComponent = native ? _NativeSelectInput.default : _SelectInput.default;
  var fcs = (0, _formControlState.default)({
    props: props,
    muiFormControl: muiFormControl,
    states: ['variant']
  });
  return _react.default.cloneElement(input, (0, _extends2.default)({
    // Most of the logic is implemented in `SelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: inputComponent,
    inputProps: (0, _extends2.default)({
      children: children,
      IconComponent: IconComponent,
      variant: fcs.variant,
      type: undefined,
      // We render a select. We can ignore the type provided by the `Input`.
      multiple: multiple
    }, native ? {} : {
      autoWidth: autoWidth,
      displayEmpty: displayEmpty,
      MenuProps: MenuProps,
      onClose: onClose,
      onOpen: onOpen,
      open: open,
      renderValue: renderValue,
      SelectDisplayProps: SelectDisplayProps
    }, inputProps, {
      classes: inputProps ? (0, _mergeClasses.default)({
        baseClasses: classes,
        newClasses: inputProps.classes,
        Component: Select
      }) : classes
    }, input ? input.props.inputProps : {})
  }, other));
}

 false ? Select.propTypes = {
  /**
   * If true, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: _propTypes.default.bool,

  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * If `true`, the selected item is displayed even if its value is empty.
   * You can only use it when the `native` property is `false` (default).
   */
  displayEmpty: _propTypes.default.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: _utils.componentPropType,

  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: _propTypes.default.element,

  /**
   * Attributes applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Properties applied to the [`Menu`](/api/menu/) element.
   */
  MenuProps: _propTypes.default.object,

  /**
   * If true, `value` must be an array and the menu will support multiple selections.
   */
  multiple: _propTypes.default.bool,

  /**
   * If `true`, the component will be using a native `select` element.
   */
  native: _propTypes.default.bool,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onOpen: _propTypes.default.func,

  /**
   * Control `select` open state.
   * You can only use it when the `native` property is `false` (default).
   */
  open: _propTypes.default.bool,

  /**
   * Render the selected value.
   * You can only use it when the `native` property is `false` (default).
   *
   * @param {*} value The `value` provided to the component.
   * @returns {ReactElement}
   */
  renderValue: _propTypes.default.func,

  /**
   * Properties applied to the clickable div element.
   */
  SelectDisplayProps: _propTypes.default.object,

  /**
   * The input value.
   * This property is required when the `native` property is `false` (default).
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.object, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.object]))]),

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
Select.defaultProps = {
  autoWidth: false,
  displayEmpty: false,
  IconComponent: _ArrowDropDown.default,
  input: _react.default.createElement(_Input.default, null),
  multiple: false,
  native: false
};
Select.muiName = 'Select';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiSelect'
})((0, _withFormControlContext.default)(Select));

exports.default = _default;

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(50));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _typeof2 = _interopRequireDefault(__webpack_require__(117));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _warning = _interopRequireDefault(__webpack_require__(27));

var _utils = __webpack_require__(14);

var _Menu = _interopRequireDefault(__webpack_require__(428));

var _utils2 = __webpack_require__(280);

var _reactHelpers = __webpack_require__(70);

function areEqualValues(a, b) {
  if ((0, _typeof2.default)(b) === 'object' && b !== null) {
    return a === b;
  }

  return String(a) === String(b);
}
/**
 * @ignore - internal component.
 */


var SelectInput =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(SelectInput, _React$Component);

  function SelectInput(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SelectInput);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SelectInput).call(this));
    _this.ignoreNextBlur = false;

    _this.update = function (_ref) {
      var event = _ref.event,
          open = _ref.open;

      if (_this.isOpenControlled) {
        if (open) {
          _this.props.onOpen(event);
        } else {
          _this.props.onClose(event);
        }

        return;
      }

      _this.setState({
        // Perform the layout computation outside of the render method.
        menuMinWidth: _this.props.autoWidth ? null : _this.displayRef.clientWidth,
        open: open
      });
    };

    _this.handleClick = function (event) {
      // Opening the menu is going to blur the. It will be focused back when closed.
      _this.ignoreNextBlur = true;

      _this.update({
        open: true,
        event: event
      });
    };

    _this.handleClose = function (event) {
      _this.update({
        open: false,
        event: event
      });
    };

    _this.handleItemClick = function (child) {
      return function (event) {
        if (!_this.props.multiple) {
          _this.update({
            open: false,
            event: event
          });
        }

        var _this$props = _this.props,
            onChange = _this$props.onChange,
            name = _this$props.name;

        if (onChange) {
          var value;

          if (_this.props.multiple) {
            value = Array.isArray(_this.props.value) ? (0, _toConsumableArray2.default)(_this.props.value) : [];
            var itemIndex = value.indexOf(child.props.value);

            if (itemIndex === -1) {
              value.push(child.props.value);
            } else {
              value.splice(itemIndex, 1);
            }
          } else {
            value = child.props.value;
          }

          event.persist();
          event.target = {
            value: value,
            name: name
          };
          onChange(event, child);
        }
      };
    };

    _this.handleBlur = function (event) {
      if (_this.ignoreNextBlur === true) {
        // The parent components are relying on the bubbling of the event.
        event.stopPropagation();
        _this.ignoreNextBlur = false;
        return;
      }

      if (_this.props.onBlur) {
        var _this$props2 = _this.props,
            value = _this$props2.value,
            name = _this$props2.name;
        event.persist();
        event.target = {
          value: value,
          name: name
        };

        _this.props.onBlur(event);
      }
    };

    _this.handleKeyDown = function (event) {
      if (_this.props.readOnly) {
        return;
      }

      if ([' ', 'ArrowUp', 'ArrowDown'].indexOf(event.key) !== -1) {
        event.preventDefault(); // Opening the menu is going to blur the. It will be focused back when closed.

        _this.ignoreNextBlur = true;

        _this.update({
          open: true,
          event: event
        });
      }
    };

    _this.handleDisplayRef = function (ref) {
      _this.displayRef = ref;
    };

    _this.handleInputRef = function (ref) {
      var inputRef = _this.props.inputRef;

      if (!inputRef) {
        return;
      }

      var nodeProxy = {
        node: ref,
        // By pass the native input as we expose a rich object (array).
        value: _this.props.value,
        focus: function focus() {
          _this.displayRef.focus();
        }
      };
      (0, _reactHelpers.setRef)(inputRef, nodeProxy);
    };

    _this.isOpenControlled = props.open !== undefined;
    _this.state = {
      menuMinWidth: null,
      open: false
    };
    return _this;
  }

  (0, _createClass2.default)(SelectInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.isOpenControlled && this.props.open) {
        // Focus the display node so the focus is restored on this element once
        // the menu is closed.
        this.displayRef.focus(); // Rerender with the resolve `displayRef` reference.

        this.forceUpdate();
      }

      if (this.props.autoFocus) {
        this.displayRef.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _classNames;

      var _this$props3 = this.props,
          autoWidth = _this$props3.autoWidth,
          children = _this$props3.children,
          classes = _this$props3.classes,
          className = _this$props3.className,
          disabled = _this$props3.disabled,
          displayEmpty = _this$props3.displayEmpty,
          IconComponent = _this$props3.IconComponent,
          inputRef = _this$props3.inputRef,
          _this$props3$MenuProp = _this$props3.MenuProps,
          MenuProps = _this$props3$MenuProp === void 0 ? {} : _this$props3$MenuProp,
          multiple = _this$props3.multiple,
          name = _this$props3.name,
          onBlur = _this$props3.onBlur,
          onChange = _this$props3.onChange,
          onClose = _this$props3.onClose,
          onFocus = _this$props3.onFocus,
          onOpen = _this$props3.onOpen,
          openProp = _this$props3.open,
          readOnly = _this$props3.readOnly,
          renderValue = _this$props3.renderValue,
          required = _this$props3.required,
          SelectDisplayProps = _this$props3.SelectDisplayProps,
          tabIndexProp = _this$props3.tabIndex,
          _this$props3$type = _this$props3.type,
          type = _this$props3$type === void 0 ? 'hidden' : _this$props3$type,
          value = _this$props3.value,
          variant = _this$props3.variant,
          other = (0, _objectWithoutProperties2.default)(_this$props3, ["autoWidth", "children", "classes", "className", "disabled", "displayEmpty", "IconComponent", "inputRef", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "required", "SelectDisplayProps", "tabIndex", "type", "value", "variant"]);
      var open = this.isOpenControlled && this.displayRef ? openProp : this.state.open;
      delete other['aria-invalid'];
      var display;
      var displaySingle = '';
      var displayMultiple = [];
      var computeDisplay = false; // No need to display any value if the field is empty.

      if ((0, _utils2.isFilled)(this.props) || displayEmpty) {
        if (renderValue) {
          display = renderValue(value);
        } else {
          computeDisplay = true;
        }
      }

      var items = _react.default.Children.map(children, function (child) {
        if (!_react.default.isValidElement(child)) {
          return null;
        }

         false ? (0, _warning.default)(child.type !== _react.default.Fragment, ["Material-UI: the Select component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n')) : void 0;
        var selected;

        if (multiple) {
          if (!Array.isArray(value)) {
            throw new Error('Material-UI: the `value` property must be an array ' + 'when using the `Select` component with `multiple`.');
          }

          selected = value.some(function (v) {
            return areEqualValues(v, child.props.value);
          });

          if (selected && computeDisplay) {
            displayMultiple.push(child.props.children);
          }
        } else {
          selected = areEqualValues(value, child.props.value);

          if (selected && computeDisplay) {
            displaySingle = child.props.children;
          }
        }

        return _react.default.cloneElement(child, {
          onClick: _this2.handleItemClick(child),
          role: 'option',
          selected: selected,
          value: undefined,
          // The value is most likely not a valid HTML attribute.
          'data-value': child.props.value // Instead, we provide it as a data attribute.

        });
      });

      if (computeDisplay) {
        display = multiple ? displayMultiple.join(', ') : displaySingle;
      } // Avoid performing a layout computation in the render method.


      var menuMinWidth = this.state.menuMinWidth;

      if (!autoWidth && this.isOpenControlled && this.displayRef) {
        menuMinWidth = this.displayRef.clientWidth;
      }

      var tabIndex;

      if (typeof tabIndexProp !== 'undefined') {
        tabIndex = tabIndexProp;
      } else {
        tabIndex = disabled ? null : 0;
      }

      return _react.default.createElement("div", {
        className: classes.root
      }, _react.default.createElement("div", (0, _extends2.default)({
        className: (0, _classnames.default)(classes.select, classes.selectMenu, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.filled, variant === 'filled'), (0, _defineProperty2.default)(_classNames, classes.outlined, variant === 'outlined'), _classNames), className),
        ref: this.handleDisplayRef,
        "aria-pressed": open ? 'true' : 'false',
        tabIndex: tabIndex,
        role: "button",
        "aria-owns": open ? "menu-".concat(name || '') : undefined,
        "aria-haspopup": "true",
        onKeyDown: this.handleKeyDown,
        onBlur: this.handleBlur,
        onClick: disabled || readOnly ? null : this.handleClick,
        onFocus: onFocus // The id can help with end-to-end testing automation.
        ,
        id: name ? "select-".concat(name) : undefined
      }, SelectDisplayProps), display || _react.default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: '&#8203;'
        }
      })), _react.default.createElement("input", (0, _extends2.default)({
        value: Array.isArray(value) ? value.join(',') : value,
        name: name,
        ref: this.handleInputRef,
        type: type
      }, other)), _react.default.createElement(IconComponent, {
        className: classes.icon
      }), _react.default.createElement(_Menu.default, (0, _extends2.default)({
        id: "menu-".concat(name || ''),
        anchorEl: this.displayRef,
        open: open,
        onClose: this.handleClose
      }, MenuProps, {
        MenuListProps: (0, _extends2.default)({
          role: 'listbox',
          disableListWrap: true
        }, MenuProps.MenuListProps),
        PaperProps: (0, _extends2.default)({}, MenuProps.PaperProps, {
          style: (0, _extends2.default)({
            minWidth: menuMinWidth
          }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
        })
      }), items));
    }
  }]);
  return SelectInput;
}(_react.default.Component);

 false ? SelectInput.propTypes = {
  /**
   * @ignore
   */
  autoFocus: _propTypes.default.bool,

  /**
   * If true, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: _propTypes.default.bool,

  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The CSS class name of the select element.
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the select will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: _propTypes.default.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: _utils.componentPropType,

  /**
   * Use that property to pass a ref callback to the native select element.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * Properties applied to the [`Menu`](/api/menu/) element.
   */
  MenuProps: _propTypes.default.object,

  /**
   * If true, `value` must be an array and the menu will support multiple selections.
   */
  multiple: _propTypes.default.bool,

  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   * @param {object} [child] The react element that was selected.
   */
  onChange: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onOpen: _propTypes.default.func,

  /**
   * Control `select` open state.
   */
  open: _propTypes.default.bool,

  /**
   * @ignore
   */
  readOnly: _propTypes.default.bool,

  /**
   * Render the selected value.
   *
   * @param {*} value The `value` provided to the component.
   * @returns {ReactElement}
   */
  renderValue: _propTypes.default.func,

  /**
   * @ignore
   */
  required: _propTypes.default.bool,

  /**
   * Properties applied to the clickable div element.
   */
  SelectDisplayProps: _propTypes.default.object,

  /**
   * @ignore
   */
  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * @ignore
   */
  type: _propTypes.default.string,

  /**
   * The input value.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.object, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.object]))]).isRequired,

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
var _default = SelectInput;
exports.default = _default;

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(44));

var _warning = _interopRequireDefault(__webpack_require__(27));

var _debounce = _interopRequireDefault(__webpack_require__(125));

var _reactEventListener = _interopRequireDefault(__webpack_require__(94));

var _utils = __webpack_require__(14);

var _ownerDocument = _interopRequireDefault(__webpack_require__(93));

var _ownerWindow = _interopRequireDefault(__webpack_require__(197));

var _helpers = __webpack_require__(29);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _Modal = _interopRequireDefault(__webpack_require__(198));

var _Grow = _interopRequireDefault(__webpack_require__(281));

var _Paper = _interopRequireDefault(__webpack_require__(63));

// @inheritedComponent Modal
// < 1kb payload overhead when lodash/debounce is > 3kb.
function getOffsetTop(rect, vertical) {
  var offset = 0;

  if (typeof vertical === 'number') {
    offset = vertical;
  } else if (vertical === 'center') {
    offset = rect.height / 2;
  } else if (vertical === 'bottom') {
    offset = rect.height;
  }

  return offset;
}

function getOffsetLeft(rect, horizontal) {
  var offset = 0;

  if (typeof horizontal === 'number') {
    offset = horizontal;
  } else if (horizontal === 'center') {
    offset = rect.width / 2;
  } else if (horizontal === 'right') {
    offset = rect.width;
  }

  return offset;
}

function getTransformOriginValue(transformOrigin) {
  return [transformOrigin.horizontal, transformOrigin.vertical].map(function (n) {
    return typeof n === 'number' ? "".concat(n, "px") : n;
  }).join(' ');
} // Sum the scrollTop between two elements.


function getScrollParent(parent, child) {
  var element = child;
  var scrollTop = 0;

  while (element && element !== parent) {
    element = element.parentNode;
    scrollTop += element.scrollTop;
  }

  return scrollTop;
}

function getAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

var styles = {
  /* Styles applied to the `Paper` component. */
  paper: {
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 'none'
  }
};
exports.styles = styles;

var Popover =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Popover, _React$Component);

  function Popover() {
    var _this;

    (0, _classCallCheck2.default)(this, Popover);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Popover).call(this));
    _this.handleGetOffsetTop = getOffsetTop;
    _this.handleGetOffsetLeft = getOffsetLeft;

    _this.componentWillUnmount = function () {
      _this.handleResize.clear();
    };

    _this.setPositioningStyles = function (element) {
      var positioning = _this.getPositioningStyle(element);

      if (positioning.top !== null) {
        element.style.top = positioning.top;
      }

      if (positioning.left !== null) {
        element.style.left = positioning.left;
      }

      element.style.transformOrigin = positioning.transformOrigin;
    };

    _this.getPositioningStyle = function (element) {
      var _this$props = _this.props,
          anchorEl = _this$props.anchorEl,
          anchorReference = _this$props.anchorReference,
          marginThreshold = _this$props.marginThreshold; // Check if the parent has requested anchoring on an inner content node

      var contentAnchorOffset = _this.getContentAnchorOffset(element);

      var elemRect = {
        width: element.offsetWidth,
        height: element.offsetHeight
      }; // Get the transform origin point on the element itself

      var transformOrigin = _this.getTransformOrigin(elemRect, contentAnchorOffset);

      if (anchorReference === 'none') {
        return {
          top: null,
          left: null,
          transformOrigin: getTransformOriginValue(transformOrigin)
        };
      } // Get the offset of of the anchoring element


      var anchorOffset = _this.getAnchorOffset(contentAnchorOffset); // Calculate element positioning


      var top = anchorOffset.top - transformOrigin.vertical;
      var left = anchorOffset.left - transformOrigin.horizontal;
      var bottom = top + elemRect.height;
      var right = left + elemRect.width; // Use the parent window of the anchorEl if provided

      var containerWindow = (0, _ownerWindow.default)(getAnchorEl(anchorEl)); // Window thresholds taking required margin into account

      var heightThreshold = containerWindow.innerHeight - marginThreshold;
      var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting

      if (top < marginThreshold) {
        var diff = top - marginThreshold;
        top -= diff;
        transformOrigin.vertical += diff;
      } else if (bottom > heightThreshold) {
        var _diff = bottom - heightThreshold;

        top -= _diff;
        transformOrigin.vertical += _diff;
      }

       false ? (0, _warning.default)(elemRect.height < heightThreshold || !elemRect.height || !heightThreshold, ['Material-UI: the popover component is too tall.', "Some part of it can not be seen on the screen (".concat(elemRect.height - heightThreshold, "px)."), 'Please consider adding a `max-height` to improve the user-experience.'].join('\n')) : void 0; // Check if the horizontal axis needs shifting

      if (left < marginThreshold) {
        var _diff2 = left - marginThreshold;

        left -= _diff2;
        transformOrigin.horizontal += _diff2;
      } else if (right > widthThreshold) {
        var _diff3 = right - widthThreshold;

        left -= _diff3;
        transformOrigin.horizontal += _diff3;
      }

      return {
        top: "".concat(top, "px"),
        left: "".concat(left, "px"),
        transformOrigin: getTransformOriginValue(transformOrigin)
      };
    };

    _this.handleEntering = function (element) {
      if (_this.props.onEntering) {
        _this.props.onEntering(element);
      }

      _this.setPositioningStyles(element);
    };

    if (typeof window !== 'undefined') {
      _this.handleResize = (0, _debounce.default)(function () {
        // Because we debounce the event, the open property might no longer be true
        // when the callback resolves.
        if (!_this.props.open) {
          return;
        }

        _this.setPositioningStyles(_this.paperRef);
      }, 166); // Corresponds to 10 frames at 60 Hz.
    }

    return _this;
  }

  (0, _createClass2.default)(Popover, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.action) {
        this.props.action({
          updatePosition: this.handleResize
        });
      }
    }
  }, {
    key: "getAnchorOffset",
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    value: function getAnchorOffset(contentAnchorOffset) {
      var _this$props2 = this.props,
          anchorEl = _this$props2.anchorEl,
          anchorOrigin = _this$props2.anchorOrigin,
          anchorReference = _this$props2.anchorReference,
          anchorPosition = _this$props2.anchorPosition;

      if (anchorReference === 'anchorPosition') {
         false ? (0, _warning.default)(anchorPosition, 'Material-UI: you need to provide a `anchorPosition` property when using ' + '<Popover anchorReference="anchorPosition" />.') : void 0;
        return anchorPosition;
      } // If an anchor element wasn't provided, just use the parent body element of this Popover


      var anchorElement = getAnchorEl(anchorEl) || (0, _ownerDocument.default)(this.paperRef).body;
      var anchorRect = anchorElement.getBoundingClientRect();
      var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';
      return {
        top: anchorRect.top + this.handleGetOffsetTop(anchorRect, anchorVertical),
        left: anchorRect.left + this.handleGetOffsetLeft(anchorRect, anchorOrigin.horizontal)
      };
    } // Returns the vertical offset of inner content to anchor the transform on if provided

  }, {
    key: "getContentAnchorOffset",
    value: function getContentAnchorOffset(element) {
      var _this$props3 = this.props,
          getContentAnchorEl = _this$props3.getContentAnchorEl,
          anchorReference = _this$props3.anchorReference;
      var contentAnchorOffset = 0;

      if (getContentAnchorEl && anchorReference === 'anchorEl') {
        var contentAnchorEl = getContentAnchorEl(element);

        if (contentAnchorEl && element.contains(contentAnchorEl)) {
          var scrollTop = getScrollParent(element, contentAnchorEl);
          contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
        } // != the default value


         false ? (0, _warning.default)(this.props.anchorOrigin.vertical === 'top', ['Material-UI: you can not change the default `anchorOrigin.vertical` value ', 'when also providing the `getContentAnchorEl` property to the popover component.', 'Only use one of the two properties.', 'Set `getContentAnchorEl` to `null | undefined`' + ' or leave `anchorOrigin.vertical` unchanged.'].join('\n')) : void 0;
      }

      return contentAnchorOffset;
    } // Return the base transform origin using the element
    // and taking the content anchor offset into account if in use

  }, {
    key: "getTransformOrigin",
    value: function getTransformOrigin(elemRect) {
      var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var transformOrigin = this.props.transformOrigin;
      return {
        vertical: this.handleGetOffsetTop(elemRect, transformOrigin.vertical) + contentAnchorOffset,
        horizontal: this.handleGetOffsetLeft(elemRect, transformOrigin.horizontal)
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          action = _this$props4.action,
          anchorEl = _this$props4.anchorEl,
          anchorOrigin = _this$props4.anchorOrigin,
          anchorPosition = _this$props4.anchorPosition,
          anchorReference = _this$props4.anchorReference,
          children = _this$props4.children,
          classes = _this$props4.classes,
          containerProp = _this$props4.container,
          elevation = _this$props4.elevation,
          getContentAnchorEl = _this$props4.getContentAnchorEl,
          marginThreshold = _this$props4.marginThreshold,
          ModalClasses = _this$props4.ModalClasses,
          onEnter = _this$props4.onEnter,
          onEntered = _this$props4.onEntered,
          onEntering = _this$props4.onEntering,
          onExit = _this$props4.onExit,
          onExited = _this$props4.onExited,
          onExiting = _this$props4.onExiting,
          open = _this$props4.open,
          PaperProps = _this$props4.PaperProps,
          role = _this$props4.role,
          transformOrigin = _this$props4.transformOrigin,
          TransitionComponent = _this$props4.TransitionComponent,
          transitionDurationProp = _this$props4.transitionDuration,
          _this$props4$Transiti = _this$props4.TransitionProps,
          TransitionProps = _this$props4$Transiti === void 0 ? {} : _this$props4$Transiti,
          other = (0, _objectWithoutProperties2.default)(_this$props4, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "classes", "container", "elevation", "getContentAnchorEl", "marginThreshold", "ModalClasses", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "role", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]);
      var transitionDuration = transitionDurationProp;

      if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
        transitionDuration = undefined;
      } // If the container prop is provided, use that
      // If the anchorEl prop is provided, use its parent body element as the container
      // If neither are provided let the Modal take care of choosing the container


      var container = containerProp || (anchorEl ? (0, _ownerDocument.default)(getAnchorEl(anchorEl)).body : undefined);
      return _react.default.createElement(_Modal.default, (0, _extends2.default)({
        classes: ModalClasses,
        container: container,
        open: open,
        BackdropProps: {
          invisible: true
        }
      }, other), _react.default.createElement(TransitionComponent, (0, _extends2.default)({
        appear: true,
        in: open,
        onEnter: onEnter,
        onEntered: onEntered,
        onExit: onExit,
        onExited: onExited,
        onExiting: onExiting,
        role: role,
        timeout: transitionDuration
      }, TransitionProps, {
        onEntering: (0, _helpers.createChainedFunction)(this.handleEntering, TransitionProps.onEntering)
      }), _react.default.createElement(_Paper.default, (0, _extends2.default)({
        className: classes.paper,
        elevation: elevation,
        ref: function ref(_ref) {
          _this2.paperRef = _reactDom.default.findDOMNode(_ref);
        }
      }, PaperProps), _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }), children)));
    }
  }]);
  return Popover;
}(_react.default.Component);

 false ? Popover.propTypes = {
  /**
   * This is callback property. It's called by the component on mount.
   * This is useful when you want to trigger an action programmatically.
   * It currently only supports updatePosition() action.
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: _propTypes.default.func,

  /**
   * This is the DOM element, or a function that returns the DOM element,
   * that may be used to set the position of the popover.
   */
  anchorEl: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   */
  anchorOrigin: _propTypes.default.shape({
    horizontal: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['left', 'center', 'right'])]).isRequired,
    vertical: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['top', 'center', 'bottom'])]).isRequired
  }),

  /**
   * This is the position that may be used
   * to set the position of the popover.
   * The coordinates are relative to
   * the application's client area.
   */
  anchorPosition: _propTypes.default.shape({
    left: _propTypes.default.number.isRequired,
    top: _propTypes.default.number.isRequired
  }),

  /*
   * This determines which anchor prop to refer to to set
   * the position of the popover.
   */
  anchorReference: _propTypes.default.oneOf(['anchorEl', 'anchorPosition', 'none']),

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * The elevation of the popover.
   */
  elevation: _propTypes.default.number,

  /**
   * This function is called in order to retrieve the content anchor element.
   * It's the opposite of the `anchorEl` property.
   * The content anchor element should be an element inside the popover.
   * It's used to correctly scroll and set the position of the popover.
   * The positioning strategy tries to make the content anchor element just above the
   * anchor element.
   */
  getContentAnchorEl: _propTypes.default.func,

  /**
   * Specifies how close to the edge of the window the popover can appear.
   */
  marginThreshold: _propTypes.default.number,

  /**
   * `classes` property applied to the [`Modal`](/api/modal/) element.
   */
  ModalClasses: _propTypes.default.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be:`"escapeKeyDown"`, `"backdropClick"`
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired before the component is entering.
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired when the component has entered.
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired when the component is entering.
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired before the component is exiting.
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired when the component has exited.
   */
  onExited: _propTypes.default.func,

  /**
   * Callback fired when the component is exiting.
   */
  onExiting: _propTypes.default.func,

  /**
   * If `true`, the popover is visible.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * Properties applied to the [`Paper`](/api/paper/) element.
   */
  PaperProps: _propTypes.default.object,

  /**
   * @ignore
   */
  role: _propTypes.default.string,

  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   */
  transformOrigin: _propTypes.default.shape({
    horizontal: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['left', 'center', 'right'])]).isRequired,
    vertical: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['top', 'center', 'bottom'])]).isRequired
  }),

  /**
   * The component used for the transition.
   */
  TransitionComponent: _utils.componentPropType,

  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])]),

  /**
   * Properties applied to the `Transition` element.
   */
  TransitionProps: _propTypes.default.object
} : void 0;
Popover.defaultProps = {
  anchorReference: 'anchorEl',
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  elevation: 8,
  marginThreshold: 16,
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  TransitionComponent: _Grow.default,
  transitionDuration: 'auto'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiPopover'
})(Popover);

exports.default = _default;

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _Transition = _interopRequireDefault(__webpack_require__(137));

var _withTheme = _interopRequireDefault(__webpack_require__(103));

var _utils = __webpack_require__(138);

// @inheritedComponent Transition
function getScale(value) {
  return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}

var styles = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    // Use translateZ to scrolling issue on Chrome.
    transform: "".concat(getScale(1), " translateZ(0)")
  }
};
/**
 * The Grow transition is used by the [Tooltip](/demos/tooltips/) and
 * [Popover](/utils/popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Grow =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Grow, _React$Component);

  function Grow() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Grow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Grow)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleEnter = function (node) {
      var _this$props = _this.props,
          theme = _this$props.theme,
          timeout = _this$props.timeout;
      (0, _utils.reflow)(node); // So the animation always start from the start.

      var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      }),
          transitionDuration = _getTransitionProps.duration,
          delay = _getTransitionProps.delay;

      var duration = 0;

      if (timeout === 'auto') {
        duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
        _this.autoTimeout = duration;
      } else {
        duration = transitionDuration;
      }

      node.style.transition = [theme.transitions.create('opacity', {
        duration: duration,
        delay: delay
      }), theme.transitions.create('transform', {
        duration: duration * 0.666,
        delay: delay
      })].join(',');

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    };

    _this.handleExit = function (node) {
      var _this$props2 = _this.props,
          theme = _this$props2.theme,
          timeout = _this$props2.timeout;
      var duration = 0;

      var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      }),
          transitionDuration = _getTransitionProps2.duration,
          delay = _getTransitionProps2.delay;

      if (timeout === 'auto') {
        duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
        _this.autoTimeout = duration;
      } else {
        duration = transitionDuration;
      }

      node.style.transition = [theme.transitions.create('opacity', {
        duration: duration,
        delay: delay
      }), theme.transitions.create('transform', {
        duration: duration * 0.666,
        delay: delay || duration * 0.333
      })].join(',');
      node.style.opacity = '0';
      node.style.transform = getScale(0.75);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.addEndListener = function (_, next) {
      if (_this.props.timeout === 'auto') {
        _this.timer = setTimeout(next, _this.autoTimeout || 0);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Grow, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          onEnter = _this$props3.onEnter,
          onExit = _this$props3.onExit,
          styleProp = _this$props3.style,
          theme = _this$props3.theme,
          timeout = _this$props3.timeout,
          other = (0, _objectWithoutProperties2.default)(_this$props3, ["children", "onEnter", "onExit", "style", "theme", "timeout"]);
      var style = (0, _extends2.default)({}, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
        appear: true,
        onEnter: this.handleEnter,
        onExit: this.handleExit,
        addEndListener: this.addEndListener,
        timeout: timeout === 'auto' ? null : timeout
      }, other), function (state, childProps) {
        return _react.default.cloneElement(children, (0, _extends2.default)({
          style: (0, _extends2.default)({
            opacity: 0,
            transform: getScale(0.75)
          }, styles[state], style)
        }, childProps));
      });
    }
  }]);
  return Grow;
}(_react.default.Component);

 false ? Grow.propTypes = {
  /**
   * A single child content element.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),

  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: _propTypes.default.bool,

  /**
   * @ignore
   */
  onEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onExit: _propTypes.default.func,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])])
} : void 0;
Grow.defaultProps = {
  timeout: 'auto'
};
Grow.muiSupportAuto = true;

var _default = (0, _withTheme.default)()(Grow);

exports.default = _default;

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _helpers = __webpack_require__(29);

var SIZE = 44;

function getRelativeValue(value, min, max) {
  var clampedValue = Math.min(Math.max(min, value), max);
  return (clampedValue - min) / (max - min);
}

function easeOut(t) {
  t = getRelativeValue(t, 0, 1); // https://gist.github.com/gre/1650294

  t = (t -= 1) * t * t + 1;
  return t;
}

function easeIn(t) {
  return t * t;
}

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-block',
      lineHeight: 1 // Keep the progress centered

    },

    /* Styles applied to the root element if `variant="static"`. */
    static: {
      transition: theme.transitions.create('transform')
    },

    /* Styles applied to the root element if `variant="indeterminate"`. */
    indeterminate: {
      animation: 'mui-progress-circular-rotate 1.4s linear infinite',
      // Backward compatible logic between JSS v9 and v10.
      // To remove with the release of Material-UI v4
      animationName: '$mui-progress-circular-rotate'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the `svg` element. */
    svg: {},

    /* Styles applied to the `circle` svg path. */
    circle: {
      stroke: 'currentColor' // Use butt to follow the specification, by chance, it's already the default CSS value.
      // strokeLinecap: 'butt',

    },

    /* Styles applied to the `circle` svg path if `variant="static"`. */
    circleStatic: {
      transition: theme.transitions.create('stroke-dashoffset')
    },

    /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */
    circleIndeterminate: {
      animation: 'mui-progress-circular-dash 1.4s ease-in-out infinite',
      // Backward compatible logic between JSS v9 and v10.
      // To remove with the release of Material-UI v4
      animationName: '$mui-progress-circular-dash',
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: '80px, 200px',
      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.

    },
    '@keyframes mui-progress-circular-rotate': {
      '100%': {
        transform: 'rotate(360deg)'
      }
    },
    '@keyframes mui-progress-circular-dash': {
      '0%': {
        strokeDasharray: '1px, 200px',
        strokeDashoffset: '0px'
      },
      '50%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-15px'
      },
      '100%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-125px'
      }
    },

    /* Styles applied to the `circle` svg path if `disableShrink={true}`. */
    circleDisableShrink: {
      animation: 'none'
    }
  };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */


exports.styles = styles;

function CircularProgress(props) {
  var _classNames, _classNames2;

  var classes = props.classes,
      className = props.className,
      color = props.color,
      disableShrink = props.disableShrink,
      size = props.size,
      style = props.style,
      thickness = props.thickness,
      value = props.value,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"]);
  var circleStyle = {};
  var rootStyle = {};
  var rootProps = {};

  if (variant === 'determinate' || variant === 'static') {
    var circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(value);

    if (variant === 'static') {
      circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
      rootStyle.transform = 'rotate(-90deg)';
    } else {
      circleStyle.strokeDashoffset = "".concat((easeIn((100 - value) / 100) * circumference).toFixed(3), "px");
      rootStyle.transform = "rotate(".concat((easeOut(value / 70) * 270).toFixed(3), "deg)");
    }
  }

  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), (0, _defineProperty2.default)(_classNames, classes.indeterminate, variant === 'indeterminate'), (0, _defineProperty2.default)(_classNames, classes.static, variant === 'static'), _classNames), className),
    style: (0, _extends2.default)({
      width: size,
      height: size
    }, rootStyle, style),
    role: "progressbar"
  }, rootProps, other), _react.default.createElement("svg", {
    className: classes.svg,
    viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE)
  }, _react.default.createElement("circle", {
    className: (0, _classnames.default)(classes.circle, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.circleIndeterminate, variant === 'indeterminate'), (0, _defineProperty2.default)(_classNames2, classes.circleStatic, variant === 'static'), (0, _defineProperty2.default)(_classNames2, classes.circleDisableShrink, disableShrink), _classNames2)),
    style: circleStyle,
    cx: SIZE,
    cy: SIZE,
    r: (SIZE - thickness) / 2,
    fill: "none",
    strokeWidth: thickness
  })));
}

 false ? CircularProgress.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['primary', 'secondary', 'inherit']),

  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   */
  disableShrink: (0, _utils.chainPropTypes)(_propTypes.default.bool, function (props) {
    /* istanbul ignore if */
    if (props.disableShrink && props.variant !== 'indeterminate') {
      return new Error('Material-UI: you have provided the `disableShrink` property ' + 'with a variant other than `indeterminate`. This will have no effect.');
    }

    return null;
  }),

  /**
   * The size of the circle.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * The thickness of the circle.
   */
  thickness: _propTypes.default.number,

  /**
   * The value of the progress indicator for the determinate and static variants.
   * Value between 0 and 100.
   */
  value: _propTypes.default.number,

  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   */
  variant: _propTypes.default.oneOf(['determinate', 'indeterminate', 'static'])
} : void 0;
CircularProgress.defaultProps = {
  color: 'primary',
  disableShrink: false,
  size: 40,
  thickness: 3.6,
  value: 0,
  variant: 'indeterminate'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiCircularProgress',
  flip: false
})(CircularProgress);

exports.default = _default;

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isByteLength;

var _assertString = _interopRequireDefault(__webpack_require__(162));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* eslint-disable prefer-rest-params */
function isByteLength(str, options) {
  (0, _assertString.default)(str);
  var min;
  var max;

  if (_typeof(options) === 'object') {
    min = options.min || 0;
    max = options.max;
  } else {
    // backwards compatibility: isByteLength(str, min [, max])
    min = arguments[1];
    max = arguments[2];
  }

  var len = encodeURI(str).split(/%..|./).length - 1;
  return len >= min && (typeof max === 'undefined' || len <= max);
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/TeamMembersAvatars.c039d8df.svg";

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Button__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_routes__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_utils_url__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_CreateBrandspaceTop_gif__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_CreateBrandspaceTop_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_CreateBrandspaceTop_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_i18n_i18n__ = __webpack_require__(15);
var _dec,_class;/**
 * The onboarding step that allows to create a new brandspace
 */var localize=__WEBPACK_IMPORTED_MODULE_17_i18n_i18n__["a" /* default */].loc.localize;var styles=function styles(theme){return{root:{width:500,height:'100%',margin:'20px auto 0',display:'flex',flexDirection:'column',alignItems:'center'},rootWithBrandspace:{marginTop:55},title:{fontWeight:'bold',marginBottom:7},text:{marginBottom:40,fontWeight:'bold',color:"".concat(theme.palette.colors.colorWithAlpha(theme.palette.colors.zeta,0.75))},navigation:{marginTop:'auto',display:'flex',flexDirection:'column'},graphic:{width:390,marginBottom:15},form:{width:425,display:'flex',flexDirection:'column',alignItems:'center'},formSection:{'&:first-child + section':{width:'100%'},'&:last-child':{marginBottom:0}},formTitle:{textAlign:'center'},formInputName:{margin:'auto'},thumbImg:{display:'block',width:210,borderRadius:15},thumbBrandName:{textAlign:'center',margin:'10px 0 25px'}};};var getDocumentLinkWithRedirectionToOnboarding=function getDocumentLinkWithRedirectionToOnboarding(brand){var _brand$instance=brand.instance,fileid=_brand$instance.fileId,provider=_brand$instance.providerId,title=_brand$instance.title;return"".concat(__WEBPACK_IMPORTED_MODULE_13_config__["_65" /* XC_URL */],"?")+Object(__WEBPACK_IMPORTED_MODULE_14_utils_url__["c" /* makeQueryString */])(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()({fileid:fileid,provider:provider,title:title},__WEBPACK_IMPORTED_MODULE_13_config__["_64" /* WORKSPACES_PARAM */],"#".concat(Object(__WEBPACK_IMPORTED_MODULE_12_routes__["w" /* getRoute */])(__WEBPACK_IMPORTED_MODULE_12_routes__["j" /* ONBOARDING */]).slice(1))),true);};var CreateBrandspaceStep=(_dec=Object(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(CreateBrandspaceStep,_Component);function CreateBrandspaceStep(){var _this;__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,CreateBrandspaceStep);_this=__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(CreateBrandspaceStep).call(this));_this.onBrandspaceAdded=_this.onBrandspaceAdded.bind(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.onStepSkipped=_this.onStepSkipped.bind(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.state={brandspace:undefined};return _this;}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(CreateBrandspaceStep,[{key:"render",value:function render(){var classes=this.props.classes;var brandspace=this.state.brandspace;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{className:__WEBPACK_IMPORTED_MODULE_16_classnames___default()(classes.root,brandspace&&classes.rootWithBrandspace)},!brandspace&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_15__assets_CreateBrandspaceTop_gif___default.a,alt:localize('onboarding-brandspace-image-alt'),className:classes.graphic}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography___default.a,{variant:"h3",align:"center",className:classes.title,paragraph:true},localize('onboarding-brandspace-title')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography___default.a,{variant:"body2",align:"center",className:classes.text},localize('onboarding-brandspace-text')),!brandspace&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{className:classes.navigation},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Button___default.a,{disableRipple:true,"data-tid":"button-create-brandspace-next",onClick:this.onStepSkipped,size:"small"},localize('onboarding-brandspace-skip'))));}},{key:"onStepSkipped",value:function onStepSkipped(){this.props.onboarding.skipStep();}},{key:"onBrandspaceAdded",value:function onBrandspaceAdded(data){var _data$result=data.result,id=_data$result._id,displayName=_data$result.displayName,brand=_data$result.brand;this.props.onboarding.fulfillStep(true);// true means the onboarding should stay at current step
this.setState({brandspace:{id:id,displayName:displayName,brand:brand}});}},{key:"renderBrandspaceThumb",value:function renderBrandspaceThumb(){var classes=this.props.classes;var _this$state$brandspac=this.state.brandspace,displayName=_this$state$brandspac.displayName,brand=_this$state$brandspac.brand;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("img",{src:brand.thumbnailURL,title:displayName,className:classes.thumbImg}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography___default.a,{variant:"body2",className:classes.thumbBrandName},displayName),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Button___default.a,{variant:"contained",color:"primary",size:"large","data-tid":"button-create-brandspace-open-brand-style",component:"a",onClick:function onClick(){window.location=getDocumentLinkWithRedirectionToOnboarding(brand);}},localize('onboarding-brandspace-go-to-style-editor')));}}]);return CreateBrandspaceStep;}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]))||_class);CreateBrandspaceStep.oId='create-brandspace';CreateBrandspaceStep.oTitle=localize('onboarding-brandspace-o-title');CreateBrandspaceStep.oMessage=localize('onboarding-brandspace-o-message');CreateBrandspaceStep.oRoute=undefined;CreateBrandspaceStep.propTypes={classes:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,// The onboarding object that contains data from the onboarding wizard, such as methods to fulfill or skip a step
onboarding:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (CreateBrandspaceStep);

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/CreateBrandspaceTop.884e3cb1.gif";

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Link__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__index__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_utils_url__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_CongratulationStep_svg__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_CongratulationStep_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_CongratulationStep_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_routes__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_i18n_i18n__ = __webpack_require__(15);
var _dec,_class;/**
 * The onboarding step that shows the congratulation page. There are two types of this step:
 * 	- when all the steps got fulfilled
 * 	- when at least one step got skipped
 */var localize=__WEBPACK_IMPORTED_MODULE_18_i18n_i18n__["a" /* default */].loc.localize;var styles={root:{height:'100%',margin:'auto',display:'flex',flexDirection:'column',alignItems:'center',position:'relative'},title:{fontWeight:'bold',marginBottom:8},titleParagraph:{marginBottom:63},subtitle:{fontWeight:'bold'},skippedSection:{display:'flex',flexDirection:'column',alignItems:'center',marginTop:30},skippedSectionLink:{fontWeight:'bold'},navigation:{marginTop:'auto',display:'flex',flexDirection:'column'},divider:{margin:'35px 0'},graphic:{width:294,height:200,marginTop:20,background:"no-repeat url(".concat(__WEBPACK_IMPORTED_MODULE_16__assets_CongratulationStep_svg___default.a,") center"),backgroundSize:'contain'}};var OID='congratulations';var CongratulationsStep=(_dec=Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(CongratulationsStep,_Component);function CongratulationsStep(props){var _this;__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this,CongratulationsStep);_this=__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(CongratulationsStep).call(this));props.onboarding.complete();return _this;}__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(CongratulationsStep,[{key:"render",value:function render(){var _this$props=this.props,classes=_this$props.classes,company=_this$props.company;var profileRoute=Object(__WEBPACK_IMPORTED_MODULE_17_routes__["w" /* getRoute */])(__WEBPACK_IMPORTED_MODULE_17_routes__["l" /* ROOT */],company.id);var titleClassName={root:classes.title,paragraph:classes.titleParagraph};if(this.areSkippedSteps){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:classes.root},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:"h3",align:"center",classes:titleClassName},localize('onboarding-congratulations-skipped-title')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:"subtitle1",align:"center",className:classes.subtitle},localize('onboarding-congratulations-skipped-subtitle')),this.renderSkippedStepsSections(),this.renderCommonSection());}return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:classes.root},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:"h3",align:"center",classes:titleClassName,paragraph:true},localize('onboarding-congratulations-title')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:"subtitle1",align:"center",className:classes.subtitle},localize('onboarding-congratulations-subtitle')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:"body1",align:"center"},localize('onboarding-congratulations-complete-profile1'),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Link___default.a,{component:__WEBPACK_IMPORTED_MODULE_12_react_router_dom__["a" /* Link */],to:profileRoute},localize('onboarding-congratulations-complete-profile2')),"?"),this.renderCommonSection());}},{key:"renderSkippedStepsSections",value:function renderSkippedStepsSections(){var sections=[];var skipped=this.props.onboarding.skipped;var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=__WEBPACK_IMPORTED_MODULE_14__index__["b" /* default */][Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var Step=_step.value;var oId=Step.oId,rest=__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(Step,["oId"]);if(skipped.indexOf(oId)!==-1){sections.push(this.renderSkippedSection(oId,rest));}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator["return"]!=null){_iterator["return"]();}}finally{if(_didIteratorError){throw _iteratorError;}}}return sections;}},{key:"renderSkippedSection",value:function renderSkippedSection(oId,params){var _this$props2=this.props,classes=_this$props2.classes,company=_this$props2.company;var oTitle=params.oTitle,oMessage=params.oMessage,oRoute=params.oRoute;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:classes.skippedSection,key:"skipped-".concat(oId,"-section")},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Link___default.a,{variant:"body1",component:__WEBPACK_IMPORTED_MODULE_12_react_router_dom__["a" /* Link */],to:Object(__WEBPACK_IMPORTED_MODULE_17_routes__["w" /* getRoute */])(oRoute,company.id),underline:"always",gutterBottom:true,className:classes.skippedSectionLink},oTitle),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:"body1",align:"center"},oMessage));}},{key:"renderCommonSection",value:function renderCommonSection(){var _this$props3=this.props,classes=_this$props3.classes,company=_this$props3.company;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:"body1",className:classes.divider},localize('onboarding-congratulations-or')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default.a,{variant:"contained",size:"large",color:"primary",component:"a","data-tid":"button-congratulations-step-start-creating",href:Object(__WEBPACK_IMPORTED_MODULE_15_utils_url__["b" /* getLinkToEditor */])(company.displayName)},localize('onboarding-congratulations-start-creating')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:classes.graphic}));}},{key:"areSkippedSteps",get:function get(){var skipped=this.props.onboarding.skipped;return skipped.length>0;}}]);return CongratulationsStep;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]))||_class);CongratulationsStep.oId=OID;CongratulationsStep.propTypes={classes:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,onboarding:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,company:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object};var mapStateToProps=function mapStateToProps(state){return{company:state.companies.rawDataById[state.companies.selectedId]};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13_react_redux__["b" /* connect */])(mapStateToProps,undefined)(CongratulationsStep));

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/CongratulationStep.6a97a62d.svg";

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_theme_icons__ = __webpack_require__(24);
var styles=function styles(theme){return{root:{position:'absolute',left:20,bottom:15,width:70,height:25,color:theme.palette.colors.alpha,zIndex:theme.zIndex.xaraLogo}};};var XaraLogo=function XaraLogo(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_theme_icons__["_12" /* XaraLogo */],{className:props.classes.root});};XaraLogo.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["withStyles"])(styles)(XaraLogo));

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers_CloudFolder_CloudFolder__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_containers_Users_Users__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_containers_NotFound_NotFound__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_containers_NoPermissions_NoPermissions__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_containers_PageNotAvailable_PageNotAvailable__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_containers_MLSConnection_MLSConnection__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_containers_SubscriptionSuccessful_SubscriptionSuccessful__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_containers_CompanyProfile_CompanyProfile__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_containers_Subscription_Subscription__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_containers_Showcase_Showcase__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_containers_OnBoarding_OnBoarding__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_containers_Fonts_Fonts__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_containers_SmartFields_SmartFields__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_containers_XCPlus_XCPlus__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_containers_AccountDetails_AccountDetails__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_containers_Customize_Customize__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_containers_WrongAccount_WrongAccount__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_url__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_routes__ = __webpack_require__(48);
var MainContent=function MainContent(props){var onBoarding=props.onBoarding,isAdmin=props.isAdmin,isTempCompany=props.isTempCompany,plan=props.plan,isCompanyFoundInSession=props.isCompanyFoundInSession,selectedId=props.selectedId,isDesktopApp=props.isDesktopApp,isCBPlanExternalRedirect=props.isCBPlanExternalRedirect,isCBPlanInternalRedirect=props.isCBPlanInternalRedirect,isPerpetualOwner=props.isPerpetualOwner,isReAccessNoIndustry=props.isReAccessNoIndustry,mlsUiType=props.mlsUiType,navOpen=props.navOpen,couponId=props.couponId,isDiscountTakeoverFromWebsite=props.isDiscountTakeoverFromWebsite,productName=props.productName,productSource=props.productSource,productPeriod=props.productPeriod,productQuantity=props.productQuantity,magixCat=props.magixCat,isUpgradePopup=props.isUpgradePopup,realEstatePlan=props.realEstatePlan,subscriptionId=props.subscriptionId,reactivateSubscription=props.reactivateSubscription;var renderRoute=function renderRoute(Component,adminOnly){var extraProps=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var RoutingComponent=function RoutingComponent(props){if(onBoarding){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Redirect */],{to:__WEBPACK_IMPORTED_MODULE_23_routes__["j" /* ONBOARDING */]});}var _props$match=props.match,path=_props$match.path,_props$match$params=_props$match.params,currency=_props$match$params.currency,planId=_props$match$params.planId;// First we check if company is in session, before using isAdmin and isTempCompany as these are
// resolved based on companies.selectedId which might be from other account
if(!isCompanyFoundInSession){var queryParams=Object(__WEBPACK_IMPORTED_MODULE_22__utils_url__["d" /* parseQuery */])(props.location.search);var queryParamsCurrency=queryParams['currency'];var queryParamsProductName=queryParams['prod'];var queryParamsProductSource=queryParams['source'];var queryParamsProductPeriod=queryParams['period'];var queryParamsProductQuantity=productQuantity;var queryParamsProductLanguage=queryParams['lang'];var queryParamsMagixSerial=queryParams['pserial'];var queryParamsMagixEmail=queryParams['pemail'];var queryParamsMagixCat=queryParams['pcat'];if(queryParams['currency']){delete queryParams['currency'];}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Redirect */],{to:{pathname:Object(__WEBPACK_IMPORTED_MODULE_23_routes__["w" /* getRoute */])(__WEBPACK_IMPORTED_MODULE_23_routes__["u" /* WRONG_ACCOUNT */],selectedId),state:{prevLocationPath:path,prevLocationSearch:queryParams,prevLocationCurrency:currency||queryParamsCurrency,prevLocationProductName:queryParamsProductName,prevLocationProductSource:queryParamsProductSource,prevLocationProductPeriod:queryParamsProductPeriod,prevLocationProductQuantity:queryParamsProductQuantity,prevLocationProductLanguage:queryParamsProductLanguage,prevLocationMagixSerial:queryParamsMagixSerial,prevLocationMagixEmail:queryParamsMagixEmail,prevLocationMagixCat:queryParamsMagixCat,prevLocationCouponId:couponId,prevLocationPlanId:planId,prevLocationUpgradePopup:isUpgradePopup,prevLocationRealEstatePlan:realEstatePlan,prevLocationIsCBPlanExternalRedirect:isCBPlanExternalRedirect,prevLocationIsCBPlanInternalRedirect:isCBPlanInternalRedirect,isDesktopApp:isDesktopApp}}});}// Show No Permission screen if
// Route is not available for not admins
// OR Route is not available for companies with a temporary name ([P9052-15208] PDF simplified workflow)
// Always show Team profile and Users and permissions tab for Team/Team+ [P9052-20321]
if(adminOnly&&!isAdmin||extraProps.showForType2Only&&mlsUiType!==__WEBPACK_IMPORTED_MODULE_20__config__["_0" /* MLS_UI */].SELF_CONNECT_API||isDesktopApp&&extraProps.hideForDesktop===true||isTempCompany&&extraProps.isVisibleForTempTeams!==true&&!(extraProps.isVisibleForDesktopTempTeams&&isDesktopApp)&&!(extraProps.showForPerpetualOwners&&isPerpetualOwner)&&!(extraProps.showInIsReAccessNoIndustryMode&&isReAccessNoIndustry)&&(!extraProps.showForTempCompanyOnPlan||!extraProps.showForTempCompanyOnPlan.includes(plan))){if(adminOnly&&!isAdmin){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Redirect */],{to:__WEBPACK_IMPORTED_MODULE_23_routes__["i" /* NO_PERMISSIONS */]});}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Redirect */],{to:Object(__WEBPACK_IMPORTED_MODULE_23_routes__["w" /* getRoute */])(__WEBPACK_IMPORTED_MODULE_23_routes__["k" /* PAGE_NOT_AVAILABLE */],selectedId)});}}// Add flag to show "complete team profile" modal if user has temporary company and is trying to see user component
if(extraProps.checkForCompletedCompany&&isTempCompany&&extraProps.isVisibleForTempTeams!==true){extraProps.askToCompleteCompanyProfile=true;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component,__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({},props,extraProps));};RoutingComponent.displayName='RoutingComponent';return RoutingComponent;};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23_routes__["s" /* UI */],component:__WEBPACK_IMPORTED_MODULE_13_containers_Showcase_Showcase__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23_routes__["h" /* NOT_FOUND */],component:__WEBPACK_IMPORTED_MODULE_6_containers_NotFound_NotFound__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23_routes__["u" /* WRONG_ACCOUNT */],component:__WEBPACK_IMPORTED_MODULE_21_containers_WrongAccount_WrongAccount__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23_routes__["i" /* NO_PERMISSIONS */],component:__WEBPACK_IMPORTED_MODULE_7_containers_NoPermissions_NoPermissions__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23_routes__["k" /* PAGE_NOT_AVAILABLE */],component:__WEBPACK_IMPORTED_MODULE_8_containers_PageNotAvailable_PageNotAvailable__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23_routes__["j" /* ONBOARDING */],component:__WEBPACK_IMPORTED_MODULE_14_containers_OnBoarding_OnBoarding__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23_routes__["d" /* CLOUD_FOLDER_TAB_ASSET */],render:renderRoute(__WEBPACK_IMPORTED_MODULE_4_containers_CloudFolder_CloudFolder__["a" /* default */],true)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23_routes__["c" /* CLOUD_FOLDER_TAB */],render:renderRoute(__WEBPACK_IMPORTED_MODULE_4_containers_CloudFolder_CloudFolder__["a" /* default */],true)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23_routes__["b" /* CLOUD_FOLDER */],render:renderRoute(__WEBPACK_IMPORTED_MODULE_4_containers_CloudFolder_CloudFolder__["a" /* default */],true,{hideForDesktop:true,showForTempCompanyOnPlan:Object(__WEBPACK_IMPORTED_MODULE_20__config__["_68" /* getCloudPlans */])()})}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23_routes__["p" /* SUBSCRIPTION_PLUS_OVERVIEW */],render:renderRoute(__WEBPACK_IMPORTED_MODULE_12_containers_Subscription_Subscription__["a" /* default */],false,{plusOverview:true,isVisibleForTempTeams:true,isDiscountTakeoverFromWebsite:isDiscountTakeoverFromWebsite,isCBPlanInternalRedirect:isCBPlanInternalRedirect,productName:productName,productSource:productSource,productPeriod:productPeriod,productQuantity:productQuantity,magixCat:magixCat,couponId:couponId,navOpen:navOpen})}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23_routes__["o" /* SUBSCRIPTION_PERPETUAL_OVERVIEW */],render:renderRoute(__WEBPACK_IMPORTED_MODULE_12_containers_Subscription_Subscription__["a" /* default */],false,{perpetualOverview:true,productName:productName,productSource:productSource,productQuantity:productQuantity,isVisibleForTempTeams:true,isCBPlanInternalRedirect:isCBPlanInternalRedirect,navOpen:navOpen,couponId:couponId})}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23_routes__["r" /* SUBSCRIPTION_UPGRADE */],render:renderRoute(__WEBPACK_IMPORTED_MODULE_12_containers_Subscription_Subscription__["a" /* default */],true,{isVisibleForTempTeams:true,productName:productName,productSource:productSource,productPeriod:productPeriod,productQuantity:productQuantity,couponId:couponId,isCBPlanExternalRedirect:isCBPlanExternalRedirect,isCBPlanInternalRedirect:isCBPlanInternalRedirect,navOpen:navOpen})}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23_routes__["n" /* SUBSCRIPTION */],render:renderRoute(__WEBPACK_IMPORTED_MODULE_12_containers_Subscription_Subscription__["a" /* default */],true,{isCBPlanExternalRedirect:isCBPlanExternalRedirect,isCBPlanInternalRedirect:isCBPlanInternalRedirect,navOpen:navOpen,isVisibleForTempTeams:true,productName:productName,productSource:productSource,productPeriod:productPeriod,productQuantity:productQuantity,magixCat:magixCat,realEstatePlan:realEstatePlan,couponId:couponId,reactivateSubscription:reactivateSubscription,isStandardProductOverview:true})}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23_routes__["q" /* SUBSCRIPTION_SUCCESSFUL */],render:renderRoute(__WEBPACK_IMPORTED_MODULE_10_containers_SubscriptionSuccessful_SubscriptionSuccessful__["a" /* default */],true,{isVisibleForTempTeams:true,subscriptionId:subscriptionId})}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23_routes__["t" /* USERS */],render:renderRoute(__WEBPACK_IMPORTED_MODULE_5_containers_Users_Users__["a" /* default */],true,{checkForCompletedCompany:true,showForTempCompanyOnPlan:[__WEBPACK_IMPORTED_MODULE_20__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT,__WEBPACK_IMPORTED_MODULE_20__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES,__WEBPACK_IMPORTED_MODULE_20__config__["_42" /* SUBSCRIPTION_PLAN */].TEAM_PLUS,__WEBPACK_IMPORTED_MODULE_20__config__["_42" /* SUBSCRIPTION_PLAN */].ESSENTIAL,__WEBPACK_IMPORTED_MODULE_20__config__["_42" /* SUBSCRIPTION_PLAN */].WEB,__WEBPACK_IMPORTED_MODULE_20__config__["_42" /* SUBSCRIPTION_PLAN */].DESIGNER,__WEBPACK_IMPORTED_MODULE_20__config__["_42" /* SUBSCRIPTION_PLAN */].PHOTO],isVisibleForDesktopTempTeams:true,showForPerpetualOwners:true,showInIsReAccessNoIndustryMode:true})}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23_routes__["g" /* MLS_CONNECTION */],render:renderRoute(__WEBPACK_IMPORTED_MODULE_9_containers_MLSConnection_MLSConnection__["a" /* default */],true,{checkForCompletedCompany:true,hideForDesktop:true,showForType2Only:true})}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23_routes__["f" /* FONTS */],render:renderRoute(__WEBPACK_IMPORTED_MODULE_15_containers_Fonts_Fonts__["a" /* default */],true,{hideForDesktop:true,showForTempCompanyOnPlan:Object(__WEBPACK_IMPORTED_MODULE_20__config__["_68" /* getCloudPlans */])()})}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23_routes__["m" /* SMART_FIELDS */],render:renderRoute(__WEBPACK_IMPORTED_MODULE_16_containers_SmartFields_SmartFields__["a" /* default */],true,{hideForDesktop:true,showForTempCompanyOnPlan:Object(__WEBPACK_IMPORTED_MODULE_20__config__["_68" /* getCloudPlans */])()})}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23_routes__["v" /* XC_PLUS */],render:renderRoute(__WEBPACK_IMPORTED_MODULE_17_containers_XCPlus_XCPlus__["a" /* default */],false,{isVisibleForTempTeams:true})}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23_routes__["a" /* ACCOUNT_DETAILS */],render:renderRoute(__WEBPACK_IMPORTED_MODULE_18_containers_AccountDetails_AccountDetails__["a" /* default */],false,{isVisibleForTempTeams:true})}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23_routes__["e" /* CUSTOMIZE */],render:renderRoute(__WEBPACK_IMPORTED_MODULE_19_containers_Customize_Customize__["a" /* default */],false,{isVisibleForTempTeams:false,hideForDesktop:true,showForTempCompanyOnPlan:Object(__WEBPACK_IMPORTED_MODULE_20__config__["_68" /* getCloudPlans */])()})}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23_routes__["l" /* ROOT */],exact:true,render:renderRoute(__WEBPACK_IMPORTED_MODULE_11_containers_CompanyProfile_CompanyProfile__["a" /* default */],false,{showForTempCompanyOnPlan:[__WEBPACK_IMPORTED_MODULE_20__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT,__WEBPACK_IMPORTED_MODULE_20__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES,__WEBPACK_IMPORTED_MODULE_20__config__["_42" /* SUBSCRIPTION_PLAN */].TEAM_PLUS,__WEBPACK_IMPORTED_MODULE_20__config__["_42" /* SUBSCRIPTION_PLAN */].ESSENTIAL,__WEBPACK_IMPORTED_MODULE_20__config__["_42" /* SUBSCRIPTION_PLAN */].WEB,__WEBPACK_IMPORTED_MODULE_20__config__["_42" /* SUBSCRIPTION_PLAN */].DESIGNER,__WEBPACK_IMPORTED_MODULE_20__config__["_42" /* SUBSCRIPTION_PLAN */].PHOTO],isVisibleForDesktopTempTeams:true,showForPerpetualOwners:true,showInIsReAccessNoIndustryMode:true})}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:"/",exact:true,render:renderRoute(__WEBPACK_IMPORTED_MODULE_11_containers_CompanyProfile_CompanyProfile__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Redirect */],{to:__WEBPACK_IMPORTED_MODULE_23_routes__["h" /* NOT_FOUND */]}));};MainContent.propTypes={onBoarding:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,isAdmin:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,isTempCompany:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,match:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,plan:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,selectedId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,isCompanyFoundInSession:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,isDesktopApp:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,couponId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,isDiscountTakeoverFromWebsite:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,isCBPlanExternalRedirect:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,isCBPlanInternalRedirect:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,magixCat:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,isUpgradePopup:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,realEstatePlan:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,reactivateSubscription:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,navOpen:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,isPerpetualOwner:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,isReAccessNoIndustry:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,mlsUiType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,productName:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,currency:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,productSource:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,productPeriod:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,productQuantity:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,subscriptionId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,location:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({search:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string})};/* harmony default export */ __webpack_exports__["a"] = (MainContent);

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Tabs__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_TeamFolders_Documents__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_TeamFolders_Assets__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_router_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_routes__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_CenteredContent_CenteredContent__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_i18n_i18n__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_lodash__);
var _dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_20_i18n_i18n__["a" /* default */].loc.localize;var TABS={ASSETS:'assets'};var styles=function styles(theme){return{root:{background:"linear-gradient(to bottom, #eee ".concat(9*theme.spacing.unit,"px, #fff ").concat(9*theme.spacing.unit,"px)")},tabContent:{paddingTop:"".concat(6*theme.spacing.unit,"px")},centeredContent:{paddingTop:"".concat(3*theme.spacing.unit,"px")}};};var CloudFolder=(_dec=Object(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(CloudFolder,_Component);function CloudFolder(){var _getPrototypeOf2;var _this;__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this,CloudFolder);for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}_this=__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this,(_getPrototypeOf2=__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(CloudFolder)).call.apply(_getPrototypeOf2,[this].concat(args)));__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this),"state",{tab:0});__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this),"handleTabChange",function(event,value){_this.setState({tab:value});});return _this;}__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(CloudFolder,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps,nextContext){var match=nextProps.match,_nextProps$folders=nextProps.folders,image=_nextProps$folders.image,logo=_nextProps$folders.logo,component=_nextProps$folders.component;var tab=match.params.tab&&match.params.tab.toLowerCase();var tabValue=tab===TABS.ASSETS&&this.areAssetsFoldersConnected(image,logo,component)?1:0;if(match.params.tab&&this.state.tab!==tabValue){this.handleTabChange(null,tabValue);}}/**
	 * Check if any assets cloud folders are connected
	 *
	 * @param {*} image Image cloud folders array
	 * @param {*} logo Logo cloud folders array
	 * @param {*} component Component cloud folders array
	 * @returns
	 * @memberof CloudFolder
	 */},{key:"areAssetsFoldersConnected",value:function areAssetsFoldersConnected(image,logo,component){return image.length>0||logo.length>0||component.length>0;}},{key:"render",value:function render(){var tab=this.state.tab;var _this$props=this.props,_this$props$classes=_this$props.classes,root=_this$props$classes.root,tabContent=_this$props$classes.tabContent,centeredContent=_this$props$classes.centeredContent,match=_this$props.match,_this$props$folders=_this$props.folders,image=_this$props$folders.image,logo=_this$props$folders.logo,component=_this$props$folders.component;var tabRoute=__WEBPACK_IMPORTED_MODULE_18_routes__["c" /* CLOUD_FOLDER_TAB */].replace(':companyId',match.params.companyId);var showAssetsTab=this.areAssetsFoldersConnected(image,logo,component);return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:root},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_CenteredContent_CenteredContent__["a" /* default */],{className:centeredContent},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Tabs___default.a,{value:tab},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab___default.a,{label:localize('cloud-folders-documents'),disableRipple:true,"data-tid":"tab-cloud-documents",component:__WEBPACK_IMPORTED_MODULE_17_react_router_dom__["a" /* Link */],to:tabRoute.replace(':tab','documents')}),showAssetsTab&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab___default.a,{label:localize('cloud-folders-assets'),"data-tid":"tab-cloud-assets",disableRipple:true,component:__WEBPACK_IMPORTED_MODULE_17_react_router_dom__["a" /* Link */],to:tabRoute.replace(':tab','assets')})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:tabContent},tab===0&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_TeamFolders_Documents__["a" /* default */],{match:match,type:"document"}),showAssetsTab&&tab===1&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_TeamFolders_Assets__["a" /* default */],{match:match,folders:{image:image,logo:logo,component:component}}))));}}]);return CloudFolder;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]))||_class);var mapStateToProps=function mapStateToProps(state){return{cloudFolders:__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state.cloudFolders,{documentFolder:null,imageFolder:null}),folders:__WEBPACK_IMPORTED_MODULE_21_lodash___default.a.get(state.companies.rawDataById[state.companies.selectedId],'folders',{})};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_14_redux__["b" /* bindActionCreators */])({},dispatch);};CloudFolder.propTypes={match:__WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.object.isRequired,classes:__WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.object,cloudFolders:__WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.object,folders:__WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(CloudFolder));

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _warning = _interopRequireDefault(__webpack_require__(27));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _reactEventListener = _interopRequireDefault(__webpack_require__(94));

var _debounce = _interopRequireDefault(__webpack_require__(125));

var _normalizeScrollLeft = __webpack_require__(937);

var _utils = __webpack_require__(14);

var _animate = _interopRequireDefault(__webpack_require__(938));

var _ScrollbarSize = _interopRequireDefault(__webpack_require__(939));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _TabIndicator = _interopRequireDefault(__webpack_require__(940));

var _TabScrollButton = _interopRequireDefault(__webpack_require__(941));

var _deprecatedPropType = _interopRequireDefault(__webpack_require__(436));

/* eslint-disable no-restricted-globals */
// < 1kb payload overhead when lodash/debounce is > 3kb.
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      overflow: 'hidden',
      minHeight: 48,
      WebkitOverflowScrolling: 'touch' // Add iOS momentum scrolling.

    },

    /* Styles applied to the flex container element. */
    flexContainer: {
      display: 'flex'
    },

    /* Styles applied to the flex container element if `centered={true}` & `!variant="scrollable"`. */
    centered: {
      justifyContent: 'center'
    },

    /* Styles applied to the tablist element. */
    scroller: {
      position: 'relative',
      display: 'inline-block',
      flex: '1 1 auto',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the tablist element if `!variant="scrollable"`. */
    fixed: {
      overflowX: 'hidden',
      width: '100%'
    },

    /* Styles applied to the tablist element if `variant="scrollable"`. */
    scrollable: {
      overflowX: 'scroll'
    },

    /* Styles applied to the `ScrollButtonComponent` component. */
    scrollButtons: {},

    /* Styles applied to the `ScrollButtonComponent` component if `scrollButtons="auto"`. */
    scrollButtonsAuto: (0, _defineProperty2.default)({}, theme.breakpoints.down('xs'), {
      display: 'none'
    }),

    /* Styles applied to the `TabIndicator` component. */
    indicator: {}
  };
};

exports.styles = styles;

var Tabs =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Tabs, _React$Component);

  function Tabs() {
    var _this;

    (0, _classCallCheck2.default)(this, Tabs);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Tabs).call(this));
    _this.state = {
      indicatorStyle: {},
      scrollerStyle: {
        marginBottom: 0
      },
      showLeftScroll: false,
      showRightScroll: false,
      mounted: false
    };

    _this.getConditionalElements = function () {
      var _this$props = _this.props,
          classes = _this$props.classes,
          deprecatedScrollable = _this$props.scrollable,
          ScrollButtonComponent = _this$props.ScrollButtonComponent,
          scrollButtons = _this$props.scrollButtons,
          theme = _this$props.theme,
          variant = _this$props.variant;
      var conditionalElements = {};
      var scrollable = variant === 'scrollable' || deprecatedScrollable;
      conditionalElements.scrollbarSizeListener = scrollable ? _react.default.createElement(_ScrollbarSize.default, {
        onChange: _this.handleScrollbarSizeChange
      }) : null;
      var showScrollButtons = scrollable && (scrollButtons === 'auto' || scrollButtons === 'on');
      conditionalElements.scrollButtonLeft = showScrollButtons ? _react.default.createElement(ScrollButtonComponent, {
        direction: theme && theme.direction === 'rtl' ? 'right' : 'left',
        onClick: _this.handleLeftScrollClick,
        visible: _this.state.showLeftScroll,
        className: (0, _classnames.default)(classes.scrollButtons, (0, _defineProperty2.default)({}, classes.scrollButtonsAuto, scrollButtons === 'auto'))
      }) : null;
      conditionalElements.scrollButtonRight = showScrollButtons ? _react.default.createElement(ScrollButtonComponent, {
        direction: theme && theme.direction === 'rtl' ? 'left' : 'right',
        onClick: _this.handleRightScrollClick,
        visible: _this.state.showRightScroll,
        className: (0, _classnames.default)(classes.scrollButtons, (0, _defineProperty2.default)({}, classes.scrollButtonsAuto, scrollButtons === 'auto'))
      }) : null;
      return conditionalElements;
    };

    _this.getTabsMeta = function (value, direction) {
      var tabsMeta;

      if (_this.tabsRef) {
        var rect = _this.tabsRef.getBoundingClientRect(); // create a new object with ClientRect class props + scrollLeft


        tabsMeta = {
          clientWidth: _this.tabsRef.clientWidth,
          scrollLeft: _this.tabsRef.scrollLeft,
          scrollLeftNormalized: (0, _normalizeScrollLeft.getNormalizedScrollLeft)(_this.tabsRef, direction),
          scrollWidth: _this.tabsRef.scrollWidth,
          left: rect.left,
          right: rect.right
        };
      }

      var tabMeta;

      if (_this.tabsRef && value !== false) {
        var children = _this.tabsRef.children[0].children;

        if (children.length > 0) {
          var tab = children[_this.valueToIndex.get(value)];

           false ? (0, _warning.default)(tab, ["Material-UI: the value provided `".concat(value, "` to the Tabs component is invalid."), 'None of the Tabs children have this value.', _this.valueToIndex.keys ? "You can provide one of the following values: ".concat(Array.from(_this.valueToIndex.keys()).join(', '), ".") : null].join('\n')) : void 0;
          tabMeta = tab ? tab.getBoundingClientRect() : null;
        }
      }

      return {
        tabsMeta: tabsMeta,
        tabMeta: tabMeta
      };
    };

    _this.handleLeftScrollClick = function () {
      _this.moveTabsScroll(-_this.tabsRef.clientWidth);
    };

    _this.handleRightScrollClick = function () {
      _this.moveTabsScroll(_this.tabsRef.clientWidth);
    };

    _this.handleScrollbarSizeChange = function (scrollbarHeight) {
      _this.setState({
        scrollerStyle: {
          marginBottom: -scrollbarHeight
        }
      });
    };

    _this.moveTabsScroll = function (delta) {
      var theme = _this.props.theme;
      var multiplier = theme.direction === 'rtl' ? -1 : 1;
      var nextScrollLeft = _this.tabsRef.scrollLeft + delta * multiplier; // Fix for Edge

      var invert = theme.direction === 'rtl' && (0, _normalizeScrollLeft.detectScrollType)() === 'reverse' ? -1 : 1;

      _this.scroll(invert * nextScrollLeft);
    };

    _this.scrollSelectedIntoView = function () {
      var _this$props2 = _this.props,
          theme = _this$props2.theme,
          value = _this$props2.value;

      var _this$getTabsMeta = _this.getTabsMeta(value, theme.direction),
          tabsMeta = _this$getTabsMeta.tabsMeta,
          tabMeta = _this$getTabsMeta.tabMeta;

      if (!tabMeta || !tabsMeta) {
        return;
      }

      if (tabMeta.left < tabsMeta.left) {
        // left side of button is out of view
        var nextScrollLeft = tabsMeta.scrollLeft + (tabMeta.left - tabsMeta.left);

        _this.scroll(nextScrollLeft);
      } else if (tabMeta.right > tabsMeta.right) {
        // right side of button is out of view
        var _nextScrollLeft = tabsMeta.scrollLeft + (tabMeta.right - tabsMeta.right);

        _this.scroll(_nextScrollLeft);
      }
    };

    _this.scroll = function (value) {
      (0, _animate.default)('scrollLeft', _this.tabsRef, value);
    };

    _this.updateScrollButtonState = function () {
      var _this$props3 = _this.props,
          deprecatedScrollable = _this$props3.scrollable,
          scrollButtons = _this$props3.scrollButtons,
          theme = _this$props3.theme,
          variant = _this$props3.variant;
      var scrollable = variant === 'scrollable' || deprecatedScrollable;

      if (scrollable && scrollButtons !== 'off') {
        var _this$tabsRef = _this.tabsRef,
            scrollWidth = _this$tabsRef.scrollWidth,
            clientWidth = _this$tabsRef.clientWidth;
        var scrollLeft = (0, _normalizeScrollLeft.getNormalizedScrollLeft)(_this.tabsRef, theme.direction);
        var showLeftScroll = theme.direction === 'rtl' ? scrollWidth > clientWidth + scrollLeft : scrollLeft > 0;
        var showRightScroll = theme.direction === 'rtl' ? scrollLeft > 0 : scrollWidth > clientWidth + scrollLeft;

        if (showLeftScroll !== _this.state.showLeftScroll || showRightScroll !== _this.state.showRightScroll) {
          _this.setState({
            showLeftScroll: showLeftScroll,
            showRightScroll: showRightScroll
          });
        }
      }
    };

    if (typeof window !== 'undefined') {
      _this.handleResize = (0, _debounce.default)(function () {
        _this.updateIndicatorState(_this.props);

        _this.updateScrollButtonState();
      }, 166); // Corresponds to 10 frames at 60 Hz.

      _this.handleTabsScroll = (0, _debounce.default)(function () {
        _this.updateScrollButtonState();
      }, 166); // Corresponds to 10 frames at 60 Hz.
    }

    return _this;
  }

  (0, _createClass2.default)(Tabs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        mounted: true
      });
      this.updateIndicatorState(this.props);
      this.updateScrollButtonState();

      if (this.props.action) {
        this.props.action({
          updateIndicator: this.handleResize
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // The index might have changed at the same time.
      // We need to check again the right indicator position.
      this.updateIndicatorState(this.props);
      this.updateScrollButtonState();

      if (this.state.indicatorStyle !== prevState.indicatorStyle) {
        this.scrollSelectedIntoView();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleResize.clear();
      this.handleTabsScroll.clear();
    }
  }, {
    key: "updateIndicatorState",
    value: function updateIndicatorState(props) {
      var theme = props.theme,
          value = props.value;

      var _this$getTabsMeta2 = this.getTabsMeta(value, theme.direction),
          tabsMeta = _this$getTabsMeta2.tabsMeta,
          tabMeta = _this$getTabsMeta2.tabMeta;

      var left = 0;

      if (tabMeta && tabsMeta) {
        var correction = theme.direction === 'rtl' ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
        left = Math.round(tabMeta.left - tabsMeta.left + correction);
      }

      var indicatorStyle = {
        left: left,
        // May be wrong until the font is loaded.
        width: tabMeta ? Math.round(tabMeta.width) : 0
      };

      if ((indicatorStyle.left !== this.state.indicatorStyle.left || indicatorStyle.width !== this.state.indicatorStyle.width) && !isNaN(indicatorStyle.left) && !isNaN(indicatorStyle.width)) {
        this.setState({
          indicatorStyle: indicatorStyle
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames4,
          _this2 = this;

      var _this$props4 = this.props,
          action = _this$props4.action,
          centered = _this$props4.centered,
          childrenProp = _this$props4.children,
          classes = _this$props4.classes,
          classNameProp = _this$props4.className,
          Component = _this$props4.component,
          _this$props4$fullWidt = _this$props4.fullWidth,
          fullWidth = _this$props4$fullWidt === void 0 ? false : _this$props4$fullWidt,
          indicatorColor = _this$props4.indicatorColor,
          onChange = _this$props4.onChange,
          _this$props4$scrollab = _this$props4.scrollable,
          deprecatedScrollable = _this$props4$scrollab === void 0 ? false : _this$props4$scrollab,
          ScrollButtonComponent = _this$props4.ScrollButtonComponent,
          scrollButtons = _this$props4.scrollButtons,
          _this$props4$TabIndic = _this$props4.TabIndicatorProps,
          TabIndicatorProps = _this$props4$TabIndic === void 0 ? {} : _this$props4$TabIndic,
          textColor = _this$props4.textColor,
          theme = _this$props4.theme,
          value = _this$props4.value,
          variant = _this$props4.variant,
          other = (0, _objectWithoutProperties2.default)(_this$props4, ["action", "centered", "children", "classes", "className", "component", "fullWidth", "indicatorColor", "onChange", "scrollable", "ScrollButtonComponent", "scrollButtons", "TabIndicatorProps", "textColor", "theme", "value", "variant"]);
      var scrollable = variant === 'scrollable' || deprecatedScrollable;
       false ? (0, _warning.default)(!centered || !scrollable, 'Material-UI: you can not use the `centered={true}` and `variant="scrollable"` properties ' + 'at the same time on a `Tabs` component.') : void 0;
      var className = (0, _classnames.default)(classes.root, classNameProp);
      var flexContainerClassName = (0, _classnames.default)(classes.flexContainer, (0, _defineProperty2.default)({}, classes.centered, centered && !scrollable));
      var scrollerClassName = (0, _classnames.default)(classes.scroller, (_classNames4 = {}, (0, _defineProperty2.default)(_classNames4, classes.fixed, !scrollable), (0, _defineProperty2.default)(_classNames4, classes.scrollable, scrollable), _classNames4));

      var indicator = _react.default.createElement(_TabIndicator.default, (0, _extends2.default)({
        className: classes.indicator,
        color: indicatorColor
      }, TabIndicatorProps, {
        style: (0, _extends2.default)({}, this.state.indicatorStyle, TabIndicatorProps.style)
      }));

      this.valueToIndex = new Map();
      var childIndex = 0;

      var children = _react.default.Children.map(childrenProp, function (child) {
        if (!_react.default.isValidElement(child)) {
          return null;
        }

         false ? (0, _warning.default)(child.type !== _react.default.Fragment, ["Material-UI: the Tabs component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n')) : void 0;
        var childValue = child.props.value === undefined ? childIndex : child.props.value;

        _this2.valueToIndex.set(childValue, childIndex);

        var selected = childValue === value;
        childIndex += 1;
        return _react.default.cloneElement(child, {
          fullWidth: variant === 'fullWidth' || fullWidth,
          indicator: selected && !_this2.state.mounted && indicator,
          selected: selected,
          onChange: onChange,
          textColor: textColor,
          value: childValue
        });
      });

      var conditionalElements = this.getConditionalElements();
      return _react.default.createElement(Component, (0, _extends2.default)({
        className: className
      }, other), _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }), conditionalElements.scrollbarSizeListener, _react.default.createElement("div", {
        className: classes.flexContainer
      }, conditionalElements.scrollButtonLeft, _react.default.createElement("div", {
        className: scrollerClassName,
        style: this.state.scrollerStyle,
        ref: function ref(_ref) {
          _this2.tabsRef = _ref;
        },
        role: "tablist",
        onScroll: this.handleTabsScroll
      }, _react.default.createElement("div", {
        className: flexContainerClassName
      }, children), this.state.mounted && indicator), conditionalElements.scrollButtonRight));
    }
  }]);
  return Tabs;
}(_react.default.Component);

 false ? Tabs.propTypes = {
  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It currently only supports `updateIndicator()` action.
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: _propTypes.default.func,

  /**
   * If `true`, the tabs will be centered.
   * This property is intended for large views.
   */
  centered: _propTypes.default.bool,

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * If `true`, the tabs will grow to use all the available space.
   * This property is intended for small views, like on mobile.
   */
  fullWidth: (0, _deprecatedPropType.default)(_propTypes.default.bool, 'Instead, use the `variant="fullWidth"` property.'),

  /**
   * Determines the color of the indicator.
   */
  indicatorColor: _propTypes.default.oneOf(['secondary', 'primary']),

  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback
   * @param {number} value We default to the index of the child
   */
  onChange: _propTypes.default.func,

  /**
   * If `true`, it will invoke scrolling properties and allow for horizontally
   * scrolling (or swiping) of the tab bar.
   */
  scrollable: (0, _deprecatedPropType.default)(_propTypes.default.bool, 'Instead, use the `variant="scrollable"` property.'),

  /**
   * The component used to render the scroll buttons.
   */
  ScrollButtonComponent: _utils.componentPropType,

  /**
   * Determine behavior of scroll buttons when tabs are set to scroll
   * `auto` will only present them on medium and larger viewports
   * `on` will always present them
   * `off` will never present them
   */
  scrollButtons: _propTypes.default.oneOf(['auto', 'on', 'off']),

  /**
   * Properties applied to the `TabIndicator` element.
   */
  TabIndicatorProps: _propTypes.default.object,

  /**
   * Determines the color of the `Tab`.
   */
  textColor: _propTypes.default.oneOf(['secondary', 'primary', 'inherit']),

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this property to `false`.
   */
  value: _propTypes.default.any,

  /**
   *  Determines additional display behavior of the tabs:
   *  - `scrollable` will invoke scrolling properties and allow for horizontally
   *  scrolling (or swiping) of the tab bar.
   *  -`fullWidth` will make the tabs grow to use all the available space,
   *  which should be used for small views, like on mobile.
   *  - `standard` will render the default state.
   */
  variant: _propTypes.default.oneOf(['standard', 'scrollable', 'fullWidth'])
} : void 0;
Tabs.defaultProps = {
  centered: false,
  component: 'div',
  indicatorColor: 'secondary',
  ScrollButtonComponent: _TabScrollButton.default,
  scrollButtons: 'auto',
  textColor: 'inherit',
  variant: 'standard'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTabs',
  withTheme: true
})(Tabs);

exports.default = _default;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// Based on https://github.com/react-bootstrap/dom-helpers/blob/master/src/util/inDOM.js
var inDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var cachedType;
function _setScrollType(type) {
    cachedType = type;
}
exports._setScrollType = _setScrollType;
// Based on the jquery plugin https://github.com/othree/jquery.rtl-scroll-type
function detectScrollType() {
    if (cachedType) {
        return cachedType;
    }
    if (!inDOM || !window.document.body) {
        return 'indeterminate';
    }
    var dummy = window.document.createElement('div');
    dummy.appendChild(document.createTextNode('ABCD'));
    dummy.dir = 'rtl';
    dummy.style.fontSize = '14px';
    dummy.style.width = '4px';
    dummy.style.height = '1px';
    dummy.style.position = 'absolute';
    dummy.style.top = '-1000px';
    dummy.style.overflow = 'scroll';
    document.body.appendChild(dummy);
    cachedType = 'reverse';
    if (dummy.scrollLeft > 0) {
        cachedType = 'default';
    }
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) {
            cachedType = 'negative';
        }
    }
    document.body.removeChild(dummy);
    return cachedType;
}
exports.detectScrollType = detectScrollType;
// Based on https://stackoverflow.com/a/24394376
function getNormalizedScrollLeft(element, direction) {
    var scrollLeft = element.scrollLeft;
    // Perform the calculations only when direction is rtl to avoid messing up the ltr bahavior
    if (direction !== 'rtl') {
        return scrollLeft;
    }
    var type = detectScrollType();
    if (type === 'indeterminate') {
        return Number.NaN;
    }
    switch (type) {
        case 'negative':
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case 'reverse':
            return element.scrollWidth - element.clientWidth - scrollLeft;
    }
    return scrollLeft;
}
exports.getNormalizedScrollLeft = getNormalizedScrollLeft;
function setNormalizedScrollLeft(element, scrollLeft, direction) {
    // Perform the calculations only when direction is rtl to avoid messing up the ltr bahavior
    if (direction !== 'rtl') {
        element.scrollLeft = scrollLeft;
        return;
    }
    var type = detectScrollType();
    if (type === 'indeterminate') {
        return;
    }
    switch (type) {
        case 'negative':
            element.scrollLeft = element.clientWidth - element.scrollWidth + scrollLeft;
            break;
        case 'reverse':
            element.scrollLeft = element.scrollWidth - element.clientWidth - scrollLeft;
            break;
        default:
            element.scrollLeft = scrollLeft;
            break;
    }
}
exports.setNormalizedScrollLeft = setNormalizedScrollLeft;


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function easeInOutSin(time) {
  return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}

function animate(prop, element, to) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var cb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
  var _options$ease = options.ease,
      ease = _options$ease === void 0 ? easeInOutSin : _options$ease,
      _options$duration = options.duration,
      duration = _options$duration === void 0 ? 300 : _options$duration;
  var start = null;
  var from = element[prop];
  var cancelled = false;

  var cancel = function cancel() {
    cancelled = true;
  };

  var step = function step(timestamp) {
    if (cancelled) {
      cb(new Error('Animation cancelled'));
      return;
    }

    if (start === null) {
      start = timestamp;
    }

    var time = Math.min(1, (timestamp - start) / duration);
    element[prop] = ease(time) * (to - from) + from;

    if (time >= 1) {
      requestAnimationFrame(function () {
        cb(null);
      });
      return;
    }

    requestAnimationFrame(step);
  };

  if (from === to) {
    cb(new Error('Element already at target position'));
    return cancel;
  }

  requestAnimationFrame(step);
  return cancel;
}

var _default = animate;
exports.default = _default;

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactEventListener = _interopRequireDefault(__webpack_require__(94));

var _debounce = _interopRequireDefault(__webpack_require__(125));

// < 1kb payload overhead when lodash/debounce is > 3kb.
var styles = {
  width: 90,
  height: 90,
  position: 'absolute',
  top: -9000,
  overflow: 'scroll',
  // Support IE 11
  msOverflowStyle: 'scrollbar'
};
/**
 * @ignore - internal component.
 * The component is originates from https://github.com/STORIS/react-scrollbar-size.
 * It has been moved into the core in order to minimize the bundle size.
 */

var ScrollbarSize =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ScrollbarSize, _React$Component);

  function ScrollbarSize() {
    var _this;

    (0, _classCallCheck2.default)(this, ScrollbarSize);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ScrollbarSize).call(this));

    _this.handleRef = function (ref) {
      _this.nodeRef = ref;
    };

    _this.setMeasurements = function () {
      var nodeRef = _this.nodeRef;

      if (!nodeRef) {
        return;
      }

      _this.scrollbarHeight = nodeRef.offsetHeight - nodeRef.clientHeight;
    };

    if (typeof window !== 'undefined') {
      _this.handleResize = (0, _debounce.default)(function () {
        var prevHeight = _this.scrollbarHeight;

        _this.setMeasurements();

        if (prevHeight !== _this.scrollbarHeight) {
          _this.props.onChange(_this.scrollbarHeight);
        }
      }, 166); // Corresponds to 10 frames at 60 Hz.
    }

    return _this;
  }

  (0, _createClass2.default)(ScrollbarSize, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setMeasurements();
      this.props.onChange(this.scrollbarHeight);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleResize.clear();
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }), _react.default.createElement("div", {
        style: styles,
        ref: this.handleRef
      }));
    }
  }]);
  return ScrollbarSize;
}(_react.default.Component);

 false ? ScrollbarSize.propTypes = {
  onChange: _propTypes.default.func.isRequired
} : void 0;
var _default = ScrollbarSize;
exports.default = _default;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _helpers = __webpack_require__(29);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'absolute',
      height: 2,
      bottom: 0,
      width: '100%',
      transition: theme.transitions.create()
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main
    }
  };
};
/**
 * @ignore - internal component.
 */


exports.styles = styles;

function TabIndicator(props) {
  var classes = props.classes,
      className = props.className,
      color = props.color,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color"]);
  return _react.default.createElement("span", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, classes["color".concat((0, _helpers.capitalize)(color))], className)
  }, other));
}

 false ? TabIndicator.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   * The color of the tab indicator.
   */
  color: _propTypes.default.oneOf(['primary', 'secondary'])
} : void 0;

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiPrivateTabIndicator'
})(TabIndicator);

exports.default = _default;

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _KeyboardArrowLeft = _interopRequireDefault(__webpack_require__(434));

var _KeyboardArrowRight = _interopRequireDefault(__webpack_require__(435));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _ButtonBase = _interopRequireDefault(__webpack_require__(64));

var styles = {
  /* Styles applied to the root element. */
  root: {
    color: 'inherit',
    width: 56,
    flexShrink: 0
  }
};
/**
 * @ignore - internal component.
 */

exports.styles = styles;

var _ref = _react.default.createElement(_KeyboardArrowLeft.default, null);

var _ref2 = _react.default.createElement(_KeyboardArrowRight.default, null);

function TabScrollButton(props) {
  var classes = props.classes,
      classNameProp = props.className,
      direction = props.direction,
      onClick = props.onClick,
      visible = props.visible,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "direction", "onClick", "visible"]);
  var className = (0, _classnames.default)(classes.root, classNameProp);

  if (!visible) {
    return _react.default.createElement("div", {
      className: className
    });
  }

  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
    className: className,
    onClick: onClick,
    tabIndex: -1
  }, other), direction === 'left' ? _ref : _ref2);
}

 false ? TabScrollButton.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Which direction should the button indicate?
   */
  direction: _propTypes.default.oneOf(['left', 'right']),

  /**
   * Callback to execute for button press.
   */
  onClick: _propTypes.default.func,

  /**
   * Should the button be present or just consume space.
   */
  visible: _propTypes.default.bool
} : void 0;
TabScrollButton.defaultProps = {
  visible: true
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiPrivateTabScrollButton'
})(TabScrollButton);

exports.default = _default;

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _extends3 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _ButtonBase = _interopRequireDefault(__webpack_require__(64));

var _helpers = __webpack_require__(29);

var _unsupportedProp = _interopRequireDefault(__webpack_require__(284));

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0, _extends3.default)({}, theme.typography.button, (0, _defineProperty2.default)({
      maxWidth: 264,
      minWidth: 72,
      position: 'relative',
      boxSizing: 'border-box',
      padding: 0,
      minHeight: 48,
      flexShrink: 0,
      overflow: 'hidden',
      whiteSpace: 'normal',
      textAlign: 'center'
    }, theme.breakpoints.up('md'), {
      fontSize: theme.typography.pxToRem(13),
      minWidth: 160
    })),

    /* Styles applied to the root element if both `icon` and `label` are provided. */
    labelIcon: {
      minHeight: 72,
      // paddingTop supposed to be 12px
      // - 3px from the paddingBottom
      paddingTop: 9 // paddingBottom supposed to be 12px
      // -3px for line-height of the label
      // -6px for label padding
      // = 3px

    },

    /* Styles applied to the root element if `textColor="inherit"`. */
    textColorInherit: {
      color: 'inherit',
      opacity: 0.7,
      '&$selected': {
        opacity: 1
      },
      '&$disabled': {
        opacity: 0.4
      }
    },

    /* Styles applied to the root element if `textColor="primary"`. */
    textColorPrimary: {
      color: theme.palette.text.secondary,
      '&$selected': {
        color: theme.palette.primary.main
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    },

    /* Styles applied to the root element if `textColor="secondary"`. */
    textColorSecondary: {
      color: theme.palette.text.secondary,
      '&$selected': {
        color: theme.palette.secondary.main
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    },

    /* Styles applied to the root element if `selected={true}` (controlled by the Tabs component). */
    selected: {},

    /* Styles applied to the root element if `disabled={true}` (controlled by the Tabs component). */
    disabled: {},

    /* Styles applied to the root element if `fullWidth={true}` (controlled by the Tabs component). */
    fullWidth: {
      flexShrink: 1,
      flexGrow: 1,
      maxWidth: 'none'
    },

    /* Styles applied to the `icon` and `label`'s wrapper element. */
    wrapper: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      flexDirection: 'column'
    },

    /* Styles applied to the label container element if `label` is provided. */
    labelContainer: (0, _defineProperty2.default)({
      width: '100%',
      // Fix an IE 11 issue
      boxSizing: 'border-box',
      padding: '6px 12px'
    }, theme.breakpoints.up('md'), {
      padding: '6px 24px'
    }),

    /* Styles applied to the label wrapper element if `label` is provided. */
    label: {},

    /* Deprecated, the styles will be removed in v4. */
    labelWrapped: {}
  };
};

exports.styles = styles;

var Tab =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Tab, _React$Component);

  function Tab() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Tab);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Tab)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      labelWrapped: false
    };

    _this.handleChange = function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          value = _this$props.value,
          onClick = _this$props.onClick;

      if (onChange) {
        onChange(event, value);
      }

      if (onClick) {
        onClick(event);
      }
    };

    _this.checkTextWrap = function () {
      if (_this.labelRef) {
        var labelWrapped = _this.labelRef.getClientRects().length > 1;

        if (_this.state.labelWrapped !== labelWrapped) {
          _this.setState({
            labelWrapped: labelWrapped
          });
        }
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Tab, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkTextWrap();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.labelWrapped === prevState.labelWrapped) {
        /**
         * At certain text and tab lengths, a larger font size may wrap to two lines while the smaller
         * font size still only requires one line.  This check will prevent an infinite render loop
         * from occurring in that scenario.
         */
        this.checkTextWrap();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _classNames2;

      var _this$props2 = this.props,
          classes = _this$props2.classes,
          className = _this$props2.className,
          disabled = _this$props2.disabled,
          fullWidth = _this$props2.fullWidth,
          icon = _this$props2.icon,
          indicator = _this$props2.indicator,
          labelProp = _this$props2.label,
          onChange = _this$props2.onChange,
          selected = _this$props2.selected,
          textColor = _this$props2.textColor,
          value = _this$props2.value,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["classes", "className", "disabled", "fullWidth", "icon", "indicator", "label", "onChange", "selected", "textColor", "value"]);
      var label;

      if (labelProp !== undefined) {
        label = _react.default.createElement("span", {
          className: classes.labelContainer
        }, _react.default.createElement("span", {
          className: (0, _classnames.default)(classes.label, (0, _defineProperty2.default)({}, classes.labelWrapped, this.state.labelWrapped)),
          ref: function ref(_ref) {
            _this2.labelRef = _ref;
          }
        }, labelProp));
      }

      return _react.default.createElement(_ButtonBase.default, (0, _extends3.default)({
        focusRipple: true,
        className: (0, _classnames.default)(classes.root, classes["textColor".concat((0, _helpers.capitalize)(textColor))], (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames2, classes.selected, selected), (0, _defineProperty2.default)(_classNames2, classes.labelIcon, icon && label), (0, _defineProperty2.default)(_classNames2, classes.fullWidth, fullWidth), _classNames2), className),
        role: "tab",
        "aria-selected": selected,
        disabled: disabled
      }, other, {
        onClick: this.handleChange
      }), _react.default.createElement("span", {
        className: classes.wrapper
      }, icon, label), indicator);
    }
  }]);
  return Tab;
}(_react.default.Component);

 false ? Tab.propTypes = {
  /**
   * This property isn't supported.
   * Use the `component` property if you need to change the children structure.
   */
  children: _unsupportedProp.default,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the tab will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * @ignore
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The icon element.
   */
  icon: _propTypes.default.node,

  /**
   * @ignore
   * For server-side rendering consideration, we let the selected tab
   * render the indicator.
   */
  indicator: _propTypes.default.node,

  /**
   * The label element.
   */
  label: _propTypes.default.node,

  /**
   * @ignore
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onClick: _propTypes.default.func,

  /**
   * @ignore
   */
  selected: _propTypes.default.bool,

  /**
   * @ignore
   */
  textColor: _propTypes.default.oneOf(['secondary', 'primary', 'inherit']),

  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: _propTypes.default.any
} : void 0;
Tab.defaultProps = {
  disabled: false,
  textColor: 'inherit'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTab'
})(Tab);

exports.default = _default;

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Description__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_i18n_i18n__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_Button__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_IconButton__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_CloudBrowser_CloudBrowser__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_redux_modules_cloudFolders__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_Grid__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_theme_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_redux_modules_session__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_redux_modules_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__material_ui_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__BaseAsset__ = __webpack_require__(447);
var _dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_15_i18n_i18n__["a" /* default */].loc.localize;var addProviders=[{type:'dropbox',name:'Dropbox',icon:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_theme_icons__["o" /* DropboxIcon */],{width:"43px",height:"40px"})},{type:'google',name:'Google Drive',icon:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_theme_icons__["r" /* GoogleDriveIcon */],{width:"47px",height:"40px"})},{type:'microsoft',name:'One Drive',icon:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_theme_icons__["R" /* OneDriveIcon */],{width:"51px",height:"30px"})}];var styles=function styles(theme){return{field:{margin:0},iframeClass:{display:'none'},deleteButton:{padding:0,minWidth:20},icon:{margin:0,cursor:'pointer',color:theme.palette.colors.grey,'&[disabled]':{fill:theme.palette.action.disabled,pointerEvents:'none'}},label:{marginRight:2,fontSize:14,lineHeight:'21px',color:'rgba(40, 40, 40, 0.75)'},folder:{borderBottom:'0.5px solid rgba(0, 0, 0, 0.25)',borderTop:'0.5px solid rgba(0, 0, 0, 0.25)',marginTop:1.5*theme.spacing.unit,height:60,display:'flex',alignItems:'center'},bold:{fontWeight:'bold'},teamFolderInfo:{marginTop:4*theme.spacing.unit},providerRoot:{marginRight:30},providerButton:{minWidth:70,width:70,height:70,boxShadow:'1px 1px 3px rgba(0,0,0, 0.16)',borderRadius:20,marginBottom:theme.spacing.unit},providerLabel:{textAlign:'center',fontSize:10,color:'rgba(40, 40, 40, 0.75)'},root:{},sectionHeader:{display:'flex',alignItems:'center',width:200},sectionContainer:{marginTop:theme.spacing.unit,display:'flex'},folderIcon:{marginRight:theme.spacing.unit,color:theme.palette.colors.grey},descriptionContainer:{maxWidth:670},errorClass:{marginTop:4*theme.spacing.unit,fontSize:12,color:'#BC1D1D !important',fontStyle:'italic'},table:{borderTop:"1px solid ".concat(theme.palette.colors.colorWithAlpha(theme.palette.colors.zeta,0.15))},tableCell:{'&:first-child':{width:'1%'// fit to content
},'&:last-child':{width:50},height:60},fullHeight:{height:'100%'}};};var CloudFolder=(_dec=Object(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_BaseAsset){__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(CloudFolder,_BaseAsset);function CloudFolder(){var _this;__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this,CloudFolder);_this=__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(CloudFolder).call(this));__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this),"state",{});_this.handleFolderRemove=_this.handleFolderRemove.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));return _this;}__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(CloudFolder,[{key:"getProvider",value:function getProvider(){var provider=window.location.hash.match(/.providerid=(.+)&host/);return provider&&decodeURIComponent(provider[1]);}},{key:"componentDidMount",value:function componentDidMount(){this.getProvider();var providerId=this.getProvider();var _this$props=this.props,changeFolder=_this$props.changeFolder,params=_this$props.match.params;if(providerId&&(!params.tab||params.tab.toLowerCase()==='documents')){providerId=decodeURIComponent(providerId);changeFolder('root',providerId,{fileId:null,providerId:providerId});this.setState({selectedFolder:'root'+providerId});}}},{key:"toggleFolder",value:function toggleFolder(path){var state=!this.state[path];this.setState(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()({},path,state));}},{key:"displayEmptyFolder",value:function displayEmptyFolder(options){var _this2=this;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_Button___default.a,{onClick:function onClick(){return _this2.toggleFolder(options.path);}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:"body1"},localize('documents-browse-drives'))));}},{key:"displayFolder",value:function displayFolder(options){var _this$props2=this.props,classes=_this$props2.classes,cloudFolders=_this$props2.cloudFolders;var folder=cloudFolders[options.path];return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:classes.folder},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:"body1"},folder.name));}},{key:"renderFolderSection",value:function renderFolderSection(options){var _this$props3=this.props,classes=_this$props3.classes,cloudFolders=_this$props3.cloudFolders;var folder=cloudFolders[options.path];return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:classes.sectionContainer},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:classes.sectionHeader},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_theme_icons__["p" /* FolderIcon */],{className:classes.folderIcon}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:"body1"},options.name)),!folder&&this.displayEmptyFolder(options),folder&&this.displayFolder(options)),this.state[options.path]&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_CloudBrowser_CloudBrowser__["a" /* default */],null));}},{key:"handleProviderClick",value:function handleProviderClick(type,companyId,hasDocument){if(hasDocument){this.setState({hasError:true});return;}if(type==='dropbox'){this.setState({dropboxLogout:true,provider:'dropbox',companyId:companyId});return;}Object(__WEBPACK_IMPORTED_MODULE_19_redux_modules_cloudFolders__["b" /* authenticateProvider */])(type,companyId);}},{key:"renderCloudProviders",value:function renderCloudProviders(document){var _this3=this;var _this$props4=this.props,companyId=_this$props4.companyId,classes=_this$props4.classes;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Grid___default.a,{container:true},addProviders.map(function(provider){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{key:provider.type,className:classes.providerRoot},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_Button___default.a,{className:classes.providerButton,"data-tid":"button-documents-provider-".concat(provider.type),key:provider.type,onClick:function onClick(){return _this3.handleProviderClick(provider.type,companyId,Boolean(document));}},provider.icon),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{className:classes.providerLabel},provider.name));}));}},{key:"removeFolder",value:function removeFolder(_ref){var fileId=_ref.fileId,providerId=_ref.providerId;var _this$props5=this.props,companyId=_this$props5.companyId,removeFolder=_this$props5.removeFolder,fetchSession=_this$props5.fetchSession;removeFolder({fileId:fileId,providerId:providerId,type:'document',companyId:companyId}).then(fetchSession);}},{key:"renderTeamFolder",value:function renderTeamFolder(document,index){var _this4=this;if(!document){return;}var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:classes.teamFolderInfo},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{style:{paddingBottom:10},className:__WEBPACK_IMPORTED_MODULE_21_classnames___default()(classes.label,classes.bold)},localize('documents-your-document-folder')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["F" /* Table */],{className:classes.table},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["G" /* TableBody */],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["J" /* TableRow */],{hover:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["H" /* TableCell */],{padding:"none",className:classes.tableCell},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_theme_icons__["p" /* FolderIcon */],{className:classes.folderIcon})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["H" /* TableCell */],{padding:"none",className:classes.tableCell},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Grid___default.a,{container:true,justify:"space-between",alignContent:"center",alignItems:"center"},this.renderFolderInfo(document),this.renderEditFolderField(document),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Grid___default.a,{container:true,className:classes.fullHeight,alignContent:"center"},this.renderRenameButton(document),this.renderSaveButton(document))))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["H" /* TableCell */],{align:"right",padding:"none",className:classes.tableCell},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_IconButton___default.a,{color:"secondary","data-tid":"button-documents-folder-delete",component:"span","aria-label":"Delete",onClick:function onClick(){return _this4.handleFolderRemove(document);}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_theme_icons__["k" /* DeleteIcon */],null)))))));}},{key:"handleFolderRemove",value:function handleFolderRemove(document){var _this5=this;this.props.showModal('CONFIRMATION_MODAL',{message:localize('documents-remove-folder-message',document.displayName),buttons:[__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_Button___default.a,{"data-tid":"button-documents-delete-cancel",key:"cancel-folder-button",variant:"outlined",color:"primary"},localize('cancel')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_Button___default.a,{key:"delete-folder-button","data-tid":"button-documents-delete-confirm",variant:"contained",color:"primary",onClick:function onClick(){return _this5.removeFolder(document);}},localize('documents-remove-folder-cta'))]});}},{key:"handleOnLoad",value:function handleOnLoad(){var _this$state=this.state,companyId=_this$state.companyId,provider=_this$state.provider;setTimeout(function(){return Object(__WEBPACK_IMPORTED_MODULE_19_redux_modules_cloudFolders__["b" /* authenticateProvider */])(provider,companyId);},500);}},{key:"dropboxLogout",value:function dropboxLogout(){var dropboxLogout=this.state.dropboxLogout;var iframeClass=this.props.classes.iframeClass;if(!dropboxLogout){return;}return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("iframe",{src:"https://www.dropbox.com/logout",className:iframeClass,onLoad:this.handleOnLoad()});}},{key:"renderError",value:function renderError(){var hasError=this.state.hasError;var _this$props6=this.props,classes=_this$props6.classes,folders=_this$props6.company.folders;if(!hasError||folders.document.length===0){return;}return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{className:classes.errorClass,dangerouslySetInnerHTML:{__html:localize('documents-error-limited')}});}},{key:"renderBasicView",value:function renderBasicView(index){var _this$props7=this.props,classes=_this$props7.classes,folders=_this$props7.company.folders;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:classes.descriptionContainer},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Description__["a" /* default */],{dangerousInnerHTML:localize('documents-description')})),this.renderCloudProviders(folders.document&&folders.document[0]),this.renderError(),this.renderTeamFolder(folders.document&&folders.document[0]),this.dropboxLogout());}},{key:"render",value:function render(){var _this$props8=this.props,classes=_this$props8.classes,match=_this$props8.match;var selectedFolder=this.state.selectedFolder;var displayCloudBrowser=Boolean(this.getProvider());return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:classes.root},!displayCloudBrowser&&this.renderBasicView(),displayCloudBrowser&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_CloudBrowser_CloudBrowser__["a" /* default */],{selectedFolder:selectedFolder,type:"document",match:match}));}}]);return CloudFolder;}(__WEBPACK_IMPORTED_MODULE_26__BaseAsset__["a" /* default */]))||_class);var mapStateToProps=function mapStateToProps(state){return{cloudFolders:__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state.cloudFolders,{documentFolder:null,imageFolder:null}),company:state.companies.rawDataById[state.companies.selectedId]||{},companyId:state.companies.selectedId};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_13_redux__["b" /* bindActionCreators */])({fetchSession:__WEBPACK_IMPORTED_MODULE_23_redux_modules_session__["b" /* fetchSession */],changeFolder:__WEBPACK_IMPORTED_MODULE_19_redux_modules_cloudFolders__["c" /* changeFolder */],updateFolder:__WEBPACK_IMPORTED_MODULE_19_redux_modules_cloudFolders__["h" /* updateFolder */],removeFolder:__WEBPACK_IMPORTED_MODULE_19_redux_modules_cloudFolders__["f" /* removeFolder */],showModal:__WEBPACK_IMPORTED_MODULE_24_redux_modules_modal__["d" /* showModal */]},dispatch);};CloudFolder.propTypes={updateFolder:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,fetchSession:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,removeFolder:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,changeFolder:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,showModal:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,classes:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.object,cloudFolders:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.object,company:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.object,companyId:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string,match:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(CloudFolder));

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _colorManipulator = __webpack_require__(81);

var _ButtonBase = _interopRequireDefault(__webpack_require__(64));

var _helpers = __webpack_require__(29);

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(24),
      padding: 12,
      borderRadius: '50%',
      overflow: 'visible',
      // Explicitly set the default value to solve a bug on IE 11.
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        },
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the children container element. */
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  };
};
/**
 * Refer to the [Icons](/style/icons/) section of the documentation
 * regarding the available icon options.
 */


exports.styles = styles;

function IconButton(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      className = props.className,
      color = props.color,
      disabled = props.disabled,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "disabled"]);
  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'default'), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), className),
    centerRipple: true,
    focusRipple: true,
    disabled: disabled
  }, other), _react.default.createElement("span", {
    className: classes.label
  }, children));
}

 false ? IconButton.propTypes = {
  /**
   * The icon element.
   */
  children: (0, _utils.chainPropTypes)(_propTypes.default.node, function (props) {
    var found = _react.default.Children.toArray(props.children).some(function (child) {
      return _react.default.isValidElement(child) && child.props.onClick;
    });

    if (found) {
      return new Error(['Material-UI: you are providing an onClick event listener ' + 'to a child of a button element.', 'Firefox will never trigger the event.', 'You should move the onClick listener to the parent button element.', 'https://github.com/mui-org/material-ui/issues/13957', // Change error message slightly on every check to prevent caching when testing
      // which would not trigger console errors on subsequent fails
      process.env.NODE_ENV === 'test' ? Date.now() : ''].join('\n'));
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * If `true`, the button will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the ripple will be disabled.
   */
  disableRipple: _propTypes.default.bool
} : void 0;
IconButton.defaultProps = {
  color: 'default',
  disabled: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiIconButton'
})(IconButton);

exports.default = _default;

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "common", {
  enumerable: true,
  get: function get() {
    return _common.default;
  }
});
Object.defineProperty(exports, "red", {
  enumerable: true,
  get: function get() {
    return _red.default;
  }
});
Object.defineProperty(exports, "pink", {
  enumerable: true,
  get: function get() {
    return _pink.default;
  }
});
Object.defineProperty(exports, "purple", {
  enumerable: true,
  get: function get() {
    return _purple.default;
  }
});
Object.defineProperty(exports, "deepPurple", {
  enumerable: true,
  get: function get() {
    return _deepPurple.default;
  }
});
Object.defineProperty(exports, "indigo", {
  enumerable: true,
  get: function get() {
    return _indigo.default;
  }
});
Object.defineProperty(exports, "blue", {
  enumerable: true,
  get: function get() {
    return _blue.default;
  }
});
Object.defineProperty(exports, "lightBlue", {
  enumerable: true,
  get: function get() {
    return _lightBlue.default;
  }
});
Object.defineProperty(exports, "cyan", {
  enumerable: true,
  get: function get() {
    return _cyan.default;
  }
});
Object.defineProperty(exports, "teal", {
  enumerable: true,
  get: function get() {
    return _teal.default;
  }
});
Object.defineProperty(exports, "green", {
  enumerable: true,
  get: function get() {
    return _green.default;
  }
});
Object.defineProperty(exports, "lightGreen", {
  enumerable: true,
  get: function get() {
    return _lightGreen.default;
  }
});
Object.defineProperty(exports, "lime", {
  enumerable: true,
  get: function get() {
    return _lime.default;
  }
});
Object.defineProperty(exports, "yellow", {
  enumerable: true,
  get: function get() {
    return _yellow.default;
  }
});
Object.defineProperty(exports, "amber", {
  enumerable: true,
  get: function get() {
    return _amber.default;
  }
});
Object.defineProperty(exports, "orange", {
  enumerable: true,
  get: function get() {
    return _orange.default;
  }
});
Object.defineProperty(exports, "deepOrange", {
  enumerable: true,
  get: function get() {
    return _deepOrange.default;
  }
});
Object.defineProperty(exports, "brown", {
  enumerable: true,
  get: function get() {
    return _brown.default;
  }
});
Object.defineProperty(exports, "grey", {
  enumerable: true,
  get: function get() {
    return _grey.default;
  }
});
Object.defineProperty(exports, "blueGrey", {
  enumerable: true,
  get: function get() {
    return _blueGrey.default;
  }
});

var _common = _interopRequireDefault(__webpack_require__(368));

var _red = _interopRequireDefault(__webpack_require__(367));

var _pink = _interopRequireDefault(__webpack_require__(365));

var _purple = _interopRequireDefault(__webpack_require__(946));

var _deepPurple = _interopRequireDefault(__webpack_require__(947));

var _indigo = _interopRequireDefault(__webpack_require__(364));

var _blue = _interopRequireDefault(__webpack_require__(948));

var _lightBlue = _interopRequireDefault(__webpack_require__(949));

var _cyan = _interopRequireDefault(__webpack_require__(950));

var _teal = _interopRequireDefault(__webpack_require__(951));

var _green = _interopRequireDefault(__webpack_require__(952));

var _lightGreen = _interopRequireDefault(__webpack_require__(953));

var _lime = _interopRequireDefault(__webpack_require__(954));

var _yellow = _interopRequireDefault(__webpack_require__(955));

var _amber = _interopRequireDefault(__webpack_require__(956));

var _orange = _interopRequireDefault(__webpack_require__(957));

var _deepOrange = _interopRequireDefault(__webpack_require__(958));

var _brown = _interopRequireDefault(__webpack_require__(959));

var _grey = _interopRequireDefault(__webpack_require__(366));

var _blueGrey = _interopRequireDefault(__webpack_require__(960));

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var purple = {
  50: '#f3e5f5',
  100: '#e1bee7',
  200: '#ce93d8',
  300: '#ba68c8',
  400: '#ab47bc',
  500: '#9c27b0',
  600: '#8e24aa',
  700: '#7b1fa2',
  800: '#6a1b9a',
  900: '#4a148c',
  A100: '#ea80fc',
  A200: '#e040fb',
  A400: '#d500f9',
  A700: '#aa00ff'
};
var _default = purple;
exports.default = _default;

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var deepPurple = {
  50: '#ede7f6',
  100: '#d1c4e9',
  200: '#b39ddb',
  300: '#9575cd',
  400: '#7e57c2',
  500: '#673ab7',
  600: '#5e35b1',
  700: '#512da8',
  800: '#4527a0',
  900: '#311b92',
  A100: '#b388ff',
  A200: '#7c4dff',
  A400: '#651fff',
  A700: '#6200ea'
};
var _default = deepPurple;
exports.default = _default;

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
var _default = blue;
exports.default = _default;

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var lightBlue = {
  50: '#e1f5fe',
  100: '#b3e5fc',
  200: '#81d4fa',
  300: '#4fc3f7',
  400: '#29b6f6',
  500: '#03a9f4',
  600: '#039be5',
  700: '#0288d1',
  800: '#0277bd',
  900: '#01579b',
  A100: '#80d8ff',
  A200: '#40c4ff',
  A400: '#00b0ff',
  A700: '#0091ea'
};
var _default = lightBlue;
exports.default = _default;

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var cyan = {
  50: '#e0f7fa',
  100: '#b2ebf2',
  200: '#80deea',
  300: '#4dd0e1',
  400: '#26c6da',
  500: '#00bcd4',
  600: '#00acc1',
  700: '#0097a7',
  800: '#00838f',
  900: '#006064',
  A100: '#84ffff',
  A200: '#18ffff',
  A400: '#00e5ff',
  A700: '#00b8d4'
};
var _default = cyan;
exports.default = _default;

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var teal = {
  50: '#e0f2f1',
  100: '#b2dfdb',
  200: '#80cbc4',
  300: '#4db6ac',
  400: '#26a69a',
  500: '#009688',
  600: '#00897b',
  700: '#00796b',
  800: '#00695c',
  900: '#004d40',
  A100: '#a7ffeb',
  A200: '#64ffda',
  A400: '#1de9b6',
  A700: '#00bfa5'
};
var _default = teal;
exports.default = _default;

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
var _default = green;
exports.default = _default;

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var lightGreen = {
  50: '#f1f8e9',
  100: '#dcedc8',
  200: '#c5e1a5',
  300: '#aed581',
  400: '#9ccc65',
  500: '#8bc34a',
  600: '#7cb342',
  700: '#689f38',
  800: '#558b2f',
  900: '#33691e',
  A100: '#ccff90',
  A200: '#b2ff59',
  A400: '#76ff03',
  A700: '#64dd17'
};
var _default = lightGreen;
exports.default = _default;

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var lime = {
  50: '#f9fbe7',
  100: '#f0f4c3',
  200: '#e6ee9c',
  300: '#dce775',
  400: '#d4e157',
  500: '#cddc39',
  600: '#c0ca33',
  700: '#afb42b',
  800: '#9e9d24',
  900: '#827717',
  A100: '#f4ff81',
  A200: '#eeff41',
  A400: '#c6ff00',
  A700: '#aeea00'
};
var _default = lime;
exports.default = _default;

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var yellow = {
  50: '#fffde7',
  100: '#fff9c4',
  200: '#fff59d',
  300: '#fff176',
  400: '#ffee58',
  500: '#ffeb3b',
  600: '#fdd835',
  700: '#fbc02d',
  800: '#f9a825',
  900: '#f57f17',
  A100: '#ffff8d',
  A200: '#ffff00',
  A400: '#ffea00',
  A700: '#ffd600'
};
var _default = yellow;
exports.default = _default;

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var amber = {
  50: '#fff8e1',
  100: '#ffecb3',
  200: '#ffe082',
  300: '#ffd54f',
  400: '#ffca28',
  500: '#ffc107',
  600: '#ffb300',
  700: '#ffa000',
  800: '#ff8f00',
  900: '#ff6f00',
  A100: '#ffe57f',
  A200: '#ffd740',
  A400: '#ffc400',
  A700: '#ffab00'
};
var _default = amber;
exports.default = _default;

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
var _default = orange;
exports.default = _default;

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var deepOrange = {
  50: '#fbe9e7',
  100: '#ffccbc',
  200: '#ffab91',
  300: '#ff8a65',
  400: '#ff7043',
  500: '#ff5722',
  600: '#f4511e',
  700: '#e64a19',
  800: '#d84315',
  900: '#bf360c',
  A100: '#ff9e80',
  A200: '#ff6e40',
  A400: '#ff3d00',
  A700: '#dd2c00'
};
var _default = deepOrange;
exports.default = _default;

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var brown = {
  50: '#efebe9',
  100: '#d7ccc8',
  200: '#bcaaa4',
  300: '#a1887f',
  400: '#8d6e63',
  500: '#795548',
  600: '#6d4c41',
  700: '#5d4037',
  800: '#4e342e',
  900: '#3e2723',
  A100: '#d7ccc8',
  A200: '#bcaaa4',
  A400: '#8d6e63',
  A700: '#5d4037'
};
var _default = brown;
exports.default = _default;

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var blueGrey = {
  50: '#eceff1',
  100: '#cfd8dc',
  200: '#b0bec5',
  300: '#90a4ae',
  400: '#78909c',
  500: '#607d8b',
  600: '#546e7a',
  700: '#455a64',
  800: '#37474f',
  900: '#263238',
  A100: '#cfd8dc',
  A200: '#b0bec5',
  A400: '#78909c',
  A700: '#455a64'
};
var _default = blueGrey;
exports.default = _default;

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Badge.default;
  }
});

var _Badge = _interopRequireDefault(__webpack_require__(962));

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _helpers = __webpack_require__(29);

var RADIUS = 10;

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      display: 'inline-flex',
      // For correct alignment with the text.
      verticalAlign: 'middle'
    },

    /* Styles applied to the badge `span` element. */
    badge: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      top: 0,
      right: 0,
      boxSizing: 'border-box',
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(12),
      minWidth: RADIUS * 2,
      padding: '0 4px',
      height: RADIUS * 2,
      borderRadius: RADIUS,
      backgroundColor: theme.palette.color,
      color: theme.palette.textColor,
      zIndex: 1,
      // Render the badge on top of potential ripples.
      transform: 'scale(1) translate(50%, -50%)',
      transformOrigin: '100% 0%',
      transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.enteringScreen
      })
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText
    },

    /* Styles applied to the badge `span` element if `invisible={true}`. */
    invisible: {
      transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.leavingScreen
      }),
      transform: 'scale(0) translate(50%, -50%)',
      transformOrigin: '100% 0%'
    },

    /* Styles applied to the root element if `variant="dot"`. */
    dot: {
      height: 6,
      minWidth: 6,
      padding: 0
    }
  };
};

exports.styles = styles;

function Badge(props) {
  var _classNames;

  var badgeContent = props.badgeContent,
      children = props.children,
      classes = props.classes,
      className = props.className,
      color = props.color,
      ComponentProp = props.component,
      invisibleProp = props.invisible,
      showZero = props.showZero,
      max = props.max,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["badgeContent", "children", "classes", "className", "color", "component", "invisible", "showZero", "max", "variant"]);
  var invisible = invisibleProp;

  if (invisibleProp == null && Number(badgeContent) === 0 && !showZero) {
    invisible = true;
  }

  var badgeClassName = (0, _classnames.default)(classes.badge, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'default'), (0, _defineProperty2.default)(_classNames, classes.invisible, invisible), (0, _defineProperty2.default)(_classNames, classes.dot, variant === 'dot'), _classNames));
  var displayValue = '';

  if (variant !== 'dot') {
    displayValue = badgeContent > max ? "".concat(max, "+") : badgeContent;
  }

  return _react.default.createElement(ComponentProp, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), children, _react.default.createElement("span", {
    className: badgeClassName
  }, displayValue));
}

 false ? Badge.propTypes = {
  /**
   * The content rendered within the badge.
   */
  badgeContent: _propTypes.default.node,

  /**
   * The badge will be added relative to this node.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['default', 'primary', 'secondary', 'error']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * If `true`, the badge will be invisible.
   */
  invisible: _propTypes.default.bool,

  /**
   * Max count to show.
   */
  max: _propTypes.default.number,

  /**
   * Controls whether the badge is hidden when `badgeContent` is zero.
   */
  showZero: _propTypes.default.bool,

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['standard', 'dot'])
} : void 0;
Badge.defaultProps = {
  color: 'default',
  component: 'span',
  max: 99,
  showZero: false,
  variant: 'standard'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiBadge'
})(Badge);

exports.default = _default;

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _BottomNavigation.default;
  }
});

var _BottomNavigation = _interopRequireDefault(__webpack_require__(964));

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _warning = _interopRequireDefault(__webpack_require__(27));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      justifyContent: 'center',
      height: 56,
      backgroundColor: theme.palette.background.paper
    }
  };
};

exports.styles = styles;

function BottomNavigation(props) {
  var childrenProp = props.children,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      onChange = props.onChange,
      showLabels = props.showLabels,
      value = props.value,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "onChange", "showLabels", "value"]);
  var className = (0, _classnames.default)(classes.root, classNameProp);

  var children = _react.default.Children.map(childrenProp, function (child, childIndex) {
    if (!_react.default.isValidElement(child)) {
      return null;
    }

     false ? (0, _warning.default)(child.type !== _react.default.Fragment, ["Material-UI: the BottomNavigation component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n')) : void 0;
    var childValue = child.props.value === undefined ? childIndex : child.props.value;
    return _react.default.cloneElement(child, {
      selected: childValue === value,
      showLabel: child.props.showLabel !== undefined ? child.props.showLabel : showLabels,
      value: childValue,
      onChange: onChange
    });
  });

  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other), children);
}

 false ? BottomNavigation.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback
   * @param {any} value We default to the index of the child
   */
  onChange: _propTypes.default.func,

  /**
   * If `true`, all `BottomNavigationAction`s will show their labels.
   * By default, only the selected `BottomNavigationAction` will show its label.
   */
  showLabels: _propTypes.default.bool,

  /**
   * The value of the currently selected `BottomNavigationAction`.
   */
  value: _propTypes.default.any
} : void 0;
BottomNavigation.defaultProps = {
  component: 'div',
  showLabels: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiBottomNavigation'
})(BottomNavigation);

exports.default = _default;

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _BottomNavigationAction.default;
  }
});

var _BottomNavigationAction = _interopRequireDefault(__webpack_require__(966));

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _ButtonBase = _interopRequireDefault(__webpack_require__(64));

var _unsupportedProp = _interopRequireDefault(__webpack_require__(284));

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      transition: theme.transitions.create(['color', 'padding-top'], {
        duration: theme.transitions.duration.short
      }),
      padding: '6px 12px 8px',
      minWidth: 80,
      maxWidth: 168,
      color: theme.palette.text.secondary,
      flex: '1',
      '&$iconOnly': {
        paddingTop: 16
      },
      '&$selected': {
        paddingTop: 6,
        color: theme.palette.primary.main
      }
    },

    /* Styles applied to the root element if selected. */
    selected: {},

    /* Styles applied to the root element if `showLabel={false}` and not selected. */
    iconOnly: {},

    /* Styles applied to the span element that wraps the icon and label. */
    wrapper: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      flexDirection: 'column'
    },

    /* Styles applied to the label's span element. */
    label: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(12),
      opacity: 1,
      transition: 'font-size 0.2s, opacity 0.2s',
      transitionDelay: '0.1s',
      '&$iconOnly': {
        opacity: 0,
        transitionDelay: '0s'
      },
      '&$selected': {
        fontSize: theme.typography.pxToRem(14)
      }
    }
  };
};

exports.styles = styles;

var BottomNavigationAction =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(BottomNavigationAction, _React$Component);

  function BottomNavigationAction() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, BottomNavigationAction);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(BottomNavigationAction)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleChange = function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          value = _this$props.value,
          onClick = _this$props.onClick;

      if (onChange) {
        onChange(event, value);
      }

      if (onClick) {
        onClick(event);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(BottomNavigationAction, [{
    key: "render",
    value: function render() {
      var _classNames, _classNames2;

      var _this$props2 = this.props,
          classes = _this$props2.classes,
          classNameProp = _this$props2.className,
          icon = _this$props2.icon,
          label = _this$props2.label,
          onChange = _this$props2.onChange,
          onClick = _this$props2.onClick,
          selected = _this$props2.selected,
          showLabelProp = _this$props2.showLabel,
          value = _this$props2.value,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["classes", "className", "icon", "label", "onChange", "onClick", "selected", "showLabel", "value"]);
      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.selected, selected), (0, _defineProperty2.default)(_classNames, classes.iconOnly, !showLabelProp && !selected), _classNames), classNameProp);
      var labelClassName = (0, _classnames.default)(classes.label, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.selected, selected), (0, _defineProperty2.default)(_classNames2, classes.iconOnly, !showLabelProp && !selected), _classNames2));
      return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
        className: className,
        focusRipple: true,
        onClick: this.handleChange
      }, other), _react.default.createElement("span", {
        className: classes.wrapper
      }, icon, _react.default.createElement("span", {
        className: labelClassName
      }, label)));
    }
  }]);
  return BottomNavigationAction;
}(_react.default.Component);

 false ? BottomNavigationAction.propTypes = {
  /**
   * This property isn't supported.
   * Use the `component` property if you need to change the children structure.
   */
  children: _unsupportedProp.default,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The icon element.
   */
  icon: _propTypes.default.node,

  /**
   * The label element.
   */
  label: _propTypes.default.node,

  /**
   * @ignore
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onClick: _propTypes.default.func,

  /**
   * @ignore
   */
  selected: _propTypes.default.bool,

  /**
   * If `true`, the `BottomNavigationAction` will show its label.
   * By default, only the selected `BottomNavigationAction`
   * inside `BottomNavigation` will show its label.
   */
  showLabel: _propTypes.default.bool,

  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: _propTypes.default.any
} : void 0;

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiBottomNavigationAction'
})(BottomNavigationAction);

exports.default = _default;

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Card.default;
  }
});

var _Card = _interopRequireDefault(__webpack_require__(968));

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _Paper = _interopRequireDefault(__webpack_require__(63));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

// @inheritedComponent Paper
var styles = {
  /* Styles applied to the root element. */
  root: {
    overflow: 'hidden'
  }
};
exports.styles = styles;

function Card(props) {
  var classes = props.classes,
      className = props.className,
      raised = props.raised,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "raised"]);
  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className),
    elevation: raised ? 8 : 1
  }, other));
}

 false ? Card.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the card will use raised styling.
   */
  raised: _propTypes.default.bool
} : void 0;
Card.defaultProps = {
  raised: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiCard'
})(Card);

exports.default = _default;

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CardActionArea.default;
  }
});

var _CardActionArea = _interopRequireDefault(__webpack_require__(970));

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _ButtonBase = _interopRequireDefault(__webpack_require__(64));

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      textAlign: 'inherit',
      width: '100%',
      '&:hover $focusHighlight': {
        opacity: theme.palette.action.hoverOpacity
      },
      '&$focusVisible $focusHighlight': {
        opacity: 0.12
      }
    },

    /* Styles applied to the ButtonBase root element if the action area is keyboard focused. */
    focusVisible: {},

    /* Styles applied to the overlay that covers the action area when it is keyboard focused. */
    focusHighlight: {
      pointerEvents: 'none',
      position: 'absolute',
      backgroundColor: 'currentcolor',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      opacity: 0,
      transition: theme.transitions.create('opacity', {
        duration: theme.transitions.duration.short
      })
    }
  };
};

exports.styles = styles;

function CardActionArea(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      focusVisibleClassName = props.focusVisibleClassName,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "focusVisibleClassName"]);
  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className),
    focusVisibleClassName: (0, _classnames.default)(focusVisibleClassName, classes.focusVisible)
  }, other), children, _react.default.createElement("span", {
    className: classes.focusHighlight
  }));
}

 false ? CardActionArea.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   */
  focusVisibleClassName: _propTypes.default.string
} : void 0;

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiCardActionArea'
})(CardActionArea);

exports.default = _default;

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CardActions.default;
  }
});

var _CardActions = _interopRequireDefault(__webpack_require__(972));

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _reactHelpers = __webpack_require__(70);

__webpack_require__(36);

// So we don't have any override priority issue.
var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    padding: '8px 4px'
  },

  /* Styles applied to the root element if `disableActionSpacing={true}`. */
  disableActionSpacing: {
    padding: 8
  },

  /* Styles applied to the children. */
  action: {
    margin: '0 4px'
  }
};
exports.styles = styles;

function CardActions(props) {
  var disableActionSpacing = props.disableActionSpacing,
      children = props.children,
      classes = props.classes,
      className = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["disableActionSpacing", "children", "classes", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.disableActionSpacing, disableActionSpacing), className)
  }, other), disableActionSpacing ? children : (0, _reactHelpers.cloneChildrenWithClassName)(children, classes.action));
}

 false ? CardActions.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the card actions do not have additional margin.
   */
  disableActionSpacing: _propTypes.default.bool
} : void 0;
CardActions.defaultProps = {
  disableActionSpacing: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiCardActions'
})(CardActions);

exports.default = _default;

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CardContent.default;
  }
});

var _CardContent = _interopRequireDefault(__webpack_require__(974));

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var styles = {
  /* Styles applied to the root element. */
  root: {
    padding: 16,
    '&:last-child': {
      paddingBottom: 24
    }
  }
};
exports.styles = styles;

function CardContent(props) {
  var classes = props.classes,
      className = props.className,
      Component = props.component,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other));
}

 false ? CardContent.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType
} : void 0;
CardContent.defaultProps = {
  component: 'div'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiCardContent'
})(CardContent);

exports.default = _default;

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CardHeader.default;
  }
});

var _CardHeader = _interopRequireDefault(__webpack_require__(976));

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _Typography = _interopRequireDefault(__webpack_require__(25));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: 16
  },

  /* Styles applied to the avatar element. */
  avatar: {
    flex: '0 0 auto',
    marginRight: 16
  },

  /* Styles applied to the action element. */
  action: {
    flex: '0 0 auto',
    alignSelf: 'flex-start',
    marginTop: -8,
    marginRight: -8
  },

  /* Styles applied to the content wrapper element. */
  content: {
    flex: '1 1 auto'
  },

  /* Styles applied to the title Typography element. */
  title: {},

  /* Styles applied to the subheader Typography element. */
  subheader: {}
};
exports.styles = styles;

function CardHeader(props) {
  var action = props.action,
      avatar = props.avatar,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      disableTypography = props.disableTypography,
      subheaderProp = props.subheader,
      subheaderTypographyProps = props.subheaderTypographyProps,
      titleProp = props.title,
      titleTypographyProps = props.titleTypographyProps,
      other = (0, _objectWithoutProperties2.default)(props, ["action", "avatar", "classes", "className", "component", "disableTypography", "subheader", "subheaderTypographyProps", "title", "titleTypographyProps"]);
  var title = titleProp;

  if (title != null && title.type !== _Typography.default && !disableTypography) {
    title = _react.default.createElement(_Typography.default, (0, _extends2.default)({
      variant: avatar ? 'body2' : 'headline',
      internalDeprecatedVariant: true,
      className: classes.title,
      component: "span"
    }, titleTypographyProps), title);
  }

  var subheader = subheaderProp;

  if (subheader != null && subheader.type !== _Typography.default && !disableTypography) {
    subheader = _react.default.createElement(_Typography.default, (0, _extends2.default)({
      variant: avatar ? 'body2' : 'body1',
      className: classes.subheader,
      color: "textSecondary",
      component: "span"
    }, subheaderTypographyProps), subheader);
  }

  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, classNameProp)
  }, other), avatar && _react.default.createElement("div", {
    className: classes.avatar
  }, avatar), _react.default.createElement("div", {
    className: classes.content
  }, title, subheader), action && _react.default.createElement("div", {
    className: classes.action
  }, action));
}

 false ? CardHeader.propTypes = {
  /**
   * The action to display in the card header.
   */
  action: _propTypes.default.node,

  /**
   * The Avatar for the Card Header.
   */
  avatar: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `title` text, and optional `subheader` text
   * with the Typography component.
   */
  disableTypography: _propTypes.default.bool,

  /**
   * The content of the component.
   */
  subheader: _propTypes.default.node,

  /**
   * These props will be forwarded to the subheader
   * (as long as disableTypography is not `true`).
   */
  subheaderTypographyProps: _propTypes.default.object,

  /**
   * The content of the Card Title.
   */
  title: _propTypes.default.node,

  /**
   * These props will be forwarded to the title
   * (as long as disableTypography is not `true`).
   */
  titleTypographyProps: _propTypes.default.object
} : void 0;
CardHeader.defaultProps = {
  component: 'div',
  disableTypography: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiCardHeader'
})(CardHeader);

exports.default = _default;

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CardMedia.default;
  }
});

var _CardMedia = _interopRequireDefault(__webpack_require__(978));

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _warning = _interopRequireDefault(__webpack_require__(27));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'block',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  },

  /* Styles applied to the root element if `component="video, audio, picture, iframe, or img"`. */
  media: {
    width: '100%'
  }
};
exports.styles = styles;
var MEDIA_COMPONENTS = ['video', 'audio', 'picture', 'iframe', 'img'];

function CardMedia(props) {
  var classes = props.classes,
      className = props.className,
      Component = props.component,
      image = props.image,
      src = props.src,
      style = props.style,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "image", "src", "style"]);
   false ? (0, _warning.default)(Boolean(image || src), 'Material-UI: either `image` or `src` property must be specified.') : void 0;
  var isMediaComponent = MEDIA_COMPONENTS.indexOf(Component) !== -1;
  var composedStyle = !isMediaComponent && image ? (0, _extends2.default)({
    backgroundImage: "url(\"".concat(image, "\")")
  }, style) : style;
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.media, isMediaComponent), className),
    style: composedStyle,
    src: isMediaComponent ? image || src : undefined
  }, other));
}

 false ? CardMedia.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Component for rendering image.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * Image to be displayed as a background image.
   * Either `image` or `src` prop must be specified.
   * Note that caller must specify height otherwise the image will not be visible.
   */
  image: _propTypes.default.string,

  /**
   * An alias for `image` property.
   * Available only with media components.
   * Media components: `video`, `audio`, `picture`, `iframe`, `img`.
   */
  src: _propTypes.default.string,

  /**
   * @ignore
   */
  style: _propTypes.default.object
} : void 0;
CardMedia.defaultProps = {
  component: 'div'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiCardMedia'
})(CardMedia);

exports.default = _default;

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Checkbox.default;
  }
});

var _Checkbox = _interopRequireDefault(__webpack_require__(980));

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _SwitchBase = _interopRequireDefault(__webpack_require__(285));

var _CheckBoxOutlineBlank = _interopRequireDefault(__webpack_require__(981));

var _CheckBox = _interopRequireDefault(__webpack_require__(982));

var _IndeterminateCheckBox = _interopRequireDefault(__webpack_require__(983));

var _helpers = __webpack_require__(29);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary
    },

    /* Styles applied to the root element if `checked={true}`. */
    checked: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `indeterminate={true}`. */
    indeterminate: {},

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }
  };
};

exports.styles = styles;

function Checkbox(props) {
  var checkedIcon = props.checkedIcon,
      classes = props.classes,
      className = props.className,
      color = props.color,
      icon = props.icon,
      indeterminate = props.indeterminate,
      indeterminateIcon = props.indeterminateIcon,
      inputProps = props.inputProps,
      other = (0, _objectWithoutProperties2.default)(props, ["checkedIcon", "classes", "className", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps"]);
  return _react.default.createElement(_SwitchBase.default, (0, _extends2.default)({
    type: "checkbox",
    checkedIcon: indeterminate ? indeterminateIcon : checkedIcon,
    className: (0, _classnames.default)((0, _defineProperty2.default)({}, classes.indeterminate, indeterminate), className),
    classes: {
      root: (0, _classnames.default)(classes.root, classes["color".concat((0, _helpers.capitalize)(color))]),
      checked: classes.checked,
      disabled: classes.disabled
    },
    inputProps: (0, _extends2.default)({
      'data-indeterminate': indeterminate
    }, inputProps),
    icon: indeterminate ? indeterminateIcon : icon
  }, other));
}

 false ? Checkbox.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['primary', 'secondary', 'default']),

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes.default.node,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,

  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the input.
   */
  indeterminate: _propTypes.default.bool,

  /**
   * The icon to display when the component is indeterminate.
   */
  indeterminateIcon: _propTypes.default.node,

  /**
   * Properties applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.checked`.
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes.default.func,

  /**
   * The input component property `type`.
   */
  type: _propTypes.default.string,

  /**
   * The value of the component.
   */
  value: _propTypes.default.string
} : void 0;
Checkbox.defaultProps = {
  checkedIcon: _react.default.createElement(_CheckBox.default, null),
  color: 'secondary',
  icon: _react.default.createElement(_CheckBoxOutlineBlank.default, null),
  indeterminate: false,
  indeterminateIcon: _react.default.createElement(_IndeterminateCheckBox.default, null)
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiCheckbox'
})(Checkbox);

exports.default = _default;

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _pure = _interopRequireDefault(__webpack_require__(57));

var _SvgIcon = _interopRequireDefault(__webpack_require__(51));

var _ref = _react.default.createElement("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
});

/**
 * @ignore - internal component.
 */
var CheckBoxOutlineBlank = function CheckBoxOutlineBlank(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

CheckBoxOutlineBlank = (0, _pure.default)(CheckBoxOutlineBlank);
CheckBoxOutlineBlank.muiName = 'SvgIcon';
var _default = CheckBoxOutlineBlank;
exports.default = _default;

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _pure = _interopRequireDefault(__webpack_require__(57));

var _SvgIcon = _interopRequireDefault(__webpack_require__(51));

var _ref = _react.default.createElement("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
});

/**
 * @ignore - internal component.
 */
var CheckBox = function CheckBox(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

CheckBox = (0, _pure.default)(CheckBox);
CheckBox.muiName = 'SvgIcon';
var _default = CheckBox;
exports.default = _default;

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _pure = _interopRequireDefault(__webpack_require__(57));

var _SvgIcon = _interopRequireDefault(__webpack_require__(51));

var _ref = _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
});

/**
 * @ignore - internal component.
 */
var IndeterminateCheckBox = function IndeterminateCheckBox(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

IndeterminateCheckBox = (0, _pure.default)(IndeterminateCheckBox);
IndeterminateCheckBox.muiName = 'SvgIcon';
var _default = IndeterminateCheckBox;
exports.default = _default;

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Chip.default;
  }
});

var _Chip = _interopRequireDefault(__webpack_require__(985));

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _warning = _interopRequireDefault(__webpack_require__(27));

var _utils = __webpack_require__(14);

var _Cancel = _interopRequireDefault(__webpack_require__(986));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _colorManipulator = __webpack_require__(81);

var _unsupportedProp = _interopRequireDefault(__webpack_require__(284));

var _helpers = __webpack_require__(29);

__webpack_require__(419);

// So we don't have any override priority issue.
var styles = function styles(theme) {
  var height = 32;
  var backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700];
  var deleteIconColor = (0, _colorManipulator.fade)(theme.palette.text.primary, 0.26);
  return {
    /* Styles applied to the root element. */
    root: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(13),
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: height,
      color: theme.palette.getContrastText(backgroundColor),
      backgroundColor: backgroundColor,
      borderRadius: height / 2,
      whiteSpace: 'nowrap',
      transition: theme.transitions.create(['background-color', 'box-shadow']),
      // label will inherit this from root, then `clickable` class overrides this for both
      cursor: 'default',
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 'none',
      textDecoration: 'none',
      border: 'none',
      // Remove `button` border
      padding: 0,
      // Remove `button` padding
      verticalAlign: 'middle',
      boxSizing: 'border-box'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },

    /* Styles applied to the root element if `onClick` is defined or `clickable={true}`. */
    clickable: {
      WebkitTapHighlightColor: 'transparent',
      // Remove grey highlight
      cursor: 'pointer',
      '&:hover, &:focus': {
        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.08)
      },
      '&:active': {
        boxShadow: theme.shadows[1],
        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.12)
      }
    },

    /**
     * Styles applied to the root element if
     * `onClick` and `color="primary"` is defined or `clickable={true}`.
     */
    clickableColorPrimary: {
      '&:hover, &:focus': {
        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.primary.main, 0.08)
      },
      '&:active': {
        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.primary.main, 0.12)
      }
    },

    /**
     * Styles applied to the root element if
     * `onClick` and `color="secondary"` is defined or `clickable={true}`.
     */
    clickableColorSecondary: {
      '&:hover, &:focus': {
        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.secondary.main, 0.08)
      },
      '&:active': {
        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.secondary.main, 0.12)
      }
    },

    /* Styles applied to the root element if `onDelete` is defined. */
    deletable: {
      '&:focus': {
        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.08)
      }
    },

    /* Styles applied to the root element if `onDelete` and `color="primary"` is defined. */
    deletableColorPrimary: {
      '&:focus': {
        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.primary.main, 0.2)
      }
    },

    /* Styles applied to the root element if `onDelete` and `color="secondary"` is defined. */
    deletableColorSecondary: {
      '&:focus': {
        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.secondary.main, 0.2)
      }
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      backgroundColor: 'transparent',
      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.text.primary, theme.palette.action.hoverOpacity)
      },
      '& $avatar': {
        marginLeft: -1
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      color: theme.palette.primary.main,
      border: "1px solid ".concat(theme.palette.primary.main),
      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      color: theme.palette.secondary.main,
      border: "1px solid ".concat(theme.palette.secondary.main),
      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity)
      }
    },

    /* Styles applied to the `avatar` element. */
    avatar: {
      marginRight: -4,
      width: height,
      height: height,
      color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
      fontSize: theme.typography.pxToRem(16)
    },

    /* Styles applied to the `avatar` element if `color="primary"`. */
    avatarColorPrimary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.dark
    },

    /* Styles applied to the `avatar` element if `color="secondary"`. */
    avatarColorSecondary: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.dark
    },

    /* Styles applied to the `avatar` elements children. */
    avatarChildren: {
      width: 19,
      height: 19
    },

    /* Styles applied to the `icon` element. */
    icon: {
      color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
      marginLeft: 4,
      marginRight: -8
    },

    /* Styles applied to the `icon` element if `color="primary"`. */
    iconColorPrimary: {
      color: 'inherit'
    },

    /* Styles applied to the `icon` element if `color="secondary"`. */
    iconColorSecondary: {
      color: 'inherit'
    },

    /* Styles applied to the label `span` element`. */
    label: {
      display: 'flex',
      alignItems: 'center',
      paddingLeft: 12,
      paddingRight: 12,
      userSelect: 'none',
      whiteSpace: 'nowrap',
      cursor: 'inherit'
    },

    /* Styles applied to the `deleteIcon` element. */
    deleteIcon: {
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      color: deleteIconColor,
      cursor: 'pointer',
      height: 'auto',
      margin: '0 4px 0 -8px',
      '&:hover': {
        color: (0, _colorManipulator.fade)(deleteIconColor, 0.4)
      }
    },

    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="default"`. */
    deleteIconColorPrimary: {
      color: (0, _colorManipulator.fade)(theme.palette.primary.contrastText, 0.7),
      '&:hover, &:active': {
        color: theme.palette.primary.contrastText
      }
    },

    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="default"`. */
    deleteIconColorSecondary: {
      color: (0, _colorManipulator.fade)(theme.palette.secondary.contrastText, 0.7),
      '&:hover, &:active': {
        color: theme.palette.secondary.contrastText
      }
    },

    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="outlined"`. */
    deleteIconOutlinedColorPrimary: {
      color: (0, _colorManipulator.fade)(theme.palette.primary.main, 0.7),
      '&:hover, &:active': {
        color: theme.palette.primary.main
      }
    },

    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="outlined"`. */
    deleteIconOutlinedColorSecondary: {
      color: (0, _colorManipulator.fade)(theme.palette.secondary.main, 0.7),
      '&:hover, &:active': {
        color: theme.palette.secondary.main
      }
    }
  };
};
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */


exports.styles = styles;

var Chip =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Chip, _React$Component);

  function Chip() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Chip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Chip)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleDeleteIconClick = function (event) {
      // Stop the event from bubbling up to the `Chip`
      event.stopPropagation();
      var onDelete = _this.props.onDelete;

      if (onDelete) {
        onDelete(event);
      }
    };

    _this.handleKeyDown = function (event) {
      var onKeyDown = _this.props.onKeyDown;

      if (onKeyDown) {
        onKeyDown(event);
      } // Ignore events from children of `Chip`.


      if (event.currentTarget !== event.target) {
        return;
      }

      var key = event.key;

      if (key === ' ' || key === 'Enter' || key === 'Backspace' || key === 'Escape') {
        event.preventDefault();
      }
    };

    _this.handleKeyUp = function (event) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          onDelete = _this$props.onDelete,
          onKeyUp = _this$props.onKeyUp;

      if (onKeyUp) {
        onKeyUp(event);
      } // Ignore events from children of `Chip`.


      if (event.currentTarget !== event.target) {
        return;
      }

      var key = event.key;

      if (onClick && (key === ' ' || key === 'Enter')) {
        onClick(event);
      } else if (onDelete && key === 'Backspace') {
        onDelete(event);
      } else if (key === 'Escape' && _this.chipRef) {
        _this.chipRef.blur();
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Chip, [{
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this;

      var _this$props2 = this.props,
          avatarProp = _this$props2.avatar,
          classes = _this$props2.classes,
          classNameProp = _this$props2.className,
          clickableProp = _this$props2.clickable,
          color = _this$props2.color,
          Component = _this$props2.component,
          deleteIconProp = _this$props2.deleteIcon,
          iconProp = _this$props2.icon,
          label = _this$props2.label,
          onClick = _this$props2.onClick,
          onDelete = _this$props2.onDelete,
          onKeyDown = _this$props2.onKeyDown,
          onKeyUp = _this$props2.onKeyUp,
          tabIndexProp = _this$props2.tabIndex,
          variant = _this$props2.variant,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["avatar", "classes", "className", "clickable", "color", "component", "deleteIcon", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "tabIndex", "variant"]);
      var clickable = clickableProp !== false && onClick ? true : clickableProp;
      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'default'), (0, _defineProperty2.default)(_classNames, classes.clickable, clickable), (0, _defineProperty2.default)(_classNames, classes["clickableColor".concat((0, _helpers.capitalize)(color))], clickable && color !== 'default'), (0, _defineProperty2.default)(_classNames, classes.deletable, onDelete), (0, _defineProperty2.default)(_classNames, classes["deletableColor".concat((0, _helpers.capitalize)(color))], onDelete && color !== 'default'), (0, _defineProperty2.default)(_classNames, classes.outlined, variant === 'outlined'), (0, _defineProperty2.default)(_classNames, classes.outlinedPrimary, variant === 'outlined' && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.outlinedSecondary, variant === 'outlined' && color === 'secondary'), _classNames), classNameProp);
      var deleteIcon = null;

      if (onDelete) {
        var _customClasses;

        var customClasses = (_customClasses = {}, (0, _defineProperty2.default)(_customClasses, classes["deleteIconColor".concat((0, _helpers.capitalize)(color))], color !== 'default' && variant !== 'outlined'), (0, _defineProperty2.default)(_customClasses, classes["deleteIconOutlinedColor".concat((0, _helpers.capitalize)(color))], color !== 'default' && variant === 'outlined'), _customClasses);
        deleteIcon = deleteIconProp && _react.default.isValidElement(deleteIconProp) ? _react.default.cloneElement(deleteIconProp, {
          className: (0, _classnames.default)(deleteIconProp.props.className, classes.deleteIcon, customClasses),
          onClick: this.handleDeleteIconClick
        }) : _react.default.createElement(_Cancel.default, {
          className: (0, _classnames.default)(classes.deleteIcon, customClasses),
          onClick: this.handleDeleteIconClick
        });
      }

      var avatar = null;

      if (avatarProp && _react.default.isValidElement(avatarProp)) {
        avatar = _react.default.cloneElement(avatarProp, {
          className: (0, _classnames.default)(classes.avatar, avatarProp.props.className, (0, _defineProperty2.default)({}, classes["avatarColor".concat((0, _helpers.capitalize)(color))], color !== 'default')),
          childrenClassName: (0, _classnames.default)(classes.avatarChildren, avatarProp.props.childrenClassName)
        });
      }

      var icon = null;

      if (iconProp && _react.default.isValidElement(iconProp)) {
        icon = _react.default.cloneElement(iconProp, {
          className: (0, _classnames.default)(classes.icon, iconProp.props.className, (0, _defineProperty2.default)({}, classes["iconColor".concat((0, _helpers.capitalize)(color))], color !== 'default'))
        });
      }

      var tabIndex = tabIndexProp;

      if (!tabIndex) {
        tabIndex = onClick || onDelete || clickable ? 0 : -1;
      }

       false ? (0, _warning.default)(!avatar || !icon, 'Material-UI: the Chip component can not handle the avatar ' + 'and the icon property at the same time. Pick one.') : void 0;
      return _react.default.createElement(Component, (0, _extends2.default)({
        role: "button",
        className: className,
        tabIndex: tabIndex,
        onClick: onClick,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        ref: function ref(_ref) {
          _this2.chipRef = _ref;
        }
      }, other), avatar || icon, _react.default.createElement("span", {
        className: classes.label
      }, label), deleteIcon);
    }
  }]);
  return Chip;
}(_react.default.Component);

 false ? Chip.propTypes = {
  /**
   * Avatar element.
   */
  avatar: _propTypes.default.element,

  /**
   * This property isn't supported.
   * Use the `component` property if you need to change the children structure.
   */
  children: _unsupportedProp.default,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If true, the chip will appear clickable, and will raise when pressed,
   * even if the onClick property is not defined.
   * If false, the chip will not be clickable, even if onClick property is defined.
   * This can be used, for example,
   * along with the component property to indicate an anchor Chip is clickable.
   */
  clickable: _propTypes.default.bool,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['default', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: _propTypes.default.element,

  /**
   * Icon element.
   */
  icon: _propTypes.default.element,

  /**
   * The content of the label.
   */
  label: _propTypes.default.node,

  /**
   * @ignore
   */
  onClick: _propTypes.default.func,

  /**
   * Callback function fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyDown: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyUp: _propTypes.default.func,

  /**
   * @ignore
   */
  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['default', 'outlined'])
} : void 0;
Chip.defaultProps = {
  component: 'div',
  color: 'default',
  variant: 'default'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiChip'
})(Chip);

exports.default = _default;

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _pure = _interopRequireDefault(__webpack_require__(57));

var _SvgIcon = _interopRequireDefault(__webpack_require__(51));

var _ref = _react.default.createElement("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
});

/**
 * @ignore - internal component.
 */
var Cancel = function Cancel(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

Cancel = (0, _pure.default)(Cancel);
Cancel.muiName = 'SvgIcon';
var _default = Cancel;
exports.default = _default;

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactDom = _interopRequireDefault(__webpack_require__(44));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactEventListener = _interopRequireDefault(__webpack_require__(94));

var _ownerDocument = _interopRequireDefault(__webpack_require__(93));

// @inheritedComponent EventListener

/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 */
var ClickAwayListener =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ClickAwayListener, _React$Component);

  function ClickAwayListener() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ClickAwayListener);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ClickAwayListener)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.mounted = false;
    _this.moved = false;

    _this.handleClickAway = function (event) {
      // Ignore events that have been `event.preventDefault()` marked.
      if (event.defaultPrevented) {
        return;
      } // IE 11 support, which trigger the handleClickAway even after the unbind


      if (!_this.mounted) {
        return;
      } // Do not act if user performed touchmove


      if (_this.moved) {
        _this.moved = false;
        return;
      } // The child might render null.


      if (!_this.node) {
        return;
      }

      var doc = (0, _ownerDocument.default)(_this.node);

      if (doc.documentElement && doc.documentElement.contains(event.target) && !_this.node.contains(event.target)) {
        _this.props.onClickAway(event);
      }
    };

    _this.handleTouchMove = function () {
      _this.moved = true;
    };

    return _this;
  }

  (0, _createClass2.default)(ClickAwayListener, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Finds the first child when a component returns a fragment.
      // https://github.com/facebook/react/blob/036ae3c6e2f056adffc31dfb78d1b6f0c63272f0/packages/react-dom/src/__tests__/ReactDOMFiber-test.js#L105
      this.node = _reactDom.default.findDOMNode(this);
      this.mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          mouseEvent = _this$props.mouseEvent,
          touchEvent = _this$props.touchEvent,
          onClickAway = _this$props.onClickAway,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "mouseEvent", "touchEvent", "onClickAway"]);
      var listenerProps = {};

      if (mouseEvent !== false) {
        listenerProps[mouseEvent] = this.handleClickAway;
      }

      if (touchEvent !== false) {
        listenerProps[touchEvent] = this.handleClickAway;
        listenerProps.onTouchMove = this.handleTouchMove;
      }

      return _react.default.createElement(_react.default.Fragment, null, children, _react.default.createElement(_reactEventListener.default, (0, _extends2.default)({
        target: "document"
      }, listenerProps, other)));
    }
  }]);
  return ClickAwayListener;
}(_react.default.Component);

 false ? ClickAwayListener.propTypes = {
  /**
   * The wrapped element.
   */
  children: _propTypes.default.element.isRequired,

  /**
   * The mouse event to listen to. You can disable the listener by providing `false`.
   */
  mouseEvent: _propTypes.default.oneOf(['onClick', 'onMouseDown', 'onMouseUp', false]),

  /**
   * Callback fired when a "click away" event is detected.
   */
  onClickAway: _propTypes.default.func.isRequired,

  /**
   * The touch event to listen to. You can disable the listener by providing `false`.
   */
  touchEvent: _propTypes.default.oneOf(['onTouchStart', 'onTouchEnd', false])
} : void 0;
ClickAwayListener.defaultProps = {
  mouseEvent: 'onMouseUp',
  touchEvent: 'onTouchEnd'
};
var _default = ClickAwayListener;
exports.default = _default;

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _Transition = _interopRequireDefault(__webpack_require__(137));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _transitions = __webpack_require__(88);

var _utils2 = __webpack_require__(138);

// @inheritedComponent Transition
var styles = function styles(theme) {
  return {
    /* Styles applied to the container element. */
    container: {
      height: 0,
      overflow: 'hidden',
      transition: theme.transitions.create('height')
    },

    /* Styles applied to the container element when the transition has entered. */
    entered: {
      height: 'auto',
      overflow: 'visible'
    },

    /* Styles applied to the outer wrapper element. */
    wrapper: {
      // Hack to get children with a negative margin to not falsify the height computation.
      display: 'flex'
    },

    /* Styles applied to the inner wrapper element. */
    wrapperInner: {
      width: '100%'
    }
  };
};
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/demos/steppers/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */


exports.styles = styles;

var Collapse =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Collapse, _React$Component);

  function Collapse() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Collapse);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Collapse)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleEnter = function (node) {
      node.style.height = _this.props.collapsedHeight;

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    };

    _this.handleEntering = function (node) {
      var _this$props = _this.props,
          timeout = _this$props.timeout,
          theme = _this$props.theme;
      var wrapperHeight = _this.wrapperRef ? _this.wrapperRef.clientHeight : 0;

      var _getTransitionProps = (0, _utils2.getTransitionProps)(_this.props, {
        mode: 'enter'
      }),
          transitionDuration = _getTransitionProps.duration;

      if (timeout === 'auto') {
        var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
        node.style.transitionDuration = "".concat(duration2, "ms");
        _this.autoTransitionDuration = duration2;
      } else {
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
      }

      node.style.height = "".concat(wrapperHeight, "px");

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    };

    _this.handleEntered = function (node) {
      node.style.height = 'auto';

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    };

    _this.handleExit = function (node) {
      var wrapperHeight = _this.wrapperRef ? _this.wrapperRef.clientHeight : 0;
      node.style.height = "".concat(wrapperHeight, "px");

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.handleExiting = function (node) {
      var _this$props2 = _this.props,
          timeout = _this$props2.timeout,
          theme = _this$props2.theme;
      var wrapperHeight = _this.wrapperRef ? _this.wrapperRef.clientHeight : 0;

      var _getTransitionProps2 = (0, _utils2.getTransitionProps)(_this.props, {
        mode: 'exit'
      }),
          transitionDuration = _getTransitionProps2.duration;

      if (timeout === 'auto') {
        var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
        node.style.transitionDuration = "".concat(duration2, "ms");
        _this.autoTransitionDuration = duration2;
      } else {
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
      }

      node.style.height = _this.props.collapsedHeight;

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.addEndListener = function (_, next) {
      if (_this.props.timeout === 'auto') {
        _this.timer = setTimeout(next, _this.autoTransitionDuration || 0);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Collapse, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          children = _this$props3.children,
          classes = _this$props3.classes,
          className = _this$props3.className,
          collapsedHeight = _this$props3.collapsedHeight,
          Component = _this$props3.component,
          onEnter = _this$props3.onEnter,
          onEntered = _this$props3.onEntered,
          onEntering = _this$props3.onEntering,
          onExit = _this$props3.onExit,
          onExiting = _this$props3.onExiting,
          style = _this$props3.style,
          theme = _this$props3.theme,
          timeout = _this$props3.timeout,
          other = (0, _objectWithoutProperties2.default)(_this$props3, ["children", "classes", "className", "collapsedHeight", "component", "onEnter", "onEntered", "onEntering", "onExit", "onExiting", "style", "theme", "timeout"]);
      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
        onEnter: this.handleEnter,
        onEntered: this.handleEntered,
        onEntering: this.handleEntering,
        onExit: this.handleExit,
        onExiting: this.handleExiting,
        addEndListener: this.addEndListener,
        timeout: timeout === 'auto' ? null : timeout
      }, other), function (state, childProps) {
        return _react.default.createElement(Component, (0, _extends2.default)({
          className: (0, _classnames.default)(classes.container, (0, _defineProperty2.default)({}, classes.entered, state === 'entered'), className),
          style: (0, _extends2.default)({}, style, {
            minHeight: collapsedHeight
          })
        }, childProps), _react.default.createElement("div", {
          className: classes.wrapper,
          ref: function ref(_ref) {
            _this2.wrapperRef = _ref;
          }
        }, _react.default.createElement("div", {
          className: classes.wrapperInner
        }, children)));
      });
    }
  }]);
  return Collapse;
}(_react.default.Component);

 false ? Collapse.propTypes = {
  /**
   * The content node to be collapsed.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The height of the container when collapsed.
   */
  collapsedHeight: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * If `true`, the component will transition in.
   */
  in: _propTypes.default.bool,

  /**
   * @ignore
   */
  onEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onEntered: _propTypes.default.func,

  /**
   * @ignore
   */
  onEntering: _propTypes.default.func,

  /**
   * @ignore
   */
  onExit: _propTypes.default.func,

  /**
   * @ignore
   */
  onExiting: _propTypes.default.func,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])])
} : void 0;
Collapse.defaultProps = {
  collapsedHeight: '0px',
  component: 'div',
  timeout: _transitions.duration.standard
};
Collapse.muiSupportAuto = true;

var _default = (0, _withStyles.default)(styles, {
  withTheme: true,
  name: 'MuiCollapse'
})(Collapse);

exports.default = _default;

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _helpers = __webpack_require__(29);

var _Modal = _interopRequireDefault(__webpack_require__(198));

var _Fade = _interopRequireDefault(__webpack_require__(199));

var _transitions = __webpack_require__(88);

var _Paper = _interopRequireDefault(__webpack_require__(63));

/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
// @inheritedComponent Modal
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {},

    /* Styles applied to the root element if `scroll="paper"`. */
    scrollPaper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },

    /* Styles applied to the root element if `scroll="body"`. */
    scrollBody: {
      overflowY: 'auto',
      overflowX: 'hidden'
    },

    /* Styles applied to the container element. */
    container: {
      height: '100%',
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 'none'
    },

    /* Styles applied to the `Paper` component. */
    paper: {
      display: 'flex',
      flexDirection: 'column',
      margin: 48,
      position: 'relative',
      overflowY: 'auto' // Fix IE 11 issue, to remove at some point.

    },

    /* Styles applied to the `Paper` component if `scroll="paper"`. */
    paperScrollPaper: {
      flex: '0 1 auto',
      maxHeight: 'calc(100% - 96px)'
    },

    /* Styles applied to the `Paper` component if `scroll="body"`. */
    paperScrollBody: {
      margin: '48px auto'
    },

    /* Styles applied to the `Paper` component if `maxWidth="xs"`. */
    paperWidthXs: {
      maxWidth: Math.max(theme.breakpoints.values.xs, 360),
      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 360) + 48 * 2), {
        margin: 48
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="sm"`. */
    paperWidthSm: {
      maxWidth: theme.breakpoints.values.sm,
      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.sm + 48 * 2), {
        margin: 48
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="md"`. */
    paperWidthMd: {
      maxWidth: theme.breakpoints.values.md,
      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.md + 48 * 2), {
        margin: 48
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="lg"`. */
    paperWidthLg: {
      maxWidth: theme.breakpoints.values.lg,
      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.lg + 48 * 2), {
        margin: 48
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="xl"`. */
    paperWidthXl: {
      maxWidth: theme.breakpoints.values.xl,
      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.xl + 48 * 2), {
        margin: 48
      })
    },

    /* Styles applied to the `Paper` component if `fullWidth={true}`. */
    paperFullWidth: {
      width: '100%'
    },

    /* Styles applied to the `Paper` component if `fullScreen={true}`. */
    paperFullScreen: {
      margin: 0,
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      maxHeight: 'none',
      borderRadius: 0,
      '&$paperScrollBody': {
        margin: 0
      }
    }
  };
};
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */


exports.styles = styles;

var Dialog =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Dialog, _React$Component);

  function Dialog() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Dialog);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Dialog)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleMouseDown = function (event) {
      _this.mouseDownTarget = event.target;
    };

    _this.handleBackdropClick = function (event) {
      // Ignore the events not coming from the "backdrop"
      // We don't want to close the dialog when clicking the dialog content.
      if (event.target !== event.currentTarget) {
        return;
      } // Make sure the event starts and ends on the same DOM element.


      if (event.target !== _this.mouseDownTarget) {
        return;
      }

      _this.mouseDownTarget = null;

      if (_this.props.onBackdropClick) {
        _this.props.onBackdropClick(event);
      }

      if (!_this.props.disableBackdropClick && _this.props.onClose) {
        _this.props.onClose(event, 'backdropClick');
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Dialog, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          BackdropProps = _this$props.BackdropProps,
          children = _this$props.children,
          classes = _this$props.classes,
          className = _this$props.className,
          disableBackdropClick = _this$props.disableBackdropClick,
          disableEscapeKeyDown = _this$props.disableEscapeKeyDown,
          fullScreen = _this$props.fullScreen,
          fullWidth = _this$props.fullWidth,
          maxWidth = _this$props.maxWidth,
          onBackdropClick = _this$props.onBackdropClick,
          onClose = _this$props.onClose,
          onEnter = _this$props.onEnter,
          onEntered = _this$props.onEntered,
          onEntering = _this$props.onEntering,
          onEscapeKeyDown = _this$props.onEscapeKeyDown,
          onExit = _this$props.onExit,
          onExited = _this$props.onExited,
          onExiting = _this$props.onExiting,
          open = _this$props.open,
          PaperComponent = _this$props.PaperComponent,
          _this$props$PaperProp = _this$props.PaperProps,
          PaperProps = _this$props$PaperProp === void 0 ? {} : _this$props$PaperProp,
          scroll = _this$props.scroll,
          TransitionComponent = _this$props.TransitionComponent,
          transitionDuration = _this$props.transitionDuration,
          TransitionProps = _this$props.TransitionProps,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["BackdropProps", "children", "classes", "className", "disableBackdropClick", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "onEnter", "onEntered", "onEntering", "onEscapeKeyDown", "onExit", "onExited", "onExiting", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"]);
      return _react.default.createElement(_Modal.default, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.root, className),
        BackdropProps: (0, _extends2.default)({
          transitionDuration: transitionDuration
        }, BackdropProps),
        closeAfterTransition: true,
        disableBackdropClick: disableBackdropClick,
        disableEscapeKeyDown: disableEscapeKeyDown,
        onBackdropClick: onBackdropClick,
        onEscapeKeyDown: onEscapeKeyDown,
        onClose: onClose,
        open: open,
        role: "dialog"
      }, other), _react.default.createElement(TransitionComponent, (0, _extends2.default)({
        appear: true,
        in: open,
        timeout: transitionDuration,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: onExited
      }, TransitionProps), _react.default.createElement("div", {
        className: (0, _classnames.default)(classes.container, classes["scroll".concat((0, _helpers.capitalize)(scroll))]),
        onClick: this.handleBackdropClick,
        onMouseDown: this.handleMouseDown,
        role: "document"
      }, _react.default.createElement(PaperComponent, (0, _extends2.default)({
        elevation: 24
      }, PaperProps, {
        className: (0, _classnames.default)(classes.paper, classes["paperScroll".concat((0, _helpers.capitalize)(scroll))], (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["paperWidth".concat(maxWidth ? (0, _helpers.capitalize)(maxWidth) : '')], maxWidth), (0, _defineProperty2.default)(_classNames, classes.paperFullScreen, fullScreen), (0, _defineProperty2.default)(_classNames, classes.paperFullWidth, fullWidth), _classNames), PaperProps.className)
      }), children))));
    }
  }]);
  return Dialog;
}(_react.default.Component);

 false ? Dialog.propTypes = {
  /**
   * @ignore
   */
  BackdropProps: _propTypes.default.object,

  /**
   * Dialog children, usually the included sub-components.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, clicking the backdrop will not fire the `onClose` callback.
   */
  disableBackdropClick: _propTypes.default.bool,

  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   */
  disableEscapeKeyDown: _propTypes.default.bool,

  /**
   * If `true`, the dialog will be full-screen
   */
  fullScreen: _propTypes.default.bool,

  /**
   * If `true`, the dialog stretches to `maxWidth`.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * Determine the max width of the dialog.
   * The dialog width grows with the size of the screen, this property is useful
   * on the desktop where you might need some coherent different width size across your
   * application. Set to `false` to disable `maxWidth`.
   */
  maxWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]),

  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback
   * @param {string} reason Can be:`"escapeKeyDown"`, `"backdropClick"`
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired before the dialog enters.
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired when the dialog has entered.
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired when the dialog is entering.
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired when the escape key is pressed,
   * `disableKeyboard` is false and the modal is in focus.
   */
  onEscapeKeyDown: _propTypes.default.func,

  /**
   * Callback fired before the dialog exits.
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired when the dialog has exited.
   */
  onExited: _propTypes.default.func,

  /**
   * Callback fired when the dialog is exiting.
   */
  onExiting: _propTypes.default.func,

  /**
   * If `true`, the Dialog is open.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * The component used to render the body of the dialog.
   */
  PaperComponent: _utils.componentPropType,

  /**
   * Properties applied to the [`Paper`](/api/paper/) element.
   */
  PaperProps: _propTypes.default.object,

  /**
   * Determine the container for scrolling the dialog.
   */
  scroll: _propTypes.default.oneOf(['body', 'paper']),

  /**
   * The component used for the transition.
   */
  TransitionComponent: _utils.componentPropType,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })]),

  /**
   * Properties applied to the `Transition` element.
   */
  TransitionProps: _propTypes.default.object
} : void 0;
Dialog.defaultProps = {
  disableBackdropClick: false,
  disableEscapeKeyDown: false,
  fullScreen: false,
  fullWidth: false,
  maxWidth: 'sm',
  PaperComponent: _Paper.default,
  scroll: 'paper',
  TransitionComponent: _Fade.default,
  transitionDuration: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDialog'
})(Dialog);

exports.default = _default;

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _reactHelpers = __webpack_require__(70);

__webpack_require__(36);

// So we don't have any override priority issue.
var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flex: '0 0 auto',
    margin: '8px 4px'
  },

  /* Styles applied to the children. */
  action: {
    margin: '0 4px'
  }
};
exports.styles = styles;

function DialogActions(props) {
  var disableActionSpacing = props.disableActionSpacing,
      children = props.children,
      classes = props.classes,
      className = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["disableActionSpacing", "children", "classes", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), disableActionSpacing ? children : (0, _reactHelpers.cloneChildrenWithClassName)(children, classes.action));
}

 false ? DialogActions.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the dialog actions do not have additional margin.
   */
  disableActionSpacing: _propTypes.default.bool
} : void 0;
DialogActions.defaultProps = {
  disableActionSpacing: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDialogActions'
})(DialogActions);

exports.default = _default;

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var styles = {
  /* Styles applied to the root element. */
  root: {
    flex: '1 1 auto',
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch',
    // Add iOS momentum scrolling.
    padding: '0 24px 24px',
    '&:first-child': {
      paddingTop: 24
    }
  }
};
exports.styles = styles;

function DialogContent(props) {
  var classes = props.classes,
      children = props.children,
      className = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "children", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), children);
}

 false ? DialogContent.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : void 0;

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDialogContent'
})(DialogContent);

exports.default = _default;

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _Typography = _interopRequireDefault(__webpack_require__(25));

// @inheritedComponent Typography
var styles = {
  /* Styles applied to the root element. */
  root: {
    // Should use variant="body1" in v4
    lineHeight: 1.5
  }
};
exports.styles = styles;

function DialogContentText(props) {
  return _react.default.createElement(_Typography.default, (0, _extends2.default)({
    component: "p",
    internalDeprecatedVariant: true,
    variant: "subheading",
    color: "textSecondary"
  }, props));
}

 false ? DialogContentText.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired
} : void 0;

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDialogContentText'
})(DialogContentText);

exports.default = _default;

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _Typography = _interopRequireDefault(__webpack_require__(25));

var styles = {
  /* Styles applied to the root element. */
  root: {
    margin: 0,
    padding: '24px 24px 20px',
    flex: '0 0 auto'
  }
};
exports.styles = styles;

function DialogTitle(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      disableTypography = props.disableTypography,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableTypography"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), disableTypography ? children : _react.default.createElement(_Typography.default, {
    variant: "title",
    internalDeprecatedVariant: true
  }, children));
}

 false ? DialogTitle.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the children won't be wrapped by a typography component.
   * For instance, this can be useful to render an h4 instead of the default h2.
   */
  disableTypography: _propTypes.default.bool
} : void 0;
DialogTitle.defaultProps = {
  disableTypography: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDialogTitle'
})(DialogTitle);

exports.default = _default;

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _warning = _interopRequireDefault(__webpack_require__(27));

var _Collapse = _interopRequireDefault(__webpack_require__(286));

var _Paper = _interopRequireDefault(__webpack_require__(63));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _reactHelpers = __webpack_require__(70);

// @inheritedComponent Paper
var styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      transition: theme.transitions.create(['margin'], transition),
      '&:before': {
        position: 'absolute',
        left: 0,
        top: -1,
        right: 0,
        height: 1,
        content: '""',
        opacity: 1,
        backgroundColor: theme.palette.divider,
        transition: theme.transitions.create(['opacity', 'background-color'], transition)
      },
      '&:first-child': {
        '&:before': {
          display: 'none'
        }
      },
      '&$expanded + &': {
        '&:before': {
          display: 'none'
        }
      }
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: 0,
      '&:first-child': {
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius
      },
      '&:last-child': {
        borderBottomLeftRadius: theme.shape.borderRadius,
        borderBottomRightRadius: theme.shape.borderRadius,
        // Fix a rendering issue on Edge
        '@supports (-ms-ime-align: auto)': {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    },

    /* Styles applied to the root element if `expanded={true}`. */
    expanded: {
      margin: '16px 0',
      '&:first-child': {
        marginTop: 0
      },
      '&:last-child': {
        marginBottom: 0
      },
      '&:before': {
        opacity: 0
      }
    },

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {
      backgroundColor: theme.palette.action.disabledBackground
    }
  };
};

exports.styles = styles;

var ExpansionPanel =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ExpansionPanel, _React$Component);

  function ExpansionPanel(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ExpansionPanel);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ExpansionPanel).call(this));

    _this.handleChange = function (event) {
      var expanded = _this.isControlled ? _this.props.expanded : _this.state.expanded;

      if (!_this.isControlled) {
        _this.setState({
          expanded: !expanded
        });
      }

      if (_this.props.onChange) {
        _this.props.onChange(event, !expanded);
      }
    };

    _this.isControlled = props.expanded != null;
    _this.state = {};

    if (!_this.isControlled) {
      // not controlled, use internal state
      _this.state.expanded = props.defaultExpanded !== undefined ? props.defaultExpanded : false;
    }

    return _this;
  }

  (0, _createClass2.default)(ExpansionPanel, [{
    key: "render",
    value: function render() {
      var _this2 = this,
          _classNames;

      var _this$props = this.props,
          childrenProp = _this$props.children,
          classes = _this$props.classes,
          classNameProp = _this$props.className,
          CollapsePropsProp = _this$props.CollapseProps,
          defaultExpanded = _this$props.defaultExpanded,
          disabled = _this$props.disabled,
          expandedProp = _this$props.expanded,
          onChange = _this$props.onChange,
          square = _this$props.square,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "classes", "className", "CollapseProps", "defaultExpanded", "disabled", "expanded", "onChange", "square"]);
      var expanded = this.isControlled ? expandedProp : this.state.expanded;
      var summary = null;

      var children = _react.default.Children.map(childrenProp, function (child) {
        if (!_react.default.isValidElement(child)) {
          return null;
        }

         false ? (0, _warning.default)(child.type !== _react.default.Fragment, ["Material-UI: the ExpansionPanel component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n')) : void 0;

        if ((0, _reactHelpers.isMuiElement)(child, ['ExpansionPanelSummary'])) {
          summary = _react.default.cloneElement(child, {
            disabled: disabled,
            expanded: expanded,
            onChange: _this2.handleChange
          });
          return null;
        }

        return child;
      });

      var CollapseProps = !expanded ? {
        'aria-hidden': 'true'
      } : null;
      return _react.default.createElement(_Paper.default, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.expanded, expanded), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.rounded, !square), _classNames), classNameProp),
        elevation: 1,
        square: square
      }, other), summary, _react.default.createElement(_Collapse.default, (0, _extends2.default)({
        in: expanded,
        timeout: "auto"
      }, CollapseProps, CollapsePropsProp), children));
    }
  }]);
  return ExpansionPanel;
}(_react.default.Component);

 false ? ExpansionPanel.propTypes = {
  /**
   * The content of the expansion panel.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Properties applied to the [`Collapse`](/api/collapse/) element.
   */
  CollapseProps: _propTypes.default.object,

  /**
   * If `true`, expands the panel by default.
   */
  defaultExpanded: _propTypes.default.bool,

  /**
   * If `true`, the panel will be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, expands the panel, otherwise collapse it.
   * Setting this prop enables control over the panel.
   */
  expanded: _propTypes.default.bool,

  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {object} event The event source of the callback
   * @param {boolean} expanded The `expanded` state of the panel
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  square: _propTypes.default.bool
} : void 0;
ExpansionPanel.defaultProps = {
  defaultExpanded: false,
  disabled: false,
  square: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiExpansionPanel'
})(ExpansionPanel);

exports.default = _default;

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ExpansionPanelActions.default;
  }
});

var _ExpansionPanelActions = _interopRequireDefault(__webpack_require__(996));

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _reactHelpers = __webpack_require__(70);

__webpack_require__(36);

// So we don't have any override priority issue.
var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '16px 8px'
  },

  /* Styles applied to the children. */
  action: {
    marginLeft: 8
  }
};
exports.styles = styles;

function ExpansionPanelActions(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), (0, _reactHelpers.cloneChildrenWithClassName)(children, classes.action));
}

 false ? ExpansionPanelActions.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : void 0;

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiExpansionPanelActions'
})(ExpansionPanelActions);

exports.default = _default;

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    padding: '8px 24px 24px'
  }
};
exports.styles = styles;

function ExpansionPanelDetails(props) {
  var classes = props.classes,
      children = props.children,
      className = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "children", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), children);
}

 false ? ExpansionPanelDetails.propTypes = {
  /**
   * The content of the expansion panel details.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : void 0;

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiExpansionPanelDetails'
})(ExpansionPanelDetails);

exports.default = _default;

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _ButtonBase = _interopRequireDefault(__webpack_require__(64));

var _IconButton = _interopRequireDefault(__webpack_require__(71));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      minHeight: 8 * 6,
      transition: theme.transitions.create(['min-height', 'background-color'], transition),
      padding: '0 24px 0 24px',
      '&:hover:not($disabled)': {
        cursor: 'pointer'
      },
      '&$expanded': {
        minHeight: 64
      },
      '&$focused': {
        backgroundColor: theme.palette.grey[300]
      },
      '&$disabled': {
        opacity: 0.38
      }
    },

    /* Styles applied to the root element if `expanded={true}`. */
    expanded: {},

    /* Styles applied to the root and children wrapper elements when focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the children wrapper element. */
    content: {
      display: 'flex',
      flexGrow: 1,
      transition: theme.transitions.create(['margin'], transition),
      margin: '12px 0',
      '& > :last-child': {
        paddingRight: 32
      },
      '&$expanded': {
        margin: '20px 0'
      }
    },

    /* Styles applied to the `IconButton` component when `expandIcon` is supplied. */
    expandIcon: {
      position: 'absolute',
      top: '50%',
      right: 8,
      transform: 'translateY(-50%) rotate(0deg)',
      transition: theme.transitions.create('transform', transition),
      '&:hover': {
        // Disable the hover effect for the IconButton,
        // because a hover effect should apply to the entire Expand button and
        // not only to the IconButton.
        backgroundColor: 'transparent'
      },
      '&$expanded': {
        transform: 'translateY(-50%) rotate(180deg)'
      }
    }
  };
};

exports.styles = styles;

var ExpansionPanelSummary =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ExpansionPanelSummary, _React$Component);

  function ExpansionPanelSummary() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ExpansionPanelSummary);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ExpansionPanelSummary)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      focused: false
    };

    _this.handleFocusVisible = function (event) {
      _this.setState({
        focused: true
      });

      if (_this.props.onFocusVisible) {
        _this.props.onFocusVisible(event);
      }
    };

    _this.handleBlur = function (event) {
      _this.setState({
        focused: false
      });

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    };

    _this.handleChange = function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          onClick = _this$props.onClick;

      if (onChange) {
        onChange(event);
      }

      if (onClick) {
        onClick(event);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(ExpansionPanelSummary, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props2 = this.props,
          children = _this$props2.children,
          classes = _this$props2.classes,
          className = _this$props2.className,
          disabled = _this$props2.disabled,
          expanded = _this$props2.expanded,
          expandIcon = _this$props2.expandIcon,
          IconButtonProps = _this$props2.IconButtonProps,
          onBlur = _this$props2.onBlur,
          onChange = _this$props2.onChange,
          onClick = _this$props2.onClick,
          onFocusVisible = _this$props2.onFocusVisible,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["children", "classes", "className", "disabled", "expanded", "expandIcon", "IconButtonProps", "onBlur", "onChange", "onClick", "onFocusVisible"]);
      var focused = this.state.focused;
      return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
        focusRipple: false,
        disableRipple: true,
        disabled: disabled,
        component: "div",
        "aria-expanded": expanded,
        className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.expanded, expanded), (0, _defineProperty2.default)(_classNames, classes.focused, focused), _classNames), className),
        onFocusVisible: this.handleFocusVisible,
        onBlur: this.handleBlur,
        onClick: this.handleChange
      }, other), _react.default.createElement("div", {
        className: (0, _classnames.default)(classes.content, (0, _defineProperty2.default)({}, classes.expanded, expanded))
      }, children), expandIcon && _react.default.createElement(_IconButton.default, (0, _extends2.default)({
        disabled: disabled,
        className: (0, _classnames.default)(classes.expandIcon, (0, _defineProperty2.default)({}, classes.expanded, expanded)),
        component: "div",
        tabIndex: -1,
        "aria-hidden": "true"
      }, IconButtonProps), expandIcon));
    }
  }]);
  return ExpansionPanelSummary;
}(_react.default.Component);

 false ? ExpansionPanelSummary.propTypes = {
  /**
   * The content of the expansion panel summary.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   * If `true`, the summary will be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * @ignore
   * If `true`, expands the summary, otherwise collapse it.
   */
  expanded: _propTypes.default.bool,

  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: _propTypes.default.node,

  /**
   * Properties applied to the `TouchRipple` element wrapping the expand icon.
   */
  IconButtonProps: _propTypes.default.object,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * @ignore
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onClick: _propTypes.default.func,

  /**
   * @ignore
   */
  onFocusVisible: _propTypes.default.func
} : void 0;
ExpansionPanelSummary.defaultProps = {
  disabled: false
};
ExpansionPanelSummary.muiName = 'ExpansionPanelSummary';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiExpansionPanelSummary'
})(ExpansionPanelSummary);

exports.default = _default;

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Fab.default;
  }
});

var _Fab = _interopRequireDefault(__webpack_require__(1000));

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _ButtonBase = _interopRequireDefault(__webpack_require__(64));

var _helpers = __webpack_require__(29);

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0, _extends2.default)({}, theme.typography.button, {
      boxSizing: 'border-box',
      minHeight: 36,
      transition: theme.transitions.create(['background-color', 'box-shadow', 'border'], {
        duration: theme.transitions.duration.short
      }),
      borderRadius: '50%',
      padding: 0,
      minWidth: 0,
      width: 56,
      height: 56,
      boxShadow: theme.shadows[6],
      '&:active': {
        boxShadow: theme.shadows[12]
      },
      color: theme.palette.getContrastText(theme.palette.grey[300]),
      backgroundColor: theme.palette.grey[300],
      '&$focusVisible': {
        boxShadow: theme.shadows[6]
      },
      '&:hover': {
        backgroundColor: theme.palette.grey.A100,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.grey[300]
        },
        '&$disabled': {
          backgroundColor: theme.palette.action.disabledBackground
        },
        textDecoration: 'none'
      },
      '&$disabled': {
        color: theme.palette.action.disabled,
        boxShadow: theme.shadows[0],
        backgroundColor: theme.palette.action.disabledBackground
      }
    }),

    /* Styles applied to the span element that wraps the children. */
    label: {
      width: '100%',
      // assure the correct width for iOS Safari
      display: 'inherit',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    primary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.primary.main
        }
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    secondary: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.secondary.main
        }
      }
    },

    /* Styles applied to the root element if `variant="extended"`. */
    extended: {
      borderRadius: 48 / 2,
      padding: '0 16px',
      width: 'auto',
      minHeight: 'auto',
      minWidth: 48,
      height: 48,
      '&$sizeSmall': {
        width: 'auto',
        padding: '0 8px',
        borderRadius: 34 / 2,
        minWidth: 34,
        height: 34
      },
      '&$sizeMedium': {
        width: 'auto',
        padding: '0 16px',
        borderRadius: 40 / 2,
        minWidth: 40,
        height: 40
      }
    },

    /* Styles applied to the ButtonBase root element if the button is keyboard focused. */
    focusVisible: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `size="small"``. */
    sizeSmall: {
      width: 40,
      height: 40
    },

    /* Styles applied to the root element if `size="medium"``. */
    sizeMedium: {
      width: 48,
      height: 48
    }
  };
};

exports.styles = styles;

function Fab(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      className = props.className,
      color = props.color,
      disabled = props.disabled,
      disableFocusRipple = props.disableFocusRipple,
      focusVisibleClassName = props.focusVisibleClassName,
      size = props.size,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "disabled", "disableFocusRipple", "focusVisibleClassName", "size", "variant"]);
  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.extended, variant === 'extended'), (0, _defineProperty2.default)(_classNames, classes.primary, color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.secondary, color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes["size".concat((0, _helpers.capitalize)(size))], size !== 'large'), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.colorInherit, color === 'inherit'), _classNames), className),
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: (0, _classnames.default)(classes.focusVisible, focusVisibleClassName)
  }, other), _react.default.createElement("span", {
    className: classes.label
  }, children));
}

 false ? Fab.propTypes = {
  /**
   * The content of the button.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * If `true`, the button will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   * `disableRipple` must also be true.
   */
  disableFocusRipple: _propTypes.default.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * @ignore
   */
  focusVisibleClassName: _propTypes.default.string,

  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: _propTypes.default.string,

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),

  /**
   * @ignore
   */
  type: _propTypes.default.string,

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['round', 'extended'])
} : void 0;
Fab.defaultProps = {
  color: 'default',
  component: 'button',
  disabled: false,
  disableFocusRipple: false,
  size: 'large',
  type: 'button',
  variant: 'round'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiFab'
})(Fab);

exports.default = _default;

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormControlLabel.default;
  }
});

var _FormControlLabel = _interopRequireDefault(__webpack_require__(1002));

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withFormControlContext = _interopRequireDefault(__webpack_require__(96));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _Typography = _interopRequireDefault(__webpack_require__(25));

var _helpers = __webpack_require__(29);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'pointer',
      // For correct alignment with the text.
      verticalAlign: 'middle',
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      marginLeft: -14,
      marginRight: 16,
      // used for row presentation of radio/checkbox
      '&$disabled': {
        cursor: 'default'
      }
    },

    /* Styles applied to the root element if `labelPlacement="start"`. */
    labelPlacementStart: {
      flexDirection: 'row-reverse',
      marginLeft: 16,
      // used for row presentation of radio/checkbox
      marginRight: -14
    },

    /* Styles applied to the root element if `labelPlacement="top"`. */
    labelPlacementTop: {
      flexDirection: 'column-reverse',
      marginLeft: 16
    },

    /* Styles applied to the root element if `labelPlacement="bottom"`. */
    labelPlacementBottom: {
      flexDirection: 'column',
      marginLeft: 16
    },

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the label's Typography component. */
    label: {
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    }
  };
};
/**
 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */


exports.styles = styles;

function FormControlLabel(props) {
  var _classNames;

  var checked = props.checked,
      classes = props.classes,
      classNameProp = props.className,
      control = props.control,
      disabledProp = props.disabled,
      inputRef = props.inputRef,
      label = props.label,
      labelPlacement = props.labelPlacement,
      muiFormControl = props.muiFormControl,
      name = props.name,
      onChange = props.onChange,
      value = props.value,
      other = (0, _objectWithoutProperties2.default)(props, ["checked", "classes", "className", "control", "disabled", "inputRef", "label", "labelPlacement", "muiFormControl", "name", "onChange", "value"]);
  var disabled = disabledProp;

  if (typeof disabled === 'undefined' && typeof control.props.disabled !== 'undefined') {
    disabled = control.props.disabled;
  }

  if (typeof disabled === 'undefined' && muiFormControl) {
    disabled = muiFormControl.disabled;
  }

  var controlProps = {
    disabled: disabled
  };
  ['checked', 'name', 'onChange', 'value', 'inputRef'].forEach(function (key) {
    if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') {
      controlProps[key] = props[key];
    }
  });
  return _react.default.createElement("label", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["labelPlacement".concat((0, _helpers.capitalize)(labelPlacement))], labelPlacement !== 'end'), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), classNameProp)
  }, other), _react.default.cloneElement(control, controlProps), _react.default.createElement(_Typography.default, {
    component: "span",
    className: (0, _classnames.default)(classes.label, (0, _defineProperty2.default)({}, classes.disabled, disabled))
  }, label));
}

 false ? FormControlLabel.propTypes = {
  /**
   * If `true`, the component appears selected.
   */
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * A control element. For instance, it can be be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: _propTypes.default.element,

  /**
   * If `true`, the control will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * The text to be used in an enclosing label element.
   */
  label: _propTypes.default.node,

  /**
   * The position of the label.
   */
  labelPlacement: _propTypes.default.oneOf(['end', 'start', 'top', 'bottom']),

  /**
   * @ignore
   */
  muiFormControl: _propTypes.default.object,

  /*
   * @ignore
   */
  name: _propTypes.default.string,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.checked`.
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes.default.func,

  /**
   * The value of the component.
   */
  value: _propTypes.default.string
} : void 0;
FormControlLabel.defaultProps = {
  labelPlacement: 'end'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiFormControlLabel'
})((0, _withFormControlContext.default)(FormControlLabel));

exports.default = _default;

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap'
  },

  /* Styles applied to the root element if `row={true}`. */
  row: {
    flexDirection: 'row'
  }
};
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */

exports.styles = styles;

function FormGroup(props) {
  var classes = props.classes,
      className = props.className,
      children = props.children,
      row = props.row,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "children", "row"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.row, row), className)
  }, other), children);
}

 false ? FormGroup.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Display group of elements in a compact row.
   */
  row: _propTypes.default.bool
} : void 0;
FormGroup.defaultProps = {
  row: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiFormGroup'
})(FormGroup);

exports.default = _default;

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _createBreakpoints = __webpack_require__(151);

var _requirePropFactory = _interopRequireDefault(__webpack_require__(1005));

// A grid component using the following libs as inspiration.
//
// For the implementation:
// - http://v4-alpha.getbootstrap.com/layout/flexbox-grid/
// - https://github.com/kristoferjoseph/flexboxgrid/blob/master/src/css/flexboxgrid.css
// - https://github.com/roylee0704/react-flexbox-grid
// - https://material.angularjs.org/latest/layout/introduction
//
// Follow this flexbox Guide to better understand the underlying model:
// - https://css-tricks.com/snippets/css/a-guide-to-flexbox/
var GUTTERS = [0, 8, 16, 24, 32, 40];
var GRID_SIZES = ['auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

function generateGrid(globalStyles, theme, breakpoint) {
  var styles = {};
  GRID_SIZES.forEach(function (size) {
    var key = "grid-".concat(breakpoint, "-").concat(size);

    if (size === true) {
      // For the auto layouting
      styles[key] = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: '100%'
      };
      return;
    }

    if (size === 'auto') {
      styles[key] = {
        flexBasis: 'auto',
        flexGrow: 0,
        maxWidth: 'none'
      };
      return;
    } // Keep 7 significant numbers.


    var width = "".concat(Math.round(size / 12 * 10e7) / 10e5, "%"); // Close to the bootstrap implementation:
    // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41

    styles[key] = {
      flexBasis: width,
      flexGrow: 0,
      maxWidth: width
    };
  }); // No need for a media query for the first size.

  if (breakpoint === 'xs') {
    (0, _extends2.default)(globalStyles, styles);
  } else {
    globalStyles[theme.breakpoints.up(breakpoint)] = styles;
  }
}

function generateGutter(theme, breakpoint) {
  var styles = {};
  GUTTERS.forEach(function (spacing, index) {
    if (index === 0) {
      // Skip the default style.
      return;
    }

    styles["spacing-".concat(breakpoint, "-").concat(spacing)] = {
      margin: -spacing / 2,
      width: "calc(100% + ".concat(spacing, "px)"),
      '& > $item': {
        padding: spacing / 2
      }
    };
  });
  return styles;
} // Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',


var styles = function styles(theme) {
  return (0, _extends2.default)({
    /* Styles applied to the root element if `container={true}`. */
    container: {
      boxSizing: 'border-box',
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%'
    },

    /* Styles applied to the root element if `item={true}`. */
    item: {
      boxSizing: 'border-box',
      margin: '0' // For instance, it's useful when used with a `figure` element.

    },

    /* Styles applied to the root element if `zeroMinWidth={true}`. */
    zeroMinWidth: {
      minWidth: 0
    },

    /* Styles applied to the root element if `direction="column"`. */
    'direction-xs-column': {
      flexDirection: 'column'
    },

    /* Styles applied to the root element if `direction="column-reverse"`. */
    'direction-xs-column-reverse': {
      flexDirection: 'column-reverse'
    },

    /* Styles applied to the root element if `direction="rwo-reverse"`. */
    'direction-xs-row-reverse': {
      flexDirection: 'row-reverse'
    },

    /* Styles applied to the root element if `wrap="nowrap"`. */
    'wrap-xs-nowrap': {
      flexWrap: 'nowrap'
    },

    /* Styles applied to the root element if `wrap="reverse"`. */
    'wrap-xs-wrap-reverse': {
      flexWrap: 'wrap-reverse'
    },

    /* Styles applied to the root element if `alignItems="center"`. */
    'align-items-xs-center': {
      alignItems: 'center'
    },

    /* Styles applied to the root element if `alignItems="flex-start"`. */
    'align-items-xs-flex-start': {
      alignItems: 'flex-start'
    },

    /* Styles applied to the root element if `alignItems="flex-end"`. */
    'align-items-xs-flex-end': {
      alignItems: 'flex-end'
    },

    /* Styles applied to the root element if `alignItems="baseline"`. */
    'align-items-xs-baseline': {
      alignItems: 'baseline'
    },

    /* Styles applied to the root element if `alignContent="center"`. */
    'align-content-xs-center': {
      alignContent: 'center'
    },

    /* Styles applied to the root element if `alignContent="flex-start"`. */
    'align-content-xs-flex-start': {
      alignContent: 'flex-start'
    },

    /* Styles applied to the root element if `alignContent="flex-end"`. */
    'align-content-xs-flex-end': {
      alignContent: 'flex-end'
    },

    /* Styles applied to the root element if `alignContent="space-between"`. */
    'align-content-xs-space-between': {
      alignContent: 'space-between'
    },

    /* Styles applied to the root element if `alignContent="space-around"`. */
    'align-content-xs-space-around': {
      alignContent: 'space-around'
    },

    /* Styles applied to the root element if `justify="center"`. */
    'justify-xs-center': {
      justifyContent: 'center'
    },

    /* Styles applied to the root element if `justify="flex-end"`. */
    'justify-xs-flex-end': {
      justifyContent: 'flex-end'
    },

    /* Styles applied to the root element if `justify="space-between"`. */
    'justify-xs-space-between': {
      justifyContent: 'space-between'
    },

    /* Styles applied to the root element if `justify="space-around"`. */
    'justify-xs-space-around': {
      justifyContent: 'space-around'
    },

    /* Styles applied to the root element if `justify="space-evenly"`. */
    'justify-xs-space-evenly': {
      justifyContent: 'space-evenly'
    }
  }, generateGutter(theme, 'xs'), _createBreakpoints.keys.reduce(function (accumulator, key) {
    // Use side effect over immutability for better performance.
    generateGrid(accumulator, theme, key);
    return accumulator;
  }, {}));
};

exports.styles = styles;

function Grid(props) {
  var _classNames;

  var alignContent = props.alignContent,
      alignItems = props.alignItems,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      container = props.container,
      direction = props.direction,
      item = props.item,
      justify = props.justify,
      lg = props.lg,
      md = props.md,
      sm = props.sm,
      spacing = props.spacing,
      wrap = props.wrap,
      xl = props.xl,
      xs = props.xs,
      zeroMinWidth = props.zeroMinWidth,
      other = (0, _objectWithoutProperties2.default)(props, ["alignContent", "alignItems", "classes", "className", "component", "container", "direction", "item", "justify", "lg", "md", "sm", "spacing", "wrap", "xl", "xs", "zeroMinWidth"]);
  var className = (0, _classnames.default)((_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.container, container), (0, _defineProperty2.default)(_classNames, classes.item, item), (0, _defineProperty2.default)(_classNames, classes.zeroMinWidth, zeroMinWidth), (0, _defineProperty2.default)(_classNames, classes["spacing-xs-".concat(String(spacing))], container && spacing !== 0), (0, _defineProperty2.default)(_classNames, classes["direction-xs-".concat(String(direction))], direction !== Grid.defaultProps.direction), (0, _defineProperty2.default)(_classNames, classes["wrap-xs-".concat(String(wrap))], wrap !== Grid.defaultProps.wrap), (0, _defineProperty2.default)(_classNames, classes["align-items-xs-".concat(String(alignItems))], alignItems !== Grid.defaultProps.alignItems), (0, _defineProperty2.default)(_classNames, classes["align-content-xs-".concat(String(alignContent))], alignContent !== Grid.defaultProps.alignContent), (0, _defineProperty2.default)(_classNames, classes["justify-xs-".concat(String(justify))], justify !== Grid.defaultProps.justify), (0, _defineProperty2.default)(_classNames, classes["grid-xs-".concat(String(xs))], xs !== false), (0, _defineProperty2.default)(_classNames, classes["grid-sm-".concat(String(sm))], sm !== false), (0, _defineProperty2.default)(_classNames, classes["grid-md-".concat(String(md))], md !== false), (0, _defineProperty2.default)(_classNames, classes["grid-lg-".concat(String(lg))], lg !== false), (0, _defineProperty2.default)(_classNames, classes["grid-xl-".concat(String(xl))], xl !== false), _classNames), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

 false ? Grid.propTypes = {
  /**
   * Defines the `align-content` style property.
   * It's applied for all screen sizes.
   */
  alignContent: _propTypes.default.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around']),

  /**
   * Defines the `align-items` style property.
   * It's applied for all screen sizes.
   */
  alignItems: _propTypes.default.oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']),

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   */
  container: _propTypes.default.bool,

  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   */
  direction: _propTypes.default.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),

  /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   */
  item: _propTypes.default.bool,

  /**
   * Defines the `justify-content` style property.
   * It is applied for all screen sizes.
   */
  justify: _propTypes.default.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly']),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `lg` breakpoint and wider screens if not overridden.
   */
  lg: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `md` breakpoint and wider screens if not overridden.
   */
  md: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `sm` breakpoint and wider screens if not overridden.
   */
  sm: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the space between the type `item` component.
   * It can only be used on a type `container` component.
   */
  spacing: _propTypes.default.oneOf(GUTTERS),

  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   */
  wrap: _propTypes.default.oneOf(['nowrap', 'wrap', 'wrap-reverse']),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `xl` breakpoint and wider screens.
   */
  xl: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for all the screen sizes with the lowest priority.
   */
  xs: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   */
  zeroMinWidth: _propTypes.default.bool
} : void 0;
Grid.defaultProps = {
  alignContent: 'stretch',
  alignItems: 'stretch',
  component: 'div',
  container: false,
  direction: 'row',
  item: false,
  justify: 'flex-start',
  lg: false,
  md: false,
  sm: false,
  spacing: 0,
  wrap: 'wrap',
  xl: false,
  xs: false,
  zeroMinWidth: false
};
var StyledGrid = (0, _withStyles.default)(styles, {
  name: 'MuiGrid'
})(Grid);

if (false) {
  var requireProp = (0, _requirePropFactory.default)('Grid');
  StyledGrid.propTypes = (0, _extends2.default)({}, StyledGrid.propTypes, {
    alignContent: requireProp('container'),
    alignItems: requireProp('container'),
    direction: requireProp('container'),
    justify: requireProp('container'),
    lg: requireProp('item'),
    md: requireProp('item'),
    sm: requireProp('item'),
    spacing: requireProp('container'),
    wrap: requireProp('container'),
    xs: requireProp('item'),
    zeroMinWidth: requireProp('zeroMinWidth')
  });
}

var _default = StyledGrid;
exports.default = _default;

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function requirePropFactory(componentNameInError) {
  /* istanbul ignore if */
  if (true) {
    return function () {
      return null;
    };
  }

  var requireProp = function requireProp(requiredProp) {
    return function (props, propName, componentName, location, propFullName) {
      var propFullNameSafe = propFullName || propName;

      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
        return new Error("The property `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` must be used on `").concat(requiredProp, "`."));
      }

      return null;
    };
  };

  return requireProp;
}

var _default = requirePropFactory;
exports.default = _default;

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _GridList.default;
  }
});

var _GridList = _interopRequireDefault(__webpack_require__(1007));

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _warning = _interopRequireDefault(__webpack_require__(27));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    overflowY: 'auto',
    listStyle: 'none',
    padding: 0,
    WebkitOverflowScrolling: 'touch' // Add iOS momentum scrolling.

  }
};
exports.styles = styles;

function GridList(props) {
  var cellHeight = props.cellHeight,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      cols = props.cols,
      Component = props.component,
      spacing = props.spacing,
      style = props.style,
      other = (0, _objectWithoutProperties2.default)(props, ["cellHeight", "children", "classes", "className", "cols", "component", "spacing", "style"]);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, classNameProp),
    style: (0, _extends2.default)({
      margin: -spacing / 2
    }, style)
  }, other), _react.default.Children.map(children, function (child) {
    if (!_react.default.isValidElement(child)) {
      return null;
    }

     false ? (0, _warning.default)(child.type !== _react.default.Fragment, ["Material-UI: the GridList component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n')) : void 0;
    var childCols = child.props.cols || 1;
    var childRows = child.props.rows || 1;
    return _react.default.cloneElement(child, {
      style: (0, _extends2.default)({
        width: "".concat(100 / cols * childCols, "%"),
        height: cellHeight === 'auto' ? 'auto' : cellHeight * childRows + spacing,
        padding: spacing / 2
      }, child.props.style)
    });
  }));
}

 false ? GridList.propTypes = {
  /**
   * Number of px for one cell height.
   * You can set `'auto'` if you want to let the children determine the height.
   */
  cellHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['auto'])]),

  /**
   * Grid Tiles that will be in Grid List.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Number of columns.
   */
  cols: _propTypes.default.number,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * Number of px for the spacing between tiles.
   */
  spacing: _propTypes.default.number,

  /**
   * @ignore
   */
  style: _propTypes.default.object
} : void 0;
GridList.defaultProps = {
  cellHeight: 180,
  cols: 2,
  component: 'ul',
  spacing: 4
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiGridList'
})(GridList);

exports.default = _default;

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _GridListTile.default;
  }
});

var _GridListTile = _interopRequireDefault(__webpack_require__(1009));

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(50));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _reactEventListener = _interopRequireDefault(__webpack_require__(94));

var _debounce = _interopRequireDefault(__webpack_require__(125));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

// < 1kb payload overhead when lodash/debounce is > 3kb.
var styles = {
  /* Styles applied to the root element. */
  root: {
    boxSizing: 'border-box',
    flexShrink: 0
  },

  /* Styles applied to the `div` element that wraps the children. */
  tile: {
    position: 'relative',
    display: 'block',
    // In case it's not rendered with a div.
    height: '100%',
    overflow: 'hidden'
  },

  /* Styles applied to an `img` element child, if needed to ensure it covers the tile. */
  imgFullHeight: {
    height: '100%',
    transform: 'translateX(-50%)',
    position: 'relative',
    left: '50%'
  },

  /* Styles applied to an `img` element child, if needed to ensure it covers the tile. */
  imgFullWidth: {
    width: '100%',
    position: 'relative',
    transform: 'translateY(-50%)',
    top: '50%'
  }
};
exports.styles = styles;

var GridListTile =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(GridListTile, _React$Component);

  function GridListTile() {
    var _this;

    (0, _classCallCheck2.default)(this, GridListTile);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(GridListTile).call(this));

    _this.fit = function () {
      var imgElement = _this.imgElement;

      if (!imgElement || !imgElement.complete) {
        return;
      }

      if (imgElement.width / imgElement.height > imgElement.parentNode.offsetWidth / imgElement.parentNode.offsetHeight) {
        var _imgElement$classList, _imgElement$classList2;

        (_imgElement$classList = imgElement.classList).remove.apply(_imgElement$classList, (0, _toConsumableArray2.default)(_this.props.classes.imgFullWidth.split(' ')));

        (_imgElement$classList2 = imgElement.classList).add.apply(_imgElement$classList2, (0, _toConsumableArray2.default)(_this.props.classes.imgFullHeight.split(' ')));
      } else {
        var _imgElement$classList3, _imgElement$classList4;

        (_imgElement$classList3 = imgElement.classList).remove.apply(_imgElement$classList3, (0, _toConsumableArray2.default)(_this.props.classes.imgFullHeight.split(' ')));

        (_imgElement$classList4 = imgElement.classList).add.apply(_imgElement$classList4, (0, _toConsumableArray2.default)(_this.props.classes.imgFullWidth.split(' ')));
      }

      imgElement.removeEventListener('load', _this.fit);
    };

    if (typeof window !== 'undefined') {
      _this.handleResize = (0, _debounce.default)(function () {
        _this.fit();
      }, 166); // Corresponds to 10 frames at 60 Hz.
    }

    return _this;
  }

  (0, _createClass2.default)(GridListTile, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.ensureImageCover();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.ensureImageCover();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleResize.clear();
    }
  }, {
    key: "ensureImageCover",
    value: function ensureImageCover() {
      if (!this.imgElement) {
        return;
      }

      if (this.imgElement.complete) {
        this.fit();
      } else {
        this.imgElement.addEventListener('load', this.fit);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          classes = _this$props.classes,
          className = _this$props.className,
          cols = _this$props.cols,
          Component = _this$props.component,
          rows = _this$props.rows,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "classes", "className", "cols", "component", "rows"]);
      return _react.default.createElement(Component, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.root, className)
      }, other), _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }), _react.default.createElement("div", {
        className: classes.tile
      }, _react.default.Children.map(children, function (child) {
        if (!_react.default.isValidElement(child)) {
          return null;
        }

        if (child.type === 'img') {
          return _react.default.cloneElement(child, {
            ref: function ref(node) {
              _this2.imgElement = node;
            }
          });
        }

        return child;
      })));
    }
  }]);
  return GridListTile;
}(_react.default.Component);

 false ? GridListTile.propTypes = {
  /**
   * Theoretically you can pass any node as children, but the main use case is to pass an img,
   * in which case GridListTile takes care of making the image "cover" available space
   * (similar to `background-size: cover` or to `object-fit: cover`).
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Width of the tile in number of grid cells.
   */
  cols: _propTypes.default.number,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * Height of the tile in number of grid cells.
   */
  rows: _propTypes.default.number
} : void 0;
GridListTile.defaultProps = {
  cols: 1,
  component: 'li',
  rows: 1
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiGridListTile'
})(GridListTile);

exports.default = _default;

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _GridListTileBar.default;
  }
});

var _GridListTileBar = _interopRequireDefault(__webpack_require__(1011));

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'absolute',
      left: 0,
      right: 0,
      height: 48,
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      fontFamily: theme.typography.fontFamily
    },

    /* Styles applied to the root element if `titlePosition="bottom"`. */
    titlePositionBottom: {
      bottom: 0
    },

    /* Styles applied to the root element if `titlePosition="top"`. */
    titlePositionTop: {
      top: 0
    },

    /* Styles applied to the root element if a `subtitle` is provided. */
    rootSubtitle: {
      height: 68
    },

    /* Styles applied to the title and subtitle container element. */
    titleWrap: {
      flexGrow: 1,
      marginLeft: theme.mixins.gutters().paddingLeft,
      marginRight: theme.mixins.gutters().paddingRight,
      color: theme.palette.common.white,
      overflow: 'hidden'
    },

    /* Styles applied to the container element if `actionPosition="left"`. */
    titleWrapActionPosLeft: {
      marginLeft: 0
    },

    /* Styles applied to the container element if `actionPosition="right"`. */
    titleWrapActionPosRight: {
      marginRight: 0
    },

    /* Styles applied to the title container element. */
    title: {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: '24px',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the subtitle container element. */
    subtitle: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: 1,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the actionIcon if supplied. */
    actionIcon: {},

    /* Styles applied to the actionIcon if `actionPosition="left"`. */
    actionIconActionPosLeft: {
      order: -1
    }
  };
};

exports.styles = styles;

function GridListTileBar(props) {
  var _classNames, _classNames2;

  var actionIcon = props.actionIcon,
      actionPosition = props.actionPosition,
      classes = props.classes,
      classNameProp = props.className,
      subtitle = props.subtitle,
      title = props.title,
      titlePosition = props.titlePosition,
      other = (0, _objectWithoutProperties2.default)(props, ["actionIcon", "actionPosition", "classes", "className", "subtitle", "title", "titlePosition"]);
  var actionPos = actionIcon && actionPosition;
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.titlePositionBottom, titlePosition === 'bottom'), (0, _defineProperty2.default)(_classNames, classes.titlePositionTop, titlePosition === 'top'), (0, _defineProperty2.default)(_classNames, classes.rootSubtitle, subtitle), _classNames), classNameProp); // Remove the margin between the title / subtitle wrapper, and the Action Icon

  var titleWrapClassName = (0, _classnames.default)(classes.titleWrap, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.titleWrapActionPosLeft, actionPos === 'left'), (0, _defineProperty2.default)(_classNames2, classes.titleWrapActionPosRight, actionPos === 'right'), _classNames2));
  return _react.default.createElement("div", (0, _extends2.default)({
    className: className
  }, other), _react.default.createElement("div", {
    className: titleWrapClassName
  }, _react.default.createElement("div", {
    className: classes.title
  }, title), subtitle ? _react.default.createElement("div", {
    className: classes.subtitle
  }, subtitle) : null), actionIcon ? _react.default.createElement("div", {
    className: (0, _classnames.default)(classes.actionIcon, (0, _defineProperty2.default)({}, classes.actionIconActionPosLeft, actionPos === 'left'))
  }, actionIcon) : null);
}

 false ? GridListTileBar.propTypes = {
  /**
   * An IconButton element to be used as secondary action target
   * (primary action target is the tile itself).
   */
  actionIcon: _propTypes.default.node,

  /**
   * Position of secondary action IconButton.
   */
  actionPosition: _propTypes.default.oneOf(['left', 'right']),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * String or element serving as subtitle (support text).
   */
  subtitle: _propTypes.default.node,

  /**
   * Title to be displayed on tile.
   */
  title: _propTypes.default.node,

  /**
   * Position of the title bar.
   */
  titlePosition: _propTypes.default.oneOf(['top', 'bottom'])
} : void 0;
GridListTileBar.defaultProps = {
  actionPosition: 'right',
  titlePosition: 'bottom'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiGridListTileBar'
})(GridListTileBar);

exports.default = _default;

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Hidden.default;
  }
});

var _Hidden = _interopRequireDefault(__webpack_require__(1013));

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _HiddenJs = _interopRequireDefault(__webpack_require__(1014));

var _HiddenCss = _interopRequireDefault(__webpack_require__(1016));

/**
 * Responsively hides children based on the selected implementation.
 */
function Hidden(props) {
  var implementation = props.implementation,
      other = (0, _objectWithoutProperties2.default)(props, ["implementation"]);

  if (implementation === 'js') {
    return _react.default.createElement(_HiddenJs.default, other);
  }

  return _react.default.createElement(_HiddenCss.default, other);
}

 false ? Hidden.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   */
  implementation: _propTypes.default.oneOf(['js', 'css']),

  /**
   * You can use this property when choosing the `js` implementation with server-side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty component during the first mount.
   * You might want to use an heuristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * https://caniuse.com/#search=client%20hint
   */
  initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

  /**
   * If true, screens this size and down will be hidden.
   */
  lgDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  lgUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  mdDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  mdUp: _propTypes.default.bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If true, screens this size and down will be hidden.
   */
  smDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  smUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xlDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xlUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xsDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xsUp: _propTypes.default.bool
} : void 0;
Hidden.defaultProps = {
  implementation: 'js',
  lgDown: false,
  lgUp: false,
  mdDown: false,
  mdUp: false,
  smDown: false,
  smUp: false,
  xlDown: false,
  xlUp: false,
  xsDown: false,
  xsUp: false
};
var _default = Hidden;
exports.default = _default;

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(150);

var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _createBreakpoints = __webpack_require__(151);

var _withWidth = _interopRequireWildcard(__webpack_require__(290));

var _utils = __webpack_require__(14);

/**
 * @ignore - internal component.
 */
function HiddenJs(props) {
  var children = props.children,
      only = props.only,
      width = props.width;
  var visible = true; // `only` check is faster to get out sooner if used.

  if (only) {
    if (Array.isArray(only)) {
      for (var i = 0; i < only.length; i += 1) {
        var breakpoint = only[i];

        if (width === breakpoint) {
          visible = false;
          break;
        }
      }
    } else if (only && width === only) {
      visible = false;
    }
  } // Allow `only` to be combined with other props. If already hidden, no need to check others.


  if (visible) {
    // determine visibility based on the smallest size up
    for (var _i = 0; _i < _createBreakpoints.keys.length; _i += 1) {
      var _breakpoint = _createBreakpoints.keys[_i];
      var breakpointUp = props["".concat(_breakpoint, "Up")];
      var breakpointDown = props["".concat(_breakpoint, "Down")];

      if (breakpointUp && (0, _withWidth.isWidthUp)(_breakpoint, width) || breakpointDown && (0, _withWidth.isWidthDown)(_breakpoint, width)) {
        visible = false;
        break;
      }
    }
  }

  if (!visible) {
    return null;
  }

  return children;
}

HiddenJs.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   */
  implementation: _propTypes.default.oneOf(['js', 'css']),

  /**
   * You can use this property when choosing the `js` implementation with server-side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty component during the first mount.
   * You might want to use an heuristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * https://caniuse.com/#search=client%20hint
   */
  initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

  /**
   * If true, screens this size and down will be hidden.
   */
  lgDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  lgUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  mdDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  mdUp: _propTypes.default.bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If true, screens this size and down will be hidden.
   */
  smDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  smUp: _propTypes.default.bool,

  /**
   * @ignore
   * width prop provided by withWidth decorator.
   */
  width: _propTypes.default.string.isRequired,

  /**
   * If true, screens this size and down will be hidden.
   */
  xlDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xlUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xsDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xsUp: _propTypes.default.bool
};

if (false) {
  HiddenJs.propTypes = (0, _utils.exactProp)(HiddenJs.propTypes);
}

var _default = (0, _withWidth.default)()(HiddenJs);

exports.default = _default;

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.isWidthDown = exports.isWidthUp = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactEventListener = _interopRequireDefault(__webpack_require__(94));

var _debounce = _interopRequireDefault(__webpack_require__(125));

var _utils = __webpack_require__(14);

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(188));

var _withTheme = _interopRequireDefault(__webpack_require__(103));

var _createBreakpoints = __webpack_require__(151);

var _getThemeProps2 = _interopRequireDefault(__webpack_require__(377));

// < 1kb payload overhead when lodash/debounce is > 3kb.
// By default, returns true if screen width is the same or greater than the given breakpoint.
var isWidthUp = function isWidthUp(breakpoint, width) {
  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (inclusive) {
    return _createBreakpoints.keys.indexOf(breakpoint) <= _createBreakpoints.keys.indexOf(width);
  }

  return _createBreakpoints.keys.indexOf(breakpoint) < _createBreakpoints.keys.indexOf(width);
}; // By default, returns true if screen width is the same or less than the given breakpoint.


exports.isWidthUp = isWidthUp;

var isWidthDown = function isWidthDown(breakpoint, width) {
  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (inclusive) {
    return _createBreakpoints.keys.indexOf(width) <= _createBreakpoints.keys.indexOf(breakpoint);
  }

  return _createBreakpoints.keys.indexOf(width) < _createBreakpoints.keys.indexOf(breakpoint);
};

exports.isWidthDown = isWidthDown;

var withWidth = function withWidth() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (Component) {
    var _options$withTheme = options.withTheme,
        withThemeOption = _options$withTheme === void 0 ? false : _options$withTheme,
        _options$noSSR = options.noSSR,
        noSSR = _options$noSSR === void 0 ? false : _options$noSSR,
        initialWidthOption = options.initialWidth,
        _options$resizeInterv = options.resizeInterval,
        resizeInterval = _options$resizeInterv === void 0 ? 166 : _options$resizeInterv;

    var WithWidth =
    /*#__PURE__*/
    function (_React$Component) {
      (0, _inherits2.default)(WithWidth, _React$Component);

      function WithWidth(props) {
        var _this;

        (0, _classCallCheck2.default)(this, WithWidth);
        _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(WithWidth).call(this, props));
        _this.state = {
          width: noSSR ? _this.getWidth() : undefined
        };

        if (typeof window !== 'undefined') {
          _this.handleResize = (0, _debounce.default)(function () {
            var width2 = _this.getWidth();

            if (width2 !== _this.state.width) {
              _this.setState({
                width: width2
              });
            }
          }, resizeInterval);
        }

        return _this;
      }

      (0, _createClass2.default)(WithWidth, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var width = this.getWidth();

          if (width !== this.state.width) {
            this.setState({
              width: width
            });
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.handleResize.clear();
        }
      }, {
        key: "getWidth",
        value: function getWidth() {
          var innerWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.innerWidth;
          var breakpoints = this.props.theme.breakpoints;
          var width = null;
          /**
           * Start with the slowest value as low end devices often have a small screen.
           *
           * innerWidth |xs      sm      md      lg      xl
           *            |-------|-------|-------|-------|------>
           * width      |  xs   |  sm   |  md   |  lg   |  xl
           */

          var index = 1;

          while (width === null && index < _createBreakpoints.keys.length) {
            var currentWidth = _createBreakpoints.keys[index]; // @media are inclusive, so reproduce the behavior here.

            if (innerWidth < breakpoints.values[currentWidth]) {
              width = _createBreakpoints.keys[index - 1];
              break;
            }

            index += 1;
          }

          width = width || 'xl';
          return width;
        }
      }, {
        key: "render",
        value: function render() {
          var _getThemeProps = (0, _getThemeProps2.default)({
            theme: this.props.theme,
            name: 'MuiWithWidth',
            props: (0, _extends2.default)({}, this.props)
          }),
              initialWidth = _getThemeProps.initialWidth,
              theme = _getThemeProps.theme,
              width = _getThemeProps.width,
              other = (0, _objectWithoutProperties2.default)(_getThemeProps, ["initialWidth", "theme", "width"]);

          var more = (0, _extends2.default)({
            width: width || this.state.width || initialWidth || initialWidthOption
          }, other); // When rendering the component on the server,
          // we have no idea about the client browser screen width.
          // In order to prevent blinks and help the reconciliation of the React tree
          // we are not rendering the child component.
          //
          // An alternative is to use the `initialWidth` property.

          if (more.width === undefined) {
            return null;
          }

          if (withThemeOption) {
            more.theme = theme;
          }

          return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(Component, more), _react.default.createElement(_reactEventListener.default, {
            target: "window",
            onResize: this.handleResize
          }));
        }
      }]);
      return WithWidth;
    }(_react.default.Component);

     false ? WithWidth.propTypes = {
      /**
       * As `window.innerWidth` is unavailable on the server,
       * we default to rendering an empty component during the first mount.
       * You might want to use an heuristic to approximate
       * the screen width of the client browser screen width.
       *
       * For instance, you could be using the user-agent or the client-hints.
       * https://caniuse.com/#search=client%20hint
       */
      initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

      /**
       * @ignore
       */
      theme: _propTypes.default.object.isRequired,

      /**
       * Bypass the width calculation logic.
       */
      width: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
    } : void 0;

    if (false) {
      WithWidth.displayName = "WithWidth(".concat((0, _utils.getDisplayName)(Component), ")");
    }

    (0, _hoistNonReactStatics.default)(WithWidth, Component);
    return (0, _withTheme.default)()(WithWidth);
  };
};

var _default = withWidth;
exports.default = _default;

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _warning = _interopRequireDefault(__webpack_require__(27));

var _createBreakpoints = __webpack_require__(151);

var _helpers = __webpack_require__(29);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var styles = function styles(theme) {
  var hidden = {
    display: 'none'
  };
  return _createBreakpoints.keys.reduce(function (acc, key) {
    acc["only".concat((0, _helpers.capitalize)(key))] = (0, _defineProperty2.default)({}, theme.breakpoints.only(key), hidden);
    acc["".concat(key, "Up")] = (0, _defineProperty2.default)({}, theme.breakpoints.up(key), hidden);
    acc["".concat(key, "Down")] = (0, _defineProperty2.default)({}, theme.breakpoints.down(key), hidden);
    return acc;
  }, {});
};
/**
 * @ignore - internal component.
 */


function HiddenCss(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      lgDown = props.lgDown,
      lgUp = props.lgUp,
      mdDown = props.mdDown,
      mdUp = props.mdUp,
      only = props.only,
      smDown = props.smDown,
      smUp = props.smUp,
      xlDown = props.xlDown,
      xlUp = props.xlUp,
      xsDown = props.xsDown,
      xsUp = props.xsUp,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "lgDown", "lgUp", "mdDown", "mdUp", "only", "smDown", "smUp", "xlDown", "xlUp", "xsDown", "xsUp"]);
   false ? (0, _warning.default)(Object.keys(other).length === 0 || Object.keys(other).length === 1 && other.hasOwnProperty('ref'), "Material-UI: unsupported properties received ".concat(Object.keys(other).join(', '), " by `<Hidden />`.")) : void 0;
  var classNames = [];

  if (className) {
    classNames.push(className);
  }

  for (var i = 0; i < _createBreakpoints.keys.length; i += 1) {
    var breakpoint = _createBreakpoints.keys[i];
    var breakpointUp = props["".concat(breakpoint, "Up")];
    var breakpointDown = props["".concat(breakpoint, "Down")];

    if (breakpointUp) {
      classNames.push(classes["".concat(breakpoint, "Up")]);
    }

    if (breakpointDown) {
      classNames.push(classes["".concat(breakpoint, "Down")]);
    }
  }

  if (only) {
    var onlyBreakpoints = Array.isArray(only) ? only : [only];
    onlyBreakpoints.forEach(function (breakpoint) {
      classNames.push(classes["only".concat((0, _helpers.capitalize)(breakpoint))]);
    });
  }

  return _react.default.createElement("div", {
    className: classNames.join(' ')
  }, children);
}

 false ? HiddenCss.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   */
  implementation: _propTypes.default.oneOf(['js', 'css']),

  /**
   * If true, screens this size and down will be hidden.
   */
  lgDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  lgUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  mdDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  mdUp: _propTypes.default.bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If true, screens this size and down will be hidden.
   */
  smDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  smUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xlDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xlUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xsDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xsUp: _propTypes.default.bool
} : void 0;

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiPrivateHiddenCss'
})(HiddenCss);

exports.default = _default;

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Icon.default;
  }
});

var _Icon = _interopRequireDefault(__webpack_require__(1018));

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _helpers = __webpack_require__(29);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      fontSize: 24,
      width: '1em',
      height: '1em',
      // Chrome fix for https://bugs.chromium.org/p/chromium/issues/detail?id=820541
      // To remove at some point.
      overflow: 'hidden',
      flexShrink: 0
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },
    fontSizeInherit: {
      fontSize: 'inherit'
    },

    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: 20
    },

    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: 36
    }
  };
};

exports.styles = styles;

function Icon(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      className = props.className,
      color = props.color,
      Component = props.component,
      fontSize = props.fontSize,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "fontSize"]);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)('material-icons', classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), (0, _defineProperty2.default)(_classNames, classes["fontSize".concat((0, _helpers.capitalize)(fontSize))], fontSize !== 'default'), _classNames), className),
    "aria-hidden": "true"
  }, other), children);
}

 false ? Icon.propTypes = {
  /**
   * The name of the icon font ligature.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary', 'action', 'error', 'disabled']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: _propTypes.default.oneOf(['inherit', 'default', 'small', 'large'])
} : void 0;
Icon.defaultProps = {
  color: 'inherit',
  component: 'span',
  fontSize: 'default'
};
Icon.muiName = 'Icon';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiIcon'
})(Icon);

exports.default = _default;

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _InputAdornment.default;
  }
});

var _InputAdornment = _interopRequireDefault(__webpack_require__(1020));

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _warning = _interopRequireDefault(__webpack_require__(27));

var _Typography = _interopRequireDefault(__webpack_require__(25));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _withFormControlContext = _interopRequireDefault(__webpack_require__(96));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    height: '0.01em',
    // Fix IE 11 flexbox alignment. To remove at some point.
    maxHeight: '2em',
    alignItems: 'center'
  },

  /* Styles applied to the root element if `variant="filled"`. */
  filled: {
    '&$positionStart': {
      marginTop: 16
    }
  },

  /* Styles applied to the root element if `position="start"`. */
  positionStart: {
    marginRight: 8
  },

  /* Styles applied to the root element if `position="end"`. */
  positionEnd: {
    marginLeft: 8
  },

  /* Styles applied to the root element if `disablePointerEvents=true`. */
  disablePointerEvents: {
    pointerEvents: 'none'
  }
};
exports.styles = styles;

function InputAdornment(props) {
  var _classNames;

  var children = props.children,
      Component = props.component,
      classes = props.classes,
      className = props.className,
      disablePointerEvents = props.disablePointerEvents,
      disableTypography = props.disableTypography,
      muiFormControl = props.muiFormControl,
      position = props.position,
      variantProp = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "component", "classes", "className", "disablePointerEvents", "disableTypography", "muiFormControl", "position", "variant"]);
  var variant = variantProp;

  if (variantProp && muiFormControl) {
     false ? (0, _warning.default)(variantProp !== muiFormControl.variant, 'Material-UI: The `InputAdornment` variant infers the variant property ' + 'you do not have to provide one.') : void 0;
  }

  if (muiFormControl && !variant) {
    variant = muiFormControl.variant;
  }

  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.filled, variant === 'filled'), (0, _defineProperty2.default)(_classNames, classes.positionStart, position === 'start'), (0, _defineProperty2.default)(_classNames, classes.positionEnd, position === 'end'), (0, _defineProperty2.default)(_classNames, classes.disablePointerEvents, disablePointerEvents), _classNames), className)
  }, other), typeof children === 'string' && !disableTypography ? _react.default.createElement(_Typography.default, {
    color: "textSecondary"
  }, children) : children);
}

 false ? InputAdornment.propTypes = {
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the input on click.
   */
  disablePointerEvents: _propTypes.default.bool,

  /**
   * If children is a string then disable wrapping in a Typography component.
   */
  disableTypography: _propTypes.default.bool,

  /**
   * @ignore
   */
  muiFormControl: _propTypes.default.object,

  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: _propTypes.default.oneOf(['start', 'end']),

  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
InputAdornment.defaultProps = {
  component: 'div',
  disablePointerEvents: false,
  disableTypography: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiInputAdornment'
})((0, _withFormControlContext.default)(InputAdornment));

exports.default = _default;

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _warning = _interopRequireDefault(__webpack_require__(27));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _colorManipulator = __webpack_require__(81);

var TRANSITION_DURATION = 4; // seconds

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      overflow: 'hidden',
      height: 4
    },

    /* Styles applied to the root & bar2 element if `color="primary"`; bar2 if `variant-"buffer"`. */
    colorPrimary: {
      backgroundColor: (0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6)
    },
    // eslint-disable-next-line max-len

    /* Styles applied to the root & bar2 elements if `color="secondary"`; bar2 if `variant="buffer"`. */
    colorSecondary: {
      backgroundColor: (0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.4)
    },

    /* Styles applied to the root element if `variant="determinate"`. */
    determinate: {},

    /* Styles applied to the root element if `variant="indeterminate"`. */
    indeterminate: {},

    /* Styles applied to the root element if `variant="buffer"`. */
    buffer: {
      backgroundColor: 'transparent'
    },

    /* Styles applied to the root element if `variant="query"`. */
    query: {
      transform: 'rotate(180deg)'
    },

    /* Styles applied to the additional bar element if `variant="buffer"`. */
    dashed: {
      position: 'absolute',
      marginTop: 0,
      height: '100%',
      width: '100%',
      animation: 'buffer 3s infinite linear',
      // Backward compatible logic between JSS v9 and v10.
      // To remove with the release of Material-UI v4
      animationName: '$buffer'
    },

    /* Styles applied to the additional bar element if `variant="buffer"` & `color="primary"`. */
    dashedColorPrimary: {
      backgroundImage: "radial-gradient(".concat((0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6), " 0%, ").concat((0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6), " 16%, transparent 42%)"),
      backgroundSize: '10px 10px',
      backgroundPosition: '0px -23px'
    },

    /* Styles applied to the additional bar element if `variant="buffer"` & `color="secondary"`. */
    dashedColorSecondary: {
      backgroundImage: "radial-gradient(".concat((0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.4), " 0%, ").concat((0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.6), " 16%, transparent 42%)"),
      backgroundSize: '10px 10px',
      backgroundPosition: '0px -23px'
    },

    /* Styles applied to the layered bar1 & bar2 elements. */
    bar: {
      width: '100%',
      position: 'absolute',
      left: 0,
      bottom: 0,
      top: 0,
      transition: 'transform 0.2s linear',
      transformOrigin: 'left'
    },

    /* Styles applied to the bar elements if `color="primary"`; bar2 if `variant` not "buffer". */
    barColorPrimary: {
      backgroundColor: theme.palette.primary.main
    },

    /* Styles applied to the bar elements if `color="secondary"`; bar2 if `variant` not "buffer". */
    barColorSecondary: {
      backgroundColor: theme.palette.secondary.main
    },

    /* Styles applied to the bar1 element if `variant="indeterminate or query"`. */
    bar1Indeterminate: {
      width: 'auto',
      animation: 'mui-indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite',
      // Backward compatible logic between JSS v9 and v10.
      // To remove with the release of Material-UI v4
      animationName: '$mui-indeterminate1'
    },

    /* Styles applied to the bar1 element if `variant="determinate"`. */
    bar1Determinate: {
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },

    /* Styles applied to the bar1 element if `variant="buffer"`. */
    bar1Buffer: {
      zIndex: 1,
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },

    /* Styles applied to the bar2 element if `variant="indeterminate or query"`. */
    bar2Indeterminate: {
      width: 'auto',
      animation: 'mui-indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite',
      // Backward compatible logic between JSS v9 and v10.
      // To remove with the release of Material-UI v4
      animationName: '$mui-indeterminate2',
      animationDelay: '1.15s'
    },

    /* Styles applied to the bar2 element if `variant="buffer"`. */
    bar2Buffer: {
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },
    // Legends:
    // || represents the viewport
    // -  represents a light background
    // x  represents a dark background
    '@keyframes mui-indeterminate1': {
      //  |-----|---x-||-----||-----|
      '0%': {
        left: '-35%',
        right: '100%'
      },
      //  |-----|-----||-----||xxxx-|
      '60%': {
        left: '100%',
        right: '-90%'
      },
      '100%': {
        left: '100%',
        right: '-90%'
      }
    },
    '@keyframes mui-indeterminate2': {
      //  |xxxxx|xxxxx||-----||-----|
      '0%': {
        left: '-200%',
        right: '100%'
      },
      //  |-----|-----||-----||-x----|
      '60%': {
        left: '107%',
        right: '-8%'
      },
      '100%': {
        left: '107%',
        right: '-8%'
      }
    },
    '@keyframes buffer': {
      '0%': {
        opacity: 1,
        backgroundPosition: '0px -23px'
      },
      '50%': {
        opacity: 0,
        backgroundPosition: '0px -23px'
      },
      '100%': {
        opacity: 1,
        backgroundPosition: '-200px -23px'
      }
    }
  };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */


exports.styles = styles;

function LinearProgress(props) {
  var _classNames, _classNames2, _classNames3, _classNames4;

  var classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      value = props.value,
      valueBuffer = props.valueBuffer,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "value", "valueBuffer", "variant"]);
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.colorPrimary, color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.colorSecondary, color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.determinate, variant === 'determinate'), (0, _defineProperty2.default)(_classNames, classes.indeterminate, variant === 'indeterminate'), (0, _defineProperty2.default)(_classNames, classes.buffer, variant === 'buffer'), (0, _defineProperty2.default)(_classNames, classes.query, variant === 'query'), _classNames), classNameProp);
  var dashedClass = (0, _classnames.default)(classes.dashed, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.dashedColorPrimary, color === 'primary'), (0, _defineProperty2.default)(_classNames2, classes.dashedColorSecondary, color === 'secondary'), _classNames2));
  var bar1ClassName = (0, _classnames.default)(classes.bar, (_classNames3 = {}, (0, _defineProperty2.default)(_classNames3, classes.barColorPrimary, color === 'primary'), (0, _defineProperty2.default)(_classNames3, classes.barColorSecondary, color === 'secondary'), (0, _defineProperty2.default)(_classNames3, classes.bar1Indeterminate, variant === 'indeterminate' || variant === 'query'), (0, _defineProperty2.default)(_classNames3, classes.bar1Determinate, variant === 'determinate'), (0, _defineProperty2.default)(_classNames3, classes.bar1Buffer, variant === 'buffer'), _classNames3));
  var bar2ClassName = (0, _classnames.default)(classes.bar, (_classNames4 = {}, (0, _defineProperty2.default)(_classNames4, classes.barColorPrimary, color === 'primary' && variant !== 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.colorPrimary, color === 'primary' && variant === 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.barColorSecondary, color === 'secondary' && variant !== 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.colorSecondary, color === 'secondary' && variant === 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.bar2Indeterminate, variant === 'indeterminate' || variant === 'query'), (0, _defineProperty2.default)(_classNames4, classes.bar2Buffer, variant === 'buffer'), _classNames4));
  var rootProps = {};
  var inlineStyles = {
    bar1: {},
    bar2: {}
  };

  if (variant === 'determinate' || variant === 'buffer') {
    if (value !== undefined) {
      rootProps['aria-valuenow'] = Math.round(value);
      inlineStyles.bar1.transform = "scaleX(".concat(value / 100, ")");
    } else {
       false ? (0, _warning.default)(false, 'Material-UI: you need to provide a value property ' + 'when using the determinate or buffer variant of LinearProgress .') : void 0;
    }
  }

  if (variant === 'buffer') {
    if (valueBuffer !== undefined) {
      inlineStyles.bar2.transform = "scaleX(".concat((valueBuffer || 0) / 100, ")");
    } else {
       false ? (0, _warning.default)(false, 'Material-UI: you need to provide a valueBuffer property ' + 'when using the buffer variant of LinearProgress.') : void 0;
    }
  }

  return _react.default.createElement("div", (0, _extends2.default)({
    className: className,
    role: "progressbar"
  }, rootProps, other), variant === 'buffer' ? _react.default.createElement("div", {
    className: dashedClass
  }) : null, _react.default.createElement("div", {
    className: bar1ClassName,
    style: inlineStyles.bar1
  }), variant === 'determinate' ? null : _react.default.createElement("div", {
    className: bar2ClassName,
    style: inlineStyles.bar2
  }));
}

 false ? LinearProgress.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['primary', 'secondary']),

  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: _propTypes.default.number,

  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: _propTypes.default.number,

  /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   */
  variant: _propTypes.default.oneOf(['determinate', 'indeterminate', 'buffer', 'query'])
} : void 0;
LinearProgress.defaultProps = {
  color: 'primary',
  variant: 'indeterminate'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiLinearProgress'
})(LinearProgress);

exports.default = _default;

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ListItemAvatar.default;
  }
});

var _ListItemAvatar = _interopRequireDefault(__webpack_require__(1023));

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _ListContext = _interopRequireDefault(__webpack_require__(201));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      width: 36,
      height: 36,
      fontSize: theme.typography.pxToRem(18),
      marginRight: 4
    },

    /* Styles applied to the root element when. */
    alignItemsFlexStart: {
      marginTop: 4
    },

    /* Styles applied to the children – typically the `Avatar` component. */
    icon: {
      width: 20,
      height: 20,
      fontSize: theme.typography.pxToRem(20)
    }
  };
};
/**
 * This is a simple wrapper to apply the `dense`
 * and `align-items="flex-start"` mode styles to `Avatar`.
 */


exports.styles = styles;

function ListItemAvatar(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className"]);
  return _react.default.createElement(_ListContext.default.Consumer, null, function (context) {
    var _classNames;

    return _react.default.cloneElement(children, (0, _extends2.default)({
      className: (0, _classnames.default)((_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.root, context.dense), (0, _defineProperty2.default)(_classNames, classes.alignItemsFlexStart, context.alignItems === 'flex-start'), _classNames), className, children.props.className),
      childrenClassName: (0, _classnames.default)((0, _defineProperty2.default)({}, classes.icon, context.dense), children.props.childrenClassName)
    }, other));
  });
}

 false ? ListItemAvatar.propTypes = {
  /**
   * The content of the component – normally `Avatar`.
   */
  children: _propTypes.default.element.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : void 0;
ListItemAvatar.muiName = 'ListItemAvatar';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiListItemAvatar'
})(ListItemAvatar);

exports.default = _default;

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ListItemIcon.default;
  }
});

var _ListItemIcon = _interopRequireDefault(__webpack_require__(1025));

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      marginRight: 16,
      color: theme.palette.action.active,
      flexShrink: 0,
      display: 'inline-flex'
    }
  };
};
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */


exports.styles = styles;

function ListItemIcon(props) {
  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, classNameProp)
  }, other), children);
}

 false ? ListItemIcon.propTypes = {
  /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `@material-ui/icons` SVG icon element.
   */
  children: _propTypes.default.element.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : void 0;

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiListItemIcon'
})(ListItemIcon);

exports.default = _default;

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ListItemSecondaryAction.default;
  }
});

var _ListItemSecondaryAction = _interopRequireDefault(__webpack_require__(1027));

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var styles = {
  /* Styles applied to the root element. */
  root: {
    position: 'absolute',
    right: 4,
    top: '50%',
    transform: 'translateY(-50%)'
  }
};
/**
 * Must be used as the last child of ListItem to function properly.
 */

exports.styles = styles;

function ListItemSecondaryAction(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), children);
}

 false ? ListItemSecondaryAction.propTypes = {
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : void 0;
ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiListItemSecondaryAction'
})(ListItemSecondaryAction);

exports.default = _default;

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ListItemText.default;
  }
});

var _ListItemText = _interopRequireDefault(__webpack_require__(1029));

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _Typography = _interopRequireDefault(__webpack_require__(25));

var _ListContext = _interopRequireDefault(__webpack_require__(201));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      flex: '1 1 auto',
      minWidth: 0,
      padding: '0 16px',
      '&:first-child': {
        paddingLeft: 0
      }
    },

    /* Styles applied to the root element if `inset={true}`. */
    inset: {
      '&:first-child': {
        paddingLeft: 56
      }
    },

    /* Styles applied to the root element if `context.dense` is `true`. */
    dense: {
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the primary `Typography` component. */
    primary: {
      '&$textDense': {
        fontSize: 'inherit'
      }
    },

    /* Styles applied to the secondary `Typography` component. */
    secondary: {
      '&$textDense': {
        fontSize: 'inherit'
      }
    },

    /* Styles applied to the `Typography` components if `context.dense` is `true`. */
    textDense: {}
  };
};

exports.styles = styles;

function ListItemText(props) {
  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      disableTypography = props.disableTypography,
      inset = props.inset,
      primaryProp = props.primary,
      primaryTypographyProps = props.primaryTypographyProps,
      secondaryProp = props.secondary,
      secondaryTypographyProps = props.secondaryTypographyProps,
      theme = props.theme,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps", "theme"]);
  return _react.default.createElement(_ListContext.default.Consumer, null, function (_ref) {
    var _classNames3;

    var dense = _ref.dense;
    var primary = primaryProp != null ? primaryProp : children;

    if (primary != null && primary.type !== _Typography.default && !disableTypography) {
      primary = _react.default.createElement(_Typography.default, (0, _extends2.default)({
        variant: theme.typography.useNextVariants ? 'body1' : 'subheading',
        className: (0, _classnames.default)(classes.primary, (0, _defineProperty2.default)({}, classes.textDense, dense)),
        component: "span"
      }, primaryTypographyProps), primary);
    }

    var secondary = secondaryProp;

    if (secondary != null && secondary.type !== _Typography.default && !disableTypography) {
      secondary = _react.default.createElement(_Typography.default, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.secondary, (0, _defineProperty2.default)({}, classes.textDense, dense)),
        color: "textSecondary"
      }, secondaryTypographyProps), secondary);
    }

    return _react.default.createElement("div", (0, _extends2.default)({
      className: (0, _classnames.default)(classes.root, (_classNames3 = {}, (0, _defineProperty2.default)(_classNames3, classes.dense, dense), (0, _defineProperty2.default)(_classNames3, classes.inset, inset), _classNames3), classNameProp)
    }, other), primary, secondary);
  });
}

 false ? ListItemText.propTypes = {
  /**
   * Alias for the `primary` property.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   */
  disableTypography: _propTypes.default.bool,

  /**
   * If `true`, the children will be indented.
   * This should be used if there is no left avatar or left icon.
   */
  inset: _propTypes.default.bool,

  /**
   * The main content element.
   */
  primary: _propTypes.default.node,

  /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   */
  primaryTypographyProps: _propTypes.default.object,

  /**
   * The secondary content element.
   */
  secondary: _propTypes.default.node,

  /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   */
  secondaryTypographyProps: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired
} : void 0;
ListItemText.defaultProps = {
  disableTypography: false,
  inset: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiListItemText',
  withTheme: true
})(ListItemText);

exports.default = _default;

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ListSubheader.default;
  }
});

var _ListSubheader = _interopRequireDefault(__webpack_require__(1031));

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _helpers = __webpack_require__(29);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      boxSizing: 'border-box',
      lineHeight: '48px',
      listStyle: 'none',
      color: theme.palette.text.secondary,
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(14)
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: {
      paddingLeft: 16,
      paddingRight: 16
    },

    /* Styles applied to the root element if `inset={true}`. */
    inset: {
      paddingLeft: 72
    },

    /* Styles applied to the root element if `disableSticky={false}`. */
    sticky: {
      position: 'sticky',
      top: 0,
      zIndex: 1,
      backgroundColor: 'inherit'
    }
  };
};

exports.styles = styles;

function ListSubheader(props) {
  var _classNames;

  var classes = props.classes,
      className = props.className,
      color = props.color,
      Component = props.component,
      disableGutters = props.disableGutters,
      disableSticky = props.disableSticky,
      inset = props.inset,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "component", "disableGutters", "disableSticky", "inset"]);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'default'), (0, _defineProperty2.default)(_classNames, classes.inset, inset), (0, _defineProperty2.default)(_classNames, classes.sticky, !disableSticky), (0, _defineProperty2.default)(_classNames, classes.gutters, !disableGutters), _classNames), className)
  }, other));
}

 false ? ListSubheader.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['default', 'primary', 'inherit']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * If `true`, the List Subheader will not have gutters.
   */
  disableGutters: _propTypes.default.bool,

  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   */
  disableSticky: _propTypes.default.bool,

  /**
   * If `true`, the List Subheader will be indented.
   */
  inset: _propTypes.default.bool
} : void 0;
ListSubheader.defaultProps = {
  color: 'default',
  component: 'li',
  disableGutters: false,
  disableSticky: false,
  inset: false
};
ListSubheader.muiName = 'ListSubheader';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiListSubheader'
})(ListSubheader);

exports.default = _default;

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Menu.default;
  }
});

var _Menu = _interopRequireDefault(__webpack_require__(428));

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _MobileStepper.default;
  }
});

var _MobileStepper = _interopRequireDefault(__webpack_require__(1034));

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(50));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _Paper = _interopRequireDefault(__webpack_require__(63));

var _helpers = __webpack_require__(29);

var _LinearProgress = _interopRequireDefault(__webpack_require__(440));

// @inheritedComponent Paper
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      background: theme.palette.background.default,
      padding: 8
    },

    /* Styles applied to the root element if `position="bottom"`. */
    positionBottom: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: theme.zIndex.mobileStepper
    },

    /* Styles applied to the root element if `position="top"`. */
    positionTop: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: theme.zIndex.mobileStepper
    },

    /* Styles applied to the root element if `position="static"`. */
    positionStatic: {},

    /* Styles applied to the dots container if `variant="dots"`. */
    dots: {
      display: 'flex',
      flexDirection: 'row'
    },

    /* Styles applied to each dot if `variant="dots"`. */
    dot: {
      backgroundColor: theme.palette.action.disabled,
      borderRadius: '50%',
      width: 8,
      height: 8,
      margin: '0 2px'
    },

    /* Styles applied to a dot if `variant="dots"` and this is the active step. */
    dotActive: {
      backgroundColor: theme.palette.primary.main
    },

    /* Styles applied to the Linear Progress component if `variant="progress"`. */
    progress: {
      width: '50%'
    }
  };
};

exports.styles = styles;

function MobileStepper(props) {
  var activeStep = props.activeStep,
      backButton = props.backButton,
      classes = props.classes,
      classNameProp = props.className,
      LinearProgressProps = props.LinearProgressProps,
      nextButton = props.nextButton,
      position = props.position,
      steps = props.steps,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["activeStep", "backButton", "classes", "className", "LinearProgressProps", "nextButton", "position", "steps", "variant"]);
  var className = (0, _classnames.default)(classes.root, classes["position".concat((0, _helpers.capitalize)(position))], classNameProp);
  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
    square: true,
    elevation: 0,
    className: className
  }, other), backButton, variant === 'dots' && _react.default.createElement("div", {
    className: classes.dots
  }, (0, _toConsumableArray2.default)(new Array(steps)).map(function (_, step) {
    var dotClassName = (0, _classnames.default)(classes.dot, (0, _defineProperty2.default)({}, classes.dotActive, step === activeStep)); // eslint-disable-next-line react/no-array-index-key

    return _react.default.createElement("div", {
      key: step,
      className: dotClassName
    });
  })), variant === 'progress' && _react.default.createElement(_LinearProgress.default, (0, _extends2.default)({
    className: classes.progress,
    variant: "determinate",
    value: Math.ceil(activeStep / (steps - 1) * 100)
  }, LinearProgressProps)), nextButton);
}

 false ? MobileStepper.propTypes = {
  /**
   * Set the active step (zero based index).
   * Defines which dot is highlighted when the variant is 'dots'.
   */
  activeStep: _propTypes.default.number,

  /**
   * A back button element. For instance, it can be a `Button` or an `IconButton`.
   */
  backButton: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Properties applied to the `LinearProgress` element.
   */
  LinearProgressProps: _propTypes.default.object,

  /**
   * A next button element. For instance, it can be a `Button` or an `IconButton`.
   */
  nextButton: _propTypes.default.node,

  /**
   * Set the positioning type.
   */
  position: _propTypes.default.oneOf(['bottom', 'top', 'static']),

  /**
   * The total steps.
   */
  steps: _propTypes.default.number.isRequired,

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['text', 'dots', 'progress'])
} : void 0;
MobileStepper.defaultProps = {
  activeStep: 0,
  position: 'bottom',
  variant: 'dots'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiMobileStepper'
})(MobileStepper);

exports.default = _default;

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _NativeSelect.default;
  }
});

var _NativeSelect = _interopRequireDefault(__webpack_require__(430));

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(19));

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactDom = _interopRequireDefault(__webpack_require__(44));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _popper = _interopRequireDefault(__webpack_require__(1037));

var _Portal = _interopRequireDefault(__webpack_require__(274));

function flipPlacement(placement) {
  var direction = typeof window !== 'undefined' && document.body.getAttribute('dir') || 'ltr';

  if (direction !== 'rtl') {
    return placement;
  }

  switch (placement) {
    case 'bottom-end':
      return 'bottom-start';

    case 'bottom-start':
      return 'bottom-end';

    case 'top-end':
      return 'top-start';

    case 'top-start':
      return 'top-end';

    default:
      return placement;
  }
}

function getAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
/**
 * Poppers rely on the 3rd party library [Popper.js](https://github.com/FezVrasta/popper.js) for positioning.
 */


var Popper =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Popper, _React$Component);

  function Popper(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Popper);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Popper).call(this));

    _this.handleOpen = function () {
      var _this$props = _this.props,
          anchorEl = _this$props.anchorEl,
          modifiers = _this$props.modifiers,
          open = _this$props.open,
          placement = _this$props.placement,
          _this$props$popperOpt = _this$props.popperOptions,
          popperOptions = _this$props$popperOpt === void 0 ? {} : _this$props$popperOpt,
          disablePortal = _this$props.disablePortal;

      var popperNode = _reactDom.default.findDOMNode((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));

      if (!popperNode || !anchorEl || !open) {
        return;
      }

      if (_this.popper) {
        _this.popper.destroy();

        _this.popper = null;
      }

      _this.popper = new _popper.default(getAnchorEl(anchorEl), popperNode, (0, _extends2.default)({
        placement: flipPlacement(placement)
      }, popperOptions, {
        modifiers: (0, _extends2.default)({}, disablePortal ? {} : {
          // It's using scrollParent by default, we can use the viewport when using a portal.
          preventOverflow: {
            boundariesElement: 'window'
          }
        }, modifiers, popperOptions.modifiers),
        // We could have been using a custom modifier like react-popper is doing.
        // But it seems this is the best public API for this use case.
        onCreate: _this.handlePopperUpdate,
        onUpdate: _this.handlePopperUpdate
      }));
    };

    _this.handlePopperUpdate = function (data) {
      if (data.placement !== _this.state.placement) {
        _this.setState({
          placement: data.placement
        });
      }
    };

    _this.handleExited = function () {
      _this.setState({
        exited: true
      });

      _this.handleClose();
    };

    _this.handleClose = function () {
      if (!_this.popper) {
        return;
      }

      _this.popper.destroy();

      _this.popper = null;
    };

    _this.state = {
      exited: !props.open
    };
    return _this;
  }

  (0, _createClass2.default)(Popper, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.open !== this.props.open && !this.props.open && !this.props.transition) {
        // Otherwise handleExited will call this.
        this.handleClose();
      } // Let's update the popper position.


      if (prevProps.open !== this.props.open || prevProps.anchorEl !== this.props.anchorEl || prevProps.popperOptions !== this.props.popperOptions || prevProps.modifiers !== this.props.modifiers || prevProps.disablePortal !== this.props.disablePortal || prevProps.placement !== this.props.placement) {
        this.handleOpen();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleClose();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          anchorEl = _this$props2.anchorEl,
          children = _this$props2.children,
          container = _this$props2.container,
          disablePortal = _this$props2.disablePortal,
          keepMounted = _this$props2.keepMounted,
          modifiers = _this$props2.modifiers,
          open = _this$props2.open,
          placementProps = _this$props2.placement,
          popperOptions = _this$props2.popperOptions,
          transition = _this$props2.transition,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["anchorEl", "children", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "transition"]);
      var _this$state = this.state,
          exited = _this$state.exited,
          placement = _this$state.placement;

      if (!keepMounted && !open && (!transition || exited)) {
        return null;
      }

      var childProps = {
        placement: placement || flipPlacement(placementProps)
      };

      if (transition) {
        childProps.TransitionProps = {
          in: open,
          onExited: this.handleExited
        };
      }

      return _react.default.createElement(_Portal.default, {
        onRendered: this.handleOpen,
        disablePortal: disablePortal,
        container: container
      }, _react.default.createElement("div", (0, _extends2.default)({
        role: "tooltip",
        style: {
          // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
          position: 'absolute'
        }
      }, other), typeof children === 'function' ? children(childProps) : children));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if (nextProps.open) {
        return {
          exited: false
        };
      }

      if (!nextProps.transition) {
        // Otherwise let handleExited take care of marking exited.
        return {
          exited: true
        };
      }

      return null;
    }
  }]);
  return Popper;
}(_react.default.Component);

 false ? Popper.propTypes = {
  /**
   * This is the DOM element, or a function that returns the DOM element,
   * that may be used to set the position of the popover.
   * The return value will passed as the reference object of the Popper
   * instance.
   */
  anchorEl: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * Popper render function or node.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]).isRequired,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: _propTypes.default.bool,

  /**
   * Always keep the children in the DOM.
   * This property can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   */
  keepMounted: _propTypes.default.bool,

  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://github.com/FezVrasta/popper.js/blob/master/docs/_includes/popper-documentation.md#modifiers--object).
   */
  modifiers: _propTypes.default.object,

  /**
   * If `true`, the popper is visible.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * Popper placement.
   */
  placement: _propTypes.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /**
   * Options provided to the [`popper.js`](https://github.com/FezVrasta/popper.js) instance.
   */
  popperOptions: _propTypes.default.object,

  /**
   * Help supporting a react-transition-group/Transition component.
   */
  transition: _propTypes.default.bool
} : void 0;
Popper.defaultProps = {
  disablePortal: false,
  placement: 'bottom',
  transition: false
};
var _default = Popper;
exports.default = _default;

/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.14.7
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["default"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(67)))

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Radio.default;
  }
});

var _Radio = _interopRequireDefault(__webpack_require__(1039));

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _SwitchBase = _interopRequireDefault(__webpack_require__(285));

var _RadioButtonUnchecked = _interopRequireDefault(__webpack_require__(1040));

var _RadioButtonChecked = _interopRequireDefault(__webpack_require__(1041));

var _helpers = __webpack_require__(29);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary
    },

    /* Styles applied to the root element if `checked={true}`. */
    checked: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }
  };
};

exports.styles = styles;

var _ref = _react.default.createElement(_RadioButtonUnchecked.default, null);

var _ref2 = _react.default.createElement(_RadioButtonChecked.default, null);

function Radio(props) {
  var classes = props.classes,
      color = props.color,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "color"]);
  return _react.default.createElement(_SwitchBase.default, (0, _extends2.default)({
    type: "radio",
    icon: _ref,
    checkedIcon: _ref2,
    classes: {
      root: (0, _classnames.default)(classes.root, classes["color".concat((0, _helpers.capitalize)(color))]),
      checked: classes.checked,
      disabled: classes.disabled
    }
  }, other));
}

 false ? Radio.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['primary', 'secondary', 'default']),

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes.default.node,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,

  /**
   * Attributes applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes.default.func,

  /**
   * The input component property `type`.
   */
  type: _propTypes.default.string,

  /**
   * The value of the component.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool])
} : void 0;
Radio.defaultProps = {
  color: 'secondary'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiRadio'
})(Radio);

exports.default = _default;

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _pure = _interopRequireDefault(__webpack_require__(57));

var _SvgIcon = _interopRequireDefault(__webpack_require__(51));

var _ref = _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
});

/**
 * @ignore - internal component.
 */
var RadioButtonUnchecked = function RadioButtonUnchecked(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

RadioButtonUnchecked = (0, _pure.default)(RadioButtonUnchecked);
RadioButtonUnchecked.muiName = 'SvgIcon';
var _default = RadioButtonUnchecked;
exports.default = _default;

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _pure = _interopRequireDefault(__webpack_require__(57));

var _SvgIcon = _interopRequireDefault(__webpack_require__(51));

var _ref = _react.default.createElement("path", {
  d: "M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
});

/**
 * @ignore - internal component.
 */
var RadioButtonChecked = function RadioButtonChecked(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

RadioButtonChecked = (0, _pure.default)(RadioButtonChecked);
RadioButtonChecked.muiName = 'SvgIcon';
var _default = RadioButtonChecked;
exports.default = _default;

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _RadioGroup.default;
  }
});

var _RadioGroup = _interopRequireDefault(__webpack_require__(1043));

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _warning = _interopRequireDefault(__webpack_require__(27));

var _FormGroup = _interopRequireDefault(__webpack_require__(439));

var _helpers = __webpack_require__(29);

// @inheritedComponent FormGroup
var RadioGroup =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(RadioGroup, _React$Component);

  function RadioGroup(props) {
    var _this;

    (0, _classCallCheck2.default)(this, RadioGroup);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RadioGroup).call(this));
    _this.radios = [];

    _this.focus = function () {
      if (!_this.radios || !_this.radios.length) {
        return;
      }

      var focusRadios = _this.radios.filter(function (n) {
        return !n.disabled;
      });

      if (!focusRadios.length) {
        return;
      }

      var selectedRadio = (0, _helpers.find)(focusRadios, function (n) {
        return n.checked;
      });

      if (selectedRadio) {
        selectedRadio.focus();
        return;
      }

      focusRadios[0].focus();
    };

    _this.handleChange = function (event) {
      if (!_this.isControlled) {
        _this.setState({
          value: event.target.value
        });
      }

      if (_this.props.onChange) {
        _this.props.onChange(event, event.target.value);
      }
    };

    _this.isControlled = props.value != null;

    if (!_this.isControlled) {
      _this.state = {
        value: props.defaultValue
      };
    }

    return _this;
  }

  (0, _createClass2.default)(RadioGroup, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          name = _this$props.name,
          valueProp = _this$props.value,
          onChange = _this$props.onChange,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "name", "value", "onChange"]);
      var value = this.isControlled ? valueProp : this.state.value;
      this.radios = [];
      return _react.default.createElement(_FormGroup.default, (0, _extends2.default)({
        role: "radiogroup"
      }, other), _react.default.Children.map(children, function (child) {
        if (!_react.default.isValidElement(child)) {
          return null;
        }

         false ? (0, _warning.default)(child.type !== _react.default.Fragment, ["Material-UI: the RadioGroup component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n')) : void 0;
        return _react.default.cloneElement(child, {
          name: name,
          inputRef: function inputRef(node) {
            if (node) {
              _this2.radios.push(node);
            }
          },
          checked: value === child.props.value,
          onChange: (0, _helpers.createChainedFunction)(child.props.onChange, _this2.handleChange)
        });
      }));
    }
  }]);
  return RadioGroup;
}(_react.default.Component);

 false ? RadioGroup.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * The default input value, useful when not controlling the component.
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]),

  /**
   * The name used to reference the value of the control.
   */
  name: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * Callback fired when a radio button is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   * @param {string} value The `value` of the selected radio button
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyDown: _propTypes.default.func,

  /**
   * Value of the selected radio button.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool])
} : void 0;
var _default = RadioGroup;
exports.default = _default;

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Snackbar.default;
  }
});

var _Snackbar = _interopRequireDefault(__webpack_require__(1045));

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _extends8 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _reactEventListener = _interopRequireDefault(__webpack_require__(94));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _transitions = __webpack_require__(88);

var _ClickAwayListener = _interopRequireDefault(__webpack_require__(438));

var _helpers = __webpack_require__(29);

var _Slide = _interopRequireDefault(__webpack_require__(275));

var _SnackbarContent = _interopRequireDefault(__webpack_require__(442));

var styles = function styles(theme) {
  var gutter = 24;
  var top = {
    top: 0
  };
  var bottom = {
    bottom: 0
  };
  var right = {
    justifyContent: 'flex-end'
  };
  var left = {
    justifyContent: 'flex-start'
  };
  var topSpace = {
    top: gutter
  };
  var bottomSpace = {
    bottom: gutter
  };
  var rightSpace = {
    right: gutter
  };
  var leftSpace = {
    left: gutter
  };
  var center = {
    left: '50%',
    right: 'auto',
    transform: 'translateX(-50%)'
  };
  return {
    /* Styles applied to the root element. */
    root: {
      zIndex: theme.zIndex.snackbar,
      position: 'fixed',
      display: 'flex',
      left: 0,
      right: 0,
      justifyContent: 'center',
      alignItems: 'center'
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'center' }}`. */
    anchorOriginTopCenter: (0, _extends8.default)({}, top, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _extends8.default)({}, center))),

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'center' }}`. */
    anchorOriginBottomCenter: (0, _extends8.default)({}, bottom, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _extends8.default)({}, center))),

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }}`. */
    anchorOriginTopRight: (0, _extends8.default)({}, top, right, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _extends8.default)({
      left: 'auto'
    }, topSpace, rightSpace))),

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }}`. */
    anchorOriginBottomRight: (0, _extends8.default)({}, bottom, right, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _extends8.default)({
      left: 'auto'
    }, bottomSpace, rightSpace))),

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }}`. */
    anchorOriginTopLeft: (0, _extends8.default)({}, top, left, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _extends8.default)({
      right: 'auto'
    }, topSpace, leftSpace))),

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }}`. */
    anchorOriginBottomLeft: (0, _extends8.default)({}, bottom, left, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _extends8.default)({
      right: 'auto'
    }, bottomSpace, leftSpace)))
  };
};
/* istanbul ignore if */


exports.styles = styles;

if (false) {
  throw new Error('Material-UI: react@16.3.0 or greater is required.');
}

var Snackbar =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Snackbar, _React$Component);

  function Snackbar() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Snackbar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Snackbar)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {};

    _this.handleMouseEnter = function (event) {
      if (_this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }

      _this.handlePause();
    };

    _this.handleMouseLeave = function (event) {
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(event);
      }

      _this.handleResume();
    };

    _this.handleClickAway = function (event) {
      if (_this.props.onClose) {
        _this.props.onClose(event, 'clickaway');
      }
    };

    _this.handlePause = function () {
      clearTimeout(_this.timerAutoHide);
    };

    _this.handleResume = function () {
      if (_this.props.autoHideDuration != null) {
        if (_this.props.resumeHideDuration != null) {
          _this.setAutoHideTimer(_this.props.resumeHideDuration);

          return;
        }

        _this.setAutoHideTimer(_this.props.autoHideDuration * 0.5);
      }
    };

    _this.handleExited = function () {
      _this.setState({
        exited: true
      });
    };

    return _this;
  }

  (0, _createClass2.default)(Snackbar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.open) {
        this.setAutoHideTimer();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.open !== this.props.open) {
        if (this.props.open) {
          this.setAutoHideTimer();
        } else {
          clearTimeout(this.timerAutoHide);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timerAutoHide);
    }
  }, {
    key: "setAutoHideTimer",
    // Timer that controls delay before snackbar auto hides
    value: function setAutoHideTimer(autoHideDuration) {
      var _this2 = this;

      var autoHideDurationBefore = autoHideDuration != null ? autoHideDuration : this.props.autoHideDuration;

      if (!this.props.onClose || autoHideDurationBefore == null) {
        return;
      }

      clearTimeout(this.timerAutoHide);
      this.timerAutoHide = setTimeout(function () {
        var autoHideDurationAfter = autoHideDuration != null ? autoHideDuration : _this2.props.autoHideDuration;

        if (!_this2.props.onClose || autoHideDurationAfter == null) {
          return;
        }

        _this2.props.onClose(null, 'timeout');
      }, autoHideDurationBefore);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          action = _this$props.action,
          _this$props$anchorOri = _this$props.anchorOrigin,
          vertical = _this$props$anchorOri.vertical,
          horizontal = _this$props$anchorOri.horizontal,
          autoHideDuration = _this$props.autoHideDuration,
          children = _this$props.children,
          classes = _this$props.classes,
          className = _this$props.className,
          ClickAwayListenerProps = _this$props.ClickAwayListenerProps,
          ContentProps = _this$props.ContentProps,
          disableWindowBlurListener = _this$props.disableWindowBlurListener,
          message = _this$props.message,
          onClose = _this$props.onClose,
          onEnter = _this$props.onEnter,
          onEntered = _this$props.onEntered,
          onEntering = _this$props.onEntering,
          onExit = _this$props.onExit,
          onExited = _this$props.onExited,
          onExiting = _this$props.onExiting,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseLeave = _this$props.onMouseLeave,
          open = _this$props.open,
          resumeHideDuration = _this$props.resumeHideDuration,
          TransitionComponent = _this$props.TransitionComponent,
          transitionDuration = _this$props.transitionDuration,
          TransitionProps = _this$props.TransitionProps,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["action", "anchorOrigin", "autoHideDuration", "children", "classes", "className", "ClickAwayListenerProps", "ContentProps", "disableWindowBlurListener", "message", "onClose", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "onMouseEnter", "onMouseLeave", "open", "resumeHideDuration", "TransitionComponent", "transitionDuration", "TransitionProps"]); // So we only render active snackbars.

      if (!open && this.state.exited) {
        return null;
      }

      return _react.default.createElement(_ClickAwayListener.default, (0, _extends8.default)({
        onClickAway: this.handleClickAway
      }, ClickAwayListenerProps), _react.default.createElement("div", (0, _extends8.default)({
        className: (0, _classnames.default)(classes.root, classes["anchorOrigin".concat((0, _helpers.capitalize)(vertical)).concat((0, _helpers.capitalize)(horizontal))], className),
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      }, other), _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onFocus: disableWindowBlurListener ? undefined : this.handleResume,
        onBlur: disableWindowBlurListener ? undefined : this.handlePause
      }), _react.default.createElement(TransitionComponent, (0, _extends8.default)({
        appear: true,
        in: open,
        onEnter: onEnter,
        onEntered: onEntered,
        onEntering: onEntering,
        onExit: onExit,
        onExited: (0, _helpers.createChainedFunction)(this.handleExited, onExited),
        onExiting: onExiting,
        timeout: transitionDuration,
        direction: vertical === 'top' ? 'down' : 'up'
      }, TransitionProps), children || _react.default.createElement(_SnackbarContent.default, (0, _extends8.default)({
        message: message,
        action: action
      }, ContentProps)))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (typeof prevState.exited === 'undefined') {
        return {
          exited: !nextProps.open
        };
      }

      if (nextProps.open) {
        return {
          exited: false
        };
      }

      return null;
    }
  }]);
  return Snackbar;
}(_react.default.Component);

 false ? Snackbar.propTypes = {
  /**
   * The action to display.
   */
  action: _propTypes.default.node,

  /**
   * The anchor of the `Snackbar`.
   */
  anchorOrigin: _propTypes.default.shape({
    horizontal: _propTypes.default.oneOf(['left', 'center', 'right']).isRequired,
    vertical: _propTypes.default.oneOf(['top', 'bottom']).isRequired
  }),

  /**
   * The number of milliseconds to wait before automatically calling the
   * `onClose` function. `onClose` should then set the state of the `open`
   * prop to hide the Snackbar. This behavior is disabled by default with
   * the `null` value.
   */
  autoHideDuration: _propTypes.default.number,

  /**
   * Replace the `SnackbarContent` component.
   */
  children: _propTypes.default.element,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Properties applied to the `ClickAwayListener` element.
   */
  ClickAwayListenerProps: _propTypes.default.object,

  /**
   * Properties applied to the [`SnackbarContent`](/api/snackbar-content/) element.
   */
  ContentProps: _propTypes.default.object,

  /**
   * If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
   */
  disableWindowBlurListener: _propTypes.default.bool,

  /**
   * When displaying multiple consecutive Snackbars from a parent rendering a single
   * <Snackbar/>, add the key property to ensure independent treatment of each message.
   * e.g. <Snackbar key={message} />, otherwise, the message may update-in-place and
   * features such as autoHideDuration may be canceled.
   */
  key: _propTypes.default.any,

  /**
   * The message to display.
   */
  message: _propTypes.default.node,

  /**
   * Callback fired when the component requests to be closed.
   * Typically `onClose` is used to set state in the parent component,
   * which is used to control the `Snackbar` `open` prop.
   * The `reason` parameter can optionally be used to control the response to `onClose`,
   * for example ignoring `clickaway`.
   *
   * @param {object} event The event source of the callback
   * @param {string} reason Can be:`"timeout"` (`autoHideDuration` expired) or: `"clickaway"`
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired before the transition is entering.
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired when the transition has entered.
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired when the transition is entering.
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired before the transition is exiting.
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired when the transition has exited.
   */
  onExited: _propTypes.default.func,

  /**
   * Callback fired when the transition is exiting.
   */
  onExiting: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseLeave: _propTypes.default.func,

  /**
   * If true, `Snackbar` is open.
   */
  open: _propTypes.default.bool,

  /**
   * The number of milliseconds to wait before dismissing after user interaction.
   * If `autoHideDuration` property isn't specified, it does nothing.
   * If `autoHideDuration` property is specified but `resumeHideDuration` isn't,
   * we default to `autoHideDuration / 2` ms.
   */
  resumeHideDuration: _propTypes.default.number,

  /**
   * The component used for the transition.
   */
  TransitionComponent: _utils.componentPropType,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })]),

  /**
   * Properties applied to the `Transition` element.
   */
  TransitionProps: _propTypes.default.object
} : void 0;
Snackbar.defaultProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'center'
  },
  disableWindowBlurListener: false,
  TransitionComponent: _Slide.default,
  transitionDuration: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

var _default = (0, _withStyles.default)(styles, {
  flip: false,
  name: 'MuiSnackbar'
})(Snackbar);

exports.default = _default;

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _Paper = _interopRequireDefault(__webpack_require__(63));

var _Typography = _interopRequireDefault(__webpack_require__(25));

var _colorManipulator = __webpack_require__(81);

// @inheritedComponent Paper
var styles = function styles(theme) {
  var _root;

  var emphasis = theme.palette.type === 'light' ? 0.8 : 0.98;
  var backgroundColor = (0, _colorManipulator.emphasize)(theme.palette.background.default, emphasis);
  return {
    /* Styles applied to the root element. */
    root: (_root = {
      color: theme.palette.getContrastText(backgroundColor),
      backgroundColor: backgroundColor,
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      padding: '6px 24px'
    }, (0, _defineProperty2.default)(_root, theme.breakpoints.up('md'), {
      minWidth: 288,
      maxWidth: 568,
      borderRadius: theme.shape.borderRadius
    }), (0, _defineProperty2.default)(_root, theme.breakpoints.down('sm'), {
      flexGrow: 1
    }), _root),

    /* Styles applied to the message wrapper element. */
    message: {
      padding: '8px 0'
    },

    /* Styles applied to the action wrapper element if `action` is provided. */
    action: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
      paddingLeft: 24,
      marginRight: -8
    }
  };
};

exports.styles = styles;

function SnackbarContent(props) {
  var action = props.action,
      classes = props.classes,
      className = props.className,
      message = props.message,
      other = (0, _objectWithoutProperties2.default)(props, ["action", "classes", "className", "message"]);
  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
    component: _Typography.default,
    headlineMapping: {
      body1: 'div',
      body2: 'div'
    },
    role: "alertdialog",
    square: true,
    elevation: 6,
    className: (0, _classnames.default)(classes.root, className)
  }, other), _react.default.createElement("div", {
    className: classes.message
  }, message), action ? _react.default.createElement("div", {
    className: classes.action
  }, action) : null);
}

 false ? SnackbarContent.propTypes = {
  /**
   * The action to display.
   */
  action: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The message to display.
   */
  message: _propTypes.default.node
} : void 0;

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiSnackbarContent'
})(SnackbarContent);

exports.default = _default;

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Step.default;
  }
});

var _Step = _interopRequireDefault(__webpack_require__(1048));

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _warning = _interopRequireDefault(__webpack_require__(27));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var styles = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the root element if `orientation="horizontal"`. */
  horizontal: {
    paddingLeft: 8,
    paddingRight: 8,
    '&:first-child': {
      paddingLeft: 0
    },
    '&:last-child': {
      paddingRight: 0
    }
  },

  /* Styles applied to the root element if `orientation="vertical"`. */
  vertical: {},

  /* Styles applied to the root element if `alternativeLabel={true}`. */
  alternativeLabel: {
    flex: 1,
    position: 'relative'
  },

  /* Styles applied to the root element if `completed={true}`. */
  completed: {}
};
exports.styles = styles;

function Step(props) {
  var _classNames;

  var active = props.active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      completed = props.completed,
      connector = props.connector,
      disabled = props.disabled,
      index = props.index,
      last = props.last,
      orientation = props.orientation,
      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "connector", "disabled", "index", "last", "orientation"]);
  var className = (0, _classnames.default)(classes.root, classes[orientation], (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.alternativeLabel, alternativeLabel), (0, _defineProperty2.default)(_classNames, classes.completed, completed), _classNames), classNameProp);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: className
  }, other), connector && alternativeLabel && index !== 0 && _react.default.cloneElement(connector, {
    orientation: orientation,
    alternativeLabel: alternativeLabel,
    index: index,
    active: active,
    completed: completed,
    disabled: disabled
  }), _react.default.Children.map(children, function (child) {
    if (!_react.default.isValidElement(child)) {
      return null;
    }

     false ? (0, _warning.default)(child.type !== _react.default.Fragment, ["Material-UI: the Step component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n')) : void 0;
    return _react.default.cloneElement(child, (0, _extends2.default)({
      active: active,
      alternativeLabel: alternativeLabel,
      completed: completed,
      disabled: disabled,
      last: last,
      icon: index + 1,
      orientation: orientation
    }, child.props));
  }));
}

 false ? Step.propTypes = {
  /**
   * Sets the step as active. Is passed to child components.
   */
  active: _propTypes.default.bool,

  /**
   * @ignore
   * Set internally by Stepper when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: _propTypes.default.bool,

  /**
   * Should be `Step` sub-components such as `StepLabel`, `StepContent`.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: _propTypes.default.bool,

  /**
   * @ignore
   * Passed down from Stepper if alternativeLabel is also set.
   */
  connector: _propTypes.default.element,

  /**
   * Mark the step as disabled, will also disable the button if
   * `StepButton` is a child of `Step`. Is passed to child components.
   */
  disabled: _propTypes.default.bool,

  /**
   * @ignore
   * Used internally for numbering.
   */
  index: _propTypes.default.number,

  /**
   * @ignore
   */
  last: _propTypes.default.bool,

  /**
   * @ignore
   */
  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
} : void 0;
Step.defaultProps = {
  active: false,
  completed: false,
  disabled: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiStep'
})(Step);

exports.default = _default;

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _StepButton.default;
  }
});

var _StepButton = _interopRequireDefault(__webpack_require__(1050));

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _ButtonBase = _interopRequireDefault(__webpack_require__(64));

var _StepLabel = _interopRequireDefault(__webpack_require__(443));

var _reactHelpers = __webpack_require__(70);

// @inheritedComponent ButtonBase
var styles = {
  /* Styles applied to the root element. */
  root: {
    width: '100%',
    padding: '24px 16px',
    margin: '-24px -16px',
    boxSizing: 'content-box'
  },

  /* Styles applied to the root element if `orientation="horizontal"`. */
  horizontal: {},

  /* Styles applied to the root element if `orientation="vertical"`. */
  vertical: {
    justifyContent: 'flex-start'
  },

  /* Styles applied to the `ButtonBase` touch-ripple. */
  touchRipple: {
    color: 'rgba(0, 0, 0, 0.3)'
  }
};
exports.styles = styles;

function StepButton(props) {
  var active = props.active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      completed = props.completed,
      disabled = props.disabled,
      icon = props.icon,
      last = props.last,
      optional = props.optional,
      orientation = props.orientation,
      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "disabled", "icon", "last", "optional", "orientation"]);
  var childProps = {
    active: active,
    alternativeLabel: alternativeLabel,
    completed: completed,
    disabled: disabled,
    icon: icon,
    optional: optional,
    orientation: orientation
  };
  var child = (0, _reactHelpers.isMuiElement)(children, ['StepLabel']) ? _react.default.cloneElement(children, childProps) : _react.default.createElement(_StepLabel.default, childProps, children);
  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
    disabled: disabled,
    TouchRippleProps: {
      className: classes.touchRipple
    },
    className: (0, _classnames.default)(classes.root, classes[orientation], classNameProp)
  }, other), child);
}

 false ? StepButton.propTypes = {
  /**
   * @ignore
   * Passed in via `Step` - passed through to `StepLabel`.
   */
  active: _propTypes.default.bool,

  /**
   * @ignore
   * Set internally by Stepper when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: _propTypes.default.bool,

  /**
   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   * Sets completed styling. Is passed to StepLabel.
   */
  completed: _propTypes.default.bool,

  /**
   * @ignore
   * Disables the button and sets disabled styling. Is passed to StepLabel.
   */
  disabled: _propTypes.default.bool,

  /**
   * The icon displayed by the step label.
   */
  icon: _propTypes.default.node,

  /**
   * @ignore
   */
  last: _propTypes.default.bool,

  /**
   * The optional node to display.
   */
  optional: _propTypes.default.node,

  /**
   * @ignore
   */
  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
} : void 0;

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiStepButton'
})(StepButton);

exports.default = _default;

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _Typography = _interopRequireDefault(__webpack_require__(25));

var _StepIcon = _interopRequireDefault(__webpack_require__(444));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      alignItems: 'center',
      '&$alternativeLabel': {
        flexDirection: 'column'
      },
      '&$disabled': {
        cursor: 'default'
      }
    },

    /* Styles applied to the root element if `orientation="horizontal". */
    horizontal: {},

    /* Styles applied to the root element if `orientation="vertical". */
    vertical: {},

    /* Styles applied to the `Typography` component which wraps `children`. */
    label: {
      color: theme.palette.text.secondary,
      '&$active': {
        color: theme.palette.text.primary,
        fontWeight: 500
      },
      '&$completed': {
        color: theme.palette.text.primary,
        fontWeight: 500
      },
      '&$alternativeLabel': {
        textAlign: 'center',
        marginTop: 16
      },
      '&$error': {
        color: theme.palette.error.main
      }
    },

    /* Styles applied to the `Typography` component if `active={true}`. */
    active: {},

    /* Styles applied to the `Typography` component if `completed={true}`. */
    completed: {},

    /* Styles applied to the root element and `Typography` component if `error={true}`. */
    error: {},

    /* Styles applied to the root element and `Typography` component if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the `icon` container element. */
    iconContainer: {
      flexShrink: 0,
      // Fix IE 11 issue
      display: 'flex',
      paddingRight: 8,
      '&$alternativeLabel': {
        paddingRight: 0
      }
    },

    /* Styles applied to the root & icon container and `Typography` if `alternativeLabel={true}`. */
    alternativeLabel: {},

    /* Styles applied to the container element which wraps `Typography` and `optional`. */
    labelContainer: {
      width: '100%'
    }
  };
};

exports.styles = styles;

function StepLabel(props) {
  var _classNames, _classNames3;

  var active = props.active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      completed = props.completed,
      disabled = props.disabled,
      error = props.error,
      icon = props.icon,
      last = props.last,
      optional = props.optional,
      orientation = props.orientation,
      StepIconComponentProp = props.StepIconComponent,
      StepIconProps = props.StepIconProps,
      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "disabled", "error", "icon", "last", "optional", "orientation", "StepIconComponent", "StepIconProps"]);
  var StepIconComponent = StepIconComponentProp;

  if (icon && !StepIconComponent) {
    StepIconComponent = _StepIcon.default;
  }

  return _react.default.createElement("span", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, classes[orientation], (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.alternativeLabel, alternativeLabel), (0, _defineProperty2.default)(_classNames, classes.error, error), _classNames), classNameProp)
  }, other), icon || StepIconComponent ? _react.default.createElement("span", {
    className: (0, _classnames.default)(classes.iconContainer, (0, _defineProperty2.default)({}, classes.alternativeLabel, alternativeLabel))
  }, _react.default.createElement(StepIconComponent, (0, _extends2.default)({
    completed: completed,
    active: active,
    error: error,
    icon: icon
  }, StepIconProps))) : null, _react.default.createElement("span", {
    className: classes.labelContainer
  }, _react.default.createElement(_Typography.default, {
    component: "span",
    className: (0, _classnames.default)(classes.label, (_classNames3 = {}, (0, _defineProperty2.default)(_classNames3, classes.alternativeLabel, alternativeLabel), (0, _defineProperty2.default)(_classNames3, classes.completed, completed), (0, _defineProperty2.default)(_classNames3, classes.active, active), (0, _defineProperty2.default)(_classNames3, classes.error, error), _classNames3))
  }, children), optional));
}

 false ? StepLabel.propTypes = {
  /**
   * @ignore
   * Sets the step as active. Is passed to child components.
   */
  active: _propTypes.default.bool,

  /**
   * @ignore
   * Set internally by Stepper when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: _propTypes.default.bool,

  /**
   * In most cases will simply be a string containing a title for the label.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   * Mark the step as completed. Is passed to child components.
   */
  completed: _propTypes.default.bool,

  /**
   * Mark the step as disabled, will also disable the button if
   * `StepLabelButton` is a child of `StepLabel`. Is passed to child components.
   */
  disabled: _propTypes.default.bool,

  /**
   * Mark the step as failed.
   */
  error: _propTypes.default.bool,

  /**
   * Override the default icon.
   */
  icon: _propTypes.default.node,

  /**
   * @ignore
   */
  last: _propTypes.default.bool,

  /**
   * The optional node to display.
   */
  optional: _propTypes.default.node,

  /**
   * @ignore
   */
  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),

  /**
   * The component to render in place of the [`StepIcon`](/api/step-icon/).
   */
  StepIconComponent: _utils.componentPropType,

  /**
   * Properties applied to the [`StepIcon`](/api/step-icon/) element.
   */
  StepIconProps: _propTypes.default.object
} : void 0;
StepLabel.defaultProps = {
  active: false,
  alternativeLabel: false,
  completed: false,
  disabled: false,
  error: false,
  last: false,
  orientation: 'horizontal'
};
StepLabel.muiName = 'StepLabel';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiStepLabel'
})(StepLabel);

exports.default = _default;

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _CheckCircle = _interopRequireDefault(__webpack_require__(1053));

var _Warning = _interopRequireDefault(__webpack_require__(1054));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _SvgIcon = _interopRequireDefault(__webpack_require__(51));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      color: theme.palette.text.disabled,
      '&$active': {
        color: theme.palette.primary.main
      },
      '&$completed': {
        color: theme.palette.primary.main
      },
      '&$error': {
        color: theme.palette.error.main
      }
    },

    /* Styles applied to the SVG text element. */
    text: {
      fill: theme.palette.primary.contrastText,
      fontSize: theme.typography.caption.fontSize,
      fontFamily: theme.typography.fontFamily
    },

    /* Styles applied to the root element if `active={true}`. */
    active: {},

    /* Styles applied to the root element if `completed={true}`. */
    completed: {},

    /* Styles applied to the root element if `error={true}`. */
    error: {}
  };
};

exports.styles = styles;

var _ref = _react.default.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "12"
});

function StepIcon(props) {
  var completed = props.completed,
      icon = props.icon,
      active = props.active,
      error = props.error,
      classes = props.classes;

  if (typeof icon === 'number' || typeof icon === 'string') {
    if (error) {
      return _react.default.createElement(_Warning.default, {
        className: (0, _classnames.default)(classes.root, classes.error)
      });
    }

    if (completed) {
      return _react.default.createElement(_CheckCircle.default, {
        className: (0, _classnames.default)(classes.root, classes.completed)
      });
    }

    return _react.default.createElement(_SvgIcon.default, {
      className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.active, active))
    }, _ref, _react.default.createElement("text", {
      className: classes.text,
      x: "12",
      y: "16",
      textAnchor: "middle"
    }, icon));
  }

  return icon;
}

 false ? StepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: _propTypes.default.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: _propTypes.default.bool,

  /**
   * Mark the step as failed.
   */
  error: _propTypes.default.bool,

  /**
   * The icon displayed by the step label.
   */
  icon: _propTypes.default.node.isRequired
} : void 0;
StepIcon.defaultProps = {
  active: false,
  completed: false,
  error: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiStepIcon'
})(StepIcon);

exports.default = _default;

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _pure = _interopRequireDefault(__webpack_require__(57));

var _SvgIcon = _interopRequireDefault(__webpack_require__(51));

var _ref = _react.default.createElement("path", {
  d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
});

/**
 * @ignore - internal component.
 */
var CheckCircle = function CheckCircle(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

CheckCircle = (0, _pure.default)(CheckCircle);
CheckCircle.muiName = 'SvgIcon';
var _default = CheckCircle;
exports.default = _default;

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _pure = _interopRequireDefault(__webpack_require__(57));

var _SvgIcon = _interopRequireDefault(__webpack_require__(51));

var _ref = _react.default.createElement("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
});

/**
 * @ignore - internal component.
 */
var Warning = function Warning(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

Warning = (0, _pure.default)(Warning);
Warning.muiName = 'SvgIcon';
var _default = Warning;
exports.default = _default;

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      flex: '1 1 auto'
    },

    /* Styles applied to the root element if `orientation="horizontal"`. */
    horizontal: {},

    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {
      marginLeft: 12,
      // half icon
      padding: '0 0 8px'
    },

    /* Styles applied to the root element if `alternativeLabel={true}`. */
    alternativeLabel: {
      position: 'absolute',
      top: 8 + 4,
      left: 'calc(-50% + 20px)',
      right: 'calc(50% + 20px)'
    },

    /* Styles applied to the root element if `active={true}`. */
    active: {},

    /* Styles applied to the root element if `completed={true}`. */
    completed: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the line element. */
    line: {
      display: 'block',
      borderColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
    },

    /* Styles applied to the root element if `orientation="horizontal"`. */
    lineHorizontal: {
      borderTopStyle: 'solid',
      borderTopWidth: 1
    },

    /* Styles applied to the root element if `orientation="vertical"`. */
    lineVertical: {
      borderLeftStyle: 'solid',
      borderLeftWidth: 1,
      minHeight: 24
    }
  };
};

exports.styles = styles;

function StepConnector(props) {
  var _classNames, _classNames2;

  var active = props.active,
      alternativeLabel = props.alternativeLabel,
      classes = props.classes,
      classNameProp = props.className,
      completed = props.completed,
      disabled = props.disabled,
      index = props.index,
      orientation = props.orientation,
      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "classes", "className", "completed", "disabled", "index", "orientation"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, classes[orientation], (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.alternativeLabel, alternativeLabel), (0, _defineProperty2.default)(_classNames, classes.active, active), (0, _defineProperty2.default)(_classNames, classes.completed, completed), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), classNameProp)
  }, other), _react.default.createElement("span", {
    className: (0, _classnames.default)(classes.line, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.lineHorizontal, orientation === 'horizontal'), (0, _defineProperty2.default)(_classNames2, classes.lineVertical, orientation === 'vertical'), _classNames2))
  }));
}

 false ? StepConnector.propTypes = {
  /**
   * @ignore
   */
  active: _propTypes.default.bool,

  /**
   * @ignore
   * Set internally by Step when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: _propTypes.default.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   */
  completed: _propTypes.default.bool,

  /**
   * @ignore
   */
  disabled: _propTypes.default.bool,

  /**
   * @ignore
   */
  index: _propTypes.default.number,

  /**
   * @ignore
   */
  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
} : void 0;
StepConnector.defaultProps = {
  alternativeLabel: false,
  orientation: 'horizontal'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiStepConnector'
})(StepConnector);

exports.default = _default;

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _StepContent.default;
  }
});

var _StepContent = _interopRequireDefault(__webpack_require__(1057));

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _warning = _interopRequireDefault(__webpack_require__(27));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _Collapse = _interopRequireDefault(__webpack_require__(286));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      marginTop: 8,
      marginLeft: 12,
      // half icon
      paddingLeft: 8 + 12,
      // margin + half icon
      paddingRight: 8,
      borderLeft: "1px solid ".concat(theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600])
    },

    /* Styles applied to the root element if `last={true}` (controlled by `Step`). */
    last: {
      borderLeft: 'none'
    },

    /* Styles applied to the Transition component. */
    transition: {}
  };
};

exports.styles = styles;

function StepContent(props) {
  var active = props.active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      className = props.className,
      completed = props.completed,
      last = props.last,
      optional = props.optional,
      orientation = props.orientation,
      TransitionComponent = props.TransitionComponent,
      transitionDurationProp = props.transitionDuration,
      TransitionProps = props.TransitionProps,
      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "last", "optional", "orientation", "TransitionComponent", "transitionDuration", "TransitionProps"]);
   false ? (0, _warning.default)(orientation === 'vertical', 'Material-UI: <StepContent /> is only designed for use with the vertical stepper.') : void 0;
  var transitionDuration = transitionDurationProp;

  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
    transitionDuration = undefined;
  }

  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.last, last), className)
  }, other), _react.default.createElement(TransitionComponent, (0, _extends2.default)({
    in: active,
    className: classes.transition,
    timeout: transitionDuration,
    unmountOnExit: true
  }, TransitionProps), children));
}

 false ? StepContent.propTypes = {
  /**
   * @ignore
   * Expands the content.
   */
  active: _propTypes.default.bool,

  /**
   * @ignore
   * Set internally by Step when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: _propTypes.default.bool,

  /**
   * Step content.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   */
  completed: _propTypes.default.bool,

  /**
   * @ignore
   */
  last: _propTypes.default.bool,

  /**
   * @ignore
   * Set internally by Step when it's supplied with the optional property.
   */
  optional: _propTypes.default.bool,

  /**
   * @ignore
   */
  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),

  /**
   * The component used for the transition.
   */
  TransitionComponent: _utils.componentPropType,

  /**
   * Adjust the duration of the content expand transition.
   * Passed as a property to the transition component.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])]),

  /**
   * Properties applied to the `Transition` element.
   */
  TransitionProps: _propTypes.default.object
} : void 0;
StepContent.defaultProps = {
  TransitionComponent: _Collapse.default,
  transitionDuration: 'auto'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiStepContent'
})(StepContent);

exports.default = _default;

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Stepper.default;
  }
});

var _Stepper = _interopRequireDefault(__webpack_require__(1059));

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _Paper = _interopRequireDefault(__webpack_require__(63));

var _StepConnector = _interopRequireDefault(__webpack_require__(445));

// @inheritedComponent Paper
var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    padding: 24
  },

  /* Styles applied to the root element if `orientation="horizontal"`. */
  horizontal: {
    flexDirection: 'row',
    alignItems: 'center'
  },

  /* Styles applied to the root element if `orientation="vertical"`. */
  vertical: {
    flexDirection: 'column'
  },

  /* Styles applied to the root element if `alternativeLabel={true}`. */
  alternativeLabel: {
    alignItems: 'flex-start'
  }
};
exports.styles = styles;

function Stepper(props) {
  var activeStep = props.activeStep,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      connectorProp = props.connector,
      nonLinear = props.nonLinear,
      orientation = props.orientation,
      other = (0, _objectWithoutProperties2.default)(props, ["activeStep", "alternativeLabel", "children", "classes", "className", "connector", "nonLinear", "orientation"]);
  var className = (0, _classnames.default)(classes.root, classes[orientation], (0, _defineProperty2.default)({}, classes.alternativeLabel, alternativeLabel), classNameProp);
  var connector = _react.default.isValidElement(connectorProp) ? _react.default.cloneElement(connectorProp, {
    orientation: orientation
  }) : null;

  var childrenArray = _react.default.Children.toArray(children);

  var steps = childrenArray.map(function (step, index) {
    var controlProps = {
      alternativeLabel: alternativeLabel,
      connector: connectorProp,
      last: index + 1 === childrenArray.length,
      orientation: orientation
    };
    var state = {
      index: index,
      active: false,
      completed: false,
      disabled: false
    };

    if (activeStep === index) {
      state.active = true;
    } else if (!nonLinear && activeStep > index) {
      state.completed = true;
    } else if (!nonLinear && activeStep < index) {
      state.disabled = true;
    }

    return [!alternativeLabel && connector && index !== 0 && _react.default.cloneElement(connector, (0, _extends2.default)({
      key: index
    }, state)), _react.default.cloneElement(step, (0, _extends2.default)({}, controlProps, state, step.props))];
  });
  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
    square: true,
    elevation: 0,
    className: className
  }, other), steps);
}

 false ? Stepper.propTypes = {
  /**
   * Set the active step (zero based index).
   */
  activeStep: _propTypes.default.number,

  /**
   * If set to 'true' and orientation is horizontal,
   * then the step label will be positioned under the icon.
   */
  alternativeLabel: _propTypes.default.bool,

  /**
   * Two or more `<Step />` components.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * A component to be placed between each step.
   */
  connector: _propTypes.default.element,

  /**
   * If set the `Stepper` will not assist in controlling steps for linear flow.
   */
  nonLinear: _propTypes.default.bool,

  /**
   * The stepper orientation (layout flow direction).
   */
  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
} : void 0;
Stepper.defaultProps = {
  activeStep: 0,
  alternativeLabel: false,
  connector: _react.default.createElement(_StepConnector.default, null),
  nonLinear: false,
  orientation: 'horizontal'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiStepper'
})(Stepper);

exports.default = _default;

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _SwipeableDrawer.default;
  }
});

var _SwipeableDrawer = _interopRequireDefault(__webpack_require__(1061));

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(150);

var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reset = reset;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(19));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactDom = _interopRequireDefault(__webpack_require__(44));

var _Drawer = _interopRequireWildcard(__webpack_require__(272));

var _transitions = __webpack_require__(88);

var _withTheme = _interopRequireDefault(__webpack_require__(103));

var _utils = __webpack_require__(138);

var _NoSsr = _interopRequireDefault(__webpack_require__(270));

var _SwipeArea = _interopRequireDefault(__webpack_require__(1062));

/* eslint-disable consistent-this */
// @inheritedComponent Drawer
// This value is closed to what browsers are using internally to
// trigger a native scroll.
var UNCERTAINTY_THRESHOLD = 3; // px
// We can only have one node at the time claiming ownership for handling the swipe.
// Otherwise, the UX would be confusing.
// That's why we use a singleton here.

var nodeThatClaimedTheSwipe = null; // Exported for test purposes.

function reset() {
  nodeThatClaimedTheSwipe = null;
}
/* istanbul ignore if */


if (false) {
  throw new Error('Material-UI: react@16.3.0 or greater is required.');
}

var SwipeableDrawer =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(SwipeableDrawer, _React$Component);

  function SwipeableDrawer() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, SwipeableDrawer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(SwipeableDrawer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {};
    _this.isSwiping = null;

    _this.handleBodyTouchStart = function (event) {
      // We are not supposed to handle this touch move.
      if (nodeThatClaimedTheSwipe !== null && nodeThatClaimedTheSwipe !== (0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this))) {
        return;
      }

      var _this$props = _this.props,
          disableDiscovery = _this$props.disableDiscovery,
          disableSwipeToOpen = _this$props.disableSwipeToOpen,
          open = _this$props.open,
          swipeAreaWidth = _this$props.swipeAreaWidth;
      var anchor = (0, _Drawer.getAnchor)(_this.props);
      var currentX = anchor === 'right' ? document.body.offsetWidth - event.touches[0].pageX : event.touches[0].pageX;
      var currentY = anchor === 'bottom' ? window.innerHeight - event.touches[0].clientY : event.touches[0].clientY;

      if (!open) {
        if (disableSwipeToOpen) {
          return;
        }

        if ((0, _Drawer.isHorizontal)(_this.props)) {
          if (currentX > swipeAreaWidth) {
            return;
          }
        } else if (currentY > swipeAreaWidth) {
          return;
        }
      }

      nodeThatClaimedTheSwipe = (0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this));
      _this.startX = currentX;
      _this.startY = currentY;

      _this.setState({
        maybeSwiping: true
      });

      if (!open && _this.paperRef) {
        // The ref may be null when a parent component updates while swiping.
        _this.setPosition(_this.getMaxTranslate() + (disableDiscovery ? 20 : -swipeAreaWidth), {
          changeTransition: false
        });
      }

      _this.velocity = 0;
      _this.lastTime = null;
      _this.lastTranslate = null;
      document.body.addEventListener('touchmove', _this.handleBodyTouchMove, {
        passive: false
      });
      document.body.addEventListener('touchend', _this.handleBodyTouchEnd); // https://plus.google.com/+PaulIrish/posts/KTwfn1Y2238

      document.body.addEventListener('touchcancel', _this.handleBodyTouchEnd);
    };

    _this.handleBodyTouchMove = function (event) {
      // the ref may be null when a parent component updates while swiping
      if (!_this.paperRef) return;
      var anchor = (0, _Drawer.getAnchor)(_this.props);
      var horizontalSwipe = (0, _Drawer.isHorizontal)(_this.props);
      var currentX = anchor === 'right' ? document.body.offsetWidth - event.touches[0].pageX : event.touches[0].pageX;
      var currentY = anchor === 'bottom' ? window.innerHeight - event.touches[0].clientY : event.touches[0].clientY; // We don't know yet.

      if (_this.isSwiping == null) {
        var dx = Math.abs(currentX - _this.startX);
        var dy = Math.abs(currentY - _this.startY); // We are likely to be swiping, let's prevent the scroll event on iOS.

        if (dx > dy) {
          event.preventDefault();
        }

        var isSwiping = horizontalSwipe ? dx > dy && dx > UNCERTAINTY_THRESHOLD : dy > dx && dy > UNCERTAINTY_THRESHOLD;

        if (isSwiping === true || (horizontalSwipe ? dy > UNCERTAINTY_THRESHOLD : dx > UNCERTAINTY_THRESHOLD)) {
          _this.isSwiping = isSwiping;

          if (!isSwiping) {
            _this.handleBodyTouchEnd(event);

            return;
          } // Shift the starting point.


          _this.startX = currentX;
          _this.startY = currentY; // Compensate for the part of the drawer displayed on touch start.

          if (!_this.props.disableDiscovery && !_this.props.open) {
            if (horizontalSwipe) {
              _this.startX -= _this.props.swipeAreaWidth;
            } else {
              _this.startY -= _this.props.swipeAreaWidth;
            }
          }
        }
      }

      if (!_this.isSwiping) {
        return;
      }

      var translate = _this.getTranslate(horizontalSwipe ? currentX : currentY);

      if (_this.lastTranslate === null) {
        _this.lastTranslate = translate;
        _this.lastTime = performance.now() + 1;
      }

      var velocity = (translate - _this.lastTranslate) / (performance.now() - _this.lastTime) * 1e3; // Low Pass filter.

      _this.velocity = _this.velocity * 0.4 + velocity * 0.6;
      _this.lastTranslate = translate;
      _this.lastTime = performance.now(); // We are swiping, let's prevent the scroll event on iOS.

      event.preventDefault();

      _this.setPosition(translate);
    };

    _this.handleBodyTouchEnd = function (event) {
      nodeThatClaimedTheSwipe = null;

      _this.removeBodyTouchListeners();

      _this.setState({
        maybeSwiping: false
      }); // The swipe wasn't started.


      if (!_this.isSwiping) {
        _this.isSwiping = null;
        return;
      }

      _this.isSwiping = null;
      var anchor = (0, _Drawer.getAnchor)(_this.props);
      var current;

      if ((0, _Drawer.isHorizontal)(_this.props)) {
        current = anchor === 'right' ? document.body.offsetWidth - event.changedTouches[0].pageX : event.changedTouches[0].pageX;
      } else {
        current = anchor === 'bottom' ? window.innerHeight - event.changedTouches[0].clientY : event.changedTouches[0].clientY;
      }

      var translateRatio = _this.getTranslate(current) / _this.getMaxTranslate();

      if (_this.props.open) {
        if (_this.velocity > _this.props.minFlingVelocity || translateRatio > _this.props.hysteresis) {
          _this.props.onClose();
        } else {
          // Reset the position, the swipe was aborted.
          _this.setPosition(0, {
            mode: 'exit'
          });
        }

        return;
      }

      if (_this.velocity < -_this.props.minFlingVelocity || 1 - translateRatio > _this.props.hysteresis) {
        _this.props.onOpen();
      } else {
        // Reset the position, the swipe was aborted.
        _this.setPosition(_this.getMaxTranslate(), {
          mode: 'enter'
        });
      }
    };

    _this.handleBackdropRef = function (ref) {
      _this.backdropRef = ref ? _reactDom.default.findDOMNode(ref) : null;
    };

    _this.handlePaperRef = function (ref) {
      _this.paperRef = ref ? _reactDom.default.findDOMNode(ref) : null;
    };

    return _this;
  }

  (0, _createClass2.default)(SwipeableDrawer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.variant === 'temporary') {
        this.listenTouchStart();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var variant = this.props.variant;
      var prevVariant = prevProps.variant;

      if (variant !== prevVariant) {
        if (variant === 'temporary') {
          this.listenTouchStart();
        } else if (prevVariant === 'temporary') {
          this.removeTouchStart();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeTouchStart();
      this.removeBodyTouchListeners(); // We need to release the lock.

      if (nodeThatClaimedTheSwipe === this) {
        nodeThatClaimedTheSwipe = null;
      }
    }
  }, {
    key: "getMaxTranslate",
    value: function getMaxTranslate() {
      return (0, _Drawer.isHorizontal)(this.props) ? this.paperRef.clientWidth : this.paperRef.clientHeight;
    }
  }, {
    key: "getTranslate",
    value: function getTranslate(current) {
      var start = (0, _Drawer.isHorizontal)(this.props) ? this.startX : this.startY;
      return Math.min(Math.max(this.props.open ? start - current : this.getMaxTranslate() + start - current, 0), this.getMaxTranslate());
    }
  }, {
    key: "setPosition",
    value: function setPosition(translate) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$mode = options.mode,
          mode = _options$mode === void 0 ? null : _options$mode,
          _options$changeTransi = options.changeTransition,
          changeTransition = _options$changeTransi === void 0 ? true : _options$changeTransi;
      var anchor = (0, _Drawer.getAnchor)(this.props);
      var rtlTranslateMultiplier = ['right', 'bottom'].indexOf(anchor) !== -1 ? 1 : -1;
      var transform = (0, _Drawer.isHorizontal)(this.props) ? "translate(".concat(rtlTranslateMultiplier * translate, "px, 0)") : "translate(0, ".concat(rtlTranslateMultiplier * translate, "px)");
      var drawerStyle = this.paperRef.style;
      drawerStyle.webkitTransform = transform;
      drawerStyle.transform = transform;
      var transition = '';

      if (mode) {
        transition = this.props.theme.transitions.create('all', (0, _utils.getTransitionProps)({
          timeout: this.props.transitionDuration
        }, {
          mode: mode
        }));
      }

      if (changeTransition) {
        drawerStyle.webkitTransition = transition;
        drawerStyle.transition = transition;
      }

      if (!this.props.disableBackdropTransition && !this.props.hideBackdrop) {
        var backdropStyle = this.backdropRef.style;
        backdropStyle.opacity = 1 - translate / this.getMaxTranslate();

        if (changeTransition) {
          backdropStyle.webkitTransition = transition;
          backdropStyle.transition = transition;
        }
      }
    }
  }, {
    key: "listenTouchStart",
    value: function listenTouchStart() {
      document.body.addEventListener('touchstart', this.handleBodyTouchStart);
    }
  }, {
    key: "removeTouchStart",
    value: function removeTouchStart() {
      document.body.removeEventListener('touchstart', this.handleBodyTouchStart);
    }
  }, {
    key: "removeBodyTouchListeners",
    value: function removeBodyTouchListeners() {
      document.body.removeEventListener('touchmove', this.handleBodyTouchMove, {
        passive: false
      });
      document.body.removeEventListener('touchend', this.handleBodyTouchEnd);
      document.body.removeEventListener('touchcancel', this.handleBodyTouchEnd);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          anchor = _this$props2.anchor,
          disableBackdropTransition = _this$props2.disableBackdropTransition,
          disableDiscovery = _this$props2.disableDiscovery,
          disableSwipeToOpen = _this$props2.disableSwipeToOpen,
          hysteresis = _this$props2.hysteresis,
          minFlingVelocity = _this$props2.minFlingVelocity,
          _this$props2$ModalPro = _this$props2.ModalProps;
      _this$props2$ModalPro = _this$props2$ModalPro === void 0 ? {} : _this$props2$ModalPro;
      var BackdropProps = _this$props2$ModalPro.BackdropProps,
          ModalPropsProp = (0, _objectWithoutProperties2.default)(_this$props2$ModalPro, ["BackdropProps"]),
          onOpen = _this$props2.onOpen,
          open = _this$props2.open,
          _this$props2$PaperPro = _this$props2.PaperProps,
          PaperProps = _this$props2$PaperPro === void 0 ? {} : _this$props2$PaperPro,
          SwipeAreaProps = _this$props2.SwipeAreaProps,
          swipeAreaWidth = _this$props2.swipeAreaWidth,
          variant = _this$props2.variant,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["anchor", "disableBackdropTransition", "disableDiscovery", "disableSwipeToOpen", "hysteresis", "minFlingVelocity", "ModalProps", "onOpen", "open", "PaperProps", "SwipeAreaProps", "swipeAreaWidth", "variant"]);
      var maybeSwiping = this.state.maybeSwiping;
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Drawer.default, (0, _extends2.default)({
        open: variant === 'temporary' && maybeSwiping ? true : open,
        variant: variant,
        ModalProps: (0, _extends2.default)({
          BackdropProps: (0, _extends2.default)({}, BackdropProps, {
            ref: this.handleBackdropRef
          })
        }, ModalPropsProp),
        PaperProps: (0, _extends2.default)({}, PaperProps, {
          style: (0, _extends2.default)({
            pointerEvents: variant === 'temporary' && !open ? 'none' : ''
          }, PaperProps.style),
          ref: this.handlePaperRef
        }),
        anchor: anchor
      }, other)), !disableDiscovery && !disableSwipeToOpen && variant === 'temporary' && _react.default.createElement(_NoSsr.default, null, _react.default.createElement(_SwipeArea.default, (0, _extends2.default)({
        anchor: anchor,
        width: swipeAreaWidth
      }, SwipeAreaProps))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (typeof prevState.maybeSwiping === 'undefined') {
        return {
          maybeSwiping: false,
          open: nextProps.open
        };
      }

      if (!nextProps.open && prevState.open) {
        return {
          maybeSwiping: false,
          open: nextProps.open
        };
      }

      return {
        open: nextProps.open
      };
    }
  }]);
  return SwipeableDrawer;
}(_react.default.Component);

 false ? SwipeableDrawer.propTypes = {
  /**
   * @ignore
   */
  anchor: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']),

  /**
   * Disable the backdrop transition.
   * This can improve the FPS on low-end devices.
   */
  disableBackdropTransition: _propTypes.default.bool,

  /**
   * If `true`, touching the screen near the edge of the drawer will not slide in the drawer a bit
   * to promote accidental discovery of the swipe gesture.
   */
  disableDiscovery: _propTypes.default.bool,

  /**
   * If `true`, swipe to open is disabled. This is useful in browsers where swiping triggers
   * navigation actions. Swipe to open is disabled on iOS browsers by default.
   */
  disableSwipeToOpen: _propTypes.default.bool,

  /**
   * @ignore
   */
  hideBackdrop: _propTypes.default.bool,

  /**
   * Affects how far the drawer must be opened/closed to change his state.
   * Specified as percent (0-1) of the width of the drawer
   */
  hysteresis: _propTypes.default.number,

  /**
   * Defines, from which (average) velocity on, the swipe is
   * defined as complete although hysteresis isn't reached.
   * Good threshold is between 250 - 1000 px/s
   */
  minFlingVelocity: _propTypes.default.number,

  /**
   * @ignore
   */
  ModalProps: _propTypes.default.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func.isRequired,

  /**
   * Callback fired when the component requests to be opened.
   *
   * @param {object} event The event source of the callback
   */
  onOpen: _propTypes.default.func.isRequired,

  /**
   * If `true`, the drawer is open.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * @ignore
   */
  PaperProps: _propTypes.default.object,

  /**
   * Properties applied to the swipe area element.
   */
  SwipeAreaProps: _propTypes.default.object,

  /**
   * The width of the left most (or right most) area in pixels where the
   * drawer can be swiped open from.
   */
  swipeAreaWidth: _propTypes.default.number,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })]),

  /**
   * @ignore
   */
  variant: _propTypes.default.oneOf(['permanent', 'persistent', 'temporary'])
} : void 0;
SwipeableDrawer.defaultProps = {
  anchor: 'left',
  disableBackdropTransition: false,
  disableDiscovery: false,
  disableSwipeToOpen: typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent),
  hysteresis: 0.55,
  minFlingVelocity: 400,
  swipeAreaWidth: 20,
  transitionDuration: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  },
  variant: 'temporary' // Mobile first.

};

var _default = (0, _withTheme.default)()(SwipeableDrawer);

exports.default = _default;

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _helpers = __webpack_require__(29);

var _Drawer = __webpack_require__(272);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'fixed',
      top: 0,
      left: 0,
      bottom: 0,
      zIndex: theme.zIndex.drawer - 1
    },
    anchorLeft: {
      right: 'auto'
    },
    anchorRight: {
      left: 'auto',
      right: 0
    },
    anchorTop: {
      bottom: 'auto',
      right: 0
    },
    anchorBottom: {
      top: 'auto',
      bottom: 0,
      right: 0
    }
  };
};
/**
 * @ignore - internal component.
 */


exports.styles = styles;

function SwipeArea(props) {
  var anchor = props.anchor,
      classes = props.classes,
      className = props.className,
      width = props.width,
      other = (0, _objectWithoutProperties2.default)(props, ["anchor", "classes", "className", "width"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, classes["anchor".concat((0, _helpers.capitalize)(anchor))], className),
    style: (0, _defineProperty2.default)({}, (0, _Drawer.isHorizontal)(props) ? 'width' : 'height', width)
  }, other));
}

 false ? SwipeArea.propTypes = {
  /**
   * Side on which to attach the discovery area.
   */
  anchor: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']).isRequired,

  /**
   * @ignore
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The width of the left most (or right most) area in pixels where the
   * drawer can be swiped open from.
   */
  width: _propTypes.default.number.isRequired
} : void 0;

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiPrivateSwipeArea'
})(SwipeArea);

exports.default = _default;

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Switch.default;
  }
});

var _Switch = _interopRequireDefault(__webpack_require__(1064));

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _helpers = __webpack_require__(29);

var _SwitchBase = _interopRequireDefault(__webpack_require__(285));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-flex',
      width: 62,
      position: 'relative',
      flexShrink: 0,
      zIndex: 0,
      // Reset the stacking context.
      // For correct alignment with the text.
      verticalAlign: 'middle'
    },

    /* Styles used to create the `icon` passed to the internal `SwitchBase` component `icon` prop. */
    icon: {
      boxShadow: theme.shadows[1],
      backgroundColor: 'currentColor',
      width: 20,
      height: 20,
      borderRadius: '50%'
    },

    /* Styles applied the icon element component if `checked={true}`. */
    iconChecked: {
      boxShadow: theme.shadows[2]
    },

    /* Styles applied to the internal `SwitchBase` component's `root` class. */
    switchBase: {
      padding: 0,
      height: 48,
      width: 48,
      color: theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[400],
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      })
    },

    /* Styles applied to the internal `SwitchBase` component's `checked` class. */
    checked: {
      transform: 'translateX(14px)',
      '& + $bar': {
        opacity: 0.5
      }
    },

    /* Styles applied to the internal SwitchBase component's root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main,
        '& + $bar': {
          backgroundColor: theme.palette.primary.main
        }
      }
    },

    /* Styles applied to the internal SwitchBase component's root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main,
        '& + $bar': {
          backgroundColor: theme.palette.secondary.main
        }
      }
    },

    /* Styles applied to the internal SwitchBase component's disabled class. */
    disabled: {
      '& + $bar': {
        opacity: theme.palette.type === 'light' ? 0.12 : 0.1
      },
      '& $icon': {
        boxShadow: theme.shadows[1]
      },
      '&$switchBase': {
        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800],
        '& + $bar': {
          backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
        }
      }
    },

    /* Styles applied to the bar element. */
    bar: {
      borderRadius: 14 / 2,
      display: 'block',
      position: 'absolute',
      zIndex: -1,
      width: 34,
      height: 14,
      top: '50%',
      left: '50%',
      marginTop: -7,
      marginLeft: -17,
      transition: theme.transitions.create(['opacity', 'background-color'], {
        duration: theme.transitions.duration.shortest
      }),
      backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white,
      opacity: theme.palette.type === 'light' ? 0.38 : 0.3
    }
  };
};

exports.styles = styles;

function Switch(props) {
  var classes = props.classes,
      className = props.className,
      color = props.color,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color"]);
  return _react.default.createElement("span", {
    className: (0, _classnames.default)(classes.root, className)
  }, _react.default.createElement(_SwitchBase.default, (0, _extends2.default)({
    type: "checkbox",
    icon: _react.default.createElement("span", {
      className: classes.icon
    }),
    classes: {
      root: (0, _classnames.default)(classes.switchBase, classes["color".concat((0, _helpers.capitalize)(color))]),
      checked: classes.checked,
      disabled: classes.disabled
    },
    checkedIcon: _react.default.createElement("span", {
      className: (0, _classnames.default)(classes.icon, classes.iconChecked)
    })
  }, other)), _react.default.createElement("span", {
    className: classes.bar
  }));
}

 false ? Switch.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['primary', 'secondary', 'default']),

  /**
   * @ignore
   */
  defaultChecked: _propTypes.default.bool,

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes.default.node,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,

  /**
   * Attributes applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.checked`.
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes.default.func,

  /**
   * The input component property `type`.
   */
  type: _propTypes.default.string,

  /**
   * The value of the component.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool])
} : void 0;
Switch.defaultProps = {
  color: 'secondary'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiSwitch'
})(Switch);

exports.default = _default;

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _TableContext = _interopRequireDefault(__webpack_require__(446));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'table',
      fontFamily: theme.typography.fontFamily,
      width: '100%',
      borderCollapse: 'collapse',
      borderSpacing: 0
    }
  };
};

exports.styles = styles;

var Table =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Table, _React$Component);

  function Table() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Table);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Table)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.memoizedContextValue = {};
    return _this;
  }

  (0, _createClass2.default)(Table, [{
    key: "useMemo",
    // To replace with the corresponding Hook once Material-UI v4 is out:
    // https://reactjs.org/docs/hooks-reference.html#usememo
    value: function useMemo(contextValue) {
      var objectKeys = Object.keys(contextValue);

      for (var i = 0; i < objectKeys.length; i += 1) {
        var objectKey = objectKeys[i];

        if (contextValue[objectKey] !== this.memoizedContextValue[objectKey]) {
          this.memoizedContextValue = contextValue;
          break;
        }
      }

      return this.memoizedContextValue;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          className = _this$props.className,
          Component = _this$props.component,
          padding = _this$props.padding,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "className", "component", "padding"]);
      return _react.default.createElement(_TableContext.default.Provider, {
        value: this.useMemo({
          padding: padding
        })
      }, _react.default.createElement(Component, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.root, className)
      }, other)));
    }
  }]);
  return Table;
}(_react.default.Component);

 false ? Table.propTypes = {
  /**
   * The content of the table, normally `TableHead` and `TableBody`.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * Allows TableCells to inherit padding of the Table.
   */
  padding: _propTypes.default.oneOf(['default', 'checkbox', 'dense', 'none'])
} : void 0;
Table.defaultProps = {
  component: 'table',
  padding: 'default'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTable'
})(Table);

exports.default = _default;

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _Tablelvl2Context = _interopRequireDefault(__webpack_require__(163));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-row-group'
  }
};
exports.styles = styles;
var contextValue = {
  variant: 'body'
};

function TableBody(props) {
  var classes = props.classes,
      className = props.className,
      Component = props.component,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
  return _react.default.createElement(_Tablelvl2Context.default.Provider, {
    value: contextValue
  }, _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other)));
}

 false ? TableBody.propTypes = {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType
} : void 0;
TableBody.defaultProps = {
  component: 'tbody'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTableBody'
})(TableBody);

exports.default = _default;

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _helpers = __webpack_require__(29);

var _deprecatedPropType = _interopRequireDefault(__webpack_require__(436));

var _colorManipulator = __webpack_require__(81);

var _TableContext = _interopRequireDefault(__webpack_require__(446));

var _Tablelvl2Context = _interopRequireDefault(__webpack_require__(163));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'table-cell',
      verticalAlign: 'inherit',
      // Workaround for a rendering bug with spanned columns in Chrome 62.0.
      // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
      borderBottom: "1px solid\n    ".concat(theme.palette.type === 'light' ? (0, _colorManipulator.lighten)((0, _colorManipulator.fade)(theme.palette.divider, 1), 0.88) : (0, _colorManipulator.darken)((0, _colorManipulator.fade)(theme.palette.divider, 1), 0.68)),
      textAlign: 'left',
      padding: '4px 56px 4px 24px',
      '&:last-child': {
        paddingRight: 24
      }
    },

    /* Styles applied to the root element if `variant="head"` or `context.table.head`. */
    head: {
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(12),
      fontWeight: theme.typography.fontWeightMedium
    },

    /* Styles applied to the root element if `variant="body"` or `context.table.body`. */
    body: {
      color: theme.palette.text.primary,
      fontSize: theme.typography.pxToRem(13),
      fontWeight: theme.typography.fontWeightRegular
    },

    /* Styles applied to the root element if `variant="footer"` or `context.table.footer`. */
    footer: {
      borderBottom: 0,
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(12)
    },

    /* Styles applied to the root element if `numeric={true}`. */
    numeric: {
      textAlign: 'right',
      flexDirection: 'row-reverse' // can be dynamically inherited at runtime by contents

    },

    /* Styles applied to the root element if `padding="dense"`. */
    paddingDense: {
      paddingRight: 24
    },

    /* Styles applied to the root element if `padding="checkbox"`. */
    paddingCheckbox: {
      padding: '0 12px',
      '&:last-child': {
        paddingRight: 12
      }
    },

    /* Styles applied to the root element if `padding="none"`. */
    paddingNone: {
      padding: 0,
      '&:last-child': {
        padding: 0
      }
    },

    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: 'left'
    },

    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: 'center'
    },

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: 'right',
      flexDirection: 'row-reverse'
    },

    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: 'justify'
    }
  };
};

exports.styles = styles;

function TableCell(props) {
  var align = props.align,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      component = props.component,
      sortDirection = props.sortDirection,
      _props$numeric = props.numeric,
      numeric = _props$numeric === void 0 ? false : _props$numeric,
      paddingProp = props.padding,
      scopeProp = props.scope,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["align", "children", "classes", "className", "component", "sortDirection", "numeric", "padding", "scope", "variant"]);
  return _react.default.createElement(_TableContext.default.Consumer, null, function (table) {
    return _react.default.createElement(_Tablelvl2Context.default.Consumer, null, function (tablelvl2) {
      var _classNames;

      var Component;

      if (component) {
        Component = component;
      } else {
        Component = tablelvl2 && tablelvl2.variant === 'head' ? 'th' : 'td';
      }

      var scope = scopeProp;

      if (!scope && tablelvl2 && tablelvl2.variant === 'head') {
        scope = 'col';
      }

      var padding = paddingProp || (table && table.padding ? table.padding : 'default');
      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.head, variant ? variant === 'head' : tablelvl2 && tablelvl2.variant === 'head'), (0, _defineProperty2.default)(_classNames, classes.body, variant ? variant === 'body' : tablelvl2 && tablelvl2.variant === 'body'), (0, _defineProperty2.default)(_classNames, classes.footer, variant ? variant === 'footer' : tablelvl2 && tablelvl2.variant === 'footer'), (0, _defineProperty2.default)(_classNames, classes["align".concat((0, _helpers.capitalize)(align))], align !== 'inherit'), (0, _defineProperty2.default)(_classNames, classes.numeric, numeric), (0, _defineProperty2.default)(_classNames, classes["padding".concat((0, _helpers.capitalize)(padding))], padding !== 'default'), _classNames), classNameProp);
      var ariaSort = null;

      if (sortDirection) {
        ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
      }

      return _react.default.createElement(Component, (0, _extends2.default)({
        className: className,
        "aria-sort": ariaSort,
        scope: scope
      }, other), children);
    });
  });
}

 false ? TableCell.propTypes = {
  /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   */
  align: _propTypes.default.oneOf(['inherit', 'left', 'center', 'right', 'justify']),

  /**
   * The table cell contents.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * If `true`, content will align to the right.
   */
  numeric: (0, _deprecatedPropType.default)(_propTypes.default.bool, 'Instead, use the `align` property.'),

  /**
   * Sets the padding applied to the cell.
   * By default, the Table parent component set the value.
   */
  padding: _propTypes.default.oneOf(['default', 'checkbox', 'dense', 'none']),

  /**
   * Set scope attribute.
   */
  scope: _propTypes.default.string,

  /**
   * Set aria-sort direction.
   */
  sortDirection: _propTypes.default.oneOf(['asc', 'desc', false]),

  /**
   * Specify the cell type.
   * By default, the TableHead, TableBody or TableFooter parent component set the value.
   */
  variant: _propTypes.default.oneOf(['head', 'body', 'footer'])
} : void 0;
TableCell.defaultProps = {
  align: 'inherit'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTableCell'
})(TableCell);

exports.default = _default;

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableFooter.default;
  }
});

var _TableFooter = _interopRequireDefault(__webpack_require__(1069));

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _Tablelvl2Context = _interopRequireDefault(__webpack_require__(163));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-footer-group'
  }
};
exports.styles = styles;
var contextValue = {
  variant: 'footer'
};

function TableFooter(props) {
  var classes = props.classes,
      className = props.className,
      Component = props.component,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
  return _react.default.createElement(_Tablelvl2Context.default.Provider, {
    value: contextValue
  }, _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other)));
}

 false ? TableFooter.propTypes = {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType
} : void 0;
TableFooter.defaultProps = {
  component: 'tfoot'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTableFooter'
})(TableFooter);

exports.default = _default;

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _Tablelvl2Context = _interopRequireDefault(__webpack_require__(163));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-header-group'
  }
};
exports.styles = styles;
var contextValue = {
  variant: 'head'
};

function TableHead(props) {
  var classes = props.classes,
      className = props.className,
      Component = props.component,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
  return _react.default.createElement(_Tablelvl2Context.default.Provider, {
    value: contextValue
  }, _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other)));
}

 false ? TableHead.propTypes = {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType
} : void 0;
TableHead.defaultProps = {
  component: 'thead'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTableHead'
})(TableHead);

exports.default = _default;

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TablePagination.default;
  }
});

var _TablePagination = _interopRequireDefault(__webpack_require__(1072));

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _InputBase = _interopRequireDefault(__webpack_require__(160));

var _MenuItem = _interopRequireDefault(__webpack_require__(95));

var _Select = _interopRequireDefault(__webpack_require__(104));

var _TableCell = _interopRequireDefault(__webpack_require__(209));

var _Toolbar = _interopRequireDefault(__webpack_require__(269));

var _Typography = _interopRequireDefault(__webpack_require__(25));

var _TablePaginationActions = _interopRequireDefault(__webpack_require__(1073));

// @inheritedComponent TableCell
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(12),
      // Increase the specificity to override TableCell.
      '&:last-child': {
        padding: 0
      }
    },

    /* Styles applied to the Toolbar component. */
    toolbar: {
      height: 56,
      minHeight: 56,
      paddingRight: 2
    },

    /* Styles applied to the spacer element. */
    spacer: {
      flex: '1 1 100%'
    },

    /* Styles applied to the caption Typography components if `variant="caption"`. */
    caption: {
      flexShrink: 0
    },

    /* Styles applied to the Select component `root` class. */
    selectRoot: {
      marginRight: 32,
      marginLeft: 8
    },

    /* Styles applied to the Select component `select` class. */
    select: {
      paddingLeft: 8,
      paddingRight: 16
    },

    /* Styles applied to the Select component `icon` class. */
    selectIcon: {
      top: 1
    },

    /* Styles applied to the `InputBase` component. */
    input: {
      color: 'inherit',
      fontSize: 'inherit',
      flexShrink: 0
    },

    /* Styles applied to the MenuItem component. */
    menuItem: {},

    /* Styles applied to the internal `TablePaginationActions` component. */
    actions: {
      flexShrink: 0,
      marginLeft: 20
    }
  };
};
/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */


exports.styles = styles;

var TablePagination =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(TablePagination, _React$Component);

  function TablePagination() {
    (0, _classCallCheck2.default)(this, TablePagination);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TablePagination).apply(this, arguments));
  }

  (0, _createClass2.default)(TablePagination, [{
    key: "componentDidUpdate",
    // This logic would be better handled on userside.
    // However, we have it just in case.
    value: function componentDidUpdate() {
      var _this$props = this.props,
          count = _this$props.count,
          onChangePage = _this$props.onChangePage,
          page = _this$props.page,
          rowsPerPage = _this$props.rowsPerPage;
      var newLastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);

      if (page > newLastPage) {
        onChangePage(null, newLastPage);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          ActionsComponent = _this$props2.ActionsComponent,
          backIconButtonProps = _this$props2.backIconButtonProps,
          classes = _this$props2.classes,
          colSpanProp = _this$props2.colSpan,
          Component = _this$props2.component,
          count = _this$props2.count,
          labelDisplayedRows = _this$props2.labelDisplayedRows,
          labelRowsPerPage = _this$props2.labelRowsPerPage,
          nextIconButtonProps = _this$props2.nextIconButtonProps,
          onChangePage = _this$props2.onChangePage,
          onChangeRowsPerPage = _this$props2.onChangeRowsPerPage,
          page = _this$props2.page,
          rowsPerPage = _this$props2.rowsPerPage,
          rowsPerPageOptions = _this$props2.rowsPerPageOptions,
          _this$props2$SelectPr = _this$props2.SelectProps,
          SelectProps = _this$props2$SelectPr === void 0 ? {} : _this$props2$SelectPr,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["ActionsComponent", "backIconButtonProps", "classes", "colSpan", "component", "count", "labelDisplayedRows", "labelRowsPerPage", "nextIconButtonProps", "onChangePage", "onChangeRowsPerPage", "page", "rowsPerPage", "rowsPerPageOptions", "SelectProps"]);
      var colSpan;

      if (Component === _TableCell.default || Component === 'td') {
        colSpan = colSpanProp || 1000; // col-span over everything
      }

      var MenuItemComponent = SelectProps.native ? 'option' : _MenuItem.default;
      return _react.default.createElement(Component, (0, _extends2.default)({
        className: classes.root,
        colSpan: colSpan
      }, other), _react.default.createElement(_Toolbar.default, {
        className: classes.toolbar
      }, _react.default.createElement("div", {
        className: classes.spacer
      }), rowsPerPageOptions.length > 1 && _react.default.createElement(_Typography.default, {
        color: "inherit",
        variant: "caption",
        className: classes.caption
      }, labelRowsPerPage), rowsPerPageOptions.length > 1 && _react.default.createElement(_Select.default, (0, _extends2.default)({
        classes: {
          root: classes.selectRoot,
          select: classes.select,
          icon: classes.selectIcon
        },
        input: _react.default.createElement(_InputBase.default, {
          className: classes.input
        }),
        value: rowsPerPage,
        onChange: onChangeRowsPerPage
      }, SelectProps), rowsPerPageOptions.map(function (rowsPerPageOption) {
        return _react.default.createElement(MenuItemComponent, {
          className: classes.menuItem,
          key: rowsPerPageOption,
          value: rowsPerPageOption
        }, rowsPerPageOption);
      })), _react.default.createElement(_Typography.default, {
        color: "inherit",
        variant: "caption",
        className: classes.caption
      }, labelDisplayedRows({
        from: count === 0 ? 0 : page * rowsPerPage + 1,
        to: Math.min(count, (page + 1) * rowsPerPage),
        count: count,
        page: page
      })), _react.default.createElement(ActionsComponent, {
        className: classes.actions,
        backIconButtonProps: backIconButtonProps,
        count: count,
        nextIconButtonProps: nextIconButtonProps,
        onChangePage: onChangePage,
        page: page,
        rowsPerPage: rowsPerPage
      })));
    }
  }]);
  return TablePagination;
}(_react.default.Component);

 false ? TablePagination.propTypes = {
  /**
   * The component used for displaying the actions.
   * Either a string to use a DOM element or a component.
   */
  ActionsComponent: _utils.componentPropType,

  /**
   * Properties applied to the back arrow [`IconButton`](/api/icon-button/) component.
   */
  backIconButtonProps: _propTypes.default.object,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  colSpan: _propTypes.default.number,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * The total number of rows.
   */
  count: _propTypes.default.number.isRequired,

  /**
   * Customize the displayed rows label.
   */
  labelDisplayedRows: _propTypes.default.func,

  /**
   * Customize the rows per page label. Invoked with a `{ from, to, count, page }`
   * object.
   */
  labelRowsPerPage: _propTypes.default.node,

  /**
   * Properties applied to the next arrow [`IconButton`](/api/icon-button/) element.
   */
  nextIconButtonProps: _propTypes.default.object,

  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback
   * @param {number} page The page selected
   */
  onChangePage: _propTypes.default.func.isRequired,

  /**
   * Callback fired when the number of rows per page is changed.
   *
   * @param {object} event The event source of the callback
   */
  onChangeRowsPerPage: _propTypes.default.func,

  /**
   * The zero-based index of the current page.
   */
  page: _propTypes.default.number.isRequired,

  /**
   * The number of rows per page.
   */
  rowsPerPage: _propTypes.default.number.isRequired,

  /**
   * Customizes the options of the rows per page select field. If less than two options are
   * available, no select field will be displayed.
   */
  rowsPerPageOptions: _propTypes.default.array,

  /**
   * Properties applied to the rows per page [`Select`](/api/select/) element.
   */
  SelectProps: _propTypes.default.object
} : void 0;
TablePagination.defaultProps = {
  ActionsComponent: _TablePaginationActions.default,
  component: _TableCell.default,
  labelDisplayedRows: function labelDisplayedRows(_ref) {
    var from = _ref.from,
        to = _ref.to,
        count = _ref.count;
    return "".concat(from, "-").concat(to, " of ").concat(count);
  },
  labelRowsPerPage: 'Rows per page:',
  rowsPerPageOptions: [10, 25, 50, 100]
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTablePagination'
})(TablePagination);

exports.default = _default;

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _KeyboardArrowLeft = _interopRequireDefault(__webpack_require__(434));

var _KeyboardArrowRight = _interopRequireDefault(__webpack_require__(435));

var _withTheme = _interopRequireDefault(__webpack_require__(103));

var _IconButton = _interopRequireDefault(__webpack_require__(71));

var _ref = _react.default.createElement(_KeyboardArrowRight.default, null);

var _ref2 = _react.default.createElement(_KeyboardArrowLeft.default, null);

var _ref3 = _react.default.createElement(_KeyboardArrowLeft.default, null);

var _ref4 = _react.default.createElement(_KeyboardArrowRight.default, null);

/**
 * @ignore - internal component.
 */
var TablePaginationActions =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(TablePaginationActions, _React$Component);

  function TablePaginationActions() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, TablePaginationActions);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(TablePaginationActions)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleBackButtonClick = function (event) {
      _this.props.onChangePage(event, _this.props.page - 1);
    };

    _this.handleNextButtonClick = function (event) {
      _this.props.onChangePage(event, _this.props.page + 1);
    };

    return _this;
  }

  (0, _createClass2.default)(TablePaginationActions, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          backIconButtonProps = _this$props.backIconButtonProps,
          count = _this$props.count,
          nextIconButtonProps = _this$props.nextIconButtonProps,
          onChangePage = _this$props.onChangePage,
          page = _this$props.page,
          rowsPerPage = _this$props.rowsPerPage,
          theme = _this$props.theme,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["backIconButtonProps", "count", "nextIconButtonProps", "onChangePage", "page", "rowsPerPage", "theme"]);
      return _react.default.createElement("div", other, _react.default.createElement(_IconButton.default, (0, _extends2.default)({
        onClick: this.handleBackButtonClick,
        disabled: page === 0,
        color: "inherit"
      }, backIconButtonProps), theme.direction === 'rtl' ? _ref : _ref2), _react.default.createElement(_IconButton.default, (0, _extends2.default)({
        onClick: this.handleNextButtonClick,
        disabled: page >= Math.ceil(count / rowsPerPage) - 1,
        color: "inherit"
      }, nextIconButtonProps), theme.direction === 'rtl' ? _ref3 : _ref4));
    }
  }]);
  return TablePaginationActions;
}(_react.default.Component);

 false ? TablePaginationActions.propTypes = {
  /**
   * Properties applied to the back arrow [`IconButton`](/api/icon-button/) element.
   */
  backIconButtonProps: _propTypes.default.object,

  /**
   * The total number of rows.
   */
  count: _propTypes.default.number.isRequired,

  /**
   * Properties applied to the next arrow [`IconButton`](/api/icon-button/) element.
   */
  nextIconButtonProps: _propTypes.default.object,

  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback
   * @param {number} page The page selected
   */
  onChangePage: _propTypes.default.func.isRequired,

  /**
   * The zero-based index of the current page.
   */
  page: _propTypes.default.number.isRequired,

  /**
   * The number of rows per page.
   */
  rowsPerPage: _propTypes.default.number.isRequired,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired
} : void 0;

var _default = (0, _withTheme.default)()(TablePaginationActions);

exports.default = _default;

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _Tablelvl2Context = _interopRequireDefault(__webpack_require__(163));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: 'inherit',
      display: 'table-row',
      height: 48,
      verticalAlign: 'middle',
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 'none',
      '&$selected': {
        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.04)' // grey[100]
        : 'rgba(255, 255, 255, 0.08)'
      },
      '&$hover:hover': {
        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.07)' // grey[200]
        : 'rgba(255, 255, 255, 0.14)'
      }
    },

    /* Styles applied to the root element if `selected={true}`. */
    selected: {},

    /* Styles applied to the root element if `hover={true}`. */
    hover: {},

    /* Styles applied to the root element if table variant = 'head'. */
    head: {
      height: 56
    },

    /* Styles applied to the root element if table variant = 'footer'. */
    footer: {
      height: 56
    }
  };
};
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */


exports.styles = styles;

function TableRow(props) {
  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      hover = props.hover,
      selected = props.selected,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "hover", "selected"]);
  return _react.default.createElement(_Tablelvl2Context.default.Consumer, null, function (tablelvl2) {
    var _classNames;

    var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.head, tablelvl2 && tablelvl2.variant === 'head'), (0, _defineProperty2.default)(_classNames, classes.footer, tablelvl2 && tablelvl2.variant === 'footer'), (0, _defineProperty2.default)(_classNames, classes.hover, hover), (0, _defineProperty2.default)(_classNames, classes.selected, selected), _classNames), classNameProp);
    return _react.default.createElement(Component, (0, _extends2.default)({
      className: className
    }, other));
  });
}

 false ? TableRow.propTypes = {
  /**
   * Should be valid <tr> children such as `TableCell`.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * If `true`, the table row will shade on hover.
   */
  hover: _propTypes.default.bool,

  /**
   * If `true`, the table row will have the selected shading.
   */
  selected: _propTypes.default.bool
} : void 0;
TableRow.defaultProps = {
  component: 'tr',
  hover: false,
  selected: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTableRow'
})(TableRow);

exports.default = _default;

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableSortLabel.default;
  }
});

var _TableSortLabel = _interopRequireDefault(__webpack_require__(1076));

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _ArrowDownward = _interopRequireDefault(__webpack_require__(1077));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _ButtonBase = _interopRequireDefault(__webpack_require__(64));

var _helpers = __webpack_require__(29);

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      cursor: 'pointer',
      display: 'inline-flex',
      justifyContent: 'flex-start',
      flexDirection: 'inherit',
      alignItems: 'center',
      '&:hover': {
        color: theme.palette.text.primary
      },
      '&:focus': {
        color: theme.palette.text.primary
      }
    },

    /* Styles applied to the root element if `active={true}`. */
    active: {
      color: theme.palette.text.primary,
      '& $icon': {
        opacity: 1
      }
    },

    /* Styles applied to the icon component. */
    icon: {
      height: 16,
      marginRight: 4,
      marginLeft: 4,
      opacity: 0,
      transition: theme.transitions.create(['opacity', 'transform'], {
        duration: theme.transitions.duration.shorter
      }),
      userSelect: 'none',
      width: 16
    },

    /* Styles applied to the icon component if `direction="desc"`. */
    iconDirectionDesc: {
      transform: 'rotate(0deg)'
    },

    /* Styles applied to the icon component if `direction="asc"`. */
    iconDirectionAsc: {
      transform: 'rotate(180deg)'
    }
  };
};
/**
 * A button based label for placing inside `TableCell` for column sorting.
 */


exports.styles = styles;

function TableSortLabel(props) {
  var active = props.active,
      children = props.children,
      classes = props.classes,
      className = props.className,
      direction = props.direction,
      hideSortIcon = props.hideSortIcon,
      IconComponent = props.IconComponent,
      other = (0, _objectWithoutProperties2.default)(props, ["active", "children", "classes", "className", "direction", "hideSortIcon", "IconComponent"]);
  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.active, active), className),
    component: "span",
    disableRipple: true
  }, other), children, hideSortIcon && !active ? null : _react.default.createElement(IconComponent, {
    className: (0, _classnames.default)(classes.icon, classes["iconDirection".concat((0, _helpers.capitalize)(direction))])
  }));
}

 false ? TableSortLabel.propTypes = {
  /**
   * If `true`, the label will have the active styling (should be true for the sorted column).
   */
  active: _propTypes.default.bool,

  /**
   * Label contents, the arrow will be appended automatically.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The current sort direction.
   */
  direction: _propTypes.default.oneOf(['asc', 'desc']),

  /**
   * Hide sort icon when active is false.
   */
  hideSortIcon: _propTypes.default.bool,

  /**
   * Sort icon to use.
   */
  IconComponent: _utils.componentPropType
} : void 0;
TableSortLabel.defaultProps = {
  active: false,
  direction: 'desc',
  hideSortIcon: false,
  IconComponent: _ArrowDownward.default
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTableSortLabel'
})(TableSortLabel);

exports.default = _default;

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _pure = _interopRequireDefault(__webpack_require__(57));

var _SvgIcon = _interopRequireDefault(__webpack_require__(51));

var _ref = _react.default.createElement("path", {
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
});

/**
 * @ignore - internal component.
 */
var ArrowDownward = function ArrowDownward(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

ArrowDownward = (0, _pure.default)(ArrowDownward);
ArrowDownward.muiName = 'SvgIcon';
var _default = ArrowDownward;
exports.default = _default;

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Tooltip.default;
  }
});

var _Tooltip = _interopRequireDefault(__webpack_require__(1079));

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(8));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _warning = _interopRequireDefault(__webpack_require__(27));

var _classnames = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(14);

var _RootRef = _interopRequireDefault(__webpack_require__(273));

var _withStyles = _interopRequireDefault(__webpack_require__(13));

var _helpers = __webpack_require__(29);

var _Grow = _interopRequireDefault(__webpack_require__(281));

var _Popper = _interopRequireDefault(__webpack_require__(441));

var styles = function styles(theme) {
  return {
    /* Styles applied to the Popper component. */
    popper: {
      zIndex: theme.zIndex.tooltip,
      opacity: 0.9,
      pointerEvents: 'none'
    },

    /* Styles applied to the Popper component if `interactive={true}`. */
    popperInteractive: {
      pointerEvents: 'auto'
    },

    /* Styles applied to the tooltip (label wrapper) element. */
    tooltip: {
      backgroundColor: theme.palette.grey[700],
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.common.white,
      fontFamily: theme.typography.fontFamily,
      padding: '4px 8px',
      fontSize: theme.typography.pxToRem(10),
      lineHeight: "".concat(theme.typography.round(14 / 10), "em"),
      maxWidth: 300
    },

    /* Styles applied to the tooltip (label wrapper) element if the tooltip is opened by touch. */
    touch: {
      padding: '8px 16px',
      fontSize: theme.typography.pxToRem(14),
      lineHeight: "".concat(theme.typography.round(16 / 14), "em")
    },

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "left". */
    tooltipPlacementLeft: (0, _defineProperty2.default)({
      transformOrigin: 'right center',
      margin: '0 24px '
    }, theme.breakpoints.up('sm'), {
      margin: '0 14px'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "right". */
    tooltipPlacementRight: (0, _defineProperty2.default)({
      transformOrigin: 'left center',
      margin: '0 24px'
    }, theme.breakpoints.up('sm'), {
      margin: '0 14px'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "top". */
    tooltipPlacementTop: (0, _defineProperty2.default)({
      transformOrigin: 'center bottom',
      margin: '24px 0'
    }, theme.breakpoints.up('sm'), {
      margin: '14px 0'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "bottom". */
    tooltipPlacementBottom: (0, _defineProperty2.default)({
      transformOrigin: 'center top',
      margin: '24px 0'
    }, theme.breakpoints.up('sm'), {
      margin: '14px 0'
    })
  };
};

exports.styles = styles;

var Tooltip =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Tooltip, _React$Component);

  function Tooltip(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Tooltip);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Tooltip).call(this));
    _this.ignoreNonTouchEvents = false;

    _this.onRootRef = function (ref) {
      _this.childrenRef = ref;
    };

    _this.handleFocus = function (event) {
      event.persist(); // The autoFocus of React might trigger the event before the componentDidMount.
      // We need to account for this eventuality.

      _this.focusTimer = setTimeout(function () {
        // We need to make sure the focus hasn't moved since the event was triggered.
        if (_this.childrenRef === document.activeElement) {
          _this.handleEnter(event);
        }
      });
      var childrenProps = _this.props.children.props;

      if (childrenProps.onFocus) {
        childrenProps.onFocus(event);
      }
    };

    _this.handleEnter = function (event) {
      var _this$props = _this.props,
          children = _this$props.children,
          enterDelay = _this$props.enterDelay;
      var childrenProps = children.props;

      if (event.type === 'mouseover' && childrenProps.onMouseOver) {
        childrenProps.onMouseOver(event);
      }

      if (_this.ignoreNonTouchEvents && event.type !== 'touchstart') {
        return;
      } // Remove the title ahead of time.
      // We don't want to wait for the next render commit.
      // We would risk displaying two tooltips at the same time (native + this one).


      _this.childrenRef.setAttribute('title', '');

      clearTimeout(_this.enterTimer);
      clearTimeout(_this.leaveTimer);

      if (enterDelay) {
        event.persist();
        _this.enterTimer = setTimeout(function () {
          _this.handleOpen(event);
        }, enterDelay);
      } else {
        _this.handleOpen(event);
      }
    };

    _this.handleOpen = function (event) {
      // The mouseover event will trigger for every nested element in the tooltip.
      // We can skip rerendering when the tooltip is already open.
      // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
      if (!_this.isControlled && !_this.state.open) {
        _this.setState({
          open: true
        });
      }

      if (_this.props.onOpen) {
        _this.props.onOpen(event);
      }
    };

    _this.handleLeave = function (event) {
      var _this$props2 = _this.props,
          children = _this$props2.children,
          leaveDelay = _this$props2.leaveDelay;
      var childrenProps = children.props;

      if (event.type === 'blur' && childrenProps.onBlur) {
        childrenProps.onBlur(event);
      }

      if (event.type === 'mouseleave' && childrenProps.onMouseLeave) {
        childrenProps.onMouseLeave(event);
      }

      clearTimeout(_this.enterTimer);
      clearTimeout(_this.leaveTimer);

      if (leaveDelay) {
        event.persist();
        _this.leaveTimer = setTimeout(function () {
          _this.handleClose(event);
        }, leaveDelay);
      } else {
        _this.handleClose(event);
      }
    };

    _this.handleClose = function (event) {
      if (!_this.isControlled) {
        _this.setState({
          open: false
        });
      }

      if (_this.props.onClose) {
        _this.props.onClose(event);
      }

      clearTimeout(_this.closeTimer);
      _this.closeTimer = setTimeout(function () {
        _this.ignoreNonTouchEvents = false;
      }, _this.props.theme.transitions.duration.shortest);
    };

    _this.handleTouchStart = function (event) {
      _this.ignoreNonTouchEvents = true;
      var _this$props3 = _this.props,
          children = _this$props3.children,
          enterTouchDelay = _this$props3.enterTouchDelay;

      if (children.props.onTouchStart) {
        children.props.onTouchStart(event);
      }

      clearTimeout(_this.leaveTimer);
      clearTimeout(_this.closeTimer);
      clearTimeout(_this.touchTimer);
      event.persist();
      _this.touchTimer = setTimeout(function () {
        _this.handleEnter(event);
      }, enterTouchDelay);
    };

    _this.handleTouchEnd = function (event) {
      var _this$props4 = _this.props,
          children = _this$props4.children,
          leaveTouchDelay = _this$props4.leaveTouchDelay;

      if (children.props.onTouchEnd) {
        children.props.onTouchEnd(event);
      }

      clearTimeout(_this.touchTimer);
      clearTimeout(_this.leaveTimer);
      event.persist();
      _this.leaveTimer = setTimeout(function () {
        _this.handleClose(event);
      }, leaveTouchDelay);
    };

    _this.isControlled = props.open != null;
    _this.state = {
      open: null
    };

    if (!_this.isControlled) {
      // not controlled, use internal state
      _this.state.open = false;
    }

    return _this;
  }

  (0, _createClass2.default)(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
       false ? (0, _warning.default)(!this.childrenRef.disabled || this.childrenRef.disabled && this.props.title === '' || this.childrenRef.tagName.toLowerCase() !== 'button', ['Material-UI: you are providing a disabled `button` child to the Tooltip component.', 'A disabled element does not fire events.', "Tooltip needs to listen to the child element's events to display the title.", '', 'Place a `div` container on top of the element.'].join('\n')) : void 0; // Fallback to this default id when possible.
      // Use the random value for client side rendering only.
      // We can't use it server-side.

      this.defaultId = "mui-tooltip-".concat(Math.round(Math.random() * 1e5)); // Rerender with this.defaultId and this.childrenRef.

      if (this.props.open) {
        this.forceUpdate();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.closeTimer);
      clearTimeout(this.enterTimer);
      clearTimeout(this.focusTimer);
      clearTimeout(this.leaveTimer);
      clearTimeout(this.touchTimer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props5 = this.props,
          children = _this$props5.children,
          classes = _this$props5.classes,
          disableFocusListener = _this$props5.disableFocusListener,
          disableHoverListener = _this$props5.disableHoverListener,
          disableTouchListener = _this$props5.disableTouchListener,
          enterDelay = _this$props5.enterDelay,
          enterTouchDelay = _this$props5.enterTouchDelay,
          id = _this$props5.id,
          interactive = _this$props5.interactive,
          leaveDelay = _this$props5.leaveDelay,
          leaveTouchDelay = _this$props5.leaveTouchDelay,
          onClose = _this$props5.onClose,
          onOpen = _this$props5.onOpen,
          openProp = _this$props5.open,
          placement = _this$props5.placement,
          PopperProps = _this$props5.PopperProps,
          theme = _this$props5.theme,
          title = _this$props5.title,
          TransitionComponent = _this$props5.TransitionComponent,
          TransitionProps = _this$props5.TransitionProps,
          other = (0, _objectWithoutProperties2.default)(_this$props5, ["children", "classes", "disableFocusListener", "disableHoverListener", "disableTouchListener", "enterDelay", "enterTouchDelay", "id", "interactive", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperProps", "theme", "title", "TransitionComponent", "TransitionProps"]);
      var open = this.isControlled ? openProp : this.state.open; // There is no point in displaying an empty tooltip.

      if (title === '') {
        open = false;
      } // For accessibility and SEO concerns, we render the title to the DOM node when
      // the tooltip is hidden. However, we have made a tradeoff when
      // `disableHoverListener` is set. This title logic is disabled.
      // It's allowing us to keep the implementation size minimal.
      // We are open to change the tradeoff.


      var shouldShowNativeTitle = !open && !disableHoverListener;
      var childrenProps = (0, _extends2.default)({
        'aria-describedby': open ? id || this.defaultId : null,
        title: shouldShowNativeTitle && typeof title === 'string' ? title : null
      }, other, children.props, {
        className: (0, _classnames.default)(other.className, children.props.className)
      });

      if (!disableTouchListener) {
        childrenProps.onTouchStart = this.handleTouchStart;
        childrenProps.onTouchEnd = this.handleTouchEnd;
      }

      if (!disableHoverListener) {
        childrenProps.onMouseOver = this.handleEnter;
        childrenProps.onMouseLeave = this.handleLeave;
      }

      if (!disableFocusListener) {
        childrenProps.onFocus = this.handleFocus;
        childrenProps.onBlur = this.handleLeave;
      }

      var interactiveWrapperListeners = interactive ? {
        onMouseOver: childrenProps.onMouseOver,
        onMouseLeave: childrenProps.onMouseLeave,
        onFocus: childrenProps.onFocus,
        onBlur: childrenProps.onBlur
      } : {};
       false ? (0, _warning.default)(!children.props.title, ['Material-UI: you have provided a `title` property to the child of <Tooltip />.', "Remove this title property `".concat(children.props.title, "` or the Tooltip component.")].join('\n')) : void 0;
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_RootRef.default, {
        rootRef: this.onRootRef
      }, _react.default.cloneElement(children, childrenProps)), _react.default.createElement(_Popper.default, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.popper, (0, _defineProperty2.default)({}, classes.popperInteractive, interactive)),
        placement: placement,
        anchorEl: this.childrenRef,
        open: open,
        id: childrenProps['aria-describedby'],
        transition: true
      }, interactiveWrapperListeners, PopperProps), function (_ref) {
        var placementInner = _ref.placement,
            TransitionPropsInner = _ref.TransitionProps;
        return _react.default.createElement(TransitionComponent, (0, _extends2.default)({
          timeout: theme.transitions.duration.shorter
        }, TransitionPropsInner, TransitionProps), _react.default.createElement("div", {
          className: (0, _classnames.default)(classes.tooltip, (0, _defineProperty2.default)({}, classes.touch, _this2.ignoreNonTouchEvents), classes["tooltipPlacement".concat((0, _helpers.capitalize)(placementInner.split('-')[0]))])
        }, title));
      }));
    }
  }]);
  return Tooltip;
}(_react.default.Component);

 false ? Tooltip.propTypes = {
  /**
   * Tooltip reference element.
   */
  children: _propTypes.default.element.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * Do not respond to focus events.
   */
  disableFocusListener: _propTypes.default.bool,

  /**
   * Do not respond to hover events.
   */
  disableHoverListener: _propTypes.default.bool,

  /**
   * Do not respond to long press touch events.
   */
  disableTouchListener: _propTypes.default.bool,

  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This property won't impact the enter touch delay (`enterTouchDelay`).
   */
  enterDelay: _propTypes.default.number,

  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   */
  enterTouchDelay: _propTypes.default.number,

  /**
   * The relationship between the tooltip and the wrapper component is not clear from the DOM.
   * This property is used with aria-describedby to solve the accessibility issue.
   * If you don't provide this property. It falls back to a randomly generated id.
   */
  id: _propTypes.default.string,

  /**
   * Makes a tooltip interactive, i.e. will not close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   */
  interactive: _propTypes.default.bool,

  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This property won't impact the leave touch delay (`leaveTouchDelay`).
   */
  leaveDelay: _propTypes.default.number,

  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   */
  leaveTouchDelay: _propTypes.default.number,

  /**
   * Callback fired when the tooltip requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired when the tooltip requests to be open.
   *
   * @param {object} event The event source of the callback
   */
  onOpen: _propTypes.default.func,

  /**
   * If `true`, the tooltip is shown.
   */
  open: _propTypes.default.bool,

  /**
   * Tooltip placement.
   */
  placement: _propTypes.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /**
   * Properties applied to the [`Popper`](/api/popper/) element.
   */
  PopperProps: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * Tooltip title. Zero-length titles string are never displayed.
   */
  title: _propTypes.default.node.isRequired,

  /**
   * The component used for the transition.
   */
  TransitionComponent: _utils.componentPropType,

  /**
   * Properties applied to the `Transition` element.
   */
  TransitionProps: _propTypes.default.object
} : void 0;
Tooltip.defaultProps = {
  disableFocusListener: false,
  disableHoverListener: false,
  disableTouchListener: false,
  enterDelay: 0,
  enterTouchDelay: 1000,
  interactive: false,
  leaveDelay: 0,
  leaveTouchDelay: 1500,
  placement: 'bottom',
  TransitionComponent: _Grow.default
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTooltip',
  withTheme: true
})(Tooltip);

exports.default = _default;

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _withMobileDialog.default;
  }
});

var _withMobileDialog = _interopRequireDefault(__webpack_require__(1081));

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(150);

var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _withWidth = _interopRequireWildcard(__webpack_require__(290));

/**
 * Dialog will responsively be full screen *at or below* the given breakpoint
 * (defaults to 'sm' for mobile devices).
 * Notice that this Higher-order Component is incompatible with server-side rendering.
 */
var withMobileDialog = function withMobileDialog() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (Component) {
    var _options$breakpoint = options.breakpoint,
        breakpoint = _options$breakpoint === void 0 ? 'sm' : _options$breakpoint;

    function WithMobileDialog(props) {
      return _react.default.createElement(Component, (0, _extends2.default)({
        fullScreen: (0, _withWidth.isWidthDown)(breakpoint, props.width)
      }, props));
    }

     false ? WithMobileDialog.propTypes = {
      width: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']).isRequired
    } : void 0;
    return (0, _withWidth.default)()(WithMobileDialog);
  };
};

var _default = withMobileDialog;
exports.default = _default;

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Zoom.default;
  }
});

var _Zoom = _interopRequireDefault(__webpack_require__(1083));

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(3));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(5));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));

var _createClass2 = _interopRequireDefault(__webpack_require__(7));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(10));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(9));

var _inherits2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _Transition = _interopRequireDefault(__webpack_require__(137));

var _transitions = __webpack_require__(88);

var _withTheme = _interopRequireDefault(__webpack_require__(103));

var _utils = __webpack_require__(138);

// @inheritedComponent Transition
var styles = {
  entering: {
    transform: 'scale(1)'
  },
  entered: {
    transform: 'scale(1)'
  }
};
/**
 * The Zoom transition can be used for the floating variant of the
 * [Button](https://material-ui.com/demos/buttons/#floating-action-buttons) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Zoom =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Zoom, _React$Component);

  function Zoom() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Zoom);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Zoom)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleEnter = function (node) {
      var theme = _this.props.theme;
      (0, _utils.reflow)(node); // So the animation always start from the start.

      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      });
      node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
      node.style.transition = theme.transitions.create('transform', transitionProps);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    };

    _this.handleExit = function (node) {
      var theme = _this.props.theme;
      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      });
      node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
      node.style.transition = theme.transitions.create('transform', transitionProps);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Zoom, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          onEnter = _this$props.onEnter,
          onExit = _this$props.onExit,
          styleProp = _this$props.style,
          theme = _this$props.theme,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "onEnter", "onExit", "style", "theme"]);
      var style = (0, _extends2.default)({}, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
        appear: true,
        onEnter: this.handleEnter,
        onExit: this.handleExit
      }, other), function (state, childProps) {
        return _react.default.cloneElement(children, (0, _extends2.default)({
          style: (0, _extends2.default)({
            transform: 'scale(0)'
          }, styles[state], style)
        }, childProps));
      });
    }
  }]);
  return Zoom;
}(_react.default.Component);

 false ? Zoom.propTypes = {
  /**
   * A single child content element.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),

  /**
   * If `true`, the component will transition in.
   */
  in: _propTypes.default.bool,

  /**
   * @ignore
   */
  onEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onExit: _propTypes.default.func,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })])
} : void 0;
Zoom.defaultProps = {
  timeout: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

var _default = (0, _withTheme.default)()(Zoom);

exports.default = _default;

/***/ }),
/* 1084 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography__);
var _dec,_class;var styles=function styles(theme){return{subLabel:{color:'rgba(40, 40, 40, 0.75)',fontSize:10},separator:{marginLeft:0.5*theme.spacing.unit,marginRight:0.5*theme.spacing.unit}};};var Path=(_dec=Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Path,_Component);function Path(){__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,Path);return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Path).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Path,[{key:"renderPath",value:function renderPath(item,index,items){var classes=this.props.classes;var lastItem=index===items.length-1;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{key:item.id,className:classes.subLabel},item.displayName,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span",{className:classes.separator},lastItem?'':'>'));}},{key:"render",value:function render(){var document=this.props.document;if(!document||!document.path){return null;}return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{container:true},document.path.map(this.renderPath.bind(this))));}}]);return Path;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]))||_class);Path.propTypes={document:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired,classes:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Path);

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Description__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Button__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Typography__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_Grid__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Asset__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_router_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_i18n_i18n__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_theme_icons__ = __webpack_require__(24);
var _dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_19_i18n_i18n__["a" /* default */].loc.localize;var styles=function styles(theme){return{root:{},assetRoot:{marginRight:30},assetButton:{width:70,height:70,minWidth:70,boxShadow:'1px 1px 3px rgba(0,0,0, 0.16)',borderRadius:20,marginBottom:theme.spacing.unit,color:theme.palette.colors.zeta,'&:hover':{color:theme.palette.colors.zeta}},stepDescription:{marginBottom:0},assetsContainer:{margin:"".concat(theme.spacing.unit*2,"px 0 ").concat(theme.spacing.unit*3,"px")},descriptionContainer:{maxWidth:670},assetLabel:{textAlign:'center',fontSize:13,color:theme.palette.colors.zeta},selectedAsset:{backgroundColor:'#e5f6ff'}};};var ASSETS=[{id:'logo',title:'Logos',icon:__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_theme_icons__["_1" /* TeamAssetsLogoIcon */],{width:"44px",height:"44px"}),description:localize('assets-description-logo')},{id:'image',title:'Images',icon:__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_theme_icons__["_0" /* TeamAssetsImageIcon */],{width:"46px",height:"30px"}),description:localize('assets-description-image')},{id:'component',title:'Other',icon:__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_theme_icons__["_2" /* TeamAssetsOtherIcon */],{width:"36px",height:"30px"}),description:localize('assets-description-component')}];var Assets=(_dec=Object(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(Assets,_Component);function Assets(){var _getPrototypeOf2;var _this;__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,Assets);for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}_this=__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,(_getPrototypeOf2=__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Assets)).call.apply(_getPrototypeOf2,[this].concat(args)));__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this),"state",{});return _this;}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Assets,[{key:"setAsset",value:function setAsset(asset){this.setState({selectedAsset:asset});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps,nextContext){var assetId=nextProps.match.params.asset;if(assetId||this.state.selectedAsset&&this.state.selectedAsset.id!==assetId){this.setAsset(__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.find(ASSETS,function(asset){return asset.id===assetId;}));}}},{key:"renderDescription",value:function renderDescription(){var classes=this.props.classes;var selectedAsset=this.state.selectedAsset;if(!selectedAsset){var assetsText=localize('assets-description-not-selected');return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{className:classes.descriptionContainer},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Description__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("span",{dangerouslySetInnerHTML:{__html:assetsText}})));}return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{className:classes.descriptionContainer},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Description__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("span",{dangerouslySetInnerHTML:{__html:selectedAsset.description}})));}},{key:"renderAsset",value:function renderAsset(){var selectedAsset=this.state.selectedAsset;var _this$props=this.props,match=_this$props.match,classes=_this$props.classes;if(!selectedAsset){return;}return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react__["Fragment"],null,!this.hasSelectedItemCloudFolders&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Typography___default.a,{variant:"h3",gutterBottom:true},localize('assets-step-2')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Description__["a" /* default */],{className:classes.stepDescription},localize('assets-step-2-description'))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Asset__["a" /* default */],{type:selectedAsset.id,match:match}));}},{key:"renderAssets",value:function renderAssets(){var _this$props2=this.props,classes=_this$props2.classes,match=_this$props2.match;var selectedAsset=this.state.selectedAsset;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_Grid___default.a,{container:true},!this.hasSelectedItemCloudFolders&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Typography___default.a,{variant:"h3",gutterBottom:true},localize('assets-step-1')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Description__["a" /* default */],{className:classes.stepDescription},localize('assets-step-1-description'))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_Grid___default.a,{container:true,className:classes.assetsContainer},ASSETS.map(function(asset){var buttonClass=__WEBPACK_IMPORTED_MODULE_16_classnames___default()(classes.assetButton,__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()({},classes.selectedAsset,selectedAsset===asset));return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{key:asset.id,className:classes.assetRoot},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Button___default.a,{"data-tid":"button-assets-type-".concat(asset.id),className:buttonClass,component:__WEBPACK_IMPORTED_MODULE_18_react_router_dom__["a" /* Link */],to:"/".concat(match.params.companyId,"/team-folders/assets/").concat(asset.id)},asset.icon),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Typography___default.a,{className:classes.assetLabel},asset.title));})),this.renderAsset());}},{key:"render",value:function render(){var _this$props3=this.props,classes=_this$props3.classes,match=_this$props3.match;if(!match.params.asset){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_router_dom__["c" /* Redirect */],{to:"/".concat(match.params.companyId,"/team-folders/assets/logo")});}return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{className:classes.root},this.renderDescription(),this.renderAssets());}},{key:"hasSelectedItemCloudFolders",get:function get(){var selectedAsset=this.state.selectedAsset;var folders=this.props.folders;if(folders&&selectedAsset){return folders[selectedAsset.id]&&folders[selectedAsset.id].length>0;}return false;}}]);return Assets;}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]))||_class);var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_11_redux__["b" /* bindActionCreators */])({},dispatch);};Assets.propTypes={match:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.object.isRequired,folders:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.object,classes:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["b" /* connect */])(mapDispatchToProps)(Assets));

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Button__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_IconButton__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_CloudBrowser_CloudBrowser__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_redux_modules_cloudFolders__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_Grid__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_theme_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_redux_modules_session__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_redux_modules_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__BaseAsset__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_i18n_i18n__ = __webpack_require__(15);
var _dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_25_i18n_i18n__["a" /* default */].loc.localize;var addProviders=[{type:'dropbox',name:'Dropbox',icon:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_theme_icons__["o" /* DropboxIcon */],{width:"33px",height:"30px"})},{type:'google',name:'Google Drive',icon:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_theme_icons__["r" /* GoogleDriveIcon */],{width:"36px",height:"30px"})},{type:'microsoft',name:'One Drive',icon:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_theme_icons__["R" /* OneDriveIcon */],{width:"42px",height:"25px"})}];var DROPBOX_TIMEOUT=500;var styles=function styles(theme){return{field:{margin:0},iframeClass:{display:'none'},deleteButton:{padding:0,minWidth:20},folderItem:{borderBottom:'0.5px solid rgba(0, 0, 0, 0.25)',height:60},icon:{margin:0,cursor:'pointer',color:theme.palette.colors.grey,'&[disabled]':{fill:theme.palette.action.disabled,pointerEvents:'none'}},label:{fontSize:14,lineHeight:'21px',color:'rgba(40, 40, 40, 0.75)',marginRight:2},folder:{marginTop:1.5*theme.spacing.unit,borderTop:'0.5px solid rgba(0, 0, 0, 0.25)'},bold:{fontWeight:'bold'},teamFolderInfo:{marginTop:4*theme.spacing.unit},providerRoot:{marginRight:30},providerButton:{marginTop:theme.spacing.unit,width:70,height:70,minWidth:70,borderRadius:20,marginBottom:theme.spacing.unit},providerLabel:{marginTop:-20,textAlign:'center',fontSize:10,color:'rgba(40, 40, 40, 0.75)'},root:{width:'100%'},sectionHeader:{display:'flex',alignItems:'center',width:200},sectionContainer:{marginTop:theme.spacing.unit,display:'flex'},folderIcon:{marginRight:theme.spacing.unit,color:theme.palette.colors.grey},errorClass:{marginTop:4*theme.spacing.unit,fontSize:12,color:'#BC1D1D !important',fontStyle:'italic'},addFolderButtonContainer:{display:'flex',marginTop:3*theme.spacing.unit,justifyContent:'flex-end',marginRight:4*theme.spacing.unit},table:{borderTop:"1px solid ".concat(theme.palette.colors.colorWithAlpha(theme.palette.colors.zeta,0.15))},tableCell:{'&:first-child':{width:'1%'// fit to content
},'&:last-child':{width:50},height:60},fullHeight:{height:'100%'}};};var Asset=(_dec=Object(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_BaseAsset){__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Asset,_BaseAsset);function Asset(){var _this;__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this,Asset);_this=__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Asset).call(this));__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this),"state",{showProviders:false});_this.handleFolderRemove=_this.handleFolderRemove.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));return _this;}__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Asset,[{key:"getProvider",value:function getProvider(){var provider=window.location.hash.match(/.providerid=(.+)&host/);return provider&&decodeURIComponent(provider[1]);}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps,nextContext){if(this.props.type!==nextProps.type){this.setState({showProviders:false});}}},{key:"componentDidMount",value:function componentDidMount(){var providerId=this.getProvider();var _this$props=this.props,changeFolder=_this$props.changeFolder,params=_this$props.match.params;if(providerId&&params.tab&&params.tab.toLowerCase()==='assets'){changeFolder('root',providerId,{fileId:null,providerId:providerId});this.setState({selectedFolder:'root'+providerId});}}},{key:"toggleFolder",value:function toggleFolder(path){var state=!this.state[path];this.setState(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()({},path,state));}},{key:"hasCloudFolders",value:function hasCloudFolders(){var _this$props2=this.props,folders=_this$props2.company.folders,type=_this$props2.type;var folderDirectories=folders[type];return folderDirectories&&folderDirectories.length>0;}},{key:"displayEmptyFolder",value:function displayEmptyFolder(options){var _this2=this;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Button___default.a,{onClick:function onClick(){return _this2.toggleFolder(options.path);}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:"body1"},localize('asset-browse-drives'))));}},{key:"displayFolder",value:function displayFolder(options){var _this$props3=this.props,classes=_this$props3.classes,cloudFolders=_this$props3.cloudFolders;var folder=cloudFolders[options.path];return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:classes.folder},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:"body1"},folder.name));}},{key:"renderFolderSection",value:function renderFolderSection(options){var _this$props4=this.props,classes=_this$props4.classes,cloudFolders=_this$props4.cloudFolders;var folder=cloudFolders[options.path];return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:classes.sectionContainer},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:classes.sectionHeader},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_theme_icons__["p" /* FolderIcon */],{className:classes.folderIcon}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:"body1"},options.name)),!folder&&this.displayEmptyFolder(options),folder&&this.displayFolder(options)),this.state[options.path]&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_CloudBrowser_CloudBrowser__["a" /* default */],null));}},{key:"handleProviderClick",value:function handleProviderClick(type,companyId){if(type==='dropbox'){this.setState({dropboxLogout:true,provider:'dropbox',companyId:companyId});return;}Object(__WEBPACK_IMPORTED_MODULE_17_redux_modules_cloudFolders__["b" /* authenticateProvider */])(type,companyId);}},{key:"renderCloudProviders",value:function renderCloudProviders(){var _this3=this;var hasCloudFolders=this.hasCloudFolders();if(hasCloudFolders&&!this.state.showProviders){return;}var _this$props5=this.props,companyId=_this$props5.companyId,classes=_this$props5.classes;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Grid___default.a,{container:true},addProviders.map(function(provider){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{key:provider.type,className:classes.providerRoot},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Button___default.a,{"data-tid":"button-asset-provider-".concat(provider.type),className:classes.providerButton,key:provider.type,onClick:function onClick(){return _this3.handleProviderClick(provider.type,companyId);}},provider.icon),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{className:classes.providerLabel},provider.name));}));}},{key:"removeFolder",value:function removeFolder(_ref){var fileId=_ref.fileId,providerId=_ref.providerId;var _this$props6=this.props,companyId=_this$props6.companyId,removeFolder=_this$props6.removeFolder,fetchSession=_this$props6.fetchSession,type=_this$props6.type;removeFolder({fileId:fileId,providerId:providerId,type:type,companyId:companyId}).then(fetchSession);}},{key:"renderTeamFolder",value:function renderTeamFolder(){var _this4=this;if(!this.hasCloudFolders()||this.state.showProviders){return null;}var _this$props7=this.props,classes=_this$props7.classes,folders=_this$props7.company.folders,type=_this$props7.type;var folderDirectories=folders[type];return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:classes.teamFolderInfo},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{style:{paddingBottom:10},className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()(classes.label,classes.bold)},localize('asset-folders',type)),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_core__["F" /* Table */],{className:classes.table},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_core__["G" /* TableBody */],null,folderDirectories.map(function(document){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_core__["J" /* TableRow */],{key:document.fileId,hover:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_core__["H" /* TableCell */],{padding:"none",className:classes.tableCell},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_theme_icons__["p" /* FolderIcon */],{className:classes.folderIcon})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_core__["H" /* TableCell */],{padding:"none",className:classes.tableCell},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Grid___default.a,{container:true,justify:"space-between",alignItems:"center",alignContent:"center"},_this4.renderFolderInfo(document),_this4.renderEditFolderField(document),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Grid___default.a,{container:true,className:classes.fullHeight,alignContent:"center"},_this4.renderRenameButton(document),_this4.renderSaveButton(document))))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_core__["H" /* TableCell */],{align:"right",padding:"none",className:classes.tableCell},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_IconButton___default.a,{color:"secondary",component:"span","aria-label":"Delete",onClick:function onClick(){return _this4.handleFolderRemove(document);}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_theme_icons__["k" /* DeleteIcon */],null))));}))));}},{key:"handleFolderRemove",value:function handleFolderRemove(document){var _this5=this;this.props.showModal('CONFIRMATION_MODAL',{message:localize('asset-folder-remove-message',document.displayName),buttons:[__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Button___default.a,{"data-tid":"button-remove-asset-cancel",key:"cancel-folder-button",variant:"outlined",color:"primary"},localize('cancel')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Button___default.a,{key:"delete-folder-button","data-tid":"button-remove-asset-confirm",variant:"contained",color:"primary",onClick:function onClick(){return _this5.removeFolder(document);}},localize('asset-folder-remove-button-remove'))]});}},{key:"handleOnLoad",value:function handleOnLoad(){var _this$state=this.state,companyId=_this$state.companyId,provider=_this$state.provider;// HACK: Without this timeout it might happen(very rare) that dropbox doesn't log out user before we hit login page.
setTimeout(function(){return Object(__WEBPACK_IMPORTED_MODULE_17_redux_modules_cloudFolders__["b" /* authenticateProvider */])(provider,companyId);},DROPBOX_TIMEOUT);}},{key:"dropboxLogout",value:function dropboxLogout(){var dropboxLogout=this.state.dropboxLogout;var iframeClass=this.props.classes.iframeClass;if(!dropboxLogout){return;}return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("iframe",{src:"https://www.dropbox.com/logout",className:iframeClass,onLoad:this.handleOnLoad()});}},{key:"renderAddTeamFolderButton",value:function renderAddTeamFolderButton(){var _this6=this;if(!this.hasCloudFolders()||this.state.showProviders){return;}var addFolderButtonContainer=this.props.classes.addFolderButtonContainer;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:addFolderButtonContainer},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Button___default.a,{variant:"contained",color:"primary","data-tid":"button-asset-add",onClick:function onClick(){return _this6.setState({showProviders:true});}},localize('asset-folder-add-button')));}},{key:"renderBasicView",value:function renderBasicView(){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",null,this.renderCloudProviders(),this.renderTeamFolder(),this.renderAddTeamFolderButton(),this.dropboxLogout());}},{key:"render",value:function render(){var _this$props8=this.props,classes=_this$props8.classes,type=_this$props8.type,match=_this$props8.match;var selectedFolder=this.state.selectedFolder;var displayCloudBrowser=Boolean(this.getProvider());return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:classes.root},!displayCloudBrowser&&this.renderBasicView(),displayCloudBrowser&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_CloudBrowser_CloudBrowser__["a" /* default */],{selectedFolder:selectedFolder,type:type,match:match}));}}]);return Asset;}(__WEBPACK_IMPORTED_MODULE_24__BaseAsset__["a" /* default */]))||_class);var mapStateToProps=function mapStateToProps(state){return{cloudFolders:__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},state.cloudFolders,{documentFolder:null,imageFolder:null}),company:state.companies.rawDataById[state.companies.selectedId]||{},companyId:state.companies.selectedId};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_12_redux__["b" /* bindActionCreators */])({fetchSession:__WEBPACK_IMPORTED_MODULE_21_redux_modules_session__["b" /* fetchSession */],updateFolder:__WEBPACK_IMPORTED_MODULE_17_redux_modules_cloudFolders__["h" /* updateFolder */],changeFolder:__WEBPACK_IMPORTED_MODULE_17_redux_modules_cloudFolders__["c" /* changeFolder */],removeFolder:__WEBPACK_IMPORTED_MODULE_17_redux_modules_cloudFolders__["f" /* removeFolder */],showModal:__WEBPACK_IMPORTED_MODULE_22_redux_modules_modal__["d" /* showModal */]},dispatch);};Asset.propTypes={match:__WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.object.isRequired,updateFolder:__WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.func,fetchSession:__WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.func,removeFolder:__WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.func,changeFolder:__WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.func,showModal:__WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.func,classes:__WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.object,cloudFolders:__WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.object,company:__WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.object,companyId:__WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.string,type:__WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Asset));

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_StickyHeader_StickyHeader__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_RolesTooltip__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_FormField__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_SmartFieldPhotoPicker_SmartFieldPhotoPicker__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_SmartFieldPhotoPicker_SmartFieldPhotoCropper__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_icons_defaultAvatar__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_icons_more__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_i18n_i18n__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__logger_logger__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_redux_modules_mls__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__material_ui_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__material_ui_core_Fade__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__material_ui_core_Fade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__material_ui_core_Fade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Features_components__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_redux_modules_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__theme_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__material_ui_icons_KeyboardArrowDown__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__material_ui_icons_KeyboardArrowDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__material_ui_icons_KeyboardArrowDown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__material_ui_icons_ExpandMore__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__material_ui_icons_ExpandMore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__material_ui_icons_ExpandMore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__material_ui_core_ExpansionPanel__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__material_ui_core_ExpansionPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__material_ui_core_ExpansionPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__material_ui_core_ExpansionPanelDetails__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__material_ui_core_ExpansionPanelDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__material_ui_core_ExpansionPanelDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__material_ui_core_ExpansionPanelSummary__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__material_ui_core_ExpansionPanelSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__material_ui_core_ExpansionPanelSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_theme_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_redux_modules_companies__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_redux_modules_session__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_Header__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_Description__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__utils_url__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__utils_forms__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__utils_users__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_lib_Segment_customTrackers__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_lib_Segment_helpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_components_CenteredContent_CenteredContent__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__utils_subscription__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_routes__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__errors_apperror__ = __webpack_require__(34);
var _errors,_invalidMLSInputValue,_dec,_class;var log=__WEBPACK_IMPORTED_MODULE_25__logger_logger__["a" /* default */].get('Subscription');var localize=__WEBPACK_IMPORTED_MODULE_23_i18n_i18n__["a" /* default */].loc.localize;var errors=(_errors={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_15_errors_errorids__["a" /* default */].OFFLINE,'subscriptions-error-offline'),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_15_errors_errorids__["a" /* default */].EXTERNAL_IDS_INVALID_COMPANY_ID,'users-external-id-error-invalid-company-id'),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_15_errors_errorids__["a" /* default */].EXTERNAL_IDS_MUST_BE_AN_ARRAY,'users-external-id-error-external-ids-must-be-an-array'),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_15_errors_errorids__["a" /* default */].EXTERNAL_IDS_TARGET_USER_IS_NOT_IN_THE_COMPANY,'users-external-id-error-target-user-not-in-the-company'),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_15_errors_errorids__["a" /* default */].FAILED_TO_UPDATE_EXTERNAL_ID,'users-external-id-error-failed-to-update-external-id'),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_15_errors_errorids__["a" /* default */].DUPLICATE_MLS_IDS,'users-external-id-duplicates'),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_15_errors_errorids__["a" /* default */].UNKNOWN,'users-external-id-error-unknown'),_errors);var invalidMLSInputValue=(_invalidMLSInputValue={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_invalidMLSInputValue,'invalid-value','users-table-mls-id-invalid-value'),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_invalidMLSInputValue,'already-used','users-table-mls-id-already-used'),_invalidMLSInputValue);var userTypeTable=[{name:localize('user-type-all'),select:function select(user){return user.role===__WEBPACK_IMPORTED_MODULE_43__config__["_54" /* USER_ROLE_ADMIN */]||user.role===__WEBPACK_IMPORTED_MODULE_43__config__["_55" /* USER_ROLE_BASIC */];}},{name:localize('user-type-admins'),select:function select(user){return user.role===__WEBPACK_IMPORTED_MODULE_43__config__["_54" /* USER_ROLE_ADMIN */];}},{name:localize('user-type-members'),select:function select(user){return user.role===__WEBPACK_IMPORTED_MODULE_43__config__["_55" /* USER_ROLE_BASIC */];}},{name:localize('user-type-pending'),select:function select(user){return!user.lastSessionTime;}}];var MINUTE=60*1000;var HOUR=60*MINUTE;var DAY=24*HOUR;var MONTH_IN_DAYS=30;var YEAR_IN_DAYS=365;var MONTHS=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];var USERS_LAST_SEEN_COLUMN_VISIBILITY_CHANGED_EVENT='users-last-seen-column-visibility-changed';var pluralize=function pluralize(value,singular,plural){return"".concat(value," ").concat(value===1?singular:plural," ago");};var shouldShowLastSeenColumn=function shouldShowLastSeenColumn(){return window.showUsersLastSeenColumn===true;};var getCalendarDaysAgo=function getCalendarDaysAgo(date){var today=new Date();var todayStart=new Date(today.getFullYear(),today.getMonth(),today.getDate());var dateStart=new Date(date.getFullYear(),date.getMonth(),date.getDate());return Math.floor((todayStart.getTime()-dateStart.getTime())/DAY);};var formatShortLastSeenDate=function formatShortLastSeenDate(date){return"".concat(MONTHS[date.getMonth()]," ").concat(date.getDate());};var formatLastSeenTooltip=function formatLastSeenTooltip(date){var hours=date.getHours();var minutes=date.getMinutes();var ampm=hours>=12?'PM':'AM';var paddedHours="".concat(hours<10?'0':'').concat(hours);var paddedMinutes="".concat(minutes<10?'0':'').concat(minutes);return"".concat(formatShortLastSeenDate(date),", ").concat(date.getFullYear()," ").concat(localize('user-last-login-at')," ")+"".concat(paddedHours,":").concat(paddedMinutes).concat(ampm);};var getLastSeenData=function getLastSeenData(lastSessionTime){if(!lastSessionTime){return{label:localize('user-last-login-never'),tooltip:null};}var sessionDate=new Date(lastSessionTime);if(Number.isNaN(sessionDate.getTime())){return{label:localize('user-last-login-never'),tooltip:null};}var elapsedTime=Date.now()-sessionDate.getTime();var elapsedMinutes=Math.floor(elapsedTime/MINUTE);var elapsedHours=Math.floor(elapsedTime/HOUR);var calendarDaysAgo=getCalendarDaysAgo(sessionDate);var label;if(calendarDaysAgo<=0&&elapsedTime<MINUTE){label=localize('user-last-login-just-now');}else if(calendarDaysAgo<=0&&elapsedTime<HOUR){label=pluralize(elapsedMinutes,localize('user-last-login-minute'),localize('user-last-login-minutes'));}else if(calendarDaysAgo<=0){label=pluralize(elapsedHours,localize('user-last-login-hour'),localize('user-last-login-hours'));}else if(calendarDaysAgo===1){label=localize('user-last-login-yesterday');}else if(calendarDaysAgo<7){label=sessionDate.toLocaleDateString('en-US',{weekday:'long'});}else if(calendarDaysAgo===7){label=pluralize(1,localize('user-last-login-week'),localize('user-last-login-weeks'));}else if(calendarDaysAgo<=MONTH_IN_DAYS){label=formatShortLastSeenDate(sessionDate);}else if(calendarDaysAgo<YEAR_IN_DAYS){label=pluralize(Math.floor(calendarDaysAgo/MONTH_IN_DAYS),localize('user-last-login-month'),localize('user-last-login-months'));}else{label=localize('user-last-login-over-a-year');}return{label:label,tooltip:formatLastSeenTooltip(sessionDate)};};var styles=function styles(theme){return __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectSpread___default()({/* page header */stickyHeader:{paddingBottom:30,marginBottom:60,'&:after':__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({width:'100%',margin:'0 5%'},theme.breakpoints.up('md'),{margin:0})},headerDescription:{margin:'0 0 40px'}},Object(__WEBPACK_IMPORTED_MODULE_46__utils_users__["g" /* getTableStyleProps */])(__WEBPACK_IMPORTED_MODULE_43__config__["_59" /* USER_TABLE_ALL */],theme),{/* expansion panel */expansionPanel:{margin:0,boxShadow:'none',border:0,'&::before':{display:'none'}},expansionPanelSummary:{padding:0,margin:0,'&.expansionPanelSummaryExpanded':{minHeight:48},'& > div:first-child':{margin:0},'&:hover h2':{color:'#2888C3'},'&:hover .expandUserTableIcon':{color:'#2888C3'}},expansionPanelDetails:{padding:0},userType:{display:'flex',justifyContent:'space-between'},userTypeCount:{color:'#6F99BD'},panelExpanded:{'& .expandUserTableIcon':{transform:'translateY(-50%) rotate(0deg)'}},columnTableToggleIcon:{position:'relative',width:33},expandUserTableIcon:{'position':'absolute','top':'50%',transform:'translateY(-50%) rotate(-90deg)','left':0,transition:'transform 0.2s'},/* More icon */iconMore:{color:'#282828'},/* delete icon */iconDelete:{color:'#282828'},/* inactive company message */errorInactiveCompany:__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectSpread___default()({},theme.overrides.MuiFormHelperText.root['&$error'],{opacity:1,padding:'0 0 20px !important'}),errorInactiveCompanyLink:__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectSpread___default()({},theme.overrides.MuiFormHelperText.root['&$error'],{padding:'0 !important',textDecoration:'underline',opacity:1,margin:'0 3px','&:hover':{textDecoration:'none'}}),buttonInviteUsers:{marginLeft:'8px',background:theme.palette.colors.white,border:'1px solid black',paddingLeft:20,paddingRight:20,'&:hover':{borderWidth:'1px'}},tableLastSeenCell:__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({width:150,whiteSpace:'nowrap'},theme.breakpoints.down('sm'),{display:'none'}),/* avatar */avatarPlaceholder:{width:'40px',height:'40px',margin:'10px 25px',opacity:0.32},defaultAvatar:{width:'40px',height:'40px'},photoPicker:{margin:'10px 25px'},select:{minWidth:'200px',marginBottom:'15px'},photoCell:{display:'flex'},pendingSign:{display:'inline-block',fontSize:'12px',fontWeight:'600',textAlign:'center',borderRadius:'10px',backgroundColor:'#FFE6C1',color:'#AC5312',lineHeight:'20px',letterSpacing:'-0.24px',marginBottom:'10px',padding:'0px 7px'},/* error message */errorMessage:{color:theme.palette.error.main,fontSize:14,lineHeight:1.5,opacity:1}});};var Users=(_dec=Object(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["N" /* withStyles */])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(Users,_Component);function Users(props){var _table;var _this;__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this,Users);_this=__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Users).call(this,props));__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this),"handleMenuOpen",function(event,user){_this.setState({moreAnchorEl:event.currentTarget,/*.parentElement*/moreMenuUser:user});});__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this),"handleMenuClose",function(){_this.setState({moreAnchorEl:null});});var queryParams=Object(__WEBPACK_IMPORTED_MODULE_44__utils_url__["d" /* parseQuery */])(props.location.search);var email=queryParams.email;_this.handleUserEdit=_this.handleUserEdit.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.updateCompanyUser=_this.updateCompanyUser.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.handleUserDelete=_this.handleUserDelete.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.onRemoveMember=_this.onRemoveMember.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.changeUserRole=_this.changeUserRole.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.handleShowAddUserModal=_this.handleShowAddUserModal.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.handleSendInvitations=_this.handleSendInvitations.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.handleAddUsers=_this.handleAddUsers.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.clearExternalIdsForUser=_this.clearExternalIdsForUser.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.clearExternalIdsStateAfterRoleChange=_this.clearExternalIdsStateAfterRoleChange.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.hideAllMlsFields=_this.hideAllMlsFields.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.cleanMlsIdValue=_this.cleanMlsIdValue.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.handleOpenPhotoPicker=_this.handleOpenPhotoPicker.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.handleOpenPhotoCropper=_this.handleOpenPhotoCropper.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.onPhotoAdd=_this.onPhotoAdd.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.onManageMlsAgentsCloseHandler=_this.onManageMlsAgentsCloseHandler.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.handleLastSeenColumnVisibilityChange=_this.handleLastSeenColumnVisibilityChange.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this));var adminsAndMembersExpandedState=Object(__WEBPACK_IMPORTED_MODULE_46__utils_users__["f" /* getSavedTableSettings */])(_this.props.settings,__WEBPACK_IMPORTED_MODULE_43__config__["_58" /* USER_TABLE_ADMINS_AND_MEMBERS */],'expanded');var guestsExpandedState=Object(__WEBPACK_IMPORTED_MODULE_46__utils_users__["f" /* getSavedTableSettings */])(_this.props.settings,__WEBPACK_IMPORTED_MODULE_43__config__["_60" /* USER_TABLE_GUESTS */],'expanded');_this.inputRefs={};_this.photoPickerRefs={};_this.onCropPhotoRef=__WEBPACK_IMPORTED_MODULE_10_react___default.a.createRef();_this.onCropPhotoRef.current=function(companyId,userId,result){var blob=result.blob;// Convert Blob back to File object.
var croppedFile=new File([blob],"photo.".concat(result.extension),{type:blob.type});_this.setState({loadingPhotoUserId:userId});_this.props.updateUserPhoto(croppedFile,companyId,userId).then(function(data){_this.setState({loadingPhotoUserId:null});if(data instanceof __WEBPACK_IMPORTED_MODULE_52__errors_apperror__["a" /* default */]){return;}});};_this.state=__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectSpread___default()({},_this.getStateFromProps(props),{willChangeRole:false,shownMlsFields:{},showPhotoCropper:false,loadingPhotoUserId:null,photoCropperUrl:'',photoCropperKey:null,focusedField:{},mlsFieldsWithErrors:{},updatingMlsIdForUsers:{},newExternalIds:{},userTypeIdx:0,moreAnchorEl:null,moreMenuUser:null,showLastSeenColumn:shouldShowLastSeenColumn(),table:(_table={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_table,__WEBPACK_IMPORTED_MODULE_43__config__["_58" /* USER_TABLE_ADMINS_AND_MEMBERS */],{expanded:adminsAndMembersExpandedState!==undefined?adminsAndMembersExpandedState:true,sortKey:Object(__WEBPACK_IMPORTED_MODULE_46__utils_users__["f" /* getSavedTableSettings */])(_this.props.settings,__WEBPACK_IMPORTED_MODULE_43__config__["_58" /* USER_TABLE_ADMINS_AND_MEMBERS */],'sortKey'),sortOrder:Object(__WEBPACK_IMPORTED_MODULE_46__utils_users__["f" /* getSavedTableSettings */])(_this.props.settings,__WEBPACK_IMPORTED_MODULE_43__config__["_58" /* USER_TABLE_ADMINS_AND_MEMBERS */],'sortOrder')}),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_table,__WEBPACK_IMPORTED_MODULE_43__config__["_60" /* USER_TABLE_GUESTS */],{expanded:guestsExpandedState!==undefined?guestsExpandedState:true,sortKey:Object(__WEBPACK_IMPORTED_MODULE_46__utils_users__["f" /* getSavedTableSettings */])(_this.props.settings,__WEBPACK_IMPORTED_MODULE_43__config__["_60" /* USER_TABLE_GUESTS */],'sortKey'),sortOrder:Object(__WEBPACK_IMPORTED_MODULE_46__utils_users__["f" /* getSavedTableSettings */])(_this.props.settings,__WEBPACK_IMPORTED_MODULE_43__config__["_60" /* USER_TABLE_GUESTS */],'sortOrder')}),_table)});if(email||'add-user'in queryParams||'show-add-users-modal'in queryParams){// 'add-user' param can be empty
var userEmail=email||queryParams['add-user']||'';if(Object(__WEBPACK_IMPORTED_MODULE_46__utils_users__["c" /* doesUserExist */])(_this.state.users,userEmail,__WEBPACK_IMPORTED_MODULE_43__config__["_56" /* USER_ROLE_GUEST */])){// [P9052-10005] Show a confirmation popup to upgrade Guest to Member
_this.confirmRoleUpgrade(__WEBPACK_IMPORTED_MODULE_43__config__["_53" /* USER_ROLES */][__WEBPACK_IMPORTED_MODULE_43__config__["_55" /* USER_ROLE_BASIC */]].label,userEmail,_this.getUserIdForEmail(email));}else{// [P9052-10177] Predefine user in the input
_this.handleShowAddUserModal(userEmail);}}return _this;}__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Users,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(props){this.setState(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectSpread___default()({},this.getStateFromProps(props)));}},{key:"getStateFromProps",value:function getStateFromProps(props){var currentPlanName=props.currentPlanName;var _props$companies=props.companies,rawDataById=_props$companies.rawDataById,selectedId=_props$companies.selectedId;var company=rawDataById[selectedId];var users=company.users,hasActiveSubscription=company.hasActiveSubscription;return{users:users,hasActiveSubscription:hasActiveSubscription,currentPlanName:currentPlanName,selectedId:selectedId,company:company};}},{key:"handleLastSeenColumnVisibilityChange",value:function handleLastSeenColumnVisibilityChange(){this.setState({showLastSeenColumn:shouldShowLastSeenColumn()});}},{key:"componentDidMount",value:function componentDidMount(){window.addEventListener(USERS_LAST_SEEN_COLUMN_VISIBILITY_CHANGED_EVENT,this.handleLastSeenColumnVisibilityChange);if(this.props.askToCompleteCompanyProfile){this.showCompleteTeamProfileModal();}if(this.props.mls.mlsUiType===__WEBPACK_IMPORTED_MODULE_43__config__["_0" /* MLS_UI */].DIRECT_MLS_API){var newExternalIds={};this.state.users.forEach(function(user,index){var userId=user.userId,externalIds=user.externalIds;if(userId){newExternalIds[userId]=!__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.isEmpty(externalIds)?__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(externalIds):[''];}});this.props.clearExternalIdState();this.setState({newExternalIds:newExternalIds});}}},{key:"componentWillUnmount",value:function componentWillUnmount(){window.removeEventListener(USERS_LAST_SEEN_COLUMN_VISIBILITY_CHANGED_EVENT,this.handleLastSeenColumnVisibilityChange);}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState){var _this2=this;if(this.props.mls.mlsUiType===__WEBPACK_IMPORTED_MODULE_43__config__["_0" /* MLS_UI */].DIRECT_MLS_API){var _prevProps$companies=prevProps.companies,rawDataByIdPrev=_prevProps$companies.rawDataById,selectedIdPrev=_prevProps$companies.selectedId;var companyPrev=rawDataByIdPrev[selectedIdPrev];var usersPrev=companyPrev.users;var usersUpdated=this.getCompanyUsers();usersUpdated.forEach(function(updatedUser,index){var oldUser=usersPrev.find(function(u){return u.email===updatedUser.email;});if(oldUser){if(!__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.isEqual(oldUser.externalIds,updatedUser.externalIds)){if(!__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.isEqual(_this2.props.companies.updatingExternalIdSuccess,prevProps.companies.updatingExternalIdSuccess)&&_this2.props.companies.updatingExternalIdSuccess.includes(updatedUser.userId)){var updatingMlsIdForUsers=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(_this2.state.updatingMlsIdForUsers);delete updatingMlsIdForUsers[updatedUser.userId];var shownMlsFields=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(_this2.state.shownMlsFields);delete shownMlsFields[updatedUser.userId];var focusedField=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(_this2.state.focusedField);delete focusedField[updatedUser.userId];// update existing external id record
if(!__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.isEqual(updatingMlsIdForUsers,_this2.state.updatingMlsIdForUsers)){_this2.setState({updatingMlsIdForUsers:updatingMlsIdForUsers,shownMlsFields:shownMlsFields,focusedField:focusedField});}// delete single MLS id
if(__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.isArray(updatedUser.externalIds)&&__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.isArray(oldUser.externalIds)&&updatedUser.externalIds.length<oldUser.externalIds.length){var newExternalIds=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(_this2.state.newExternalIds);var nonEmptyValues=_this2.state.newExternalIds[updatedUser.userId].filter(function(id){return _this2.cleanMlsIdValue(id).length;});newExternalIds[updatedUser.userId]=nonEmptyValues.length?nonEmptyValues:[''];var mlsFieldsWithErrors=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(_this2.state.mlsFieldsWithErrors);delete mlsFieldsWithErrors[updatedUser.userId];_this2.setState({newExternalIds:newExternalIds,mlsFieldsWithErrors:mlsFieldsWithErrors});}}}else{// By default init externalIds to '', for example if user is changed from guest to member/admin
var _newExternalIds=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(_this2.state.newExternalIds);if(updatedUser.userId&&!__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(_this2.state.newExternalIds,"[".concat(updatedUser.userId,"]"))){_newExternalIds[updatedUser.userId]=[''];_this2.setState({newExternalIds:_newExternalIds});}}}});if(!__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.isEmpty(this.props.companies.updatingExternalIdErrorId)){var updatingMlsIdForUsers=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(this.state.updatingMlsIdForUsers);Object.keys(updatingMlsIdForUsers).map(function(currentUserId){var apiError=_this2.props.companies.updatingExternalIdErrorId.find(function(user){return user.userId===currentUserId;});if(apiError){Object.keys(updatingMlsIdForUsers[currentUserId]).map(function(currentUserIndex){if(__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(_this2.state.updatingMlsIdForUsers,"[".concat(currentUserId,"][").concat(currentUserIndex,"]"))){var shownMlsFields=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(_this2.state.shownMlsFields);shownMlsFields[currentUserId]=shownMlsFields[currentUserId]||{};shownMlsFields[currentUserId][currentUserIndex]=true;delete updatingMlsIdForUsers[currentUserId][currentUserIndex];_this2.setState({updatingMlsIdForUsers:updatingMlsIdForUsers,shownMlsFields:shownMlsFields});}});}});}}}/**
	 * Show a confirmation popup on the user upgrade
	 * @param {string} newRole The new role
	 * @param {string} email User's email
	 *
	 * @memberof Users
	 */},{key:"confirmRoleUpgrade",value:function confirmRoleUpgrade(newRole,email,userId){var _this3=this;this.props.showModal('CONFIRMATION_MODAL',{message:localize('users-confirm-role-upgrade',email),buttons:[__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_Features_components__["a" /* Button */],{key:"button-cancel",variant:"outlined",color:"primary"},localize('no')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_Features_components__["a" /* Button */],{key:"button-confirm",variant:"contained",color:"primary",onClick:function onClick(){return _this3.handleUserEdit(newRole,email,userId);}},localize('yes'))]});}},{key:"handleTableToggle",value:function handleTableToggle(e,tableId){if(e.target.closest('.columnTableInfo'))return;// Ignore click on info icon
var tablesState=this.state.table;var isTableExpanded=!tablesState[tableId].expanded;tablesState[tableId].expanded=isTableExpanded;this.setState(tablesState);// use same settings in all companies
var userPageSettings=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(this.props.settings,"".concat(__WEBPACK_IMPORTED_MODULE_43__config__["k" /* CAP_KEY */],".").concat(__WEBPACK_IMPORTED_MODULE_43__config__["_52" /* USER_PAGE_SETTINGS_KEY */]),{});userPageSettings[tableId]||(userPageSettings[tableId]={});userPageSettings[tableId].expanded=isTableExpanded;this.props.writeUserSettings(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({},__WEBPACK_IMPORTED_MODULE_43__config__["_52" /* USER_PAGE_SETTINGS_KEY */],userPageSettings));}},{key:"sortTable",value:function sortTable(tableId,newSortColumnKey){var tablesState=this.state.table;var currentSortKey=tablesState[tableId].sortKey;var currentSortOrder=tablesState[tableId].sortOrder;if(!currentSortKey){tablesState[tableId].sortKey=newSortColumnKey;tablesState[tableId].sortOrder=__WEBPACK_IMPORTED_MODULE_43__config__["_36" /* SORT_ORDER */].DESC;}else if(currentSortKey===newSortColumnKey){tablesState[tableId].sortOrder=currentSortOrder===__WEBPACK_IMPORTED_MODULE_43__config__["_36" /* SORT_ORDER */].ASC?__WEBPACK_IMPORTED_MODULE_43__config__["_36" /* SORT_ORDER */].DESC:__WEBPACK_IMPORTED_MODULE_43__config__["_36" /* SORT_ORDER */].ASC;}else if(currentSortKey!==newSortColumnKey){tablesState[tableId].sortKey=newSortColumnKey;tablesState[tableId].sortOrder=__WEBPACK_IMPORTED_MODULE_43__config__["_36" /* SORT_ORDER */].ASC;}this.setState(tablesState);// use same settings in all companies
var userPageSettings=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(this.props.settings,"".concat(__WEBPACK_IMPORTED_MODULE_43__config__["k" /* CAP_KEY */],".").concat(__WEBPACK_IMPORTED_MODULE_43__config__["_52" /* USER_PAGE_SETTINGS_KEY */]),{});userPageSettings[tableId]||(userPageSettings[tableId]={});userPageSettings[tableId].sortKey=tablesState[tableId].sortKey;userPageSettings[tableId].sortOrder=tablesState[tableId].sortOrder;this.props.writeUserSettings(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({},__WEBPACK_IMPORTED_MODULE_43__config__["_52" /* USER_PAGE_SETTINGS_KEY */],userPageSettings));}},{key:"onPhotoAdd",value:function onPhotoAdd(e,updatedUser){var _this4=this;var file=e.currentTarget.files[0];e.currentTarget.value='';this.setState({loadingPhotoUserId:updatedUser.userId});this.props.updateUserPhoto(file,this.state.company.id,updatedUser.userId).then(function(data){_this4.setState({loadingPhotoUserId:null});if(data instanceof __WEBPACK_IMPORTED_MODULE_52__errors_apperror__["a" /* default */]){return;}})["catch"](function(error){_this4.setState({loadingPhotoUserId:null});});}},{key:"handleOpenPhotoPicker",value:function handleOpenPhotoPicker(refId){if(this.photoPickerRefs[refId].current){this.photoPickerRefs[refId].current.click();}}},{key:"handleOpenPhotoCropper",value:function(){var _handleOpenPhotoCropper=__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.mark(function _callee(key,value){return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.setState({showPhotoCropper:true,photoCropperUrl:value,photoCropperKey:key});case 1:case"end":return _context.stop();}}},_callee,this);}));function handleOpenPhotoCropper(_x,_x2){return _handleOpenPhotoCropper.apply(this,arguments);}return handleOpenPhotoCropper;}()},{key:"handleRemovePhoto",value:function handleRemovePhoto(userId){this.props.updateUserPhoto(null,this.state.company.id,userId).then(function(data){if(data instanceof __WEBPACK_IMPORTED_MODULE_52__errors_apperror__["a" /* default */]){return;}});}},{key:"renderErrorLoadingMlsData",value:function renderErrorLoadingMlsData(){var _classNames;var classes=this.props.classes;var errorMessage=localize('mls-error-loading-mls-data');return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["M" /* Typography */],{className:__WEBPACK_IMPORTED_MODULE_42_classnames___default()((_classNames={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames,classes.errorMessage,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames,'errorMessage',true),_classNames)),variant:"body2"},errorMessage);}},{key:"render",value:function render(){var _this5=this;var _this$state=this.state,redirectUrl=_this$state.redirectUrl,preselectSubscriptionView=_this$state.preselectSubscriptionView,preselectOpenCBDetails=_this$state.preselectOpenCBDetails;var classes=this.props.classes;var _this$props$mls=this.props.mls,getConnectionsErrorId=_this$props$mls.getConnectionsErrorId,getAgentsMlsIdsErrorId=_this$props$mls.getAgentsMlsIdsErrorId,mlsBoardListFailedToLoad=_this$props$mls.mlsBoardListFailedToLoad;if(redirectUrl){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_router_dom__["c" /* Redirect */],{to:__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectSpread___default()({pathname:redirectUrl},(preselectSubscriptionView||preselectOpenCBDetails)&&{state:{preselectSubscriptionView:preselectSubscriptionView,preselectOpenCBDetails:preselectOpenCBDetails}})});}return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_49_components_CenteredContent_CenteredContent__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_StickyHeader_StickyHeader__["a" /* default */],{className:classes.stickyHeader},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40__components_Header__["a" /* default */],null,localize('users-header')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41__components_Description__["a" /* default */],{className:classes.headerDescription},localize('users-description')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_Features_components__["a" /* Button */],{variant:"contained","data-tid":"button-user-add",color:"primary",onClick:function onClick(){return _this5.handleShowAddUserModal();},className:classes.buttonAddUsers},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__theme_icons__["s" /* IconAddUsers */],{className:classes.iconAddUsers}),localize('users-add')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_Features_components__["a" /* Button */],{variant:"outlined","data-tid":"button-user-send-invitations",color:"primary",onClick:function onClick(){return _this5.handleSendInvitations();},className:classes.buttonInviteUsers},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__theme_icons__["C" /* IconInvite */],{className:classes.iconAddUsers}),localize('users-send-invitations'))),!this.props.askToCompleteCompanyProfile&&this.renderInactiveCompanyInformation(classes),this.props.mls.mlsUiType===__WEBPACK_IMPORTED_MODULE_43__config__["_0" /* MLS_UI */].SELF_CONNECT_API&&(getConnectionsErrorId||getAgentsMlsIdsErrorId||mlsBoardListFailedToLoad)&&this.renderErrorLoadingMlsData(),!this.props.askToCompleteCompanyProfile&&this.renderUserTable(__WEBPACK_IMPORTED_MODULE_43__config__["_58" /* USER_TABLE_ADMINS_AND_MEMBERS */],[__WEBPACK_IMPORTED_MODULE_43__config__["_54" /* USER_ROLE_ADMIN */],__WEBPACK_IMPORTED_MODULE_43__config__["_55" /* USER_ROLE_BASIC */]],this.state.newExternalIds),!this.props.askToCompleteCompanyProfile&&this.renderUserTable(__WEBPACK_IMPORTED_MODULE_43__config__["_60" /* USER_TABLE_GUESTS */],[__WEBPACK_IMPORTED_MODULE_43__config__["_56" /* USER_ROLE_GUEST */]]));}},{key:"renderUserTable",value:function renderUserTable(tableId,renderRoles,externalIds){var _this6=this,_classNames2,_classNames3,_classNames5,_classNames6,_classNames7,_classNames8,_classNames9,_classNames10,_classNames11,_classNames12;var classes=this.props.classes;var users=this.state.users;var _this$state$table$tab=this.state.table[tableId],expanded=_this$state$table$tab.expanded,sortKey=_this$state$table$tab.sortKey,sortOrder=_this$state$table$tab.sortOrder;var showTypeSelect=tableId===__WEBPACK_IMPORTED_MODULE_43__config__["_58" /* USER_TABLE_ADMINS_AND_MEMBERS */];var sourceUsers=users.filter(function(user){return renderRoles.includes(user.role);});// If it's admins and members table, also filter by user type set by this.state.userTypeIdx
var usersToRender=Object(__WEBPACK_IMPORTED_MODULE_46__utils_users__["j" /* sortUsers */])(sourceUsers.filter(function(user){return showTypeSelect?userTypeTable[_this6.state.userTypeIdx].select(user,_this6.state.company.email):true;}),sortKey,sortOrder);var showMlsIdColumn=tableId===__WEBPACK_IMPORTED_MODULE_43__config__["_58" /* USER_TABLE_ADMINS_AND_MEMBERS */]&&__WEBPACK_IMPORTED_MODULE_43__config__["G" /* ENABLE_MLS_ID_FIELD_FOR_INDUSTRIES */].includes(this.props.company.industryId);var showUserPhoto=tableId===__WEBPACK_IMPORTED_MODULE_43__config__["_58" /* USER_TABLE_ADMINS_AND_MEMBERS */];var showLastSeenColumn=this.state.showLastSeenColumn;var tableLabel=!showTypeSelect||!this.state.userTypeIdx?__WEBPACK_IMPORTED_MODULE_43__config__["_57" /* USER_TABLES */][tableId].label:userTypeTable[this.state.userTypeIdx].name;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__material_ui_core_ExpansionPanel___default.a,{expanded:expanded,className:__WEBPACK_IMPORTED_MODULE_42_classnames___default()((_classNames2={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames2,classes.expansionPanel,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames2,classes.panelExpanded,expanded),_classNames2)),onMouseLeave:function onMouseLeave(){return showMlsIdColumn&&_this6.hideAllMlsFields(false);},onChange:function onChange(e){return _this6.handleTableToggle(e,tableId);}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__material_ui_core_ExpansionPanelSummary___default.a,{className:__WEBPACK_IMPORTED_MODULE_42_classnames___default()((_classNames3={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames3,classes.expansionPanelSummary,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames3,'expansionPanelSummaryExpanded',expanded),_classNames3))},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["o" /* Grid */],{container:true,direction:"row",className:__WEBPACK_IMPORTED_MODULE_42_classnames___default()(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({},classes.tableHead,!showTypeSelect))},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["o" /* Grid */],{item:true,className:classes.columnTableToggleIcon},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_icons_ExpandMore___default.a,{style:{fontSize:27},className:__WEBPACK_IMPORTED_MODULE_42_classnames___default()((_classNames5={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames5,classes.expandUserTableIcon,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames5,'expandUserTableIcon',true),_classNames5))})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["o" /* Grid */],{item:true,className:classes.columnTableTitle},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["M" /* Typography */],{className:classes.tableTitle,variant:"h2"},tableLabel," (",usersToRender.length,")")),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["o" /* Grid */],{item:true,container:true,justify:"center",className:__WEBPACK_IMPORTED_MODULE_42_classnames___default()((_classNames6={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames6,classes.columnTableInfo,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames6,'columnTableInfo',true),_classNames6))},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_RolesTooltip__["a" /* default */],{tableId:tableId})))),showTypeSelect&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_Features_components__["b" /* Select */],{className:classes.select,id:"select-user-type",value:this.state.userTypeIdx,disableUnderline:true,onChange:function onChange(event){return _this6.setState({userTypeIdx:event.target.value});},renderValue:function renderValue(value){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,localize('user-type-type')+userTypeTable[value].name);}},userTypeTable.map(function(type,index){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["x" /* MenuItem */],{className:classes.userType,key:type.name,value:index},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,type.name),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.userTypeCount},'('+sourceUsers.filter(function(user){return userTypeTable[index].select(user,_this6.state.company.email);}).length+')'));})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__material_ui_core_ExpansionPanelDetails___default.a,{className:classes.expansionPanelDetails},usersToRender.length===0?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["M" /* Typography */],{variant:"body2",className:classes.noUsersFound},localize('users-table-no-guests-found')):__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["c" /* ClickAwayListener */],{onClickAway:function onClickAway(){showMlsIdColumn&&_this6.hideAllMlsFields(true);}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["F" /* Table */],{className:classes.table,key:"user-table-".concat(tableId)},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["I" /* TableHead */],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["J" /* TableRow */],{className:classes.tableHeadRow},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["H" /* TableCell */],{padding:"dense",className:__WEBPACK_IMPORTED_MODULE_42_classnames___default()((_classNames7={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames7,classes.noBorderedCell,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames7,classes.tableNameCellHeader,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames7,classes.tableCellHeader,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames7,classes.tableHasSortArrow,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames7,'rowHasMls',showMlsIdColumn),_classNames7))},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["p" /* IconButton */],{className:__WEBPACK_IMPORTED_MODULE_42_classnames___default()((_classNames8={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames8,classes.sortArrow,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames8,'sortArrow',true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames8,'desc',sortKey===__WEBPACK_IMPORTED_MODULE_43__config__["_46" /* TABLE_COLUMNS */].FULL_NAME&&sortOrder===__WEBPACK_IMPORTED_MODULE_43__config__["_36" /* SORT_ORDER */].DESC),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames8,'active',sortKey===__WEBPACK_IMPORTED_MODULE_43__config__["_46" /* TABLE_COLUMNS */].FULL_NAME),_classNames8)),component:"span","aria-label":localize('users-table-change-sorting-order'),onClick:function onClick(){return _this6.sortTable(tableId,__WEBPACK_IMPORTED_MODULE_43__config__["_46" /* TABLE_COLUMNS */].FULL_NAME);}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__theme_icons__["X" /* SortArrow */],{className:classes.sortArrowIcon})),localize('users-table-header-name')),showUserPhoto&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["H" /* TableCell */],{padding:"none",className:__WEBPACK_IMPORTED_MODULE_42_classnames___default()(classes.noBorderedCell,classes.tableCellHeader,classes.tablePhotoCellHeader,classes.tableHasSortArrow)},localize('users-table-header-photo')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["H" /* TableCell */],{padding:"dense",className:__WEBPACK_IMPORTED_MODULE_42_classnames___default()((_classNames9={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames9,classes.noBorderedCell,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames9,classes.tableEmailCellHeader,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames9,classes.tableCellHeader,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames9,classes.tableHasSortArrow,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames9,'rowHasMls',showMlsIdColumn),_classNames9))},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["p" /* IconButton */],{className:__WEBPACK_IMPORTED_MODULE_42_classnames___default()((_classNames10={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames10,classes.sortArrow,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames10,'sortArrow',true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames10,'desc',sortKey===__WEBPACK_IMPORTED_MODULE_43__config__["_46" /* TABLE_COLUMNS */].EMAIL&&sortOrder===__WEBPACK_IMPORTED_MODULE_43__config__["_36" /* SORT_ORDER */].DESC),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames10,'active',sortKey===__WEBPACK_IMPORTED_MODULE_43__config__["_46" /* TABLE_COLUMNS */].EMAIL),_classNames10)),component:"span","aria-label":localize('users-table-change-sorting-order'),onClick:function onClick(){return _this6.sortTable(tableId,__WEBPACK_IMPORTED_MODULE_43__config__["_46" /* TABLE_COLUMNS */].EMAIL);}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__theme_icons__["X" /* SortArrow */],{className:classes.sortArrowIcon})),localize('users-table-header-email')),showMlsIdColumn&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["H" /* TableCell */],{padding:"none",className:__WEBPACK_IMPORTED_MODULE_42_classnames___default()(classes.tableMLSCellHeader,classes.noBorderedCell,classes.tableCellHeader,classes.tableHasSortArrow)},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["p" /* IconButton */],{className:__WEBPACK_IMPORTED_MODULE_42_classnames___default()((_classNames11={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames11,classes.sortArrow,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames11,'sortArrow',true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames11,'desc',sortKey===__WEBPACK_IMPORTED_MODULE_43__config__["_46" /* TABLE_COLUMNS */].MLS_ID&&sortOrder===__WEBPACK_IMPORTED_MODULE_43__config__["_36" /* SORT_ORDER */].DESC),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames11,'active',sortKey===__WEBPACK_IMPORTED_MODULE_43__config__["_46" /* TABLE_COLUMNS */].MLS_ID),_classNames11)),component:"span","aria-label":localize('users-table-change-sorting-order'),onClick:function onClick(){return _this6.sortTable(tableId,__WEBPACK_IMPORTED_MODULE_43__config__["_46" /* TABLE_COLUMNS */].MLS_ID);}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__theme_icons__["X" /* SortArrow */],{className:classes.sortArrowIcon})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p",{className:classes.tableMLSCellHeaderLabel},localize('users-table-header-mls')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["L" /* Tooltip */],{placement:"top",title:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["M" /* Typography */],{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_42_classnames___default()(classes.infoTooltipText)},localize('users-table-header-mls-tooltip')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span",{className:classes.tooltipArrow})),classes:{tooltip:classes.mlsInfoTooltipTableHead}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["p" /* IconButton */],{className:classes.infoIconButton,color:"primary",component:"span",disableRipple:true},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__theme_icons__["N" /* Info */],null)))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["H" /* TableCell */],{padding:"none",className:__WEBPACK_IMPORTED_MODULE_42_classnames___default()(classes.tableRoleCellHeader,classes.noBorderedCell,classes.tableCellHeader,classes.tableHasSortArrow)},tableId===__WEBPACK_IMPORTED_MODULE_43__config__["_58" /* USER_TABLE_ADMINS_AND_MEMBERS */]&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["p" /* IconButton */],{className:__WEBPACK_IMPORTED_MODULE_42_classnames___default()((_classNames12={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames12,classes.sortArrow,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames12,'leftAligned',true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames12,'sortArrow',true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames12,'desc',sortKey===__WEBPACK_IMPORTED_MODULE_43__config__["_46" /* TABLE_COLUMNS */].ROLE&&sortOrder===__WEBPACK_IMPORTED_MODULE_43__config__["_36" /* SORT_ORDER */].DESC),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames12,'active',sortKey===__WEBPACK_IMPORTED_MODULE_43__config__["_46" /* TABLE_COLUMNS */].ROLE),_classNames12)),component:"span","aria-label":localize('users-table-change-sorting-order'),onClick:function onClick(){return _this6.sortTable(tableId,__WEBPACK_IMPORTED_MODULE_43__config__["_46" /* TABLE_COLUMNS */].ROLE);}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__theme_icons__["X" /* SortArrow */],{className:classes.sortArrowIcon})),localize('users-table-header-user-role')),showLastSeenColumn&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["H" /* TableCell */],{padding:"dense",className:__WEBPACK_IMPORTED_MODULE_42_classnames___default()(classes.tableLastSeenCell,classes.noBorderedCell,classes.tableCellHeader)},localize('users-table-header-last-seen')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["H" /* TableCell */],{align:"right",padding:"none",className:__WEBPACK_IMPORTED_MODULE_42_classnames___default()(classes.tableActionsCell,classes.noBorderedCell)}))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["G" /* TableBody */],null,this.renderUserRows(renderRoles,usersToRender,showMlsIdColumn,showUserPhoto,externalIds,showLastSeenColumn))),this.state.showPhotoCropper&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_SmartFieldPhotoPicker_SmartFieldPhotoCropper__["a" /* default */],{photoUrl:this.state.photoCropperUrl,scale:1,onCropCb:function onCropCb(result){return _this6.onCropPhotoRef.current&&_this6.onCropPhotoRef.current(_this6.state.company.id,_this6.state.photoCropperKey,result);},hideModal:function hideModal(){return _this6.setState({showPhotoCropper:false});}}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["w" /* Menu */],{anchorEl:this.state.moreAnchorEl,open:Boolean(this.state.moreAnchorEl),onClose:this.handleMenuClose,anchorOrigin:{vertical:'top',horizontal:'right'},transformOrigin:{vertical:'top',horizontal:'left'}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["x" /* MenuItem */],{onClick:function onClick(){_this6.handleMenuClose();_this6.onRemoveMember(_this6.handleUserDelete,{email:_this6.state.moreMenuUser.email,user:Object(__WEBPACK_IMPORTED_MODULE_46__utils_users__["d" /* encodeUser */])(_this6.state.moreMenuUser)});}},localize('subscription-reduce-action-remove')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["x" /* MenuItem */],{onClick:function onClick(){_this6.handleMenuClose();_this6.handleAddUsers([{email:_this6.state.moreMenuUser.email,id:new Date().getTime(),role:_this6.state.moreMenuUser.role}],null);}},localize('user-menu-send-invite'))))));}},{key:"renderMLSFormField",value:function renderMLSFormField(userId,externalId,index){var _classNames13,_this7=this;var classes=this.props.classes;var errorClasses={error:classes.mlsErrorMessage};this.inputRefs["input-mls-".concat(userId,"-").concat(index)]=__WEBPACK_IMPORTED_MODULE_10_react___default.a.createRef();var errorMessageKey=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(this.state.mlsFieldsWithErrors,"[".concat(userId,"][").concat(index,"]"));return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["L" /* Tooltip */],{placement:"top",open:!__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(this.state.focusedField,"[".concat(userId,"][").concat(index,"]")),title:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["M" /* Typography */],{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_42_classnames___default()((_classNames13={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames13,classes.infoTooltipText,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames13,classes.mlsPendingPrompt,!userId),_classNames13))},localize(userId?'users-table-enter-agent-mls-id':'user-table-mls-pending-prompt')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span",{className:classes.tooltipArrow})),classes:{tooltip:classes.mlsInfoTooltipTableBody}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_FormField__["a" /* default */],{value:externalId||'',autoComplete:"off",className:__WEBPACK_IMPORTED_MODULE_42_classnames___default()(classes.mlsInputField),"data-tid":'mls-id-field',onChange:function onChange(event){return _this7.onMLSFieldChange(event,userId,index);},onKeyPress:function onKeyPress(event){return _this7.onMLSFieldKeyPress(event,userId,index);},onKeyDown:function onKeyDown(event){return _this7.onMLSFieldBlur(event);},onFocus:function onFocus(event){return _this7.onMLSFieldFocus(userId,index);},margin:"normal",id:"input-mls-".concat(userId,"-").concat(index),helperText:errorMessageKey&&localize(errorMessageKey),error:!!__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(this.state.mlsFieldsWithErrors,"[".concat(userId,"][").concat(index,"]")),FormHelperTextProps:{classes:errorClasses},inputRef:this.inputRefs["input-mls-".concat(userId,"-").concat(index)]}));}},{key:"renderMLSCell",value:function renderMLSCell(userId,externalIds){var _this8=this;var classes=this.props.classes;var _this$props$mls2=this.props.mls,getConnectionsErrorId=_this$props$mls2.getConnectionsErrorId,getAgentsMlsIdsErrorId=_this$props$mls2.getAgentsMlsIdsErrorId,mlsBoardListFailedToLoad=_this$props$mls2.mlsBoardListFailedToLoad,getAgentsMlsIdsSuccess=_this$props$mls2.getAgentsMlsIdsSuccess,getConnectionsSuccess=_this$props$mls2.getConnectionsSuccess,mlsBoardList=_this$props$mls2.mlsBoardList,connections=_this$props$mls2.connections;if(!userId){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["H" /* TableCell */],{padding:"dense",className:__WEBPACK_IMPORTED_MODULE_42_classnames___default()(classes.tableCellBody,classes.mlsPendingPrompt)},localize('user-table-mls-pending-prompt'));}if(this.props.mls.mlsUiType===__WEBPACK_IMPORTED_MODULE_43__config__["_0" /* MLS_UI */].SELF_CONNECT_API){var selfStartMlsIdsForUser=[];if(Array.isArray(this.props.mls.agentsMlsIds)){selfStartMlsIdsForUser=this.props.mls.agentsMlsIds.filter(function(item){return item.userId===userId;}).map(function(item){return item.agentMlsId;});}return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["H" /* TableCell */],{padding:"dense",className:classes.tableCellBody},getConnectionsErrorId||getAgentsMlsIdsErrorId||mlsBoardListFailedToLoad?this.renderMLSFieldContentError(userId):!getConnectionsSuccess||!getAgentsMlsIdsSuccess||mlsBoardList.length===0?this.renderMLSFieldContentLoading(userId):connections.length?selfStartMlsIdsForUser.length?this.renderMLSFieldContentClickToEdit(userId,selfStartMlsIdsForUser):this.renderMLSFieldContentClickToEnter(userId):this.renderMLSFieldContentNoConnections(userId));}else if(this.props.mls.mlsUiType===__WEBPACK_IMPORTED_MODULE_43__config__["_0" /* MLS_UI */].DIRECT_MLS_API){var apiError=this.props.companies.updatingExternalIdErrorId.find(function(user){return user.userId===userId;});var errorMessageKey=apiError&&apiError.errorId&&errors[apiError.errorId]||errors[__WEBPACK_IMPORTED_MODULE_15_errors_errorids__["a" /* default */].UNKNOWN];return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["H" /* TableCell */],{padding:"dense",className:classes.tableCellBody},externalIds&&externalIds.map(function(externalId,index){return __WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(_this8.state.updatingMlsIdForUsers,"[".concat(userId,"][").concat(index,"]"))?_this8.renderMLSFieldContentUpdatingState(userId,externalId,index):__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(_this8.state.shownMlsFields,"[".concat(userId,"][").concat(index,"]"))?!_this8.props.companies.updatingExternalIdXhrInProgress.includes(userId)?_this8.renderMLSFieldContentInputField(userId,externalId,index):_this8.renderMLSFieldContentNonEditableValue(userId,externalId,index):externalId===''?_this8.renderMLSFieldContentNoExternalId(userId,index):_this8.renderMLSFieldContentNonEditableValue(userId,externalId,index);}),apiError&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["M" /* Typography */],{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_42_classnames___default()(classes.externalIdsErrorMessage)},localize(errorMessageKey)));}}},{key:"renderMLSFieldContentInputField",value:function renderMLSFieldContentInputField(userId,externalId,index){var _this9=this,_classNames14,_classNames15;var classes=this.props.classes;var apiError=this.props.companies.updatingExternalIdErrorId.find(function(user){return user.userId===userId;});var saveEnabled=this.isMLSSaveEnabled(userId,index);var addFieldEnabled=this.isMLSAddFieldEnabled(userId,index)&&!apiError;var shouldRenderActionIcons=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(this.state.focusedField,"[".concat(userId,"][").concat(index,"]"));return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{key:"user-input-field-".concat(userId,"-").concat(index),onMouseEnter:function onMouseEnter(){return _this9.showMLSField(userId,index);},className:classes.singleMlsIdField},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["o" /* Grid */],{container:true,direction:"row",className:classes.mlsIdFieldGrid},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["o" /* Grid */],{item:true,className:classes.mlsIdFieldWrapper},this.renderMLSFormField(userId,externalId,index)),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["o" /* Grid */],{item:true,className:classes.mlsFieldActionIcon},(shouldRenderActionIcons||apiError)&&//show Save icon to enable resubmit
__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["L" /* Tooltip */],{placement:"top",disableHoverListener:!saveEnabled||apiError,disableFocusListener:!saveEnabled||apiError,title:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["M" /* Typography */],{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_42_classnames___default()(classes.infoTooltipText)},localize('users-table-mls-id-done')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span",{className:classes.tooltipArrow})),classes:{tooltip:classes.infoTooltip}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__theme_icons__["E" /* IconMlsIdDone */],{className:__WEBPACK_IMPORTED_MODULE_42_classnames___default()((_classNames14={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames14,classes.mlsActionIcon,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames14,classes.mlsIconDone,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames14,classes.mlsIconEnabled,saveEnabled),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames14,'mls-icon-hover',saveEnabled),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames14,'mls-icon-done',true),_classNames14)),onClick:function onClick(event){return saveEnabled&&_this9.saveMLSFieldChanges(userId,index);}}))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["o" /* Grid */],{item:true,className:classes.mlsFieldActionIcon},shouldRenderActionIcons&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["L" /* Tooltip */],{placement:"top",disableHoverListener:!addFieldEnabled,disableFocusListener:!addFieldEnabled,title:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["M" /* Typography */],{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_42_classnames___default()(classes.infoTooltipText)},localize('users-table-mls-id-add')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span",{className:classes.tooltipArrow})),classes:{tooltip:classes.infoTooltip}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__theme_icons__["D" /* IconMlsIdAdd */],{className:__WEBPACK_IMPORTED_MODULE_42_classnames___default()((_classNames15={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames15,classes.mlsActionIcon,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames15,classes.mlsIconAdd,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames15,classes.mlsIconEnabled,addFieldEnabled),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames15,'mls-icon-hover',addFieldEnabled),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames15,'mls-icon-add',true),_classNames15)),onClick:function onClick(){return addFieldEnabled&&_this9.addNewMlsFieldRow(userId,index);}})))));}/* selfStart1 - loading data  */},{key:"renderMLSFieldContentLoading",value:function renderMLSFieldContentLoading(userId){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{key:"user-selfstart-loading-".concat(userId),className:classes.loadingSelfStartMlsId},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__theme_icons__["Y" /* SpinnerIcon */],{className:classes.updatingUserIcon}));}/* selfStart1 - mls error loading data  */},{key:"renderMLSFieldContentError",value:function renderMLSFieldContentError(userId){var classes=this.props.classes;var errorMessage=localize('mls-field-error-data-not-loaded');return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["M" /* Typography */],{key:"user-selfstart-error-".concat(userId),className:classes.errorSelfStartMlsId,variant:"body2"},errorMessage);}/* selfStart1 - list of MLS IDs  */},{key:"renderMLSFieldContentClickToEdit",value:function renderMLSFieldContentClickToEdit(userId,selfStartMlsIdsForUser){var _this10=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{key:"user-selfstart-value-".concat(userId),onClick:function onClick(){return _this10.handleManageMlsAgents(userId,selfStartMlsIdsForUser);},className:classes.nonEmptySelfStartMlsId},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["M" /* Typography */],{variant:"body2",dangerouslySetInnerHTML:{__html:selfStartMlsIdsForUser.join('<br />')}}));}/* selfStart1 empty field - empty MLS ID field */},{key:"renderMLSFieldContentClickToEnter",value:function renderMLSFieldContentClickToEnter(userId){var _this11=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{key:"user-no-selfstart-value-".concat(userId),onClick:function onClick(){return _this11.handleManageMlsAgents(userId);},className:classes.emptySelfStartMlsId},localize(userId?'users-table-click-to-enter-agent-mls-id':'user-table-mls-pending-prompt'));}/* selfStart1 no connections setup  */},{key:"renderMLSFieldContentNoConnections",value:function renderMLSFieldContentNoConnections(userId){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{key:"user-no-ml-connections-".concat(userId),className:classes.noConnectionSelfStartMlsId},localize('users-table-mls-no-connections'));}/* custom integration - empty MLS ID field */},{key:"renderMLSFieldContentNoExternalId",value:function renderMLSFieldContentNoExternalId(userId,index){var _this12=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{key:"user-no-external-id-".concat(userId,"-").concat(index),onMouseEnter:function onMouseEnter(){return _this12.showMLSField(userId,index);},className:classes.emptyExternalMlsId},localize(userId?'users-table-enter-agent-mls-id':'user-table-mls-pending-prompt'));}},{key:"renderMLSFieldContentNonEditableValue",value:function renderMLSFieldContentNonEditableValue(userId,externalId,index){var _this13=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{key:"user-non-editable-value-".concat(userId,"-").concat(index),onMouseEnter:function onMouseEnter(){return _this13.showMLSField(userId,index);},className:classes.nonEditableMlsIdValueNode},externalId);}},{key:"renderMLSFieldContentUpdatingState",value:function renderMLSFieldContentUpdatingState(userId,externalId,index){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{key:"user-updating-state-".concat(userId,"-").concat(index),className:classes.updatingMlsIdNode},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["o" /* Grid */],{container:true,direction:"row",className:classes.updatingMlsUserGrid},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["o" /* Grid */],{item:true,className:classes.updatingMlsUserValue},externalId),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["o" /* Grid */],{item:true,className:classes.updatingMlsUserIcon},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__theme_icons__["Y" /* SpinnerIcon */],{className:classes.updatingUserIcon}))));}},{key:"hasFocusedField",value:function hasFocusedField(){var _this14=this;var result;var focusedField=this.state.focusedField;Object.keys(focusedField).map(function(currentUserId){Object.keys(focusedField[currentUserId]).map(function(currentUserIndex){if(__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(_this14.state.focusedField,"[".concat(currentUserId,"][").concat(currentUserIndex,"]"))){result=true;}});});return result;}},{key:"showMLSField",value:function showMLSField(userId,index){var _this15=this;var shownMlsFields=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(this.state.shownMlsFields);Object.keys(shownMlsFields).map(function(currentUserId){Object.keys(shownMlsFields[currentUserId]).map(function(currentUserIndex){if(!__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(_this15.state.focusedField,"[".concat(currentUserId,"][").concat(currentUserIndex,"]"))){delete shownMlsFields[currentUserId][currentUserIndex];}});});if(!shownMlsFields[userId]){shownMlsFields[userId]={};}shownMlsFields[userId][index]=true;this.setState({shownMlsFields:shownMlsFields});}},{key:"saveMLSFieldChanges",value:function saveMLSFieldChanges(userId,index){var _this16=this;var value=this.state.newExternalIds[userId][index];var newExternalIds=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(this.state.newExternalIds);newExternalIds[userId][index]=value;this.setState({newExternalIds:newExternalIds},function(){_this16.updateExternalIdsForUser(userId,index);});}},{key:"addNewMlsFieldRow",value:function addNewMlsFieldRow(userId,index){var _this17=this;this.resetLastFocusedMLSField(false,true);var newExternalIds=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(this.state.newExternalIds);var nextRowIndex=newExternalIds[userId].length;this.inputRefs["input-mls-".concat(userId,"-").concat(nextRowIndex)]=__WEBPACK_IMPORTED_MODULE_10_react___default.a.createRef();newExternalIds[userId].push('');var shownMlsFields=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(this.state.shownMlsFields);if(!shownMlsFields[userId]){shownMlsFields[userId]={};}shownMlsFields[userId][nextRowIndex]=true;// update focused field
var focusedField={};focusedField[userId]={};focusedField[userId][index]=true;this.setState({newExternalIds:newExternalIds,shownMlsFields:shownMlsFields,focusedField:focusedField},function(){Object(__WEBPACK_IMPORTED_MODULE_45__utils_forms__["a" /* focusSelect */])(_this17.inputRefs["input-mls-".concat(userId,"-").concat(nextRowIndex)].current);});}},{key:"onMLSFieldChange",value:function onMLSFieldChange(event,userId,index){this.validateMlsId(event.target.value,userId,index);var newExternalIds=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(this.state.newExternalIds);newExternalIds[userId][index]=event.target.value;this.setState({newExternalIds:newExternalIds});// Clear API error mesassage when he edits field after ERROR.DUPLICATE_MLS_IDS error
var apiError=this.props.companies.updatingExternalIdErrorId.find(function(user){return user.userId===userId;});if(__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(apiError,'errorId')===__WEBPACK_IMPORTED_MODULE_15_errors_errorids__["a" /* default */].DUPLICATE_MLS_IDS){this.props.clearExternalIdState();}}},{key:"cleanMlsIdValue",value:function cleanMlsIdValue(val){return val.toString().trim();}},{key:"isMlsIdAlreadyUsed",value:function isMlsIdAlreadyUsed(id){var result=false;if(id==='')return result;var newExternalIds=this.state.newExternalIds;Object.keys(newExternalIds).forEach(function(currentUserId){if(__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.isArray(newExternalIds[currentUserId])&&newExternalIds[currentUserId].includes(id)){result=true;}});return result;}},{key:"validateMlsId",value:function validateMlsId(value,userId,index){var val=value.toString();var isIdAlreadyUsed=this.isMlsIdAlreadyUsed(val);if(val===''||this.cleanMlsIdValue(val)===val&&!isIdAlreadyUsed){var mlsFieldsWithErrors=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(this.state.mlsFieldsWithErrors);if(__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(this.state.mlsFieldsWithErrors,"[".concat(userId,"][").concat(index,"]"))){delete mlsFieldsWithErrors[userId][index];}this.setState({mlsFieldsWithErrors:mlsFieldsWithErrors});return true;}else{var _mlsFieldsWithErrors=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(this.state.mlsFieldsWithErrors);if(!_mlsFieldsWithErrors[userId]){_mlsFieldsWithErrors[userId]={};}_mlsFieldsWithErrors[userId][index]=isIdAlreadyUsed?invalidMLSInputValue['already-used']:invalidMLSInputValue['invalid-value'];this.setState({mlsFieldsWithErrors:_mlsFieldsWithErrors});return false;}}},{key:"isMLSSaveEnabled",value:function isMLSSaveEnabled(userId,index){var users=this.state.users;var originalUser=users.find(function(user){return user.userId===userId;});var originalExteralIds=originalUser.externalIds;var externalId=this.state.newExternalIds[userId][index];var fieldHasError=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(this.state.mlsFieldsWithErrors,"[".concat(userId,"][").concat(index,"]"));if(fieldHasError){return false;}if(this.cleanMlsIdValue(externalId).length===0){return!__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.isEmpty(originalExteralIds);}return __WEBPACK_IMPORTED_MODULE_24_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(originalExteralIds,"[".concat(index,"]")))||originalExteralIds[index]!==externalId;}},{key:"isMLSAddFieldEnabled",value:function isMLSAddFieldEnabled(userId,index){var users=this.state.users;var originalUser=users.find(function(user){return user.userId===userId;});var originalExteralIds=originalUser.externalIds;var externalId=this.state.newExternalIds[userId][index];if(this.cleanMlsIdValue(externalId).length===0&&__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(originalExteralIds,"[".concat(index,"]")))){// default empty field
return false;}else if(this.cleanMlsIdValue(externalId).length>0&&__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(originalExteralIds,"[".concat(index,"]")))){// new empty field which was not saved
return false;}return true;}},{key:"onMLSFieldKeyPress",value:function onMLSFieldKeyPress(event,userId,index){var _this18=this;if(event.key==='Enter'){if(!this.isMLSSaveEnabled(userId,index))return;var value=this.state.newExternalIds[userId][index];var newExternalIds=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(this.state.newExternalIds);newExternalIds[userId][index]=value;this.setState({newExternalIds:newExternalIds},function(){_this18.updateExternalIdsForUser(userId,index);});}}},{key:"resetPreviousAPIMessageFieldValue",value:function resetPreviousAPIMessageFieldValue(exceptUserId,exceptIndex){var _this19=this;if(this.props.companies.updatingExternalIdErrorId.length){// clear any previous error message from API field
var users=this.getCompanyUsers();var newExternalIds=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(this.state.newExternalIds);var shownMlsFields=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(this.state.shownMlsFields);var fousedFieldHasChanged=false;Object.keys(newExternalIds).map(function(currentUserId){var apiError=_this19.props.companies.updatingExternalIdErrorId.find(function(user){return user.userId===currentUserId;});if(apiError){var user=users.find(function(u){return u.userId===currentUserId;});Object.keys(newExternalIds[currentUserId]).map(function(currentUserIndex){var originalExternalIdsValue=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(user,"externalIds[".concat(currentUserIndex,"]"))||'';if(!exceptUserId&&!exceptIndex||exceptUserId!==currentUserId||exceptUserId===currentUserId&&parseInt(currentUserIndex)!==parseInt(exceptIndex)){newExternalIds[currentUserId][currentUserIndex]=originalExternalIdsValue;}// don't clear error message if field with error is focused
if(exceptUserId&&exceptUserId===currentUserId&&parseInt(currentUserIndex)===parseInt(exceptIndex)){if(!__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.isEqual(originalExternalIdsValue,newExternalIds[currentUserId][currentUserIndex])){fousedFieldHasChanged=true;}}if(!exceptUserId&&!exceptIndex||exceptUserId!==currentUserId||exceptUserId===currentUserId&&parseInt(currentUserIndex)!==parseInt(exceptIndex)){if(!__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(_this19.state.focusedField,"[".concat(currentUserId,"][").concat(currentUserIndex,"]"))){// ignore focusedField here as it will be updated
// in hideAllMlsFields() > resetLastFocusedMLSField() chain
var currentUserTotalIds=Object.keys(newExternalIds[currentUserId]).length;if(currentUserIndex>0&&currentUserIndex==currentUserTotalIds-1&&__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.isEmpty(originalExternalIdsValue)){// remove last empty when added with Add new button
delete shownMlsFields[currentUserId][currentUserIndex];newExternalIds[currentUserId].pop();}}}});}});this.setState({newExternalIds:newExternalIds,shownMlsFields:shownMlsFields});if(!exceptUserId||!fousedFieldHasChanged){this.props.clearExternalIdState();}}}},{key:"onMLSFieldFocus",value:function onMLSFieldFocus(userId,index){if(__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(this.state.focusedField,"[".concat(userId,"][").concat(index,"]")))return;if(!__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.isEmpty(this.state.focusedField)){this.resetLastFocusedMLSField(true,true);}else{this.resetPreviousAPIMessageFieldValue(userId,index);}var focusedField={};focusedField[userId]={};focusedField[userId][index]=true;this.setState({focusedField:focusedField});}},{key:"onMLSFieldBlur",value:function onMLSFieldBlur(event){if(event.key==='Tab'){this.hideAllMlsFields(true);}}},{key:"hideAllMlsFields",value:function hideAllMlsFields(reset){var _this20=this;var shownMlsFields=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(this.state.shownMlsFields);Object.keys(shownMlsFields).map(function(currentUserId){Object.keys(shownMlsFields[currentUserId]).map(function(currentUserIndex){if(!__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(_this20.state.focusedField,"[".concat(currentUserId,"][").concat(currentUserIndex,"]"))){delete shownMlsFields[currentUserId][currentUserIndex];}});});this.setState({shownMlsFields:shownMlsFields});reset&&this.resetLastFocusedMLSField(true,true);}},{key:"resetLastFocusedMLSField",value:function resetLastFocusedMLSField(resetPreviousAPIMessageField,clearExternalIdState){var _this21=this;resetPreviousAPIMessageField&&this.resetPreviousAPIMessageFieldValue();var focusedField=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(this.state.focusedField);var users=this.getCompanyUsers();Object.keys(focusedField).map(function(currentUserId){Object.keys(focusedField[currentUserId]).map(function(currentUserIndex){if(__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(_this21.state.focusedField,"[".concat(currentUserId,"][").concat(currentUserIndex,"]"))){delete focusedField[currentUserId][currentUserIndex];var shownMlsFields=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(_this21.state.shownMlsFields);if(__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(_this21.state.shownMlsFields,"[".concat(currentUserId,"][").concat(currentUserIndex,"]"))){delete shownMlsFields[currentUserId][currentUserIndex];}var mlsFieldsWithErrors=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(_this21.state.mlsFieldsWithErrors);var user=users.find(function(u){return u.userId===currentUserId;});var originalExternalIdsValue=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(user,"externalIds[".concat(currentUserIndex,"]"))||'';var newExternalIds=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(_this21.state.newExternalIds);var currentUserTotalIds=Object.keys(newExternalIds[currentUserId]).length;if(currentUserIndex>0&&currentUserIndex==currentUserTotalIds-1&&__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.isEmpty(originalExternalIdsValue)){// remove last empty when added with Add new button
newExternalIds[currentUserId].pop();delete shownMlsFields[currentUserId][currentUserIndex];}else{newExternalIds[currentUserId][currentUserIndex]=originalExternalIdsValue;}if(__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(_this21.state.mlsFieldsWithErrors,"[".concat(currentUserId,"][").concat(currentUserIndex,"]"))){delete mlsFieldsWithErrors[currentUserId][currentUserIndex];}_this21.setState({newExternalIds:newExternalIds,focusedField:focusedField,shownMlsFields:shownMlsFields,mlsFieldsWithErrors:mlsFieldsWithErrors});}});});clearExternalIdState&&this.props.clearExternalIdState();}},{key:"updateExternalIdsForUser",value:function updateExternalIdsForUser(userId,index){var _this22=this;var users=this.state.users;var updateUser=users.find(function(user){return user.userId===userId;});var originalExteralIds=updateUser.externalIds;var newExternalIds=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(this.state.newExternalIds);// Delete empty MLS fields
if(__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.isArray(updateUser.externalIds)&&__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.isArray(this.state.newExternalIds[userId])&&this.state.newExternalIds[userId].length>updateUser.externalIds.length){var delIdIndex=[];var nonEmptyValues=[];this.state.newExternalIds[userId].forEach(function(id,index){if(_this22.cleanMlsIdValue(id).length===0){delIdIndex.push(index);}else{nonEmptyValues.push(id);}});newExternalIds[userId]=nonEmptyValues.length?nonEmptyValues:[''];this.setState({newExternalIds:newExternalIds});if(delIdIndex.length){var shownMlsFields=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(this.state.shownMlsFields);var mlsFieldsWithErrors=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(this.state.mlsFieldsWithErrors);var focusedField=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(this.state.focusedField);delIdIndex.forEach(function(indexToDelete){if(__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(_this22.state.shownMlsFields,"[".concat(userId,"][").concat(indexToDelete,"]"))){delete shownMlsFields[userId][indexToDelete];}if(__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(_this22.state.focusedField,"[".concat(userId,"][").concat(indexToDelete,"]"))){delete focusedField[userId][indexToDelete];}if(__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(_this22.state.mlsFieldsWithErrors,"[".concat(userId,"][").concat(indexToDelete,"]"))){delete mlsFieldsWithErrors[userId][indexToDelete];}});this.setState({shownMlsFields:shownMlsFields,mlsFieldsWithErrors:mlsFieldsWithErrors,focusedField:focusedField});}}// Send PATCH request if externalIds value changed
if(!__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.isEqual(originalExteralIds,newExternalIds[userId])){var updatingMlsIdForUsers=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(this.state.updatingMlsIdForUsers);if(!updatingMlsIdForUsers[userId]){updatingMlsIdForUsers[userId]={};}updatingMlsIdForUsers[userId][index]=true;this.setState({updatingMlsIdForUsers:updatingMlsIdForUsers,focusedField:{}});this.props.updateUserExternalId(this.props.selectedCompanyId,userId,__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.without(newExternalIds[userId],'',null,undefined));}}},{key:"getCompanyUsers",value:function getCompanyUsers(){var _this$props$companies=this.props.companies,rawDataById=_this$props$companies.rawDataById,selectedId=_this$props$companies.selectedId;var company=rawDataById[selectedId];var users=company.users;return users;}},{key:"getUserIdForEmail",value:function getUserIdForEmail(email){var users=this.getCompanyUsers();var user=users.find(function(u){return u.email===email;});var userId=user.userId;return userId;}},{key:"clearExternalIdsStateAfterRoleChange",value:function clearExternalIdsStateAfterRoleChange(){this.props.clearExternalIdState();}},{key:"clearExternalIdsForUser",value:function clearExternalIdsForUser(userId){var users=this.getCompanyUsers();var user=users.find(function(u){return u.userId===userId;});if(userId&&!__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.isEmpty(user.externalIds)){var updatingMlsIdForUsers=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(this.state.updatingMlsIdForUsers);if(__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(this.state.updatingMlsIdForUsers,"[".concat(userId,"]"))){delete updatingMlsIdForUsers[userId];}var shownMlsFields=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(this.state.shownMlsFields);if(__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(this.state.shownMlsFields,"[".concat(userId,"]"))){delete shownMlsFields[userId];}var focusedField=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(this.state.focusedField);if(__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(this.state.focusedField,"[".concat(userId,"]"))){delete focusedField[userId];}var mlsFieldsWithErrors=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.clone(this.state.mlsFieldsWithErrors);if(__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(this.state.mlsFieldsWithErrors,"[".concat(userId,"]"))){delete mlsFieldsWithErrors[userId];}this.setState({shownMlsFields:shownMlsFields,focusedField:focusedField,updatingMlsIdForUsers:updatingMlsIdForUsers,mlsFieldsWithErrors:mlsFieldsWithErrors});}}},{key:"isBulkAddedUser",value:function isBulkAddedUser(user){return user.userId&&user.inviteCounter===0&&user.email!==this.state.company.email;}},{key:"renderLastSeenCell",value:function renderLastSeenCell(lastSessionTime){var classes=this.props.classes;var _getLastSeenData=getLastSeenData(lastSessionTime),label=_getLastSeenData.label,tooltip=_getLastSeenData.tooltip;var labelNode=__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span",null,label);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["H" /* TableCell */],{padding:"dense",className:__WEBPACK_IMPORTED_MODULE_42_classnames___default()(classes.tableCellBody,classes.tableLastSeenCell)},tooltip?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["L" /* Tooltip */],{placement:"top",title:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["M" /* Typography */],{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_42_classnames___default()(classes.infoTooltipText)},tooltip),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span",{className:classes.tooltipArrow})),classes:{tooltip:classes.infoTooltip}},labelNode):labelNode);}},{key:"renderUserRows",value:function renderUserRows(renderRoles,usersToRender,showMlsIdColumn,showUserPhoto,externalIds,showLastSeenColumn){var _this23=this;var classes=this.props.classes;var currentUserEmail=this.props.currentUserEmail;return usersToRender.map(function(user,index){var _classNames16;var _encodeUser=Object(__WEBPACK_IMPORTED_MODULE_46__utils_users__["d" /* encodeUser */])(user),name=_encodeUser.name,email=_encodeUser.email,role=_encodeUser.role,userId=_encodeUser.userId,profilePhotoUri=_encodeUser.profilePhotoUri;var key="user-row-".concat(index);var refId=userId;// make refId equal user id as we need a unique identifier of the table row
_this23.photoPickerRefs[refId]=__WEBPACK_IMPORTED_MODULE_10_react___default.a.createRef();!userId&&(name=localize('user-table-username-pending-prompt'));var _convertPlanIdIntoSub=Object(__WEBPACK_IMPORTED_MODULE_50__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(_this23.props.currentPlanId),plan=_convertPlanIdIntoSub.plan;var companyCreator=email===_this23.state.company.email;var showNoInvitationSign=userId&&user.role!==__WEBPACK_IMPORTED_MODULE_43__config__["_56" /* USER_ROLE_GUEST */]&&!companyCreator&&currentUserEmail!==email&&!user.lastSessionTime&&!user.inviteCounter;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__material_ui_core_Fade___default.a,{"in":true,key:key},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["J" /* TableRow */],{hover:true,className:__WEBPACK_IMPORTED_MODULE_42_classnames___default()((_classNames16={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames16,classes.tableBodyRow,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames16,'transtionsEnabled',_this23.state.willChangeRole),_classNames16))},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["H" /* TableCell */],{padding:"dense",className:classes.tableCellBody},currentUserEmail===email?localize('users-table-name-you',name):name),!userId&&showUserPhoto&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["H" /* TableCell */],{padding:"dense",className:"".concat(classes.tableCellBody," ").concat(classes.photoCell)},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["L" /* Tooltip */],{placement:"top",title:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["M" /* Typography */],{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_42_classnames___default()(classes.infoTooltipText)},localize('user-table-photo-pending-prompt')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span",{className:classes.tooltipArrow})),classes:{tooltip:classes.infoTooltip}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_icons_defaultAvatar__["a" /* default */],{className:classes.avatarPlaceholder}))),userId&&showUserPhoto&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["H" /* TableCell */],{padding:"dense",className:classes.tableCellBody},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_SmartFieldPhotoPicker_SmartFieldPhotoPicker__["a" /* default */],{defaultPhoto:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_icons_defaultAvatar__["a" /* default */],{className:classes.defaultAvatar}),photoUrlOrFile:profilePhotoUri||'',onSelectPhoto:function onSelectPhoto(){return _this23.handleOpenPhotoPicker(refId);},onCropPhoto:function onCropPhoto(){return profilePhotoUri&&_this23.handleOpenPhotoCropper(refId,profilePhotoUri);},onRemovePhoto:function onRemovePhoto(){return _this23.handleRemovePhoto(userId);},showProgress:_this23.state.loadingPhotoUserId===userId}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("input",{style:{display:'none'},ref:_this23.photoPickerRefs[refId],type:"file",accept:".png,.jpg,.jpeg",multiple:true,onChange:function onChange(e){return _this23.onPhotoAdd(e,{name:name,email:email,role:role,userId:userId,profilePhotoUri:profilePhotoUri});}})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["H" /* TableCell */],{padding:"dense",className:classes.tableCellBody},showNoInvitationSign?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.pendingSign},localize('user-type-no-invitation')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,email)):email),showMlsIdColumn&&_this23.renderMLSCell(userId,externalIds[userId]),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["H" /* TableCell */],{padding:"none",className:classes.tableCellBody},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_Features_components__["b" /* Select */],{id:"select-current-user-role-".concat(index),"data-tid":"select-current-user-role-".concat(index),name:"editUser-".concat(email),onChange:function onChange(event){return _this23.handleUserEdit(event.target.value,email,userId);},onClick:function onClick(){showMlsIdColumn&&_this23.hideAllMlsFields(true);},className:classes.roleSelect,disableUnderline:true,fullWidth:true,IconComponent:__WEBPACK_IMPORTED_MODULE_32__material_ui_icons_KeyboardArrowDown___default.a,MenuProps:{classes:{paper:classes.roleSelectItems}},value:role,disabled:currentUserEmail===email||plan===__WEBPACK_IMPORTED_MODULE_43__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT},__WEBPACK_IMPORTED_MODULE_46__utils_users__["a" /* PERMISSION_ROLE */].map(function(option){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["x" /* MenuItem */],{key:option.key,value:option.value},option.value);}))),showLastSeenColumn&&_this23.renderLastSeenCell(user.lastSessionTime),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["H" /* TableCell */],{align:"right",padding:"none"},user.role===__WEBPACK_IMPORTED_MODULE_43__config__["_56" /* USER_ROLE_GUEST */]?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["p" /* IconButton */],{color:"secondary","data-tid":"button-user-delete-".concat(index),component:"span",name:"deleteUser-".concat(email),disabled:currentUserEmail===email,className:classes.iconDelete,onClick:function onClick(){return _this23.onRemoveMember(_this23.handleUserDelete,{email:email,user:Object(__WEBPACK_IMPORTED_MODULE_46__utils_users__["d" /* encodeUser */])(user)});},"aria-label":"Delete"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37_theme_icons__["k" /* DeleteIcon */],null)):__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["p" /* IconButton */],{color:"primary","data-tid":"button-user-more-".concat(index),component:"span",disabled:currentUserEmail===email,className:classes.iconMore,onClick:function onClick(event){return _this23.handleMenuOpen(event,user);},"aria-label":"More"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_icons_more__["a" /* default */],null)))));},this);}/**
	 * Render the inactive company message
	 */},{key:"renderInactiveCompanyInformation",value:function renderInactiveCompanyInformation(classes){var _this24=this;var _this$state$company=this.state.company,hasActiveSubscription=_this$state$company.hasActiveSubscription,hasTrial=_this$state$company.hasTrial;var _getSubscriptionsAndA=Object(__WEBPACK_IMPORTED_MODULE_50__utils_subscription__["i" /* getSubscriptionsAndAddons */])(this.props.company),perpetualAddons=_getSubscriptionsAndA.perpetualAddons;var _getSubscriptionsAndA2=Object(__WEBPACK_IMPORTED_MODULE_50__utils_subscription__["i" /* getSubscriptionsAndAddons */])(this.props.company,true),cancelledSubscription=_getSubscriptionsAndA2.subscription;var hasCancelledSubscriptionForNewPlan=false;if(cancelledSubscription){var _convertPlanIdIntoSub2=Object(__WEBPACK_IMPORTED_MODULE_50__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(cancelledSubscription.planId),plan=_convertPlanIdIntoSub2.plan;if(Object.values(__WEBPACK_IMPORTED_MODULE_43__config__["_42" /* SUBSCRIPTION_PLAN */]).includes(plan)){hasCancelledSubscriptionForNewPlan=true;}}var renderInactiveCompanyErrorMessage=function renderInactiveCompanyErrorMessage(){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,localize('users-inactive-company-information-1'),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["r" /* Link */],{component:"button",className:classes.errorInactiveCompanyLink,onClick:function onClick(){_this24.setState({redirectUrl:Object(__WEBPACK_IMPORTED_MODULE_51_routes__["w" /* getRoute */])(__WEBPACK_IMPORTED_MODULE_51_routes__["n" /* SUBSCRIPTION */],_this24.state.selectedId),preselectSubscriptionView:__WEBPACK_IMPORTED_MODULE_43__config__["_45" /* SUBSCRIPTION_VIEW */].PURCHASE_OPTIONS});}},localize('users-inactive-company-information-2')),hasCancelledSubscriptionForNewPlan&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,localize('users-inactive-company-information-3'),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["r" /* Link */],{component:"button",className:classes.errorInactiveCompanyLink,onClick:function onClick(){_this24.setState({redirectUrl:Object(__WEBPACK_IMPORTED_MODULE_51_routes__["w" /* getRoute */])(__WEBPACK_IMPORTED_MODULE_51_routes__["n" /* SUBSCRIPTION */],_this24.state.selectedId),preselectSubscriptionView:__WEBPACK_IMPORTED_MODULE_43__config__["_45" /* SUBSCRIPTION_VIEW */].CURRENT_PRODUCTS,preselectOpenCBDetails:true});}},localize('users-inactive-company-information-4'))),localize('users-inactive-company-information-5'));};return hasActiveSubscription||hasTrial||!__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.isEmpty(perpetualAddons)?null:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core__["M" /* Typography */],{className:classes.errorInactiveCompany,"data-tid":"company-error-messages"},renderInactiveCompanyErrorMessage());}/**
	 * Triggers when number of company's memeber is reduced
	 * @param {*} callback Method, which should be executed on confirm
	 * @param {object} params { parameter: value} list
	 * @memberof Users
	 */},{key:"onRemoveMember",value:function onRemoveMember(callback,params){this.props.showModal('CONFIRMATION_MODAL',{message:localize('users-remove-member-confirmation',params.email),buttons:[__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_Features_components__["a" /* Button */],{key:"button-cancel",variant:"outlined",color:"primary"},localize('no')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_Features_components__["a" /* Button */],{key:"button-confirm",variant:"contained",color:"primary",onClick:function onClick(){return callback(params);}},localize('yes'))]});}},{key:"changeUserRole",value:function changeUserRole(params){var _this25=this;var email=params.email,updatedUser=params.updatedUser;var userId=updatedUser.userId;var previousUser=this.state.users.find(function(user){return user.email===email;});var users=this.state.users.map(function(user){return user.email===email?updatedUser:user;});var paidUsersNumber=this.state.users.filter(function(user){return user.role!==__WEBPACK_IMPORTED_MODULE_43__config__["_56" /* USER_ROLE_GUEST */];}).length;if(this.state.hasActiveSubscription){this.props.estimateCostOnUpdateCompanyUser(users,updatedUser).then(function(data){if(data instanceof __WEBPACK_IMPORTED_MODULE_52__errors_apperror__["a" /* default */]){log.send(data);if(data.errorId===__WEBPACK_IMPORTED_MODULE_15_errors_errorids__["a" /* default */].API_REQUEST_LIMIT_EXCEEDED){_this25.props.showRateLimitError();}return;}var _data$result=data.result,amount=_data$result.amount,currency=_data$result.currency,taxRate=_data$result.taxRate;if(amount){var _ref=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_43__config__["x" /* CURRENCIES */],{key:currency.toLowerCase()})||{},_ref$symbol=_ref.symbol,symbol=_ref$symbol===void 0?'':_ref$symbol;var message="".concat(localize('users-increase-confirm',[paidUsersNumber,paidUsersNumber+1,symbol,amount/100]));if(taxRate!==null){message+=" (".concat(localize('subscription-including-vat'),")");}_this25.showConfirmationPopup(message).then(function(){_this25.props.updateCompanyUser(users,updatedUser).then(function(data){if(data instanceof __WEBPACK_IMPORTED_MODULE_52__errors_apperror__["a" /* default */]){log.send(data);if(data.errorId===__WEBPACK_IMPORTED_MODULE_15_errors_errorids__["a" /* default */].API_REQUEST_LIMIT_EXCEEDED){_this25.props.showRateLimitError();}}else{Object(__WEBPACK_IMPORTED_MODULE_47_lib_Segment_customTrackers__["T" /* trackUserEdit */])(Object(__WEBPACK_IMPORTED_MODULE_46__utils_users__["d" /* encodeUser */])(previousUser),Object(__WEBPACK_IMPORTED_MODULE_46__utils_users__["d" /* encodeUser */])(updatedUser),Object(__WEBPACK_IMPORTED_MODULE_48_lib_Segment_helpers__["a" /* getTrackingOptions */])(_this25.props.company));if(params.removeExternalIds){_this25.clearExternalIdsForUser(userId);}else if(params.clearExternalIdsState){_this25.clearExternalIdsStateAfterRoleChange(userId);}}});})["catch"](function(){// silent catch
});}else{_this25.props.updateCompanyUser(users,updatedUser).then(function(data){if(data instanceof __WEBPACK_IMPORTED_MODULE_52__errors_apperror__["a" /* default */]){log.send(data);if(data.errorId===__WEBPACK_IMPORTED_MODULE_15_errors_errorids__["a" /* default */].API_REQUEST_LIMIT_EXCEEDED){_this25.props.showRateLimitError();}}else{Object(__WEBPACK_IMPORTED_MODULE_47_lib_Segment_customTrackers__["T" /* trackUserEdit */])(Object(__WEBPACK_IMPORTED_MODULE_46__utils_users__["d" /* encodeUser */])(previousUser),Object(__WEBPACK_IMPORTED_MODULE_46__utils_users__["d" /* encodeUser */])(updatedUser),Object(__WEBPACK_IMPORTED_MODULE_48_lib_Segment_helpers__["a" /* getTrackingOptions */])(_this25.props.company));if(params.removeExternalIds){_this25.clearExternalIdsForUser(userId);}else if(params.clearExternalIdsState){_this25.clearExternalIdsStateAfterRoleChange(userId);}}});}});}else{this.props.updateCompanyUser(users,updatedUser).then(function(data){if(data instanceof __WEBPACK_IMPORTED_MODULE_52__errors_apperror__["a" /* default */]){log.send(data);if(data.errorId===__WEBPACK_IMPORTED_MODULE_15_errors_errorids__["a" /* default */].API_REQUEST_LIMIT_EXCEEDED){_this25.props.showRateLimitError();}}else{Object(__WEBPACK_IMPORTED_MODULE_47_lib_Segment_customTrackers__["T" /* trackUserEdit */])(Object(__WEBPACK_IMPORTED_MODULE_46__utils_users__["d" /* encodeUser */])(previousUser),Object(__WEBPACK_IMPORTED_MODULE_46__utils_users__["d" /* encodeUser */])(updatedUser),Object(__WEBPACK_IMPORTED_MODULE_48_lib_Segment_helpers__["a" /* getTrackingOptions */])(_this25.props.company));if(params.removeExternalIds){_this25.clearExternalIdsForUser(userId);}else if(params.clearExternalIdsState){_this25.clearExternalIdsStateAfterRoleChange(userId);}}});}}},{key:"handleUserEdit",value:function handleUserEdit(role,email,userId){var updatedUser=Object(__WEBPACK_IMPORTED_MODULE_46__utils_users__["b" /* decodeUser */])({email:email,role:role,userId:userId});var users=this.getCompanyUsers();var oldUserData=users.find(function(u){return u.email===email;});var oldRole=oldUserData.role;if(updatedUser.role===__WEBPACK_IMPORTED_MODULE_43__config__["_56" /* USER_ROLE_GUEST */]){this.onRemoveMember(this.changeUserRole,{email:email,updatedUser:updatedUser,removeExternalIds:true});}else{this.setState({willChangeRole:true});this.changeUserRole({email:email,updatedUser:updatedUser,clearExternalIdsState:oldRole===__WEBPACK_IMPORTED_MODULE_43__config__["_56" /* USER_ROLE_GUEST */]&&updatedUser.role!==__WEBPACK_IMPORTED_MODULE_43__config__["_56" /* USER_ROLE_GUEST */]});}}},{key:"updateCompanyUser",value:function updateCompanyUser(users,updatedUser,previousUser){var _this26=this;this.props.updateCompanyUser(users,updatedUser).then(function(data){if(data instanceof __WEBPACK_IMPORTED_MODULE_52__errors_apperror__["a" /* default */]){log.send(data);if(data.errorId===__WEBPACK_IMPORTED_MODULE_15_errors_errorids__["a" /* default */].API_REQUEST_LIMIT_EXCEEDED){_this26.props.showRateLimitError();}}});}},{key:"handleUserDelete",value:function handleUserDelete(params){var _this27=this;var user=params.user;Object(__WEBPACK_IMPORTED_MODULE_47_lib_Segment_customTrackers__["S" /* trackUserDelete */])(user,Object(__WEBPACK_IMPORTED_MODULE_48_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));if(user){this.props.deleteCompanyUser(user.email).then(function(data){if(data instanceof __WEBPACK_IMPORTED_MODULE_52__errors_apperror__["a" /* default */]){log.send(data);if(data.errorId===__WEBPACK_IMPORTED_MODULE_15_errors_errorids__["a" /* default */].API_REQUEST_LIMIT_EXCEEDED){_this27.props.showRateLimitError();}}});}}},{key:"handleAddUsers",value:function handleAddUsers(newUsers,companyInviteMessage){var _this28=this;var totalAvailableSeatsNumber=0;var newTotalSeatsNumber=0;var nonGuestUsers=Object(__WEBPACK_IMPORTED_MODULE_46__utils_users__["e" /* filterNonGuestUsers */])(this.props.company.users);var hasPlan=this.props.currentPlanId!==undefined;var additionalUsersNumber=newUsers.filter(function(user){return user.role!==__WEBPACK_IMPORTED_MODULE_43__config__["_56" /* USER_ROLE_GUEST */];}).length;if(hasPlan){var _convertPlanIdIntoSub3=Object(__WEBPACK_IMPORTED_MODULE_50__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(this.props.currentPlanId),plan=_convertPlanIdIntoSub3.plan;totalAvailableSeatsNumber=__WEBPACK_IMPORTED_MODULE_43__config__["_3" /* PACKAGES_CONFIG */][plan].freeSeatsIncluded+Object(__WEBPACK_IMPORTED_MODULE_50__utils_subscription__["e" /* getMembersPaidQuantity */])(this.props.company);var areAllSeatsUsed=nonGuestUsers.length>=totalAvailableSeatsNumber;newTotalSeatsNumber=areAllSeatsUsed?totalAvailableSeatsNumber+additionalUsersNumber:nonGuestUsers.length+additionalUsersNumber;}if(this.state.hasActiveSubscription){this.props.estimateCostOnAddCompanyUsers(newUsers).then(function(data){if(data instanceof __WEBPACK_IMPORTED_MODULE_52__errors_apperror__["a" /* default */]){// API_REQUEST_LIMIT_EXCEEDED error is shown inline, we don't have to trigger popup here
return;}var _data$result2=data.result,amount=_data$result2.amount,currency=_data$result2.currency,taxRate=_data$result2.taxRate;if(amount){var _ref2=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_43__config__["x" /* CURRENCIES */],{key:currency.toLowerCase()})||{},_ref2$symbol=_ref2.symbol,symbol=_ref2$symbol===void 0?'':_ref2$symbol;var message="".concat(localize('users-increase-confirm',[totalAvailableSeatsNumber,newTotalSeatsNumber,symbol,amount/100]));if(taxRate!==null){message+=" (".concat(localize('subscription-including-vat'),")");}_this28.showConfirmationPopup(message).then(function(){return _this28.addCompanyUsersAndTrack(newUsers,newTotalSeatsNumber,companyInviteMessage);})["catch"](function(){// silent catch - no error logged
// back to invitation popup
_this28.handleShowAddUserModal();});}else{_this28.addCompanyUsersAndTrack(newUsers,newTotalSeatsNumber,companyInviteMessage);}});}else{this.addCompanyUsersAndTrack(newUsers,newTotalSeatsNumber,companyInviteMessage);}}},{key:"handleSendInvitations",value:function handleSendInvitations(){var _this29=this;var users=this.state.users;var usersToInvite=users.filter(function(user){return[__WEBPACK_IMPORTED_MODULE_43__config__["_54" /* USER_ROLE_ADMIN */],__WEBPACK_IMPORTED_MODULE_43__config__["_55" /* USER_ROLE_BASIC */]].includes(user.role)&&!user.lastSessionTime&&user.email!==_this29.state.company.email&&user.email!==_this29.props.currentUserEmail;});// send emails to every user who hasn’t signed in
var hasPlan=this.props.currentPlanId!==undefined;var totalAvailableSeatsNumber=0;var newTotalSeatsNumber=0;var nonGuestUsers=Object(__WEBPACK_IMPORTED_MODULE_46__utils_users__["e" /* filterNonGuestUsers */])(this.props.company.users);var additionalUsersNumber=usersToInvite.length;if(hasPlan){var _convertPlanIdIntoSub4=Object(__WEBPACK_IMPORTED_MODULE_50__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(this.props.currentPlanId),plan=_convertPlanIdIntoSub4.plan;totalAvailableSeatsNumber=__WEBPACK_IMPORTED_MODULE_43__config__["_3" /* PACKAGES_CONFIG */][plan].freeSeatsIncluded+Object(__WEBPACK_IMPORTED_MODULE_50__utils_subscription__["e" /* getMembersPaidQuantity */])(this.props.company);var areAllSeatsUsed=nonGuestUsers.length>=totalAvailableSeatsNumber;newTotalSeatsNumber=areAllSeatsUsed?totalAvailableSeatsNumber+additionalUsersNumber:nonGuestUsers.length+additionalUsersNumber;}this.props.sendInviteToUsers(usersToInvite,null,hasPlan,newTotalSeatsNumber);}},{key:"handleManageMlsAgents",value:function handleManageMlsAgents(userId){var selfStartMlsIdsForUser=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var connections=this.props.mls.connections;this.props.showModal('MANAGE_MLS_AGENTS_MODAL',{connections:connections,preselectUserId:userId,usersPage:true,selfStartMlsIdsForUser:selfStartMlsIdsForUser,onClose:this.onManageMlsAgentsCloseHandler});}},{key:"onManageMlsAgentsCloseHandler",value:function onManageMlsAgentsCloseHandler(){this.props.clearConnectMlsState();this.props.hideModal();}},{key:"handleShowAddUserModal",value:function handleShowAddUserModal(email,showApiError){var errorId=this.props.companies.addCompanyUsersErrorId;var isUserLimitReachedError=showApiError&&errorId===__WEBPACK_IMPORTED_MODULE_15_errors_errorids__["a" /* default */].USER_REACHED_THE_COMPANY_INVITATION_LIMIT;if(isUserLimitReachedError){this.props.hideModal();this.props.showErrorPopup(__WEBPACK_IMPORTED_MODULE_15_errors_errorids__["a" /* default */].USER_REACHED_THE_COMPANY_INVITATION_LIMIT);}else{var _convertPlanIdIntoSub5=Object(__WEBPACK_IMPORTED_MODULE_50__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(this.props.currentPlanId),plan=_convertPlanIdIntoSub5.plan;var allowedRoles;var upgradeInfoMessage;if(plan===__WEBPACK_IMPORTED_MODULE_43__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT){allowedRoles=[__WEBPACK_IMPORTED_MODULE_43__config__["_56" /* USER_ROLE_GUEST */]];upgradeInfoMessage=localize('re-upgrade-to-brokerage-to-add-more-users');}this.props.showModal('INVITE_USERS_MODAL',{email:email,handleAddUsers:this.handleAddUsers,showApiError:showApiError,allowedRoles:allowedRoles,upgradeInfoMessage:upgradeInfoMessage});}}},{key:"addCompanyUsersAndTrack",value:function addCompanyUsersAndTrack(users,newTotalSeatsNumber,companyInviteMessage){var _this30=this;var userDataFiltered=users.map(function(user){return{email:user.email,role:user.role};});var hasPlan=this.props.currentPlanId!==undefined;var targetUsersPayingQuantity;if(hasPlan){targetUsersPayingQuantity=newTotalSeatsNumber;}this.props.addCompanyUsers(userDataFiltered,companyInviteMessage,hasPlan,targetUsersPayingQuantity).then(function(data){if(data instanceof __WEBPACK_IMPORTED_MODULE_52__errors_apperror__["a" /* default */]){_this30.handleShowAddUserModal(null,true);return;}else{_this30.props.hideModal();}Object(__WEBPACK_IMPORTED_MODULE_47_lib_Segment_customTrackers__["R" /* trackUserAdd */])(users,Object(__WEBPACK_IMPORTED_MODULE_48_lib_Segment_helpers__["a" /* getTrackingOptions */])(_this30.props.company));_this30.props.inviteUsersClearUsers();_this30.props.inviteUsersClearMessage();});}/**
	 * Show cost confirmation popup
	 *
	 * @param {string} message HTML message
	 * @param {string} actionButtonLabel a label on the action button
	 * @returns Promise
	 * @memberof Users
	 */},{key:"showConfirmationPopup",value:function showConfirmationPopup(message){var _this31=this;var actionButtonLabel=arguments.length>1&&arguments[1]!==undefined?arguments[1]:localize('pay-now');return new Promise(function(resolve,reject){_this31.props.showModal('CONFIRMATION_MODAL',{message:{__html:message},buttons:[__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_Features_components__["a" /* Button */],{key:"button-cancel",variant:"outlined",color:"primary",onClick:function onClick(){return reject();}},localize('cancel')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_Features_components__["a" /* Button */],{key:"button-confirm",variant:"contained",color:"primary",onClick:function onClick(){return resolve();}},actionButtonLabel)]});});}},{key:"showCompleteTeamProfileModal",value:function showCompleteTeamProfileModal(){var _this32=this;this.props.showModal('CONFIRMATION_MODAL',{message:{__html:localize('users-complete-team-profile')},buttons:[__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_Features_components__["a" /* Button */],{key:"button-confirm",variant:"contained",color:"primary",onClick:function onClick(){_this32.setState({redirectUrl:Object(__WEBPACK_IMPORTED_MODULE_51_routes__["w" /* getRoute */])(__WEBPACK_IMPORTED_MODULE_51_routes__["l" /* ROOT */],_this32.state.selectedId)});}},localize('users-team-profile'))]});}}]);return Users;}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]))||_class);Users.propTypes={classes:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.object,company:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.object,companies:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.object,currentUserEmail:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string,auth:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.array,addCompanyUsers:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func.isRequired,sendInviteToUsers:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func.isRequired,updateCompanyUser:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func.isRequired,deleteCompanyUser:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func.isRequired,estimateCostOnAddCompanyUsers:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func.isRequired,estimateCostOnUpdateCompanyUser:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func.isRequired,estimateCostOnDeleteCompanyUser:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func.isRequired,writeUserSettings:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func.isRequired,showModal:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,hideModal:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,location:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.object,askToCompleteCompanyProfile:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,settings:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.object,inviteUsersClearUsers:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,inviteUsersClearMessage:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,currentPlanId:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string,showRateLimitError:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func.isRequired,updateUserExternalId:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func.isRequired,clearExternalIdState:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func.isRequired,selectedCompanyId:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string,showErrorPopup:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func.isRequired,updateUserPhoto:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func.isRequired,mls:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.object,clearConnectMlsState:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func.isRequired};var mapStateToProps=function mapStateToProps(state){return{error:state.error,company:state.companies.rawDataById[state.companies.selectedId],auth:state.session.user.auth,companies:state.companies,currentUserEmail:state.session.user.mainEmail,currentPlanName:Object(__WEBPACK_IMPORTED_MODULE_50__utils_subscription__["d" /* getCurrentPlanName */])(state.companies.rawDataById[state.companies.selectedId]),settings:state.session.user.settings,currentPlanId:Object(__WEBPACK_IMPORTED_MODULE_50__utils_subscription__["c" /* getCurrentPlanId */])(state.companies.rawDataById[state.companies.selectedId]),selectedCompanyId:state.companies.selectedId,mls:state.mls};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_12_redux__["b" /* bindActionCreators */])({addCompanyUsers:__WEBPACK_IMPORTED_MODULE_38_redux_modules_companies__["b" /* addCompanyUsers */],sendInviteToUsers:__WEBPACK_IMPORTED_MODULE_38_redux_modules_companies__["G" /* sendInviteToUsers */],updateCompanyUser:__WEBPACK_IMPORTED_MODULE_38_redux_modules_companies__["L" /* updateCompanyUser */],deleteCompanyUser:__WEBPACK_IMPORTED_MODULE_38_redux_modules_companies__["j" /* deleteCompanyUser */],estimateCostOnAddCompanyUsers:__WEBPACK_IMPORTED_MODULE_38_redux_modules_companies__["k" /* estimateCostOnAddCompanyUsers */],estimateCostOnUpdateCompanyUser:__WEBPACK_IMPORTED_MODULE_38_redux_modules_companies__["n" /* estimateCostOnUpdateCompanyUser */],estimateCostOnDeleteCompanyUser:__WEBPACK_IMPORTED_MODULE_38_redux_modules_companies__["m" /* estimateCostOnDeleteCompanyUser */],writeUserSettings:__WEBPACK_IMPORTED_MODULE_39_redux_modules_session__["d" /* writeUserSettings */],showModal:__WEBPACK_IMPORTED_MODULE_30_redux_modules_modal__["d" /* showModal */],hideModal:__WEBPACK_IMPORTED_MODULE_30_redux_modules_modal__["b" /* hideModal */],inviteUsersClearMessage:__WEBPACK_IMPORTED_MODULE_38_redux_modules_companies__["z" /* inviteUsersClearMessage */],inviteUsersClearUsers:__WEBPACK_IMPORTED_MODULE_38_redux_modules_companies__["A" /* inviteUsersClearUsers */],showRateLimitError:__WEBPACK_IMPORTED_MODULE_38_redux_modules_companies__["J" /* showRateLimitError */],updateUserExternalId:__WEBPACK_IMPORTED_MODULE_38_redux_modules_companies__["O" /* updateUserExternalId */],clearExternalIdState:__WEBPACK_IMPORTED_MODULE_38_redux_modules_companies__["e" /* clearExternalIdState */],showErrorPopup:__WEBPACK_IMPORTED_MODULE_38_redux_modules_companies__["H" /* showErrorPopup */],updateUserPhoto:__WEBPACK_IMPORTED_MODULE_38_redux_modules_companies__["P" /* updateUserPhoto */],clearConnectMlsState:__WEBPACK_IMPORTED_MODULE_26_redux_modules_mls__["e" /* clearConnectMlsState */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Users));

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_i18n_i18n__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__icons_pencil__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__theme_icons__ = __webpack_require__(24);
var localize=__WEBPACK_IMPORTED_MODULE_11_i18n_i18n__["a" /* default */].loc.localize;var styles=function styles(theme){return{root:{width:'40px',height:'40px',margin:'10px 25px',border:'0px solid',borderRadius:'5px',overflow:'hidden',position:'relative'},rootOverlay:{cursor:'pointer'},photo:{width:'100%',height:'100%',objectFit:'cover',objectPosition:'top'},hoverOverlay:{width:'100%',height:'100%',position:'absolute',left:0,top:0,opacity:0,transition:'opacity 150ms ease-out',backgroundColor:'#2e3f4f'},hoverOverlayVisible:{opacity:0.6},pencil:{position:'absolute',left:'calc(50% - 12px)',top:'calc(50% - 12px)',pointerEvents:'none',opacity:0,transition:'opacity 150ms ease-out',color:'white'},pencilVisible:{opacity:1},loadingIcon:{display:'block',height:'30px',width:'30px',margin:'0 auto',fill:'#96DCFD',animation:'spin 2s linear infinite'},'@keyframes spin':{'0':{transform:'rotate(0deg)'},'100%':{transform:'rotate(360deg)'}}};};var SmartFieldPhotoPicker=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(SmartFieldPhotoPicker,_Component);function SmartFieldPhotoPicker(props){var _this;__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,SmartFieldPhotoPicker);_this=__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(SmartFieldPhotoPicker).call(this,props));__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this),"handleMenuOpen",function(event){_this.setState({anchorEl:event.currentTarget.parentElement});});__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this),"handleMenuClose",function(){_this.setState({anchorEl:null});});__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this),"handleMouseEnter",function(){_this.setState({hovering:_this.props.showProgress?false:true});});__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this),"handleMouseLeave",function(){_this.setState({hovering:false});});_this.state={objectUrl:'',anchorEl:null,hovering:false};return _this;}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(SmartFieldPhotoPicker,[{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){var photoUrlOrFile=this.props.photoUrlOrFile;var objectUrl=this.state.objectUrl;if(photoUrlOrFile!==prevProps.photoUrlOrFile){if(objectUrl){URL.revokeObjectURL(objectUrl);}if(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.isString(photoUrlOrFile)){this.setState({objectUrl:''});}else{this.setState({objectUrl:URL.createObjectURL(photoUrlOrFile)});}}}},{key:"componentWillUnmount",value:function componentWillUnmount(){var objectUrl=this.state.objectUrl;if(objectUrl){URL.revokeObjectURL(objectUrl);}}},{key:"render",value:function render(){var _this2=this;var _this$props=this.props,classes=_this$props.classes,defaultPhoto=_this$props.defaultPhoto,_this$props$photoUrlO=_this$props.photoUrlOrFile,photoUrlOrFile=_this$props$photoUrlO===void 0?'':_this$props$photoUrlO,onSelectPhoto=_this$props.onSelectPhoto,onCropPhoto=_this$props.onCropPhoto,onRemovePhoto=_this$props.onRemovePhoto,showProgress=_this$props.showProgress;var _this$state=this.state,objectUrl=_this$state.objectUrl,anchorEl=_this$state.anchorEl,hovering=_this$state.hovering;var showDefaultPhoto=!photoUrlOrFile&&defaultPhoto&&!showProgress;var photoUrl=objectUrl||(__WEBPACK_IMPORTED_MODULE_10_lodash___default.a.isString(photoUrlOrFile)?photoUrlOrFile:'');showProgress&&hovering&&this.setState({hovering:false});return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{className:"".concat(classes.root," ").concat(hovering?classes.rootOverlay:''),onMouseEnter:this.handleMouseEnter,onMouseLeave:this.handleMouseLeave},showDefaultPhoto&&defaultPhoto,photoUrlOrFile&&!showProgress&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("img",{className:classes.photo,src:photoUrl,alt:"photo preview"}),showProgress&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__theme_icons__["Y" /* SpinnerIcon */],{className:classes.loadingIcon}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{className:"".concat(classes.hoverOverlay," ").concat(hovering?classes.hoverOverlayVisible:''),onClick:showProgress?undefined:this.handleMenuOpen}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__icons_pencil__["a" /* default */],{className:"".concat(classes.pencil," ").concat(hovering?classes.pencilVisible:'')}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["w" /* Menu */],{anchorEl:anchorEl,open:Boolean(anchorEl),onClose:this.handleMenuClose,anchorOrigin:{vertical:'top',horizontal:'right'},transformOrigin:{vertical:'top',horizontal:'left'}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["x" /* MenuItem */],{onClick:function onClick(){onSelectPhoto&&onSelectPhoto();_this2.handleMenuClose();}},localize('smartfield-photo-picker-upload-photo')),onCropPhoto&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["x" /* MenuItem */],{disabled:!photoUrlOrFile,onClick:function onClick(){onCropPhoto();_this2.handleMenuClose();}},localize('smartfield-photo-picker-crop-photo')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["x" /* MenuItem */],{disabled:!photoUrlOrFile,onClick:function onClick(){onRemovePhoto&&onRemovePhoto();_this2.handleMenuClose();}},localize('smartfield-photo-picker-remove-photo'))));}}]);return SmartFieldPhotoPicker;}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);SmartFieldPhotoPicker.propTypes={photoUrlOrFile:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,classes:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,defaultPhoto:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,onSelectPhoto:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a["function"],onCropPhoto:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a["function"],onRemovePhoto:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a["function"],showProgress:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["N" /* withStyles */])(styles)(SmartFieldPhotoPicker));

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core__ = __webpack_require__(28);
/*eslint-disable max-len*/var SvgIcon=__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["D" /* SvgIcon */];var PencilIcon=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(PencilIcon,_Component);function PencilIcon(props){var _this;__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this,PencilIcon);_this=__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(PencilIcon).call(this,props));_this.props=props;return _this;}__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(PencilIcon,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SvgIcon,__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({width:"24",height:"24",viewBox:"0 0 24 24"},this.props),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("path",{d:"M16.6168 3.75204C16.8552 3.51361 17.1383 3.32448 17.4498 3.19545C17.7613 3.06641 18.0952 3 18.4324 3C18.7696 3 19.1035 3.06641 19.415 3.19545C19.7265 3.32448 20.0095 3.51361 20.248 3.75204C20.4864 3.99046 20.6755 4.27351 20.8046 4.58503C20.9336 4.89655 21 5.23043 21 5.56761C21 5.90479 20.9336 6.23868 20.8046 6.55019C20.6755 6.86171 20.4864 7.14476 20.248 7.38319L7.99283 19.6383L3 21L4.36168 16.0072L16.6168 3.75204Z",fill:"none",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"}));}}]);return PencilIcon;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PencilIcon);

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_slider__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_icons_zoomout__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_icons_zoomin__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_icons_bkg_svg__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_icons_bkg_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_icons_bkg_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_i18n_i18n__ = __webpack_require__(15);
var localize=__WEBPACK_IMPORTED_MODULE_16_i18n_i18n__["a" /* default */].loc.localize;var MAX_SCALE=2;var MAX_FRAME_DISPLAY_SIZE=200;var JPEG_EXPORT_QUALITY=0.9;var styles=function styles(theme){return{dialogPaper:{minWidth:444},content:{width:'100%',alignItems:'center',justifyContent:'center',gap:'16px',touchAction:'none'},dialogTitle:{textAlign:'left'},prompt:{alignSelf:'flex-start',fontSize:'16px'},cropper:{alignItems:'center',justifyContent:'center',overflow:'hidden',position:'relative',maxWidth:'100% !important'},cropperImage:{position:'absolute',pointerEvents:'auto',cursor:'move'},cropperMask:{boxSizing:'content-box',zIndex:1,borderStyle:'solid',borderColor:'rgba(255, 255, 255, 0.67)',pointerEvents:'none','&::before':{content:'""',position:'absolute',border:'1px dashed black',inset:"".concat(MAX_FRAME_DISPLAY_SIZE*(MAX_SCALE-1)/2,"px")}},zoomContainer:{width:'100%',gap:'16px',paddingBottom:'16px'},sliderGrid:{flex:'1 0 auto'},slider:{height:'26px',background:"no-repeat url(".concat(__WEBPACK_IMPORTED_MODULE_15__components_icons_bkg_svg___default.a,") center"),backgroundSize:'contain'},sliderStick:{border:'1px black solid'},handle:{width:'12px',backgroundColor:'#2fa5e7',height:'12px',borderRadius:'6px'},button:{borderRadius:'5px',marginRight:'30px',marginBottom:'12px'},actionButtons:{justifyContent:'flex-end'}};};var SmartFieldPhotoCropper=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(SmartFieldPhotoCropper,_Component);function SmartFieldPhotoCropper(props){var _this;__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this,SmartFieldPhotoCropper);_this=__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(SmartFieldPhotoCropper).call(this,props));__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this),"closeDialog",function(){return _this.props.hideModal();});__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this),"handleEscape",function(e){// Prefer modern key; fallback for older browsers
var isEsc=e.key==='Escape'||e.keyCode===27;if(!isEsc)return;// If something *intentionally* prevented default, honor it
if(e.defaultPrevented)return;_this.closeDialog();});__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this),"setImgDisplaySize",function(_ref){var naturalWidth=_ref.naturalWidth,naturalHeight=_ref.naturalHeight;var frameAspect=1;var imageAspect=naturalWidth/naturalHeight;if(imageAspect>frameAspect){_this.setState({imgDisplayHeight:_this.frameDisplayHeight,imgDisplayWidth:_this.frameDisplayHeight*imageAspect});}else{var displayHeight=_this.frameDisplayWidth/imageAspect;_this.setState({imgDisplayWidth:_this.frameDisplayWidth,imgDisplayHeight:_this.frameDisplayWidth/imageAspect});if(_this.props.translate===undefined){// P9052-27544 Default to top aligned position
var maxTranslateY=(displayHeight*_this.state.scale-_this.frameDisplayHeight)/2/_this.state.scale;_this.setState({translate:[0,maxTranslateY]});}}});__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this),"setTranslateClamped",function(newTranslate){var clamped=[__WEBPACK_IMPORTED_MODULE_12_lodash___default.a.clamp(newTranslate[0],-_this.maxTranslate[0],_this.maxTranslate[0]),__WEBPACK_IMPORTED_MODULE_12_lodash___default.a.clamp(newTranslate[1],-_this.maxTranslate[1],_this.maxTranslate[1])];_this.setState({translate:clamped});});__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this),"translateHandler",{onStart:function onStart(clientX,clientY){_this.dragStartTranslate=_this.state.translate;_this.dragStartPos=[clientX,clientY];},onMove:function onMove(clientX,clientY){if(_this.dragStartPos){var deltaX=(clientX-_this.dragStartPos[0])/_this.state.scale;var deltaY=(clientY-_this.dragStartPos[1])/_this.state.scale;_this.setTranslateClamped([_this.dragStartTranslate[0]+deltaX,_this.dragStartTranslate[1]+deltaY]);}},onEnd:function onEnd(){_this.dragStartTranslate=null;_this.dragStartPos=null;}});__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this),"reset",function(){_this.setState({translate:[0,0],scale:1});});_this.state={scale:props.scale||1,translate:props.translate||[0,0],imgDisplayWidth:0,imgDisplayHeight:0};_this.frameDisplayWidth=Math.min(MAX_FRAME_DISPLAY_SIZE,MAX_FRAME_DISPLAY_SIZE);_this.frameDisplayHeight=Math.min(MAX_FRAME_DISPLAY_SIZE,MAX_FRAME_DISPLAY_SIZE);_this.dragStartTranslate=null;_this.dragStartPos=null;_this.maxTranslate=[0,0];_this.imgRef=Object(__WEBPACK_IMPORTED_MODULE_8_react__["createRef"])();_this.onSaveRef={current:null};_this.photoUrl=props.photoUrl;_this.onCropCb=props.onCropCb;_this.onSaveRef.current=function(){var img=_this.imgRef.current;var imgNaturalWidth=img.naturalWidth,imgNaturalHeight=img.naturalHeight;var imageAspect=imgNaturalWidth/imgNaturalHeight;// Assume frameAspect is 1 (square).
// Output size should therefore also be square, at 1:1 pixel size, considering any scaling.
// Note that this calculation should be generalised in case frameAspect is not 1.
var outputSize=Math.min(imgNaturalWidth,imgNaturalHeight)/_this.state.scale;var frameNaturalSize=[outputSize,outputSize];var canvas=document.createElement('canvas');canvas.width=frameNaturalSize[0];canvas.height=frameNaturalSize[1];var context=canvas.getContext('2d');// translate is in screen pixels; naturalTranslate in frame/output pixels.
var naturalTranslate=__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(_this.state.translate);naturalTranslate[0]*=frameNaturalSize[0]/_this.frameDisplayWidth;naturalTranslate[1]*=frameNaturalSize[1]/_this.frameDisplayHeight;// Same factor as previous line.
var frameAspect=1;var baseScale;var sx;var sy;var sWidth;var sHeight;if(imageAspect>frameAspect){// Scale of 1 fits image natural height to frame natural height.
baseScale=frameNaturalSize[1]/imgNaturalHeight;sHeight=imgNaturalHeight/_this.state.scale;sWidth=imgNaturalHeight*frameAspect/_this.state.scale;}else{// Scale of 1 fits image natural width to frame natural width.
baseScale=frameNaturalSize[0]/imgNaturalWidth;sWidth=imgNaturalWidth/_this.state.scale;sHeight=imgNaturalWidth/frameAspect/_this.state.scale;}sx=imgNaturalWidth/2-naturalTranslate[0]/baseScale-frameNaturalSize[0]/2/baseScale/_this.state.scale;sy=imgNaturalHeight/2-naturalTranslate[1]/baseScale-frameNaturalSize[1]/2/baseScale/_this.state.scale;var dx=0;var dy=0;var dWidth=canvas.width;var dHeight=canvas.height;context&&context.drawImage(img,sx,sy,sWidth,sHeight,dx,dy,dWidth,dHeight);var matchResult=_this.photoUrl.match(/^data:(.*);base64/);var originalJpeg=matchResult&&matchResult[1]==='image/jpeg';canvas.toBlob(function(blob){_this.onCropCb&&_this.onCropCb({blob:blob,extension:originalJpeg?'jpeg':'png',scale:_this.state.scale,translate:_this.state.translate});_this.closeDialog();},originalJpeg?'image/jpeg':'image/png',JPEG_EXPORT_QUALITY);};return _this;}__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(SmartFieldPhotoCropper,[{key:"componentDidUpdate",value:function componentDidUpdate(_,prevState){if(prevState.imgDisplayWidth!==this.state.imgDisplayWidth||prevState.imgDisplayHeight!==this.state.imgDisplayHeight||prevState.scale!==this.state.scale){var _this$state=this.state,imgDisplayWidth=_this$state.imgDisplayWidth,imgDisplayHeight=_this$state.imgDisplayHeight,scale=_this$state.scale;if(!(imgDisplayWidth&&imgDisplayHeight))return;this.maxTranslate=[(imgDisplayWidth*scale-this.frameDisplayWidth)/2/scale,(imgDisplayHeight*scale-this.frameDisplayHeight)/2/scale];this.setTranslateClamped(this.state.translate);}}},{key:"componentDidMount",value:function componentDidMount(){window.addEventListener('keydown',this.handleEscape);}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.dragStartTranslate=null;this.dragStartPos=null;window.removeEventListener('keydown',this.handleEscape);}},{key:"render",value:function render(){var _this2=this;var _this$props=this.props,classes=_this$props.classes,photoUrl=_this$props.photoUrl;var _this$state2=this.state,scale=_this$state2.scale,translate=_this$state2.translate,imgDisplayWidth=_this$state2.imgDisplayWidth,imgDisplayHeight=_this$state2.imgDisplayHeight;var imageStyle={width:imgDisplayWidth,height:imgDisplayHeight,transform:"scale(".concat(scale,") translate(").concat(translate[0],"px, ").concat(translate[1],"px)")};// P9052-27546 Add parameter to photoUrl to prevent using a cached non-CORS version of the image
var cropPhotoUrl=typeof photoUrl==='string'&&photoUrl.startsWith('http')?"".concat(photoUrl).concat(photoUrl.includes('?')?'&':'?',"crop=true"):photoUrl;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["d" /* Dialog */],{open:true,onClose:this.closeDialog,onEscapeKeyDown:this.closeDialog,disableEscapeKeyDown:false,BackdropProps:{style:{backgroundColor:'rgba(46, 63, 79, 0.4)'}},classes:{paper:classes.dialogPaper},PaperProps:{style:{border:0,width:309,minWidth:505,borderRadius:5,boxShadow:'0px 4px 24px rgba(0, 0, 0, 0.08)'}}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["g" /* DialogTitle */],{variant:"body1",color:"default",className:classes.dialogTitle},localize('smartfield-photo-picker-crop-photo')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["f" /* DialogContent */],{className:classes.dialogContent},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["o" /* Grid */],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["o" /* Grid */],{container:true,direction:"column",className:classes.content,onMouseMove:function onMouseMove(e){return _this2.translateHandler.onMove(e.clientX,e.clientY);},onTouchMove:function onTouchMove(e){return _this2.translateHandler.onMove(e.touches[0].clientX,e.touches[0].clientY);},onMouseUp:this.translateHandler.onEnd,onTouchEnd:this.translateHandler.onEnd,onDoubleClick:this.reset},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["M" /* Typography */],{className:classes.prompt},localize('smartfield-photo-picker-crop-photo-drag-prompt')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["o" /* Grid */],{item:true,container:true,className:classes.cropper,style:{width:this.frameDisplayWidth*MAX_SCALE,height:this.frameDisplayHeight*MAX_SCALE}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("img",{ref:this.imgRef,className:classes.cropperImage,style:imageStyle,src:cropPhotoUrl,crossOrigin:"use-credentials",onLoad:function onLoad(e){return _this2.setImgDisplaySize(e.target);},onMouseDown:function onMouseDown(e){_this2.translateHandler.onStart(e.clientX,e.clientY);e.preventDefault();},onTouchStart:function onTouchStart(e){return _this2.translateHandler.onStart(e.touches[0].clientX,e.touches[0].clientY);},onContextMenu:function onContextMenu(e){return e.preventDefault();},onWheel:function onWheel(e){e.persist();_this2.setState(function(prev){return{scale:__WEBPACK_IMPORTED_MODULE_12_lodash___default.a.clamp(prev.scale-e.deltaY/100,1,MAX_SCALE)};});},"data-tid":"smartfield-photo-cropper-photo"}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:classes.cropperMask,style:{width:this.frameDisplayWidth,height:this.frameDisplayHeight,minWidth:this.frameDisplayWidth,borderWidth:"".concat(this.frameDisplayHeight*(MAX_SCALE-1)/2,"px ").concat(this.frameDisplayWidth*(MAX_SCALE-1)/2,"px")}})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["o" /* Grid */],{item:true,container:true,className:classes.zoomContainer},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["o" /* Grid */],{item:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_icons_zoomout__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["o" /* Grid */],{item:true,className:classes.sliderGrid},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_slider___default.a,{className:classes.slider,handleClassName:classes.handle,value:scale,defaultValue:50,min:1,max:MAX_SCALE,step:0.01,onChange:function onChange(val){return _this2.setState({scale:val});}})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["o" /* Grid */],{item:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_icons_zoomin__["a" /* default */],null)))))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["o" /* Grid */],{item:true,container:true,className:classes.actionButtons},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["a" /* Button */],{variant:"outlined",color:"primary","data-tid":"button-photo-cropper-modal-cancel",className:classes.button,onClick:function onClick(){return _this2.closeDialog();},disabled:false},localize('cancel')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["a" /* Button */],{variant:"contained",color:"primary","data-tid":"button-photo-cropper-modal-save",className:classes.button,onClick:function onClick(){return _this2.onSaveRef.current&&_this2.onSaveRef.current();},disabled:false},localize('save'))));}}]);return SmartFieldPhotoCropper;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);SmartFieldPhotoCropper.propTypes={scale:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,translate:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,photoUrl:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,onCropCb:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,classes:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,hideModal:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["N" /* withStyles */])(styles)(SmartFieldPhotoCropper));

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(1);
var factory = __webpack_require__(1093);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(146);

// -- Inlined from fbjs --

var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function _invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var warning = function(){};

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

// /-- Inlined from fbjs --

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core__ = __webpack_require__(28);
/*eslint-disable max-len*/var SvgIcon=__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["D" /* SvgIcon */];var ZoomOutIcon=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ZoomOutIcon,_Component);function ZoomOutIcon(props){var _this;__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this,ZoomOutIcon);_this=__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(ZoomOutIcon).call(this,props));_this.props=props;return _this;}__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ZoomOutIcon,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SvgIcon,__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({width:"24",height:"24",viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg"},this.props),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("g",{fill:"none"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("path",{d:"M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("path",{d:"M18 18L20 20",stroke:"currentColor",strokeWidth:"2"}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("path",{d:"M23 23L19 19",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("path",{d:"M7 11H15",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"})));}}]);return ZoomOutIcon;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ZoomOutIcon);

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core__ = __webpack_require__(28);
/*eslint-disable max-len*/var SvgIcon=__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["D" /* SvgIcon */];var ZoomInIcon=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ZoomInIcon,_Component);function ZoomInIcon(props){var _this;__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this,ZoomInIcon);_this=__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(ZoomInIcon).call(this,props));_this.props=props;return _this;}__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ZoomInIcon,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SvgIcon,__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({width:"24",height:"24",viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg"},this.props),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("g",{fill:"none"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("path",{d:"M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("path",{d:"M23 23L19 19",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("path",{d:"M11 7V15",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("path",{d:"M7 11H15",stroke:"currentColor",strokeWidth:"2",strokeLinecap:"round",strokeLinejoin:"round"}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("path",{d:"M18 18L20 20",stroke:"currentColor",strokeWidth:"2"})));}}]);return ZoomInIcon;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ZoomInIcon);

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bkg.b533d77d.svg";

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core__ = __webpack_require__(28);
/*eslint-disable max-len*/var SvgIcon=__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["D" /* SvgIcon */];var DefaultAvatar=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(DefaultAvatar,_Component);function DefaultAvatar(props){var _this;__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this,DefaultAvatar);_this=__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(DefaultAvatar).call(this,props));_this.props=props;return _this;}__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(DefaultAvatar,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SvgIcon,__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({width:"96",height:"96",viewBox:"0 0 96 96"},this.props),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("rect",{x:"0",y:"0",width:"96",height:"96",fill:"#c5c5c5"}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("circle",{cx:"48",cy:"38.5",r:"22.5",fill:"#fff"}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("ellipse",{cx:"48",cy:"96",rx:"37.5",ry:"39.5",fill:"#fff"}));}}]);return DefaultAvatar;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DefaultAvatar);

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core__ = __webpack_require__(28);
/*eslint-disable max-len*/var SvgIcon=__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["D" /* SvgIcon */];var MoreIcon=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(MoreIcon,_Component);function MoreIcon(props){var _this;__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this,MoreIcon);_this=__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(MoreIcon).call(this,props));_this.props=props;return _this;}__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(MoreIcon,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SvgIcon,__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({width:"24",height:"24",viewBox:"0 0 24 24"},this.props),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("circle",{cx:"5",cy:"12",r:"2",fill:"currentColor",fillOpacity:"0.75"}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("circle",{cx:"12",cy:"12",r:"2",fill:"currentColor",fillOpacity:"0.75"}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("circle",{cx:"19",cy:"12",r:"2",fill:"currentColor",fillOpacity:"0.75"}));}}]);return MoreIcon;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MoreIcon);

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__index__ = __webpack_require__(296);
var ButtonWithPermissions=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ButtonWithPermissions,_Component);function ButtonWithPermissions(){__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this,ButtonWithPermissions);return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(ButtonWithPermissions).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ButtonWithPermissions,[{key:"render",value:function render(){var props=__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},this.props);if(Object(__WEBPACK_IMPORTED_MODULE_8__index__["a" /* hasFeature */])(this.props)===false){props.disabled=true;}return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["a" /* Button */],props);}}]);return ButtonWithPermissions;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ButtonWithPermissions);

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__index__ = __webpack_require__(296);
var ButtonWithPermissions=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ButtonWithPermissions,_Component);function ButtonWithPermissions(){__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this,ButtonWithPermissions);return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(ButtonWithPermissions).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ButtonWithPermissions,[{key:"render",value:function render(){var props=__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},this.props);if(Object(__WEBPACK_IMPORTED_MODULE_8__index__["a" /* hasFeature */])(this.props)===false){props.disabled=true;}return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["K" /* TextField */],props);}}]);return ButtonWithPermissions;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (ButtonWithPermissions);

/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__index__ = __webpack_require__(296);
var SelectWithPermissions=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(SelectWithPermissions,_Component);function SelectWithPermissions(){__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this,SelectWithPermissions);return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(SelectWithPermissions).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(SelectWithPermissions,[{key:"render",value:function render(){var props=__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},this.props);if(Object(__WEBPACK_IMPORTED_MODULE_8__index__["a" /* hasFeature */])(this.props)===false){props.disabled=true;}return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["C" /* Select */],props);}}]);return SelectWithPermissions;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SelectWithPermissions);

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_i18n_i18n__ = __webpack_require__(15);
var _dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_9_i18n_i18n__["a" /* default */].loc.localize;var styles=function styles(theme){return{notFound:{margin:'3rem'},notFoundTitle:{marginBottom:'2rem'}};};var NotFound=(_dec=Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(NotFound,_Component);function NotFound(){__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,NotFound);return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(NotFound).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(NotFound,[{key:"render",value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:classes.notFound},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{className:classes.notFoundTitle,variant:"h2"},localize('not-found-title')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:"body2"},localize('not-found-message1')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:"body2"},localize('not-found-message2')));}}]);return NotFound;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]))||_class);NotFound.propTypes={classes:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (NotFound);

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_no_permissions_svg__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_no_permissions_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_no_permissions_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_i18n_i18n__ = __webpack_require__(15);
var _dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_9_i18n_i18n__["a" /* default */].loc.localize;var styles=function styles(theme){return{container:{textAlign:'center'},noPermissionSVG:{height:'auto',width:'50%',maxWidth:700,marginTop:50}};};var NoPermissions=(_dec=Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(NoPermissions,_Component);function NoPermissions(){__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,NoPermissions);return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(NoPermissions).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(NoPermissions,[{key:"render",value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:classes.container},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("img",{className:classes.noPermissionSVG,src:__WEBPACK_IMPORTED_MODULE_8__assets_no_permissions_svg___default.a,alt:localize('no-permissions-admin-only')}));}}]);return NoPermissions;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]))||_class);NoPermissions.propTypes={classes:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (NoPermissions);

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/no_permissions.f849acd9.svg";

/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_not_available_png__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_not_available_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_not_available_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_i18n_i18n__ = __webpack_require__(15);
var _dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_11_i18n_i18n__["a" /* default */].loc.localize;var styles=function styles(theme){return{container:{textAlign:'center'},image:{height:'auto',width:300,marginTop:40,marginBottom:10},errorMessage:{fontSize:16,lineHeight:1.5,marginBottom:30}};};var PageNotAvailable=(_dec=Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(PageNotAvailable,_Component);function PageNotAvailable(){__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,PageNotAvailable);return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(PageNotAvailable).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(PageNotAvailable,[{key:"render",value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:classes.container},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("img",{className:classes.image,src:__WEBPACK_IMPORTED_MODULE_9__assets_not_available_png___default.a,alt:localize('page-not-available-image-alt')}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["M" /* Typography */],{variant:"body2",className:classes.errorMessage},localize('page-not-available-message')),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["a" /* Button */],{"data-tid":'button-page-not-available-refresh',variant:"contained",color:"primary",onClick:function onClick(){window.location='/?reload-app=true';}},localize('page-not-available-refresh')));}}]);return PageNotAvailable;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]))||_class);PageNotAvailable.propTypes={classes:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,selectedCompanyId:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string};var mapStateToProps=function mapStateToProps(state){return{selectedCompanyId:state.companies.selectedId};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps)(PageNotAvailable));

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_StickyHeader_StickyHeader__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_i18n_i18n__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__logger_logger__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_url__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_redux_modules_mls__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__theme_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_redux_modules_companies__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Features_components__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_redux_modules_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Header__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_mls__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_components_CenteredContent_CenteredContent__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__errors_apperror__ = __webpack_require__(34);
var _dec,_class;var log=__WEBPACK_IMPORTED_MODULE_15__logger_logger__["a" /* default */].get('Subscription');var localize=__WEBPACK_IMPORTED_MODULE_14_i18n_i18n__["a" /* default */].loc.localize;var styles=function styles(theme){return __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_objectSpread___default()({/* page header */stickyHeader:{paddingBottom:30,marginBottom:60,'&:after':__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()({width:'100%',margin:'0 5%'},theme.breakpoints.up('md'),{margin:0})},headerDescription:{margin:'0 0 40px'}},Object(__WEBPACK_IMPORTED_MODULE_25__utils_mls__["b" /* getTableStyleProps */])(theme),{/* add users button */buttonAddMls:{marginTop:40,background:theme.palette.colors.black,paddingLeft:20,paddingRight:20},iconMlsAdd:{width:15,marginRight:10,color:theme.palette.colors.white},buttonInviteUsers:{marginLeft:'8px',background:theme.palette.colors.white,border:'1px solid black',paddingLeft:20,paddingRight:20,'&:hover':{borderWidth:'1px'}},/* MLS list */ /* no mls message */noMlsConnected:{border:'1px solid #dedede',borderRadius:5,padding:'35px 25px'},mlsList:{marginBottom:40,border:'1px solid #dedede',borderRadius:5,padding:'24px 25px',position:'relative'},mlsListHeader:{justifyContent:'space-between',alignItems:'center'},mlsListHeaderTitle:{marginBottom:25},mlsListHeaderButtons:{textAlign:'right',marginBottom:25},buttonManageMls:{marginLeft:'8px',background:theme.palette.colors.white,border:'1px solid black',paddingLeft:20,paddingRight:20,'&:hover':{borderWidth:'1px'}},iconManageMls:{marginRight:5},table:{},buttonDeleteOffice:{padding:0,'&:hover':{background:'none'},'&:hover svg':{color:theme.palette.common.black}},iconDeleteOffice:{color:theme.palette.colors.zeta},/* loading icon */loadingContainer:{minHeight:400,width:'100%',position:'relative'},loadingContainerOfficeRow:{minHeight:20},loadingContainerConnectionRow:{minHeight:47},loadingContent:{position:'absolute',top:'50%',left:'50%',transform:'translate(-50%, -50%)'},loadingMessage:{fontSize:16,lineHeight:1.5,opacity:1,marginTop:10},loadingIcon:{display:'block',height:'24px',width:'24px',margin:'0 auto',fill:'#96DCFD',animation:'spin 2s linear infinite'},'@keyframes spin':{'0':{transform:'rotate(0deg)'},'100%':{transform:'rotate(360deg)'}},/* error message */errorMessage:{color:theme.palette.error.main,fontSize:14,lineHeight:1.5,opacity:1,textAlign:'center',padding:100,width:'100%','&.inline':{padding:0},'&.dense':{padding:'20px 20px 0'}}});};var Users=(_dec=Object(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["N" /* withStyles */])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(Users,_Component);function Users(props){var _this;__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,Users);_this=__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Users).call(this,props));_this.handleRemoveMls=_this.handleRemoveMls.bind(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.onRemoveOffice=_this.onRemoveOffice.bind(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.handleRemoveOffice=_this.handleRemoveOffice.bind(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.handleShowAddMlsModal=_this.handleShowAddMlsModal.bind(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.onModalCloseHandler=_this.onModalCloseHandler.bind(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.state=__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_objectSpread___default()({},_this.getStateFromProps(props));return _this;}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Users,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){this.setState(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_objectSpread___default()({},this.getStateFromProps(nextProps)));}},{key:"getStateFromProps",value:function getStateFromProps(props){var currentPlanName=props.currentPlanName;var _props$companies=props.companies,rawDataById=_props$companies.rawDataById,selectedId=_props$companies.selectedId;var company=rawDataById[selectedId];var users=company.users,hasActiveSubscription=company.hasActiveSubscription;return{users:users,hasActiveSubscription:hasActiveSubscription,currentPlanName:currentPlanName,selectedId:selectedId,company:company};}},{key:"componentDidMount",value:function componentDidMount(){var queryParams=Object(__WEBPACK_IMPORTED_MODULE_16__utils_url__["d" /* parseQuery */])(this.props.location.search);if('show-add-mls-popup'in queryParams){this.handleShowAddMlsModal();}}},{key:"handleShowAddMlsModal",value:function handleShowAddMlsModal(){this.props.showModal('ADD_MLS_CONNECTION_MODAL',{onClose:this.onModalCloseHandler});}},{key:"handleAddOffice",value:function handleAddOffice(mlsName,mlsConnectionId){this.props.showModal('ADD_MLS_OFFICE_MODAL',{mlsName:mlsName,mlsConnectionId:mlsConnectionId,onClose:this.onModalCloseHandler});}},{key:"handleManageMlsAgents",value:function handleManageMlsAgents(mlsConnectionId){var connections=this.props.mls.connections;this.props.showModal('MANAGE_MLS_AGENTS_MODAL',{connections:connections,mlsConnectionId:mlsConnectionId,onClose:this.onModalCloseHandler});}},{key:"onModalCloseHandler",value:function onModalCloseHandler(shouldReloadList){this.props.clearConnectMlsState();this.props.hideModal();if(shouldReloadList){this.props.getConnectionList();this.props.getAgentMlsIds();}}/**
	 * Called when button is pressed to delete office
	 * @param {object} params { parameter: value} list
	 * @memberof MLS
	 */},{key:"handleRemoveOffice",value:function handleRemoveOffice(mlsConnectionId,office){var officeMlsId=office.officeMlsId,officeName=office.officeName;this.props.deleteOfficeId(mlsConnectionId,officeMlsId,officeName).then(function(data){if(data instanceof __WEBPACK_IMPORTED_MODULE_27__errors_apperror__["a" /* default */]){log.send(data);}});}/**
	 * Triggers when user confirms office deletion in popup
	 * @param {*} callback Method, which should be executed on confirm
	 * @param {object} params { parameter: value} list
	 * @memberof MLS
	 */},{key:"onRemoveOffice",value:function onRemoveOffice(callbackRemoveOffice,callbackRemoveConnection,connection,office){var mlsConnectionId=connection.mlsConnectionId;var nrOfOffices=connection.offices.length;if(nrOfOffices===1){this.props.showModal('CONFIRMATION_MODAL',{title:localize('remove-mls-confirmation-title',connection.name),message:{__html:localize('remove-mls-confirmation-description')},buttons:[__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_Features_components__["a" /* Button */],{key:"button-cancel",variant:"outlined",color:"primary"},localize('cancel')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_Features_components__["a" /* Button */],{key:"button-confirm",variant:"contained",color:"primary",onClick:function onClick(){return callbackRemoveConnection(connection);}},localize('delete'))]});}else{this.props.showModal('CONFIRMATION_MODAL',{message:{__html:localize('remove-office-confirmation',office.officeName)},buttons:[__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_Features_components__["a" /* Button */],{key:"button-cancel",variant:"outlined",color:"primary"},localize('cancel')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_Features_components__["a" /* Button */],{key:"button-confirm",variant:"contained",color:"primary",onClick:function onClick(){return callbackRemoveOffice(mlsConnectionId,office);}},localize('delete'))]});}}/**
	 * Called when button is pressed to delete MLS
	 * @param {object} connection { parameter: value} list
	 * @memberof MLS
	 */},{key:"handleRemoveMls",value:function handleRemoveMls(connection){var mlsConnectionId=connection.mlsConnectionId,name=connection.name;this.props.deleteMLSConnection(mlsConnectionId,name).then(function(data){if(data instanceof __WEBPACK_IMPORTED_MODULE_27__errors_apperror__["a" /* default */]){log.send(data);}});}},{key:"getCompanyUsers",value:function getCompanyUsers(){var _this$props$companies=this.props.companies,rawDataById=_this$props$companies.rawDataById,selectedId=_this$props$companies.selectedId;var company=rawDataById[selectedId];var users=company.users;return users;}},{key:"render",value:function render(){var _this2=this;var classes=this.props.classes;var _this$props$mls=this.props.mls,connections=_this$props$mls.connections,getConnectionsSuccess=_this$props$mls.getConnectionsSuccess,getConnectionsErrorId=_this$props$mls.getConnectionsErrorId,getAgentsMlsIdsErrorId=_this$props$mls.getAgentsMlsIdsErrorId,getAgentsMlsIdsSuccess=_this$props$mls.getAgentsMlsIdsSuccess,mlsBoardList=_this$props$mls.mlsBoardList,mlsBoardListFailedToLoad=_this$props$mls.mlsBoardListFailedToLoad;var renderNoMlsConnected=function renderNoMlsConnected(){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{container:true,direction:"row",className:classes.noMlsConnected},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["M" /* Typography */],{variant:"body2"},localize('mls-list-no-mls-connected')));};var renderOfficeRowContent=function renderOfficeRowContent(office,officeIndex,connection,connectionIndex){var mlsConnectionId=connection.mlsConnectionId;var apiError=_this2.props.mls.deletingMlsOfficeErrorId.find(function(item){return item.officeMlsId===office.officeMlsId;})||_this2.props.mls.deletingMlsConnectionErrorId.find(function(item){return item.mlsConnectionId===mlsConnectionId;});var errorMessageKey;if(apiError){errorMessageKey=apiError&&apiError.errorId&&__WEBPACK_IMPORTED_MODULE_25__utils_mls__["a" /* MLS_ERRORS */][apiError.errorId]||__WEBPACK_IMPORTED_MODULE_25__utils_mls__["a" /* MLS_ERRORS */][__WEBPACK_IMPORTED_MODULE_12_errors_errorids__["a" /* default */].UNKNOWN];}if(_this2.props.mls.deletingMlsOfficeXhrInProgress.find(function(item){return item.officeMlsId===office.officeMlsId&&item.mlsConnectionId===mlsConnectionId;})){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["H" /* TableCell */],{colSpan:3,className:__WEBPACK_IMPORTED_MODULE_24_classnames___default()(classes.tableLoadingCellBody,classes.tableCellBody)},renderLoading(null,classes.loadingContainerOfficeRow));}else{return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["H" /* TableCell */],{className:__WEBPACK_IMPORTED_MODULE_24_classnames___default()(classes.tableNameCellBody,classes.tableCellBody)},office.officeName),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["H" /* TableCell */],{className:__WEBPACK_IMPORTED_MODULE_24_classnames___default()(classes.tableIdCellBody,classes.tableCellBody)},office.officeMlsId),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["H" /* TableCell */],{className:classes.tableActionsCell},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["p" /* IconButton */],{className:classes.buttonDeleteOffice,component:"span","aria-label":localize('mls-list-office-delete-office'),onClick:function onClick(){_this2.onRemoveOffice(_this2.handleRemoveOffice,_this2.handleRemoveMls,connection,office);}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__theme_icons__["l" /* DeleteIconRounded */],{className:classes.iconDeleteOffice})),errorMessageKey&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,renderErrorMessage(errorMessageKey,true))));}};var renderOffices=function renderOffices(offices,connection,connectionIndex){var _classNames;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["F" /* Table */],{className:classes.table,key:"offices-table-connection\u2013".concat(connectionIndex)},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["I" /* TableHead */],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["J" /* TableRow */],{className:classes.tableHeadRow},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["H" /* TableCell */],{padding:"dense",className:__WEBPACK_IMPORTED_MODULE_24_classnames___default()((_classNames={},__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_classNames,classes.noBorderedCell,true),__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_classNames,classes.tableNameCellHeader,true),__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_classNames,classes.tableCellHeader,true),_classNames))},localize('mls-list-office-name')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["H" /* TableCell */],{className:__WEBPACK_IMPORTED_MODULE_24_classnames___default()(classes.tableIdCellHeader,classes.noBorderedCell,classes.tableCellHeader)},localize('mls-list-office-id')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["H" /* TableCell */],null))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["G" /* TableBody */],null,offices.map(function(office,officeIndex){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["J" /* TableRow */],{key:"offices-table-connection\u2013".concat(connectionIndex,"-office-").concat(officeIndex),hover:true,className:classes.tableBodyRow},renderOfficeRowContent(office,officeIndex,connection,connectionIndex));})));};var renderMlsListHeader=function renderMlsListHeader(_ref){var name=_ref.name,mlsConnectionId=_ref.mlsConnectionId;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{container:true,direction:"row",className:classes.mlsListHeader},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{item:true,className:classes.mlsListHeaderTitle},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["M" /* Typography */],{variant:"h4"},name)),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{item:true,className:classes.mlsListHeaderButtons},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_Features_components__["a" /* Button */],{variant:"outlined","data-tid":"button-add-office",color:"primary",onClick:function onClick(){return _this2.handleAddOffice(name,mlsConnectionId);},className:classes.buttonManageMls},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__theme_icons__["D" /* IconMlsIdAdd */],{className:classes.iconManageMls}),localize('mls-list-add-office')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_Features_components__["a" /* Button */],{variant:"outlined","data-tid":"button-manage-agents",color:"primary",onClick:function onClick(){return _this2.handleManageMlsAgents(mlsConnectionId);},className:classes.buttonManageMls},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__theme_icons__["U" /* SettingsIcon */],{className:classes.iconManageMls}),localize('mls-list-manage-agents'))));};var renderMlsListContent=function renderMlsListContent(connection,index){if(connection.offices.length){return renderOffices(connection.offices,connection,index);}else if(_this2.props.mls.deletingMlsConnectionXhrInProgress.includes(connection.mlsConnectionId)){return renderLoading(null,classes.loadingContainerConnectionRow);}};var renderMlsList=function renderMlsList(){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,connections.map(function(connection,index){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{container:true,direction:"row",className:classes.mlsList,key:"mls-list-".concat(index)},renderMlsListHeader(connection),renderMlsListContent(connection,index));}));};var renderLoading=function renderLoading(messageKey,additionalClass){var classes=_this2.props.classes;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:__WEBPACK_IMPORTED_MODULE_24_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_objectSpread___default()(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()({},classes.loadingContainer,true),additionalClass&&__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()({},additionalClass,true)))},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:classes.loadingContent},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__theme_icons__["Y" /* SpinnerIcon */],{className:classes.loadingIcon}),messageKey&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["M" /* Typography */],{className:classes.loadingMessage,variant:"body2"},localize(messageKey))));};var renderErrorMessage=function renderErrorMessage(errorMessageKey,inline,dense){var _classNames2;var errorMessage=localize(errorMessageKey);return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["M" /* Typography */],{className:__WEBPACK_IMPORTED_MODULE_24_classnames___default()((_classNames2={},__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_classNames2,classes.errorMessage,true),__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_classNames2,'inline',inline),__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_classNames2,'dense',dense),__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_classNames2,'errorMessage',true),_classNames2)),variant:"body2",dangerouslySetInnerHTML:{__html:errorMessage}});};var renderMlsContent=function renderMlsContent(){if(getConnectionsErrorId||getAgentsMlsIdsErrorId||mlsBoardListFailedToLoad){var errorMessageKey=getConnectionsErrorId&&__WEBPACK_IMPORTED_MODULE_25__utils_mls__["a" /* MLS_ERRORS */][getConnectionsErrorId]||getAgentsMlsIdsErrorId&&__WEBPACK_IMPORTED_MODULE_25__utils_mls__["a" /* MLS_ERRORS */][getAgentsMlsIdsErrorId]||mlsBoardListFailedToLoad&&'mls-connection-popup-error-failed-to-load-mls-board-list'||__WEBPACK_IMPORTED_MODULE_25__utils_mls__["a" /* MLS_ERRORS */][__WEBPACK_IMPORTED_MODULE_12_errors_errorids__["a" /* default */].UNKNOWN];return renderErrorMessage(errorMessageKey);}else if(!getConnectionsSuccess||!getAgentsMlsIdsSuccess||mlsBoardList.length===0){return renderLoading('mls-list-loading');}else if(getConnectionsSuccess){return connections.length?renderMlsList():renderNoMlsConnected();}};return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_components_CenteredContent_CenteredContent__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_StickyHeader_StickyHeader__["a" /* default */],{className:classes.stickyHeader},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_Header__["a" /* default */],null,localize('mls-connection-header')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_Features_components__["a" /* Button */],{variant:"contained","data-tid":"button-mls-add",color:"primary",onClick:function onClick(){return _this2.handleShowAddMlsModal();},className:classes.buttonAddMls},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__theme_icons__["D" /* IconMlsIdAdd */],{className:classes.iconMlsAdd}),localize('mls-add-button'))),renderMlsContent());}}]);return Users;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]))||_class);Users.propTypes={classes:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,company:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,companies:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,showModal:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,hideModal:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,location:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,settings:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,currentPlanId:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,selectedCompanyId:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,showErrorPopup:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,mls:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,getConnectionList:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,getAgentMlsIds:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,deleteMLSConnection:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,deleteOfficeId:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,showRateLimitError:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,clearConnectMlsState:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,addAgentMlsId:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired};var mapStateToProps=function mapStateToProps(state){return{error:state.error,company:state.companies.rawDataById[state.companies.selectedId],auth:state.session.user.auth,companies:state.companies,settings:state.session.user.settings,selectedCompanyId:state.companies.selectedId,mls:state.mls};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_10_redux__["b" /* bindActionCreators */])({showModal:__WEBPACK_IMPORTED_MODULE_22_redux_modules_modal__["d" /* showModal */],hideModal:__WEBPACK_IMPORTED_MODULE_22_redux_modules_modal__["b" /* hideModal */],showErrorPopup:__WEBPACK_IMPORTED_MODULE_19_redux_modules_companies__["H" /* showErrorPopup */],getConnectionList:__WEBPACK_IMPORTED_MODULE_17_redux_modules_mls__["n" /* getConnectionList */],getAgentMlsIds:__WEBPACK_IMPORTED_MODULE_17_redux_modules_mls__["m" /* getAgentMlsIds */],showRateLimitError:__WEBPACK_IMPORTED_MODULE_19_redux_modules_companies__["J" /* showRateLimitError */],deleteMLSConnection:__WEBPACK_IMPORTED_MODULE_17_redux_modules_mls__["i" /* deleteMLSConnection */],deleteOfficeId:__WEBPACK_IMPORTED_MODULE_17_redux_modules_mls__["j" /* deleteOfficeId */],clearConnectMlsState:__WEBPACK_IMPORTED_MODULE_17_redux_modules_mls__["e" /* clearConnectMlsState */],addAgentMlsId:__WEBPACK_IMPORTED_MODULE_17_redux_modules_mls__["a" /* addAgentMlsId */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Users));

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Typography__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_routes__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__theme_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_subscription__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_downloads__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__redux_modules_crs__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__redux_modules_discount__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_redux_modules_session__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_storage__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lib_Segment_customTrackers__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lib_Segment_helpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_i18n_i18n__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__redux_modules_app__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__redux_modules_companies__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_utils_string__ = __webpack_require__(211);
var _dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_24_i18n_i18n__["a" /* default */].loc.localize;var styles=function styles(theme){return{successMessageContainer:{textAlign:'center',height:'100%',display:'flex',flexDirection:'column',justifyContent:'center',minHeight:'400px'},title:{fontSize:'22px',lineHeight:'25px',margin:'0 0 1rem',fontWeight:'bold',opacity:1},description:{opacity:1,color:'#2E3F4F',marginBottom:10},currentlySignedInTitle:{fontSize:'16px',lineHeight:'24px',fontWeight:'bold',color:'#2E3F4F',opacity:1},successAnimationSVG:{height:'56px',width:'56px',margin:'0 auto 1.5rem',color:'#2FA5E7'},buttonsContainer:{padding:'53px 0 0'},buttonRoot:{margin:'0 5px',minWidth:'157px'}};};var SubscriptionSuccessful=(_dec=Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(SubscriptionSuccessful,_Component);function SubscriptionSuccessful(props){var _this;__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this,SubscriptionSuccessful);_this=__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(SubscriptionSuccessful).call(this,props));var savedCheckoutPlanId=Object(__WEBPACK_IMPORTED_MODULE_21__utils_storage__["i" /* getCheckoutPlan */])();var savedCheckoutSeatsQuantity=Object(__WEBPACK_IMPORTED_MODULE_21__utils_storage__["j" /* getCheckoutSeatsQuantity */])();var wasPerpertualPlanPurchased=Object(__WEBPACK_IMPORTED_MODULE_16__utils_subscription__["t" /* isPerpetualPlan */])(savedCheckoutPlanId);var isDesktopOnly=Object(__WEBPACK_IMPORTED_MODULE_16__utils_subscription__["q" /* isDesktopOnlyPlan */])(savedCheckoutPlanId);var activeSubscription=Object(__WEBPACK_IMPORTED_MODULE_16__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(savedCheckoutPlanId);var plan=activeSubscription.plan;if(plan){var planName;if(wasPerpertualPlanPurchased){var addonData=Object(__WEBPACK_IMPORTED_MODULE_17__utils_downloads__["a" /* getAddonDataForDownload */])(__WEBPACK_IMPORTED_MODULE_14__config__["X" /* MAP_ADDON_TO_LATEST_VERSION */][plan]);planName=addonData.title;}else{planName=__WEBPACK_IMPORTED_MODULE_14__config__["_3" /* PACKAGES_CONFIG */][plan].title;}_this.state=__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({savedCheckoutPlanId:savedCheckoutPlanId,planName:Object(__WEBPACK_IMPORTED_MODULE_28_utils_string__["b" /* stripHTML */])(planName)},savedCheckoutSeatsQuantity&&{savedCheckoutSeatsQuantity:savedCheckoutSeatsQuantity},{isDesktopOnly:isDesktopOnly,wasPerpertualPlanPurchased:wasPerpertualPlanPurchased});}else{_this.state={missingPlanId:true};}return _this;}__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(SubscriptionSuccessful,[{key:"render",value:function render(){var _this2=this;var _this$props=this.props,classes=_this$props.classes,selectedCompanyId=_this$props.selectedCompanyId;if(this.state.missingPlanId){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:classes.successMessageContainer},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__theme_icons__["Z" /* SuccessIcon */],{className:classes.successAnimationSVG}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Typography___default.a,{className:classes.title,variant:"h2"},localize('purchase-successful-thanks')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:classes.buttonsContainer},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button___default.a,{"data-tid":"button-success-see-my-plans",variant:"outlined",color:"primary",classes:{root:classes.buttonRoot},onClick:function onClick(){_this2.props.history.push({pathname:Object(__WEBPACK_IMPORTED_MODULE_13_routes__["w" /* getRoute */])(__WEBPACK_IMPORTED_MODULE_13_routes__["n" /* SUBSCRIPTION */],selectedCompanyId),state:{preselectSubscriptionView:__WEBPACK_IMPORTED_MODULE_14__config__["_45" /* SUBSCRIPTION_VIEW */].CURRENT_PRODUCTS}});}},localize('subscription-successful-see-plans'))));}var nrOfProductUserOwns=Object(__WEBPACK_IMPORTED_MODULE_16__utils_subscription__["j" /* getTotalProductsForCompany */])(this.props.company);if(nrOfProductUserOwns===0&&!this.state.wasPerpertualPlanPurchased){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:classes.successMessageContainer},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Typography___default.a,{className:classes.title,variant:"h2"},localize('subscription-successful-not-found')));}return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:classes.successMessageContainer},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__theme_icons__["Z" /* SuccessIcon */],{className:classes.successAnimationSVG}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Typography___default.a,{className:classes.title,variant:"h2"},localize(this.state.wasPerpertualPlanPurchased?'purchase-successful-thanks':'subscription-successful-thanks')),this.state.isDesktopOnly?__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Typography___default.a,{variant:"body1",className:classes.description},localize(this.state.wasPerpertualPlanPurchased?'subscription-successful-purchased':'subscription-successful-upgraded-to')," ",__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("strong",null,this.state.planName),"."),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Typography___default.a,{variant:"body1",className:classes.description,dangerouslySetInnerHTML:{__html:localize('subscription-successful-activation-email',__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(this.props.user,'mainEmail'))}}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:classes.buttonsContainer},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button___default.a,{"data-tid":"button-success-see-my-plans",variant:"outlined",color:"primary",classes:{root:classes.buttonRoot},onClick:function onClick(){_this2.props.history.push({pathname:Object(__WEBPACK_IMPORTED_MODULE_13_routes__["w" /* getRoute */])(__WEBPACK_IMPORTED_MODULE_13_routes__["n" /* SUBSCRIPTION */],selectedCompanyId),state:{preselectSubscriptionView:__WEBPACK_IMPORTED_MODULE_14__config__["_45" /* SUBSCRIPTION_VIEW */].CURRENT_PRODUCTS}});}},localize('subscription-successful-see-plans')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button___default.a,{"data-tid":"button-download-product",variant:"contained",color:"primary",classes:{root:classes.buttonRoot},onClick:function onClick(){if(_this2.state.wasPerpertualPlanPurchased){var plan=_this2.state.savedCheckoutPlanId.split('-')[0];var addonData=Object(__WEBPACK_IMPORTED_MODULE_17__utils_downloads__["a" /* getAddonDataForDownload */])(__WEBPACK_IMPORTED_MODULE_14__config__["X" /* MAP_ADDON_TO_LATEST_VERSION */][plan]);_this2.onDownloadClick(addonData.downloadUrl,addonData.storageKey,addonData.trackingKey);}else{var activeSubscription=Object(__WEBPACK_IMPORTED_MODULE_16__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(_this2.state.savedCheckoutPlanId);var _plan=activeSubscription.plan;var _DESKTOP_APPS$_plan$t=__WEBPACK_IMPORTED_MODULE_14__config__["C" /* DESKTOP_APPS */][_plan.toUpperCase()],downloadUrl=_DESKTOP_APPS$_plan$t.downloadUrl,storageKey=_DESKTOP_APPS$_plan$t.storageKey,trackingKey=_DESKTOP_APPS$_plan$t.trackingKey;_this2.onDownloadClick(downloadUrl,storageKey,trackingKey);}}},localize('subscription-successful-download-products')))):__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Typography___default.a,{variant:"body1",className:classes.description},localize('subscription-successful-upgraded')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:classes.buttonsContainer},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button___default.a,{"data-tid":"button-success-see-my-plans",variant:"outlined",color:"primary",classes:{root:classes.buttonRoot},onClick:function onClick(){_this2.props.history.push({pathname:Object(__WEBPACK_IMPORTED_MODULE_13_routes__["w" /* getRoute */])(__WEBPACK_IMPORTED_MODULE_13_routes__["n" /* SUBSCRIPTION */],selectedCompanyId),state:{preselectSubscriptionView:__WEBPACK_IMPORTED_MODULE_14__config__["_45" /* SUBSCRIPTION_VIEW */].CURRENT_PRODUCTS}});}},localize('subscription-successful-see-plans')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button___default.a,{"data-tid":"button-success-start-creating",variant:"contained",color:"primary",classes:{root:classes.buttonRoot},onClick:function onClick(){window.location.href=__WEBPACK_IMPORTED_MODULE_14__config__["_65" /* XC_URL */];}},localize('subscription-successful-start-creating')))));}},{key:"componentDidMount",value:function componentDidMount(){var _this3=this;if(this.state.savedCheckoutPlanId){var activeSubscription=Object(__WEBPACK_IMPORTED_MODULE_16__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(this.state.savedCheckoutPlanId);var period=activeSubscription.period,plan=activeSubscription.plan;if(this.isCloudPlan()){this.props.getDesktopAppFlag();}var savedCredentials=Object(__WEBPACK_IMPORTED_MODULE_21__utils_storage__["r" /* getMagixDiscountCredentials */])();// For initial purchase user gets redirected to external page
// so when seeing this page redux this.props.crs.isDiscountApplied prop does not exist
// but we can check for savedCredentials which is only saved if 
// this.props.crs.isDiscountApplied is true during checkout
if(savedCredentials&&(period===__WEBPACK_IMPORTED_MODULE_14__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL||period===__WEBPACK_IMPORTED_MODULE_14__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL)){if(savedCredentials){// Save data to mkdb.crs_store db table;
this.props.updateUsage(savedCredentials.email,savedCredentials.serial,__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(this.props.user,'mainEmail'),this.state.wasPerpertualPlanPurchased?__WEBPACK_IMPORTED_MODULE_14__config__["Y" /* MAXIC_DISCOUNT_PROD_TYPE */].PERPETUAL:__WEBPACK_IMPORTED_MODULE_14__config__["Y" /* MAXIC_DISCOUNT_PROD_TYPE */].SUBSCRIPTION);Object(__WEBPACK_IMPORTED_MODULE_21__utils_storage__["g" /* clearMagixDiscountCredentials */])();this.props.clearCrsCredentials();this.props.clearAppliedDiscount();// Update mxDiscountUsed flag only for subscriptions;
// user can buy perpetual products unlimited times using magix discount
if(period===__WEBPACK_IMPORTED_MODULE_14__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL){this.props.writeCompanySettings({mxDiscountUsed:true});}}}var isFirstOrder=Object(__WEBPACK_IMPORTED_MODULE_21__utils_storage__["o" /* getIsFirstOrder */])();if(isFirstOrder&&this.props.subscriptionId&&!this.state.wasPerpertualPlanPurchased){/* eslint-disable no-undef */typeof _refersion!=='undefined'&&_refersion(function(){if(typeof _rfsn!=='undefined'){_rfsn._addCart(_this3.props.subscriptionId);_rfsn._setSource('CHARGEBEE');}});}if(this.state.wasPerpertualPlanPurchased){var _convertPlanIdIntoSub=Object(__WEBPACK_IMPORTED_MODULE_16__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(this.state.savedCheckoutPlanId),currency=_convertPlanIdIntoSub.currency;if(currency===__WEBPACK_IMPORTED_MODULE_14__config__["x" /* CURRENCIES */].EUR.key){this.writePendingPaymentToCompanySettings();}Object(__WEBPACK_IMPORTED_MODULE_22_lib_Segment_customTrackers__["Q" /* trackSubscriptionSuccessful */])(this.props.selectedCompanyId,this.state.savedCheckoutPlanId,'perpetual-order',Object(__WEBPACK_IMPORTED_MODULE_23_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}else{this.writePendingSubscriptionToCompanySettings();var reUpgradePopupPlan=Object(__WEBPACK_IMPORTED_MODULE_21__utils_storage__["s" /* getReUpgradePopupPlan */])();if(reUpgradePopupPlan===plan&&Object(__WEBPACK_IMPORTED_MODULE_21__utils_storage__["q" /* getIsReUpgradePopupFlag */])()){Object(__WEBPACK_IMPORTED_MODULE_22_lib_Segment_customTrackers__["C" /* trackPaywallConverstion */])(plan,this.props.selectedCompanyId,Object(__WEBPACK_IMPORTED_MODULE_23_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));Object(__WEBPACK_IMPORTED_MODULE_21__utils_storage__["h" /* clearReUpgradePopupPlan */])();Object(__WEBPACK_IMPORTED_MODULE_21__utils_storage__["f" /* clearIsReUpgradePopupFlag */])();}Object(__WEBPACK_IMPORTED_MODULE_22_lib_Segment_customTrackers__["Q" /* trackSubscriptionSuccessful */])(this.props.selectedCompanyId,this.state.savedCheckoutPlanId,isFirstOrder?'first-order':'plan-upgrade',Object(__WEBPACK_IMPORTED_MODULE_23_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}}}},{key:"isCloudPlan",value:function isCloudPlan(){if(this.state.savedCheckoutPlanId){var activeSubscription=Object(__WEBPACK_IMPORTED_MODULE_16__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(this.state.savedCheckoutPlanId);var plan=activeSubscription.plan;return __WEBPACK_IMPORTED_MODULE_14__config__["_3" /* PACKAGES_CONFIG */][plan].isCloudSuitePlan;}else{return false;}}},{key:"writePendingPaymentToCompanySettings",value:function writePendingPaymentToCompanySettings(){var pendingPerpetualPlans=Object(__WEBPACK_IMPORTED_MODULE_16__utils_subscription__["g" /* getPendingPerpetualPlans */])(this.props.company);pendingPerpetualPlans[this.state.savedCheckoutPlanId]=true;this.props.writeCompanySettings({pendingPerpetualPlans:pendingPerpetualPlans});}// write pending subscription to use it in the future in this company only
},{key:"writePendingSubscriptionToCompanySettings",value:function writePendingSubscriptionToCompanySettings(){this.props.writeCompanySettings(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({pendingSubscription:this.state.savedCheckoutPlanId},this.state.savedCheckoutSeatsQuantity&&{pendingSeatsQuantity:this.state.savedCheckoutSeatsQuantity}));}},{key:"onDownloadClick",value:function onDownloadClick(downloadUrl,storageKey,trackingKey){Object(__WEBPACK_IMPORTED_MODULE_17__utils_downloads__["b" /* trackAndDownload */])(this.props,downloadUrl,storageKey,trackingKey,Object(__WEBPACK_IMPORTED_MODULE_23_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}}]);return SubscriptionSuccessful;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]))||_class);SubscriptionSuccessful.propTypes={company:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.object,classes:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.object,companies:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.object,history:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.object,selectedCompanyId:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string,clearCrsCredentials:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,clearAppliedDiscount:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,writeCompanySettings:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,crs:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.object.isRequired,updateUsage:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func.isRequired,user:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.object.isRequired,getDesktopAppFlag:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,subscriptionId:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string,settings:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.object,writeUserSettings:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func// action creator from session module
};var mapStateToProps=function mapStateToProps(state){return{crs:state.crs,user:state.session.user,settings:state.session.user.settings,company:state.companies.rawDataById[state.companies.selectedId],selectedCompanyId:state.companies.selectedId};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])({writeUserSettings:__WEBPACK_IMPORTED_MODULE_20_redux_modules_session__["d" /* writeUserSettings */],getDesktopAppFlag:__WEBPACK_IMPORTED_MODULE_26__redux_modules_app__["d" /* getDesktopAppFlag */],clearCrsCredentials:__WEBPACK_IMPORTED_MODULE_18__redux_modules_crs__["c" /* clearCrsCredentials */],clearAppliedDiscount:__WEBPACK_IMPORTED_MODULE_19__redux_modules_discount__["f" /* clearAppliedDiscount */],writeCompanySettings:__WEBPACK_IMPORTED_MODULE_27__redux_modules_companies__["R" /* writeCompanySettings */],updateUsage:__WEBPACK_IMPORTED_MODULE_18__redux_modules_crs__["f" /* updateUsage */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(SubscriptionSuccessful));

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Header__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Description__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_FormLabel__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_FormField__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_AutoComplete__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_StickyHeader_StickyHeader__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_Button__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_redux_modules_companies__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_i18n_i18n__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__material_ui_core_Select__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__material_ui_icons_KeyboardArrowDown__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__material_ui_icons_KeyboardArrowDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__material_ui_icons_KeyboardArrowDown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__material_ui_core_FormHelperText__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__material_ui_core_MenuItem__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__material_ui_core_Typography__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__CompanyProfileSchema__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_utils_state__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_redux_store__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_redux_modules_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_components_CenteredContent_CenteredContent__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__theme_uiConfig__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_utils_language__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__errors_errorids__ = __webpack_require__(22);
var _errors,_dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_23_i18n_i18n__["a" /* default */].loc.localize;var styles=function styles(theme){return{button:{width:200},bottomBorder:{paddingBottom:3*theme.spacing.unit},details:{paddingBottom:theme.spacing.unit*4},detailsContainer:{marginTop:theme.spacing.unit*2},field:{width:240,margin:'0 0 5px 0','&:focus':{outline:'none'}},'root':{'&$error':{marginTop:10,marginBottom:15,fontSize:'0.8rem'}},'error':{},fieldDescription:{marginTop:5,width:300,marginLeft:18,'& sup':{marginLeft:-10,marginRight:3}},errorMessage:{color:theme.palette.error.main,opacity:1,marginTop:15,marginBottom:0,width:'100%'}};};var DEFAULT_INDUSTRY={industryId:1000,industry:'Other'};var onLeaveMessage=localize('leave-page-confirmation');var errors=(_errors={},__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_37__errors_errorids__["a" /* default */].OFFLINE,localize('subscriptions-error-offline')),__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_37__errors_errorids__["a" /* default */].API_REQUEST_LIMIT_EXCEEDED,localize('error-cb-api-rate-limit-reached')),_errors);var CompanyProfile=(_dec=Object(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(CompanyProfile,_Component);function CompanyProfile(props){var _this;__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this,CompanyProfile);_this=__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(CompanyProfile).call(this));var companyData=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.pick(props.company,Object.keys(__WEBPACK_IMPORTED_MODULE_30__CompanyProfileSchema__["a" /* default */]));companyData.language=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(props.company,'settings.languageLocaleCode')||'';_this.state={values:companyData,touched:{},errors:{},companySizes:[],companyLanguages:__WEBPACK_IMPORTED_MODULE_36_utils_language__["a" /* LOCALES_MAPPING */].sort(function(a,b){var languageA=a.language;var languageB=b.language;if(languageA<languageB){return-1;}if(languageA>languageB){return 1;}return 0;}),companyIndustries:[],companyCountries:[]};_this.onBeforeUnload=_this.onBeforeUnload.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.validateCompany=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.debounce(props.validateCompany,__WEBPACK_IMPORTED_MODULE_35__theme_uiConfig__["g" /* typingDebounceTimeout */]);return _this;}__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(CompanyProfile,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_32_redux_store__["c" /* setConfirmationFunction */])(function(message,callback){_this2.doIfCanLeave(callback);});this.historyUnblock=__WEBPACK_IMPORTED_MODULE_32_redux_store__["b" /* history */].block('');window.addEventListener('beforeunload',this.onBeforeUnload);}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.historyUnblock();Object(__WEBPACK_IMPORTED_MODULE_32_redux_store__["c" /* setConfirmationFunction */])(null);window.removeEventListener('beforeunload',this.onBeforeUnload);}},{key:"onChange",value:function onChange(event,name){this.setFieldState(name,event.target.value);}},{key:"setFieldState",value:function setFieldState(fieldName,value){var newState=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.cloneDeep(this.state);newState.values[fieldName]=value;this.setState(newState,this.validateAll);}},{key:"setIndustryFieldState",value:function setIndustryFieldState(){var fieldName=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'industry';var value=arguments.length>1?arguments[1]:undefined;var newState=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.cloneDeep(this.state);newState.values[fieldName]=value;var validIndustry=this.props.companyIndustries.find(function(industry){return industry.displayName===value;});if(validIndustry){newState.values.industryId=validIndustry.industryId;}this.setState(newState,this.validateAll);}},{key:"onBlur",value:function onBlur(event,name){var newState=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.cloneDeep(this.state);newState.touched[name]=true;this.setState(newState,this.validateAll);}},{key:"validateAll",value:function validateAll(){var errors={};for(var field in __WEBPACK_IMPORTED_MODULE_30__CompanyProfileSchema__["a" /* default */]){var validate=__WEBPACK_IMPORTED_MODULE_30__CompanyProfileSchema__["a" /* default */][field];if(validate){var error=validate(this.state.values[field],this.state,this.props);if(error){errors[field]=error;}}}this.setState({errors:errors});}},{key:"hasUnsavedData",value:function hasUnsavedData(){var changed=this.getChangedData();return!__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.isEmpty(changed);}},{key:"doIfCanLeave",value:function doIfCanLeave(callback){if(!this.hasUnsavedData()){callback(true);return;}this.props.showModal('CONFIRMATION_MODAL',{message:onLeaveMessage,buttons:[__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Button___default.a,{key:"button-cancel",variant:"outlined",color:"primary","data-tid":"button-company-profile-company-stay",onClick:function onClick(){callback(false);}},localize('stay-on-page')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Button___default.a,{key:"button-confirm","data-tid":"button-company-profile-company-leave",variant:"contained",color:"primary",onClick:function onClick(){callback(true);}},localize('leave-page'))]});}},{key:"onBeforeUnload",value:function onBeforeUnload(e){if(this.hasUnsavedData()){var dialogText=onLeaveMessage;e.returnValue=dialogText;return dialogText;}}},{key:"field",value:function field(name,placeholder){var _this3=this;var _this$props=this.props,classes=_this$props.classes,isAdmin=_this$props.isAdmin;var errorClasses={root:classes.root,error:classes.error};return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_FormField__["a" /* default */],{value:this.state.values[name],className:classes.field,"data-tid":"form-company-profile-".concat(name),onChange:function onChange(event){return _this3.onChange(event,name);},onBlur:function onBlur(event){return _this3.onBlur(event,name);},id:name,placeholder:placeholder,margin:"normal",helperText:this.state.errors[name],error:!!this.state.errors[name],FormHelperTextProps:{classes:errorClasses},disabled:!isAdmin});}},{key:"fieldTeamName",value:function fieldTeamName(name,placeholder){var _this4=this;return Object(__WEBPACK_IMPORTED_MODULE_8_react__["cloneElement"])(this.field(name,placeholder),{onChange:function onChange(event){_this4.onChange(event,name);event.target.value!==''&&event.target.value!==_this4.props.company.displayName&&_this4.validateCompany(event.target.value);},helperText:this.state.errors[name]||!this.props.isNameValid&&localize('company-profile-team-name-taken'),error:this.state.errors[name]||!this.props.isNameValid});}},{key:"updateCompany",value:function updateCompany(companyId,changed){//[P9052-11080] Use industryId over existing industry information, default is other
if(changed.industry===''){changed=__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},changed,DEFAULT_INDUSTRY);}if(changed.language){this.saveCompanyLanguage();delete changed.language;}if(!__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.isEmpty(changed)){this.props.updateCompany(companyId,changed);}}},{key:"saveCompanyLanguage",value:function saveCompanyLanguage(){this.props.writeCompanySettings({languageLocaleCode:this.state.values.language});}},{key:"getChangedData",value:function getChangedData(){var _this5=this;return __WEBPACK_IMPORTED_MODULE_24_lodash___default.a.pickBy(__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.omit(this.state.values,['industry']),function(value,field){return field!=='language'&&_this5.props.company[field]!==value||field==='language'&&value!==__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(_this5.props.company,'settings.languageLocaleCode')&&value!=='';});}},{key:"render",value:function render(){var _this6=this;var _this$props2=this.props,classes=_this$props2.classes,company=_this$props2.company,companyIsUpdating=_this$props2.companyIsUpdating,isAdmin=_this$props2.isAdmin,isNameValid=_this$props2.isNameValid;var readOnly=!isAdmin;var changed=this.getChangedData();var canSave=Object.keys(changed).length&&!Object.keys(this.state.errors).length&&!companyIsUpdating&&isNameValid;var errorClasses={root:classes.root,error:classes.error};//[P9052-11080] Use industryId over existing industry information
var initialIndustry='';if(this.props.company.industryId&&this.state.values.industry===null){initialIndustry=(this.props.companyIndustries.find(function(industry){return industry.industryId===_this6.props.company.industryId;})||{}).displayName||'';}var saveButton=__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Button___default.a,{variant:"contained",color:"primary","data-tid":"button-company-profile-save",className:classes.button,onClick:function onClick(){return _this6.updateCompany(company.id,changed);},disabled:!canSave||readOnly},localize('save'));var renderErrorMessage=function renderErrorMessage(){if(!_this6.props.companies.companyIsUpdating&&_this6.props.companies.companyUpdatingErrorId||__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(_this6.props.company,'companySettingsUpdatingErrorId')){var errorMessage=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(_this6.props.company,'companySettingsUpdatingErrorId')?errors[_this6.props.company.companySettingsUpdatingErrorId]||localize('company-profile-settings-error'):errors[_this6.props.companies.companyUpdatingErrorId]||localize('subscriptions-error-unknown');return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__material_ui_core_Typography___default.a,{className:classes.errorMessage,variant:"body2",dangerouslySetInnerHTML:{__html:errorMessage}});}};return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34_components_CenteredContent_CenteredContent__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_StickyHeader_StickyHeader__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Header__["a" /* default */],null,localize('company-profile-header')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Description__["a" /* default */],null,localize(readOnly?'company-profile-description-read-only':'company-profile-description')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{container:true,className:classes.details},saveButton,renderErrorMessage())),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{container:true,className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()(classes.detailsContainer,classes.bottomBorder)},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_FormLabel__["a" /* default */],{title:localize('required-field'),required:true},localize('company-profile-team-name')),this.fieldTeamName('displayName',localize('company-profile-team-name-placeholder'))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_FormLabel__["a" /* default */],{required:true},localize('company-profile-language')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core_Select___default.a,{"data-tid":"select-company-profile-company-language",className:classes.field,value:this.state.values.language,name:"language",displayEmpty:true,disableUnderline:true,IconComponent:__WEBPACK_IMPORTED_MODULE_26__material_ui_icons_KeyboardArrowDown___default.a,onChange:function onChange(event){var newState=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.cloneDeep(_this6.state);newState.values['language']=event.target.value;_this6.setState(newState);},disabled:readOnly},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__material_ui_core_MenuItem___default.a,{value:"",disabled:true},localize('company-profile-language-selector')),this.state.companyLanguages.map(function(option){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__material_ui_core_MenuItem___default.a,{key:option.locale,value:option.locale,"data-tid":"select-company-profile-company-language-".concat(option.locale)},option.language," - ",option.country);}))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_FormLabel__["a" /* default */],{title:localize('required-field'),required:true},localize('company-profile-email')),this.field('email',localize('company-profile-email-placeholder')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__material_ui_core_Typography___default.a,{className:classes.fieldDescription,variant:"body2"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("sup",null,"*"),localize('company-profile-email-description',company.displayName))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_FormLabel__["a" /* default */],null,localize('company-profile-address')),this.field('address1',localize('company-profile-address1-placeholder')),this.field('address2',localize('company-profile-address2-placeholder')),this.field('city',localize('company-profile-city-placeholder')),this.field('region',localize('company-profile-region-placeholder')),this.field('postcode',localize('company-profile-postcode-placeholder')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_AutoComplete__["a" /* default */],{inputProps:{value:this.state.values.country,onChange:function onChange(event,_ref){var newValue=_ref.newValue;_this6.setFieldState('country',newValue);},onBlur:function onBlur(event){_this6.onBlur(event,'country');},placeholder:localize('company-profile-country-placeholder'),disabled:readOnly},suggestions:this.props.companyCountries}),this.state.errors['country']&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core_FormHelperText___default.a,{error:true,classes:errorClasses},this.state.errors['country'])),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_FormLabel__["a" /* default */],null,localize('company-profile-phone')),this.field('phone',localize('company-profile-phone-placeholder'))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_FormLabel__["a" /* default */],null,localize('company-profile-website')),this.field('website',localize('company-profile-website-placeholder'))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_FormLabel__["a" /* default */],null,localize('company-profile-industry')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core_Select___default.a,{"data-tid":"select-company-profile-company-industry",className:classes.field,value:this.state.values.industry||initialIndustry,name:"industry",displayEmpty:true,disableUnderline:true,IconComponent:__WEBPACK_IMPORTED_MODULE_26__material_ui_icons_KeyboardArrowDown___default.a,onChange:function onChange(event){_this6.setIndustryFieldState('industry',event.target.value);},disabled:readOnly},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__material_ui_core_MenuItem___default.a,{value:"",disabled:true},localize('company-profile-industry-selector')),this.props.companyIndustries.map(function(industry){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__material_ui_core_MenuItem___default.a,{key:industry.displayName,value:industry.displayName,"data-tid":"select-company-profile-company-industry-".concat(industry.displayName)},industry.displayName);}))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_FormLabel__["a" /* default */],null,localize('company-profile-size')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core_Select___default.a,{"data-tid":"select-company-profile-company-size",className:classes.field,value:this.state.values.size,name:"size",displayEmpty:true,disableUnderline:true,IconComponent:__WEBPACK_IMPORTED_MODULE_26__material_ui_icons_KeyboardArrowDown___default.a,onChange:function onChange(event){var newState=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.cloneDeep(_this6.state);newState.values['size']=event.target.value;_this6.setState(newState);},disabled:readOnly},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__material_ui_core_MenuItem___default.a,{value:"",disabled:true},localize('company-profile-size-selector')),this.props.companySizes.map(function(option){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__material_ui_core_MenuItem___default.a,{key:option,value:option,"data-tid":"select-company-profile-company-size-".concat(option)},option);})))));}}]);return CompanyProfile;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]))||_class);var mapStateToProps=function mapStateToProps(state){return{companies:state.companies,company:state.companies.rawDataById[state.companies.selectedId],companyIsUpdating:state.companies.companyIsUpdating,companySizes:state.companies.sizes,companyIndustries:state.companies.industries,companyCountries:state.companies.countries,isAdmin:Object(__WEBPACK_IMPORTED_MODULE_31_utils_state__["a" /* isAdmin */])(state),isNameValid:state.companies.valid};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_17_redux__["b" /* bindActionCreators */])({writeCompanySettings:__WEBPACK_IMPORTED_MODULE_22_redux_modules_companies__["R" /* writeCompanySettings */],validateCompany:__WEBPACK_IMPORTED_MODULE_22_redux_modules_companies__["Q" /* validateCompany */],updateCompany:__WEBPACK_IMPORTED_MODULE_22_redux_modules_companies__["K" /* updateCompany */],showModal:__WEBPACK_IMPORTED_MODULE_33_redux_modules_modal__["d" /* showModal */]},dispatch);};CompanyProfile.propTypes={classes:__WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.object,cloudFolders:__WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.object,company:__WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.object,validateCompany:__WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.func.isRequired,updateCompany:__WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.func.isRequired,companyIsUpdating:__WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.bool.isRequired,companySizes:__WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.array.isRequired,companyIndustries:__WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.array.isRequired,companyCountries:__WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.array.isRequired,isAdmin:__WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.bool,showModal:__WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.func,isNameValid:__WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.bool,companies:__WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.object,writeCompanySettings:__WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.func};CompanyProfile.defaultProps={company:{}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_15_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(CompanyProfile));

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_autosuggest__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_autosuggest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_autosuggest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Paper__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Paper__);
var _dec,_class;var transitionProperties=' 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms';var placeholderStyles={fontStyle:'italic',opacity:'0.42',transition:"opacity ".concat(transitionProperties)};var styles=function styles(theme){return{autosuggestInput:__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_objectSpread___default()({},theme.overrides.MuiInput.input,theme.overrides.MuiInput.root,{outline:'none','&::-webkit-input-placeholder':placeholderStyles,'&::-moz-placeholder':placeholderStyles,'&:-ms-input-placeholder':placeholderStyles,'&::-ms-input-placeholder':placeholderStyles,fontSize:14,transition:"border-radius ".concat(transitionProperties)}),autosuggestInputOpen:{borderBottomRightRadius:0,borderBottomLeftRadius:0,transition:"border-radius ".concat(transitionProperties)},autosuggestContainer:{position:'relative',width:240,marginBottom:5},autosuggestSuggestionsContainer:{opacity:0,transition:"opacity ".concat(transitionProperties)},autosuggestSuggestionsContainerOpen:{position:'absolute',marginTop:0,borderRadius:'0px 0px 20px 20px',zIndex:1,left:1,right:1,overflow:'hidden',opacity:1,transition:"opacity ".concat(transitionProperties)},autosuggestSuggestionHighlighted:{backgroundColor:'rgba(0, 0, 0, 0.08)'},autosuggestSuggestion:{display:'block'},menuItem:{fontSize:14,paddingTop:6,paddingBottom:6},autosuggestSuggestionsList:{margin:0,padding:'5px 0',listStyleType:'none',maxHeight:200,overflowY:'auto'},disabled:{}};};var AutoComplete=(_dec=Object(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(AutoComplete,_Component);function AutoComplete(props){var _this;__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,AutoComplete);_this=__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(AutoComplete).call(this));__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this),"getSuggestions",function(value){var inputValue=value.trim().toLowerCase();var inputLength=inputValue.length;return inputLength===0?[]:_this.props.suggestions.filter(function(option){return option.toLowerCase().indexOf(inputValue)===0;});});__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this),"onSuggestionsFetchRequested",function(_ref){var value=_ref.value;_this.setState({suggestions:_this.getSuggestions(value)});});__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this),"onSuggestionsClearRequested",function(){_this.setState({suggestions:[]});});__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this),"getSuggestionValue",function(suggestion){return suggestion;});__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this),"renderSuggestionsContainer",function(options){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Paper___default.a,options.containerProps,options.children);});__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this),"renderSuggestion",function(suggestion,_ref2){var query=_ref2.query,isHighlighted=_ref2.isHighlighted;var classes=_this.props.classes;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem___default.a,{className:classes.menuItem,selected:isHighlighted,component:"div"},suggestion);});_this.state={suggestions:[]};return _this;}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(AutoComplete,[{key:"render",value:function render(){var _this$props=this.props,classes=_this$props.classes,inputProps=_this$props.inputProps;inputProps.autoComplete='new-password';inputProps.spellCheck='false';return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_autosuggest___default.a,{theme:{input:classes.autosuggestInput,inputOpen:classes.autosuggestInputOpen,container:classes.autosuggestContainer,suggestionsContainer:classes.autosuggestSuggestionsContainer,suggestionsContainerOpen:classes.autosuggestSuggestionsContainerOpen,suggestionsList:classes.autosuggestSuggestionsList,suggestion:classes.autosuggestSuggestion,suggestionHighlighted:classes.autosuggestSuggestionHighlighted},inputProps:inputProps,suggestions:this.state.suggestions,onSuggestionsFetchRequested:this.onSuggestionsFetchRequested,onSuggestionsClearRequested:this.onSuggestionsClearRequested,getSuggestionValue:this.getSuggestionValue,renderSuggestion:this.renderSuggestion,renderSuggestionsContainer:this.renderSuggestionsContainer});}}]);return AutoComplete;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]))||_class);AutoComplete.propTypes={suggestions:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.array.isRequired,classes:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,inputProps:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (AutoComplete);

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1112).default;

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _arrays = __webpack_require__(1113);

var _arrays2 = _interopRequireDefault(_arrays);

var _reactAutowhatever = __webpack_require__(1114);

var _reactAutowhatever2 = _interopRequireDefault(_reactAutowhatever);

var _theme = __webpack_require__(1122);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var alwaysTrue = function alwaysTrue() {
  return true;
};
var defaultShouldRenderSuggestions = function defaultShouldRenderSuggestions(value) {
  return value.trim().length > 0;
};
var defaultRenderSuggestionsContainer = function defaultRenderSuggestionsContainer(_ref) {
  var containerProps = _ref.containerProps,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    containerProps,
    children
  );
};

var Autosuggest = function (_Component) {
  _inherits(Autosuggest, _Component);

  function Autosuggest(_ref2) {
    var alwaysRenderSuggestions = _ref2.alwaysRenderSuggestions;

    _classCallCheck(this, Autosuggest);

    var _this = _possibleConstructorReturn(this, (Autosuggest.__proto__ || Object.getPrototypeOf(Autosuggest)).call(this));

    _initialiseProps.call(_this);

    _this.state = {
      isFocused: false,
      isCollapsed: !alwaysRenderSuggestions,
      highlightedSectionIndex: null,
      highlightedSuggestionIndex: null,
      highlightedSuggestion: null,
      valueBeforeUpDown: null
    };

    _this.justPressedUpDown = false;
    _this.justMouseEntered = false;

    _this.pressedSuggestion = null;
    return _this;
  }

  _createClass(Autosuggest, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.onDocumentMouseDown);
      document.addEventListener('mouseup', this.onDocumentMouseUp);

      this.input = this.autowhatever.input;
      this.suggestionsContainer = this.autowhatever.itemsContainer;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ((0, _arrays2.default)(nextProps.suggestions, this.props.suggestions)) {
        if (nextProps.highlightFirstSuggestion && nextProps.suggestions.length > 0 && this.justPressedUpDown === false && this.justMouseEntered === false) {
          this.highlightFirstSuggestion();
        }
      } else {
        if (this.willRenderSuggestions(nextProps)) {
          if (this.state.isCollapsed && !this.justSelectedSuggestion) {
            this.revealSuggestions();
          }
        } else {
          this.resetHighlightedSuggestion();
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _props = this.props,
          suggestions = _props.suggestions,
          onSuggestionHighlighted = _props.onSuggestionHighlighted,
          highlightFirstSuggestion = _props.highlightFirstSuggestion;


      if (!(0, _arrays2.default)(suggestions, prevProps.suggestions) && suggestions.length > 0 && highlightFirstSuggestion) {
        this.highlightFirstSuggestion();
        return;
      }

      if (onSuggestionHighlighted) {
        var highlightedSuggestion = this.getHighlightedSuggestion();
        var prevHighlightedSuggestion = prevState.highlightedSuggestion;

        if (highlightedSuggestion != prevHighlightedSuggestion) {
          onSuggestionHighlighted({
            suggestion: highlightedSuggestion
          });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.onDocumentMouseDown);
      document.removeEventListener('mouseup', this.onDocumentMouseUp);
    }
  }, {
    key: 'updateHighlightedSuggestion',
    value: function updateHighlightedSuggestion(sectionIndex, suggestionIndex, prevValue) {
      var _this2 = this;

      this.setState(function (state) {
        var valueBeforeUpDown = state.valueBeforeUpDown;


        if (suggestionIndex === null) {
          valueBeforeUpDown = null;
        } else if (valueBeforeUpDown === null && typeof prevValue !== 'undefined') {
          valueBeforeUpDown = prevValue;
        }

        return {
          highlightedSectionIndex: sectionIndex,
          highlightedSuggestionIndex: suggestionIndex,
          highlightedSuggestion: suggestionIndex === null ? null : _this2.getSuggestion(sectionIndex, suggestionIndex),
          valueBeforeUpDown: valueBeforeUpDown
        };
      });
    }
  }, {
    key: 'resetHighlightedSuggestion',
    value: function resetHighlightedSuggestion() {
      var shouldResetValueBeforeUpDown = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.setState(function (state) {
        var valueBeforeUpDown = state.valueBeforeUpDown;


        return {
          highlightedSectionIndex: null,
          highlightedSuggestionIndex: null,
          highlightedSuggestion: null,
          valueBeforeUpDown: shouldResetValueBeforeUpDown ? null : valueBeforeUpDown
        };
      });
    }
  }, {
    key: 'revealSuggestions',
    value: function revealSuggestions() {
      this.setState({
        isCollapsed: false
      });
    }
  }, {
    key: 'closeSuggestions',
    value: function closeSuggestions() {
      this.setState({
        highlightedSectionIndex: null,
        highlightedSuggestionIndex: null,
        highlightedSuggestion: null,
        valueBeforeUpDown: null,
        isCollapsed: true
      });
    }
  }, {
    key: 'getSuggestion',
    value: function getSuggestion(sectionIndex, suggestionIndex) {
      var _props2 = this.props,
          suggestions = _props2.suggestions,
          multiSection = _props2.multiSection,
          getSectionSuggestions = _props2.getSectionSuggestions;


      if (multiSection) {
        return getSectionSuggestions(suggestions[sectionIndex])[suggestionIndex];
      }

      return suggestions[suggestionIndex];
    }
  }, {
    key: 'getHighlightedSuggestion',
    value: function getHighlightedSuggestion() {
      var _state = this.state,
          highlightedSectionIndex = _state.highlightedSectionIndex,
          highlightedSuggestionIndex = _state.highlightedSuggestionIndex;


      if (highlightedSuggestionIndex === null) {
        return null;
      }

      return this.getSuggestion(highlightedSectionIndex, highlightedSuggestionIndex);
    }
  }, {
    key: 'getSuggestionValueByIndex',
    value: function getSuggestionValueByIndex(sectionIndex, suggestionIndex) {
      var getSuggestionValue = this.props.getSuggestionValue;


      return getSuggestionValue(this.getSuggestion(sectionIndex, suggestionIndex));
    }
  }, {
    key: 'getSuggestionIndices',
    value: function getSuggestionIndices(suggestionElement) {
      var sectionIndex = suggestionElement.getAttribute('data-section-index');
      var suggestionIndex = suggestionElement.getAttribute('data-suggestion-index');

      return {
        sectionIndex: typeof sectionIndex === 'string' ? parseInt(sectionIndex, 10) : null,
        suggestionIndex: parseInt(suggestionIndex, 10)
      };
    }
  }, {
    key: 'findSuggestionElement',
    value: function findSuggestionElement(startNode) {
      var node = startNode;

      do {
        if (node.getAttribute('data-suggestion-index') !== null) {
          return node;
        }

        node = node.parentNode;
      } while (node !== null);

      console.error('Clicked element:', startNode); // eslint-disable-line no-console
      throw new Error("Couldn't find suggestion element");
    }
  }, {
    key: 'maybeCallOnChange',
    value: function maybeCallOnChange(event, newValue, method) {
      var _props$inputProps = this.props.inputProps,
          value = _props$inputProps.value,
          onChange = _props$inputProps.onChange;


      if (newValue !== value) {
        onChange(event, { newValue: newValue, method: method });
      }
    }
  }, {
    key: 'willRenderSuggestions',
    value: function willRenderSuggestions(props) {
      var suggestions = props.suggestions,
          inputProps = props.inputProps,
          shouldRenderSuggestions = props.shouldRenderSuggestions;
      var value = inputProps.value;


      return suggestions.length > 0 && shouldRenderSuggestions(value);
    }
  }, {
    key: 'getQuery',
    value: function getQuery() {
      var inputProps = this.props.inputProps;
      var value = inputProps.value;
      var valueBeforeUpDown = this.state.valueBeforeUpDown;


      return (valueBeforeUpDown === null ? value : valueBeforeUpDown).trim();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          suggestions = _props3.suggestions,
          renderInputComponent = _props3.renderInputComponent,
          onSuggestionsFetchRequested = _props3.onSuggestionsFetchRequested,
          renderSuggestion = _props3.renderSuggestion,
          inputProps = _props3.inputProps,
          multiSection = _props3.multiSection,
          renderSectionTitle = _props3.renderSectionTitle,
          id = _props3.id,
          getSectionSuggestions = _props3.getSectionSuggestions,
          theme = _props3.theme,
          getSuggestionValue = _props3.getSuggestionValue,
          alwaysRenderSuggestions = _props3.alwaysRenderSuggestions,
          highlightFirstSuggestion = _props3.highlightFirstSuggestion;
      var _state2 = this.state,
          isFocused = _state2.isFocused,
          isCollapsed = _state2.isCollapsed,
          highlightedSectionIndex = _state2.highlightedSectionIndex,
          highlightedSuggestionIndex = _state2.highlightedSuggestionIndex,
          valueBeforeUpDown = _state2.valueBeforeUpDown;

      var shouldRenderSuggestions = alwaysRenderSuggestions ? alwaysTrue : this.props.shouldRenderSuggestions;
      var value = inputProps.value,
          _onFocus = inputProps.onFocus,
          _onKeyDown = inputProps.onKeyDown;

      var willRenderSuggestions = this.willRenderSuggestions(this.props);
      var isOpen = alwaysRenderSuggestions || isFocused && !isCollapsed && willRenderSuggestions;
      var items = isOpen ? suggestions : [];
      var autowhateverInputProps = _extends({}, inputProps, {
        onFocus: function onFocus(event) {
          if (!_this3.justSelectedSuggestion && !_this3.justClickedOnSuggestionsContainer) {
            var shouldRender = shouldRenderSuggestions(value);

            _this3.setState({
              isFocused: true,
              isCollapsed: !shouldRender
            });

            _onFocus && _onFocus(event);

            if (shouldRender) {
              onSuggestionsFetchRequested({ value: value, reason: 'input-focused' });
            }
          }
        },
        onBlur: function onBlur(event) {
          if (_this3.justClickedOnSuggestionsContainer) {
            _this3.input.focus();
            return;
          }

          _this3.blurEvent = event;

          if (!_this3.justSelectedSuggestion) {
            _this3.onBlur();
            _this3.onSuggestionsClearRequested();
          }
        },
        onChange: function onChange(event) {
          var value = event.target.value;

          var shouldRender = shouldRenderSuggestions(value);

          _this3.maybeCallOnChange(event, value, 'type');

          if (_this3.suggestionsContainer) {
            _this3.suggestionsContainer.scrollTop = 0;
          }

          _this3.setState(_extends({}, highlightFirstSuggestion ? {} : {
            highlightedSectionIndex: null,
            highlightedSuggestionIndex: null,
            highlightedSuggestion: null
          }, {
            valueBeforeUpDown: null,
            isCollapsed: !shouldRender
          }));

          if (shouldRender) {
            onSuggestionsFetchRequested({ value: value, reason: 'input-changed' });
          } else {
            _this3.onSuggestionsClearRequested();
          }
        },
        onKeyDown: function onKeyDown(event, data) {
          var keyCode = event.keyCode;


          switch (keyCode) {
            case 40: // ArrowDown
            case 38:
              // ArrowUp
              if (isCollapsed) {
                if (shouldRenderSuggestions(value)) {
                  onSuggestionsFetchRequested({
                    value: value,
                    reason: 'suggestions-revealed'
                  });
                  _this3.revealSuggestions();
                }
              } else if (suggestions.length > 0) {
                var newHighlightedSectionIndex = data.newHighlightedSectionIndex,
                    newHighlightedItemIndex = data.newHighlightedItemIndex;


                var newValue = void 0;

                if (newHighlightedItemIndex === null) {
                  // valueBeforeUpDown can be null if, for example, user
                  // hovers on the first suggestion and then pressed Up.
                  // If that happens, use the original input value.
                  newValue = valueBeforeUpDown === null ? value : valueBeforeUpDown;
                } else {
                  newValue = _this3.getSuggestionValueByIndex(newHighlightedSectionIndex, newHighlightedItemIndex);
                }

                _this3.updateHighlightedSuggestion(newHighlightedSectionIndex, newHighlightedItemIndex, value);
                _this3.maybeCallOnChange(event, newValue, keyCode === 40 ? 'down' : 'up');
              }

              event.preventDefault(); // Prevents the cursor from moving

              _this3.justPressedUpDown = true;

              setTimeout(function () {
                _this3.justPressedUpDown = false;
              });

              break;

            // Enter
            case 13:
              {
                // See #388
                if (event.keyCode === 229) {
                  break;
                }

                var highlightedSuggestion = _this3.getHighlightedSuggestion();

                if (isOpen && !alwaysRenderSuggestions) {
                  _this3.closeSuggestions();
                }

                if (highlightedSuggestion != null) {
                  var _newValue = getSuggestionValue(highlightedSuggestion);

                  _this3.maybeCallOnChange(event, _newValue, 'enter');

                  _this3.onSuggestionSelected(event, {
                    suggestion: highlightedSuggestion,
                    suggestionValue: _newValue,
                    suggestionIndex: highlightedSuggestionIndex,
                    sectionIndex: highlightedSectionIndex,
                    method: 'enter'
                  });

                  _this3.justSelectedSuggestion = true;

                  setTimeout(function () {
                    _this3.justSelectedSuggestion = false;
                  });
                }

                break;
              }

            // Escape
            case 27:
              {
                if (isOpen) {
                  // If input.type === 'search', the browser clears the input
                  // when Escape is pressed. We want to disable this default
                  // behaviour so that, when suggestions are shown, we just hide
                  // them, without clearing the input.
                  event.preventDefault();
                }

                var willCloseSuggestions = isOpen && !alwaysRenderSuggestions;

                if (valueBeforeUpDown === null) {
                  // Didn't interact with Up/Down
                  if (!willCloseSuggestions) {
                    var _newValue2 = '';

                    _this3.maybeCallOnChange(event, _newValue2, 'escape');

                    if (shouldRenderSuggestions(_newValue2)) {
                      onSuggestionsFetchRequested({
                        value: _newValue2,
                        reason: 'escape-pressed'
                      });
                    } else {
                      _this3.onSuggestionsClearRequested();
                    }
                  }
                } else {
                  // Interacted with Up/Down
                  _this3.maybeCallOnChange(event, valueBeforeUpDown, 'escape');
                }

                if (willCloseSuggestions) {
                  _this3.onSuggestionsClearRequested();
                  _this3.closeSuggestions();
                } else {
                  _this3.resetHighlightedSuggestion();
                }

                break;
              }
          }

          _onKeyDown && _onKeyDown(event);
        }
      });
      var renderSuggestionData = {
        query: this.getQuery()
      };

      return _react2.default.createElement(_reactAutowhatever2.default, {
        multiSection: multiSection,
        items: items,
        renderInputComponent: renderInputComponent,
        renderItemsContainer: this.renderSuggestionsContainer,
        renderItem: renderSuggestion,
        renderItemData: renderSuggestionData,
        renderSectionTitle: renderSectionTitle,
        getSectionItems: getSectionSuggestions,
        highlightedSectionIndex: highlightedSectionIndex,
        highlightedItemIndex: highlightedSuggestionIndex,
        inputProps: autowhateverInputProps,
        itemProps: this.itemProps,
        theme: (0, _theme.mapToAutowhateverTheme)(theme),
        id: id,
        ref: this.storeAutowhateverRef
      });
    }
  }]);

  return Autosuggest;
}(_react.Component);

Autosuggest.propTypes = {
  suggestions: _propTypes2.default.array.isRequired,
  onSuggestionsFetchRequested: function onSuggestionsFetchRequested(props, propName) {
    var onSuggestionsFetchRequested = props[propName];

    if (typeof onSuggestionsFetchRequested !== 'function') {
      throw new Error("'onSuggestionsFetchRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsFetchRequestedProp");
    }
  },
  onSuggestionsClearRequested: function onSuggestionsClearRequested(props, propName) {
    var onSuggestionsClearRequested = props[propName];

    if (props.alwaysRenderSuggestions === false && typeof onSuggestionsClearRequested !== 'function') {
      throw new Error("'onSuggestionsClearRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsClearRequestedProp");
    }
  },
  onSuggestionSelected: _propTypes2.default.func,
  onSuggestionHighlighted: _propTypes2.default.func,
  renderInputComponent: _propTypes2.default.func,
  renderSuggestionsContainer: _propTypes2.default.func,
  getSuggestionValue: _propTypes2.default.func.isRequired,
  renderSuggestion: _propTypes2.default.func.isRequired,
  inputProps: function inputProps(props, propName) {
    var inputProps = props[propName];

    if (!inputProps.hasOwnProperty('value')) {
      throw new Error("'inputProps' must have 'value'.");
    }

    if (!inputProps.hasOwnProperty('onChange')) {
      throw new Error("'inputProps' must have 'onChange'.");
    }
  },
  shouldRenderSuggestions: _propTypes2.default.func,
  alwaysRenderSuggestions: _propTypes2.default.bool,
  multiSection: _propTypes2.default.bool,
  renderSectionTitle: function renderSectionTitle(props, propName) {
    var renderSectionTitle = props[propName];

    if (props.multiSection === true && typeof renderSectionTitle !== 'function') {
      throw new Error("'renderSectionTitle' must be implemented. See: https://github.com/moroshko/react-autosuggest#renderSectionTitleProp");
    }
  },
  getSectionSuggestions: function getSectionSuggestions(props, propName) {
    var getSectionSuggestions = props[propName];

    if (props.multiSection === true && typeof getSectionSuggestions !== 'function') {
      throw new Error("'getSectionSuggestions' must be implemented. See: https://github.com/moroshko/react-autosuggest#getSectionSuggestionsProp");
    }
  },
  focusInputOnSuggestionClick: _propTypes2.default.bool,
  highlightFirstSuggestion: _propTypes2.default.bool,
  theme: _propTypes2.default.object,
  id: _propTypes2.default.string
};
Autosuggest.defaultProps = {
  renderSuggestionsContainer: defaultRenderSuggestionsContainer,
  shouldRenderSuggestions: defaultShouldRenderSuggestions,
  alwaysRenderSuggestions: false,
  multiSection: false,
  focusInputOnSuggestionClick: true,
  highlightFirstSuggestion: false,
  theme: _theme.defaultTheme,
  id: '1'
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onDocumentMouseDown = function (event) {
    _this4.justClickedOnSuggestionsContainer = false;

    var node = event.detail && event.detail.target || // This is for testing only. Please show me a better way to emulate this.
    event.target;

    while (node !== null && node !== document) {
      if (node.getAttribute('data-suggestion-index') !== null) {
        // Suggestion was clicked
        return;
      }

      if (node === _this4.suggestionsContainer) {
        // Something else inside suggestions container was clicked
        _this4.justClickedOnSuggestionsContainer = true;
        return;
      }

      node = node.parentNode;
    }
  };

  this.storeAutowhateverRef = function (autowhatever) {
    if (autowhatever !== null) {
      _this4.autowhatever = autowhatever;
    }
  };

  this.onSuggestionMouseEnter = function (event, _ref3) {
    var sectionIndex = _ref3.sectionIndex,
        itemIndex = _ref3.itemIndex;

    _this4.updateHighlightedSuggestion(sectionIndex, itemIndex);

    if (event.target === _this4.pressedSuggestion) {
      _this4.justSelectedSuggestion = true;
    }

    _this4.justMouseEntered = true;

    setTimeout(function () {
      _this4.justMouseEntered = false;
    });
  };

  this.highlightFirstSuggestion = function () {
    _this4.updateHighlightedSuggestion(_this4.props.multiSection ? 0 : null, 0);
  };

  this.onDocumentMouseUp = function () {
    if (_this4.pressedSuggestion && !_this4.justSelectedSuggestion) {
      _this4.input.focus();
    }
    _this4.pressedSuggestion = null;
  };

  this.onSuggestionMouseDown = function (event) {
    // Checking if this.justSelectedSuggestion is already true to not duplicate touch events in chrome
    // See: https://github.com/facebook/react/issues/9809#issuecomment-413978405
    if (!_this4.justSelectedSuggestion) {
      _this4.justSelectedSuggestion = true;
      _this4.pressedSuggestion = event.target;
    }
  };

  this.onSuggestionsClearRequested = function () {
    var onSuggestionsClearRequested = _this4.props.onSuggestionsClearRequested;


    onSuggestionsClearRequested && onSuggestionsClearRequested();
  };

  this.onSuggestionSelected = function (event, data) {
    var _props4 = _this4.props,
        alwaysRenderSuggestions = _props4.alwaysRenderSuggestions,
        onSuggestionSelected = _props4.onSuggestionSelected,
        onSuggestionsFetchRequested = _props4.onSuggestionsFetchRequested;


    onSuggestionSelected && onSuggestionSelected(event, data);

    if (alwaysRenderSuggestions) {
      onSuggestionsFetchRequested({
        value: data.suggestionValue,
        reason: 'suggestion-selected'
      });
    } else {
      _this4.onSuggestionsClearRequested();
    }

    _this4.resetHighlightedSuggestion();
  };

  this.onSuggestionClick = function (event) {
    var _props5 = _this4.props,
        alwaysRenderSuggestions = _props5.alwaysRenderSuggestions,
        focusInputOnSuggestionClick = _props5.focusInputOnSuggestionClick;

    var _getSuggestionIndices = _this4.getSuggestionIndices(_this4.findSuggestionElement(event.target)),
        sectionIndex = _getSuggestionIndices.sectionIndex,
        suggestionIndex = _getSuggestionIndices.suggestionIndex;

    var clickedSuggestion = _this4.getSuggestion(sectionIndex, suggestionIndex);
    var clickedSuggestionValue = _this4.props.getSuggestionValue(clickedSuggestion);

    _this4.maybeCallOnChange(event, clickedSuggestionValue, 'click');
    _this4.onSuggestionSelected(event, {
      suggestion: clickedSuggestion,
      suggestionValue: clickedSuggestionValue,
      suggestionIndex: suggestionIndex,
      sectionIndex: sectionIndex,
      method: 'click'
    });

    if (!alwaysRenderSuggestions) {
      _this4.closeSuggestions();
    }

    if (focusInputOnSuggestionClick === true) {
      _this4.input.focus();
    } else {
      _this4.onBlur();
    }

    setTimeout(function () {
      _this4.justSelectedSuggestion = false;
    });
  };

  this.onBlur = function () {
    var _props6 = _this4.props,
        inputProps = _props6.inputProps,
        shouldRenderSuggestions = _props6.shouldRenderSuggestions;
    var value = inputProps.value,
        onBlur = inputProps.onBlur;

    var highlightedSuggestion = _this4.getHighlightedSuggestion();
    var shouldRender = shouldRenderSuggestions(value);

    _this4.setState({
      isFocused: false,
      highlightedSectionIndex: null,
      highlightedSuggestionIndex: null,
      highlightedSuggestion: null,
      valueBeforeUpDown: null,
      isCollapsed: !shouldRender
    });

    onBlur && onBlur(_this4.blurEvent, { highlightedSuggestion: highlightedSuggestion });
  };

  this.onSuggestionMouseLeave = function (event) {
    _this4.resetHighlightedSuggestion(false); // shouldResetValueBeforeUpDown

    if (_this4.justSelectedSuggestion && event.target === _this4.pressedSuggestion) {
      _this4.justSelectedSuggestion = false;
    }
  };

  this.onSuggestionTouchStart = function () {
    _this4.justSelectedSuggestion = true;
    // todo: event.preventDefault when https://github.com/facebook/react/issues/2043
    // todo: gets released so onSuggestionMouseDown won't fire in chrome
  };

  this.onSuggestionTouchMove = function () {
    _this4.justSelectedSuggestion = false;
    _this4.pressedSuggestion = null;
    _this4.input.focus();
  };

  this.itemProps = function (_ref4) {
    var sectionIndex = _ref4.sectionIndex,
        itemIndex = _ref4.itemIndex;

    return {
      'data-section-index': sectionIndex,
      'data-suggestion-index': itemIndex,
      onMouseEnter: _this4.onSuggestionMouseEnter,
      onMouseLeave: _this4.onSuggestionMouseLeave,
      onMouseDown: _this4.onSuggestionMouseDown,
      onTouchStart: _this4.onSuggestionTouchStart,
      onTouchMove: _this4.onSuggestionTouchMove,
      onClick: _this4.onSuggestionClick
    };
  };

  this.renderSuggestionsContainer = function (_ref5) {
    var containerProps = _ref5.containerProps,
        children = _ref5.children;
    var renderSuggestionsContainer = _this4.props.renderSuggestionsContainer;


    return renderSuggestionsContainer({
      containerProps: containerProps,
      children: children,
      query: _this4.getQuery()
    });
  };
};

exports.default = Autosuggest;

/***/ }),
/* 1113 */
/***/ (function(module, exports) {

module.exports = function shallowEqualArrays(arrA, arrB) {
  if (arrA === arrB) {
    return true;
  }

  if (!arrA || !arrB) {
    return false;
  }

  var len = arrA.length;

  if (arrB.length !== len) {
    return false;
  }

  for (var i = 0; i < len; i++) {
    if (arrA[i] !== arrB[i]) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1115).default;

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _sectionIterator = __webpack_require__(1116);

var _sectionIterator2 = _interopRequireDefault(_sectionIterator);

var _reactThemeable = __webpack_require__(1117);

var _reactThemeable2 = _interopRequireDefault(_reactThemeable);

var _SectionTitle = __webpack_require__(1119);

var _SectionTitle2 = _interopRequireDefault(_SectionTitle);

var _ItemsList = __webpack_require__(1120);

var _ItemsList2 = _interopRequireDefault(_ItemsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var emptyObject = {};
var defaultRenderInputComponent = function defaultRenderInputComponent(props) {
  return _react2.default.createElement('input', props);
};
var defaultRenderItemsContainer = function defaultRenderItemsContainer(_ref) {
  var containerProps = _ref.containerProps,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    containerProps,
    children
  );
};
var defaultTheme = {
  container: 'react-autowhatever__container',
  containerOpen: 'react-autowhatever__container--open',
  input: 'react-autowhatever__input',
  inputOpen: 'react-autowhatever__input--open',
  inputFocused: 'react-autowhatever__input--focused',
  itemsContainer: 'react-autowhatever__items-container',
  itemsContainerOpen: 'react-autowhatever__items-container--open',
  itemsList: 'react-autowhatever__items-list',
  item: 'react-autowhatever__item',
  itemFirst: 'react-autowhatever__item--first',
  itemHighlighted: 'react-autowhatever__item--highlighted',
  sectionContainer: 'react-autowhatever__section-container',
  sectionContainerFirst: 'react-autowhatever__section-container--first',
  sectionTitle: 'react-autowhatever__section-title'
};

var Autowhatever = function (_Component) {
  _inherits(Autowhatever, _Component);

  function Autowhatever(props) {
    _classCallCheck(this, Autowhatever);

    var _this = _possibleConstructorReturn(this, (Autowhatever.__proto__ || Object.getPrototypeOf(Autowhatever)).call(this, props));

    _this.storeInputReference = function (input) {
      if (input !== null) {
        _this.input = input;
      }
    };

    _this.storeItemsContainerReference = function (itemsContainer) {
      if (itemsContainer !== null) {
        _this.itemsContainer = itemsContainer;
      }
    };

    _this.onHighlightedItemChange = function (highlightedItem) {
      _this.highlightedItem = highlightedItem;
    };

    _this.getItemId = function (sectionIndex, itemIndex) {
      if (itemIndex === null) {
        return null;
      }

      var id = _this.props.id;

      var section = sectionIndex === null ? '' : 'section-' + sectionIndex;

      return 'react-autowhatever-' + id + '-' + section + '-item-' + itemIndex;
    };

    _this.onFocus = function (event) {
      var inputProps = _this.props.inputProps;


      _this.setState({
        isInputFocused: true
      });

      inputProps.onFocus && inputProps.onFocus(event);
    };

    _this.onBlur = function (event) {
      var inputProps = _this.props.inputProps;


      _this.setState({
        isInputFocused: false
      });

      inputProps.onBlur && inputProps.onBlur(event);
    };

    _this.onKeyDown = function (event) {
      var _this$props = _this.props,
          inputProps = _this$props.inputProps,
          highlightedSectionIndex = _this$props.highlightedSectionIndex,
          highlightedItemIndex = _this$props.highlightedItemIndex;


      switch (event.key) {
        case 'ArrowDown':
        case 'ArrowUp':
          {
            var nextPrev = event.key === 'ArrowDown' ? 'next' : 'prev';

            var _this$sectionIterator = _this.sectionIterator[nextPrev]([highlightedSectionIndex, highlightedItemIndex]),
                _this$sectionIterator2 = _slicedToArray(_this$sectionIterator, 2),
                newHighlightedSectionIndex = _this$sectionIterator2[0],
                newHighlightedItemIndex = _this$sectionIterator2[1];

            inputProps.onKeyDown(event, { newHighlightedSectionIndex: newHighlightedSectionIndex, newHighlightedItemIndex: newHighlightedItemIndex });
            break;
          }

        default:
          inputProps.onKeyDown(event, { highlightedSectionIndex: highlightedSectionIndex, highlightedItemIndex: highlightedItemIndex });
      }
    };

    _this.highlightedItem = null;

    _this.state = {
      isInputFocused: false
    };

    _this.setSectionsItems(props);
    _this.setSectionIterator(props);
    _this.setTheme(props);
    return _this;
  }

  _createClass(Autowhatever, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.ensureHighlightedItemIsVisible();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.items !== this.props.items) {
        this.setSectionsItems(nextProps);
      }

      if (nextProps.items !== this.props.items || nextProps.multiSection !== this.props.multiSection) {
        this.setSectionIterator(nextProps);
      }

      if (nextProps.theme !== this.props.theme) {
        this.setTheme(nextProps);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.ensureHighlightedItemIsVisible();
    }
  }, {
    key: 'setSectionsItems',
    value: function setSectionsItems(props) {
      if (props.multiSection) {
        this.sectionsItems = props.items.map(function (section) {
          return props.getSectionItems(section);
        });
        this.sectionsLengths = this.sectionsItems.map(function (items) {
          return items.length;
        });
        this.allSectionsAreEmpty = this.sectionsLengths.every(function (itemsCount) {
          return itemsCount === 0;
        });
      }
    }
  }, {
    key: 'setSectionIterator',
    value: function setSectionIterator(props) {
      this.sectionIterator = (0, _sectionIterator2.default)({
        multiSection: props.multiSection,
        data: props.multiSection ? this.sectionsLengths : props.items.length
      });
    }
  }, {
    key: 'setTheme',
    value: function setTheme(props) {
      this.theme = (0, _reactThemeable2.default)(props.theme);
    }
  }, {
    key: 'renderSections',
    value: function renderSections() {
      var _this2 = this;

      if (this.allSectionsAreEmpty) {
        return null;
      }

      var theme = this.theme;
      var _props = this.props,
          id = _props.id,
          items = _props.items,
          renderItem = _props.renderItem,
          renderItemData = _props.renderItemData,
          renderSectionTitle = _props.renderSectionTitle,
          highlightedSectionIndex = _props.highlightedSectionIndex,
          highlightedItemIndex = _props.highlightedItemIndex,
          itemProps = _props.itemProps;


      return items.map(function (section, sectionIndex) {
        var keyPrefix = 'react-autowhatever-' + id + '-';
        var sectionKeyPrefix = keyPrefix + 'section-' + sectionIndex + '-';
        var isFirstSection = sectionIndex === 0;

        // `key` is provided by theme()
        /* eslint-disable react/jsx-key */
        return _react2.default.createElement(
          'div',
          theme(sectionKeyPrefix + 'container', 'sectionContainer', isFirstSection && 'sectionContainerFirst'),
          _react2.default.createElement(_SectionTitle2.default, {
            section: section,
            renderSectionTitle: renderSectionTitle,
            theme: theme,
            sectionKeyPrefix: sectionKeyPrefix
          }),
          _react2.default.createElement(_ItemsList2.default, {
            items: _this2.sectionsItems[sectionIndex],
            itemProps: itemProps,
            renderItem: renderItem,
            renderItemData: renderItemData,
            sectionIndex: sectionIndex,
            highlightedItemIndex: highlightedSectionIndex === sectionIndex ? highlightedItemIndex : null,
            onHighlightedItemChange: _this2.onHighlightedItemChange,
            getItemId: _this2.getItemId,
            theme: theme,
            keyPrefix: keyPrefix,
            ref: _this2.storeItemsListReference
          })
        );
        /* eslint-enable react/jsx-key */
      });
    }
  }, {
    key: 'renderItems',
    value: function renderItems() {
      var items = this.props.items;


      if (items.length === 0) {
        return null;
      }

      var theme = this.theme;
      var _props2 = this.props,
          id = _props2.id,
          renderItem = _props2.renderItem,
          renderItemData = _props2.renderItemData,
          highlightedSectionIndex = _props2.highlightedSectionIndex,
          highlightedItemIndex = _props2.highlightedItemIndex,
          itemProps = _props2.itemProps;


      return _react2.default.createElement(_ItemsList2.default, {
        items: items,
        itemProps: itemProps,
        renderItem: renderItem,
        renderItemData: renderItemData,
        highlightedItemIndex: highlightedSectionIndex === null ? highlightedItemIndex : null,
        onHighlightedItemChange: this.onHighlightedItemChange,
        getItemId: this.getItemId,
        theme: theme,
        keyPrefix: 'react-autowhatever-' + id + '-'
      });
    }
  }, {
    key: 'ensureHighlightedItemIsVisible',
    value: function ensureHighlightedItemIsVisible() {
      var highlightedItem = this.highlightedItem;


      if (!highlightedItem) {
        return;
      }

      var itemsContainer = this.itemsContainer;

      var itemOffsetRelativeToContainer = highlightedItem.offsetParent === itemsContainer ? highlightedItem.offsetTop : highlightedItem.offsetTop - itemsContainer.offsetTop;

      var scrollTop = itemsContainer.scrollTop; // Top of the visible area

      if (itemOffsetRelativeToContainer < scrollTop) {
        // Item is off the top of the visible area
        scrollTop = itemOffsetRelativeToContainer;
      } else if (itemOffsetRelativeToContainer + highlightedItem.offsetHeight > scrollTop + itemsContainer.offsetHeight) {
        // Item is off the bottom of the visible area
        scrollTop = itemOffsetRelativeToContainer + highlightedItem.offsetHeight - itemsContainer.offsetHeight;
      }

      if (scrollTop !== itemsContainer.scrollTop) {
        itemsContainer.scrollTop = scrollTop;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var theme = this.theme;
      var _props3 = this.props,
          id = _props3.id,
          multiSection = _props3.multiSection,
          renderInputComponent = _props3.renderInputComponent,
          renderItemsContainer = _props3.renderItemsContainer,
          highlightedSectionIndex = _props3.highlightedSectionIndex,
          highlightedItemIndex = _props3.highlightedItemIndex;
      var isInputFocused = this.state.isInputFocused;

      var renderedItems = multiSection ? this.renderSections() : this.renderItems();
      var isOpen = renderedItems !== null;
      var ariaActivedescendant = this.getItemId(highlightedSectionIndex, highlightedItemIndex);
      var itemsContainerId = 'react-autowhatever-' + id;
      var containerProps = _extends({
        role: 'combobox',
        'aria-haspopup': 'listbox',
        'aria-owns': itemsContainerId,
        'aria-expanded': isOpen
      }, theme('react-autowhatever-' + id + '-container', 'container', isOpen && 'containerOpen'), this.props.containerProps);
      var inputComponent = renderInputComponent(_extends({
        type: 'text',
        value: '',
        autoComplete: 'off',
        'aria-autocomplete': 'list',
        'aria-controls': itemsContainerId,
        'aria-activedescendant': ariaActivedescendant
      }, theme('react-autowhatever-' + id + '-input', 'input', isOpen && 'inputOpen', isInputFocused && 'inputFocused'), this.props.inputProps, {
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.props.inputProps.onKeyDown && this.onKeyDown,
        ref: this.storeInputReference
      }));
      var itemsContainer = renderItemsContainer({
        containerProps: _extends({
          id: itemsContainerId,
          role: 'listbox'
        }, theme('react-autowhatever-' + id + '-items-container', 'itemsContainer', isOpen && 'itemsContainerOpen'), {
          ref: this.storeItemsContainerReference
        }),
        children: renderedItems
      });

      return _react2.default.createElement(
        'div',
        containerProps,
        inputComponent,
        itemsContainer
      );
    }
  }]);

  return Autowhatever;
}(_react.Component);

Autowhatever.propTypes = {
  id: _propTypes2.default.string, // Used in aria-* attributes. If multiple Autowhatever's are rendered on a page, they must have unique ids.
  multiSection: _propTypes2.default.bool, // Indicates whether a multi section layout should be rendered.
  renderInputComponent: _propTypes2.default.func, // When specified, it is used to render the input element.
  renderItemsContainer: _propTypes2.default.func, // Renders the items container.
  items: _propTypes2.default.array.isRequired, // Array of items or sections to render.
  renderItem: _propTypes2.default.func, // This function renders a single item.
  renderItemData: _propTypes2.default.object, // Arbitrary data that will be passed to renderItem()
  renderSectionTitle: _propTypes2.default.func, // This function gets a section and renders its title.
  getSectionItems: _propTypes2.default.func, // This function gets a section and returns its items, which will be passed into `renderItem` for rendering.
  containerProps: _propTypes2.default.object, // Arbitrary container props
  inputProps: _propTypes2.default.object, // Arbitrary input props
  itemProps: _propTypes2.default.oneOfType([// Arbitrary item props
  _propTypes2.default.object, _propTypes2.default.func]),
  highlightedSectionIndex: _propTypes2.default.number, // Section index of the highlighted item
  highlightedItemIndex: _propTypes2.default.number, // Highlighted item index (within a section)
  theme: _propTypes2.default.oneOfType([// Styles. See: https://github.com/markdalgleish/react-themeable
  _propTypes2.default.object, _propTypes2.default.array])
};
Autowhatever.defaultProps = {
  id: '1',
  multiSection: false,
  renderInputComponent: defaultRenderInputComponent,
  renderItemsContainer: defaultRenderItemsContainer,
  renderItem: function renderItem() {
    throw new Error('`renderItem` must be provided');
  },
  renderItemData: emptyObject,
  renderSectionTitle: function renderSectionTitle() {
    throw new Error('`renderSectionTitle` must be provided');
  },
  getSectionItems: function getSectionItems() {
    throw new Error('`getSectionItems` must be provided');
  },
  containerProps: emptyObject,
  inputProps: emptyObject,
  itemProps: emptyObject,
  highlightedSectionIndex: null,
  highlightedItemIndex: null,
  theme: defaultTheme
};
exports.default = Autowhatever;

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

module.exports = function (_ref) {
  var data = _ref.data;
  var multiSection = _ref.multiSection;

  function nextNonEmptySectionIndex(sectionIndex) {
    if (sectionIndex === null) {
      sectionIndex = 0;
    } else {
      sectionIndex++;
    }

    while (sectionIndex < data.length && data[sectionIndex] === 0) {
      sectionIndex++;
    }

    return sectionIndex === data.length ? null : sectionIndex;
  }

  function prevNonEmptySectionIndex(sectionIndex) {
    if (sectionIndex === null) {
      sectionIndex = data.length - 1;
    } else {
      sectionIndex--;
    }

    while (sectionIndex >= 0 && data[sectionIndex] === 0) {
      sectionIndex--;
    }

    return sectionIndex === -1 ? null : sectionIndex;
  }

  function next(position) {
    var _position = _slicedToArray(position, 2);

    var sectionIndex = _position[0];
    var itemIndex = _position[1];


    if (multiSection) {
      if (itemIndex === null || itemIndex === data[sectionIndex] - 1) {
        sectionIndex = nextNonEmptySectionIndex(sectionIndex);

        if (sectionIndex === null) {
          return [null, null];
        }

        return [sectionIndex, 0];
      }

      return [sectionIndex, itemIndex + 1];
    }

    if (data === 0 || itemIndex === data - 1) {
      return [null, null];
    }

    if (itemIndex === null) {
      return [null, 0];
    }

    return [null, itemIndex + 1];
  }

  function prev(position) {
    var _position2 = _slicedToArray(position, 2);

    var sectionIndex = _position2[0];
    var itemIndex = _position2[1];


    if (multiSection) {
      if (itemIndex === null || itemIndex === 0) {
        sectionIndex = prevNonEmptySectionIndex(sectionIndex);

        if (sectionIndex === null) {
          return [null, null];
        }

        return [sectionIndex, data[sectionIndex] - 1];
      }

      return [sectionIndex, itemIndex - 1];
    }

    if (data === 0 || itemIndex === 0) {
      return [null, null];
    }

    if (itemIndex === null) {
      return [null, data - 1];
    }

    return [null, itemIndex - 1];
  }

  function isLast(position) {
    return next(position)[1] === null;
  }

  return {
    next: next,
    prev: prev,
    isLast: isLast
  };
};


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

var _objectAssign = __webpack_require__(1118);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var truthy = function truthy(x) {
  return x;
};

exports['default'] = function (input) {
  var _ref = Array.isArray(input) && input.length === 2 ? input : [input, null];

  var _ref2 = _slicedToArray(_ref, 2);

  var theme = _ref2[0];
  var classNameDecorator = _ref2[1];

  return function (key) {
    for (var _len = arguments.length, names = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      names[_key - 1] = arguments[_key];
    }

    var styles = names.map(function (name) {
      return theme[name];
    }).filter(truthy);

    return typeof styles[0] === 'string' || typeof classNameDecorator === 'function' ? { key: key, className: classNameDecorator ? classNameDecorator.apply(undefined, _toConsumableArray(styles)) : styles.join(' ') } : { key: key, style: _objectAssign2['default'].apply(undefined, [{}].concat(_toConsumableArray(styles))) };
  };
};

module.exports = exports['default'];

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function ToObject(val) {
	if (val == null) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function ownEnumerableKeys(obj) {
	var keys = Object.getOwnPropertyNames(obj);

	if (Object.getOwnPropertySymbols) {
		keys = keys.concat(Object.getOwnPropertySymbols(obj));
	}

	return keys.filter(function (key) {
		return propIsEnumerable.call(obj, key);
	});
}

module.exports = Object.assign || function (target, source) {
	var from;
	var keys;
	var to = ToObject(target);

	for (var s = 1; s < arguments.length; s++) {
		from = arguments[s];
		keys = ownEnumerableKeys(Object(from));

		for (var i = 0; i < keys.length; i++) {
			to[keys[i]] = from[keys[i]];
		}
	}

	return to;
};


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _compareObjects = __webpack_require__(298);

var _compareObjects2 = _interopRequireDefault(_compareObjects);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SectionTitle = function (_Component) {
  _inherits(SectionTitle, _Component);

  function SectionTitle() {
    _classCallCheck(this, SectionTitle);

    return _possibleConstructorReturn(this, (SectionTitle.__proto__ || Object.getPrototypeOf(SectionTitle)).apply(this, arguments));
  }

  _createClass(SectionTitle, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects2.default)(nextProps, this.props);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          section = _props.section,
          renderSectionTitle = _props.renderSectionTitle,
          theme = _props.theme,
          sectionKeyPrefix = _props.sectionKeyPrefix;

      var sectionTitle = renderSectionTitle(section);

      if (!sectionTitle) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        theme(sectionKeyPrefix + 'title', 'sectionTitle'),
        sectionTitle
      );
    }
  }]);

  return SectionTitle;
}(_react.Component);

SectionTitle.propTypes = {
  section: _propTypes2.default.any.isRequired,
  renderSectionTitle: _propTypes2.default.func.isRequired,
  theme: _propTypes2.default.func.isRequired,
  sectionKeyPrefix: _propTypes2.default.string.isRequired
};
exports.default = SectionTitle;

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Item = __webpack_require__(1121);

var _Item2 = _interopRequireDefault(_Item);

var _compareObjects = __webpack_require__(298);

var _compareObjects2 = _interopRequireDefault(_compareObjects);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ItemsList = function (_Component) {
  _inherits(ItemsList, _Component);

  function ItemsList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ItemsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ItemsList.__proto__ || Object.getPrototypeOf(ItemsList)).call.apply(_ref, [this].concat(args))), _this), _this.storeHighlightedItemReference = function (highlightedItem) {
      _this.props.onHighlightedItemChange(highlightedItem === null ? null : highlightedItem.item);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ItemsList, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects2.default)(nextProps, this.props, ['itemProps']);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          items = _props.items,
          itemProps = _props.itemProps,
          renderItem = _props.renderItem,
          renderItemData = _props.renderItemData,
          sectionIndex = _props.sectionIndex,
          highlightedItemIndex = _props.highlightedItemIndex,
          getItemId = _props.getItemId,
          theme = _props.theme,
          keyPrefix = _props.keyPrefix;

      var sectionPrefix = sectionIndex === null ? keyPrefix : keyPrefix + 'section-' + sectionIndex + '-';
      var isItemPropsFunction = typeof itemProps === 'function';

      return _react2.default.createElement(
        'ul',
        _extends({ role: 'listbox' }, theme(sectionPrefix + 'items-list', 'itemsList')),
        items.map(function (item, itemIndex) {
          var isFirst = itemIndex === 0;
          var isHighlighted = itemIndex === highlightedItemIndex;
          var itemKey = sectionPrefix + 'item-' + itemIndex;
          var itemPropsObj = isItemPropsFunction ? itemProps({ sectionIndex: sectionIndex, itemIndex: itemIndex }) : itemProps;
          var allItemProps = _extends({
            id: getItemId(sectionIndex, itemIndex),
            'aria-selected': isHighlighted
          }, theme(itemKey, 'item', isFirst && 'itemFirst', isHighlighted && 'itemHighlighted'), itemPropsObj);

          if (isHighlighted) {
            allItemProps.ref = _this2.storeHighlightedItemReference;
          }

          // `key` is provided by theme()
          /* eslint-disable react/jsx-key */
          return _react2.default.createElement(_Item2.default, _extends({}, allItemProps, {
            sectionIndex: sectionIndex,
            isHighlighted: isHighlighted,
            itemIndex: itemIndex,
            item: item,
            renderItem: renderItem,
            renderItemData: renderItemData
          }));
          /* eslint-enable react/jsx-key */
        })
      );
    }
  }]);

  return ItemsList;
}(_react.Component);

ItemsList.propTypes = {
  items: _propTypes2.default.array.isRequired,
  itemProps: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  renderItem: _propTypes2.default.func.isRequired,
  renderItemData: _propTypes2.default.object.isRequired,
  sectionIndex: _propTypes2.default.number,
  highlightedItemIndex: _propTypes2.default.number,
  onHighlightedItemChange: _propTypes2.default.func.isRequired,
  getItemId: _propTypes2.default.func.isRequired,
  theme: _propTypes2.default.func.isRequired,
  keyPrefix: _propTypes2.default.string.isRequired
};
ItemsList.defaultProps = {
  sectionIndex: null
};
exports.default = ItemsList;

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _compareObjects = __webpack_require__(298);

var _compareObjects2 = _interopRequireDefault(_compareObjects);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Item = function (_Component) {
  _inherits(Item, _Component);

  function Item() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Item);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Item.__proto__ || Object.getPrototypeOf(Item)).call.apply(_ref, [this].concat(args))), _this), _this.storeItemReference = function (item) {
      if (item !== null) {
        _this.item = item;
      }
    }, _this.onMouseEnter = function (event) {
      var _this$props = _this.props,
          sectionIndex = _this$props.sectionIndex,
          itemIndex = _this$props.itemIndex;


      _this.props.onMouseEnter(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _this.onMouseLeave = function (event) {
      var _this$props2 = _this.props,
          sectionIndex = _this$props2.sectionIndex,
          itemIndex = _this$props2.itemIndex;


      _this.props.onMouseLeave(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _this.onMouseDown = function (event) {
      var _this$props3 = _this.props,
          sectionIndex = _this$props3.sectionIndex,
          itemIndex = _this$props3.itemIndex;


      _this.props.onMouseDown(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _this.onClick = function (event) {
      var _this$props4 = _this.props,
          sectionIndex = _this$props4.sectionIndex,
          itemIndex = _this$props4.itemIndex;


      _this.props.onClick(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Item, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects2.default)(nextProps, this.props, ['renderItemData']);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isHighlighted = _props.isHighlighted,
          item = _props.item,
          renderItem = _props.renderItem,
          renderItemData = _props.renderItemData,
          restProps = _objectWithoutProperties(_props, ['isHighlighted', 'item', 'renderItem', 'renderItemData']);

      delete restProps.sectionIndex;
      delete restProps.itemIndex;

      if (typeof restProps.onMouseEnter === 'function') {
        restProps.onMouseEnter = this.onMouseEnter;
      }

      if (typeof restProps.onMouseLeave === 'function') {
        restProps.onMouseLeave = this.onMouseLeave;
      }

      if (typeof restProps.onMouseDown === 'function') {
        restProps.onMouseDown = this.onMouseDown;
      }

      if (typeof restProps.onClick === 'function') {
        restProps.onClick = this.onClick;
      }

      return _react2.default.createElement(
        'li',
        _extends({ role: 'option' }, restProps, { ref: this.storeItemReference }),
        renderItem(item, _extends({ isHighlighted: isHighlighted }, renderItemData))
      );
    }
  }]);

  return Item;
}(_react.Component);

Item.propTypes = {
  sectionIndex: _propTypes2.default.number,
  isHighlighted: _propTypes2.default.bool.isRequired,
  itemIndex: _propTypes2.default.number.isRequired,
  item: _propTypes2.default.any.isRequired,
  renderItem: _propTypes2.default.func.isRequired,
  renderItemData: _propTypes2.default.object.isRequired,
  onMouseEnter: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  onMouseDown: _propTypes2.default.func,
  onClick: _propTypes2.default.func
};
exports.default = Item;

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultTheme = exports.defaultTheme = {
  container: 'react-autosuggest__container',
  containerOpen: 'react-autosuggest__container--open',
  input: 'react-autosuggest__input',
  inputOpen: 'react-autosuggest__input--open',
  inputFocused: 'react-autosuggest__input--focused',
  suggestionsContainer: 'react-autosuggest__suggestions-container',
  suggestionsContainerOpen: 'react-autosuggest__suggestions-container--open',
  suggestionsList: 'react-autosuggest__suggestions-list',
  suggestion: 'react-autosuggest__suggestion',
  suggestionFirst: 'react-autosuggest__suggestion--first',
  suggestionHighlighted: 'react-autosuggest__suggestion--highlighted',
  sectionContainer: 'react-autosuggest__section-container',
  sectionContainerFirst: 'react-autosuggest__section-container--first',
  sectionTitle: 'react-autosuggest__section-title'
};

var mapToAutowhateverTheme = exports.mapToAutowhateverTheme = function mapToAutowhateverTheme(theme) {
  var result = {};

  for (var key in theme) {
    switch (key) {
      case 'suggestionsContainer':
        result['itemsContainer'] = theme[key];
        break;

      case 'suggestionsContainerOpen':
        result['itemsContainerOpen'] = theme[key];
        break;

      case 'suggestion':
        result['item'] = theme[key];
        break;

      case 'suggestionFirst':
        result['itemFirst'] = theme[key];
        break;

      case 'suggestionHighlighted':
        result['itemHighlighted'] = theme[key];
        break;

      case 'suggestionsList':
        result['itemsList'] = theme[key];
        break;

      default:
        result[key] = theme[key];
    }
  }

  return result;
};

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validator_lib_isEmail__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validator_lib_isEmail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_validator_lib_isEmail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_validator_lib_isURL__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_validator_lib_isURL___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_validator_lib_isURL__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18n_i18n__ = __webpack_require__(15);
var localize=__WEBPACK_IMPORTED_MODULE_2_i18n_i18n__["a" /* default */].loc.localize;var consecutiveSpacesRegex=new RegExp(/ {2,}/);var leadingTrailingSpacesRegex=new RegExp(/^ | $/);var schema={'displayName':function displayName(value,state){if(!value){return localize('required-field');}if(state.touched['displayName']){if(value.length<4){return localize('company-profile-team-name-length');}if(consecutiveSpacesRegex.test(value)){return localize('company-profile-team-name-consecutive-spaces');}if(leadingTrailingSpacesRegex.test(value)){return localize('company-profile-team-name-leading-trailing-spaces');}}},'language':null,'email':function email(value,state){if(!value){return localize('required-field');}if(state.touched['email']&&!__WEBPACK_IMPORTED_MODULE_0_validator_lib_isEmail___default()(value)){return localize('company-profile-email-invalid');}},'address1':null,'address2':null,'city':null,'region':null,'postcode':null,'country':function country(value,state,props){if(value&&state.touched['country']&&props.companyCountries.indexOf(value)===-1){return localize('company-profile-country-invalid');}},'phone':function phone(value){// eslint-disable-next-line no-useless-escape
if(value&&value.match(/^[0-9\-\+\(\)\s]*$/)===null){return localize('company-profile-phone-invalid');}},'website':function website(value,state){if(value&&state.touched['website']&&!__WEBPACK_IMPORTED_MODULE_1_validator_lib_isURL___default()(value,{protocols:['http','https'],require_protocol:true})){return localize('company-profile-website-invalid');}},'industry':function industry(value,state,props){var industryDisplayNames=props.companyIndustries.map(function(industry){return industry.displayName;});if(value&&state.touched['industry']&&industryDisplayNames.indexOf(value)===-1){return localize('company-profile-industry-invalid');}},'size':null};/* harmony default export */ __webpack_exports__["a"] = (schema);

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOCALES_MAPPING; });
// https://cdn.simplelocalize.io/public/v1/locales
var LOCALES_MAPPING=[{'locale':'aa-ER','language':'Afar','country':'Eritrea'},{'locale':'af-NA','language':'Afrikaans','country':'Namibia'},{'locale':'am-ET','language':'Amharic','country':'Ethiopia'},{'locale':'af-ZA','language':'Afrikaans','country':'South Africa'},{'locale':'ar-EG','language':'Arabic','country':'Egypt'},{'locale':'ar-DZ','language':'Arabic','country':'Algeria'},{'locale':'ar-BH','language':'Arabic','country':'Bahrain'},{'locale':'ar-DJ','language':'Arabic','country':'Djibouti'},{'locale':'ar-ER','language':'Arabic','country':'Eritrea'},{'locale':'ar-YE','language':'Arabic','country':'Yemen'},{'locale':'ar-IL','language':'Arabic','country':'Israel'},{'locale':'ar-IQ','language':'Arabic','country':'Iraq'},{'locale':'ar-JO','language':'Arabic','country':'Jordan'},{'locale':'ar-KM','language':'Arabic','country':'Comoros'},{'locale':'ar-QA','language':'Arabic','country':'Qatar'},{'locale':'ar-LB','language':'Arabic','country':'Lebanon'},{'locale':'ar-KW','language':'Arabic','country':'Kuwait'},{'locale':'ar-LY','language':'Arabic','country':'Libya'},{'locale':'ar-MA','language':'Arabic','country':'Morocco'},{'locale':'ar-MR','language':'Arabic','country':'Mauritania'},{'locale':'ar-PS','language':'Arabic','country':'Palestine'},{'locale':'ar-OM','language':'Arabic','country':'Oman'},{'locale':'ar-SA','language':'Arabic','country':'Saudi Arabia'},{'locale':'ar-SO','language':'Arabic','country':'Somalia'},{'locale':'ar-SD','language':'Arabic','country':'Sudan'},{'locale':'ar-SY','language':'Arabic','country':'Syria'},{'locale':'ar-TD','language':'Arabic','country':'Chad'},{'locale':'ar-TN','language':'Arabic','country':'Tunisia'},{'locale':'az-AZ','language':'Azerbaijani','country':'Azerbaijan'},{'locale':'ar-AE','language':'Arabic','country':'United Arab Emirates'},{'locale':'ay-BO','language':'Aymara','country':'Bolivia'},{'locale':'be-BY','language':'Belarusian','country':'Belarus'},{'locale':'bi-VU','language':'Bislama','country':'Vanuatu'},{'locale':'bn-BD','language':'Bengali','country':'Bangladesh'},{'locale':'bs-BA','language':'Bosnian','country':'Bosnia and Herzegovina'},{'locale':'bs-ME','language':'Bosnian','country':'Montenegro'},{'locale':'bg-BG','language':'Bulgarian','country':'Bulgaria'},{'locale':'ca-AD','language':'Catalan','country':'Andorra'},{'locale':'byn-ER','language':'Bilen','country':'Eritrea'},{'locale':'cs-CZ','language':'Czech','country':'Czechia'},{'locale':'ch-GU','language':'Chamorro','country':'Guam'},{'locale':'ch-MP','language':'Chamorro','country':'Northern Mariana Islands'},{'locale':'de-BE','language':'German','country':'Belgium'},{'locale':'da-DK','language':'Danish','country':'Denmark'},{'locale':'de-LI','language':'German','country':'Liechtenstein'},{'locale':'de-DE','language':'German','country':'Germany'},{'locale':'de-LU','language':'German','country':'Luxembourg'},{'locale':'de-AT','language':'German','country':'Austria'},{'locale':'de-CH','language':'German','country':'Switzerland'},{'locale':'de-VA','language':'German','country':'Vatican City'},{'locale':'dz-BT','language':'Dzongkha','country':'Bhutan'},{'locale':'el-GR','language':'Greek (modern)','country':'Greece'},{'locale':'dv-MV','language':'Divehi','country':'Maldives'},{'locale':'el-CY','language':'Greek (modern)','country':'Cyprus'},{'locale':'en-AS','language':'English','country':'American Samoa'},{'locale':'en-AI','language':'English','country':'Anguilla'},{'locale':'en-AQ','language':'English','country':'Antarctica'},{'locale':'en-AG','language':'English','country':'Antigua and Barbuda'},{'locale':'en-AU','language':'English','country':'Australia'},{'locale':'en-BS','language':'English','country':'Bahamas'},{'locale':'en-BB','language':'English','country':'Barbados'},{'locale':'en-BZ','language':'English','country':'Belize'},{'locale':'en-BM','language':'English','country':'Bermuda'},{'locale':'en-BW','language':'English','country':'Botswana'},{'locale':'en-IO','language':'English','country':'British Indian Ocean Territory'},{'locale':'en-CK','language':'English','country':'Cook Islands'},{'locale':'en-DM','language':'English','country':'Dominica'},{'locale':'en-CW','language':'English','country':'Curacao'},{'locale':'en-SZ','language':'English','country':'Eswatini'},{'locale':'en-FK','language':'English','country':'Falkland Islands'},{'locale':'en-FJ','language':'English','country':'Fiji'},{'locale':'en-ER','language':'English','country':'Eritrea'},{'locale':'en-FM','language':'English','country':'Federated States of Micronesia'},{'locale':'en-GM','language':'English','country':'Gambia'},{'locale':'en-GI','language':'English','country':'Gibraltar'},{'locale':'en-GH','language':'English','country':'Ghana'},{'locale':'en-GD','language':'English','country':'Grenada'},{'locale':'en-GG','language':'English','country':'Guernsey'},{'locale':'en-GY','language':'English','country':'Guyana'},{'locale':'en-GU','language':'English','country':'Guam'},{'locale':'en-HM','language':'English','country':'Heard Island and McDonald Islands'},{'locale':'en-IM','language':'English','country':'Isle of Man'},{'locale':'en-IE','language':'English','country':'Ireland'},{'locale':'en-HK','language':'English','country':'Hong Kong'},{'locale':'en-JM','language':'English','country':'Jamaica'},{'locale':'en-JE','language':'English','country':'Jersey'},{'locale':'en-IN','language':'English','country':'India'},{'locale':'en-VG','language':'English','country':'British Virgin Islands'},{'locale':'en-VI','language':'English','country':'Virgin Islands'},{'locale':'en-CM','language':'English','country':'Cameroon'},{'locale':'en-CA','language':'English','country':'Canada'},{'locale':'en-KE','language':'English','country':'Kenya'},{'locale':'en-KI','language':'English','country':'Kiribati'},{'locale':'en-UM','language':'English','country':'United States Minor Outlying Islands'},{'locale':'en-CC','language':'English','country':'Cocos (Keeling) Islands'},{'locale':'en-KY','language':'English','country':'Cayman Islands'},{'locale':'en-LR','language':'English','country':'Liberia'},{'locale':'en-LS','language':'English','country':'Lesotho'},{'locale':'en-MT','language':'English','country':'Malta'},{'locale':'en-MH','language':'English','country':'Marshall Islands'},{'locale':'en-MU','language':'English','country':'Mauritius'},{'locale':'en-MS','language':'English','country':'Montserrat'},{'locale':'en-NA','language':'English','country':'Namibia'},{'locale':'en-NR','language':'English','country':'Nauru'},{'locale':'en-NZ','language':'English','country':'New Zealand'},{'locale':'en-NG','language':'English','country':'Nigeria'},{'locale':'en-NU','language':'English','country':'Niue'},{'locale':'en-MP','language':'English','country':'Northern Mariana Islands'},{'locale':'en-NF','language':'English','country':'Norfolk Island'},{'locale':'en-PW','language':'English','country':'Palau'},{'locale':'en-PK','language':'English','country':'Pakistan'},{'locale':'en-PG','language':'English','country':'Papua New Guinea'},{'locale':'en-MW','language':'English','country':'Malawi'},{'locale':'en-PH','language':'English','country':'Philippines'},{'locale':'en-PN','language':'English','country':'Pitcairn Islands'},{'locale':'en-PR','language':'English','country':'Puerto Rico'},{'locale':'en-RW','language':'English','country':'Rwanda'},{'locale':'en-MF','language':'English','country':'Saint Martin'},{'locale':'en-SB','language':'English','country':'Solomon Islands'},{'locale':'en-ZM','language':'English','country':'Zambia'},{'locale':'en-WS','language':'English','country':'Samoa'},{'locale':'en-SC','language':'English','country':'Seychelles'},{'locale':'en-SL','language':'English','country':'Sierra Leone'},{'locale':'en-SX','language':'English','country':'Sint Maarten'},{'locale':'en-ZW','language':'English','country':'Zimbabwe'},{'locale':'en-SG','language':'English','country':'Singapore'},{'locale':'en-SH','language':'English','country':'Saint Helena, Ascension and Tristan da Cunha'},{'locale':'en-KN','language':'English','country':'Saint Kitts and Nevis'},{'locale':'en-LC','language':'English','country':'Saint Lucia'},{'locale':'en-ZA','language':'English','country':'South Africa'},{'locale':'en-SD','language':'English','country':'Sudan'},{'locale':'en-GS','language':'English','country':'South Georgia and South Sandwich Islands'},{'locale':'en-SS','language':'English','country':'South Sudan'},{'locale':'en-TZ','language':'English','country':'Tanzania'},{'locale':'en-TK','language':'English','country':'Tokelau'},{'locale':'en-TO','language':'English','country':'Tonga'},{'locale':'en-TT','language':'English','country':'Trinidad and Tobago'},{'locale':'en-TC','language':'English','country':'Turks and Caicos Islands'},{'locale':'en-VC','language':'English','country':'Saint Vincent and the Grenadines'},{'locale':'en-VU','language':'English','country':'Vanuatu'},{'locale':'en-TV','language':'English','country':'Tuvalu'},{'locale':'en-UG','language':'English','country':'Uganda'},{'locale':'en-US','language':'English','country':'United States of America'},{'locale':'en-GB','language':'English','country':'United Kingdom'},{'locale':'en-CX','language':'English','country':'Christmas Island'},{'locale':'fan-GQ','language':'Fang','country':'Equatorial Guinea'},{'locale':'fo-FO','language':'Faroese','country':'Faroe Islands'},{'locale':'et-EE','language':'Estonian','country':'Estonia'},{'locale':'fa-IR','language':'Persian (Farsi)','country':'Iran'},{'locale':'fj-FJ','language':'Fijian','country':'Fiji'},{'locale':'fi-FI','language':'Finnish','country':'Finland'},{'locale':'fr-GQ','language':'French','country':'Equatorial Guinea'},{'locale':'fr-BJ','language':'French','country':'Benin'},{'locale':'fr-BE','language':'French','country':'Belgium'},{'locale':'fr-BF','language':'French','country':'Burkina Faso'},{'locale':'fr-CD','language':'French','country':'Democratic Republic of the Congo'},{'locale':'fr-BI','language':'French','country':'Burundi'},{'locale':'fr-DJ','language':'French','country':'Djibouti'},{'locale':'fr-CI','language':'French','country':'Ivory Coast'},{'locale':'fr-FR','language':'French','country':'France'},{'locale':'fr-GF','language':'French','country':'French Guiana'},{'locale':'fr-PF','language':'French','country':'French Polynesia'},{'locale':'fr-TF','language':'French','country':'French Southern and Antarctic Lands'},{'locale':'fr-GA','language':'French','country':'Gabon'},{'locale':'fr-GP','language':'French','country':'Guadeloupe'},{'locale':'fr-HT','language':'French','country':'Haiti'},{'locale':'fr-GN','language':'French','country':'Guinea'},{'locale':'fr-JE','language':'French','country':'Jersey'},{'locale':'fr-MC','language':'French','country':'Principality of Monaco'},{'locale':'fr-CA','language':'French','country':'Canada'},{'locale':'fr-GG','language':'French','country':'Guernsey'},{'locale':'fr-CM','language':'French','country':'Cameroon'},{'locale':'fr-KM','language':'French','country':'Comoros'},{'locale':'fr-LB','language':'French','country':'Lebanon'},{'locale':'fr-MG','language':'French','country':'Madagascar'},{'locale':'fr-LU','language':'French','country':'Luxembourg'},{'locale':'fr-MQ','language':'French','country':'Martinique'},{'locale':'fr-ML','language':'French','country':'Mali'},{'locale':'fr-YT','language':'French','country':'Mayotte'},{'locale':'fr-NC','language':'French','country':'New Caledonia'},{'locale':'fr-CG','language':'French','country':'Republic of the Congo'},{'locale':'fr-RE','language':'French','country':'Reunion'},{'locale':'fr-RW','language':'French','country':'Rwanda'},{'locale':'fr-MF','language':'French','country':'Saint Martin'},{'locale':'fr-BL','language':'French','country':'Saint Barthelemy'},{'locale':'fr-NE','language':'French','country':'Niger'},{'locale':'fr-CH','language':'French','country':'Switzerland'},{'locale':'fr-SC','language':'French','country':'Seychelles'},{'locale':'fr-PM','language':'French','country':'Saint Pierre and Miquelon'},{'locale':'fr-TG','language':'French','country':'Togo'},{'locale':'fr-SN','language':'French','country':'Senegal'},{'locale':'fr-TD','language':'French','country':'Chad'},{'locale':'fr-VA','language':'French','country':'Vatican City'},{'locale':'fr-VU','language':'French','country':'Vanuatu'},{'locale':'fr-WF','language':'French','country':'Wallis and Futuna'},{'locale':'fr-CF','language':'French','country':'Central African Republic'},{'locale':'ff-GN','language':'Fula','country':'Guinea'},{'locale':'ff-BF','language':'Fula','country':'Burkina Faso'},{'locale':'ga-IE','language':'Irish','country':'Ireland'},{'locale':'gv-IM','language':'Manx','country':'Isle of Man'},{'locale':'gn-AR','language':'Guaraní','country':'Argentina'},{'locale':'gn-PY','language':'Guaraní','country':'Paraguay'},{'locale':'ht-HT','language':'Haitian','country':'Haiti'},{'locale':'he-IL','language':'Hebrew (modern)','country':'Israel'},{'locale':'hif-FJ','language':'Fiji Hindi','country':'Fiji'},{'locale':'hr-BA','language':'Croatian','country':'Bosnia and Herzegovina'},{'locale':'hi-IN','language':'Hindi','country':'India'},{'locale':'hr-HR','language':'Croatian','country':'Croatia'},{'locale':'hr-ME','language':'Croatian','country':'Montenegro'},{'locale':'hu-HU','language':'Hungarian','country':'Hungary'},{'locale':'hy-AM','language':'Armenian','country':'Armenia'},{'locale':'id-ID','language':'Indonesian','country':'Indonesia'},{'locale':'is-IS','language':'Icelandic','country':'Iceland'},{'locale':'it-IT','language':'Italian','country':'Italy'},{'locale':'hy-CY','language':'Armenian','country':'Cyprus'},{'locale':'it-SM','language':'Italian','country':'San Marino'},{'locale':'it-CH','language':'Italian','country':'Switzerland'},{'locale':'it-VA','language':'Italian','country':'Vatican City'},{'locale':'kl-GL','language':'Greenlandic','country':'Greenland'},{'locale':'ja-JP','language':'Japanese','country':'Japan'},{'locale':'ka-GE','language':'Georgian','country':'Georgia'},{'locale':'kk-KZ','language':'Kazakh','country':'Kazakhstan'},{'locale':'km-KH','language':'Khmer','country':'Cambodia'},{'locale':'rw-RW','language':'Kinyarwanda','country':'Rwanda'},{'locale':'kg-CD','language':'Kongo','country':'Democratic Republic of the Congo'},{'locale':'ky-KG','language':'Kyrgyz','country':'Kyrgyzstan'},{'locale':'ko-KP','language':'Korean','country':'North Korea'},{'locale':'ko-KR','language':'Korean','country':'South Korea'},{'locale':'kun-ER','language':'Kunama','country':'Eritrea'},{'locale':'lo-LA','language':'Lao','country':'Laos'},{'locale':'ku-IQ','language':'Kurdish','country':'Iraq'},{'locale':'la-VA','language':'Latin','country':'Vatican City'},{'locale':'lv-LV','language':'Latvian','country':'Latvia'},{'locale':'ln-CG','language':'Lingala','country':'Republic of the Congo'},{'locale':'ln-CD','language':'Lingala','country':'Democratic Republic of the Congo'},{'locale':'lb-LU','language':'Luxembourgish','country':'Luxembourg'},{'locale':'lu-CD','language':'Luba-Katanga','country':'Democratic Republic of the Congo'},{'locale':'lt-LT','language':'Lithuanian','country':'Lithuania'},{'locale':'mk-MK','language':'Macedonian','country':'North Macedonia'},{'locale':'mh-MH','language':'Marshallese','country':'Marshall Islands'},{'locale':'mg-MG','language':'Malagasy','country':'Madagascar'},{'locale':'mn-MN','language':'Mongolian','country':'Mongolia'},{'locale':'mi-NZ','language':'Māori','country':'New Zealand'},{'locale':'mt-MT','language':'Maltese','country':'Malta'},{'locale':'ms-BN','language':'Malay','country':'Brunei'},{'locale':'ms-SG','language':'Malay','country':'Singapore'},{'locale':'my-MM','language':'Burmese','country':'Myanmar'},{'locale':'na-NR','language':'Nauruan','country':'Nauru'},{'locale':'nr-ZA','language':'Southern Ndebele','country':'South Africa'},{'locale':'nd-ZW','language':'Northern Ndebele','country':'Zimbabwe'},{'locale':'nl-AW','language':'Dutch','country':'Aruba'},{'locale':'ne-NP','language':'Nepali','country':'Nepal'},{'locale':'nl-BE','language':'Dutch','country':'Belgium'},{'locale':'nl-BQ','language':'Dutch','country':'Caribbean Netherlands'},{'locale':'nl-NL','language':'Dutch','country':'Netherlands'},{'locale':'nl-CW','language':'Dutch','country':'Curacao'},{'locale':'nl-MF','language':'Dutch','country':'Saint Martin'},{'locale':'nl-SX','language':'Dutch','country':'Sint Maarten'},{'locale':'nn-BV','language':'Norwegian Nynorsk','country':'Bouvet Island'},{'locale':'nl-SR','language':'Dutch','country':'Suriname'},{'locale':'nn-NO','language':'Norwegian Nynorsk','country':'Norway'},{'locale':'nb-BV','language':'Norwegian Bokmål','country':'Bouvet Island'},{'locale':'no-BV','language':'Norwegian','country':'Bouvet Island'},{'locale':'nb-NO','language':'Norwegian Bokmål','country':'Norway'},{'locale':'no-NO','language':'Norwegian','country':'Norway'},{'locale':'no-SJ','language':'Norwegian','country':'Svalbard'},{'locale':'pa-AW','language':'Punjabi (Eastern)','country':'Aruba'},{'locale':'nrb-ER','language':'Nara','country':'Eritrea'},{'locale':'ny-MW','language':'Chichewa','country':'Malawi'},{'locale':'pa-CW','language':'Punjabi (Eastern)','country':'Curacao'},{'locale':'pl-PL','language':'Polish','country':'Poland'},{'locale':'pt-AO','language':'Portuguese','country':'Angola'},{'locale':'pt-GQ','language':'Portuguese','country':'Equatorial Guinea'},{'locale':'pt-GW','language':'Portuguese','country':'Guinea-Bissau'},{'locale':'pt-BR','language':'Portuguese','country':'Brazil'},{'locale':'pt-CV','language':'Portuguese','country':'Cape Verde'},{'locale':'pt-MO','language':'Portuguese','country':'Macao'},{'locale':'pt-TL','language':'Portuguese','country':'East Timor'},{'locale':'pt-MZ','language':'Portuguese','country':'Mozambique'},{'locale':'pt-PT','language':'Portuguese','country':'Portugal'},{'locale':'pt-ST','language':'Portuguese','country':'Sao Tome and Principe'},{'locale':'qu-BO','language':'Quechua','country':'Bolivia'},{'locale':'ps-AF','language':'Pashto','country':'Afghanistan'},{'locale':'rar-CK','language':'Cook Islands Māori','country':'Cook Islands'},{'locale':'ro-MD','language':'Romanian','country':'Moldova'},{'locale':'rm-CH','language':'Romansh','country':'Switzerland'},{'locale':'rtm-FJ','language':'Rotuman','country':'Fiji'},{'locale':'rn-BI','language':'Kirundi','country':'Burundi'},{'locale':'ro-RO','language':'Romanian','country':'Romania'},{'locale':'ru-AQ','language':'Russian','country':'Antarctica'},{'locale':'ru-KZ','language':'Russian','country':'Kazakhstan'},{'locale':'ru-BY','language':'Russian','country':'Belarus'},{'locale':'ru-RU','language':'Russian','country':'Russia'},{'locale':'ru-KG','language':'Russian','country':'Kyrgyzstan'},{'locale':'ru-TM','language':'Russian','country':'Turkmenistan'},{'locale':'ru-UZ','language':'Russian','country':'Uzbekistan'},{'locale':'sg-CF','language':'Sango','country':'Central African Republic'},{'locale':'si-LK','language':'Sinhalese','country':'Sri Lanka'},{'locale':'sk-SK','language':'Slovak','country':'Slovakia'},{'locale':'sk-CZ','language':'Slovak','country':'Czechia'},{'locale':'sl-SI','language':'Slovene','country':'Slovenia'},{'locale':'sm-AS','language':'Samoan','country':'American Samoa'},{'locale':'sn-ZW','language':'Shona','country':'Zimbabwe'},{'locale':'ru-TJ','language':'Russian','country':'Tajikistan'},{'locale':'so-SO','language':'Somali','country':'Somalia'},{'locale':'st-LS','language':'Southern Sotho','country':'Lesotho'},{'locale':'st-ZA','language':'Southern Sotho','country':'South Africa'},{'locale':'es-GQ','language':'Spanish','country':'Equatorial Guinea'},{'locale':'es-AR','language':'Spanish','country':'Argentina'},{'locale':'sm-WS','language':'Samoan','country':'Samoa'},{'locale':'es-BO','language':'Spanish','country':'Bolivia'},{'locale':'es-CL','language':'Spanish','country':'Chile'},{'locale':'es-BZ','language':'Spanish','country':'Belize'},{'locale':'es-DO','language':'Spanish','country':'Dominican Republic'},{'locale':'es-CR','language':'Spanish','country':'Costa Rica'},{'locale':'es-SV','language':'Spanish','country':'El Salvador'},{'locale':'es-EC','language':'Spanish','country':'Ecuador'},{'locale':'es-GU','language':'Spanish','country':'Guam'},{'locale':'es-GT','language':'Spanish','country':'Guatemala'},{'locale':'es-CO','language':'Spanish','country':'Colombia'},{'locale':'es-MX','language':'Spanish','country':'Mexico'},{'locale':'es-CU','language':'Spanish','country':'Cuba'},{'locale':'es-HN','language':'Spanish','country':'Honduras'},{'locale':'es-NI','language':'Spanish','country':'Nicaragua'},{'locale':'es-PY','language':'Spanish','country':'Paraguay'},{'locale':'es-PA','language':'Spanish','country':'Panama'},{'locale':'es-PE','language':'Spanish','country':'Peru'},{'locale':'es-PR','language':'Spanish','country':'Puerto Rico'},{'locale':'es-VE','language':'Spanish','country':'Venezuela'},{'locale':'es-UY','language':'Spanish','country':'Uruguay'},{'locale':'es-EH','language':'Spanish','country':'Western Sahara'},{'locale':'es-ES','language':'Spanish','country':'Spain'},{'locale':'sq-AL','language':'Albanian','country':'Albania'},{'locale':'sq-XK','language':'Albanian','country':'Kosovo'},{'locale':'sr-BA','language':'Serbian','country':'Bosnia and Herzegovina'},{'locale':'sr-XK','language':'Serbian','country':'Kosovo'},{'locale':'sq-ME','language':'Albanian','country':'Montenegro'},{'locale':'sr-ME','language':'Serbian','country':'Montenegro'},{'locale':'sr-RS','language':'Serbian','country':'Serbia'},{'locale':'ss-SZ','language':'Swati','country':'Eswatini'},{'locale':'ss-ZA','language':'Swati','country':'South Africa'},{'locale':'sw-CD','language':'Swahili','country':'Democratic Republic of the Congo'},{'locale':'sw-KE','language':'Swahili','country':'Kenya'},{'locale':'sw-TZ','language':'Swahili','country':'Tanzania'},{'locale':'sw-UG','language':'Swahili','country':'Uganda'},{'locale':'ssy-ER','language':'Saho','country':'Eritrea'},{'locale':'sv-AX','language':'Swedish','country':'Åland Islands'},{'locale':'ta-SG','language':'Tamil','country':'Singapore'},{'locale':'sv-FI','language':'Swedish','country':'Finland'},{'locale':'sv-SE','language':'Swedish','country':'Sweden'},{'locale':'ta-LK','language':'Tamil','country':'Sri Lanka'},{'locale':'tg-TJ','language':'Tajik','country':'Tajikistan'},{'locale':'th-TH','language':'Thai','country':'Thailand'},{'locale':'ti-ER','language':'Tigrinya','country':'Eritrea'},{'locale':'to-TO','language':'Tonga (Tonga Islands)','country':'Tonga'},{'locale':'tn-ZA','language':'Tswana','country':'South Africa'},{'locale':'tn-BW','language':'Tswana','country':'Botswana'},{'locale':'tig-ER','language':'Tigre','country':'Eritrea'},{'locale':'ts-ZA','language':'Tsonga','country':'South Africa'},{'locale':'tk-AF','language':'Turkmen','country':'Afghanistan'},{'locale':'tk-TM','language':'Turkmen','country':'Turkmenistan'},{'locale':'tr-CY','language':'Turkish','country':'Cyprus'},{'locale':'uk-UA','language':'Ukrainian','country':'Ukraine'},{'locale':'ur-PK','language':'Urdu','country':'Pakistan'},{'locale':'tr-TR','language':'Turkish','country':'Turkey'},{'locale':'uz-AF','language':'Uzbek','country':'Afghanistan'},{'locale':'uz-UZ','language':'Uzbek','country':'Uzbekistan'},{'locale':'vi-VN','language':'Vietnamese','country':'Vietnam'},{'locale':'zh-CN','language':'Chinese','country':'China'},{'locale':'ve-ZA','language':'Venda','country':'South Africa'},{'locale':'xh-ZA','language':'Xhosa','country':'South Africa'},{'locale':'zh-HK','language':'Chinese','country':'Hong Kong'},{'locale':'zh-SG','language':'Chinese','country':'Singapore'},{'locale':'zh-TW','language':'Chinese','country':'Taiwan'},{'locale':'zh-MO','language':'Chinese','country':'Macao'},{'locale':'ms-MY','language':'Malay','country':'Malaysia'},{'locale':'zu-ZA','language':'Zulu','country':'South Africa'}];

/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom_server__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom_server___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_dom_server__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_utils_state__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_utils_users__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_utils_string__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_utils_intercom__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Header__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_RealEstatePackages__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_redux_modules_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_StickyHeader_StickyHeader__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_RolesTooltip__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_subscription__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__theme_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_PromoForm__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_QuantityField__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_redux_modules_discount__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_redux_modules_crs__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__material_ui_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__material_ui_icons_ExpandMore__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__material_ui_icons_ExpandMore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__material_ui_icons_ExpandMore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__material_ui_icons_KeyboardArrowDown__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__material_ui_icons_KeyboardArrowDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__material_ui_icons_KeyboardArrowDown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__redux_modules_chargebee__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__redux_modules_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_redux_modules_companies__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__redux_modules_session__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__utils_storage__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_redux_modules_error__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_redux_modules_preloader__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_redux_modules_chargebeeLoader__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_lib_Segment_customTrackers__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_lib_Segment_helpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_i18n_i18n__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_components_CenteredContent_CenteredContent__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__utils_url__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_routes__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_theme_uiConfig__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__errors_apperror__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__logger_logger__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_redux_modules_app__ = __webpack_require__(122);
var _dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_49_i18n_i18n__["a" /* default */].loc.localize;var log=__WEBPACK_IMPORTED_MODULE_56__logger_logger__["a" /* default */].get('Subscription');var localeDateStringOptions={year:'numeric',month:'short',day:'numeric'};// Use this to create breakpoint when screen is smaller for 200px compared to LG MUI breakpont 
var BREAKPOINT_1100_DIFFERENCE=200;var PERIOD_AND_CURRENCY_SELECTOR_DIFFERENCE=10;var CLEAR_PENDING_SUBSCRIPTION_TIMEOUT=30000;var PACKAGE_COLUMN_WIDTH_TRESHOLD_CLOUD=300;var PACKAGE_COLUMN_WIDTH_TRESHOLD_DESKTOP=225;var itemRefPrefix=['ProductPriceInfo','ProductShortDescriptionDesktop','ProductShortDescriptionCloud'];var styles=function styles(theme){var _columnDiscountBanner;return{stickyHeader:{marginBottom:45,marginLeft:-10,marginRight:-10,paddingLeft:10,paddingRight:10,width:'calc(100% + 20px)',maxWidth:1360,background:theme.palette.common.white},header:{paddingBottom:20},/* product list */productsList:{//maxWidth: 1350,
flexDirection:'column'},productsListVerticalWrapper:{width:'100%'},productsListVertical:{position:'relative',flexDirection:'row',flexWrap:'nowrap',justifyContent:'space-between','&.columns2 .productVerticalColumn':{flex:'0 0 calc(50% - 18px)','&:last-child':{marginLeft:18,marginRight:'auto'}},'&.columns3 .productVerticalColumn':{flex:'0 0 calc(33% - 18px)'},'&.columns4 .productVerticalColumn':{flex:'0 0 calc(25% - 18px)','& .productContentVertical':{padding:18}},'&.mobilePackageList':{display:'block','& .productVerticalColumn':{margin:'0 0 10px !important'}}},product:{width:'100%',marginBottom:20},productVerticalColumn:{maxWidth:427,display:'flex'},productWrapperVertical:{borderRadius:20,boxShadow:'0px 0px 10px 1px rgba(0, 0, 0, 0.10);',padding:8,display:'flex','&.isCloudCategory.scaleBox:not(.activeProductContent)':{background:'linear-gradient(to bottom, #FF00B1, #632ACD)'}},productContent:{borderRadius:0,boxShadow:'0px 0px 10px 1px rgba(0, 0, 0, 0.10);',padding:25},ownedProductContent:{position:'relative',paddingTop:55,paddingBottom:55,'&.hasAddons':{position:'relative',margin:'0 0 30px'},'&.hasAddons:after':{position:'absolute',bottom:'-25px',left:0,content:'""',height:1,width:'100%',background:'#ebebeb'},'&.hasCancellationDate':{paddingTop:25,paddingBottom:25},'&.hasReactivateLink':{paddingTop:16,paddingBottom:0},'&.isMonthly':{paddingTop:16,paddingBottom:0}},activeProductContent:{'& .productContentVertical':{background:'#F4F4F4'},'& .packageDetailsTag':{background:'#e1e1e1'}},productColumns:__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({},theme.breakpoints.down('sm'),{flexDirection:'column'}),productContentVertical:{display:'flex',background:'#fff',flexDirection:'column',borderRadius:14,padding:'24px 24px 10px'},/* column name / price */gridProductHeader:{position:'relative',marginBottom:10},gridProducPriceAndDescription:{},productTag:{background:'#FF00B1',color:'#fff',fontSize:13,lineHeight:1.2,textTransform:'uppercase',borderRadius:5,opacity:1,padding:'2px 7px',position:'absolute',top:5,right:0},productTagCurrent:{background:'#000'},columnProductIcon:{width:'60px',marginRight:'10px',display:'flex',alignItems:'center','& img':{display:'block'}},columnProductTitle:{width:'calc(100% - 70px)',justifyContent:'center'},columnProductTitleSimple:{fontSize:24,lineHeight:1},productTitle:{color:'#000',fontSize:'20px',fontWeight:700,lineHeight:1},productTitleLarge:{fontSize:'24px'},productTitleUnlimited:{},productQuantityPerUser:{color:'#000',fontSize:'14px',opacity:1},productPriceInfo:__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({},theme.breakpoints.down('sm'),{width:'100%'}),productPriceInfoVertical:{width:'100%'},productMembersIncludedInfo:{},productPriceInfoPending:{color:'#000',fontSize:'14px',opacity:1,margin:'20px 0 37px',fontStyle:'italic'},productPrice:{paddingTop:'10px',color:'#000',marginBottom:7,fontSize:'32px',lineHeight:1,fontWeight:700,'&:before':{content:'attr(data-icon)'}},productMonthLabel:{fontSize:'15px',fontWeight:400},itemsVatLabel:{fontSize:'15px',fontWeight:400,marginLeft:5,lineHeight:1,whiteSpace:'nowrap'},itemsQuantityabel:{fontSize:'15px',fontWeight:400,marginLeft:5,lineHeight:1},productSavedAmount:{background:'#FDD8D8',marginBottom:'5px',color:'#FF4D4D',fontSize:'11px',lineHeight:'14px',padding:'5px',opacity:1},productPriceBilledAnualy:{width:'100%',marginBottom:5,fontSize:'14px',lineHeight:'1.4',opacity:1,color:'#858585'},productPriceBilledAnualyValue:{marginLeft:5,color:'#000'},columnProductShortDescriptionDesktop:{paddingBottom:20},productShortDescriptionDesktop:{width:'100%',fontSize:'14px',lineHeight:1.4,color:'#000',opacity:1},productShortDescriptionCloud:{width:'100%',fontSize:'14px',lineHeight:1.4,color:'#632ACF',opacity:1,paddingBottom:25},columnProductDescriptionMain:{},columnProductDescriptionSecondary:{},/* column description main */productDescriptionMainTitle:{color:'#000',fontSize:'20px',lineHeight:1,fontWeight:700,marginBottom:'20px'},button:{padding:'0 15px 1px',borderRadius:'21px',background:'#000',fontSize:'14px',lineHeight:'35px',fontWeight:600,textTransform:'uppercase',textShadow:'none','&:hover':{backgroundColor:theme.palette.colors.darkPurpleHover}},/* column description secondary */purchaseButton:__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({marginTop:'25px',marginBottom:'26px',minWidth:'200px',padding:'7px 15px 8px',lineHeight:1.5,whiteSpace:'wrap'},theme.breakpoints.down('md'),{whiteSpace:'wrap',minWidth:0}),viewCurrentPlanButtonContainer:{},viewCurrentPlanButton:{width:'100%',maxWidth:'200px',background:'#fff',color:'#000',border:'1px solid #000','&:hover':{borderColor:theme.palette.colors.darkPurpleHover},marginTop:'25px',marginBottom:'26px','html[lang="de"] &':{maxWidth:'230px'}},/* members included info */membersIncludedList:{padding:'10px 0 0'},membersIncludedListItem:{margin:'0 0 6px',padding:0,alignItems:'flex-start'},membersIncludedListItemText:{padding:0},membersIncludedListItemTextItem:{fontSize:'14px',lineHeight:1.4,color:'#000'},membersIncludedListItemIcon:{margin:'2px 5px 0 0','& svg':{color:'#000 !important'}},/* features list */featuresList:{},featuresListItem:{margin:'0 0 6px',padding:0},featuresListItemCloudStyle:{paddingLeft:0,paddingRight:0,'& svg':{color:'#000 !important'}},featuresListItemText:{padding:0},featuresListItemTextCloudStyle:{padding:'0 0 0 6px'},featuresListItemTextItem:{fontSize:'14px',lineHeight:1.4,color:'#000'},featuresListItemTextItemCloudStyle:{fontSize:'15px',lineHeight:1.2,color:'#000',fontWeight:600},featuresListItemIcon:{margin:'0 5px 0 0'},essentialBox:{'& svg':{color:theme.palette.colors.zeta}},scaleBox:{'& svg':{color:theme.palette.colors.darkPurple},'&.isCloudCategory svg':{color:theme.palette.colors.zeta}},webBox:{'& svg':{color:theme.palette.colors.darkPurple}},photoBox:{'& svg':{color:'#2FE7CE'}},designerBox:{'& svg':{color:'#2888C3'}},featuresListItemIconIncluded:{},featuresListItemIconExcluded:{width:16,height:16,color:'red !important'},planCategoryTag:{color:'#632ace',padding:'1px 10px',margin:'0 0 15px',opacity:1,display:'inline-block',fontSize:'15px',lineHeight:1.5,background:'#dfd3f4',borderRadius:3},/* filters */periodAndCurrencySelectorContainer:{//maxWidth: 1350,
borderTop:'1px solid #ebebeb',paddingTop:17,paddingBottom:17,justifyContent:'flex-start','&.layoutWithQuantityField':{justifyContent:'space-between','& .periodSelectorColumn':{order:1},'& .currencySelectorColumn':{order:2}},'&.layoutWithPeriodSelector':__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({},theme.breakpoints.down(theme.breakpoints.values.lg-PERIOD_AND_CURRENCY_SELECTOR_DIFFERENCE),{display:'block'})},periodSelectorColumn:{marginLeft:'auto'},categorySelector:{borderTop:'1px solid #ebebeb',paddingTop:45,justifyContent:'center',width:'100%',height:'auto',padding:'0',marginBottom:'30px','& + .periodAndCurrencySelectorContainer':{borderTop:0}},categorySelectorColumn:{padding:'0 10px',width:300},categorySelectorButton:{textDecoration:'none',color:theme.palette.colors.colorWithAlpha(theme.palette.colors.zeta,0.75),'&:hover':{textDecoration:'none'},marginBottom:10},categorySelectorButtonActive:{backgroundColor:theme.palette.colors.alpha,color:theme.palette.common.white,pointerEvents:'none','&:hover':{backgroundColor:theme.palette.colors.alpha,color:theme.palette.common.white}},periodSelector:__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({display:'flex',alignItems:'center',justifyContent:'center',marginBottom:10,marginRight:15},theme.breakpoints.down(theme.breakpoints.values.lg-PERIOD_AND_CURRENCY_SELECTOR_DIFFERENCE),{display:'block'}),periodSelectorLabel:{'& span':{opacity:1,color:'#000',fontSize:15,lineHeight:1}},periodSelectorLabelChecked:{'& span':{opacity:1,color:'#2fa5e7',fontSize:15,lineHeight:1,'&[class*=MuiFormControlLabel-label]':{color:'#000'}}},periodSelectorLabelHover:{'&:hover span':{color:'#2888c3 !important'}},periodSelectorDiscount:{background:'#E1F4FD',color:'#2888C3 !important',display:'inline-block',padding:5,opacity:1,borderRadius:5},radioButton:{root:{'&$checked':{color:'#2FA5E7'}},checked:{}},currencySelector:{border:'none',boxShadow:'none',position:'relative',top:0,marginBottom:15},currencySelectorSelect:{'& [class*=MuiSelect-selectMenu]':{fontSize:15}},currencySelectorSelectItems:{'& li':{fontSize:15}},inline:{display:'inline'},noMargins:{margin:0},marginTop20:{marginTop:20},marginBottom20:{marginBottom:20},yourCurrentSubscription:{},/* owned products */columnActiveProductName:__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({width:'37.5%',paddingRight:'20px'},theme.breakpoints.down('sm'),{width:'100%',paddingRight:0}),columnActiveProductDetails:__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({display:'flex',flexDirection:'column',justifyContent:'center',width:'43.5%',paddingRight:'20px'},theme.breakpoints.down('sm'),{width:'100%',paddingRight:0,paddingTop:10}),columnTextLarger:{fontFamily:'"Open Sans Xara", Arial, Helvetica, sans-serif',fontSize:16,lineHeight:1.5,fontWeight:600,opacity:1},columnTextSmaller:{fontFamily:'"Open Sans Xara", Arial, Helvetica, sans-serif',fontWeight:'normal',fontSize:14,lineHeight:1.5,opacity:1},columnActiveProductDetailsTitle:{paddingBottom:10},columnActiveProductDetailsQuantity:{marginBottom:10},columnActiveProductDetailsUsedInfo:{},columnActiveProductDetailsBillingDate:{marginBottom:10},columnActiveProductDetailsCurrentBillingPeriod:{marginBottom:10},columnActiveProductDetailsSubscriptionRenewalDate:{maxWidth:323,borderTop:'1px solid #ebebeb',paddingTop:15,marginTop:4},columnActiveProductDetailsCancellationDate:{maxWidth:323,color:'#F26600',borderTop:'1px solid #ebebeb',paddingTop:15,marginTop:4},columnActiveProductDetailsRevokeCancellationInfo:{maxWidth:323,paddingTop:7},columnActiveProductDetailsSeatsStats:{marginBottom:10},infoPendingSubscription:{},infoAccessToProducts:{},expiredProductsLists:{'& li':{position:'relative',maxWidth:300,padding:'0 0 0 10px','&:before':{content:'""',display:'inline-block',width:'3px',height:'3px',borderRadius:3,background:'#000',marginRight:5,position:'absolute',top:10,left:0},'& p':{}}},columnActiveProductActions:__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({width:'18%',display:'flex'},theme.breakpoints.down('sm'),{width:'100%',paddingTop:0,paddingRight:0}),columnActiveProductActionsList:{display:'flex',justifyContent:'center',flexDirection:'column','& li':{padding:0}},columnActiveProductActionsListItem:{marginTop:10,'&:last-child':{marginBottom:10}},activeProductActionLink:{fontSize:16,lineHeight:1.5,textDecoration:'underline',textAlign:'left','&:hover':{color:'#2888C3'}},upgradeLink:{},contactUsLink:{},viewDetailsAndManageLink:{},buyMoreSeatsLink:{},buyMoreSeatsLinkDisabled:{color:'rgba(0, 0, 0, 0.87)',textDecoration:'none','&:hover':{color:'rgba(0, 0, 0, 0.87)',textDecoration:'none',cursor:'default'}},buyMoreLicenses:{},italic:{fontStyle:'italic'},underlined:{borderBottom:'1px solid'},moreInfo:{display:'inline-flex',cursor:'pointer','& svg':{marginTop:-2}},haveQuestionContainer:{paddingTop:20},haveQuestionsMessage:{},haveQuestionsLink:{fontSize:'inherit','&:hover':{color:'#2888C3'}},productCTASwitchOrReactivate:{background:'#CDEFFF',justifyContent:'center',padding:'7px 20px',width:'calc(100% + 50px)',margin:'13px -25px 0'},switchOrReactivateLink:{fontSize:14,color:'#2E3F4F',opacity:1,'&:hover':{color:'#2888C3'}},/* promo code / discount banner */promoFormAndDiscountBannerContainer:__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({//maxWidth: 1350,
paddingBottom:45,justifyContent:'space-between'},theme.breakpoints.down(theme.breakpoints.values.lg-BREAKPOINT_1100_DIFFERENCE),{flexDirection:'column'}),/* promo code form */columnPromoForm:__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({width:'55%'},theme.breakpoints.down(theme.breakpoints.values.lg-BREAKPOINT_1100_DIFFERENCE),{width:'100%',marginBottom:'30px'}),/* tooltip */arrow:{position:'absolute',fontSize:6,width:'3em',height:'1em',bottom:0,left:'50%',transform:'translateX(-50%)',marginBottom:'-0.95em','&::before':{content:'""',margin:'auto',display:'block',width:0,height:0,borderStyle:'solid',borderWidth:'1em 1em 0 1em',borderColor:"".concat(theme.palette.common.black," transparent transparent transparent")}},infoTooltip:{padding:7,backgroundColor:theme.palette.common.black},infoTooltipText:{color:theme.palette.common.white,opacity:1},infoIcon:{width:15,height:15,color:'#6F99BD',border:'1px solid #6F99BD',padding:0,marginLeft:10},infoIconQuantityField:{position:'relative',top:12},/* discount banner */columnDiscountBanner:(_columnDiscountBanner={width:'40%',alignItems:'center'},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_columnDiscountBanner,theme.breakpoints.down('md'),{width:'45%'}),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_columnDiscountBanner,theme.breakpoints.down(theme.breakpoints.values.lg-BREAKPOINT_1100_DIFFERENCE),{width:'100%'}),_columnDiscountBanner),discountBannerContainer:__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({flexWrap:'nowrap',justifyContent:'flex-end'},theme.breakpoints.down(theme.breakpoints.values.lg-BREAKPOINT_1100_DIFFERENCE),{justifyContent:'center'}),discountBannerQuestionColumn:{},discountBannerQuestion:__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({color:'#000',fontSize:15,lineHeight:1.2,opacity:1},theme.breakpoints.down(theme.breakpoints.values.lg-BREAKPOINT_1100_DIFFERENCE),{textAlign:'center'}),discountBannerVoucherIconColumn:__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({padding:'0 10px 0 0'},theme.breakpoints.down('sm'),{padding:'0 0 10px'}),discountBannerVoucherIcon:{position:'relative',top:'2px'},discountBannerDiscountAppliedColumn:__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({},theme.breakpoints.down('sm'),{width:'auto',textAlign:'center',paddingLeft:'10px',paddingRight:'10px'}),discountBannerDiscountApplied:{fontSize:15,color:'#000',lineHeight:1.2,opacity:1,fontWeight:600,fontFamily:'Lato, "Open Sans Xara", Arial, Helvetica, sans-serif'},discountBannerGetDiscountButtonColumn:{padding:'0 0 0 10px'},discountBannerTryAnotherSerialButtonColumn:__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({padding:'0 0 0 20px',textAlign:'right'},theme.breakpoints.down('sm'),{padding:'10px 0 0',textAlign:'center'}),discountBannerTryAnotherSerial:{fontSize:'11px'},discountBannerLink:{fontSize:14,color:'#000',lineHeight:1.2,opacity:1,fontWeight:600,fontFamily:'Lato, "Open Sans Xara", Arial, Helvetica, sans-serif',textTransform:'uppercase'},/* see all products */seeAllProductsLink:{color:'#000',textTransform:'uppercase',marginRight:'auto',marginLeft:18,alignSelf:'flex-start',opacity:1},/* main tabs at top */subscriptionViewSelector:{paddingTop:25,paddingBottom:45},subscriptionViewSelectorColumn:{},subscriptionViewSelectorLink:{position:'relative',fontSize:15,color:'#000',lineHeight:1.2,opacity:1,fontWeight:600,fontFamily:'Lato, "Open Sans Xara", Arial, Helvetica, sans-serif',padding:'0 19px 7px',display:'inline-block',transition:'color 0.2s',letterSpacing:0,'&:hover':{color:theme.palette.colors.alpha}},subscriptionViewSelectorLinkActive:{color:theme.palette.colors.alpha,'&:after':{position:'absolute',display:'block',content:'""',width:'100%',height:2,bottom:0,left:0,background:theme.palette.colors.alpha}},purchaseOptionsWrapper:{maxWidth:1350,'& > .planBoxesWrapper:first-child':{'& > div:first-child':{paddingTop:0,borderTop:0}}},planBoxesWrapper:{},quantitySelectorColumn:{'& + .periodSelectorColumn':__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({order:0},theme.breakpoints.down(theme.breakpoints.values.lg-PERIOD_AND_CURRENCY_SELECTOR_DIFFERENCE),{marginLeft:0})},currencySelectorColumn:__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({},theme.breakpoints.down(theme.breakpoints.values.lg-PERIOD_AND_CURRENCY_SELECTOR_DIFFERENCE),{maxWidth:200}),noProductsFound:{color:theme.palette.common.black,opacity:1},/* Accepted payment methods */acceptedPaymentMethodsContainer:{justifyContent:'center',padding:'40px 0 20px'},acceptedPaymentMethods:{padding:'0 0 0 16px',color:'#000',fontSize:15,lineHeight:1.2,fontWeight:600,opacity:1},acceptedPaymentMethodsIcon:{height:'16px',position:'relative',top:3,margin:'0 0 0 20px'},/* Accordion */packageDetailsAccordion:{background:'none',margin:'0 0 18px !important',boxShadow:'none',border:0,'&::before':{display:'none'},'&.packageDetailsHighlighted':{'& .accordionTitle':{textTransform:'uppercase',color:theme.palette.colors.darkPurpleHover},'& .expandAccordionIcon':{color:theme.palette.colors.darkPurpleHover}},'&.packageDetailsHasTag':{'& .accordionTitle':{}}},packageDetailsAccordionSummary:{padding:0,margin:0,minHeight:0,'&.packageDetailsAccordionSummaryExpanded':{minHeight:0},'& > div:first-child':{margin:0},'&:hover h2':{},'&:hover .expandAccordionIcon':{}},packageDetailsAccordionDetails:{padding:'10px 0 0'},packageDetailsAccordionContent:{padding:'0 0 0 26px',opacity:1,color:'#000','& span':{display:'block','&:not(:last-child)':{marginBottom:6}}},packageDetailsAccordionExpanded:{'& .expandAccordionIcon':{transform:'translateY(-50%) rotate(-180deg)'}},columnAccordionToggleIcon:{position:'relative',flex:'0 0 20px'},columnAccordionToggleTitle:{paddingLeft:6,flex:'1 1 calc(100% - 20px)',position:'relative'},accordionTitle:{fontSize:15,lineHeight:1.2,fontWeight:600,opacity:1,color:'#000','&:after':{content:'""',clear:'both',display:'table'}},expandAccordionIcon:{'position':'absolute','top':'50%',transform:'translateY(-50%) rotate(0deg)','left':0,transition:'transform 0.2s'},packageDetailsTag:{fontFamily:'"Open Sans Xara", Arial, Helvetica, sans-serif',fontWeight:'normal',background:'#F4F4F4',color:'#616161',fontSize:15,lineHeight:1.2,borderRadius:5,opacity:1,padding:'1px 4px',marginLeft:10,"float":'right','html[lang="de"] &':{maxWidth:120,textAlign:'center'}},columnPackageDetailsSectionTitle:{position:'relative'},packageDetailsSectionTitle:{color:theme.palette.colors.darkPurpleHover,textTransform:'uppercase',fontWeight:600,fontSize:15,lineHeight:1.2,marginBottom:'17px','&:after':{content:'""',clear:'both',display:'table'}},packageDetailsSectionContent:{padding:'0 0 0 26px',margin:'-10px 0 20px 0',opacity:1,color:'#000'},/* addons */addonsWrapper:{borderTop:'1px solid #ebebeb',marginTop:40,paddingTop:35},addonsTitleGrid:{paddingBottom:30},addonsTitle:{fontFamily:'Lato, "Open Sans Xara", Arial, Helvetica, sans-serif',fontSize:24,lineHeight:1.2,fontWeight:700},addonContainer:__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({justifyContent:'space-between',borderRadius:20,boxShadow:'0px 0px 10px 1px rgba(0, 0, 0, 0.10);',padding:25,marginBottom:15,'&:last-child':{marginBottom:0},'&.addonContainer-ai':{'& img':{width:50}}},theme.breakpoints.down('sm'),{display:'block'}),addonTitleAndDescriptionColumn:__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({flex:'0 0 calc(33% - 18px)'},theme.breakpoints.down('sm'),{paddingBottom:20}),addonIconAndTitle:{marginBottom:20},addonIconColumn:{width:55,marginRight:'15px',display:'flex',alignItems:'center','& img':{display:'block',width:'100%'}},addonTitleColumn:{width:'calc(100% - 70px)',justifyContent:'center'},addonTitle:{fontFamily:'Lato, "Open Sans Xara", Arial, Helvetica, sans-serif',fontSize:20,lineHeight:1.2,fontWeight:700},addonTag:{background:'#F4F4F4',color:'#616161',fontSize:15,lineHeight:1.2,borderRadius:5,opacity:1,padding:'2px 4px',display:'inline-block',marginBottom:20},addonDescription:{fontSize:15,lineHeight:1.2,opacity:1,color:'#2888C3',marginBottom:15},addonDetails:{fontSize:15,lineHeight:1.2,opacity:1,color:'#000'},addonDetailsListColumn:__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({flex:'0 0 calc(33% - 18px)',display:'flex',flexDirection:'column',justifyContent:'center'},theme.breakpoints.down('sm'),{paddingBottom:20}),addonDetailsList:{},addonDetailsListItem:{margin:'0 0 12px',padding:0},addonDetailsListItemIcon:{margin:'0 10px 0 0','& svg':{color:'#2888C3'}},addonDetailsListItemIconIncluded:{},addonDetailsListItemText:{padding:0},addonDetailsListItemTextItem:{fontSize:'14px',lineHeight:1.4,color:'#000'},addonFeaturesNote:{fontSize:'12px',lineHeight:1.2,color:'#000'},addonActionsColumn:{flex:'0 0 calc(33% - 18px)',display:'flex',alignItems:'center',justifyContent:'center'},addonButtonContainer:{},addonButton:__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({minWidth:'200px',padding:'7px 15px 8px',lineHeight:1.5,whiteSpace:'wrap'},theme.breakpoints.down('md'),{whiteSpace:'wrap',minWidth:0})};};var Subscription=(_dec=Object(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits___default()(Subscription,_Component);function Subscription(props){var _this;__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default()(this,Subscription);_this=__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default()(Subscription).call(this,props));_this.updateDimensionsThrottled=__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.throttle(_this.updateDimensions.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)),500);_this.getSubscriptionEstimationDebounced=__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.debounce(_this.props.getSubscriptionEstimation,350);Object.values(__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */]).forEach(function(plan){_this["".concat(plan.toLowerCase(),"ProductPriceInfoRef")]=__WEBPACK_IMPORTED_MODULE_10_react___default.a.createRef();_this["".concat(plan.toLowerCase(),"ProductShortDescriptionDesktopRef")]=__WEBPACK_IMPORTED_MODULE_10_react___default.a.createRef();_this["".concat(plan.toLowerCase(),"ProductShortDescriptionCloudRef")]=__WEBPACK_IMPORTED_MODULE_10_react___default.a.createRef();});_this['productsListVerticalRef']=__WEBPACK_IMPORTED_MODULE_10_react___default.a.createRef();var _parseQuery=Object(__WEBPACK_IMPORTED_MODULE_52__utils_url__["d" /* parseQuery */])(props.location.search),email=_parseQuery.email;var planId=props.match.params.planId;_this.buyMoreSeatsCallback=_this.buyMoreSeatsCallback.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.reactivateMySubscriptionHandler=_this.reactivateMySubscriptionHandler.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.showSubscriptionDetails=_this.showSubscriptionDetails.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.calculateCheckoutData=_this.calculateCheckoutData.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.fetchSubscriptionEstimate=_this.fetchSubscriptionEstimate.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.getSubscriptionEstimationUrl=_this.getSubscriptionEstimationUrl.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.renderCurrencySelector=_this.renderCurrencySelector.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.handleCurrencyChange=_this.handleCurrencyChange.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.renderInfoTooltip=_this.renderInfoTooltip.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.getDiscountPrice=_this.getDiscountPrice.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.getDefaultQuantity=_this.getDefaultQuantity.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.getQuantityInputValue=_this.getQuantityInputValue.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.doCheckout=_this.doCheckout.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.changeRoute=_this.changeRoute.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.handleSwitchToPlansFromBuyMoreLicensesPopup=_this.handleSwitchToPlansFromBuyMoreLicensesPopup.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.routeToOneTimeCheckBoxAndShowDiscountPopup=_this.routeToOneTimeCheckBoxAndShowDiscountPopup.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.contactUsHandler=_this.contactUsHandler.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.shouldShowAppliedDiscountForCurrentPackage=_this.shouldShowAppliedDiscountForCurrentPackage.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.getQualifyingProductsForCoupon=_this.getQualifyingProductsForCoupon.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.getNumberOfQualifyingProductsForCoupon=_this.getNumberOfQualifyingProductsForCoupon.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.clearInvalidFieldsForBuyMorePopup=_this.clearInvalidFieldsForBuyMorePopup.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.addVersionToTitle=_this.addVersionToTitle.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.handleBuyRequest=_this.handleBuyRequest.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.getVatLabel=_this.getVatLabel.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this));var stateFromProps=_this.getStateFromProps(props);var cbPlanIdAfterRedirect=__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(_this.props,'location.state.cbPlanIdAfterRedirect');_this.state=__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({accordion:{}},stateFromProps,{willProceedToCheckout:false,redirectRoute:null,mobilePackageList:false,// [P9052-10176] The app will fill in add member input after upgrade to Team by this email into.
email:email,hideDiscountBannerForeverChecked:false});if([planId,cbPlanIdAfterRedirect].includes(__WEBPACK_IMPORTED_MODULE_38__config__["_37" /* STANDARD_OVERVIEW_PLAN_ID */])){Object(__WEBPACK_IMPORTED_MODULE_47_lib_Segment_customTrackers__["Z" /* trackVisitedStandardOverview */])(Object(__WEBPACK_IMPORTED_MODULE_48_lib_Segment_helpers__["a" /* getTrackingOptions */])(_this.props.company));}if([planId,cbPlanIdAfterRedirect].includes(__WEBPACK_IMPORTED_MODULE_38__config__["_25" /* REAL_ESTATE_OVERVIEW_PLAN_ID */])){Object(__WEBPACK_IMPORTED_MODULE_47_lib_Segment_customTrackers__["Y" /* trackVisitedRealEstateOverview */])(Object(__WEBPACK_IMPORTED_MODULE_48_lib_Segment_helpers__["a" /* getTrackingOptions */])(_this.props.company));}var blockRedirectOnReRoute=true;if(planId){var _convertPlanIdIntoSub=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(planId||cbPlanIdAfterRedirect),plan=_convertPlanIdIntoSub.plan;if(__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT===plan&&Object(__WEBPACK_IMPORTED_MODULE_17_utils_users__["e" /* filterNonGuestUsers */])(_this.props.company.users).length>1){// block direct checkout link link to individual plan when admins + members > 1 
// cap_url/#6925641cfbc87de97a5d5683/?chargebee-plan-id=individual_agent-monthly-usd
blockRedirectOnReRoute=true;}else if([__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES,__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT].includes(plan)){blockRedirectOnReRoute=false;}}if(_this.props.isCBPlanExternalRedirect&&Object(__WEBPACK_IMPORTED_MODULE_16_utils_state__["e" /* showNewRealEstateUI */])(_this.props.company,_this.props.app.isDesktopTrial,_this.props.app.isReAccessNoIndustry)&&blockRedirectOnReRoute){_this.state.shouldStartUpdate=false;}else{_this.state.shouldStartUpdate=(planId||cbPlanIdAfterRedirect)&&_this.shouldStartSubscriptionUpgrade(planId||cbPlanIdAfterRedirect);}if(planId&&!cbPlanIdAfterRedirect){// happens on both initial purchase AND upgrade but only when following link to CAP in format:
// localhost:3000/#62c59dcd465cc44ca33f04e0/?chargebee-plan-id=teamplus-annual-usd
if(_this.state.shouldStartUpdate){// this path happens also for initial purchase not just upgrade
var _convertPlanIdIntoSub2=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(planId||cbPlanIdAfterRedirect),_plan=_convertPlanIdIntoSub2.plan,period=_convertPlanIdIntoSub2.period,currency=_convertPlanIdIntoSub2.currency;!_this.hasPlan&&_this.props.showPreloader();var _getSubscriptionsAndA=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["i" /* getSubscriptionsAndAddons */])(_this.props.company,true),pastSubscription=_getSubscriptionsAndA.subscription;if(!__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.isEmpty(pastSubscription)){var _convertPlanIdIntoSub3=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(pastSubscription.planId);currency=_convertPlanIdIntoSub3.currency;}var _PACKAGES_CONFIG$_pla=__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][_plan],freeSeatsIncluded=_PACKAGES_CONFIG$_pla.freeSeatsIncluded,isPerpetual=_PACKAGES_CONFIG$_pla.isPerpetual;/*
				use freeSeatsIncluded for quantity for direct link
				to avoid THE_NUMBER_OF_THE_USERS_CANNOT_BE_LESS_THAN_THE_NUMBER_OF_USERS_OF_COMPANY error
				or quantity from url params 
				*/var useQuantity=Math.max(freeSeatsIncluded,_this.props.productQuantity||1);Object(__WEBPACK_IMPORTED_MODULE_47_lib_Segment_customTrackers__["l" /* trackClickSubscriptionUpgrade */])(_plan,period,isPerpetual,Object(__WEBPACK_IMPORTED_MODULE_48_lib_Segment_helpers__["a" /* getTrackingOptions */])(_this.props.company));var nonGuestUsers=Object(__WEBPACK_IMPORTED_MODULE_17_utils_users__["e" /* filterNonGuestUsers */])(_this.props.company.users);if(!_this.props.currentPlanId&&Object(__WEBPACK_IMPORTED_MODULE_16_utils_state__["e" /* showNewRealEstateUI */])(_this.props.company,_this.props.app.isDesktopTrial,_this.props.app.isReAccessNoIndustry)&&nonGuestUsers.length>useQuantity){// For real estate company, avoid triggering showModalInReduceUsersApiWorkflow after
// THE_NUMBER_OF_THE_USERS_CANNOT_BE_LESS_THAN_THE_NUMBER_OF_USERS_OF_COMPANY error,
// instead force to checkout with all filterNonGuestUsers().length
useQuantity=nonGuestUsers.length;}_this.proceedChargeBeeSubscription(_plan,period,currency,!!_this.activePlan,_this.getCouponSetId(period,_plan),_this.props.couponId,useQuantity);}// P9052-15958: clear plan id from URL after triggering an upgrade
props.history.push({pathname:Object(__WEBPACK_IMPORTED_MODULE_53_routes__["w" /* getRoute */])(__WEBPACK_IMPORTED_MODULE_53_routes__["n" /* SUBSCRIPTION */],props.company.id),state:{cbPlanIdAfterRedirect:planId}});}return _this;}__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default()(Subscription,[{key:"componentDidMount",value:function componentDidMount(){if(this.isPlusOverviewMode){Object(__WEBPACK_IMPORTED_MODULE_47_lib_Segment_customTrackers__["W" /* trackVisitedPlusOverview */])(Object(__WEBPACK_IMPORTED_MODULE_48_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}else if(this.isPerpetualOverviewMode){Object(__WEBPACK_IMPORTED_MODULE_47_lib_Segment_customTrackers__["V" /* trackVisitedPerpetualOverview */])(Object(__WEBPACK_IMPORTED_MODULE_48_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}var preselectOpenCBDetails=__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(this.props,'location.state.preselectOpenCBDetails');if(preselectOpenCBDetails){this.props.history.replace({pathname:Object(__WEBPACK_IMPORTED_MODULE_53_routes__["w" /* getRoute */])(__WEBPACK_IMPORTED_MODULE_53_routes__["n" /* SUBSCRIPTION */],this.props.company.id),state:{preselectOpenCBDetails:null,preselectSubscriptionView:null}});this.showSubscriptionDetails();}var preselectSubscriptionView=!Object(__WEBPACK_IMPORTED_MODULE_16_utils_state__["e" /* showNewRealEstateUI */])(this.props.company,this.props.app.isDesktopTrial,this.props.app.isReAccessNoIndustry)&&__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(this.props,'location.state.preselectSubscriptionView');if(preselectSubscriptionView){this.props.history.replace({pathname:Object(__WEBPACK_IMPORTED_MODULE_53_routes__["w" /* getRoute */])(__WEBPACK_IMPORTED_MODULE_53_routes__["n" /* SUBSCRIPTION */],this.props.company.id),state:{preselectSubscriptionView:null}});}if(this.props.reactivateSubscription&&!this.props.wasRenewalPopupShown){this.props.setSubscriptionView(__WEBPACK_IMPORTED_MODULE_38__config__["_45" /* SUBSCRIPTION_VIEW */].CURRENT_PRODUCTS,true);if(!this.hasPlan){// if cancellation is pending only show CURRENT_PRODUCTS view without triggering CB widget
// as CURRENT_PRODUCTS contains text explaining how to cancel cancellation
this.showSubscriptionDetails();}this.props.setRenewalPopupWasShown();Object(__WEBPACK_IMPORTED_MODULE_47_lib_Segment_customTrackers__["X" /* trackVisitedReactivateRouteFromEmail */])(Object(__WEBPACK_IMPORTED_MODULE_48_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}this.updatePendingSubscription();if((!this.props.isCBPlanExternalRedirect||!this.state.shouldStartUpdate||this.props.isCBPlanExternalRedirect&&this.state.shouldStartUpdate&&this.hasPlan)&&// don't fetch estimate when coupon is entered when Buy more perpetual licenses popup 
// is opened and user proceedes to checkout
this.props.discount.couponType!==__WEBPACK_IMPORTED_MODULE_38__config__["v" /* COUPON_TYPE */].LICENSES&&!this.state.willProceedToCheckout&&!this.isPerpetualOverviewMode&&!this.isPerpetualPeriodSelected&&(this.getSubscriptionEstimationUrl()!==this.props.companies.getSubscriptionEstimateUrl||this.props.companies.getSubscriptionEstimateForPlan!==this.getPlanForSubscriptionEstimation()||!this.props.companies.subscriptionEstimation&&!this.props.companies.getSubscriptionEstimateXhrInProgress)){this.fetchSubscriptionEstimate(false);}if(!Object(__WEBPACK_IMPORTED_MODULE_16_utils_state__["e" /* showNewRealEstateUI */])(this.props.company,this.props.app.isDesktopTrial,this.props.app.isReAccessNoIndustry)){window.addEventListener('resize',this.updateDimensionsThrottled);this.updateDimensionsThrottled();}this.props.realEstatePlan&&Object(__WEBPACK_IMPORTED_MODULE_43__utils_storage__["D" /* saveReUpgradePopupPlan */])(this.props.realEstatePlan);}},{key:"getStateFromProps",value:function getStateFromProps(props){var match=props.match,currentPlanId=props.currentPlanId,_props$company=props.company,hasTrial=_props$company.hasTrial,trialDays=_props$company.trialDays;var queryParams=Object(__WEBPACK_IMPORTED_MODULE_52__utils_url__["d" /* parseQuery */])(props.location.search);var currencyFromUrl=match.params.currency||queryParams['currency'];var plan;var currentPackageCurrency;var currency;var seatsQuantity;var licensesQuantity;var category=null;var period=null;var subscriptionView=null;var hasPeriodAutoSet;var hasCategoryAutoSet;var hasCurrencyAutoSet;var hasSeatsQuantityAutoSet;var hasLicensesQuantityAutoSet;var hasSubscriptionViewAutoSet;// Get plan details, take into account only subscription as perpetual/addon is not shown
// in standard CREATIVE_TOOLS/CLOUD_SUITE tabs
var activeSubscription=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(currentPlanId);if(currentPlanId){plan=activeSubscription.plan;}// quantity
if(this.props.productQuantity&&!this.isPerpetualOverviewMode){if(plan&&Object(__WEBPACK_IMPORTED_MODULE_16_utils_state__["e" /* showNewRealEstateUI */])(this.props.company,this.props.app.isDesktopTrial,this.props.app.isReAccessNoIndustry)){if(plan===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES){seatsQuantity=this.props.productQuantity-Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["e" /* getMembersPaidQuantity */])(this.props.company)-__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][plan].freeSeatsIncluded;}else{seatsQuantity=this.props.productQuantity-Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["e" /* getMembersPaidQuantity */])(this.props.company);}}else{seatsQuantity=this.props.productQuantity;}}else{seatsQuantity=this.getDefaultQuantity(props,__WEBPACK_IMPORTED_MODULE_38__config__["_19" /* QUANTITY_TYPE */].SEATS,Object(__WEBPACK_IMPORTED_MODULE_16_utils_state__["e" /* showNewRealEstateUI */])(this.props.company,this.props.app.isDesktopTrial,this.props.app.isReAccessNoIndustry));}if(!plan&&__WEBPACK_IMPORTED_MODULE_38__config__["K" /* FORCE_RE_CHECKOUT_WITH_ALL_USERS */]&&Object(__WEBPACK_IMPORTED_MODULE_16_utils_state__["e" /* showNewRealEstateUI */])(this.props.company,this.props.app.isDesktopTrial,this.props.app.isReAccessNoIndustry)){// for RE packages don't allow checkout with less users than members + admin length
var nonGuestUsers=Object(__WEBPACK_IMPORTED_MODULE_17_utils_users__["e" /* filterNonGuestUsers */])(props.company.users).length;if(seatsQuantity<nonGuestUsers&&nonGuestUsers>1){seatsQuantity=nonGuestUsers;}}hasSeatsQuantityAutoSet=true;licensesQuantity=this.props.productQuantity&&this.isPerpetualOverviewMode?this.props.productQuantity:this.getDefaultQuantity(props,__WEBPACK_IMPORTED_MODULE_38__config__["_19" /* QUANTITY_TYPE */].LICENSES);hasLicensesQuantityAutoSet=true;// currency
var alreadyUsedCurrency=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["b" /* getCurrencyUsedInCB */])(props.company);alreadyUsedCurrency&&(currentPackageCurrency=alreadyUsedCurrency);// read curreny from URL, use it from existing plan or default to USD
currency=currentPackageCurrency||currencyFromUrl||__WEBPACK_IMPORTED_MODULE_38__config__["z" /* DEFAULT_SUBSCRIPTION */].currency;hasCurrencyAutoSet=true;// subscriptionView
subscriptionView=__WEBPACK_IMPORTED_MODULE_38__config__["_45" /* SUBSCRIPTION_VIEW */].PURCHASE_OPTIONS;var seatsQuantityFinal;if(!props.app.isSeatsQuantityAutoApplied){seatsQuantityFinal=props.app.seatsQuantity!==null?props.app.seatsQuantity:seatsQuantity;}else if(hasSeatsQuantityAutoSet){seatsQuantityFinal=seatsQuantity;}var licensesQuantityFinal;if(!props.app.isLicensesQuantityAutoApplied){licensesQuantityFinal=props.app.licensesQuantity!==null?props.app.licensesQuantity:licensesQuantity;}else if(hasLicensesQuantityAutoSet){licensesQuantityFinal=licensesQuantity;}if(this.state){var plansToRender=this.getPlansToRender(false,true,false,parseInt(this.isPerpetualOverviewMode||props.app.subscriptionPeriod===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL?licensesQuantityFinal:seatsQuantityFinal));var preselectCategory;var preselectPeriod;if(this.state.pendingRouteChange){preselectCategory=__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(props,'location.state.preselectCategory');hasCategoryAutoSet=true;}if(this.state.pendingUpgradePlanClicked){preselectCategory=__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(this.props,'location.state.preselectCategory')||props.app.subscriptionCategory;hasCategoryAutoSet=true;}if(this.state.pendingShowMagixDiscountForPerpetualClicked){preselectPeriod=props.app.subscriptionPeriod;hasPeriodAutoSet=true;}if(this.state.pendingReactivatePlanId||this.state.pendingSeeAllProductsPlanClicked){preselectCategory=props.app.subscriptionCategory;hasCategoryAutoSet=true;}if(this.state.pendingReactivatePeriod||this.state.pendingActivatePeriod){preselectPeriod=props.app.subscriptionPeriod;hasPeriodAutoSet=true;}if(preselectCategory){category=preselectCategory;}else{if(!this.state.isPeriodReset){var _this$getCategoryOfCo=this.getCategoryOfCoupon(props,plansToRender,currency),isCouponAppliedToCloud=_this$getCategoryOfCo.isCouponAppliedToCloud,isCouponAppliedToDesktop=_this$getCategoryOfCo.isCouponAppliedToDesktop;if(this.areCloudOnlyPlans(plansToRender)||this.shouldRenderCategorySelector&&isCouponAppliedToCloud&&!isCouponAppliedToDesktop){category=__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CLOUD_SUITE;hasCategoryAutoSet=true;}else if(this.areDesktopOnlyPlans(plansToRender)||this.shouldRenderCategorySelector&&isCouponAppliedToDesktop&&!isCouponAppliedToCloud){category=__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CREATIVE_TOOLS;hasCategoryAutoSet=true;}if(isCouponAppliedToCloud&&isCouponAppliedToDesktop&&!category){// exclude productName and source=pricing
if(this.props.productName&&this.props.app.isDesktopApp||this.props.magixCat){category=__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CREATIVE_TOOLS;hasCategoryAutoSet=true;}else{if(props.app.subscriptionCategory){// stay at current category
category=props.app.subscriptionCategory;hasCategoryAutoSet=true;}else{if(this.isPlusOverviewMode||this.isPerpetualOverviewMode){category=__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CREATIVE_TOOLS;}else{if(plan){category=this.getCategoryOfUpgradeOptionForActivePlan(activeSubscription.plan,activeSubscription.period);}else{category=__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CLOUD_SUITE;}}hasCategoryAutoSet=true;}}}}}if(preselectPeriod){period=preselectPeriod;}else if(this.shouldRenderPeriodSelector&&!this.state.isPeriodReset){var _this$getPeriodOfCoup=this.getPeriodOfCoupon(props,plansToRender,currency,category),isCouponAppliedToMonthly=_this$getPeriodOfCoup.isCouponAppliedToMonthly,isCouponAppliedToAnnualy=_this$getPeriodOfCoup.isCouponAppliedToAnnualy,isCouponAppliedToPerpetual=_this$getPeriodOfCoup.isCouponAppliedToPerpetual;if(props.app.subscriptionPeriod){if(props.app.subscriptionPeriod===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY&&isCouponAppliedToMonthly||props.app.subscriptionPeriod===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL&&isCouponAppliedToAnnualy||props.app.subscriptionPeriod===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL&&isCouponAppliedToPerpetual){period=props.app.subscriptionPeriod;hasPeriodAutoSet=true;}}if(!period){if(isCouponAppliedToMonthly&&isCouponAppliedToAnnualy){period=__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL;hasPeriodAutoSet=true;}else if(isCouponAppliedToMonthly){period=__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY;hasPeriodAutoSet=true;}else if(isCouponAppliedToAnnualy){period=__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL;hasPeriodAutoSet=true;}else if(isCouponAppliedToPerpetual){period=__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL;hasPeriodAutoSet=true;}}}else if(this.isPerpetualOverviewMode){period=__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL;hasPeriodAutoSet=true;}else{var _activeSubscription=this.state.activeSubscription;if(_activeSubscription.period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY&&_activeSubscription.plan===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].TEAM_PLUS){period=__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL;}else{period=_activeSubscription.period;//period = props.app.subscriptionPeriod || activeSubscription.period;
}hasPeriodAutoSet=true;}}if(!category){if(props.app.isPerpetualApp||this.isPerpetualOverviewMode){category=__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CREATIVE_TOOLS;hasCategoryAutoSet=true;}else{// exclude productName and source=pricing
if(this.props.productName&&this.props.app.isDesktopApp||this.props.magixCat){category=__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CREATIVE_TOOLS;hasCategoryAutoSet=true;}else{// default
if(!props.app.isCategoryAutoApplied&&props.app.subscriptionCategory){category=props.app.subscriptionCategory;hasCategoryAutoSet=false;}else{// isCategoryAutoApplied === true when clicking on "switch to yearly and save..."
// or when applying discount
// default for perpetual-overview and plus-overview
if(props.app.subscriptionCategory){category=props.app.subscriptionCategory;}else if(this.isPlusOverviewMode||this.isPerpetualOverviewMode){category=__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CREATIVE_TOOLS;}else{if(plan){category=this.getCategoryOfUpgradeOptionForActivePlan(activeSubscription.plan,activeSubscription.period);}else{category=__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(props,'location.state.preselectCategory')||__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CLOUD_SUITE;}}hasCategoryAutoSet=true;}}}}// User on subscription opening xara.com/welcome, then opening CAP with specific pcat which does not contain upgrade
// options for that user. In that case show all upgrade options.
// For example user on proplus plan opening pcat=web but he can only upgrade to Cloud Team+
var preselectPackage;if(plan&&this.preselectedPackage){var isPerpetual=__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][this.preselectedPackage].isPerpetual;if(__WEBPACK_IMPORTED_MODULE_38__config__["_43" /* SUBSCRIPTION_PLAN_UPGRADE_OPTIONS */][plan].includes(this.preselectedPackage)||isPerpetual){preselectPackage=this.preselectedPackage;}}else if(!plan&&this.preselectedPackage){preselectPackage=this.preselectedPackage;}if(preselectPackage===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].SCALE){preselectPackage=__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].TEAM_PLUS;}if([__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES,__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT].includes(preselectPackage)){preselectPackage=null;}if(!period){if(Object(__WEBPACK_IMPORTED_MODULE_16_utils_state__["e" /* showNewRealEstateUI */])(this.props.company,this.props.app.isDesktopTrial,this.props.app.isReAccessNoIndustry)){period=__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY;hasPeriodAutoSet=true;}else if(props.app.isPerpetualApp||this.isPerpetualOverviewMode){period=__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL;hasPeriodAutoSet=true;}else{// default
period=props.app.subscriptionPeriod||__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL;hasPeriodAutoSet=true;}}var subscriptionViewFinal;var preselectSubscriptionView=!Object(__WEBPACK_IMPORTED_MODULE_16_utils_state__["e" /* showNewRealEstateUI */])(this.props.company,this.props.app.isDesktopTrial,this.props.app.isReAccessNoIndustry)&&__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(this.props,'location.state.preselectSubscriptionView');if(preselectSubscriptionView){subscriptionViewFinal=preselectSubscriptionView;this.props.setSubscriptionView(preselectSubscriptionView,true);}else if(!props.app.isSubscriptionViewAutoApplied){// if user clicked on view, use user defined view
subscriptionViewFinal=props.app.subscriptionView||subscriptionView;}else if(hasSubscriptionViewAutoSet){//use auto set view
subscriptionViewFinal=subscriptionView;this.props.setSubscriptionView(subscriptionView,true);}else{subscriptionViewFinal=__WEBPACK_IMPORTED_MODULE_38__config__["_45" /* SUBSCRIPTION_VIEW */].CURRENT_PRODUCTS;}var categoryFinal;if(props.company.hasUnlimitedTeamSubscription){categoryFinal=this.isPlusOverviewMode||this.isPerpetualOverviewMode?__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CREATIVE_TOOLS:__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CLOUD_SUITE;}else if(!props.app.isCategoryAutoApplied){// if user clicked on category, use user defined category
categoryFinal=props.app.subscriptionCategory||category;}else if(hasCategoryAutoSet){//use auto set category
categoryFinal=category;this.props.setSubscriptionCategory(category,true);}var isPeriodReset=false;if(categoryFinal===__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CLOUD_SUITE&&this.state&&this.isPerpetualPeriodSelected&&this.shouldRenderCategorySelector){// when Desktop tab > One-Time purchase is selected and user clicks on Cloud
period=__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(this.allPeriods,'[0]');isPeriodReset=true;}var periodFinal;if(isPeriodReset){periodFinal=period;this.props.setSubscriptionPeriod(period,true);//props.perpetualOverview
}else if(!props.app.isPeriodAutoApplied){// if user clicked on period, use user defined period
periodFinal=props.app.subscriptionPeriod||period;}else if(hasPeriodAutoSet){//use auto set period
periodFinal=period;this.props.setSubscriptionPeriod(period,true);}var currencyFinal;if(!props.app.isCurrencyAutoApplied){currencyFinal=props.app.subscriptionCurrency||currency;}else if(hasCurrencyAutoSet){currencyFinal=currency;this.props.setSubscriptionCurrency(currency,true);}if(this.props.productQuantity&&!this.isPerpetualOverviewMode&&this.props.app.seatsQuantity===null){this.props.setSeatsQuantity(seatsQuantity,true);}else if(props.app.isSeatsQuantityAutoApplied&&hasSeatsQuantityAutoSet){this.props.setSeatsQuantity(seatsQuantity,true);}if(this.props.productQuantity&&this.isPerpetualOverviewMode&&this.props.app.licensesQuantity===null){this.props.setLicensesQuantity(licensesQuantity,true);}else if(props.app.isLicensesQuantityAutoApplied&&hasLicensesQuantityAutoSet){this.props.setLicensesQuantity(licensesQuantity,true);}var pendingSubscription,pendingSeatsQuantity;if(__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(props.company,'settings.pendingSubscription')&&props.currentPlanId&&__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(props.company,'settings.pendingSubscription')!==props.currentPlanId){pendingSubscription=__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(props.company,'settings.pendingSubscription');pendingSeatsQuantity=__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(props.company,'settings.pendingSeatsQuantity');}var showPromoForm=true;if(props.isDiscountTakeoverFromWebsite||props.company.hasUnlimitedTeamSubscription){showPromoForm=false;}else if(activeSubscription.plan){if(activeSubscription.plan===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].TEAM_PLUS&&activeSubscription.period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL&&periodFinal!==__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL&&!this.isPerpetualOverviewMode&&!props.app.isPerpetualApp){showPromoForm=false;}}var showDiscountBanner=true;if(this.props.company.hasUnlimitedTeamSubscription||this.props.isDiscountTakeoverFromWebsite||// eslint-disable-next-line max-len
__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(this.props,"settings.cap[".concat(__WEBPACK_IMPORTED_MODULE_38__config__["_50" /* USER_DISCOUNT_BANNER_SETTING_KEY */],"][").concat(props.company.id,"][").concat(__WEBPACK_IMPORTED_MODULE_38__config__["L" /* FOREVER_HIDDEN_KEY */],"]"),false)||Object(__WEBPACK_IMPORTED_MODULE_43__utils_storage__["t" /* isDiscountBannerTemporarilyHidden */])()){// Permanently disable banner
showDiscountBanner=false;}else if(periodFinal===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL){// Always show banner on perpetual route or when One-Time Purchase checkbox is checked
showDiscountBanner=true;}else if(activeSubscription.plan){var desktopUpgradeOptions=[];__WEBPACK_IMPORTED_MODULE_38__config__["_43" /* SUBSCRIPTION_PLAN_UPGRADE_OPTIONS */][activeSubscription.plan].forEach(function(upgradeOptionPlan){if(__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][upgradeOptionPlan].isDesktopTag&&!__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][upgradeOptionPlan].isCloudTag){desktopUpgradeOptions.push(upgradeOptionPlan);}});if(__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][activeSubscription.plan].isDesktopTag&&!__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][activeSubscription.plan].isCloudTag&&activeSubscription.period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY){desktopUpgradeOptions.push(activeSubscription.plan);}var isRenderingAnyDesktopPlan;if(props.plusOverview){desktopUpgradeOptions.length>0&&(isRenderingAnyDesktopPlan=true);}else if(desktopUpgradeOptions.length&&(this.state&&!this.shouldRenderCategorySelector||this.state&&this.shouldRenderCategorySelector&&categoryFinal===__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CREATIVE_TOOLS||!this.state)){isRenderingAnyDesktopPlan=true;}if(!isRenderingAnyDesktopPlan){showDiscountBanner=false;}}else{// Trial or free plan
if(categoryFinal===__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CLOUD_SUITE||__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(this.props.company,'settings.mxDiscountUsed',false)){showDiscountBanner=false;}}var result={isPeriodReset:isPeriodReset,activeSubscription:activeSubscription,hasTrial:hasTrial,trialDays:trialDays,period:periodFinal,currency:currencyFinal,category:categoryFinal,subscriptionView:subscriptionViewFinal,preselectPackage:preselectPackage,isPerpetualApp:props.app.isPerpetualApp,seatsQuantity:seatsQuantityFinal,licensesQuantity:licensesQuantityFinal,pendingUpgradePlanClicked:false,pendingSeeAllProductsPlanClicked:false,pendingShowMagixDiscountForPerpetualClicked:false,pendingRouteChange:false,pendingSubscription:pendingSubscription,pendingSeatsQuantity:pendingSeatsQuantity,showPromoForm:showPromoForm,showDiscountBanner:showDiscountBanner};return result;}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState){var _this2=this;if((this.props.isCBPlanExternalRedirect||this.props.productName)&&Object(__WEBPACK_IMPORTED_MODULE_16_utils_state__["e" /* showNewRealEstateUI */])(this.props.company,this.props.app.isDesktopTrial,this.props.app.isReAccessNoIndustry)){window.location.href=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["h" /* getSubscriptionRedirectUrl */])(__WEBPACK_IMPORTED_MODULE_38__config__["_25" /* REAL_ESTATE_OVERVIEW_PLAN_ID */],this.props.selectedCompanyId);return;}this.handleUpdateLastPageVisited();// take into account that call crs-web might come after initial call to estimation session, 
// in that case we update prices
// same thing if user enters different seats quantity to input 
// field then we ignore previous request to getSubscriptionEstimation and make new request
var couponAppliedWithoutValidation=this.props.discount.couponAppliedWithoutValidation;var isPerpetualCheckbox=this.isPurchaseOptionsView&&this.isPerpetualPeriodSelected&&!this.isPerpetualOverviewMode;if((!this.props.companies.subscriptionEstimation&&!this.props.companies.getSubscriptionEstimateXhrInProgress||this.getSubscriptionEstimationUrl()!==this.props.companies.getSubscriptionEstimateUrl||this.props.companies.getSubscriptionEstimateForPlan!==this.getPlanForSubscriptionEstimation())&&// don't fetch estimate when coupon is entered on perpetual route;
// on One-Time checkbox route this.props.discount.couponType will be SEATS
this.props.discount.couponType!==__WEBPACK_IMPORTED_MODULE_38__config__["v" /* COUPON_TYPE */].LICENSES&&!this.state.willProceedToCheckout&&(// Buy more perpetual licenses popup is opened and user proceedes to checkout
!this.props.companies.getSubscriptionEstimateErrorId||(this.props.companies.getSubscriptionEstimateErrorId===__WEBPACK_IMPORTED_MODULE_57_errors_errorids__["a" /* default */].OFFLINE||this.props.companies.getSubscriptionEstimateErrorId===__WEBPACK_IMPORTED_MODULE_57_errors_errorids__["a" /* default */].API_REQUEST_LIMIT_EXCEEDED)&&couponAppliedWithoutValidation)&&!this.isPerpetualOverviewMode&&(!this.isPerpetualPeriodSelected||isPerpetualCheckbox)&&(!this.props.isCBPlanExternalRedirect||!this.state.shouldStartUpdate||this.props.isCBPlanExternalRedirect&&this.state.shouldStartUpdate&&!this.hasPlan)){this.fetchSubscriptionEstimate(false);}if(this.hasPlan&&!__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["i" /* getSubscriptionsAndAddons */])(this.props.company),'subscription.cancellationPending')&&!this.props.companies.upcomingInvoiceEstimationXhrInProgress&&!this.props.company.hasUnlimitedTeamSubscription&&!this.props.companies.upcomingInvoiceEstimation&&(!this.props.companies.getUpcomingInvoiceErorId||this.props.companies.getUpcomingInvoiceErorId!==__WEBPACK_IMPORTED_MODULE_57_errors_errorids__["a" /* default */].OFFLINE&&this.props.companies.getUpcomingInvoiceErorId!==__WEBPACK_IMPORTED_MODULE_57_errors_errorids__["a" /* default */].API_REQUEST_LIMIT_EXCEEDED)){this.props.getUpcomingInvoiceEstimate();}var isUpgradeViaQueryParam=this.hasPlan&&(this.props.couponId||this.props.app.isUpgradePopup||this.props.isDiscountTakeoverFromWebsite&&this.props.magixCat&&this.isPlusOverviewMode);// User opened perpetual route and entered serial/email to get discount,
// when switching to /subscriptions/ we should send same coupon code to estimationSession but not for active plan
var isChangeFromPerpetualToSubscriptionWithMagixDiscountApplied=this.hasPlan&&this.props.discount.appliedProdTypeOfLastValidCombination===__WEBPACK_IMPORTED_MODULE_38__config__["Y" /* MAXIC_DISCOUNT_PROD_TYPE */].PERPETUAL&&!this.isPerpetualOverviewMode;var shouldRequestActiveAccountData=(isUpgradeViaQueryParam||isChangeFromPerpetualToSubscriptionWithMagixDiscountApplied)&&!this.props.modalShown&&!this.props.companies.getSubscriptionEstimateActivePlanXhrInProgress&&!this.props.companies.subscriptionEstimationActivePlan;var isPlanUpgrade=this.props.currentPlanId!==prevProps.currentPlanId&&prevProps.currentPlanId!==undefined;if(this.hasPlan&&(shouldRequestActiveAccountData||isPlanUpgrade)){var _convertPlanIdIntoSub4=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(this.props.currentPlanId),plan=_convertPlanIdIntoSub4.plan,period=_convertPlanIdIntoSub4.period;if(!__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(this.props.companies,"subscriptionEstimation[".concat(plan,"-").concat(period,"-").concat(__WEBPACK_IMPORTED_MODULE_38__config__["l" /* CB_API_FETCH_CURRENCY */],"].estimation"))){this.fetchSubscriptionEstimate(true,true);}}if(__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(this.state,'pendingShowMagixDiscountForPerpetualClicked')){this.showMagixDiscountPopup(true);}var reactivatePlanId=__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(this.state,'pendingReactivatePlanId');var reactivateQuantity=__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(this.state,'pendingReactivateQuantity');var reactivatePeriod=__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(this.state,'pendingReactivatePeriod');// wait until client re-fetches data for correct setas quantity and period
if(reactivatePlanId&&this.period===reactivatePeriod&&this.state.seatsQuantity===reactivateQuantity&&this.props.companies.subscriptionEstimation&&!this.props.companies.getSubscriptionEstimateXhrInProgress&&this.props.companies.getSubscriptionEstimateForPlan===this.getPlanForSubscriptionEstimation()&&this.getSubscriptionEstimationUrl(false,false)===this.props.companies.getSubscriptionEstimateUrl&&// wait until changeMagixDiscountProdType() updates redux state to match subscription route
!(this.props.discount.isDiscountApplied&&this.props.discount.discountType===__WEBPACK_IMPORTED_MODULE_38__config__["F" /* DISCOUNT_TYPE */].MAGIX&&this.props.discount.appliedProdTypeOfLastValidCombination===__WEBPACK_IMPORTED_MODULE_38__config__["Y" /* MAXIC_DISCOUNT_PROD_TYPE */].PERPETUAL)){this.setState({pendingReactivatePlanId:null,pendingReactivateQuantity:null,pendingReactivatePeriod:null},function(){var _convertPlanIdIntoSub5=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(reactivatePlanId),plan=_convertPlanIdIntoSub5.plan,period=_convertPlanIdIntoSub5.period;var quantity=_this2.getQuantityInputValue(__WEBPACK_IMPORTED_MODULE_38__config__["_19" /* QUANTITY_TYPE */].SEATS);var _this2$calculateCheck=_this2.calculateCheckoutData(plan,period,false/*isPerpetual*/,quantity),checkoutPricePerMonth=_this2$calculateCheck.checkoutPricePerMonth,showDiscountForPlan=_this2$calculateCheck.showDiscountForPlan,annualPriceTotal=_this2$calculateCheck.annualPriceTotal,errorLoadingSubscriptionEstimationData=_this2$calculateCheck.errorLoadingSubscriptionEstimationData,planIsTaxed=_this2$calculateCheck.planIsTaxed;_this2.showConfirmChoiceModal(function(){return _this2.doCheckout(plan,period,false,// isUpgrade
showDiscountForPlan,//useDiscount
false,//isPerpetual
false//isUserNumberMismatch
);},__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][plan].title,plan,quantity,_this2.currency,_this2.period,checkoutPricePerMonth,annualPriceTotal,errorLoadingSubscriptionEstimationData,planIsTaxed);});}var activatePlanId=__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(this.state,'pendingActivatePlanId');var activatePeriod=__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(this.state,'pendingActivatePeriod');if(activatePlanId){var _PACKAGES_CONFIG$acti=__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][activatePlanId],isPerpetual=_PACKAGES_CONFIG$acti.isPerpetual,freeSeatsIncluded=_PACKAGES_CONFIG$acti.freeSeatsIncluded;var _this$props$discount=this.props.discount,pendingRequest=_this$props$discount.pendingRequest,isDiscountApplied=_this$props$discount.isDiscountApplied;if(// wait for couponId to be applied to perpetual product
isPerpetual&&(!this.props.couponId||this.props.couponId&&!pendingRequest&&isDiscountApplied)||// wait until client re-fetches data for correct getSubscriptionEstimationUrl
(!activatePeriod||this.period===activatePeriod)&&this.props.companies.subscriptionEstimation&&!this.props.companies.getSubscriptionEstimateXhrInProgress&&this.props.companies.getSubscriptionEstimateForPlan===this.getPlanForSubscriptionEstimation()&&this.getSubscriptionEstimationUrl(false,false)===this.props.companies.getSubscriptionEstimateUrl){this.setState({pendingActivatePlanId:null,pendingActivatePeriod:null},function(){var quantity=_this2.getQuantityInputValue(isPerpetual?__WEBPACK_IMPORTED_MODULE_38__config__["_19" /* QUANTITY_TYPE */].LICENSES:__WEBPACK_IMPORTED_MODULE_38__config__["_19" /* QUANTITY_TYPE */].SEATS);var _this2$calculateCheck2=_this2.calculateCheckoutData(activatePlanId,_this2.period,isPerpetual,quantity),checkoutPricePerMonth=_this2$calculateCheck2.checkoutPricePerMonth,showDiscountForPlan=_this2$calculateCheck2.showDiscountForPlan,annualPriceTotal=_this2$calculateCheck2.annualPriceTotal,errorLoadingSubscriptionEstimationData=_this2$calculateCheck2.errorLoadingSubscriptionEstimationData,planIsTaxed=_this2$calculateCheck2.planIsTaxed;var displayTitle=_this2.addVersionToTitle(activatePlanId,__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][activatePlanId].title);_this2.handleBuyRequest(activatePlanId,_this2.period,_this2.hasPlan,isPerpetual,displayTitle,showDiscountForPlan,quantity,freeSeatsIncluded,checkoutPricePerMonth,annualPriceTotal,errorLoadingSubscriptionEstimationData,planIsTaxed);});}}if(this.props.discount.appliedProdTypeOfLastValidCombination){var isPerpetualMode=this.isPerpetualOverviewMode||this.isPerpetualPeriodSelected||this.isCurrentProductsView;if(isPerpetualMode&&this.props.discount.appliedProdTypeOfLastValidCombination!==__WEBPACK_IMPORTED_MODULE_38__config__["Y" /* MAXIC_DISCOUNT_PROD_TYPE */].PERPETUAL){this.props.changeMagixDiscountProdType(__WEBPACK_IMPORTED_MODULE_38__config__["Y" /* MAXIC_DISCOUNT_PROD_TYPE */].PERPETUAL,this.props.crs.prodCatOfLastValidCombination,null,true);}else if(!isPerpetualMode&&this.props.discount.appliedProdTypeOfLastValidCombination===__WEBPACK_IMPORTED_MODULE_38__config__["Y" /* MAXIC_DISCOUNT_PROD_TYPE */].PERPETUAL){this.props.changeMagixDiscountProdType(__WEBPACK_IMPORTED_MODULE_38__config__["Y" /* MAXIC_DISCOUNT_PROD_TYPE */].SUBSCRIPTION,null,this.props.crs.tierOfLastValidCombination,// use cached object as it contains data for valid discount which might be rendered on the screen
// props.crs.areCredentialsValid is related to most recent request which might be invalid and have false false
__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(this.props.crs,'crsResponseCache.valid')&&!__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(this.props.crs,'crsResponseCache.used_for_sub'));}}if(this.props.app.reduceUsersApiState&&!prevProps.app.reduceUsersApiState){this.showModalInReduceUsersApiWorkflow();}if(!Object(__WEBPACK_IMPORTED_MODULE_16_utils_state__["e" /* showNewRealEstateUI */])(this.props.company,this.props.app.isDesktopTrial,this.props.app.isReAccessNoIndustry)){this.updateDimensionsThrottled();}}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(Object(__WEBPACK_IMPORTED_MODULE_16_utils_state__["e" /* showNewRealEstateUI */])(this.props.company,this.props.app.isDesktopTrial,this.props.app.isReAccessNoIndustry)){var defaultQuantity=this.getDefaultQuantity(this.props,__WEBPACK_IMPORTED_MODULE_38__config__["_19" /* QUANTITY_TYPE */].SEATS,true);this.props.setSeatsQuantity(defaultQuantity);}else{window.removeEventListener('resize',this.updateDimensionsThrottled);}}},{key:"componentWillMount",value:function componentWillMount(){this.handleUpdateLastPageVisited();}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _this3=this;var werePerpetualAddonsChanged=false;var _getSubscriptionsAndA2=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["i" /* getSubscriptionsAndAddons */])(nextProps.company),nextPerpetualAddons=_getSubscriptionsAndA2.perpetualAddons;var _getSubscriptionsAndA3=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["i" /* getSubscriptionsAndAddons */])(this.props.company),perpetualAddons=_getSubscriptionsAndA3.perpetualAddons;if((nextPerpetualAddons||[]).length!=(perpetualAddons||[]).length){werePerpetualAddonsChanged=true;}if(this.state.pendingRouteChange||werePerpetualAddonsChanged||this.props.isStandardProductOverview!==nextProps.isStandardProductOverview||this.props.app.wasPerpetualOverviewPageVisited!==nextProps.app.wasPerpetualOverviewPageVisited||this.props.app.wasPlusOverviewPageVisited!==nextProps.app.wasPlusOverviewPageVisited||this.props.productQuantity!==nextProps.productQuantity||this.props.productSource!==nextProps.productSource||this.props.productPeriod!==nextProps.productPeriod||this.props.currentPlanId!==nextProps.currentPlanId||this.props.currency!==nextProps.currency||this.props.app.showAllPackages!==nextProps.app.showAllPackages||this.props.app.isUpgradePopup!==nextProps.app.isUpgradePopup||this.props.app.isCouponIdProvided!==nextProps.app.isCouponIdProvided||this.props.app.isPerpetualApp!==nextProps.app.isPerpetualApp||this.props.app.subscriptionPeriod!==nextProps.app.subscriptionPeriod||this.props.app.subscriptionCategory!==nextProps.app.subscriptionCategory||this.props.app.subscriptionCurrency!==nextProps.app.subscriptionCurrency||this.props.app.seatsQuantity!==nextProps.app.seatsQuantity||this.props.app.licensesQuantity!==nextProps.app.licensesQuantity||this.props.app.subscriptionView!==nextProps.app.subscriptionView||this.props.app.isPeriodAutoApplied!==nextProps.app.isPeriodAutoApplied||this.props.app.isCategoryAutoApplied!==nextProps.app.isCategoryAutoApplied||this.props.app.isSubscriptionViewAutoApplied!==nextProps.app.isSubscriptionViewAutoApplied||this.props.app.isCurrencyAutoApplied!==nextProps.app.isCurrencyAutoApplied||this.props.app.isSeatsQuantityAutoApplied!==nextProps.app.isSeatsQuantityAutoApplied||this.props.app.isLicensesQuantityAutoApplied!==nextProps.app.isLicensesQuantityAutoApplied||!__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.isEmpty(nextProps.discount)&&this.props.discount.couponConfig!==nextProps.discount.couponConfig||!__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.isEmpty(nextProps.discount)&&this.props.discount.couponType!==nextProps.discount.couponType){this.setState(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({},this.getStateFromProps(nextProps)));}if(nextProps.isCBPlanInternalRedirect&&nextProps.app.pendingTriggerCheckout!==true&&this.preselectedPackage&&(// for subscription open Confirm order popup only if period param is send from XC
this.props.productPeriod||__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][this.preselectedPackage].isPerpetual)){var canBeUpgraded;if(this.props.company.hasUnlimitedTeamSubscription){canBeUpgraded=false;}else if(!this.hasPlan||__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][this.preselectedPackage].isPerpetual){canBeUpgraded=true;}else{var plansToRender=this.getPlansToRender(true,true,false);var planToActivate=this.preselectedPackage===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].SCALE?__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].TEAM_PLUS:this.preselectedPackage;var activeSubscription=this.state.activeSubscription;if((this.activePlan!==planToActivate||activeSubscription.period!==this.props.productPeriod)&&// don't allow downgrade from annual to monthly
!(activeSubscription.period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL&&this.props.productPeriod===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY)&&plansToRender.includes(planToActivate)){canBeUpgraded=true;}}if(canBeUpgraded){this.props.setPendingTriggerCheckout(true);this.setState({pendingActivatePlanId:this.preselectedPackage===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].SCALE?__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].TEAM_PLUS:this.preselectedPackage,pendingActivatePeriod:this.props.productPeriod},function(){if(_this3.props.productPeriod&&_this3.period!==_this3.props.productPeriod){_this3.props.setAppStateParams({subscriptionPeriod:_this3.props.productPeriod});}});}}if(__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(nextProps,'location.state.showInvalidQueryPlanIdMessage')){this.props.showPackageDiscontinuedMessage();this.props.history.replace({pathname:Object(__WEBPACK_IMPORTED_MODULE_53_routes__["w" /* getRoute */])(__WEBPACK_IMPORTED_MODULE_53_routes__["n" /* SUBSCRIPTION */],this.props.company.id),state:{showInvalidQueryPlanIdMessage:null}});}// close any modals which might be open when industry change (confirm checkout popup etc.)
// as popup they might not be applicable or relavant any more
if(this.props.company.industryId!==nextProps.company.industryId&&[this.props.company.industryId,nextProps.company.industryId].includes(__WEBPACK_IMPORTED_MODULE_38__config__["_24" /* REAL_ESTATE_INDUSTY_ID */])){this.props.hideModal();}}//#region Rendering
},{key:"render",value:function render(){var _this$state=this.state,redirectRoute=_this$state.redirectRoute,email=_this$state.email;var _this$props=this.props,isAdmin=_this$props.isAdmin,classes=_this$props.classes;if(this.state.pendingReactivatePlanId&&(this.isPerpetualOverviewMode||this.isPlusOverviewMode)){// When user clicks on Reactivate plan link while on plus-overview or perpetual-overview route
return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_router_dom__["c" /* Redirect */],{to:{pathname:Object(__WEBPACK_IMPORTED_MODULE_53_routes__["w" /* getRoute */])(__WEBPACK_IMPORTED_MODULE_53_routes__["n" /* SUBSCRIPTION */],this.state.selectedId),state:{pendingReactivatePlanId:this.state.pendingReactivatePlanId,pendingReactivateQuantity:this.state.pendingReactivateQuantity,pendingReactivatePeriod:this.state.pendingReactivatePeriod}}});}if(redirectRoute){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_router_dom__["c" /* Redirect */],{to:redirectRoute});}// [P9052-10177] Redirect to Users & Permissions to add a member
if((this.isEssentialPlan||this.isScalePlan)&&email){var usersRoute=Object(__WEBPACK_IMPORTED_MODULE_53_routes__["w" /* getRoute */])(__WEBPACK_IMPORTED_MODULE_53_routes__["t" /* USERS */],this.state.selectedId)+"?email=".concat(email);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_router_dom__["c" /* Redirect */],{to:usersRoute});}var renderView=isAdmin?this.renderAdminView(Object(__WEBPACK_IMPORTED_MODULE_16_utils_state__["e" /* showNewRealEstateUI */])(this.props.company,this.props.app.isDesktopTrial,this.props.app.isReAccessNoIndustry)):this.renderMemberView();return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_51_components_CenteredContent_CenteredContent__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_StickyHeader_StickyHeader__["a" /* default */],{className:classes.stickyHeader},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_Header__["a" /* default */],{className:classes.header},localize('subscription-header')),isAdmin&&!Object(__WEBPACK_IMPORTED_MODULE_16_utils_state__["e" /* showNewRealEstateUI */])(this.props.company,this.props.app.isDesktopTrial,this.props.app.isReAccessNoIndustry)&&this.renderSubscriptionViewSelector()),renderView);}},{key:"isRealEstateIndustry",value:function isRealEstateIndustry(){return this.props.company.industryId===__WEBPACK_IMPORTED_MODULE_38__config__["_24" /* REAL_ESTATE_INDUSTY_ID */];}},{key:"renderMemberView",value:function renderMemberView(){var _this4=this;var classes=this.props.classes;var sendEmailNotificationFn=__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.debounce(function(){return _this4.props.sendEmailNotification('explicit_upgrade_teamplus',localize('subscription-admin-notified'));},__WEBPACK_IMPORTED_MODULE_54_theme_uiConfig__["a" /* actionButtonDebounceTimeout */]);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{variant:"body1",className:classes.marginBottom20,dangerouslySetInnerHTML:{__html:localize('subscription-not-admin')}}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["a" /* Button */],{onClick:sendEmailNotificationFn,variant:"contained","data-tid":"button-notify-team-admin",color:"primary",title:localize('subscription-notify-admin')},localize('subscription-notify-admin')));}},{key:"renderPromoFormAndDiscountBanner",value:function renderPromoFormAndDiscountBanner(){var classes=this.props.classes;var _this$state2=this.state,showDiscountBanner=_this$state2.showDiscountBanner,showPromoForm=_this$state2.showPromoForm;var appliedProdTypeOfLastValidCombination=this.props.discount.appliedProdTypeOfLastValidCombination;// qualifying products in current route not in all routes
var nrOfQualifyingProductsForCoupon=this.getNumberOfQualifyingProductsForCoupon(false,false,false);var nrOfQualifyingProductsForCouponInAllCurrencies=this.getNumberOfQualifyingProductsForCoupon(true,false,false);var nrOfQualifyingSubscriptions=this.getNumberOfQualifyingProductsForCoupon(true,true,false);var nrOfQualifyingPerpetualProducts=this.getNumberOfQualifyingProductsForCoupon(true,false,true);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{container:true,direction:"row",className:classes.promoFormAndDiscountBannerContainer},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,className:classes.columnPromoForm},showPromoForm&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_PromoForm__["a" /* default */],{isPerpetualCheckbox:this.isPerpetualPeriodSelected&&!this.isPerpetualOverviewMode,contactUsHandler:this.contactUsHandler,addVersionToTitle:this.addVersionToTitle,currency:this.currency,changeRoute:this.changeRoute,getQualifyingProductsForCoupon:this.getQualifyingProductsForCoupon,type:this.isPerpetualOverviewMode||this.isPerpetualPeriodSelected?__WEBPACK_IMPORTED_MODULE_38__config__["v" /* COUPON_TYPE */].LICENSES:__WEBPACK_IMPORTED_MODULE_38__config__["v" /* COUPON_TYPE */].SEATS,category:this.category,appliedProdTypeOfLastValidCombination:appliedProdTypeOfLastValidCombination,nrOfQualifyingSubscriptions:nrOfQualifyingSubscriptions,nrOfQualifyingPerpetualProducts:nrOfQualifyingPerpetualProducts,nrOfQualifyingProductsForCouponInAllCurrencies:nrOfQualifyingProductsForCouponInAllCurrencies,nrOfQualifyingProductsForCoupon:nrOfQualifyingProductsForCoupon})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,container:true,className:classes.columnDiscountBanner},showDiscountBanner&&this.renderDiscountBanner()));}},{key:"renderAdminView",value:function renderAdminView(showRealEstateUi){if(showRealEstateUi){var _convertPlanIdIntoSub6=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(this.props.currentPlanId),plan=_convertPlanIdIntoSub6.plan;var cancelledPlanId;var cancelledSubscription;if(!plan){var _getSubscriptionsAndA4=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["i" /* getSubscriptionsAndAddons */])(this.props.company,true);cancelledSubscription=_getSubscriptionsAndA4.subscription;if(!__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.isEmpty(cancelledSubscription)){var _convertPlanIdIntoSub7=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(cancelledSubscription.planId);cancelledPlanId=_convertPlanIdIntoSub7.plan;}}return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_RealEstatePackages__["a" /* default */],{isTrial:this.state.hasTrial,membersPaidQuantity:Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["e" /* getMembersPaidQuantity */])(this.props.company),nonGuestUsersNumber:Object(__WEBPACK_IMPORTED_MODULE_17_utils_users__["e" /* filterNonGuestUsers */])(this.props.company.users).length,getVatLabel:this.getVatLabel,totalNumberOfSeats:this.getTotalNumberOfSeats(),buyMoreSeatsCallback:this.buyMoreSeatsCallback,reactivateMySubscriptionHandler:this.reactivateMySubscriptionHandler,nextBillingDate:this.getNextBillingDate(),pendingCancellationDate:this.getCancellationDate(),showSubscriptionDetails:this.showSubscriptionDetails,cancelledPlanId:cancelledPlanId,cancelledSubscription:cancelledSubscription,currentPlanId:plan,quantity:this.getQuantityIntegerValue(__WEBPACK_IMPORTED_MODULE_38__config__["_19" /* QUANTITY_TYPE */].SEATS),realEstatePlan:this.props.realEstatePlan,fetchSubscriptionEstimate:this.fetchSubscriptionEstimate,calculateCheckoutData:this.calculateCheckoutData,handleBuyRequest:this.handleBuyRequest,showErrorPopup:this.props.showErrorPopup,symbol:this.currency.symbol,shouldRenderCurrencySelector:this.shouldRenderCurrencySelector,renderCurrencySelector:this.renderCurrencySelector}));}else{return this.isCurrentProductsView?this.renderProductsView():this.renderPurchaseOptionsView();}}},{key:"renderPurchaseOptionsView",value:function renderPurchaseOptionsView(){var _classNames;var classes=this.props.classes;var _this$state3=this.state,showDiscountBanner=_this$state3.showDiscountBanner,showPromoForm=_this$state3.showPromoForm;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()((_classNames={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames,classes.purchaseOptionsWrapper,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames,'purchaseOptionsWrapper',true),_classNames))},this.shouldRenderPlanBoxes&&(showDiscountBanner||showPromoForm)&&this.renderPromoFormAndDiscountBanner(),this.shouldRenderPlanBoxes?this.renderPlanBoxes():__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{variant:"body2",className:classes.italic,dangerouslySetInnerHTML:{__html:localize('subscription-no-upgrade-options')}}));}},{key:"renderProductsView",value:function renderProductsView(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{container:true,className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.yourCurrentSubscription)},this.renderCurrentPlans());}},{key:"toggleDiscountBanner",value:function toggleDiscountBanner(event){this.setState({hideDiscountBannerForeverChecked:event.target.checked});}},{key:"updateDimensions",value:function updateDimensions(){var _this5=this;var switchToMobilePackageList=function switchToMobilePackageList(){var currentListRef=_this5['productsListVerticalRef'];if(!currentListRef||!currentListRef.current)return;if(_this5.props.navOpen){if(_this5.state.mobilePackageList!==false){_this5.setState({mobilePackageList:false});}}else{var nrOfDesktopPlansInContainer=0;var nrOfCloudPlansInContainer=0;Object.values(__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */]).forEach(function(plan){var currentRefDesktop=_this5["".concat(plan.toLowerCase(),"ProductShortDescriptionDesktopRef")];if(currentRefDesktop&&currentRefDesktop.current){nrOfDesktopPlansInContainer++;}var currentRefCloud=_this5["".concat(plan.toLowerCase(),"ProductShortDescriptionCloudRef")];if(currentRefCloud&&currentRefCloud.current){nrOfCloudPlansInContainer++;}});var containerWidth=0;if(currentListRef.current){var _currentListRef$curre=currentListRef.current.getBoundingClientRect(),width=_currentListRef$curre.width;containerWidth=width;}if((nrOfDesktopPlansInContainer||nrOfCloudPlansInContainer)>0&&containerWidth>0){var approxPlanWidth=Math.round(containerWidth/(nrOfDesktopPlansInContainer||nrOfCloudPlansInContainer));var tresholdWidth=nrOfDesktopPlansInContainer>0?PACKAGE_COLUMN_WIDTH_TRESHOLD_DESKTOP:PACKAGE_COLUMN_WIDTH_TRESHOLD_CLOUD;var result=approxPlanWidth<tresholdWidth;if(_this5.state.mobilePackageList!==result){_this5.setState({mobilePackageList:result});}}}};var setMinHeight=function setMinHeight(refPrefix){var descriptionHeight=0;Object.values(__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */]).forEach(function(plan){var currentRef=_this5["".concat(plan.toLowerCase()).concat(refPrefix,"Ref")];if(currentRef&&currentRef.current){currentRef.current.style.minHeight='auto';var _currentRef$current$g=currentRef.current.getBoundingClientRect(),height=_currentRef$current$g.height;descriptionHeight=Math.max(height,descriptionHeight);}});if(descriptionHeight!==0){Object.values(__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */]).forEach(function(plan){var currentRef=_this5["".concat("".concat(plan).concat(refPrefix,"Ref"))];if(currentRef&&currentRef.current){currentRef.current.style.minHeight="".concat(descriptionHeight,"px");}});}};switchToMobilePackageList();itemRefPrefix.forEach(function(refPrefix){setMinHeight(refPrefix);});}},{key:"closeDiscountBanner",value:function closeDiscountBanner(){if(this.state.hideDiscountBannerForeverChecked){// hide banner permanently
var discountBannerSetting=__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(this.props.settings,"".concat(__WEBPACK_IMPORTED_MODULE_38__config__["k" /* CAP_KEY */],".").concat(__WEBPACK_IMPORTED_MODULE_38__config__["_50" /* USER_DISCOUNT_BANNER_SETTING_KEY */]),{});var companySettings=discountBannerSetting[this.props.company.id]||{};companySettings[__WEBPACK_IMPORTED_MODULE_38__config__["L" /* FOREVER_HIDDEN_KEY */]]||(companySettings[__WEBPACK_IMPORTED_MODULE_38__config__["L" /* FOREVER_HIDDEN_KEY */]]=true);discountBannerSetting[this.props.company.id]=companySettings;this.props.writeUserSettings(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({},__WEBPACK_IMPORTED_MODULE_38__config__["_50" /* USER_DISCOUNT_BANNER_SETTING_KEY */],discountBannerSetting));}else{// hide banner temporarily
Object(__WEBPACK_IMPORTED_MODULE_43__utils_storage__["y" /* saveHideDiscountBannerFlag */])();}this.setState({showDiscountBanner:false});}},{key:"showMagixDiscountPopup",value:function showMagixDiscountPopup(isPerpetualProductType){var modalProps={magixDiscountProdType:isPerpetualProductType||this.isPerpetualOverviewMode||this.isPerpetualPeriodSelected?__WEBPACK_IMPORTED_MODULE_38__config__["Y" /* MAXIC_DISCOUNT_PROD_TYPE */].PERPETUAL:__WEBPACK_IMPORTED_MODULE_38__config__["Y" /* MAXIC_DISCOUNT_PROD_TYPE */].SUBSCRIPTION};this.props.showModal('DISCOUNT_MODAL',modalProps);}},{key:"routeToOneTimeCheckBoxAndShowDiscountPopup",value:function routeToOneTimeCheckBoxAndShowDiscountPopup(){var _this6=this;this.setState({pendingShowMagixDiscountForPerpetualClicked:true},function(){_this6.clearInvalidFieldsForBuyMorePopup(true);_this6.props.setAppStateParams({subscriptionView:__WEBPACK_IMPORTED_MODULE_38__config__["_45" /* SUBSCRIPTION_VIEW */].PURCHASE_OPTIONS,subscriptionPeriod:__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL,subscriptionCategory:__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CREATIVE_TOOLS});});}},{key:"getDiscountPercent",value:function getDiscountPercent(){var _this$props$discount2=this.props.discount,discountType=_this$props$discount2.discountType,couponSetKey=_this$props$discount2.couponSetKey,couponConfig=_this$props$discount2.couponConfig;if(discountType===__WEBPACK_IMPORTED_MODULE_38__config__["F" /* DISCOUNT_TYPE */].MAGIX||discountType===__WEBPACK_IMPORTED_MODULE_38__config__["F" /* DISCOUNT_TYPE */].COUPON_SET_ID){return __WEBPACK_IMPORTED_MODULE_38__config__["D" /* DISCOUNTS_CONFIG */][couponSetKey].discount;}else if(discountType===__WEBPACK_IMPORTED_MODULE_38__config__["F" /* DISCOUNT_TYPE */].COUPON_ID){if(__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(couponConfig,'discount_type')==='percentage'){return couponConfig.discount_percentage/100;}else if(__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(couponConfig,'discount_type')==='fixed_amount'){return couponConfig.discount_amount/100;}}}},{key:"getDiscountPrice",value:function getDiscountPrice(currentPrice,plan){var _this$props$discount3=this.props.discount,discountType=_this$props$discount3.discountType,couponConfig=_this$props$discount3.couponConfig;if(plan&&discountType===__WEBPACK_IMPORTED_MODULE_38__config__["F" /* DISCOUNT_TYPE */].MAGIX){// Calculate price for perpetual from env variables
var couponTier=__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.invert(__WEBPACK_IMPORTED_MODULE_38__config__["_7" /* PERPETAUL_PRODUCT_CATEGORY_TO_PACKAGE_MAP */])[plan];var discountPerc=__WEBPACK_IMPORTED_MODULE_38__config__["D" /* DISCOUNTS_CONFIG */]["tier_".concat(couponTier)].discount;return parseFloat(discountPerc>0&&(currentPrice*(1-discountPerc)).toFixed(2));}else if(discountType===__WEBPACK_IMPORTED_MODULE_38__config__["F" /* DISCOUNT_TYPE */].COUPON_SET_ID||discountType===__WEBPACK_IMPORTED_MODULE_38__config__["F" /* DISCOUNT_TYPE */].MAGIX){var _discountPerc=this.getDiscountPercent();return parseFloat(_discountPerc>0&&(currentPrice*(1-_discountPerc)).toFixed(2));}else if(discountType===__WEBPACK_IMPORTED_MODULE_38__config__["F" /* DISCOUNT_TYPE */].COUPON_ID){var _discountPerc2=this.getDiscountPercent();if(__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(couponConfig,'discount_type')==='percentage'){// Coupon set it does not provide leading numbers - don't show any discount
return parseFloat(_discountPerc2>0&&(currentPrice*(1-_discountPerc2)).toFixed(2));}else if(__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(couponConfig,'discount_type')==='fixed_amount'){return parseFloat((currentPrice-_discountPerc2).toFixed(2));}}}},{key:"getDefaultQuantity",value:function getDefaultQuantity(props,type,showNewRealEstateUI){var currentPlanId=props.currentPlanId,company=props.company;// On /perpetual-overview/ route in quantity box we put
// - number on members + admins if user has no addons
// - if user has already purchased any addon we use 1
// On non-perpetual route default is number of users
var _getSubscriptionsAndA5=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["i" /* getSubscriptionsAndAddons */])(company),perpetualAddons=_getSubscriptionsAndA5.perpetualAddons;var nonGuestUsers=Object(__WEBPACK_IMPORTED_MODULE_17_utils_users__["e" /* filterNonGuestUsers */])(company.users);if(type===__WEBPACK_IMPORTED_MODULE_38__config__["_19" /* QUANTITY_TYPE */].LICENSES){return __WEBPACK_IMPORTED_MODULE_50_lodash___default.a.isEmpty(perpetualAddons)?nonGuestUsers.length:1;}else if(type===__WEBPACK_IMPORTED_MODULE_38__config__["_19" /* QUANTITY_TYPE */].SEATS){// Subscription page
if(showNewRealEstateUI){// if user has plan set additional quantity to 0
// if there is no plan then set quantity to 0 for single admin user or match team size
return currentPlanId?0:nonGuestUsers.length===1?0:nonGuestUsers.length;}else{return this.hasPlan?1:nonGuestUsers.length;}}}},{key:"renderDiscountBanner",value:function renderDiscountBanner(){var _this7=this;var classes=this.props.classes;var _this$props$discount4=this.props.discount,isDiscountApplied=_this$props$discount4.isDiscountApplied,discountType=_this$props$discount4.discountType;var isMagixDiscountApplied=isDiscountApplied&&discountType===__WEBPACK_IMPORTED_MODULE_38__config__["F" /* DISCOUNT_TYPE */].MAGIX;var discountPerc=isMagixDiscountApplied&&this.getDiscountPercent();// eslint-disable-next-line no-unused-vars
return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{container:true,direction:"row",className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.discountBannerContainer,isMagixDiscountApplied&&classes.hasAppliedDiscount)},isMagixDiscountApplied?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,className:classes.discountBannerVoucherIconColumn},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__theme_icons__["_6" /* VoucherIcon */],{className:classes.discountBannerVoucherIcon})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,className:classes.discountBannerDiscountAppliedColumn},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{variant:"body2",className:classes.discountBannerDiscountApplied},this.isPerpetualOverviewMode||this.isPerpetualPeriodSelected?this.props.discount.appliedProdTypeOfLastValidCombination===__WEBPACK_IMPORTED_MODULE_38__config__["Y" /* MAXIC_DISCOUNT_PROD_TYPE */].PERPETUAL&&__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(this.props.crs,'isFallbackProductReturnedLastValidCombination')?localize('subscription-discount-applied-perpetual-generic'):localize('subscription-discount-applied-perpetual',discountPerc*100):localize('subscription-discount-applied',discountPerc*100))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,className:classes.discountBannerTryAnotherSerialButtonColumn},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["r" /* Link */],{underline:"hover","data-tid":'button-discount-banner',className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.discountBannerTryAnotherSerial,classes.discountBannerLink),onClick:function onClick(){return _this7.showMagixDiscountPopup();}},localize('subscription-discount-try-another-serial')))):__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,className:classes.discountBannerQuestionColumn},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{variant:"body2",className:classes.discountBannerQuestion,dangerouslySetInnerHTML:{__html:localize('subscription-discount-magix')}})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,className:classes.discountBannerGetDiscountButtonColumn},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["r" /* Link */],{underline:"hover","data-tid":'button-discount-banner',className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.discountBannerGetDiscountButton,classes.discountBannerLink),onClick:function onClick(){return _this7.showMagixDiscountPopup();}},localize('subscription-discount-get')))));}},{key:"renderPlanBoxes",value:function renderPlanBoxes(){var _classNames2,_classNames3,_classNames4,_classNames5,_classNames6;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{container:true,className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()((_classNames2={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames2,classes.planBoxesWrapper,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames2,'planBoxesWrapper',true),_classNames2))},this.shouldRenderCategorySelector&&this.renderCategorySelector(),(this.shouldRenderPeriodSelector||this.shouldRenderCurrencySelector||this.shouldRenderQuantityField)&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{container:true,item:true,className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()((_classNames3={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames3,classes.periodAndCurrencySelectorContainer,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames3,'periodAndCurrencySelectorContainer',true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames3,'layoutWithQuantityField',this.shouldRenderQuantityField),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames3,'layoutWithPeriodSelector',this.shouldRenderPeriodSelector),_classNames3))},this.shouldRenderQuantityField&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()((_classNames4={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames4,classes.quantitySelectorColumn,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames4,'quantitySelectorColumn',true),_classNames4))},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__components_QuantityField__["a" /* default */],{category:this.category,isPerpetualOverviewMode:this.isPerpetualOverviewMode,quantity:this.getQuantityInputValue(this.isPerpetualOverviewMode||this.isPerpetualPeriodSelected?__WEBPACK_IMPORTED_MODULE_38__config__["_19" /* QUANTITY_TYPE */].LICENSES:__WEBPACK_IMPORTED_MODULE_38__config__["_19" /* QUANTITY_TYPE */].SEATS),quantityType:this.isPerpetualOverviewMode||this.isPerpetualPeriodSelected?__WEBPACK_IMPORTED_MODULE_38__config__["_19" /* QUANTITY_TYPE */].LICENSES:__WEBPACK_IMPORTED_MODULE_38__config__["_19" /* QUANTITY_TYPE */].SEATS,renderInfoTooltip:this.renderInfoTooltip,enableBulkDiscountTooltip:!this.isPerpetualOverviewMode&&!this.isPerpetualPeriodSelected})),this.shouldRenderPeriodSelector&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()((_classNames5={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames5,classes.periodSelectorColumn,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames5,'periodSelectorColumn',true),_classNames5))},this.renderPeriodSelector()),this.shouldRenderCurrencySelector&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()((_classNames6={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames6,classes.currencySelectorColumn,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames6,'currencySelectorColumn',true),_classNames6))},this.renderCurrencySelector())),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{container:true,item:true},this.renderPlans(),this.renderAddons(),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{container:true,className:classes.acceptedPaymentMethodsContainer},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{variant:"body2",className:classes.acceptedPaymentMethods},localize('subscription-payment-methods-accepted'),this.currency&&this.currency.key==__WEBPACK_IMPORTED_MODULE_38__config__["x" /* CURRENCIES */].EUR.key?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__theme_icons__["_8" /* WeAcceptEurIcon */],{className:classes.acceptedPaymentMethodsIcon}):__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__theme_icons__["_9" /* WeAcceptIcon */],{className:classes.acceptedPaymentMethodsIcon})))));}},{key:"filterPlans",value:function filterPlans(plansToRender,onlySelectedCategory,onlyPreselected,isPerpetualApp,itemsQuantity,period){var _this8=this;var results=[];var usePeriod=period||this.period;plansToRender.forEach(function(planKey){var planId=__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */][planKey]||planKey;var _PACKAGES_CONFIG$plan=__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][planId],isCloudSuitePlan=_PACKAGES_CONFIG$plan.isCloudSuitePlan,isCreativeToolsPlan=_PACKAGES_CONFIG$plan.isCreativeToolsPlan,isPlusPackage=_PACKAGES_CONFIG$plan.isPlusPackage,isPerpetual=_PACKAGES_CONFIG$plan.isPerpetual;var showPackage=false;if(_this8.isPlusOverviewMode){if(isPlusPackage||isPerpetual){if(isPerpetualApp&&_this8.isPerpetualPeriodSelected){showPackage=isPerpetual;}else{showPackage=_this8.shouldPreselectPackage&&onlyPreselected?planId===_this8.state.preselectPackage&&!isPerpetual:!isPerpetual||isPerpetual&&_this8.hasPlan;}}else{showPackage=false;}}else if(_this8.isPerpetualOverviewMode){showPackage=_this8.shouldPreselectPackage&&onlyPreselected?planId===_this8.state.preselectPackage:isPerpetual;}else if(usePeriod===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL){showPackage=!onlySelectedCategory||isPerpetual;}else{showPackage=_this8.shouldPreselectPackage&&onlyPreselected?planId===_this8.state.preselectPackage:!onlySelectedCategory||_this8.isCloudSuiteCategory&&isCloudSuitePlan||_this8.isCreativeToolsCategory&&isCreativeToolsPlan&&(isPerpetual&&usePeriod===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL||!isPerpetual&&usePeriod!==__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL);}// eslint-disable-next-line no-unused-vars
var quantity=itemsQuantity||(isPerpetual?_this8.state.licensesQuantity:_this8.state.seatsQuantity);showPackage&&results.push(planId);});return __WEBPACK_IMPORTED_MODULE_50_lodash___default.a.uniq(results);}},{key:"getPlansToRender",value:function getPlansToRender(onlySelectedCategory,showMonthlyToYearlyUpgrade,onlyPreselected,itemsQuantity,period){var _this$state4=this.state,activeSubscription=_this$state4.activeSubscription,isPerpetualApp=_this$state4.isPerpetualApp;var plansToRender=[];var _getSubscriptionsAndA6=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["i" /* getSubscriptionsAndAddons */])(this.props.company),perpetualAddons=_getSubscriptionsAndA6.perpetualAddons;// If user has subscription render only upgrade options
// Additionaly render perpetual plans if isPerpetualApp or user has purchased perpetual product before,
// otherwise render all subscriptions
if(this.isPerpetualOverviewMode){plansToRender.push(__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].PHOTO_PERPETUAL,__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].WEB_PERPETUAL,__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].DESIGNER_PERPETUAL);}else{var subscriptionPlans;if(this.hasPlan){subscriptionPlans=this.props.company.hasUnlimitedTeamSubscription?[]:// Don't render Enterprise on plus-overview route
this.isPlusOverviewMode&&activeSubscription.plan===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].TEAM_PLUS&&activeSubscription.period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL?[]:__WEBPACK_IMPORTED_MODULE_38__config__["_43" /* SUBSCRIPTION_PLAN_UPGRADE_OPTIONS */][activeSubscription.plan];}else{subscriptionPlans=Object.keys(__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.omit(__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */],__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].SCALE));}plansToRender.push.apply(plansToRender,__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(subscriptionPlans));if(!__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.isEmpty(perpetualAddons)&&!this.props.company.hasUnlimitedTeamSubscription&&!this.isPlusOverviewMode){plansToRender.push(__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].PHOTO_PERPETUAL,__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].WEB_PERPETUAL,__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].DESIGNER_PERPETUAL);}}var results=this.filterPlans(plansToRender,onlySelectedCategory,onlyPreselected,isPerpetualApp,itemsQuantity,period);if(showMonthlyToYearlyUpgrade&&activeSubscription&&activeSubscription.plan&&activeSubscription.period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY){results.push(activeSubscription.plan);}return results;}},{key:"getNumberOfQualifyingProductsForCoupon",value:function getNumberOfQualifyingProductsForCoupon(accrossAllCurrencies,onlySubscription,onlyPerpetual,limitToPlan){return this.getQualifyingProductsForCoupon(accrossAllCurrencies,onlySubscription,onlyPerpetual,limitToPlan).length;}},{key:"getQualifyingProductsForCoupon",value:function getQualifyingProductsForCoupon(accrossAllCurrencies,onlySubscription,onlyPerpetual,limitToPlan){var _this9=this;var result=[];var _this$props$discount5=this.props.discount,discountType=_this$props$discount5.discountType,isDiscountApplied=_this$props$discount5.isDiscountApplied,couponConfig=_this$props$discount5.couponConfig,couponSetKey=_this$props$discount5.couponSetKey,couponId=_this$props$discount5.couponId,appliedProdTypeOfLastValidCombination=_this$props$discount5.appliedProdTypeOfLastValidCombination,appliedProdCatOfLastValidCombination=_this$props$discount5.appliedProdCatOfLastValidCombination;var activeSubscription=this.state.activeSubscription;var plansToCheck=[];if(discountType===__WEBPACK_IMPORTED_MODULE_38__config__["F" /* DISCOUNT_TYPE */].COUPON_ID&&(onlySubscription||onlyPerpetual)||isDiscountApplied&&(discountType===__WEBPACK_IMPORTED_MODULE_38__config__["F" /* DISCOUNT_TYPE */].COUPON_ID||discountType===__WEBPACK_IMPORTED_MODULE_38__config__["F" /* DISCOUNT_TYPE */].MAGIX||discountType===__WEBPACK_IMPORTED_MODULE_38__config__["F" /* DISCOUNT_TYPE */].COUPON_SET_ID&&couponSetKey===__WEBPACK_IMPORTED_MODULE_38__config__["E" /* DISCOUNT_KEY */].UPGRADE_POPUP)){if((this.isPerpetualOverviewMode||onlyPerpetual||this.hasPerpetualCheckbox)&&!onlySubscription){if(this.shouldPreselectPackage&&this.isPerpetualOverviewMode){plansToCheck.push(this.state.preselectPackage);}else{if(limitToPlan){plansToCheck.push(limitToPlan);}else{plansToCheck.push(__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].PHOTO_PERPETUAL,__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].WEB_PERPETUAL,__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].DESIGNER_PERPETUAL);}}}var allUpgradeOptionsPlans=(!this.isPerpetualOverviewMode&&!onlyPerpetual||onlySubscription)&&this.getPlanIdsForSubscriptionEstimate(this.props.currentPlanId,true,false);!__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.isEmpty(allUpgradeOptionsPlans)&&plansToCheck.push.apply(plansToCheck,__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(allUpgradeOptionsPlans));if(!__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.isEmpty(plansToCheck)){plansToCheck.forEach(function(checkPlan){var planId=checkPlan.split('-')[0];var checkCurrencies=accrossAllCurrencies?Object.values(__WEBPACK_IMPORTED_MODULE_38__config__["x" /* CURRENCIES */]):[_this9.currency];checkCurrencies.forEach(function(loopCurrency){if(__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][planId].isPerpetual){if(_this9.shouldShowAppliedDiscountForCurrentPackage(planId,__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL,loopCurrency.key,couponConfig,discountType,couponSetKey,couponId,false,appliedProdTypeOfLastValidCombination,appliedProdCatOfLastValidCombination)){result.push(planId);}}else if(!_this9.isPerpetualOverviewMode||onlySubscription){var _convertPlanIdIntoSub8=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(checkPlan),plan=_convertPlanIdIntoSub8.plan,period=_convertPlanIdIntoSub8.period;// ?cid=BOOSTMYROI is already excluding desktop+ packages
// in shouldShowAppliedDiscountForCurrentPackage
if(_this9.shouldShowAppliedDiscountForCurrentPackage(plan,period,loopCurrency.key,couponConfig,discountType,couponSetKey,couponId,false,appliedProdTypeOfLastValidCombination,appliedProdCatOfLastValidCombination)){if(_this9.hasPlan&&activeSubscription.plan===plan&&activeSubscription.period===period){return;}result.push(plan);}}});});}}return __WEBPACK_IMPORTED_MODULE_50_lodash___default.a.uniq(result);}},{key:"renderPlans",value:function renderPlans(){var _this10=this,_classNames8;var classes=this.props.classes;var _this$state5=this.state,activeSubscription=_this$state5.activeSubscription,period=_this$state5.period;var plansToRender=this.getPlansToRender(true,false,true);if(!this.isPerpetualOverviewMode&&activeSubscription.plan){// If user already has monthly plan and he clicks on annual checkbox,
// then offer him to upgrade to annual version of existing plan
var _PACKAGES_CONFIG$acti2=__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][activeSubscription.plan],isCloudSuitePlanSelected=_PACKAGES_CONFIG$acti2.isCloudSuitePlan,isCreativeToolsPlanSelected=_PACKAGES_CONFIG$acti2.isCreativeToolsPlan;if(this.isMonthlyPlan&&this.isAnnualPeriodSelected&&(this.isCloudSuiteCategory&&isCloudSuitePlanSelected||this.isCreativeToolsCategory&&isCreativeToolsPlanSelected)&&!this.shouldPreselectPackage){plansToRender.unshift(activeSubscription.plan);}}plansToRender.sort(function(a,b){return __WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][a].order-__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][b].order;});// Add current plan to other upgrade options so that user can compare features with other plans
if(!this.isPlusOverviewMode&&!this.isPerpetualOverviewMode&&activeSubscription.plan){if(activeSubscription.period===period){if(this.shouldRenderCategorySelector){if(__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][activeSubscription.plan].isCloudSuitePlan&&this.category===__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CLOUD_SUITE){plansToRender.unshift('current');}else if(__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][activeSubscription.plan].isCreativeToolsPlan&&this.category===__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CREATIVE_TOOLS){plansToRender.unshift('current');}}else{plansToRender.unshift('current');}}}var resultPlans=plansToRender.map(function(planId,index){var _classNames7;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,key:"plan-item-".concat(index+1),className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()((_classNames7={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames7,classes.productVerticalColumn,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames7,'productVerticalColumn',true),_classNames7))},_this10.renderBox(planId));});return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{ref:this['productsListVerticalRef'],className:classes.productsListVerticalWrapper},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{container:true,className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()((_classNames8={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames8,classes.productsListVertical,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames8,'mobilePackageList',this.state.mobilePackageList),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames8,"columns".concat(plansToRender.length),true),_classNames8))},resultPlans.map(function(item){return item;}),this.shouldPreselectPackage&&this.renderSeeAllProductsLink()));}},{key:"renderAddons",value:function renderAddons(){var _this11=this;var classes=this.props.classes;var keys=Object.keys(__WEBPACK_IMPORTED_MODULE_38__config__["d" /* ADDONS_LIST */]).map(function(key){return key.toLowerCase();});var addonsToRender=[];keys.forEach(function(key){if(_this11.category===__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CLOUD_SUITE&&__WEBPACK_IMPORTED_MODULE_38__config__["c" /* ADDONS_CONFIG */][key].isCloudAddon||_this11.category===__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CREATIVE_TOOLS&&__WEBPACK_IMPORTED_MODULE_38__config__["c" /* ADDONS_CONFIG */][key].isDesktopAddon){addonsToRender.push(key);}});if(__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.isEmpty(addonsToRender))return;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,container:true,className:classes.addonsWrapper,direction:"column"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,className:classes.addonsTitleGrid},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{variant:"h2",className:classes.addonsTitle},localize('addons-section-title'))),addonsToRender.map(function(id){return _this11.renderAddon(id);}));}},{key:"renderAddon",value:function renderAddon(addonId){var _classNames9;var symbol=this.currency.symbol;var classes=this.props.classes;var _ADDONS_CONFIG$addonI=__WEBPACK_IMPORTED_MODULE_38__config__["c" /* ADDONS_CONFIG */][addonId],title=_ADDONS_CONFIG$addonI.title,description=_ADDONS_CONFIG$addonI.description,details=_ADDONS_CONFIG$addonI.details,featuresList=_ADDONS_CONFIG$addonI.featuresList,featuresNote=_ADDONS_CONFIG$addonI.featuresNote,tag=_ADDONS_CONFIG$addonI.tag,tagSubscription=_ADDONS_CONFIG$addonI.tagSubscription,tagPerpetual=_ADDONS_CONFIG$addonI.tagPerpetual,buttonLabel=_ADDONS_CONFIG$addonI.buttonLabel,Icon=_ADDONS_CONFIG$addonI.icon,buttonURL=_ADDONS_CONFIG$addonI.buttonURL,intercomMessage=_ADDONS_CONFIG$addonI.intercomMessage;var tagToRender;if(tagSubscription&&tagPerpetual){if(this.isPerpetualOverviewMode||this.isPerpetualPeriodSelected){tagToRender=tagPerpetual;}else{tagToRender=tagSubscription;}}else{tagToRender=tag;}return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{key:"addon-".concat(addonId),item:true,container:true,className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()((_classNames9={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames9,classes.addonContainer,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames9,"addonContainer-".concat(addonId),true),_classNames9))},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,className:classes.addonTitleAndDescriptionColumn},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,container:true,direction:"row",className:classes.addonIconAndTitle},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,className:classes.addonIconColumn},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Icon,null)),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,container:true,direction:"column",className:classes.addonTitleColumn},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{variant:"h3",className:classes.addonTitle,dangerouslySetInnerHTML:{__html:title}}))),tagToRender&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{variant:"h3",className:classes.addonTag},tagToRender),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{variant:"h3",className:classes.addonDescription},description),details&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{variant:"h3",className:classes.addonDetails},localize(details,[symbol]))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,className:classes.addonDetailsListColumn},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["s" /* List */],{disablePadding:true,className:classes.addonDetailsList},featuresList&&featuresList.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["t" /* ListItem */],{key:"features-list-".concat(index),dense:true,className:classes.addonDetailsListItem},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["u" /* ListItemIcon */],{className:classes.addonDetailsListItemIcon},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__theme_icons__["d" /* CheckIcon2 */],{className:classes.addonDetailsListItemIconIncluded})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["v" /* ListItemText */],{className:classes.addonDetailsListItemText,primaryTypographyProps:{className:classes.addonDetailsListItemTextItem}},item.label));})),featuresNote&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{variant:"h3",className:classes.addonFeaturesNote},featuresNote)),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,className:classes.addonActionsColumn},this.renderAddonButton(buttonLabel,buttonURL,intercomMessage,addonId)));}},{key:"renderAddonButton",value:function renderAddonButton(buttonLabel,buttonURL,intercomMessage,addonId){var _classNames10,_this12=this;var classes=this.props.classes;var buttonClassName=__WEBPACK_IMPORTED_MODULE_36_classnames___default()((_classNames10={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames10,classes.button,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames10,classes.addonButton,true),_classNames10));return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.addonButtonContainer},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["a" /* Button */],{variant:"contained",key:"main",className:buttonClassName,onClick:function onClick(){if(buttonURL){if(addonId===__WEBPACK_IMPORTED_MODULE_38__config__["d" /* ADDONS_LIST */].HOSTING){if(__WEBPACK_IMPORTED_MODULE_49_i18n_i18n__["a" /* default */].getCurrentLanguage()==='de'){buttonURL=__WEBPACK_IMPORTED_MODULE_38__config__["M" /* HOSTING_BUTTON_URL_DE */];}else{buttonURL=__WEBPACK_IMPORTED_MODULE_38__config__["N" /* HOSTING_BUTTON_URL_EN */];}}window.open(buttonURL,'_blank');}else if(intercomMessage){Object(__WEBPACK_IMPORTED_MODULE_19_utils_intercom__["a" /* openIntercomChat */])(intercomMessage,true,_this12.props.showErrorPopup);}}},buttonLabel));}},{key:"calculateCheckoutData",value:function calculateCheckoutData(planToRender,period,isPerpetual,quantity){var checkoutPriceTotal;var checkoutPricePerMonth=0;var showDiscountForPlan;var currentRegularPrice;var annualPriceTotal;var saving;var errorLoadingSubscriptionEstimationData=false;var planIsTaxed=null;var _this$props$discount6=this.props.discount,discountType=_this$props$discount6.discountType,isDiscountApplied=_this$props$discount6.isDiscountApplied,couponConfig=_this$props$discount6.couponConfig,couponSetKey=_this$props$discount6.couponSetKey,couponId=_this$props$discount6.couponId,appliedProdTypeOfLastValidCombination=_this$props$discount6.appliedProdTypeOfLastValidCombination,appliedProdCatOfLastValidCombination=_this$props$discount6.appliedProdCatOfLastValidCombination;if(isPerpetual){showDiscountForPlan=isDiscountApplied&&this.shouldShowAppliedDiscountForCurrentPackage(planToRender,period,this.currency.key,couponConfig,discountType,couponSetKey,couponId,false,appliedProdTypeOfLastValidCombination,appliedProdCatOfLastValidCombination);currentRegularPrice=parseFloat(__WEBPACK_IMPORTED_MODULE_38__config__["_44" /* SUBSCRIPTION_PRICES */][planToRender][__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL]);if(quantity){currentRegularPrice*=quantity;}var subscriptionDiscountPrice=showDiscountForPlan?this.getDiscountPrice(currentRegularPrice,planToRender):null;if(subscriptionDiscountPrice){checkoutPricePerMonth=subscriptionDiscountPrice;saving=(currentRegularPrice-subscriptionDiscountPrice).toFixed(2);}else{checkoutPricePerMonth=currentRegularPrice;}if(subscriptionDiscountPrice&&this.getDiscountPercent()===1&&period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL){// When discount is 100% show original price to avoid slightly different number because of rounding 
saving=currentRegularPrice;}}else{var planEstimation=__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(this.props.companies,"subscriptionEstimation[".concat(planToRender,"-").concat(period,"-").concat(__WEBPACK_IMPORTED_MODULE_38__config__["l" /* CB_API_FETCH_CURRENCY */],"].estimation"))||__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(this.props.companies,"subscriptionEstimationActivePlan[".concat(planToRender,"-").concat(period,"-").concat(__WEBPACK_IMPORTED_MODULE_38__config__["l" /* CB_API_FETCH_CURRENCY */],"].estimation"));if(planEstimation){planIsTaxed=planEstimation.isTaxed;currentRegularPrice=(planEstimation.isTaxed?planEstimation.totalAmountWithoutTaxAndWithoutDiscount*(1+planEstimation.totalTaxRate/100):planEstimation.totalAmountWithoutTaxAndWithoutDiscount)/100;checkoutPriceTotal=(planEstimation.isTaxed?planEstimation.totalAmountWithTaxWithDiscountWithoutCreditsApplied:planEstimation.totalAmountWithoutTaxWithDiscountWithoutCreditsApplied)/100;if(period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL){annualPriceTotal=checkoutPriceTotal;checkoutPricePerMonth=checkoutPriceTotal/12;}else{checkoutPricePerMonth=checkoutPriceTotal;}showDiscountForPlan=Boolean(planEstimation.totalDiscountAmountWithoutTax);if(showDiscountForPlan){saving=(currentRegularPrice-checkoutPriceTotal).toFixed(2);}}else{errorLoadingSubscriptionEstimationData=true;}}annualPriceTotal&&(annualPriceTotal=annualPriceTotal.toFixed(2));checkoutPricePerMonth&&(checkoutPricePerMonth=checkoutPricePerMonth.toFixed(2));return{checkoutPricePerMonth:checkoutPricePerMonth,showDiscountForPlan:showDiscountForPlan,currentRegularPrice:currentRegularPrice,annualPriceTotal:annualPriceTotal,saving:saving,errorLoadingSubscriptionEstimationData:errorLoadingSubscriptionEstimationData,planIsTaxed:planIsTaxed};}},{key:"renderBox",value:function renderBox(plan){var _classNames11,_this13=this,_classNames18;var planToRender;if(plan==='current'){if(this.props.company.hasUnlimitedTeamSubscription){planToRender=__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].ENTERPRISE;}else{planToRender=this.activePlan;}}else{planToRender=plan;}var classes=this.props.classes;var period=this.state.period;var _this$props$discount7=this.props.discount,discountType=_this$props$discount7.discountType,couponConfig=_this$props$discount7.couponConfig,couponSetKey=_this$props$discount7.couponSetKey,appliedProdTypeOfLastValidCombination=_this$props$discount7.appliedProdTypeOfLastValidCombination;var _PACKAGES_CONFIG$plan2=__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][planToRender],className=_PACKAGES_CONFIG$plan2.className,title=_PACKAGES_CONFIG$plan2.title,description=_PACKAGES_CONFIG$plan2.description,descriptionDesktop=_PACKAGES_CONFIG$plan2.descriptionDesktop,optionsTitle=_PACKAGES_CONFIG$plan2.optionsTitle,optionsTitleActive=_PACKAGES_CONFIG$plan2.optionsTitleActive,optionsTitleDesktop=_PACKAGES_CONFIG$plan2.optionsTitleDesktop,featuresListMain=_PACKAGES_CONFIG$plan2.featuresListMain,featuresListAdvanced=_PACKAGES_CONFIG$plan2.featuresListAdvanced,customPackageTag=_PACKAGES_CONFIG$plan2.customPackageTag,per_user=_PACKAGES_CONFIG$plan2.per_user,isPerpetual=_PACKAGES_CONFIG$plan2.isPerpetual,isCloudSuitePlan=_PACKAGES_CONFIG$plan2.isCloudSuitePlan,isCreativeToolsPlan=_PACKAGES_CONFIG$plan2.isCreativeToolsPlan,Icon=_PACKAGES_CONFIG$plan2.icon;var isCurrentActivePlan=plan==='current';var isCloudPackageLayout=this.category===__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CLOUD_SUITE;var isDesktopPackageLayout=this.category===__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CREATIVE_TOOLS;var productClassName=__WEBPACK_IMPORTED_MODULE_36_classnames___default()((_classNames11={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames11,classes.productWrapperVertical,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames11,classes.activeProductContent,isCurrentActivePlan),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames11,'activeProductContent',isCurrentActivePlan),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames11,'isCloudCategory',isCloudPackageLayout),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames11,className,true),_classNames11));var textClassName=classes[className];var symbol=this.currency.symbol;var displayTitle=this.addVersionToTitle(planToRender,title);var featuresIncludedTitle=isDesktopPackageLayout&&optionsTitleDesktop?optionsTitleDesktop:this.hasPlan&&optionsTitleActive||optionsTitle;var packageDescription=isDesktopPackageLayout&&descriptionDesktop?descriptionDesktop:description;var quantity=this.hasPlan&&!isPerpetual?Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["e" /* getMembersPaidQuantity */])(this.props.company):this.getQuantityIntegerValue(isPerpetual?__WEBPACK_IMPORTED_MODULE_38__config__["_19" /* QUANTITY_TYPE */].LICENSES:__WEBPACK_IMPORTED_MODULE_38__config__["_19" /* QUANTITY_TYPE */].SEATS);var _this$calculateChecko=this.calculateCheckoutData(planToRender,period,isPerpetual,quantity),checkoutPricePerMonth=_this$calculateChecko.checkoutPricePerMonth,showDiscountForPlan=_this$calculateChecko.showDiscountForPlan,currentRegularPrice=_this$calculateChecko.currentRegularPrice,annualPriceTotal=_this$calculateChecko.annualPriceTotal,saving=_this$calculateChecko.saving,planIsTaxed=_this$calculateChecko.planIsTaxed,errorLoadingSubscriptionEstimationData=_this$calculateChecko.errorLoadingSubscriptionEstimationData;var savingWithYourDiscountKey=isPerpetual?'saving-once-off':'saving-subscription';if(saving){// Cover case when monthly discount is for only few months
if(__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(couponConfig,'duration_type')==='limited_period'&&__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(couponConfig,'period_unit')==='month'){savingWithYourDiscountKey+='-per-limited-period';}else{if(period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL){savingWithYourDiscountKey+='-per-year';}else if(period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY){savingWithYourDiscountKey+='-per-month';}if(discountType===__WEBPACK_IMPORTED_MODULE_38__config__["F" /* DISCOUNT_TYPE */].MAGIX&&appliedProdTypeOfLastValidCombination===__WEBPACK_IMPORTED_MODULE_38__config__["Y" /* MAXIC_DISCOUNT_PROD_TYPE */].SUBSCRIPTION||discountType===__WEBPACK_IMPORTED_MODULE_38__config__["F" /* DISCOUNT_TYPE */].COUPON_SET_ID&&couponSetKey===__WEBPACK_IMPORTED_MODULE_38__config__["E" /* DISCOUNT_KEY */].UPGRADE_POPUP){savingWithYourDiscountKey+='-first-order-only';}}}var renderSavedAmount=function renderSavedAmount(){var savingKey;if(!isPerpetual){if(period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL){savingKey='subscription-amount-per-year';}else if(period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY){savingKey='subscription-amount-per-month';}}return isPerpetual?"".concat(localize('subscription-saving-regular-price')," <strong>").concat(symbol).concat(currentRegularPrice.toFixed(2),"</strong>.\n\t\t\t\t").concat(localize(savingWithYourDiscountKey,"".concat(symbol).concat(saving)),"\t\t\t\t\n\t\t\t\t"):"".concat(localize('subscription-saving-regular-price')," <strong>").concat(symbol).concat(currentRegularPrice.toFixed(2)," \n\t\t\t\t/").concat(localize(savingKey),"</strong>.\n\t\t\t\t").concat(localize(savingWithYourDiscountKey,"".concat(symbol).concat(saving)));};var renderEnterprisePrice=function renderEnterprisePrice(){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{variant:"h2",className:classes.productPrice},localize('subscription-plan-enterprise-price')));};var renderProductPrice=function renderProductPrice(){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{variant:"h2",className:classes.productPrice,"data-icon":symbol},checkoutPricePerMonth,isPerpetual?quantity?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span",{className:classes.itemsQuantityabel},localize('subscription-price-for-number-of-licenses',quantity)):'':__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span",{className:classes.productMonthLabel},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span",null,"/",localize('subscription-amount-per-month'))),_this13.getVatLabel(isPerpetual,false)),annualPriceTotal&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{variant:"body2",className:classes.productPriceBilledAnualy},localize('subscription-billed-annually-as-one-payment-of'),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span",{className:classes.productPriceBilledAnualyValue},symbol,annualPriceTotal),_this13.getVatLabel(isPerpetual,planIsTaxed)),!isCurrentActivePlan&&saving>0&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{variant:"body2",className:classes.productSavedAmount,dangerouslySetInnerHTML:{__html:renderSavedAmount()}}));};var renderLoadingIcon=function renderLoadingIcon(){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{variant:"body2",className:classes.productPriceInfoPending},"(",localize('subscription-calculating-price'),")");};var renderMembersIncludedInfo=function renderMembersIncludedInfo(){var infoToRender=__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][planToRender],'membersIncludedInfo');return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["s" /* List */],{disablePadding:true,className:classes.membersIncludedList},infoToRender&&infoToRender.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["t" /* ListItem */],{key:"box-item-".concat(index),dense:true,className:classes.membersIncludedListItem},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["u" /* ListItemIcon */],{className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(textClassName,classes.membersIncludedListItemIcon)},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__theme_icons__["d" /* CheckIcon2 */],null)),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["v" /* ListItemText */],{className:classes.membersIncludedListItemText,primaryTypographyProps:{className:classes.membersIncludedListItemTextItem}},item.label,item.rolesTooltip&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_RolesTooltip__["a" /* default */],{showGuestTooltip:true}),item.tooltip&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_RolesTooltip__["a" /* default */],{text:item.tooltip})));}));};var renderProductPriceAndDescription=function renderProductPriceAndDescription(){if(isCloudPackageLayout){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,container:true,className:classes.gridProducPriceAndDescription},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{ref:_this13["".concat(planToRender.toLowerCase(),"ProductShortDescriptionCloudRef")]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{variant:"body2",className:classes.productShortDescriptionCloud},packageDescription)),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{className:classes.productPriceInfoVertical},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{ref:_this13["".concat(planToRender.toLowerCase(),"ProductPriceInfoRef")]},planToRender===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].ENTERPRISE?renderEnterprisePrice():checkoutPricePerMonth&&!_this13.props.companies.getSubscriptionEstimateXhrInProgress?renderProductPrice():renderLoadingIcon(),planToRender!==__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].ENTERPRISE&&renderMembersIncludedInfo())));}else if(isDesktopPackageLayout){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{ref:_this13["".concat(planToRender.toLowerCase(),"ProductShortDescriptionDesktopRef")]},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,container:true,className:classes.gridProducPriceAndDescription},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{className:classes.productPriceInfo},planToRender===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].ENTERPRISE?renderEnterprisePrice():checkoutPricePerMonth&&!_this13.props.companies.getSubscriptionEstimateXhrInProgress?renderProductPrice():renderLoadingIcon()),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,className:classes.columnProductShortDescriptionDesktop},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{variant:"body2",className:classes.productShortDescriptionDesktop},packageDescription))));}};var renderProductHeader=function renderProductHeader(){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,container:true,direction:"row"},customPackageTag&&!isCurrentActivePlan&&isCloudPackageLayout&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{variant:"body2",className:classes.productTag},localize('subscription-plan-scale-tag')),isCurrentActivePlan&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.productTag,classes.productTagCurrent)},localize('subscription-plan-tag-current-plan')),isDesktopPackageLayout&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,className:classes.columnProductIcon},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Icon,null)),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,container:true,direction:"column",className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(isCloudPackageLayout?classes.columnProductTitleSimple:classes.columnProductTitle)},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{variant:"h1",className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.productTitle,isCloudPackageLayout&&classes.productTitleLarge),dangerouslySetInnerHTML:{__html:displayTitle}}),!_this13.props.company.hasUnlimitedTeamSubscription&&(planToRender===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].TEAM_PLUS||planToRender===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].ESSENTIAL)&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{variant:"body2",className:classes.productQuantityPerUser},per_user)));};var renderFeaturesListAccordion=function renderFeaturesListAccordion(item){var _classNames12,_classNames13,_classNames14,_classNames15,_classNames16;var expanded=__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(_this13.state.accordion,"[".concat(item.id,"].expanded"),false);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["h" /* ExpansionPanel */],{key:"accordion-".concat(item.id),expanded:expanded,className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()((_classNames12={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames12,classes.packageDetailsAccordion,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames12,classes.packageDetailsAccordionExpanded,expanded),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames12,'packageDetailsHighlighted',Boolean(item.highlighted)),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames12,'packageDetailsHasTag',Boolean(item.tag)),_classNames12)),onChange:function onChange(e){return _this13.handleAccordionToggle(e,item.id);}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["j" /* ExpansionPanelSummary */],{className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()((_classNames13={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames13,classes.packageDetailsAccordionSummary,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames13,'packageDetailsAccordionSummaryExpanded',expanded),_classNames13))},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{container:true,direction:"row"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,className:classes.columnAccordionToggleIcon},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__material_ui_icons_ExpandMore___default.a,{style:{fontSize:20},className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()((_classNames14={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames14,classes.expandAccordionIcon,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames14,'expandAccordionIcon',true),_classNames14))})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,className:classes.columnAccordionToggleTitle},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()((_classNames15={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames15,classes.accordionTitle,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames15,'accordionTitle',true),_classNames15))},item.tag&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span",{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()((_classNames16={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames16,classes.packageDetailsTag,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames16,'packageDetailsTag',true),_classNames16))},localize(item.tag)),item.label)))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["i" /* ExpansionPanelDetails */],{className:classes.packageDetailsAccordionDetails},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{variant:"body2",className:classes.packageDetailsAccordionContent,dangerouslySetInnerHTML:{__html:item.description}})));};var renderFeaturesListSection=function renderFeaturesListSection(item){var _classNames17;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{container:true,direction:"row",key:"accordion-section-".concat(item.id)},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,className:classes.columnPackageDetailsSectionTitle},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{variant:"h3",className:classes.packageDetailsSectionTitle},item.tag&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span",{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()((_classNames17={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames17,classes.packageDetailsTag,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames17,'packageDetailsTag',true),_classNames17))},localize(item.tag)),item.label),item.description&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{variant:"body2",className:classes.packageDetailsSectionContent},localize(item.description)),item.bullets&&item.bullets.map(function(item,index){return renderFeaturesListAccordion(item);})));};var renderCloudFeatures=function renderCloudFeatures(){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,featuresListAdvanced&&featuresListAdvanced.map(function(item,index){if(item.type===__WEBPACK_IMPORTED_MODULE_38__config__["_5" /* PACKAGE_DESCRIPTION_ITEM_TYPE */].ACCORDION){return renderFeaturesListAccordion(item);}else if(item.type===__WEBPACK_IMPORTED_MODULE_38__config__["_5" /* PACKAGE_DESCRIPTION_ITEM_TYPE */].SECTION){return renderFeaturesListSection(item);}}),/* render desktop features inside active plan box active plan */isCurrentActivePlan&&isCreativeToolsPlan&&!isCloudSuitePlan&&renderDesktopFeatures(true));};var renderDesktopFeatures=function renderDesktopFeatures(renderCloudStyleBullets){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["s" /* List */],{disablePadding:true,className:classes.featuresList},featuresListMain&&featuresListMain.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["t" /* ListItem */],{key:"desktop-features-".concat(index),dense:true,className:renderCloudStyleBullets?classes.featuresListItemCloudStyle:classes.featuresListItem},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["u" /* ListItemIcon */],{className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(textClassName,classes.featuresListItemIcon)},item.excluded?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__theme_icons__["_11" /* XIcon */],{className:classes.featuresListItemIconExcluded}):__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__theme_icons__["d" /* CheckIcon2 */],{className:classes.featuresListItemIconIncluded})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["v" /* ListItemText */],{className:renderCloudStyleBullets?classes.featuresListItemTextCloudStyle:classes.featuresListItemText,primaryTypographyProps:{className:renderCloudStyleBullets?classes.featuresListItemTextItemCloudStyle:classes.featuresListItemTextItem}},item.label));}));};return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["y" /* Paper */],{className:productClassName,component:"section"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{container:true,direction:"row",className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()((_classNames18={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames18,'productContentVertical',true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames18,classes.productContentVertical,true),_classNames18))},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,container:true,className:classes.gridProductHeader},renderProductHeader()),!this.props.company.hasUnlimitedTeamSubscription&&renderProductPriceAndDescription(),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,className:classes.columnProductDescriptionMain},isCurrentActivePlan?this.renderViewCurrentPlanButton():planToRender===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].ENTERPRISE?this.renderContactSalesButton(planToRender):this.renderUpgradeButton(displayTitle,planToRender,showDiscountForPlan,period,checkoutPricePerMonth,annualPriceTotal,errorLoadingSubscriptionEstimationData,planIsTaxed),!isCurrentActivePlan&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{variant:"h2",className:classes.productDescriptionMainTitle},featuresIncludedTitle),isDesktopPackageLayout&&this.renderProductCategory(planToRender),isDesktopPackageLayout?renderDesktopFeatures(false):renderCloudFeatures())));}},{key:"getVatLabel",value:function getVatLabel(isPerpetual,planIsTaxed,textOnly){if(this.currency.key===__WEBPACK_IMPORTED_MODULE_38__config__["x" /* CURRENCIES */].USD.key)return;var classes=this.props.classes;var _getSubscriptionsAndA7=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["i" /* getSubscriptionsAndAddons */])(this.props.company,true),pastSubscription=_getSubscriptionsAndA7.subscription;if(isPerpetual){// Perpetual price comes from config so VAT is not included
return textOnly?"(".concat(localize('subscription-plus-vat'),")"):__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span",{className:classes.itemsVatLabel},"(",localize('subscription-plus-vat'),")");}else if(planIsTaxed===true){return textOnly?"(".concat(localize('subscription-including-vat'),")"):__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span",{className:classes.itemsVatLabel},"(",localize('subscription-including-vat'),")");}else if(!this.hasPlan&&__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.isEmpty(pastSubscription)){// If user does not have current or past subscription we don't know VAT info
return textOnly?"(".concat(localize('subscription-plus-vat'),")"):__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span",{className:classes.itemsVatLabel},"(",localize('subscription-plus-vat'),")");}}},{key:"handleAccordionToggle",value:function handleAccordionToggle(e,accordionId){var accordionState=this.state.accordion;var isAccordionExpanded=!__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(this.state.accordion,"[".concat(accordionId,"]expanded"),false);if(!accordionState[accordionId]){accordionState[accordionId]={};}accordionState[accordionId].expanded=isAccordionExpanded;this.setState(accordionState);}},{key:"addVersionToTitle",value:function addVersionToTitle(plan,title,productVersion){if(plan===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].WEB_PERPETUAL){return title.replace('_VERSION_',productVersion||__WEBPACK_IMPORTED_MODULE_38__config__["_63" /* WEB_PERPETUAL_LATEST_VERSION */]);}else if(plan===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].PHOTO_PERPETUAL){return title.replace('_VERSION_',productVersion||__WEBPACK_IMPORTED_MODULE_38__config__["_9" /* PHOTO_PERPETUAL_LATEST_VERSION */]);}else if(plan===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].DESIGNER_PERPETUAL){return title.replace('_VERSION_',productVersion||__WEBPACK_IMPORTED_MODULE_38__config__["A" /* DESIGNER_PERPETUAL_LATEST_VERSION */]);}else{return title;}}},{key:"renderViewCurrentPlanButton",value:function renderViewCurrentPlanButton(plan,useDiscount){var _classNames19,_this14=this;var classes=this.props.classes;var buttonClassName=__WEBPACK_IMPORTED_MODULE_36_classnames___default()((_classNames19={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames19,classes.button,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames19,classes.viewCurrentPlanButton,true),_classNames19));return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.viewCurrentPlanButtonContainer},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["a" /* Button */],{variant:"contained","data-tid":"buttonview-current-plan",key:"main",className:buttonClassName,onClick:function onClick(){return _this14.handleViewCurrentPlan();}},localize('subscription-box-view-current-plan')));}},{key:"showReduceUsersModal",value:function showReduceUsersModal(callback,freeSeatsIncluded,quantityFromQueryParam){var modalProps={cb:callback,getQuantityInputValue:this.getQuantityInputValue,freeSeatsIncluded:freeSeatsIncluded,quantityFromQueryParam:quantityFromQueryParam};this.props.showModal('REDUCE_USERS',modalProps);}},{key:"showConfirmChoiceModal",value:function showConfirmChoiceModal(callback,displayTitle,plan,quantity,currency,period,checkoutPricePerMonth,annualPriceTotal,errorLoadingSubscriptionEstimationData,planIsTaxed){var _PACKAGES_CONFIG$plan3=__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][plan],isPerpetual=_PACKAGES_CONFIG$plan3.isPerpetual,freeSeatsIncluded=_PACKAGES_CONFIG$plan3.freeSeatsIncluded;var productTitle=Object(__WEBPACK_IMPORTED_MODULE_18_utils_string__["b" /* stripHTML */])(displayTitle);var modalProps={cb:callback,plan:plan,listItems:[productTitle]};var priceAndPeriodLabelKey;if(period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL){priceAndPeriodLabelKey='subscription-current-billing-period-yearly';}else if(period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY){priceAndPeriodLabelKey='subscription-current-billing-period-monthly';}else{priceAndPeriodLabelKey='subscription-current-billing-period-perpetual';}var priceToShow;if(period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL){priceToShow=annualPriceTotal;}else if(period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY||period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL){priceToShow=checkoutPricePerMonth;}var priceAndPeriod;if(!errorLoadingSubscriptionEstimationData){// Allow checkout if fetching addon data fails but don't show price in Confirm choice popup
priceAndPeriod="".concat(localize(priceAndPeriodLabelKey),":\n\t\t\t").concat(currency.symbol).concat(priceToShow," ").concat(localize('subscription-currency-'+currency.key));var vatLabel=this.getVatLabel(isPerpetual,planIsTaxed);if(vatLabel){priceAndPeriod="".concat(priceAndPeriod).concat(Object(__WEBPACK_IMPORTED_MODULE_11_react_dom_server__["renderToString"])(vatLabel));}}if(isPerpetual){modalProps.listItems.push(localize('subscription-confirm-choice-licenses-total',quantity));priceAndPeriod&&modalProps.listItems.push(priceAndPeriod);}else{if([__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].WEB,__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].PHOTO,__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].DESIGNER].includes(plan)){modalProps.listItems.push(localize('subscription-confirm-choice-users-total',quantity));}else if(plan===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT){modalProps.listItems.push(localize('subscription-confirm-choice-one-agent',quantity));}else if([__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].ESSENTIAL,__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].TEAM_PLUS,__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES].includes(plan)){var usersKey=plan===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES?'agents':'users';var quantityString=quantity<=freeSeatsIncluded?localize("subscription-confirm-choice-".concat(usersKey,"-total-including-free"),[freeSeatsIncluded,freeSeatsIncluded-1]):localize("subscription-confirm-choice-".concat(usersKey,"-total"),quantity);modalProps.listItems.push(quantityString);}if(priceAndPeriod){modalProps.listItems.push(priceAndPeriod);}else{modalProps.listItems.push(localize(priceAndPeriodLabelKey));modalProps.listItems.push("".concat(localize('subscription-currency'),":\n\t\t\t\t\t").concat(localize('subscription-currency-'+currency.key)));}if([__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT,__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES].includes(plan)){modalProps.listItems.push(localize('subscription-confirm-choice-12-months-commitment'));}}this.props.showModal('CONFIRM_PURCHASE_CHOICE',modalProps);}},{key:"doCheckout",value:function doCheckout(plan,period,isUpgrade,useDiscount,isPerpetual,isUserNumberMismatch){var _this15=this;Object(__WEBPACK_IMPORTED_MODULE_47_lib_Segment_customTrackers__["l" /* trackClickSubscriptionUpgrade */])(plan,period,isPerpetual,Object(__WEBPACK_IMPORTED_MODULE_48_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));var _PACKAGES_CONFIG$plan4=__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][plan],isEmptySeatsAllowed=_PACKAGES_CONFIG$plan4.isEmptySeatsAllowed,freeSeatsIncluded=_PACKAGES_CONFIG$plan4.freeSeatsIncluded;// If users enters quantity = 1 or 2 when buying team/+, continue with order but send all free seats to MW
var checkoutQuantity=this.getQuantityIntegerValue(isPerpetual?__WEBPACK_IMPORTED_MODULE_38__config__["_19" /* QUANTITY_TYPE */].LICENSES:__WEBPACK_IMPORTED_MODULE_38__config__["_19" /* QUANTITY_TYPE */].SEATS);if(!isUpgrade&&isEmptySeatsAllowed&&freeSeatsIncluded&&checkoutQuantity<freeSeatsIncluded){checkoutQuantity=freeSeatsIncluded;}var triggerChargebeeProceed=function triggerChargebeeProceed(){_this15.proceedChargeBeeSubscription(plan,period,_this15.currency.key,isUpgrade,useDiscount?_this15.getCouponSetId(period,plan):null,useDiscount?_this15.props.discount.couponId:null,checkoutQuantity);};if(isUserNumberMismatch){triggerChargebeeProceed();}else{this.setState({willProceedToCheckout:true},function(){triggerChargebeeProceed();});}}},{key:"renderProductCategory",value:function renderProductCategory(plan){var classes=this.props.classes;var tag;if(__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][plan].isPerpetual){tag=localize('subscription-tag-desktop-only');}else if(__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][plan].isCloudTag&&__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][plan].isDesktopTag){tag=localize('subscription-tag-cloud-and-desktop');}else if(__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][plan].isDesktopTag){tag=localize('subscription-tag-desktop-only');}else if(__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][plan].isCloudTag){tag=localize('subscription-tag-cloud-only');}return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.planCategoryTag)},tag);}},{key:"renderUpgradeButton",value:function renderUpgradeButton(displayTitle,plan,useDiscount,period,checkoutPricePerMonth,annualPriceTotal,errorLoadingSubscriptionEstimationData,planIsTaxed){var _classNames20,_this16=this;if(this.props.company.hasUnlimitedTeamSubscription)return;var classes=this.props.classes;var _PACKAGES_CONFIG$plan5=__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][plan],className=_PACKAGES_CONFIG$plan5.className,isPerpetual=_PACKAGES_CONFIG$plan5.isPerpetual,freeSeatsIncluded=_PACKAGES_CONFIG$plan5.freeSeatsIncluded;var buttonClassName=__WEBPACK_IMPORTED_MODULE_36_classnames___default()((_classNames20={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames20,classes.button,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames20,classes.purchaseButton,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames20,classes[className],true),_classNames20));var isUpgrade=this.hasPlan;var quantity=this.getQuantityInputValue(isPerpetual?__WEBPACK_IMPORTED_MODULE_38__config__["_19" /* QUANTITY_TYPE */].LICENSES:__WEBPACK_IMPORTED_MODULE_38__config__["_19" /* QUANTITY_TYPE */].SEATS);var label;if(isPerpetual){label=localize('subscription-box-buy');}else if(!this.hasPlan){label=localize('subscription-box-subscribe');}else if(this.hasPlan){if(plan===this.activePlan&&this.isMonthlyPlan&&period==__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL){label=localize('subscription-box-view-change-to-yearly-subscription');}else{label=this.category===__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CREATIVE_TOOLS?localize('subscription-box-change-to-this-plan'):localize('subscription-box-upgrade');}}return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.purchaseButtonContainer},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["a" /* Button */],{variant:"contained","data-tid":"button-subscription-update-".concat(plan),key:"main",disabled:!Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["v" /* isValidNonZeroQuantity */])(quantity),className:buttonClassName,onClick:function onClick(){return _this16.handleBuyRequest(plan,period,isUpgrade,isPerpetual,displayTitle,useDiscount,quantity,freeSeatsIncluded,checkoutPricePerMonth,annualPriceTotal,errorLoadingSubscriptionEstimationData,planIsTaxed);}},label));}},{key:"handleBuyRequest",value:function handleBuyRequest(plan,period,isUpgrade,isPerpetual,displayTitle,useDiscount,quantity,freeSeatsIncluded,checkoutPricePerMonth,annualPriceTotal,errorLoadingSubscriptionEstimationData,planIsTaxed){var _this17=this;if(isPerpetual){this.showConfirmChoiceModal(function(){return _this17.doCheckout(plan,period,false/*isUpgrade*/,useDiscount,isPerpetual,false/*isUserNumberMismatch*/);},displayTitle,plan,quantity,this.currency,this.period,checkoutPricePerMonth,annualPriceTotal,errorLoadingSubscriptionEstimationData,null/* planIsTaxed */);}else if(!this.hasPlan){var nonGuestUsers=Object(__WEBPACK_IMPORTED_MODULE_17_utils_users__["e" /* filterNonGuestUsers */])(this.props.company.users);if(quantity<nonGuestUsers.length&&nonGuestUsers.length>freeSeatsIncluded){this.props.showModal('CONFIRMATION_MODAL',{title:localize('subscription-confirm-number-of-users-title'),message:{__html:localize('subscription-confirm-number-of-users-description',[nonGuestUsers.length,quantity])},buttons:[__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["a" /* Button */],{"data-tid":"confirm-number-of-users-cancel",key:"confirm-number-of-users-cancel",variant:"outlined",color:"primary"},localize('go-back')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["a" /* Button */],{"data-tid":"confirm-number-of-users-reduce",key:"confirm-number-of-users-reduce",variant:"contained",color:"primary",onClick:function onClick(){_this17.props.hideModal();_this17.showReduceUsersModal(function(){return _this17.showConfirmChoiceModal(function(){return _this17.doCheckout(plan,period,isUpgrade,useDiscount,isPerpetual,false/*isUserNumberMismatch*/);},displayTitle,plan,quantity,_this17.currency,_this17.period,checkoutPricePerMonth,annualPriceTotal,errorLoadingSubscriptionEstimationData,planIsTaxed);},freeSeatsIncluded,null// quantityFromQueryParam
);}},localize('reduce-users'))]});}else{this.showConfirmChoiceModal(function(){return _this17.doCheckout(plan,period,isUpgrade,useDiscount,isPerpetual,false/*isUserNumberMismatch*/);},displayTitle,plan,quantity,this.currency,this.period,checkoutPricePerMonth,annualPriceTotal,errorLoadingSubscriptionEstimationData,planIsTaxed);}}else{this.doCheckout(plan,period,isUpgrade,useDiscount,isPerpetual,false/*isUserNumberMismatch*/);}}},{key:"renderContactSalesButton",value:function renderContactSalesButton(plan){var _classNames21,_this18=this;var classes=this.props.classes;var buttonClassName=__WEBPACK_IMPORTED_MODULE_36_classnames___default()((_classNames21={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames21,classes.button,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames21,classes.purchaseButton,true),_classNames21));return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.purchaseButtonContainer},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["a" /* Button */],{variant:"contained","data-tid":"button-subscription-update-".concat(plan),key:"main",className:buttonClassName,onClick:function onClick(){return _this18.props.showModal('CONTACT_SALES_MODAL',{title:localize('contact-sales-form-title')});}},localize('subscription-contact-sales')));}},{key:"renderSeeAllProductsLink",value:function renderSeeAllProductsLink(){var _this19=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["r" /* Link */],{component:"button",variant:"body2","data-tid":"see-al-products-button",underline:"none",className:classes.seeAllProductsLink,onClick:function onClick(){return _this19.toggleSeeAllProducts();}},localize('subscription-list-see-all-products'));}},{key:"renderSubscriptionViewSelector",value:function renderSubscriptionViewSelector(){var _this20=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{container:true,item:true,className:classes.subscriptionViewSelector},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,className:classes.subscriptionViewSelectorColumn},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["r" /* Link */],{underline:"none","data-tid":"subscription-view-current-products-link",className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.subscriptionViewSelectorLink,this.isCurrentProductsView&&classes.subscriptionViewSelectorLinkActive),onClick:function onClick(){return _this20.handleSubscriptionViewChange(__WEBPACK_IMPORTED_MODULE_38__config__["_45" /* SUBSCRIPTION_VIEW */].CURRENT_PRODUCTS);}},__WEBPACK_IMPORTED_MODULE_38__config__["_45" /* SUBSCRIPTION_VIEW */].CURRENT_PRODUCTS)),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,className:classes.subscriptionViewSelectorColumn},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["r" /* Link */],{underline:"none","data-tid":"subscription-view-purchase-options-link",className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.subscriptionViewSelectorLink,this.isPurchaseOptionsView&&classes.subscriptionViewSelectorLinkActive),onClick:function onClick(){return _this20.handleSubscriptionViewChange(__WEBPACK_IMPORTED_MODULE_38__config__["_45" /* SUBSCRIPTION_VIEW */].PURCHASE_OPTIONS);}},__WEBPACK_IMPORTED_MODULE_38__config__["_45" /* SUBSCRIPTION_VIEW */].PURCHASE_OPTIONS)));}},{key:"renderCategorySelector",value:function renderCategorySelector(){var _this21=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{container:true,item:true,className:classes.categorySelector},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,className:classes.categorySelectorColumn},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["a" /* Button */],{variant:this.isCloudSuiteCategory?'contained':'outlined',disableRipple:true,fullWidth:true,"data-tid":"plan-category-button-cloud-suite",className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.categorySelectorButton,this.isCloudSuiteCategory&&classes.categorySelectorButtonActive),onClick:function onClick(){return _this21.handlePlanCategoryChange(__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CLOUD_SUITE);}},localize('subscription-category-cloud'))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,className:classes.categorySelectorColumn},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["a" /* Button */],{variant:this.isCreativeToolsCategory?'contained':'outlined',disableRipple:true,fullWidth:true,"data-tid":"plan-category-button-creative-tools",className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.categorySelectorButton,this.isCreativeToolsCategory&&classes.categorySelectorButtonActive),onClick:function onClick(){return _this21.handlePlanCategoryChange(__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CREATIVE_TOOLS);}},localize('subscription-category-desktop'))));}},{key:"renderPeriodSelector",value:function renderPeriodSelector(){var _this22=this;var classes=this.props.classes;var period=this.state.period;var selectedValue=period||__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.periodSelector},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["B" /* RadioGroup */],{name:"period","data-tid":"period-selector",value:selectedValue,row:true,onChange:function onChange(event){return _this22.handlePeriodChange(event);}},this.allPeriods.includes(__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL)&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["k" /* FormControlLabel */],{value:__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL,className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.noMargins,selectedValue===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL?classes.periodSelectorLabelChecked:classes.periodSelectorLabel,classes.periodSelectorLabelHover),control:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["A" /* Radio */],{color:"primary",className:classes.radioButton,disableRipple:true}),label:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,localize('subscription-period-selector-annual'),"\xA0",!(this.isScalePlan&&this.isAnnualPlan)&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span",{className:classes.periodSelectorDiscount},localize('subscription-period-selector-annual-discount')))}),this.allPeriods.includes(__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY)&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["k" /* FormControlLabel */],{value:__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY,className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.noMargins,selectedValue===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY?classes.periodSelectorLabelChecked:classes.periodSelectorLabel,classes.periodSelectorLabelHover),control:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["A" /* Radio */],{color:"primary",className:classes.radioButton,disableRipple:true}),label:localize('subscription-period-selector-monthly')}),this.allPeriods.includes(__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL)&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["k" /* FormControlLabel */],{value:__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL,className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.noMargins,selectedValue===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL?classes.periodSelectorLabelChecked:classes.periodSelectorLabel,classes.periodSelectorLabelHover),control:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["A" /* Radio */],{color:"primary",className:classes.radioButton,disableRipple:true}),label:localize('subscription-period-selector-perpetual')})));}},{key:"renderCurrencySelector",value:function renderCurrencySelector(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["y" /* Paper */],{className:classes.currencySelector,component:"section"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["C" /* Select */],{name:"currency","data-tid":"currency-selector",className:classes.currencySelectorSelect,onChange:this.handleCurrencyChange,value:this.currency.key,displayEmpty:true,fullWidth:true,disableUnderline:true,IconComponent:__WEBPACK_IMPORTED_MODULE_35__material_ui_icons_KeyboardArrowDown___default.a,MenuProps:{classes:{paper:classes.currencySelectorSelectItems}}},Object.keys(__WEBPACK_IMPORTED_MODULE_38__config__["x" /* CURRENCIES */]).map(function(key){var option=__WEBPACK_IMPORTED_MODULE_38__config__["x" /* CURRENCIES */][key];return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["x" /* MenuItem */],{key:option.key,value:option.key},option.value);})));}},{key:"renderInfoTooltip",value:function renderInfoTooltip(key,isQuantityFieldRelated,plan){var _classNames22;var classes=this.props.classes;var message;if(key){if(key==='desktop-plus-extended'){var plansToRender=this.getPlansToRender(true,true,false);var isAnyCreativeToolsPlan=plansToRender.some(function(planId){return __WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][planId].isCreativeToolsPlan;});if(isAnyCreativeToolsPlan){message=localize("license-info-".concat(key));}}else{message=localize("license-info-".concat(key));}}else if(plan===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].PHOTO||plan===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].WEB||plan===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].DESIGNER){message=localize('license-info-desktop-plus');}else if(plan===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].TEAM_PLUS){message=localize('license-info-scale');}if(!message)return;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["L" /* Tooltip */],{placement:"top",title:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.infoTooltipText)},message),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span",{className:classes.arrow})),classes:{tooltip:classes.infoTooltip}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["p" /* IconButton */],{className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()((_classNames22={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames22,classes.infoIcon,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames22,classes.infoIconQuantityField,isQuantityFieldRelated),_classNames22)),color:"primary",component:"span",disableRipple:true},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__theme_icons__["N" /* Info */],null)));}},{key:"renderSubscriptionActionButtons",value:function renderSubscriptionActionButtons(plan,period){var _this23=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["t" /* ListItem */],{className:classes.columnActiveProductActionsListItem},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["r" /* Link */],{component:"button",variant:"body2","data-tid":"view-details-and-manage-button",className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.activeProductActionLink,classes.viewDetailsAndManage),onClick:function onClick(){return _this23.showSubscriptionDetails();}},localize('subscription-action-view-details-and-manage'))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["t" /* ListItem */],{className:classes.columnActiveProductActionsListItem},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["r" /* Link */],{component:"button",variant:"body2","data-tid":"update-credit-card-button",className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.activeProductActionLink,classes.viewDetailsAndManage),onClick:function onClick(){return _this23.showSubscriptionDetails();}},localize('subscription-action-update-credit-card'))),__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][plan].isMultiUser&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["t" /* ListItem */],{className:classes.columnActiveProductActionsListItem},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["r" /* Link */],{component:"button",variant:"body2","data-tid":"buy-more-seats-button",className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.activeProductActionLink,classes.buyMoreSeatsLink,this.props.companies.pendingPayingUserQuantity&&classes.buyMoreSeatsLinkDisabled),onClick:function onClick(){return!_this23.props.companies.pendingPayingUserQuantity&&_this23.handleBuyMoreSeats(plan,period);}},localize('subscription-action-add-more-seats'))));}},{key:"renderSubscriptionUpgradeButton",value:function renderSubscriptionUpgradeButton(){var _this24=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["t" /* ListItem */],{className:classes.columnActiveProductActionsListItem},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["r" /* Link */],{component:"button",variant:"body2","data-tid":"upgrade-plan-button",className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.activeProductActionLink,classes.upgradeLink),onClick:function onClick(){return _this24.handleUpgradePlan();}},localize(this.hasPlan?'subscription-action-upgrade':'subscription-action-upgrade-now')));}},{key:"renderContactUsButton",value:function renderContactUsButton(){var _this25=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["t" /* ListItem */],{className:classes.columnActiveProductActionsListItem},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["r" /* Link */],{component:"button",variant:"body2","data-tid":"contact-us-button",className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.activeProductActionLink,classes.contactUsLink),onClick:function onClick(){return _this25.contactUsHandler();}},localize('subscription-contact-us')));}},{key:"getTotalNumberOfSeats",value:function getTotalNumberOfSeats(){var result=this.props.companies.pendingPayingUserQuantity?this.props.companies.pendingPayingUserQuantity:this.hasPlan?Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["e" /* getMembersPaidQuantity */])(this.props.company)+__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][this.activePlan].freeSeatsIncluded:0;return result;}},{key:"renderCurrentPlans",value:function renderCurrentPlans(){var _this26=this,_classNames23;var classes=this.props.classes;var _this$state6=this.state,activeSubscription=_this$state6.activeSubscription,hasTrial=_this$state6.hasTrial;var _getSubscriptionsAndA8=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["i" /* getSubscriptionsAndAddons */])(this.props.company),perpetualAddons=_getSubscriptionsAndA8.perpetualAddons,subscription=_getSubscriptionsAndA8.subscription;var cancelledSubscription;var cancelledPlanId;if(!this.hasPlan&&!this.props.company.hasUnlimitedTeamSubscription){var _getSubscriptionsAndA9=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["i" /* getSubscriptionsAndAddons */])(this.props.company,true);cancelledSubscription=_getSubscriptionsAndA9.subscription;if(!__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.isEmpty(cancelledSubscription)){var _convertPlanIdIntoSub9=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(cancelledSubscription.planId);cancelledPlanId=_convertPlanIdIntoSub9.plan;if(!Object.values(__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */]).includes(cancelledPlanId)){// Cancelled subscriptions are not migrated, we upgrade them to Scale
cancelledPlanId=__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].SCALE;}}}var totalNumberOfSeats=this.getTotalNumberOfSeats();var ownedPerpetualAddons=[];if(!__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.isEmpty(perpetualAddons)&&!this.props.company.hasUnlimitedTeamSubscription){perpetualAddons.sort(function(a,b){var productKeyA=a.id.split('_')[0];var productKeyB=b.id.split('_')[0];var productVersionA=parseInt(a.id.split('_')[1]);var productVersionB=parseInt(b.id.split('_')[1]);return productVersionB-productVersionA||productKeyB.localeCompare(productKeyA);});perpetualAddons.forEach(function(addon,index){var productKey=addon.id.split('_')[0];var productVersion=parseInt(addon.id.split('_')[1]);var plan=productKey.toLowerCase();var _PACKAGES_CONFIG$plan6=__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][plan],Icon=_PACKAGES_CONFIG$plan6.icon,title=_PACKAGES_CONFIG$plan6.title;var displayTitle=_this26.addVersionToTitle(plan,title,productVersion);var renderLicenseUsageStats=function renderLicenseUsageStats(){if(addon.paidQuantity>1){return localize('subscription-used-licenses',[addon.usedQuantity,addon.paidQuantity]);}else if(addon.paidQuantity===1){return localize(addon.usedQuantity===1?'subscription-used-licenses-single-user':'subscription-used-licenses-single-user-not-used');}};ownedPerpetualAddons.push(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,key:"active-product-addon-".concat(index+1),className:classes.product},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["y" /* Paper */],{className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.productContent,classes.ownedProductContent),component:"section"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{container:true,direction:"row",className:classes.productColumns},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,container:true,className:classes.columnActiveProductName},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,container:true,direction:"row"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,className:classes.columnProductIcon},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Icon,null)),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,container:true,direction:"column",className:classes.columnProductTitle},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{variant:"h1",className:classes.productTitle,dangerouslySetInnerHTML:{__html:displayTitle}})))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,className:classes.columnActiveProductDetails},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.columnActiveProductDetailsTitle,classes.columnTextLarger)},localize('subscription-duration-lifetime')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.columnActiveProductDetailsQuantity,classes.columnTextSmaller)},localize('subscription-total-licenses'),": ",addon.paidQuantity,_this26.renderInfoTooltip('perpetual',false)),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.columnActiveProductDetailsUsedInfo,classes.columnTextSmaller)},renderLicenseUsageStats())),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,className:classes.columnActiveProductActions},!_this26.props.company.hasUnlimitedTeamSubscription&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["r" /* Link */],{component:"button",variant:"body2","data-tid":"buy-more-licenses",className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.buyMoreLicenses,classes.activeProductActionLink),underline:"none",onClick:function onClick(){return _this26.handlePurchaseMoreLicenses(plan);}},localize('subscription-your-producs-buy-more-licenses')))))));});}var Icon,title,planTid;if(!__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.isEmpty(this.pendingSubscription)){var _convertPlanIdIntoSub10=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(this.pendingSubscription),savedCheckoutPlan=_convertPlanIdIntoSub10.plan;var _PACKAGES_CONFIG$save=__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][savedCheckoutPlan];Icon=_PACKAGES_CONFIG$save.icon;title=_PACKAGES_CONFIG$save.title;planTid='current-plan';}else if(this.hasPlan){if(this.props.company.hasUnlimitedTeamSubscription){var _PACKAGES_CONFIG$SUBS=__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].ENTERPRISE];Icon=_PACKAGES_CONFIG$SUBS.icon;title=_PACKAGES_CONFIG$SUBS.title;}else{var _PACKAGES_CONFIG$acti3=__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][activeSubscription.plan];Icon=_PACKAGES_CONFIG$acti3.icon;title=_PACKAGES_CONFIG$acti3.title;}planTid='current-plan';}else{Icon=__WEBPACK_IMPORTED_MODULE_28__theme_icons__["F" /* IconNoPackage */];title=localize(hasTrial?'subscription-trial':'subscription-free');planTid=hasTrial?'subscription-trial':'subscription-free';}if([__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES,__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT].includes(activeSubscription.plan)){Icon=__WEBPACK_IMPORTED_MODULE_28__theme_icons__["F" /* IconNoPackage */];}var billingNextDate=this.getNextBillingDate();var cancellationDate=this.getCancellationDate();var renewalEstimation=0;var renewalEstimationIsTaxed=false;if(this.hasPlan){var upcomingInvoiceEstimation=this.props.companies.upcomingInvoiceEstimation;if(upcomingInvoiceEstimation){renewalEstimation=(upcomingInvoiceEstimation.totalAmountWithTaxWithDiscountWithoutCreditsApplied/100).toFixed(2);renewalEstimationIsTaxed=upcomingInvoiceEstimation.totalTaxRate!=null;}}var renderNextBillingAmount=function renderNextBillingAmount(){var result='';if(_this26.props.companies.pendingPayingUserQuantity||_this26.props.companies.upcomingInvoiceEstimationXhrInProgress){result=localize('subscription-calculating-renewal');}else{result="".concat(_this26.currency.symbol).concat(renewalEstimation);if(renewalEstimationIsTaxed){result+=" (".concat(localize('subscription-including-vat'),")");}}return result;};var renderActiveProductDetails=function renderActiveProductDetails(){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,subscription.nextBillingAt&&!subscription.cancellationPending&&!_this26.props.company.hasUnlimitedTeamSubscription&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.columnActiveProductDetailsCurrentBillingPeriod,classes.columnTextLarger)},localize(activeSubscription.period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL?'subscription-current-billing-period-yearly':'subscription-current-billing-period-monthly'),": ",renderNextBillingAmount()),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.columnActiveProductDetailsSeatsStats,classes.columnTextSmaller)},__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][activeSubscription.plan].freeSeatsIncluded===1&&!__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][activeSubscription.plan].isEmptySeatsAllowed?localize('subscription-single-user'):_this26.props.company.hasUnlimitedTeamSubscription?"".concat(localize('subscription-total-users'),": ").concat(totalNumberOfSeats):localize('subscription-user-licenses-stats',[totalNumberOfSeats,Object(__WEBPACK_IMPORTED_MODULE_17_utils_users__["e" /* filterNonGuestUsers */])(_this26.props.company.users).length]),_this26.renderInfoTooltip(null,false,activeSubscription.plan)),cancellationDate&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.columnActiveProductDetailsCancellationDate,classes.columnTextSmaller)},localize(_this26.isRealEstateIndustry()?'re-subscription-cancellation-date':'subscription-cancellation-date',cancellationDate)),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.columnActiveProductDetailsRevokeCancellationInfo,classes.columnTextSmaller)},localize('subscription-revoke-cancellation-info'))),billingNextDate&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.columnActiveProductDetailsSubscriptionRenewalDate,classes.columnTextSmaller)},localize('subscription-renewal-date'),": ",billingNextDate));};var getAccesToProductsDetails=function getAccesToProductsDetails(isTrialActive){var isPerpetualMode=_this26.props.app.isPerpetualApp||_this26.isPerpetualOverviewMode;var key=isPerpetualMode?isTrialActive?'subscription-no-access-to-desktop-apps-perpetual':'subscription-continue-to-use-desktop-apps-perpetual':isTrialActive?'subscription-no-access-to-desktop-apps-plus':'subscription-continue-to-use-desktop-apps-plus';return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["s" /* List */],{className:classes.expiredProductsLists},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["t" /* ListItem */],null,!isPerpetualMode&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{className:classes.columnTextSmaller},localize(isTrialActive?'subscription-xara-cloud':'subscription-xara-cloud-free-plan'))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["t" /* ListItem */],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{className:classes.columnTextSmaller},localize(key))));};var renderActiveTrialDetails=function renderActiveTrialDetails(){var trialExpireDate=new Date(_this26.props.company.trial.endDate).toLocaleDateString(__WEBPACK_IMPORTED_MODULE_49_i18n_i18n__["a" /* default */].getCurrentLanguage(true),localeDateStringOptions);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.columnActiveProductDetailsTitle,classes.columnTextLarger)},localize('subscription-trial-expires-on'),": ",trialExpireDate),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.infoAccessToProducts,classes.columnTextSmaller)},localize('subscription-trial-you-have-full-access-to'),":"),getAccesToProductsDetails(true));};var renderPendingSubscription=function renderPendingSubscription(){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.infoPendingSubscription,classes.columnTextSmaller)},localize('subscription-pending-subscription'));};var renderExpiredTrialDetails=function renderExpiredTrialDetails(){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.infoAccessToProducts,classes.columnTextSmaller)},localize('subscription-free-you-can-continue-to-use'),":"),getAccesToProductsDetails(false));};return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{container:true,item:true},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{container:true,className:classes.productsList},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,key:'active-product-subscription',className:classes.product},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["y" /* Paper */],{className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()((_classNames23={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames23,classes.productContent,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames23,classes.ownedProductContent,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames23,'hasReactivateLink',!__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.isEmpty(cancelledSubscription)),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames23,'isMonthly',this.hasPlan&&activeSubscription.period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames23,'hasCancellationDate',Boolean(cancellationDate)),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames23,'hasAddons',!__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.isEmpty(ownedPerpetualAddons)),_classNames23)),component:"section"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({container:true,direction:"row",className:classes.productColumns},planTid?{'data-tid':planTid}:{}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,container:true,className:classes.columnActiveProductName},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,container:true,direction:"row"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,className:classes.columnProductIcon},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(Icon,null)),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,container:true,direction:"column",className:classes.columnProductTitle},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{variant:"h1",className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.productTitle,this.props.company.hasUnlimitedTeamSubscription?classes.productTitleUnlimited:null),dangerouslySetInnerHTML:{__html:title}})))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,className:classes.columnActiveProductDetails},this.pendingSubscription?renderPendingSubscription():this.hasPlan?renderActiveProductDetails():hasTrial?renderActiveTrialDetails():renderExpiredTrialDetails()),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{item:true,className:classes.columnActiveProductActions},!this.pendingSubscription&&(this.hasNonUnlimitedSubscription||this.canSubscriptionBeUpgraded)&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["s" /* List */],{className:classes.columnActiveProductActionsList},this.hasNonUnlimitedSubscription&&this.renderSubscriptionActionButtons(activeSubscription.plan,activeSubscription.period),this.canSubscriptionBeUpgraded&&this.renderSubscriptionUpgradeButton(),!this.hasPlan&&this.renderContactUsButton()))),!__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.isEmpty(cancelledSubscription)&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{container:true,direction:"row",className:classes.productCTASwitchOrReactivate},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["r" /* Link */],{component:"button",variant:"body2","data-tid":"reactivate-my-plan-link",className:classes.switchOrReactivateLink,underline:"always",onClick:function onClick(){return _this26.reactivateMySubscriptionHandler(cancelledSubscription);}},localize('subscription-reactivate-my-plan',[Object(__WEBPACK_IMPORTED_MODULE_18_utils_string__["b" /* stripHTML */])(__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][cancelledPlanId].title)]))),this.hasPlan&&activeSubscription.period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{container:true,direction:"row",className:classes.productCTASwitchOrReactivate},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["r" /* Link */],{component:"button",variant:"body2","data-tid":"switch-to-yearly-link",className:classes.switchOrReactivateLink,underline:"always",onClick:function onClick(){return _this26.switchToYearlyHandler();}},localize('subscription-switch-to-yearly-and-save'))))),ownedPerpetualAddons),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Grid___default.a,{container:true,className:classes.haveQuestionContainer},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Typography___default.a,{className:__WEBPACK_IMPORTED_MODULE_36_classnames___default()(classes.haveQuestionsMessage,classes.columnTextSmaller)},localize('subscription-got-questions-general'),"\xA0",__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["r" /* Link */],{component:"button",variant:"body2","data-tid":"have-questions-link",className:classes.haveQuestionsLink,underline:"always",onClick:function onClick(){return _this26.contactUsHandler();}},localize('subscription-contact-us')))));}//#endregion
//#region State change handlers
},{key:"handlePeriodChange",value:function handlePeriodChange(event){var period=event.target.value;this.props.setSubscriptionPeriod(period,false);Object(__WEBPACK_IMPORTED_MODULE_47_lib_Segment_customTrackers__["w" /* trackDurationChange */])(period,Object(__WEBPACK_IMPORTED_MODULE_48_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}},{key:"handlePlanCategoryChange",value:function handlePlanCategoryChange(category){// Switch period selector to Annual if a current plan is annual
this.props.setSubscriptionCategory(category,false);Object(__WEBPACK_IMPORTED_MODULE_47_lib_Segment_customTrackers__["k" /* trackCategoryChange */])(category,Object(__WEBPACK_IMPORTED_MODULE_48_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}},{key:"handleSubscriptionViewChange",value:function handleSubscriptionViewChange(view){this.props.setSubscriptionView(view,false);}},{key:"handleCurrencyChange",value:function handleCurrencyChange(event){this.props.setSubscriptionCurrency(__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_38__config__["x" /* CURRENCIES */],{key:event.target.value}).key,false);}//#endregion
//#region ChargeBee integration methods
/**
	 * Proceed ChargeBee Subscription - triggers on package upgrade
	 *
	 * @param {string} plan
	 * @param {string} period
	 * @param {string} currency
	 * @param {bool} upgrade
	 * @param {string} couponSetId
	 * @param {string} couponId
	 * @memberof Subscription
	 */},{key:"proceedChargeBeeSubscription",value:function proceedChargeBeeSubscription(plan,period,currency,upgrade,couponSetId,couponId,quantity){var _this27=this;// Covers two cases:
// 1. Clear credentials from previous abandoned initial purchase of annual plan where magix discout was applied
// Otherwise it could be false positive in SubscriptionSuccessful.js > componentDidMount when doing next 
// purchase of annual plan without magix discout
// Clears magix credentials when submitting promo/gift form
Object(__WEBPACK_IMPORTED_MODULE_43__utils_storage__["g" /* clearMagixDiscountCredentials */])();Object(__WEBPACK_IMPORTED_MODULE_43__utils_storage__["b" /* clearFirstOrder */])();// Put this code here because of race condition with paymentRedirectUrl redirect in app.js
if(this.props.discount.isDiscountApplied&&this.props.discount.discountType===__WEBPACK_IMPORTED_MODULE_38__config__["F" /* DISCOUNT_TYPE */].MAGIX&&(this.props.discount.appliedProdTypeOfLastValidCombination===__WEBPACK_IMPORTED_MODULE_38__config__["Y" /* MAXIC_DISCOUNT_PROD_TYPE */].SUBSCRIPTION&&period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL||this.props.discount.appliedProdTypeOfLastValidCombination===__WEBPACK_IMPORTED_MODULE_38__config__["Y" /* MAXIC_DISCOUNT_PROD_TYPE */].PERPETUAL&&period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL)){Object(__WEBPACK_IMPORTED_MODULE_43__utils_storage__["C" /* saveMagixDiscountCredentials */])(this.props.discount.usedMagixEmail,this.props.discount.usedProductSerial);}var addOnName=__WEBPACK_IMPORTED_MODULE_38__config__["X" /* MAP_ADDON_TO_LATEST_VERSION */][plan];var chargebeeItemName=addOnName?"".concat(addOnName,"-").concat(__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL,"-").concat(currency):"".concat(plan===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].SCALE?__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].TEAM_PLUS:plan,"-").concat(period,"-").concat(currency);Object(__WEBPACK_IMPORTED_MODULE_43__utils_storage__["v" /* saveCheckoutPlan */])("".concat(plan===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].SCALE?__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].TEAM_PLUS:plan,"-").concat(period,"-").concat(currency));Object(__WEBPACK_IMPORTED_MODULE_43__utils_storage__["w" /* saveCheckoutSeatsQuantity */])(quantity);var nrOfProductUserOwns=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["j" /* getTotalProductsForCompany */])(this.props.company);nrOfProductUserOwns===0&&Object(__WEBPACK_IMPORTED_MODULE_43__utils_storage__["E" /* setIsFirstOrder */])(true);var isoCodeLang=__WEBPACK_IMPORTED_MODULE_49_i18n_i18n__["a" /* default */].getCurrentLanguage(true);var cartLang=null;var storageCheckoutLang=null;if(isoCodeLang==='de-DE'){cartLang=isoCodeLang;storageCheckoutLang='de';}Object(__WEBPACK_IMPORTED_MODULE_43__utils_storage__["u" /* saveCheckoutLang */])(storageCheckoutLang);this.props.createChargeBeeSubscription(this.hasPlan,chargebeeItemName,upgrade,undefined,couponSetId,couponId,Boolean(addOnName),quantity,cartLang).then(function(data){if(data instanceof __WEBPACK_IMPORTED_MODULE_55__errors_apperror__["a" /* default */]){Object(__WEBPACK_IMPORTED_MODULE_43__utils_storage__["g" /* clearMagixDiscountCredentials */])();log.send(data);if(data.errorId===__WEBPACK_IMPORTED_MODULE_57_errors_errorids__["a" /* default */].API_REQUEST_LIMIT_EXCEEDED){_this27.props.showRateLimitError();}else if(_this27.props.isCBPlanExternalRedirect&&_this27.state.shouldStartUpdate){// Error returned from estimation endpoint when 
// http://localhost:3000/#COMPANY/?chargebee-plan-id=teamplus-annual-usd&cid=DOESNOTEXIST url is used
// but it could happens also in some other cases when CB returns 13001
if(__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(data,'errorId')===__WEBPACK_IMPORTED_MODULE_57_errors_errorids__["a" /* default */].THE_NUMBER_OF_THE_USERS_CANNOT_BE_LESS_THAN_THE_NUMBER_OF_USERS_OF_COMPANY&&!_this27.hasPlan){var _PACKAGES_CONFIG$plan7=__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][plan],title=_PACKAGES_CONFIG$plan7.title,freeSeatsIncluded=_PACKAGES_CONFIG$plan7.freeSeatsIncluded;_this27.props.couponId&&_this27.props.applyDiscountUsingCouponId(_this27.props.couponId,__WEBPACK_IMPORTED_MODULE_38__config__["v" /* COUPON_TYPE */].SEATS,true);/*
							use freeSeatsIncluded for quantity for direct link
							to avoid THE_NUMBER_OF_THE_USERS_CANNOT_BE_LESS_THAN_THE_NUMBER_OF_USERS_OF_COMPANY error
							or quantity from url params 
							*/var useQuantity=Math.max(freeSeatsIncluded,_this27.props.productQuantity||1);var nonGuestUsers=Object(__WEBPACK_IMPORTED_MODULE_17_utils_users__["e" /* filterNonGuestUsers */])(_this27.props.company.users);_this27.props.showModal('CONFIRMATION_MODAL',{title:localize('subscription-confirm-number-of-users-title'),message:{__html:localize('subscription-confirm-number-of-users-description',[nonGuestUsers.length,useQuantity])},buttons:[__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["a" /* Button */],{"data-tid":"confirm-number-of-users-cancel",key:"confirm-number-of-users-cancel",variant:"outlined",color:"primary"},localize('go-back')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core__["a" /* Button */],{"data-tid":"confirm-number-of-users-reduce",key:"confirm-number-of-users-reduce",variant:"contained",color:"primary",onClick:function onClick(){return _this27.handleShowModalInReduceUsersApiErrorWorkflow({plan:plan,period:period,quantity:quantity,upgrade:upgrade,title:title,useQuantity:useQuantity,freeSeatsIncluded:freeSeatsIncluded});}},localize('reduce-users'))],showCouponErrorMessageIfExists:true});}else{_this27.props.showErrorPopup(data.errorId||__WEBPACK_IMPORTED_MODULE_57_errors_errorids__["a" /* default */].UNKNOWN);}}_this27.props.hidePreloader();return;}if(data.result&&data.result.hostedPage){_this27.openChargeBeeCheckout(data.result.hostedPage);}});}},{key:"handleShowModalInReduceUsersApiErrorWorkflow",value:function handleShowModalInReduceUsersApiErrorWorkflow(props){this.props.setReduceUsersApiErrorState(props);}},{key:"showModalInReduceUsersApiWorkflow",value:function showModalInReduceUsersApiWorkflow(){var _this28=this;var _this$props$app$reduc=this.props.app.reduceUsersApiState,plan=_this$props$app$reduc.plan,period=_this$props$app$reduc.period,quantity=_this$props$app$reduc.quantity,upgrade=_this$props$app$reduc.upgrade,title=_this$props$app$reduc.title,useQuantity=_this$props$app$reduc.useQuantity,freeSeatsIncluded=_this$props$app$reduc.freeSeatsIncluded;this.props.hideModal();this.showReduceUsersModal(function(){// fetch price after user submits Reduce user modal as by this time fetch()
// from estimation endpoint should complete
var _this28$calculateChec=_this28.calculateCheckoutData(plan===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].SCALE?__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].TEAM_PLUS:plan,period,false/*isPerpetual*/,quantity),checkoutPricePerMonth=_this28$calculateChec.checkoutPricePerMonth,annualPriceTotal=_this28$calculateChec.annualPriceTotal,showDiscountForPlan=_this28$calculateChec.showDiscountForPlan,errorLoadingSubscriptionEstimationData=_this28$calculateChec.errorLoadingSubscriptionEstimationData,planIsTaxed=_this28$calculateChec.planIsTaxed;_this28.showConfirmChoiceModal(function(){return _this28.doCheckout(plan,period,upgrade,showDiscountForPlan,false,// isPerpetual
// eslint-disable-next-line max-len
true/*isUserNumberMismatch*/);},title,plan,useQuantity,_this28.currency,period,checkoutPricePerMonth,annualPriceTotal,errorLoadingSubscriptionEstimationData,planIsTaxed);},freeSeatsIncluded,useQuantity,true);}},{key:"getQuantityIntegerValue",value:function getQuantityIntegerValue(type){return Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["v" /* isValidNonZeroQuantity */])(type===__WEBPACK_IMPORTED_MODULE_38__config__["_19" /* QUANTITY_TYPE */].LICENSES?this.state.licensesQuantity:this.state.seatsQuantity)?parseInt(type===__WEBPACK_IMPORTED_MODULE_38__config__["_19" /* QUANTITY_TYPE */].LICENSES?this.state.licensesQuantity:this.state.seatsQuantity):0;}},{key:"getCouponSetId",value:function getCouponSetId(period,plan){var couponSetId;var _this$props$discount8=this.props.discount,discountType=_this$props$discount8.discountType,couponSetKey=_this$props$discount8.couponSetKey,isDiscountApplied=_this$props$discount8.isDiscountApplied,appliedProdTypeOfLastValidCombination=_this$props$discount8.appliedProdTypeOfLastValidCombination,appliedProdCatOfLastValidCombination=_this$props$discount8.appliedProdCatOfLastValidCombination;// We limit magix discount to annual plans on client side and UPGRADE_POPUP to XC/XC+ packages only excluding desktop+
if(isDiscountApplied&&(discountType===__WEBPACK_IMPORTED_MODULE_38__config__["F" /* DISCOUNT_TYPE */].MAGIX&&(appliedProdTypeOfLastValidCombination===__WEBPACK_IMPORTED_MODULE_38__config__["Y" /* MAXIC_DISCOUNT_PROD_TYPE */].SUBSCRIPTION&&period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL||appliedProdTypeOfLastValidCombination===__WEBPACK_IMPORTED_MODULE_38__config__["Y" /* MAXIC_DISCOUNT_PROD_TYPE */].PERPETUAL&&period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL)||discountType===__WEBPACK_IMPORTED_MODULE_38__config__["F" /* DISCOUNT_TYPE */].COUPON_SET_ID)){if(plan&&couponSetKey===__WEBPACK_IMPORTED_MODULE_38__config__["E" /* DISCOUNT_KEY */].UPGRADE_POPUP){// Plan is provided only when clicked on Subscribe button
if(__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][plan].isCloudSuitePlan){couponSetId=__WEBPACK_IMPORTED_MODULE_38__config__["D" /* DISCOUNTS_CONFIG */][couponSetKey].coupon_set_id;}}else if(discountType===__WEBPACK_IMPORTED_MODULE_38__config__["F" /* DISCOUNT_TYPE */].MAGIX&&plan&&__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][plan].isPerpetual){// maxic perpetual discount
var isFallbackProduct=__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(this.props.crs,'isFallbackProductReturnedLastValidCombination');if(__WEBPACK_IMPORTED_MODULE_38__config__["_7" /* PERPETAUL_PRODUCT_CATEGORY_TO_PACKAGE_MAP */][appliedProdCatOfLastValidCombination]===plan||isFallbackProduct){// If user is not owner of specific product (wd, dp or pgd) CRS endpoint returns fallback product,
// in this case give discount for all perpetual products but
// using discount specific for each of them (20%, 30%, 40%)
var couponTier=isFallbackProduct?__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.invert(__WEBPACK_IMPORTED_MODULE_38__config__["_7" /* PERPETAUL_PRODUCT_CATEGORY_TO_PACKAGE_MAP */])[plan]:appliedProdCatOfLastValidCombination;couponSetId=__WEBPACK_IMPORTED_MODULE_38__config__["D" /* DISCOUNTS_CONFIG */]["tier_".concat(couponTier)].coupon_set_id;}}else{couponSetId=__WEBPACK_IMPORTED_MODULE_38__config__["D" /* DISCOUNTS_CONFIG */][couponSetKey].coupon_set_id;}}return couponSetId;}},{key:"getMemberAddonDetailsFromPaymentAccount",value:function getMemberAddonDetailsFromPaymentAccount(plan,period,currency){var addonDetailsFromPaymentAccount=__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(this.props.companies,"currentMemberAddonDetails[".concat(Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["f" /* getNonObsoleteMemberAddonForPlan */])(plan),"-").concat(period,"-").concat(currency,"]"));if(!addonDetailsFromPaymentAccount)return;var amountWithoutTaxAndWithoutDiscount=addonDetailsFromPaymentAccount.amountWithoutTaxAndWithoutDiscount;var amountWithoutTaxAndWithDiscount=addonDetailsFromPaymentAccount.amountWithoutTaxAndWithDiscount;var discountAmountWithoutTax=addonDetailsFromPaymentAccount.discountAmountWithoutTax;var discountPercent;if(discountAmountWithoutTax&&amountWithoutTaxAndWithoutDiscount&&amountWithoutTaxAndWithDiscount){discountPercent=Math.ceil((1-amountWithoutTaxAndWithDiscount/amountWithoutTaxAndWithoutDiscount)*100);}return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({},addonDetailsFromPaymentAccount,{discountPercent:discountPercent,hasDiscount:Boolean(discountAmountWithoutTax)});}},{key:"fetchSubscriptionEstimate",value:function fetchSubscriptionEstimate(skipDiscount,onlyActivePlan){var subscriptionEstimationUrl=this.getSubscriptionEstimationUrl(skipDiscount,onlyActivePlan);var planForSubscriptionEstimation=this.getPlanForSubscriptionEstimation();var _this$getCouponDataFo=this.getCouponDataForSubscriptionEstimate(),couponSetId=_this$getCouponDataFo.couponSetId,couponId=_this$getCouponDataFo.couponId,discountType=_this$getCouponDataFo.discountType,couponSetKey=_this$getCouponDataFo.couponSetKey;var fn=onlyActivePlan?this.props.getSubscriptionEstimation:this.getSubscriptionEstimationDebounced;subscriptionEstimationUrl&&fn(subscriptionEstimationUrl,planForSubscriptionEstimation,discountType,couponSetKey,onlyActivePlan?null:!couponSetId&&couponId,onlyActivePlan?null:couponSetId,this.isPerpetualOverviewMode||this.isPerpetualPeriodSelected?__WEBPACK_IMPORTED_MODULE_38__config__["v" /* COUPON_TYPE */].LICENSES:__WEBPACK_IMPORTED_MODULE_38__config__["v" /* COUPON_TYPE */].SEATS,onlyActivePlan);}},{key:"getPlanForSubscriptionEstimation",value:function getPlanForSubscriptionEstimation(){if(this.props.currentPlanId){var _convertPlanIdIntoSub11=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(this.props.currentPlanId),plan=_convertPlanIdIntoSub11.plan,period=_convertPlanIdIntoSub11.period;return"".concat(plan,"-").concat(period,"-").concat(__WEBPACK_IMPORTED_MODULE_38__config__["l" /* CB_API_FETCH_CURRENCY */]);}else{return'all';}}},{key:"getSubscriptionEstimationUrl",value:function getSubscriptionEstimationUrl(skipDiscount,onlyActivePlan){var _this$props$discount9=this.props.discount,discountType=_this$props$discount9.discountType,isDiscountApplied=_this$props$discount9.isDiscountApplied,couponSetKey=_this$props$discount9.couponSetKey,couponAppliedWithoutValidation=_this$props$discount9.couponAppliedWithoutValidation,isResponsePendingFromEstimationEndpoint=_this$props$discount9.isResponsePendingFromEstimationEndpoint;var _this$getCouponDataFo2=this.getCouponDataForSubscriptionEstimate(),couponSetId=_this$getCouponDataFo2.couponSetId,couponId=_this$getCouponDataFo2.couponId;var quantityOfMembers;var paidQuantity=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["e" /* getMembersPaidQuantity */])(this.props.company);if(onlyActivePlan){quantityOfMembers=0;}else if(this.hasPlan&&paidQuantity>0){quantityOfMembers=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["e" /* getMembersPaidQuantity */])(this.props.company)+__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][this.activePlan].freeSeatsIncluded;}else if(this.hasPlan&&paidQuantity===0){quantityOfMembers=Object(__WEBPACK_IMPORTED_MODULE_17_utils_users__["e" /* filterNonGuestUsers */])(this.props.company.users).length>__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][this.activePlan].freeSeatsIncluded?Object(__WEBPACK_IMPORTED_MODULE_17_utils_users__["e" /* filterNonGuestUsers */])(this.props.company.users).length:0;}else{quantityOfMembers=this.state.seatsQuantity;}var skipActivePlan=!onlyActivePlan&&this.hasPlan&&(isDiscountApplied||couponAppliedWithoutValidation)&&(couponAppliedWithoutValidation&&isResponsePendingFromEstimationEndpoint||discountType===__WEBPACK_IMPORTED_MODULE_38__config__["F" /* DISCOUNT_TYPE */].COUPON_ID||discountType===__WEBPACK_IMPORTED_MODULE_38__config__["F" /* DISCOUNT_TYPE */].MAGIX||discountType===__WEBPACK_IMPORTED_MODULE_38__config__["F" /* DISCOUNT_TYPE */].COUPON_SET_ID&&couponSetKey===__WEBPACK_IMPORTED_MODULE_38__config__["E" /* DISCOUNT_KEY */].UPGRADE_POPUP);var fetchSubscriptionEstimatesForPlans=this.getPlanIdsForSubscriptionEstimate(this.props.currentPlanId,skipActivePlan,onlyActivePlan);if(__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.isEmpty(fetchSubscriptionEstimatesForPlans))return;var couponSetIdQuery='';var couponIdQuery='';if(!onlyActivePlan&&!skipDiscount){couponSetId&&(couponSetIdQuery="&couponSetId=".concat(encodeURIComponent(couponSetId)));!couponSetId&&couponId&&(couponIdQuery="&couponId=".concat(encodeURIComponent(couponId)));}var plansQueryString=fetchSubscriptionEstimatesForPlans.reduce(function(accumulator,currentValue){return"".concat(accumulator,"&planIds[]=").concat(currentValue);},'');var _getSubscriptionsAndA10=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["i" /* getSubscriptionsAndAddons */])(this.props.company,true),pastSubscription=_getSubscriptionsAndA10.subscription;var companyIdforEndpoint=!__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.isEmpty(pastSubscription)?"".concat(this.props.selectedCompanyId,"/"):'';// eslint-disable-next-line max-len 
return"/companies/subscription/".concat(companyIdforEndpoint,"createSubscriptionEstimation?quantityOfMembers=").concat(quantityOfMembers).concat(plansQueryString).concat(couponIdQuery).concat(couponSetIdQuery);}},{key:"getCouponDataForSubscriptionEstimate",value:function getCouponDataForSubscriptionEstimate(){var _this$props$discount10=this.props.discount,discountType=_this$props$discount10.discountType,couponSetKey=_this$props$discount10.couponSetKey,isDiscountApplied=_this$props$discount10.isDiscountApplied,couponAppliedWithoutValidation=_this$props$discount10.couponAppliedWithoutValidation,userSuppliedPromoCode=_this$props$discount10.userSuppliedPromoCode;var couponSetId=this.getCouponSetId(this.state.period);var couponId=null;if(isDiscountApplied&&discountType===__WEBPACK_IMPORTED_MODULE_38__config__["F" /* DISCOUNT_TYPE */].COUPON_ID){couponId=this.props.discount.couponId;}else if(couponAppliedWithoutValidation){couponId=userSuppliedPromoCode;}return{couponSetId:couponSetId,couponId:couponId,discountType:discountType,couponSetKey:couponSetKey};}},{key:"getPlanIdsForSubscriptionEstimate",value:function getPlanIdsForSubscriptionEstimate(selectedPlanId,skipActivePlan,onlyActivePlan){var result=[];if(selectedPlanId){var _convertPlanIdIntoSub12=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(selectedPlanId),plan=_convertPlanIdIntoSub12.plan,period=_convertPlanIdIntoSub12.period;if(onlyActivePlan){result.push("".concat(plan,"-").concat(period,"-").concat(__WEBPACK_IMPORTED_MODULE_38__config__["l" /* CB_API_FETCH_CURRENCY */]));}else{// Get price for current plan
// skip current plan if cap is not opened with CID query parameter as in this case it will be missing
// price of current active subscription
if(!skipActivePlan){result.push("".concat(plan,"-").concat(period,"-").concat(__WEBPACK_IMPORTED_MODULE_38__config__["l" /* CB_API_FETCH_CURRENCY */]));}// Upgrade monthly to annual; there is no upgrade to annual for RE plans
if(!__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][plan].isRealEstatePlan&&period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY){result.push("".concat(plan,"-").concat(__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL,"-").concat(__WEBPACK_IMPORTED_MODULE_38__config__["l" /* CB_API_FETCH_CURRENCY */]));}// Upgrade to other plans in selected period
__WEBPACK_IMPORTED_MODULE_38__config__["_43" /* SUBSCRIPTION_PLAN_UPGRADE_OPTIONS */][plan].forEach(function(upgradeOptionPlan){if(!__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][upgradeOptionPlan].isPerpetual&&!__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][upgradeOptionPlan].doesNotExistInCB){result.push("".concat(upgradeOptionPlan,"-").concat(period,"-").concat(__WEBPACK_IMPORTED_MODULE_38__config__["l" /* CB_API_FETCH_CURRENCY */]));if(!__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][upgradeOptionPlan].isRealEstatePlan&&period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY){result.push("".concat(upgradeOptionPlan,"-").concat(__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL,"-").concat(__WEBPACK_IMPORTED_MODULE_38__config__["l" /* CB_API_FETCH_CURRENCY */]));}}});}}else if(this.props.company){var planKeys;var periodKeys;if(Object(__WEBPACK_IMPORTED_MODULE_16_utils_state__["e" /* showNewRealEstateUI */])(this.props.company,this.props.app.isDesktopTrial,this.props.app.isReAccessNoIndustry)){planKeys=[__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT,__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES];periodKeys=[__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY];}else{planKeys=Object.keys(__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.omit(__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */],__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].SCALE,__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].ENTERPRISE));periodKeys=[__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY,__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL];}planKeys.forEach(function(planKey){if(!__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][planKey].isPerpetual){periodKeys.forEach(function(periodKey){if(!(__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][planKey].isRealEstatePlan&&periodKey===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL)){result.push("".concat(planKey,"-").concat(periodKey.toLowerCase(),"-").concat(__WEBPACK_IMPORTED_MODULE_38__config__["l" /* CB_API_FETCH_CURRENCY */]));}});}});}return __WEBPACK_IMPORTED_MODULE_50_lodash___default.a.uniq(result);}},{key:"shouldShowAppliedDiscountForCurrentPackage",value:function shouldShowAppliedDiscountForCurrentPackage(plan,period,currency,couponConfig,discountType,couponSetKey,couponId,isMemberAddon,appliedProdTypeOfLastValidCombination,appliedProdCatOfLastValidCombination){// We limit magix discount to annual plans on client side and UPGRADE_POPUP to XC/XC+ packages only excluding desktop+
if(discountType===__WEBPACK_IMPORTED_MODULE_38__config__["F" /* DISCOUNT_TYPE */].MAGIX&&(appliedProdTypeOfLastValidCombination===__WEBPACK_IMPORTED_MODULE_38__config__["Y" /* MAXIC_DISCOUNT_PROD_TYPE */].SUBSCRIPTION&&period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL||appliedProdTypeOfLastValidCombination===__WEBPACK_IMPORTED_MODULE_38__config__["Y" /* MAXIC_DISCOUNT_PROD_TYPE */].PERPETUAL&&period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL)||discountType===__WEBPACK_IMPORTED_MODULE_38__config__["F" /* DISCOUNT_TYPE */].COUPON_SET_ID){if(couponSetKey===__WEBPACK_IMPORTED_MODULE_38__config__["E" /* DISCOUNT_KEY */].UPGRADE_POPUP){return __WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][plan].isCloudSuitePlan;}else{if(appliedProdTypeOfLastValidCombination===__WEBPACK_IMPORTED_MODULE_38__config__["Y" /* MAXIC_DISCOUNT_PROD_TYPE */].PERPETUAL&&period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL){if(plan===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].PHOTO_PERPETUAL&&appliedProdCatOfLastValidCombination===__WEBPACK_IMPORTED_MODULE_38__config__["_12" /* PRODUCT_CATEGORY */].PHOTO||plan===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].WEB_PERPETUAL&&appliedProdCatOfLastValidCombination===__WEBPACK_IMPORTED_MODULE_38__config__["_12" /* PRODUCT_CATEGORY */].WEB||plan===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].DESIGNER_PERPETUAL&&appliedProdCatOfLastValidCombination===__WEBPACK_IMPORTED_MODULE_38__config__["_12" /* PRODUCT_CATEGORY */].DESIGNER||__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(this.props.crs,'isFallbackProductReturnedLastValidCombination')){return true;}else{return false;}}else{// magix discount for subscription plans
var cbProductIds=__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(couponConfig,'plan_ids');if(cbProductIds&&[__WEBPACK_IMPORTED_MODULE_38__config__["E" /* DISCOUNT_KEY */].TIER1,__WEBPACK_IMPORTED_MODULE_38__config__["E" /* DISCOUNT_KEY */].TIER2,__WEBPACK_IMPORTED_MODULE_38__config__["E" /* DISCOUNT_KEY */].TIER3].includes(couponSetKey)){return cbProductIds.some(function(allowedCbProductId){var _convertPlanIdIntoSub13=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(allowedCbProductId),allowed_plan=_convertPlanIdIntoSub13.plan,allowed_period=_convertPlanIdIntoSub13.period,allowed_currency=_convertPlanIdIntoSub13.currency;return plan===allowed_plan&&period===allowed_period&&currency===allowed_currency;});}else{return false;}}}}else if(discountType===__WEBPACK_IMPORTED_MODULE_38__config__["F" /* DISCOUNT_TYPE */].COUPON_ID){if(couponId===__WEBPACK_IMPORTED_MODULE_38__config__["D" /* DISCOUNTS_CONFIG */][__WEBPACK_IMPORTED_MODULE_38__config__["E" /* DISCOUNT_KEY */].UPGRADE_POPUP].coupon_set_id){return __WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][plan].isCloudSuitePlan;}else{var sourceObject=__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][plan].isPerpetual||isMemberAddon?'addon':'plan';if(__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][plan].isPerpetual&&__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(couponConfig,'duration_type')==='forever'){return false;}else{if(__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(couponConfig,'apply_on')==='invoice_amount'){return true;}else if(__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(couponConfig,'apply_on')==='each_specified_item'){if(__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(couponConfig,"".concat(sourceObject,"_constraint"))==='all'){return true;}else if(__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(couponConfig,"".concat(sourceObject,"_constraint"))==='specific'){var _cbProductIds=__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(couponConfig,"".concat(sourceObject,"_ids"));return _cbProductIds.some(function(allowedCbProductId){var _convertPlanIdIntoSub14=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(allowedCbProductId),allowed_plan=_convertPlanIdIntoSub14.plan,allowed_period=_convertPlanIdIntoSub14.period,allowed_currency=_convertPlanIdIntoSub14.currency;var latestPlan=__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][plan].isPerpetual?__WEBPACK_IMPORTED_MODULE_38__config__["X" /* MAP_ADDON_TO_LATEST_VERSION */][plan]:isMemberAddon?Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["f" /* getNonObsoleteMemberAddonForPlan */])(plan):plan;return latestPlan===allowed_plan&&period===allowed_period&&currency===allowed_currency;});}else{//constraint = not_applicable
return false;}}else{//not configured
return false;}}}}}/**
	 * Start Subscription upgrade process
	 *
	 * @param {string} planId for example, 'team-annual-usd'
	 * @returns
	 * @memberof Subscription
	 */},{key:"shouldStartSubscriptionUpgrade",value:function shouldStartSubscriptionUpgrade(planId){var activeSubscription=this.state.activeSubscription;var _convertPlanIdIntoSub15=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(planId),plan=_convertPlanIdIntoSub15.plan,period=_convertPlanIdIntoSub15.period,currency=_convertPlanIdIntoSub15.currency;if([__WEBPACK_IMPORTED_MODULE_38__config__["_37" /* STANDARD_OVERVIEW_PLAN_ID */],__WEBPACK_IMPORTED_MODULE_38__config__["_25" /* REAL_ESTATE_OVERVIEW_PLAN_ID */]].includes(planId)){return;}// Check if we can open Chargebee for an upgrade, if not we need to show the standard subscription page
if(activeSubscription.plan!==undefined){if(activeSubscription.plan===plan&&activeSubscription.period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY&&period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL&&activeSubscription.currency===currency){// allow upgrade from monthly to  yearly
return true;}else if(// requesting to subscribe for the same plan they already have, or downgrade
!__WEBPACK_IMPORTED_MODULE_38__config__["_43" /* SUBSCRIPTION_PLAN_UPGRADE_OPTIONS */][activeSubscription.plan].includes(plan===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].SCALE?__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].TEAM_PLUS:plan)||// requesting change from annual to monthly
activeSubscription.period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL&&period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY||// requesting to use a different currency
activeSubscription.currency!==currency){return;}}return true;}/**
	 * Get the current subscription plan and trigger ChargeBee portal popup
	 *
	 * @memberof Subscription
	 */},{key:"showSubscriptionDetails",value:function showSubscriptionDetails(){var _this29=this;var _getSubscriptionsAndA11=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["i" /* getSubscriptionsAndAddons */])(this.props.company,false),activeSubscription=_getSubscriptionsAndA11.subscription;var plan,period,currency;if(activeSubscription){var _convertPlanIdIntoSub16=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(activeSubscription.planId);plan=_convertPlanIdIntoSub16.plan;period=_convertPlanIdIntoSub16.period;currency=_convertPlanIdIntoSub16.currency;}else{var _getSubscriptionsAndA12=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["i" /* getSubscriptionsAndAddons */])(this.props.company,true),cancelledSubscription=_getSubscriptionsAndA12.subscription;if(!__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.isEmpty(cancelledSubscription)){var _convertPlanIdIntoSub17=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(cancelledSubscription.planId);plan=_convertPlanIdIntoSub17.plan;period=_convertPlanIdIntoSub17.period;currency=_convertPlanIdIntoSub17.currency;}}if(plan&&period&&currency){this.props.createChargeBeeSession("".concat(plan,"-").concat(period,"-").concat(currency)).then(function(data){if(data instanceof __WEBPACK_IMPORTED_MODULE_55__errors_apperror__["a" /* default */]){log.send(data);if(data.errorId===__WEBPACK_IMPORTED_MODULE_57_errors_errorids__["a" /* default */].API_REQUEST_LIMIT_EXCEEDED){_this29.props.showRateLimitError();}return;}data.result&&_this29.openChargeBeePortal(data.result.portal_session);});}}/**
	 * Go to Cloud suite or Creative tools category
	 *
	 * @memberof Subscription
	 */},{key:"handleUpgradePlan",value:function handleUpgradePlan(showPeriod){var _this30=this;var activeSubscription=this.state.activeSubscription;var plan=activeSubscription.plan,period=activeSubscription.period;if(!showPeriod&&activeSubscription.plan===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].TEAM_PLUS&&activeSubscription.period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY){showPeriod=__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL;}var showCategory;if(plan){showCategory=this.getCategoryOfUpgradeOptionForActivePlan(plan,period);}else if(this.props.app.isDesktopApp){// For desktop app, if category selected is shown switch to CREATIVE_TOOLS,
// otherwise switch to single category whatever is defined by this.category
showCategory=this.shouldRenderCategorySelector?__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CREATIVE_TOOLS:this.category;}else{showCategory=this.props.discount.isDiscountApplied&&this.props.discount.discountType===__WEBPACK_IMPORTED_MODULE_38__config__["F" /* DISCOUNT_TYPE */].MAGIX?__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CREATIVE_TOOLS:__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CLOUD_SUITE;}if(this.isPerpetualOverviewMode||this.isPlusOverviewMode){this.setState({pendingUpgradePlanClicked:true},function(){_this30.props.history.push({pathname:Object(__WEBPACK_IMPORTED_MODULE_53_routes__["w" /* getRoute */])(__WEBPACK_IMPORTED_MODULE_53_routes__["n" /* SUBSCRIPTION */],_this30.props.company.id),state:{preselectCategory:showCategory}});});}else{this.setState({pendingUpgradePlanClicked:true},function(){_this30.props.setAppStateParams(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectSpread___default()({subscriptionView:__WEBPACK_IMPORTED_MODULE_38__config__["_45" /* SUBSCRIPTION_VIEW */].PURCHASE_OPTIONS,subscriptionCategory:showCategory},showPeriod&&{subscriptionPeriod:showPeriod}));});}}/**
	 * Reactivate my plan handler
	 *
	 * @memberof Subscription
	 */},{key:"reactivateMySubscriptionHandler",value:function reactivateMySubscriptionHandler(cancelledSubscription){var _this31=this;var _convertPlanIdIntoSub18=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(cancelledSubscription.planId),plan=_convertPlanIdIntoSub18.plan,period=_convertPlanIdIntoSub18.period,currency=_convertPlanIdIntoSub18.currency;if(!Object.values(__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */]).includes(plan)){// Cancelled subscriptions are not migrated, we upgrade them to Scale
plan=__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].TEAM_PLUS;}var showCategory=__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][plan].isCloudSuitePlan?__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CLOUD_SUITE:__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CREATIVE_TOOLS;var defaultQuantity=this.getDefaultQuantity(this.props,__WEBPACK_IMPORTED_MODULE_38__config__["_19" /* QUANTITY_TYPE */].SEATS);this.setState({pendingReactivatePlanId:"".concat(plan,"-").concat(period,"-").concat(currency),pendingReactivateQuantity:defaultQuantity,pendingReactivatePeriod:period},function(){_this31.props.setSeatsQuantity(defaultQuantity);_this31.props.setAppStateParams({subscriptionView:__WEBPACK_IMPORTED_MODULE_38__config__["_45" /* SUBSCRIPTION_VIEW */].PURCHASE_OPTIONS,subscriptionPeriod:period,subscriptionCategory:showCategory});});}},{key:"handleSwitchToPlansFromBuyMoreLicensesPopup",value:function handleSwitchToPlansFromBuyMoreLicensesPopup(){this.props.hideModal();this.props.setAppStateParams({subscriptionView:__WEBPACK_IMPORTED_MODULE_38__config__["_45" /* SUBSCRIPTION_VIEW */].PURCHASE_OPTIONS,subscriptionPeriod:__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL,subscriptionCategory:__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CLOUD_SUITE});if(this.props.discount.isDiscountApplied&&this.props.discount.couponType===__WEBPACK_IMPORTED_MODULE_38__config__["v" /* COUPON_TYPE */].LICENSES){this.props.changeCouponType(__WEBPACK_IMPORTED_MODULE_38__config__["v" /* COUPON_TYPE */].SEATS);}}},{key:"getCategoryOfUpgradeOptionForActivePlan",value:function getCategoryOfUpgradeOptionForActivePlan(plan,period){var showCategory;if([__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].WEB,__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].PHOTO].includes(plan)){showCategory=__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CREATIVE_TOOLS;}else if(plan===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].DESIGNER){// designer can only be upgraded to Scale (cloud) option
showCategory=period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY?__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CREATIVE_TOOLS:__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CLOUD_SUITE;}else{showCategory=__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CLOUD_SUITE;}return showCategory;}/**
	 * Open ChargeBee portal popup with details of company's subscription
	 *
	 * @param {*} portalSession
	 * @returns
	 * @memberof Subscription
	 */},{key:"openChargeBeePortal",value:function openChargeBeePortal(portalSession){if(!portalSession)return;if(__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_39__redux_modules_chargebee__["a" /* ChargeBee */])){this.handleCBnotLoaded();return;}__WEBPACK_IMPORTED_MODULE_39__redux_modules_chargebee__["a" /* ChargeBee */].setPortalSession(portalSession);var cbPortal=__WEBPACK_IMPORTED_MODULE_39__redux_modules_chargebee__["a" /* ChargeBee */].createChargebeePortal();cbPortal.open();}/**
	 * Open ChargeBee Checkout popup to upgrade from Pro to Team subscription
	 *
	 * @param {JSON} hostedPage JSON object from Middleware
	 * @memberof Subscription
	 */},{key:"openChargeBeeCheckout",value:function openChargeBeeCheckout(_hostedPage){var _this32=this;if(!_hostedPage)return;if(__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_39__redux_modules_chargebee__["a" /* ChargeBee */])){this.handleCBnotLoaded();return;}__WEBPACK_IMPORTED_MODULE_39__redux_modules_chargebee__["a" /* ChargeBee */].openCheckout({hostedPage:function hostedPage(){return Promise.resolve(_hostedPage);},loaded:function loaded(){_this32.setState({willProceedToCheckout:false});},success:function success(){_this32.props.showChargebeeLoader();__WEBPACK_IMPORTED_MODULE_39__redux_modules_chargebee__["a" /* ChargeBee */].closeAll();},error:function error(_error){var nError=new __WEBPACK_IMPORTED_MODULE_55__errors_apperror__["a" /* default */]({message:'openChargeBeeCheckout.hostedPage failed',errorId:__WEBPACK_IMPORTED_MODULE_57_errors_errorids__["a" /* default */].UNKNOWN,originalError:_error,visualisers:{feature:'CHARGEBEE'}});log.send(nError);}});}},{key:"handleCBnotLoaded",value:function handleCBnotLoaded(){this.props.setErrorId(__WEBPACK_IMPORTED_MODULE_57_errors_errorids__["a" /* default */].CB_NOT_LOADED);var nError=new __WEBPACK_IMPORTED_MODULE_55__errors_apperror__["a" /* default */]({message:'ChargeBee library could not be loaded',errorId:__WEBPACK_IMPORTED_MODULE_57_errors_errorids__["a" /* default */].CB_NOT_LOADED,visualisers:{feature:'CHARGEBEE'}});log.send(nError);}},{key:"toggleSeeAllProducts",value:function toggleSeeAllProducts(){var _this33=this;var isCloudPackagePreselected=[__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].SCALE,__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].ESSENTIAL].includes(this.preselectedPackage);if(isCloudPackagePreselected){this.setState({pendingSeeAllProductsPlanClicked:true,preselectPackage:false},function(){_this33.props.setAppStateParams({subscriptionView:__WEBPACK_IMPORTED_MODULE_38__config__["_45" /* SUBSCRIPTION_VIEW */].PURCHASE_OPTIONS,subscriptionPeriod:__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL,subscriptionCategory:__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CLOUD_SUITE});_this33.props.setAllPackagesShownFlag(true);});}else{this.setState({preselectPackage:false});this.props.setAllPackagesShownFlag(true);}}},{key:"handleViewCurrentPlan",value:function handleViewCurrentPlan(){this.handleSubscriptionViewChange(__WEBPACK_IMPORTED_MODULE_38__config__["_45" /* SUBSCRIPTION_VIEW */].CURRENT_PRODUCTS);}},{key:"contactUsHandler",value:function contactUsHandler(message){Object(__WEBPACK_IMPORTED_MODULE_19_utils_intercom__["a" /* openIntercomChat */])(message,true,this.props.showErrorPopup);}},{key:"switchToYearlyHandler",value:function switchToYearlyHandler(){this.handleUpgradePlan(__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL);}},{key:"handleUpdateLastPageVisited",value:function handleUpdateLastPageVisited(){if(this.props.isStandardProductOverview&&(this.props.app.wasPlusOverviewPageVisited||this.props.app.wasPerpetualOverviewPageVisited)){this.props.clearSubscriptionState();}if(this.props.isStandardProductOverview&&this.props.app.wasPerpetualOverviewPageVisited&&this.props.discount.isDiscountApplied&&this.props.discount.couponType===__WEBPACK_IMPORTED_MODULE_38__config__["v" /* COUPON_TYPE */].LICENSES){//SUBSCRIPTION_VIEW
this.props.changeCouponType(__WEBPACK_IMPORTED_MODULE_38__config__["v" /* COUPON_TYPE */].SEATS);}if(this.isCurrentProductsView&&this.props.discount.isDiscountApplied&&this.props.discount.couponType===__WEBPACK_IMPORTED_MODULE_38__config__["v" /* COUPON_TYPE */].SEATS){// When going from One-Time-Checkbox to Buy more licenses coupon is not applied on checkout
this.props.changeCouponType(__WEBPACK_IMPORTED_MODULE_38__config__["v" /* COUPON_TYPE */].LICENSES);}// when going from One-Time (perpetual) checkbox with applied perpetual coupon to Monthly/Annually checkbox
var isPerpetualCheckbox=this.isPurchaseOptionsView&&this.isPerpetualPeriodSelected&&!this.isPerpetualOverviewMode;if(this.isPurchaseOptionsView&&this.props.isStandardProductOverview&&this.props.discount.isDiscountApplied&&this.props.discount.couponType===__WEBPACK_IMPORTED_MODULE_38__config__["v" /* COUPON_TYPE */].LICENSES&&!isPerpetualCheckbox){this.props.changeCouponType(__WEBPACK_IMPORTED_MODULE_38__config__["v" /* COUPON_TYPE */].SEATS);}}},{key:"clearInvalidFieldsForBuyMorePopup",value:function clearInvalidFieldsForBuyMorePopup(resetSeatsQuantityToDefault,clearDiscountField){if(this.props.discount.couponCodeFetchSuccess===false||clearDiscountField){// Clear coupon applied in background if it's invalid
this.props.clearAppliedDiscount();}var currentLicensesQuantityValue=this.getQuantityInputValue(__WEBPACK_IMPORTED_MODULE_38__config__["_19" /* QUANTITY_TYPE */].LICENSES);if(!Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["v" /* isValidNonZeroQuantity */])(currentLicensesQuantityValue)){// If quantity values in invalid in Subscription page, reset it in Extra licenses modal
this.props.setLicensesQuantity(this.getDefaultQuantity(this.props,__WEBPACK_IMPORTED_MODULE_38__config__["_19" /* QUANTITY_TYPE */].LICENSES));}var currentSeatsQuantityValue=this.getQuantityInputValue(__WEBPACK_IMPORTED_MODULE_38__config__["_19" /* QUANTITY_TYPE */].SEATS);var defaultSeatsQuantity=this.getDefaultQuantity(this.props,__WEBPACK_IMPORTED_MODULE_38__config__["_19" /* QUANTITY_TYPE */].SEATS);if(!Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["v" /* isValidNonZeroQuantity */])(currentSeatsQuantityValue)||resetSeatsQuantityToDefault&&currentSeatsQuantityValue!==defaultSeatsQuantity){// If quantity values in invalid in Subscription page, reset it in Extra licenses modal
this.props.setSeatsQuantity(this.getDefaultQuantity(this.props,__WEBPACK_IMPORTED_MODULE_38__config__["_19" /* QUANTITY_TYPE */].SEATS));}}},{key:"handlePurchaseMoreLicenses",value:function handlePurchaseMoreLicenses(plan){var _this34=this;var _this$props$discount11=this.props.discount,isDiscountApplied=_this$props$discount11.isDiscountApplied,discountType=_this$props$discount11.discountType,couponId=_this$props$discount11.couponId,couponSetKey=_this$props$discount11.couponSetKey,couponConfig=_this$props$discount11.couponConfig,appliedProdTypeOfLastValidCombination=_this$props$discount11.appliedProdTypeOfLastValidCombination,appliedProdCatOfLastValidCombination=_this$props$discount11.appliedProdCatOfLastValidCombination;var showDiscount=isDiscountApplied&&this.shouldShowAppliedDiscountForCurrentPackage(plan,__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL,this.currency.key,couponConfig,discountType,couponSetKey,couponId,false,appliedProdTypeOfLastValidCombination,appliedProdCatOfLastValidCombination);this.clearInvalidFieldsForBuyMorePopup(null,!showDiscount);var modalProps={cb:function cb(hasCouponError){var _this34$props$discoun=_this34.props.discount,isDiscountApplied=_this34$props$discoun.isDiscountApplied,discountType=_this34$props$discoun.discountType,couponType=_this34$props$discoun.couponType;var useDiscount=!hasCouponError&&isDiscountApplied&&couponType===__WEBPACK_IMPORTED_MODULE_38__config__["v" /* COUPON_TYPE */].LICENSES&&discountType===__WEBPACK_IMPORTED_MODULE_38__config__["F" /* DISCOUNT_TYPE */].COUPON_ID;_this34.doCheckout(plan,__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL,false/*isUpgrade*/,useDiscount,true/*isPerpetual*/,false/*isUserNumberMismatch*/);},type:__WEBPACK_IMPORTED_MODULE_38__config__["j" /* BUY_MORE_POPUP_TYPE */].LICENSES,plan:plan,currency:this.currency,getQuantityInputValue:this.getQuantityInputValue,renderInfoTooltip:this.renderInfoTooltip,shouldShowAppliedDiscountForCurrentPackage:this.shouldShowAppliedDiscountForCurrentPackage,getNumberOfQualifyingProductsForCoupon:this.getNumberOfQualifyingProductsForCoupon,getQualifyingProductsForCoupon:this.getQualifyingProductsForCoupon,addVersionToTitle:this.addVersionToTitle,getDiscountPrice:this.getDiscountPrice,clearInvalidFieldsForBuyMorePopup:this.clearInvalidFieldsForBuyMorePopup,contactUsHandler:this.contactUsHandler,handleSwitchToPlansFromBuyMoreLicensesPopup:this.handleSwitchToPlansFromBuyMoreLicensesPopup,routeToOneTimeCheckBoxAndShowDiscountPopup:this.routeToOneTimeCheckBoxAndShowDiscountPopup};this.props.showModal('BUY_MORE_LICENSES_OR_SEATS',modalProps);}},{key:"buyMoreSeatsCallback",value:function buyMoreSeatsCallback(){var targetUsersPayingQuantity=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["e" /* getMembersPaidQuantity */])(this.props.company)+__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][this.activePlan].freeSeatsIncluded+parseInt(this.getQuantityInputValue());this.props.purchaseSeats(this.getQuantityInputValue(),targetUsersPayingQuantity);}},{key:"handleBuyMoreSeats",value:function handleBuyMoreSeats(plan,period){this.clearInvalidFieldsForBuyMorePopup(true);var modalProps={cb:this.buyMoreSeatsCallback,type:__WEBPACK_IMPORTED_MODULE_38__config__["j" /* BUY_MORE_POPUP_TYPE */].SEATS,plan:plan,period:period,currency:this.currency,getQuantityInputValue:this.getQuantityInputValue,renderInfoTooltip:this.renderInfoTooltip,nrOfNonGuestUsers:Object(__WEBPACK_IMPORTED_MODULE_17_utils_users__["e" /* filterNonGuestUsers */])(this.props.company.users).length,clearInvalidFieldsForBuyMorePopup:this.clearInvalidFieldsForBuyMorePopup};this.props.showModal('BUY_MORE_LICENSES_OR_SEATS',modalProps);}},{key:"updatePendingSubscription",value:function updatePendingSubscription(){var _this35=this;var pendingSubscriptionSettingsValue=__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(this.props.company,'settings.pendingSubscription');if(this.props.currentPlanId&&pendingSubscriptionSettingsValue&&this.props.currentPlanId===pendingSubscriptionSettingsValue){this.setState({pendingSubscription:false,pendingSeatsQuantity:false});this.deleteSavedPendingSubscription();}if(pendingSubscriptionSettingsValue){setTimeout(function(){_this35.deleteSavedPendingSubscription();},CLEAR_PENDING_SUBSCRIPTION_TIMEOUT);}}},{key:"deleteSavedPendingSubscription",value:function deleteSavedPendingSubscription(){this.props.writeCompanySettings({pendingSubscription:null,pendingSeatsQuantity:null});}},{key:"changeRoute",value:function changeRoute(props){var _this36=this;this.setState({pendingRouteChange:true},function(){_this36.props.history.push(props);});}//#endregion
//#region Getters
},{key:"getCancellationDate",value:function getCancellationDate(){var _getSubscriptionsAndA13=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["i" /* getSubscriptionsAndAddons */])(this.props.company),subscription=_getSubscriptionsAndA13.subscription;var cancellationDate;if(this.hasPlan){if(subscription.cancellationPending&&subscription.cancelledAt){cancellationDate=new Date(subscription.cancelledAt).toLocaleDateString(__WEBPACK_IMPORTED_MODULE_49_i18n_i18n__["a" /* default */].getCurrentLanguage(true),localeDateStringOptions);}}return cancellationDate;}},{key:"getNextBillingDate",value:function getNextBillingDate(){var _getSubscriptionsAndA14=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["i" /* getSubscriptionsAndAddons */])(this.props.company),subscription=_getSubscriptionsAndA14.subscription;var billingNextDate;if(this.hasPlan){if(subscription.nextBillingAt&&!subscription.cancellationPending){billingNextDate=new Date(subscription.nextBillingAt).toLocaleDateString(__WEBPACK_IMPORTED_MODULE_49_i18n_i18n__["a" /* default */].getCurrentLanguage(true),localeDateStringOptions);}}return billingNextDate;}// Check if there is active subscription plan
},{key:"getQuantityInputValue",value:function getQuantityInputValue(type){return type===__WEBPACK_IMPORTED_MODULE_38__config__["_19" /* QUANTITY_TYPE */].LICENSES?this.state.licensesQuantity:this.state.seatsQuantity;}},{key:"areCloudOnlyPlans",value:function areCloudOnlyPlans(plans){var desktopPackages=[__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].WEB,__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].DESIGNER,__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].PHOTO,__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].PHOTO_PERPETUAL,__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].WEB_PERPETUAL,__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].DESIGNER_PERPETUAL];var isCloudOnly=true;plans.forEach(function(planId){if(desktopPackages.includes(planId)){isCloudOnly=false;}});return isCloudOnly;}},{key:"areDesktopOnlyPlans",value:function areDesktopOnlyPlans(plans){var cloudPackages=[__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].ESSENTIAL,__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].TEAM_PLUS];var isDesktopOnly=true;plans.forEach(function(planId){if(cloudPackages.includes(planId)){isDesktopOnly=false;}});return isDesktopOnly;}},{key:"getCategoryOfCoupon",value:function getCategoryOfCoupon(props,plans,currency){var _this37=this;var _props$discount=props.discount,isDiscountApplied=_props$discount.isDiscountApplied,couponAppliedWithoutValidation=_props$discount.couponAppliedWithoutValidation,couponConfig=_props$discount.couponConfig,isResponsePendingFromEstimationEndpoint=_props$discount.isResponsePendingFromEstimationEndpoint;var isCouponAppliedToCloud=false;var isCouponAppliedToDesktop=false;if(!isDiscountApplied||couponAppliedWithoutValidation&&isResponsePendingFromEstimationEndpoint&&couponConfig===null){if(isDiscountApplied&&couponAppliedWithoutValidation&&couponConfig===null){}return{isCouponAppliedToCloud:isCouponAppliedToCloud,isCouponAppliedToDesktop:isCouponAppliedToDesktop};}plans.forEach(function(planId){var periodsArray=[__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL,__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY];if(_this37.isPerpetualOverviewMode||_this37.hasPerpetualCheckbox){periodsArray.push(__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL);}periodsArray.forEach(function(period){if(period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL&&__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][planId].isPerpetual||period!==__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL&&!__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][planId].isPerpetual){var shouldApplyDiscount=_this37.shouldShowAppliedDiscountForCurrentPackage(planId,period,currency,props.discount.couponConfig,props.discount.discountType,props.discount.couponSetKey,props.discount.couponId,false,couponAppliedWithoutValidation,true,props.discount.appliedProdTypeOfLastValidCombination,props.discount.appliedProdCatOfLastValidCombination);if(shouldApplyDiscount){__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][planId].isCloudSuitePlan&&(isCouponAppliedToCloud=true);__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][planId].isCreativeToolsPlan&&(isCouponAppliedToDesktop=true);__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][planId].isPerpetual&&(isCouponAppliedToDesktop=true);}}});});return{isCouponAppliedToCloud:isCouponAppliedToCloud,isCouponAppliedToDesktop:isCouponAppliedToDesktop};}},{key:"getPeriodOfCoupon",value:function getPeriodOfCoupon(props,plans,currency,category){var _this38=this;var isDiscountApplied=props.discount.isDiscountApplied;var isCouponAppliedToMonthly=false;var isCouponAppliedToAnnualy=false;var isCouponAppliedToPerpetual=false;if(!isDiscountApplied){return{isCouponAppliedToMonthly:isCouponAppliedToMonthly,isCouponAppliedToAnnualy:isCouponAppliedToAnnualy,isCouponAppliedToPerpetual:isCouponAppliedToPerpetual};}var searchInPlans=plans;if(category){searchInPlans=searchInPlans.filter(function(planId){return category===__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CLOUD_SUITE&&__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][planId].isCloudSuitePlan||category===__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CREATIVE_TOOLS&&__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][planId].isCreativeToolsPlan||category===__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CREATIVE_TOOLS&&__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][planId].isPerpetual;});}searchInPlans.forEach(function(planId){var periodsArray=[__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL,__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY];if(_this38.isPerpetualOverviewMode||_this38.hasPerpetualCheckbox){periodsArray.push(__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL);}periodsArray.forEach(function(period){if(period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL&&__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][planId].isPerpetual||period!==__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL&&!__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][planId].isPerpetual){var shouldApplyDiscount=_this38.shouldShowAppliedDiscountForCurrentPackage(planId,period,currency,props.discount.couponConfig,props.discount.discountType,props.discount.couponSetKey,props.discount.couponId,false,props.discount.appliedProdTypeOfLastValidCombination,props.discount.appliedProdCatOfLastValidCombination);if(shouldApplyDiscount){period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY&&(isCouponAppliedToMonthly=true);period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL&&(isCouponAppliedToAnnualy=true);period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL&&(isCouponAppliedToPerpetual=true);}}});});return{isCouponAppliedToMonthly:isCouponAppliedToMonthly,isCouponAppliedToAnnualy:isCouponAppliedToAnnualy,isCouponAppliedToPerpetual:isCouponAppliedToPerpetual};}},{key:"shouldRenderPerpetualCheckbox",get:function get(){return this.hasPerpetualCheckbox&&(this.category===__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CREATIVE_TOOLS||this.isScalePlan&&this.isAnnualPlan);}},{key:"hasPerpetualCheckbox",get:function get(){var _getSubscriptionsAndA15=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["i" /* getSubscriptionsAndAddons */])(this.props.company),perpetualAddons=_getSubscriptionsAndA15.perpetualAddons;return!__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.isEmpty(perpetualAddons)&&!this.props.company.hasUnlimitedTeamSubscription&&!this.isPlusOverviewMode;}},{key:"hasPlan",get:function get(){var planId=__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(this.state,'activeSubscription.plan');return planId!==undefined;}},{key:"pendingSubscription",get:function get(){return __WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(this.state,'pendingSubscription');}},{key:"pendingSeatsQuantity",get:function get(){return __WEBPACK_IMPORTED_MODULE_50_lodash___default.a.get(this.state,'pendingSeatsQuantity');}// Get active plan
},{key:"activePlan",get:function get(){var plan=this.state.activeSubscription.plan;return plan;}// Check if the current plan is Essential
},{key:"isEssentialPlan",get:function get(){var plan=this.state.activeSubscription.plan;return plan===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].ESSENTIAL;}// Check if the current plan is Scale
},{key:"isScalePlan",get:function get(){var plan=this.state.activeSubscription.plan;return plan===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].TEAM_PLUS;}// Check if the current plan has monthly payment period
},{key:"isMonthlyPlan",get:function get(){var period=this.state.activeSubscription.period;return period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY;}// Check if the current plan has annual payment period
},{key:"isAnnualPlan",get:function get(){var period=this.state.activeSubscription.period;return period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL;}// Check if the current period selector is annual
},{key:"isAnnualPeriodSelected",get:function get(){return this.period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL;}// Check if the current period selector is perpetual
},{key:"isPerpetualPeriodSelected",get:function get(){return this.period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL;}// Check if the plans category selector is Cloud Suite
},{key:"isCloudSuiteCategory",get:function get(){return this.category===__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CLOUD_SUITE;}// Check if the tab selector is Your Producs
},{key:"isCurrentProductsView",get:function get(){return this.subscriptionView===__WEBPACK_IMPORTED_MODULE_38__config__["_45" /* SUBSCRIPTION_VIEW */].CURRENT_PRODUCTS;}// Check if the tab selector is Purchase Options
},{key:"isPurchaseOptionsView",get:function get(){return this.subscriptionView===__WEBPACK_IMPORTED_MODULE_38__config__["_45" /* SUBSCRIPTION_VIEW */].PURCHASE_OPTIONS;}// Check if the plans category selector is Creative Tools
},{key:"isCreativeToolsCategory",get:function get(){return this.category===__WEBPACK_IMPORTED_MODULE_38__config__["_10" /* PLAN_CATEGORIES */].CREATIVE_TOOLS;}// Get the current value from payment period selector
},{key:"period",get:function get(){var period=this.state.period;return period;}// Get the current value from currency selector
},{key:"currency",get:function get(){return __WEBPACK_IMPORTED_MODULE_50_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_38__config__["x" /* CURRENCIES */],{key:this.state.currency});}// Get the current value from plans category selector
},{key:"category",get:function get(){var category=this.state.category;return category;}// Get the current value from subscriptionView selector
},{key:"subscriptionView",get:function get(){var subscriptionView=this.state.subscriptionView;return subscriptionView;}// Get if the Subscription page is opened in the Plus Overview Mode
},{key:"isPlusOverviewMode",get:function get(){var plusOverview=this.props.plusOverview;return plusOverview;}// Get if the Subscription page is opened in the Perpetual Overview Mode
},{key:"isPerpetualOverviewMode",get:function get(){var perpetualOverview=this.props.perpetualOverview;return perpetualOverview;}},{key:"preselectedPackage",get:function get(){var _this$props2=this.props,productName=_this$props2.productName,magixCat=_this$props2.magixCat;var result;if(productName){if(!(result=__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */][this.props.productName.toUpperCase()])){result=__WEBPACK_IMPORTED_MODULE_38__config__["_16" /* PRODUCT_PREFIX_TO_PACKAGE_MAP */][this.props.productName];}}else if(magixCat){result=__WEBPACK_IMPORTED_MODULE_38__config__["_13" /* PRODUCT_CATEGORY_TO_PACKAGE_MAP */][this.props.magixCat];}return result;}//#endregion
//#region Rendering conditions
},{key:"shouldRenderPlanBoxes",get:function get(){var _getSubscriptionsAndA16=Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["i" /* getSubscriptionsAndAddons */])(this.props.company),perpetualAddons=_getSubscriptionsAndA16.perpetualAddons;// Don't render Enterprise on plus-overview route
// /* temporarily disable */ if (this.isScalePlan && this.isAnnualPlan && this.isPlusOverviewMode) return false;
var plan=this.state.activeSubscription.plan;if(plan===__WEBPACK_IMPORTED_MODULE_38__config__["_42" /* SUBSCRIPTION_PLAN */].DESIGNER&&this.isAnnualPlan&&this.isPlusOverviewMode)return false;// only scale unlimited has no further upgrade options
return!(this.isScalePlan&&this.props.company.hasUnlimitedTeamSubscription&&!this.isPerpetualOverviewMode)||!__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.isEmpty(perpetualAddons);}},{key:"shouldRenderCategorySelector",get:function get(){// Always hide if the Subscription page is opened in the Plus Overview Mode
if(this.isPlusOverviewMode||this.isPerpetualOverviewMode){return false;}if(this.state.preselectPackage&&!this.props.app.showAllPackages){return false;}// No active subscription or available upgrade options are in both cloud and desktop categories
//getPlansToRender(onlySelectedCategory, showMonthlyToYearlyUpgrade, onlyPreselected
var plansToRender=this.getPlansToRender(false,true,false);var hasCloudSuiteUpgradeTab=false;var hasCreativeToolsUpgradeTab=false;plansToRender.every(function(planId){if(__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][planId].isCloudSuitePlan){hasCloudSuiteUpgradeTab=true;}if(__WEBPACK_IMPORTED_MODULE_38__config__["_3" /* PACKAGES_CONFIG */][planId].isCreativeToolsPlan){hasCreativeToolsUpgradeTab=true;}return!hasCloudSuiteUpgradeTab||!hasCreativeToolsUpgradeTab;});return!this.hasPlan||hasCloudSuiteUpgradeTab&&hasCreativeToolsUpgradeTab&&!this.areCloudOnlyPlans(plansToRender)&&!this.areDesktopOnlyPlans(plansToRender);}},{key:"shouldPreselectPackage",get:function get(){return this.state.preselectPackage&&!this.props.app.showAllPackages;}},{key:"shouldRenderQuantityField",get:function get(){return this.period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL||this.isPerpetualOverviewMode&&!this.props.company.hasUnlimitedTeamSubscription||!this.hasPlan;}},{key:"allPeriods",get:function get(){var activeSubscription=this.state.activeSubscription;var periods=[];if(!this.hasPlan){periods.push(__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL,__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY);}if(this.hasPlan){if(activeSubscription.period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY){this.isScalePlan?!this.isPlusOverviewMode&&periods.push(__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL):periods.push(__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY,__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL);}else if(!this.isScalePlan){periods.push(__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL);}}if(activeSubscription.plan&&!periods.includes(activeSubscription.period)){periods.push(activeSubscription.period);}this.shouldRenderPerpetualCheckbox&&periods.push(__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL);return periods;}},{key:"shouldRenderPeriodSelector",get:function get(){// No active subscription
// or current plan with monthly period and not Team+ monthly -> show period selector
// (as when active subscription is Team+ monthly then user can only upgrade to Team+ yearly, there are no other options)
// or current subscription is perpetual
// If user has perpetual, show period selector so user can buy more
if(this.isPerpetualOverviewMode)return;return this.allPeriods.length>1;}},{key:"shouldRenderAnnualAndMonthlyOptions",get:function get(){var activeSubscription=this.state.activeSubscription;return!this.hasPlan||activeSubscription.period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY&&!(this.isScalePlan&&this.isMonthlyPlan);}},{key:"shouldRenderCurrencySelector",get:function get(){// No active or past subscription -> show currency selector
return!Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["b" /* getCurrencyUsedInCB */])(this.props.company);}},{key:"hasNonUnlimitedSubscription",get:function get(){var company=this.props.company;return!company.hasUnlimitedTeamSubscription&&this.hasPlan;}},{key:"canSubscriptionBeUpgraded",get:function get(){var activeSubscription=this.state.activeSubscription;if(this.props.company.hasUnlimitedTeamSubscription)return false;if(!this.hasPlan||!__WEBPACK_IMPORTED_MODULE_50_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_38__config__["_43" /* SUBSCRIPTION_PLAN_UPGRADE_OPTIONS */][activeSubscription.plan])||activeSubscription.period===__WEBPACK_IMPORTED_MODULE_38__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY){return true;}}//#endregion
}]);return Subscription;}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]))||_class);Subscription.propTypes={classes:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.object,company:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.object,paymentRedirectUrl:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.string,showPackageDiscontinuedMessage:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func.isRequired,showRateLimitError:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func.isRequired,showErrorPopup:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func.isRequired,getSubscriptionEstimation:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func.isRequired,getUpcomingInvoiceEstimate:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func.isRequired,createChargeBeeSession:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func.isRequired,createChargeBeeSubscription:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func.isRequired,showPreloader:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func.isRequired,showChargebeeLoader:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func.isRequired,hideChargebeeLoader:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func.isRequired,sendEmailNotification:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func.isRequired,location:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.shape({pathname:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.string.isRequired,search:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.string}),history:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.object,currentPlanId:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.string,match:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.object.isRequired,plusOverview:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.bool,perpetualOverview:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.bool,isAdmin:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.bool,setErrorId:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func.isRequired,writeUserSettings:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func,settings:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.object,showModal:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func,crs:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.object.isRequired,app:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.object.isRequired,discount:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.object.isRequired,writeCompanySettings:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func,purchaseSeats:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func,couponId:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.string,isDiscountTakeoverFromWebsite:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.bool,productName:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.string,productSource:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.string,productPeriod:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.string,magixCat:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.string,realEstatePlan:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.string,setAllPackagesShownFlag:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func,setSubscriptionCategory:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func,setSubscriptionView:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func,setSubscriptionPeriod:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func,setSubscriptionCurrency:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func,setSeatsQuantity:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func,setLicensesQuantity:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func,setAppStateParams:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func,clearSubscriptionState:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func,clearAppliedDiscount:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func,changeCouponType:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func,currency:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.string,isStandardProductOverview:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.bool,isCBPlanExternalRedirect:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.bool,isCBPlanInternalRedirect:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.bool,selectedCompanyId:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.string,hideModal:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func,companies:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.object,productQuantity:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.number,couponAppliedWithoutValidation:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.bool,navOpen:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.bool,modalShown:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.bool,hidePreloader:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func,changeMagixDiscountProdType:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func,setPendingTriggerCheckout:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func,setReduceUsersApiErrorState:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func,clearReduceUsersApiErrorState:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func,applyDiscountUsingCouponId:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func,reactivateSubscription:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.bool,wasRenewalPopupShown:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.bool,setRenewalPopupWasShown:__WEBPACK_IMPORTED_MODULE_37_prop_types___default.a.func};var mapStateToProps=function mapStateToProps(state){return{company:state.companies.rawDataById[state.companies.selectedId],paymentRedirectUrl:state.companies.paymentRedirectUrl,currentPlanId:Object(__WEBPACK_IMPORTED_MODULE_27__utils_subscription__["c" /* getCurrentPlanId */])(state.companies.rawDataById[state.companies.selectedId]),isAdmin:Object(__WEBPACK_IMPORTED_MODULE_16_utils_state__["a" /* isAdmin */])(state),modalShown:state.modal.modalShown,settings:state.session.user.settings,crs:state.crs,discount:state.discount,app:state.app,selectedCompanyId:state.companies.selectedId,companies:state.companies,wasRenewalPopupShown:state.app.wasRenewalPopupShown};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_14_redux__["b" /* bindActionCreators */])({getSubscriptionEstimation:__WEBPACK_IMPORTED_MODULE_41_redux_modules_companies__["t" /* getSubscriptionEstimation */],getUpcomingInvoiceEstimate:__WEBPACK_IMPORTED_MODULE_41_redux_modules_companies__["u" /* getUpcomingInvoiceEstimate */],showPackageDiscontinuedMessage:__WEBPACK_IMPORTED_MODULE_41_redux_modules_companies__["I" /* showPackageDiscontinuedMessage */],showRateLimitError:__WEBPACK_IMPORTED_MODULE_41_redux_modules_companies__["J" /* showRateLimitError */],showErrorPopup:__WEBPACK_IMPORTED_MODULE_41_redux_modules_companies__["H" /* showErrorPopup */],createChargeBeeSession:__WEBPACK_IMPORTED_MODULE_41_redux_modules_companies__["g" /* createChargeBeeSession */],createChargeBeeSubscription:__WEBPACK_IMPORTED_MODULE_41_redux_modules_companies__["h" /* createChargeBeeSubscription */],showPreloader:__WEBPACK_IMPORTED_MODULE_45_redux_modules_preloader__["c" /* showPreloader */],showChargebeeLoader:__WEBPACK_IMPORTED_MODULE_46_redux_modules_chargebeeLoader__["c" /* showChargebeeLoader */],hideChargebeeLoader:__WEBPACK_IMPORTED_MODULE_46_redux_modules_chargebeeLoader__["b" /* hideChargebeeLoader */],sendEmailNotification:__WEBPACK_IMPORTED_MODULE_41_redux_modules_companies__["F" /* sendEmailNotification */],setErrorId:__WEBPACK_IMPORTED_MODULE_44_redux_modules_error__["c" /* setErrorId */],writeUserSettings:__WEBPACK_IMPORTED_MODULE_42__redux_modules_session__["d" /* writeUserSettings */],showModal:__WEBPACK_IMPORTED_MODULE_40__redux_modules_modal__["d" /* showModal */],writeCompanySettings:__WEBPACK_IMPORTED_MODULE_41_redux_modules_companies__["R" /* writeCompanySettings */],purchaseSeats:__WEBPACK_IMPORTED_MODULE_41_redux_modules_companies__["B" /* purchaseSeats */],setAllPackagesShownFlag:__WEBPACK_IMPORTED_MODULE_58_redux_modules_app__["e" /* setAllPackagesShownFlag */],setSubscriptionCategory:__WEBPACK_IMPORTED_MODULE_58_redux_modules_app__["s" /* setSubscriptionCategory */],setSubscriptionView:__WEBPACK_IMPORTED_MODULE_58_redux_modules_app__["v" /* setSubscriptionView */],setSubscriptionPeriod:__WEBPACK_IMPORTED_MODULE_58_redux_modules_app__["u" /* setSubscriptionPeriod */],setSubscriptionCurrency:__WEBPACK_IMPORTED_MODULE_58_redux_modules_app__["t" /* setSubscriptionCurrency */],setSeatsQuantity:__WEBPACK_IMPORTED_MODULE_58_redux_modules_app__["r" /* setSeatsQuantity */],setLicensesQuantity:__WEBPACK_IMPORTED_MODULE_58_redux_modules_app__["j" /* setLicensesQuantity */],setAppStateParams:__WEBPACK_IMPORTED_MODULE_58_redux_modules_app__["f" /* setAppStateParams */],clearSubscriptionState:__WEBPACK_IMPORTED_MODULE_58_redux_modules_app__["b" /* clearSubscriptionState */],clearAppliedDiscount:__WEBPACK_IMPORTED_MODULE_31_redux_modules_discount__["f" /* clearAppliedDiscount */],changeCouponType:__WEBPACK_IMPORTED_MODULE_31_redux_modules_discount__["e" /* changeCouponType */],changeMagixDiscountProdType:__WEBPACK_IMPORTED_MODULE_32_redux_modules_crs__["a" /* changeMagixDiscountProdType */],hideModal:__WEBPACK_IMPORTED_MODULE_24_redux_modules_modal__["b" /* hideModal */],hidePreloader:__WEBPACK_IMPORTED_MODULE_45_redux_modules_preloader__["b" /* hidePreloader */],setPendingTriggerCheckout:__WEBPACK_IMPORTED_MODULE_58_redux_modules_app__["k" /* setPendingTriggerCheckout */],applyDiscountUsingCouponId:__WEBPACK_IMPORTED_MODULE_31_redux_modules_discount__["a" /* applyDiscountUsingCouponId */],setReduceUsersApiErrorState:__WEBPACK_IMPORTED_MODULE_58_redux_modules_app__["p" /* setReduceUsersApiErrorState */],setRenewalPopupWasShown:__WEBPACK_IMPORTED_MODULE_58_redux_modules_app__["q" /* setRenewalPopupWasShown */],clearReduceUsersApiErrorState:__WEBPACK_IMPORTED_MODULE_58_redux_modules_app__["a" /* clearReduceUsersApiErrorState */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_15_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Subscription));

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1127);
} else {
  module.exports = require('./cjs/react-dom-server.browser.development.js');
}


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.2
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var p=__webpack_require__(179),q=__webpack_require__(146),t=__webpack_require__(1),w=__webpack_require__(180),x=__webpack_require__(245),y=__webpack_require__(1128),z=__webpack_require__(1130);
function A(a){for(var b=arguments.length-1,d="http://reactjs.org/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)d+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);p(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}
var C="function"===typeof Symbol&&Symbol["for"],aa=C?Symbol["for"]("react.call"):60104,ba=C?Symbol["for"]("react.return"):60105,ca=C?Symbol["for"]("react.portal"):60106,E=C?Symbol["for"]("react.fragment"):60107,da=C?Symbol["for"]("react.strict_mode"):60108,F=C?Symbol["for"]("react.provider"):60109,ea=C?Symbol["for"]("react.context"):60110,fa=C?Symbol["for"]("react.async_mode"):60111,ha=C?Symbol["for"]("react.forward_ref"):60112,ia=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
G={},H={};function ja(a){if(H.hasOwnProperty(a))return!0;if(G.hasOwnProperty(a))return!1;if(ia.test(a))return H[a]=!0;G[a]=!0;return!1}function ka(a,b,d,c){if(null!==d&&0===d.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(c)return!1;if(null!==d)return!d.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function la(a,b,d,c){if(null===b||"undefined"===typeof b||ka(a,b,d,c))return!0;if(null!==d)switch(d.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function I(a,b,d,c,k){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=c;this.attributeNamespace=k;this.mustUseProperty=d;this.propertyName=a;this.type=b}var J={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){J[a]=new I(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];J[b]=new I(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){J[a]=new I(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){J[a]=new I(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){J[a]=new I(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){J[a]=new I(a,3,!0,a.toLowerCase(),null)});
["capture","download"].forEach(function(a){J[a]=new I(a,4,!1,a.toLowerCase(),null)});["cols","rows","size","span"].forEach(function(a){J[a]=new I(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){J[a]=new I(a,5,!1,a.toLowerCase(),null)});var K=/[\-:]([a-z])/g;function L(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(K,
L);J[b]=new I(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(K,L);J[b]=new I(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(K,L);J[b]=new I(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});J.tabIndex=new I("tabIndex",1,!1,"tabindex",null);var ma=/["'&<>]/;
function M(a){if("boolean"===typeof a||"number"===typeof a)return""+a;a=""+a;var b=ma.exec(a);if(b){var d="",c,k=0;for(c=b.index;c<a.length;c++){switch(a.charCodeAt(c)){case 34:b="\x26quot;";break;case 38:b="\x26amp;";break;case 39:b="\x26#x27;";break;case 60:b="\x26lt;";break;case 62:b="\x26gt;";break;default:continue}k!==c&&(d+=a.substring(k,c));k=c+1;d+=b}a=k!==c?d+a.substring(k,c):d}return a}var N={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function O(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
var P={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},na=q({menuitem:!0},P),Q={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,
fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},oa=["Webkit","ms","Moz","O"];Object.keys(Q).forEach(function(a){oa.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Q[b]=Q[a]})});var R=t.Children.toArray,S=w.thatReturns("");w.thatReturns("");var pa={listing:!0,pre:!0,textarea:!0};
function T(a){return"string"===typeof a?a:"function"===typeof a?a.displayName||a.name:null}var qa=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,U={},ra=z(function(a){return y(a)});function sa(a){var b="";t.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function ta(a,b){if(a=a.contextTypes){var d={},c;for(c in a)d[c]=b[c];b=d}else b=x;return b}var ua={children:null,dangerouslySetInnerHTML:null,suppressContentEditableWarning:null,suppressHydrationWarning:null};
function V(a,b){void 0===a&&A("152",T(b)||"Component")}
function va(a,b){function d(c,k){var d=ta(k,b),f=[],h=!1,g={isMounted:function(){return!1},enqueueForceUpdate:function(){if(null===f)return null},enqueueReplaceState:function(a,b){h=!0;f=[b]},enqueueSetState:function(a,b){if(null===f)return null;f.push(b)}},e=void 0;if(k.prototype&&k.prototype.isReactComponent){if(e=new k(c.props,d,g),"function"===typeof k.getDerivedStateFromProps){var v=k.getDerivedStateFromProps.call(null,c.props,e.state);null!=v&&(e.state=q({},e.state,v))}}else if(e=k(c.props,
d,g),null==e||null==e.render){a=e;V(a,k);return}e.props=c.props;e.context=d;e.updater=g;g=e.state;void 0===g&&(e.state=g=null);if("function"===typeof e.UNSAFE_componentWillMount||"function"===typeof e.componentWillMount)if("function"===typeof e.componentWillMount&&"function"!==typeof k.getDerivedStateFromProps&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&"function"!==typeof k.getDerivedStateFromProps&&e.UNSAFE_componentWillMount(),f.length){g=f;var u=h;f=null;h=!1;if(u&&
1===g.length)e.state=g[0];else{v=u?g[0]:e.state;var m=!0;for(u=u?1:0;u<g.length;u++){var n=g[u];n="function"===typeof n?n.call(e,v,c.props,d):n;null!=n&&(m?(m=!1,v=q({},v,n)):q(v,n))}e.state=v}}else f=null;a=e.render();V(a,k);c=void 0;if("function"===typeof e.getChildContext&&(d=k.childContextTypes,"object"===typeof d)){c=e.getChildContext();for(var r in c)r in d?void 0:A("108",T(k)||"Unknown",r)}c&&(b=q({},b,c))}for(;t.isValidElement(a);){var c=a,k=c.type;if("function"!==typeof k)break;d(c,k)}return{child:a,
context:b}}
var W=function(){function a(b,d){if(!(this instanceof a))throw new TypeError("Cannot call a class as a function");t.isValidElement(b)?b.type!==E?b=[b]:(b=b.props.children,b=t.isValidElement(b)?[b]:R(b)):b=R(b);this.stack=[{type:null,domNamespace:N.html,children:b,childIndex:0,context:x,footer:""}];this.exhausted=!1;this.currentSelectValue=null;this.previousWasTextNode=!1;this.makeStaticMarkup=d;this.providerStack=[];this.providerIndex=-1}a.prototype.pushProvider=function(a){this.providerIndex+=1;
this.providerStack[this.providerIndex]=a;a.type._context._currentValue=a.props.value};a.prototype.popProvider=function(a){this.providerStack[this.providerIndex]=null;--this.providerIndex;a=a.type._context;a._currentValue=0>this.providerIndex?a._defaultValue:this.providerStack[this.providerIndex].props.value};a.prototype.read=function(a){if(this.exhausted)return null;for(var b="";b.length<a;){if(0===this.stack.length){this.exhausted=!0;break}var c=this.stack[this.stack.length-1];if(c.childIndex>=c.children.length){var k=
c.footer;b+=k;""!==k&&(this.previousWasTextNode=!1);this.stack.pop();"select"===c.type?this.currentSelectValue=null:null!=c.type&&null!=c.type.type&&c.type.type.$$typeof===F&&this.popProvider(c.type)}else k=c.children[c.childIndex++],b+=this.render(k,c.context,c.domNamespace)}return b};a.prototype.render=function(a,d,c){if("string"===typeof a||"number"===typeof a){c=""+a;if(""===c)return"";if(this.makeStaticMarkup)return M(c);if(this.previousWasTextNode)return"\x3c!-- --\x3e"+M(c);this.previousWasTextNode=
!0;return M(c)}d=va(a,d);a=d.child;d=d.context;if(null===a||!1===a)return"";if(!t.isValidElement(a)){if(null!=a&&null!=a.$$typeof){var b=a.$$typeof;b===ca?A("257"):void 0;A("258",b.toString())}a=R(a);this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:d,footer:""});return""}b=a.type;if("string"===typeof b)return this.renderDOM(a,d,c);switch(b){case da:case fa:case E:return a=R(a.props.children),this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:d,footer:""}),
"";case aa:case ba:A("259")}if("object"===typeof b&&null!==b)switch(b.$$typeof){case ha:return a=R(b.render(a.props,a.ref)),this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:d,footer:""}),"";case F:return b=R(a.props.children),c={type:a,domNamespace:c,children:b,childIndex:0,context:d,footer:""},this.pushProvider(a),this.stack.push(c),"";case ea:return b=R(a.props.children(a.type._currentValue)),this.stack.push({type:a,domNamespace:c,children:b,childIndex:0,context:d,footer:""}),
""}A("130",null==b?b:typeof b,"")};a.prototype.renderDOM=function(a,d,c){var b=a.type.toLowerCase();c===N.html&&O(b);U.hasOwnProperty(b)||(qa.test(b)?void 0:A("65",b),U[b]=!0);var f=a.props;if("input"===b)f=q({type:void 0},f,{defaultChecked:void 0,defaultValue:void 0,value:null!=f.value?f.value:f.defaultValue,checked:null!=f.checked?f.checked:f.defaultChecked});else if("textarea"===b){var h=f.value;if(null==h){h=f.defaultValue;var l=f.children;null!=l&&(null!=h?A("92"):void 0,Array.isArray(l)&&(1>=
l.length?void 0:A("93"),l=l[0]),h=""+l);null==h&&(h="")}f=q({},f,{value:void 0,children:""+h})}else if("select"===b)this.currentSelectValue=null!=f.value?f.value:f.defaultValue,f=q({},f,{value:void 0});else if("option"===b){l=this.currentSelectValue;var D=sa(f.children);if(null!=l){var B=null!=f.value?f.value+"":D;h=!1;if(Array.isArray(l))for(var g=0;g<l.length;g++){if(""+l[g]===B){h=!0;break}}else h=""+l===B;f=q({selected:void 0,children:void 0},f,{selected:h,children:D})}}if(h=f)na[b]&&(null!=h.children||
null!=h.dangerouslySetInnerHTML?A("137",b,S()):void 0),null!=h.dangerouslySetInnerHTML&&(null!=h.children?A("60"):void 0,"object"===typeof h.dangerouslySetInnerHTML&&"__html"in h.dangerouslySetInnerHTML?void 0:A("61")),null!=h.style&&"object"!==typeof h.style?A("62",S()):void 0;h=f;l=this.makeStaticMarkup;D=1===this.stack.length;B="\x3c"+a.type;for(r in h)if(h.hasOwnProperty(r)){var e=h[r];if(null!=e){if("style"===r){g=void 0;var v="",u="";for(g in e)if(e.hasOwnProperty(g)){var m=0===g.indexOf("--"),
n=e[g];null!=n&&(v+=u+ra(g)+":",u=g,m=null==n||"boolean"===typeof n||""===n?"":m||"number"!==typeof n||0===n||Q.hasOwnProperty(u)&&Q[u]?(""+n).trim():n+"px",v+=m,u=";")}e=v||null}g=null;b:if(m=b,n=h,-1===m.indexOf("-"))m="string"===typeof n.is;else switch(m){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":m=!1;break b;default:m=!0}if(m)ua.hasOwnProperty(r)||(g=r,g=ja(g)&&null!=
e?g+"\x3d"+('"'+M(e)+'"'):"");else{m=r;g=e;e=J.hasOwnProperty(m)?J[m]:null;if(n="style"!==m)n=null!==e?0===e.type:!(2<m.length)||"o"!==m[0]&&"O"!==m[0]||"n"!==m[1]&&"N"!==m[1]?!1:!0;n||la(m,g,e,!1)?g="":null!==e?(m=e.attributeName,e=e.type,g=3===e||4===e&&!0===g?m+'\x3d""':m+"\x3d"+('"'+M(g)+'"')):g=m+"\x3d"+('"'+M(g)+'"')}g&&(B+=" "+g)}}l||D&&(B+=' data-reactroot\x3d""');var r=B;h="";P.hasOwnProperty(b)?r+="/\x3e":(r+="\x3e",h="\x3c/"+a.type+"\x3e");a:{l=f.dangerouslySetInnerHTML;if(null!=l){if(null!=
l.__html){l=l.__html;break a}}else if(l=f.children,"string"===typeof l||"number"===typeof l){l=M(l);break a}l=null}null!=l?(f=[],pa[b]&&"\n"===l.charAt(0)&&(r+="\n"),r+=l):f=R(f.children);a=a.type;c=null==c||"http://www.w3.org/1999/xhtml"===c?O(a):"http://www.w3.org/2000/svg"===c&&"foreignObject"===a?"http://www.w3.org/1999/xhtml":c;this.stack.push({domNamespace:c,type:b,children:f,childIndex:0,context:d,footer:h});this.previousWasTextNode=!1;return r};return a}(),X={renderToString:function(a){return(new W(a,
!1)).read(Infinity)},renderToStaticMarkup:function(a){return(new W(a,!0)).read(Infinity)},renderToNodeStream:function(){A("207")},renderToStaticNodeStream:function(){A("208")},version:"16.3.2"},Y=Object.freeze({default:X}),Z=Y&&X||Y;module.exports=Z["default"]?Z["default"]:Z;


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(1129);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_slider__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_FormField__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_i18n_i18n__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_redux_modules_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__theme_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_ExpansionPanel__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_ExpansionPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_ExpansionPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_ExpansionPanelSummary__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_ExpansionPanelSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_ExpansionPanelSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_core_ExpansionPanelDetails__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_core_ExpansionPanelDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_ExpansionPanelDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__material_ui_icons_ExpandMore__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__material_ui_icons_ExpandMore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__material_ui_icons_ExpandMore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_utils_intercom__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_redux_modules_app__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_lib_Segment_customTrackers__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lib_Segment_helpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__errors_errorids__ = __webpack_require__(22);
var _errors,_dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_14_i18n_i18n__["a" /* default */].loc.localize;var errors=(_errors={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_32__errors_errorids__["a" /* default */].OFFLINE,localize('subscriptions-error-offline')),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_32__errors_errorids__["a" /* default */].API_REQUEST_LIMIT_EXCEEDED,localize('error-cb-api-rate-limit-reached')),_errors);var ExpansionPanel=Object(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["N" /* withStyles */])({root:{boxShadow:'none',borderBottom:'2px solid #F2F2F2',marginTop:'10px',borderRadius:0,'&:before':{display:'none'}},expanded:{margin:'10px auto 0'}})(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_ExpansionPanel___default.a);var ExpansionPanelSummary=Object(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["N" /* withStyles */])({root:{background:'none',borderBottom:'none',marginBottom:0,minHeight:56,padding:0,'&$expanded':{minHeight:56},'& [class*=expandIcon]':{top:'22%',right:0,padding:0}},content:{margin:'0','&$expanded':{margin:'0'}},expanded:{}})(function(props){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_ExpansionPanelSummary___default.a,props);});ExpansionPanelSummary.muiName='ExpansionPanelSummary';var ExpansionPanelDetails=Object(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["N" /* withStyles */])(function(theme){return{root:{padding:'0 0 12px'}};})(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_ExpansionPanelDetails___default.a);var styles=function styles(theme){return{realEstateUiWrapper:{maxWidth:'1600px'},/* slider header */sliderHeader:{flexDirection:'column',textAlign:'center',marginBottom:30},sliderTitle:{color:'#2A3F51',fontSize:'20px',lineHeight:'24px',marginBottom:19,display:'block',opacity:1,fontFamily:'Poppins, sans-serif',fontWeight:600},sliderSubtitle:{fontSize:'20px',lineHeight:'24px',fontFamily:'Roboto, sans-serif',fontWeight:300,display:'block',color:'#16212A',opacity:1},/* slider */sliderWrapper:{margin:'0 auto 62px',maxWidth:1050,'&.hasCurrency':{maxWidth:1225},'&.reducedMargin':{marginBottom:'37px'},'@media screen and (max-width: 1200px)':{display:'block',textAlign:'center'}},sliderGrid:{'&.hasCurrency':{maxWidth:698},flex:'1 1 calc(100% - 230px - 25px)',display:'flex',flexDirection:'column',justifyContent:'center',position:'relative','@media screen and (max-width: 1200px)':{margin:'0 auto',maxWidth:698}},sliderValueWrapper:{display:'flex',flexDirection:'column',justifyContent:'center',flex:'0 0 230px',marginLeft:20,color:'#2A3F51','@media screen and (max-width: 1200px)':{margin:'20px auto'}},agentsLegendLabel:{fontFamily:'Poppins, sans-serif',fontWeight:300,fontSize:__WEBPACK_IMPORTED_MODULE_14_i18n_i18n__["a" /* default */].getCurrentLanguage(false)==='de'?'17px':'20px',lineHeight:'24px',opacity:1},agentsLegendValue:{fontWeight:600,color:'#002748',marginLeft:5,cursor:'pointer'},quantityNumberInfo:{opacity:1},quantityNumberInfoClickToEdit:{paddingTop:6},quantityNumberInfoSave:{},agentsQuantityField:{margin:'-6px 0 0 7px',width:'60px','& input':{height:'20px',borderWidth:1,borderStyle:'solid',borderRadius:5,borderColor:'#2a3f51',padding:'7px 10px',color:'#333',fontWeight:600,fontSize:'18px',lineHeight:'20px','&:focus':{borderColor:theme.palette.primary.main},'&::placeholder':{fontFamily:'Open Sans, sans-serif',fontWeight:'normal',fontStyle:'normal',fontSize:'14px',lineHeight:'19px',color:theme.palette.text.primary}}},currencySelectorGrid:{flex:'0 0 160px',display:'flex',flexDirection:'column',justifyContent:'center',marginLeft:20,'& > *':{marginBottom:'0 !important'},'@media screen and (max-width: 1200px)':{margin:'0 auto',maxWidth:'160px'}},slider:{background:'#EDEEEF',borderRadius:12,height:12,'& .bar-0':{height:12,borderRadius:12,backgroundImage:'linear-gradient(90deg, #0ab5ff, #0ab5ff 50%, #0065f0)'},'&.disabled':{opacity:0.5}},handle:{width:'20px',height:'20px',backgroundColor:'#fff',boxShadow:'0px 3px 6px rgba(214, 214, 214, 1);',borderRadius:'50%',marginTop:'-5px',cursor:'pointer'},/* packages */packagesContainerWrapper:{display:'flex',justifyContent:'space-between',flexFlow:'row nowrap','@media screen and (max-width: 770px)':{flexDirection:'column'}},"package":{flex:'0 0 calc(50% - 12px)',padding:'32px',background:'#fff',borderRadius:30,border:'1px solid #fff',transition:'all .3s ease-in-out',position:'relative'},/* package elements */packageTag:{opacity:1,display:'inline-block',padding:'2px 9px',borderRadius:'3px',fontFamily:'Poppins, sans-serif',fontWeight:500,fontSize:'15px',lineHeight:'18px',marginBottom:'21px',textTransform:'uppercase',letterSpacing:'0.5px'},packageTitle:{fontSize:'35px',lineHeight:'39px',color:'#002748',fontFamily:'Poppins, sans-serif',fontWeight:600,marginBottom:'10px'},packagePrice:{opacity:1,fontSize:'40px',lineHeight:'44px',color:'#002748',fontFamily:'Poppins, sans-serif',fontWeight:600,marginBottom:'10px','& span':{color:'#2A3F51',fontWeight:300,fontSize:'15px',lineHeight:'19px'},'& del':{color:'#cad1d5',fontSize:'30px',lineHeight:'44px'}},couponGrid:{alignItems:'center',marginBottom:'22px'},withCode:{opacity:1,fontWeight:300,fontSize:'15px',lineHeight:'19px','& span':{fontWeight:600,fontSize:'15px',border:'2px solid #0065F0',borderRadius:3,color:'#0065F0',padding:'0 3px'}},packageSubtitle:{opacity:1,color:'#2A3F51',fontFamily:'Poppins, sans-serif',fontWeight:300,fontSize:'15px',lineHeight:'19px',marginBottom:'34px'},packageEndsOn:{fontSize:'18px',lineHeight:'20px',fontFamily:'Roboto, sans-serif',color:'#D30404',position:'absolute',top:'35px',right:'40px'},/* features list */featuresGroupTitle:{fontSize:'15px',lineHeight:'19px',color:'#002748',fontFamily:'Poppins, sans-serif',fontWeight:600,paddingTop:'32px',marginBottom:'12px'},featuresList:{listStyle:'none'},featuresListItem:{'&:not(:first-child)':{marginTop:'8px'},padding:'2px 0',alignItems:'start'},featuresListIcon:{color:'#0065f0',padding:0,margin:'-2px 0 0'},featuresListTitle:{opacity:1,fontSize:'15px',lineHeight:'19px',fontFamily:'Roboto, sans-serif',fontWeight:400,color:'#2A3F51'},featuresListDescription:{opacity:1,display:'block',fontSize:'13px',lineHeight:'17px',color:'#808082',fontFamily:'Roboto, sans-serif',fontWeight:300,paddingTop:'7px'},/* sections list */sectionsListIcon:{color:'#002748',fontSize:'30px'},sectionsListTitle:{fontSize:'15px',lineHeight:'19px',color:'#002748',fontFamily:'Poppins, sans-serif',fontWeight:600,padding:'0 30px 0 0',position:'relative'},sectionsListDescription:{opacity:1,fontSize:'13px',lineHeight:'17px',fontFamily:'Roboto, sans-serif',fontWeight:300,color:'#808082',paddingTop:'7px',paddingBottom:'10px'},/* styles for individual packages */individualAgentsPackage:{'& .packageTag':{background:'#E1E8FF',color:'#0065F0'}},brokeragesPackage:{boxShadow:'15px 15px 50px rgba(0, 101, 240, 0.2)','& .packageTag':{background:'#0065F0',color:'#fff'},'& .packagePrice':{color:'#0065F0',marginBottom:0}},singleAgentCurrentPlan:{'& .individualAgentsPackage':{border:'1px solid #ddd',opacity:'0.5'},'& .brokeragesPackage':{border:'1px solid #0065F0'}},brokeragesCurrentPlan:{'& .individualAgentsPackage':{opacity:'0.5',boxShadow:'15px 15px 50px rgba(0, 101, 240, 0.2)','@media screen and (max-width: 770px)':{order:2}},'& .brokeragesPackage':{border:'1px solid #0065F0','@media screen and (max-width: 770px)':{order:1}}},brokeragesPlanPendingCancellation:{'& .individualAgentsPackage':{border:'1px solid #ddd',opacity:'0.5'},'& .brokeragesPackage':{border:'1px solid #0065F0',boxShadow:'15px 15px 50px rgba(0, 101, 240, 0.2)',opacity:1}},singleAgentPlanPendingCancellation:{'& .individualAgentsPackage':{border:'1px solid #0065F0',boxShadow:'15px 15px 50px rgba(0, 101, 240, 0.2)'},'& .brokeragesPackage':{border:'1px solid #ddd',opacity:'0.5',boxShadow:'none'}},brokeragesPlanCancelled:{'& .brokeragesPackage':{}},singleAgentPlanCancelled:{'& .individualAgentsPackage':{border:'1px solid #ddd'}},singleAgentCardActive:{'& .individualAgentsPackage':{border:'1px solid #0065F0',opacity:'1','@media screen and (max-width: 770px)':{order:1,marginBottom:'20px'}},'& .brokeragesPackage':{opacity:'0.5','@media screen and (max-width: 770px)':{order:2}}},brokeragesCardActive:{'& .individualAgentsPackage':{opacity:'0.5','@media screen and (max-width: 770px)':{order:2}},'& .brokeragesPackage':{border:'1px solid #0065F0',opacity:'1','@media screen and (max-width: 770px)':{order:1,marginBottom:'20px'}}},brokerageDecreasingSeats:{'& .individualAgentsPackage':{opacity:'1'},'& .brokeragesPackage':{opacity:'1','& > *':{opacity:0.5},'& .packageTag':{opacity:1},'& .packageTitle':{opacity:1},'& .packagePrice':{opacity:1},'& .packageSubtitle':{opacity:1}}},brokerageIncreasingSeats:{'& .individualAgentsPackage':{opacity:'0.5'},'& .brokeragesPackage':{opacity:'1'}},singleAgentPlanDisabled:{'& .individualAgentsPackage':{opacity:'0.5'}},// buttons
purchaseButtonContainer:{paddingTop:30},button:{borderRadius:'6px',display:'inline-block',minWidth:'255px',fontFamily:'Poppins, sans-serif',padding:'11px 20px',textAlign:'center',textTransform:'uppercase',whiteSpace:'nowrap',textShadow:'none',transition:'all .3s ease-in-out','&.disabled':{color:theme.palette.colors.colorWithAlpha(theme.palette.common.black,0.60),background:theme.palette.colors.colorWithAlpha(theme.palette.common.black,0.15),border:0}},purchaseButtonContained:{backgroundImage:'linear-gradient(90deg,#0ab5ff,#0ab5ff 50%,#0065f0)',backgroundPosition:'100% 50%',backgroundRepeat:'no-repeat',backgroundSize:'200% 100%',padding:'13px 20px','&:hover':{backgroundPosition:'0 50%'},'&.updating':{color:'#fff'}},purchaseButtonOutlined:{border:'2px solid #0065f0',color:'#0065f0','&:hover':{background:'#0065f0',color:'#fff',opacity:1}},/* subscription status and links */statusAndLinksGrid:{width:'100%',marginTop:'40px',paddingTop:'44px',borderTop:'2px solid #f3f3f3','@media screen and (max-width: 770px)':{flexDirection:'column'}},statusGrid:{paddingLeft:'30px',width:'50%','@media screen and (max-width: 770px)':{width:'100%',padding:0,textAlign:'center'}},nextBilling:{opacity:1,fontFamily:'Roboto, sans-serif',fontSize:'18px',lineHeight:'21px','& strong':{color:'#5C5D5D',fontFamily:'Poppins, sans-serif',fontWeight:600}},status:{marginTop:'12px',opacity:1,fontFamily:'Roboto, sans-serif',fontSize:'18px',lineHeight:'21px','& strong':{color:'#5C5D5D',fontFamily:'Poppins, sans-serif',fontWeight:600}},statusActive:{color:'#00AA55'},statusCancelled:{color:'#D30404'},linksGrid:{paddingRight:'30px',width:'50%','@media screen and (max-width: 770px)':{width:'100%',padding:0,textAlign:'center'}},manageCBList:{display:'flex',flexFlow:'row nowrap',justifyContent:'right','@media screen and (max-width: 770px)':{display:'block',textAlign:'center'}},manageCBListItem:{width:'auto','@media screen and (max-width: 770px)':{display:'block',width:'100%',textAlign:'center'}},manageCBLink:{opacity:1,fontFamily:'Roboto, sans-serif',fontSize:'18px',lineHeight:'21px',color:'#5C5D5D'},/* info tooltip */infoIconButton:{position:'relative',top:'-2px',width:16,height:16,marginRight:6,color:theme.palette.colors.white,backgroundColor:'#d30404',borderColor:'#d30404',padding:0,'&:hover':{backgroundColor:"".concat(theme.palette.colors.black),borderColor:"".concat(theme.palette.colors.black)}},tooltipArrow:{position:'absolute',fontSize:6,width:'3em',height:'1em',top:0,left:'50%',transform:'translateX(-50%)',marginTop:'-0.95em','&::before':{content:'""',margin:'auto',display:'block',width:0,height:0,borderStyle:'solid',borderWidth:'0 1em 1em 1em',borderColor:"transparent transparent ".concat(theme.palette.common.black," transparent")}},infoTooltip:{padding:7,backgroundColor:theme.palette.common.black},infoTooltipText:{color:theme.palette.common.white,opacity:1,pointerEvents:'auto'},addMoreSeatsWrapper:{flexDirection:'column'},addMoreSeatsGrid:{textAlign:'center'},addMoreSeatsMesssage:{margin:'0 auto 35px',opacity:1,display:'block',fontSize:'15px',lineHeight:'19px',color:'#808082',fontFamily:'Roboto, sans-serif',fontWeight:300,paddingTop:'7px'},updateSeatsButton:{display:'flex',margin:'0 auto 12px',backgroundImage:'linear-gradient(90deg,#0ab5ff,#0ab5ff 50%,#0065f0)',backgroundPosition:'100% 50%',backgroundRepeat:'no-repeat',backgroundSize:'200% 100%',padding:'13px 20px',color:'#fff',transition:'all .3s ease-in-out','&:hover':{backgroundPosition:'0 50%'}},updateSeatsButtonIcon:{marginRight:'7px'},/* error message */successMessage:{margin:'-20px auto 35px',opacity:1,display:'block',fontSize:'15px',lineHeight:'19px',fontFamily:'Roboto, sans-serif',textAlign:'center',fontWeight:300,paddingTop:'7px',color:'#2A3F51'},/* error message */errorMessage:{margin:'-35px auto 35px',opacity:1,display:'block',fontSize:'15px',lineHeight:'19px',fontFamily:'Roboto, sans-serif',textAlign:'center',fontWeight:300,paddingTop:'7px',color:theme.palette.error.main,'& a':{color:theme.palette.primary.main}},/* loading icon */loadingWrapper:{},loadingMessage:{margin:'0 auto 35px',opacity:1,display:'block',fontSize:'15px',lineHeight:'19px',color:'#2A3F51',fontFamily:'Roboto, sans-serif',textAlign:'center',fontWeight:300,paddingTop:'7px'},loadingIcon:{display:'block',height:'24px',width:'24px',margin:'0 auto 10px',fill:'#0065f0',animation:'spin 2s linear infinite'},'@keyframes spin':{'0':{transform:'rotate(0deg)'},'100%':{transform:'rotate(360deg)'}}};};var AGENTS_NUMBER_DEFAULT=__WEBPACK_IMPORTED_MODULE_26__config__["_3" /* PACKAGES_CONFIG */][__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES].freeSeatsIncluded;var AGENTS_NUMBER_MAX=140;// max slider value which renders to max 500
var RealEstatePackages=(_dec=Object(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["N" /* withStyles */])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits___default()(RealEstatePackages,_Component);function RealEstatePackages(props){var _this;__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default()(this,RealEstatePackages);_this=__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default()(RealEstatePackages).call(this,props));_this.agentsInputValue=__WEBPACK_IMPORTED_MODULE_10_react___default.a.createRef();_this.state={sliderValue:AGENTS_NUMBER_DEFAULT,sliderDragged:false,priceValue:'',priceSubtitleValue:'',focusPackage:'',agentsLegend:'',showSlider:true,showAddSeatsSection:false,initialQuantity:_this.getInitialQuantity(),planIsTaxed:null,edit_mode_initial_slider_value:null,edit_mode_initial_input_value:null,edit_mode_modified_input_value:null,isEditMode:false,xhrInProgress:false,apiRequestError:false,apiRequestSuccess:false,errors:{apiError:null},copied:false};_this.handleSliderChangeDebounced=__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.debounce(_this.handleSliderChange,350);_this.handleWindowResizeDebounced=__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.debounce(_this.handleWindowResize.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this)),500);_this.handleUpdateSeats=_this.handleUpdateSeats.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.switchToEditMode=_this.switchToEditMode.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.handleAgentsNumberClickAwayListener=_this.handleAgentsNumberClickAwayListener.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this));return _this;}__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default()(RealEstatePackages,[{key:"componentDidMount",value:function componentDidMount(){this.refreshAgentsNumberInSlider(this.getSliderQuantity(),false);this.preselectPackage();window.addEventListener('resize',this.handleWindowResizeDebounced);var viewPortWidth=document&&window&&Math.max(document.documentElement.clientWidth,window.innerWidth||0);if(viewPortWidth<=__WEBPACK_IMPORTED_MODULE_26__config__["_4" /* PACKAGES_HIDE_SIDEBAR_BREAKPOINT */]){this.handleWindowResizeDebounced();}}},{key:"componentWillUnmount",value:function componentWillUnmount(){window.removeEventListener('resize',this.handleWindowResizeDebounced);}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _this2=this;if(this.state.priceValue&&this.props.symbol!==nextProps.symbol){this.refreshAgentsNumberInSlider(this.state.renderedValue,false,nextProps.symbol);}if(this.props.companies.pendingPayingUserQuantity!==nextProps.companies.pendingPayingUserQuantity||this.props.membersPaidQuantity!==nextProps.membersPaidQuantity||this.props.totalNumberOfSeats!==nextProps.totalNumberOfSeats){var initialQuantity=this.getInitialQuantity(nextProps.membersPaidQuantity);this.setState({initialQuantity:initialQuantity},function(){_this2.refreshAgentsNumberInSlider(nextProps.totalNumberOfSeats,false,nextProps.symbol);});}if(this.props.companies.createChargeBeeSubscriptionErrorId!==nextProps.companies.createChargeBeeSubscriptionErrorId&&nextProps.companies.createChargeBeeSubscriptionErrorId!==null||this.props.companies.purchaseSeatsErrorId!==nextProps.companies.purchaseSeatsErrorId&&nextProps.companies.purchaseSeatsErrorId!==null){this.handleApiErrors(nextProps);}if(this.props.companies.createChargeBeeSubscriptionSuccess!==nextProps.companies.createChargeBeeSubscriptionSuccess&&nextProps.companies.createChargeBeeSubscriptionSuccess===true||this.props.companies.purchaseSeatsSuccess!==nextProps.companies.purchaseSeatsSuccess&&nextProps.companies.purchaseSeatsSuccess===true){this.setState({xhrInProgress:false,apiRequestError:false,apiRequestSuccess:Boolean(nextProps.companies.purchaseSeatsSuccess),errors:{apiError:null}});}/* eslint-disable max-len */var planEstimation=__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(this.props.companies,"subscriptionEstimation[".concat(__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES,"-").concat(__WEBPACK_IMPORTED_MODULE_26__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY,"-").concat(__WEBPACK_IMPORTED_MODULE_26__config__["l" /* CB_API_FETCH_CURRENCY */],"].estimation"))||__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(this.props.companies,"subscriptionEstimationActivePlan[".concat(__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES,"-").concat(__WEBPACK_IMPORTED_MODULE_26__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY,"-").concat(__WEBPACK_IMPORTED_MODULE_26__config__["l" /* CB_API_FETCH_CURRENCY */],"].estimation"))||__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(this.props.companies,"subscriptionEstimation[".concat(__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT,"-").concat(__WEBPACK_IMPORTED_MODULE_26__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY,"-").concat(__WEBPACK_IMPORTED_MODULE_26__config__["l" /* CB_API_FETCH_CURRENCY */],"].estimation"))||__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(this.props.companies,"subscriptionEstimationActivePlan[".concat(__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT,"-").concat(__WEBPACK_IMPORTED_MODULE_26__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY,"-").concat(__WEBPACK_IMPORTED_MODULE_26__config__["l" /* CB_API_FETCH_CURRENCY */],"].estimation"));/* eslint-enable max-len */var isTaxed=__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(planEstimation,'isTaxed');if(isTaxed&&!this.state.planIsTaxed){this.setState({planIsTaxed:isTaxed},function(){_this2.refreshAgentsNumberInSlider(_this2.state.renderedValue,false,nextProps.symbol);});}}},{key:"handleApiErrors",value:function handleApiErrors(nextProps){if(nextProps.companies.createChargeBeeSubscriptionErrorId||nextProps.companies.purchaseSeatsErrorId){var errorMessage=nextProps.companies.createChargeBeeSubscriptionErrorId&&errors[nextProps.companies.createChargeBeeSubscriptionErrorId]||nextProps.companies.purchaseSeatsErrorId&&errors[nextProps.companies.purchaseSeatsErrorId]||localize('subscriptions-error-unknown');this.setState({xhrInProgress:false,apiRequestError:true,apiRequestSuccess:false,errors:{apiError:errorMessage}});}}},{key:"hasCancelledRePackage",value:function hasCancelledRePackage(){return[__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES,__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT].includes(this.props.cancelledPlanId);}},{key:"handleWindowResize",value:function handleWindowResize(){var _this3=this;// blue bar in slider does not update correctly when left side panel (menu) collapses during window resize
// as there is no method on slider which would trigger resize, we have to toggle it for short period
this.setState({showSlider:false},function(){setTimeout(function(){_this3.setState({showSlider:true},function(){});},200);});}},{key:"getInitialQuantity",value:function getInitialQuantity(nextMembersPaidQuantity){if(this.props.currentPlanId){if(this.props.currentPlanId===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT){return 1;}else{return(nextMembersPaidQuantity||this.props.membersPaidQuantity)+__WEBPACK_IMPORTED_MODULE_26__config__["_3" /* PACKAGES_CONFIG */][this.props.currentPlanId].freeSeatsIncluded;}}else{return this.props.quantity>1?this.props.quantity:AGENTS_NUMBER_DEFAULT;}}},{key:"getSliderQuantity",value:function getSliderQuantity(nextPropsTotalNumberOfSeats){var quantity=0;var totalNumberOfSeats=nextPropsTotalNumberOfSeats||this.props.totalNumberOfSeats;if(!this.isIndividualAgentDisabled()&&(this.props.realEstatePlan===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT||this.props.currentPlanId===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT)){quantity=this.props.quantity>1?this.props.quantity:1;}else{if(this.props.currentPlanId){if(this.props.quantity!=totalNumberOfSeats){return this.props.membersPaidQuantity+__WEBPACK_IMPORTED_MODULE_26__config__["_3" /* PACKAGES_CONFIG */][this.props.currentPlanId].freeSeatsIncluded+this.props.quantity;}else{quantity=totalNumberOfSeats>1?totalNumberOfSeats:AGENTS_NUMBER_DEFAULT;}}else{quantity=this.props.quantity>1?this.props.quantity:AGENTS_NUMBER_DEFAULT;}}return quantity;}},{key:"handleSliderChange",value:function handleSliderChange(renderedValue){var _this4=this;var newInputValue;if(this.props.currentPlanId){if(this.props.currentPlanId===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT){newInputValue=renderedValue===1?0:renderedValue;}else{newInputValue=renderedValue-this.props.membersPaidQuantity-__WEBPACK_IMPORTED_MODULE_26__config__["_3" /* PACKAGES_CONFIG */][this.props.currentPlanId].freeSeatsIncluded;}}else{newInputValue=renderedValue===1?0:renderedValue;}this.props.setSeatsQuantity(newInputValue);setTimeout(function(){Object(__WEBPACK_IMPORTED_MODULE_30_lib_Segment_customTrackers__["D" /* trackQuantityChange */])('agent-seats',renderedValue,Object(__WEBPACK_IMPORTED_MODULE_31_lib_Segment_helpers__["a" /* getTrackingOptions */])(_this4.props.company));},250);}},{key:"preselectPackage",value:function preselectPackage(){var preselectPackage;if(this.isIndividualAgentDisabled()){preselectPackage='brokerages';}else if(this.props.realEstatePlan===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT){preselectPackage='single-agent';}else if(this.props.realEstatePlan===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES){preselectPackage='brokerages';}preselectPackage&&this.setState({preselectPackage:preselectPackage});}},{key:"calculatePricing",value:function calculatePricing(agentCount){var basePrice=__WEBPACK_IMPORTED_MODULE_26__config__["_3" /* PACKAGES_CONFIG */][__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES].basePrice;var includedAgents=__WEBPACK_IMPORTED_MODULE_26__config__["_3" /* PACKAGES_CONFIG */][__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES].freeSeatsIncluded;var extraPricePerAgent=__WEBPACK_IMPORTED_MODULE_26__config__["_3" /* PACKAGES_CONFIG */][__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES].extraPricePerAgent;var extraAgents=Math.max(agentCount-includedAgents,0);var total=basePrice+extraAgents*extraPricePerAgent;var perAgent=Math.round(total/agentCount);return{total:total,perAgent:perAgent};}},{key:"copyCouponCode",value:function(){var _copyCouponCode=__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee(coupon){return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return navigator.clipboard.writeText(coupon);case 2:this.setState({'copied':true});case 3:case"end":return _context.stop();}}},_callee,this);}));function copyCouponCode(_x){return _copyCouponCode.apply(this,arguments);}return copyCouponCode;}()},{key:"renderFeaturesList",value:function renderFeaturesList(key,featuresList){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["s" /* List */],{disablePadding:true,className:classes.featuresList},featuresList.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["t" /* ListItem */],{key:"".concat(key,"-").concat(index),dense:true,className:classes.featuresListItem},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["u" /* ListItemIcon */],{className:classes.featuresListIcon},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__theme_icons__["e" /* CheckIconRounded */],null)),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["v" /* ListItemText */],{className:classes.featuresListText},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:"body2",className:classes.featuresListTitle},item.title),item.description&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:"body2",className:classes.featuresListDescription},item.description)));}));}},{key:"getQuantitySnapValueForSliderValue",value:function getQuantitySnapValueForSliderValue(value){var result;if(value===1){result=1;}else if(value>1&&value<=AGENTS_NUMBER_DEFAULT){result=AGENTS_NUMBER_DEFAULT;}else if(value>AGENTS_NUMBER_DEFAULT&&value<=100){result=value;}else if(value>100&&value<=105){if(105-value<=(105-100)/2){result=150;}else{result=100;}}else if(value>105&&value<=110){if(110-value<=(110-105)/2){result=200;}else{result=150;}}else if(value>110&&value<=115){if(115-value<=(115-110)/2){result=250;}else{result=200;}}else if(value>115&&value<=120){if(120-value<=(120-115)/2){result=300;}else{result=250;}}else if(value>120){if(140-value<=(140-120)/2){result=500;}else{result=300;}}return result;}},{key:"snapRenderedValue",value:function snapRenderedValue(value){var result;if(value<0){result=1;}else if(value>500){result=500;}else if(value<=100){result=value;}else if(value>100&&value<=150){if(150-value<=(150-100)/2){result=150;}else{result=100;}}else if(value>150&&value<=200){if(200-value<=(200-150)/2){result=200;}else{result=150;}}else if(value>200&&value<=250){if(250-value<=(250-200)/2){result=250;}else{result=200;}}else if(value>250&&value<=300){if(300-value<=(300-250)/2){result=300;}else{result=250;}}else if(value>300){if(500-value<=(500-300)/2){result=500;}else{result=300;}}return result;}},{key:"getSliderSnapValueForQuantityValue",value:function getSliderSnapValueForQuantityValue(newInputValue){// convert input range (1-500) to slider value (1-140) and snap it
var sliderValue;if(newInputValue>=1&&newInputValue<=100){sliderValue=newInputValue;}else if(newInputValue>100&&newInputValue<=150){if(150-newInputValue<=(150-100)/2){sliderValue=105;}else{sliderValue=100;}}else if(newInputValue>150&&newInputValue<=200){if(200-newInputValue<=(200-150)/2){sliderValue=110;}else{sliderValue=105;}}else if(newInputValue>200&&newInputValue<=250){if(250-newInputValue<=(250-200)/2){sliderValue=115;}else{sliderValue=110;}}else if(newInputValue>250&&newInputValue<=300){if(300-newInputValue<=(300-250)/2){sliderValue=120;}else{sliderValue=115;}}else if(newInputValue>300){if(500-newInputValue<=(500-300)/2){sliderValue=140;}else{sliderValue=120;}}return sliderValue;}},{key:"refreshAgentsNumberInSlider",value:function refreshAgentsNumberInSlider(quantityValue,refetchEstimationData,useSymbol,sliderValue){if(__WEBPACK_IMPORTED_MODULE_26__config__["K" /* FORCE_RE_CHECKOUT_WITH_ALL_USERS */]&&!this.props.currentPlanId&&quantityValue<this.props.nonGuestUsersNumber){quantityValue=this.props.nonGuestUsersNumber;}var renderedValue=quantityValue>1&&quantityValue<AGENTS_NUMBER_DEFAULT+1?AGENTS_NUMBER_DEFAULT:quantityValue===0?AGENTS_NUMBER_DEFAULT:quantityValue;// snap quantity from query param or input field
renderedValue=this.snapRenderedValue(renderedValue);var symbol=this.props.symbol;var priceValue;var priceSubtitleValue;var vatLabel=this.props.getVatLabel(false,this.state.planIsTaxed,true);var valLabelValue=vatLabel?" ".concat(vatLabel):'';if(renderedValue===1){priceValue=null;priceSubtitleValue=localize('re-packages-choose-team-size');}else if(renderedValue===AGENTS_NUMBER_DEFAULT||renderedValue>=AGENTS_NUMBER_DEFAULT+1&&renderedValue<100){var pricing=this.calculatePricing(renderedValue);priceValue="".concat(useSymbol||symbol).concat(pricing.total," <span>").concat(localize('re-packages-per-month')).concat(valLabelValue,"</span>");priceSubtitleValue="~".concat(useSymbol||symbol).concat(pricing.perAgent," ").concat(localize('re-packages-per-agent')).concat(valLabelValue);}else if(renderedValue>=100){priceValue=localize('re-packages-lets-talk');priceSubtitleValue=localize('re-packages-custom-pricing');}var focusPackage;if(renderedValue===1){focusPackage='single-agent';}else if(renderedValue>=AGENTS_NUMBER_DEFAULT+1){focusPackage='brokerages';}var agentsLegend='';if(renderedValue===1){agentsLegend=localize('re-packages-legend-agent',renderedValue);}else if(renderedValue>1&&renderedValue<=AGENTS_NUMBER_DEFAULT){agentsLegend=localize('re-packages-legend-up-to-agents',renderedValue);}else{agentsLegend=localize('re-packages-legend-agents',renderedValue);if(renderedValue===500){agentsLegend+='+';}}if(refetchEstimationData){this.handleSliderChangeDebounced(renderedValue);}var newState={// slider state
sliderValue:sliderValue||this.getSliderSnapValueForQuantityValue(quantityValue),renderedValue:renderedValue,priceValue:priceValue,priceSubtitleValue:priceSubtitleValue,focusPackage:focusPackage,preselectPackage:null,agentsLegend:agentsLegend,// on Esc key always reset slider to already snaped value
edit_mode_initial_slider_value:this.getSliderSnapValueForQuantityValue(quantityValue),edit_mode_initial_input_value:renderedValue,edit_mode_modified_input_value:renderedValue};if(refetchEstimationData){newState=__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({sliderDragged:true},newState,{// XHR state
xhrInProgress:false,apiRequestError:false,apiRequestSuccess:false,errors:{apiError:null}});}if(this.isSliderDisabled()||this.state.apiRequestSuccess&&!__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(newState,'apiRequestSuccess')||this.props.currentPlanId&&this.state.initialQuantity!==renderedValue&&renderedValue<100){newState.showAddSeatsSection=true;}else{newState.showAddSeatsSection=false;}this.setState(newState);}},{key:"isSliderDisabled",value:function isSliderDisabled(){return Boolean(this.state.xhrInProgress||this.props.companies.pendingPayingUserQuantity);}},{key:"isBrokerageSeatsDecrease",value:function isBrokerageSeatsDecrease(){return this.props.currentPlanId===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES&&this.state.renderedValue<this.state.initialQuantity;}},{key:"isBrokerageSeatsIncrease",value:function isBrokerageSeatsIncrease(){return this.props.currentPlanId===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES&&this.state.renderedValue>this.state.initialQuantity;}},{key:"handleUpdateSeats",value:function handleUpdateSeats(){if(this.isBrokerageSeatsDecrease()){var intercomMessage=localize('package-brokerages-downgrade-seats-message',[this.state.initialQuantity,this.state.renderedValue,__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(this.props.user,'mainEmail')]);Object(__WEBPACK_IMPORTED_MODULE_27_utils_intercom__["a" /* openIntercomChat */])(intercomMessage,true,this.props.showErrorPopup);}else{if(this.props.currentPlanId===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT){var upgradeToPlan=__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES;var freeSeatsIncluded=__WEBPACK_IMPORTED_MODULE_26__config__["_3" /* PACKAGES_CONFIG */][upgradeToPlan].freeSeatsIncluded;var _this$props$calculate=this.props.calculateCheckoutData(upgradeToPlan,__WEBPACK_IMPORTED_MODULE_26__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY,false/* isPerpetual */,this.props.quantity),checkoutPricePerMonth=_this$props$calculate.checkoutPricePerMonth,annualPriceTotal=_this$props$calculate.annualPriceTotal,errorLoadingSubscriptionEstimationData=_this$props$calculate.errorLoadingSubscriptionEstimationData,planIsTaxed=_this$props$calculate.planIsTaxed;this.props.handleBuyRequest(upgradeToPlan,__WEBPACK_IMPORTED_MODULE_26__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY,Boolean(this.props.currentPlanId)/* isUpgrade */,false/*isPerpetual*/,__WEBPACK_IMPORTED_MODULE_26__config__["_3" /* PACKAGES_CONFIG */][upgradeToPlan].title,false/* useDiscount*/,this.props.quantity,freeSeatsIncluded,checkoutPricePerMonth,annualPriceTotal,errorLoadingSubscriptionEstimationData,planIsTaxed);}else{this.showPurchaseConfirmationPopup();}}}},{key:"showPurchaseConfirmationPopup",value:function showPurchaseConfirmationPopup(){var _this5=this;var message="".concat(localize('re-packages-add-more-seats-difference',[this.props.totalNumberOfSeats,this.state.renderedValue]));message+="<br>".concat(localize('subscription-extra-users-admin-member-usage'));message+="<br>".concat(localize('re-packages-add-more-seats-new-price',this.state.priceValue));this.showConfirmationPopup(message).then(function(){return _this5.makePurchase();})["catch"](function(){// silent catch - no error logged
});}/**
	 * Show purchase confirmation popup
	 *
	 * @param {string} message HTML message
	 * @returns Promise
	 */},{key:"showConfirmationPopup",value:function showConfirmationPopup(message){var _this6=this;return new Promise(function(resolve,reject){_this6.props.showModal('CONFIRMATION_MODAL',{title:localize('subscription-extra-users-title'),message:{__html:message},buttons:[__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["a" /* Button */],{key:"button-cancel",variant:"outlined",color:"primary",onClick:function onClick(){return reject();}},localize('cancel')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["a" /* Button */],{key:"button-confirm",variant:"contained",color:"primary",onClick:function onClick(){return resolve();}},localize('pay-now'))]});});}},{key:"makePurchase",value:function makePurchase(){this.setState({xhrInProgress:true,apiRequestError:false,apiRequestSuccess:false,errors:{apiError:null}});this.props.buyMoreSeatsCallback();}},{key:"renderUpgradeNowButton",value:function renderUpgradeNowButton(plan){var _this7=this,_classNames;var classes=this.props.classes;var label;var callback;var disabled=false;if(this.props.currentPlanId===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES&&plan===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT){callback=function callback(){var intercomMessage=localize('package-brokerages-downgrade-intercom-message',[__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(_this7.props.user,'mainEmail')]);Object(__WEBPACK_IMPORTED_MODULE_27_utils_intercom__["a" /* openIntercomChat */])(intercomMessage,true,_this7.props.showErrorPopup);};}else if(plan===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT||plan===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES&&this.state.renderedValue<100){var freeSeatsIncluded=__WEBPACK_IMPORTED_MODULE_26__config__["_3" /* PACKAGES_CONFIG */][plan].freeSeatsIncluded;callback=function callback(){var _this7$props$calculat=_this7.props.calculateCheckoutData(plan,__WEBPACK_IMPORTED_MODULE_26__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY,false/* isPerpetual */,_this7.props.quantity),checkoutPricePerMonth=_this7$props$calculat.checkoutPricePerMonth,annualPriceTotal=_this7$props$calculat.annualPriceTotal,errorLoadingSubscriptionEstimationData=_this7$props$calculat.errorLoadingSubscriptionEstimationData,planIsTaxed=_this7$props$calculat.planIsTaxed;if(plan===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT){// temp override for coupon
checkoutPricePerMonth=49.00;}_this7.props.handleBuyRequest(plan,__WEBPACK_IMPORTED_MODULE_26__config__["_41" /* SUBSCRIPTION_PERIOD */].MONTHLY,Boolean(_this7.props.currentPlanId)/* isUpgrade */,false/*isPerpetual*/,__WEBPACK_IMPORTED_MODULE_26__config__["_3" /* PACKAGES_CONFIG */][plan].title,false/* useDiscount*/,_this7.props.quantity,freeSeatsIncluded,checkoutPricePerMonth,annualPriceTotal,errorLoadingSubscriptionEstimationData,planIsTaxed);};}if(plan===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT){disabled=this.props.companies.getSubscriptionEstimateXhrInProgress||this.props.currentPlanId===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT||this.isIndividualAgentDisabled();if(this.isIndividualAgentDisabled()){label=localize('re-packages-plan-disabled');}else if(this.props.cancelledPlanId===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT){label=localize('re-packages-reactivate-plan');}else if(this.props.currentPlanId===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT){label=localize('subscription-plan-tag-current-plan');}else if(this.props.currentPlanId===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES){label=localize('subscription-action-downgrade-to-individual-agent');}else{label=localize('subscription-action-upgrade-now');}}else if(plan===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES){disabled=this.props.companies.getSubscriptionEstimateXhrInProgress&&this.state.renderedValue<100;if(this.state.renderedValue>=100){label=localize('subscription-action-talk-to-sales');}else if(this.props.cancelledPlanId===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES){label=localize('re-packages-reactivate-plan');}else if(this.props.currentPlanId===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES){label=localize('subscription-plan-tag-current-plan');disabled=true;}else{label=localize('subscription-action-upgrade-now');}if(this.state.renderedValue>=100){var agentsNumber=parseInt(this.state.renderedValue)>=500?'500+':this.state.renderedValue;var intercomMessage=localize('package-brokerages-upgrade-intercom-message',[agentsNumber,__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(this.props.user,'mainEmail')]);callback=function callback(){Object(__WEBPACK_IMPORTED_MODULE_27_utils_intercom__["a" /* openIntercomChat */])(intercomMessage,true,_this7.props.showErrorPopup);};}}return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.purchaseButtonContainer},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["a" /* Button */],{variant:plan===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES?'contained':'outlined',"data-tid":"button-subscription-update-".concat(plan),key:"button-subscription-update-".concat(plan),disabled:disabled,className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()((_classNames={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames,classes.button,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames,'disabled',disabled),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames,'updating',this.props.companies.getSubscriptionEstimateXhrInProgress),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames,plan===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES?classes.purchaseButtonContained:classes.purchaseButtonOutlined,true),_classNames)),onClick:callback},label));}},{key:"isIndividualAgentDisabled",value:function isIndividualAgentDisabled(){return this.props.nonGuestUsersNumber>1&&!this.props.currentPlanId;}},{key:"renderStatusAndLinks",value:function renderStatusAndLinks(){var _this8=this;var classes=this.props.classes;var subscriptionStatus;var statusClass;if(this.props.pendingCancellationDate){subscriptionStatus=localize('re-packages-status-pending-cancellation');statusClass=classes.statusCancelled;}else if(this.props.nextBillingDate){subscriptionStatus=localize('re-packages-status-active');statusClass=classes.statusActive;}else if(this.hasCancelledRePackage()){subscriptionStatus=localize('re-packages-status-cancelled');statusClass=classes.statusCancelled;}return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{item:true,container:true,className:classes.statusAndLinksGrid},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{item:true,className:classes.statusGrid},this.props.nextBillingDate&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:"body2",className:classes.nextBilling},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("strong",null,localize('re-packages-next-billing')),": ",this.props.nextBillingDate),(this.hasCancelledRePackage()||this.props.pendingCancellationDate)&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()(classes.status,statusClass)},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("strong",null,localize('re-packages-status')),": ",subscriptionStatus)),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{item:true,className:classes.linksGrid},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["s" /* List */],{className:classes.manageCBList},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["t" /* ListItem */],{className:classes.manageCBListItem},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["r" /* Link */],{component:"button",variant:"body2","data-tid":"re-packages-manage-payment-method",className:classes.manageCBLink,onClick:function onClick(){return _this8.props.showSubscriptionDetails();}},localize('re-packages-manage-payment-method'))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["t" /* ListItem */],{className:classes.manageCBListItem},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["r" /* Link */],{component:"button",variant:"body2","data-tid":"re-packages-view-invoices",className:classes.manageCBLink,onClick:function onClick(){return _this8.props.showSubscriptionDetails();}},localize('re-packages-view-invoices'))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["t" /* ListItem */],{className:classes.manageCBListItem},this.renderCancelOrReactivateLink()))));}},{key:"renderCancelOrReactivateLink",value:function renderCancelOrReactivateLink(){var _this9=this;var classes=this.props.classes;if(this.props.pendingCancellationDate){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["r" /* Link */],{component:"button",variant:"body2","data-tid":"re-packages-cancel-plan",className:classes.manageCBLink,onClick:function onClick(){return _this9.props.showSubscriptionDetails();}},localize('re-packages-revoke-cancellation'));}else if(this.props.currentPlanId){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["r" /* Link */],{component:"button",variant:"body2","data-tid":"re-packages-cancel-plan",className:classes.manageCBLink,onClick:function onClick(){return _this9.props.showSubscriptionDetails();}},localize('re-packages-cancel-plan'));}else if(this.hasCancelledRePackage()){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["r" /* Link */],{component:"button",variant:"body2","data-tid":"re-packages-cancel-plan",className:classes.manageCBLink,onClick:function onClick(){return _this9.props.reactivateMySubscriptionHandler(_this9.props.cancelledSubscription);}},localize('re-packages-reactivate-plan'));}}},{key:"switchToEditMode",value:function switchToEditMode(){this.setState({edit_mode_initial_slider_value:this.state.sliderValue,edit_mode_initial_input_value:this.state.renderedValue,edit_mode_modified_input_value:this.state.renderedValue,isEditMode:true});setTimeout(function(){this.agentsInputValue.current&&this.agentsInputValue.current.focus();}.bind(this),100);}},{key:"handleAgentsNumberClickAwayListener",value:function handleAgentsNumberClickAwayListener(){this.updateSliderFromInput();}},{key:"onAgentsNumberChange",value:function onAgentsNumberChange(event){this.setState({edit_mode_modified_input_value:event.target.value});}},{key:"updateSliderFromInput",value:function updateSliderFromInput(){// On Enter or blur: commit the value and update the slider thumb position.
var parsedInputValue=parseInt(this.agentsInputValue.current.value);// Only integers
var newInputValue=isNaN(parsedInputValue)?1:parsedInputValue;this.refreshAgentsNumberInSlider(newInputValue,true);}},{key:"onAgentsNumberKeyDown",value:function onAgentsNumberKeyDown(event){var _this10=this;if(event.key==='Escape'||event.keyCode===27){// escape
// On Escape: cancel and revert to the previous value.
event.preventDefault();this.setState({edit_mode_modified_input_value:this.state.edit_mode_initial_slider_value},function(){_this10.refreshAgentsNumberInSlider(_this10.state.edit_mode_initial_input_value,true);_this10.agentsInputValue.current&&_this10.agentsInputValue.current.blur();});}else if(event.key==='Enter'||event.keyCode===13){// enter
event.preventDefault();this.updateSliderFromInput();}}},{key:"render",value:function render(){var _this11=this,_classNames3,_classNames4,_classNames5,_classNames6,_classNames7,_classNames8,_classNames9,_classNames10,_classNames11,_classNames12,_classNames13,_classNames14,_classNames15,_classNames16,_classNames17;var sliderValue=this.state.sliderValue;var _this$props=this.props,classes=_this$props.classes,symbol=_this$props.symbol;var individualAgentPrice=__WEBPACK_IMPORTED_MODULE_26__config__["_3" /* PACKAGES_CONFIG */][__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT].basePrice;var individualAgentPriceDiscount=__WEBPACK_IMPORTED_MODULE_26__config__["_3" /* PACKAGES_CONFIG */][__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT].discountPrice;var vatLabel=this.props.getVatLabel(false,this.state.planIsTaxed,true);var valLabelValue=vatLabel?" ".concat(vatLabel):'';var individualAgentPriceString="".concat(symbol).concat(individualAgentPrice," <span>").concat(localize('re-packages-per-month')).concat(valLabelValue,"</span>");var sliderDisabled=this.isSliderDisabled();var renderAgentsQuantityField=function renderAgentsQuantityField(){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["c" /* ClickAwayListener */],{onClickAway:_this11.handleAgentsNumberClickAwayListener},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_FormField__["a" /* default */],{value:_this11.state.edit_mode_modified_input_value,className:classes.agentsQuantityField,"data-tid":"agents-quantity-field",onChange:function onChange(event){return _this11.onAgentsNumberChange(event);},onKeyDown:function onKeyDown(event){return _this11.onAgentsNumberKeyDown(event);},id:"agents-quantity-field",type:"text",autoComplete:"off",margin:"normal",inputRef:_this11.agentsInputValue}));};var renderPendingCancellationDate=function renderPendingCancellationDate(){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:"body2",className:classes.packageEndsOn},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["L" /* Tooltip */],{placement:"bottom",title:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()(classes.infoTooltipText)},localize('subscription-undo-cancellation-info-real-estate')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span",{className:classes.tooltipArrow})),classes:{tooltip:classes.infoTooltip}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["p" /* IconButton */],{className:classes.infoIconButton,color:"primary",component:"span",disableRipple:true},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__theme_icons__["N" /* Info */],null))),localize('re-packages-ends-on')," ",_this11.props.pendingCancellationDate);};var renderCancelledInfo=function renderCancelledInfo(){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:"body2",className:classes.packageEndsOn},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["L" /* Tooltip */],{placement:"bottom",title:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()(classes.infoTooltipText)},localize('subscription-reactivate-plan-info-real-estate')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span",{className:classes.tooltipArrow})),classes:{tooltip:classes.infoTooltip}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["p" /* IconButton */],{className:classes.infoIconButton,color:"primary",component:"span",disableRipple:true},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__theme_icons__["N" /* Info */],null))),localize('re-packages-status-cancelled'));};var renderLoading=function renderLoading(){var classes=_this11.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.loadingWrapper},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__theme_icons__["Y" /* SpinnerIcon */],{className:classes.loadingIcon}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{className:classes.loadingMessage,variant:"body2"},localize('subscriptions-modal-fetching-data')));};var renderSuccessMessage=function renderSuccessMessage(){var classes=_this11.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{className:classes.successMessagesGrid,item:true,container:true},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{className:classes.successMessage,variant:"body2"},localize('re-packages-success-purchasing-seats')));};var renderErrorMessage=function renderErrorMessage(){var errorMessage=__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(_this11.state,'errors.apiError');var classes=_this11.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{className:classes.errorMessagesGrid,item:true,container:true},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{className:classes.errorMessage,variant:"body2",dangerouslySetInnerHTML:{__html:errorMessage}}));};var renderAddSeatsButton=function renderAddSeatsButton(){var _classNames2;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{className:classes.addMoreSeatsWrapper,item:true,container:true},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{item:true,className:classes.addMoreSeatsGrid},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["a" /* Button */],{variant:"contained","data-tid":"button-subscription-seats",key:"button-subscription-seats",className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()((_classNames2={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames2,classes.button,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames2,classes.updateSeatsButton,true),_classNames2)),onClick:_this11.handleUpdateSeats},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__theme_icons__["_4" /* UpdateSeatsIcon */],{className:classes.updateSeatsButtonIcon}),localize('subscription-action-update-seats'))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{item:true,className:classes.addMoreSeatsGrid},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:"body2",className:classes.addMoreSeatsMesssage,dangerouslySetInnerHTML:{__html:localize('re-packages-add-more-seats',[_this11.state.renderedValue,_this11.state.renderedValue>1?_this11.state.priceValue:individualAgentPriceString])}}))),Object.keys(_this11.state.errors).length>0&&renderErrorMessage());};var renderAddSeatsSection=function renderAddSeatsSection(){if(_this11.state.xhrInProgress||_this11.props.companies.pendingPayingUserQuantity){return renderLoading();}else if(_this11.state.apiRequestSuccess){return renderSuccessMessage();}else if(_this11.state.apiRequestError){return renderAddSeatsButton();}else{return renderAddSeatsButton();}};return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.realEstateUiWrapper},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{item:true,container:true,className:classes.sliderHeader},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:"body2",className:classes.sliderTitle},localize('re-packages-slider-title')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:"body2",className:classes.sliderSubtitle},localize('re-packages-slider-subtitle'))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{item:true,container:true,className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()((_classNames3={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames3,classes.sliderWrapper,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames3,'hasCurrency',this.props.shouldRenderCurrencySelector),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames3,'reducedMargin',this.state.showAddSeatsSection),_classNames3))},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{item:true,className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()((_classNames4={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames4,classes.sliderGrid,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames4,'hasCurrency',this.props.shouldRenderCurrencySelector),_classNames4))},this.state.showSlider&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_slider___default.a,{withBars:true,disabled:sliderDisabled,className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()((_classNames5={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames5,classes.slider,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames5,'disabled',sliderDisabled),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames5,'reducedMargin',this.state.showAddSeatsSection),_classNames5)),handleClassName:classes.handle,value:sliderValue,defaultValue:AGENTS_NUMBER_DEFAULT,min:1,max:AGENTS_NUMBER_MAX,step:1,onChange:function onChange(value){return _this11.refreshAgentsNumberInSlider(_this11.getQuantitySnapValueForSliderValue(value),true,null,value);},onAfterChange:function onAfterChange(value){// snap handle on release if slider value is not matching snaped slider value
var sliderRangeForInputValue=_this11.getSliderSnapValueForQuantityValue(_this11.state.renderedValue);if(value!==sliderRangeForInputValue){_this11.refreshAgentsNumberInSlider(_this11.state.renderedValue,true);}}})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{item:true,className:classes.sliderValueWrapper},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:"body2",className:classes.agentsLegendLabel},localize('re-packages-legend-label'),":",this.state.isEditMode?renderAgentsQuantityField():__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span",{className:classes.agentsLegendValue,onClick:this.switchToEditMode},this.state.agentsLegend)),this.state.isEditMode?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()((_classNames6={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames6,classes.quantityNumberInfo,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames6,classes.quantityNumberInfoSave,true),_classNames6))},localize('re-packages-legend-save-info')):__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()((_classNames7={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames7,classes.quantityNumberInfo,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames7,classes.quantityNumberInfoClickToEdit,true),_classNames7))},localize('re-packages-legend-click-info'))),this.props.shouldRenderCurrencySelector&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{item:true,className:classes.currencySelectorGrid},this.props.renderCurrencySelector())),this.state.showAddSeatsSection&&renderAddSeatsSection(),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{item:true,container:true,className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()((_classNames8={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames8,classes.packagesContainerWrapper,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames8,classes.singleAgentCardActive,!this.isIndividualAgentDisabled()&&(this.state.preselectPackage==='single-agent'||this.state.focusPackage==='single-agent'&&this.state.sliderDragged)),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames8,classes.brokeragesCardActive,this.isIndividualAgentDisabled()||this.state.preselectPackage==='brokerages'||this.state.focusPackage==='brokerages'&&this.state.sliderDragged),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames8,classes.brokeragesCurrentPlan,this.props.currentPlanId===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES&&!this.props.pendingCancellationDate),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames8,classes.singleAgentCurrentPlan,this.props.currentPlanId===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT&&!this.props.pendingCancellationDate),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames8,classes.brokeragesPlanPendingCancellation,this.props.currentPlanId===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES&&this.props.pendingCancellationDate),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames8,classes.singleAgentPlanPendingCancellation,this.props.currentPlanId===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT&&this.props.pendingCancellationDate),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames8,classes.brokeragesPlanCancelled,this.props.cancelledPlanId===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames8,classes.singleAgentPlanCancelled,this.props.cancelledPlanId===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames8,classes.brokerageDecreasingSeats,this.isBrokerageSeatsDecrease()&&this.state.renderedValue>1),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames8,classes.brokerageIncreasingSeats,this.isBrokerageSeatsIncrease()&&this.state.renderedValue>1&&!(this.props.currentPlanId===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES&&this.props.pendingCancellationDate)),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames8,classes.singleAgentPlanDisabled,this.isIndividualAgentDisabled()),_classNames8))},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{item:true,className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()((_classNames9={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames9,classes.individualAgentsPackage,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames9,'individualAgentsPackage',true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames9,classes["package"],true),_classNames9))},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()((_classNames10={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames10,'packageTag',true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames10,classes.packageTag,true),_classNames10))},this.props.currentPlanId===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT?localize('subscription-plan-tag-current-plan'):__WEBPACK_IMPORTED_MODULE_26__config__["_3" /* PACKAGES_CONFIG */][__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT].tag),this.props.currentPlanId===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT&&this.props.pendingCancellationDate&&renderPendingCancellationDate(),this.props.cancelledPlanId===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT&&renderCancelledInfo(),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:"h2",className:classes.packageTitle},__WEBPACK_IMPORTED_MODULE_26__config__["_3" /* PACKAGES_CONFIG */][__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT].title),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()((_classNames11={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames11,'packagePrice',true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames11,classes.packagePrice,true),_classNames11)),dangerouslySetInnerHTML:{__html:"<del>".concat(symbol).concat(individualAgentPrice,"</del>\n\t\t\t\t\t\t\t\t\t").concat(symbol).concat(individualAgentPriceDiscount," <span>").concat(localize('re-packages-per-month'),"</span>")}}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{item:true,container:true,className:classes.couponGrid},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{item:true},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()((_classNames12={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames12,'withCode',true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames12,classes.withCode,true),_classNames12)),dangerouslySetInnerHTML:{__html:"".concat(localize('package-with-code'),": <span>AGENT49</span>")}})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{item:true},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["p" /* IconButton */],{"data-tid":"button-copy-coupon",onClick:function onClick(){return _this11.copyCouponCode('AGENT49');},className:classes.iconCopy,color:"primary",component:"span",disableRipple:true},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["L" /* Tooltip */],{placement:"bottom",title:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()(classes.infoTooltipText)},this.state.copied?localize('coupon-copied'):localize('coupon-copy')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span",{className:classes.tooltipArrow})),classes:{tooltip:classes.infoTooltip}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__theme_icons__["h" /* CopyIcon */],{width:"15",height:"18"}))))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:"body2",className:classes.packageSubtitle},__WEBPACK_IMPORTED_MODULE_26__config__["_3" /* PACKAGES_CONFIG */][__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT].subtitle),this.renderFeaturesList('individual-agents-features',__WEBPACK_IMPORTED_MODULE_26__config__["_3" /* PACKAGES_CONFIG */][__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT].individualAgentsFeatureslist),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:"h3",className:classes.featuresGroupTitle},__WEBPACK_IMPORTED_MODULE_26__config__["_3" /* PACKAGES_CONFIG */][__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT].whatYouGetTitle),this.renderFeaturesList('individual-agents-what-you-get',__WEBPACK_IMPORTED_MODULE_26__config__["_3" /* PACKAGES_CONFIG */][__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT].individualAgentsWhatToGet),this.renderUpgradeNowButton(__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].INDIVIDUAL_AGENT)),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{item:true,className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()((_classNames13={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames13,classes.brokeragesPackage,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames13,'brokeragesPackage',true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames13,classes["package"],true),_classNames13))},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()((_classNames14={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames14,'packageTag',true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames14,classes.packageTag,true),_classNames14))},this.props.currentPlanId===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES?localize('subscription-plan-tag-current-plan'):__WEBPACK_IMPORTED_MODULE_26__config__["_3" /* PACKAGES_CONFIG */][__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES].tag),this.props.currentPlanId===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES&&this.props.pendingCancellationDate&&renderPendingCancellationDate(),this.props.cancelledPlanId===__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES&&renderCancelledInfo(),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:"h2",className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()((_classNames15={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames15,'packageTitle',true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames15,classes.packageTitle,true),_classNames15))},__WEBPACK_IMPORTED_MODULE_26__config__["_3" /* PACKAGES_CONFIG */][__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES].title),this.state.priceValue&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()((_classNames16={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames16,'packagePrice',true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames16,classes.packagePrice,true),_classNames16)),dangerouslySetInnerHTML:{__html:this.state.priceValue}}),this.state.priceSubtitleValue&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()((_classNames17={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames17,'packageSubtitle',true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames17,classes.packageSubtitle,true),_classNames17)),dangerouslySetInnerHTML:{__html:this.state.priceSubtitleValue}}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.sectionsList},__WEBPACK_IMPORTED_MODULE_26__config__["_3" /* PACKAGES_CONFIG */][__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES].brokeragesFeatureslist&&__WEBPACK_IMPORTED_MODULE_26__config__["_3" /* PACKAGES_CONFIG */][__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES].brokeragesFeatureslist.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(ExpansionPanel,{key:"brokerages-feature-section-".concat(index)},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(ExpansionPanelSummary,{expandIcon:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_icons_ExpandMore___default.a,{className:classes.sectionsListIcon})},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.sectionsListText},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:"h3",className:classes.sectionsListTitle},item.title),item.description&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:"body2",className:classes.sectionsListDescription},item.description))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(ExpansionPanelDetails,null,_this11.renderFeaturesList('brokerages-features',item.featuresList)));})),this.renderUpgradeNowButton(__WEBPACK_IMPORTED_MODULE_26__config__["_42" /* SUBSCRIPTION_PLAN */].BROKERAGES))),(this.props.currentPlanId||this.props.pendingCancellationDate||this.props.cancelledPlanId)&&this.renderStatusAndLinks());}}]);return RealEstatePackages;}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]))||_class);RealEstatePackages.propTypes={showErrorPopup:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.func.isRequired,classes:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.object,symbol:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.string,renderCurrencySelector:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.func,user:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.object.isRequired,handleBuyRequest:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.func,calculateCheckoutData:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.func,fetchSubscriptionEstimate:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.func,realEstatePlan:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.func,setSeatsQuantity:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.func,quantity:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.number,company:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.object,companies:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.object,currentPlanId:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.string,showSubscriptionDetails:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.func,reactivateMySubscriptionHandler:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.func,buyMoreSeatsCallback:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.func,nextBillingDate:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.string,pendingCancellationDate:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.string,cancelledPlanId:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.string,cancelledSubscription:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.object,totalNumberOfSeats:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.number,getVatLabel:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.func,nonGuestUsersNumber:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.number,membersPaidQuantity:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.number,showModal:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.func,shouldRenderCurrencySelector:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.bool};var mapStateToProps=function mapStateToProps(state){return{user:state.session.user,company:state.companies.rawDataById[state.companies.selectedId],companies:state.companies};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_16_redux__["b" /* bindActionCreators */])({setSeatsQuantity:__WEBPACK_IMPORTED_MODULE_29_redux_modules_app__["r" /* setSeatsQuantity */],showModal:__WEBPACK_IMPORTED_MODULE_17_redux_modules_modal__["d" /* showModal */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_15_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(RealEstatePackages));

/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChargeBee; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(17);
var ChargeBee=window.Chargebee&&window.Chargebee.init({site:__WEBPACK_IMPORTED_MODULE_0__config__["q" /* CHARGEBEE_SITE_URL */],enableGATracking:__WEBPACK_IMPORTED_MODULE_0__config__["o" /* CHARGEBEE_ENABLE_GA_TRACKING */],enableRefersionTracking:__WEBPACK_IMPORTED_MODULE_0__config__["p" /* CHARGEBEE_ENABLE_REFERSION_TRACKING */]});

/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Paper__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button_Button__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_TextField__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_Select__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_MenuItem__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_styles_colorManipulator__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_styles_colorManipulator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_styles_colorManipulator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_icons_KeyboardArrowDown__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_icons_KeyboardArrowDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_icons_KeyboardArrowDown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_Link__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_Popover__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_Popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_icons_Info__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_icons_Info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__material_ui_icons_Info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_Tabs__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_core_Tab__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_core_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_Tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__material_ui_core_Table__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__material_ui_core_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__material_ui_core_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__material_ui_core_TableBody__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__material_ui_core_TableBody___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__material_ui_core_TableBody__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__material_ui_core_TableCell__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__material_ui_core_TableCell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__material_ui_core_TableCell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__material_ui_core_TableHead__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__material_ui_core_TableHead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__material_ui_core_TableHead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__material_ui_core_TableRow__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__material_ui_core_TableRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__material_ui_core_TableRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__material_ui_core_IconButton__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__material_ui_core_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__material_ui_core_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_theme_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_redux_modules_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_i18n_i18n__ = __webpack_require__(15);
var _dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_35_i18n_i18n__["a" /* default */].loc.localize;var styles=function styles(theme){return{container:{padding:"".concat(6*theme.spacing.unit,"px ").concat(8*theme.spacing.unit,"px")},paper:__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_objectSpread___default()({},theme.mixins.gutters(),{paddingTop:theme.spacing.unit*2,paddingBottom:theme.spacing.unit*2,height:'100%'}),tabsPaper:{background:'#eee'},inheritButton:{color:theme.palette.common.white,backgroundColor:'#4acfce','&:disabled':{backgroundColor:Object(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_styles_colorManipulator__["fade"])('#4acfce',0.3)},'&:hover':{backgroundColor:'#80ffff'}},flexColumnList:{display:'flex',flexDirection:'column',alignItems:'center'},flexRowList:{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center'},table:{tableLayout:'fixed'},tableAccountCell:{width:160},tableActionsCell:{width:50}};};var Showcase=(_dec=Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(Showcase,_Component);function Showcase(props){var _this;__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,Showcase);_this=__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Showcase).call(this,props));_this.triggerModal=_this.triggerModal.bind(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.state={infoAnchor:null,tabValue:0};return _this;}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Showcase,[{key:"render",value:function render(){var _this2=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{className:classes.container},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{container:true,spacing:16,alignItems:"stretch"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography___default.a,{variant:"h1",gutterBottom:true},localize('showcase-headline1')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography___default.a,{variant:"h2",gutterBottom:true},localize('showcase-headline2')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography___default.a,{variant:"h3",gutterBottom:true},localize('showcase-headline3')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography___default.a,{variant:"caption",gutterBottom:true},localize('showcase-caption')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography___default.a,{variant:"subtitle1",gutterBottom:true},localize('showcase-explanation')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography___default.a,{variant:"body1",gutterBottom:true},localize('showcase-body1')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography___default.a,{variant:"body2"},localize('showcase-body2')))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Paper___default.a,{className:__WEBPACK_IMPORTED_MODULE_31_classnames___default()(classes.paper,classes.flexColumnList)},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button_Button___default.a,{variant:"contained",color:"primary",size:"small"},localize('save')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button_Button___default.a,{variant:"contained",color:"primary",size:"small",disabled:true},localize('save')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button_Button___default.a,{variant:"contained",color:"secondary",size:"small"},localize('delete')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button_Button___default.a,{variant:"contained",color:"secondary",size:"small",disabled:true},localize('delete')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button_Button___default.a,{variant:"contained",color:"inherit",size:"small",className:classes.inheritButton},localize('showcase-launch-editor')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button_Button___default.a,{variant:"contained",color:"inherit",size:"small",disabled:true,className:classes.inheritButton},localize('showcase-launch-editor')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button_Button___default.a,{variant:"contained",size:"small"},localize('cancel')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button_Button___default.a,{variant:"contained",size:"small",disabled:true},localize('cancel')))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Paper___default.a,{className:__WEBPACK_IMPORTED_MODULE_31_classnames___default()(classes.paper,classes.flexColumnList)},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button_Button___default.a,{variant:"contained",color:"primary"},localize('save')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button_Button___default.a,{variant:"contained",color:"primary",disabled:true},localize('save')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button_Button___default.a,{variant:"contained",color:"secondary"},localize('delete')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button_Button___default.a,{variant:"contained",color:"secondary",disabled:true},localize('delete')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button_Button___default.a,{variant:"contained",color:"inherit",className:classes.inheritButton},localize('showcase-launch-editor')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button_Button___default.a,{variant:"contained",color:"inherit",disabled:true,className:classes.inheritButton},localize('showcase-launch-editor')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button_Button___default.a,{variant:"contained"},localize('cancel')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button_Button___default.a,{variant:"contained",disabled:true},localize('cancel')))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Paper___default.a,{className:__WEBPACK_IMPORTED_MODULE_31_classnames___default()(classes.paper,classes.flexColumnList)},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button_Button___default.a,{variant:"contained",color:"primary",size:"large"},localize('save')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button_Button___default.a,{variant:"contained",color:"primary",size:"large",disabled:true},localize('save')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button_Button___default.a,{variant:"contained",color:"secondary",size:"large"},localize('delete')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button_Button___default.a,{variant:"contained",color:"secondary",size:"large",disabled:true},localize('delete')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button_Button___default.a,{variant:"contained",color:"inherit",size:"large",className:classes.inheritButton},localize('showcase-launch-editor')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button_Button___default.a,{variant:"contained",color:"inherit",size:"large",disabled:true,className:classes.inheritButton},localize('showcase-launch-editor')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button_Button___default.a,{variant:"contained",size:"large"},localize('cancel')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button_Button___default.a,{variant:"contained",size:"large",disabled:true},localize('cancel')))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Paper___default.a,{className:__WEBPACK_IMPORTED_MODULE_31_classnames___default()(classes.paper,classes.flexColumnList)},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{container:true,spacing:8},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_TextField___default.a,{id:"email",name:"email",type:"email",placeholder:localize('showcase-email-placeholder'),fullWidth:true,InputProps:{disableUnderline:true}})),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_TextField___default.a,{id:"email2",name:"email2",type:"email",placeholder:localize('showcase-email-placeholder'),value:localize('showcase-email-value'),fullWidth:true,InputProps:{disableUnderline:true}})),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_TextField___default.a,{id:"disabled",name:"disabled",placeholder:localize('showcase-disabled-placeholder'),value:localize('showcase-disabled-value'),disabled:true,fullWidth:true,InputProps:{disableUnderline:true}})),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_Select___default.a,{value:"",name:"age",displayEmpty:true,disableUnderline:true,fullWidth:true,IconComponent:__WEBPACK_IMPORTED_MODULE_18__material_ui_icons_KeyboardArrowDown___default.a},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_MenuItem___default.a,{value:"",disabled:true},localize('showcase-select-placeholder')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_MenuItem___default.a,{value:10},localize('showcase-select-option-10')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_MenuItem___default.a,{value:20},localize('showcase-select-option-20')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_MenuItem___default.a,{value:30},localize('showcase-select-option-30')))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_TextField___default.a,{placeholder:localize('showcase-multiline-placeholder'),multiline:true,rows:"4",fullWidth:true,InputProps:{disableUnderline:true}}))))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Paper___default.a,{className:__WEBPACK_IMPORTED_MODULE_31_classnames___default()(classes.paper,classes.flexColumnList)},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{container:true,spacing:8},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true,xs:4,className:classes.flexRowList},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Link___default.a,{variant:"body1",onClick:this.triggerModal('CONFIRMATION_MODAL',localize('showcase-confirmation-popup-title'),{__html:localize('showcase-confirmation-popup-message')},[__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button_Button___default.a,{key:"button-cancel",variant:"outlined",color:"primary",onClick:function onClick(){}},localize('cancel')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button_Button___default.a,{key:"button-confirm",variant:"contained",color:"primary",onClick:function onClick(){}},localize('showcase-confirmation-popup-confirm'))])},localize('showcase-confirmation-popup'))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true,xs:4,className:classes.flexRowList},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Link___default.a,{variant:"body1",color:"inherit",onClick:this.triggerModal('ERROR_MODAL')},localize('showcase-error-popup'))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true,xs:4,className:classes.flexRowList},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography___default.a,{variant:"body1",inline:true},localize('showcase-info-link')),"\xA0",__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_icons_Info___default.a,{color:"primary","aria-owns":this.state.infoAnchor?'info-popover':undefined,"aria-haspopup":"true",onClick:function onClick(event){return _this2.setState({infoAnchor:event.target});}}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Popover___default.a,{id:"info-popover",className:classes.popover,open:!!this.state.infoAnchor,anchorEl:this.state.infoAnchor,anchorOrigin:{vertical:'top',horizontal:'center'},transformOrigin:{vertical:'bottom',horizontal:'center'},onClose:function onClose(){return _this2.setState({infoAnchor:null});},disableRestoreFocus:true},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography___default.a,{variant:"subtitle1",gutterBottom:true},localize('showcase-info-title')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography___default.a,{variant:"body2",dangerouslySetInnerHTML:{__html:localize('showcase-info-text1')}}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography___default.a,{variant:"body2",dangerouslySetInnerHTML:{__html:localize('showcase-info-text2')}}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography___default.a,{variant:"body2",dangerouslySetInnerHTML:{__html:localize('showcase-info-text3')}})))))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Paper___default.a,{className:__WEBPACK_IMPORTED_MODULE_31_classnames___default()(classes.paper,classes.tabsPaper)},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_Tabs___default.a,{value:this.state.tabValue,onChange:function onChange(event,value){return _this2.setState({tabValue:value});}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_Tab___default.a,{label:localize('showcase-tab1'),disableRipple:true}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_Tab___default.a,{label:localize('showcase-tab2'),disableRipple:true}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_Tab___default.a,{label:localize('showcase-tab3'),disableRipple:true})),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Paper___default.a,{elevation:0,square:true,style:{padding:20}},this.state.tabValue===0&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography___default.a,{variant:"body2"},localize('showcase-tab1')),this.state.tabValue===1&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography___default.a,{variant:"body2"},localize('showcase-tab2')),this.state.tabValue===2&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography___default.a,{variant:"body2"},localize('showcase-tab3'))))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Paper___default.a,{className:__WEBPACK_IMPORTED_MODULE_31_classnames___default()(classes.paper)},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core_Table___default.a,{className:classes.table},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core_TableHead___default.a,null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__material_ui_core_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__material_ui_core_TableCell___default.a,null,localize('showcase-table-head-email')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__material_ui_core_TableCell___default.a,{className:classes.tableAccountCell,align:"center"},localize('showcase-table-head-account-type')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__material_ui_core_TableCell___default.a,{className:classes.tableActionsCell,align:"right"}))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core_TableBody___default.a,null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__material_ui_core_TableRow___default.a,{hover:true},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__material_ui_core_TableCell___default.a,null,localize('showcase-table-body-email')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__material_ui_core_TableCell___default.a,{align:"center",padding:"dense"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_Select___default.a,{value:"10",name:"accountType",displayEmpty:true,disableUnderline:true,fullWidth:true,IconComponent:__WEBPACK_IMPORTED_MODULE_18__material_ui_icons_KeyboardArrowDown___default.a},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_MenuItem___default.a,{value:"",disabled:true},localize('showcase-table-select-option1')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_MenuItem___default.a,{value:10},localize('showcase-table-select-option2')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_MenuItem___default.a,{value:20},localize('showcase-table-select-option3')))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__material_ui_core_TableCell___default.a,{align:"right",padding:"none"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__material_ui_core_IconButton___default.a,{color:"secondary",component:"span",disableRipple:true},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30_theme_icons__["k" /* DeleteIcon */],null)))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__material_ui_core_TableRow___default.a,{hover:true},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__material_ui_core_TableCell___default.a,null,localize('showcase-table-body-email')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__material_ui_core_TableCell___default.a,{align:"center",padding:"dense"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_Select___default.a,{value:"20",name:"accountType",displayEmpty:true,disableUnderline:true,fullWidth:true,IconComponent:__WEBPACK_IMPORTED_MODULE_18__material_ui_icons_KeyboardArrowDown___default.a},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_MenuItem___default.a,{value:"",disabled:true},localize('showcase-table-select-option1')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_MenuItem___default.a,{value:10},localize('showcase-table-select-option2')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_MenuItem___default.a,{value:20},localize('showcase-table-select-option3')))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__material_ui_core_TableCell___default.a,{align:"right",padding:"none"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__material_ui_core_IconButton___default.a,{color:"secondary",component:"span",disableRipple:true},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30_theme_icons__["k" /* DeleteIcon */],null)))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__material_ui_core_TableRow___default.a,{hover:true},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__material_ui_core_TableCell___default.a,null,localize('showcase-table-body-email')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__material_ui_core_TableCell___default.a,{align:"center",padding:"dense"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_Select___default.a,{value:"10",name:"accountType",displayEmpty:true,disableUnderline:true,fullWidth:true,IconComponent:__WEBPACK_IMPORTED_MODULE_18__material_ui_icons_KeyboardArrowDown___default.a},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_MenuItem___default.a,{value:"",disabled:true},localize('showcase-table-select-option1')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_MenuItem___default.a,{value:10},localize('showcase-table-select-option2')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_MenuItem___default.a,{value:20},localize('showcase-table-select-option3')))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__material_ui_core_TableCell___default.a,{align:"right",padding:"none"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__material_ui_core_IconButton___default.a,{color:"secondary",component:"span",disableRipple:true},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30_theme_icons__["k" /* DeleteIcon */],null)))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__material_ui_core_TableRow___default.a,{hover:true},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__material_ui_core_TableCell___default.a,null,localize('showcase-table-body-email')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__material_ui_core_TableCell___default.a,{align:"center",padding:"dense"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_Select___default.a,{value:"20",name:"accountType",displayEmpty:true,disableUnderline:true,fullWidth:true,IconComponent:__WEBPACK_IMPORTED_MODULE_18__material_ui_icons_KeyboardArrowDown___default.a},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_MenuItem___default.a,{value:"",disabled:true},localize('showcase-table-select-option1')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_MenuItem___default.a,{value:10},localize('showcase-table-select-option2')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_MenuItem___default.a,{value:20},localize('showcase-table-select-option3')))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__material_ui_core_TableCell___default.a,{align:"right",padding:"none"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__material_ui_core_IconButton___default.a,{color:"secondary",component:"span",disableRipple:true},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30_theme_icons__["k" /* DeleteIcon */],null)))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__material_ui_core_TableRow___default.a,{hover:true},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__material_ui_core_TableCell___default.a,null,localize('showcase-table-body-email')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__material_ui_core_TableCell___default.a,{align:"center",padding:"dense"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_Select___default.a,{value:"10",name:"accountType",displayEmpty:true,disableUnderline:true,fullWidth:true,IconComponent:__WEBPACK_IMPORTED_MODULE_18__material_ui_icons_KeyboardArrowDown___default.a},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_MenuItem___default.a,{value:"",disabled:true},localize('showcase-table-select-option1')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_MenuItem___default.a,{value:10},localize('showcase-table-select-option2')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_MenuItem___default.a,{value:20},localize('showcase-table-select-option3')))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__material_ui_core_TableCell___default.a,{align:"right",padding:"none"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__material_ui_core_IconButton___default.a,{color:"secondary",component:"span",disableRipple:true},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30_theme_icons__["k" /* DeleteIcon */],null))))))))));}},{key:"triggerModal",value:function triggerModal(modalType,title,message,buttons){var _this3=this;return function(){_this3.props.showModal(modalType,{title:title,message:message,buttons:buttons});};}}]);return Showcase;}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]))||_class);Showcase.propTypes={classes:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.object,showModal:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_32_redux__["b" /* bindActionCreators */])({showModal:__WEBPACK_IMPORTED_MODULE_34_redux_modules_modal__["d" /* showModal */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_33_react_redux__["b" /* connect */])(null,mapDispatchToProps)(Showcase));

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(203));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
})), 'Info');

exports.default = _default;

/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_OnBoardingWizard_OnBoardingWizard__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_redux_modules_session__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_routes__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Steps__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_containers_App_AppContext__ = __webpack_require__(453);
/**
 * The onboarding container that renders the onboarding wizard with the given steps
 */var OnBoarding=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(OnBoarding,_Component);function OnBoarding(props){var _this;__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this,OnBoarding);_this=__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(OnBoarding).call(this));_this.complete=_this.complete.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.stepFulfilled=_this.stepFulfilled.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.stepSkipped=_this.stepSkipped.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.state={// The completed flag indicates if the onboarding has finished.
// We store its value in state and don't update when a new props
// are received. This is because the last step gets fulfilled
// automatically when it's shown, but we need to keep this step
// on screen until the user reloads a page. If the completed flag
// is set to true we redirect to the root.
completed:__WEBPACK_IMPORTED_MODULE_17_lodash___default.a.get(props.settings,'completed',false)};return _this;}__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(OnBoarding,[{key:"render",value:function render(){var _this2=this;var completed=this.state.completed;var _this$props$settings=this.props.settings,fulfilled=_this$props$settings.fulfilled,skipped=_this$props$settings.skipped;if(completed){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["c" /* Redirect */],{to:__WEBPACK_IMPORTED_MODULE_16_routes__["l" /* ROOT */]});}return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_containers_App_AppContext__["a" /* default */].Consumer,null,function(context){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_OnBoardingWizard_OnBoardingWizard__["a" /* default */],{steps:__WEBPACK_IMPORTED_MODULE_18__Steps__["b" /* default */],fulfilledSteps:fulfilled,skippedSteps:skipped,onCompleted:_this2.complete,onStepFulfilled:_this2.stepFulfilled,onStepSkipped:_this2.stepSkipped,onStepActive:context.scrollContentToTop});});}/**
	 * Completes the onboarding
	 */},{key:"complete",value:function complete(){this.syncSettings({completed:true});}/**
	 * Fulfills a step by adding current step to the fulfilled array and syncing with the server
	 * @param oId {String} The step identifier
	 */},{key:"stepFulfilled",value:function stepFulfilled(oId){var _this$props$settings2=this.props.settings,settings=_this$props$settings2===void 0?{}:_this$props$settings2;var _settings$fulfilled=settings.fulfilled,fulfilled=_settings$fulfilled===void 0?[]:_settings$fulfilled;if(fulfilled.indexOf(oId)===-1){fulfilled.push(oId);this.syncSettings({fulfilled:fulfilled});}}/**
	 * Skips a step by adding current step to the skipped array and syncing with the server
	 * @param oId {String} The step identifier
	 */},{key:"stepSkipped",value:function stepSkipped(oId){var _this$props$settings3=this.props.settings,settings=_this$props$settings3===void 0?{}:_this$props$settings3;var _settings$skipped=settings.skipped,skipped=_settings$skipped===void 0?[]:_settings$skipped;if(skipped.indexOf(oId)===-1){skipped.push(oId);this.syncSettings({skipped:skipped});}}/**
	 * Sync settings with the server by sending request to it
	 * @param settings {Object} Settings object
	 */},{key:"syncSettings",value:function syncSettings(settings){this.props.writeUserSettings(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({},__WEBPACK_IMPORTED_MODULE_15_config__["_1" /* ONBOARDING_KEY */],__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},settings)));}}]);return OnBoarding;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);OnBoarding.defaultProps={settings:{}};OnBoarding.propTypes={settings:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,// settings from session.user
writeUserSettings:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func// action creator from session module
};var mapStateToProps=function mapStateToProps(state){return{settings:__WEBPACK_IMPORTED_MODULE_17_lodash___default.a.get(state.session,"user.settings.".concat(__WEBPACK_IMPORTED_MODULE_15_config__["k" /* CAP_KEY */],".").concat(__WEBPACK_IMPORTED_MODULE_15_config__["_1" /* ONBOARDING_KEY */]))};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_12_redux__["b" /* bindActionCreators */])({writeUserSettings:__WEBPACK_IMPORTED_MODULE_14_redux_modules_session__["d" /* writeUserSettings */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(OnBoarding));

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__OnBoardingOverlay__ = __webpack_require__(1137);
var _dec,_class;/**
 * The onboarding wizard that is responsible for showing, navigating, fulfilling and skipping steps
 */var styles=function styles(theme){return{root:{minHeight:'100%',display:'flex',flexDirection:'column'},step:{display:'flex',flexDirection:'column',flexGrow:'1',padding:'20px 60px 10px'},navigation:{display:'flex',alignSelf:'center',marginBottom:33},navigationItem:{padding:7,'&:after':{content:'""',display:'block',width:9,height:9,borderRadius:20,boxShadow:"inset 0 0 0 1px ".concat(theme.palette.colors.alpha),transition:theme.transitions.create('box-shadow')}},navigationItemActive:{'&:after':{boxShadow:"inset 0 0 0 20px ".concat(theme.palette.colors.alpha)}},overlay:{transition:theme.transitions.create('transform',{easing:theme.transitions.easing.easeOut,duration:theme.transitions.duration.leavingScreen})}};};var OnboardingWizard=(_dec=Object(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(OnboardingWizard,_Component);function OnboardingWizard(props){var _this;__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this,OnboardingWizard);_this=__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(OnboardingWizard).call(this,props));_this.go=_this.go.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.prev=_this.prev.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.next=_this.next.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.onStepFulfilled=_this.onStepFulfilled.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.onStepSkipped=_this.onStepSkipped.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.state={step:_this.getStep(props),stay:false};return _this;}__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(OnboardingWizard,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(props){var _this2=this;var step=this.getStep(props);if(!this.state.stay&&step!==this.state.step){this.setState({step:step},function(){_this2.props.onStepActive(step);});}}},{key:"render",value:function render(){var _this$props$classes=this.props.classes,root=_this$props$classes.root,step=_this$props$classes.step,navigation=_this$props$classes.navigation,overlay=_this$props$classes.overlay;if(!this.steps.length){return null;}return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{className:root},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{className:step},this.renderStep()),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{className:navigation},this.renderNavigation()),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__OnBoardingOverlay__["a" /* default */],{oId:this.state.step,classes:{root:overlay}}));}/**
	 * Renders single step based on the step from state
	 * @returns The onboarding step
	 */},{key:"renderStep",value:function renderStep(){var step=this.state.step;var Step=Object(__WEBPACK_IMPORTED_MODULE_10_lodash__["find"])(this.steps,function(Step){return Step.oId===step;});return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Step,{onboarding:{fulfilled:this.props.fulfilledSteps,skipped:this.props.skippedSteps,complete:this.props.onCompleted,fulfillStep:this.onStepFulfilled,skipStep:this.onStepSkipped,nextStep:this.next,prevStep:this.prev}});}/**
	 * Render the onboarding navigation
	 * @returns The array of <div /> elements
	 */},{key:"renderNavigation",value:function renderNavigation(){var _this$props$classes2=this.props.classes,navigationItem=_this$props$classes2.navigationItem,navigationItemActive=_this$props$classes2.navigationItemActive;var step=this.state.step;return this.steps.map(function(Step){var _classNames;var oId=Step.oId;var stepClassName=__WEBPACK_IMPORTED_MODULE_9_classnames___default()((_classNames={},__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_classNames,navigationItem,true),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_classNames,navigationItemActive,oId===step),_classNames));return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{key:"onboarding-nav-".concat(oId),className:stepClassName,"data-step":oId});});}/**
	 * Goes to the given step
	 * @param step Step identifier
	 */},{key:"go",value:function go(step){var _this3=this;if(step!==this.state.step){this.setState({step:step},function(){_this3.props.onStepActive(step);});}}/**
	 * Navigates to next step
	 */},{key:"next",value:function next(){var current=this.state.step;var step=this.findNextStep()||current;this.go(step);}/**
	 * Navigates to previous step
	 */},{key:"prev",value:function prev(){var current=this.state.step;var step=this.findPrevStep()||current;this.go(step);}/**
	 * Finds next step based on the current step
	 * @returns Step identifier
	 */},{key:"findNextStep",value:function findNextStep(){var _this4=this;var step=this.state.step;var index=Object(__WEBPACK_IMPORTED_MODULE_10_lodash__["findIndex"])(this.steps,function(Step){return Step.oId===_this4.state.step;});var _ref=this.steps[index+1]||step,oId=_ref.oId;return oId;}/**
	 * Finds prev step based on the current step
	 * @returns Step identifier
	 */},{key:"findPrevStep",value:function findPrevStep(){var _this5=this;var step=this.state.step;var index=Object(__WEBPACK_IMPORTED_MODULE_10_lodash__["findIndex"])(this.steps,function(Step){return Step.oId===_this5.state.step;});var _ref2=this.steps[index-1]||step,oId=_ref2.oId;return oId;}/**
	 * Fulfills a step
	 * @param stay Flag that indicates if the wizard should not navigate to next step
	 */},{key:"onStepFulfilled",value:function onStepFulfilled(){var _this6=this;var stay=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var step=this.state.step;this.setState({stay:stay},function(){_this6.props.onStepFulfilled(step);});}/**
	 * Skips a step
	 */},{key:"onStepSkipped",value:function onStepSkipped(){var step=this.state.step;this.props.onStepSkipped(step);}/**
	 * Returns a step based on current props. It checks the fulfilled and skipped steps and returns
	 * only next step that doesn't exist in both arrays.
	 * @param props Current properties
	 * @returns {Object|undefined} Steps if found
	 */},{key:"getStep",value:function getStep(props){var fulfilledSteps=props.fulfilledSteps,skippedSteps=props.skippedSteps;var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=this.steps[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var Step=_step.value;if(fulfilledSteps.indexOf(Step.oId)===-1&&skippedSteps.indexOf(Step.oId)===-1){return Step.oId;}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator["return"]!=null){_iterator["return"]();}}finally{if(_didIteratorError){throw _iteratorError;}}}}/**
	 * Steps getter
	 * @returns The onboarding steps
	 */},{key:"steps",get:function get(){return this.props.steps;}}]);return OnboardingWizard;}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]))||_class);OnboardingWizard.propTypes={classes:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,steps:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.array.isRequired,fulfilledSteps:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.array,skippedSteps:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.array,onStepFulfilled:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,onStepSkipped:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,onStepActive:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,onCompleted:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func};OnboardingWizard.defaultProps={fulfilledSteps:[],skippedSteps:[],onStepFulfilled:__WEBPACK_IMPORTED_MODULE_10_lodash__["noop"],onStepSkipped:__WEBPACK_IMPORTED_MODULE_10_lodash__["noop"],onStepActive:__WEBPACK_IMPORTED_MODULE_10_lodash__["noop"],onCompleted:__WEBPACK_IMPORTED_MODULE_10_lodash__["noop"]};/* harmony default export */ __webpack_exports__["a"] = (OnboardingWizard);

/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_theme_uiConfig__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
var _dec,_class;/**
 * Renders the onboarding overlay over the left menu
 */var RESIZE_DEBOUNCE_TIME=100;var styles=function styles(theme){return{root:{position:'fixed',left:0,top:__WEBPACK_IMPORTED_MODULE_9_theme_uiConfig__["f" /* topBarHeight */],bottom:60,// don't cover Xara logo
width:"calc(".concat(__WEBPACK_IMPORTED_MODULE_9_theme_uiConfig__["c" /* mainNavWidth */],"px - 1px)"),// border or shadow
zIndex:theme.zIndex.drawer}};};var OnboardingOverlay=(_dec=Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(OnboardingOverlay,_Component);function OnboardingOverlay(props){var _this;__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,OnboardingOverlay);_this=__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(OnboardingOverlay).call(this,props));_this.onResize=Object(__WEBPACK_IMPORTED_MODULE_10_lodash__["debounce"])(_this.onResize.bind(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this)),RESIZE_DEBOUNCE_TIME);_this.state={node:null};return _this;}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(OnboardingOverlay,[{key:"setNode",value:function setNode(props){this.setState({node:window.document.querySelector("[data-oid=\"".concat(props.oId,"\"]"))});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(props){this.setNode(props);}},{key:"componentDidMount",value:function componentDidMount(){window.addEventListener('resize',this.onResize);this.setNode(this.props);}},{key:"componentWillUnmount",value:function componentWillUnmount(){window.removeEventListener('resize',this.onResize);}},{key:"onResize",value:function onResize(){this.setNode(this.props);}},{key:"render",value:function render(){var root=this.props.classes.root;var node=this.state.node;if(!node){return null;}return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:root,style:{backgroundImage:this.backgroundStyle}});}},{key:"backgroundStyle",get:function get(){var node=this.state.node;var _node$getBoundingClie=node.getBoundingClientRect(),top=_node$getBoundingClie.top,height=_node$getBoundingClie.height;var color='rgba(255, 255, 255, 0.81)';var coordA="calc(".concat(top,"px - ").concat(__WEBPACK_IMPORTED_MODULE_9_theme_uiConfig__["f" /* topBarHeight */],"px)");var coordB="calc(".concat(top+height,"px - ").concat(__WEBPACK_IMPORTED_MODULE_9_theme_uiConfig__["f" /* topBarHeight */],"px)");return"linear-gradient(\n\t\t\tto bottom, \n\t\t\t".concat(color," ").concat(coordA,", \n\t\t\ttransparent ").concat(coordA,", \n\t\t\ttransparent ").concat(coordB,", \n\t\t\t").concat(color," ").concat(coordB,"\n\t\t)");}}]);return OnboardingOverlay;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]))||_class);OnboardingOverlay.propTypes={classes:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,oId:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (OnboardingOverlay);

/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_i18n_i18n__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Header__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Description__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_FileUploader_FileUploader__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Features_components__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_Table__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_TableBody__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_TableBody___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_TableBody__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_TableCell__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_TableCell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_TableCell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_TableHead__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_TableHead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_TableHead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_TableRow__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_TableRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_TableRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_core_IconButton__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_core_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_theme_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_redux_modules_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_redux_modules_companies__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_cursor__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_components_CenteredContent_CenteredContent__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_StickyHeader_StickyHeader__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__errors_apperror__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__errors_errorids__ = __webpack_require__(22);
var _dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_11_i18n_i18n__["a" /* default */].loc.localize;var styles={uploadButton:{marginBottom:20}};var Fonts=(_dec=Object(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Fonts,_Component);function Fonts(){var _this;__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this,Fonts);_this=__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Fonts).call(this));_this.uploader=null;_this.handleUpload=_this.handleUpload.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.uploadFont=_this.uploadFont.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));return _this;}__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Fonts,[{key:"render",value:function render(){var _this2=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_components_CenteredContent_CenteredContent__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__components_StickyHeader_StickyHeader__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Header__["a" /* default */],null,localize('fonts-header')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Description__["a" /* default */],{variant:"body2",dangerousInnerHTML:localize('fonts-description')}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_Features_components__["a" /* Button */],{feature:"FONT_UPLOAD",variant:"contained",color:"primary","data-tid":"button-fonts-upload",onClick:function onClick(){return _this2.uploader.openPicker();},title:localize('fonts-upload-button'),className:classes.uploadButton},localize('fonts-upload-button')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Table___default.a,null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_TableHead___default.a,null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_TableCell___default.a,{padding:"none",style:{border:0}},localize('fonts-table-header')))))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Table___default.a,null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_TableBody___default.a,null,this.renderRows())),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_FileUploader_FileUploader__["a" /* default */],{ref:function ref(uploader){return _this2.uploader=uploader;},multiple:true,accept:__WEBPACK_IMPORTED_MODULE_28__config__["J" /* FONTS_ACCEPTED_FILE_TYPES */].join(','),onUpload:this.handleUpload}));}},{key:"renderRows",value:function renderRows(){var _this3=this;var fonts=this.props.fonts;return fonts.map(function(font,index){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_TableRow___default.a,{key:"font-".concat(index),hover:true,"data-tid":"button-fonts-row-".concat(index)},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_TableCell___default.a,{padding:"none"},font.internalFontId),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_TableCell___default.a,{align:"right",padding:"none"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_IconButton___default.a,{"data-tid":"button-fonts-delete-".concat(index),color:"secondary",component:"span",onClick:function onClick(){return _this3.handleRemove(font);},"aria-label":"Delete"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_theme_icons__["k" /* DeleteIcon */],null))));});}},{key:"handleRemove",value:function handleRemove(font){var _this4=this;this.props.showModal('CONFIRMATION_MODAL',{message:localize('fonts-delete-confirmation'),buttons:[__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_Features_components__["a" /* Button */],{"data-tid":"button-fonts-confirm-cancel",key:"button-cancel",variant:"outlined",color:"primary"},localize('cancel')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_Features_components__["a" /* Button */],{key:"button-confirm","data-tid":"`button-fonts-confirm-delete",variant:"contained",color:"primary",onClick:function onClick(){return _this4.props.removeCompanyFont(font);}},localize('delete'))]});}},{key:"handleUpload",value:function handleUpload(fonts){var _this5=this;this.uploadSequence(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(fonts),function(font){return new Promise(function(resolve){var exists=_this5.fontExists(font);var uploadAndResolve=function uploadAndResolve(){return _this5.uploadFont(font,exists).then(resolve);};if(exists){_this5.triggerFontExistsPopup(font,uploadAndResolve,resolve);}else{uploadAndResolve();}});});}},{key:"uploadSequence",value:function uploadSequence(fonts,callback){return fonts.reduce(function(promise,task){return promise.then(function(){return callback(task);});},Promise.resolve());}},{key:"uploadFont",value:function uploadFont(font,replaceMode){var _this6=this;var data=new FormData();data.append('font',font);Object(__WEBPACK_IMPORTED_MODULE_27__utils_cursor__["b" /* changeCursor */])(__WEBPACK_IMPORTED_MODULE_27__utils_cursor__["a" /* PROGRESS */]);return this.props.addCompanyFont(data,replaceMode).then(function(response){if(response instanceof __WEBPACK_IMPORTED_MODULE_31__errors_apperror__["a" /* default */]){var error_id=__WEBPACK_IMPORTED_MODULE_12_lodash___default.a.get(response,'originalErrors[0].errorId');var status=__WEBPACK_IMPORTED_MODULE_12_lodash___default.a.get(response,'originalErrors[0].status');if(status===413){// A bit different way of handling server error. Middleware have a problem with providing errorId
// in this case so we rely on server response status code (P9052-10423).
_this6.triggerFontSizeExceededPopup();}else{_this6.props.showErrorPopup(error_id||__WEBPACK_IMPORTED_MODULE_32__errors_errorids__["a" /* default */].UNKNOWN);}}Object(__WEBPACK_IMPORTED_MODULE_27__utils_cursor__["b" /* changeCursor */])();});}},{key:"fontExists",value:function fontExists(font){var name=font.name.toLowerCase();var existing=this.props.fonts.filter(function(font){return font.internalFontId.toLowerCase()===name;});return existing.length>0;}},{key:"triggerFontExistsPopup",value:function triggerFontExistsPopup(font,replaceCallback,skipCallback){this.props.showModal('CONFIRMATION_MODAL',{message:localize('fonts-font-exists-confirmation',font.name),buttons:[__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_Features_components__["a" /* Button */],{key:"button-cancel",variant:"outlined",color:"primary",onClick:skipCallback},localize('skip')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_Features_components__["a" /* Button */],{key:"button-confirm",variant:"contained",color:"primary",onClick:replaceCallback},localize('replace'))]});}},{key:"triggerFontSizeExceededPopup",value:function triggerFontSizeExceededPopup(){this.props.showModal('CONFIRMATION_MODAL',{message:localize('fonts-size-exceeded'),buttons:[__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_Features_components__["a" /* Button */],{key:"button-confirm",variant:"contained",color:"primary"},localize('close'))]});}}]);return Fonts;}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]))||_class);Fonts.propTypes={classes:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,fonts:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.array,showModal:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,removeCompanyFont:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,addCompanyFont:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,showErrorPopup:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired};var mapStateToProps=function mapStateToProps(state){return{fonts:__WEBPACK_IMPORTED_MODULE_12_lodash___default.a.get(state.companies.rawDataById,"".concat(state.companies.selectedId,".fonts"),[])};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])({showModal:__WEBPACK_IMPORTED_MODULE_25_redux_modules_modal__["d" /* showModal */],addCompanyFont:__WEBPACK_IMPORTED_MODULE_26_redux_modules_companies__["a" /* addCompanyFont */],removeCompanyFont:__WEBPACK_IMPORTED_MODULE_26_redux_modules_companies__["C" /* removeCompanyFont */],showErrorPopup:__WEBPACK_IMPORTED_MODULE_26_redux_modules_companies__["H" /* showErrorPopup */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Fonts));

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
var FileUploader=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(FileUploader,_Component);function FileUploader(){var _this;__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this,FileUploader);_this=__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(FileUploader).call(this));_this.input=null;_this.handleChange=_this.handleChange.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this));return _this;}__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(FileUploader,[{key:"render",value:function render(){var _this2=this;var _this$props=this.props,onUpload=_this$props.onUpload,props=__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_this$props,["onUpload"]);return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("input",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({},props,{type:"file",ref:function ref(input){return _this2.input=input;},onChange:this.handleChange,style:{display:'none'}}));}},{key:"openPicker",value:function openPicker(){this.input&&this.input.click();}},{key:"handleChange",value:function handleChange(event){var files=event.currentTarget.files;this.props.onUpload(files);event.currentTarget.value='';}}]);return FileUploader;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);FileUploader.propTypes={onUpload:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (FileUploader);

/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AUTO */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROGRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeCursor; });
var AUTO='auto';var PROGRESS='progress';var changeCursor=function changeCursor(){var type=arguments.length>0&&arguments[0]!==undefined?arguments[0]:AUTO;window.document.body.style.cursor=type;};

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SmartFields */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Description__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_CenteredContent_CenteredContent__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_StickyHeader_StickyHeader__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_FormLabel__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_FormField__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_theme_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_Tabs__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_Tab__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_Tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_Grid__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_Button__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_FormHelperText__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_IconButton__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_Popover__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_Popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_Popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_core_Typography__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_i18n_i18n__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__SmartFieldsSchema__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_redux_modules_companies__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_redux_store__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_redux_modules_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_theme_uiConfig__ = __webpack_require__(69);
var _dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_27_i18n_i18n__["a" /* default */].loc.localize;var styles=function styles(theme){return{stickyHeader:{paddingTop:0,marginBottom:80,'&:after':__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()({width:'auto',margin:'0 5%'},theme.breakpoints.up('md'),{margin:'0 9%'})},header:{background:"linear-gradient(to bottom, #eee ".concat(9*theme.spacing.unit,"px, #fff ").concat(9*theme.spacing.unit,"px)")},centeredContent:{marginTop:0,paddingTop:25},descriptionContainer:{marginTop:50},descriptionInfo:{marginLeft:'auto'},descriptionInfoIcon:{color:theme.palette.colors.white,backgroundColor:theme.palette.colors.epsilon,borderColor:theme.palette.colors.epsilon,padding:0,marginRight:6,'&:hover':{backgroundColor:"".concat(theme.palette.colors.epsilonHover," !important"),borderColor:"".concat(theme.palette.colors.epsilonHover," !important")}},buttonContainer:{paddingBottom:20},section:{padding:'10px 0 22px'},sectionLabel:{fontSize:18,marginTop:0,color:theme.palette.colors.colorWithAlpha(theme.palette.colors.zeta,0.9)},fieldDescription:{fontSize:16,marginBottom:12,marginLeft:18},field:{marginBottom:5,width:340},inputWidth:{width:340},popover:{pointerEvents:'none'}};};var onLeaveMessage=localize('leave-page-confirmation');var SmartFields=(_dec=Object(__WEBPACK_IMPORTED_MODULE_26__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(SmartFields,_Component);function SmartFields(props){var _this;__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this,SmartFields);_this=__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(SmartFields).call(this));_this.validateFields=__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.debounce(_this.validateFields.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this)),__WEBPACK_IMPORTED_MODULE_33_theme_uiConfig__["g" /* typingDebounceTimeout */]);_this.onBeforeUnload=_this.onBeforeUnload.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.state=__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},_this.getStateFromProps(props));return _this;}__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(SmartFields,[{key:"getStateFromProps",value:function getStateFromProps(props){return{tab:0,infoAnchor:null,button:false,values:__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.clone(props.smartFields),errors:{},dirty:{}};}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(props){this.setState(this.getStateFromProps(props));}},{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_31_redux_store__["c" /* setConfirmationFunction */])(function(message,callback){_this2.doIfCanLeave(callback);});this.historyUnblock=__WEBPACK_IMPORTED_MODULE_31_redux_store__["b" /* history */].block('');window.addEventListener('beforeunload',this.onBeforeUnload);}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.historyUnblock();Object(__WEBPACK_IMPORTED_MODULE_31_redux_store__["c" /* setConfirmationFunction */])(null);window.removeEventListener('beforeunload',this.onBeforeUnload);}},{key:"onBeforeUnload",value:function onBeforeUnload(e){if(this.areUnsavedChanges){var dialogText=onLeaveMessage;e.returnValue=dialogText;return dialogText;}}},{key:"render",value:function render(){var _this3=this;var classes=this.props.classes;var tab=this.state.tab;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_StickyHeader_StickyHeader__["a" /* default */],{className:classes.stickyHeader},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:classes.header},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_CenteredContent_CenteredContent__["a" /* default */],{className:classes.centeredContent,padding:false},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_Tabs___default.a,{value:tab,onChange:function onChange(event,tab){return _this3.setState({tab:tab});}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_Tab___default.a,{component:"div",label:localize('smartfields-tab'),disableRipple:true})),tab===0&&this.renderCompanySmartFieldsHeader()))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_CenteredContent_CenteredContent__["a" /* default */],{padding:false},tab===0&&this.renderCompanySmartFieldsContent()));}},{key:"renderCompanySmartFieldsHeader",value:function renderCompanySmartFieldsHeader(){var _this4=this;var classes=this.props.classes;var infoAnchor=this.state.infoAnchor;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Grid___default.a,{container:true,classes:{container:classes.descriptionContainer}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Description__["a" /* default */],{variant:"body2"},localize('smartfields-description'))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Grid___default.a,{item:true,className:classes.descriptionInfo},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_IconButton___default.a,{className:classes.descriptionInfoIcon,color:"primary",component:"span",disableRipple:true,"aria-owns":infoAnchor?'info-popover':undefined,"aria-haspopup":"true",onMouseEnter:function onMouseEnter(event){return _this4.toggleInfoPopover(event);},onMouseLeave:function onMouseLeave(){return _this4.toggleInfoPopover();}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_theme_icons__["N" /* Info */],null)),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_Popover___default.a,{id:"info-popover",className:classes.popover,open:infoAnchor!==null,anchorEl:infoAnchor,anchorOrigin:{vertical:'center',horizontal:'left'},transformOrigin:{vertical:'center',horizontal:'right'},disableRestoreFocus:true,onClose:function onClose(){return _this4.toggleInfoPopover();}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_Typography___default.a,{variant:"body2",dangerouslySetInnerHTML:{__html:localize('smartfields-info')}})))),this.button());}},{key:"renderCompanySmartFieldsContent",value:function renderCompanySmartFieldsContent(){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,this.renderSection(localize('smartfields-team-name'),__WEBPACK_IMPORTED_MODULE_29__SmartFieldsSchema__["a" /* default */].COMPANY_NAME),this.renderSection(localize('smartfields-email'),__WEBPACK_IMPORTED_MODULE_29__SmartFieldsSchema__["a" /* default */].EMAIL),this.renderSection(localize('smartfields-address'),__WEBPACK_IMPORTED_MODULE_29__SmartFieldsSchema__["a" /* default */].ADDRESS),this.renderSection(localize('smartfields-phone'),__WEBPACK_IMPORTED_MODULE_29__SmartFieldsSchema__["a" /* default */].PHONE_NUMBER),this.renderSection(localize('smartfields-website'),__WEBPACK_IMPORTED_MODULE_29__SmartFieldsSchema__["a" /* default */].WEBSITE),this.renderSection(localize('smartfields-instagram'),__WEBPACK_IMPORTED_MODULE_29__SmartFieldsSchema__["a" /* default */].INSTAGRAM),this.renderSection(localize('smartfields-facebook'),__WEBPACK_IMPORTED_MODULE_29__SmartFieldsSchema__["a" /* default */].FACEBOOK),this.renderSection(localize('smartfields-twitter'),__WEBPACK_IMPORTED_MODULE_29__SmartFieldsSchema__["a" /* default */].TWITTER),this.renderSection(localize('smartfields-linkedin'),__WEBPACK_IMPORTED_MODULE_29__SmartFieldsSchema__["a" /* default */].LINKEDIN));}},{key:"button",value:function button(){var _this5=this;var classes=this.props.classes;var errors=this.areErrors;var disabled=!this.state.button||errors||!this.areUnsavedChanges;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Grid___default.a,{container:true,className:classes.buttonContainer},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Button___default.a,{variant:"contained",color:"primary",size:"large","data-tid":"button-smartfields-save",disabled:disabled,onClick:function onClick(){return _this5.handleSave();}},localize('save'))),errors&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_FormHelperText___default.a,{error:true},localize('smartfields-error'))));}},{key:"renderSection",value:function renderSection(title){var _this6=this;var fields=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Grid___default.a,{container:true,classes:{container:classes.section}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_FormLabel__["a" /* default */],{title:title,className:classes.sectionLabel},title),fields.map(function(field){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Grid___default.a,{key:field.key,item:true,xs:12},field.description&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_FormHelperText___default.a,{className:classes.fieldDescription},field.description),_this6.renderField(field));},this));}},{key:"renderField",value:function renderField(field){var _this7=this;var classes=this.props.classes;var key=field.key,_field$placeholder=field.placeholder,placeholder=_field$placeholder===void 0?'':_field$placeholder,_field$prefix=field.prefix,prefix=_field$prefix===void 0?'':_field$prefix;var value=this.state.values[key];return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_FormField__["a" /* default */],{name:key,"data-tid":"form-smartfields-".concat(key),value:value,placeholder:placeholder,onChange:function onChange(event){return _this7.onChange(event,key,prefix);},helperText:this.state.errors[key],error:!!this.state.errors[key],className:classes.field});}},{key:"onChange",value:function onChange(event,key,prefix){var _this$state=this.state,values=_this$state.values,dirty=_this$state.dirty,errors=_this$state.errors;var smartFields=this.props.smartFields;var value=event.target.value;// Add prefix if it's not provided
if(value&&value.charAt(0)!==prefix){value=prefix+value;}// Delete error when typing; value will be validated in validateFields
if(errors[key]){delete errors[key];}this.setState({button:false,values:__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},values,__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()({},key,value)),dirty:__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},dirty,__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()({},key,value!==smartFields[key])),errors:errors},this.validateFields);}},{key:"validateFields",value:function validateFields(){var errors={};for(var _i=0,_Object$keys=Object.keys(__WEBPACK_IMPORTED_MODULE_29__SmartFieldsSchema__["a" /* default */]);_i<_Object$keys.length;_i++){var id=_Object$keys[_i];var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=__WEBPACK_IMPORTED_MODULE_29__SmartFieldsSchema__["a" /* default */][id][Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var field=_step.value;var key=field.key,validator=field.validator;if(validator){var error=validator(this.state.values[key],this.state.dirty[key]);if(error){errors[key]=error;}}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator["return"]!=null){_iterator["return"]();}}finally{if(_didIteratorError){throw _iteratorError;}}}}this.setState({button:true,errors:errors});}},{key:"toggleInfoPopover",value:function toggleInfoPopover(){var event=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{target:null};this.setState({infoAnchor:event.target});}},{key:"handleSave",value:function handleSave(){var _this$state2=this.state,values=_this$state2.values,dirty=_this$state2.dirty;var smartFields={};for(var _i2=0,_Object$keys2=Object.keys(values);_i2<_Object$keys2.length;_i2++){var key=_Object$keys2[_i2];var value=values[key];// Transform only those smart fields that are touched (value changed)
if(dirty[key]){smartFields[key]=value;}}!__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.isEmpty(smartFields)&&this.props.updateSmartFields(smartFields);}},{key:"doIfCanLeave",value:function doIfCanLeave(callback){var dirty=this.state.dirty;// No changes, leave the page
if(__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.isEmpty(dirty)){callback(true);return;}this.props.showModal('CONFIRMATION_MODAL',{message:onLeaveMessage,buttons:[__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Button___default.a,{key:"button-cancel",variant:"outlined",color:"primary","data-tid":"button-smartfields-company-stay",onClick:function onClick(){callback(false);}},localize('stay-on-page')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Button___default.a,{key:"button-confirm",variant:"contained",color:"primary","data-tid":"button-smartfields-company-leave",onClick:function onClick(){callback(true);}},localize('leave-page'))]});}},{key:"areUnsavedChanges",get:function get(){var dirty=this.state.dirty;return Object.keys(__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.pickBy(dirty)).length>0;}},{key:"areErrors",get:function get(){var errors=this.state.errors;return Object.keys(errors).length>0;}}]);return SmartFields;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]))||_class);SmartFields.propTypes={classes:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,smartFields:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,updateSmartFields:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,showModal:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func};var mapStateToProps=function mapStateToProps(state){return{smartFields:__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(state.companies.rawDataById,"".concat(state.companies.selectedId,".smartFields"),{})};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_25_redux__["b" /* bindActionCreators */])({updateSmartFields:__WEBPACK_IMPORTED_MODULE_30_redux_modules_companies__["N" /* updateSmartFields */],showModal:__WEBPACK_IMPORTED_MODULE_32_redux_modules_modal__["d" /* showModal */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_24_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(SmartFields));

/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validator_lib_isEmail__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validator_lib_isEmail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_validator_lib_isEmail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_validator_lib_isURL__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_validator_lib_isURL___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_validator_lib_isURL__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18n_i18n__ = __webpack_require__(15);
var localize=__WEBPACK_IMPORTED_MODULE_2_i18n_i18n__["a" /* default */].loc.localize;var urlValidator=function urlValidator(message){return function(value,isDirty){if(value&&isDirty&&!__WEBPACK_IMPORTED_MODULE_1_validator_lib_isURL___default()(value)){return message;}};};/* harmony default export */ __webpack_exports__["a"] = ({COMPANY_NAME:[{key:'company:companyname',placeholder:localize('smartfields-team-name-placeholder')}],EMAIL:[{key:'company:email',placeholder:localize('smartfields-email-placeholder'),validator:function validator(value,isDirty){if(value&&isDirty&&!__WEBPACK_IMPORTED_MODULE_0_validator_lib_isEmail___default()(value)){return localize('smartfields-email-invalid');}}}],ADDRESS:[{key:'company:addressline1',placeholder:localize('smartfields-address1-placeholder')},{key:'company:city',placeholder:localize('smartfields-city-placeholder')},{key:'company:region',placeholder:localize('smartfields-region-placeholder')},{key:'company:postcode',placeholder:localize('smartfields-postcode-placeholder')},{key:'company:country',placeholder:localize('smartfields-country-placeholder')}],PHONE_NUMBER:[{key:'company:telephone',placeholder:localize('smartfields-phone-placeholder'),validator:function validator(value,isDirty){// eslint-disable-next-line no-useless-escape
if(value&&isDirty&&value.match(/^[0-9\-\+\(\)\s]*$/)===null){return localize('smartfields-phone-invalid');}}}],WEBSITE:[{key:'company:website',placeholder:localize('smartfields-website-placeholder'),// eslint-disable-next-line
validator:urlValidator(localize('smartfields-website-invalid'))}],INSTAGRAM:[{key:'company:instagram:link',description:localize('smartfields-social-link-description'),placeholder:localize('smartfields-instagram-link-placeholder'),validator:urlValidator(localize('smartfields-instagram-link-invalid'))},{key:'company:instagram:text',description:localize('smartfields-social-name-description'),prefix:'@',placeholder:localize('smartfields-instagram-name-placeholder')}],FACEBOOK:[{key:'company:facebook:link',description:localize('smartfields-social-link-description'),placeholder:localize('smartfields-facebook-link-placeholder'),validator:urlValidator(localize('smartfields-facebook-link-invalid'))},{key:'company:facebook:text',description:localize('smartfields-social-name-description'),prefix:'@',placeholder:localize('smartfields-facebook-name-placeholder')}],TWITTER:[{key:'company:twitter:link',description:localize('smartfields-social-link-description'),placeholder:localize('smartfields-twitter-link-placeholder'),validator:urlValidator(localize('smartfields-twitter-link-invalid'))},{key:'company:twitter:text',description:localize('smartfields-social-name-description'),prefix:'@',placeholder:localize('smartfields-twitter-name-placeholder')}],LINKEDIN:[{key:'company:linkedin:link',description:localize('smartfields-social-link-description'),placeholder:localize('smartfields-linkedin-link-placeholder'),validator:urlValidator(localize('smartfields-linkedin-link-invalid'))},{key:'company:linkedin:text',description:localize('smartfields-social-name-description'),placeholder:localize('smartfields-linkedin-name-placeholder')}]});

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_CenteredContent_CenteredContent__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Description__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Header__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_redux_modules_session__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_redux_modules_companies__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_Grid__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_i18n_i18n__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__material_ui_core_Typography__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_subscription__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_downloads__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lib_Segment_helpers__ = __webpack_require__(38);
var _dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_22_i18n_i18n__["a" /* default */].loc.localize;var styles=function styles(theme){return{windowsInfo:{fontStyle:'italic',fontSize:'14px',lineHeight:'15px',display:'block',paddingTop:'10px'},bold:{fontWeight:'bold'},link:{marginLeft:'53px'},button:{minWidth:'380px'},product:{marginBottom:20},buttonOwned:{},buttonNotOwned:{borderColor:theme.palette.colors.alpha,'&:hover':{borderColor:'#2888C3'}},ownedProducts:{marginBottom:20,'& + div':{borderTop:'1px solid #ebebeb',paddingTop:20}},ownedProductsTitle:{color:'#000',marginBottom:20}};};var XCPlus=(_dec=Object(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(XCPlus,_Component);function XCPlus(){var _getPrototypeOf2;var _this;__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this,XCPlus);for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}_this=__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this,(_getPrototypeOf2=__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(XCPlus)).call.apply(_getPrototypeOf2,[this].concat(args)));__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this),"onDownloadClick",function(downloadUrl,storageKey,trackingKey){Object(__WEBPACK_IMPORTED_MODULE_26__utils_downloads__["b" /* trackAndDownload */])(_this.props,downloadUrl,storageKey,trackingKey,Object(__WEBPACK_IMPORTED_MODULE_27_lib_Segment_helpers__["a" /* getTrackingOptions */])(_this.props.company));});return _this;}__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(XCPlus,[{key:"getTempAddonObject",value:function getTempAddonObject(plan){return{id:"".concat(__WEBPACK_IMPORTED_MODULE_8__config__["X" /* MAP_ADDON_TO_LATEST_VERSION */][plan],"-per-eur"),active:true,users:[this.props.user.userId]};}},{key:"deleteSavedPendingPerpetualPlan",value:function deleteSavedPendingPerpetualPlan(plan){var pendingPerpetualPlans=Object(__WEBPACK_IMPORTED_MODULE_25__utils_subscription__["g" /* getPendingPerpetualPlans */])(this.props.company);delete pendingPerpetualPlans[plan];this.props.writeCompanySettings({pendingPerpetualPlans:pendingPerpetualPlans});}},{key:"renderProducts",value:function renderProducts(){var _this2=this;var company=this.props.company;var _getSubscriptionsAndA=Object(__WEBPACK_IMPORTED_MODULE_25__utils_subscription__["i" /* getSubscriptionsAndAddons */])(company),subscription=_getSubscriptionsAndA.subscription,perpetualAddons=_getSubscriptionsAndA.perpetualAddons;var pendingPerpetualPlans=Object(__WEBPACK_IMPORTED_MODULE_25__utils_subscription__["g" /* getPendingPerpetualPlans */])(this.props.company);if(!__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.isEmpty(pendingPerpetualPlans)){perpetualAddons=perpetualAddons||[];var perpetualsPlans=[{cbPlanId:'photol-per-eur',plan:__WEBPACK_IMPORTED_MODULE_8__config__["_42" /* SUBSCRIPTION_PLAN */].PHOTO_PERPETUAL},{cbPlanId:'webl-per-eur',plan:__WEBPACK_IMPORTED_MODULE_8__config__["_42" /* SUBSCRIPTION_PLAN */].WEB_PERPETUAL},{cbPlanId:'designerl-per-eur',plan:__WEBPACK_IMPORTED_MODULE_8__config__["_42" /* SUBSCRIPTION_PLAN */].DESIGNER_PERPETUAL}];perpetualsPlans.forEach(function(item){if(pendingPerpetualPlans[item.cbPlanId]){var pendingPlanData=_this2.getTempAddonObject(item.plan);if(!perpetualAddons.find(function(item){return item.id===pendingPlanData.id;})){perpetualAddons.push(pendingPlanData);}else{_this2.deleteSavedPendingPerpetualPlan(item.cbPlanId);}}});}var hasPerpetualPlan=!__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.isEmpty(perpetualAddons)&&!this.props.company.hasUnlimitedTeamSubscription;var hasSubscription=!__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.isEmpty(subscription);var plansToRender=[];var addSubscriptionsToRenderQueue=function addSubscriptionsToRenderQueue(){if(!__WEBPACK_IMPORTED_MODULE_23_lodash___default.a.isEmpty(subscription)){var _convertPlanIdIntoSub=Object(__WEBPACK_IMPORTED_MODULE_25__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(subscription.planId),plan=_convertPlanIdIntoSub.plan;if(plan===__WEBPACK_IMPORTED_MODULE_8__config__["_42" /* SUBSCRIPTION_PLAN */].DESIGNER){plansToRender.push(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},__WEBPACK_IMPORTED_MODULE_8__config__["C" /* DESKTOP_APPS */].DESIGNER,{owned:true,primary:true}));}else{plansToRender.push(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},__WEBPACK_IMPORTED_MODULE_8__config__["C" /* DESKTOP_APPS */].DESIGNER,{owned:true,primary:plan===__WEBPACK_IMPORTED_MODULE_8__config__["_42" /* SUBSCRIPTION_PLAN */].DESIGNER}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},__WEBPACK_IMPORTED_MODULE_8__config__["C" /* DESKTOP_APPS */].WEB,{owned:true,primary:plan===__WEBPACK_IMPORTED_MODULE_8__config__["_42" /* SUBSCRIPTION_PLAN */].WEB}),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},__WEBPACK_IMPORTED_MODULE_8__config__["C" /* DESKTOP_APPS */].PHOTO,{owned:true,primary:plan===__WEBPACK_IMPORTED_MODULE_8__config__["_42" /* SUBSCRIPTION_PLAN */].PHOTO}));}}else{plansToRender.push(__WEBPACK_IMPORTED_MODULE_8__config__["C" /* DESKTOP_APPS */].DESIGNER,__WEBPACK_IMPORTED_MODULE_8__config__["C" /* DESKTOP_APPS */].WEB,__WEBPACK_IMPORTED_MODULE_8__config__["C" /* DESKTOP_APPS */].PHOTO);}};var addAddonsToRenderQueue=function addAddonsToRenderQueue(){perpetualAddons.forEach(function(addon){var addonData=Object(__WEBPACK_IMPORTED_MODULE_26__utils_downloads__["a" /* getAddonDataForDownload */])(addon.id);addonData.owned=true;if(addon.paidQuantity>addon.usedQuantity||addon.users.includes(_this2.props.user.userId)){var higherVersionAvailable=false;if(addonData.isPerpetual&&addonData.productVersion===19&&!plansToRender.find(function(item){return item.itemKey==="".concat(addonData.productKey,"-20");})){// A V19 owner should see V19 and V20 downloads. A V20 owner should only see V20. 
var addonDataV20=Object(__WEBPACK_IMPORTED_MODULE_26__utils_downloads__["a" /* getAddonDataForDownload */])(addon.id,20);addonDataV20.owned=true;plansToRender.push(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},addonDataV20,{primary:true}));higherVersionAvailable=true;}if(!plansToRender.find(function(item){return item.itemKey==="".concat(addonData.productKey,"-").concat(addonData.productVersion);})){plansToRender.push(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},addonData,{primary:!higherVersionAvailable}));}}});};if(!hasPerpetualPlan){addSubscriptionsToRenderQueue();}else if(hasPerpetualPlan&&!hasSubscription){addAddonsToRenderQueue();}else if(hasPerpetualPlan&&hasSubscription){addSubscriptionsToRenderQueue();addAddonsToRenderQueue();}return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react__["Fragment"],null,this.renderProductGroup(plansToRender,true),this.renderProductGroup(plansToRender,false));}},{key:"render",value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_CenteredContent_CenteredContent__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Header__["a" /* default */],null,localize('download-header')),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Description__["a" /* default */],null,localize('download-description1'),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("br",null),localize('download-description2'),__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("span",{className:classes.windowsInfo},localize('download-description3'))),this.renderProducts());}},{key:"renderProductGroup",value:function renderProductGroup(plansToRender,renderOwned){var _this3=this;var classes=this.props.classes;var result=plansToRender.map(function(plan,index){var downloadUrl=plan.downloadUrl,storageKey=plan.storageKey,trackingKey=plan.trackingKey,title=plan.title,detailsUrl=plan.detailsUrl,owned=plan.owned,primary=plan.primary;var primaryOwned=owned&&primary;if(renderOwned&&!primaryOwned||!renderOwned&&primaryOwned){return;}return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_Grid___default.a,{container:true,key:"product-item-".concat(index+1),alignItems:"center",className:classes.product},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["a" /* Button */],{onClick:function onClick(){return _this3.onDownloadClick(downloadUrl,storageKey,trackingKey);},variant:primaryOwned?'contained':'outlined',"data-tid":"button-download",color:"primary",size:"large",title:"Download",className:__WEBPACK_IMPORTED_MODULE_20_classnames___default()(classes.button,primaryOwned?classes.buttonOwned:classes.buttonNotOwned)},localize('download-download',title)),detailsUrl&&__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["r" /* Link */],{href:detailsUrl,target:"_blank",variant:"body1",underline:"always",className:classes.link},localize('download-find-out-more')));});if(result.some(function(item){return Boolean(item);})){if(renderOwned){return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:classes.ownedProducts},__WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core_Typography___default.a,{variant:"body1",className:classes.ownedProductsTitle},localize('download-you-own-this-product')),result);}else{return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement("div",{className:classes.otherProducts},result);}}}}]);return XCPlus;}(__WEBPACK_IMPORTED_MODULE_18_react__["Component"]))||_class);XCPlus.propTypes={classes:__WEBPACK_IMPORTED_MODULE_21_prop_types___default.a.object,company:__WEBPACK_IMPORTED_MODULE_21_prop_types___default.a.object,settings:__WEBPACK_IMPORTED_MODULE_21_prop_types___default.a.object,// settings from session.user
writeUserSettings:__WEBPACK_IMPORTED_MODULE_21_prop_types___default.a.func,// action creator from session module
user:__WEBPACK_IMPORTED_MODULE_21_prop_types___default.a.object.isRequired,writeCompanySettings:__WEBPACK_IMPORTED_MODULE_21_prop_types___default.a.func};// Leaving Redux bindings for phase 2 of P9052-13492.
var mapStateToProps=function mapStateToProps(state){return{company:state.companies.rawDataById[state.companies.selectedId],settings:state.session.user.settings,user:state.session.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_14_redux__["b" /* bindActionCreators */])({writeUserSettings:__WEBPACK_IMPORTED_MODULE_15_redux_modules_session__["d" /* writeUserSettings */],writeCompanySettings:__WEBPACK_IMPORTED_MODULE_16_redux_modules_companies__["R" /* writeCompanySettings */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_19_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(XCPlus));

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Header__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_FormLabel__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_FormField__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_StickyHeader_StickyHeader__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_Button__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_Grid__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_redux_modules_account__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_i18n_i18n__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_core_Typography__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__AccountDetailsSchema__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_utils_state__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_utils_forms__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_utils_browser__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_utils_string__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_redux_store__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_redux_modules_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_components_CenteredContent_CenteredContent__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__theme_icons__ = __webpack_require__(24);
var _errors,_dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_21_i18n_i18n__["a" /* default */].loc.localize;var minPasswordLength=__WEBPACK_IMPORTED_MODULE_33__config__["a" /* ACCOUNT_SETTINGS */].minPasswordLength;var maxPasswordLength=__WEBPACK_IMPORTED_MODULE_33__config__["a" /* ACCOUNT_SETTINGS */].maxPasswordLength;var styles=function styles(theme){return{header:{paddingBottom:20},button:{fontSize:16,lineHeight:1.5,width:160},detailsContainer:{marginTop:theme.spacing.unit*2},columnField:{width:260},columnSaveButton:{},field:{width:240,margin:'0 0 5px 0','&:focus':{outline:'none'}},'root':{'&$error':{marginTop:10,marginBottom:15,fontSize:'0.8rem'}},fieldDescription:{width:400,marginLeft:18,marginTop:20,marginBottom:10},emailSentMessage:{width:600,marginLeft:18,marginTop:20,marginBottom:10},spinnerIcon:{height:'24px',width:'24px',fill:'white',animation:'spin 2s linear infinite'},checkIcon:{color:'green'},'@keyframes spin':{'0':{transform:'rotate(0deg)'},'100%':{transform:'rotate(360deg)'}}};};var onLeaveMessage=localize('leave-page-confirmation');var errors=(_errors={},__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_32__errors_errorids__["a" /* default */].OFFLINE,localize('account-error-offline')),__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_32__errors_errorids__["a" /* default */].INVALID_PASSWORD,localize('account-error-invalid-password')),__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_32__errors_errorids__["a" /* default */].PASSWORDS_NOT_MATCHING,localize('account-error-passwords-not-matching')),__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_32__errors_errorids__["a" /* default */].PASSWORD_ALREADY_USED,localize('account-error-password-already-used')),__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_32__errors_errorids__["a" /* default */].WRONG_PASSWORD,localize('account-error-wrong-password')),__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_32__errors_errorids__["a" /* default */].EMAIL_ALREADY_USED,localize('account-error-email-already-used')),__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_32__errors_errorids__["a" /* default */].INVALID_EMAIL_FORMAT,localize('account-error-invalid-email-format')),__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_32__errors_errorids__["a" /* default */].INVALID_FIRST_NAME,localize('account-error-invalid-first-name')),__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_32__errors_errorids__["a" /* default */].INVALID_LAST_NAME,localize('account-error-invalid-last-name')),__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_32__errors_errorids__["a" /* default */].EMAIL_ASSOCIATED_TO_ANOTHER_USER,localize('account-error-email-associated-to-another-user')),__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_32__errors_errorids__["a" /* default */].UNKNOWN_EMAIL,localize('account-error-unknown-email')),__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_32__errors_errorids__["a" /* default */].NOTIFICATION_SERVICE_INTERNAL_ERROR,localize('account-error-notification-service-internal-error')),_errors);var AccountDetails=(_dec=Object(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(AccountDetails,_Component);function AccountDetails(props){var _this;__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this,AccountDetails);_this=__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(AccountDetails).call(this,props));var currentEmail=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(props.user,'mainEmail');var currentFirstName=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(props.user,'firstName');var currentLastName=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(props.user,'lastName');_this.currentPassword=__WEBPACK_IMPORTED_MODULE_9_react___default.a.createRef();_this.newEmail=__WEBPACK_IMPORTED_MODULE_9_react___default.a.createRef();_this.newFirstName=__WEBPACK_IMPORTED_MODULE_9_react___default.a.createRef();_this.newLastName=__WEBPACK_IMPORTED_MODULE_9_react___default.a.createRef();_this.newPassword=__WEBPACK_IMPORTED_MODULE_9_react___default.a.createRef();_this.state={// email
currentEmail:currentEmail,newEmail:currentEmail,oldEmail:'',newEmailSuccess:false,newEmailError:'',// name
newNameSuccess:false,newNameError:false,newFirstName:currentFirstName,newLastName:currentLastName,// password
currentPassword:'',passwordError:'',checkedPassword:'',newPassword:'',newPasswordSuccess:false,newPasswordError:'',confirmNewPassword:'',// misc flags
credentialsChecked:false,unlocking:false,changingEmail:false,changingFirstName:false,changingLastName:false,changingPassword:false,hasPassword:_this.props.user.hasPassword,showResetPasswordSuccess:false,showResetPasswordError:false,touched:{},errors:{}};_this.onBeforeUnload=_this.onBeforeUnload.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this));return _this;}__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(AccountDetails,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_29_redux_store__["c" /* setConfirmationFunction */])(function(message,callback){_this2.doIfCanLeave(callback);});this.historyUnblock=__WEBPACK_IMPORTED_MODULE_29_redux_store__["b" /* history */].block('');window.addEventListener('beforeunload',this.onBeforeUnload);}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.historyUnblock();Object(__WEBPACK_IMPORTED_MODULE_29_redux_store__["c" /* setConfirmationFunction */])(null);this.currentPassword=null;this.newEmail=null;this.newFirstName=null;this.newLastName=null;this.newPassword=null;window.removeEventListener('beforeunload',this.onBeforeUnload);}},{key:"handleCredentialsValidation",value:function handleCredentialsValidation(nextProps){if(nextProps.account.areCredentialsValid===true){this.setState({checkedPassword:this.state.currentPassword,credentialsChecked:true,unlocking:false,errors:{'currentPassword':''}});this.validateAll();}else if(nextProps.account.areCredentialsValid===false){var errorMessage=errors[nextProps.account.checkCredentialsErrorid]||localize('account-error-unknown');this.setState({credentialsChecked:false,unlocking:false,errors:{'currentPassword':errorMessage}});Object(__WEBPACK_IMPORTED_MODULE_26_utils_forms__["a" /* focusSelect */])(this.currentPassword.current);}}},{key:"handleEmailUpdate",value:function handleEmailUpdate(nextProps){var _this3=this;if(nextProps.account.accountEmailUpdateSuccess===true){this.setState(function(prevState){return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},prevState,{oldEmail:_this3.state.currentEmail,currentEmail:_this3.state.newEmail,changingEmail:false,newEmailSuccess:true,errors:__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},prevState.errors,{'newEmail':null}),touched:__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},prevState.touched,{'newEmail':null})});},function(){return _this3.showNewEmailSentConfirmationPopup(_this3.state.newEmail,_this3.state.currentEmail);});}else if(nextProps.account.accountEmailUpdateSuccess===false){var errorMessage=errors[nextProps.account.accountEmailUpdateErrorId]||localize('account-error-unknown');this.setState(function(prevState){return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},prevState,{changingEmail:false,errors:__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},prevState.errors,{'newEmail':errorMessage})});});Object(__WEBPACK_IMPORTED_MODULE_26_utils_forms__["a" /* focusSelect */])(this.newEmail.current);}}},{key:"handleNameUpdate",value:function handleNameUpdate(nextProps){var firstNameFiltered=this.getFilteredName('newFirstName');var lastNameFiltered=this.getFilteredName('newLastName');if(nextProps.account.accountNameUpdateSuccess===true){this.setState(function(prevState){return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},prevState,{newFirstName:firstNameFiltered,newLastName:lastNameFiltered,changingName:false,newNameSuccess:true,errors:__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},prevState.errors,{'newLastName':null}),touched:__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},prevState.touched,{'newFirstName':null,'newLastName':null})});});}else if(nextProps.account.accountNameUpdateSuccess===false){var errorMessage=errors[nextProps.account.accountNameUpdateErrorId]||localize('account-error-unknown');this.setState(function(prevState){return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},prevState,{newFirstName:firstNameFiltered,newLastName:lastNameFiltered,changingName:false,errors:__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},prevState.errors,{'newLastName':errorMessage})});});Object(__WEBPACK_IMPORTED_MODULE_26_utils_forms__["a" /* focusSelect */])(this.newFirstName.current);}}},{key:"handlePasswordUpdate",value:function handlePasswordUpdate(nextProps){var _this4=this;if(nextProps.account.accountPasswordUpdateSuccess===true){this.setState(function(prevState){return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},prevState,{changingPassword:false,checkedPassword:_this4.state.newPassword,newPassword:'',confirmNewPassword:'',newPasswordSuccess:true,errors:__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},prevState.errors,{'confirmNewPassword':null}),touched:__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},prevState.touched,{'newPassword':null,'confirmNewPassword':null})});});}else if(nextProps.account.accountPasswordUpdateSuccess===false){var errorMessage=errors[nextProps.account.accountPasswordUpdateErrorId]||localize('account-error-unknown');this.setState(function(prevState){return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},prevState,{changingPassword:false,errors:__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},prevState.errors,{'confirmNewPassword':errorMessage})});});Object(__WEBPACK_IMPORTED_MODULE_26_utils_forms__["a" /* focusSelect */])(this.newPassword.current);}}},{key:"handlePasswordReset",value:function handlePasswordReset(nextProps){if(nextProps.account.accountPasswordResetSuccess===true){this.setState(function(prevState){return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},prevState,{showResetPasswordSuccess:true});});}else if(nextProps.account.accountPasswordResetSuccess===false){this.setState(function(prevState){return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},prevState,{showResetPasswordError:true});});}}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){// Credentials check
if(this.props.account.areCredentialsValid!==nextProps.account.areCredentialsValid){this.handleCredentialsValidation(nextProps);}if(this.props.account.accountEmailUpdateSuccess!==nextProps.account.accountEmailUpdateSuccess){this.handleEmailUpdate(nextProps);}if(this.props.account.accountNameUpdateSuccess!==nextProps.account.accountNameUpdateSuccess){this.handleNameUpdate(nextProps);}if(this.props.account.accountPasswordUpdateSuccess!==nextProps.account.accountPasswordUpdateSuccess){this.handlePasswordUpdate(nextProps);}if(this.props.account.accountPasswordResetSuccess!==nextProps.account.accountPasswordResetSuccess){this.handlePasswordReset(nextProps);}var newState={};if(this.props.user.firstName!==nextProps.user.firstName){newState.newFirstName=nextProps.user.firstName;}if(this.props.user.lastName!==nextProps.user.lastName){newState.newLastName=nextProps.user.lastName;}if(!__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.isEmpty(newState)){this.setState(function(prevState){return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},prevState,newState);});}}},{key:"onChange",value:function onChange(event,name){name==='newEmail'&&this.setState({newEmailSuccess:false});name==='newFirstName'||name==='newLastName'&&this.setState({newNameSuccess:false});name==='newPassword'&&this.setState({newPasswordSuccess:false});this.setFieldState(name,event.target.value);}},{key:"setFieldState",value:function setFieldState(fieldName,value){this.setState(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()({},fieldName,value),this.validateAll);}},{key:"onBlur",value:function onBlur(event,name){if(name==='currentPassword')return;this.setState(function(prevState){return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},prevState,{touched:__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},prevState.touched,__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_defineProperty___default()({},name,true))});},this.validateAll);}},{key:"onKeyPress",value:function onKeyPress(event,name){if(event.key==='Enter'){if(name==='currentPassword'){this.unlockForm();}else if(name==='newEmail'){this.updateEmail();}else if(name==='newFirstName'||name==='newLastName'){this.updateName();}else if(name==='newPassword'||name==='confirmNewPassword'){this.updatePassword();}}}},{key:"validateAll",value:function validateAll(){var errors={};for(var field in __WEBPACK_IMPORTED_MODULE_24__AccountDetailsSchema__["a" /* default */]){var validate=__WEBPACK_IMPORTED_MODULE_24__AccountDetailsSchema__["a" /* default */][field];if(validate){var error=validate(this.state[field],this.state,this.props);if(error){errors[field]=error;}}}this.setState({errors:errors});}},{key:"hasUnsavedData",value:function hasUnsavedData(){var wasNameChanged=this.state.newFirstName!==__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(this.props.user,'firstName')||this.state.newLastName!==__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(this.props.user,'lastName');var wasPasswordChanged=this.state.newPassword.length>0||this.state.confirmNewPassword.length>0;return wasNameChanged||wasPasswordChanged||this.state.newEmail!==this.state.currentEmail;}},{key:"doIfCanLeave",value:function doIfCanLeave(callback){if(!this.hasUnsavedData()){callback(true);return;}this.props.showModal('CONFIRMATION_MODAL',{message:onLeaveMessage,buttons:[__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Button___default.a,{key:"button-cancel",variant:"outlined",color:"primary","data-tid":"button-account-stay",onClick:function onClick(){callback(false);}},localize('stay-on-page')),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Button___default.a,{key:"button-confirm","data-tid":"button-account-leave",variant:"contained",color:"primary",onClick:function onClick(){callback(true);}},localize('leave-page'))]});}},{key:"onBeforeUnload",value:function onBeforeUnload(e){if(this.hasUnsavedData()){var dialogText=onLeaveMessage;e.returnValue=dialogText;return dialogText;}}},{key:"field",value:function field(name,placeholder,disabled,type,maxLength){var _this5=this;var classes=this.props.classes;var errorClasses={root:classes.root,error:classes.error};return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_FormField__["a" /* default */],__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({value:this.state[name],className:classes.field,"data-tid":"form-account-profile-".concat(name),onChange:function onChange(event){return _this5.onChange(event,name);},onBlur:function onBlur(event){return _this5.onBlur(event,name);},onKeyPress:function onKeyPress(event){return _this5.onKeyPress(event,name);},id:name,placeholder:placeholder},type?{type:type}:{},{margin:"normal",helperText:this.state.errors[name],error:!!this.state.errors[name],FormHelperTextProps:{classes:errorClasses},disabled:disabled,maxLength:maxLength,inputRef:this[name]}));}},{key:"unlockForm",value:function unlockForm(){this.setState({unlocking:true});this.props.checkCredentials(this.state.currentEmail,this.state.currentPassword);}},{key:"updateEmail",value:function updateEmail(){this.setState({oldEmail:'',changingEmail:true,errors:{'newEmail':null}});this.props.updateEmail(this.state.currentEmail,this.state.checkedPassword,this.state.newEmail);}},{key:"updateName",value:function updateName(){this.setState({changingName:true,errors:{'newLastName':null}});var firstNameFiltered=this.getFilteredName('newFirstName');var lastNameFiltered=this.getFilteredName('newLastName');this.props.updateName(this.state.currentEmail,this.state.checkedPassword,firstNameFiltered,lastNameFiltered);}},{key:"updatePassword",value:function updatePassword(){this.setState({changingPassword:true,errors:{'newPassword':null}});this.props.updatePassword(this.state.currentEmail,this.state.checkedPassword,this.state.newPassword,this.state.confirmNewPassword);}},{key:"getFilteredName",value:function getFilteredName(name){return Object(__WEBPACK_IMPORTED_MODULE_28_utils_string__["a" /* replaceConsecutiveSpaces */])((__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(this.state,"[".concat(name,"]"))||'').trim());}},{key:"showSetPasswordPopup",value:function showSetPasswordPopup(){var _this6=this;this.props.showModal('SET_PASSWORD_MODAL',{title:localize('account-password-popup-title'),message:{__html:localize('account-password-popup-message',this.state.currentEmail)},buttons:[__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Button___default.a,{key:"set-password-button","data-tid":"button-set-password-send-email",variant:"contained",color:"primary",onClick:function onClick(){return _this6.resetPassword();}},localize('account-password-popup-button'))]});}},{key:"resetPassword",value:function resetPassword(){var qs=Object(__WEBPACK_IMPORTED_MODULE_27_utils_browser__["c" /* makeQuery */])({host:Object(__WEBPACK_IMPORTED_MODULE_27_utils_browser__["a" /* getHost */])(),email:this.state.currentEmail,'set-password':true});this.props.resetPassword(qs);}},{key:"showNewEmailSentConfirmationPopup",value:function showNewEmailSentConfirmationPopup(newEmail,oldEmail){this.props.showModal('CONFIRM_YOUR_EMAIL_ADDRESS_MODAL',{title:localize('account-confirm-email-popup-title'),message:{__html:localize('account-confirm-email-popup-message',[newEmail,oldEmail])},buttons:[__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Button___default.a,{key:"new-email-sent-confirmation-button","data-tid":"button-new-email-sent-confirmation",variant:"contained",color:"primary"},localize('close'))]});}},{key:"render",value:function render(){var _this7=this;var classes=this.props.classes;var passwordLocked=this.state.credentialsChecked||!this.state.currentPassword.length||this.state.unlocking;var emailLocked=!this.state.credentialsChecked||this.state.changingEmail;var nameLocked=!this.state.credentialsChecked||this.state.changingName;var changePasswordLocked=!this.state.credentialsChecked||this.state.changingPassword;if(!this.state.hasPassword){if(this.state.showResetPasswordSuccess||this.state.showResetPasswordError){this.props.hideModal();return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31_components_CenteredContent_CenteredContent__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_StickyHeader_StickyHeader__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Header__["a" /* default */],{className:classes.header},localize('account-header'))),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Grid___default.a,{container:true,className:classes.detailsContainer},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Grid___default.a,{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_Typography___default.a,{className:classes.emailSentMessage,variant:"body2"},this.state.showResetPasswordSuccess?localize('account-reset-password-success'):localize('account-reset-password-error')))));}else{this.showSetPasswordPopup();return null;}}else if(this.state.newEmailSuccess===true){this.props.hideModal();return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31_components_CenteredContent_CenteredContent__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_StickyHeader_StickyHeader__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Header__["a" /* default */],{className:classes.header},localize('account-header'))),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Grid___default.a,{container:true,className:classes.detailsContainer},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Grid___default.a,{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_Typography___default.a,{className:classes.emailSentMessage,variant:"body2"},localize('account-new-email-success')))));}return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31_components_CenteredContent_CenteredContent__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_StickyHeader_StickyHeader__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Header__["a" /* default */],{className:classes.header},localize('account-header'))),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Grid___default.a,{container:true,className:classes.detailsContainer},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Grid___default.a,{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_Typography___default.a,{className:classes.fieldDescription,variant:"body2"},localize('account-current-password-description')),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Grid___default.a,{container:true,direction:"row"},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Grid___default.a,{item:true,className:classes.columnField},this.field('currentPassword',localize('account-current-password-placeholder'),this.state.credentialsChecked||this.state.unlocking,'password')),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Grid___default.a,{item:true,className:classes.columnSaveButton},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Button___default.a,{variant:"contained",color:"primary","data-tid":"button-account-unlock-form",className:classes.button,disabled:passwordLocked,onClick:function onClick(){return _this7.unlockForm();}},this.state.unlocking?__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__theme_icons__["Y" /* SpinnerIcon */],{className:classes.spinnerIcon}):localize('account-current-password-button'))))),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Grid___default.a,{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_FormLabel__["a" /* default */],null,localize('account-email-label'),this.state.newEmailSuccess&&__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__theme_icons__["c" /* CheckIcon */],{className:classes.checkIcon})),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Grid___default.a,{container:true,direction:"row"},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Grid___default.a,{item:true,className:classes.columnField},this.field('newEmail',localize('account-email-placeholder'),emailLocked)),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Grid___default.a,{item:true,className:classes.columnSaveButton},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Button___default.a,{variant:"contained",color:"primary","data-tid":"button-account-update-email",className:classes.button,onClick:function onClick(){return _this7.updateEmail();},disabled:emailLocked||__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(this.state.errors,'newEmail')},this.state.changingEmail?__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__theme_icons__["Y" /* SpinnerIcon */],{className:classes.spinnerIcon}):localize('account-email-button'))))),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Grid___default.a,{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_FormLabel__["a" /* default */],null,localize('account-name-label'),this.state.newNameSuccess&&__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__theme_icons__["c" /* CheckIcon */],{className:classes.checkIcon})),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Grid___default.a,{container:true,direction:"row"},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Grid___default.a,{item:true,container:true,direction:"column",className:classes.columnField},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Grid___default.a,{item:true},this.field('newFirstName',localize('account-name-first-placeholder'),nameLocked)),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Grid___default.a,{item:true},this.field('newLastName',localize('account-name-last-placeholder'),nameLocked))),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Grid___default.a,{item:true,className:classes.columnSaveButton},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Button___default.a,{variant:"contained",color:"primary","data-tid":"button-account-update-name",className:classes.button,onClick:function onClick(){return _this7.updateName();},disabled:nameLocked||__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(this.state.errors,'newFirstName')||__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(this.state.errors,'newLastName')},this.state.changingName?__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__theme_icons__["Y" /* SpinnerIcon */],{className:classes.spinnerIcon}):localize('account-name-button'))))),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Grid___default.a,{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_FormLabel__["a" /* default */],null,localize('account-password-label'),this.state.newPasswordSuccess&&__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__theme_icons__["c" /* CheckIcon */],{className:classes.checkIcon})),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_Typography___default.a,{className:classes.fieldDescription,variant:"body2"},localize('account-password-description',[minPasswordLength,maxPasswordLength])),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Grid___default.a,{container:true,direction:"row"},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Grid___default.a,{item:true,className:classes.columnField},this.field('newPassword',localize('account-password-placeholder'),changePasswordLocked,'password',maxPasswordLength),this.field('confirmNewPassword',localize('account-password-repeat-placeholder'),changePasswordLocked,'password',maxPasswordLength)),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Grid___default.a,{item:true,className:classes.columnSaveButton},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Button___default.a,{variant:"contained",color:"primary","data-tid":"button-account-update-password",className:classes.button,onClick:function onClick(){return _this7.updatePassword();},disabled:changePasswordLocked||__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(this.state.errors,'newPassword')||__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(this.state.errors,'confirmNewPassword')},this.state.changingPassword?__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__theme_icons__["Y" /* SpinnerIcon */],{className:classes.spinnerIcon}):localize('account-password-button')))))));}}]);return AccountDetails;}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]))||_class);var mapStateToProps=function mapStateToProps(state){return{companies:state.companies,isAdmin:Object(__WEBPACK_IMPORTED_MODULE_25_utils_state__["a" /* isAdmin */])(state),isNameValid:state.companies.valid,user:state.session.user,account:state.account};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_16_redux__["b" /* bindActionCreators */])({updateName:__WEBPACK_IMPORTED_MODULE_20_redux_modules_account__["h" /* updateName */],updatePassword:__WEBPACK_IMPORTED_MODULE_20_redux_modules_account__["i" /* updatePassword */],updateEmail:__WEBPACK_IMPORTED_MODULE_20_redux_modules_account__["g" /* updateEmail */],resetPassword:__WEBPACK_IMPORTED_MODULE_20_redux_modules_account__["e" /* resetPassword */],checkCredentials:__WEBPACK_IMPORTED_MODULE_20_redux_modules_account__["a" /* checkCredentials */],showModal:__WEBPACK_IMPORTED_MODULE_30_redux_modules_modal__["d" /* showModal */],hideModal:__WEBPACK_IMPORTED_MODULE_30_redux_modules_modal__["b" /* hideModal */]},dispatch);};AccountDetails.propTypes={classes:__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.object,cloudFolders:__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.object,updateName:__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.func.isRequired,updateEmail:__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.func.isRequired,resetPassword:__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.func.isRequired,checkCredentials:__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.func.isRequired,updatePassword:__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.func.isRequired,isAdmin:__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.bool,showModal:__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.func,hideModal:__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.func,isNameValid:__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.bool,user:__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.object.isRequired,account:__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.object.isRequired,companies:__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_14_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(AccountDetails));

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validator_lib_isEmail__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validator_lib_isEmail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_validator_lib_isEmail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18n_i18n__ = __webpack_require__(15);
var localize=__WEBPACK_IMPORTED_MODULE_2_i18n_i18n__["a" /* default */].loc.localize;var consecutiveSpacesRegex=new RegExp(/ {2,}/);var leadingTrailingSpacesRegex=new RegExp(/^ | $/);var schema={'newEmail':function newEmail(value,state){if(!value){return localize('required-field');}if(state.touched['newEmail']){if(!__WEBPACK_IMPORTED_MODULE_0_validator_lib_isEmail___default()(value)){return localize('account-email-invalid');}if(state.currentEmail===value){return localize('account-email-the-same');}}},'newFirstName':function newFirstName(value,state){if(!value){return localize('required-field');}if(state.touched['newFirstName']){if(consecutiveSpacesRegex.test(value)){return localize('account-name-consecutive-spaces');}if(leadingTrailingSpacesRegex.test(value)){return localize('account-name-first-leading-trailing-spaces');}}},'newLastName':function newLastName(value,state){if(!value){return localize('required-field');}if(state.touched['newLastName']){if(consecutiveSpacesRegex.test(value)){return localize('account-name-consecutive-spaces');}if(leadingTrailingSpacesRegex.test(value)){return localize('account-name-last-leading-trailing-spaces');}}},'newPassword':function newPassword(value,state){if(state.touched['newPassword']){if(!value){return localize('required-field');}if(value.length<__WEBPACK_IMPORTED_MODULE_1__config__["a" /* ACCOUNT_SETTINGS */].minPasswordLength){return localize('account-password-too-short',__WEBPACK_IMPORTED_MODULE_1__config__["a" /* ACCOUNT_SETTINGS */].minPasswordLength);}if(value.length>__WEBPACK_IMPORTED_MODULE_1__config__["a" /* ACCOUNT_SETTINGS */].maxPasswordLength){return localize('account-password-too-long',__WEBPACK_IMPORTED_MODULE_1__config__["a" /* ACCOUNT_SETTINGS */].maxPasswordLength);}}},'confirmNewPassword':function confirmNewPassword(value,state){if(state.touched['confirmNewPassword']){if(!value){return localize('required-field');}if(value.length<__WEBPACK_IMPORTED_MODULE_1__config__["a" /* ACCOUNT_SETTINGS */].minPasswordLength){return localize('account-password-too-short',__WEBPACK_IMPORTED_MODULE_1__config__["a" /* ACCOUNT_SETTINGS */].minPasswordLength);}if(value.length>__WEBPACK_IMPORTED_MODULE_1__config__["a" /* ACCOUNT_SETTINGS */].maxPasswordLength){return localize('account-password-too-long',__WEBPACK_IMPORTED_MODULE_1__config__["a" /* ACCOUNT_SETTINGS */].maxPasswordLength);}}}};/* harmony default export */ __webpack_exports__["a"] = (schema);

/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Header__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux_store__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CustomizeSchema__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_StickyHeader_StickyHeader__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_redux_modules_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_validator_lib_isEmail__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_validator_lib_isEmail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_validator_lib_isEmail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_i18n_i18n__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_CenteredContent_CenteredContent__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__theme_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_redux_modules_companies__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__material_ui_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_theme_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_FormField__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__errors_errorids__ = __webpack_require__(22);
var _errors,_dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_19_i18n_i18n__["a" /* default */].loc.localize;var onLeaveMessage=localize('leave-page-confirmation');var errors=(_errors={},__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_27__errors_errorids__["a" /* default */].OFFLINE,localize('subscriptions-error-offline')),__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_27__errors_errorids__["a" /* default */].API_REQUEST_LIMIT_EXCEEDED,localize('error-cb-api-rate-limit-reached')),_errors);var styles=function styles(theme){return{header:{paddingBottom:20},sectionHeading:{marginTop:20,marginBottom:12,paddingLeft:8,fontSize:18,lineHeight:1.5,fontWeight:'bold'},sectionHeadingEditor:{paddingBottom:5},sectionHeadingOther:{paddingBottom:5},showInHomeScreen:{marginTop:10,marginBottom:10,fontSize:14,lineHeight:1.5,color:'#2E3F4F',opacity:1},detailsContainer:{marginTop:theme.spacing.unit*2},detailsContainerDivider:{borderTop:'1px solid #aabfd1',paddingTop:6},details:{paddingBottom:theme.spacing.unit*4},row:{marginBottom:5,'&.hover':{background:'#e0f5fe'}},firstRow:{'&.hover':{background:'#e0f5fe'}},lastRow:{'& p':{position:'relative',top:7}},labelContainer:{'& p':{fontSize:14,lineHeight:1.5,paddingTop:10,color:'#2E3F4F',opacity:1}},checkboxLabel:{width:408},switchLabel:{width:408,'& p':{paddingTop:5}},hasIcon:{padding:'0 0 0 25px','& p':{display:'inline-block'}},hasInfoIcon:{padding:'0 0 0 8px','& p':{display:'inline-block'}},fieldsetLabel:{'& p':{fontWeight:600,paddingLeft:10,paddingBottom:12}},/* checkbox */columnCheckbox:{},checkbox:{padding:'6px 16px 6px 0',marginLeft:-3},checkboxUnchecked:{color:'#2E3F4F'},checkboxUncheckedHover:{color:'#2888C3'},checkboxChecked:{root:{'&$checked':{color:'#2FA5E7'}}},checkboxCheckedHover:{color:'#2888C3 !important'},icon:{display:'inline-block',position:'relative',top:'7px',marginRight:'10px',color:'#2E3F4F'},/* switch */columnSwitch:{},infoIcon:{width:12,height:12,position:'relative',top:16,color:'#6F99BD',border:'1px solid #6F99BD',padding:0,marginLeft:6},/* switch custom style */SwitchBase:{height:40,'&$SwitchChecked':{color:theme.palette.common.white,'& + $SwitchBar':{backgroundColor:'#2FA5E7'}}},SwitchChecked:{transform:'translateX(13px)','& + $SwitchBar':{opacity:1,border:'none'}},SwitchBar:{borderRadius:6,width:16,height:8,marginTop:-4,marginLeft:-9,border:'solid 1px',borderColor:'#6F99BD',backgroundColor:'#6F99BD',opacity:1,transition:theme.transitions.create(['background-color','border'])},SwitchIcon:{width:10,height:10,border:'1px solid #6F99BD'},SwitchIconChecked:{boxShadow:theme.shadows[1],border:'1px solid #2FA5E7'},/* switch hover style */SwitchBaseHovered:{height:40,'&$SwitchCheckedHovered':{color:theme.palette.common.white,'& + $SwitchBarHovered':{backgroundColor:'#2888C3'}}},SwitchCheckedHovered:{transform:'translateX(13px)','& + $SwitchBarHovered':{opacity:1,border:'none'}},SwitchBarHovered:{borderRadius:6,width:16,height:8,marginTop:-4,marginLeft:-9,border:'solid 1px',borderColor:'#2888C3',backgroundColor:'#2888C3',opacity:1,transition:theme.transitions.create(['background-color','border'])},SwitchIconHovered:{width:10,height:10,border:'1px solid #2888C3'},SwitchIconCheckedHovered:{boxShadow:theme.shadows[1],border:'1px solid #2888C3'},/* switch disabled style */SwitchBaseDisabled:{height:40,'&$SwitchCheckedDisabled':{color:theme.palette.common.white,'& + $SwitchBarDisabled':{backgroundColor:'#bdbdbd'}}},SwitchCheckedDisabled:{transform:'translateX(13px)','& + $SwitchBarDisabled':{opacity:1,border:'none'}},SwitchBarDisabled:{borderRadius:6,width:16,height:8,marginTop:-4,marginLeft:-9,border:'solid 1px',borderColor:'#bdbdbd',backgroundColor:'#bdbdbd',opacity:1,transition:theme.transitions.create(['background-color','border'])},SwitchIconDisabled:{width:10,height:10,border:'1px solid #bdbdbd'},SwitchIconCheckedDisabled:{boxShadow:theme.shadows[1],border:'1px solid #bdbdbd'},/* tooltip */arrow:{position:'absolute',fontSize:6,width:'3em',height:'1em',bottom:0,left:'50%',transform:'translateX(-50%)',marginBottom:'-0.95em','&::before':{content:'""',margin:'auto',display:'block',width:0,height:0,borderStyle:'solid',borderWidth:'1em 1em 0 1em',borderColor:"".concat(theme.palette.common.black," transparent transparent transparent")}},infoTooltip:{padding:7,backgroundColor:theme.palette.common.black},infoTooltipText:{color:theme.palette.common.white,opacity:1},/* text field */textField:{width:240,margin:'0 0 5px 20px','& input':{border:'1px solid #aabfd1',borderStyle:'solid',borderRadius:5,color:theme.palette.text.primary,padding:'10px','&:focus, &:hover':{borderColor:'#2FA5E7'},'&::placeholder':{fontFamily:'Open Sans, sans-serif',fontWeight:'normal',fontStyle:'normal',fontSize:'14px',lineHeight:'19px',color:theme.palette.text.primary}},'& [id*=helper-text]':{paddingLeft:0,color:theme.palette.error.main},'& [class*=error] input':{borderColor:"".concat(theme.palette.error.main," !important")}},errorMessage:{color:theme.palette.error.main,opacity:1,marginTop:15,marginBottom:0,width:'100%'},spinnerIcon:{height:'24px',width:'24px',fill:'#bdbdbd',margin:'8px 0 0 16px',animation:'spin 2s linear infinite'},checkIcon:{color:theme.palette.colors.grey,margin:'10px 0 0 10px','&.modified':{'&:hover':{color:'#2888C3'}}},'@keyframes spin':{'0':{transform:'rotate(0deg)'},'100%':{transform:'rotate(360deg)'}}};};var Customize=(_dec=Object(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["N" /* withStyles */])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Customize,_Component);function Customize(props){var _this;__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this,Customize);_this=__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(Customize).call(this,props));_this.defaultPrintDocumentRecipientEmail=__WEBPACK_IMPORTED_MODULE_8_react___default.a.createRef();var defaultPrintDocumentRecipientEmail=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(_this.props.company,'settings.defaultPrintDocumentRecipientEmail','');_this.state={currentPrintDocumentRecipientEmail:defaultPrintDocumentRecipientEmail,newDefaultPrintDocumentRecipientEmail:defaultPrintDocumentRecipientEmail,oldDefaultPrintDocumentRecipientEmail:'',defaultPrintDocumentRecipientEmailSucess:false,teamDocumentsChecked:__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(_this.props.company,'settings.teamDocumentsEnabled',true),teamDocumentsHovered:false,teamTemplatesPlaybookFoldersAdminOnlyChecked:__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(_this.props.company,'settings.teamTemplatesPlaybookFoldersAdminOnlyEnabled',false),teamTemplatesPlaybookFoldersAdminOnlyHovered:false,xaraTemplatesChecked:__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(_this.props.company,'settings.xaraTemplatesEnabled',true),xaraTemplatesHovered:false,xaraTemplatesAdminOnlyChecked:__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(_this.props.company,'settings.xaraTemplatesAdminOnlyEnabled',false),xaraTemplatesAdminOnlyHovered:false,autoAddAssetsChecked:__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(_this.props.company,'settings.autoAddAssetsEnabled',true),autoAddAssetsHovered:false,showCommercialPrintingChecked:__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(_this.props.company,'settings.showCommercialPrintingEnabled',true),showCommercialPrintingHovered:false,xpressDocsIntegrationChecked:__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(_this.props.company,'settings.xpressDocsIntegrationEnabled',true),xpressDocsIntegrationHovered:false,onlyAdminsCanPublishTeamDocsChecked:__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(_this.props.company,'settings.onlyAdminsCanPublishTeamDocsEnabled',false),onlyAdminsCanPublishTeamDocsHovered:false,onlyAdminsCanImportDocsChecked:__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(_this.props.company,'settings.onlyAdminsCanImportDocsEnabled',false),onlyAdminsCanImportDocsHovered:false,pendingKey:null,pendingValue:null,successKey:null,errors:{},touched:{}};_this.onBeforeUnload=_this.onBeforeUnload.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.saveTextFieldChange=_this.saveTextFieldChange.bind(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_assertThisInitialized___default()(_this));return _this;}__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(Customize,[{key:"handleUpdate",value:function handleUpdate(nextProps){if(nextProps.company.companySettingsUpdateSuccess===true){var newProps={successKey:this.state.pendingKey,pendingKey:null,pendingValue:null,touched:{}};if(this.state.pendingKey==='defaultPrintDocumentRecipientEmail'){newProps.currentPrintDocumentRecipientEmail=this.state.pendingValue;}this.setState(newProps);}else if(nextProps.company.companySettingsUpdateSuccess===false){var _this$setState;this.setState((_this$setState={},__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_this$setState,"".concat(this.state.pendingKey,"Checked"),!this.state.pendingValue),__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_this$setState,"".concat(this.state.pendingKey,"Hovered"),false),__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_this$setState,"pendingKey",null),__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_this$setState,"pendingValue",null),_this$setState));}}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(this.props.company.companySettingsUpdateSuccess!==nextProps.company.companySettingsUpdateSuccess){this.handleUpdate(nextProps);}}},{key:"handleToggleChange",value:function handleToggleChange(event,key){var _this$setState2;this.setState((_this$setState2={},__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_this$setState2,"".concat(key,"Checked"),event.target.checked),__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_this$setState2,"pendingKey",key),__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_this$setState2,"pendingValue",event.target.checked),_this$setState2));this.props.writeCompanySettings(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()({},"".concat(key,"Enabled"),event.target.checked));}},{key:"rowMouseEnter",value:function rowMouseEnter(event){event.currentTarget.classList.add('hover');}},{key:"rowMouseLeave",value:function rowMouseLeave(event){event.currentTarget.classList.remove('hover');}},{key:"formElementMouseEnter",value:function formElementMouseEnter(key){this.setState(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()({},"".concat(key,"Hovered"),true));}},{key:"formElementMouseLeave",value:function formElementMouseLeave(key){this.setState(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()({},"".concat(key,"Hovered"),false));}},{key:"getCheckboxClassName",value:function getCheckboxClassName(isChecked,isHovered){var classes=this.props.classes;if(isChecked){return"".concat(classes.checkbox," ").concat(isHovered?classes.checkboxCheckedHover:classes.checkboxChecked);}else{return"".concat(classes.checkbox," ").concat(isHovered?classes.checkboxUncheckedHover:classes.checkboxUnchecked);}}},{key:"doIfCanLeave",value:function doIfCanLeave(callback){if(!this.hasUnsavedData()){callback(true);return;}this.props.showModal('CONFIRMATION_MODAL',{message:onLeaveMessage,buttons:[__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["a" /* Button */],{key:"button-cancel",variant:"outlined",color:"primary","data-tid":"button-account-stay",onClick:function onClick(){callback(false);}},localize('stay-on-page')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["a" /* Button */],{key:"button-confirm","data-tid":"button-account-leave",variant:"contained",color:"primary",onClick:function onClick(){callback(true);}},localize('leave-page'))]});}},{key:"onBeforeUnload",value:function onBeforeUnload(e){if(this.hasUnsavedData()){var dialogText=onLeaveMessage;e.returnValue=dialogText;return dialogText;}}},{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_11_redux_store__["c" /* setConfirmationFunction */])(function(message,callback){_this2.doIfCanLeave(callback);});this.historyUnblock=__WEBPACK_IMPORTED_MODULE_11_redux_store__["b" /* history */].block('');window.addEventListener('beforeunload',this.onBeforeUnload);}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.historyUnblock();Object(__WEBPACK_IMPORTED_MODULE_11_redux_store__["c" /* setConfirmationFunction */])(null);this.defaultPrintDocumentRecipientEmail=null;window.removeEventListener('beforeunload',this.onBeforeUnload);}},{key:"hasUnsavedData",value:function hasUnsavedData(){return this.state.currentPrintDocumentRecipientEmail!=this.state.newDefaultPrintDocumentRecipientEmail;}},{key:"onTextFieldChange",value:function onTextFieldChange(event,name){this.setFieldState(name,event.target.value);}},{key:"setFieldState",value:function setFieldState(name,value){var newState=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.cloneDeep(this.state);newState.touched[name]=true;newState[name]=value;newState.pendingKey=null;newState.pendingValue=null;newState.successKey=null;if(this.state.errors[name]){this.setState(newState,this.validateAll);}else{this.setState(newState);}}},{key:"onTextFieldBlur",value:function onTextFieldBlur(event,name){var newState=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.cloneDeep(this.state);if(this.hasUnsavedData()){newState.touched[name]=true;this.setState(newState,this.validateAll);}}},{key:"onTextFieldSave",value:function onTextFieldSave(event,name){if(name==='newDefaultPrintDocumentRecipientEmail'&&this.hasUnsavedData()){this.validateAll(function(){this.saveTextFieldChange('defaultPrintDocumentRecipientEmail',this.state.newDefaultPrintDocumentRecipientEmail);}.bind(this));}}},{key:"onTextFieldKeyPress",value:function onTextFieldKeyPress(event,name){if(event.key==='Enter'&&name==='newDefaultPrintDocumentRecipientEmail'&&this.hasUnsavedData()){this.validateAll(function(){this.saveTextFieldChange('defaultPrintDocumentRecipientEmail',this.state.newDefaultPrintDocumentRecipientEmail);}.bind(this));}}},{key:"saveTextFieldChange",value:function saveTextFieldChange(key,value){this.setState({key:value,pendingKey:key,pendingValue:value});this.props.writeCompanySettings(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()({},key,value));}},{key:"validateAll",value:function validateAll(cb){var errors={};for(var field in __WEBPACK_IMPORTED_MODULE_12__CustomizeSchema__["a" /* default */]){var validate=__WEBPACK_IMPORTED_MODULE_12__CustomizeSchema__["a" /* default */][field];if(validate){var error=validate(this.state[field],this.state,this.props);if(error){errors[field]=error;}}}this.setState({errors:errors},function(){__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.isEmpty(errors)&&cb&&cb();});}},{key:"renderTextField",value:function renderTextField(name,placeholder,disabled,type){var _this3=this;var classes=this.props.classes;var errorClasses={root:classes.root,error:classes.error};return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_FormField__["a" /* default */],__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({value:this.state[name],className:classes.textField,"data-tid":"form-customize-".concat(name),onChange:function onChange(event){return _this3.onTextFieldChange(event,name);},onBlur:function onBlur(event){return _this3.onTextFieldBlur(event,name);},onKeyPress:function onKeyPress(event){return _this3.onTextFieldKeyPress(event,name);},id:name,placeholder:placeholder},type?{type:type}:{},{margin:"normal",helperText:this.state.errors[name],error:!!this.state.errors[name],FormHelperTextProps:{classes:errorClasses},disabled:disabled,inputRef:this[name]}));}},{key:"renderCheckbox",value:function renderCheckbox(key,isDisabled,isChecked,className){var _this4=this;var classes=this.props.classes;if(isDisabled){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["b" /* Checkbox */],{disabled:true,checked:isChecked,"data-tid":"customize-company-settings-".concat(key),id:"customize-company-settings-".concat(key),className:classes.checkbox,color:"primary"});}else{return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["b" /* Checkbox */],{checked:isChecked,"data-tid":"customize-company-settings-".concat(key),id:"customize-company-settings-".concat(key),onChange:function onChange(event){return _this4.handleToggleChange(event,key);},className:className,onMouseEnter:function onMouseEnter(){return _this4.formElementMouseEnter(key);},onMouseLeave:function onMouseLeave(){return _this4.formElementMouseLeave(key);},color:"primary"});}}},{key:"renderSwitch",value:function renderSwitch(key,isDisabled,isChecked,isHovered){var _this5=this;var lockedOnDisabled=arguments.length>4&&arguments[4]!==undefined?arguments[4]:true;var classes=this.props.classes;if(isDisabled){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["E" /* Switch */],{disabled:true,checked:lockedOnDisabled?true:isChecked,classes:{switchBase:classes.SwitchBaseDisabled,bar:classes.SwitchBarDisabled,icon:classes.SwitchIconDisabled,iconChecked:classes.SwitchIconCheckedDisabled,checked:classes.SwitchCheckedDisabled},"data-tid":"customize-company-settings-".concat(key),id:"customize-company-settings-".concat(key),color:"primary"});}else{return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["E" /* Switch */],{checked:isChecked,"data-tid":"customize-company-settings-".concat(key),id:"customize-company-settings-".concat(key),onChange:function onChange(event){return _this5.handleToggleChange(event,key);},classes:{switchBase:isHovered?classes.SwitchBaseHovered:classes.SwitchBase,bar:isHovered?classes.SwitchBarHovered:classes.SwitchBar,icon:isHovered?classes.SwitchIconHovered:classes.SwitchIcon,iconChecked:isHovered?classes.SwitchIconCheckedHovered:classes.SwitchIconChecked,checked:isHovered?classes.SwitchCheckedHovered:classes.SwitchChecked},onMouseEnter:function onMouseEnter(){return _this5.formElementMouseEnter(key);},onMouseLeave:function onMouseLeave(){return _this5.formElementMouseLeave(key);},color:"primary"});}}},{key:"render",value:function render(){var _this6=this;var classes=this.props.classes;var teamDocumentsChecked=this.state.teamDocumentsChecked;var teamDocumentsHovered=this.state.teamDocumentsHovered;var teamTemplatesPlaybookFoldersAdminOnlyChecked=this.state.teamTemplatesPlaybookFoldersAdminOnlyChecked;var teamTemplatesPlaybookFoldersAdminOnlyHovered=this.state.teamTemplatesPlaybookFoldersAdminOnlyHovered;var teamTemplatesPlaybookFoldersAdminOnlyClassName=this.getCheckboxClassName(teamTemplatesPlaybookFoldersAdminOnlyChecked,teamTemplatesPlaybookFoldersAdminOnlyHovered);var xaraTemplatesChecked=this.state.xaraTemplatesChecked;var xaraTemplatesHovered=this.state.xaraTemplatesHovered;var xaraTemplatesAdminOnlyChecked=this.state.xaraTemplatesAdminOnlyChecked;var xaraTemplatesAdminOnlyHovered=this.state.xaraTemplatesAdminOnlyHovered;var xaraTemplatesAdminOnlyClassName=this.getCheckboxClassName(xaraTemplatesAdminOnlyChecked,xaraTemplatesAdminOnlyHovered);var autoAddAssetsChecked=this.state.autoAddAssetsChecked;var autoAddAssetsHovered=this.state.autoAddAssetsHovered;var onlyAdminsCanPublishTeamDocsChecked=this.state.onlyAdminsCanPublishTeamDocsChecked;var onlyAdminsCanPublishTeamDocsHovered=this.state.onlyAdminsCanPublishTeamDocsHovered;var onlyAdminsCanImportDocsChecked=this.state.onlyAdminsCanImportDocsChecked;var onlyAdminsCanImportDocsHovered=this.state.onlyAdminsCanImportDocsHovered;var showCommercialPrintingChecked=this.state.showCommercialPrintingChecked;var showCommercialPrintingHovered=this.state.showCommercialPrintingHovered;var xpressDocsIntegrationChecked=this.state.xpressDocsIntegrationChecked;var xpressDocsIntegrationHovered=this.state.xpressDocsIntegrationHovered;var defaultPrintDocumentRecipientEmailDisabled=this.state.pendingKey&&this.state.pendingKey==='defaultPrintDocumentRecipientEmail';var renderErrorMessage=function renderErrorMessage(){if(_this6.props.company.companySettingsUpdatingErrorId){var errorMessage=errors[_this6.props.company.companySettingsUpdatingErrorId]||localize('subscriptions-error-unknown');return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["M" /* Typography */],{className:classes.errorMessage,variant:"body2",dangerouslySetInnerHTML:{__html:errorMessage}});}};var renderTextFieldStateIcon=function renderTextFieldStateIcon(stateFieldName,dbFieldName){if(_this6.state.successKey===dbFieldName){return;}else if(_this6.state.pendingKey===dbFieldName){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__theme_icons__["Y" /* SpinnerIcon */],{className:classes.spinnerIcon});}else if(Object.keys(_this6.state.touched).includes(stateFieldName)&&_this6.hasUnsavedData()&&(stateFieldName!=='newDefaultPrintDocumentRecipientEmail'||__WEBPACK_IMPORTED_MODULE_18_validator_lib_isEmail___default()(_this6.state[stateFieldName])||_this6.state[stateFieldName]==='')){var _classNames;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["L" /* Tooltip */],{placement:"top",title:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["M" /* Typography */],{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()(classes.infoTooltipText)},localize('customize-text-field-save')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span",{className:classes.arrow})),classes:{tooltip:classes.infoTooltip}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__theme_icons__["J" /* IconTextFieldStatus */],{className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()((_classNames={},__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_classNames,classes.checkIcon,true),__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_classNames,'modified',true),_classNames)),onClick:function onClick(event){return _this6.onTextFieldSave(event,stateFieldName);}}));}};return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_CenteredContent_CenteredContent__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_StickyHeader_StickyHeader__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Header__["a" /* default */],{className:classes.header},localize('customize-header')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{container:true,className:classes.details},renderErrorMessage())),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{container:true,className:classes.detailsContainer},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["M" /* Typography */],{className:classes.sectionHeading,variant:"body2"},localize('customize-home-screen'))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{container:true,direction:"row",className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()(classes.firstRow,classes.lastRow),onMouseEnter:this.rowMouseEnter,onMouseLeave:this.rowMouseLeave},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{item:true,container:true,className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()(classes.labelContainer,classes.switchLabel,classes.hasInfoIcon)},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["M" /* Typography */],{variant:"body2"},localize('customize-admins-only-import-docs'))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{item:true,className:classes.columnSwitch},this.renderSwitch('onlyAdminsCanImportDocs',false,onlyAdminsCanImportDocsChecked,onlyAdminsCanImportDocsHovered)))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["l" /* FormGroup */],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{container:true,direction:"row"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{item:true,className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()(classes.labelContainer,classes.checkboxLabel,classes.fieldsetLabel)},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["M" /* Typography */],{variant:"body2"},localize('customize-files',this.props.company.displayName)))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{container:true,direction:"row",className:classes.row,onMouseEnter:this.rowMouseEnter,onMouseLeave:this.rowMouseLeave},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{item:true,className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()(classes.labelContainer,classes.checkboxLabel,classes.hasIcon)},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__theme_icons__["m" /* DocumentsIcon */],{className:classes.icon}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["M" /* Typography */],{variant:"body2"},localize('customize-documents'))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{item:true},this.renderSwitch('teamDocuments',false,teamDocumentsChecked,teamDocumentsHovered)),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{item:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["M" /* Typography */],{className:classes.showInHomeScreen,variant:"body2"},localize('customize-show-in-home-screen')))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{container:true,direction:"row",className:classes.row,onMouseEnter:this.rowMouseEnter,onMouseLeave:this.rowMouseLeave},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{item:true,className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()(classes.labelContainer,classes.checkboxLabel,classes.hasIcon)},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__theme_icons__["_3" /* TemplatesIcon */],{className:classes.icon}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["M" /* Typography */],{variant:"body2"},localize('customize-templates'))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{item:true},this.renderSwitch('teamTemplates',/* isDisabled */true)),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{item:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["M" /* Typography */],{className:classes.showInHomeScreen,variant:"body2"},localize('customize-show-in-home-screen'))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{item:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{container:true,direction:"row"},this.renderCheckbox('teamTemplatesPlaybookFoldersAdminOnly',false,teamTemplatesPlaybookFoldersAdminOnlyChecked,teamTemplatesPlaybookFoldersAdminOnlyClassName),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["M" /* Typography */],{className:classes.showInHomeScreen,variant:"body2"},localize('customize-show-playbook-folders-to-admins-only')))))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{container:true,direction:"row",className:classes.row,onMouseEnter:this.rowMouseEnter,onMouseLeave:this.rowMouseLeave},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{item:true,className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()(classes.labelContainer,classes.checkboxLabel,classes.hasIcon)},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__theme_icons__["b" /* AssetsIcon */],{className:classes.icon}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["M" /* Typography */],{variant:"body2"},localize('customize-assets'))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{item:true},this.renderSwitch('teamAssets',true)),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{item:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["M" /* Typography */],{className:classes.showInHomeScreen,variant:"body2"},localize('customize-show-in-home-screen')))))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{container:true,direction:"row",className:classes.row,onMouseEnter:this.rowMouseEnter,onMouseLeave:this.rowMouseLeave},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{item:true,className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()(classes.labelContainer,classes.checkboxLabel,classes.fieldsetLabel)},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["M" /* Typography */],{variant:"body2"},localize('customize-xara-templates'))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{item:true},this.renderSwitch('xaraTemplates',false,xaraTemplatesChecked,xaraTemplatesHovered)),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{item:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{item:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["M" /* Typography */],{className:classes.showInHomeScreen,variant:"body2"},localize('customize-show-in-home-screen'))),xaraTemplatesChecked&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{item:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{container:true,direction:"row"},this.renderCheckbox('xaraTemplatesAdminOnly',false,xaraTemplatesAdminOnlyChecked,xaraTemplatesAdminOnlyClassName),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["M" /* Typography */],{className:classes.showInHomeScreen,variant:"body2"},localize('customize-show-to-admins-only'))))))))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{container:true,className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()(classes.detailsContainer,classes.detailsContainerDivider)},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["M" /* Typography */],{className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()(classes.sectionHeading,classes.sectionHeadingEditor),variant:"body2"},localize('customize-editor'))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{container:true,direction:"row",className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()(classes.row,classes.lastRow),onMouseEnter:this.rowMouseEnter,onMouseLeave:this.rowMouseLeave},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{item:true,container:true,className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()(classes.labelContainer,classes.switchLabel,classes.hasInfoIcon)},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["M" /* Typography */],{variant:"body2"},localize('customize-automatically-save-images')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["L" /* Tooltip */],{placement:"top",title:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["M" /* Typography */],{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()(classes.infoTooltipText)},localize('customize-automatically-save-images-info')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span",{className:classes.arrow})),classes:{tooltip:classes.infoTooltip}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["p" /* IconButton */],{className:classes.infoIcon,color:"primary",component:"span",disableRipple:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_theme_icons__["N" /* Info */],null)))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{item:true,className:classes.columnSwitch},this.renderSwitch('autoAddAssets',false,autoAddAssetsChecked,autoAddAssetsHovered)))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{container:true,direction:"row",className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()(classes.row,classes.lastRow),onMouseEnter:this.rowMouseEnter,onMouseLeave:this.rowMouseLeave},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{item:true,container:true,className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()(classes.labelContainer,classes.switchLabel,classes.hasInfoIcon)},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["M" /* Typography */],{variant:"body2"},localize('customize-admins-only-publish-team-docs'))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{item:true,className:classes.columnSwitch},this.renderSwitch('onlyAdminsCanPublishTeamDocs',false,onlyAdminsCanPublishTeamDocsChecked,onlyAdminsCanPublishTeamDocsHovered))))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{container:true,className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()(classes.detailsContainer,classes.detailsContainerDivider)},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["M" /* Typography */],{className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()(classes.sectionHeading,classes.sectionHeadingOther),variant:"body2"},localize('customize-other'))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{container:true,direction:"row",className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()(classes.row,classes.lastRow),onMouseEnter:this.rowMouseEnter,onMouseLeave:this.rowMouseLeave},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{item:true,container:true,className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()(classes.labelContainer,classes.switchLabel,classes.hasInfoIcon)},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["M" /* Typography */],{variant:"body2"},localize('customize-show-commercial-printing'))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{item:true,className:classes.columnSwitch},this.renderSwitch('showCommercialPrinting',false,showCommercialPrintingChecked,showCommercialPrintingHovered,false)))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{container:true,direction:"row",className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()(classes.row,classes.lastRow),onMouseEnter:this.rowMouseEnter,onMouseLeave:this.rowMouseLeave},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{item:true,container:true,className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()(classes.labelContainer,classes.switchLabel,classes.hasInfoIcon)},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["M" /* Typography */],{variant:"body2"},localize('customize-xpressdocs-integration'))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{item:true,className:classes.columnSwitch},this.renderSwitch('xpressDocsIntegration',!showCommercialPrintingChecked,showCommercialPrintingChecked&&xpressDocsIntegrationChecked,xpressDocsIntegrationHovered,false)))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{container:true,direction:"row",className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()(classes.row,classes.lastRow)},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{item:true,container:true,className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()(classes.labelContainer,classes.switchLabel,classes.hasInfoIcon)},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["M" /* Typography */],{variant:"body2"},localize('customize-default-print-document-recipient')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["L" /* Tooltip */],{placement:"top",title:__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["M" /* Typography */],{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_10_classnames___default()(classes.infoTooltipText)},localize('customize-default-print-document-recipient-info')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span",{className:classes.arrow})),classes:{tooltip:classes.infoTooltip}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["p" /* IconButton */],{className:classes.infoIcon,color:"primary",component:"span",disableRipple:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_theme_icons__["N" /* Info */],null)))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core__["o" /* Grid */],{item:true,className:classes.columnTextField},this.renderTextField('newDefaultPrintDocumentRecipientEmail',localize('customize-default-print-document-recipient-placeholder'),defaultPrintDocumentRecipientEmailDisabled,'email'),renderTextFieldStateIcon('newDefaultPrintDocumentRecipientEmail','defaultPrintDocumentRecipientEmail'))))));}}]);return Customize;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]))||_class);var mapStateToProps=function mapStateToProps(state){return{company:state.companies.rawDataById[state.companies.selectedId],companyIsUpdating:state.companies.companyIsUpdating,companies:state.companies};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_15_redux__["b" /* bindActionCreators */])({writeCompanySettings:__WEBPACK_IMPORTED_MODULE_23_redux_modules_companies__["R" /* writeCompanySettings */],showModal:__WEBPACK_IMPORTED_MODULE_17_redux_modules_modal__["d" /* showModal */],hideModal:__WEBPACK_IMPORTED_MODULE_17_redux_modules_modal__["b" /* hideModal */]},dispatch);};Customize.propTypes={classes:__WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.object,company:__WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.object,writeCompanySettings:__WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.func,showModal:__WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.func,hideModal:__WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.func,companyIsUpdating:__WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.bool.isRequired,companies:__WEBPACK_IMPORTED_MODULE_16_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_14_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Customize));

/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validator_lib_isEmail__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validator_lib_isEmail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_validator_lib_isEmail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_i18n__ = __webpack_require__(15);
var localize=__WEBPACK_IMPORTED_MODULE_1_i18n_i18n__["a" /* default */].loc.localize;var schema={'newDefaultPrintDocumentRecipientEmail':function newDefaultPrintDocumentRecipientEmail(value,state){if(!value){// allow empty value
return false;}if(state.touched['newDefaultPrintDocumentRecipientEmail']&&!__WEBPACK_IMPORTED_MODULE_0_validator_lib_isEmail___default()(value)){return localize('customize-default-print-document-recipient-email-invalid');}}};/* harmony default export */ __webpack_exports__["a"] = (schema);

/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_subscription__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__theme_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_routes__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_redux_modules_companies__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_redux_modules_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lib_Segment_customTrackers__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lib_Segment_helpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_i18n_i18n__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core__ = __webpack_require__(28);
var _dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_20_i18n_i18n__["a" /* default */].loc.localize;var styles=function styles(theme){return{wrongAccount:{textAlign:'center',margin:'4rem'},wrongAccountTitle:{margin:'3rem 0 4.7rem',fontWeight:'bold'},xDarkLogo:{width:'57px',height:'57px',display:'inline',position:'relative',top:'10px'},xaraLogo:{width:'85px',height:'30px',display:'inline',color:theme.palette.colors.alpha},currentlySignedInTitle:{fontSize:'22px',lineHeight:'32px',fontWeight:'bold',color:'#2E3F4F'},currentlySignedInEmail:{margin:'1.5rem 0 2rem',fontWeight:'bold'},list:{display:'inline-block'},listItem:{marginBottom:'10px','&:hover button, &:hover a':{textDecoration:'none',color:theme.palette.colors.zeta},'&:hover svg':{color:theme.palette.colors.zeta}},listItemIcon:{margin:'0 10px 0 0'},listItemText:{padding:0},nextIcon:{width:'16px',height:'16px',color:theme.palette.colors.alpha,position:'relative',top:'1px'},listItemLink:{fontSize:'18px',lineHeight:'23px',fontWeight:'bold'}};};var WrongAccount=(_dec=Object(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(WrongAccount,_Component);function WrongAccount(){__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this,WrongAccount);return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(WrongAccount).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(WrongAccount,[{key:"componentDidMount",value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_17_lib_Segment_customTrackers__["_0" /* trackWrongAccountScreen */])(Object(__WEBPACK_IMPORTED_MODULE_18_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}},{key:"renderUpgradePopup",value:function renderUpgradePopup(planId,currency,productName,productLang,magixSerial,magixEmail,magixCat,couponId,isUpgradePopup,realEstatePlan,isCBPlanExternalRedirect,isCBPlanInternalRedirect,productQuantity,productPeriod,productSource){if(planId){this.props.showModal('UPGRADE_COMPANY_MODAL',{planId:planId,currency:currency,productName:productName,productLang:productLang,magixSerial:magixSerial,magixEmail:magixEmail,magixCat:magixCat,couponId:couponId,isUpgradePopup:isUpgradePopup,realEstatePlan:realEstatePlan,isCBPlanExternalRedirect:isCBPlanExternalRedirect,isCBPlanInternalRedirect:isCBPlanInternalRedirect,productQuantity:productQuantity,productPeriod:productPeriod,productSource:productSource});}}},{key:"renderCompanySelectionPopup",value:function renderCompanySelectionPopup(redirectURL){this.props.showModal('COMPANY_SELECTION_MODAL',{redirectURL:redirectURL});}},{key:"render",value:function render(){var _this=this;var _this$props=this.props,classes=_this$props.classes,companies=_this$props.companies,currentUserEmail=_this$props.currentUserEmail;var rawDataById=companies.rawDataById;var sessionCompanyId=Object(__WEBPACK_IMPORTED_MODULE_15_redux_modules_companies__["D" /* resolveActiveCompanyId */])(false);var sessionCompany=companies.rawDataById[sessionCompanyId];var prevLocationPath=__WEBPACK_IMPORTED_MODULE_21_lodash___default.a.get(this.props,'location.state.prevLocationPath');var prevLocationSearch=__WEBPACK_IMPORTED_MODULE_21_lodash___default.a.get(this.props,'location.state.prevLocationSearch');var prevLocationCurrency=__WEBPACK_IMPORTED_MODULE_21_lodash___default.a.get(this.props,'location.state.prevLocationCurrency');var prevLocationProductName=__WEBPACK_IMPORTED_MODULE_21_lodash___default.a.get(this.props,'location.state.prevLocationProductName');var prevLocationProductQuantity=__WEBPACK_IMPORTED_MODULE_21_lodash___default.a.get(this.props,'location.state.prevLocationProductQuantity');var prevLocationProductSource=__WEBPACK_IMPORTED_MODULE_21_lodash___default.a.get(this.props,'location.state.prevLocationProductSource');var prevLocationProductPeriod=__WEBPACK_IMPORTED_MODULE_21_lodash___default.a.get(this.props,'location.state.prevLocationProductPeriod');var prevLocationProductLanguage=__WEBPACK_IMPORTED_MODULE_21_lodash___default.a.get(this.props,'location.state.prevLocationProductLanguage');var prevLocationMagixSerial=__WEBPACK_IMPORTED_MODULE_21_lodash___default.a.get(this.props,'location.state.prevLocationMagixSerial');var prevLocationMagixEmail=__WEBPACK_IMPORTED_MODULE_21_lodash___default.a.get(this.props,'location.state.prevLocationMagixEmail');var prevLocationMagixCat=__WEBPACK_IMPORTED_MODULE_21_lodash___default.a.get(this.props,'location.state.prevLocationMagixCat');var prevLocationCouponId=__WEBPACK_IMPORTED_MODULE_21_lodash___default.a.get(this.props,'location.state.prevLocationCouponId');var prevLocationPlanId=__WEBPACK_IMPORTED_MODULE_21_lodash___default.a.get(this.props,'location.state.prevLocationPlanId');var isDesktopApp=__WEBPACK_IMPORTED_MODULE_21_lodash___default.a.get(this.props,'location.state.isDesktopApp');var prevLocationUpgradePopup=__WEBPACK_IMPORTED_MODULE_21_lodash___default.a.get(this.props,'location.state.prevLocationUpgradePopup');var prevLocationRealEstatePlan=__WEBPACK_IMPORTED_MODULE_21_lodash___default.a.get(this.props,'location.state.prevLocationRealEstatePlan');var prevLocationIsCBPlanExternalRedirect=__WEBPACK_IMPORTED_MODULE_21_lodash___default.a.get(this.props,'location.state.prevLocationIsCBPlanExternalRedirect');var prevLocationIsCBPlanInternalRedirect=__WEBPACK_IMPORTED_MODULE_21_lodash___default.a.get(this.props,'location.state.prevLocationIsCBPlanInternalRedirect');var prevCbPlanId=__WEBPACK_IMPORTED_MODULE_21_lodash___default.a.get(this.props,'location.state.prevCbPlanId');var queryString=prevLocationSearch&&Object.keys(prevLocationSearch).length?Object.entries(prevLocationSearch).map(function(_ref){var _ref2=__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_ref,2),key=_ref2[0],val=_ref2[1];return"".concat(key,"=").concat(val);}).join('&'):null;__WEBPACK_IMPORTED_MODULE_19__config__["u" /* COUPON_ID_PARAM */];if(prevLocationUpgradePopup){queryString=queryString?"".concat(queryString,"&").concat(__WEBPACK_IMPORTED_MODULE_19__config__["_49" /* UPGRADE_POPUP_PARAM */],"=1"):"".concat(__WEBPACK_IMPORTED_MODULE_19__config__["_49" /* UPGRADE_POPUP_PARAM */],"=1");}if(prevLocationRealEstatePlan){queryString=queryString?"".concat(queryString,"&").concat(__WEBPACK_IMPORTED_MODULE_19__config__["_26" /* REAL_ESTATE_PLAN_PARAM */],"=").concat(prevLocationRealEstatePlan):"".concat(__WEBPACK_IMPORTED_MODULE_19__config__["_26" /* REAL_ESTATE_PLAN_PARAM */],"=").concat(prevLocationRealEstatePlan);}if(prevLocationCouponId){queryString=queryString?"".concat(queryString,"&").concat(__WEBPACK_IMPORTED_MODULE_19__config__["u" /* COUPON_ID_PARAM */],"=").concat(prevLocationCouponId):"".concat(__WEBPACK_IMPORTED_MODULE_19__config__["u" /* COUPON_ID_PARAM */],"=").concat(prevLocationCouponId);}var adminOrMemberOfCompanies=rawDataById?Object.values(rawDataById).filter(function(company){return[__WEBPACK_IMPORTED_MODULE_19__config__["_54" /* USER_ROLE_ADMIN */],__WEBPACK_IMPORTED_MODULE_19__config__["_55" /* USER_ROLE_BASIC */]].includes(company.userRole);}):[];return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:classes.wrongAccount},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__theme_icons__["_10" /* XDarkLogo */],{className:classes.xDarkLogo}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__theme_icons__["_12" /* XaraLogo */],{className:classes.xaraLogo}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{className:classes.wrongAccountTitle,variant:"h2"},localize('wrong-account-title')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:"body2",className:classes.currentlySignedInTitle},localize('wrong-account-signed-in-title')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:"h2",className:classes.currentlySignedInEmail},currentUserEmail),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core__["s" /* List */],{className:classes.list},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core__["t" /* ListItem */],{key:'option-use-existing-account',dense:true,className:classes.listItem},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core__["u" /* ListItemIcon */],{className:classes.listItemIcon},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__theme_icons__["Q" /* NextIcon */],{className:classes.nextIcon})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core__["v" /* ListItemText */],{className:classes.listItemText},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core__["r" /* Link */],{variant:"body2","data-tid":"continue-with-this-account-button",className:classes.listItemLink,onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_17_lib_Segment_customTrackers__["_2" /* trackWrongAccountScreenUseExistingAccount */])(Object(__WEBPACK_IMPORTED_MODULE_18_lib_Segment_helpers__["a" /* getTrackingOptions */])(_this.props.company));_this.props.changeCompanyAndNotify(sessionCompany);if(prevLocationPath){// Take currency from existing plan of company in session (as it can't be changed), 
// otherwise from URL (for plus-overview package), defaults to USD
var currentPackageCurrency;var alreadyUsedCurrency=Object(__WEBPACK_IMPORTED_MODULE_11__utils_subscription__["b" /* getCurrencyUsedInCB */])(sessionCompany);alreadyUsedCurrency&&(currentPackageCurrency=alreadyUsedCurrency);if(queryString&&queryString.indexOf('chargebee-plan-id')!==-1||prevCbPlanId){// eslint-disable-next-line max-len
// url like http://localhost:3000/#5fa000d8f123/?chargebee-plan-id=plus-overview&currency=usd
var planId=prevCbPlanId||prevLocationSearch['chargebee-plan-id'];//prevCbPlanId
var currency=currentPackageCurrency||prevLocationCurrency;// If user is admin of multiple companies ask user to choose company, 
// otherwise redirect to URL
if(adminOrMemberOfCompanies.length>1){_this.renderUpgradePopup(planId,currency,prevLocationProductName,prevLocationProductLanguage,prevLocationMagixSerial,prevLocationMagixEmail,prevLocationMagixCat,prevLocationCouponId,prevLocationUpgradePopup,prevLocationRealEstatePlan,prevLocationIsCBPlanExternalRedirect,prevLocationIsCBPlanInternalRedirect,prevLocationProductQuantity,prevLocationProductPeriod,prevLocationProductSource);}else{var queryVars=['company-known=1'];if(prevLocationProductName){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["_15" /* PRODUCT_NAME_PARAM */],"=").concat(prevLocationProductName));}if(prevLocationProductQuantity){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["_17" /* PRODUCT_QUANTITY_PARAM */],"=").concat(prevLocationProductQuantity));}if(prevLocationProductSource){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["_18" /* PRODUCT_SOURCE_PARAM */],"=").concat(prevLocationProductSource));}if(prevLocationProductPeriod){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["_6" /* PERIOD_PARAM */],"=").concat(prevLocationProductPeriod));}if(prevLocationProductLanguage){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["_14" /* PRODUCT_LANGUAGE_PARAM */],"=").concat(prevLocationProductLanguage));}if(prevLocationMagixSerial){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["W" /* MAGIX_SERIAL_PARAM */],"=").concat(prevLocationMagixSerial));}if(prevLocationMagixEmail){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["V" /* MAGIX_EMAIL_PARAM */],"=").concat(prevLocationMagixEmail));}if(prevLocationMagixCat){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["U" /* MAGIX_CATEGORY_PARAM */],"=").concat(prevLocationMagixCat));}if(prevLocationCouponId){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["u" /* COUPON_ID_PARAM */],"=").concat(prevLocationCouponId));}if(prevLocationUpgradePopup){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["_49" /* UPGRADE_POPUP_PARAM */],"=").concat(prevLocationUpgradePopup));}if(prevLocationRealEstatePlan){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["_26" /* REAL_ESTATE_PLAN_PARAM */],"=").concat(prevLocationRealEstatePlan));}if(prevLocationIsCBPlanExternalRedirect){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["H" /* EXTERNAL_REDIRECT_PARAM */],"=1"));}if(prevLocationIsCBPlanInternalRedirect){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["S" /* INTERNAL_REDIRECT_PARAM */],"=1"));}var redirectURL=Object(__WEBPACK_IMPORTED_MODULE_11__utils_subscription__["h" /* getSubscriptionRedirectUrl */])(planId,sessionCompanyId,currency,queryVars);location.href=redirectURL;}}else{if(prevLocationPath===__WEBPACK_IMPORTED_MODULE_13_routes__["p" /* SUBSCRIPTION_PLUS_OVERVIEW */]||prevLocationPath===__WEBPACK_IMPORTED_MODULE_13_routes__["o" /* SUBSCRIPTION_PERPETUAL_OVERVIEW */]){// eslint-disable-next-line max-len
// url like http://localhost:3000/#63123230879f5c68a6a6c58a0d4/subscription/plus-overview/?desktop-app=1
prevLocationPath=prevLocationPath.replace(':currency?','');if(prevLocationCurrency){prevLocationPath="".concat(prevLocationPath).concat(prevLocationCurrency);}}var _redirectURL=prevLocationPath;if(queryString){_redirectURL="".concat(_redirectURL,"?").concat(queryString);}_redirectURL=prevLocationPlanId?_redirectURL.replace(':planId',prevLocationPlanId):_redirectURL.replace(':planId','');if(adminOrMemberOfCompanies.length>1){// eslint-disable-next-line max-len
// url like http://localhost:3000/#64a2a2123123123/subscription/web-annual-usd/?company-known=1
if(prevLocationPlanId){var relatedSubscription=Object(__WEBPACK_IMPORTED_MODULE_11__utils_subscription__["a" /* convertPlanIdIntoSubscription */])(prevLocationPlanId);var planCurrency=relatedSubscription.currency;_this.renderUpgradePopup(prevLocationPlanId,planCurrency,prevLocationProductName,prevLocationProductLanguage,prevLocationMagixSerial,prevLocationMagixEmail,prevLocationMagixCat,prevLocationCouponId,prevLocationUpgradePopup,prevLocationRealEstatePlan,prevLocationIsCBPlanExternalRedirect,prevLocationIsCBPlanInternalRedirect,prevLocationProductQuantity,prevLocationProductPeriod,prevLocationProductSource);}else{// eslint-disable-next-line max-len
// url like http://localhost:3000/#64a2a2123123123/subscription/ or http://localhost:3000/#64a2a2123123123/users/
_this.renderCompanySelectionPopup(_redirectURL);}}else{_this.props.history.push(Object(__WEBPACK_IMPORTED_MODULE_13_routes__["w" /* getRoute */])(_redirectURL,sessionCompanyId));window.location.reload();}}}else{_this.props.history.push(Object(__WEBPACK_IMPORTED_MODULE_13_routes__["w" /* getRoute */])(__WEBPACK_IMPORTED_MODULE_13_routes__["n" /* SUBSCRIPTION */],sessionCompanyId));window.location.reload();}}},localize('wrong-account-use-existing-account')))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core__["t" /* ListItem */],{key:'option-switch-account',dense:true,className:classes.listItem},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core__["u" /* ListItemIcon */],{className:classes.listItemIcon},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__theme_icons__["Q" /* NextIcon */],{className:classes.nextIcon})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core__["v" /* ListItemText */],{className:classes.listItemText},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core__["r" /* Link */],{component:"button",variant:"body2","data-tid":"change-account-button",className:classes.listItemLink,onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_17_lib_Segment_customTrackers__["_1" /* trackWrongAccountScreenSwitchAccount */])(Object(__WEBPACK_IMPORTED_MODULE_18_lib_Segment_helpers__["a" /* getTrackingOptions */])(_this.props.company));var prevComponent;if(prevLocationPath){prevComponent=prevLocationPath.replace('/:companyId','').replace(':currency?','').replace(':planId','');}if(!prevComponent||prevComponent.length===0){prevComponent='/';}var urlParams=['switch-account=1',"".concat(__WEBPACK_IMPORTED_MODULE_19__config__["_34" /* SKIP_ONBOARDING_PARAM */],"=1"),"".concat(__WEBPACK_IMPORTED_MODULE_19__config__["i" /* BACK_TO_PARAM */],"=").concat(encodeURIComponent(prevComponent))];if(prevLocationProductQuantity){urlParams.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["_17" /* PRODUCT_QUANTITY_PARAM */],"=").concat(prevLocationProductQuantity));}if(isDesktopApp){urlParams.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["f" /* APP_COMPANY_ID_PARAM */],"=").concat(sessionCompanyId));}var redirectURL="".concat(__WEBPACK_IMPORTED_MODULE_19__config__["_65" /* XC_URL */],"?").concat(urlParams.join('&'));if(queryString){redirectURL="".concat(redirectURL,"&").concat(queryString);}window.location.href=redirectURL;}},localize('wrong-account-change-account'))))));}}]);return WrongAccount;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]))||_class);WrongAccount.propTypes={currentUserEmail:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,classes:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,companies:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,company:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,changeCompanyAndNotify:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,history:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,prevLocationCurrency:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,prevLocationPlanId:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,showModal:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,isDesktopApp:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,location:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.shape({pathname:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired})};// Leaving Redux bindings for phase 2 of P9052-13492.
var mapStateToProps=function mapStateToProps(state){return{companies:state.companies,company:state.companies.rawDataById?state.companies.rawDataById[state.companies.selectedId]:null,currentUserEmail:state.session.user.mainEmail};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_14_redux__["b" /* bindActionCreators */])({changeCompanyAndNotify:__WEBPACK_IMPORTED_MODULE_15_redux_modules_companies__["d" /* changeCompanyAndNotify */],showModal:__WEBPACK_IMPORTED_MODULE_16_redux_modules_modal__["d" /* showModal */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(WrongAccount));

/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_theme_icons__ = __webpack_require__(24);
var _dec,_class;var styles=function styles(theme){return{root:{width:'100%',height:'100%'},preloader:{display:'block',width:'300px',height:'300px',position:'absolute',top:'calc(50% - 150px)',left:'calc(50% - 150px)'}};};var Preloader=(_dec=Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Preloader,_Component);function Preloader(){__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,Preloader);return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Preloader).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Preloader,[{key:"render",value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:classes.root},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:classes.preloader},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_theme_icons__["S" /* PreloaderIcon */],null)));}}]);return Preloader;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]))||_class);Preloader.propTypes={classes:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Preloader);

/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__theme_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_i18n_i18n__ = __webpack_require__(15);
var _dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_10_i18n_i18n__["a" /* default */].loc.localize;var styles=function styles(theme){return{root:{width:'100%',height:'100%'},preloader:{position:'absolute',top:'50%',left:'50%',transform:'translate(-50%, -50%)'},title:{display:'block',fontSize:'22px',lineHeight:'25px',fontWeight:'bold',margin:'30px 0 0',opacity:1,textAlign:'center'},xaraLogo:{width:'84px',height:'25px',margin:'0 auto',display:'block',color:theme.palette.colors.alpha}};};var ProcessingOrder=(_dec=Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(ProcessingOrder,_Component);function ProcessingOrder(){__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,ProcessingOrder);return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(ProcessingOrder).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ProcessingOrder,[{key:"render",value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:classes.root},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:classes.preloader},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__theme_icons__["_13" /* XaraLogoAnimated */],{className:classes.xaraLogo}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:"h2",className:classes.title},localize('processing-order'))));}}]);return ProcessingOrder;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]))||_class);ProcessingOrder.propTypes={classes:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (ProcessingOrder);

/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ErrorModal__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ConfirmationModal__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__UpgradeCompanyModal__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__GuestModal__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CompanySelectionModal__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SetPasswordModal__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ConfirmYourEmailAddressModal__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DiscountModal__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ConfirmPurchaseChoiceModal__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__InviteUsersModal__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__AddMlsConnectionModal__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__AddMlsOfficeModal__ = __webpack_require__(1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ManageMlsAgentsModal__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ContactSalesModal__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__BuyMoreLicensesOrSeatsModal__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ReduceUsersModal__ = __webpack_require__(1211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_prop_types__);
var MODALS={'ERROR_MODAL':__WEBPACK_IMPORTED_MODULE_7__ErrorModal__["a" /* default */],'CONFIRMATION_MODAL':__WEBPACK_IMPORTED_MODULE_8__ConfirmationModal__["a" /* default */],'UPGRADE_COMPANY_MODAL':__WEBPACK_IMPORTED_MODULE_9__UpgradeCompanyModal__["a" /* default */],'GUEST_MODAL':__WEBPACK_IMPORTED_MODULE_10__GuestModal__["a" /* default */],'COMPANY_SELECTION_MODAL':__WEBPACK_IMPORTED_MODULE_11__CompanySelectionModal__["a" /* default */],'SET_PASSWORD_MODAL':__WEBPACK_IMPORTED_MODULE_12__SetPasswordModal__["a" /* default */],'CONFIRM_YOUR_EMAIL_ADDRESS_MODAL':__WEBPACK_IMPORTED_MODULE_13__ConfirmYourEmailAddressModal__["a" /* default */],'DISCOUNT_MODAL':__WEBPACK_IMPORTED_MODULE_14__DiscountModal__["a" /* default */],'INVITE_USERS_MODAL':__WEBPACK_IMPORTED_MODULE_16__InviteUsersModal__["a" /* default */],'ADD_MLS_CONNECTION_MODAL':__WEBPACK_IMPORTED_MODULE_17__AddMlsConnectionModal__["a" /* default */],'ADD_MLS_OFFICE_MODAL':__WEBPACK_IMPORTED_MODULE_18__AddMlsOfficeModal__["a" /* default */],'MANAGE_MLS_AGENTS_MODAL':__WEBPACK_IMPORTED_MODULE_19__ManageMlsAgentsModal__["a" /* default */],'CONTACT_SALES_MODAL':__WEBPACK_IMPORTED_MODULE_20__ContactSalesModal__["a" /* default */],'CONFIRM_PURCHASE_CHOICE':__WEBPACK_IMPORTED_MODULE_15__ConfirmPurchaseChoiceModal__["a" /* default */],'BUY_MORE_LICENSES_OR_SEATS':__WEBPACK_IMPORTED_MODULE_21__BuyMoreLicensesOrSeatsModal__["a" /* default */],'REDUCE_USERS':__WEBPACK_IMPORTED_MODULE_22__ReduceUsersModal__["a" /* default */]};var Modal=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Modal,_Component);function Modal(){__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,Modal);return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Modal).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Modal,[{key:"render",value:function render(){var _this$props$modal=this.props.modal,modalType=_this$props$modal.modalType,modalProps=_this$props$modal.modalProps;if(!modalType){return null;}var SpecificModal=MODALS[modalType];return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(SpecificModal,modalProps);}}]);return Modal;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);Modal.propTypes={modal:__WEBPACK_IMPORTED_MODULE_23_prop_types___default.a.object};var mapStateToProps=function mapStateToProps(state){return{modal:state.modal};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps)(Modal));

/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Dialog__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogActions__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogContent__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_DialogContentText__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Button__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_errors_errors__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_redux_modules_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_redux_modules_error__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_redux_modules_session__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_routes__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__errors_apperror__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_redux_modules_preloader__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_redux_modules_chargebeeLoader__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_i18n_i18n__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lib_Segment_customTrackers__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lib_Segment_helpers__ = __webpack_require__(38);
var _dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_25_i18n_i18n__["a" /* default */].loc.localize;var styles=function styles(theme){return{dialog:{'& a':{color:theme.palette.colors.alpha,'&:hover':{textDecoration:'none'}}},content:{},actions:{},button:{}};};var ErrorModal=(_dec=Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(ErrorModal,_Component);function ErrorModal(props){var _this;__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,ErrorModal);_this=__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(ErrorModal).call(this));_this.state=_this.getState(props);return _this;}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ErrorModal,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(props){this.setState(this.getState(props));}},{key:"componentDidMount",value:function componentDidMount(){var errorId=this.props.error.errorId;if(errorId===__WEBPACK_IMPORTED_MODULE_16_errors_errorids__["a" /* default */].USER_REACHED_THE_COMPANY_INVITATION_LIMIT){Object(__WEBPACK_IMPORTED_MODULE_26_lib_Segment_customTrackers__["U" /* trackUsersLimitReachedOnNonPayingAccount */])(Object(__WEBPACK_IMPORTED_MODULE_27_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}}},{key:"getState",value:function getState(props){var _props$error=props.error,errorId=_props$error.errorId,errorMessage=_props$error.errorMessage;// Setting error title, but we don't use it now in UI.
var _getErrorMessageById=Object(__WEBPACK_IMPORTED_MODULE_15_errors_errors__["a" /* default */])(errorId),_getErrorMessageById$=_getErrorMessageById.title,title=_getErrorMessageById$===void 0?localize('error-modal-title'):_getErrorMessageById$,message=_getErrorMessageById.message,buttons=_getErrorMessageById.buttons;return{errorId:errorId,title:title,message:errorMessage||message,buttons:buttons};}},{key:"render",value:function render(){var _this2=this;var _this$props=this.props,classes=_this$props.classes,modalShown=_this$props.modalShown;var _this$state=this.state,message=_this$state.message,buttons=_this$state.buttons,redirectUrl=_this$state.redirectUrl;if(redirectUrl){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["c" /* Redirect */],{to:redirectUrl});}return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Dialog___default.a,{open:modalShown,"aria-labelledby":"alert-dialog-title","aria-describedby":"alert-dialog-description",onExited:function onExited(){return _this2.resetModal();},classes:{paper:classes.dialog}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_DialogContentText___default.a,{variant:"body1",color:"default",dangerouslySetInnerHTML:{__html:message}})),buttons&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogActions___default.a,null,buttons.map(function(button,index){var type=buttons.length>=2&&button.close&&!button.primary?'default':'primary';return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Button___default.a,{key:"button-".concat(index),variant:"contained",color:type,onClick:function onClick(){return _this2.handleButtonClick(button);}},button.label);})));}},{key:"handleButtonClick",value:function handleButtonClick(button){var _this3=this;var _this$props2=this.props,companyId=_this$props2.companyId,errorId=_this$props2.error.errorId;if(button.close){if(button.redirect){if(button.redirect==__WEBPACK_IMPORTED_MODULE_21_routes__["n" /* SUBSCRIPTION */]){this.setState({redirectUrl:Object(__WEBPACK_IMPORTED_MODULE_21_routes__["w" /* getRoute */])(__WEBPACK_IMPORTED_MODULE_21_routes__["n" /* SUBSCRIPTION */],companyId)},function(){_this3.resetModal();});}else{window.location.href=button.redirect;}return;}// To hide <Preloader> screen after error in subscription process:
// - clear state.errors.errorId flag
// - clear preloader.loading flag
// - close modal
this.resetModal();this.props.hidePreloader();this.props.hideChargebeeLoader();return;}// Special case: need to show confirmation after sending an email
if(errorId===__WEBPACK_IMPORTED_MODULE_16_errors_errorids__["a" /* default */].USER_NOT_VALIDATED){return this.handleAccountConfirmationButtonClick();}return button.onClick;}},{key:"handleAccountConfirmationButtonClick",value:function handleAccountConfirmationButtonClick(){var _this4=this;this.props.hideModal();this.props.verifyUserAccount().then(function(data){if(data instanceof __WEBPACK_IMPORTED_MODULE_22__errors_apperror__["a" /* default */]){return;}_this4.props.showModal('CONFIRMATION_MODAL',{message:localize('error-modal-account-confirmation-message',_this4.props.currentUserEmail),buttons:[__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Button___default.a,{key:"button-confirm",variant:"contained",color:"primary",onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["c" /* Redirect */],{to:__WEBPACK_IMPORTED_MODULE_21_routes__["l" /* ROOT */]});}},localize('continue'))]});});}},{key:"resetModal",value:function resetModal(){this.props.resetErrorId();this.props.resetModal();}}]);return ErrorModal;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]))||_class);ErrorModal.propTypes={showModal:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.func,hideModal:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.func,resetModal:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.func,resetErrorId:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.func,verifyUserAccount:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.func,classes:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.object,error:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.object,modalShown:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.bool,currentUserEmail:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.string,companyId:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.string,hidePreloader:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.func,hideChargebeeLoader:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.func,company:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.object};var mapStateToProps=function mapStateToProps(state){return{company:state.companies.rawDataById?state.companies.rawDataById[state.companies.selectedId]:null,error:state.error,modalShown:state.modal.modalShown,currentUserEmail:state.session.user&&state.session.user.mainEmail,companyId:state.companies.selectedId};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_8_redux__["b" /* bindActionCreators */])({showModal:__WEBPACK_IMPORTED_MODULE_17_redux_modules_modal__["d" /* showModal */],hideModal:__WEBPACK_IMPORTED_MODULE_17_redux_modules_modal__["b" /* hideModal */],resetModal:__WEBPACK_IMPORTED_MODULE_17_redux_modules_modal__["c" /* resetModal */],resetErrorId:__WEBPACK_IMPORTED_MODULE_18_redux_modules_error__["b" /* resetErrorId */],verifyUserAccount:__WEBPACK_IMPORTED_MODULE_19_redux_modules_session__["c" /* verifyUserAccount */],hidePreloader:__WEBPACK_IMPORTED_MODULE_23_redux_modules_preloader__["b" /* hidePreloader */],hideChargebeeLoader:__WEBPACK_IMPORTED_MODULE_24_redux_modules_chargebeeLoader__["b" /* hideChargebeeLoader */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ErrorModal));

/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogActions__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogContent__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogContentText__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_DialogTitle__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_redux_modules_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_Grid__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_Typography__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_i18n_i18n__ = __webpack_require__(15);
var _dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_19_i18n_i18n__["a" /* default */].loc.localize;var styles=function styles(theme){return{modal:{},content:{marginBottom:40},contentText:{opacity:1,color:'#000',textAlign:'left'},/* Dialog */dialogPaper:{minWidth:444},dialogWrapper:{position:'relative',padding:'15px 10px 15px'},dialogTitle:{'& h6':{fontWeight:600,fontSize:'28px',lineHeight:1.4,marginBottom:6,textAlign:'left'}},dialogActions:{},/* buttons */button:{fontFamily:'Open Sans, sans-serif',borderRadius:5,fontWeight:600,fontSize:18,lineHeight:1.3,color:'#000',opacity:'1 !important',paddingLeft:15,paddingRight:15,minWidth:100},buttonCancel:{},buttonConfirm:{background:theme.palette.primary.main,color:'white',textShadow:'none','&[class*=contained][class*=disabled]':{backgroundColor:'#B3B9C0'},marginLeft:10},/* error message */errorMessage:{color:theme.palette.error.main,fontSize:14,lineHeight:1.5,opacity:1,textAlign:'left',marginTop:0,marginBottom:15}};};var ConfirmationModal=(_dec=Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(ConfirmationModal,_Component);function ConfirmationModal(){__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,ConfirmationModal);return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(ConfirmationModal).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ConfirmationModal,[{key:"render",value:function render(){var _this$props=this.props,classes=_this$props.classes,modalShown=_this$props.modalShown,resetModal=_this$props.resetModal,title=_this$props.title;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog___default.a,{open:modalShown,"aria-labelledby":"alert-dialog-title","aria-describedby":"alert-dialog-description",onExited:resetModal,BackdropProps:{style:{backgroundColor:'rgba(46, 63, 79, 0.4)'}},classes:{paper:classes.dialogPaper},PaperProps:{style:{border:0,width:309,borderRadius:5,boxShadow:'0px 4px 24px rgba(0, 0, 0, 0.08)'}}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:classes.dialogWrapper},title&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_DialogTitle___default.a,{variant:"body1",color:"default",className:classes.dialogTitle},title),this.renderContent(),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogActions___default.a,{className:classes.dialogActions},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_Grid___default.a,{item:true,container:true,direction:"row",justify:"flex-end"},this.renderButtons()))));}},{key:"renderContent",value:function renderContent(){var contentText;var _this$props2=this.props,message=_this$props2.message,classes=_this$props2.classes;if(message&&message.__html){contentText=__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogContentText___default.a,{dangerouslySetInnerHTML:message,variant:"body1",color:"default",className:classes.contentText});}else{contentText=__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogContentText___default.a,{variant:"body1",color:"default",className:classes.contentText},message);}return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogContent___default.a,{className:classes.content},this.renderErrorMessage(),contentText);}},{key:"renderErrorMessage",value:function renderErrorMessage(){var classes=this.props.classes;if(this.props.showCouponErrorMessageIfExists&&(this.props.discount.couponCodeInvalidReason||this.props.discount.couponCodeFetchErrorId)){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_Typography___default.a,{className:classes.errorMessage,variant:"body2",dangerouslySetInnerHTML:{__html:localize('subscriptions-error-reduce-users-invalid-coupon')}});}}},{key:"renderButtons",value:function renderButtons(){var _this$props3=this.props,hideModal=_this$props3.hideModal,buttons=_this$props3.buttons,hideModalOnButtonClick=_this$props3.hideModalOnButtonClick,classes=_this$props3.classes;return buttons.map(function(button,index){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_Grid___default.a,{item:true,key:"confirmation-modal-button-".concat(index)},Object(__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"])(button,{className:index===0&&buttons.length>1?__WEBPACK_IMPORTED_MODULE_18_classnames___default()(classes.button,classes.buttonCancel):__WEBPACK_IMPORTED_MODULE_18_classnames___default()(classes.button,classes.buttonConfirm),onClick:function onClick(){hideModalOnButtonClick&&hideModal();button.props.onClick&&button.props.onClick();}}));});}}]);return ConfirmationModal;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]))||_class);ConfirmationModal.defaultProps={buttons:[],hideModalOnButtonClick:true};ConfirmationModal.propTypes={classes:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.object,modalShown:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.bool,hideModal:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.func,resetModal:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.func,title:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.string,message:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.object]),buttons:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.array,hideModalOnButtonClick:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.bool,discount:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.object.isRequired,showCouponErrorMessageIfExists:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.bool};var mapStateToProps=function mapStateToProps(state){return{modalShown:state.modal.modalShown,discount:state.discount};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_8_redux__["b" /* bindActionCreators */])({hideModal:__WEBPACK_IMPORTED_MODULE_14_redux_modules_modal__["b" /* hideModal */],resetModal:__WEBPACK_IMPORTED_MODULE_14_redux_modules_modal__["c" /* resetModal */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ConfirmationModal));

/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Select__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_KeyboardArrowDown__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_KeyboardArrowDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_KeyboardArrowDown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Dialog__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogActions__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_DialogContent__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_DialogContentText__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_redux_modules_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_redux_modules_chargebeeLoader__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_subscription__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_redux_modules_preloader__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_utils_state__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_i18n_i18n__ = __webpack_require__(15);
var localize=__WEBPACK_IMPORTED_MODULE_25_i18n_i18n__["a" /* default */].loc.localize;var UpgradeCompanyModal=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(UpgradeCompanyModal,_Component);function UpgradeCompanyModal(props){var _this;__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,UpgradeCompanyModal);_this=__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(UpgradeCompanyModal).call(this,props));_this.goToSubscription=_this.goToSubscription.bind(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this));var redirectUrl=undefined;// set redirectUrl if we are going to redirect to subscription page directly
// If user has 1 company and is the admin we can go straight to chargebee
var isAdminOfSingleCompany=_this.props.isAdmin&&_this.props.numberOfCompanies===1;// If app is opened using desktop-app=1 flag and user is admin of requested company, we don't ask user to choose company
var isAdminOfDesktopAppCompany=_this.props.isAdmin&&props.isDesktopApp;if(isAdminOfSingleCompany||isAdminOfDesktopAppCompany){_this.goToSubscription();}_this.state={redirectUrl:redirectUrl,selectedCompanyId:_this.props.companyId};return _this;}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(UpgradeCompanyModal,[{key:"render",value:function render(){var _this$props=this.props,modalShown=_this$props.modalShown,resetModal=_this$props.resetModal,companies=_this$props.companies;var _this$state=this.state,redirectUrl=_this$state.redirectUrl,selectedCompanyId=_this$state.selectedCompanyId;// redirect to the subscription page
if(redirectUrl){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["c" /* Redirect */],{to:redirectUrl});}return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Dialog___default.a,{open:modalShown,"aria-labelledby":"alert-dialog-title","aria-describedby":"alert-dialog-description",onExited:resetModal},companies.rawDataById[selectedCompanyId].userRole===__WEBPACK_IMPORTED_MODULE_19__config__["_54" /* USER_ROLE_ADMIN */]?this.renderAdminDialog():this.renderMemberDialog());}},{key:"renderAdminDialog",value:function renderAdminDialog(){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_DialogContentText___default.a,{variant:"body1",color:"default"},localize('upgrade-company-modal-admin-message'))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogActions___default.a,null,this.renderCompanySelector()),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default.a,{key:"upgrade-company-button","data-tid":"button-upgrade-company-continue",variant:"contained",color:"primary",onClick:this.goToSubscription},localize('upgrade-company-modal-upgrade'))));}},{key:"renderMemberDialog",value:function renderMemberDialog(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_DialogContentText___default.a,{variant:"body1",color:"default"},localize('upgrade-company-modal-member-message')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogActions___default.a,null,this.renderCompanySelector()),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default.a,{disableRipple:true,"data-tid":"button-create-new-team",onClick:function onClick(){var queryVars=['create-company=true'];if(_this2.props.productQuantity){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["_17" /* PRODUCT_QUANTITY_PARAM */],"=").concat(_this2.props.productQuantity));}if(_this2.props.productPeriod){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["_6" /* PERIOD_PARAM */],"=").concat(_this2.props.productPeriod));}if(_this2.props.productName){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["_15" /* PRODUCT_NAME_PARAM */],"=").concat(_this2.props.productName));}if(_this2.props.productSource){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["_18" /* PRODUCT_SOURCE_PARAM */],"=").concat(_this2.props.productSource));}if(_this2.props.productLang){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["_14" /* PRODUCT_LANGUAGE_PARAM */],"=").concat(_this2.props.productLang));}if(_this2.props.couponId){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["u" /* COUPON_ID_PARAM */],"=").concat(_this2.props.couponId));}if(_this2.props.currency){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["y" /* CURRENCY_PARAM */],"=").concat(_this2.props.currency));}if(_this2.props.planId){queryVars.push("chargebee-plan-id=".concat(_this2.props.planId));}var redirectURL="".concat(__WEBPACK_IMPORTED_MODULE_19__config__["_65" /* XC_URL */],"?").concat(queryVars.join('&'));window.location.href=redirectURL;}},localize('upgrade-company-modal-create-new-team')))));}},{key:"renderCompanySelector",value:function renderCompanySelector(){var _this3=this;var companies=Object.values(this.props.companies.byId);return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Select___default.a,{"data-tid":"upgrade-company-company-selector",value:this.state.selectedCompanyId,name:"company",disableUnderline:true,IconComponent:__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_KeyboardArrowDown___default.a,onChange:function onChange(event){_this3.setState({selectedCompanyId:event.target.value});}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem___default.a,{value:"",disabled:true},localize('upgrade-company-modal-selector')),companies.map(function(company){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem___default.a,{key:company.id,value:company.id,"data-tid":"upgrade-company-item-".concat(company.displayName)},company.displayName);}));}},{key:"goToSubscription",value:function goToSubscription(){// happens on initial purchase only (not for upgrade)
// we make hard page reload in case we don't support change company by router path
var companies=this.props.companies;var companyId=this.state?this.state.selectedCompanyId:this.props.companyId;// Take currency from existing plan of company selected in modal window (as it can't be changed), 
// otherwise from URL (for plus-overview package), defaults to USD
var currentPackageCurrency;var alreadyUsedCurrency=Object(__WEBPACK_IMPORTED_MODULE_22__utils_subscription__["b" /* getCurrencyUsedInCB */])(companies.rawDataById[companyId]);alreadyUsedCurrency&&(currentPackageCurrency=alreadyUsedCurrency);var currency=currentPackageCurrency||this.props.currency;var queryVars=['company-known=1'];if(this.props.productName){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["_15" /* PRODUCT_NAME_PARAM */],"=").concat(this.props.productName));}if(this.props.productQuantity){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["_17" /* PRODUCT_QUANTITY_PARAM */],"=").concat(this.props.productQuantity));}if(this.props.productSource){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["_18" /* PRODUCT_SOURCE_PARAM */],"=").concat(this.props.productSource));}if(this.props.productPeriod){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["_6" /* PERIOD_PARAM */],"=").concat(this.props.productPeriod));}if(this.props.productLang){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["_14" /* PRODUCT_LANGUAGE_PARAM */],"=").concat(this.props.productLang));}if(this.props.magixEmail){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["V" /* MAGIX_EMAIL_PARAM */],"=").concat(this.props.magixEmail));}if(this.props.magixSerial){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["W" /* MAGIX_SERIAL_PARAM */],"=").concat(this.props.magixSerial));}if(this.props.magixCat){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["U" /* MAGIX_CATEGORY_PARAM */],"=").concat(this.props.magixCat));}if(this.props.couponId){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["u" /* COUPON_ID_PARAM */],"=").concat(this.props.couponId));}if(this.props.isUpgradePopup){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["_49" /* UPGRADE_POPUP_PARAM */],"=").concat(this.props.isUpgradePopup));}if(this.props.realEstatePlan){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["_26" /* REAL_ESTATE_PLAN_PARAM */],"=").concat(this.props.realEstatePlan));}if(this.props.isCBPlanExternalRedirect){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["H" /* EXTERNAL_REDIRECT_PARAM */],"=1"));}if(this.props.isCBPlanInternalRedirect){queryVars.push("".concat(__WEBPACK_IMPORTED_MODULE_19__config__["S" /* INTERNAL_REDIRECT_PARAM */],"=1"));}window.location.href=Object(__WEBPACK_IMPORTED_MODULE_22__utils_subscription__["h" /* getSubscriptionRedirectUrl */])(this.props.planId,companyId,currency,queryVars);window.location.reload();this.props.hideModal();this.props.showPreloader();}}]);return UpgradeCompanyModal;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);UpgradeCompanyModal.propTypes={companies:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.object,modalShown:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.bool,hideModal:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.func,resetModal:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.func,paymentRedirectUrl:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.string,companyId:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.string,planId:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.string,currency:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.string,productName:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.string,productLang:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.string,magixEmail:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.string,magixSerial:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.string,magixCat:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.string,couponId:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.string,realEstatePlan:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.bool,isUpgradePopup:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.bool,history:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.object,showChargebeeLoader:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.func,showPreloader:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.func,location:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.shape({search:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.string}),isDesktopApp:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.bool,isAdmin:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.bool,isCBPlanExternalRedirect:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.bool,isCBPlanInternalRedirect:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.bool,numberOfCompanies:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.number,productQuantity:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.number,productSource:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.number,productPeriod:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.number};var mapStateToProps=function mapStateToProps(state){return{modalShown:state.modal.modalShown,companies:state.companies,companyId:state.companies.rawDataById[state.companies.selectedId].id,paymentRedirectUrl:state.companies.paymentRedirectUrl,isAdmin:Object(__WEBPACK_IMPORTED_MODULE_24_utils_state__["a" /* isAdmin */])(state),numberOfCompanies:Object.values(state.companies.byId).length};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])({hideModal:__WEBPACK_IMPORTED_MODULE_18_redux_modules_modal__["b" /* hideModal */],resetModal:__WEBPACK_IMPORTED_MODULE_18_redux_modules_modal__["c" /* resetModal */],showChargebeeLoader:__WEBPACK_IMPORTED_MODULE_21_redux_modules_chargebeeLoader__["c" /* showChargebeeLoader */],showPreloader:__WEBPACK_IMPORTED_MODULE_23_redux_modules_preloader__["c" /* showPreloader */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(UpgradeCompanyModal));

/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Select__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_KeyboardArrowDown__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_KeyboardArrowDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_KeyboardArrowDown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Dialog__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_DialogActions__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_DialogContent__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogContentText__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_i18n_i18n__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash__);
var localize=__WEBPACK_IMPORTED_MODULE_18_i18n_i18n__["a" /* default */].loc.localize;var GuestModal=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(GuestModal,_Component);function GuestModal(props){var _this;__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,GuestModal);_this=__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(GuestModal).call(this,props));_this.goToPage=_this.goToPage.bind(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this));var companiesWithAdminRole=Object.values(_this.props.companies.rawDataById).filter(function(company){return company.userRole===__WEBPACK_IMPORTED_MODULE_16__config__["_54" /* USER_ROLE_ADMIN */];});_this.state={companiesWithAdminRole:companiesWithAdminRole,selectedCompanyId:__WEBPACK_IMPORTED_MODULE_19_lodash___default.a.get(companiesWithAdminRole,'[0].id')};return _this;}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(GuestModal,[{key:"render",value:function render(){var modalShown=this.props.modalShown;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Dialog___default.a,{open:modalShown,"aria-labelledby":"alert-dialog-title","aria-describedby":"alert-dialog-description"},this.renderGuestDialog());}},{key:"renderGuestDialog",value:function renderGuestDialog(){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogContentText___default.a,{variant:"body1",color:"default"},localize('guest-modal-message'),!__WEBPACK_IMPORTED_MODULE_19_lodash___default.a.isEmpty(this.state.companiesWithAdminRole)&&localize('guest-modal-message-can-select-different-team')),!__WEBPACK_IMPORTED_MODULE_19_lodash___default.a.isEmpty(this.state.companiesWithAdminRole)&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_DialogActions___default.a,null,this.renderCompanySelector()),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default.a,{key:"upgrade-company-button","data-tid":"button-upgrade-company-continue",variant:"contained",color:"primary",onClick:this.goToPage},localize('continue')))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default.a,{disableRipple:true,"data-tid":"button-create-new-team",onClick:function onClick(){window.location.href=__WEBPACK_IMPORTED_MODULE_16__config__["_65" /* XC_URL */]+'?create-company=true';}},localize('guest-modal-create-new-team')))));}},{key:"renderCompanySelector",value:function renderCompanySelector(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Select___default.a,{"data-tid":"upgrade-company-company-selector",value:this.state.selectedCompanyId,name:"company",disableUnderline:true,IconComponent:__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_KeyboardArrowDown___default.a,onChange:function onChange(event){_this2.setState({selectedCompanyId:event.target.value});}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:"",disabled:true},localize('guest-modal-selector')),this.state.companiesWithAdminRole.map(function(company){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{key:company.id,value:company.id,"data-tid":"upgrade-company-item-".concat(company.displayName)},company.displayName);}));}},{key:"goToPage",value:function goToPage(){window.location.href="/#".concat(this.state.selectedCompanyId,"/?company-known=1");window.location.reload();}}]);return GuestModal;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);GuestModal.propTypes={companies:__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.object,modalShown:__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.bool,isDesktopApp:__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.bool};var mapStateToProps=function mapStateToProps(state){return{modalShown:state.modal.modalShown,companies:state.companies};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps)(GuestModal));

/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_modules_preloader__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Select__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_KeyboardArrowDown__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_KeyboardArrowDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_KeyboardArrowDown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Dialog__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogActions__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_DialogContent__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_DialogContentText__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_redux_modules_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_i18n_i18n__ = __webpack_require__(15);
var localize=__WEBPACK_IMPORTED_MODULE_20_i18n_i18n__["a" /* default */].loc.localize;var CompanySelectionModal=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(CompanySelectionModal,_Component);function CompanySelectionModal(props){var _this;__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,CompanySelectionModal);_this=__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(CompanySelectionModal).call(this,props));_this.goToPage=_this.goToPage.bind(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.state={selectedCompanyId:_this.props.companyId};return _this;}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(CompanySelectionModal,[{key:"render",value:function render(){var _this$props=this.props,modalShown=_this$props.modalShown,resetModal=_this$props.resetModal;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Dialog___default.a,{open:modalShown,"aria-labelledby":"alert-dialog-title","aria-describedby":"alert-dialog-description",onExited:resetModal},this.renderDialog());}},{key:"renderDialog",value:function renderDialog(){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_DialogContentText___default.a,{variant:"body1",color:"default"},localize('company-selection-modal-select-team'))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogActions___default.a,null,this.renderCompanySelector()),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default.a,{key:"upgrade-company-button","data-tid":"button-upgrade-company-continue",variant:"contained",color:"primary",onClick:this.goToPage},localize('continue'))));}},{key:"renderCompanySelector",value:function renderCompanySelector(){var _this2=this;var companies=Object.values(this.props.companies.byId);return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Select___default.a,{"data-tid":"upgrade-company-company-selector",value:this.state.selectedCompanyId,name:"company",disableUnderline:true,IconComponent:__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_KeyboardArrowDown___default.a,onChange:function onChange(event){_this2.setState({selectedCompanyId:event.target.value});}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem___default.a,{value:"",disabled:true},localize('company-selection-modal-selector')),companies.map(function(company){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem___default.a,{key:company.id,value:company.id,"data-tid":"upgrade-company-item-".concat(company.displayName)},company.displayName);}));}},{key:"goToPage",value:function goToPage(){var redirectURL=this.props.redirectURL;var companyId=this.state?this.state.selectedCompanyId:this.props.companyId;var url=window.location.origin+redirectURL.replace(':companyId','#'+companyId);if(url.indexOf('company-known=1')===-1){url+=url.indexOf('?')===-1?'/?':'&';url+='company-known=1';}window.location.href=url;window.location.reload();this.props.hideModal();this.props.showPreloader();}}]);return CompanySelectionModal;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);CompanySelectionModal.propTypes={companies:__WEBPACK_IMPORTED_MODULE_19_prop_types___default.a.object,modalShown:__WEBPACK_IMPORTED_MODULE_19_prop_types___default.a.bool,hideModal:__WEBPACK_IMPORTED_MODULE_19_prop_types___default.a.func,resetModal:__WEBPACK_IMPORTED_MODULE_19_prop_types___default.a.func,companyId:__WEBPACK_IMPORTED_MODULE_19_prop_types___default.a.string,showPreloader:__WEBPACK_IMPORTED_MODULE_19_prop_types___default.a.func,redirectURL:__WEBPACK_IMPORTED_MODULE_19_prop_types___default.a.string};var mapStateToProps=function mapStateToProps(state){return{modalShown:state.modal.modalShown,companies:state.companies,companyId:state.companies.rawDataById[state.companies.selectedId].id};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])({hideModal:__WEBPACK_IMPORTED_MODULE_18_redux_modules_modal__["b" /* hideModal */],resetModal:__WEBPACK_IMPORTED_MODULE_18_redux_modules_modal__["c" /* resetModal */],showPreloader:__WEBPACK_IMPORTED_MODULE_7_redux_modules_preloader__["c" /* showPreloader */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(CompanySelectionModal));

/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogActions__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogContent__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogContentText__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_DialogTitle__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_redux_modules_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_prop_types__);
var _dec,_class;var styles=function styles(theme){return{modal:{},content:{},actions:{},button:{}};};var SetPasswordModal=(_dec=Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(SetPasswordModal,_Component);function SetPasswordModal(){__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,SetPasswordModal);return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(SetPasswordModal).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(SetPasswordModal,[{key:"render",value:function render(){var _this$props=this.props,classes=_this$props.classes,modalShown=_this$props.modalShown,resetModal=_this$props.resetModal,title=_this$props.title;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog___default.a,{open:modalShown,"aria-labelledby":"alert-dialog-title","aria-describedby":"alert-dialog-description",onExited:resetModal,classes:{paper:classes.modal}},title&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_DialogTitle___default.a,null,title),this.renderContent(),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogActions___default.a,{className:classes.actions},this.renderButtons()));}},{key:"renderContent",value:function renderContent(){var contentText;var _this$props2=this.props,message=_this$props2.message,classes=_this$props2.classes;if(message&&message.__html){contentText=__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogContentText___default.a,{dangerouslySetInnerHTML:message,variant:"body1",color:"default"});}else{contentText=__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogContentText___default.a,{variant:"body1",color:"default"},message);}return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogContent___default.a,{className:classes.content},contentText);}},{key:"renderButtons",value:function renderButtons(){var _this$props3=this.props,hideModal=_this$props3.hideModal,buttons=_this$props3.buttons,hideModalOnButtonClick=_this$props3.hideModalOnButtonClick;return buttons.map(function(button,index){return Object(__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"])(button,{key:"set-password-modal-button-".concat(index),onClick:function onClick(){hideModalOnButtonClick&&hideModal();button.props.onClick&&button.props.onClick();}});});}}]);return SetPasswordModal;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]))||_class);SetPasswordModal.defaultProps={buttons:[],hideModalOnButtonClick:true};SetPasswordModal.propTypes={classes:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.object,modalShown:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.bool,hideModal:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.func,resetModal:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.func,title:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.string,message:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.object]),buttons:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.array,hideModalOnButtonClick:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.bool};var mapStateToProps=function mapStateToProps(state){return{modalShown:state.modal.modalShown};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_8_redux__["b" /* bindActionCreators */])({hideModal:__WEBPACK_IMPORTED_MODULE_14_redux_modules_modal__["b" /* hideModal */],resetModal:__WEBPACK_IMPORTED_MODULE_14_redux_modules_modal__["c" /* resetModal */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(SetPasswordModal));

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogActions__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogContent__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogContentText__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_DialogTitle__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_redux_modules_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_prop_types__);
var _dec,_class;var styles=function styles(theme){return{modal:{},content:{},actions:{},button:{}};};var ConfirmYourEmailAddressModal=(_dec=Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(ConfirmYourEmailAddressModal,_Component);function ConfirmYourEmailAddressModal(){__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,ConfirmYourEmailAddressModal);return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(ConfirmYourEmailAddressModal).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ConfirmYourEmailAddressModal,[{key:"render",value:function render(){var _this$props=this.props,classes=_this$props.classes,modalShown=_this$props.modalShown,resetModal=_this$props.resetModal,title=_this$props.title;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog___default.a,{open:modalShown,"aria-labelledby":"alert-dialog-title","aria-describedby":"alert-dialog-description",onExited:resetModal,classes:{paper:classes.modal}},title&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_DialogTitle___default.a,null,title),this.renderContent(),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogActions___default.a,{className:classes.actions},this.renderButtons()));}},{key:"renderContent",value:function renderContent(){var contentText;var _this$props2=this.props,message=_this$props2.message,classes=_this$props2.classes;if(message&&message.__html){contentText=__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogContentText___default.a,{dangerouslySetInnerHTML:message,variant:"body1",color:"default"});}else{contentText=__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogContentText___default.a,{variant:"body1",color:"default"},message);}return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogContent___default.a,{className:classes.content},contentText);}},{key:"renderButtons",value:function renderButtons(){var _this$props3=this.props,hideModal=_this$props3.hideModal,buttons=_this$props3.buttons,hideModalOnButtonClick=_this$props3.hideModalOnButtonClick;return buttons.map(function(button,index){return Object(__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"])(button,{key:"set-password-modal-button-".concat(index),onClick:function onClick(){hideModalOnButtonClick&&hideModal();button.props.onClick&&button.props.onClick();}});});}}]);return ConfirmYourEmailAddressModal;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]))||_class);ConfirmYourEmailAddressModal.defaultProps={buttons:[],hideModalOnButtonClick:true};ConfirmYourEmailAddressModal.propTypes={classes:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.object,modalShown:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.bool,hideModal:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.func,resetModal:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.func,title:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.string,message:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.object]),buttons:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.array,hideModalOnButtonClick:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.bool};var mapStateToProps=function mapStateToProps(state){return{modalShown:state.modal.modalShown};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_8_redux__["b" /* bindActionCreators */])({hideModal:__WEBPACK_IMPORTED_MODULE_14_redux_modules_modal__["b" /* hideModal */],resetModal:__WEBPACK_IMPORTED_MODULE_14_redux_modules_modal__["c" /* resetModal */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ConfirmYourEmailAddressModal));

/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_modules_preloader__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Button__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_IconButton__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_Dialog__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_DialogTitle__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_DialogContent__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_redux_modules_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_core_Typography__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__FormField__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__theme_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__DiscountSchema__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_redux_modules_crs__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_redux_modules_discount__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_lib_Segment_customTrackers__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_lib_Segment_helpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_i18n_i18n__ = __webpack_require__(15);
var _errors,_dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_34_i18n_i18n__["a" /* default */].loc.localize;var styles=function styles(theme){return{/* Dialog */dialogPaper:{minWidth:444},dialogWrapper:{position:'relative',padding:'15px 10px 15px',minHeight:291},dialogTitle:{'& h6':{fontWeight:600,fontSize:'28px',lineHeight:1.4,marginBottom:20,textAlign:'left'}},/* close button */closeDialog:{position:'absolute',top:10,right:10},closeDialogIcon:{color:'#6F99BD',width:'20px',height:'20px'},/* input field */fieldRoot:{'&$error':{marginTop:10,marginBottom:15,fontSize:'0.8rem'}},field:{width:'100%',margin:'0 0 24px 0','& input':{borderWidth:1,borderStyle:'solid',borderRadius:5,borderColor:theme.palette.secondary.lighter,color:theme.palette.text.primary,padding:'7px 10px','&:focus':{borderColor:theme.palette.primary.main},'&::placeholder':{fontFamily:'Open Sans, sans-serif',fontWeight:'normal',fontStyle:'normal',fontSize:'14px',lineHeight:'19px',color:theme.palette.text.primary}},'& [id*=helper-text]':{paddingLeft:'10px'}},/* buttons */button:{fontFamily:'Open Sans, sans-serif',borderRadius:5,fontWeight:600,fontSize:18,lineHeight:1.3,opacity:'1 !important',color:'#000'},buttonCancel:{},buttonPrimary:{background:theme.palette.primary.main,color:'white',textShadow:'none','&[class*=contained][class*=disabled]':{backgroundColor:'#B3B9C0'}},buttonSubmit:{marginLeft:10},buttonApply:{},/* error message */errorMessage:{color:theme.palette.error.main,fontSize:14,lineHeight:1.5,opacity:1,textAlign:'left',marginTop:-15,marginBottom:15,'& a':{color:theme.palette.primary.main}},/* loading icon */loadingWrapper:{position:'absolute',top:'50%',left:'50%',transform:'translate(-50%, -50%)'},loadingMessage:{fontSize:16,lineHeight:1.5,opacity:1},loadingIcon:{display:'block',height:'24px',width:'24px',margin:'0 auto 10px',fill:'#96DCFD',animation:'spin 2s linear infinite'},'@keyframes spin':{'0':{transform:'rotate(0deg)'},'100%':{transform:'rotate(360deg)'}},/* success screen */successScreenDescription:{fontSize:16,lineHeight:1.5,opacity:1,textAlign:'left'},successScreenIcon:{margin:'20px 0'},/* serial number example */serialNumberDescription:{margin:'-5px 0 0',textAlign:'left',color:theme.palette.text.primary,opacity:1},serialNumberExampleList:{margin:'0 0 10px',listStyle:'none'},serialNumberExampleListItem:{textAlign:'left',fontSize:13,lineHeight:1.5,color:theme.palette.text.primary,fontFamily:'"Open Sans Xara", Arial, Helvetica, sans-serif',padding:0}};};var errors=(_errors={},__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_30__errors_errorids__["a" /* default */].OFFLINE,localize('discount-modal-error-offline')),__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_30__errors_errorids__["a" /* default */].CRS_INFO_REQUEST_FAILED,localize('discount-modal-error-crs-info-request-failed')),__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_30__errors_errorids__["a" /* default */].CRS_INVALID_CREDENTIALS,localize('discount-modal-error-crs-invalid-credentials')),__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_30__errors_errorids__["a" /* default */].CRS_CREDENTIALS_ALREADY_USED,localize('discount-modal-error-crs-credentials-already-used')),_errors);var invalidReason={'invalid-serial':localize('discount-modal-invalid-serial'),'serial-email-missmatch':localize('discount-modal-serial-email-missmatch')};var DiscountModal=(_dec=Object(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(DiscountModal,_Component);function DiscountModal(props){var _this;__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this,DiscountModal);_this=__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(DiscountModal).call(this,props));_this.state={magixEmail:'',productSerial:'',xhrInProgress:false,crsValidationError:false,crsValidationSuccess:false,touched:{},errors:{}};return _this;}__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(DiscountModal,[{key:"render",value:function render(){var _this2=this;var _this$props=this.props,modalShown=_this$props.modalShown,resetModal=_this$props.resetModal,classes=_this$props.classes;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_Dialog___default.a,{open:modalShown,"aria-labelledby":"alert-dialog-title","aria-describedby":"alert-dialog-description",onExited:resetModal,BackdropProps:{style:{backgroundColor:'rgba(46, 63, 79, 0.4)'}},classes:{paper:classes.dialogPaper},PaperProps:{style:{border:0,width:309,borderRadius:5,boxShadow:'0px 4px 24px rgba(0, 0, 0, 0.08)'}}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:classes.dialogWrapper},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_IconButton___default.a,{className:classes.closeDialog,component:"span","aria-label":"Close",onClick:function onClick(){return _this2.closeDialog();}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__theme_icons__["_11" /* XIcon */],{className:classes.closeDialogIcon})),function(){if(_this2.state.xhrInProgress){return _this2.renderLoading();}else if(_this2.state.crsValidationSuccess){return _this2.renderSuccessScreen();}else{return _this2.renderForm();}}()));}},{key:"closeDialog",value:function closeDialog(){this.props.hideModal();}},{key:"applyDiscount",value:function applyDiscount(){this.props.clearAppliedDiscount();// clears isUpgradePopup and isCouponIdProvided
this.props.applyMagixDiscount(this.state.magixEmail,this.state.productSerial,this.props.crs.prodCatOfLastValidCombination,this.props.crs.tierOfLastValidCombination,this.props.crs.prodTypeOfLastValidCombination);this.closeDialog();}},{key:"renderLoading",value:function renderLoading(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:classes.loadingWrapper},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__theme_icons__["Y" /* SpinnerIcon */],{className:classes.loadingIcon}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_Typography___default.a,{className:classes.loadingMessage,variant:"body2"},localize('discount-modal-checking')));}},{key:"renderErrorMessage",value:function renderErrorMessage(){var errorMessage=__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.get(this.state,'errors.globalError');var classes=this.props.classes;Object(__WEBPACK_IMPORTED_MODULE_32_lib_Segment_customTrackers__["s" /* trackDiscountCouponError */])(Object(__WEBPACK_IMPORTED_MODULE_33_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_Typography___default.a,{className:classes.errorMessage,variant:"body2",dangerouslySetInnerHTML:{__html:errorMessage}});}},{key:"renderSuccessScreen",value:function renderSuccessScreen(){var _this3=this;var classes=this.props.classes;var tierKey;if(this.props.crs.prodTypeOfLastValidCombination===__WEBPACK_IMPORTED_MODULE_31__config__["Y" /* MAXIC_DISCOUNT_PROD_TYPE */].SUBSCRIPTION){tierKey=this.props.crs.tierOfLastValidCombination;}else if(this.props.crs.prodTypeOfLastValidCombination===__WEBPACK_IMPORTED_MODULE_31__config__["Y" /* MAXIC_DISCOUNT_PROD_TYPE */].PERPETUAL){tierKey=this.props.crs.prodCatOfLastValidCombination;}var discountPerc=__WEBPACK_IMPORTED_MODULE_31__config__["D" /* DISCOUNTS_CONFIG */]["tier_".concat(tierKey)].discount*100;Object(__WEBPACK_IMPORTED_MODULE_32_lib_Segment_customTrackers__["t" /* trackDiscountCouponShown */])(Object(__WEBPACK_IMPORTED_MODULE_33_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_DialogTitle___default.a,{variant:"body1",color:"default",className:classes.dialogTitle},this.props.magixDiscountProdType===__WEBPACK_IMPORTED_MODULE_31__config__["Y" /* MAXIC_DISCOUNT_PROD_TYPE */].PERPETUAL&&__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.get(this.props.crs,'isFallbackProductReturnedLastValidCombination')?localize('discount-modal-success-title-generic'):localize('discount-modal-success-title',discountPerc)),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_Typography___default.a,{className:classes.successScreenDescription,variant:"body2"},localize(this.props.magixDiscountProdType===__WEBPACK_IMPORTED_MODULE_31__config__["Y" /* MAXIC_DISCOUNT_PROD_TYPE */].PERPETUAL?'discount-modal-success-message-perpetual':'discount-modal-success-message-subscription'))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__theme_icons__["_7" /* VoucherIconColored */],{className:classes.successScreenIcon})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true,container:true,direction:"row",justify:"flex-end"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Button___default.a,{variant:"contained",color:"primary","data-tid":"button-discount-modal-apply",className:__WEBPACK_IMPORTED_MODULE_16_classnames___default()(classes.button,classes.buttonPrimary,classes.buttonApply),onClick:function onClick(){return _this3.applyDiscount();},disabled:false},localize('great')))))));}},{key:"renderForm",value:function renderForm(){var _this4=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_DialogTitle___default.a,{variant:"body1",color:"default",className:classes.dialogTitle},localize('discount-modal-title')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{container:true,direction:"column"},this.state.crsValidationError&&this.renderErrorMessage(),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true},this.field('magixEmail',localize('discount-modal-email-placeholder'),false,'email')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true},this.field('productSerial',localize('discount-modal-serial-placeholder'))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_Typography___default.a,{className:classes.serialNumberDescription,variant:"body2"},localize('discount-modal-serial-number-format-example')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core__["s" /* List */],{className:classes.serialNumberExampleList},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core__["t" /* ListItem */],{className:classes.serialNumberExampleListItem},"P3-XXXXX-XXXXX-XXXXX-XXXXX-XXXXX-XXXXX"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core__["t" /* ListItem */],{className:classes.serialNumberExampleListItem},"S2-XXXXX-XXXXX-XXXXX-XXXXX-XXXXX"))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true,container:true,direction:"row",justify:"flex-end"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Button___default.a,{variant:"outlined",color:"primary","data-tid":"button-discount-modal-cancel",className:__WEBPACK_IMPORTED_MODULE_16_classnames___default()(classes.button,classes.buttonCancel),onClick:function onClick(){return _this4.closeDialog();},disabled:false},localize('cancel'))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Button___default.a,{variant:"contained",color:"primary","data-tid":"button-discount-modal-save",className:__WEBPACK_IMPORTED_MODULE_16_classnames___default()(classes.button,classes.buttonPrimary,classes.buttonSubmit),onClick:function onClick(){return _this4.submitForm();},disabled:!this.isSubmitEnabled()},localize('submit')))))));}},{key:"isSubmitEnabled",value:function isSubmitEnabled(){return this.state.magixEmail&&this.state.productSerial&&(Object.keys(this.state.errors).length===0||Object.keys(this.state.errors).length===1&&__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.get(this.state,'errors.globalError'));}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){// Credentials check
if(this.props.crs.areCredentialsValid!==nextProps.crs.areCredentialsValid){this.handleCredentialsValidation(nextProps);}}},{key:"handleCredentialsValidation",value:function handleCredentialsValidation(nextProps){if(nextProps.crs.areCredentialsValid===true){this.setState({xhrInProgress:false,crsValidationError:false,crsValidationSuccess:true,errors:{globalError:null}});}else if(nextProps.crs.areCredentialsValid===false){// Happens in casecases:
// - firstMessageId is OFFLINE
// - General HTTP error when status code != 200 (CRS_INFO_REQUEST_FAILED)
// - returned json.valid = false, for example when serial is invalid.
var errorMessage=nextProps.crs.checkCredentialsInvalidReason&&invalidReason[nextProps.crs.checkCredentialsInvalidReason]||nextProps.crs.checkCredentialsErrorid&&errors[nextProps.crs.checkCredentialsErrorid]||nextProps.crs.checkCredentialsErrorMessage||localize('discount-modal-error-unknown');if(nextProps.crs.checkCredentialsInvalidReason&&invalidReason[nextProps.crs.checkCredentialsInvalidReason]){if(nextProps.crs.checkCredentialsInvalidReason==='invalid-serial'){Object(__WEBPACK_IMPORTED_MODULE_32_lib_Segment_customTrackers__["y" /* trackInvalidSerial */])(Object(__WEBPACK_IMPORTED_MODULE_33_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}else if(nextProps.crs.checkCredentialsInvalidReason==='serial-email-missmatch'){Object(__WEBPACK_IMPORTED_MODULE_32_lib_Segment_customTrackers__["x" /* trackEmailSerialMissmatch */])(Object(__WEBPACK_IMPORTED_MODULE_33_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}}this.setState({xhrInProgress:false,crsValidationError:true,crsValidationSuccess:false,errors:{globalError:errorMessage}});}}},{key:"field",value:function field(name,placeholder,disabled,type,maxLength){var _this5=this;var classes=this.props.classes;var errorClasses={root:classes.fieldRoot,error:classes.error};return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__FormField__["a" /* default */],__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({value:this.state[name],autoComplete:"off",className:classes.field,"data-tid":"form-crs-validation-".concat(name),onChange:function onChange(event){return _this5.onChange(event,name);},onBlur:function onBlur(event){return _this5.onBlur(event,name);},onKeyPress:function onKeyPress(event){return _this5.onKeyPress(event,name);},id:name,placeholder:placeholder},type?{type:type}:{},{margin:"normal",helperText:this.state.errors[name],error:!!this.state.errors[name],FormHelperTextProps:{classes:errorClasses},disabled:disabled,maxLength:maxLength,inputRef:this[name]}));}},{key:"onChange",value:function onChange(event,name){this.setFieldState(name,event.target.value);}},{key:"setFieldState",value:function setFieldState(fieldName,value){this.setState(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()({},fieldName,value),this.validateAll);}},{key:"onBlur",value:function onBlur(event,name){this.setState(function(prevState){return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},prevState,{touched:__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},prevState.touched,__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()({},name,true))});},this.validateAll);}},{key:"onKeyPress",value:function onKeyPress(event,name){if(!this.isSubmitEnabled())return;if(event.key==='Enter'){this.submitForm();}}},{key:"submitForm",value:function submitForm(){this.setState({xhrInProgress:true,crsValidationError:false,crsValidationSuccess:false});this.props.checkCrsCredentials(this.state.magixEmail,this.state.productSerial,__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.get(this.props.user,'mainEmail'),this.props.magixDiscountProdType);}},{key:"validateAll",value:function validateAll(){var errors={};for(var field in __WEBPACK_IMPORTED_MODULE_26__DiscountSchema__["a" /* default */]){var validate=__WEBPACK_IMPORTED_MODULE_26__DiscountSchema__["a" /* default */][field];if(validate){var error=validate(this.state[field],this.state,this.props);if(error){errors[field]=error;}}}var globalError=__WEBPACK_IMPORTED_MODULE_29_lodash___default.a.get(this.state,'errors.globalError');if(globalError){errors['globalError']=globalError;}this.setState({errors:errors});}},{key:"updateMagixEmail",value:function updateMagixEmail(){this.setState({errors:{'magixEmail':null}});}},{key:"updateProductSerial",value:function updateProductSerial(){this.setState({errors:{'productSerial':null}});}}]);return DiscountModal;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]))||_class);DiscountModal.propTypes={companies:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.object,modalShown:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.bool,hideModal:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.func,resetModal:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.func,companyId:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,showPreloader:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.func,redirectURL:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,classes:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.object,checkCrsCredentials:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.func.isRequired,crs:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.object.isRequired,applyMagixDiscount:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.func,clearAppliedDiscount:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.func,user:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.object.isRequired,magixDiscountProdType:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string.isRequired,company:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.object};var mapStateToProps=function mapStateToProps(state){return{company:state.companies.rawDataById?state.companies.rawDataById[state.companies.selectedId]:null,user:state.session.user,modalShown:state.modal.modalShown,companies:state.companies,companyId:state.companies.rawDataById[state.companies.selectedId].id,crs:state.crs};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_11_redux__["b" /* bindActionCreators */])({hideModal:__WEBPACK_IMPORTED_MODULE_20_redux_modules_modal__["b" /* hideModal */],resetModal:__WEBPACK_IMPORTED_MODULE_20_redux_modules_modal__["c" /* resetModal */],showPreloader:__WEBPACK_IMPORTED_MODULE_9_redux_modules_preloader__["c" /* showPreloader */],checkCrsCredentials:__WEBPACK_IMPORTED_MODULE_27_redux_modules_crs__["b" /* checkCrsCredentials */],applyMagixDiscount:__WEBPACK_IMPORTED_MODULE_28_redux_modules_discount__["d" /* applyMagixDiscount */],clearAppliedDiscount:__WEBPACK_IMPORTED_MODULE_28_redux_modules_discount__["f" /* clearAppliedDiscount */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(DiscountModal));

/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validator_lib_isEmail__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validator_lib_isEmail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_validator_lib_isEmail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18n_i18n__ = __webpack_require__(15);
var localize=__WEBPACK_IMPORTED_MODULE_2_i18n_i18n__["a" /* default */].loc.localize;var schema={'magixEmail':function magixEmail(value,state){if(!value){return localize('required-field');}if(state.touched['magixEmail']){if(!__WEBPACK_IMPORTED_MODULE_0_validator_lib_isEmail___default()(value)){return localize('discount-modal-email-invalid');}}},'productSerial':function productSerial(value,state){if(state.touched['productSerial']){if(!value){return localize('required-field');}if(!__WEBPACK_IMPORTED_MODULE_1__config__["_33" /* SERIAL_NUMBER_REGEXP */].test(value)){return localize('discount-modal-serial-invalid-format');}}}};/* harmony default export */ __webpack_exports__["a"] = (schema);

/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Grid__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_IconButton__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Dialog__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogTitle__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_DialogContent__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_redux_modules_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_Typography__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__theme_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lib_Segment_customTrackers__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lib_Segment_helpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_i18n_i18n__ = __webpack_require__(15);
var _errors,_dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_26_i18n_i18n__["a" /* default */].loc.localize;var styles=function styles(theme){return{/* Dialog */dialogPaper:{minWidth:444},dialogWrapper:{position:'relative',padding:'15px 10px 15px',minHeight:291},dialogTitle:{'& h6':{fontWeight:600,fontSize:'28px',lineHeight:1.4,marginBottom:6,textAlign:'left'}},/* close button */closeDialog:{position:'absolute',top:10,right:10},closeDialogIcon:{color:'#6F99BD',width:'20px',height:'20px'},/* buttons */button:{fontFamily:'Open Sans, sans-serif',borderRadius:5,fontWeight:600,fontSize:18,lineHeight:1.3,color:'#000',opacity:'1 !important',paddingLeft:15,paddingRight:15,minWidth:'auto'},buttonCancel:{},buttonPrimary:{background:theme.palette.primary.main,color:'white',textShadow:'none','&[class*=contained][class*=disabled]':{backgroundColor:'#B3B9C0'}},buttonContinue:{marginLeft:10},/* description and list items */selectedItemsDescription:{opacity:1,color:'#000',textAlign:'left',margin:'0 0 10px'},selectedItemsList:{margin:'0 0 30px 10px',listStyle:'none'},selectedItemsListItem:{textAlign:'left',fontSize:16,lineHeight:1.5,color:'#000',fontFamily:'"Open Sans Xara", Arial, Helvetica, sans-serif',position:'relative',padding:'0 0 0 14px','&:before':{content:'""',display:'inline-block',width:'3px',height:'3px',borderRadius:3,background:'#000',marginRight:5,position:'absolute',top:10,left:0}},/* error message */errorMessage:{color:theme.palette.error.main,fontSize:14,lineHeight:1.5,opacity:1,textAlign:'left',marginTop:0,marginBottom:15,'& a':{color:theme.palette.primary.main}},/* loading icon */loadingWrapper:{position:'absolute',top:'50%',left:'50%',transform:'translate(-50%, -50%)'},loadingMessage:{fontSize:16,lineHeight:1.5,opacity:1},loadingIcon:{display:'block',height:'24px',width:'24px',margin:'0 auto 10px',fill:'#96DCFD',animation:'spin 2s linear infinite'},'@keyframes spin':{'0':{transform:'rotate(0deg)'},'100%':{transform:'rotate(360deg)'}}};};var errors=(_errors={},__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_19__errors_errorids__["a" /* default */].OFFLINE,localize('subscriptions-error-offline')),__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_19__errors_errorids__["a" /* default */].API_REQUEST_LIMIT_EXCEEDED,localize('error-cb-api-rate-limit-reached')),__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_19__errors_errorids__["a" /* default */].THE_NUMBER_OF_THE_USERS_CANNOT_BE_LESS_THAN_THE_NUMBER_OF_USERS_OF_COMPANY,localize('subscriptions-error-invalid-numbers-of-users')),_errors);var ConfirmPurchaseChoiceModal=(_dec=Object(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(ConfirmPurchaseChoiceModal,_Component);function ConfirmPurchaseChoiceModal(props){var _this;__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,ConfirmPurchaseChoiceModal);_this=__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(ConfirmPurchaseChoiceModal).call(this,props));_this.state={apiRequestError:false,apiRequestSuccess:false,xhrInProgress:false,errors:{}};return _this;}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ConfirmPurchaseChoiceModal,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(this.props.companies.createChargeBeeSubscriptionErrorId!==nextProps.companies.createChargeBeeSubscriptionErrorId&&nextProps.companies.createChargeBeeSubscriptionErrorId!==null){this.handleApiErrors(nextProps);}if(this.props.companies.createChargeBeeSubscriptionSuccess!==nextProps.companies.createChargeBeeSubscriptionSuccess&&nextProps.companies.createChargeBeeSubscriptionSuccess===true){this.setState({xhrInProgress:false,apiRequestError:false,apiRequestSuccess:true,errors:{apiError:null}});}}},{key:"componentDidMount",value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_24_lib_Segment_customTrackers__["m" /* trackConfirmPurchaseChoicePopupShown */])(this.props.plan,Object(__WEBPACK_IMPORTED_MODULE_25_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}},{key:"render",value:function render(){var _this2=this;var _this$props=this.props,modalShown=_this$props.modalShown,resetModal=_this$props.resetModal,classes=_this$props.classes;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Dialog___default.a,{open:modalShown,"aria-labelledby":"alert-dialog-title","aria-describedby":"alert-dialog-description",onExited:resetModal,BackdropProps:{style:{backgroundColor:'rgba(46, 63, 79, 0.4)'}},classes:{paper:classes.dialogPaper},PaperProps:{style:{border:0,width:309,borderRadius:5,boxShadow:'0px 4px 24px rgba(0, 0, 0, 0.08)'}}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:classes.dialogWrapper},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_IconButton___default.a,{className:classes.closeDialog,component:"span","aria-label":"Close",onClick:function onClick(){return _this2.closeDialog();}},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__theme_icons__["_11" /* XIcon */],{className:classes.closeDialogIcon})),function(){if(_this2.state.xhrInProgress){return _this2.renderLoading();}else if(_this2.state.apiRequestSuccess){_this2.closeDialog();}else if(_this2.state.apiRequestError){return _this2.renderContent();}else{return _this2.renderContent();}}()));}},{key:"renderLoading",value:function renderLoading(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:classes.loadingWrapper},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__theme_icons__["Y" /* SpinnerIcon */],{className:classes.loadingIcon}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_Typography___default.a,{className:classes.loadingMessage,variant:"body2"},localize('subscriptions-modal-fetching-data')));}},{key:"renderContent",value:function renderContent(){var _this3=this;var _this$props2=this.props,classes=_this$props2.classes,listItems=_this$props2.listItems;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogTitle___default.a,{variant:"body1",color:"default",className:classes.dialogTitle},localize('subscription-confirm-choice-title')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_DialogContent___default.a,null,Object.keys(this.state.errors).length>0&&this.renderErrorMessage(),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_Typography___default.a,{className:classes.selectedItemsDescription,variant:"body1"},localize('subscription-confirm-choice-selected'),":"),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core__["s" /* List */],{className:classes.selectedItemsList},listItems.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core__["t" /* ListItem */],{key:"selected-item-".concat(index+1),className:classes.selectedItemsListItem},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_Typography___default.a,{variant:"p",className:classes.productTitle,dangerouslySetInnerHTML:{__html:item}}));})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Grid___default.a,{item:true,container:true,direction:"row",justify:"flex-end"},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default.a,{variant:"outlined",color:"primary","data-role":"outlined","data-tid":"button-confirm-choice-modal-cancel",className:__WEBPACK_IMPORTED_MODULE_13_classnames___default()(classes.button,classes.buttonCancel),onClick:function onClick(){return _this3.closeDialog();}},localize('go-back'))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default.a,{variant:"contained",color:"primary","data-role":"contained","data-tid":"button-confirm-choice-modal-continue",className:__WEBPACK_IMPORTED_MODULE_13_classnames___default()(classes.button,classes.buttonPrimary,classes.buttonContinue),onClick:function onClick(){return _this3.continueToCheckout();}},localize('continue-to-checkout'))))));}},{key:"closeDialog",value:function closeDialog(){this.props.hideModal();}},{key:"renderErrorMessage",value:function renderErrorMessage(){var errorMessage=__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.get(this.state,'errors.apiError');var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_Typography___default.a,{className:classes.errorMessage,variant:"body2",dangerouslySetInnerHTML:{__html:errorMessage}});}},{key:"handleApiErrors",value:function handleApiErrors(propsSource){if(propsSource.companies.createChargeBeeSubscriptionErrorId){var errorMessage=propsSource.companies.createChargeBeeSubscriptionErrorId&&errors[propsSource.companies.createChargeBeeSubscriptionErrorId]||localize('subscriptions-error-unknown');this.setState({xhrInProgress:false,apiRequestError:true,apiRequestSuccess:false,errors:{apiError:errorMessage}});}}},{key:"continueToCheckout",value:function continueToCheckout(){this.setState({xhrInProgress:true,apiRequestError:false,apiRequestSuccess:false,errors:{apiError:null}});this.props.cb();}}]);return ConfirmPurchaseChoiceModal;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]))||_class);ConfirmPurchaseChoiceModal.propTypes={companies:__WEBPACK_IMPORTED_MODULE_21_prop_types___default.a.object,modalShown:__WEBPACK_IMPORTED_MODULE_21_prop_types___default.a.bool,hideModal:__WEBPACK_IMPORTED_MODULE_21_prop_types___default.a.func,resetModal:__WEBPACK_IMPORTED_MODULE_21_prop_types___default.a.func,classes:__WEBPACK_IMPORTED_MODULE_21_prop_types___default.a.object,listItems:__WEBPACK_IMPORTED_MODULE_21_prop_types___default.a.array,plan:__WEBPACK_IMPORTED_MODULE_21_prop_types___default.a.string,cb:__WEBPACK_IMPORTED_MODULE_21_prop_types___default.a.func,company:__WEBPACK_IMPORTED_MODULE_21_prop_types___default.a.object};var mapStateToProps=function mapStateToProps(state){return{company:state.companies.rawDataById?state.companies.rawDataById[state.companies.selectedId]:null,modalShown:state.modal.modalShown,companies:state.companies};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_8_redux__["b" /* bindActionCreators */])({hideModal:__WEBPACK_IMPORTED_MODULE_17_redux_modules_modal__["b" /* hideModal */],resetModal:__WEBPACK_IMPORTED_MODULE_17_redux_modules_modal__["c" /* resetModal */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ConfirmPurchaseChoiceModal));

/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_custom_scrollbars__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_custom_scrollbars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_custom_scrollbars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_users__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_browser__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_redux_modules_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_redux_modules_companies__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Features_components__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_icons_Add__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_icons_Add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__material_ui_icons_Add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_icons_KeyboardArrowDown__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_icons_KeyboardArrowDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__material_ui_icons_KeyboardArrowDown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__theme_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__theme_uiConfig__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__FormField__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_storage__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_lib_Segment_customTrackers__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_lib_Segment_helpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_i18n_i18n__ = __webpack_require__(15);
var _errors,_dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_33_i18n_i18n__["a" /* default */].loc.localize;var PERMISSION_ROLE=[{key:__WEBPACK_IMPORTED_MODULE_30__config__["_54" /* USER_ROLE_ADMIN */],value:__WEBPACK_IMPORTED_MODULE_30__config__["_53" /* USER_ROLES */][__WEBPACK_IMPORTED_MODULE_30__config__["_54" /* USER_ROLE_ADMIN */]].label},{key:__WEBPACK_IMPORTED_MODULE_30__config__["_55" /* USER_ROLE_BASIC */],value:__WEBPACK_IMPORTED_MODULE_30__config__["_53" /* USER_ROLES */][__WEBPACK_IMPORTED_MODULE_30__config__["_55" /* USER_ROLE_BASIC */]].label},// Temporarily enable users to add guests through this popup - users can activate perpetual version as guests
// without needing to upgrade to team
{key:__WEBPACK_IMPORTED_MODULE_30__config__["_56" /* USER_ROLE_GUEST */],value:__WEBPACK_IMPORTED_MODULE_30__config__["_53" /* USER_ROLES */][__WEBPACK_IMPORTED_MODULE_30__config__["_56" /* USER_ROLE_GUEST */]].label}];var ERROR_MESSAGES={INVALID_EMAIL:localize('users-email-error-invalid'),USER_ALREADY_EXISTS:localize('users-email-error-exists'),USER_ALREADY_EXISTS_IN_INVITE_LIST:localize('users-email-already-exists-in-invite-list'),USER_MESSAGE_EMPTY:localize('users-message-empty')};var errors=(_errors={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_29__errors_errorids__["a" /* default */].API_REQUEST_LIMIT_EXCEEDED,localize('error-cb-api-rate-limit-reached')),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_29__errors_errorids__["a" /* default */].OFFLINE,localize('users-batch-add-error-offline')),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_29__errors_errorids__["a" /* default */].SUBSCRIPTION_PLAN_PROHIBITS_USER_MODIFICATION,localize('users-batch-add-error-cant-modify-users')),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_29__errors_errorids__["a" /* default */].FAILED_TO_ADD_USERS_TO_COMPANY,localize('users-batch-add-error-failed-to-add-user-to-company')),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_29__errors_errorids__["a" /* default */].INVALID_USER,localize('users-batch-add-error-invalid-user')),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_29__errors_errorids__["a" /* default */].INVALID_USERS,localize('users-batch-add-error-invalid-users')),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_29__errors_errorids__["a" /* default */].USER_ALREADY_EXISTS_IN_COMPANY,localize('users-batch-add-error-user-already-exists')),_errors);var EMPTY_USER_MEMBER={email:'',role:__WEBPACK_IMPORTED_MODULE_30__config__["_55" /* USER_ROLE_BASIC */],id:null};var EMPTY_USER_GUEST={email:'',role:__WEBPACK_IMPORTED_MODULE_30__config__["_56" /* USER_ROLE_GUEST */],id:null};var styles=function styles(theme){return{/* Dialog */dialogPaper:{minWidth:444},dialogWrapper:{position:'relative',padding:'15px 10px 0',minHeight:291},dialogTitle:{'& h6':{fontWeight:600,fontSize:'28px',lineHeight:1.4,marginBottom:20,textAlign:'left'}},/* dialog content */dialogContent:{overflow:'visible'},/* close button */closeDialog:{position:'absolute',top:10,right:10},closeDialogIcon:{color:'#6F99BD',width:'20px',height:'20px'},/* loading icon */loadingContainer:{minHeight:402,position:'relative'},loadingContent:{position:'absolute',top:'50%',left:'50%',transform:'translate(-50%, -50%)'},loadingMessage:{fontSize:16,lineHeight:1.5,opacity:1},loadingIcon:{display:'block',height:'24px',width:'24px',margin:'0 auto 10px',fill:'#96DCFD',animation:'spin 2s linear infinite'},'@keyframes spin':{'0':{transform:'rotate(0deg)'},'100%':{transform:'rotate(360deg)'}},/* input field */field:{width:'100%',margin:0,'& input, & textarea':{border:'1px solid #aabfd1',borderStyle:'solid',borderRadius:5,color:theme.palette.text.primary,padding:'10px','&:focus, &:hover':{color:'#2888c3',borderColor:'#2888c3'},'&::placeholder':{fontFamily:'Open Sans, sans-serif',fontWeight:'normal',fontStyle:'normal',fontSize:'14px',lineHeight:'19px',color:theme.palette.text.primary}},'& textarea':{width:'425px',display:'block'},'& [id*=helper-text]':{paddingLeft:0,color:theme.palette.error.main},'& [class*=error] input':{borderColor:"".concat(theme.palette.error.main," !important")}},/* buttons */button:{fontFamily:'Open Sans, sans-serif',borderRadius:5,fontWeight:600,fontSize:18,lineHeight:1.3,opacity:'1 !important'},buttonPrimary:{background:theme.palette.primary.main,color:'white',textShadow:'none',paddingLeft:10,paddingRight:15,'&[class*=contained][class*=disabled]':{backgroundColor:'#f4f4f4',color:'#4a5660'}},/* upgrade info message */upgradeInfoMessage:{color:theme.palette.error.main,fontSize:14,lineHeight:1.5,opacity:1,textAlign:'left',marginTop:-15,marginBottom:15,marginRight:20,'& a':{color:theme.palette.primary.main}},/* error message */errorMessage:{color:theme.palette.error.main,fontSize:14,lineHeight:1.5,opacity:1,textAlign:'left',marginTop:-15,marginBottom:15,'& a':{color:theme.palette.primary.main}},/* inviation message */invitationEmailLabelContainer:{width:'100%',paddingBottom:40},invitationEmailLabel:{textAlign:'left',color:theme.palette.text.primary,opacity:1,margin:'0 0 5px'},inviteButtonContainer:{position:'relative',width:'calc(100% + 60px)',margin:'0 0 0 -30px',padding:'24px 30px 10px 0','&:before':{content:'""',position:'absolute',top:0,left:0,width:'100%',height:'calc(100% + 14px)',boxShadow:'0px -4px 10px 0px rgba(0, 0, 0, 0.1)'}},inviteUsers:{},iconInviteUsers:{marginRight:5},/* user row */userRow:{marginBottom:16,width:'100%'},/* remove user */removeUserColumn:{width:33},removeUserButon:{position:'relative',left:-9,top:5,'&[class*=disabled]':{opacity:0.5}},removeUserIcon:{color:'#6F99BD',width:15,height:15,'&:hover':{color:'#2888c3'}},/* user email */userEmailColumn:{width:238,paddingRight:16},/* user role */userRoleColumn:{paddingRight:10},/* user info */userInfoColumn:{width:19},/* add another user */addAnotherUserContainer:{width:'100%',textAlign:'left'},addAnotherUserLink:{display:'inline-block',margin:'0 0 40px 0',textAlign:'left',color:theme.palette.colors.alpha,'&:hover, &:hover svg':{color:'#2888c3'},fontSize:'16px',lineHeight:'20px',fontWeight:600},addAnotherUserIconButton:{margin:'0 0 0 -6px'},addAnotherUserIcon:{width:20,height:20},/* roleSelect */roleSelect:{width:125},selectElement:{borderRadius:5,boxShadow:'none',borderColor:'#aabfd1',paddingRight:10,paddingLeft:10,textAlign:'left','&:hover, &:focus':{borderRadius:5,color:'#2888c3',borderColor:'#2888c3'}},selectElementItem:{'&:hover':{background:'#e0f5fe'},'&[class*=selected]':{background:'#e0f5fe !important'}},selectElementIcon:{right:4,'&:hover':{color:'#93c3e1'}},selectElementPaper:{borderRadius:5,border:0,boxShadow:'0px 4px 4px rgba(0, 0, 0, 0.1)'},/* info icon */infoIconButton:{position:'relative',top:8,width:16,height:16,color:theme.palette.colors.white,backgroundColor:'#6F99BD',borderColor:'#6F99BD',padding:0,'&:hover':{backgroundColor:"".concat(theme.palette.colors.epsilonHover," !important"),borderColor:"".concat(theme.palette.colors.epsilonHover," !important")}},tooltipArrow:{position:'absolute',fontSize:6,width:'3em',height:'1em',bottom:0,left:'50%',transform:'translateX(-50%)',marginBottom:'-0.95em','&::before':{content:'""',margin:'auto',display:'block',width:0,height:0,borderStyle:'solid',borderWidth:'1em 1em 0 1em',borderColor:"".concat(theme.palette.common.black," transparent transparent transparent")}},infoTooltip:{padding:7,backgroundColor:theme.palette.common.black},infoTooltipText:{color:theme.palette.common.white,opacity:1}};};var InviteUserModal=(_dec=Object(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["N" /* withStyles */])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits___default()(InviteUserModal,_Component);function InviteUserModal(props){var _this;__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default()(this,InviteUserModal);_this=__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default()(InviteUserModal).call(this,props));_this.state={xhrInProgress:false,apiValidationError:false,willIncreaseUserNumber:false,errors:{}};_this.handleAddAnotherUser=_this.handleAddAnotherUser.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.scrollbarRef=__WEBPACK_IMPORTED_MODULE_10_react___default.a.createRef(null);/* get users customer previously entered to Invite Users popup before he was redirected to CB checkout */var usersFromStorage=Object(__WEBPACK_IMPORTED_MODULE_27__utils_storage__["m" /* getInvitedUsers */])();if(usersFromStorage){usersFromStorage.forEach(function(user){return _this.props.inviteUserAdd(user);});Object(__WEBPACK_IMPORTED_MODULE_27__utils_storage__["d" /* clearInvitedUsers */])();}else if(_this.props.companyInviteUsers.length===0){var defaultUser=_this.getUserPlaceholder(props.email);_this.props.inviteUserAdd(defaultUser);}var inviteMessage=Object(__WEBPACK_IMPORTED_MODULE_27__utils_storage__["l" /* getInviteMessage */])();if(inviteMessage){_this.props.inviteUserSetMessage(inviteMessage);Object(__WEBPACK_IMPORTED_MODULE_27__utils_storage__["c" /* clearInviteMessage */])();}return _this;}__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default()(InviteUserModal,[{key:"render",value:function render(){var _this2=this;var _this$props=this.props,modalShown=_this$props.modalShown,resetModal=_this$props.resetModal,classes=_this$props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["d" /* Dialog */],{open:modalShown,"aria-labelledby":"alert-dialog-title","aria-describedby":"alert-dialog-description",onExited:resetModal,BackdropProps:{style:{backgroundColor:'rgba(46, 63, 79, 0.4)'}},classes:{paper:classes.dialogPaper},PaperProps:{style:{border:0,width:309,minWidth:505,borderRadius:5,boxShadow:'0px 4px 24px rgba(0, 0, 0, 0.08)'}}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.dialogWrapper},!this.state.xhrInProgress&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["p" /* IconButton */],{className:classes.closeDialog,component:"span","aria-label":"Close",onClick:function onClick(){return _this2.closeDialog();}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__theme_icons__["_11" /* XIcon */],{className:classes.closeDialogIcon})),function(){if(_this2.state.xhrInProgress){return _this2.renderLoading();}else{return _this2.renderForm();}}()));}},{key:"closeDialog",value:function closeDialog(){this.props.hideModal();}},{key:"renderLoading",value:function renderLoading(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.loadingContainer},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.loadingContent},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__theme_icons__["Y" /* SpinnerIcon */],{className:classes.loadingIcon}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["M" /* Typography */],{className:classes.loadingMessage,variant:"body2"},localize('users-popup-saving-users'))));}},{key:"renderUpgradePlanInfo",value:function renderUpgradePlanInfo(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["M" /* Typography */],{className:classes.upgradeInfoMessage,variant:"body2"},this.props.upgradeInfoMessage);}},{key:"renderErrorMessage",value:function renderErrorMessage(){var errors=this.getErrors();var apiError=__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(errors,'apiError');var formError=this.hasFormError(errors)&&localize('users-please-errors-found-in-the-form');var errorMessage;if(formError){errorMessage=formError;}else if(apiError){errorMessage=apiError;}var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["M" /* Typography */],{className:classes.errorMessage,variant:"body2",dangerouslySetInnerHTML:{__html:errorMessage}});}},{key:"renderForm",value:function renderForm(){var _classNames,_this3=this;var _this$props2=this.props,classes=_this$props2.classes,companyInviteMessage=_this$props2.companyInviteMessage;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["g" /* DialogTitle */],{variant:"body1",color:"default",className:classes.dialogTitle},localize('users-popup-header')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["f" /* DialogContent */],{className:classes.dialogContent},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{container:true,direction:"column"},this.props.upgradeInfoMessage&&this.renderUpgradePlanInfo(),Object.keys(this.state.errors).length>0&&this.renderErrorMessage(),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{container:true,item:true,direction:"column",className:classes.userRowsContainer},this.renderUserFields()),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{item:true,className:classes.addAnotherUserContainer},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["r" /* Link */],{variant:"body1",onClick:this.handleAddAnotherUser,className:classes.addAnotherUserLink,underline:"none"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["p" /* IconButton */],{className:classes.addAnotherUserIconButton,color:"primary",component:"span",disableRipple:true},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_icons_Add___default.a,{style:{fontSize:27},className:__WEBPACK_IMPORTED_MODULE_14_classnames___default()((_classNames={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames,classes.addAnotherUserIcon,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames,'addAnotherUserIcon',true),_classNames))})),localize('users-popup-add-another'))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{item:true,className:classes.invitationEmailLabelContainer},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["M" /* Typography */],{className:classes.invitationEmailLabel,variant:"body2"},localize('users-popup-invitation-email-message-label')),this.textField('invitationMessage',companyInviteMessage,localize('users-popup-invitation-email-message-value'),null,null,null,true)),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{item:true,container:true,direction:"row",justify:"flex-end",className:classes.inviteButtonContainer},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["a" /* Button */],{variant:"contained",color:"primary","data-tid":"button-user-invite",className:__WEBPACK_IMPORTED_MODULE_14_classnames___default()(classes.button,classes.inviteUsers,classes.buttonPrimary),onClick:function onClick(){return _this3.submitForm();},disabled:!this.isSubmitEnabled()},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__theme_icons__["C" /* IconInvite */],{className:classes.iconInviteUsers}),localize('users-popup-invite-all'))))));}},{key:"renderUserFields",value:function renderUserFields(){var _this4=this;var _this$props3=this.props,classes=_this$props3.classes,companyInviteUsers=_this$props3.companyInviteUsers;var items=companyInviteUsers.map(function(user){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{item:true,key:"invite-user-".concat(user.id),className:classes.userRow},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{container:true,direction:"row"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{item:true,className:classes.removeUserColumn},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["p" /* IconButton */],{className:classes.removeUserButon,disableRipple:true,component:"span",disabled:companyInviteUsers.length===1,"aria-label":"Close",onClick:function onClick(){return _this4.removeUser(user.id);}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__theme_icons__["_11" /* XIcon */],{className:classes.removeUserIcon}))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{item:true,className:classes.userEmailColumn},_this4.textField("userEmail_".concat(user.id),user.email,localize('users-popup-new-user-email-address'),false,'email')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{item:true,className:classes.userRoleColumn},_this4.selectField("userRole_".concat(user.id),user.role)),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{item:true,className:classes.userInfoColumn},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["L" /* Tooltip */],{placement:"top",title:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["M" /* Typography */],{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_14_classnames___default()(classes.infoTooltipText)},_this4.renderTooltipForRole(user.role)),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span",{className:classes.tooltipArrow})),classes:{tooltip:classes.infoTooltip}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["p" /* IconButton */],{className:classes.infoIconButton,color:"primary",component:"span",disableRipple:true},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__theme_icons__["N" /* Info */],null))))));});return companyInviteUsers.length>3?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_custom_scrollbars__["Scrollbars"],{ref:this.scrollbarRef,style:{height:215},autoHide:false,renderThumbVertical:function renderThumbVertical(_ref){var style=_ref.style,props=__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(_ref,["style"]);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({},props,{style:__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectSpread___default()({},style,{backgroundColor:'#6F99BD',opacity:0.5,borderRadius:3})}));}},items):items;}},{key:"isSubmitEnabled",value:function isSubmitEnabled(){if(this.props.companyInviteUsers.length===0)return;// check for input error
return Object.keys(this.getErrors()).length===0&&!this.props.companyInviteUsers.some(function(user){return user.email==='';})||// check for api error
Object.keys(this.getErrors()).length===1&&__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.get(this.state,'errors.apiError');}},{key:"getErrors",value:function getErrors(){var _this5=this;var errorState=this.state.errors;Object.keys(errorState).forEach(function(fieldName){if(fieldName.indexOf('userEmail')!==-1){var userId=parseInt(fieldName.split('_')[1]);var userFound=_this5.props.companyInviteUsers.find(function(user){return user.id===userId;});if(!userFound){delete errorState[fieldName];}}});return errorState;}},{key:"hasFormError",value:function hasFormError(errorState){var result=false;Object.keys(errorState).forEach(function(fieldName){if(fieldName.indexOf('invitationMessage')!==-1||fieldName.indexOf('userEmail')!==-1){result=true;}});return result;}},{key:"componentDidMount",value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_31_lib_Segment_customTrackers__["g" /* trackAddUsersPopupShown */])(Object(__WEBPACK_IMPORTED_MODULE_32_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));this.validateAll(null,null,true);if(this.props.showApiError&&(this.props.companies.estimateCostOnAddCompanyUsersErrorId||this.props.companies.addCompanyUsersErrorId)){this.handleApiErrors(this.props);}}},{key:"componentDidUpdate",value:function componentDidUpdate(){if(this.state.willIncreaseUserNumber){if(this.scrollbarRef&&this.scrollbarRef.current){this.scrollbarRef.current.scrollToBottom();}}}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var prevIds=this.props.companyInviteUsers.map(function(item){return item.id;});var newdIds=nextProps.companyInviteUsers.map(function(item){return item.id;});if(nextProps.companyInviteUsers.length&&JSON.stringify(prevIds)!==JSON.stringify(newdIds)||nextProps.companyInviteMessage&&this.state.errors['invitationMessage']){this.validateAll(nextProps.companies.inviteUsers,nextProps.companyInviteMessage);}this.setState({willIncreaseUserNumber:nextProps.companyInviteUsers.length>this.props.companyInviteUsers.length});if(this.props.companies.estimateCostOnAddCompanyUsersErrorId!==nextProps.companies.estimateCostOnAddCompanyUsersErrorId||this.props.companies.addCompanyUsersErrorId!==nextProps.companies.addCompanyUsersErrorId){this.handleApiErrors(nextProps);}}},{key:"handleApiErrors",value:function handleApiErrors(propsSource){if(propsSource.companies.estimateCostOnAddCompanyUsersErrorId||propsSource.companies.addCompanyUsersErrorId){var errorMessage;errorMessage=propsSource.companies.estimateCostOnAddCompanyUsersErrorId&&errors[propsSource.companies.estimateCostOnAddCompanyUsersErrorId]||propsSource.companies.addCompanyUsersErrorId&&errors[propsSource.companies.addCompanyUsersErrorId]||localize('users-batch-add-error-unknown');this.setState({xhrInProgress:false,apiValidationError:true,errors:{apiError:errorMessage}});}}},{key:"textField",value:function textField(name,value,placeholder,disabled,type,maxLength,autosize){var _this6=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__FormField__["a" /* default */],__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({value:value,autoComplete:__WEBPACK_IMPORTED_MODULE_17__utils_browser__["b" /* isChrome */]?'disabled':'off',className:classes.field,"data-tid":"form-user-".concat(name),onChange:function onChange(event){return _this6.onTextFieldChange(event,name);},onBlur:function onBlur(event){return _this6.onTextFieldBlur(event,name);},onKeyPress:function onKeyPress(event){return _this6.onKeyPress(event,name);},id:name,placeholder:placeholder},type?{type:type}:{},autosize?{autosize:autosize}:{},{margin:"normal",helperText:this.state.errors[name],error:!!this.state.errors[name],disabled:disabled,maxLength:maxLength,inputRef:this[name]}));}},{key:"selectField",value:function selectField(name,role){var _this7=this;var classes=this.props.classes;var availableRoles;if(this.props.allowedRoles){availableRoles=PERMISSION_ROLE.filter(function(item){return _this7.props.allowedRoles.includes(item.key);});}else{availableRoles=PERMISSION_ROLE;}return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_Features_components__["b" /* Select */],{id:name,"data-tid":name,name:name,onChange:function onChange(event){return _this7.onSelectFieldChange(event,name);},className:classes.roleSelect,disableUnderline:true,fullWidth:true,classes:{select:classes.selectElement,icon:classes.selectElementIcon},MenuProps:{classes:{paper:classes.selectElementPaper}},IconComponent:__WEBPACK_IMPORTED_MODULE_22__material_ui_icons_KeyboardArrowDown___default.a,value:role},availableRoles.map(function(option){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["x" /* MenuItem */],{key:option.key,value:option.key,className:classes.selectElementItem},option.value);}));}},{key:"onTextFieldChange",value:function onTextFieldChange(event,name){if(name.indexOf('userEmail')!==-1){var userId=parseInt(name.split('_')[1]);var relatedUser=this.props.companyInviteUsers.find(function(user){return user.id===userId;});relatedUser.email=event.target.value;this.props.inviteUserUpdate(relatedUser);this.state.errors[name]&&this.validateEmail(name,event.target.value);}else if(name.indexOf('invitationMessage')!==-1){this.props.inviteUserSetMessage(event.target.value);this.state.errors[name]&&this.validateMessage(name,event.target.value);}}},{key:"validateAll",value:function validateAll(users,message,isPopupLoad){var _this8=this;var messageToValidate=message||this.props.companyInviteMessage;messageToValidate&&this.validateMessage('invitationMessage',messageToValidate);var usersToValidate=users||this.props.companyInviteUsers;if(usersToValidate.length===1&&usersToValidate[0].email==='')return;usersToValidate.forEach(function(user,index){if(index===usersToValidate.length-1&&user.email===''&&!isPopupLoad)return;_this8.validateEmail("userEmail_".concat(user.id),user.email,usersToValidate);});}},{key:"onTextFieldBlur",value:function onTextFieldBlur(event,name){if(name.indexOf('userEmail')!==-1){this.validateEmail(name,event.target.value);}else if(name.indexOf('invitationMessage')!==-1){this.validateMessage(name,event.target.value);}}},{key:"validateEmail",value:function validateEmail(name,value,companyInviteUsers){var _this$props$companies=this.props.companies,rawDataById=_this$props$companies.rawDataById,selectedId=_this$props$companies.selectedId;var company=rawDataById[selectedId];var users=company.users;var userId=parseInt(name.split('_')[1]);var companyInviteUsersToValidate=companyInviteUsers||this.props.companyInviteUsers;var error;if(!__WEBPACK_IMPORTED_MODULE_24__theme_uiConfig__["b" /* emailValidationPattern */].test(value)){error=ERROR_MESSAGES.INVALID_EMAIL;}else if(Object(__WEBPACK_IMPORTED_MODULE_16__utils_users__["c" /* doesUserExist */])(users,value)){error=ERROR_MESSAGES.USER_ALREADY_EXISTS;}else if(Object(__WEBPACK_IMPORTED_MODULE_16__utils_users__["h" /* isDuplicateEntry */])(companyInviteUsersToValidate,value,userId)){error=ERROR_MESSAGES.USER_ALREADY_EXISTS_IN_INVITE_LIST;}var errorState=this.getErrors();if(error){errorState[name]=error;}else{errorState[name]&&delete errorState[name];}this.setState({errors:errorState});}},{key:"validateMessage",value:function validateMessage(name,value){var errorState=this.getErrors();var error=value&&value.replace(/\s+/g,'').length===0?ERROR_MESSAGES.USER_MESSAGE_EMPTY:'';if(error){errorState[name]=error;}else{errorState[name]&&delete errorState[name];}this.setState({errors:errorState});}},{key:"onSelectFieldChange",value:function onSelectFieldChange(event,name){if(name.indexOf('userRole')!==-1){var userId=parseInt(name.split('_')[1]);var relatedUser=this.props.companyInviteUsers.find(function(user){return user.id===userId;});relatedUser.role=event.target.value;this.props.inviteUserUpdate(relatedUser);}}},{key:"setFieldState",value:function setFieldState(fieldName,value){this.setState(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({},fieldName,value));}},{key:"onKeyPress",value:function onKeyPress(event,name){if(!this.isSubmitEnabled()||name==='invitationMessage')return;if(event.key==='Enter'){this.submitForm();}}},{key:"submitForm",value:function submitForm(){this.setState({xhrInProgress:true,apiValidationError:false});this.props.handleAddUsers(this.props.companyInviteUsers,this.props.companyInviteMessage);}},{key:"handleAddAnotherUser",value:function handleAddAnotherUser(){this.props.inviteUserAdd(this.getUserPlaceholder());}},{key:"removeUser",value:function removeUser(id){this.props.inviteUserRemove(id);}},{key:"getUserPlaceholder",value:function getUserPlaceholder(email){var defaultUser;if(this.props.allowedRoles){if(this.props.allowedRoles.includes(__WEBPACK_IMPORTED_MODULE_30__config__["_55" /* USER_ROLE_BASIC */])){defaultUser=__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.clone(EMPTY_USER_MEMBER);}else if(this.props.allowedRoles.includes(__WEBPACK_IMPORTED_MODULE_30__config__["_56" /* USER_ROLE_GUEST */])){defaultUser=__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.clone(EMPTY_USER_GUEST);}}else{defaultUser=__WEBPACK_IMPORTED_MODULE_28_lodash___default.a.clone(EMPTY_USER_MEMBER);}email&&(defaultUser.email=email);defaultUser.id=new Date().getTime();return defaultUser;}},{key:"renderTooltipForRole",value:function renderTooltipForRole(role){if(role===__WEBPACK_IMPORTED_MODULE_30__config__["_54" /* USER_ROLE_ADMIN */]){return localize('users-roles-popover-admin-description');}else if(role===__WEBPACK_IMPORTED_MODULE_30__config__["_55" /* USER_ROLE_BASIC */]){return localize('users-roles-popover-member-description');}else if(role===__WEBPACK_IMPORTED_MODULE_30__config__["_56" /* USER_ROLE_GUEST */]){return localize('users-roles-popover-guest-description');}}}]);return InviteUserModal;}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]))||_class);InviteUserModal.propTypes={companies:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.object,modalShown:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.bool,hideModal:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.func,resetModal:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.func,classes:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.object,email:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.string,inviteUserAdd:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.func,inviteUserUpdate:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.func,inviteUserRemove:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.func,inviteUserSetMessage:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.func,companyInviteUsers:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.array,companyInviteMessage:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.string,handleAddUsers:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.func,showApiError:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.bool,company:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.object,allowedRoles:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.array,upgradeInfoMessage:__WEBPACK_IMPORTED_MODULE_25_prop_types___default.a.string};var mapStateToProps=function mapStateToProps(state){return{company:state.companies.rawDataById?state.companies.rawDataById[state.companies.selectedId]:null,modalShown:state.modal.modalShown,companies:state.companies,companyInviteUsers:state.companies.inviteUsers,companyInviteMessage:state.companies.inviteUsersMessage};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_12_redux__["b" /* bindActionCreators */])({hideModal:__WEBPACK_IMPORTED_MODULE_18_redux_modules_modal__["b" /* hideModal */],resetModal:__WEBPACK_IMPORTED_MODULE_18_redux_modules_modal__["c" /* resetModal */],inviteUserAdd:__WEBPACK_IMPORTED_MODULE_19_redux_modules_companies__["v" /* inviteUserAdd */],inviteUserUpdate:__WEBPACK_IMPORTED_MODULE_19_redux_modules_companies__["y" /* inviteUserUpdate */],inviteUserRemove:__WEBPACK_IMPORTED_MODULE_19_redux_modules_companies__["w" /* inviteUserRemove */],inviteUserSetMessage:__WEBPACK_IMPORTED_MODULE_19_redux_modules_companies__["x" /* inviteUserSetMessage */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(InviteUserModal));

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _raf2 = __webpack_require__(1164);

var _raf3 = _interopRequireDefault(_raf2);

var _domCss = __webpack_require__(454);

var _domCss2 = _interopRequireDefault(_domCss);

var _react = __webpack_require__(1);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isString = __webpack_require__(1171);

var _isString2 = _interopRequireDefault(_isString);

var _getScrollbarWidth = __webpack_require__(1172);

var _getScrollbarWidth2 = _interopRequireDefault(_getScrollbarWidth);

var _returnFalse = __webpack_require__(1173);

var _returnFalse2 = _interopRequireDefault(_returnFalse);

var _getInnerWidth = __webpack_require__(1174);

var _getInnerWidth2 = _interopRequireDefault(_getInnerWidth);

var _getInnerHeight = __webpack_require__(1175);

var _getInnerHeight2 = _interopRequireDefault(_getInnerHeight);

var _styles = __webpack_require__(1176);

var _defaultRenderElements = __webpack_require__(1177);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Scrollbars = function (_Component) {
    _inherits(Scrollbars, _Component);

    function Scrollbars(props) {
        var _ref;

        _classCallCheck(this, Scrollbars);

        for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            rest[_key - 1] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = Scrollbars.__proto__ || Object.getPrototypeOf(Scrollbars)).call.apply(_ref, [this, props].concat(rest)));

        _this.getScrollLeft = _this.getScrollLeft.bind(_this);
        _this.getScrollTop = _this.getScrollTop.bind(_this);
        _this.getScrollWidth = _this.getScrollWidth.bind(_this);
        _this.getScrollHeight = _this.getScrollHeight.bind(_this);
        _this.getClientWidth = _this.getClientWidth.bind(_this);
        _this.getClientHeight = _this.getClientHeight.bind(_this);
        _this.getValues = _this.getValues.bind(_this);
        _this.getThumbHorizontalWidth = _this.getThumbHorizontalWidth.bind(_this);
        _this.getThumbVerticalHeight = _this.getThumbVerticalHeight.bind(_this);
        _this.getScrollLeftForOffset = _this.getScrollLeftForOffset.bind(_this);
        _this.getScrollTopForOffset = _this.getScrollTopForOffset.bind(_this);

        _this.scrollLeft = _this.scrollLeft.bind(_this);
        _this.scrollTop = _this.scrollTop.bind(_this);
        _this.scrollToLeft = _this.scrollToLeft.bind(_this);
        _this.scrollToTop = _this.scrollToTop.bind(_this);
        _this.scrollToRight = _this.scrollToRight.bind(_this);
        _this.scrollToBottom = _this.scrollToBottom.bind(_this);

        _this.handleTrackMouseEnter = _this.handleTrackMouseEnter.bind(_this);
        _this.handleTrackMouseLeave = _this.handleTrackMouseLeave.bind(_this);
        _this.handleHorizontalTrackMouseDown = _this.handleHorizontalTrackMouseDown.bind(_this);
        _this.handleVerticalTrackMouseDown = _this.handleVerticalTrackMouseDown.bind(_this);
        _this.handleHorizontalThumbMouseDown = _this.handleHorizontalThumbMouseDown.bind(_this);
        _this.handleVerticalThumbMouseDown = _this.handleVerticalThumbMouseDown.bind(_this);
        _this.handleWindowResize = _this.handleWindowResize.bind(_this);
        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.handleDrag = _this.handleDrag.bind(_this);
        _this.handleDragEnd = _this.handleDragEnd.bind(_this);

        _this.state = {
            didMountUniversal: false
        };
        return _this;
    }

    _createClass(Scrollbars, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.addListeners();
            this.update();
            this.componentDidMountUniversal();
        }
    }, {
        key: 'componentDidMountUniversal',
        value: function componentDidMountUniversal() {
            // eslint-disable-line react/sort-comp
            var universal = this.props.universal;

            if (!universal) return;
            this.setState({ didMountUniversal: true });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.update();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.removeListeners();
            (0, _raf2.cancel)(this.requestFrame);
            clearTimeout(this.hideTracksTimeout);
            clearInterval(this.detectScrollingInterval);
        }
    }, {
        key: 'getScrollLeft',
        value: function getScrollLeft() {
            if (!this.view) return 0;
            return this.view.scrollLeft;
        }
    }, {
        key: 'getScrollTop',
        value: function getScrollTop() {
            if (!this.view) return 0;
            return this.view.scrollTop;
        }
    }, {
        key: 'getScrollWidth',
        value: function getScrollWidth() {
            if (!this.view) return 0;
            return this.view.scrollWidth;
        }
    }, {
        key: 'getScrollHeight',
        value: function getScrollHeight() {
            if (!this.view) return 0;
            return this.view.scrollHeight;
        }
    }, {
        key: 'getClientWidth',
        value: function getClientWidth() {
            if (!this.view) return 0;
            return this.view.clientWidth;
        }
    }, {
        key: 'getClientHeight',
        value: function getClientHeight() {
            if (!this.view) return 0;
            return this.view.clientHeight;
        }
    }, {
        key: 'getValues',
        value: function getValues() {
            var _ref2 = this.view || {},
                _ref2$scrollLeft = _ref2.scrollLeft,
                scrollLeft = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft,
                _ref2$scrollTop = _ref2.scrollTop,
                scrollTop = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop,
                _ref2$scrollWidth = _ref2.scrollWidth,
                scrollWidth = _ref2$scrollWidth === undefined ? 0 : _ref2$scrollWidth,
                _ref2$scrollHeight = _ref2.scrollHeight,
                scrollHeight = _ref2$scrollHeight === undefined ? 0 : _ref2$scrollHeight,
                _ref2$clientWidth = _ref2.clientWidth,
                clientWidth = _ref2$clientWidth === undefined ? 0 : _ref2$clientWidth,
                _ref2$clientHeight = _ref2.clientHeight,
                clientHeight = _ref2$clientHeight === undefined ? 0 : _ref2$clientHeight;

            return {
                left: scrollLeft / (scrollWidth - clientWidth) || 0,
                top: scrollTop / (scrollHeight - clientHeight) || 0,
                scrollLeft: scrollLeft,
                scrollTop: scrollTop,
                scrollWidth: scrollWidth,
                scrollHeight: scrollHeight,
                clientWidth: clientWidth,
                clientHeight: clientHeight
            };
        }
    }, {
        key: 'getThumbHorizontalWidth',
        value: function getThumbHorizontalWidth() {
            var _props = this.props,
                thumbSize = _props.thumbSize,
                thumbMinSize = _props.thumbMinSize;
            var _view = this.view,
                scrollWidth = _view.scrollWidth,
                clientWidth = _view.clientWidth;

            var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
            var width = Math.ceil(clientWidth / scrollWidth * trackWidth);
            if (trackWidth === width) return 0;
            if (thumbSize) return thumbSize;
            return Math.max(width, thumbMinSize);
        }
    }, {
        key: 'getThumbVerticalHeight',
        value: function getThumbVerticalHeight() {
            var _props2 = this.props,
                thumbSize = _props2.thumbSize,
                thumbMinSize = _props2.thumbMinSize;
            var _view2 = this.view,
                scrollHeight = _view2.scrollHeight,
                clientHeight = _view2.clientHeight;

            var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
            var height = Math.ceil(clientHeight / scrollHeight * trackHeight);
            if (trackHeight === height) return 0;
            if (thumbSize) return thumbSize;
            return Math.max(height, thumbMinSize);
        }
    }, {
        key: 'getScrollLeftForOffset',
        value: function getScrollLeftForOffset(offset) {
            var _view3 = this.view,
                scrollWidth = _view3.scrollWidth,
                clientWidth = _view3.clientWidth;

            var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
            var thumbWidth = this.getThumbHorizontalWidth();
            return offset / (trackWidth - thumbWidth) * (scrollWidth - clientWidth);
        }
    }, {
        key: 'getScrollTopForOffset',
        value: function getScrollTopForOffset(offset) {
            var _view4 = this.view,
                scrollHeight = _view4.scrollHeight,
                clientHeight = _view4.clientHeight;

            var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
            var thumbHeight = this.getThumbVerticalHeight();
            return offset / (trackHeight - thumbHeight) * (scrollHeight - clientHeight);
        }
    }, {
        key: 'scrollLeft',
        value: function scrollLeft() {
            var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            if (!this.view) return;
            this.view.scrollLeft = left;
        }
    }, {
        key: 'scrollTop',
        value: function scrollTop() {
            var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            if (!this.view) return;
            this.view.scrollTop = top;
        }
    }, {
        key: 'scrollToLeft',
        value: function scrollToLeft() {
            if (!this.view) return;
            this.view.scrollLeft = 0;
        }
    }, {
        key: 'scrollToTop',
        value: function scrollToTop() {
            if (!this.view) return;
            this.view.scrollTop = 0;
        }
    }, {
        key: 'scrollToRight',
        value: function scrollToRight() {
            if (!this.view) return;
            this.view.scrollLeft = this.view.scrollWidth;
        }
    }, {
        key: 'scrollToBottom',
        value: function scrollToBottom() {
            if (!this.view) return;
            this.view.scrollTop = this.view.scrollHeight;
        }
    }, {
        key: 'addListeners',
        value: function addListeners() {
            /* istanbul ignore if */
            if (typeof document === 'undefined' || !this.view) return;
            var view = this.view,
                trackHorizontal = this.trackHorizontal,
                trackVertical = this.trackVertical,
                thumbHorizontal = this.thumbHorizontal,
                thumbVertical = this.thumbVertical;

            view.addEventListener('scroll', this.handleScroll);
            if (!(0, _getScrollbarWidth2["default"])()) return;
            trackHorizontal.addEventListener('mouseenter', this.handleTrackMouseEnter);
            trackHorizontal.addEventListener('mouseleave', this.handleTrackMouseLeave);
            trackHorizontal.addEventListener('mousedown', this.handleHorizontalTrackMouseDown);
            trackVertical.addEventListener('mouseenter', this.handleTrackMouseEnter);
            trackVertical.addEventListener('mouseleave', this.handleTrackMouseLeave);
            trackVertical.addEventListener('mousedown', this.handleVerticalTrackMouseDown);
            thumbHorizontal.addEventListener('mousedown', this.handleHorizontalThumbMouseDown);
            thumbVertical.addEventListener('mousedown', this.handleVerticalThumbMouseDown);
            window.addEventListener('resize', this.handleWindowResize);
        }
    }, {
        key: 'removeListeners',
        value: function removeListeners() {
            /* istanbul ignore if */
            if (typeof document === 'undefined' || !this.view) return;
            var view = this.view,
                trackHorizontal = this.trackHorizontal,
                trackVertical = this.trackVertical,
                thumbHorizontal = this.thumbHorizontal,
                thumbVertical = this.thumbVertical;

            view.removeEventListener('scroll', this.handleScroll);
            if (!(0, _getScrollbarWidth2["default"])()) return;
            trackHorizontal.removeEventListener('mouseenter', this.handleTrackMouseEnter);
            trackHorizontal.removeEventListener('mouseleave', this.handleTrackMouseLeave);
            trackHorizontal.removeEventListener('mousedown', this.handleHorizontalTrackMouseDown);
            trackVertical.removeEventListener('mouseenter', this.handleTrackMouseEnter);
            trackVertical.removeEventListener('mouseleave', this.handleTrackMouseLeave);
            trackVertical.removeEventListener('mousedown', this.handleVerticalTrackMouseDown);
            thumbHorizontal.removeEventListener('mousedown', this.handleHorizontalThumbMouseDown);
            thumbVertical.removeEventListener('mousedown', this.handleVerticalThumbMouseDown);
            window.removeEventListener('resize', this.handleWindowResize);
            // Possibly setup by `handleDragStart`
            this.teardownDragging();
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll(event) {
            var _this2 = this;

            var _props3 = this.props,
                onScroll = _props3.onScroll,
                onScrollFrame = _props3.onScrollFrame;

            if (onScroll) onScroll(event);
            this.update(function (values) {
                var scrollLeft = values.scrollLeft,
                    scrollTop = values.scrollTop;

                _this2.viewScrollLeft = scrollLeft;
                _this2.viewScrollTop = scrollTop;
                if (onScrollFrame) onScrollFrame(values);
            });
            this.detectScrolling();
        }
    }, {
        key: 'handleScrollStart',
        value: function handleScrollStart() {
            var onScrollStart = this.props.onScrollStart;

            if (onScrollStart) onScrollStart();
            this.handleScrollStartAutoHide();
        }
    }, {
        key: 'handleScrollStartAutoHide',
        value: function handleScrollStartAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.showTracks();
        }
    }, {
        key: 'handleScrollStop',
        value: function handleScrollStop() {
            var onScrollStop = this.props.onScrollStop;

            if (onScrollStop) onScrollStop();
            this.handleScrollStopAutoHide();
        }
    }, {
        key: 'handleScrollStopAutoHide',
        value: function handleScrollStopAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.hideTracks();
        }
    }, {
        key: 'handleWindowResize',
        value: function handleWindowResize() {
            this.update();
        }
    }, {
        key: 'handleHorizontalTrackMouseDown',
        value: function handleHorizontalTrackMouseDown(event) {
            event.preventDefault();
            var target = event.target,
                clientX = event.clientX;

            var _target$getBoundingCl = target.getBoundingClientRect(),
                targetLeft = _target$getBoundingCl.left;

            var thumbWidth = this.getThumbHorizontalWidth();
            var offset = Math.abs(targetLeft - clientX) - thumbWidth / 2;
            this.view.scrollLeft = this.getScrollLeftForOffset(offset);
        }
    }, {
        key: 'handleVerticalTrackMouseDown',
        value: function handleVerticalTrackMouseDown(event) {
            event.preventDefault();
            var target = event.target,
                clientY = event.clientY;

            var _target$getBoundingCl2 = target.getBoundingClientRect(),
                targetTop = _target$getBoundingCl2.top;

            var thumbHeight = this.getThumbVerticalHeight();
            var offset = Math.abs(targetTop - clientY) - thumbHeight / 2;
            this.view.scrollTop = this.getScrollTopForOffset(offset);
        }
    }, {
        key: 'handleHorizontalThumbMouseDown',
        value: function handleHorizontalThumbMouseDown(event) {
            event.preventDefault();
            this.handleDragStart(event);
            var target = event.target,
                clientX = event.clientX;
            var offsetWidth = target.offsetWidth;

            var _target$getBoundingCl3 = target.getBoundingClientRect(),
                left = _target$getBoundingCl3.left;

            this.prevPageX = offsetWidth - (clientX - left);
        }
    }, {
        key: 'handleVerticalThumbMouseDown',
        value: function handleVerticalThumbMouseDown(event) {
            event.preventDefault();
            this.handleDragStart(event);
            var target = event.target,
                clientY = event.clientY;
            var offsetHeight = target.offsetHeight;

            var _target$getBoundingCl4 = target.getBoundingClientRect(),
                top = _target$getBoundingCl4.top;

            this.prevPageY = offsetHeight - (clientY - top);
        }
    }, {
        key: 'setupDragging',
        value: function setupDragging() {
            (0, _domCss2["default"])(document.body, _styles.disableSelectStyle);
            document.addEventListener('mousemove', this.handleDrag);
            document.addEventListener('mouseup', this.handleDragEnd);
            document.onselectstart = _returnFalse2["default"];
        }
    }, {
        key: 'teardownDragging',
        value: function teardownDragging() {
            (0, _domCss2["default"])(document.body, _styles.disableSelectStyleReset);
            document.removeEventListener('mousemove', this.handleDrag);
            document.removeEventListener('mouseup', this.handleDragEnd);
            document.onselectstart = undefined;
        }
    }, {
        key: 'handleDragStart',
        value: function handleDragStart(event) {
            this.dragging = true;
            event.stopImmediatePropagation();
            this.setupDragging();
        }
    }, {
        key: 'handleDrag',
        value: function handleDrag(event) {
            if (this.prevPageX) {
                var clientX = event.clientX;

                var _trackHorizontal$getB = this.trackHorizontal.getBoundingClientRect(),
                    trackLeft = _trackHorizontal$getB.left;

                var thumbWidth = this.getThumbHorizontalWidth();
                var clickPosition = thumbWidth - this.prevPageX;
                var offset = -trackLeft + clientX - clickPosition;
                this.view.scrollLeft = this.getScrollLeftForOffset(offset);
            }
            if (this.prevPageY) {
                var clientY = event.clientY;

                var _trackVertical$getBou = this.trackVertical.getBoundingClientRect(),
                    trackTop = _trackVertical$getBou.top;

                var thumbHeight = this.getThumbVerticalHeight();
                var _clickPosition = thumbHeight - this.prevPageY;
                var _offset = -trackTop + clientY - _clickPosition;
                this.view.scrollTop = this.getScrollTopForOffset(_offset);
            }
            return false;
        }
    }, {
        key: 'handleDragEnd',
        value: function handleDragEnd() {
            this.dragging = false;
            this.prevPageX = this.prevPageY = 0;
            this.teardownDragging();
            this.handleDragEndAutoHide();
        }
    }, {
        key: 'handleDragEndAutoHide',
        value: function handleDragEndAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.hideTracks();
        }
    }, {
        key: 'handleTrackMouseEnter',
        value: function handleTrackMouseEnter() {
            this.trackMouseOver = true;
            this.handleTrackMouseEnterAutoHide();
        }
    }, {
        key: 'handleTrackMouseEnterAutoHide',
        value: function handleTrackMouseEnterAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.showTracks();
        }
    }, {
        key: 'handleTrackMouseLeave',
        value: function handleTrackMouseLeave() {
            this.trackMouseOver = false;
            this.handleTrackMouseLeaveAutoHide();
        }
    }, {
        key: 'handleTrackMouseLeaveAutoHide',
        value: function handleTrackMouseLeaveAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.hideTracks();
        }
    }, {
        key: 'showTracks',
        value: function showTracks() {
            clearTimeout(this.hideTracksTimeout);
            (0, _domCss2["default"])(this.trackHorizontal, { opacity: 1 });
            (0, _domCss2["default"])(this.trackVertical, { opacity: 1 });
        }
    }, {
        key: 'hideTracks',
        value: function hideTracks() {
            var _this3 = this;

            if (this.dragging) return;
            if (this.scrolling) return;
            if (this.trackMouseOver) return;
            var autoHideTimeout = this.props.autoHideTimeout;

            clearTimeout(this.hideTracksTimeout);
            this.hideTracksTimeout = setTimeout(function () {
                (0, _domCss2["default"])(_this3.trackHorizontal, { opacity: 0 });
                (0, _domCss2["default"])(_this3.trackVertical, { opacity: 0 });
            }, autoHideTimeout);
        }
    }, {
        key: 'detectScrolling',
        value: function detectScrolling() {
            var _this4 = this;

            if (this.scrolling) return;
            this.scrolling = true;
            this.handleScrollStart();
            this.detectScrollingInterval = setInterval(function () {
                if (_this4.lastViewScrollLeft === _this4.viewScrollLeft && _this4.lastViewScrollTop === _this4.viewScrollTop) {
                    clearInterval(_this4.detectScrollingInterval);
                    _this4.scrolling = false;
                    _this4.handleScrollStop();
                }
                _this4.lastViewScrollLeft = _this4.viewScrollLeft;
                _this4.lastViewScrollTop = _this4.viewScrollTop;
            }, 100);
        }
    }, {
        key: 'raf',
        value: function raf(callback) {
            var _this5 = this;

            if (this.requestFrame) _raf3["default"].cancel(this.requestFrame);
            this.requestFrame = (0, _raf3["default"])(function () {
                _this5.requestFrame = undefined;
                callback();
            });
        }
    }, {
        key: 'update',
        value: function update(callback) {
            var _this6 = this;

            this.raf(function () {
                return _this6._update(callback);
            });
        }
    }, {
        key: '_update',
        value: function _update(callback) {
            var _props4 = this.props,
                onUpdate = _props4.onUpdate,
                hideTracksWhenNotNeeded = _props4.hideTracksWhenNotNeeded;

            var values = this.getValues();
            if ((0, _getScrollbarWidth2["default"])()) {
                var scrollLeft = values.scrollLeft,
                    clientWidth = values.clientWidth,
                    scrollWidth = values.scrollWidth;

                var trackHorizontalWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
                var thumbHorizontalWidth = this.getThumbHorizontalWidth();
                var thumbHorizontalX = scrollLeft / (scrollWidth - clientWidth) * (trackHorizontalWidth - thumbHorizontalWidth);
                var thumbHorizontalStyle = {
                    width: thumbHorizontalWidth,
                    transform: 'translateX(' + thumbHorizontalX + 'px)'
                };
                var scrollTop = values.scrollTop,
                    clientHeight = values.clientHeight,
                    scrollHeight = values.scrollHeight;

                var trackVerticalHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
                var thumbVerticalHeight = this.getThumbVerticalHeight();
                var thumbVerticalY = scrollTop / (scrollHeight - clientHeight) * (trackVerticalHeight - thumbVerticalHeight);
                var thumbVerticalStyle = {
                    height: thumbVerticalHeight,
                    transform: 'translateY(' + thumbVerticalY + 'px)'
                };
                if (hideTracksWhenNotNeeded) {
                    var trackHorizontalStyle = {
                        visibility: scrollWidth > clientWidth ? 'visible' : 'hidden'
                    };
                    var trackVerticalStyle = {
                        visibility: scrollHeight > clientHeight ? 'visible' : 'hidden'
                    };
                    (0, _domCss2["default"])(this.trackHorizontal, trackHorizontalStyle);
                    (0, _domCss2["default"])(this.trackVertical, trackVerticalStyle);
                }
                (0, _domCss2["default"])(this.thumbHorizontal, thumbHorizontalStyle);
                (0, _domCss2["default"])(this.thumbVertical, thumbVerticalStyle);
            }
            if (onUpdate) onUpdate(values);
            if (typeof callback !== 'function') return;
            callback(values);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this7 = this;

            var scrollbarWidth = (0, _getScrollbarWidth2["default"])();
            /* eslint-disable no-unused-vars */

            var _props5 = this.props,
                onScroll = _props5.onScroll,
                onScrollFrame = _props5.onScrollFrame,
                onScrollStart = _props5.onScrollStart,
                onScrollStop = _props5.onScrollStop,
                onUpdate = _props5.onUpdate,
                renderView = _props5.renderView,
                renderTrackHorizontal = _props5.renderTrackHorizontal,
                renderTrackVertical = _props5.renderTrackVertical,
                renderThumbHorizontal = _props5.renderThumbHorizontal,
                renderThumbVertical = _props5.renderThumbVertical,
                tagName = _props5.tagName,
                hideTracksWhenNotNeeded = _props5.hideTracksWhenNotNeeded,
                autoHide = _props5.autoHide,
                autoHideTimeout = _props5.autoHideTimeout,
                autoHideDuration = _props5.autoHideDuration,
                thumbSize = _props5.thumbSize,
                thumbMinSize = _props5.thumbMinSize,
                universal = _props5.universal,
                autoHeight = _props5.autoHeight,
                autoHeightMin = _props5.autoHeightMin,
                autoHeightMax = _props5.autoHeightMax,
                style = _props5.style,
                children = _props5.children,
                props = _objectWithoutProperties(_props5, ['onScroll', 'onScrollFrame', 'onScrollStart', 'onScrollStop', 'onUpdate', 'renderView', 'renderTrackHorizontal', 'renderTrackVertical', 'renderThumbHorizontal', 'renderThumbVertical', 'tagName', 'hideTracksWhenNotNeeded', 'autoHide', 'autoHideTimeout', 'autoHideDuration', 'thumbSize', 'thumbMinSize', 'universal', 'autoHeight', 'autoHeightMin', 'autoHeightMax', 'style', 'children']);
            /* eslint-enable no-unused-vars */

            var didMountUniversal = this.state.didMountUniversal;


            var containerStyle = _extends({}, _styles.containerStyleDefault, autoHeight && _extends({}, _styles.containerStyleAutoHeight, {
                minHeight: autoHeightMin,
                maxHeight: autoHeightMax
            }), style);

            var viewStyle = _extends({}, _styles.viewStyleDefault, {
                // Hide scrollbars by setting a negative margin
                marginRight: scrollbarWidth ? -scrollbarWidth : 0,
                marginBottom: scrollbarWidth ? -scrollbarWidth : 0
            }, autoHeight && _extends({}, _styles.viewStyleAutoHeight, {
                // Add scrollbarWidth to autoHeight in order to compensate negative margins
                minHeight: (0, _isString2["default"])(autoHeightMin) ? 'calc(' + autoHeightMin + ' + ' + scrollbarWidth + 'px)' : autoHeightMin + scrollbarWidth,
                maxHeight: (0, _isString2["default"])(autoHeightMax) ? 'calc(' + autoHeightMax + ' + ' + scrollbarWidth + 'px)' : autoHeightMax + scrollbarWidth
            }), autoHeight && universal && !didMountUniversal && {
                minHeight: autoHeightMin,
                maxHeight: autoHeightMax
            }, universal && !didMountUniversal && _styles.viewStyleUniversalInitial);

            var trackAutoHeightStyle = {
                transition: 'opacity ' + autoHideDuration + 'ms',
                opacity: 0
            };

            var trackHorizontalStyle = _extends({}, _styles.trackHorizontalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                display: 'none'
            });

            var trackVerticalStyle = _extends({}, _styles.trackVerticalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                display: 'none'
            });

            return (0, _react.createElement)(tagName, _extends({}, props, { style: containerStyle, ref: function ref(_ref3) {
                    _this7.container = _ref3;
                } }), [(0, _react.cloneElement)(renderView({ style: viewStyle }), { key: 'view', ref: function ref(_ref4) {
                    _this7.view = _ref4;
                } }, children), (0, _react.cloneElement)(renderTrackHorizontal({ style: trackHorizontalStyle }), { key: 'trackHorizontal', ref: function ref(_ref5) {
                    _this7.trackHorizontal = _ref5;
                } }, (0, _react.cloneElement)(renderThumbHorizontal({ style: _styles.thumbHorizontalStyleDefault }), { ref: function ref(_ref6) {
                    _this7.thumbHorizontal = _ref6;
                } })), (0, _react.cloneElement)(renderTrackVertical({ style: trackVerticalStyle }), { key: 'trackVertical', ref: function ref(_ref7) {
                    _this7.trackVertical = _ref7;
                } }, (0, _react.cloneElement)(renderThumbVertical({ style: _styles.thumbVerticalStyleDefault }), { ref: function ref(_ref8) {
                    _this7.thumbVertical = _ref8;
                } }))]);
        }
    }]);

    return Scrollbars;
}(_react.Component);

exports["default"] = Scrollbars;


Scrollbars.propTypes = {
    onScroll: _propTypes2["default"].func,
    onScrollFrame: _propTypes2["default"].func,
    onScrollStart: _propTypes2["default"].func,
    onScrollStop: _propTypes2["default"].func,
    onUpdate: _propTypes2["default"].func,
    renderView: _propTypes2["default"].func,
    renderTrackHorizontal: _propTypes2["default"].func,
    renderTrackVertical: _propTypes2["default"].func,
    renderThumbHorizontal: _propTypes2["default"].func,
    renderThumbVertical: _propTypes2["default"].func,
    tagName: _propTypes2["default"].string,
    thumbSize: _propTypes2["default"].number,
    thumbMinSize: _propTypes2["default"].number,
    hideTracksWhenNotNeeded: _propTypes2["default"].bool,
    autoHide: _propTypes2["default"].bool,
    autoHideTimeout: _propTypes2["default"].number,
    autoHideDuration: _propTypes2["default"].number,
    autoHeight: _propTypes2["default"].bool,
    autoHeightMin: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
    autoHeightMax: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
    universal: _propTypes2["default"].bool,
    style: _propTypes2["default"].object,
    children: _propTypes2["default"].node
};

Scrollbars.defaultProps = {
    renderView: _defaultRenderElements.renderViewDefault,
    renderTrackHorizontal: _defaultRenderElements.renderTrackHorizontalDefault,
    renderTrackVertical: _defaultRenderElements.renderTrackVerticalDefault,
    renderThumbHorizontal: _defaultRenderElements.renderThumbHorizontalDefault,
    renderThumbVertical: _defaultRenderElements.renderThumbVerticalDefault,
    tagName: 'div',
    thumbMinSize: 30,
    hideTracksWhenNotNeeded: false,
    autoHide: false,
    autoHideTimeout: 1000,
    autoHideDuration: 200,
    autoHeight: false,
    autoHeightMin: 0,
    autoHeightMax: 200,
    universal: false
};

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(1165)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(67)))

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(155)))

/***/ }),
/* 1166 */
/***/ (function(module, exports) {

var div = null
var prefixes = [ 'Webkit', 'Moz', 'O', 'ms' ]

module.exports = function prefixStyle (prop) {
  // re-use a dummy div
  if (!div) {
    div = document.createElement('div')
  }

  var style = div.style

  // prop exists without prefix
  if (prop in style) {
    return prop
  }

  // borderRadius -> BorderRadius
  var titleCase = prop.charAt(0).toUpperCase() + prop.slice(1)

  // find the vendor-prefixed prop
  for (var i = prefixes.length; i >= 0; i--) {
    var name = prefixes[i] + titleCase
    // e.g. WebkitBorderRadius or webkitBorderRadius
    if (name in style) {
      return name
    }
  }

  return false
}


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {


var space = __webpack_require__(1168)

/**
 * Export.
 */

module.exports = toCamelCase

/**
 * Convert a `string` to camel case.
 *
 * @param {String} string
 * @return {String}
 */

function toCamelCase(string) {
  return space(string).replace(/\s(\w)/g, function (matches, letter) {
    return letter.toUpperCase()
  })
}


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {


var clean = __webpack_require__(1169)

/**
 * Export.
 */

module.exports = toSpaceCase

/**
 * Convert a `string` to space case.
 *
 * @param {String} string
 * @return {String}
 */

function toSpaceCase(string) {
  return clean(string).replace(/[\W_]+(.|$)/g, function (matches, match) {
    return match ? ' ' + match : ''
  }).trim()
}


/***/ }),
/* 1169 */
/***/ (function(module, exports) {


/**
 * Export.
 */

module.exports = toNoCase

/**
 * Test whether a string is camel-case.
 */

var hasSpace = /\s/
var hasSeparator = /(_|-|\.|:)/
var hasCamel = /([a-z][A-Z]|[A-Z][a-z])/

/**
 * Remove any starting case from a `string`, like camel or snake, but keep
 * spaces and punctuation that may be important otherwise.
 *
 * @param {String} string
 * @return {String}
 */

function toNoCase(string) {
  if (hasSpace.test(string)) return string.toLowerCase()
  if (hasSeparator.test(string)) return (unseparate(string) || string).toLowerCase()
  if (hasCamel.test(string)) return uncamelize(string).toLowerCase()
  return string.toLowerCase()
}

/**
 * Separator splitter.
 */

var separatorSplitter = /[\W_]+(.|$)/g

/**
 * Un-separate a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function unseparate(string) {
  return string.replace(separatorSplitter, function (m, next) {
    return next ? ' ' + next : ''
  })
}

/**
 * Camelcase splitter.
 */

var camelSplitter = /(.)([A-Z]+)/g

/**
 * Un-camelcase a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function uncamelize(string) {
  return string.replace(camelSplitter, function (m, previous, uppers) {
    return previous + ' ' + uppers.toLowerCase().split('').join(' ')
  })
}


/***/ }),
/* 1170 */
/***/ (function(module, exports) {

/* The following list is defined in React's core */
var IS_UNITLESS = {
  animationIterationCount: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridColumn: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  stopOpacity: true,
  strokeDashoffset: true,
  strokeOpacity: true,
  strokeWidth: true
};

module.exports = function(name, value) {
  if(typeof value === 'number' && !IS_UNITLESS[ name ]) {
    return value + 'px';
  } else {
    return value;
  }
};

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = isString;
function isString(maybe) {
    return typeof maybe === 'string';
}

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getScrollbarWidth;

var _domCss = __webpack_require__(454);

var _domCss2 = _interopRequireDefault(_domCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var scrollbarWidth = false;

function getScrollbarWidth() {
    if (scrollbarWidth !== false) return scrollbarWidth;
    /* istanbul ignore else */
    if (typeof document !== 'undefined') {
        var div = document.createElement('div');
        (0, _domCss2["default"])(div, {
            width: 100,
            height: 100,
            position: 'absolute',
            top: -9999,
            overflow: 'scroll',
            MsOverflowStyle: 'scrollbar'
        });
        document.body.appendChild(div);
        scrollbarWidth = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    } else {
        scrollbarWidth = 0;
    }
    return scrollbarWidth || 0;
}

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = returnFalse;
function returnFalse() {
    return false;
}

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getInnerWidth;
function getInnerWidth(el) {
    var clientWidth = el.clientWidth;

    var _getComputedStyle = getComputedStyle(el),
        paddingLeft = _getComputedStyle.paddingLeft,
        paddingRight = _getComputedStyle.paddingRight;

    return clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
}

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getInnerHeight;
function getInnerHeight(el) {
    var clientHeight = el.clientHeight;

    var _getComputedStyle = getComputedStyle(el),
        paddingTop = _getComputedStyle.paddingTop,
        paddingBottom = _getComputedStyle.paddingBottom;

    return clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
}

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var containerStyleDefault = exports.containerStyleDefault = {
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: '100%'
};

// Overrides containerStyleDefault properties
var containerStyleAutoHeight = exports.containerStyleAutoHeight = {
    height: 'auto'
};

var viewStyleDefault = exports.viewStyleDefault = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'scroll',
    WebkitOverflowScrolling: 'touch'
};

// Overrides viewStyleDefault properties
var viewStyleAutoHeight = exports.viewStyleAutoHeight = {
    position: 'relative',
    top: undefined,
    left: undefined,
    right: undefined,
    bottom: undefined
};

var viewStyleUniversalInitial = exports.viewStyleUniversalInitial = {
    overflow: 'hidden',
    marginRight: 0,
    marginBottom: 0
};

var trackHorizontalStyleDefault = exports.trackHorizontalStyleDefault = {
    position: 'absolute',
    height: 6
};

var trackVerticalStyleDefault = exports.trackVerticalStyleDefault = {
    position: 'absolute',
    width: 6
};

var thumbHorizontalStyleDefault = exports.thumbHorizontalStyleDefault = {
    position: 'relative',
    display: 'block',
    height: '100%'
};

var thumbVerticalStyleDefault = exports.thumbVerticalStyleDefault = {
    position: 'relative',
    display: 'block',
    width: '100%'
};

var disableSelectStyle = exports.disableSelectStyle = {
    userSelect: 'none'
};

var disableSelectStyleReset = exports.disableSelectStyleReset = {
    userSelect: ''
};

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.renderViewDefault = renderViewDefault;
exports.renderTrackHorizontalDefault = renderTrackHorizontalDefault;
exports.renderTrackVerticalDefault = renderTrackVerticalDefault;
exports.renderThumbHorizontalDefault = renderThumbHorizontalDefault;
exports.renderThumbVerticalDefault = renderThumbVerticalDefault;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* eslint-disable react/prop-types */

function renderViewDefault(props) {
    return _react2["default"].createElement('div', props);
}

function renderTrackHorizontalDefault(_ref) {
    var style = _ref.style,
        props = _objectWithoutProperties(_ref, ['style']);

    var finalStyle = _extends({}, style, {
        right: 2,
        bottom: 2,
        left: 2,
        borderRadius: 3
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

function renderTrackVerticalDefault(_ref2) {
    var style = _ref2.style,
        props = _objectWithoutProperties(_ref2, ['style']);

    var finalStyle = _extends({}, style, {
        right: 2,
        bottom: 2,
        top: 2,
        borderRadius: 3
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

function renderThumbHorizontalDefault(_ref3) {
    var style = _ref3.style,
        props = _objectWithoutProperties(_ref3, ['style']);

    var finalStyle = _extends({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

function renderThumbVerticalDefault(_ref4) {
    var style = _ref4.style,
        props = _objectWithoutProperties(_ref4, ['style']);

    var finalStyle = _extends({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(203));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'Add');

exports.default = _default;

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_redux_modules_mls__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_FormHelperText__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__AddMlsConnectionModalSchema__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_redux_modules_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_redux_modules_companies__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_ReactSelect__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_redux_modules_account__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__FormField__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__theme_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_lib_Segment_customTrackers__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_lib_Segment_helpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_utils_intercom__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_utils_forms__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_utils_mls__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_i18n_i18n__ = __webpack_require__(15);
var _dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_34_i18n_i18n__["a" /* default */].loc.localize;var SCREEN_TYPE={MLS_API:'MLS_API',MLS_CUSTOM:'MLS_CUSTOM',MLS_AGENT_ID_REVIEW_NEEDED:'MLS_AGENT_ID_REVIEW_NEEDED',MLS_OFFICE_ID_REVIEW_NEEDED:'MLS_OFFICE_ID_REVIEW_NEEDED'};var CONNECT_WITH={MLS_OFFICE_ID:'MLS_OFFICE_ID',AGENT_MLS_ID:'AGENT_MLS_ID'};var styles=function styles(theme){return __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_objectSpread___default()({},Object(__WEBPACK_IMPORTED_MODULE_32_utils_forms__["b" /* getMlsFormProps */])(theme),{/* Dialog */dialogPaper:{minWidth:444},dialogWrapper:{position:'relative',padding:'15px 10px 0',minHeight:535,display:'flex',flexDirection:'column'},/* loading icon */loadingContainer:{minHeight:535,position:'relative'},/* autoCompleteComponent */autoCompleteComponent:{},optionAgentId:{margin:'0 70px 0 -8px'}});};var InviteUserModal=(_dec=Object(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["N" /* withStyles */])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_inherits___default()(InviteUserModal,_Component);function InviteUserModal(props){var _this;__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_classCallCheck___default()(this,InviteUserModal);_this=__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_getPrototypeOf___default()(InviteUserModal).call(this,props));_this.state={currentStep:SCREEN_TYPE.MLS_API,connectWith:CONNECT_WITH.AGENT_MLS_ID,mlsOfficeId:'',agentMlsId:'',mlsSystem:null,mlsSystemCustom:null,listingMlsNumber:'',xhrInProgress:false,apiRequestSuccess:false,apiRequestError:false,errors:{},touched:{}};_this.handleMlsNotInTheList=_this.handleMlsNotInTheList.bind(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.handleOpenIntercom=_this.handleOpenIntercom.bind(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_assertThisInitialized___default()(_this));return _this;}__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_createClass___default()(InviteUserModal,[{key:"render",value:function render(){var _this2=this;var _this$props=this.props,modalShown=_this$props.modalShown,resetModal=_this$props.resetModal,classes=_this$props.classes;return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["d" /* Dialog */],{open:modalShown,"aria-labelledby":"alert-dialog-title","aria-describedby":"alert-dialog-description",onExited:resetModal,BackdropProps:{style:{backgroundColor:'rgba(46, 63, 79, 0.4)'}},classes:{paper:classes.dialogPaper},PaperProps:{style:{border:0,width:309,minWidth:505,borderRadius:5,boxShadow:'0px 4px 24px rgba(0, 0, 0, 0.08)'}}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div",{className:classes.dialogWrapper},!this.state.xhrInProgress&&__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["p" /* IconButton */],{className:classes.closeDialog,component:"span","aria-label":"Close",onClick:function onClick(){return _this2.closeDialog();}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__theme_icons__["_11" /* XIcon */],{className:classes.closeDialogIcon})),function(){if(_this2.state.xhrInProgress){return _this2.renderLoading();}else if([SCREEN_TYPE.MLS_AGENT_ID_REVIEW_NEEDED,SCREEN_TYPE.MLS_OFFICE_ID_REVIEW_NEEDED].includes(_this2.state.currentStep)){return _this2.props.mls.reviewMlsSuccess?_this2.renderSuccess():_this2.renderReviewMlsId();}else if(_this2.state.apiRequestSuccess){return _this2.renderSuccess();}else if(_this2.state.apiRequestError){return _this2.state.currentStep===SCREEN_TYPE.MLS_CUSTOM?_this2.renderForm():_this2.renderFailure();}else{return _this2.renderForm();}}()));}},{key:"closeDialog",value:function closeDialog(){var shouldReloadList=this.state.apiRequestSuccess&&this.state.currentStep===SCREEN_TYPE.MLS_API;this.props.onClose(shouldReloadList);}},{key:"backToForm",value:function backToForm(){this.props.clearConnectMlsState();this.setState({currentStep:SCREEN_TYPE.MLS_API,xhrInProgress:false,apiRequestSuccess:false,apiRequestError:false,errors:{}});}},{key:"renderLoading",value:function renderLoading(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div",{className:classes.loadingContainer},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div",{className:classes.loadingContent},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__theme_icons__["Y" /* SpinnerIcon */],{className:classes.loadingIcon}),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["M" /* Typography */],{className:classes.loadingMessage,variant:"body2"},localize('mls-popup-saving-form'))));}},{key:"renderSuccess",value:function renderSuccess(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["g" /* DialogTitle */],{variant:"body1",color:"default",className:classes.dialogTitle},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__theme_icons__["K" /* IconTickRounded */],{className:classes.headerIcon})," ",localize([SCREEN_TYPE.MLS_CUSTOM,SCREEN_TYPE.MLS_AGENT_ID_REVIEW_NEEDED,SCREEN_TYPE.MLS_OFFICE_ID_REVIEW_NEEDED].includes(this.state.currentStep)?'mls-request-success-screen-title':'mls-connection-success-screen-title')),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["f" /* DialogContent */],{className:classes.dialogContent},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["o" /* Grid */],{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["o" /* Grid */],{item:true,className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()(classes.successMessage,classes.feedbackMessage)},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["M" /* Typography */],{variant:"body2",dangerouslySetInnerHTML:{__html:localize([SCREEN_TYPE.MLS_CUSTOM,SCREEN_TYPE.MLS_AGENT_ID_REVIEW_NEEDED,SCREEN_TYPE.MLS_OFFICE_ID_REVIEW_NEEDED].includes(this.state.currentStep)?'mls-request-success-screen-description':'mls-connection-success-screen-description')}})))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["e" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["o" /* Grid */],{item:true,container:true,direction:"row",justify:"flex-end",className:classes.buttonsContainer},this.state.currentStep===SCREEN_TYPE.MLS_API&&__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["a" /* Button */],{variant:"contained",color:"primary","data-tid":"button-run-playbooks",className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()(classes.button,classes.buttonPrimary),onClick:function onClick(){return _this3.runPlaybooks();}},localize('mls-connection-success-screen-run-playbooks')),[SCREEN_TYPE.MLS_CUSTOM,SCREEN_TYPE.MLS_AGENT_ID_REVIEW_NEEDED,SCREEN_TYPE.MLS_OFFICE_ID_REVIEW_NEEDED].includes(this.state.currentStep)&&__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["a" /* Button */],{variant:"contained",color:"primary","data-tid":"button-close-dialog",className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()(classes.button,classes.buttonPrimary),onClick:function onClick(){return _this3.closeDialog();}},localize('mls-request-success-screen-got-it')))));}},{key:"renderFailure",value:function renderFailure(){var _this4=this;var classes=this.props.classes;var errors=this.state.errors;var apiError=__WEBPACK_IMPORTED_MODULE_27_lodash___default.a.get(errors,'apiError');var headerIcon=__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__theme_icons__["z" /* IconErrorRounded */],{className:classes.headerIcon});var popupTitle=localize('mls-error-connection-screen-title');return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["g" /* DialogTitle */],{variant:"body1",color:"default",className:classes.dialogTitle},headerIcon," ",popupTitle),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["f" /* DialogContent */],{className:classes.dialogContent},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["o" /* Grid */],{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["o" /* Grid */],{item:true,className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()(classes.failureMessage,classes.feedbackMessage)},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["M" /* Typography */],{variant:"body2",dangerouslySetInnerHTML:{__html:apiError}}),__WEBPACK_IMPORTED_MODULE_27_lodash___default.a.get(this.props.mls,'addConnectionWithOfficeIdErrorId'!==__WEBPACK_IMPORTED_MODULE_28__errors_errorids__["a" /* default */].MLS_NO_LISTINGS_FOUND)&&this.renderContactForHelp()))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["e" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["o" /* Grid */],{item:true,container:true,direction:"row",justify:"flex-end",className:classes.buttonsContainer},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["a" /* Button */],{variant:"outlined",color:"primary","data-tid":"button-back-to-form",className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()(classes.button,classes.buttonBack),onClick:function onClick(){return _this4.backToForm();}},localize('mls-error-screen-back')),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["a" /* Button */],{variant:"contained",color:"primary","data-tid":"button-close-dialog",className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()(classes.button,classes.buttonPrimary),onClick:function onClick(){return _this4.closeDialog();}},localize('mls-error-screen-close')))));}},{key:"renderReviewMlsId",value:function renderReviewMlsId(){var _this5=this;var classes=this.props.classes;var headerIcon=__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__theme_icons__["B" /* IconInfoRounded */],{className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()(classes.headerIcon,classes.headerIconInfo)});var popupTitle=localize('mls-error-connection-screen-title-no-listings-found');var errorMessage=this.state.currentStep===SCREEN_TYPE.MLS_OFFICE_ID_REVIEW_NEEDED?localize('mls-popup-no-listings-found-for-office-id',[this.state.mlsSystem.label,this.state.mlsOfficeId]):localize('mls-popup-no-listings-found-for-agent-id',[this.state.mlsSystem.label,this.state.agentMlsId]);return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["g" /* DialogTitle */],{variant:"body1",color:"default",className:classes.dialogTitle},headerIcon," ",popupTitle),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["f" /* DialogContent */],{className:classes.dialogContent},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["o" /* Grid */],{container:true,direction:"column"},Object.keys(this.state.errors).length>0&&this.renderErrorMessage(),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["o" /* Grid */],{item:true,className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()(classes.failureMessage,classes.feedbackMessage)},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["M" /* Typography */],{variant:"body2",dangerouslySetInnerHTML:{__html:errorMessage}}),__WEBPACK_IMPORTED_MODULE_27_lodash___default.a.get(this.props.mls,'reviewMlsErrorId')&&this.renderContactForHelp()))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["e" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["o" /* Grid */],{item:true,container:true,direction:"row",justify:"flex-end",className:classes.buttonsContainer},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["a" /* Button */],{variant:"outlined",color:"primary","data-tid":"button-back-to-form",className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()(classes.button,classes.buttonBack),onClick:function onClick(){return _this5.backToForm();}},localize('mls-error-screen-back')),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["a" /* Button */],{variant:"contained",color:"primary","data-tid":"button-send-to-review-office-id",className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()(classes.button,classes.buttonPrimary),onClick:function onClick(){return _this5.sendToReview();}},localize('mls-error-screen-send-to-review')))));}},{key:"renderErrorMessage",value:function renderErrorMessage(){var errors=this.state.errors;var apiError=__WEBPACK_IMPORTED_MODULE_27_lodash___default.a.get(errors,'apiError');var formError=this.hasFormError(errors)&&'mls-popup-errors-found-in-the-form';var errorMessageKey;if(this.state.errors.mlsBoardListError){errorMessageKey='mls-connection-popup-error-failed-to-load-mls-board-list';}else if(formError){errorMessageKey=formError;}else if(apiError){errorMessageKey=apiError;}var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["M" /* Typography */],{className:classes.errorMessage,variant:"body2",dangerouslySetInnerHTML:{__html:localize(errorMessageKey)}});}},{key:"renderContactForHelp",value:function renderContactForHelp(){return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["M" /* Typography */],{variant:"body2"},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["r" /* Link */],{onClick:this.handleOpenIntercom},localize('mls-error-screen-contact-for-help-1')),"\xA0",localize('mls-error-screen-contact-for-help-2'));}},{key:"handleMlsNotInTheList",value:function handleMlsNotInTheList(){this.setState({agentMlsId:'',listingMlsNumber:'',currentStep:SCREEN_TYPE.MLS_CUSTOM,errors:{}});}},{key:"handleOpenIntercom",value:function handleOpenIntercom(){Object(__WEBPACK_IMPORTED_MODULE_31_utils_intercom__["a" /* openIntercomChat */])(null,true,this.props.showErrorPopup);}},{key:"handleConnectWithChange",value:function handleConnectWithChange(event){var newState={connectWith:event.target.value,errors:{}};if(this.props.mls.mlsBoardListFailedToLoad){newState.errors.mlsBoardListError=true;}this.setState(newState);}},{key:"renderForm",value:function renderForm(){var _classNames,_this6=this;var classes=this.props.classes;var _this$state=this.state,mlsOfficeId=_this$state.mlsOfficeId,agentMlsId=_this$state.agentMlsId,mlsSystem=_this$state.mlsSystem,mlsSystemCustom=_this$state.mlsSystemCustom,listingMlsNumber=_this$state.listingMlsNumber;var errorClasses={error:classes.error};return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["g" /* DialogTitle */],{variant:"body1",color:"default",className:classes.dialogTitle},localize(this.state.currentStep===SCREEN_TYPE.MLS_CUSTOM?'custom-mls-connection-popup-header':'mls-connection-popup-header')),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["f" /* DialogContent */],{className:classes.dialogContent},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["o" /* Grid */],{container:true,direction:"column"},Object.keys(this.state.errors).length>0&&this.renderErrorMessage(),this.state.currentStep===SCREEN_TYPE.MLS_API&&__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["o" /* Grid */],{item:true,className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()((_classNames={},__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_classNames,classes.textFieldWrapper,true),__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(_classNames,classes.textFieldWrapperError,this.state.errors['mlsSystem']),_classNames))},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["M" /* Typography */],{className:classes.formFieldLabel,variant:"body1"},localize('your-mls-label')),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_ReactSelect__["a" /* default */],{value:__WEBPACK_IMPORTED_MODULE_27_lodash___default.a.get(mlsSystem,'value')===''?null/* shows placeholder */:mlsSystem,options:this.props.mls.mlsBoardList.map(function(item){return{label:item.displayName,value:item.mlsBoardCode};}),className:classes.autoCompleteComponent,placeholder:localize('your-mls-placeholder'),isDisabled:this.props.mls.mlsBoardListFailedToLoad===true,onChangeHandler:function onChangeHandler(newValue){_this6.onAutocompleteFieldChange(newValue,'mlsSystem');}}),this.state.errors['mlsSystem']&&__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_FormHelperText___default.a,{error:true,classes:errorClasses},this.state.errors['mlsSystem'])),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["o" /* Grid */],{item:true,className:classes.radioGroupContainer},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["M" /* Typography */],{className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()(classes.formFieldLabel,classes.radioGroupLabel),variant:"body1"},localize('mls-connect-with-label')),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["B" /* RadioGroup */],{name:"connectOptions","data-tid":"connect-options",value:this.state.connectWith,row:true,onChange:function onChange(event){return _this6.handleConnectWithChange(event);}},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["k" /* FormControlLabel */],{value:CONNECT_WITH.AGENT_MLS_ID,className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()(classes.optionAgentId,classes.noMargins,this.state.connectWith===CONNECT_WITH.AGENT_MLS_ID?classes.radioSelectorLabelChecked:classes.radioSelectorLabel,classes.radioSelectorLabelHover),control:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["A" /* Radio */],{color:"primary",className:classes.radioButton,disableRipple:true}),label:localize('mls-agent-id-label')}),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["k" /* FormControlLabel */],{value:CONNECT_WITH.MLS_OFFICE_ID,className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()(classes.noMargins,this.state.connectWith===CONNECT_WITH.MLS_OFFICE_ID?classes.radioSelectorLabelChecked:classes.radioSelectorLabel,classes.radioSelectorLabelHover),control:__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["A" /* Radio */],{color:"primary",className:classes.radioButton,disableRipple:true}),label:localize('mls-office-id-label')}))),this.state.connectWith===CONNECT_WITH.MLS_OFFICE_ID&&__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["o" /* Grid */],{item:true,className:classes.textFieldWrapper},this.textField('mlsOfficeId',mlsOfficeId,localize('mls-office-id-placeholder'),null,null,null,false)),this.state.connectWith===CONNECT_WITH.AGENT_MLS_ID&&__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["o" /* Grid */],{item:true,className:classes.textFieldWrapper},this.textField('agentMlsId',agentMlsId,localize('mls-agent-id-placeholder'),null,null,null,false))),this.state.currentStep===SCREEN_TYPE.MLS_CUSTOM&&__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["o" /* Grid */],{item:true,className:classes.textFieldWrapper},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["M" /* Typography */],{className:classes.formFieldLabel,variant:"body1"},localize('your-mls-label')),this.textField('mlsSystemCustom',mlsSystemCustom,localize('mls-office-other-placeholder'),null,null,null,false)),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["o" /* Grid */],{item:true,className:classes.textFieldWrapper},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["M" /* Typography */],{className:classes.formFieldLabel,variant:"body1"},localize('mls-office-id-label')),this.textField('mlsOfficeId',mlsOfficeId,localize('mls-office-id-placeholder'),null,null,null,false)),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["o" /* Grid */],{item:true,className:classes.textFieldWrapper},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["M" /* Typography */],{className:classes.formFieldLabel,variant:"body1"},localize('mls-listing-number-label')),this.textField('listingMlsNumber',listingMlsNumber,localize('mls-listing-number-placeholder'),null,null,null,false))),this.state.currentStep===SCREEN_TYPE.MLS_API&&__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["o" /* Grid */],{item:true,className:classes.linksContainer},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["M" /* Typography */],{variant:"body1",className:classes.link},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["r" /* Link */],{onClick:this.handleMlsNotInTheList},localize('mls-connection-popup-mls-not-in-the-list'))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["M" /* Typography */],{variant:"body1",className:classes.link},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["r" /* Link */],{onClick:this.handleOpenIntercom},localize('mls-popup-contact-us')))))),__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["e" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["o" /* Grid */],{item:true,container:true,direction:"row",justify:"flex-end",className:classes.buttonsContainer},__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["a" /* Button */],{variant:"contained",color:"primary","data-tid":"button-connect-mls",className:__WEBPACK_IMPORTED_MODULE_18_classnames___default()(classes.button,classes.buttonPrimary),onClick:function onClick(){return _this6.submitForm();},disabled:Object.keys(this.getFormErrors(true)).length>0},localize(this.state.xhrInProgress?'mls-popup-sending-request':this.state.currentStep===SCREEN_TYPE.MLS_CUSTOM?'mls-popup-submit-request':'mls-popup-connect')))));}},{key:"runPlaybooks",value:function runPlaybooks(){window.open("".concat(__WEBPACK_IMPORTED_MODULE_14__config__["_65" /* XC_URL */],"?viewID=PLAYBOOK_RUNS"),'_blank');}},{key:"submitForm",value:function(){var _submitForm=__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee(){var forceAddition,_args=arguments;return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:forceAddition=_args.length>0&&_args[0]!==undefined?_args[0]:false;this.setState({xhrInProgress:true,apiRequestError:false,apiRequestSuccess:false,errors:{apiError:null}});if(this.state.currentStep===SCREEN_TYPE.MLS_CUSTOM){this.props.sendConnectMlsRequest({'user-email':__WEBPACK_IMPORTED_MODULE_27_lodash___default.a.get(this.props.user,'mainEmail'),'user-xc-id':__WEBPACK_IMPORTED_MODULE_27_lodash___default.a.get(this.props.user,'userId'),'mls-system':this.state.mlsSystemCustom,'listing-mls-number':this.state.listingMlsNumber,'mls-office-id':this.state.mlsOfficeId,'process-activate-playbooks':1});}else if(this.state.currentStep===SCREEN_TYPE.MLS_API){if(this.state.connectWith===CONNECT_WITH.MLS_OFFICE_ID){this.props.addMLSConnectionWithOfficeId(__WEBPACK_IMPORTED_MODULE_27_lodash___default.a.get(this.state.mlsSystem,'value'),this.state.mlsOfficeId,forceAddition);}else if(this.state.connectWith===CONNECT_WITH.AGENT_MLS_ID){this.props.addMLSConnectionWithAgentId(__WEBPACK_IMPORTED_MODULE_27_lodash___default.a.get(this.state.mlsSystem,'value'),this.state.agentMlsId);}}case 3:case"end":return _context.stop();}}},_callee,this);}));function submitForm(){return _submitForm.apply(this,arguments);}return submitForm;}()},{key:"sendToReview",value:function(){var _sendToReview=__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:this.setState({xhrInProgress:true,apiRequestError:false,apiRequestSuccess:false,errors:{apiError:null}});this.props.sendMlsReviewRequest({'user-email':__WEBPACK_IMPORTED_MODULE_27_lodash___default.a.get(this.props.user,'mainEmail'),'user-xc-id':__WEBPACK_IMPORTED_MODULE_27_lodash___default.a.get(this.props.user,'userId'),'mls-system':this.state.mlsSystem.label,'mls-agent-id':this.state.agentMlsId||'-','mls-office-id':this.state.mlsOfficeId||'-','process-review':1});case 2:case"end":return _context2.stop();}}},_callee2,this);}));function sendToReview(){return _sendToReview.apply(this,arguments);}return sendToReview;}()},{key:"isSubmitEnabled",value:function isSubmitEnabled(){return!this.hasFormError(this.state.errors)||Object.keys(this.state.errors).length===1&&__WEBPACK_IMPORTED_MODULE_27_lodash___default.a.get(this.state,'errors.apiError');}},{key:"hasFormError",value:function hasFormError(errorState){var result=false;Object.keys(errorState).forEach(function(fieldName){if(fieldName.indexOf('mlsOfficeId')!==-1||fieldName.indexOf('agentMlsId')!==-1||fieldName.indexOf('mlsSystemCustom')!==-1||fieldName.indexOf('mlsSystem')!==-1){result=true;}});return result;}},{key:"componentDidMount",value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_29_lib_Segment_customTrackers__["b" /* trackAddMlsConnectionPopupShown */])(Object(__WEBPACK_IMPORTED_MODULE_30_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));if(this.props.mls.mlsBoardListFailedToLoad){this.setState({errors:{mlsBoardListError:true}});}}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(this.props.mls.reviewMlsErrorId!==nextProps.mls.reviewMlsErrorId&&nextProps.mls.reviewMlsErrorId!==null||this.props.mls.connectMlsErrorId!==nextProps.mls.connectMlsErrorId&&nextProps.mls.connectMlsErrorId!==null||this.props.mls.addConnectionWithOfficeIdErrorId!==nextProps.mls.addConnectionWithOfficeIdErrorId&&nextProps.mls.addConnectionWithOfficeIdErrorId!==null||this.props.mls.addConnectionWithAgentIdErrorId!==nextProps.mls.addConnectionWithAgentIdErrorId&&nextProps.mls.addConnectionWithAgentIdErrorId!==null){this.handleApiErrors(nextProps);if(nextProps.mls.reviewMlsErrorId){Object(__WEBPACK_IMPORTED_MODULE_29_lib_Segment_customTrackers__["O" /* trackSentReviewMlsToXaraFailure */])(Object(__WEBPACK_IMPORTED_MODULE_30_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}else if(nextProps.mls.addConnectionWithOfficeIdErrorId){Object(__WEBPACK_IMPORTED_MODULE_29_lib_Segment_customTrackers__["p" /* trackConnectedMlsWithOfficeIdFailure */])(Object(__WEBPACK_IMPORTED_MODULE_30_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}else if(nextProps.mls.addConnectionWithAgentIdErrorId){Object(__WEBPACK_IMPORTED_MODULE_29_lib_Segment_customTrackers__["n" /* trackConnectedMlsWithAgentIdFailure */])(Object(__WEBPACK_IMPORTED_MODULE_30_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}else if(nextProps.mls.connectMlsErrorId){Object(__WEBPACK_IMPORTED_MODULE_29_lib_Segment_customTrackers__["M" /* trackSentConnectionRequestToXaraFailure */])(Object(__WEBPACK_IMPORTED_MODULE_30_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}}if(this.props.mls.addConnectionWithOfficeIdErrorId!==nextProps.mls.addConnectionWithOfficeIdErrorId&&nextProps.mls.addConnectionWithOfficeIdErrorId===__WEBPACK_IMPORTED_MODULE_28__errors_errorids__["a" /* default */].EMAIL_NOT_VERIFIED||this.props.mls.addConnectionWithAgentIdErrorId!==nextProps.mls.addConnectionWithAgentIdErrorId&&nextProps.mls.addConnectionWithAgentIdErrorId===__WEBPACK_IMPORTED_MODULE_28__errors_errorids__["a" /* default */].EMAIL_NOT_VERIFIED){this.props.sendVerifyAccountEmail(__WEBPACK_IMPORTED_MODULE_27_lodash___default.a.get(this.props.user,'mainEmail'));}if(this.props.mls.reviewMlsSuccess!==nextProps.mls.reviewMlsSuccess&&nextProps.mls.reviewMlsSuccess===true||this.props.mls.connectMlsSuccess!==nextProps.mls.connectMlsSuccess&&nextProps.mls.connectMlsSuccess===true||this.props.mls.addConnectionWithOfficeIdSuccess!==nextProps.mls.addConnectionWithOfficeIdSuccess&&nextProps.mls.addConnectionWithOfficeIdSuccess===true||this.props.mls.addConnectionWithAgentIdSuccess!==nextProps.mls.addConnectionWithAgentIdSuccess&&nextProps.mls.addConnectionWithAgentIdSuccess===true){if(nextProps.mls.reviewMlsSuccess){Object(__WEBPACK_IMPORTED_MODULE_29_lib_Segment_customTrackers__["P" /* trackSentReviewMlsToXaraSuccess */])(Object(__WEBPACK_IMPORTED_MODULE_30_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}else if(nextProps.mls.addConnectionWithOfficeIdSuccess){Object(__WEBPACK_IMPORTED_MODULE_29_lib_Segment_customTrackers__["q" /* trackConnectedMlsWithOfficeIdSuccess */])(Object(__WEBPACK_IMPORTED_MODULE_30_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}else if(nextProps.mls.addConnectionWithAgentIdSuccess){Object(__WEBPACK_IMPORTED_MODULE_29_lib_Segment_customTrackers__["o" /* trackConnectedMlsWithAgentIdSuccess */])(Object(__WEBPACK_IMPORTED_MODULE_30_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}else if(nextProps.mls.connectMlsSuccess){Object(__WEBPACK_IMPORTED_MODULE_29_lib_Segment_customTrackers__["N" /* trackSentConnectionRequestToXaraSuccess */])(Object(__WEBPACK_IMPORTED_MODULE_30_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}this.setState({xhrInProgress:false,apiRequestError:false,apiRequestSuccess:true,errors:{apiError:null}});}}},{key:"handleApiErrors",value:function handleApiErrors(nextProps){var errorMessageKey;var errorMessage;if(nextProps.mls.reviewMlsErrorId){errorMessageKey=nextProps.mls.reviewMlsErrorId&&__WEBPACK_IMPORTED_MODULE_33_utils_mls__["a" /* MLS_ERRORS */][nextProps.mls.reviewMlsErrorId]||__WEBPACK_IMPORTED_MODULE_33_utils_mls__["a" /* MLS_ERRORS */][__WEBPACK_IMPORTED_MODULE_28__errors_errorids__["a" /* default */].UNKNOWN];}else if(nextProps.mls.connectMlsErrorId){errorMessageKey=nextProps.mls.connectMlsErrorId&&__WEBPACK_IMPORTED_MODULE_33_utils_mls__["a" /* MLS_ERRORS */][nextProps.mls.connectMlsErrorId]||__WEBPACK_IMPORTED_MODULE_33_utils_mls__["a" /* MLS_ERRORS */][__WEBPACK_IMPORTED_MODULE_28__errors_errorids__["a" /* default */].UNKNOWN];}else if(nextProps.mls.addConnectionWithOfficeIdErrorId){errorMessageKey=nextProps.mls.addConnectionWithOfficeIdErrorId&&__WEBPACK_IMPORTED_MODULE_33_utils_mls__["a" /* MLS_ERRORS */][nextProps.mls.addConnectionWithOfficeIdErrorId]||__WEBPACK_IMPORTED_MODULE_33_utils_mls__["a" /* MLS_ERRORS */][__WEBPACK_IMPORTED_MODULE_28__errors_errorids__["a" /* default */].UNKNOWN];}else if(nextProps.mls.addConnectionWithAgentIdErrorId){errorMessageKey=nextProps.mls.addConnectionWithAgentIdErrorId&&__WEBPACK_IMPORTED_MODULE_33_utils_mls__["a" /* MLS_ERRORS */][nextProps.mls.addConnectionWithAgentIdErrorId]||__WEBPACK_IMPORTED_MODULE_33_utils_mls__["a" /* MLS_ERRORS */][__WEBPACK_IMPORTED_MODULE_28__errors_errorids__["a" /* default */].UNKNOWN];}if(this.state.currentStep===SCREEN_TYPE.MLS_API&&this.state.connectWith===CONNECT_WITH.MLS_OFFICE_ID&&nextProps.mls.addConnectionWithOfficeIdErrorId===__WEBPACK_IMPORTED_MODULE_28__errors_errorids__["a" /* default */].MLS_NO_LISTINGS_FOUND){this.setState({xhrInProgress:false,apiRequestError:false,apiRequestSuccess:false,currentStep:SCREEN_TYPE.MLS_OFFICE_ID_REVIEW_NEEDED,errors:{}});}else if(this.state.currentStep===SCREEN_TYPE.MLS_API&&this.state.connectWith===CONNECT_WITH.AGENT_MLS_ID&&nextProps.mls.addConnectionWithAgentIdErrorId===__WEBPACK_IMPORTED_MODULE_28__errors_errorids__["a" /* default */].MLS_NO_LISTINGS_FOUND){this.setState({xhrInProgress:false,apiRequestError:false,apiRequestSuccess:false,currentStep:SCREEN_TYPE.MLS_AGENT_ID_REVIEW_NEEDED,errors:{}});}else{errorMessage=localize(errorMessageKey);this.setState({xhrInProgress:false,apiRequestError:true,apiRequestSuccess:false,errors:{apiError:errorMessage}});}}},{key:"textField",value:function textField(name,value,placeholder,disabled,type,maxLength,autosize){var _this7=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__FormField__["a" /* default */],__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({value:value,autoComplete:"off",className:classes.field,"data-tid":"form-user-".concat(name),onChange:function onChange(event){return _this7.onTextFieldChange(event,name);},onBlur:function onBlur(event){return _this7.onTextFieldBlur(event,name);},onKeyPress:function onKeyPress(event){return _this7.onTextFieldKeyPress(event,name);},id:name,placeholder:placeholder},type?{type:type}:{},autosize?{autosize:autosize}:{},{margin:"normal",helperText:this.state.errors[name],error:!!this.state.errors[name],disabled:disabled,maxLength:maxLength,inputRef:this[name]}));}},{key:"onAutocompleteFieldChange",value:function onAutocompleteFieldChange(newValue,name){this.setState(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()({},name,newValue));this.setFieldState(name,newValue);}},{key:"onTextFieldBlur",value:function onTextFieldBlur(event,name){var newState=__WEBPACK_IMPORTED_MODULE_27_lodash___default.a.cloneDeep(this.state);newState.touched[name]=true;this.setState(newState,this.validateAll);}},{key:"onTextFieldKeyPress",value:function onTextFieldKeyPress(event,name){if(!this.isSubmitEnabled())return;if(event.key==='Enter'){this.submitForm();}}},{key:"onTextFieldChange",value:function onTextFieldChange(event,name){this.setFieldState(name,event.target.value);}},{key:"setFieldState",value:function setFieldState(fieldName,value){this.setState(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()({},fieldName,value));var newState=__WEBPACK_IMPORTED_MODULE_27_lodash___default.a.cloneDeep(this.state);newState.touched[fieldName]=true;newState[fieldName]=value;this.setState(newState,this.validateAll);}},{key:"getFormErrors",value:function getFormErrors(includeAllField){// includeAllField - include all fields in validation, not only touched
var validateFields=null;if(this.state.currentStep===SCREEN_TYPE.MLS_CUSTOM){validateFields=['mlsSystemCustom','mlsOfficeId'];}else if(this.state.currentStep===SCREEN_TYPE.MLS_API){if(this.state.connectWith===CONNECT_WITH.MLS_OFFICE_ID){validateFields=['mlsSystem','mlsOfficeId'];}else if(this.state.connectWith===CONNECT_WITH.AGENT_MLS_ID){validateFields=['mlsSystem','agentMlsId'];}}var foundErrors={};for(var field in __WEBPACK_IMPORTED_MODULE_19__AddMlsConnectionModalSchema__["a" /* default */]){if(validateFields.includes(field)){var validate=__WEBPACK_IMPORTED_MODULE_19__AddMlsConnectionModalSchema__["a" /* default */][field];if(validate){var error=validate(this.state[field],this.state,includeAllField);if(error){foundErrors[field]=error;}}}}return foundErrors;}},{key:"validateAll",value:function validateAll(){this.setState({errors:this.getFormErrors(false)});}}]);return InviteUserModal;}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]))||_class);InviteUserModal.propTypes={companies:__WEBPACK_IMPORTED_MODULE_24_prop_types___default.a.object,mls:__WEBPACK_IMPORTED_MODULE_24_prop_types___default.a.object,modalShown:__WEBPACK_IMPORTED_MODULE_24_prop_types___default.a.bool,hideModal:__WEBPACK_IMPORTED_MODULE_24_prop_types___default.a.func,resetModal:__WEBPACK_IMPORTED_MODULE_24_prop_types___default.a.func,classes:__WEBPACK_IMPORTED_MODULE_24_prop_types___default.a.object,email:__WEBPACK_IMPORTED_MODULE_24_prop_types___default.a.string,showApiError:__WEBPACK_IMPORTED_MODULE_24_prop_types___default.a.bool,company:__WEBPACK_IMPORTED_MODULE_24_prop_types___default.a.object,user:__WEBPACK_IMPORTED_MODULE_24_prop_types___default.a.object.isRequired,showErrorPopup:__WEBPACK_IMPORTED_MODULE_24_prop_types___default.a.func.isRequired,sendConnectMlsRequest:__WEBPACK_IMPORTED_MODULE_24_prop_types___default.a.func,sendMlsReviewRequest:__WEBPACK_IMPORTED_MODULE_24_prop_types___default.a.func,sendVerifyAccountEmail:__WEBPACK_IMPORTED_MODULE_24_prop_types___default.a.func,selectedCompanyId:__WEBPACK_IMPORTED_MODULE_24_prop_types___default.a.string,addMLSConnectionWithAgentId:__WEBPACK_IMPORTED_MODULE_24_prop_types___default.a.func.isRequired,addMLSConnectionWithOfficeId:__WEBPACK_IMPORTED_MODULE_24_prop_types___default.a.func.isRequired,clearConnectMlsState:__WEBPACK_IMPORTED_MODULE_24_prop_types___default.a.func.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_24_prop_types___default.a.func.isRequired};var mapStateToProps=function mapStateToProps(state){return{company:state.companies.rawDataById?state.companies.rawDataById[state.companies.selectedId]:null,modalShown:state.modal.modalShown,companies:state.companies,mls:state.mls,user:state.session.user,selectedCompanyId:state.companies.selectedId};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_13_redux__["b" /* bindActionCreators */])({hideModal:__WEBPACK_IMPORTED_MODULE_20_redux_modules_modal__["b" /* hideModal */],resetModal:__WEBPACK_IMPORTED_MODULE_20_redux_modules_modal__["c" /* resetModal */],showErrorPopup:__WEBPACK_IMPORTED_MODULE_21_redux_modules_companies__["H" /* showErrorPopup */],sendConnectMlsRequest:__WEBPACK_IMPORTED_MODULE_16_redux_modules_mls__["p" /* sendConnectMlsRequest */],sendMlsReviewRequest:__WEBPACK_IMPORTED_MODULE_16_redux_modules_mls__["q" /* sendMlsReviewRequest */],sendVerifyAccountEmail:__WEBPACK_IMPORTED_MODULE_23_redux_modules_account__["f" /* sendVerifyAccountEmail */],addMLSConnectionWithAgentId:__WEBPACK_IMPORTED_MODULE_16_redux_modules_mls__["b" /* addMLSConnectionWithAgentId */],addMLSConnectionWithOfficeId:__WEBPACK_IMPORTED_MODULE_16_redux_modules_mls__["c" /* addMLSConnectionWithOfficeId */],clearConnectMlsState:__WEBPACK_IMPORTED_MODULE_16_redux_modules_mls__["e" /* clearConnectMlsState */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(InviteUserModal));

/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_i18n_i18n__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
var localize=__WEBPACK_IMPORTED_MODULE_0_i18n_i18n__["a" /* default */].loc.localize;var schema={'mlsSystem':function mlsSystem(object,state,includeAllField){if(state.touched['mlsSystem']||includeAllField){if(!(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(object,'value','')||'').trim()){return localize('required-field');}}},'mlsSystemCustom':function mlsSystemCustom(value,state,includeAllField){if(state.touched['mlsSystemCustom']||includeAllField){if(!(value||'').trim()){return localize('required-field');}}},'mlsOfficeId':function mlsOfficeId(value,state,includeAllField){if(state.touched['mlsOfficeId']||includeAllField){if(!(value||'').trim()){return localize('required-field');}}},'agentMlsId':function agentMlsId(value,state,includeAllField){if(state.touched['agentMlsId']||includeAllField){if(!(value||'').trim()){return localize('required-field');}}}};/* harmony default export */ __webpack_exports__["a"] = (schema);

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_select__ = __webpack_require__(1182);
var fontStyle={fontFamily:'Open Sans, sans-serif',fontWeight:'normal',fontStyle:'normal',fontSize:'14px',lineHeight:'19px'};var inputFieldBorderActive='#2888c3';var inputFieldBorderDefault='rgba(0, 0, 0, 0.23)';function getColorStyles(isFocused){// Documentation for props https://react-select.com/props
return{control:function control(styles){return __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_objectSpread___default()({},styles,fontStyle,{backgroundColor:'white',boxShadow:'none',borderColor:isFocused?inputFieldBorderActive:inputFieldBorderDefault,'&:hover':{borderColor:inputFieldBorderActive}});},option:function option(styles,_ref){var isDisabled=_ref.isDisabled,isFocused=_ref.isFocused,isSelected=_ref.isSelected;return __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_objectSpread___default()({},styles,fontStyle,{textAlign:'left',backgroundColor:isDisabled?undefined:isSelected?'rgba(47, 165, 231, 0.30)':isFocused?'rgba(47, 165, 231, 0.30)':undefined,color:isDisabled?'#ccc':'#2E3F4F',cursor:isDisabled?'not-allowed':'default'});},input:function input(styles){return __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_objectSpread___default()({},styles);},placeholder:function placeholder(styles){return __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_objectSpread___default()({},styles,fontStyle);},singleValue:function singleValue(styles){return __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_objectSpread___default()({},styles);},noOptionsMessage:function noOptionsMessage(styles){return __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_objectSpread___default()({},styles,fontStyle);}};}var ReactSelect=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ReactSelect,_Component);function ReactSelect(props){var _this;__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,ReactSelect);_this=__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(ReactSelect).call(this,props));__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this),"handleChange",function(newValue){_this.props.onChangeHandler(newValue);});__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this),"onMenuOpen",function(){_this.setState({controlFocused:true});});__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this),"onMenuClose",function(){_this.setState({controlFocused:false});});_this.state={controlFocused:false};return _this;}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ReactSelect,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_select__["a" /* default */],{onMenuOpen:this.onMenuOpen,onMenuClose:this.onMenuClose,value:this.props.value,onChange:this.handleChange,options:this.props.options.map(function(item){if(!item.label){item.label=item.value;}return item;}),placeholder:this.props.placeholder,styles:getColorStyles(this.state.controlFocused),isDisabled:this.props.isDisabled});}}]);return ReactSelect;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);ReactSelect.propTypes={options:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.array.isRequired,placeholder:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,classes:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,onChangeHandler:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,value:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,isDisabled:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (ReactSelect);

/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NonceProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createClass__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_memoize_one__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__emotion_core__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_dom__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__babel_runtime_helpers_typeof__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__index_75b02bac_browser_esm_js__ = __webpack_require__(461);
/* unused harmony reexport components */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Select_e1cf49ae_browser_esm_js__ = __webpack_require__(464);
/* unused harmony reexport createFilter */
/* unused harmony reexport defaultTheme */
/* unused harmony reexport mergeStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__emotion_css__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_input_autosize__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__stateManager_2f2b6f5b_browser_esm_js__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__emotion_cache__ = __webpack_require__(301);

























function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var NonceProvider = /*#__PURE__*/function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(NonceProvider, _Component);

  var _super = _createSuper(NonceProvider);

  function NonceProvider(props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, NonceProvider);

    _this = _super.call(this, props);

    _this.createEmotionCache = function (nonce) {
      return Object(__WEBPACK_IMPORTED_MODULE_22__emotion_cache__["a" /* default */])({
        nonce: nonce
      });
    };

    _this.createEmotionCache = Object(__WEBPACK_IMPORTED_MODULE_12_memoize_one__["a" /* default */])(_this.createEmotionCache);
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_createClass__["a" /* default */])(NonceProvider, [{
    key: "render",
    value: function render() {
      var emotionCache = this.createEmotionCache(this.props.nonce);
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__emotion_core__["a" /* CacheProvider */], {
        value: emotionCache
      }, this.props.children);
    }
  }]);

  return NonceProvider;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

var index = Object(__WEBPACK_IMPORTED_MODULE_21__stateManager_2f2b6f5b_browser_esm_js__["a" /* m */])(__WEBPACK_IMPORTED_MODULE_17__Select_e1cf49ae_browser_esm_js__["a" /* S */]);

/* harmony default export */ __webpack_exports__["a"] = (index);



/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _inheritsLoose; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(1185);

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(t, o);
}


/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _setPrototypeOf; });
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}


/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ __webpack_exports__["a"] = (stylis_min);


/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

/* unused harmony default export */ var _unused_webpack_default_export = (weakMemoize);


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(1189);
function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, setPrototypeOf(t, o);
}
module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1189 */
/***/ (function(module, exports) {

function _setPrototypeOf(t, e) {
  return module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _setPrototypeOf(t, e);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

/* harmony default export */ __webpack_exports__["a"] = (murmur2);


/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _taggedTemplateLiteral;
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit__ = __webpack_require__(1197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nonIterableRest__ = __webpack_require__(1198);



function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__nonIterableRest__["a" /* default */])();
}

/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toConsumableArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nonIterableSpread__ = __webpack_require__(1202);



function _toConsumableArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__nonIterableSpread__["a" /* default */])();
}

/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithoutHoles;
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableSpread;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

/***/ }),
/* 1203 */
/***/ (function(module, exports) {

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

module.exports = _taggedTemplateLiteral;

/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return manageState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var defaultProps = {
  defaultInputValue: '',
  defaultMenuIsOpen: false,
  defaultValue: null
};

var manageState = function manageState(SelectComponent) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(StateManager, _Component);

    var _super = _createSuper(StateManager);

    function StateManager() {
      var _this;

      Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, StateManager);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      _this.select = void 0;
      _this.state = {
        inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
        menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
        value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
      };

      _this.onChange = function (value, actionMeta) {
        _this.callProp('onChange', value, actionMeta);

        _this.setState({
          value: value
        });
      };

      _this.onInputChange = function (value, actionMeta) {
        // TODO: for backwards compatibility, we allow the prop to return a new
        // value, but now inputValue is a controllable prop we probably shouldn't
        var newValue = _this.callProp('onInputChange', value, actionMeta);

        _this.setState({
          inputValue: newValue !== undefined ? newValue : value
        });
      };

      _this.onMenuOpen = function () {
        _this.callProp('onMenuOpen');

        _this.setState({
          menuIsOpen: true
        });
      };

      _this.onMenuClose = function () {
        _this.callProp('onMenuClose');

        _this.setState({
          menuIsOpen: false
        });
      };

      return _this;
    }

    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(StateManager, [{
      key: "focus",
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.select.blur();
      } // FIXME: untyped flow code, return any

    }, {
      key: "getProp",
      value: function getProp(key) {
        return this.props[key] !== undefined ? this.props[key] : this.state[key];
      } // FIXME: untyped flow code, return any

    }, {
      key: "callProp",
      value: function callProp(name) {
        if (typeof this.props[name] === 'function') {
          var _this$props;

          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          return (_this$props = this.props)[name].apply(_this$props, args);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props2 = this.props,
            defaultInputValue = _this$props2.defaultInputValue,
            defaultMenuIsOpen = _this$props2.defaultMenuIsOpen,
            defaultValue = _this$props2.defaultValue,
            props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_this$props2, ["defaultInputValue", "defaultMenuIsOpen", "defaultValue"]);

        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(SelectComponent, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
          ref: function ref(_ref) {
            _this2.select = _ref;
          },
          inputValue: this.getProp('inputValue'),
          menuIsOpen: this.getProp('menuIsOpen'),
          onChange: this.onChange,
          onInputChange: this.onInputChange,
          onMenuClose: this.onMenuClose,
          onMenuOpen: this.onMenuOpen,
          value: this.getProp('value')
        }));
      }
    }]);

    return StateManager;
  }(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]), _class.defaultProps = defaultProps, _temp;
};




/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_redux_modules_mls__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AddMlsOfficeModalSchema__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_utils_intercom__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_redux_modules_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_redux_modules_companies__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__FormField__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__theme_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_redux_modules_account__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lib_Segment_customTrackers__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lib_Segment_helpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_utils_forms__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_utils_mls__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_i18n_i18n__ = __webpack_require__(15);
var _dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_30_i18n_i18n__["a" /* default */].loc.localize;var styles=function styles(theme){return __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_objectSpread___default()({},Object(__WEBPACK_IMPORTED_MODULE_28_utils_forms__["b" /* getMlsFormProps */])(theme),{/* Dialog */dialogPaper:{minWidth:444},dialogWrapper:{position:'relative',padding:'15px 10px 0',minHeight:400,display:'flex',flexDirection:'column'},/* loading icon */loadingContainer:{minHeight:400,position:'relative'},introMessage:{marginBottom:40}});};var SCREEN_TYPE={MLS_API:'MLS_API',MLS_OFFICE_ID_REVIEW_NEEDED:'MLS_OFFICE_ID_REVIEW_NEEDED'};var InviteUserModal=(_dec=Object(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["N" /* withStyles */])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_inherits___default()(InviteUserModal,_Component);function InviteUserModal(props){var _this;__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_classCallCheck___default()(this,InviteUserModal);_this=__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_getPrototypeOf___default()(InviteUserModal).call(this,props));_this.state={currentStep:SCREEN_TYPE.MLS_API,mlsOfficeId:'',xhrInProgress:false,apiRequestSuccess:false,apiRequestError:false,errors:{},touched:{}};_this.handleOpenIntercom=_this.handleOpenIntercom.bind(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_assertThisInitialized___default()(_this));return _this;}__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_createClass___default()(InviteUserModal,[{key:"render",value:function render(){var _this2=this;var _this$props=this.props,modalShown=_this$props.modalShown,resetModal=_this$props.resetModal,classes=_this$props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["d" /* Dialog */],{open:modalShown,"aria-labelledby":"alert-dialog-title","aria-describedby":"alert-dialog-description",onExited:resetModal,BackdropProps:{style:{backgroundColor:'rgba(46, 63, 79, 0.4)'}},classes:{paper:classes.dialogPaper},PaperProps:{style:{border:0,width:309,minWidth:505,borderRadius:5,boxShadow:'0px 4px 24px rgba(0, 0, 0, 0.08)'}}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.dialogWrapper},!this.state.xhrInProgress&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["p" /* IconButton */],{className:classes.closeDialog,component:"span","aria-label":"Close",onClick:function onClick(){return _this2.closeDialog();}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__theme_icons__["_11" /* XIcon */],{className:classes.closeDialogIcon})),function(){if(_this2.state.xhrInProgress){return _this2.renderLoading();}else if(_this2.state.currentStep===SCREEN_TYPE.MLS_OFFICE_ID_REVIEW_NEEDED){return _this2.props.mls.reviewMlsSuccess?_this2.renderSuccess():_this2.renderReviewMlsId();}else if(_this2.state.apiRequestSuccess){return _this2.renderSuccess();}else if(_this2.state.apiRequestError){return _this2.renderFailure();}else{return _this2.renderForm();}}()));}},{key:"closeDialog",value:function closeDialog(){var shouldReloadList=this.state.apiRequestSuccess&&this.state.currentStep===SCREEN_TYPE.MLS_API;this.props.onClose(shouldReloadList);}},{key:"backToForm",value:function backToForm(){this.props.clearConnectMlsState();this.setState({currentStep:SCREEN_TYPE.MLS_API,xhrInProgress:false,apiRequestSuccess:false,apiRequestError:false,errors:{}});}},{key:"renderLoading",value:function renderLoading(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.loadingContainer},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.loadingContent},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__theme_icons__["Y" /* SpinnerIcon */],{className:classes.loadingIcon}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["M" /* Typography */],{className:classes.loadingMessage,variant:"body2"},localize('mls-popup-saving-form'))));}},{key:"renderSuccess",value:function renderSuccess(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["g" /* DialogTitle */],{variant:"body1",color:"default",className:classes.dialogTitle},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__theme_icons__["K" /* IconTickRounded */],{className:classes.headerIcon})," ",localize(this.state.currentStep===SCREEN_TYPE.MLS_OFFICE_ID_REVIEW_NEEDED?'mls-request-success-screen-title':'mls-office-success-screen-title')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["f" /* DialogContent */],{className:classes.dialogContent},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{item:true,className:classes.formMessage},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["M" /* Typography */],{variant:"body2",dangerouslySetInnerHTML:{__html:this.state.currentStep===SCREEN_TYPE.MLS_OFFICE_ID_REVIEW_NEEDED?localize('mls-request-success-screen-description'):localize('mls-office-success-screen-description',[this.state.mlsOfficeId,this.props.mlsName])}})))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["e" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{item:true,container:true,direction:"row",justify:"flex-end",className:classes.buttonsContainer},this.state.currentStep===SCREEN_TYPE.MLS_API&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["a" /* Button */],{variant:"contained",color:"primary","data-tid":"button-close-dialog",className:__WEBPACK_IMPORTED_MODULE_15_classnames___default()(classes.button,classes.buttonPrimary),onClick:function onClick(){return _this3.closeDialog();}},localize('mls-request-success-screen-close')),this.state.currentStep===SCREEN_TYPE.MLS_OFFICE_ID_REVIEW_NEEDED&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["a" /* Button */],{variant:"contained",color:"primary","data-tid":"button-close-dialog",className:__WEBPACK_IMPORTED_MODULE_15_classnames___default()(classes.button,classes.buttonPrimary),onClick:function onClick(){return _this3.closeDialog();}},localize('mls-request-success-screen-got-it')))));}},{key:"renderFailure",value:function renderFailure(){var _this4=this;var classes=this.props.classes;var errors=this.state.errors;var apiError=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(errors,'apiError');var headerIcon;var popupTitle;var showSendToReview=false;if(this.props.mls.addMlsOfficeIdErrorId&&this.props.mls.addMlsOfficeIdErrorId===__WEBPACK_IMPORTED_MODULE_29_utils_mls__["a" /* MLS_ERRORS */].NO_LISTINGS_FOUND){popupTitle=localize('mls-error-connection-screen-title-no-listings-found');headerIcon=__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__theme_icons__["B" /* IconInfoRounded */],{className:__WEBPACK_IMPORTED_MODULE_15_classnames___default()(classes.headerIcon,classes.headerIconInfo)});showSendToReview=true;}else{popupTitle=localize('mls-error-office-screen-title');headerIcon=__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__theme_icons__["z" /* IconErrorRounded */],{className:classes.headerIcon});}return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["g" /* DialogTitle */],{variant:"body1",color:"default",className:classes.dialogTitle},headerIcon," ",popupTitle),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["f" /* DialogContent */],{className:classes.dialogContent},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{item:true,className:classes.formMessage},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["M" /* Typography */],{variant:"body2",dangerouslySetInnerHTML:{__html:apiError}}),this.renderContactForHelp()))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["e" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{item:true,container:true,direction:"row",justify:"flex-end",className:classes.buttonsContainer},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["a" /* Button */],{variant:"outlined",color:"primary","data-tid":"button-back",className:__WEBPACK_IMPORTED_MODULE_15_classnames___default()(classes.button,classes.buttonBack),onClick:function onClick(){return _this4.backToForm();}},localize('mls-error-screen-back')),showSendToReview?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["a" /* Button */],{variant:"contained",color:"primary","data-tid":"button-send-to-review-office-id",className:__WEBPACK_IMPORTED_MODULE_15_classnames___default()(classes.button,classes.buttonPrimary),onClick:function onClick(){return _this4.sendToReview();}},localize('mls-error-screen-send-to-review')):__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["a" /* Button */],{variant:"contained",color:"primary","data-tid":"button-close-dialog",className:__WEBPACK_IMPORTED_MODULE_15_classnames___default()(classes.button,classes.buttonPrimary),onClick:function onClick(){return _this4.closeDialog();}},localize('mls-error-screen-close')))));}},{key:"renderReviewMlsId",value:function renderReviewMlsId(){var _this5=this;var classes=this.props.classes;var headerIcon=__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__theme_icons__["B" /* IconInfoRounded */],{className:__WEBPACK_IMPORTED_MODULE_15_classnames___default()(classes.headerIcon,classes.headerIconInfo)});var popupTitle=localize('mls-error-connection-screen-title-no-listings-found');var errorMessage=localize('mls-popup-no-listings-found-for-office-id',[this.props.mlsName,this.state.mlsOfficeId]);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["g" /* DialogTitle */],{variant:"body1",color:"default",className:classes.dialogTitle},headerIcon," ",popupTitle),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["f" /* DialogContent */],{className:classes.dialogContent},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{container:true,direction:"column"},Object.keys(this.state.errors).length>0&&this.renderErrorMessage(),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{item:true,className:__WEBPACK_IMPORTED_MODULE_15_classnames___default()(classes.failureMessage,classes.feedbackMessage)},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["M" /* Typography */],{variant:"body2",dangerouslySetInnerHTML:{__html:errorMessage}}),__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(this.props.mls,'reviewMlsErrorId')&&this.renderContactForHelp()))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["e" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{item:true,container:true,direction:"row",justify:"flex-end",className:classes.buttonsContainer},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["a" /* Button */],{variant:"outlined",color:"primary","data-tid":"button-back-to-form",className:__WEBPACK_IMPORTED_MODULE_15_classnames___default()(classes.button,classes.buttonBack),onClick:function onClick(){return _this5.backToForm();}},localize('mls-error-screen-back')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["a" /* Button */],{variant:"contained",color:"primary","data-tid":"button-send-to-review-office-id",className:__WEBPACK_IMPORTED_MODULE_15_classnames___default()(classes.button,classes.buttonPrimary),onClick:function onClick(){return _this5.sendToReview();}},localize('mls-error-screen-send-to-review')))));}},{key:"renderErrorMessage",value:function renderErrorMessage(){var errors=this.state.errors;var apiError=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(errors,'apiError');var formError=this.hasFormError(errors)&&'mls-popup-errors-found-in-the-form';var errorMessageKey;if(formError){errorMessageKey=formError;}else if(apiError){errorMessageKey=apiError;}var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["M" /* Typography */],{className:classes.errorMessage,variant:"body2",dangerouslySetInnerHTML:{__html:localize(errorMessageKey)}});}},{key:"renderContactForHelp",value:function renderContactForHelp(){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["M" /* Typography */],{variant:"body2"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["r" /* Link */],{onClick:this.handleOpenIntercom},localize('mls-error-screen-contact-for-help-1')),"\xA0",localize('mls-error-screen-contact-for-help-2'));}},{key:"handleOpenIntercom",value:function handleOpenIntercom(){Object(__WEBPACK_IMPORTED_MODULE_17_utils_intercom__["a" /* openIntercomChat */])(null,true,this.props.showErrorPopup);}},{key:"renderForm",value:function renderForm(){var _this6=this;var classes=this.props.classes;var mlsOfficeId=this.state.mlsOfficeId;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["g" /* DialogTitle */],{variant:"body1",color:"default",className:classes.dialogTitle},localize('mls-office-popup-header')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["f" /* DialogContent */],{className:classes.dialogContent},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{item:true,className:__WEBPACK_IMPORTED_MODULE_15_classnames___default()(classes.formMessage,classes.introMessage)},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["M" /* Typography */],{variant:"body2",dangerouslySetInnerHTML:{__html:localize('mls-office-popup-description',this.props.mlsName)}})),Object.keys(this.state.errors).length>0&&this.renderErrorMessage(),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{item:true,className:classes.textFieldWrapper},this.textField('mlsOfficeId',mlsOfficeId,localize('mls-office-id-placeholder'),null,null,null,false))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{item:true,className:classes.linksContainer},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["M" /* Typography */],{variant:"body1",className:classes.link},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["r" /* Link */],{onClick:this.handleOpenIntercom},localize('mls-popup-contact-us')))))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["e" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{item:true,container:true,direction:"row",justify:"flex-end",className:classes.buttonsContainer},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["a" /* Button */],{variant:"contained",color:"primary","data-tid":"button-connect-mls",className:__WEBPACK_IMPORTED_MODULE_15_classnames___default()(classes.button,classes.buttonPrimary),onClick:function onClick(){return _this6.submitForm();},disabled:Object.keys(this.getFormErrors(true)).length>0},localize(this.state.xhrInProgress?'mls-popup-sending-request':'mls-popup-connect')))));}},{key:"submitForm",value:function(){var _submitForm=__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee(){var forceAddition,_args=arguments;return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:forceAddition=_args.length>0&&_args[0]!==undefined?_args[0]:false;this.setState({xhrInProgress:true,apiRequestError:false,apiRequestSuccess:false,errors:{apiError:null}});this.props.addOfficeId(this.props.mlsConnectionId,this.state.mlsOfficeId,forceAddition);case 3:case"end":return _context.stop();}}},_callee,this);}));function submitForm(){return _submitForm.apply(this,arguments);}return submitForm;}()},{key:"sendToReview",value:function(){var _sendToReview=__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:this.setState({xhrInProgress:true,apiRequestError:false,apiRequestSuccess:false,errors:{apiError:null}});this.props.sendMlsReviewRequest({'user-email':__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(this.props.user,'mainEmail'),'user-xc-id':__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(this.props.user,'userId'),'mls-system':this.props.mlsName,'mls-agent-id':'-','mls-office-id':this.state.mlsOfficeId,'process-review':1});case 2:case"end":return _context2.stop();}}},_callee2,this);}));function sendToReview(){return _sendToReview.apply(this,arguments);}return sendToReview;}()},{key:"isSubmitEnabled",value:function isSubmitEnabled(){return!this.hasFormError(this.state.errors)||Object.keys(this.state.errors).length===1&&__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(this.state,'errors.apiError');}},{key:"hasFormError",value:function hasFormError(errorState){var result=false;Object.keys(errorState).forEach(function(fieldName){if(fieldName.indexOf('mlsOfficeId')!==-1){result=true;}});return result;}},{key:"componentDidMount",value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_26_lib_Segment_customTrackers__["d" /* trackAddMlsOfficePopupShown */])(Object(__WEBPACK_IMPORTED_MODULE_27_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(this.props.mls.reviewMlsErrorId!==nextProps.mls.reviewMlsErrorId&&nextProps.mls.reviewMlsErrorId!==null||this.props.mls.addMlsOfficeIdErrorId!==nextProps.mls.addMlsOfficeIdErrorId&&nextProps.mls.addMlsOfficeIdErrorId!==null){this.handleApiErrors(nextProps);if(nextProps.mls.reviewMlsErrorId){Object(__WEBPACK_IMPORTED_MODULE_26_lib_Segment_customTrackers__["O" /* trackSentReviewMlsToXaraFailure */])(Object(__WEBPACK_IMPORTED_MODULE_27_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}else if(nextProps.mls.addMlsOfficeIdErrorId){Object(__WEBPACK_IMPORTED_MODULE_26_lib_Segment_customTrackers__["c" /* trackAddMlsOfficeFailure */])(Object(__WEBPACK_IMPORTED_MODULE_27_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}}if(this.props.mls.addMlsOfficeIdErrorId!==nextProps.mls.addMlsOfficeIdErrorId&&nextProps.mls.addMlsOfficeIdErrorId===__WEBPACK_IMPORTED_MODULE_25__errors_errorids__["a" /* default */].EMAIL_NOT_VERIFIED){this.props.sendVerifyAccountEmail(__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.get(this.props.user,'mainEmail'));}if(this.props.mls.reviewMlsSuccess!==nextProps.mls.reviewMlsSuccess&&nextProps.mls.reviewMlsSuccess===true||this.props.mls.addMlsOfficeIdSuccess!==nextProps.mls.addMlsOfficeIdSuccess&&nextProps.mls.addMlsOfficeIdSuccess===true){if(nextProps.mls.addMlsOfficeIdSuccess){Object(__WEBPACK_IMPORTED_MODULE_26_lib_Segment_customTrackers__["e" /* trackAddMlsOfficeSuccess */])(Object(__WEBPACK_IMPORTED_MODULE_27_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}else if(nextProps.mls.reviewMlsSuccess){Object(__WEBPACK_IMPORTED_MODULE_26_lib_Segment_customTrackers__["P" /* trackSentReviewMlsToXaraSuccess */])(Object(__WEBPACK_IMPORTED_MODULE_27_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}this.setState({xhrInProgress:false,apiRequestError:false,apiRequestSuccess:true,errors:{apiError:null}});}}},{key:"handleApiErrors",value:function handleApiErrors(nextProps){var errorMessageKey;var errorMessage;if(nextProps.mls.reviewMlsErrorId){errorMessageKey=nextProps.mls.reviewMlsErrorId&&__WEBPACK_IMPORTED_MODULE_29_utils_mls__["a" /* MLS_ERRORS */][nextProps.mls.reviewMlsErrorId]||__WEBPACK_IMPORTED_MODULE_29_utils_mls__["a" /* MLS_ERRORS */][__WEBPACK_IMPORTED_MODULE_25__errors_errorids__["a" /* default */].UNKNOWN];}else if(nextProps.mls.addMlsOfficeIdErrorId){errorMessageKey=nextProps.mls.addMlsOfficeIdErrorId&&__WEBPACK_IMPORTED_MODULE_29_utils_mls__["a" /* MLS_ERRORS */][nextProps.mls.addMlsOfficeIdErrorId]||__WEBPACK_IMPORTED_MODULE_29_utils_mls__["a" /* MLS_ERRORS */][__WEBPACK_IMPORTED_MODULE_25__errors_errorids__["a" /* default */].UNKNOWN];}if(this.state.currentStep===SCREEN_TYPE.MLS_API&&nextProps.mls.addMlsOfficeIdErrorId===__WEBPACK_IMPORTED_MODULE_25__errors_errorids__["a" /* default */].MLS_NO_LISTINGS_FOUND){this.setState({xhrInProgress:false,apiRequestError:false,apiRequestSuccess:false,currentStep:SCREEN_TYPE.MLS_OFFICE_ID_REVIEW_NEEDED,errors:{}});}else{errorMessage=localize(errorMessageKey);this.setState({xhrInProgress:false,apiRequestError:true,apiRequestSuccess:false,errors:{apiError:errorMessage}});}}},{key:"textField",value:function textField(name,value,placeholder,disabled,type,maxLength,autosize){var _this7=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__FormField__["a" /* default */],__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({value:value,autoComplete:"off",className:classes.field,"data-tid":"form-user-".concat(name),onChange:function onChange(event){return _this7.onTextFieldChange(event,name);},onBlur:function onBlur(event){return _this7.onTextFieldBlur(event,name);},onKeyPress:function onKeyPress(event){return _this7.onTextFieldKeyPress(event,name);},id:name,placeholder:placeholder},type?{type:type}:{},autosize?{autosize:autosize}:{},{margin:"normal",helperText:this.state.errors[name],error:!!this.state.errors[name],disabled:disabled,maxLength:maxLength,inputRef:this[name]}));}},{key:"onTextFieldBlur",value:function onTextFieldBlur(event,name){var newState=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.cloneDeep(this.state);newState.touched[name]=true;this.setState(newState,this.validateAll);}},{key:"onTextFieldKeyPress",value:function onTextFieldKeyPress(event,name){if(!this.isSubmitEnabled())return;if(event.key==='Enter'){this.submitForm();}}},{key:"onTextFieldChange",value:function onTextFieldChange(event,name){this.setFieldState(name,event.target.value);}},{key:"setFieldState",value:function setFieldState(fieldName,value){var newState=__WEBPACK_IMPORTED_MODULE_24_lodash___default.a.cloneDeep(this.state);newState.touched[fieldName]=true;newState[fieldName]=value;this.setState(newState,this.validateAll);}},{key:"getFormErrors",value:function getFormErrors(includeAllField){// includeAllField - include all fields in validation, not only touched
var validateFields=null;if(this.state.currentStep===SCREEN_TYPE.MLS_API){validateFields=['mlsOfficeId'];}var foundErrors={};for(var field in __WEBPACK_IMPORTED_MODULE_16__AddMlsOfficeModalSchema__["a" /* default */]){if(validateFields.includes(field)){var validate=__WEBPACK_IMPORTED_MODULE_16__AddMlsOfficeModalSchema__["a" /* default */][field];if(validate){var error=validate(this.state[field],this.state,includeAllField);if(error){foundErrors[field]=error;}}}}return foundErrors;}},{key:"validateAll",value:function validateAll(){this.setState({errors:this.getFormErrors(false)});}}]);return InviteUserModal;}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]))||_class);InviteUserModal.propTypes={companies:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.object,mls:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.object,modalShown:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.bool,hideModal:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.func,resetModal:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.func,classes:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.object,email:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.string,showApiError:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.bool,company:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.object,user:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.object.isRequired,showErrorPopup:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.func.isRequired,selectedCompanyId:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.string,addOfficeId:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.func.isRequired,clearConnectMlsState:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.func.isRequired,sendMlsReviewRequest:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.func.isRequired,mlsName:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.string.isRequired,mlsConnectionId:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.string.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.func.isRequired,sendVerifyAccountEmail:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.func.isRequired};var mapStateToProps=function mapStateToProps(state){return{company:state.companies.rawDataById?state.companies.rawDataById[state.companies.selectedId]:null,modalShown:state.modal.modalShown,companies:state.companies,mls:state.mls,user:state.session.user,selectedCompanyId:state.companies.selectedId};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_12_redux__["b" /* bindActionCreators */])({hideModal:__WEBPACK_IMPORTED_MODULE_18_redux_modules_modal__["b" /* hideModal */],resetModal:__WEBPACK_IMPORTED_MODULE_18_redux_modules_modal__["c" /* resetModal */],showErrorPopup:__WEBPACK_IMPORTED_MODULE_19_redux_modules_companies__["H" /* showErrorPopup */],addOfficeId:__WEBPACK_IMPORTED_MODULE_14_redux_modules_mls__["d" /* addOfficeId */],sendMlsReviewRequest:__WEBPACK_IMPORTED_MODULE_14_redux_modules_mls__["q" /* sendMlsReviewRequest */],clearConnectMlsState:__WEBPACK_IMPORTED_MODULE_14_redux_modules_mls__["e" /* clearConnectMlsState */],sendVerifyAccountEmail:__WEBPACK_IMPORTED_MODULE_23_redux_modules_account__["f" /* sendVerifyAccountEmail */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(InviteUserModal));

/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_i18n_i18n__ = __webpack_require__(15);
var localize=__WEBPACK_IMPORTED_MODULE_0_i18n_i18n__["a" /* default */].loc.localize;var schema={'mlsOfficeId':function mlsOfficeId(value,state,includeAllField){if(state.touched['mlsOfficeId']||includeAllField){if(!(value||'').trim()){return localize('required-field');}}}};/* harmony default export */ __webpack_exports__["a"] = (schema);

/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_utils_users__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_redux_modules_session__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_custom_scrollbars__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_custom_scrollbars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_custom_scrollbars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_icons_KeyboardArrowDown__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_icons_KeyboardArrowDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_icons_KeyboardArrowDown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_redux_modules_mls__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_redux_modules_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_redux_modules_companies__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__FormField__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__theme_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lib_Segment_customTrackers__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lib_Segment_helpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_utils_intercom__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_utils_forms__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_utils_mls__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_i18n_i18n__ = __webpack_require__(15);
var _invalidMLSInputValue,_dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_33_i18n_i18n__["a" /* default */].loc.localize;var invalidMLSInputValue=(_invalidMLSInputValue={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_invalidMLSInputValue,'invalid-value','users-table-mls-id-invalid-value'),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_invalidMLSInputValue,'already-used','users-table-mls-id-already-used'),_invalidMLSInputValue);var SCREEN_TYPE={USERS_LIST:'USERS_LIST',CHECK_AGENT_ID_VALIDITY:'CHECK_AGENT_ID_VALIDITY'};var styles=function styles(theme){return __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectSpread___default()({},Object(__WEBPACK_IMPORTED_MODULE_31_utils_forms__["b" /* getMlsFormProps */])(theme),{/* Dialog */dialogPaper:__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({minWidth:960},theme.breakpoints.down('sm'),{minWidth:'90%'}),dialogWrapper:{position:'relative',padding:'15px 10px 0',minHeight:400,display:'flex',flexDirection:'column'},/* dialog content */dialogContentUserList:{minHeight:610,overflow:'visible'},dialogContentCheckValidity:{minHeight:530,overflow:'visible'},/* loading icon */loadingContainer:{minHeight:680,position:'relative'},/* mls system and search */mlsSystemAndSearchContainer:{justifyContent:'space-between'},mlsSystemFieldContainer:{marginBottom:23},mlsSelect:{minWidth:'362px',maxWidth:'450px',textAlign:'left','& div[class*="selectMenu"]':{paddingTop:9,paddingBottom:9}},mlsSelectedValue:{overflow:'hidden',textOverflow:'ellipsis'},mlsSelectOption:{},searchFieldContainer:{marginBottom:23},/* input field */field:{margin:0,'& input':{width:225,borderRadius:20,border:'1px solid rgba(153, 153, 153, 0.32)',boxShadow:"1px 1px 3px ".concat(theme.palette.colors.colorWithAlpha(theme.palette.common.black,0.16)),color:theme.palette.colors.colorWithAlpha(theme.palette.colors.zeta,0.75),padding:'13px 40px 12px 15px',fontFamily:'Open Sans, sans-serif',fontWeight:'normal',fontStyle:'normal',fontSize:'13px',lineHeight:'14px','&:focus, &:hover':{color:'#2888c3',borderColor:'#2888c3'},'&::placeholder':{fontFamily:'Open Sans, sans-serif',fontWeight:'normal',fontStyle:'normal',fontSize:'13px',lineHeight:'14px',color:theme.palette.colors.colorWithAlpha(theme.palette.colors.zeta,0.75)}},'& textarea':{width:'425px',display:'block'},'& [id*=helper-text]':{paddingLeft:0,color:theme.palette.error.main},'& [class*=error] input':{borderColor:"".concat(theme.palette.error.main," !important")}},inputAdornment:{position:'absolute',top:'50%',right:7,transform:'translateY(-50%)'},introMessage:{marginBottom:23,textAlign:'left','& p:not(:last-child)':{marginBottom:20},'& p':{fontSize:'16px',lineHeight:'22px',opacity:1}}},Object(__WEBPACK_IMPORTED_MODULE_14_utils_users__["g" /* getTableStyleProps */])(__WEBPACK_IMPORTED_MODULE_30__config__["_61" /* USER_TABLE_MANAGE_AGENTS */],theme),{/* user table */tableWrapper:{width:'calc(100% + 15px)',overflow:'hidden'},connectionStatus:{padding:'3px 8px',fontFamily:'Open Sans, sans-serif',fontWeight:'bold',fontStyle:'normal',fontSize:'12px',lineHeight:'14px',borderRadius:10,opacity:1,display:'inline-block'},connectionStatusConnected:{background:'#BEFAC8',color:'#287A0C'},connectionStatusNotConnected:{background:'#BFBFBF',color:theme.palette.common.black}});};var ManageMlsAgentsModal=(_dec=Object(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["N" /* withStyles */])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_inherits___default()(ManageMlsAgentsModal,_Component);function ManageMlsAgentsModal(props){var _this;__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this,ManageMlsAgentsModal);_this=__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(ManageMlsAgentsModal).call(this,props));_this.inputRefs={};_this.scrollbarRef=__WEBPACK_IMPORTED_MODULE_10_react___default.a.createRef(null);var stateFromProps=_this.getStateFromProps(props);var companyUsers=stateFromProps.users;_this.hideAllMlsFields=_this.hideAllMlsFields.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.cleanMlsIdValue=_this.cleanMlsIdValue.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.clickAwayHandler=_this.clickAwayHandler.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.handleScrollStart=_this.handleScrollStart.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this));var searchTerm='';var usersToRender;var showingSearchResults;var mlsSystem=null;if(_this.props.preselectUserId){usersToRender=companyUsers.filter(function(u){return u.userId===_this.props.preselectUserId;});if(usersToRender.length){showingSearchResults=true;searchTerm=usersToRender[0].name;// find first connectionId for this user to avoid preselecting connection where user does not have record
var preselectedAgentRecord=_this.props.mls.agentsMlsIds.find(function(conn){return conn.userId===_this.props.preselectUserId;});var preselectConnectionId=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(preselectedAgentRecord,'mlsConnectionId');if(preselectConnectionId){mlsSystem=_this.props.connections.find(function(item){return item.mlsConnectionId===preselectConnectionId;});}else{// no mls connection for this user in any MLS board
mlsSystem=_this.props.connections[0];}}else{showingSearchResults=false;mlsSystem=_this.props.connections[0];}}else{// when modal is opened from mls-connection section
usersToRender=companyUsers;showingSearchResults=false;mlsSystem=_this.props.connections.find(function(item){return item.mlsConnectionId===_this.props.mlsConnectionId;});}var newExternalId=_this.getNewExternalId();var shownMlsFields={};shownMlsFields[mlsSystem.mlsConnectionId]={};var focusedField={};var focusFieldOnMount;if(_this.props.usersPage&&_this.props.preselectUserId&&mlsSystem.mlsConnectionId&&_this.props.selfStartMlsIdsForUser.length<2){shownMlsFields[mlsSystem.mlsConnectionId][_this.props.preselectUserId]=true;focusedField[mlsSystem.mlsConnectionId]={};focusedField[mlsSystem.mlsConnectionId][_this.props.preselectUserId]=true;focusFieldOnMount="input-mls-".concat(mlsSystem.mlsConnectionId,"-").concat(_this.props.preselectUserId);}else if(!_this.props.usersPage&&usersToRender.length===1&&!newExternalId[mlsSystem.mlsConnectionId][usersToRender[0].userId]){shownMlsFields[mlsSystem.mlsConnectionId][usersToRender[0].userId]=true;focusFieldOnMount="input-mls-".concat(mlsSystem.mlsConnectionId,"-").concat(usersToRender[0].userId);}_this.state=__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectSpread___default()({},stateFromProps,{currentStep:SCREEN_TYPE.USERS_LIST,mlsSystem:mlsSystem,dropdownOpened:_this.props.usersPage&&_this.props.selfStartMlsIdsForUser.length>1,preselectUserId:_this.props.preselectUserId,usersToRender:usersToRender,// sorting
sortKey:Object(__WEBPACK_IMPORTED_MODULE_14_utils_users__["f" /* getSavedTableSettings */])(_this.props.settings,__WEBPACK_IMPORTED_MODULE_30__config__["_61" /* USER_TABLE_MANAGE_AGENTS */],'sortKey'),sortOrder:Object(__WEBPACK_IMPORTED_MODULE_14_utils_users__["f" /* getSavedTableSettings */])(_this.props.settings,__WEBPACK_IMPORTED_MODULE_30__config__["_61" /* USER_TABLE_MANAGE_AGENTS */],'sortOrder'),// search
searchTerm:searchTerm,showingSearchResults:showingSearchResults,// mls ID related
focusFieldOnMount:focusFieldOnMount,newExternalId:newExternalId,shownMlsFields:shownMlsFields,focusedField:focusedField,mlsFieldsWithErrors:{},updatingMlsIdForUsers:{}});_this.handleOpenIntercom=_this.handleOpenIntercom.bind(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_assertThisInitialized___default()(_this));return _this;}__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(ManageMlsAgentsModal,[{key:"getStateFromProps",value:function getStateFromProps(props){var _props$companies=props.companies,rawDataById=_props$companies.rawDataById,selectedId=_props$companies.selectedId;var company=rawDataById[selectedId];var users=company.users;return{users:users};}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var selectedConnectionId=this.state.mlsSystem.mlsConnectionId;this.setState(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectSpread___default()({},this.getStateFromProps(nextProps)));if(this.state.currentStep===SCREEN_TYPE.CHECK_AGENT_ID_VALIDITY){if(!__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.isEqual(this.props.mls.addingAgentMlsIdSuccess,nextProps.mls.addingAgentMlsIdSuccess)&&nextProps.mls.addingAgentMlsIdSuccess.find(function(item){return item.mlsConnectionId===selectedConnectionId;})||!__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.isEqual(this.props.mls.editingAgentMlsIdSuccess,nextProps.mls.editingAgentMlsIdSuccess)&&nextProps.mls.editingAgentMlsIdSuccess.find(function(item){return item.mlsConnectionId===selectedConnectionId;})){this.setState({currentStep:SCREEN_TYPE.USERS_LIST});}}if(!__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.isEqual(this.props.mls.addingAgentMlsIdErrorId,nextProps.mls.addingAgentMlsIdErrorId)&&nextProps.mls.addingAgentMlsIdErrorId.find(function(item){return item.mlsConnectionId===selectedConnectionId;})||!__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.isEqual(this.props.mls.editingAgentMlsIdErrorId,nextProps.mls.editingAgentMlsIdErrorId)&&nextProps.mls.editingAgentMlsIdErrorId.find(function(item){return item.mlsConnectionId===selectedConnectionId;})){this.handleApiErrors(nextProps);}}},{key:"render",value:function render(){var _classNames,_this2=this;var _this$props=this.props,modalShown=_this$props.modalShown,resetModal=_this$props.resetModal,classes=_this$props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["d" /* Dialog */],{open:modalShown,"aria-labelledby":"alert-dialog-title","aria-describedby":"alert-dialog-description",onExited:resetModal,BackdropProps:{style:{backgroundColor:'rgba(46, 63, 79, 0.4)'}},classes:{paper:classes.dialogPaper},PaperProps:{style:{border:0,width:309,borderRadius:5,boxShadow:'0px 4px 24px rgba(0, 0, 0, 0.08)'}}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.dialogWrapper},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["p" /* IconButton */],{className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()((_classNames={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames,classes.closeDialog,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames,'closeDialog',true),_classNames)),component:"span","aria-label":"Close",onClick:function onClick(){return _this2.closeDialog();}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__theme_icons__["_11" /* XIcon */],{className:classes.closeDialogIcon})),function(){if(_this2.state.currentStep===SCREEN_TYPE.CHECK_AGENT_ID_VALIDITY&&(_this2.props.mls.addingAgentMlsIdXhrInProgress.length||_this2.props.mls.editingAgentMlsIdXhrInProgress.length)){return _this2.renderLoading();}else if(_this2.state.currentStep===SCREEN_TYPE.CHECK_AGENT_ID_VALIDITY){return _this2.renderCheckAgentIdValidity();}else{return _this2.renderContent();}}()));}},{key:"closeDialog",value:function closeDialog(){this.props.onClose(false/*shouldReloadList*/);}},{key:"handleConfirmMlsId",value:function handleConfirmMlsId(){Object(__WEBPACK_IMPORTED_MODULE_27_lib_Segment_customTrackers__["B" /* trackMlsConfirmAgentValidity */])(Object(__WEBPACK_IMPORTED_MODULE_28_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));var agentIdsWithError=this.getAgentIdsToConfirmRemoval();for(var i=0;i<agentIdsWithError.length;i++){this.updateExternalIdForUser(agentIdsWithError[i].userId,agentIdsWithError[i].mlsConnectionId,agentIdsWithError[i].agentMlsId||agentIdsWithError[i].newAgentMlsId,true/* forceAddition */);}}},{key:"handleRemoveMlsId",value:function handleRemoveMlsId(){var updatingMlsIdForUsers=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.clone(this.state.updatingMlsIdForUsers);updatingMlsIdForUsers[this.state.mlsSystem.mlsConnectionId]={};var shownMlsFields=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.clone(this.state.shownMlsFields);shownMlsFields[this.state.mlsSystem.mlsConnectionId]={};this.setState({shownMlsFields:shownMlsFields,updatingMlsIdForUsers:updatingMlsIdForUsers,currentStep:SCREEN_TYPE.USERS_LIST});this.resetPreviousAPIMessageFieldValue();this.props.clearConnectMlsState();}},{key:"getAgentIdsToConfirmRemoval",value:function getAgentIdsToConfirmRemoval(){var selectedConnectionId=this.state.mlsSystem.mlsConnectionId;var agentIdsWithError=[];this.props.mls.addingAgentMlsIdErrorId.forEach(function(item){if(function(item){return item.mlsConnectionId===selectedConnectionId&&item.errorId===__WEBPACK_IMPORTED_MODULE_26__errors_errorids__["a" /* default */].AGENT_NO_LISTINGS_FOUND&&item.forceAddition===false;}){agentIdsWithError.push(item);}});this.props.mls.editingAgentMlsIdErrorId.forEach(function(item){if(function(item){return item.mlsConnectionId===selectedConnectionId&&item.errorId===__WEBPACK_IMPORTED_MODULE_26__errors_errorids__["a" /* default */].AGENT_NO_LISTINGS_FOUND&&item.forceAddition===false;}){agentIdsWithError.push(item);}});return agentIdsWithError;}},{key:"renderCheckAgentIdValidity",value:function renderCheckAgentIdValidity(){var _this3=this;var classes=this.props.classes;var headerIcon=__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__theme_icons__["B" /* IconInfoRounded */],{className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()(classes.headerIcon,classes.headerIconInfo)});var popupTitle=localize('mls-error-manage-agents-screen-title-no-listings-found');var agentIdsWithError=this.getAgentIdsToConfirmRemoval().map(function(item){return item.agentMlsId||item.newAgentMlsId;});var errorMessage=localize('mls-error-manage-agents-no-listings-found',[agentIdsWithError.join(','),this.state.mlsSystem.name]);var forceAdditionErrorMessages=this.getForceAdditionErrorMessage();return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["g" /* DialogTitle */],{variant:"body1",color:"default",className:classes.dialogTitle},headerIcon," ",popupTitle),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["f" /* DialogContent */],{className:classes.dialogContentCheckValidity},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{container:true,direction:"column"},forceAdditionErrorMessages.length>0&&forceAdditionErrorMessages,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{item:true,className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()(classes.failureMessage,classes.feedbackMessage)},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["M" /* Typography */],{variant:"body2",dangerouslySetInnerHTML:{__html:errorMessage}}),forceAdditionErrorMessages.length>0&&this.renderContactForHelp()))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["e" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{item:true,container:true,direction:"row",justify:"flex-end",className:classes.buttonsContainer},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["a" /* Button */],{variant:"outlined",color:"primary","data-tid":"button-remove-mls-id-form",className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()(classes.button,classes.buttonBack),onClick:function onClick(){return _this3.handleRemoveMlsId();}},localize('mls-error-screen-remove-mls-id')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["a" /* Button */],{variant:"contained",color:"primary","data-tid":"button-confirm-agent-mls-id",className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()(classes.button,classes.buttonPrimary),onClick:function onClick(){return _this3.handleConfirmMlsId();}},localize('mls-error-screen-confirm')))));}},{key:"renderLoading",value:function renderLoading(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.loadingContainer},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.loadingContent},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__theme_icons__["Y" /* SpinnerIcon */],{className:classes.loadingIcon}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["M" /* Typography */],{className:classes.loadingMessage,variant:"body2"},localize('mls-popup-saving-form'))));}},{key:"getForceAdditionErrorMessage",value:function getForceAdditionErrorMessage(){var classes=this.props.classes;var result=[];var forceAdditionRequestErrors=[];var selectedConnectionId=this.state.mlsSystem.mlsConnectionId;this.props.mls.addingAgentMlsIdErrorId.forEach(function(item){if(item.mlsConnectionId===selectedConnectionId&&item.forceAddition){forceAdditionRequestErrors.push(item);}});this.props.mls.editingAgentMlsIdErrorId.forEach(function(item){if(item.mlsConnectionId===selectedConnectionId&&item.forceAddition){forceAdditionRequestErrors.push(item);}});forceAdditionRequestErrors.forEach(function(item){var errorMessageKey=item.errorId&&__WEBPACK_IMPORTED_MODULE_32_utils_mls__["a" /* MLS_ERRORS */][item.errorId]||__WEBPACK_IMPORTED_MODULE_32_utils_mls__["a" /* MLS_ERRORS */][__WEBPACK_IMPORTED_MODULE_26__errors_errorids__["a" /* default */].UNKNOWN];var errorMessage=localize('mls-error-manage-agents-no-listings-found-force-addition',[item.agentMlsId||item.newAgentMlsId,item.mlsConnectionId]);result.push(__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["M" /* Typography */],{className:classes.errorMessage,variant:"body2",dangerouslySetInnerHTML:{__html:"".concat(errorMessage," ").concat(localize(errorMessageKey))}}));});return result;}},{key:"handleOpenIntercom",value:function handleOpenIntercom(){Object(__WEBPACK_IMPORTED_MODULE_29_utils_intercom__["a" /* openIntercomChat */])(null,true,this.props.showErrorPopup);}},{key:"renderContent",value:function renderContent(){var _classNames2,_this4=this;var classes=this.props.classes;var _this$state=this.state,searchTerm=_this$state.searchTerm,mlsSystem=_this$state.mlsSystem,dropdownOpened=_this$state.dropdownOpened;var selectedConnectionId=this.state.mlsSystem.mlsConnectionId;var isSelectDisabled=this.props.connections.length===1||// disable dropdown while loading, otherwise on very slow connection response might 
// arrive after user changes this.state.mlsSystem using dropdown
this.props.mls.addingAgentMlsIdXhrInProgress.find(function(item){return item.mlsConnectionId===selectedConnectionId;})||this.props.mls.editingAgentMlsIdXhrInProgress.find(function(item){return item.mlsConnectionId===selectedConnectionId;})||this.props.mls.deletingAgentMlsIdXhrInProgress.find(function(item){return item.mlsConnectionId===selectedConnectionId;});return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["g" /* DialogTitle */],{variant:"body1",color:"default",className:classes.dialogTitle},localize('mls-manage-agents-popup-header')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["f" /* DialogContent */],{className:classes.dialogContentUserList},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{container:true,direction:"column"},!this.props.usersPage&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{item:true,className:classes.introMessage},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["M" /* Typography */],{variant:"body2"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["r" /* Link */],{className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()((_classNames2={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames2,classes.introMessageLink,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames2,'introMessageLink',true),_classNames2)),onClick:function onClick(){return _this4.handleAddUserToTeam();}},localize('mls-manage-agents-popup-add-users-1')),"\xA0",localize('if they are not yet in the team.'))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{container:true,direction:"row",className:classes.mlsSystemAndSearchContainer},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{item:true,className:classes.mlsSystemFieldContainer},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["C" /* Select */],{disabled:isSelectDisabled,className:classes.mlsSelect,id:"select-mls-system",value:mlsSystem,open:dropdownOpened,"native":false,displayEmpty:true,renderValue:function renderValue(option){if(option){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.mlsSelectedValue},option.name);}else{return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.mlsSelectedValue},localize('mls-please-select-mls-connection'));}},disableUnderline:true,IconComponent:__WEBPACK_IMPORTED_MODULE_17__material_ui_icons_KeyboardArrowDown___default.a,onChange:function onChange(event){return _this4.handleConnectionDropdownChange(event);},onOpen:function onOpen(){return _this4.handleConnectionDropdownOpen();},onClose:function onClose(){return _this4.handleConnectionDropdownClose();}},this.props.connections.map(function(option,index){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["x" /* MenuItem */],{className:classes.mlsSelectOption,key:option.mlsConnectionId,value:option},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",null,option.name));}))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{item:true,className:classes.searchFieldContainer},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{item:true,className:classes.textFieldWrapper},this.textField('searchTerm',searchTerm,localize('mls-search-for-agent-placeholder'),null,null,null,false,this.state.showingSearchResults?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["L" /* Tooltip */],{placement:"top",title:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["M" /* Typography */],{variant:"body2",className:classes.infoTooltipText},localize('mls-clear-search')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span",{className:classes.tooltipArrow})),classes:{tooltip:classes.infoTooltip}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__theme_icons__["g" /* ClearSearchIcon */],null)):__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__theme_icons__["T" /* SearchIcon */],null))))),this.renderUserTable(__WEBPACK_IMPORTED_MODULE_30__config__["_61" /* USER_TABLE_MANAGE_AGENTS */],this.state.newExternalId))));}},{key:"handleAddUserToTeam",value:function handleAddUserToTeam(){Object(__WEBPACK_IMPORTED_MODULE_27_lib_Segment_customTrackers__["z" /* trackManageAgentMlsPopupAddUsers */])(Object(__WEBPACK_IMPORTED_MODULE_28_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));var pathName="".concat(location.origin,"/#").concat(this.props.company.id,"/users?show-add-users-modal=1");window.open(pathName,'_blank');}},{key:"handleConnectionDropdownChange",value:function handleConnectionDropdownChange(event){this.setState({mlsSystem:event.target.value});}},{key:"handleConnectionDropdownOpen",value:function handleConnectionDropdownOpen(){this.setState({dropdownOpened:true});}},{key:"handleConnectionDropdownClose",value:function handleConnectionDropdownClose(){this.setState({dropdownOpened:false});}},{key:"getCompanyUsers",value:function getCompanyUsers(){var _this$props$companies=this.props.companies,rawDataById=_this$props$companies.rawDataById,selectedId=_this$props$companies.selectedId;var company=rawDataById[selectedId];var users=company.users;return users;}},{key:"renderUserTable",value:function renderUserTable(tableId,externalIds){var _this5=this,_classNames3,_classNames4,_classNames5,_classNames6,_classNames8;var classes=this.props.classes;var _this$state2=this.state,sortKey=_this$state2.sortKey,sortOrder=_this$state2.sortOrder;var usersToRender=this.state.usersToRender.map(function(user){var originalExternalIdValue=_this5.getOriginalMlsIdForAgent(_this5.state.mlsSystem.mlsConnectionId,user.userId);return __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectSpread___default()({},user,{mlsConnected:Boolean(originalExternalIdValue),originalAgentMlsId:originalExternalIdValue});});usersToRender=Object(__WEBPACK_IMPORTED_MODULE_14_utils_users__["j" /* sortUsers */])(usersToRender,sortKey,sortOrder);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{className:classes.tableWrapper},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["F" /* Table */],{className:classes.table},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["I" /* TableHead */],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["J" /* TableRow */],{className:classes.tableHeadRow},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["H" /* TableCell */],{padding:"dense",className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()(classes.noBorderedCell,classes.tableNameCellHeader,classes.tableCellHeader,classes.tableHasSortArrow)},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["p" /* IconButton */],{className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()((_classNames3={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames3,classes.sortArrow,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames3,'sortArrow',true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames3,'desc',sortKey===__WEBPACK_IMPORTED_MODULE_30__config__["_46" /* TABLE_COLUMNS */].FULL_NAME&&sortOrder===__WEBPACK_IMPORTED_MODULE_30__config__["_36" /* SORT_ORDER */].DESC),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames3,'active',sortKey===__WEBPACK_IMPORTED_MODULE_30__config__["_46" /* TABLE_COLUMNS */].FULL_NAME),_classNames3)),component:"span","aria-label":localize('users-table-change-sorting-order'),onClick:function onClick(){return Object(__WEBPACK_IMPORTED_MODULE_14_utils_users__["i" /* sortTable */])(_this5,tableId,__WEBPACK_IMPORTED_MODULE_30__config__["_46" /* TABLE_COLUMNS */].FULL_NAME,_this5.props.writeUserSettings);}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__theme_icons__["X" /* SortArrow */],{className:classes.sortArrowIcon})),localize('users-table-header-name')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["H" /* TableCell */],{padding:"dense",className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()(classes.noBorderedCell,classes.tableEmailCellHeader,classes.tableCellHeader,classes.tableHasSortArrow)},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["p" /* IconButton */],{className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()((_classNames4={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames4,classes.sortArrow,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames4,'sortArrow',true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames4,'desc',sortKey===__WEBPACK_IMPORTED_MODULE_30__config__["_46" /* TABLE_COLUMNS */].EMAIL&&sortOrder===__WEBPACK_IMPORTED_MODULE_30__config__["_36" /* SORT_ORDER */].DESC),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames4,'active',sortKey===__WEBPACK_IMPORTED_MODULE_30__config__["_46" /* TABLE_COLUMNS */].EMAIL),_classNames4)),component:"span","aria-label":localize('users-table-change-sorting-order'),onClick:function onClick(){return Object(__WEBPACK_IMPORTED_MODULE_14_utils_users__["i" /* sortTable */])(_this5,tableId,__WEBPACK_IMPORTED_MODULE_30__config__["_46" /* TABLE_COLUMNS */].EMAIL,_this5.props.writeUserSettings);}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__theme_icons__["X" /* SortArrow */],{className:classes.sortArrowIcon})),localize('users-table-header-email')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["H" /* TableCell */],{padding:"none",className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()(classes.tableMLSCellHeader,classes.noBorderedCell,classes.tableCellHeader,classes.tableHasSortArrow)},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["p" /* IconButton */],{className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()((_classNames5={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames5,classes.sortArrow,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames5,'sortArrow',true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames5,'desc',sortKey===__WEBPACK_IMPORTED_MODULE_30__config__["_46" /* TABLE_COLUMNS */].MLS_ID_TYPE2&&sortOrder===__WEBPACK_IMPORTED_MODULE_30__config__["_36" /* SORT_ORDER */].DESC),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames5,'active',sortKey===__WEBPACK_IMPORTED_MODULE_30__config__["_46" /* TABLE_COLUMNS */].MLS_ID_TYPE2),_classNames5)),component:"span","aria-label":localize('users-table-change-sorting-order'),onClick:function onClick(){return Object(__WEBPACK_IMPORTED_MODULE_14_utils_users__["i" /* sortTable */])(_this5,tableId,__WEBPACK_IMPORTED_MODULE_30__config__["_46" /* TABLE_COLUMNS */].MLS_ID_TYPE2,_this5.props.writeUserSettings);}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__theme_icons__["X" /* SortArrow */],{className:classes.sortArrowIcon})),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("p",{className:classes.tableMLSCellHeaderLabel},localize('users-table-header-mls')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["L" /* Tooltip */],{placement:"top",title:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["M" /* Typography */],{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()(classes.infoTooltipText,classes.infoTooltipCentered),dangerouslySetInnerHTML:{__html:localize('users-table-header-mls-tooltip-agents-modal')}}),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span",{className:classes.tooltipArrow})),classes:{tooltip:classes.infoTooltip}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["p" /* IconButton */],{className:classes.infoIconButton,color:"primary",component:"span",disableRipple:true},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__theme_icons__["N" /* Info */],null)))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["H" /* TableCell */],{padding:"dense",className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()(classes.noBorderedCell,classes.tableConnectionStatusCellHeader,classes.tableCellHeader,classes.tableHasSortArrow)},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["p" /* IconButton */],{className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()((_classNames6={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames6,classes.sortArrow,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames6,'sortArrow',true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames6,'desc',sortKey===__WEBPACK_IMPORTED_MODULE_30__config__["_46" /* TABLE_COLUMNS */].CONNECTION_STATUS&&sortOrder===__WEBPACK_IMPORTED_MODULE_30__config__["_36" /* SORT_ORDER */].DESC),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames6,'active',sortKey===__WEBPACK_IMPORTED_MODULE_30__config__["_46" /* TABLE_COLUMNS */].CONNECTION_STATUS),_classNames6)),component:"span","aria-label":localize('users-table-change-sorting-order'),onClick:function onClick(){return Object(__WEBPACK_IMPORTED_MODULE_14_utils_users__["i" /* sortTable */])(_this5,tableId,__WEBPACK_IMPORTED_MODULE_30__config__["_46" /* TABLE_COLUMNS */].CONNECTION_STATUS,_this5.props.writeUserSettings);}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__theme_icons__["X" /* SortArrow */],{className:classes.sortArrowIcon})),localize('users-table-header-connection-status'))))),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_custom_scrollbars__["Scrollbars"],{ref:this.scrollbarRef,style:{height:410},autoHide:false,onScrollStart:this.handleScrollStart,renderThumbVertical:function renderThumbVertical(_ref){var style=_ref.style,props=__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_ref,["style"]);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({},props,{style:__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectSpread___default()({},style,{width:8,backgroundColor:'#6F99BD',opacity:0.5,borderRadius:4})}));}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["c" /* ClickAwayListener */],{onClickAway:this.clickAwayHandler},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["F" /* Table */],{className:classes.table,onMouseLeave:function onMouseLeave(){return _this5.hideAllMlsFields(false,true);}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["G" /* TableBody */],null,usersToRender.length===0?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["J" /* TableRow */],{key:'user-not-found',hover:true,className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({},classes.tableBodyRow,true))},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["H" /* TableCell */],{padding:"dense",colSpan:4,className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()(classes.tableCellBody,classes.tableNotFoundCellBody)},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["M" /* Typography */],{variant:"body1",className:classes.noUsersFound},localize('mls-agents-table-no-users-found')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["a" /* Button */],{variant:"contained","data-tid":"button-user-add",color:"primary",onClick:function onClick(){return _this5.handleAddUserToTeam();},className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()((_classNames8={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames8,classes.buttonAddUsers,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames8,'buttonAddUsers',true),_classNames8))},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__theme_icons__["s" /* IconAddUsers */],{className:classes.iconAddUsers}),localize('mls-agents-table-add-user-to-team'))))):this.renderUserRows(usersToRender,externalIds))))));}},{key:"handleScrollStart",value:function handleScrollStart(){this.hideAllMlsFields();}},{key:"clickAwayHandler",value:function clickAwayHandler(e){var target=e.target.nodeType===Node.TEXT_NODE?e.target.parentElement:e.target;var isAddUserButton=target.closest('.introMessageLink')||target.closest('.buttonAddUsers')||target.closest('.closeDialog');if(isAddUserButton)return;this.hideAllMlsFields(true);}},{key:"getOriginalMlsIdForAgent",value:function getOriginalMlsIdForAgent(mlsConnectionId,userId,props){var agentRecord=(props||this.props).mls.agentsMlsIds.find(function(conn){return conn.userId===userId&&conn.mlsConnectionId===mlsConnectionId;});var originalExternalIdValue=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(agentRecord,'agentMlsId','');return originalExternalIdValue;}},{key:"getMongoAgentId",value:function getMongoAgentId(mlsConnectionId,userId){var agentRecord=this.props.mls.agentsMlsIds.find(function(conn){return conn.userId===userId&&conn.mlsConnectionId===mlsConnectionId;});return __WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(agentRecord,'_id');}},{key:"renderUserRows",value:function renderUserRows(usersToRender,externalIds){var _this6=this;var mlsSystem=this.state.mlsSystem;var _this$props2=this.props,currentUserEmail=_this$props2.currentUserEmail,classes=_this$props2.classes;return usersToRender.map(function(user,index){var _encodeUser=Object(__WEBPACK_IMPORTED_MODULE_14_utils_users__["d" /* encodeUser */])(user),name=_encodeUser.name,email=_encodeUser.email,userId=_encodeUser.userId;var key="user-row-".concat(index);return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["J" /* TableRow */],{key:key,hover:true,className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()({},classes.tableBodyRow,true))},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["H" /* TableCell */],{padding:"dense",className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()(classes.tableCellBody,classes.tableNameCellBody)},currentUserEmail===email?localize('users-table-name-you',name):name),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["H" /* TableCell */],{padding:"dense",className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()(classes.tableCellBody,classes.tableEmailCellBody)},email),_this6.renderMLSCell(userId,_this6.state.mlsSystem.mlsConnectionId,_this6.state.newExternalId[mlsSystem.mlsConnectionId][userId]),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["H" /* TableCell */],{padding:"dense",className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()(classes.tableCellBody,classes.tableConnectionStatusCellBody)},user.mlsConnected?__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["M" /* Typography */],{className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()(classes.connectionStatusConnected,classes.connectionStatus),variant:"body2"},localize('users-table-mls-connected')):__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["M" /* Typography */],{className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()(classes.connectionStatusNotConnected,classes.connectionStatus),variant:"body2"},localize('users-table-mls-not-connected'))));},this);}},{key:"componentDidMount",value:function componentDidMount(){var _this7=this;Object(__WEBPACK_IMPORTED_MODULE_27_lib_Segment_customTrackers__["A" /* trackManageAgentMlsPopupShown */])(Object(__WEBPACK_IMPORTED_MODULE_28_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));if(this.state.focusFieldOnMount){setTimeout(function(){_this7.inputRefs[_this7.state.focusFieldOnMount].current&&Object(__WEBPACK_IMPORTED_MODULE_31_utils_forms__["a" /* focusSelect */])(_this7.inputRefs[_this7.state.focusFieldOnMount].current);},250);}}},{key:"getNewExternalId",value:function getNewExternalId(){var _this8=this;var newExternalId={};var companyUsers=this.getCompanyUsers();this.props.connections.forEach(function(currentConnection){companyUsers.forEach(function(currentUser){if(currentUser.userId){var originalExternalIdValue=_this8.getOriginalMlsIdForAgent(currentConnection.mlsConnectionId,currentUser.userId);if(!newExternalId[currentConnection.mlsConnectionId]){newExternalId[currentConnection.mlsConnectionId]={};}newExternalId[currentConnection.mlsConnectionId][currentUser.userId]=originalExternalIdValue;}});});return newExternalId;}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){var _this9=this;var _prevProps$companies=prevProps.companies,rawDataByIdPrev=_prevProps$companies.rawDataById,selectedIdPrev=_prevProps$companies.selectedId;var companyPrev=rawDataByIdPrev[selectedIdPrev];var usersPrev=companyPrev.users;var usersUpdated=this.getCompanyUsers();if(!__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.isEqual(usersPrev,usersUpdated)){if(this.state.showingSearchResults){this.setState(this.getSearchResults());}else{this.setState({usersToRender:this.state.users});}}usersUpdated.forEach(function(updatedUser,index){var oldUser=usersPrev.find(function(u){return u.email===updatedUser.email;});if(oldUser){_this9.props.connections.forEach(function(_ref2){var mlsConnectionId=_ref2.mlsConnectionId;var newExternalIdValue=_this9.getOriginalMlsIdForAgent(mlsConnectionId,oldUser.userId,_this9.props);var previousExternalIdsValue=_this9.getOriginalMlsIdForAgent(mlsConnectionId,oldUser.userId,prevProps);if(newExternalIdValue!==previousExternalIdsValue){if(!__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.isEqual(_this9.props.mls.addingAgentMlsIdSuccess,prevProps.mls.addingAgentMlsIdSuccess)&&_this9.props.mls.addingAgentMlsIdSuccess.find(function(item){return item.userId===updatedUser.userId&&item.mlsConnectionId===mlsConnectionId;})||!__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.isEqual(_this9.props.mls.editingAgentMlsIdSuccess,prevProps.mls.editingAgentMlsIdSuccess)&&_this9.props.mls.editingAgentMlsIdSuccess.find(function(item){return item.userId===updatedUser.userId&&item.mlsConnectionId===mlsConnectionId;})||!__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.isEqual(_this9.props.mls.deletingAgentMlsIdSuccess,prevProps.mls.deletingAgentMlsIdSuccess)&&_this9.props.mls.deletingAgentMlsIdSuccess.find(function(item){return item.userId===updatedUser.userId&&item.mlsConnectionId===mlsConnectionId;})){var shouldUpdateState=false;if(!__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.isEqual(__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.omit(updatingMlsIdForUsers,["[".concat(mlsConnectionId,"][").concat(updatedUser.userId,"]")]),_this9.state.updatingMlsIdForUsers)){shouldUpdateState=true;}shouldUpdateState=true;var updatingMlsIdForUsers=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.clone(_this9.state.updatingMlsIdForUsers);if(__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(updatingMlsIdForUsers,"[".concat(mlsConnectionId,"][").concat(updatedUser.userId,"]"))){delete updatingMlsIdForUsers[mlsConnectionId][updatedUser.userId];}var shownMlsFields=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.clone(_this9.state.shownMlsFields);if(__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(shownMlsFields,"[".concat(mlsConnectionId,"][").concat(updatedUser.userId,"]"))){delete shownMlsFields[mlsConnectionId][updatedUser.userId];}var focusedField=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.clone(_this9.state.focusedField);if(__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(focusedField,"[".concat(mlsConnectionId,"][").concat(updatedUser.userId,"]"))){delete focusedField[mlsConnectionId][updatedUser.userId];}var mlsFieldsWithErrors=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.clone(_this9.state.mlsFieldsWithErrors);if(__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(mlsFieldsWithErrors,"[".concat(mlsConnectionId,"][").concat(updatedUser.userId,"]"))){delete mlsFieldsWithErrors[mlsConnectionId][updatedUser.userId];}// update existing external id record for current user
if(shouldUpdateState){_this9.setState({updatingMlsIdForUsers:updatingMlsIdForUsers,shownMlsFields:shownMlsFields,focusedField:focusedField,mlsFieldsWithErrors:mlsFieldsWithErrors});}}}});}else if(updatedUser.userId){// initialize to default (empty string) for users added in new tab
var newExternalId=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.clone(_this9.state.newExternalId);_this9.props.connections.forEach(function(_ref3){var mlsConnectionId=_ref3.mlsConnectionId;var originalExternalIdValue=_this9.getOriginalMlsIdForAgent(mlsConnectionId,updatedUser.userId);if(!newExternalId[mlsConnectionId]){newExternalId[mlsConnectionId]={};}newExternalId[mlsConnectionId][updatedUser.userId]=originalExternalIdValue;_this9.setState({newExternalId:newExternalId});});}});// delete "updating" indicator for user and focus field
if(this.state.currentStep===SCREEN_TYPE.USERS_LIST&&(!__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.isEmpty(this.props.mls.addingAgentMlsIdErrorId)||!__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.isEmpty(this.props.mls.editingAgentMlsIdErrorId)||!__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.isEmpty(this.props.mls.deletingAgentMlsIdErrorId))){var updatingMlsIdForUsers=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.clone(this.state.updatingMlsIdForUsers);this.props.connections.forEach(function(_ref4){var mlsConnectionId=_ref4.mlsConnectionId;if(updatingMlsIdForUsers[mlsConnectionId]){Object.keys(updatingMlsIdForUsers[mlsConnectionId]).map(function(currentUserId){var apiError=_this9.getApiErrorForUserAndConnection(currentUserId,mlsConnectionId);if(apiError){if(__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(_this9.state.updatingMlsIdForUsers,"[".concat(mlsConnectionId,"][").concat(currentUserId,"]"))){var shownMlsFields=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.clone(_this9.state.shownMlsFields);if(!shownMlsFields[mlsConnectionId]){shownMlsFields[mlsConnectionId]={};}shownMlsFields[mlsConnectionId][currentUserId]=true;delete updatingMlsIdForUsers[mlsConnectionId][currentUserId];_this9.setState({updatingMlsIdForUsers:updatingMlsIdForUsers,shownMlsFields:shownMlsFields});}}});}});}}},{key:"renderContactForHelp",value:function renderContactForHelp(){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["M" /* Typography */],{variant:"body2"},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["r" /* Link */],{onClick:this.handleOpenIntercom},localize('mls-error-screen-contact-for-help-1')),"\xA0",localize('mls-error-screen-contact-for-help-2'));}},{key:"handleApiErrors",value:function handleApiErrors(nextProps){var selectedConnectionId=this.state.mlsSystem.mlsConnectionId;if(this.state.currentStep===SCREEN_TYPE.USERS_LIST&&(!__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.isEqual(this.props.mls.addingAgentMlsIdErrorId,nextProps.mls.addingAgentMlsIdErrorId)&&nextProps.mls.addingAgentMlsIdErrorId.find(function(item){return item.mlsConnectionId===selectedConnectionId&&item.errorId===__WEBPACK_IMPORTED_MODULE_26__errors_errorids__["a" /* default */].AGENT_NO_LISTINGS_FOUND;})||!__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.isEqual(this.props.mls.editingAgentMlsIdErrorId,nextProps.mls.editingAgentMlsIdErrorId)&&nextProps.mls.editingAgentMlsIdErrorId.find(function(item){return item.mlsConnectionId===selectedConnectionId&&item.errorId===__WEBPACK_IMPORTED_MODULE_26__errors_errorids__["a" /* default */].AGENT_NO_LISTINGS_FOUND;}))){this.setState({currentStep:SCREEN_TYPE.CHECK_AGENT_ID_VALIDITY});}}},{key:"textField",value:function textField(name,value,placeholder,disabled,type,maxLength,autosize,icon){var _this10=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__FormField__["a" /* default */],__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({value:value,autoComplete:"off",className:classes.field,"data-tid":"form-user-".concat(name),onChange:function onChange(event){return _this10.onTextFieldChange(event,name);},onKeyPress:function onKeyPress(event){return _this10.onTextFieldKeyPress(event,name);},id:name,placeholder:placeholder},type?{type:type}:{},autosize?{autosize:autosize}:{},{margin:"normal",disabled:disabled,maxLength:maxLength,inputRef:this[name]},icon?{inputProps:{endAdornment:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["q" /* InputAdornment */],{position:"end",className:classes.inputAdornment},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["p" /* IconButton */],{"aria-label":"Search",onClick:function onClick(){return _this10.handleSearchIconClick();}},icon))}}:{}));}},{key:"handleSearchIconClick",value:function handleSearchIconClick(){if(this.state.showingSearchResults){this.setState({searchTerm:'',showingSearchResults:false,preselectUserId:null,usersToRender:this.state.users});}else{this.setState(this.getSearchResults());}}},{key:"onTextFieldKeyPress",value:function onTextFieldKeyPress(event,name){if(event.key==='Enter'){this.setState(this.getSearchResults());}}},{key:"getSearchResults",value:function getSearchResults(){var _this11=this;return{preselectUserId:null,showingSearchResults:this.state.searchTerm!=='',usersToRender:this.state.searchTerm===''?this.state.users:this.state.users.filter(function(u){return(u.name||'').toLowerCase().indexOf(_this11.state.searchTerm.toLowerCase())!==-1||u.email.toLowerCase().indexOf(_this11.state.searchTerm.toLowerCase())!==-1;})};}},{key:"onTextFieldChange",value:function onTextFieldChange(event,name){this.setFieldState(name,event.target.value);}},{key:"setFieldState",value:function setFieldState(fieldName,value){var newState=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.cloneDeep(this.state);newState[fieldName]=value;this.setState(newState);}},{key:"renderMLSCell",value:function renderMLSCell(userId,mlsConnectionId,externalId){var _this12=this;var classes=this.props.classes;if(!userId){return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["H" /* TableCell */],{padding:"dense",className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()(classes.tableCellBody,classes.mlsPendingPrompt)},localize('user-table-mls-pending-prompt'));}var apiError=this.getApiErrorForUserAndConnection(userId,mlsConnectionId);var errorMessageKey=apiError&&apiError.errorId&&__WEBPACK_IMPORTED_MODULE_32_utils_mls__["a" /* MLS_ERRORS */][apiError.errorId]||__WEBPACK_IMPORTED_MODULE_32_utils_mls__["a" /* MLS_ERRORS */][__WEBPACK_IMPORTED_MODULE_26__errors_errorids__["a" /* default */].UNKNOWN];var renderCellContent=function renderCellContent(){var isUserUpdating=_this12.props.mls.addingAgentMlsIdXhrInProgress.find(function(item){return item.userId===userId&&item.mlsConnectionId===mlsConnectionId;})||_this12.props.mls.editingAgentMlsIdXhrInProgress.find(function(item){return item.userId===userId&&item.mlsConnectionId===mlsConnectionId;})||_this12.props.mls.deletingAgentMlsIdXhrInProgress.find(function(item){return item.userId===userId&&item.mlsConnectionId===mlsConnectionId;});return __WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(_this12.state.updatingMlsIdForUsers,"[".concat(mlsConnectionId,"][").concat(userId,"]"))?_this12.renderMLSFieldContentUpdatingState(userId,externalId,mlsConnectionId):__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(_this12.state.shownMlsFields,"[".concat(mlsConnectionId,"][").concat(userId,"]"))?!isUserUpdating?_this12.renderMLSFieldContentInputField(userId,externalId,mlsConnectionId)//xxx
:_this12.renderMLSFieldContentNonEditableValue(userId,externalId,mlsConnectionId):externalId===''?_this12.renderMLSFieldContentNoExternalId(userId,mlsConnectionId):_this12.renderMLSFieldContentNonEditableValue(userId,externalId,mlsConnectionId);};return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["H" /* TableCell */],{padding:"dense",className:classes.tableCellBody},renderCellContent(),apiError&&__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["M" /* Typography */],{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()(classes.externalIdsErrorMessage)},localize(errorMessageKey)));}},{key:"renderMLSFormField",value:function renderMLSFormField(userId,externalId,mlsConnectionId){var _classNames10,_this13=this;var classes=this.props.classes;var errorClasses={error:classes.mlsErrorMessage};this.inputRefs["input-mls-".concat(mlsConnectionId,"-").concat(userId)]=__WEBPACK_IMPORTED_MODULE_10_react___default.a.createRef();var errorMessageKey=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(this.state.mlsFieldsWithErrors,"[".concat(mlsConnectionId,"][").concat(userId,"]"));return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["L" /* Tooltip */],{placement:"top",open:!__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(this.state.focusedField,"[".concat(mlsConnectionId,"][").concat(userId,"]")),title:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["M" /* Typography */],{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()((_classNames10={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames10,classes.infoTooltipText,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames10,classes.mlsPendingPrompt,!userId),_classNames10))},localize(userId?'users-table-enter-agent-mls-id':'user-table-mls-pending-prompt')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span",{className:classes.tooltipArrow})),classes:{tooltip:classes.mlsInfoTooltipTableBody}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__FormField__["a" /* default */],{value:externalId||'',autoComplete:"off",className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()(classes.mlsInputField),"data-tid":'mls-id-field',onChange:function onChange(event){return _this13.onMLSFieldChange(event,userId,mlsConnectionId);},onKeyPress:function onKeyPress(event){return _this13.onMLSFieldKeyPress(event,userId,mlsConnectionId);},onKeyDown:function onKeyDown(event){return _this13.onMLSFieldBlur(event);},onFocus:function onFocus(event){return _this13.onMLSFieldFocus(userId,mlsConnectionId);},margin:"normal",id:"input-mls-".concat(userId,"-").concat(mlsConnectionId),helperText:errorMessageKey&&localize(errorMessageKey),error:!!__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(this.state.mlsFieldsWithErrors,"[".concat(mlsConnectionId,"][").concat(userId,"]")),FormHelperTextProps:{classes:errorClasses},inputRef:this.inputRefs["input-mls-".concat(mlsConnectionId,"-").concat(userId)]}));}},{key:"renderMLSFieldContentInputField",value:function renderMLSFieldContentInputField(userId,externalId,mlsConnectionId){var _this14=this,_classNames11;var classes=this.props.classes;var apiError=this.getApiErrorForUserAndConnection(userId,mlsConnectionId);var saveEnabled=this.isMLSSaveEnabled(userId,mlsConnectionId);var shouldRenderActionIcons=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(this.state.focusedField,"[".concat(mlsConnectionId,"][").concat(userId,"]"));return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{key:"user-input-field-".concat(mlsConnectionId,"-").concat(userId),onMouseEnter:function onMouseEnter(){return _this14.showMLSField(userId,mlsConnectionId);},className:classes.singleMlsIdField},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{container:true,direction:"row",className:classes.mlsIdFieldGrid},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{item:true,className:classes.mlsIdFieldWrapper},this.renderMLSFormField(userId,externalId,mlsConnectionId)),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{item:true,className:classes.mlsFieldActionIcon},(shouldRenderActionIcons||apiError)&&//show Save icon to enable resubmit
__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["L" /* Tooltip */],{placement:"top",disableHoverListener:!saveEnabled||apiError,disableFocusListener:!saveEnabled||apiError,title:__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["M" /* Typography */],{variant:"body2",className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()(classes.infoTooltipText)},localize('users-table-mls-id-done')),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span",{className:classes.tooltipArrow})),classes:{tooltip:classes.infoTooltip}},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__theme_icons__["E" /* IconMlsIdDone */],{className:__WEBPACK_IMPORTED_MODULE_19_classnames___default()((_classNames11={},__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames11,classes.mlsActionIcon,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames11,classes.mlsIconDone,true),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames11,classes.mlsIconEnabled,saveEnabled),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames11,'mls-icon-hover',saveEnabled),__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_defineProperty___default()(_classNames11,'mls-icon-done',true),_classNames11)),onClick:function onClick(event){return saveEnabled&&_this14.saveMLSFieldChanges(userId,mlsConnectionId);}})))));}},{key:"renderMLSFieldContentNoExternalId",value:function renderMLSFieldContentNoExternalId(userId,mlsConnectionId){var _this15=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{key:"user-no-external-id-".concat(mlsConnectionId,"-").concat(userId),onMouseEnter:function onMouseEnter(){return _this15.showMLSField(userId,mlsConnectionId);},className:classes.emptyExternalMlsId},localize(userId?'users-table-enter-agent-mls-id':'user-table-mls-pending-prompt'));}},{key:"renderMLSFieldContentNonEditableValue",value:function renderMLSFieldContentNonEditableValue(userId,externalId,mlsConnectionId){var _this16=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{key:"user-non-editable-value-".concat(mlsConnectionId,"-").concat(userId),onMouseEnter:function onMouseEnter(){return _this16.showMLSField(userId,mlsConnectionId);},className:classes.nonEditableMlsIdValueNode},externalId);}},{key:"renderMLSFieldContentUpdatingState",value:function renderMLSFieldContentUpdatingState(userId,externalId,mlsConnectionId){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div",{key:"user-updating-state-".concat(mlsConnectionId,"-").concat(userId),className:classes.updatingMlsIdNode},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{container:true,direction:"row",className:classes.updatingMlsUserGrid},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{item:true,className:classes.updatingMlsUserValue},externalId),__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["o" /* Grid */],{item:true,className:classes.updatingMlsUserIcon},__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__theme_icons__["Y" /* SpinnerIcon */],{className:classes.updatingUserIcon}))));}},{key:"showMLSField",value:function showMLSField(userId,mlsConnectionId){var _this17=this;var shownMlsFields=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.clone(this.state.shownMlsFields);Object.keys(shownMlsFields).map(function(currentmlsConnectionId){Object.keys(shownMlsFields[currentmlsConnectionId]).map(function(currentUserId){if(!__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(_this17.state.focusedField,"[".concat(currentmlsConnectionId,"][").concat(currentUserId,"]"))){delete shownMlsFields[currentmlsConnectionId][currentUserId];}});});if(!shownMlsFields[mlsConnectionId]){shownMlsFields[mlsConnectionId]={};}shownMlsFields[mlsConnectionId][userId]=true;this.setState({shownMlsFields:shownMlsFields});}},{key:"saveMLSFieldChanges",value:function saveMLSFieldChanges(userId,mlsConnectionId){var _this18=this;var value=this.state.newExternalId[mlsConnectionId][userId];var newExternalId=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.clone(this.state.newExternalId);newExternalId[mlsConnectionId][userId]=value;this.setState({newExternalId:newExternalId},function(){_this18.updateExternalIdForUser(userId,mlsConnectionId,value);});}},{key:"onMLSFieldChange",value:function onMLSFieldChange(event,userId,mlsConnectionId){this.validateMlsId(event.target.value,userId,mlsConnectionId);var newExternalId=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.clone(this.state.newExternalId);newExternalId[mlsConnectionId][userId]=event.target.value;this.setState({newExternalId:newExternalId});// Clear API error mesassage when he edits field after ERROR.DUPLICATE_MLS_IDS error
var apiError=this.getApiErrorForUserAndConnection(userId,mlsConnectionId);if(__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(apiError,'errorId')===__WEBPACK_IMPORTED_MODULE_26__errors_errorids__["a" /* default */].AGENT_ID_EXISTS){this.props.clearErrorsForConnectionAndUser(mlsConnectionId,userId);}}},{key:"cleanMlsIdValue",value:function cleanMlsIdValue(val){return val.toString().trim();}},{key:"isMlsIdAlreadyUsed",value:function isMlsIdAlreadyUsed(id){var result=false;var mlsSystem=this.state.mlsSystem;var mlsConnectionId=mlsSystem.mlsConnectionId;if(id==='')return result;var newExternalId=this.state.newExternalId[mlsConnectionId];Object.keys(newExternalId).forEach(function(currentUserId){if(newExternalId[currentUserId]===id){result=true;}});return result;}},{key:"validateMlsId",value:function validateMlsId(value,userId,mlsConnectionId){var val=value.toString();var isIdAlreadyUsed=this.isMlsIdAlreadyUsed(val);if(val===''||this.cleanMlsIdValue(val)===val&&!isIdAlreadyUsed){var mlsFieldsWithErrors=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.clone(this.state.mlsFieldsWithErrors);if(__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(this.state.mlsFieldsWithErrors,"[".concat(mlsConnectionId,"][").concat(userId,"]"))){delete mlsFieldsWithErrors[mlsConnectionId][userId];}this.setState({mlsFieldsWithErrors:mlsFieldsWithErrors});return true;}else{var _mlsFieldsWithErrors=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.clone(this.state.mlsFieldsWithErrors);if(!_mlsFieldsWithErrors[mlsConnectionId]){_mlsFieldsWithErrors[mlsConnectionId]={};}_mlsFieldsWithErrors[mlsConnectionId][userId]=isIdAlreadyUsed?invalidMLSInputValue['already-used']:invalidMLSInputValue['invalid-value'];this.setState({mlsFieldsWithErrors:_mlsFieldsWithErrors});return false;}}},{key:"isMLSSaveEnabled",value:function isMLSSaveEnabled(userId,mlsConnectionId){var originalExternalId=this.getOriginalMlsIdForAgent(mlsConnectionId,userId,null);var externalId=this.state.newExternalId[mlsConnectionId][userId];var fieldHasError=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(this.state.mlsFieldsWithErrors,"[".concat(mlsConnectionId,"][").concat(userId,"]"));if(fieldHasError){return false;}if(this.cleanMlsIdValue(externalId).length===0){return originalExternalId;}else{return originalExternalId===''||originalExternalId!==externalId;}}},{key:"onMLSFieldKeyPress",value:function onMLSFieldKeyPress(event,userId,mlsConnectionId){var _this19=this;if(event.key==='Enter'){if(!this.isMLSSaveEnabled(userId,mlsConnectionId))return;var value=this.state.newExternalId[mlsConnectionId][userId];var newExternalId=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.clone(this.state.newExternalId);newExternalId[mlsConnectionId][userId]=value;this.setState({newExternalId:newExternalId},function(){_this19.updateExternalIdForUser(userId,mlsConnectionId,value);});}}},{key:"getApiErrorForUserAndConnection",value:function getApiErrorForUserAndConnection(userId,mlsConnectionId){return this.props.mls.addingAgentMlsIdErrorId.find(function(user){return user.userId===userId&&user.mlsConnectionId===mlsConnectionId;})||this.props.mls.editingAgentMlsIdErrorId.find(function(user){return user.userId===userId&&user.mlsConnectionId===mlsConnectionId;})||this.props.mls.deletingAgentMlsIdErrorId.find(function(user){return user.userId===userId&&user.mlsConnectionId===mlsConnectionId;});}},{key:"resetPreviousAPIMessageFieldValue",value:function resetPreviousAPIMessageFieldValue(exceptUserId){var _this20=this;var mlsSystem=this.state.mlsSystem;var mlsConnectionId=mlsSystem.mlsConnectionId;if(this.props.mls.addingAgentMlsIdErrorId.length||this.props.mls.editingAgentMlsIdErrorId.length||this.props.mls.deletingAgentMlsIdErrorId.length){// clear any previous error message from API field
var newExternalId=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.clone(this.state.newExternalId);var fousedFieldHasChanged=false;Object.keys(newExternalId[mlsConnectionId]).map(function(currentUserId){var apiError=_this20.getApiErrorForUserAndConnection(currentUserId,mlsConnectionId);if(apiError){var originalExternalIdValue=_this20.getOriginalMlsIdForAgent(mlsConnectionId,currentUserId);if(!exceptUserId||exceptUserId!==currentUserId){newExternalId[mlsConnectionId][currentUserId]=originalExternalIdValue;}// don't clear error message if field with error is focused
if(exceptUserId&&exceptUserId===currentUserId){if(originalExternalIdValue!==newExternalId[mlsConnectionId][currentUserId]){fousedFieldHasChanged=true;}}}});this.setState({newExternalId:newExternalId});if(!exceptUserId||!fousedFieldHasChanged){this.props.clearConnectMlsState();}}}},{key:"onMLSFieldFocus",value:function onMLSFieldFocus(userId,mlsConnectionId){if(__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(this.state.focusedField,"[".concat(mlsConnectionId,"][").concat(userId,"]")))return;if(!__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(this.state.focusedField,"[".concat(mlsConnectionId,"]")))){this.resetLastFocusedMLSField(true,true);}else{this.resetPreviousAPIMessageFieldValue(userId);}var focusedField={};if(!focusedField[mlsConnectionId]){focusedField[mlsConnectionId]={};}focusedField[mlsConnectionId][userId]=true;this.setState({focusedField:focusedField});}},{key:"onMLSFieldBlur",value:function onMLSFieldBlur(event){if(event.key==='Tab'){this.hideAllMlsFields(true);}}},{key:"hideAllMlsFields",value:function hideAllMlsFields(reset,keepFocused){var _this21=this;var shownMlsFields=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.clone(this.state.shownMlsFields);var mlsSystem=this.state.mlsSystem;var mlsConnectionId=mlsSystem.mlsConnectionId;if(keepFocused){!__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(shownMlsFields,"[".concat(mlsConnectionId,"]")))&&Object.keys(shownMlsFields[mlsConnectionId]).map(function(currentUserId){if(!__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(_this21.state.focusedField,"[".concat(mlsConnectionId,"][").concat(currentUserId,"]"))){delete shownMlsFields[mlsConnectionId][currentUserId];}});}else{shownMlsFields[this.state.mlsSystem.mlsConnectionId]={};}this.setState({shownMlsFields:shownMlsFields});reset&&this.resetLastFocusedMLSField(true,true);}},{key:"resetLastFocusedMLSField",value:function resetLastFocusedMLSField(resetPreviousAPIMessageField,clearExternalIdState){var _this22=this;resetPreviousAPIMessageField&&this.resetPreviousAPIMessageFieldValue();var mlsSystem=this.state.mlsSystem;var mlsConnectionId=mlsSystem.mlsConnectionId;var focusedField=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.clone(this.state.focusedField);focusedField[mlsConnectionId]&&Object.keys(focusedField[mlsConnectionId]).map(function(currentUserId){if(__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(_this22.state.focusedField,"[".concat(mlsConnectionId,"][").concat(currentUserId,"]"))){delete focusedField[mlsConnectionId][currentUserId];var shownMlsFields=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.clone(_this22.state.shownMlsFields);if(__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(_this22.state.shownMlsFields,"[".concat(mlsConnectionId,"][").concat(currentUserId,"]"))){delete shownMlsFields[mlsConnectionId][currentUserId];}var mlsFieldsWithErrors=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.clone(_this22.state.mlsFieldsWithErrors);var originalExternalIdValue=_this22.getOriginalMlsIdForAgent(mlsConnectionId,currentUserId);var newExternalId=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.clone(_this22.state.newExternalId);newExternalId[mlsConnectionId][currentUserId]=originalExternalIdValue;if(__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.get(_this22.state.mlsFieldsWithErrors,"[".concat(mlsConnectionId,"][").concat(currentUserId,"]"))){delete mlsFieldsWithErrors[mlsConnectionId][currentUserId];}_this22.setState({newExternalId:newExternalId,focusedField:focusedField,shownMlsFields:shownMlsFields,mlsFieldsWithErrors:mlsFieldsWithErrors});}});if(clearExternalIdState){this.props.clearConnectMlsState();}}},{key:"updateExternalIdForUser",value:function updateExternalIdForUser(userId,mlsConnectionId,newValue){var forceAddition=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var originalExternalIdValue=this.getOriginalMlsIdForAgent(mlsConnectionId,userId);var agentMongoId=this.getMongoAgentId(mlsConnectionId,userId);var isEmptyString=this.cleanMlsIdValue(newValue).length===0;if(newValue!==originalExternalIdValue){var updatingMlsIdForUsers=__WEBPACK_IMPORTED_MODULE_25_lodash___default.a.clone(this.state.updatingMlsIdForUsers);if(!updatingMlsIdForUsers[mlsConnectionId]){updatingMlsIdForUsers[mlsConnectionId]={};}updatingMlsIdForUsers[mlsConnectionId][userId]=true;this.setState({updatingMlsIdForUsers:updatingMlsIdForUsers,focusedField:{}});if(originalExternalIdValue){if(isEmptyString){this.props.deleteAgentMlsId(mlsConnectionId,userId,agentMongoId);}else{this.props.editAgentMlsId(mlsConnectionId,userId,newValue,agentMongoId,forceAddition);}}else{this.props.addAgentMlsId(mlsConnectionId,userId,newValue,forceAddition);}}}}]);return ManageMlsAgentsModal;}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]))||_class);ManageMlsAgentsModal.propTypes={companies:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.object,mls:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.object,modalShown:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.bool,hideModal:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.func,resetModal:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.func,classes:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.object,email:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,showApiError:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.bool,company:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.object,user:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.object.isRequired,showErrorPopup:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.func.isRequired,selectedCompanyId:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,addOfficeId:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.func.isRequired,clearConnectMlsState:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.func.isRequired,clearErrorsForConnectionAndUser:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.func.isRequired,mlsConnectionId:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,onClose:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.func.isRequired,connections:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.array,selfStartMlsIdsForUser:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.array,usersPage:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.bool,preselectUserId:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,currentUserEmail:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.string,settings:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.object,writeUserSettings:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.func.isRequired,addAgentMlsId:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.func.isRequired,deleteAgentMlsId:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.func.isRequired,editAgentMlsId:__WEBPACK_IMPORTED_MODULE_22_prop_types___default.a.func.isRequired};var mapStateToProps=function mapStateToProps(state){return{company:state.companies.rawDataById?state.companies.rawDataById[state.companies.selectedId]:null,modalShown:state.modal.modalShown,companies:state.companies,mls:state.mls,user:state.session.user,selectedCompanyId:state.companies.selectedId,currentUserEmail:state.session.user.mainEmail,settings:state.session.user.settings};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_12_redux__["b" /* bindActionCreators */])({writeUserSettings:__WEBPACK_IMPORTED_MODULE_15_redux_modules_session__["d" /* writeUserSettings */],hideModal:__WEBPACK_IMPORTED_MODULE_20_redux_modules_modal__["b" /* hideModal */],resetModal:__WEBPACK_IMPORTED_MODULE_20_redux_modules_modal__["c" /* resetModal */],showErrorPopup:__WEBPACK_IMPORTED_MODULE_21_redux_modules_companies__["H" /* showErrorPopup */],addOfficeId:__WEBPACK_IMPORTED_MODULE_18_redux_modules_mls__["d" /* addOfficeId */],clearConnectMlsState:__WEBPACK_IMPORTED_MODULE_18_redux_modules_mls__["e" /* clearConnectMlsState */],clearErrorsForConnectionAndUser:__WEBPACK_IMPORTED_MODULE_18_redux_modules_mls__["f" /* clearErrorsForConnectionAndUser */],addAgentMlsId:__WEBPACK_IMPORTED_MODULE_18_redux_modules_mls__["a" /* addAgentMlsId */],deleteAgentMlsId:__WEBPACK_IMPORTED_MODULE_18_redux_modules_mls__["h" /* deleteAgentMlsId */],editAgentMlsId:__WEBPACK_IMPORTED_MODULE_18_redux_modules_mls__["k" /* editAgentMlsId */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ManageMlsAgentsModal));

/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ContactSalesSchema__ = __webpack_require__(1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_browser__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_redux_modules_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_redux_modules_companies__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Features_components__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_icons_KeyboardArrowDown__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_icons_KeyboardArrowDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_icons_KeyboardArrowDown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__FormField__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__theme_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lib_Segment_customTrackers__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lib_Segment_helpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_i18n_i18n__ = __webpack_require__(15);
var _dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_27_i18n_i18n__["a" /* default */].loc.localize;var detectErrorsInFormFields=['firstName','lastName','companyName','nrOfUsers','workEmail','jobTitle','usageInfo'];var errors=__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()({},__WEBPACK_IMPORTED_MODULE_23__errors_errorids__["a" /* default */].OFFLINE,localize('contact-sales-error-offline'));var NR_OF_USERS_OPTIONS=['20-49','50-99','100-250','251-500','501-1000','1000+'];var styles=function styles(theme){return{/* Dialog */dialogPaper:{minWidth:444},dialogWrapper:{position:'relative',padding:'15px 10px 0',minHeight:291},dialogTitle:{'& h6':{fontWeight:600,fontSize:'28px',lineHeight:1.2,marginBottom:20,textAlign:'left'}},/* dialog content */dialogContent:{overflow:'visible'},/* close button */closeDialog:{position:'absolute',top:10,right:10},closeDialogIcon:{color:'#6F99BD',width:'20px',height:'20px'},/* form */formRow:{justifyContent:'space-between',marginBottom:10},formField:{flex:'0 0 45%',margin:'0 0 10px'},formLabel:{display:'block',textAlign:'left',fontWeight:600,lineHeight:1.5,opacity:1,color:'#000000bf',margin:'0 0 5px'},/* loading icon */loadingContainer:{minHeight:402,position:'relative'},loadingContent:{position:'absolute',top:'50%',left:'50%',transform:'translate(-50%, -50%)'},loadingMessage:{fontSize:16,lineHeight:1.5,opacity:1},loadingIcon:{display:'block',height:'24px',width:'24px',margin:'0 auto 10px',fill:'#96DCFD',animation:'spin 2s linear infinite'},'@keyframes spin':{'0':{transform:'rotate(0deg)'},'100%':{transform:'rotate(360deg)'}},/* input field */fieldTextElement:{width:'100%',margin:0,'&.noLabel':{marginTop:29},'& input, & textarea':{border:'1px solid #aabfd1',borderStyle:'solid',borderRadius:5,color:theme.palette.text.primary,padding:'10px','&:focus, &:hover':{color:'#2888c3',borderColor:'#2888c3'},'&::placeholder':{fontFamily:'Open Sans, sans-serif',fontWeight:'normal',fontStyle:'normal',fontSize:'14px',lineHeight:'19px',color:theme.palette.text.primary}},'& textarea':{width:'425px',display:'block'},'& [id*=helper-text]':{paddingLeft:0,color:theme.palette.error.main},'& [class*=error] input':{borderColor:"".concat(theme.palette.error.main," !important")}},fieldSelectElement:{width:'100%'},selectElement:{borderRadius:5,boxShadow:'none',borderColor:'#aabfd1',padding:10,textAlign:'left','&:hover, &:focus':{borderRadius:5,color:'#2888c3',borderColor:'#2888c3'}},selectElementError:{borderRadius:5,boxShadow:'none',borderColor:"".concat(theme.palette.error.main," !important"),padding:10,textAlign:'left','&:hover, &:focus':{borderRadius:5,color:'#2888c3',borderColor:'#2888c3'}},selectElementItem:{'&:hover':{background:'#e0f5fe'},'&[class*=selected]':{background:'#e0f5fe !important'}},selectElementIcon:{right:4,'&:hover':{color:'#93c3e1'}},selectElementPaper:{borderRadius:5,border:0,boxShadow:'0px 4px 4px rgba(0, 0, 0, 0.1)'},selectError:{paddingLeft:0,color:theme.palette.error.main,fontStyle:'italic'},/* buttons */actionButtons:{justifyContent:'space-between',padding:'10px 0 20px'},actionButtonSubmitColumn:{},actionButtonDemoLinkColumn:{display:'flex',alignItems:'center'},demoLink:{textDecoration:'underline',textTransform:'uppercase','&:hover':{textDecoration:'none'},fontSize:13,lineHeight:1.2,opacity:1,'html[lang="de"] &':{maxWidth:200}},button:{fontFamily:'Open Sans, sans-serif',borderRadius:5,fontWeight:600,fontSize:18,lineHeight:1.3,opacity:'1 !important'},buttonPrimary:{background:theme.palette.primary.main,color:'white',textShadow:'none',paddingLeft:10,paddingRight:10,width:'100%','&[class*=contained][class*=disabled]':{backgroundColor:'#f4f4f4',color:'#4a5660'}},buttonClose:{display:'block',maxWidth:200,margin:'0 auto'},/* error message */errorMessage:{color:theme.palette.error.main,fontSize:14,lineHeight:1.5,opacity:1,textAlign:'left',marginTop:-15,marginBottom:15,'& a':{color:theme.palette.primary.main}},/* success message */successMessage:{textAlign:'left',color:'#000',fontSize:14,lineHeight:1.3,opacity:1,padding:'0 0 30px','& a':{color:'#2fa5e7'}}};};var ContactSalesModal=(_dec=Object(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["N" /* withStyles */])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(ContactSalesModal,_Component);function ContactSalesModal(props){var _this;__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this,ContactSalesModal);_this=__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(ContactSalesModal).call(this,props));_this.state={values:{firstName:'',lastName:'',companyName:'',nrOfUsers:'',workEmail:'',jobTitle:'',phoneNumberPrefix:'',phoneNumber:'',usageInfo:''},xhrInProgress:false,apiRequestSuccess:false,apiRequestError:false,errors:{},touched:{}};_this.scrollbarRef=__WEBPACK_IMPORTED_MODULE_8_react___default.a.createRef(null);return _this;}__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(ContactSalesModal,[{key:"render",value:function render(){var _this2=this;var _this$props=this.props,modalShown=_this$props.modalShown,resetModal=_this$props.resetModal,classes=_this$props.classes;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["d" /* Dialog */],{open:modalShown,"aria-labelledby":"alert-dialog-title","aria-describedby":"alert-dialog-description",onExited:resetModal,BackdropProps:{style:{backgroundColor:'rgba(46, 63, 79, 0.4)'}},classes:{paper:classes.dialogPaper},PaperProps:{style:{border:0,width:309,minWidth:505,borderRadius:5,boxShadow:'0px 4px 24px rgba(0, 0, 0, 0.08)'}}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:classes.dialogWrapper},!this.state.xhrInProgress&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["p" /* IconButton */],{className:classes.closeDialog,component:"span","aria-label":"Close",onClick:function onClick(){return _this2.closeDialog();}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__theme_icons__["_11" /* XIcon */],{className:classes.closeDialogIcon})),function(){if(_this2.state.xhrInProgress){return _this2.renderLoading();}else if(_this2.state.apiRequestSuccess){return _this2.renderSuccess();}else if(_this2.state.apiRequestError){return _this2.renderForm();}else{return _this2.renderForm();}}()));}},{key:"closeDialog",value:function closeDialog(){this.props.hideModal();}},{key:"renderLoading",value:function renderLoading(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:classes.loadingContainer},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:classes.loadingContent},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__theme_icons__["Y" /* SpinnerIcon */],{className:classes.loadingIcon}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["M" /* Typography */],{className:classes.loadingMessage,variant:"body2"},localize('contact-sales-saving-form'))));}},{key:"renderErrorMessage",value:function renderErrorMessage(){var errors=this.state.errors;var apiError=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(errors,'apiError');var formError=this.hasFormError(errors)&&localize('contact-sales-please-errors-found-in-the-form');var errorMessage;if(formError){errorMessage=formError;}else if(apiError){errorMessage=apiError;}var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["M" /* Typography */],{className:classes.errorMessage,variant:"body2",dangerouslySetInnerHTML:{__html:errorMessage}});}},{key:"renderSuccess",value:function renderSuccess(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["g" /* DialogTitle */],{variant:"body1",color:"default",className:classes.dialogTitle},localize('contact-sales-form-success-title')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["f" /* DialogContent */],{className:classes.dialogContent},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["M" /* Typography */],{className:classes.successMessage,variant:"body2",onClick:function onClick(){return _this3.openCalendlyLink();},dangerouslySetInnerHTML:{__html:localize('contact-sales-form-success-description')}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["a" /* Button */],{variant:"contained",key:"main",className:__WEBPACK_IMPORTED_MODULE_12_classnames___default()(classes.button,classes.buttonPrimary,classes.buttonClose),onClick:function onClick(){return _this3.closeDialog();}},localize('close'))));}},{key:"renderForm",value:function renderForm(){var _this4=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["g" /* DialogTitle */],{variant:"body1",color:"default",className:classes.dialogTitle},this.props.title),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["f" /* DialogContent */],{className:classes.dialogContent},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["o" /* Grid */],{container:true,direction:"column"},Object.keys(this.state.errors).length>0&&this.renderErrorMessage(),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["o" /* Grid */],{container:true,item:true,direction:"column",className:classes.userRowsContainer},this.renderFormFields()),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["o" /* Grid */],{item:true,container:true,direction:"row",justify:"flex-end",className:classes.actionButtons},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["o" /* Grid */],{item:true,className:classes.actionButtonSubmitColumn},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["a" /* Button */],{variant:"contained",color:"primary","data-tid":"button-contact-sales",className:__WEBPACK_IMPORTED_MODULE_12_classnames___default()(classes.button,classes.buttonPrimary),onClick:function onClick(){return _this4.submitForm();},disabled:!this.isSubmitEnabled()},localize('contact-sales-form-submit'))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["o" /* Grid */],{item:true,className:classes.actionButtonDemoLinkColumn},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["r" /* Link */],{variant:"body1",onClick:function onClick(){return _this4.openCalendlyLink();},className:classes.demoLink,underline:"none"},localize('contact-sales-form-demo-link')))))));}},{key:"openCalendlyLink",value:function openCalendlyLink(){var newWindow=window.open(__WEBPACK_IMPORTED_MODULE_25__config__["r" /* CONTACT_SALES */].CALENDLY_LINK,'_blank');newWindow&&newWindow.focus();}},{key:"renderFormFields",value:function renderFormFields(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["o" /* Grid */],{container:true,item:true,direction:"row",className:classes.formRow},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["o" /* Grid */],{item:true,className:classes.formField},this.textField('firstName',this.state.values.firstName,localize('contact-sales-form-first-name'),false,'text')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["o" /* Grid */],{item:true,className:classes.formField},this.textField('lastName',this.state.values.lastName,localize('contact-sales-form-last-name'),false,'text'))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["o" /* Grid */],{container:true,item:true,direction:"row",className:classes.formRow},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["o" /* Grid */],{item:true,className:classes.formField},this.textField('companyName',this.state.values.companyName,localize('contact-sales-form-company-name'),false,'text')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["o" /* Grid */],{item:true,className:classes.formField},this.selectField('nrOfUsers',this.state.values.nrOfUsers,localize('contact-sales-form-number-of-users'),true))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["o" /* Grid */],{container:true,item:true,direction:"row",className:classes.formRow},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["o" /* Grid */],{item:true,className:classes.formField},this.textField('workEmail',this.state.values.workEmail,localize('contact-sales-form-work-email'),false,'email')),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["o" /* Grid */],{item:true,className:classes.formField},this.textField('jobTitle',this.state.values.jobTitle,localize('contact-sales-form-job-title'),false,'text'))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["o" /* Grid */],{container:true,item:true,direction:"row",className:classes.formRow},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["o" /* Grid */],{item:true,className:classes.formField},this.selectField('phoneNumberPrefix',this.state.values.phoneNumberPrefix,localize('contact-sales-form-phone-number'),false)),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["o" /* Grid */],{item:true,className:classes.formField},this.textField('phoneNumber',this.state.values.phoneNumber,localize('contact-sales-form-phone-number'),false,'text',null,null,'XX XXX XXX',false))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["o" /* Grid */],{container:true,item:true,direction:"row",className:classes.formRow},this.textField('usageInfo',this.state.values.usageInfo,localize('contact-sales-form-usage-info'),false,'textarea',null,true)));}},{key:"isSubmitEnabled",value:function isSubmitEnabled(){var _this5=this;var nrOfRequiredFieldsChanged=0;detectErrorsInFormFields.forEach(function(fieldName){if(_this5.state.touched[fieldName]){nrOfRequiredFieldsChanged++;}});var allRequiredFieldsChanged=nrOfRequiredFieldsChanged===detectErrorsInFormFields.length;// check for input error
return allRequiredFieldsChanged>0&&!this.hasFormError(this.state.errors)||Object.keys(this.state.errors).length===1&&__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(this.state,'errors.apiError');}},{key:"hasFormError",value:function hasFormError(errorState){var result=false;Object.keys(errorState).forEach(function(fieldName){if(detectErrorsInFormFields.includes(fieldName)){result=true;}});return result;}},{key:"componentDidMount",value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_24_lib_Segment_customTrackers__["r" /* trackContactSalesPopupShown */])(Object(__WEBPACK_IMPORTED_MODULE_26_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(this.props.companies.contactSalesErrorId!==nextProps.companies.contactSalesErrorId&&nextProps.companies.contactSalesErrorId!==null){this.handleApiErrors(nextProps);}if(this.props.companies.contactSalesSuccess!==nextProps.companies.contactSalesSuccess&&nextProps.companies.contactSalesSuccess===true){this.setState({xhrInProgress:false,apiRequestError:false,apiRequestSuccess:true,errors:{apiError:null}});}}},{key:"handleApiErrors",value:function handleApiErrors(nextProps){if(nextProps.companies.contactSalesErrorId){var errorMessage=nextProps.companies.contactSalesErrorId&&errors[nextProps.companies.contactSalesErrorId]||localize('contact-sales-error-unknown');this.setState({xhrInProgress:false,apiRequestError:true,apiRequestSuccess:false,errors:{apiError:errorMessage}});}}},{key:"textField",value:function textField(name,value,label,disabled,type,maxLength,autosize,placeholder){var _classNames,_this6=this;var required=arguments.length>8&&arguments[8]!==undefined?arguments[8]:true;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,name!=='phoneNumber'&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["n" /* FormLabel */],{required:required,className:classes.formLabel},label),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__FormField__["a" /* default */],__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({value:value,autoComplete:__WEBPACK_IMPORTED_MODULE_14__utils_browser__["b" /* isChrome */]?'disabled':'off',className:__WEBPACK_IMPORTED_MODULE_12_classnames___default()((_classNames={},__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_classNames,classes.fieldTextElement,true),__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_classNames,'noLabel',name==='phoneNumber'),_classNames)),"data-tid":"form-sales-".concat(name),onChange:function onChange(event){return _this6.onTextFieldChange(event,name);},onBlur:function onBlur(event){return _this6.onTextFieldBlur(event,name);},onKeyPress:function onKeyPress(event){return _this6.onKeyPress(event,name);},placeholder:placeholder,id:name},type?{type:type}:{},autosize?{autosize:autosize}:{},{margin:"normal",helperText:this.state.errors[name],error:!!this.state.errors[name],disabled:disabled,maxLength:maxLength,inputRef:this[name]})));}},{key:"selectField",value:function selectField(name,value,label,required){var _this7=this;var classes=this.props.classes;var hasError=Boolean(this.state.errors[name]);return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["n" /* FormLabel */],{required:required,className:classes.formLabel},label),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_Features_components__["b" /* Select */],{id:name,"data-tid":name,name:name,onChange:function onChange(event){return _this7.onSelectFieldChange(event,name);},className:classes.fieldSelectElement,disableUnderline:true,fullWidth:true,classes:{select:hasError?classes.selectElementError:classes.selectElement,icon:classes.selectElementIcon},MenuProps:{classes:{paper:classes.selectElementPaper}},displayEmpty:true,IconComponent:__WEBPACK_IMPORTED_MODULE_18__material_ui_icons_KeyboardArrowDown___default.a,value:value},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{value:"",disabled:true},name==='nrOfUsers'?localize('contact-sales-form-number-of-users-select'):'+'),name==='nrOfUsers'?this.renderNrOfUsersDropdown():this.renderPhonePrefixDropdown()),hasError&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["m" /* FormHelperText */],{className:classes.selectError},this.state.errors[name]));}},{key:"renderNrOfUsersDropdown",value:function renderNrOfUsersDropdown(){var classes=this.props.classes;return NR_OF_USERS_OPTIONS.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{key:index,value:value,className:classes.selectElementItem},value);});}},{key:"renderPhonePrefixDropdown",value:function renderPhonePrefixDropdown(){/* eslint-disable max-len */var classes=this.props.classes;var COUNTRY_OPTIONS=[__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-af',value:"+93","data-value":"AF"},"Afghanistan (+93)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-al',value:"+355","data-value":"AL"},"Albania (+355)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-dz',value:"+213","data-value":"DZ"},"Algeria (+213)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ad',value:"+376","data-value":"AD"},"Andorra (+376)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ao',value:"+244","data-value":"AO"},"Angola (+244)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-aq',value:"+672","data-value":"AQ"},"Antarctica (+672)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ag',value:"+1","data-value":"AG"},"Antigua and Barbuda (+1-268)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ar',value:"+54","data-value":"AR"},"Argentina (+54)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-am',value:"+374","data-value":"AM"},"Armenia (+374)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-aw',value:"+297","data-value":"AW"},"Aruba (+297)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ac',value:"+247","data-value":"AC"},"Ascension Island (+247)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-au',value:"+61","data-value":"AU"},"Australia (+61)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-at',value:"+43","data-value":"AT"},"Austria (+43)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-az',value:"+994","data-value":"AZ"},"Azerbaijan (+994)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-bs',value:"+1","data-value":"BS"},"Bahamas (+1)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-bh',value:"+973","data-value":"BH"},"Bahrain (+973)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-bd',value:"+880","data-value":"BD"},"Bangladesh (+880)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-bb',value:"+1","data-value":"BB"},"Barbados (+1)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-by',value:"+375","data-value":"BY"},"Belarus (+375)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-be',value:"+32","data-value":"BE"},"Belgium (+32)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-bz',value:"+501","data-value":"BZ"},"Belize (+501)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-bj',value:"+229","data-value":"BJ"},"Benin (+229)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-bm',value:"+1","data-value":"BM"},"Bermuda (+1)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-bt',value:"+975","data-value":"BT"},"Bhutan (+975)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-bo',value:"+591","data-value":"BO"},"Bolivia (+591)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-bq',value:"+599","data-value":"BQ"},"Bonaire (+599)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ba',value:"+387","data-value":"BA"},"Bosnia and Herzegovina (+387)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-bw',value:"+267","data-value":"BW"},"Botswana (+267)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-bv',value:"+47","data-value":"BV"},"Bouvet Island (+47)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-br',value:"+55","data-value":"BR"},"Brazil (+55)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-io',value:"+44","data-value":"IO"},"British Indian Ocean Territory (+44)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-vg',value:"+1","data-value":"VG"},"British Virgin Islands (+1)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-bn',value:"+673","data-value":"BN"},"Brunei (+673)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-bg',value:"+359","data-value":"BG"},"Bulgaria (+359)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-bf',value:"+226","data-value":"BF"},"Burkina Faso (+226)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-bi',value:"+257","data-value":"BI"},"Burundi (+257)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-cv',value:"+238","data-value":"CV"},"Cabo Verde (+238)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-kh',value:"+855","data-value":"KH"},"Cambodia (+855)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-cm',value:"+237","data-value":"CM"},"Cameroon (+237)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ca',value:"+1","data-value":"CA"},"Canada (+1)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ky',value:"+1","data-value":"KY"},"Cayman Islands (+1)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-cf',value:"+236","data-value":"CF"},"Central African Republic (+236)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-td',value:"+235","data-value":"TD"},"Chad (+235)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-cl',value:"+56","data-value":"CL"},"Chile (+56)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-cn',value:"+86","data-value":"CN"},"China (+86)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-cx',value:"+61","data-value":"CX"},"Christmas Island (+61)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-cc',value:"+61","data-value":"CC"},"Cocos (Keeling) Islands (+61)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-c0',value:"+57","data-value":"CO"},"Colombia (+57)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-km',value:"+269","data-value":"KM"},"Comoros (+269)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-cg',value:"+242","data-value":"CG"},"Congo (+242)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-cd',value:"+243","data-value":"CD"},"Congo (DRC) (+243)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ck',value:"+682","data-value":"CK"},"Cook Islands (+682)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-cr',value:"+506","data-value":"CR"},"Costa Rica (+506)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ci',value:"+225","data-value":"CI"},"C\xF4te d'Ivoire (+225)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-hr',value:"+385","data-value":"HR"},"Croatia (+385)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-cu',value:"+53","data-value":"CU"},"Cuba (+53)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-cw',value:"+599","data-value":"CW"},"Cura\xE7ao (+599)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-cy',value:"+357","data-value":"CY"},"Cyprus (+357)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-cz',value:"+420","data-value":"CZ"},"Czechia (+420)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-dk',value:"+45","data-value":"DK"},"Denmark (+45)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-dj',value:"+253","data-value":"DJ"},"Djibouti (+253)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-dm',value:"+1","data-value":"DM"},"Dominica (+1)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-do',value:"+1","data-value":"DO"},"Dominican Republic (+1)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ec',value:"+593","data-value":"EC"},"Ecuador (+593)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-eg',value:"+20","data-value":"EG"},"Egypt (+20)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-sv',value:"+503","data-value":"SV"},"El Salvador (+503)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-gq',value:"+240","data-value":"GQ"},"Equatorial Guinea (+240)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-er',value:"+291","data-value":"ER"},"Eritrea (+291)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ee',value:"+372","data-value":"EE"},"Estonia (+372)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-et',value:"+251","data-value":"ET"},"Ethiopia (+251)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-fk',value:"+500","data-value":"FK"},"Falkland Islands (+500)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-fo',value:"+298","data-value":"FO"},"Faroe Islands (+298)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-fj',value:"+679","data-value":"FJ"},"Fiji (+679)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-fi',value:"+358","data-value":"FI"},"Finland (+358)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-fr',value:"+33","data-value":"FR"},"France (+33)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-gf',value:"+594","data-value":"GF"},"French Guiana (+594)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-pf',value:"+689","data-value":"PF"},"French Polynesia (+689)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ga',value:"+241","data-value":"GA"},"Gabon (+241)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-gm',value:"+220","data-value":"GM"},"Gambia (+220)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ge',value:"+995","data-value":"GE"},"Georgia (+995)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-de',value:"+49","data-value":"DE"},"Germany (+49)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-gh',value:"+233","data-value":"GH"},"Ghana (+233)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-gi',value:"+350","data-value":"GI"},"Gibraltar (+350)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-gr',value:"+30","data-value":"GR"},"Greece (+30)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-gl',value:"+299","data-value":"GL"},"Greenland (+299)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-gd',value:"+1","data-value":"GD"},"Grenada (+1)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-gp',value:"+590","data-value":"GP"},"Guadeloupe (+590)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-gu',value:"+1","data-value":"GU"},"Guam (+1)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-gt',value:"+502","data-value":"GT"},"Guatemala (+502)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-gg',value:"+44","data-value":"GG"},"Guernsey (+44)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-gn',value:"+224","data-value":"GN"},"Guinea (+224)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-gw',value:"+245","data-value":"GW"},"Guinea-Bissau (+245)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-gy',value:"+592","data-value":"GY"},"Guyana (+592)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ht',value:"+509","data-value":"HT"},"Haiti (+509)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-hn',value:"+504","data-value":"HN"},"Honduras (+504)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-hk',value:"+852","data-value":"HK"},"Hong Kong SAR (+852)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-hu',value:"+36","data-value":"HU"},"Hungary (+36)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-is',value:"+354","data-value":"IS"},"Iceland (+354)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-in',value:"+91","data-value":"IN"},"India (+91)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-id',value:"+62","data-value":"ID"},"Indonesia (+62)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ir',value:"+98","data-value":"IR"},"Iran (+98)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-iq',value:"+964","data-value":"IQ"},"Iraq (+964)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ie',value:"+353","data-value":"IE"},"Ireland (+353)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-im',value:"+44","data-value":"IM"},"Isle of Man (+44)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-il',value:"+972","data-value":"IL"},"Israel (+972)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-it',value:"+39","data-value":"IT"},"Italy (+39)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-jm',value:"+1","data-value":"JM"},"Jamaica (+1)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-xj',value:"+47","data-value":"XJ"},"Jan Mayen (+47)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-jp',value:"+81","data-value":"JP"},"Japan (+81)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-je',value:"+44","data-value":"JE"},"Jersey (+44)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-jo',value:"+962","data-value":"JO"},"Jordan (+962)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-kz',value:"+7","data-value":"KZ"},"Kazakhstan (+7)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ke',value:"+254","data-value":"KE"},"Kenya (+254)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ki',value:"+686","data-value":"KI"},"Kiribati (+686)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-kr',value:"+82","data-value":"KR"},"Korea (+82)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-xk',value:"+383","data-value":"XK"},"Kosovo (+383)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-kw',value:"+965","data-value":"KW"},"Kuwait (+965)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-kg',value:"+996","data-value":"KG"},"Kyrgyzstan (+996)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-la',value:"+856","data-value":"LA"},"Laos (+856)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-lv',value:"+371","data-value":"LV"},"Latvia (+371)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-lb',value:"+961","data-value":"LB"},"Lebanon (+961)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ls',value:"+266","data-value":"LS"},"Lesotho (+266)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-lr',value:"+231","data-value":"LR"},"Liberia (+231)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ly',value:"+218","data-value":"LY"},"Libya (+218)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-li',value:"+423","data-value":"LI"},"Liechtenstein (+423)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-lt',value:"+370","data-value":"LT"},"Lithuania (+370)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-lu',value:"+352","data-value":"LU"},"Luxembourg (+352)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-mo',value:"+853","data-value":"MO"},"Macao SAR (+853)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-mg',value:"+261","data-value":"MG"},"Madagascar (+261)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-mw',value:"+265","data-value":"MW"},"Malawi (+265)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-my',value:"+60","data-value":"MY"},"Malaysia (+60)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-mv',value:"+960","data-value":"MV"},"Maldives (+960)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ml',value:"+223","data-value":"ML"},"Mali (+223)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-mt',value:"+356","data-value":"MT"},"Malta (+356)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-mh',value:"+692","data-value":"MH"},"Marshall Islands (+692)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-mq',value:"+596","data-value":"MQ"},"Martinique (+596)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-mr',value:"+222","data-value":"MR"},"Mauritania (+222)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-mu',value:"+230","data-value":"MU"},"Mauritius (+230)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-yt',value:"+262","data-value":"YT"},"Mayotte (+262)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-mx',value:"+52","data-value":"MX"},"Mexico (+52)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-fm',value:"+691","data-value":"FM"},"Micronesia (+691)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-md',value:"+373","data-value":"MD"},"Moldova (+373)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-mc',value:"+377","data-value":"MC"},"Monaco (+377)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-mn',value:"+976","data-value":"MN"},"Mongolia (+976)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-me',value:"+382","data-value":"ME"},"Montenegro (+382)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ms',value:"+1","data-value":"MS"},"Montserrat (+1)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ma',value:"+212","data-value":"MA"},"Morocco (+212)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-mz',value:"+258","data-value":"MZ"},"Mozambique (+258)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-mm',value:"+95","data-value":"MM"},"Myanmar (+95)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-na',value:"+264","data-value":"NA"},"Namibia (+264)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-nr',value:"+674","data-value":"NR"},"Nauru (+674)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-np',value:"+977","data-value":"NP"},"Nepal (+977)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-nl',value:"+31","data-value":"NL"},"Netherlands (+31)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-an',value:"+599","data-value":"AN"},"Netherlands Antilles (Former) (+599)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-nc',value:"+687","data-value":"NC"},"New Caledonia (+687)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-nz',value:"+64","data-value":"NZ"},"New Zealand (+64)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ni',value:"+505","data-value":"NI"},"Nicaragua (+505)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ne',value:"+227","data-value":"NE"},"Niger (+227)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ng',value:"+234","data-value":"NG"},"Nigeria (+234)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-nu',value:"+683","data-value":"NU"},"Niue (+683)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-kp',value:"+850","data-value":"KP"},"North Korea (+850)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-mk',value:"+389","data-value":"MK"},"North Macedonia (+389)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-mp',value:"+1","data-value":"MP"},"Northern Mariana Islands (+1)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-no',value:"+47","data-value":"NO"},"Norway (+47)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-om',value:"+968","data-value":"OM"},"Oman (+968)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-pk',value:"+92","data-value":"PK"},"Pakistan (+92)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-pw',value:"+680","data-value":"PW"},"Palau (+680)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ps',value:"+970","data-value":"PS"},"Palestinian Authority (+970)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-pa',value:"+507","data-value":"PA"},"Panama (+507)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-pg',value:"+675","data-value":"PG"},"Papua New Guinea (+675)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-py',value:"+595","data-value":"PY"},"Paraguay (+595)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-pe',value:"+51","data-value":"PE"},"Peru (+51)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ph',value:"+63","data-value":"PH"},"Philippines (+63)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-pl',value:"+48","data-value":"PL"},"Poland (+48)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-pt',value:"+351","data-value":"PT"},"Portugal (+351)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-qa',value:"+974","data-value":"QA"},"Qatar (+974)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-re',value:"+262","data-value":"RE"},"R\xE9union (+262)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ro',value:"+40","data-value":"RO"},"Romania (+40)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ru',value:"+7","data-value":"RU"},"Russia (+7)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-rw',value:"+250","data-value":"RW"},"Rwanda (+250)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-xs',value:"+599","data-value":"XS"},"Saba (+599)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-kn',value:"+1","data-value":"KN"},"Saint Kitts and Nevis (+1)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-lc',value:"+1","data-value":"LC"},"Saint Lucia (+1)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-pm',value:"+508","data-value":"PM"},"Saint Pierre and Miquelon (+508)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-vc',value:"+1","data-value":"VC"},"Saint Vincent and the Grenadines (+1)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ws',value:"+685","data-value":"WS"},"Samoa (+685)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-sm',value:"+378","data-value":"SM"},"San Marino (+378)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-st',value:"+239","data-value":"ST"},"S\xE3o Tom\xE9 and Pr\xEDncipe (+239)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-sa',value:"+966","data-value":"SA"},"Saudi Arabia (+966)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-sn',value:"+221","data-value":"SN"},"Senegal (+221)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-rs',value:"+381","data-value":"RS"},"Serbia (+381)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-sc',value:"+248","data-value":"SC"},"Seychelles (+248)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-sl',value:"+232","data-value":"SL"},"Sierra Leone (+232)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-sg',value:"+65","data-value":"SG"},"Singapore (+65)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-xe',value:"+599","data-value":"XE"},"Sint Eustatius (+599)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-sk',value:"+421","data-value":"SK"},"Slovakia (+421)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-si',value:"+386","data-value":"SI"},"Slovenia (+386)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-sb',value:"+677","data-value":"SB"},"Solomon Islands (+677)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-so',value:"+252","data-value":"SO"},"Somalia (+252)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-za',value:"+27","data-value":"ZA"},"South Africa (+27)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ss',value:"+211","data-value":"SS"},"South Sudan (+211)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-es',value:"+34","data-value":"ES"},"Spain (+34)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-lk',value:"+94","data-value":"LK"},"Sri Lanka (+94)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-sh',value:"+290","data-value":"SH"},"St Helena, Ascension, and Tristan da Cunha (+290)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-sd',value:"+249","data-value":"SD"},"Sudan (+249)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-sr',value:"+597","data-value":"SR"},"Suriname (+597)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-sj',value:"+47","data-value":"SJ"},"Svalbard (+47)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-sz',value:"+268","data-value":"SZ"},"Swaziland (+268)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-se',value:"+46","data-value":"SE"},"Sweden (+46)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ch',value:"+41","data-value":"CH"},"Switzerland (+41)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-sy',value:"+963","data-value":"SY"},"Syria (+963)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-tw',value:"+886","data-value":"TW"},"Taiwan (+886)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-tj',value:"+992","data-value":"TJ"},"Tajikistan (+992)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-tz',value:"+255","data-value":"TZ"},"Tanzania (+255)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-th',value:"+66","data-value":"TH"},"Thailand (+66)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-tl',value:"+670","data-value":"TL"},"Timor-Leste (+670)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-tg',value:"+228","data-value":"TG"},"Togo (+228)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-tk',value:"+690","data-value":"TK"},"Tokelau (+690)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-to',value:"+676","data-value":"TO"},"Tonga (+676)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-tt',value:"+1","data-value":"TT"},"Trinidad and Tobago (+1)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ta',value:"+290","data-value":"TA"},"Tristan da Cunha (+290)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-tn',value:"+216","data-value":"TN"},"Tunisia (+216)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-tr',value:"+90","data-value":"TR"},"Turkey (+90)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-tm',value:"+993","data-value":"TM"},"Turkmenistan (+993)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-tc',value:"+1","data-value":"TC"},"Turks and Caicos Islands (+1)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-tv',value:"+688","data-value":"TV"},"Tuvalu (+688)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-um',value:"+1","data-value":"UM"},"U.S. Outlying Islands (+1)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-vi',value:"+1","data-value":"VI"},"U.S. Virgin Islands (+1)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ug',value:"+256","data-value":"UG"},"Uganda (+256)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ua',value:"+380","data-value":"UA"},"Ukraine (+380)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ae',value:"+971","data-value":"AE"},"United Arab Emirates (+971)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-uk',value:"+44","data-value":"UK"},"United Kingdom (+44)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-us',value:"+1","data-value":"US"},"United States (+1)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-uy',value:"+598","data-value":"UY"},"Uruguay (+598)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-uz',value:"+998","data-value":"UZ"},"Uzbekistan (+998)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-vu',value:"+678","data-value":"VU"},"Vanuatu (+678)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-va',value:"+379","data-value":"VA"},"Vatican City (+379)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ve',value:"+58","data-value":"VE"},"Venezuela (+58)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-vn',value:"+84","data-value":"VN"},"Vietnam (+84)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-wf',value:"+681","data-value":"WF"},"Wallis and Futuna (+681)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-ye',value:"+967","data-value":"YE"},"Yemen (+967)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-zm',value:"+260","data-value":"ZM"},"Zambia (+260)"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["x" /* MenuItem */],{className:classes.selectElementItem,key:'phone-prefix-zw',value:"+263","data-value":"ZW"},"Zimbabwe (+263)")];return COUNTRY_OPTIONS.map(function(el){return el;});}},{key:"onTextFieldChange",value:function onTextFieldChange(event,name){this.setFieldState(name,event.target.value);}},{key:"validateAll",value:function validateAll(){var errors={};for(var field in __WEBPACK_IMPORTED_MODULE_13__ContactSalesSchema__["a" /* default */]){var validate=__WEBPACK_IMPORTED_MODULE_13__ContactSalesSchema__["a" /* default */][field];if(validate){var error=validate(this.state.values[field],this.state,this.props);if(error){errors[field]=error;}}}this.setState({errors:errors});}},{key:"onTextFieldBlur",value:function onTextFieldBlur(event,name){var newState=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.cloneDeep(this.state);newState.touched[name]=true;this.setState(newState,this.validateAll);}},{key:"onSelectFieldChange",value:function onSelectFieldChange(event,name){this.setFieldState(name,event.target.value);}},{key:"setFieldState",value:function setFieldState(fieldName,value){var newState=__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.cloneDeep(this.state);newState.touched[fieldName]=true;newState.values=__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},newState.values||{},__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()({},fieldName,value));this.setState(newState,this.validateAll);}},{key:"onKeyPress",value:function onKeyPress(event,name){if(!this.isSubmitEnabled()||name==='usageInfo')return;if(event.key==='Enter'){this.submitForm();}}},{key:"submitForm",value:function submitForm(){this.setState({xhrInProgress:true,apiRequestError:false,apiRequestSuccess:false,errors:{apiError:null}});this.props.sendContactSalesRequest(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({companyId:this.props.selectedCompanyId,'user-xc-id':__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(this.props.user,'userId'),sessionEmail:__WEBPACK_IMPORTED_MODULE_22_lodash___default.a.get(this.props.user,'mainEmail'),'process-sales-form':1,lang:__WEBPACK_IMPORTED_MODULE_27_i18n_i18n__["a" /* default */].getCurrentLanguage()},this.state.values));}}]);return ContactSalesModal;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]))||_class);ContactSalesModal.propTypes={companies:__WEBPACK_IMPORTED_MODULE_19_prop_types___default.a.object,modalShown:__WEBPACK_IMPORTED_MODULE_19_prop_types___default.a.bool,hideModal:__WEBPACK_IMPORTED_MODULE_19_prop_types___default.a.func,resetModal:__WEBPACK_IMPORTED_MODULE_19_prop_types___default.a.func,selectedCompanyId:__WEBPACK_IMPORTED_MODULE_19_prop_types___default.a.string,classes:__WEBPACK_IMPORTED_MODULE_19_prop_types___default.a.object,sendContactSalesRequest:__WEBPACK_IMPORTED_MODULE_19_prop_types___default.a.func,user:__WEBPACK_IMPORTED_MODULE_19_prop_types___default.a.object.isRequired,title:__WEBPACK_IMPORTED_MODULE_19_prop_types___default.a.string,company:__WEBPACK_IMPORTED_MODULE_19_prop_types___default.a.object};var mapStateToProps=function mapStateToProps(state){return{company:state.companies.rawDataById?state.companies.rawDataById[state.companies.selectedId]:null,selectedCompanyId:state.companies.selectedId,modalShown:state.modal.modalShown,companies:state.companies,user:state.session.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_10_redux__["b" /* bindActionCreators */])({sendContactSalesRequest:__WEBPACK_IMPORTED_MODULE_16_redux_modules_companies__["E" /* sendContactSalesRequest */],hideModal:__WEBPACK_IMPORTED_MODULE_15_redux_modules_modal__["b" /* hideModal */],resetModal:__WEBPACK_IMPORTED_MODULE_15_redux_modules_modal__["c" /* resetModal */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ContactSalesModal));

/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validator_lib_isEmail__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validator_lib_isEmail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_validator_lib_isEmail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_i18n__ = __webpack_require__(15);
var localize=__WEBPACK_IMPORTED_MODULE_1_i18n_i18n__["a" /* default */].loc.localize;var schema={'firstName':function firstName(value,state){if(state.touched['firstName']){if(!value){return localize('required-field');}}},'lastName':function lastName(value,state){if(state.touched['lastName']){if(!value){return localize('required-field');}}},'companyName':function companyName(value,state){if(state.touched['companyName']){if(!value){return localize('required-field');}}},'nrOfUsers':function nrOfUsers(value,state){if(state.touched['nrOfUsers']){if(!value){return localize('required-field');}}},'workEmail':function workEmail(value,state){if(state.touched['workEmail']){if(!value){return localize('required-field');}if(!__WEBPACK_IMPORTED_MODULE_0_validator_lib_isEmail___default()(value)){return localize('contact-sales-email-invalid');}}},'jobTitle':function jobTitle(value,state){if(state.touched['jobTitle']){if(!value){return localize('required-field');}}},'phoneNumber':function phoneNumber(value,state){if(state.touched['phoneNumber']){// eslint-disable-next-line no-useless-escape
if(value&&value.match(/^[0-9\-\+\(\)\s]*$/)===null){return localize('contact-sales-phone-invalid');}}},'usageInfo':function usageInfo(value,state){if(state.touched['usageInfo']){if(!value){return localize('required-field');}}}};/* harmony default export */ __webpack_exports__["a"] = (schema);

/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux_modules_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_redux_modules_companies__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_subscription__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_QuantityField__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__errors_apperror__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__theme_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_PromoForm__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lib_Segment_customTrackers__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lib_Segment_helpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_i18n_i18n__ = __webpack_require__(15);
var _errors,_dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_26_i18n_i18n__["a" /* default */].loc.localize;var styles=function styles(theme){return{/* Dialog */dialogPaper:{minWidth:444},dialogWrapper:{position:'relative',padding:'15px 10px',minHeight:270},dialogTitle:{'& h6':{fontWeight:600,fontSize:'28px',lineHeight:1.4,marginBottom:5,textAlign:'left'}},/* close button */closeDialog:{position:'absolute',top:10,right:10},closeDialogIcon:{color:'#6F99BD',width:'20px',height:'20px'},text:{textAlign:'left',color:'#000',opacity:1},/* price per license */priceGridElement:{textAlign:'left'},pricePerLicense:{display:'inline-block',marginBottom:16,marginRight:10},couponCodeLink:{fontFamily:'Lato, "Open Sans Xara", Arial, Helvetica, sans-serif',fontSize:14,textDecoration:'underline','&:hover':{color:'#2888C3'}},showDiscountForm:{},changeDiscountForm:{display:'block',marginTop:-6,marginBottom:6},discountAppliedLabel:{fontFamily:'"Open Sans Xara", Arial, Helvetica, sans-serif',fontWeight:'normal',fontSize:14,lineHeight:1.5,background:'#E1F4FD',color:'#2888C3',display:'inline-block',padding:'1px 5px',opacity:1,borderRadius:5},seatsDiscountAppliedLabel:{marginLeft:5,fontSize:14,lineHeight:1.5},invalidDiscount:{display:'inline-block',marginRight:10,marginTop:5,marginBottom:18,color:theme.palette.colors.error},invalidCouponMessage:{marginRight:10},/* promo form */promoFormGridElement:{marginBottom:16},/* total users */totalUsersAfterPurchase:{},roleInfo:{},/* total price for seats */totalPriceforExtraSeats:{paddingTop:20,paddingBottom:10},/* quantity */quantityGridElement:{},/* total users */totalUsersGridElement:{},/* buttons */buttonsContainer:{paddingTop:30},button:{fontFamily:'Open Sans, sans-serif',borderRadius:5,fontWeight:600,fontSize:18,lineHeight:1.3,opacity:'1 !important',color:'#000',paddingLeft:15,paddingRight:15,minWidth:'auto'},buttonCancel:{},buttonContinue:{background:theme.palette.primary.main,color:'white',textShadow:'none','&[class*=contained][class*=disabled]':{backgroundColor:'#B3B9C0'},marginLeft:10},/* error message */errorMessage:{color:theme.palette.error.main,fontSize:14,lineHeight:1.5,opacity:1,textAlign:'left',marginTop:0,marginBottom:15,'& a':{color:theme.palette.primary.main}},/* loading icon */loadingWrapper:{position:'absolute',top:'50%',left:'50%',transform:'translate(-50%, -50%)'},loadingMessage:{fontSize:16,lineHeight:1.5,opacity:1},loadingIcon:{display:'block',height:'24px',width:'24px',margin:'0 auto 10px',fill:'#96DCFD',animation:'spin 2s linear infinite'},'@keyframes spin':{'0':{transform:'rotate(0deg)'},'100%':{transform:'rotate(360deg)'}},/* magix discount link */discountBannerContainer:{flexWrap:'nowrap',marginBottom:15},discountBannerQuestionColumn:{},discountBannerQuestion:{color:'#000',fontSize:15,lineHeight:1.2,opacity:1},discountBannerGetDiscountButtonColumn:{padding:'0 0 0 10px'},discountBannerLink:{fontSize:14,color:'#000',lineHeight:1.2,opacity:1,fontWeight:600,fontFamily:'Lato, "Open Sans Xara", Arial, Helvetica, sans-serif',textTransform:'uppercase'}};};var errors=(_errors={},__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_18__errors_errorids__["a" /* default */].OFFLINE,localize('subscriptions-error-offline')),__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_18__errors_errorids__["a" /* default */].API_REQUEST_LIMIT_EXCEEDED,localize('error-cb-api-rate-limit-reached')),_errors);var BuyMoreLicensesOrSeatsModal=(_dec=Object(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(BuyMoreLicensesOrSeatsModal,_Component);function BuyMoreLicensesOrSeatsModal(props){var _this;__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,BuyMoreLicensesOrSeatsModal);_this=__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(BuyMoreLicensesOrSeatsModal).call(this,props));_this.getEstimatedCostForSeatsDebounced=__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.debounce(_this.getEstimatedCostForSeats,350);_this.hasCouponError=_this.hasCouponError.bind(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_assertThisInitialized___default()(_this));_this.state={showPromoForm:false,inputFieldQuantity:_this.getInputFieldQuantity(props.type),apiRequestError:false,apiRequestSuccess:false,xhrInProgress:false,fetchingSeatsCostEstimate:false,fetchingSeatsCostEstimateError:false,seatsCostEstimate:null,discountPercent:null,isTaxed:null,hasCouponError:false,errors:{}};return _this;}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(BuyMoreLicensesOrSeatsModal,[{key:"componentDidMount",value:function componentDidMount(){if(this.props.type===__WEBPACK_IMPORTED_MODULE_22__config__["j" /* BUY_MORE_POPUP_TYPE */].LICENSES){Object(__WEBPACK_IMPORTED_MODULE_24_lib_Segment_customTrackers__["i" /* trackBuyMoreLicensesPopupShown */])(this.props.plan,Object(__WEBPACK_IMPORTED_MODULE_25_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}else{Object(__WEBPACK_IMPORTED_MODULE_24_lib_Segment_customTrackers__["j" /* trackBuyMoreSeatsPopupShown */])(this.props.plan,Object(__WEBPACK_IMPORTED_MODULE_25_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));this.getEstimatedCostForSeats(this.state.inputFieldQuantity);}}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState){var type=this.props.type;this.updateSeatsQuantity(prevProps,type);}},{key:"updateSeatsQuantity",value:function updateSeatsQuantity(compareProps,type){if(type===__WEBPACK_IMPORTED_MODULE_22__config__["j" /* BUY_MORE_POPUP_TYPE */].SEATS&&(this.props.app.seatsQuantity!==compareProps.app.seatsQuantity||this.props.app.isSeatsQuantityAutoApplied!==compareProps.app.isSeatsQuantityAutoApplied)||type===__WEBPACK_IMPORTED_MODULE_22__config__["j" /* BUY_MORE_POPUP_TYPE */].LICENSES&&(this.props.app.licensesQuantity!==compareProps.app.licensesQuantity||this.props.app.isLicensesQuantityAutoApplied!==compareProps.app.isLicensesQuantityAutoApplied)){var quantity=this.getInputFieldQuantity(type);this.setState({inputFieldQuantity:quantity});if(type===__WEBPACK_IMPORTED_MODULE_22__config__["j" /* BUY_MORE_POPUP_TYPE */].SEATS&&Object(__WEBPACK_IMPORTED_MODULE_15__utils_subscription__["v" /* isValidNonZeroQuantity */])(quantity)){this.getEstimatedCostForSeatsDebounced(quantity);}}}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(this.props.companies.createChargeBeeSubscriptionErrorId!==nextProps.companies.createChargeBeeSubscriptionErrorId&&nextProps.companies.createChargeBeeSubscriptionErrorId!==null||this.props.companies.purchaseSeatsErrorId!==nextProps.companies.purchaseSeatsErrorId&&nextProps.companies.purchaseSeatsErrorId!==null){this.handleApiErrors(nextProps);}if(this.props.companies.createChargeBeeSubscriptionSuccess!==nextProps.companies.createChargeBeeSubscriptionSuccess&&nextProps.companies.createChargeBeeSubscriptionSuccess===true||this.props.companies.purchaseSeatsSuccess!==nextProps.companies.purchaseSeatsSuccess&&nextProps.companies.purchaseSeatsSuccess===true){this.setState({xhrInProgress:false,apiRequestError:false,apiRequestSuccess:true,errors:{apiError:null}});}}},{key:"render",value:function render(){var _this2=this;var _this$props=this.props,modalShown=_this$props.modalShown,resetModal=_this$props.resetModal,classes=_this$props.classes;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["d" /* Dialog */],{open:modalShown,"aria-labelledby":"alert-dialog-title","aria-describedby":"alert-dialog-description",onExited:resetModal,BackdropProps:{style:{backgroundColor:'rgba(46, 63, 79, 0.4)'}},classes:{paper:classes.dialogPaper},PaperProps:{style:{border:0,width:309,borderRadius:5,boxShadow:'0px 4px 24px rgba(0, 0, 0, 0.08)'}}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{className:classes.dialogWrapper},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["p" /* IconButton */],{className:classes.closeDialog,component:"span","aria-label":"Close",onClick:function onClick(){return _this2.closeDialog(false);}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__theme_icons__["_11" /* XIcon */],{className:classes.closeDialogIcon})),function(){if(_this2.state.xhrInProgress){return _this2.renderLoading();}else if(_this2.state.apiRequestSuccess){_this2.closeDialog(true);}else if(_this2.state.apiRequestError){return _this2.renderForm();}else{return _this2.renderForm();}}()));}},{key:"renderForm",value:function renderForm(){var _this3=this;var _this$props2=this.props,type=_this$props2.type,classes=_this$props2.classes;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["g" /* DialogTitle */],{variant:"body1",color:"default",className:classes.dialogTitle},localize(type===__WEBPACK_IMPORTED_MODULE_22__config__["j" /* BUY_MORE_POPUP_TYPE */].LICENSES?'subscription-extra-licenses-title':'subscription-extra-users-title')),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["f" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{container:true,direction:"column"},Object.keys(this.state.errors).length>0&&this.renderErrorMessage(),type===__WEBPACK_IMPORTED_MODULE_22__config__["j" /* BUY_MORE_POPUP_TYPE */].LICENSES?this.renderLicensesForm():this.renderSeatsForm(),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{item:true,container:true,direction:"row",justify:"flex-end",className:__WEBPACK_IMPORTED_MODULE_11_classnames___default()(classes.buttonsContainer)},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{item:true},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["a" /* Button */],{variant:"outlined",color:"primary","data-tid":"button-buy-more-modal-cancel",className:__WEBPACK_IMPORTED_MODULE_11_classnames___default()(classes.button,classes.buttonCancel),onClick:function onClick(){return _this3.closeDialog(false);},disabled:false},localize('cancel'))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{item:true},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["a" /* Button */],{variant:"contained",color:"primary","data-tid":"button-buy-more-modal-save",className:__WEBPACK_IMPORTED_MODULE_11_classnames___default()(classes.button,classes.buttonContinue),onClick:function onClick(){return _this3.submitForm();},disabled:!this.isFormValid()},type===__WEBPACK_IMPORTED_MODULE_22__config__["j" /* BUY_MORE_POPUP_TYPE */].LICENSES?localize('continue'):localize('pay-now')))))));}},{key:"renderLicensesForm",value:function renderLicensesForm(){var _this4=this;var _this$props3=this.props,currency=_this$props3.currency,plan=_this$props3.plan,classes=_this$props3.classes;var showPromoForm=this.state.showPromoForm;var _this$props$discount=this.props.discount,isDiscountApplied=_this$props$discount.isDiscountApplied,discountType=_this$props$discount.discountType,couponId=_this$props$discount.couponId,couponSetKey=_this$props$discount.couponSetKey,couponConfig=_this$props$discount.couponConfig,couponType=_this$props$discount.couponType,appliedProdTypeOfLastValidCombination=_this$props$discount.appliedProdTypeOfLastValidCombination,appliedProdCatOfLastValidCombination=_this$props$discount.appliedProdCatOfLastValidCombination;var pricePerLicense=parseFloat(__WEBPACK_IMPORTED_MODULE_22__config__["_44" /* SUBSCRIPTION_PRICES */][plan][__WEBPACK_IMPORTED_MODULE_22__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL]);var discountPrice;var showDiscount=isDiscountApplied&&this.props.shouldShowAppliedDiscountForCurrentPackage(plan,__WEBPACK_IMPORTED_MODULE_22__config__["_41" /* SUBSCRIPTION_PERIOD */].PERPETUAL,currency.key,couponConfig,discountType,couponSetKey,couponId,false,appliedProdTypeOfLastValidCombination,appliedProdCatOfLastValidCombination);if(showDiscount){discountPrice=this.props.getDiscountPrice(pricePerLicense,plan);}var nrOfQualifyingProductsForCouponInAllCurrencies=this.props.getNumberOfQualifyingProductsForCoupon(true,false,false,plan);var nrOfQualifyingSubscriptions=this.props.getNumberOfQualifyingProductsForCoupon(true,true,false);var nrOfQualifyingPerpetualProducts=this.props.getNumberOfQualifyingProductsForCoupon(true,false,true);var invalidDiscount=isDiscountApplied&&!showDiscount&&couponType===__WEBPACK_IMPORTED_MODULE_22__config__["v" /* COUPON_TYPE */].LICENSES;var checkoutPrice=discountPrice||pricePerLicense;checkoutPrice=checkoutPrice.toFixed(2);return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{item:true,className:classes.priceGridElement},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["M" /* Typography */],{variant:"body1",className:__WEBPACK_IMPORTED_MODULE_11_classnames___default()(classes.pricePerLicense,classes.text)},localize('subscription-extra-licenses-cost-per-license',[currency.symbol,checkoutPrice])),showDiscount&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["M" /* Typography */],{className:classes.discountAppliedLabel},localize('subscription-extra-licenses-discount-applied')),!showPromoForm&&!showDiscount&&!invalidDiscount&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["r" /* Link */],{underline:"hover","data-tid":'button-discount-banner',onClick:function onClick(){return _this4.showDiscountForm();},className:__WEBPACK_IMPORTED_MODULE_11_classnames___default()(classes.couponCodeLink,classes.showDiscountForm)},localize('subscription-extra-licenses-discount-use')),!showPromoForm&&showDiscount&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["r" /* Link */],{underline:"hover","data-tid":'button-discount-banner',onClick:function onClick(){return _this4.resetDiscountForm();},className:__WEBPACK_IMPORTED_MODULE_11_classnames___default()(classes.couponCodeLink,classes.changeDiscountForm)},localize('subscription-extra-licenses-change-coupon')),!showPromoForm&&!showDiscount&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{container:true,direction:"row",className:__WEBPACK_IMPORTED_MODULE_11_classnames___default()(classes.discountBannerContainer)},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{item:true,className:classes.discountBannerQuestionColumn},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["M" /* Typography */],{variant:"body2",className:classes.discountBannerQuestion,dangerouslySetInnerHTML:{__html:localize('subscription-discount-magix')}})),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{item:true,className:classes.discountBannerGetDiscountButtonColumn},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["r" /* Link */],{underline:"hover","data-tid":'button-discount-banner',className:__WEBPACK_IMPORTED_MODULE_11_classnames___default()(classes.discountBannerGetDiscountButton,classes.discountBannerLink),onClick:function onClick(){return _this4.props.routeToOneTimeCheckBoxAndShowDiscountPopup();}},localize('subscription-discount-get'))))),showPromoForm&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{item:true,className:__WEBPACK_IMPORTED_MODULE_11_classnames___default()(classes.promoFormGridElement)},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_PromoForm__["a" /* default */],{type:__WEBPACK_IMPORTED_MODULE_22__config__["v" /* COUPON_TYPE */].LICENSES,currency:this.props.currency,nrOfQualifyingProductsForCoupon:showDiscount?1:0,nrOfQualifyingProductsForCouponInAllCurrencies:nrOfQualifyingProductsForCouponInAllCurrencies,nrOfQualifyingSubscriptions:nrOfQualifyingSubscriptions,nrOfQualifyingPerpetualProducts:nrOfQualifyingPerpetualProducts,getQualifyingProductsForCoupon:this.props.getQualifyingProductsForCoupon,addVersionToTitle:this.props.addVersionToTitle,plan:this.props.plan,handleSwitchToPlansFromBuyMoreLicensesPopup:this.props.handleSwitchToPlansFromBuyMoreLicensesPopup,contactUsHandler:this.props.contactUsHandler,hasCouponError:this.hasCouponError})),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{item:true,className:classes.quantityGridElement},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_QuantityField__["a" /* default */],{quantity:this.state.inputFieldQuantity,renderInfoTooltip:this.props.renderInfoTooltip,quantityType:this.props.type,isBuyMorePopup:true})));}},{key:"renderSeatsForm",value:function renderSeatsForm(){var _this5=this;var _this$props4=this.props,currency=_this$props4.currency,plan=_this$props4.plan,classes=_this$props4.classes,period=_this$props4.period;var _this$state=this.state,seatsCostEstimate=_this$state.seatsCostEstimate,discountPercent=_this$state.discountPercent,fetchingSeatsCostEstimate=_this$state.fetchingSeatsCostEstimate,fetchingSeatsCostEstimateError=_this$state.fetchingSeatsCostEstimateError,isTaxed=_this$state.isTaxed;var renderCostEstimate=function renderCostEstimate(){if(seatsCostEstimate!==null){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react__["Fragment"],null,currency.symbol,seatsCostEstimate," / ",localize(period===__WEBPACK_IMPORTED_MODULE_22__config__["_41" /* SUBSCRIPTION_PERIOD */].ANNUAL?'subscription-billing-year':'subscription-billing-month')," ",isTaxed&&"(".concat(localize('subscription-including-vat'),")"),discountPercent&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("span",{className:__WEBPACK_IMPORTED_MODULE_11_classnames___default()(classes.discountAppliedLabel,classes.seatsDiscountAppliedLabel)},discountPercent,"% ",localize('subscription-extra-users-seat-discount-applied')));}else if(fetchingSeatsCostEstimate){return localize('subscription-extra-users-calculating-total');}else if(fetchingSeatsCostEstimateError){return _this5.props.companies.estimateCostOnAddUserSeatsErrorId&&errors[_this5.props.companies.estimateCostOnAddUserSeatsErrorId]||localize('subscription-extra-users-error-calculating');}};var totalNumberOfUserLicenses=this.props.companies.pendingPayingUserQuantity?parseInt(this.state.inputFieldQuantity)+this.props.companies.pendingPayingUserQuantity:parseInt(this.state.inputFieldQuantity)+Object(__WEBPACK_IMPORTED_MODULE_15__utils_subscription__["e" /* getMembersPaidQuantity */])(this.props.company)+__WEBPACK_IMPORTED_MODULE_22__config__["_3" /* PACKAGES_CONFIG */][plan].freeSeatsIncluded;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{item:true,className:classes.quantityGridElement},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_QuantityField__["a" /* default */],{quantity:this.state.inputFieldQuantity,renderInfoTooltip:this.props.renderInfoTooltip,plan:plan,quantityType:this.props.type,enableBulkDiscountTooltip:true,isBuyMorePopup:true})),this.isFormValid()&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{item:true,className:classes.totalUsersGridElement},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["M" /* Typography */],{variant:"body1",className:__WEBPACK_IMPORTED_MODULE_11_classnames___default()(classes.totalUsersAfterPurchase,classes.text)},localize('subscription-extra-users-total-users-after-purchase',totalNumberOfUserLicenses)),[__WEBPACK_IMPORTED_MODULE_22__config__["_42" /* SUBSCRIPTION_PLAN */].TEAM_PLUS,__WEBPACK_IMPORTED_MODULE_22__config__["_42" /* SUBSCRIPTION_PLAN */].ESSENTIAL].includes(plan)&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["M" /* Typography */],{variant:"body1",className:__WEBPACK_IMPORTED_MODULE_11_classnames___default()(classes.roleInfo,classes.text)},localize('subscription-extra-users-admin-member-usage'))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["o" /* Grid */],{item:true,className:classes.totalUsersGridElement},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["M" /* Typography */],{variant:"body1",className:__WEBPACK_IMPORTED_MODULE_11_classnames___default()(classes.totalPriceforExtraSeats,classes.text)},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("span",null,localize('subscription-extra-users-total-until-renewal'),":\xA0"),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("span",null,renderCostEstimate())))));}},{key:"getInputFieldQuantity",value:function getInputFieldQuantity(type){return this.props.getQuantityInputValue(type===__WEBPACK_IMPORTED_MODULE_22__config__["j" /* BUY_MORE_POPUP_TYPE */].SEATS?__WEBPACK_IMPORTED_MODULE_22__config__["_19" /* QUANTITY_TYPE */].SEATS:__WEBPACK_IMPORTED_MODULE_22__config__["_19" /* QUANTITY_TYPE */].LICENSES);}},{key:"closeDialog",value:function closeDialog(closeDuringCheckout){this.props.clearInvalidFieldsForBuyMorePopup(true,!closeDuringCheckout&&this.state.hasCouponError);this.props.hideModal();}},{key:"renderLoading",value:function renderLoading(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{className:classes.loadingWrapper},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__theme_icons__["Y" /* SpinnerIcon */],{className:classes.loadingIcon}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["M" /* Typography */],{className:classes.loadingMessage,variant:"body2"},localize('subscriptions-modal-fetching-data')));}},{key:"renderErrorMessage",value:function renderErrorMessage(){var errorMessage=__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.get(this.state,'errors.apiError');var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["M" /* Typography */],{className:classes.errorMessage,variant:"body2",dangerouslySetInnerHTML:{__html:errorMessage}});}},{key:"handleApiErrors",value:function handleApiErrors(nextProps){if(nextProps.companies.createChargeBeeSubscriptionErrorId||nextProps.companies.purchaseSeatsErrorId){var errorMessage=nextProps.companies.createChargeBeeSubscriptionErrorId&&errors[nextProps.companies.createChargeBeeSubscriptionErrorId]||nextProps.companies.purchaseSeatsErrorId&&errors[nextProps.companies.purchaseSeatsErrorId]||localize('subscriptions-error-unknown');this.setState({xhrInProgress:false,apiRequestError:true,apiRequestSuccess:false,errors:{apiError:errorMessage}});}}},{key:"isFormValid",value:function isFormValid(){return Object(__WEBPACK_IMPORTED_MODULE_15__utils_subscription__["v" /* isValidNonZeroQuantity */])(this.state.inputFieldQuantity);}},{key:"hasCouponError",value:function hasCouponError(value){this.setState({hasCouponError:value});}},{key:"showDiscountForm",value:function showDiscountForm(){this.setState({showPromoForm:true});}},{key:"resetDiscountForm",value:function resetDiscountForm(){this.setState({showPromoForm:true});}},{key:"getEstimatedCostForSeats",value:function getEstimatedCostForSeats(quantity){var _this6=this;this.setState({fetchingSeatsCostEstimate:true});this.props.estimateCostOnAddUserSeats(quantity).then(function(data){if(data instanceof __WEBPACK_IMPORTED_MODULE_19__errors_apperror__["a" /* default */]){_this6.setState({fetchingSeatsCostEstimate:false,fetchingSeatsCostEstimateError:true,seatsCostEstimate:null,discountPercent:null,isTaxed:null});return;}var _data$result=data.result,amount=_data$result.amount,discountAmountWithoutTax=_data$result.discountAmountWithoutTax,amountWithoutTaxAndWithoutDiscount=_data$result.amountWithoutTaxAndWithoutDiscount,amountWithoutTaxAndWithDiscount=_data$result.amountWithoutTaxAndWithDiscount,taxRate=_data$result.taxRate;var discountPercent;if(discountAmountWithoutTax&&amountWithoutTaxAndWithoutDiscount&&amountWithoutTaxAndWithDiscount){discountPercent=Math.ceil((1-amountWithoutTaxAndWithDiscount/amountWithoutTaxAndWithoutDiscount)*100);}_this6.setState({fetchingSeatsCostEstimate:false,fetchingSeatsCostEstimateError:false,seatsCostEstimate:amount?(amount/100).toFixed(2):0,discountPercent:discountPercent,isTaxed:taxRate!==null});});}},{key:"submitForm",value:function submitForm(){this.setState({xhrInProgress:true,apiRequestError:false,apiRequestSuccess:false,errors:{apiError:null}});this.props.cb(this.state.hasCouponError);}}]);return BuyMoreLicensesOrSeatsModal;}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]))||_class);BuyMoreLicensesOrSeatsModal.propTypes={companies:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.object,modalShown:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.bool,hideModal:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,resetModal:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,classes:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.object,plan:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string,type:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string,currency:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.object,discount:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.object.isRequired,cb:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,shouldShowAppliedDiscountForCurrentPackage:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,getNumberOfQualifyingProductsForCoupon:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,getQualifyingProductsForCoupon:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,getDiscountPrice:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,getQuantityInputValue:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,clearInvalidFieldsForBuyMorePopup:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,renderInfoTooltip:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,app:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.object.isRequired,nrOfNonGuestUsers:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.number,period:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.string,estimateCostOnAddUserSeats:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,company:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.object,contactUsHandler:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,addVersionToTitle:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,handleSwitchToPlansFromBuyMoreLicensesPopup:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func,routeToOneTimeCheckBoxAndShowDiscountPopup:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func};var mapStateToProps=function mapStateToProps(state){return{modalShown:state.modal.modalShown,discount:state.discount,companies:state.companies,app:state.app,company:state.companies.rawDataById[state.companies.selectedId]};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])({estimateCostOnAddUserSeats:__WEBPACK_IMPORTED_MODULE_13_redux_modules_companies__["l" /* estimateCostOnAddUserSeats */],hideModal:__WEBPACK_IMPORTED_MODULE_12_redux_modules_modal__["b" /* hideModal */],resetModal:__WEBPACK_IMPORTED_MODULE_12_redux_modules_modal__["c" /* resetModal */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(BuyMoreLicensesOrSeatsModal));

/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils_users__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Features_components__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_KeyboardArrowDown__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_KeyboardArrowDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_KeyboardArrowDown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_custom_scrollbars__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_custom_scrollbars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_custom_scrollbars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_redux_modules_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_redux_modules_companies__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_RolesTooltip__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_redux_modules_session__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__material_ui_core__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__theme_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lib_Segment_customTrackers__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_lib_Segment_helpers__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_i18n_i18n__ = __webpack_require__(15);
var _errors,_dec,_class;var localize=__WEBPACK_IMPORTED_MODULE_30_i18n_i18n__["a" /* default */].loc.localize;var REDUCE_ACTIONS=[{key:__WEBPACK_IMPORTED_MODULE_27__config__["_27" /* REDUCE_ACTION */].KEEP_ROLE,value:localize('subscription-reduce-action-keep-role')},{key:__WEBPACK_IMPORTED_MODULE_27__config__["_27" /* REDUCE_ACTION */].CHANGE_TO_GUEST,value:localize('subscription-reduce-action-change-to-guest')},{key:__WEBPACK_IMPORTED_MODULE_27__config__["_27" /* REDUCE_ACTION */].REMOVE,value:localize('subscription-reduce-action-remove')}];var styles=function styles(theme){return __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectSpread___default()({/* Dialog */dialogPaper:__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()({minWidth:960},theme.breakpoints.down('sm'),{minWidth:'90%'}),dialogWrapper:{position:'relative',padding:'15px 10px',minHeight:576},dialogTitle:{'& h6':{fontWeight:600,fontSize:'28px',lineHeight:1.4,marginBottom:5,textAlign:'left'}},/* close button */closeDialog:{position:'absolute',top:10,right:10},closeDialogIcon:{color:'#6F99BD',width:'20px',height:'20px'},text:{textAlign:'left',color:'#000',opacity:1},/* intro description */description:{marginBottom:20},remaining:{marginBottom:20,'& span':{fontWeight:600,color:theme.palette.colors.alpha}},introText:{color:'#000',textAlign:'left',opacity:1},/* buttons */buttonsContainer:{paddingTop:40},aboutRolesGridElement:{paddingTop:8},aboutRoles:{display:'inline-block',marginRight:5,fontFamily:'"Open Sans Xara", Arial, Helvetica, sans-serif',fontWeight:'normal',fontSize:14,lineHeight:1.5,opacity:1},cancelButtonGridElement:{marginLeft:'auto'},continueButtonGridElement:{},button:{fontFamily:'Open Sans, sans-serif',borderRadius:5,fontWeight:600,fontSize:18,lineHeight:1.3,opacity:'1 !important',color:'#000',paddingLeft:15,paddingRight:15,minWidth:'auto'},buttonCancel:{},buttonContinue:{background:theme.palette.primary.main,color:'white',textShadow:'none','&[class*=contained][class*=disabled]':{backgroundColor:'#B3B9C0'},marginLeft:10},/* error message */errorMessage:{color:theme.palette.error.main,fontSize:14,lineHeight:1.5,opacity:1,textAlign:'left',marginTop:0,marginBottom:15,'& a':{color:theme.palette.primary.main}},/* loading icon */loadingWrapper:{position:'absolute',top:'50%',left:'50%',transform:'translate(-50%, -50%)'},loadingMessage:{fontSize:16,lineHeight:1.5,opacity:1},loadingIcon:{display:'block',height:'24px',width:'24px',margin:'0 auto 10px',fill:'#96DCFD',animation:'spin 2s linear infinite'}},Object(__WEBPACK_IMPORTED_MODULE_13_utils_users__["g" /* getTableStyleProps */])(__WEBPACK_IMPORTED_MODULE_27__config__["_62" /* USER_TABLE_REDUCE_USERS */],theme),{/* user table */tableWrapper:{width:'calc(100% + 15px)'}});};var errors=(_errors={},__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_22__errors_errorids__["a" /* default */].API_REQUEST_LIMIT_EXCEEDED,localize('error-cb-api-rate-limit-reached')),__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_errors,__WEBPACK_IMPORTED_MODULE_22__errors_errorids__["a" /* default */].OFFLINE,localize('subscriptions-error-offline')),_errors);var ReduceUsersModal=(_dec=Object(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(ReduceUsersModal,_Component);function ReduceUsersModal(props){var _this;__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this,ReduceUsersModal);_this=__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(ReduceUsersModal).call(this,props));_this.state=__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectSpread___default()({},_this.getStateFromProps(props),{sortKey:Object(__WEBPACK_IMPORTED_MODULE_13_utils_users__["f" /* getSavedTableSettings */])(_this.props.settings,__WEBPACK_IMPORTED_MODULE_27__config__["_62" /* USER_TABLE_REDUCE_USERS */],'sortKey'),sortOrder:Object(__WEBPACK_IMPORTED_MODULE_13_utils_users__["f" /* getSavedTableSettings */])(_this.props.settings,__WEBPACK_IMPORTED_MODULE_27__config__["_62" /* USER_TABLE_REDUCE_USERS */],'sortOrder'),userQuantity:props.quantityFromQueryParam||_this.props.getQuantityInputValue(__WEBPACK_IMPORTED_MODULE_27__config__["_19" /* QUANTITY_TYPE */].SEATS),apiRequestError:false,apiRequestSuccess:false,xhrInProgress:false,errors:{}});_this.scrollbarRef=__WEBPACK_IMPORTED_MODULE_9_react___default.a.createRef(null);return _this;}__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(ReduceUsersModal,[{key:"getStateFromProps",value:function getStateFromProps(props){var _props$companies=props.companies,rawDataById=_props$companies.rawDataById,selectedId=_props$companies.selectedId;var company=rawDataById[selectedId];var users=company.users;return{users:users};}},{key:"render",value:function render(){var _this2=this;var _this$props=this.props,modalShown=_this$props.modalShown,resetModal=_this$props.resetModal,classes=_this$props.classes;return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["d" /* Dialog */],{open:modalShown,"aria-labelledby":"alert-dialog-title","aria-describedby":"alert-dialog-description",onExited:resetModal,BackdropProps:{style:{backgroundColor:'rgba(46, 63, 79, 0.4)'}},classes:{paper:classes.dialogPaper},PaperProps:{style:{border:0,width:309,borderRadius:5,boxShadow:'0px 4px 24px rgba(0, 0, 0, 0.08)'}}},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div",{className:classes.dialogWrapper},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["p" /* IconButton */],{className:classes.closeDialog,component:"span","aria-label":"Close",onClick:function onClick(){return _this2.closeDialog();}},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__theme_icons__["_11" /* XIcon */],{className:classes.closeDialogIcon})),function(){if(_this2.state.xhrInProgress){return _this2.renderLoading();}else if(_this2.state.apiRequestSuccess){_this2.props.cb();}else if(_this2.state.apiRequestError){return _this2.renderContent();}else{return _this2.renderContent();}}()));}},{key:"closeDialog",value:function closeDialog(){this.props.hideModal();}},{key:"renderLoading",value:function renderLoading(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div",{className:classes.loadingWrapper},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__theme_icons__["Y" /* SpinnerIcon */],{className:classes.loadingIcon}),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["M" /* Typography */],{className:classes.loadingMessage,variant:"body2"},localize('subscriptions-modal-updating-users')));}},{key:"renderErrorMessage",value:function renderErrorMessage(){var errorMessage=__WEBPACK_IMPORTED_MODULE_21_lodash___default.a.get(this.state,'errors.apiError');var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["M" /* Typography */],{className:classes.errorMessage,variant:"body2",dangerouslySetInnerHTML:{__html:errorMessage}});}},{key:"getNumberOfRemainingUsersToReduce",value:function getNumberOfRemainingUsersToReduce(nonGuestUsers,customerEnteredQuantity,freeSeatsIncluded){var _this3=this;var nrOfUsersToReduce=nonGuestUsers.length-Math.max(customerEnteredQuantity,freeSeatsIncluded);nonGuestUsers.forEach(function(nonGuestUser){if(_this3.props.companies.pendingReduceUsers.find(function(reducedUser){return reducedUser.email===nonGuestUser.email;})){nrOfUsersToReduce-=1;}});return nrOfUsersToReduce>0?nrOfUsersToReduce:0;}},{key:"renderContent",value:function renderContent(){var _this4=this;var _this$props2=this.props,classes=_this$props2.classes,freeSeatsIncluded=_this$props2.freeSeatsIncluded;var nonGuestUsers=Object(__WEBPACK_IMPORTED_MODULE_13_utils_users__["e" /* filterNonGuestUsers */])(this.props.company.users);var nrOfRemainingUsersToReduce=this.getNumberOfRemainingUsersToReduce(nonGuestUsers,this.state.userQuantity,freeSeatsIncluded);return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["g" /* DialogTitle */],{variant:"body1",color:"default",className:classes.dialogTitle},localize('subscription-reduce-users-title')),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["f" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["o" /* Grid */],{container:true,direction:"column"},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["M" /* Typography */],{className:__WEBPACK_IMPORTED_MODULE_17_classnames___default()(classes.introText,classes.description),variant:"body1",dangerouslySetInnerHTML:{__html:localize('subscription-reduce-users-description',freeSeatsIncluded)}}),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["M" /* Typography */],{className:__WEBPACK_IMPORTED_MODULE_17_classnames___default()(classes.introText,classes.remaining),variant:"body1",dangerouslySetInnerHTML:{__html:localize('subscription-reduce-seats-remaining',nrOfRemainingUsersToReduce.toString())}}),Object.keys(this.state.errors).length>0&&this.renderErrorMessage(),this.renderUserTable(__WEBPACK_IMPORTED_MODULE_27__config__["_62" /* USER_TABLE_REDUCE_USERS */],[__WEBPACK_IMPORTED_MODULE_27__config__["_54" /* USER_ROLE_ADMIN */],__WEBPACK_IMPORTED_MODULE_27__config__["_55" /* USER_ROLE_BASIC */]]),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["o" /* Grid */],{item:true,container:true,direction:"row",justify:"flex-start",className:__WEBPACK_IMPORTED_MODULE_17_classnames___default()(classes.buttonsContainer)},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["o" /* Grid */],{item:true,className:classes.aboutRolesGridElement},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["M" /* Typography */],{className:__WEBPACK_IMPORTED_MODULE_17_classnames___default()(classes.aboutRoles)},localize('subscription-reduce-about-roles')),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_RolesTooltip__["a" /* default */],{tableId:__WEBPACK_IMPORTED_MODULE_27__config__["_62" /* USER_TABLE_REDUCE_USERS */]})),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["o" /* Grid */],{item:true,className:classes.cancelButtonGridElement},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["a" /* Button */],{variant:"outlined",color:"primary","data-tid":"button-reduce-users-cancel",className:__WEBPACK_IMPORTED_MODULE_17_classnames___default()(classes.button,classes.buttonCancel),onClick:function onClick(){return _this4.closeDialog();},disabled:false},localize('cancel'))),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["o" /* Grid */],{item:true,className:classes.continueButtonGridElement},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["a" /* Button */],{variant:"contained",color:"primary","data-tid":"button-reduce-users-continue",className:__WEBPACK_IMPORTED_MODULE_17_classnames___default()(classes.button,classes.buttonContinue),onClick:function onClick(){return _this4.submitForm();},disabled:!this.isFormValid()},localize('save-and-continue')))))));}},{key:"renderUserTable",value:function renderUserTable(tableId,renderRoles){var _this5=this;var classes=this.props.classes;var users=this.state.users;var _this$state=this.state,sortKey=_this$state.sortKey,sortOrder=_this$state.sortOrder;var usersToRender=Object(__WEBPACK_IMPORTED_MODULE_13_utils_users__["j" /* sortUsers */])(users.filter(function(user){return renderRoles.includes(user.role);}),sortKey,sortOrder);if(usersToRender.length===0){return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["M" /* Typography */],{variant:"body1",className:classes.noUsersFound},localize('users-table-no-guests-found'));}else{var _classNames,_classNames2,_classNames3;return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div",{className:classes.tableWrapper},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["F" /* Table */],{className:classes.table},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["I" /* TableHead */],null,__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["J" /* TableRow */],{className:classes.tableHeadRow},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["H" /* TableCell */],{padding:"dense",className:__WEBPACK_IMPORTED_MODULE_17_classnames___default()(classes.noBorderedCell,classes.tableNameCellHeader,classes.tableCellHeader,classes.tableHasSortArrow)},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["p" /* IconButton */],{className:__WEBPACK_IMPORTED_MODULE_17_classnames___default()((_classNames={},__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_classNames,classes.sortArrow,true),__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_classNames,'sortArrow',true),__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_classNames,'desc',sortKey===__WEBPACK_IMPORTED_MODULE_27__config__["_46" /* TABLE_COLUMNS */].FULL_NAME&&sortOrder===__WEBPACK_IMPORTED_MODULE_27__config__["_36" /* SORT_ORDER */].DESC),__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_classNames,'active',sortKey===__WEBPACK_IMPORTED_MODULE_27__config__["_46" /* TABLE_COLUMNS */].FULL_NAME),_classNames)),component:"span","aria-label":localize('users-table-change-sorting-order'),onClick:function onClick(){return Object(__WEBPACK_IMPORTED_MODULE_13_utils_users__["i" /* sortTable */])(_this5,tableId,__WEBPACK_IMPORTED_MODULE_27__config__["_46" /* TABLE_COLUMNS */].FULL_NAME,_this5.props.writeUserSettings);}},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__theme_icons__["X" /* SortArrow */],{className:classes.sortArrowIcon})),localize('users-table-header-name')),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["H" /* TableCell */],{padding:"dense",className:__WEBPACK_IMPORTED_MODULE_17_classnames___default()(classes.noBorderedCell,classes.tableEmailCellHeader,classes.tableCellHeader,classes.tableHasSortArrow)},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["p" /* IconButton */],{className:__WEBPACK_IMPORTED_MODULE_17_classnames___default()((_classNames2={},__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_classNames2,classes.sortArrow,true),__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_classNames2,'sortArrow',true),__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_classNames2,'desc',sortKey===__WEBPACK_IMPORTED_MODULE_27__config__["_46" /* TABLE_COLUMNS */].EMAIL&&sortOrder===__WEBPACK_IMPORTED_MODULE_27__config__["_36" /* SORT_ORDER */].DESC),__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_classNames2,'active',sortKey===__WEBPACK_IMPORTED_MODULE_27__config__["_46" /* TABLE_COLUMNS */].EMAIL),_classNames2)),component:"span","aria-label":localize('users-table-change-sorting-order'),onClick:function onClick(){return Object(__WEBPACK_IMPORTED_MODULE_13_utils_users__["i" /* sortTable */])(_this5,tableId,__WEBPACK_IMPORTED_MODULE_27__config__["_46" /* TABLE_COLUMNS */].EMAIL,_this5.props.writeUserSettings);}},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__theme_icons__["X" /* SortArrow */],{className:classes.sortArrowIcon})),localize('users-table-header-email')),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["H" /* TableCell */],{padding:"none",className:__WEBPACK_IMPORTED_MODULE_17_classnames___default()(classes.noBorderedCell,classes.tableRoleCellHeader,classes.tableCellHeader,classes.tableHasSortArrow)},[__WEBPACK_IMPORTED_MODULE_27__config__["_62" /* USER_TABLE_REDUCE_USERS */],__WEBPACK_IMPORTED_MODULE_27__config__["_58" /* USER_TABLE_ADMINS_AND_MEMBERS */]].includes(tableId)&&__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["p" /* IconButton */],{className:__WEBPACK_IMPORTED_MODULE_17_classnames___default()((_classNames3={},__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_classNames3,classes.sortArrow,true),__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_classNames3,'sortArrow',true),__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_classNames3,'desc',sortKey===__WEBPACK_IMPORTED_MODULE_27__config__["_46" /* TABLE_COLUMNS */].ROLE&&sortOrder===__WEBPACK_IMPORTED_MODULE_27__config__["_36" /* SORT_ORDER */].DESC),__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(_classNames3,'active',sortKey===__WEBPACK_IMPORTED_MODULE_27__config__["_46" /* TABLE_COLUMNS */].ROLE),_classNames3)),component:"span","aria-label":localize('users-table-change-sorting-order'),onClick:function onClick(){return Object(__WEBPACK_IMPORTED_MODULE_13_utils_users__["i" /* sortTable */])(_this5,tableId,__WEBPACK_IMPORTED_MODULE_27__config__["_46" /* TABLE_COLUMNS */].ROLE,_this5.props.writeUserSettings);}},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__theme_icons__["X" /* SortArrow */],{className:classes.sortArrowIcon})),localize('users-table-header-user-role')),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["H" /* TableCell */],{padding:"dense",className:__WEBPACK_IMPORTED_MODULE_17_classnames___default()(classes.noBorderedCell,classes.tableSelectReduceActionCellHeader,classes.tableCellHeader,classes.tableHasSortArrow)},localize('users-table-header-select-action'),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["L" /* Tooltip */],{placement:"top",title:__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["s" /* List */],{className:classes.tooltipList},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["t" /* ListItem */],{className:classes.tooltipListItem},localize('subscription-reduce-reduce-users-action-info-keep-role')),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["t" /* ListItem */],{className:classes.tooltipListItem},localize('subscription-reduce-reduce-users-action-info-change-to-guest')),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["t" /* ListItem */],{className:classes.tooltipListItem},localize('subscription-reduce-reduce-users-action-info-remove'))),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("span",{className:classes.tooltipArrow})),classes:{tooltip:classes.infoTooltip}},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["p" /* IconButton */],{className:classes.infoIconButton,color:"primary",component:"span",disableRipple:true},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__theme_icons__["N" /* Info */],null))))))),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_custom_scrollbars__["Scrollbars"],{ref:this.scrollbarRef,style:{height:240},autoHide:false,renderThumbVertical:function renderThumbVertical(_ref){var style=_ref.style,props=__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_ref,["style"]);return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div",__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({},props,{style:__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectSpread___default()({},style,{width:8,backgroundColor:'#6F99BD',opacity:0.5,borderRadius:4})}));}},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["F" /* Table */],{className:classes.table},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["G" /* TableBody */],null,this.renderUserRows(usersToRender)))));}}},{key:"renderUserRows",value:function renderUserRows(usersToRender){var _this6=this;var classes=this.props.classes;var currentUserEmail=this.props.currentUserEmail;return usersToRender.map(function(user,index){var _encodeUser=Object(__WEBPACK_IMPORTED_MODULE_13_utils_users__["d" /* encodeUser */])(user),name=_encodeUser.name,email=_encodeUser.email,role=_encodeUser.role,userId=_encodeUser.userId,externalIds=_encodeUser.externalIds;var key="user-row-".concat(index);var selectedValue;// State is stored to redux state in case user reopens this popup
// Note that redux.companies.pendingReduceUsers will be cleared if users closes this popup,
// makes changes on Users page, and then opens this popup again
var pendingReduceUserEntry=_this6.props.companies.pendingReduceUsers.find(function(user){return user.email===email;});if(pendingReduceUserEntry){selectedValue=pendingReduceUserEntry.action;}else{selectedValue=__WEBPACK_IMPORTED_MODULE_27__config__["_27" /* REDUCE_ACTION */].KEEP_ROLE;}return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["J" /* TableRow */],{key:key,hover:true,className:__WEBPACK_IMPORTED_MODULE_17_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()({},classes.tableBodyRow,true))},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["H" /* TableCell */],{padding:"dense",className:__WEBPACK_IMPORTED_MODULE_17_classnames___default()(classes.tableCellBody,classes.tableNameCellBody)},currentUserEmail===email?localize('users-table-name-you',name):name),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["H" /* TableCell */],{padding:"dense",className:__WEBPACK_IMPORTED_MODULE_17_classnames___default()(classes.tableCellBody,classes.tableEmailCellBody)},email),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["H" /* TableCell */],{padding:"dense",className:__WEBPACK_IMPORTED_MODULE_17_classnames___default()(classes.tableCellBody,classes.tableRoleCellBody)},role),__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["H" /* TableCell */],{padding:"none",className:__WEBPACK_IMPORTED_MODULE_17_classnames___default()(classes.tableCellBody,classes.tableCellReduceAction,classes.tableSelectActionCellBody)},__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Features_components__["b" /* Select */],{id:"select-reduce-action-role-".concat(index),"data-tid":"select-reduce-action-role-".concat(index),name:"editUser-".concat(email),onChange:function onChange(event){return _this6.handleAction(email,userId,externalIds,event.target.value);},className:classes.roleSelect,disableUnderline:true,fullWidth:true,IconComponent:__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_KeyboardArrowDown___default.a,MenuProps:{classes:{paper:classes.roleSelectItems}},value:selectedValue,disabled:currentUserEmail===email},REDUCE_ACTIONS.map(function(option){return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core__["x" /* MenuItem */],{key:option.key,value:option.key},option.value);}))));},this);}},{key:"handleAction",value:function handleAction(email,userId,externalIds,action){this.props.updatePendingReduceUser(email,userId,externalIds,action);}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){this.setState(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_objectSpread___default()({},this.getStateFromProps(nextProps)));if(this.props.companies.batchReduceUsersErrorId!==nextProps.companies.batchReduceUsersErrorId&&nextProps.companies.batchReduceUsersErrorId!==null){this.handleApiErrors(nextProps);}if(this.props.companies.batchReduceUsersSuccess!==nextProps.companies.batchReduceUsersSuccess&&nextProps.companies.batchReduceUsersSuccess===true){this.setState({xhrInProgress:false,apiRequestError:false,apiRequestSuccess:true,errors:{apiError:null}});}}},{key:"handleApiErrors",value:function handleApiErrors(nextProps){if(nextProps.companies.batchReduceUsersErrorId){var errorMessage=nextProps.companies.batchReduceUsersErrorId&&errors[nextProps.companies.batchReduceUsersErrorId]||localize('subscriptions-error-unknown');this.setState({xhrInProgress:false,apiRequestError:true,apiRequestSuccess:false,errors:{apiError:errorMessage}});}}},{key:"isFormValid",value:function isFormValid(){var nonGuestUsers=Object(__WEBPACK_IMPORTED_MODULE_13_utils_users__["e" /* filterNonGuestUsers */])(this.props.company.users);return this.getNumberOfRemainingUsersToReduce(nonGuestUsers,this.state.userQuantity,this.props.freeSeatsIncluded)===0;}},{key:"componentDidMount",value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_28_lib_Segment_customTrackers__["E" /* trackReduceUsersModal */])(Object(__WEBPACK_IMPORTED_MODULE_29_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));}},{key:"submitForm",value:function submitForm(){var _this7=this;var nonGuestUsers=Object(__WEBPACK_IMPORTED_MODULE_13_utils_users__["e" /* filterNonGuestUsers */])(this.props.company.users);var nrOfUsersToTurnToGuest=0;var nrOfUsersToDelete=0;// This is data for all users, it contains all users in updated state
var usersData=nonGuestUsers.map(function(originalUser){var userPendingUpdate=_this7.props.companies.pendingReduceUsers.find(function(reducedUser){return originalUser.email===reducedUser.email;});if(userPendingUpdate){if(userPendingUpdate.action===__WEBPACK_IMPORTED_MODULE_27__config__["_27" /* REDUCE_ACTION */].CHANGE_TO_GUEST){var updatedUser=__WEBPACK_IMPORTED_MODULE_21_lodash___default.a.clone(userPendingUpdate);updatedUser.role=__WEBPACK_IMPORTED_MODULE_27__config__["_56" /* USER_ROLE_GUEST */];nrOfUsersToTurnToGuest++;return updatedUser;}else if(userPendingUpdate.action===__WEBPACK_IMPORTED_MODULE_27__config__["_27" /* REDUCE_ACTION */].REMOVE){var _updatedUser=__WEBPACK_IMPORTED_MODULE_21_lodash___default.a.clone(userPendingUpdate);nrOfUsersToDelete++;return _updatedUser;}}}).filter(function(item){return!!item;});Object(__WEBPACK_IMPORTED_MODULE_28_lib_Segment_customTrackers__["F" /* trackReducedUsers */])(nrOfUsersToTurnToGuest,nrOfUsersToDelete,Object(__WEBPACK_IMPORTED_MODULE_29_lib_Segment_helpers__["a" /* getTrackingOptions */])(this.props.company));this.setState({xhrInProgress:true,apiRequestError:false,apiRequestSuccess:false,errors:{apiError:null}});this.props.batchReduceUsers(usersData);}}]);return ReduceUsersModal;}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]))||_class);ReduceUsersModal.propTypes={modalShown:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.bool,hideModal:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.func,resetModal:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.func,classes:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.object,company:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.object,companies:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.object,cb:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.func,currentUserEmail:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.string,getQuantityInputValue:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.func,settings:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.object,updatePendingReduceUser:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.func.isRequired,batchReduceUsers:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.func.isRequired,freeSeatsIncluded:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.number.isRequired,discount:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.object.isRequired,quantityFromQueryParam:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.number,writeUserSettings:__WEBPACK_IMPORTED_MODULE_20_prop_types___default.a.func.isRequired};var mapStateToProps=function mapStateToProps(state){return{company:state.companies.rawDataById[state.companies.selectedId],modalShown:state.modal.modalShown,companies:state.companies,app:state.app,currentUserEmail:state.session.user.mainEmail,discount:state.discount,settings:state.session.user.settings};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_11_redux__["b" /* bindActionCreators */])({writeUserSettings:__WEBPACK_IMPORTED_MODULE_24_redux_modules_session__["d" /* writeUserSettings */],hideModal:__WEBPACK_IMPORTED_MODULE_18_redux_modules_modal__["b" /* hideModal */],resetModal:__WEBPACK_IMPORTED_MODULE_18_redux_modules_modal__["c" /* resetModal */],updatePendingReduceUser:__WEBPACK_IMPORTED_MODULE_19_redux_modules_companies__["M" /* updatePendingReduceUser */],batchReduceUsers:__WEBPACK_IMPORTED_MODULE_19_redux_modules_companies__["c" /* batchReduceUsers */]},dispatch);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ReduceUsersModal));

/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__QuickMessage__ = __webpack_require__(1213);
var _dec,_class;/**
 * Shows a queue of quick temporary notifications, most recent at the top.
 * Each notification is visible for QUICK_MESSAGE_DURATION and takes QUICK_MESSAGE_FADE_OUT_DURATION to fade out.
 */var styles=function styles(theme){return{quickMessages:{position:'absolute',top:'100px',right:'28px'}};};var QuickMessages=(_dec=Object(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(QuickMessages,_Component);function QuickMessages(){__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this,QuickMessages);return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(QuickMessages).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(QuickMessages,[{key:"render",value:function render(){var _this$props=this.props,classes=_this$props.classes,quickMessages=_this$props.quickMessages;var messages=Object.entries(quickMessages)// most recent message displayed at the top
.sort(function(a,b){return b[1].created-a[1].created;}).map(function(entry){var key=entry[0];var quickMessage=entry[1];return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__QuickMessage__["a" /* default */],__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({key:key},quickMessage));});return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div",{className:classes.quickMessages},messages);}}]);return QuickMessages;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]))||_class);QuickMessages.propTypes={classes:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,quickMessages:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object};var mapStateToProps=function mapStateToProps(state){return{quickMessages:state.quickMessages};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps)(QuickMessages));

/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__theme_uiConfig__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
var _dec,_class;/**
 * A quick temporary notification.
 */var styles=function styles(theme){return{quickMessage:{backgroundColor:theme.palette.colors.zeta,borderRadius:'9px',height:'40px',padding:'10px 10px 11px 10px',color:theme.palette.colors.white,marginBottom:'1rem',opacity:0.31,transition:"opacity ".concat(__WEBPACK_IMPORTED_MODULE_7__theme_uiConfig__["e" /* quickMessageFadeOutDuration */],"ms ease-in-out"),fontFamily:theme.typography.fontFamily,fontWeight:'normal',fontSize:'13px',lineHeight:'18px',zIndex:1001,position:'relative'},quickMessageFading:{opacity:0}};};var QuickMessage=(_dec=Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__["withStyles"])(styles),_dec(_class=/*#__PURE__*/function(_Component){__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(QuickMessage,_Component);function QuickMessage(){__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this,QuickMessage);return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(QuickMessage).apply(this,arguments));}__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(QuickMessage,[{key:"render",value:function render(){var _this$props=this.props,classes=_this$props.classes,fading=_this$props.fading;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:__WEBPACK_IMPORTED_MODULE_9_classnames___default()(classes.quickMessage,fading&&classes.quickMessageFading)},this.props.message);}}]);return QuickMessage;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]))||_class);QuickMessage.propTypes={classes:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,message:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,fading:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (QuickMessage);

/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__errors_apperror__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__errors_errorhelper__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__logger_logger__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__errors_httperror__ = __webpack_require__(68);
var log=__WEBPACK_IMPORTED_MODULE_7__logger_logger__["a" /* default */].get('apistatustester');var ENDPOINT=__WEBPACK_IMPORTED_MODULE_2__config__["_67" /* apiStatus */].endpoint;var STATUS=__WEBPACK_IMPORTED_MODULE_2__config__["_67" /* apiStatus */].status;var protocol=location.protocol+'//';var environmentEndpoint=__WEBPACK_IMPORTED_MODULE_2__config__["P" /* HTTP_API_URL */].replace(/https?:\/\/(.*?)\..*/,'$1');var url=protocol+__WEBPACK_IMPORTED_MODULE_2__config__["_67" /* apiStatus */].url+ENDPOINT[environmentEndpoint];var waitingPromise,resolveWaitingPromise,nextCheck,showingError=false;/**
 * Returns a promise for the network request and once the request returns schedules the
 * next API check
 * @returns a promise which is the api network request
 */function isApiAvailable(){// in case called directly from other services, clear the next check
clearTimeout(nextCheck);return new Promise(function(res,rej){__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url).then(resolve)["catch"](reject);function resolve(response){scheduleNextCheck();var data=response&&response.data&&response.data.data||{};switch(data.status){case STATUS.ONLINE:hideMaintenanceMessage();resolveWaitingPromise&&resolveWaitingPromise();resolveWaitingPromise=undefined;res(STATUS.ONLINE);break;case STATUS.MAINTENANCE:case STATUS.OFFLINE:default:showMaintenanceMessage(data.description);rej(data.status);break;}}function reject(error){scheduleNextCheck();var httpErrorProps=Object(__WEBPACK_IMPORTED_MODULE_5__errors_errorhelper__["a" /* extractPropsforAxiosHttpError */])(error);var nError=new __WEBPACK_IMPORTED_MODULE_4__errors_apperror__["a" /* default */]({message:'API Status request rejected',errorId:__WEBPACK_IMPORTED_MODULE_6__errors_errorids__["a" /* default */].REJECTED_API_STATUS_REQUEST,originalError:new __WEBPACK_IMPORTED_MODULE_8__errors_httperror__["a" /* default */](httpErrorProps),visualisers:{feature:getVisualisersFeature(error)}});rej(nError);}});}function getVisualisersFeature(error){return Object(__WEBPACK_IMPORTED_MODULE_5__errors_errorhelper__["d" /* isNetworkStatusOffline */])(error)?'SUPPRESSED_ERROR':'API_STATUS_TESTER';}function doStatusCheck(){isApiAvailable()["catch"](function(error){log.send(new __WEBPACK_IMPORTED_MODULE_4__errors_apperror__["a" /* default */]({message:'API status check failed',errorId:__WEBPACK_IMPORTED_MODULE_6__errors_errorids__["a" /* default */].UNKNOWN,originalError:error,visualisers:{feature:getVisualisersFeature(error)}}));});}/**
 * Schedule the next request to test the API
 * Ensures only 1 loop of checks is running
 */function scheduleNextCheck(){clearTimeout(nextCheck);nextCheck=setTimeout(doStatusCheck,__WEBPACK_IMPORTED_MODULE_2__config__["_67" /* apiStatus */].timeout);}/**
 * waitForTheAPI
 * @returs returns a promise which resolves when the service is back online
 */function waitForTheApi(){if(!resolveWaitingPromise){waitingPromise=new Promise(function(resolve){resolveWaitingPromise=resolve;});}return waitingPromise||Promise.resolve();}/**
 * Update application state with current error
 */var showMaintenanceMessage=function showMaintenanceMessage(message){__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch({type:__WEBPACK_IMPORTED_MODULE_3__actions__["_76" /* ERROR_HANDLER_SET */],error:{errorMessage:message,errorId:__WEBPACK_IMPORTED_MODULE_6__errors_errorids__["a" /* default */].WAITING_FOR_API}});showingError=true;};/**
 * Clear the application state of the current error
 */var hideMaintenanceMessage=function hideMaintenanceMessage(){showingError&&__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch({type:__WEBPACK_IMPORTED_MODULE_3__actions__["_131" /* MODAL_HIDE */]});showingError=false;};// delay to allow for all animation and z-index construction in event of error on load
setTimeout(doStatusCheck,2000);/* unused harmony default export */ var _unused_webpack_default_export = ({waitForTheApi:waitForTheApi,isApiAvailable:isApiAvailable,_spec:{showMaintenanceMessage:showMaintenanceMessage,hideMaintenanceMessage:hideMaintenanceMessage,scheduleNextCheck:scheduleNextCheck}});

/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_containers_ErrorBoundary_FallbackScreen__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__theme_muiTheme__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_styles_MuiThemeProvider__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_styles_MuiThemeProvider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_styles_MuiThemeProvider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__errors_apperror__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__logger_logger__ = __webpack_require__(40);
var log=__WEBPACK_IMPORTED_MODULE_16__logger_logger__["a" /* default */].get('ErrorBoundary');var ErrorBoundary=/*#__PURE__*/function(_React$Component){__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ErrorBoundary,_React$Component);function ErrorBoundary(props){var _this;__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this,ErrorBoundary);_this=__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this,__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(ErrorBoundary).call(this,props));_this.state={hasError:false};return _this;}__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ErrorBoundary,[{key:"componentDidCatch",value:function componentDidCatch(error,errorInfo){// Called after rendering fallback UI in render()
// Allows side effects like error-logging
this.processStateError(error,errorInfo);}},{key:"processStateError",value:function processStateError(error,errorInfo){var options={visualisers:{feature:'ERROR_BOUNDARY_ERROR'}};this.constructor.processError(error,errorInfo,options);this.setState({hasError:true});}},{key:"render",value:function render(){var hasError=this.state.hasError;return hasError?this.constructor.renderFallBackScreen():this.props.children;}}],[{key:"getDerivedStateFromError",value:function getDerivedStateFromError(error){return{hasError:true};}},{key:"processError",value:function processError(event,errorInfo,options){var nErrorProps;if(event.reason){var reason=event.reason;var message=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.isString(reason)?reason:__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(reason,'message')||'unknown-unhandled-rejection';nErrorProps=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.assign({message:message,errorId:event.reason&&event.reason.errorId||__WEBPACK_IMPORTED_MODULE_14__errors_errorids__["a" /* default */].UNKNOWN,originalError:event.reason,errorDetails:__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},errorInfo&&{errorInfo:errorInfo}),visualisers:{feature:'GLOBAL_UNHANDLED_REJECTION'}},options);}else{nErrorProps=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.assign({errorId:__WEBPACK_IMPORTED_MODULE_14__errors_errorids__["a" /* default */].UNKNOWN,message:event&&event.message?event.message:'unknown-javascript-error',originalError:event.error,// actual error is in ErrorEvent.error
errorDetails:__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectSpread___default()({},errorInfo&&{errorInfo:errorInfo}),visualisers:{feature:'GLOBAL_UNCAUGHT_ERROR'}},options);}log.send(new __WEBPACK_IMPORTED_MODULE_15__errors_apperror__["a" /* default */](nErrorProps));this.state&&this.setState({hasError:true});}},{key:"renderFallBackScreen",value:function renderFallBackScreen(target,isExtensionError){if(target){Object(__WEBPACK_IMPORTED_MODULE_9_react_dom__["unmountComponentAtNode"])(target);Object(__WEBPACK_IMPORTED_MODULE_9_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_styles_MuiThemeProvider___default.a,{theme:__WEBPACK_IMPORTED_MODULE_12__theme_muiTheme__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_containers_ErrorBoundary_FallbackScreen__["a" /* default */],{reload:this.reloadPage,isExtensionError:isExtensionError})),target);}else{return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_containers_ErrorBoundary_FallbackScreen__["a" /* default */],{reload:this.reloadPage});}}}]);return ErrorBoundary;}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(ErrorBoundary,"handleUncaughtError",function(event,target){// Ignore error rethrown from ErrorBoundary in DEV environment
// https://github.com/facebook/react/issues/10474
if(event&&event.message&&event.message==='Uncaught Error: The error you provided does not contain a stack trace.'){return;}var isDevError=event.error.stack&&event.error.stack.indexOf('invokeGuardedCallbackDev')!==-1;if(!isDevError){if(target){var isExtensionError=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(event,'error.stack')&&event.error.stack.indexOf('chrome-extension')!==-1;ErrorBoundary.renderFallBackScreen(target,isExtensionError);}var options={visualisers:{feature:'GLOBAL_UNHANDLED_REJECTION'}};ErrorBoundary.processError(event,null,options);}});__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(ErrorBoundary,"handleUnhandledPromiseRejection",function(event,target){if(event&&event.reason&&event.reason.message&&event.reason.message==='Action timed out for registerMaster'){return;}if(target){var isExtensionError=__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(event,'error.stack')&&event.error.stack.indexOf('chrome-extension')!==-1;if(event instanceof CustomEvent&&event.type==='unhandledrejection'){console.log('possible extension error',event);// eslint-disable-line no-console
}else{ErrorBoundary.renderFallBackScreen(target,isExtensionError);}}var options={visualisers:{feature:'GLOBAL_UNHANDLED_REJECTION'}};ErrorBoundary.processError(event,null,options);});__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(ErrorBoundary,"reloadPage",function(){window.location='/?reload-app=true';});ErrorBoundary.propTypes={children:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.node.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ErrorBoundary);

/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Dialog__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_i18n_i18n__ = __webpack_require__(15);
var localize=__WEBPACK_IMPORTED_MODULE_7_i18n_i18n__["a" /* default */].loc.localize;function FallbackScreen(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Dialog___default.a,{open:true,"aria-labelledby":"alert-dialog-title","aria-describedby":"alert-dialog-description"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText___default.a,{variant:"body1",color:"default"},props.isExtensionError?localize('fallback-screen-message-browser-extension'):localize('fallback-screen-message'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{variant:"contained",color:"primary",onClick:function onClick(){return props.reload(true);}},localize('fallback-screen-reload'))));}FallbackScreen.propTypes={reload:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,isExtensionError:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (FallbackScreen);

/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hex2rgb; });
var bound=function bound(n,limit){var abs=Math.abs,min=Math.min,max=Math.max;n=min(limit,max(0,parseFloat(n)));if(abs(n-limit)<0.000001){return 1;}return n%limit/parseFloat(limit);};var rgb2rgb=function rgb2rgb(rgb){return{r:bound(rgb.r,255)*255,g:bound(rgb.g,255)*255,b:bound(rgb.b,255)*255};};var hex2rgb=function hex2rgb(hex){hex=hex.charAt(0)==='#'?hex.slice(1):hex;if(hex.length===3){hex=hex.charAt(0)+hex.charAt(0)+hex.charAt(1)+hex.charAt(1)+hex.charAt(2)+hex.charAt(2);}return rgb2rgb({r:parseInt(hex.substring(0,2),16),g:parseInt(hex.substring(2,4),16),b:parseInt(hex.substring(4,6),16)});};

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (immutable) */ __webpack_exports__["a"] = unregister;
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl="".concat("","/service-worker.js");if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');// eslint-disable-line no-console
}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');// eslint-disable-line no-console
}}};};})["catch"](function(error){console.error('Error during service worker registration:',error);// eslint-disable-line no-console
});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}})["catch"](function(){console.log(// eslint-disable-line no-console
'No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export manageRefersionField */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return saveRefersionFieldsToStorage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_cookie__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger_logger__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__errors_errorids__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__errors_apperror__ = __webpack_require__(34);
var log=__WEBPACK_IMPORTED_MODULE_1__logger_logger__["a" /* default */].get('refersion');var rfsn_expires_cookie=Object(__WEBPACK_IMPORTED_MODULE_0_utils_cookie__["a" /* getCookieValue */])('rfsn_expires');var rfsn_expires_localstorage=localStorage.getItem('rfsn_expires');var manageRefersionField=function manageRefersionField(key,value){if(localStorage.getItem(key)){// check expiry date if field already exists in local storage
if(rfsn_expires_localstorage<new Date().getTime()){localStorage.removeItem(key);localStorage.removeItem('rfsn_expires');}}else if(value){// add field/value to local storage and expiry date
try{localStorage.setItem(key,value);localStorage.setItem('rfsn_expires',rfsn_expires_cookie);}catch(err){log.send(new __WEBPACK_IMPORTED_MODULE_3__errors_apperror__["a" /* default */]({message:'manageRefersionField() failed',errorId:__WEBPACK_IMPORTED_MODULE_2__errors_errorids__["a" /* default */].UNKNOWN,originalError:err,visualisers:{feature:'REFERSION'}}));}}};var saveRefersionFieldsToStorage=function saveRefersionFieldsToStorage(){['rfsn_aid','rfsn_ci','rfsn_cs'].forEach(function(field){return manageRefersionField(field,Object(__WEBPACK_IMPORTED_MODULE_0_utils_cookie__["a" /* getCookieValue */])(field));});};

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCookieValue; });
var getCookieValue=function getCookieValue(cookieName){var value=null;var relatedCookie=document.cookie.split('; ').find(function(row){return row.startsWith(cookieName);});if(relatedCookie){value=relatedCookie.split('=')[1];}return value;};

/***/ }),
/* 1221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clientid__ = __webpack_require__(190);
function onBeforeUnload(){// We want to preserve our clientId across a refresh so we always write our clientId
// into local storage when unloading the client
window.localStorage.setItem('xc-next-clientid-cap',__WEBPACK_IMPORTED_MODULE_0__clientid__["a" /* default */]);}window.addEventListener('beforeunload',onBeforeUnload);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.4908f721.js